/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 34861:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.defaultConfig = void 0;
exports.defaultConfig = {
    lib: "https://adsdk.microsoft.com/ast/ast.js",
    pageOpts: {
        member: 14785,
        disablePsa: true,
        noBidIfUnsold: true,
        keywords: {}
    },
    allowedFormats: [
        "banner"
    ]
}; //# sourceMappingURL=default.js.map


/***/ }),

/***/ 43368:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.no = exports.defaultConfig = void 0;
var default_1 = __webpack_require__(34861);
Object.defineProperty(exports, "defaultConfig", ({
    enumerable: true,
    get: function get() {
        return default_1.defaultConfig;
    }
}));
var no_1 = __webpack_require__(83288);
Object.defineProperty(exports, "no", ({
    enumerable: true,
    get: function get() {
        return no_1.no;
    }
})); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 83288:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.no = void 0;
var default_1 = __webpack_require__(34861);
exports.no = _objectSpreadProps(_objectSpread({}, default_1.defaultConfig), {
    pageOpts: _objectSpreadProps(_objectSpread({}, default_1.defaultConfig.pageOpts), {
        keywords: {
            "no-sno-publishergroup": "schibsted"
        }
    })
}); //# sourceMappingURL=no.js.map


/***/ }),

/***/ 74302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.adsConfig = void 0;
var appnexus = __importStar(__webpack_require__(43368));
var common = {
    service: "appnexus",
    appnexus: appnexus.defaultConfig,
    headerBiddingEnabled: false
};
exports.adsConfig = {
    dk: _objectSpread({}, common),
    fi: _objectSpread({}, common),
    fr: _objectSpread({}, common),
    gb: _objectSpread({}, common),
    no: _objectSpreadProps(_objectSpread({}, common), {
        appnexus: appnexus.no
    }),
    nz: _objectSpreadProps(_objectSpread({}, common), {
        labelAlign: "bottom"
    }),
    se: _objectSpread({}, common)
}; //# sourceMappingURL=index.js.map


/***/ }),

/***/ 66481:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.dk = void 0;
var ads_1 = __webpack_require__(74302);
var types_1 = __webpack_require__(42222);
var privacyPolicyUrl = "/information/privatlivspolitik";
var cookiePolicyUrl = "/information/cookiepolitik";
exports.dk = {
    countryCode: "dk",
    active: true,
    sitename: "Prisjagt",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    locale: "da-dk",
    localeStandard: "da-DK",
    sites: {
        businessCenter: "https://business.prisjagt.dk",
        production: "https://prisjagt.dk",
        classic: "https://classic.prisjagt.dk",
        analytics: "https://prisjagt.dk/analytics/store/",
        brands: undefined,
        forum: undefined,
        mobile: undefined,
        staging: "https://next-dk.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "da",
    timezone: "Europe/Copenhagen",
    currencyCode: "DKK",
    url: {
        campaigns: "/tema",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.prisjagt.dk"
        }
    },
    socialNetworks: {
        facebook: {
            link: "https://www.facebook.com/Prisjagt"
        }
    },
    email: {
        noreply: "noreply@prisjagt.dk",
        security: "security@prisjagt.dk"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/tema"
        },
        campaign: {
            path: "/tema/:slug"
        },
        productAlert: {
            relativePath: "/overvage"
        },
        productCompare: {
            path: "/sammenlign/produkter/:productIds?"
        },
        editorialContentListing: {
            path: "/artikler"
        },
        article: {
            path: "/artikler/:slug"
        },
        categoryIndex: {
            path: "/kategorier"
        },
        expertProductTest: {
            path: "/tester/:slug?",
            relativePath: "/tester"
        },
        expertToplists: {
            path: "/toplister/:slug?",
            relativePath: "/toplister"
        },
        expertGuide: {
            path: "/guider/:slug?",
            relativePath: "/guider"
        },
        expertLandingPage: {
            path: "/eksperter"
        },
        expertProfile: {
            path: "/eksperter/profil/:slug?",
            relativePath: "/eksperter/profil"
        },
        expertCategory: {
            path: "/eksperter/:slug",
            relativePath: "/eksperter"
        },
        promotions: {
            path: "/kampagner"
        },
        promotionProducts: {
            path: "/kampagner/:id"
        },
        usedProducts: {
            path: "/brugt"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        }
    },
    popularCampaignFilterPaths: [],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        priceInformation: 5,
        privacyPolicy: privacyPolicyUrl,
        cookiePolicy: cookiePolicyUrl,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        contact: "/information/kontakt",
        about: "/information/om-prisjagt",
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        experts: "experts",
        categoryIndex: "categoryIndex",
        used: "used",
        blackFriday: true
    },
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "",
        list: "",
        gansubFormId: ""
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.dk),
    paymentProviders: {
        priorities: [
            "PAYPAL",
            "SWISH",
            "VIPPS",
            "KLARNA",
            "SVEA_WEB_PAY",
            "AMEX",
            "MASTER_CARD",
            "VISA",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieUrl: cookiePolicyUrl,
            privacyUrl: privacyPolicyUrl
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: false,
    shopOfTheYear: false,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/prishistorik--ecYOMFnxIAACQAU7bH"
        },
        newsletterArticlesSidebar: {
            path: "/nyhedsbrev--ecZXF9oBcAACMAX1ZY"
        }
    },
    experts: {
        enabled: true
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    login: {
        enabled: true
    },
    promotions: {
        enabled: false
    },
    prisjaktSourcepointConfig: {
        accountId: 2033,
        baseEndpoint: "https://cdn.privacy-mgmt.com",
        propertyId: 39431,
        consentLanguage: "dk",
        groupPmId: 1312602,
        propertyHref: "https://prisjagt.dk"
    }
}; //# sourceMappingURL=dk.js.map


/***/ }),

/***/ 25373:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fi = void 0;
var ads_1 = __webpack_require__(74302);
var types_1 = __webpack_require__(42222);
var privacyPolicyUrl = "/information/tietosuojakaytanto";
var cookiePolicyUrl = "/information/evastekaytanto";
exports.fi = {
    countryCode: "fi",
    active: true,
    sitename: "Hintaopas",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    locale: "fi",
    localeStandard: "fi-FI",
    sites: {
        businessCenter: "https://business.hintaopas.fi",
        production: "https://hintaopas.fi",
        classic: "https://classic.hintaopas.fi",
        analytics: "https://classic.hintaopas.fi/analytics/store/",
        brands: undefined,
        forum: undefined,
        mobile: undefined,
        staging: "https://next-fi.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-25",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "fi",
    timezone: "Europe/Helsinki",
    currencyCode: "EUR",
    url: {
        campaigns: "/teema",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.hintaopas.fi"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/hintaopas/"
        },
        facebook: {
            link: "https://www.facebook.com/hintaopas"
        },
        twitter: {
            link: "https://twitter.com/Hintaopas_FI"
        }
    },
    email: {
        noreply: "noreply@hintaopas.fi",
        security: "security@hintaopas.fi"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/teema"
        },
        campaign: {
            path: "/teema/:slug"
        },
        shopOfTheYear: {
            path: "/vuoden-verkkokauppa"
        },
        shopOfTheYearCategory: {
            path: "/vuoden-verkkokauppa/:year/category/:id"
        },
        shopOfTheYearWinners: {
            path: "/vuoden-verkkokauppa/:section"
        },
        productCompare: {
            path: "/vertaa/tuotteet/:productIds?"
        },
        editorialContentListing: {
            path: "/artikkeleita"
        },
        article: {
            path: "/artikkeleita/:slug"
        },
        categoryIndex: {
            path: "/tuotekategoriat"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        },
        promotions: {
            path: "/kampanjat"
        },
        promotionProducts: {
            path: "/kampanjat/:id"
        },
        usedProducts: {
            path: "/kaytetyt"
        },
        expertProductTest: {
            path: "/testit/:slug?",
            relativePath: "/testit"
        },
        expertToplists: {
            path: "/top-listat/:slug?",
            relativePath: "/top-listat"
        },
        expertGuide: {
            path: "/oppaat/:slug?",
            relativePath: "/oppaat"
        },
        expertLandingPage: {
            path: "/asiantuntijat"
        },
        expertProfile: {
            path: "/asiantuntijat/profiili/:slug?",
            relativePath: "/asiantuntijat/profiili"
        },
        expertCategory: {
            path: "/asiantuntijat/:slug",
            relativePath: "/asiantuntijat"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Sykemittarit ja \xe4lykellot - parhaat tarjoukset",
            path: "?sort=product.popularity.total&category=1942"
        },
        {
            title: "Matkapuhelimet ja kuulokkeet",
            path: "?category=103%7C148"
        },
        {
            title: "Juoksukeng\xe4t ja tennarit – parhaat tarjoukset",
            path: "?sort=product.popularity.total&category=1428%7C1497"
        },
        {
            title: "Parhaat tarjoukset alle 50€",
            path: "?price=0-50"
        },
        {
            title: "Keitti\xf6 & kodinkoneet - parhaat tarjoukset",
            path: "?category=1671%7C504"
        },
        {
            title: "Televisiot",
            path: "?category=107"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        priceInformation: 5,
        privacyPolicy: privacyPolicyUrl,
        cookiePolicy: cookiePolicyUrl,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        contact: "/information/ota-yhteytta",
        about: "/information/tietoa-hintaoppaasta",
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        experts: "experts",
        categoryIndex: "categoryIndex",
        used: "used",
        newsroom: "newsroom",
        blackFriday: true
    },
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "SBTmg",
        gansubFormId: "mBEs"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.fi),
    paymentProviders: {
        priorities: [
            "SWISH",
            "VIPPS",
            "PAYPAL",
            "KLARNA",
            "SVEA_WEB_PAY",
            "AMEX",
            "MASTER_CARD",
            "VISA",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieUrl: cookiePolicyUrl,
            privacyUrl: privacyPolicyUrl
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: false,
    shopOfTheYear: true,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/hintahistoria-nayttaa-miten-hinta-on-muuttunut-ajan-myota--ecYO001xAAACMA0Ed_"
        },
        newsletterArticlesSidebar: {
            path: "/uutiskirje--ecZXLDthcAACQAZSip"
        }
    },
    experts: {
        enabled: true
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    login: {
        enabled: true
    },
    promotions: {
        enabled: false
    },
    prisjaktSourcepointConfig: {
        accountId: 2033,
        baseEndpoint: "https://cdn.privacy-mgmt.com",
        propertyId: 39428,
        consentLanguage: "fi",
        groupPmId: 1312605,
        propertyHref: "https://hintaopas.fi"
    }
}; //# sourceMappingURL=fi.js.map


/***/ }),

/***/ 72937:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fr = void 0;
var ads_1 = __webpack_require__(74302);
var types_1 = __webpack_require__(42222);
var cookiePolicyUrl = "/information/politique-de-cookies";
var privacyPolicyUrl = "/information/politique-de-confidentialite";
exports.fr = {
    countryCode: "fr",
    active: true,
    sitename: "leD\xe9nicheur",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    locale: "fr-fr",
    localeStandard: "fr-FR",
    sites: {
        businessCenter: "https://business.ledenicheur.fr",
        production: "https://ledenicheur.fr",
        classic: "https://classic.ledenicheur.fr",
        analytics: "https://classic.ledenicheur.fr/analytics/store",
        forum: undefined,
        brands: undefined,
        mobile: "https://m.ledenicheur.fr",
        staging: "https://next-fr.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "12": "2020-01-09"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "fr",
    timezone: "Europe/Paris",
    currencyCode: "EUR",
    url: {
        campaigns: "/actu",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.ledenicheur.fr"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/ledenicheur/"
        },
        facebook: {
            link: "https://www.facebook.com/leDenicheurFR"
        },
        twitter: {
            link: "https://twitter.com/leDenicheur"
        }
    },
    email: {
        noreply: "noreply@ledenicheur.fr",
        security: "security@ledenicheur.fr"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/actu"
        },
        campaign: {
            path: "/actu/:slug"
        },
        productCompare: {
            path: "/comparer/produits/:productIds?"
        },
        editorialContentListing: {
            path: "/articles"
        },
        article: {
            path: "/articles/:slug"
        },
        categoryIndex: {
            path: "/categories"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        },
        promotions: {
            path: "/campagnes"
        },
        promotionProducts: {
            path: "/campagnes/:id"
        },
        usedProducts: {
            path: "/reconditionne-ou-occasion"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Smartphones",
            path: "?category=103&price=100-10000"
        },
        {
            title: "Informatique",
            path: "?category=382%7C384%7C393%7C353%7C352%7C1243%7C1313%7C977"
        },
        {
            title: "Enceintes & casques audio",
            path: "?category=148%7C1827&price=15-10000"
        },
        {
            title: "TV",
            path: "?category=107&price=100-10000"
        },
        {
            title: "Gros \xe9lectrom\xe9nager",
            path: "?category=504"
        },
        {
            title: "Cuisine",
            path: "?category=1671&price=30-3000"
        },
        {
            title: "Aspirateurs",
            path: "?category=515%7C520&price=100-2000"
        },
        {
            title: "Chauffages & climatisation",
            path: "?category=507&price=30-3000"
        },
        {
            title: "Outillage & jardinage",
            path: "?category=1064%7C1069&price=30-3000"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        priceInformation: 5,
        registerShop: 10,
        media: 12,
        aboutReviews: 15,
        cookiePolicy: cookiePolicyUrl,
        privacyPolicy: privacyPolicyUrl,
        disclaimer: "/information/conditions-generales-dutilisation",
        userAgreement: "/information/regles-dutilisation",
        contact: "/information/contact",
        about: "/information/a-propos-nous",
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        categoryIndex: "categoryIndex",
        used: "used",
        newsroom: "newsroom",
        blackFriday: true
    },
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "SAzT5",
        gansubFormId: "gc6FyDznc6U0BEVZnott"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    paymentProviders: {
        priorities: [
            "VISA",
            "MASTER_CARD",
            "AMEX",
            "DINERS",
            "SWISH",
            "VIPPS",
            "PAYPAL",
            "KLARNA",
            "SVEA_WEB_PAY"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Card,
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Invoice
        ]
    },
    offerList: {
        filters: {
            hiddenFilters: [
                types_1.FilterType.INTERNATIONAL
            ]
        }
    },
    ads: _objectSpread({
        active: false
    }, ads_1.adsConfig.fr),
    privacySettings: {
        responsive: {
            cookieUrl: cookiePolicyUrl,
            privacyUrl: privacyPolicyUrl
        }
    },
    modules: {
        categoryInfo: {
            enabled: true
        },
        userReviewPurchaseDate: {
            enabled: true,
            datePlaceholderFormat: "aaaa-mm-jj"
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: false,
    shopOfTheYear: false,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/historique-des-prix--ecYORbihIAACMAWaGg"
        },
        newsletterArticlesSidebar: {
            path: "/newsletter--ecZXLBkxcAACMAZR8L"
        }
    },
    experts: {
        enabled: false
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    login: {
        enabled: false
    },
    promotions: {
        enabled: false
    },
    prisjaktSourcepointConfig: {
        accountId: 2033,
        baseEndpoint: "https://cdn.privacy-mgmt.com",
        propertyId: 39434,
        consentLanguage: "fr",
        groupPmId: 1312593,
        propertyHref: "https://ledenicheur.fr"
    }
}; //# sourceMappingURL=fr.js.map


/***/ }),

/***/ 77392:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.gb = void 0;
var ads_1 = __webpack_require__(74302);
var types_1 = __webpack_require__(42222);
var cookiePolicyUrl = "/information/cookie-policy";
var privacyPolicyUrl = "/information/privacy-policy";
exports.gb = {
    countryCode: "gb",
    active: true,
    sitename: "PriceSpy",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    locale: "en-gb",
    localeStandard: "en-GB",
    sites: {
        businessCenter: "https://business.pricespy.co.uk",
        production: "https://pricespy.co.uk",
        classic: "https://classic.pricespy.co.uk",
        analytics: "https://pricespy.co.uk/analytics/store/",
        brands: undefined,
        forum: undefined,
        staging: "https://next-gb.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-26",
            "12": "2020-01-02",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "en_GB",
    timezone: "Europe/London",
    currencyCode: "GBP",
    url: {
        campaigns: "/theme",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            info: "/info.php",
            lists: "/list.php",
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/expert.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.pricespy.co.uk"
        }
    },
    email: {
        noreply: "noreply@pricespy.co.uk",
        security: "security@pricespy.co.uk"
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/pricespy/"
        },
        facebook: {
            link: "https://www.facebook.com/PriceSpyUK"
        },
        twitter: {
            link: "https://twitter.com/PriceSpyUK"
        }
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/theme"
        },
        campaign: {
            path: "/theme/:slug"
        },
        productCompare: {
            path: "/compare/products/:productIds?"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        },
        promotions: {
            path: "/promotions"
        },
        promotionProducts: {
            path: "/promotions/:id"
        },
        usedProducts: {
            path: "/used"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Best TV deals under \xa31000",
            path: "?category=107&price=1-1000&sort=rank%7Cdesc"
        },
        {
            title: "Best deals under \xa350",
            path: "?sort=rank%7Cdesc&price=1-50"
        },
        {
            title: "Best deals \xa350-100",
            path: "?sort=rank%7Cdesc&price=50-100"
        },
        {
            title: "Work from home",
            path: "?category=555%7C148%7C1594"
        },
        {
            title: "Most popular vacuum cleaners",
            path: "?sort=product.popularity.total&category=515"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        priceInformation: 5,
        registerShop: 10,
        media: 12,
        aboutReviews: 15,
        cookiePolicy: cookiePolicyUrl,
        privacyPolicy: privacyPolicyUrl,
        disclaimer: "/information/disclaimer",
        userAgreement: "/information/rules-and-guidelines-for-users",
        contact: "/information/contact",
        about: "/information/about-pricespy",
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        categoryIndex: "categoryIndex",
        used: "used",
        supportPage: "supportPage",
        newsroom: "newsroom",
        blackFriday: true
    },
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "BYajAsGm",
        gansubFormId: "Q2lk"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.gb),
    paymentProviders: {
        priorities: [
            "KLARNA",
            "SVEA_WEB_PAY",
            "PAYPAL",
            "SWISH",
            "VIPPS",
            "AMEX",
            "MASTER_CARD",
            "VISA",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieUrl: cookiePolicyUrl,
            privacyUrl: privacyPolicyUrl
        }
    },
    structuredData: {
        "@context": "http://schema.org",
        "@type": "Organization",
        legalName: "PriceSpy Ltd",
        areaServed: "GB",
        url: "https://pricespy.co.uk",
        address: {
            "@type": "PostalAddress",
            streetAddress: "Sweden House, 5 Upper Montagu Street",
            addressLocality: "London",
            postalCode: "W1H 2AG",
            addressCountry: "United Kingdom"
        },
        logo: "https://pricespy-75b8.kxcdn.com/g/rfe/logos/logo_gb_v2_dark.svg",
        sameAs: [
            "https://www.facebook.com/PriceSpyUK",
            "https://twitter.com/pricespyuk"
        ]
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: false,
    shopOfTheYear: true,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/price-history--ecYSSD4hIAACEAXXWu"
        },
        newsletterArticlesSidebar: {
            path: "/newsletter--ecZXGEORcAACYAX3Qm"
        }
    },
    experts: {
        enabled: false
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    login: {
        enabled: false
    },
    promotions: {
        enabled: false
    },
    prisjaktSourcepointConfig: {
        accountId: 2033,
        baseEndpoint: "https://cdn.privacy-mgmt.com",
        propertyId: 39432,
        consentLanguage: "en",
        groupPmId: 1312596,
        propertyHref: "https://pricespy.co.uk"
    }
}; //# sourceMappingURL=gb.js.map


/***/ }),

/***/ 10439:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.q = void 0;
var dk_1 = __webpack_require__(66481);
var fi_1 = __webpack_require__(25373);
var fr_1 = __webpack_require__(72937);
var gb_1 = __webpack_require__(77392);
var no_1 = __webpack_require__(31929);
var nz_1 = __webpack_require__(78309);
var se_1 = __webpack_require__(50337);
exports.q = {
    se: se_1.se,
    gb: gb_1.gb,
    fi: fi_1.fi,
    fr: fr_1.fr,
    no: no_1.no,
    nz: nz_1.nz,
    dk: dk_1.dk
}; //# sourceMappingURL=index.js.map


/***/ }),

/***/ 31929:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.no = void 0;
var ads_1 = __webpack_require__(74302);
var types_1 = __webpack_require__(42222);
var privacyPolicyUrl = "/information/personvernerklaring";
var cookiePolicyUrl = "/information/cookiepolicy";
exports.no = {
    countryCode: "no",
    active: true,
    sitename: "Prisjakt",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    locale: "no",
    localeStandard: "nb-NO",
    sites: {
        businessCenter: "https://business.prisjakt.no",
        production: "https://www.prisjakt.no",
        classic: "https://classic.prisjakt.no",
        analytics: "https://classic.prisjakt.no/analytics/store",
        brands: undefined,
        forum: undefined,
        mobile: "https://m.prisjakt.no",
        staging: "https://next-no.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-25",
            "12": "2020-01-01",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "nb_NO",
    timezone: "Europe/Oslo",
    currencyCode: "NOK",
    url: {
        campaigns: "/tema",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.prisjakt.no"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/prisjakt.no/"
        },
        facebook: {
            link: "https://www.facebook.com/PrisjaktNorge"
        },
        twitter: {
            link: "https://twitter.com/PrisjaktNorge"
        }
    },
    email: {
        noreply: "noreply@prisjakt.no",
        security: "security@prisjakt.no"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/tema"
        },
        campaign: {
            path: "/tema/:slug"
        },
        shopOfTheYear: {
            path: "/arets-butikk"
        },
        shopOfTheYearCategory: {
            path: "/arets-butikk/:year/category/:id"
        },
        shopOfTheYearWinners: {
            path: "/arets-butikk/:section"
        },
        productCompare: {
            path: "/sammenlign/produkter/:productIds?"
        },
        editorialContentListing: {
            path: "/artikler"
        },
        article: {
            path: "/artikler/:slug"
        },
        categoryIndex: {
            path: "/kategorier"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        },
        expertProductTest: {
            path: "/tester/:slug?",
            relativePath: "/tester"
        },
        expertToplists: {
            path: "/topplister/:slug?",
            relativePath: "/topplister"
        },
        expertGuide: {
            path: "/guider/:slug?",
            relativePath: "/guider"
        },
        expertLandingPage: {
            path: "/eksperter"
        },
        expertProfile: {
            path: "/eksperter/profil/:slug?",
            relativePath: "/eksperter/profil"
        },
        expertCategory: {
            path: "/eksperter/:slug",
            relativePath: "/eksperter"
        },
        promotions: {
            path: "/kampanjer"
        },
        promotionProducts: {
            path: "/kampanjer/:id"
        },
        usedProducts: {
            path: "/brukt"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Tilbud under 500 kr",
            path: "?price=0-500"
        },
        {
            title: "Tilbud 500-1000 kr",
            path: "?price=500-1000"
        },
        {
            title: "Beste tilbud p\xe5 hodetelefoner",
            path: "?category=148"
        },
        {
            title: "Beste tilbud p\xe5 robotst\xf8vsugere og st\xf8vsugere",
            path: "?category=515%7C520"
        },
        {
            title: "Jobb hjemmefra",
            path: "?category=555%7C148%7C1594"
        },
        {
            title: "Beste tilbud p\xe5 hvitevarer",
            path: "?category=504"
        },
        {
            title: "TVs",
            path: "?category=107"
        }
    ],
    campaignFeaturedList: [
        {
            campaignId: 2,
            listId: 520202
        }
    ],
    infoPages: [
        9,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        privacyPolicy: privacyPolicyUrl,
        cookiePolicy: cookiePolicyUrl,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        contact: "/information/kontakt",
        about: "/information/om-prisjakt-NO",
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        experts: "experts",
        shopOfTheYear: "shopOfTheYear",
        shopOfTheYearForShops: "https://landing.prisjakt.nu/arets_butikk",
        categoryIndex: "categoryIndex",
        used: "used",
        supportPage: "supportPage",
        newsroom: "newsroom",
        getStarted: "/tema/kom-i-gang-med-prisjakts-smarte-verkty",
        howWorks: "/information/pa-din-side-siden-2002",
        transparency: "/info/apenhetsloven--ipZH2UQxAAACIAj9Uf",
        blackFriday: true
    },
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "DiriBRd",
        gansubFormId: "ygTTkGiPETLPh10qRO"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    paymentProviders: {
        priorities: [
            "KLARNA",
            "SVEA_WEB_PAY",
            "VIPPS",
            "PAYPAL",
            "SWISH",
            "AMEX",
            "MASTER_CARD",
            "VISA",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Card
        ]
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.no),
    privacySettings: {
        responsive: {
            cookieUrl: cookiePolicyUrl,
            privacyUrl: privacyPolicyUrl
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: true,
    showBrandingTagline: true,
    shopOfTheYear: true,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        aboutExperts: {
            path: "/info/apenhetsl%C3%B8fte-prisjakt-eksperter--ipZIGG3BAAACMAoZJY"
        },
        priceHistoryInfo: {
            path: "/prishistorikk--ecYOasRhIAACMAY7_I"
        },
        newsletterArticlesSidebar: {
            path: "/nyhetsbrev--ecZXFxSRcAACUAXx-i"
        },
        aboutDealsCalculation: {
            path: "/apenhetsl\xf8fte-hvordan-vi-finner-dagens-beste-tilbud--ecZakVPRAAAB4AtdgT"
        }
    },
    experts: {
        enabled: true
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    login: {
        enabled: true
    },
    promotions: {
        enabled: true
    },
    prisjaktSourcepointConfig: {
        accountId: 2033,
        baseEndpoint: "https://cdn.privacy-mgmt.com",
        propertyId: 39426,
        consentLanguage: "no",
        groupPmId: 1312612,
        propertyHref: "https://prisjakt.no"
    }
}; //# sourceMappingURL=no.js.map


/***/ }),

/***/ 78309:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.nz = void 0;
var ads_1 = __webpack_require__(74302);
var types_1 = __webpack_require__(42222);
var cookiePolicyUrl = "/information/cookie-policy";
var privacyPolicyUrl = "/information/privacy-policy";
exports.nz = {
    countryCode: "nz",
    active: true,
    sitename: "PriceSpy",
    locale: "en-nz",
    localeStandard: "en-NZ",
    sites: {
        businessCenter: "https://business.pricespy.co.uk",
        production: "https://pricespy.co.nz",
        classic: "https://classic.pricespy.co.nz",
        analytics: "https://classic.pricespy.co.nz/analytics/store/",
        brands: undefined,
        forum: "https://classic.pricespy.co.nz/forum",
        mobile: undefined,
        staging: undefined
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-26",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "en_NZ",
    timezone: "Pacific/Auckland",
    currencyCode: "NZD",
    url: {
        campaigns: "/theme",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.pricespy.co.nz"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/pricespy.co.nz/"
        },
        facebook: {
            link: "https://www.facebook.com/PriceSpyNZ"
        },
        twitter: {
            link: "https://twitter.com/PriceSpyNZ"
        }
    },
    email: {
        noreply: "noreply@pricespy.co.nz",
        security: "security@pricespy.co.nz"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/theme"
        },
        campaign: {
            path: "/theme/:slug"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        },
        promotions: {
            path: "/promotions"
        },
        promotionProducts: {
            path: "/promotions/:id"
        },
        usedProducts: {
            path: "/used"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Best smartphones",
            path: "?sort=product.user_reviews.rating%7Cdesc&category=103"
        },
        {
            title: "Great deals on headphones",
            path: "?sort=rank%7Cdesc&category=148"
        },
        {
            title: "Best deals kitchen and whiteware",
            path: "?sort=rank%7Cdesc&category=1671%7C504"
        },
        {
            title: "Best deals under $100",
            path: "?price=1-100"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        priceInformation: 5,
        registerShop: 10,
        media: 12,
        aboutReviews: 15,
        cookiePolicy: cookiePolicyUrl,
        privacyPolicy: privacyPolicyUrl,
        userAgreement: "/information/rules-and-guidelines-for-users",
        disclaimer: "/information/disclaimer",
        contact: "/information/contact",
        about: "/information/about-pricespy",
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        categoryIndex: "categoryIndex",
        newsroom: "newsroom",
        bestDeals: "/theme/daily-deals",
        blackFriday: true
    },
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "B7L94dEdgU9jQ",
        gansubFormId: "O5VZ"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.nz),
    paymentProviders: {
        priorities: [
            "SWISH",
            "VIPPS",
            "PAYPAL",
            "KLARNA",
            "SVEA_WEB_PAY",
            "VISA",
            "MASTER_CARD",
            "AMEX",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieUrl: cookiePolicyUrl,
            privacyUrl: privacyPolicyUrl
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: true,
    shopOfTheYear: true,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/price-history--ecYSSqGxIAACIAXh9N"
        },
        newsletterArticlesSidebar: {
            path: "/newsletter--ecZXbnPhcAACUAd5xi"
        }
    },
    experts: {
        enabled: false
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: false,
    login: {
        enabled: false
    },
    promotions: {
        enabled: false
    },
    prisjaktSourcepointConfig: {
        accountId: 2033,
        baseEndpoint: "https://cdn.privacy-mgmt.com",
        propertyId: 39430,
        consentLanguage: "en",
        groupPmId: 1312599,
        propertyHref: "https://pricespy.co.nz"
    }
}; //# sourceMappingURL=nz.js.map


/***/ }),

/***/ 50337:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.se = void 0;
var ads_1 = __webpack_require__(74302);
var types_1 = __webpack_require__(42222);
var cookiePolicyUrl = "/information/cookiepolicy";
var privacyPolicyUrl = "/information/integritetspolicy";
exports.se = {
    countryCode: "se",
    active: true,
    sitename: "Prisjakt",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    locale: "sv-se",
    localeStandard: "sv-SE",
    sites: {
        businessCenter: "https://business.prisjakt.nu",
        production: "https://www.prisjakt.nu",
        classic: "https://classic.prisjakt.nu",
        analytics: "https://classic.prisjakt.nu/analytics/store",
        brands: "https://research.prisjakt.nu",
        forum: "https://www.minhembio.com/forum",
        mobile: "https://m.prisjakt.nu",
        staging: "https://next-se.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-25",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "sv",
    timezone: "Europe/Stockholm",
    currencyCode: "SEK",
    url: {
        campaigns: "/tema",
        sponsoredArticles: "/artiklar/sponsrad",
        legacy: {
            brand: "/tillverkare.php",
            category: "/kategori.php",
            fight: "/fight.php",
            forum: "https://www.minhembio.com/forum",
            info: "/info.php",
            lists: "/list.php",
            minhembio: "https://www.minhembio.com",
            plugin: "/plugins/",
            product: "/produkt.php",
            raw: "/expert.php",
            store_info: "/butiksinfo.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.prisjakt.nu"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/prisjakt/"
        },
        facebook: {
            link: "https://www.facebook.com/Prisjakt"
        },
        twitter: {
            link: "https://twitter.com/Prisjaktnu"
        }
    },
    email: {
        noreply: "noreply@prisjakt.nu",
        security: "security@prisjakt.nu"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/tema"
        },
        campaign: {
            path: "/tema/:slug"
        },
        productAlert: {
            path: "*--p:id/bevaka",
            relativePath: "/bevaka"
        },
        productCompare: {
            path: "/jamfor/produkter/:productIds?"
        },
        shopOfTheYear: {
            path: "/arets-butik"
        },
        shopOfTheYearWinners: {
            path: "/arets-butik/:section"
        },
        categoryIndex: {
            path: "/kategorier"
        },
        expertProductTest: {
            path: "/tester/:slug?",
            relativePath: "/tester"
        },
        expertToplists: {
            path: "/topplistor/:slug?",
            relativePath: "/topplistor"
        },
        expertGuide: {
            path: "/guider/:slug?",
            relativePath: "/guider"
        },
        expertLandingPage: {
            path: "/experter"
        },
        expertProfile: {
            path: "/experter/profil/:slug?",
            relativePath: "/experter/profil"
        },
        expertCategory: {
            path: "/experter/:slug",
            relativePath: "/experter"
        },
        changelog: {
            path: "/changelog"
        },
        changelogLatest: {
            path: "/sok-med-filter-bekann-farg-och-las-vad-hela-varlden-tycker--clY9k8KxAAACUARLc3"
        },
        brand: {
            path: "/tillverkare.php"
        },
        category: {
            path: "/kategori.php"
        },
        product: {
            path: "/produkt.php"
        },
        store: {
            path: "/butiksinfo.php"
        },
        promotions: {
            path: "/kampanjer"
        },
        promotionProducts: {
            path: "/kampanjer/:id"
        },
        usedProducts: {
            path: "/begagnat"
        },
        editorialContentListing: {
            path: "/artiklar"
        },
        article: {
            path: "/artiklar/:slug"
        },
        sponsoredArticle: {
            path: "/artiklar/sponsrad/:slug"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Deals under 500 kr",
            path: "?price=19-500&sort=rank%7Cdesc"
        },
        {
            title: "Arbeta hemifr\xe5n",
            path: "?category=555%7C1594%7C148"
        },
        {
            title: "Deals 500 - 1000 kr",
            path: "?sort=product.popularity.total&price=500-1000"
        },
        {
            title: "Popul\xe4ra h\xf6rlurar",
            path: "?category=148&sort=product.popularity.total"
        },
        {
            title: "Vitvaror",
            path: "?category=504"
        },
        {
            title: "Till barnen",
            path: "?category=1815%7C1553"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        7,
        14,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        priceInformation: 5,
        cookiePolicy: cookiePolicyUrl,
        privacyPolicy: privacyPolicyUrl,
        contact: "/information/kontakta-oss",
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        about: "/information/om-prisjakt",
        adlink: "adlink",
        themes: "themes",
        careers: "careers",
        articles: "articles",
        shopOfTheYear: "shopOfTheYear",
        categoryIndex: "categoryIndex",
        used: "used",
        expertLogin: "expertLogin",
        experts: "experts",
        supportPage: "supportPage",
        newsroom: "newsroom",
        shopOfTheYearForShops: "https://landing.prisjakt.nu/arets_butik",
        howWorks: "/information/pa-din-sida-sedan-2002-info",
        getStarted: "/tema/kom-igang-med-prisjakts-smarta-verktyg",
        blackFriday: true
    },
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "B36O",
        gansubFormId: "9wO6UTbrO"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpreadProps(_objectSpread({}, ads_1.adsConfig.se), {
        active: true
    }),
    paymentProviders: {
        priorities: [
            "KLARNA",
            "SVEA_WEB_PAY",
            "SWISH",
            "PAYPAL",
            "VIPPS",
            "AMEX",
            "VISA",
            "MASTER_CARD",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieUrl: cookiePolicyUrl,
            privacyUrl: privacyPolicyUrl
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: true,
    showBrandingTagline: true,
    shopOfTheYear: true,
    structuredData: {
        "@context": "http://schema.org",
        "@type": "Organization",
        legalName: "Prisjakt Sverige AB",
        areaServed: "SE",
        url: "https://www.prisjakt.nu",
        address: {
            "@type": "PostalAddress",
            streetAddress: "Storgatan 47 A",
            addressLocality: "\xc4ngelholm",
            postalCode: "262 32",
            addressCountry: "Sweden"
        },
        logo: "https://pricespy-75b8.kxcdn.com/g/rfe/logos/logo_se_v2_dark.svg",
        sameAs: [
            "https://www.facebook.com/Prisjakt",
            "https://twitter.com/prisjaktnu"
        ]
    },
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        aboutExperts: {
            path: "/info/transparenslofte-prisjakt-experter--ecYmerohAAACMA0AaC"
        },
        recruiting: {
            path: "/vi-soker-nya-experter--ecYS9l2BMAACEAw3yp"
        },
        priceHistoryInfo: {
            path: "/prishistoriken--ecYMguqxEAACQA86mw"
        },
        newsletterArticlesSidebar: {
            path: "/nyhetsbrev--ecZXBQqxcAACQAWgbX"
        },
        aboutDealsCalculation: {
            path: "/transparenslofte-hur-vi-beraknar-deals--ecZakOvxAAAB8Atcyh"
        }
    },
    experts: {
        enabled: true
    },
    imageSearchEnabled: true,
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    partnerVideosEnabled: true,
    mobileContractsEnabled: true,
    productOfTheYear: {
        years: [
            {
                year: 2023,
                releaseDate: "2023-03-09T00:00:00.000Z"
            }
        ]
    },
    login: {
        enabled: true
    },
    promotions: {
        enabled: true
    },
    prisjaktSourcepointConfig: {
        accountId: 2033,
        baseEndpoint: "https://cdn.privacy-mgmt.com",
        propertyId: 39152,
        consentLanguage: "sv",
        groupPmId: 1298526,
        propertyHref: "https://prisjakt.nu"
    }
}; //# sourceMappingURL=se.js.map


/***/ }),

/***/ 42222:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.PaymentProviderGroup = exports.FilterType = exports.MARKET_CODES = exports.LANGUAGE_CODES = void 0;
exports.LANGUAGE_CODES = [
    "da",
    "fi",
    "fr",
    "en_GB",
    "nb_NO",
    "en_NZ",
    "sv"
];
exports.MARKET_CODES = [
    "se",
    "gb",
    "fi",
    "fr",
    "no",
    "nz",
    "dk"
];
var FilterType;
(function(FilterType) {
    FilterType["PRICES_INC_SHIPPING"] = "prices_inc_shipping";
    FilterType["IN_STOCK"] = "in_stock";
    FilterType["AUTHORIZED_DEALER"] = "authorized_dealer";
    FilterType["PICKUP_ONLY"] = "pickup_only";
    FilterType["INTERNATIONAL"] = "international";
    FilterType["NOT_FOR_SALE"] = "not_for_sale";
    FilterType["VARIANT_SIZE"] = "variant_size";
    FilterType["VARIANT_COLOR"] = "variant_color";
    FilterType["CONDITION"] = "condition";
    FilterType["DELIVERY_METHOD"] = "shipping-delivery-method";
    FilterType["CARRIERS"] = "shipping-carriers";
})(FilterType || (exports.FilterType = FilterType = {}));
var PaymentProviderGroup;
(function(PaymentProviderGroup) {
    PaymentProviderGroup[PaymentProviderGroup["Direct"] = 0] = "Direct";
    PaymentProviderGroup[PaymentProviderGroup["Invoice"] = 1] = "Invoice";
    PaymentProviderGroup[PaymentProviderGroup["Card"] = 2] = "Card";
})(PaymentProviderGroup || (exports.PaymentProviderGroup = PaymentProviderGroup = {})); //# sourceMappingURL=types.js.map


/***/ }),

/***/ 53254:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CampaignSettingsCookieName": () => (/* binding */ $496b546b5120b8e7$export$a9d5cc8838307fdb),
  "FeatureFlagCookieName": () => (/* binding */ $496b546b5120b8e7$export$c69cc42ed1c00d2e),
  "FeatureFlagId": () => (/* binding */ $496b546b5120b8e7$export$80c3e6e583109d73),
  "FeatureFlagOptions": () => (/* binding */ $496b546b5120b8e7$export$b446d2f8a6f20cab),
  "PjFrontEndAdmin": () => (/* binding */ $2327f7e5eb1bd05d$export$d2e0ab0ab8f011c0),
  "default": () => (/* binding */ $462fb44f0a57047a$export$2e2bcd8739ae039),
  "getCampaignSettings": () => (/* binding */ $e2d16f58ba95d9c6$export$dc5a5dac2ea3dc21),
  "isFeatureFlagEnabled": () => (/* binding */ $1d26324dec7a35cc$export$392992d139518242),
  "isValidFeatureFlag": () => (/* binding */ $1d26324dec7a35cc$export$30c745d5cc7e8d03),
  "useFeatureFlag": () => (/* binding */ $1d26324dec7a35cc$export$61acb772777ef35d)
});

;// CONCATENATED MODULE: ./packages/frontend-admin-ui/dist/module.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@2.0.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(5341);
// EXTERNAL MODULE: ./packages/rfe-nextjs-proxy/dist/index.js
var dist = __webpack_require__(16235);
;// CONCATENATED MODULE: ./packages/frontend-admin-ui/dist/module.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $ec8c6eb8352c0933$var$getDomain() {
    var ref;
    if (typeof window === "undefined") return "";
    var ref1;
    return (ref1 = (ref = window.location.hostname.match(/\w+\.(?:[a-z]{2,}|co.uk|co.nz)$/)) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : "";
}
function $ec8c6eb8352c0933$export$2edfe291d87a018a(cookieName) {
    var ref;
    if (typeof document === "undefined") return undefined;
    var value = (ref = document.cookie.split(";").map(function(str) {
        return str.trim();
    }).find(function(str) {
        return str.startsWith(cookieName);
    })) === null || ref === void 0 ? void 0 : ref.substring(cookieName.length + 1);
    return typeof value === "string" ? decodeURIComponent(value) : undefined;
}
function $ec8c6eb8352c0933$export$8169aa6a2c63f12a(cookieName, value) {
    var expireDays = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    if (typeof document === "undefined") return;
    var encodedValue = encodeURIComponent(value);
    var domain = $ec8c6eb8352c0933$var$getDomain();
    var date = new Date();
    date.setDate(date.getDate() + expireDays);
    document.cookie = "".concat(cookieName, "=").concat(encodedValue, "; expires=").concat(date.toUTCString(), "; path=/; domain=").concat(domain);
}
var $496b546b5120b8e7$exports = {};
$parcel$export($496b546b5120b8e7$exports, "CampaignSettingsCookieName", function() {
    return $496b546b5120b8e7$export$a9d5cc8838307fdb;
});
$parcel$export($496b546b5120b8e7$exports, "FeatureFlagCookieName", function() {
    return $496b546b5120b8e7$export$c69cc42ed1c00d2e;
});
$parcel$export($496b546b5120b8e7$exports, "FeatureFlagId", function() {
    return $496b546b5120b8e7$export$80c3e6e583109d73;
});
$parcel$export($496b546b5120b8e7$exports, "FeatureFlagOptions", function() {
    return $496b546b5120b8e7$export$b446d2f8a6f20cab;
});
/**
 * There are bugs related to compiling multiple targets with parcel.
 * So, for now, to be able to import these constants in a Next.js server
 * context, we can import them from this TS file instead of the deafult
 * package export.
 */ /* Campaigns */ var $496b546b5120b8e7$export$a9d5cc8838307fdb = "pj:campaigns";
var $496b546b5120b8e7$export$c69cc42ed1c00d2e = "pj:feature-flags";
var $496b546b5120b8e7$export$80c3e6e583109d73;
(function(FeatureFlagId) {
    FeatureFlagId["AdDevtools"] = "ad_devtools";
    FeatureFlagId["AllProductVariants"] = "variants-all";
    FeatureFlagId["ProductImageSearch"] = "image-search-all";
    FeatureFlagId["MyFeedPage"] = "me-feed-page";
    FeatureFlagId["PrisjaktAccount"] = "pj-account";
    FeatureFlagId["FloatingOfferList"] = "floating-offer-list";
    FeatureFlagId["NativeAdsPC"] = "native-ads-pc";
})($496b546b5120b8e7$export$80c3e6e583109d73 || ($496b546b5120b8e7$export$80c3e6e583109d73 = {}));
var $496b546b5120b8e7$export$b446d2f8a6f20cab = [
    {
        title: "Enable ad devtools",
        id: "ad_devtools"
    },
    {
        title: "Show all product variants",
        id: "variants-all"
    },
    {
        title: "Show image search for all products",
        id: "image-search-all"
    },
    {
        title: "My feed page",
        id: "me-feed-page"
    },
    {
        title: "Prisjakt Account",
        id: "pj-account"
    },
    {
        title: "Floating Offer List",
        id: "floating-offer-list"
    },
    {
        title: "Native Ads (PC)",
        id: "native-ads-pc"
    }
];
var $e2d16f58ba95d9c6$var$DefaultCampaignSettings = {
    displayDate: undefined
};
function $e2d16f58ba95d9c6$export$94d7d3df23ad5844() {
    return (0, $ec8c6eb8352c0933$export$2edfe291d87a018a)((0, $496b546b5120b8e7$export$a9d5cc8838307fdb));
}
function $e2d16f58ba95d9c6$export$d891ca38e279098f(value) {
    return (0, $ec8c6eb8352c0933$export$8169aa6a2c63f12a)((0, $496b546b5120b8e7$export$a9d5cc8838307fdb), value, 1);
}
function $e2d16f58ba95d9c6$export$dc5a5dac2ea3dc21() {
    var cookie = $e2d16f58ba95d9c6$export$94d7d3df23ad5844();
    var objectValue = cookie ? JSON.parse(cookie) : {};
    var _key;
    var settings = Object.keys($e2d16f58ba95d9c6$var$DefaultCampaignSettings).reduce(function(acc, key) {
        return _objectSpreadProps(_objectSpread({}, acc), _defineProperty({}, key, (_key = objectValue[key]) !== null && _key !== void 0 ? _key : $e2d16f58ba95d9c6$var$DefaultCampaignSettings[key]));
    }, {});
    if (settings.displayDate !== undefined) settings.displayDate = new Date(settings.displayDate);
    return settings;
}
function $e2d16f58ba95d9c6$export$a91a47b7b38ce443(settings) {
    $e2d16f58ba95d9c6$export$d891ca38e279098f(JSON.stringify(settings));
}
var $884783e2804cbfdc$var$ButtonStyles = {
    primary: "pjfa-bg-blue-500 pjfa-text-white",
    secondary: "pjfa-bg-slate-500 pjfa-text-white",
    success: "pjfa-bg-green-500 pjfa-text-white",
    warning: "pjfa-bg-amber-500 pjfa-text-white",
    error: "pjfa-bg-red-500 pjfa-text-white"
};
var $884783e2804cbfdc$var$DisabledButtonStyles = {
    primary: "pjfa-bg-blue-200 pjfa-text-white",
    secondary: "pjfa-bg-slate-200 pjfa-text-white",
    success: "pjfa-bg-green-200 pjfa-text-white",
    warning: "pjfa-bg-amber-200 pjfa-text-white",
    error: "pjfa-bg-red-200 pjfa-text-white"
};
var $884783e2804cbfdc$export$353f5b6fc5456de1 = function(param) {
    var tmp = param.variant, variant = tmp === void 0 ? "primary" : tmp, tmp1 = param.disabled, disabled = tmp1 === void 0 ? false : tmp1, children = param.children, className = param.className, onClick = param.onClick;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
        onClick: onClick,
        disabled: disabled,
        className: (0, clsx/* default */.Z)(className, disabled ? $884783e2804cbfdc$var$DisabledButtonStyles[variant] : $884783e2804cbfdc$var$ButtonStyles[variant], "pjfa-py-2 pjfa-px-4 pjfa-rounded-md pjfa-text-sm pjfa-font-medium"),
        type: "button",
        children: children
    });
};
var $89dc3a660f9973b2$var$BackgroundClasses = {
    transparent: "pjfa-bg-transparent",
    light: "pjfa-bg-slate-100 pjfa-border-slate-200 pjfa-border-2 pjfa-border-solid",
    dark: "pjfa-bg-slate-600",
    info: "pjfa-bg-blue-50 pjfa-border-blue-100 pjfa-border-2 pjfa-border-solid",
    warning: "pjfa-bg-yellow-100 pjfa-border-yellow-300 pjfa-border-2 pjfa-border-solid",
    success: "pjfa-bg-green-100 pjfa-border-green-300 pjfa-border-2 pjfa-border-solid",
    error: "pjfa-bg-red-100 pjfa-border-red-200 pjfa-border-2 pjfa-border-solid"
};
var $89dc3a660f9973b2$export$2ddb90ad54e5f587 = function(param) {
    var children = param.children, className = param.className, tmp = param.background, background = tmp === void 0 ? "transparent" : tmp;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
        className: (0, clsx/* default */.Z)("pjfa-p-3 pjfa-rounded-md", $89dc3a660f9973b2$var$BackgroundClasses[background], className),
        children: children
    });
};
function $273d6d47bdebe5e3$export$c8421ae98bf4951a(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}
function $273d6d47bdebe5e3$export$1a574e7dbe961c78(str) {
    var ref = _slicedToArray(str.split(/[-T:]/), 5), year = ref[0], month = ref[1], day = ref[2], hours = ref[3], minutes = ref[4];
    var date = new Date();
    date.setFullYear(Number(year));
    date.setMonth(Number(month) - 1);
    date.setDate(Number(day));
    date.setHours(Number(hours));
    date.setMinutes(Number(minutes));
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}
function $5c59b236a0c39645$var$getIcon(ended, active) {
    if (ended) return "\uD83D\uDD34";
    return active ? "\uD83D\uDFE2" : "⚪️";
}
var $5c59b236a0c39645$export$aa069b7bee0613e4 = function(param) {
    var name = param.name, active = param.active, ended = param.ended, startDate = param.startDate, endDate = param.endDate, onSetDisplayDate = param.onSetDisplayDate;
    var start = startDate.substring(0, 10);
    var end = endDate.substring(0, 10);
    var title = "".concat($5c59b236a0c39645$var$getIcon(ended, active), " ").concat(name);
    var onClick = (0, react.useCallback)(function() {
        var startTime = new Date(startDate).getTime();
        var endTime = new Date(endDate).getTime();
        var middleTime = startTime + (endTime - startTime) / 2;
        onSetDisplayDate === null || onSetDisplayDate === void 0 ? void 0 : onSetDisplayDate(new Date(middleTime));
    }, [
        startDate,
        endDate,
        onSetDisplayDate
    ]);
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0, jsx_runtime.jsxs)("button", {
            className: "pjfa-w-full pjfa-flex pjfa-py-1 pjfa-text-left pjfa-items-center hover:pjfa-text-slate-500",
            type: "button",
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                    className: "pjfa-text-sm pjfa-font-bold pjfa-flex-1",
                    children: title
                }),
                /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                    className: "pjfa-text-xs",
                    children: "".concat(start, " - ").concat(end)
                })
            ]
        })
    });
};
var $5c59b236a0c39645$export$6fe55797853af99b = function(param) {
    var onSetDisplayDate = param.onSetDisplayDate, campaigns = param.campaigns;
    return campaigns ? /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, jsx_runtime.Fragment), {
        children: [
            /*#__PURE__*/ (0, jsx_runtime.jsx)("h3", {
                className: "pjfa-font-bold pjfa-mb-1",
                children: "Select campaign:"
            }),
            /*#__PURE__*/ (0, jsx_runtime.jsx)("ul", {
                className: "pjfa-list-none pjfa-mb-0",
                children: campaigns.sort(function(a, b) {
                    return a.startDate.localeCompare(b.startDate);
                }).map(function(campaign) {
                    return /*#__PURE__*/ (0, jsx_runtime.jsx)($5c59b236a0c39645$export$aa069b7bee0613e4, _objectSpreadProps(_objectSpread({}, campaign), {
                        onSetDisplayDate: onSetDisplayDate
                    }), campaign.name);
                })
            })
        ]
    }) : null;
};
var $db92213b5a26952c$export$28d7870edd5ab7b5 = function() {
    var ref = (0, $fa32e51c77cec7fb$export$bea99b36cddd5d35)(), campaigns = ref.campaigns;
    var ref1 = campaigns !== null && campaigns !== void 0 ? campaigns : {}, allCampaigns = ref1.allCampaigns, onCampaignSettingsChange = ref1.onCampaignSettingsChange;
    var cookie = (0, $e2d16f58ba95d9c6$export$94d7d3df23ad5844)();
    var ref2 = _slicedToArray((0, react.useState)((0, $e2d16f58ba95d9c6$export$dc5a5dac2ea3dc21)()), 2), settings = ref2[0], setSettings = ref2[1];
    var _displayDate;
    var ref3 = _slicedToArray((0, react.useState)((0, $273d6d47bdebe5e3$export$c8421ae98bf4951a)((_displayDate = settings.displayDate) !== null && _displayDate !== void 0 ? _displayDate : new Date()).toISOString().slice(0, 16)), 2), displayDate = ref3[0], setDisplayDate = ref3[1];
    var updateCampaignSettings = (0, react.useCallback)(function(newSettings) {
        (0, $e2d16f58ba95d9c6$export$a91a47b7b38ce443)(newSettings); // set cookie
        setSettings((0, $e2d16f58ba95d9c6$export$dc5a5dac2ea3dc21)());
        onCampaignSettingsChange === null || onCampaignSettingsChange === void 0 ? void 0 : onCampaignSettingsChange((0, $e2d16f58ba95d9c6$export$dc5a5dac2ea3dc21)());
    }, [
        setSettings,
        onCampaignSettingsChange
    ]);
    var onSetDisplayDate = (0, react.useCallback)(function(date) {
        return updateCampaignSettings(_objectSpreadProps(_objectSpread({}, settings), {
            displayDate: date
        }));
    }, [
        updateCampaignSettings,
        settings
    ]);
    var onClearDisplayDate = (0, react.useCallback)(function() {
        return onSetDisplayDate();
    }, [
        onSetDisplayDate
    ]);
    var onSaveDisplayDate = (0, react.useCallback)(function() {
        return onSetDisplayDate((0, $273d6d47bdebe5e3$export$1a574e7dbe961c78)(displayDate));
    }, [
        displayDate,
        onSetDisplayDate
    ]);
    var ref4 = _slicedToArray((0, react.useState)(false), 2), debug = ref4[0], setDebug = ref4[1];
    var onToggleDebug = (0, react.useCallback)(function() {
        return setDebug(!debug);
    }, [
        debug
    ]);
    return /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
        className: "pjfa-p-3",
        children: [
            /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, $89dc3a660f9973b2$export$2ddb90ad54e5f587), {
                background: settings.displayDate ? "error" : "light",
                className: "pjfa-mb-4",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
                        className: "pjfa-mb-4",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("h3", {
                                className: "pjfa-font-bold pjfa-mb-1",
                                children: "Current display date (local time):"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("p", {
                                className: settings.displayDate ? "pjfa-font-bold" : "",
                                children: settings.displayDate ? new Intl.DateTimeFormat("sv-SE", {
                                    dateStyle: "short",
                                    timeStyle: "short"
                                }).format(settings.displayDate) : "Not set"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $884783e2804cbfdc$export$353f5b6fc5456de1), {
                        className: "pjfa-w-full",
                        variant: settings.displayDate ? "error" : "secondary",
                        onClick: onClearDisplayDate,
                        disabled: !settings.displayDate,
                        children: "Clear date"
                    })
                ]
            }),
            (allCampaigns === null || allCampaigns === void 0 ? void 0 : allCampaigns.length) ? /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $89dc3a660f9973b2$export$2ddb90ad54e5f587), {
                background: "light",
                className: "pjfa-mb-4",
                children: /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $5c59b236a0c39645$export$6fe55797853af99b), {
                    campaigns: allCampaigns,
                    onSetDisplayDate: onSetDisplayDate
                })
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, $89dc3a660f9973b2$export$2ddb90ad54e5f587), {
                background: "light",
                className: "pjfa-mb-8",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
                        className: "pjfa-mb-4",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("h3", {
                                className: "pjfa-font-bold pjfa-mb-1",
                                children: "Set display date manually (local time):"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("input", {
                                type: "datetime-local",
                                value: displayDate,
                                onChange: function(e) {
                                    return setDisplayDate(e.target.value);
                                },
                                className: "pjfa-bg-white pjfa-border pjfa-border-slate-300"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $884783e2804cbfdc$export$353f5b6fc5456de1), {
                        className: "pjfa-w-full",
                        disabled: displayDate === "" || !Date.parse(displayDate),
                        variant: "primary",
                        onClick: onSaveDisplayDate,
                        children: "Set date"
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                className: "pjfa-mb-4 pjfa-text-center pjfa-text-gray-400 pjfa-text-sm",
                children: /*#__PURE__*/ (0, jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: onToggleDebug,
                    children: [
                        debug ? "Hide" : "Show",
                        " debug info"
                    ]
                })
            }),
            debug && /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, $89dc3a660f9973b2$export$2ddb90ad54e5f587), {
                background: "light",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("h3", {
                        className: "pjfa-font-bold pjfa-mb-1",
                        children: "Cookie value:"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("pre", {
                        className: "pjfa-break-all pjfa-whitespace-pre-wrap",
                        children: cookie === undefined ? "undefined" : cookie
                    })
                ]
            })
        ]
    });
};
var $db92213b5a26952c$export$2e2bcd8739ae039 = (/* unused pure expression or super */ null && ($db92213b5a26952c$export$28d7870edd5ab7b5));
var $653138570fe58eda$export$54c2e3dc7acea9f5 = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("ul", {
        children: children
    });
};
var $51b00bd4109baf22$export$c36f87108246a02a = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("li", {
        className: (0, clsx/* default */.Z)(className, "pjfa-flex pjfa-items-center pjfa-h-[48px] pjfa-relative pjfa-text-left pjfa-text-md", "pjfa-border-b-[1px] pjfa-border-solid pjfa-border-b-slate-200"),
        children: children
    });
};
var $8f04a1918f28a376$export$cd64b929790b306c = function(param) {
    var children = param.children, id = param.id, onClick = param.onClick, className = param.className;
    var onClickHandler = (0, react.useCallback)(function() {
        return typeof onClick === "function" ? onClick(id) : undefined;
    }, [
        onClick,
        id
    ]);
    return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $51b00bd4109baf22$export$c36f87108246a02a), {
        className: className,
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
            type: "button",
            onClick: onClickHandler,
            className: (0, clsx/* default */.Z)("pjfa-flex-1 pjfa-h-[48px] pjfa-px-3 pjfa-text-left", "pjfa-bg-slate-50 hover:pjfa-bg-slate-100", "pjfa-border-y-[1px] pjfa-border-solid pjfa-border-b-slate-200 pjfa-border-t-white"),
            children: children
        })
    });
};
var $2a28d398394d1fe2$export$a583f905da3ed349 = function(param) {
    var items = param.items, onSelect = param.onSelect;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $653138570fe58eda$export$54c2e3dc7acea9f5), {
        children: items.map(function(param) {
            var title = param.title, id = param.id;
            return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $8f04a1918f28a376$export$cd64b929790b306c), {
                id: id,
                onClick: onSelect,
                children: title
            }, id);
        })
    });
};
var $40b54a6e1bab5345$export$a26c533e56bb7dc3 = function(param) {
    var title = param.title, id = param.id, active = param.active, onClick = param.onClick;
    var onClickHandler = (0, react.useCallback)(function() {
        return onClick === null || onClick === void 0 ? void 0 : onClick(id, !active);
    }, [
        onClick,
        id,
        active
    ]);
    return /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, $8f04a1918f28a376$export$cd64b929790b306c), {
        id: id,
        onClick: onClickHandler,
        children: [
            /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                className: "pjfa-mr-2",
                children: active ? "✅" : "⬜️"
            }),
            title
        ]
    });
};
var $8d722a80aacdf84d$export$6c7d1e2ecefc0a19 = function(param) {
    var items = param.items, onSelect = param.onSelect;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $653138570fe58eda$export$54c2e3dc7acea9f5), {
        children: items.map(function(param) {
            var title = param.title, id = param.id, active = param.active;
            return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $40b54a6e1bab5345$export$a26c533e56bb7dc3), {
                title: title,
                id: id,
                active: active,
                onClick: onSelect
            }, id);
        })
    });
};
function $1d26324dec7a35cc$export$30c745d5cc7e8d03(value) {
    return Object.values((0, $496b546b5120b8e7$export$80c3e6e583109d73)).includes(value);
}
function $1d26324dec7a35cc$export$392992d139518242(rawCookieValue, flagId) {
    return typeof rawCookieValue === "string" && rawCookieValue.split(",").includes(flagId);
}
function $1d26324dec7a35cc$export$61acb772777ef35d(flagId) {
    if (flagId === "pj-account") return true;
    return $1d26324dec7a35cc$export$993e1c5bbbea03c2().includes(flagId);
}
function $1d26324dec7a35cc$export$415eb492e4c8ef52(flagIds) {
    (0, $ec8c6eb8352c0933$export$8169aa6a2c63f12a)((0, $496b546b5120b8e7$export$c69cc42ed1c00d2e), Object.values((0, $496b546b5120b8e7$export$80c3e6e583109d73)).filter(function(flag) {
        return flagIds.includes(flag);
    }).join(","), 30);
}
function $1d26324dec7a35cc$export$993e1c5bbbea03c2() {
    var value = (0, $ec8c6eb8352c0933$export$2edfe291d87a018a)((0, $496b546b5120b8e7$export$c69cc42ed1c00d2e));
    return typeof value === "string" ? value.split(",").filter($1d26324dec7a35cc$export$30c745d5cc7e8d03) : [];
}
var $bbfbe3830d5926ff$export$ab28ab2e245553c7 = function() {
    var enabledFlags = (0, $1d26324dec7a35cc$export$993e1c5bbbea03c2)();
    var ref = _slicedToArray((0, react.useState)(function() {
        return (0, $496b546b5120b8e7$export$b446d2f8a6f20cab).map(function(item) {
            return _objectSpreadProps(_objectSpread({}, item), {
                active: enabledFlags.includes(item.id)
            });
        });
    }), 2), options = ref[0], setOptions = ref[1];
    var handleToggle = (0, react.useCallback)(function(id, active) {
        var newOptions = options.map(function(item) {
            return item.id === id ? _objectSpreadProps(_objectSpread({}, item), {
                active: active
            }) : item;
        });
        (0, $1d26324dec7a35cc$export$415eb492e4c8ef52)(newOptions.filter(function(item) {
            return item.active;
        }).map(function(item) {
            return item.id;
        }));
        setOptions(newOptions);
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $8d722a80aacdf84d$export$6c7d1e2ecefc0a19), {
        items: options,
        onSelect: handleToggle
    });
};
function $e42663ce78f7e0c1$export$4294e8c381c3d6f0(enabled) {
    if (enabled) (0, $ec8c6eb8352c0933$export$8169aa6a2c63f12a)((0, dist.NEXTJS_COOKIE), (0, dist.NEXTJS_COOKIE_VERSION), 30);
    else (0, $ec8c6eb8352c0933$export$8169aa6a2c63f12a)((0, dist.NEXTJS_COOKIE), "", 0);
}
function $e42663ce78f7e0c1$export$c4a65de139d15bd0() {
    return (0, $ec8c6eb8352c0933$export$2edfe291d87a018a)((0, dist.NEXTJS_COOKIE));
}
function $e42663ce78f7e0c1$export$733024cb5984b12c() {
    return $e42663ce78f7e0c1$export$c4a65de139d15bd0() === (0, dist.NEXTJS_COOKIE_VERSION);
}
function $8954be06281dffb5$var$useLocation() {
    var ref = (0, window.location), pathname = ref.pathname, search = ref.search;
    return "".concat(pathname).concat(search);
}
function $8954be06281dffb5$var$useIsNextJsPath() {
    var experimentalPaths = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0, $fa32e51c77cec7fb$export$bea99b36cddd5d35)(), market = ref.market;
    var url = $8954be06281dffb5$var$useLocation();
    return (0, dist.isProxyMarket)(market) && (0, dist.isNextJsPath)(url, market, experimentalPaths);
}
function $8954be06281dffb5$var$useNextJsPaths() {
    var experimentalPaths = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0, $fa32e51c77cec7fb$export$bea99b36cddd5d35)(), market = ref.market;
    return (0, dist.isProxyMarket)(market) ? (0, dist.getProxyPaths)(market, experimentalPaths).map(function(path) {
        return path.toString();
    }) : [];
}
var $8954be06281dffb5$export$4d85688fd020059a = function() {
    var ref = _slicedToArray((0, react.useState)((0, $e42663ce78f7e0c1$export$c4a65de139d15bd0)()), 2), cookieValue = ref[0], setCookieValue = ref[1];
    var ref1 = _slicedToArray((0, react.useState)((0, $e42663ce78f7e0c1$export$733024cb5984b12c)()), 2), experimentalRoutesEnabled = ref1[0], setExperimentalRoutesEnabled = ref1[1];
    var nextJsPaths = $8954be06281dffb5$var$useNextJsPaths(experimentalRoutesEnabled);
    var currentUrlIsNextJsPath = $8954be06281dffb5$var$useIsNextJsPath(experimentalRoutesEnabled);
    var currentUrl = $8954be06281dffb5$var$useLocation();
    var handleToggle = (0, react.useCallback)(function() {
        var newValue = !experimentalRoutesEnabled;
        (0, $e42663ce78f7e0c1$export$4294e8c381c3d6f0)(newValue);
        setExperimentalRoutesEnabled(newValue);
        setCookieValue((0, $e42663ce78f7e0c1$export$c4a65de139d15bd0)());
    }, [
        experimentalRoutesEnabled
    ]);
    var ref2 = _slicedToArray((0, react.useState)(false), 2), debug = ref2[0], setDebug = ref2[1];
    var onToggleDebug = (0, react.useCallback)(function() {
        return setDebug(!debug);
    }, [
        debug
    ]);
    return /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
        className: "pjfa-p-3",
        children: [
            /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, $89dc3a660f9973b2$export$2ddb90ad54e5f587), {
                background: experimentalRoutesEnabled ? "error" : "light",
                className: "pjfa-mb-4",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("h3", {
                        className: "pjfa-font-bold pjfa-mb-2",
                        children: "Next.js experimental routes"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("p", {
                        className: "pjfa-mb-4",
                        children: experimentalRoutesEnabled ? "You have enabled Next.js experimental routes \uD83D\uDE80" : "You have disabled Next.js experimental routes \uD83D\uDC0C"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $884783e2804cbfdc$export$353f5b6fc5456de1), {
                        className: "pjfa-w-full",
                        variant: experimentalRoutesEnabled ? "error" : "primary",
                        onClick: handleToggle,
                        children: experimentalRoutesEnabled ? "Disable experimental \uD83D\uDE33" : "Enable experimental \uD83E\uDD20"
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, $89dc3a660f9973b2$export$2ddb90ad54e5f587), {
                background: "info",
                className: "pjfa-mb-4",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("h3", {
                        className: "pjfa-font-bold pjfa-mb-2",
                        children: "Current route"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsxs)("table", {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime.jsx)("th", {
                                        className: "pjfa-font-bold pjfa-text-right pjfa-align-text-top pjfa-pr-3",
                                        children: "URL"
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                        className: "pjfa-text-xs",
                                        children: /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                                            className: "pjfa-font-mono pjfa-break-all",
                                            children: currentUrl
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime.jsx)("th", {
                                        className: "pjfa-font-bold pjfa-text-right pjfa-align-text-top pjfa-pr-3",
                                        children: "Renderer"
                                    }),
                                    /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                        children: currentUrlIsNextJsPath ? "Next.js" : "RFE"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, $89dc3a660f9973b2$export$2ddb90ad54e5f587), {
                background: "info",
                className: "pjfa-mb-4",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("h3", {
                        className: "pjfa-font-bold pjfa-mb-2",
                        children: "Routes served by Next.js"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("ul", {
                        className: "pjfa-mb-0 pjfa-list-none",
                        children: nextJsPaths.map(function(path) {
                            return /*#__PURE__*/ (0, jsx_runtime.jsx)("li", {
                                className: "pjfa-text-xs pjfa-font-mono",
                                children: path
                            }, path);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                className: "pjfa-mb-4 pjfa-text-center pjfa-text-gray-400 pjfa-text-sm",
                children: /*#__PURE__*/ (0, jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: onToggleDebug,
                    children: [
                        debug ? "Hide" : "Show",
                        " debug info"
                    ]
                })
            }),
            debug && /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, $89dc3a660f9973b2$export$2ddb90ad54e5f587), {
                background: "light",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("h3", {
                        className: "pjfa-font-bold pjfa-mb-1",
                        children: "Cookie value:"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("pre", {
                        className: "pjfa-break-all pjfa-whitespace-pre-wrap",
                        children: cookieValue === undefined ? "undefined" : cookieValue
                    })
                ]
            })
        ]
    });
};
var $61b7e6d2111dea24$export$6e2c8f0811a474ce;
(function(Section) {
    Section["Campaigns"] = "campaigns";
    Section["FeatureFlags"] = "feature-flags";
    Section["NextJs"] = "nextjs";
})($61b7e6d2111dea24$export$6e2c8f0811a474ce || ($61b7e6d2111dea24$export$6e2c8f0811a474ce = {}));
var _obj;
var $61b7e6d2111dea24$export$5cbb1b99bc8b7278 = (_obj = {}, _defineProperty(_obj, "campaigns", "Campaigns"), _defineProperty(_obj, "feature-flags", "Feature Flags"), _defineProperty(_obj, "nextjs", "Next.js"), _obj);
var _obj1;
var $61b7e6d2111dea24$export$2009c21107fe8b85 = (_obj1 = {}, _defineProperty(_obj1, "campaigns", (0, $db92213b5a26952c$export$28d7870edd5ab7b5)), _defineProperty(_obj1, "feature-flags", (0, $bbfbe3830d5926ff$export$ab28ab2e245553c7)), _defineProperty(_obj1, "nextjs", (0, $8954be06281dffb5$export$4d85688fd020059a)), _obj1);
var $61b7e6d2111dea24$export$fc1acc9190910d14 = function(value) {
    return Object.values($61b7e6d2111dea24$export$6e2c8f0811a474ce).includes(value);
};
var $61b7e6d2111dea24$export$70755ead1a7beec = function(param) {
    var section = param.section;
    var Component = $61b7e6d2111dea24$export$2009c21107fe8b85[section];
    return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, react.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)(Component, {})
    });
};
var $6860df8b43a9e045$var$IconClose = function() {
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.6673 10.6984L22.3661 19.9997L31.6673 29.3009L29.3019 31.6663L20.0007 22.3651L10.6994 31.6663L8.33398 29.3009L17.6352 19.9997L8.33398 10.6984L10.6994 8.33301L20.0007 17.6343L29.3019 8.33301L31.6673 10.6984Z",
            fill: "#000"
        })
    });
};
var $6860df8b43a9e045$var$IconBack = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)("path", {
            d: "M8.20711 14C7.76165 14 7.53857 13.4614 7.85355 13.1464L11.6464 9.35355C11.8417 9.15829 12.1583 9.15829 12.3536 9.35355L16.1464 13.1464C16.4614 13.4614 16.2383 14 15.7929 14H8.20711Z",
            fill: "#000"
        })
    });
};
var $6860df8b43a9e045$export$8b251419efc915eb = function(param) {
    var title = param.title, onExit = param.onExit, onBack = param.onBack;
    var ref = (0, $fa32e51c77cec7fb$export$bea99b36cddd5d35)(), pinned = ref.pinned, togglePinned = ref.togglePinned;
    var onExitHandler = (0, react.useCallback)(function() {
        return typeof onExit === "function" ? onExit() : undefined;
    }, [
        onExit
    ]);
    var onBackHandler = (0, react.useCallback)(function() {
        return typeof onBack === "function" ? onBack() : undefined;
    }, [
        onBack
    ]);
    var onTogglePinned = (0, react.useCallback)(function() {
        return togglePinned();
    }, [
        togglePinned
    ]);
    return /*#__PURE__*/ (0, jsx_runtime.jsxs)("header", {
        className: (0, clsx/* default */.Z)("pjfa-flex pjfa-items-center pjfa-h-[48px] pjfa-relative pjfa-bg-slate-200", "pjfa-border-b-[1px] pjfa-border-solid pjfa-border-b-slate-300"),
        children: [
            /*#__PURE__*/ (0, jsx_runtime.jsx)("h1", {
                className: "pjfa-flex-1 pjfa-text-center pjfa-text-xl pjfa-font-bold",
                children: title
            }),
            typeof onExit === "function" ? /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
                type: "button",
                onClick: onExitHandler,
                className: (0, clsx/* default */.Z)("pjfa-flex pjfa-items-center pjfa-justify-center pjfa-absolute pjfa-top-0 pjfa-left-0", "pjfa-w-[48px] pjfa-h-[48px] pjfa-opacity-20 hover:pjfa-opacity-40"),
                children: /*#__PURE__*/ (0, jsx_runtime.jsx)($6860df8b43a9e045$var$IconClose, {})
            }) : null,
            typeof onBack === "function" ? /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
                type: "button",
                onClick: onBackHandler,
                className: (0, clsx/* default */.Z)("pjfa-flex pjfa-items-center pjfa-justify-center pjfa-absolute pjfa-top-0 pjfa-left-0", "pjfa-w-[48px] pjfa-h-[48px] pjfa-opacity-20 hover:pjfa-opacity-40"),
                children: /*#__PURE__*/ (0, jsx_runtime.jsx)($6860df8b43a9e045$var$IconBack, {
                    className: (0, clsx/* default */.Z)("pjfa-transform -pjfa-rotate-90 pjfa-scale-[2]")
                })
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
                type: "button",
                onClick: onTogglePinned,
                className: (0, clsx/* default */.Z)("pjfa-flex pjfa-items-center pjfa-justify-center pjfa-absolute pjfa-top-0 pjfa-right-0 pjfa-h-[48px] pjfa-px-4"),
                children: pinned ? "\uD83D\uDCCC Unpin" : "\uD83D\uDCCC Pin"
            })
        ]
    });
};
var $e937ea93886f445d$export$e6ff31bff12b7ff4 = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
        className: className,
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 491 491",
            children: /*#__PURE__*/ (0, jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("path", {
                        d: "M244.89.5C380.2.4 489.97 110 490.08 245.31c.1 135.31-109.5 245.09-244.81 245.19C109.95 490.6.18 381 .08 245.69v-.19C.02 110.24 109.63.56 244.89.5",
                        style: {
                            fill: "#f36"
                        }
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("path", {
                        d: "M244.81 116.02c71.5-.05 129.5 57.88 129.55 129.39.04 71.5-57.88 129.5-129.39 129.54-71.5.05-129.5-57.88-129.55-129.38v-.08c-.01-71.48 57.92-129.44 129.39-129.47",
                        style: {
                            fill: "#00addb"
                        }
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("path", {
                        d: "M429.04 245.51c.06-38.29-11.85-75.65-34.08-106.83l24.19-24.22c-12.37-16.47-27-31.11-43.45-43.49L351.47 95.2c-63.79-45.28-149.21-45.32-213.03-.1L114.2 70.85a218.98 218.98 0 0 0-43.49 43.47l24.21 24.22c-45.49 63.92-45.57 149.62-.21 213.63L70.6 376.29a219.512 219.512 0 0 0 43.47 43.49l24.08-24.1c63.95 45.51 149.72 45.47 213.63-.1l24.07 24.09a219.03 219.03 0 0 0 43.42-43.55l-24.09-24.11a183.59 183.59 0 0 0 33.87-106.52m-313.54 0c.07-71.45 58.05-129.32 129.5-129.25 71.46.07 129.32 58.05 129.25 129.5-.06 71.41-57.97 129.26-129.38 129.25-71.49-.03-129.41-58.01-129.38-129.49",
                        style: {
                            fill: "#ffd065"
                        }
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("path", {
                        d: "M244.82 184.06c33.94-.03 61.49 27.46 61.52 61.4s-27.46 61.49-61.4 61.52c-33.94.03-61.49-27.46-61.52-61.41v-.06c-.02-33.92 27.46-61.44 61.4-61.45",
                        style: {
                            fill: "#ffd065"
                        }
                    })
                ]
            })
        })
    });
};
var $404a34dadc09ddf2$var$buttonPositionClassNames = {
    topLeft: "pjfa-top-0 pjfa-left-0 pjfa--translate-x-6 pjfa--translate-y-6",
    topRight: "pjfa-top-0 pjfa-right-0 pjfa-translate-x-6 pjfa--translate-y-6",
    bottomLeft: "pjfa-bottom-0 pjfa-left-0 pjfa--translate-x-6 pjfa-translate-y-6",
    bottomRight: "pjfa-bottom-0 pjfa-right-0 pjfa-translate-x-6 pjfa-translate-y-6",
    midLeft: "pjfa-bottom-[calc(50%-32px)] pjfa-left-0 pjfa--translate-x-8",
    midRight: "pjfa-bottom-[calc(50%-32px)] pjfa-right-0 pjfa-translate-x-8"
};
var $404a34dadc09ddf2$export$5ef3f69a99c16d51 = function(param) {
    var position = param.position, onClick = param.onClick, className = param.className;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
        type: "button",
        onClick: onClick,
        className: (0, clsx/* default */.Z)("pjfa-fixed pjfa-w-16 pjfa-h-16 pjfa-z-top", "pjfa-grayscale pjfa-mix-blend-multiply", "pjfa-group pjfa-transition-transform", "hover:pjfa-grayscale-0 hover:pjfa-mix-blend-normal", "hover:pjfa-translate-x-0 hover:pjfa-translate-y-0", $404a34dadc09ddf2$var$buttonPositionClassNames[position], className),
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $e937ea93886f445d$export$e6ff31bff12b7ff4), {
            className: "pjfa-absolute pjfa-left-[calc(50%-20px)] pjfa-bottom-[calc(50%-20px)] pjfa-w-10 pjfa-h-10"
        })
    });
};
var $51aec73f27e1a11a$export$6661021c36f0a701 = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
        className: (0, clsx/* default */.Z)(className, "pjfa-fixed pjfa-h-full pjfa-w-[400px] pjfa-top-0 pjfa-left-0 pjfa-z-top pjfa-overflow-y-auto", "pjfa-shadow-lg pjfa-transition-transform pjfa-transform pjfa-duration-300"),
        children: children
    });
};
var $05ab6cd7acadbd96$export$d653589df987fd93 = function() {
    var ref = (0, $fa32e51c77cec7fb$export$bea99b36cddd5d35)(), open = ref.open, pinned = ref.pinned, section = ref.section, setSection = ref.setSection, exitSection = ref.exitSection, toggleOpen = ref.toggleOpen;
    var onSelect = (0, react.useCallback)(function(id) {
        return (0, $61b7e6d2111dea24$export$fc1acc9190910d14)(id) ? setSection(id) : undefined;
    }, [
        setSection
    ]);
    return /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, react.Suspense), {
        fallback: null,
        children: [
            /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $404a34dadc09ddf2$export$5ef3f69a99c16d51), {
                position: "midLeft",
                onClick: toggleOpen
            }),
            /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, $51aec73f27e1a11a$export$6661021c36f0a701), {
                className: (0, clsx/* default */.Z)(open ? "pjfa-block" : "pjfa-hidden", pinned ? "" : "pjfa-translate-x-[-370px]", "pjfa-group pjfa-bg-white pjfa-transition-all hover:pjfa-translate-x-0"),
                children: [
                    !pinned && /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                        className: (0, clsx/* default */.Z)("pjfa-transition-opacity pjfa-opacity-100 group-hover:opacity-0", "pjfa-absolute pjfa-top-0 pjfa-right-0 pjfa-w-full pjfa-h-full", "pjfa-bg-gradient-to-r pjfa-from-white pjfa-from-95% pjfa-via-white pjfa-to-slate-300")
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                        className: (0, clsx/* default */.Z)("pjfa-absolute pjfa-top-0 pjfa-right-0 pjfa-w-full pjfa-h-full", "pjfa-bg-white pjfa-transition-opacity", pinned ? "" : "pjfa-opacity-30 group-hover:pjfa-opacity-100"),
                        children: section ? /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, jsx_runtime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $6860df8b43a9e045$export$8b251419efc915eb), {
                                    title: (0, $61b7e6d2111dea24$export$5cbb1b99bc8b7278)[section],
                                    onBack: exitSection
                                }),
                                /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $61b7e6d2111dea24$export$70755ead1a7beec), {
                                    section: section
                                })
                            ]
                        }) : /*#__PURE__*/ (0, jsx_runtime.jsxs)((0, jsx_runtime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $6860df8b43a9e045$export$8b251419efc915eb), {
                                    title: "Prisjakt",
                                    onExit: toggleOpen
                                }),
                                /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $2a28d398394d1fe2$export$a583f905da3ed349), {
                                    items: Object.entries((0, $61b7e6d2111dea24$export$5cbb1b99bc8b7278)).map(function(param) {
                                        var _param = _slicedToArray(param, 2), id = _param[0], title = _param[1];
                                        return {
                                            title: title,
                                            id: id
                                        };
                                    }),
                                    onSelect: onSelect
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $fa32e51c77cec7fb$var$PjFrontEndAdminContext = /*#__PURE__*/ (0, react.createContext)({
    open: false,
    pinned: false,
    toggleOpen: function() {
        return undefined;
    },
    togglePinned: function() {
        return undefined;
    },
    setSection: function() {
        return undefined;
    },
    exitSection: function() {
        return undefined;
    }
});
function $fa32e51c77cec7fb$var$getOptionsFromUrl() {
    var searchParams = new URLSearchParams((0, window.location.search));
    var options = {};
    searchParams.forEach(function(value, key) {
        if (key.startsWith("_pjfa")) options[key.substring(6)] = value;
    });
    return options;
}
function $fa32e51c77cec7fb$var$isTruthy(value) {
    return [
        "true",
        "1"
    ].includes(String(value));
}
var $fa32e51c77cec7fb$export$d38e92caad79f779 = function(param) {
    var children = param.children, campaigns = param.campaigns, market = param.market;
    var initialValues = $fa32e51c77cec7fb$var$getOptionsFromUrl();
    var ref = _slicedToArray((0, react.useState)($fa32e51c77cec7fb$var$isTruthy(initialValues.open)), 2), open = ref[0], setOpen = ref[1];
    var ref1 = _slicedToArray((0, react.useState)($fa32e51c77cec7fb$var$isTruthy(initialValues.pinned)), 2), pinned = ref1[0], setPinned = ref1[1];
    var ref2 = _slicedToArray((0, react.useState)((0, $61b7e6d2111dea24$export$fc1acc9190910d14)(initialValues.section) ? initialValues.section : undefined), 2), section = ref2[0], setSection = ref2[1];
    var exitSection = (0, react.useCallback)(function() {
        return setSection(undefined);
    }, [
        setSection
    ]);
    var togglePinned = (0, react.useCallback)(function() {
        return setPinned(function(val) {
            return !val;
        });
    }, [
        setPinned
    ]);
    var toggleOpen = (0, react.useCallback)(function() {
        return setOpen(function(val) {
            return !val;
        });
    }, [
        setOpen
    ]);
    var value = (0, react.useMemo)(function() {
        return {
            open: open,
            pinned: pinned,
            togglePinned: togglePinned,
            toggleOpen: toggleOpen,
            section: section,
            setSection: setSection,
            exitSection: exitSection,
            campaigns: campaigns,
            market: market
        };
    }, [
        open,
        pinned,
        togglePinned,
        toggleOpen,
        section,
        setSection,
        exitSection,
        campaigns,
        market
    ]);
    return /*#__PURE__*/ (0, jsx_runtime.jsx)($fa32e51c77cec7fb$var$PjFrontEndAdminContext.Provider, {
        value: value,
        children: children
    });
};
var $fa32e51c77cec7fb$export$bea99b36cddd5d35 = function() {
    var context = (0, react.useContext)($fa32e51c77cec7fb$var$PjFrontEndAdminContext);
    if (!context) throw new Error("PjFrontEndAdminContext must be used within PjFrontEndAdminContextProvider");
    return context;
};
var $2327f7e5eb1bd05d$export$d2e0ab0ab8f011c0 = function(param) {
    var campaigns = param.campaigns, market = param.market;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $fa32e51c77cec7fb$export$d38e92caad79f779), {
        campaigns: campaigns,
        market: market,
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $05ab6cd7acadbd96$export$d653589df987fd93), {})
    });
};
var $462fb44f0a57047a$export$2e2bcd8739ae039 = (0, $2327f7e5eb1bd05d$export$d2e0ab0ab8f011c0);
 //# sourceMappingURL=module.js.map


/***/ }),

/***/ 71447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var C = Object.create;
var A = Object.defineProperty;
var w = Object.getOwnPropertyDescriptor;
var x = Object.getOwnPropertyNames;
var U = Object.getPrototypeOf, E = Object.prototype.hasOwnProperty;
var S = function(e, n) {
    for(var t in n)A(e, t, {
        get: n[t],
        enumerable: !0
    });
}, h = function(e, n, t, s) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (n && typeof n == "object" || typeof n == "function") try {
        var _loop = function() {
            var o = _step.value;
            !E.call(e, o) && o !== t && A(e, o, {
                get: function() {
                    return n[o];
                },
                enumerable: !(s = w(n, o)) || s.enumerable
            });
        };
        for(var _iterator = x(n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
};
var j = function(e, n, t) {
    return t = e != null ? C(U(e)) : {}, h(n || !e || !e.__esModule ? A(t, "default", {
        value: e,
        enumerable: !0
    }) : t, e);
}, b = function(e) {
    return h(A({}, "__esModule", {
        value: !0
    }), e);
};
var R = {};
S(R, {
    AccountContext: function() {
        return l;
    },
    AccountProvider: function() {
        return y;
    },
    useAccount: function() {
        return M;
    }
});
module.exports = b(R);
var i = j(__webpack_require__(50959)), v = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u", T = v ? i.useLayoutEffect : i.useEffect, _ = function() {
    var _ref = _asyncToGenerator(function() {
        return __generator(this, function(_state) {
            return [
                2,
                JSON.stringify({
                    s: Math.random().toString(16),
                    location: v && window.location.href
                })
            ];
        });
    });
    return function _() {
        return _ref.apply(this, arguments);
    };
}(), L = function(e, n) {
    if (e === n) return !0;
    if (!e || !n) return !1;
    var t = Object.keys(e), s = Object.keys(n);
    return t.length !== s.length ? !1 : t.every(function(o) {
        return e[o] === n[o];
    });
}, l = (0, i.createContext)(void 0), y = function(param) {
    var e = param.config, n = param.children, tmp = param.getAuthState, t = tmp === void 0 ? void 0 : tmp, tmp1 = param.onSessionChange, s = tmp1 === void 0 ? void 0 : tmp1, tmp2 = param.backendLogout, o = tmp2 === void 0 ? function() {
        return Promise.resolve();
    } : tmp2, tmp3 = param.getSession, r = tmp3 === void 0 ? /*#__PURE__*/ _asyncToGenerator(function() {
        return __generator(this, function(_state) {
            return [
                2
            ];
        });
    }) : tmp3;
    var ref = _slicedToArray((0, i.useState)(), 2), c = ref[0], d = ref[1], ref1 = _slicedToArray((0, i.useState)(!1), 2), k = ref1[0], f = ref1[1], a = (0, i.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var u, e;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        r()
                    ];
                case 1:
                    u = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2
                    ];
                case 3:
                    d(function(p) {
                        return L(p, u) ? p : (s && s(p, u), u);
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        r,
        s
    ]);
    T(function() {
        a().then(function() {
            f(!0);
        });
    }, []);
    var g = (0, i.useMemo)(function() {
        return {
            session: c,
            config: e,
            getAuthState: t || _,
            backendLogout: o,
            refreshSession: a,
            hasSessionInitiated: k
        };
    }, [
        c,
        e,
        t,
        o,
        a,
        k
    ]);
    return i.default.createElement(l.Provider, {
        value: g
    }, n);
};
var m = __webpack_require__(50959);
var N = {
    development: {
        hosts: [
            {
                market: "se",
                baseUrl: "https://account-se-dev.cloud.pji.nu"
            },
            {
                market: "no",
                baseUrl: "https://account-no-dev.cloud.pji.nu"
            },
            {
                market: "fi",
                baseUrl: "https://account-fi-dev.cloud.pji.nu"
            },
            {
                market: "dk",
                baseUrl: "https://account-dk-dev.cloud.pji.nu"
            }
        ],
        validIssuers: [
            "https://securetoken.google.com/dev-community-bt9o"
        ],
        validAudiences: [
            "dev-community-bt9o"
        ],
        tenants: [
            {
                market: "se",
                tenantId: "market-se-jx880"
            },
            {
                market: "no",
                tenantId: "market-no-lu5g0"
            },
            {
                market: "fi",
                tenantId: "market-fi-9yas9"
            },
            {
                market: "dk",
                tenantId: "market-dk-batfh"
            }
        ]
    },
    production: {
        hosts: [
            {
                market: "se",
                baseUrl: "https://account.prisjakt.nu"
            },
            {
                market: "no",
                baseUrl: "https://account.prisjakt.no"
            },
            {
                market: "fi",
                baseUrl: "https://account.hintaopas.fi"
            },
            {
                market: "dk",
                baseUrl: "https://account.prisjagt.dk"
            }
        ],
        validIssuers: [
            "https://securetoken.google.com/prd-community-8sq2"
        ],
        validAudiences: [
            "prd-community-8sq2"
        ],
        tenants: [
            {
                market: "se",
                tenantId: "market-se-w9iof"
            },
            {
                market: "no",
                tenantId: "market-no-jt2uf"
            },
            {
                market: "fi",
                tenantId: "market-fi-vgwf0"
            },
            {
                market: "dk",
                tenantId: "market-dk-n2yp6"
            }
        ]
    }
};
function I(e) {
    var n = N[e], t = new Map(n.tenants.map(function(r) {
        return [
            r.tenantId,
            r
        ];
    })), s = new Map(n.tenants.map(function(r) {
        return [
            r.market,
            r
        ];
    })), o = new Map(n.hosts.map(function(r) {
        return [
            r.market,
            r
        ];
    }));
    return {
        getBaseUrl: function getBaseUrl(r) {
            var c = o.get(r);
            if (c === void 0) throw new Error("host for market ".concat(r, " not found"));
            return c.baseUrl;
        },
        getTenantIdByMarket: function getTenantIdByMarket(r) {
            var c = s.get(r);
            if (c === void 0) throw new Error("tenant for market ".concat(r, " not found"));
            return c.tenantId;
        },
        getTenantById: function getTenantById(r) {
            return t.get(r);
        },
        getValidAudiences: function getValidAudiences() {
            return n.validAudiences;
        },
        getValidIssuers: function getValidIssuers() {
            return n.validIssuers;
        }
    };
}
function P(e, n, t) {
    var s = e.getBaseUrl(n), o = t.responseType, r = t.clientId, c = t.codeChallenge, d = t.codeChallengeMethod, k = t.redirectUri, f = t.state, a = new URLSearchParams({
        response_type: o,
        client_id: r,
        redirect_uri: k
    });
    return c && a.set("code_challenge", c), d && a.set("code_challenge_method", d), f && a.set("state", f), "".concat(s, "/authorize?").concat(a.toString());
}
var M = function() {
    var e = (0, m.useContext)(l);
    if (e === void 0) throw new Error("useAccount must be used within an AccountProvider");
    var _env;
    var n = e.session, t = e.config, s = e.getAuthState, o = e.backendLogout, r = e.refreshSession, c = e.hasSessionInitiated, d = (0, m.useMemo)(function() {
        return I((_env = t.env) !== null && _env !== void 0 ? _env : "development");
    }, [
        t.env
    ]), k = (0, m.useCallback)(function() {
        var _window;
        var g = (_window = t.window) !== null && _window !== void 0 ? _window : window;
        !g || s().then(function(u) {
            !g || (g.location.href = P(d, t.market, {
                responseType: "code",
                state: u,
                clientId: t.clientId,
                redirectUri: t.redirectUri
            }));
        }).catch(function(u) {
            console.warn("useAccount, login(): ".concat(u.message));
        });
    }, [
        t.clientId,
        t.market,
        t.redirectUri,
        t.window,
        d,
        s
    ]), f = (0, m.useCallback)(function() {
        o().finally(function() {
            return r();
        }).catch(function(u) {
            console.warn("useAccount, logout(): ".concat(u.message));
        });
    }, [
        o,
        r
    ]), a = (0, m.useCallback)(function() {
        return "".concat(d.getBaseUrl(t.market), "/profile");
    }, []);
    return {
        session: n,
        refreshSession: r,
        login: k,
        logout: f,
        profilePageUrl: a,
        hasSessionInitiated: c
    };
};


/***/ }),

/***/ 36074:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getPreviousUrlFromResponse = exports.getNextUrlFromResponse = exports.getCanonicalUrlFromResponse = exports.getUrlFromResponse = exports.extractFiltersFromUrl = exports.addFilterToUrlBuilder = exports.addFilterToUrl = exports.getStringQuery = exports.getSortedQuery = exports.filtersToQueryObject = exports.filterToQueryParams = void 0;
var query_string_for_all_1 = __importDefault(__webpack_require__(25932));
__exportStar(__webpack_require__(86060), exports);
var EXCLUDED_PARAMS = [
    "offset",
    "sort",
    "direction",
    "size",
    "q",
    "utm_source",
    "utm_content",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "ad"
];
var PREFIXES = {
    rangeGroup: "rg_",
    range: "r_",
    boolean: "b_",
    query: "q_"
};
function unsupportedFilterType(_filter, returnValue) {
    return returnValue;
}
var filterToQueryParams = function(filter) {
    switch(filter.type){
        case "term":
            {
                return _defineProperty({}, filter.property, filter.id);
            }
        case "terms":
            {
                return _defineProperty({}, filter.property, filter.ids.join("|"));
            }
        case "range":
            {
                return _defineProperty({}, "".concat(PREFIXES.range).concat(filter.property), "".concat(filter.from, "-").concat(filter.to));
            }
        case "range-group":
            {
                return _defineProperty({}, "".concat(PREFIXES.rangeGroup).concat(filter.property), Array.isArray(filter.key) ? filter.key.join("|") : filter.key);
            }
        case "boolean":
            {
                var trueValues = [
                    "1",
                    "true",
                    "yes",
                    1,
                    true
                ];
                var value = trueValues.includes(filter.id) ? "1" : "0";
                return _defineProperty({}, "".concat(PREFIXES.boolean).concat(filter.property), value);
            }
        case "name-search":
            {
                return _defineProperty({}, "".concat(PREFIXES.query, "name"), encodeURI(filter.query));
            }
        default:
            return unsupportedFilterType(filter, {});
    }
};
exports.filterToQueryParams = filterToQueryParams;
var filtersToQueryObject = function(filters) {
    return Array.isArray(filters) && filters.length > 0 ? filters.reduce(function(result, filter) {
        return _objectSpread({}, result, (0, exports.filterToQueryParams)(filter));
    }, {}) : {};
};
exports.filtersToQueryObject = filtersToQueryObject;
var getSortedQuery = function(query) {
    return Object.keys(query).sort().reduce(function(result, key) {
        return _objectSpreadProps(_objectSpread({}, result), _defineProperty({}, key, query[key]));
    }, {});
};
exports.getSortedQuery = getSortedQuery;
var getStringQuery = function(query) {
    return query_string_for_all_1.default.stringify((0, exports.getSortedQuery)(query));
};
exports.getStringQuery = getStringQuery;
var addFilterToUrl = function(baseUrl, filter) {
    var ref = _slicedToArray(baseUrl.split("?", 2), 2), baseUrlPathName = ref[0], baseUrlQueryString = ref[1];
    var baseUrlQuery = query_string_for_all_1.default.parse(baseUrlQueryString || "");
    var newQuery = _objectSpread({}, baseUrlQuery, (0, exports.filterToQueryParams)(filter));
    if (Object.keys(newQuery).length === 0) {
        return baseUrlPathName;
    }
    return "".concat(baseUrlPathName, "?").concat((0, exports.getStringQuery)(newQuery));
};
exports.addFilterToUrl = addFilterToUrl;
var addFilterToUrlBuilder = function(urlBuilder, filter) {
    var filterQueryParams = (0, exports.filterToQueryParams)(filter);
    Object.entries(filterQueryParams).forEach(function(param) {
        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
        return urlBuilder.searchParams.set(key, value);
    });
    urlBuilder.searchParams.sort();
};
exports.addFilterToUrlBuilder = addFilterToUrlBuilder;
var extractFiltersFromUrl = function(input) {
    var searchParams = new URL(input, "http://dummy").searchParams;
    var params = _toConsumableArray(searchParams.keys()).filter(function(key) {
        return !EXCLUDED_PARAMS.includes(key);
    });
    return params.map(function(param) {
        var paramValue = searchParams.get(param);
        if (paramValue === null) {
            return null;
        }
        if (param === "".concat(PREFIXES.query, "name")) {
            return {
                type: "name-search",
                query: decodeURI(paramValue)
            };
        }
        if (param.startsWith(PREFIXES.rangeGroup)) {
            // Values can be divided by | which indicates an OR operator
            var values = paramValue.split("|");
            return {
                type: "range-group",
                property: param.substr(PREFIXES.rangeGroup.length),
                key: values
            };
        }
        if (param.startsWith(PREFIXES.range)) {
            var match = paramValue.match(/^(-?\d+\.?\d*)-(-?\d+\.?\d*)$/);
            var from = match && match[1] ? Number.parseFloat(match[1]) : NaN;
            var to = match && match[2] ? Number.parseFloat(match[2]) : NaN;
            return {
                type: "range",
                property: param.substr(PREFIXES.range.length),
                from: !Number.isNaN(from) ? from : null,
                to: !Number.isNaN(to) ? to : null
            };
        }
        if (param.startsWith(PREFIXES.boolean)) {
            return {
                type: "boolean",
                property: param.substr(PREFIXES.boolean.length),
                id: String([
                    "1",
                    "true",
                    "yes"
                ].includes(paramValue))
            };
        }
        // Values can be divided by | or , which indicates OR AND operators
        var delimiter = paramValue.includes(",") ? "," : "|";
        var operator = delimiter === "," ? "AND" : "OR";
        var values1 = paramValue.split(delimiter);
        return values1.length === 1 ? {
            type: "term",
            property: param,
            id: values1[0]
        } : {
            type: "terms",
            property: param,
            ids: values1,
            operator: operator
        };
    }).filter(Boolean);
};
exports.extractFiltersFromUrl = extractFiltersFromUrl;
var getResultsSlice = function(data) {
    return data.slices.find(function(slice) {
        return slice.type === "products" || slice.type === "offers";
    });
};
var addOffsetToUrlBuilder = function(urlBuilder, data) {
    var resultsSlice = getResultsSlice(data);
    if (resultsSlice && resultsSlice.offset > 0) {
        urlBuilder.searchParams.set("offset", "".concat(resultsSlice.offset));
        urlBuilder.searchParams.sort();
    }
    return urlBuilder;
};
var getUrlFromResponse = function(data, baseUrl) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        includeOffset: true
    };
    var urlBuilder = new URL(data.baseUrl, baseUrl);
    data.filters.forEach(function(filter) {
        return (0, exports.addFilterToUrlBuilder)(urlBuilder, filter);
    });
    if (options.includeOffset) {
        addOffsetToUrlBuilder(urlBuilder, data);
    }
    return urlBuilder;
};
exports.getUrlFromResponse = getUrlFromResponse;
var getCanonicalUrlFromResponse = function(data, baseUrl) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        includeOffset: true
    };
    var urlBuilder = new URL(data.baseUrl, baseUrl);
    data.navigationState.previous.forEach(function(param) {
        var filters = param.filters;
        return filters.forEach(function(f) {
            return (0, exports.addFilterToUrlBuilder)(urlBuilder, f);
        });
    });
    if (options.includeOffset) {
        addOffsetToUrlBuilder(urlBuilder, data);
    }
    return urlBuilder;
};
exports.getCanonicalUrlFromResponse = getCanonicalUrlFromResponse;
var getNextUrlFromResponse = function(data, baseUrl) {
    var resultsSlice = getResultsSlice(data);
    if (!resultsSlice || resultsSlice.pagination.currentPage >= resultsSlice.pagination.pages) {
        return null;
    }
    var pagination = resultsSlice.pagination, size = resultsSlice.size;
    var urlBuilder = (0, exports.getCanonicalUrlFromResponse)(data, baseUrl, {
        includeOffset: false
    });
    urlBuilder.searchParams.set("offset", "".concat(pagination.currentPage * size));
    urlBuilder.searchParams.sort();
    return urlBuilder;
};
exports.getNextUrlFromResponse = getNextUrlFromResponse;
var getPreviousUrlFromResponse = function(data, baseUrl) {
    var resultsSlice = getResultsSlice(data);
    if (!resultsSlice || resultsSlice.pagination.currentPage === 1) {
        return null;
    }
    var offset = resultsSlice.offset, size = resultsSlice.size;
    var urlBuilder = (0, exports.getCanonicalUrlFromResponse)(data, baseUrl, {
        includeOffset: false
    });
    var newOffset = offset - size;
    if (newOffset > 0) {
        urlBuilder.searchParams.set("offset", "".concat(newOffset));
        urlBuilder.searchParams.sort();
    }
    return urlBuilder;
};
exports.getPreviousUrlFromResponse = getPreviousUrlFromResponse; //# sourceMappingURL=index.js.map


/***/ }),

/***/ 86060:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
})); //# sourceMappingURL=types.js.map


/***/ }),

/***/ 6895:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZD": () => (/* binding */ $5258fa9672d60cb5$export$802c9e01fab68a53),
  "iH": () => (/* binding */ $40584624a4f973e6$export$16c9df8491437fa5),
  "is": () => (/* binding */ $91c77fc24d8eb02f$export$1c69debae1b9d0a5),
  "DD": () => (/* binding */ $3a2635aa79cac88b$export$dcafcc7609c4931f),
  "R3": () => (/* binding */ $40584624a4f973e6$export$bfc5a6a4518bc41f),
  "UF": () => (/* binding */ $f61637d5be8505ac$export$d12e78c94daaa5bc)
});

// UNUSED EXPORTS: Apntag, WelcomePageAdCookieName, WelcomePageAdCookieVersion, useRefreshAds

;// CONCATENATED MODULE: ./packages/react-ads/dist/module.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@2.0.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(5341);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intersection-observer@9.16.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(18905);
;// CONCATENATED MODULE: ./packages/react-ads/dist/module.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var $b0f05381f5e2d767$export$3d7865934588d77e;
(function(EventType) {
    EventType["AD_REQUESTED"] = "adRequested";
    EventType["AD_AVAILABLE"] = "adAvailable";
    EventType["AD_BAD_REQUEST"] = "adBadRequest";
    EventType["AD_LOADED"] = "adLoaded";
    EventType["AD_NO_BID"] = "adNoBid";
    EventType["AD_REQUEST_FAILURE"] = "adRequestFailure";
    EventType["AD_ERROR"] = "adError";
    EventType["AD_COLLAPSE"] = "adCollapse";
})($b0f05381f5e2d767$export$3d7865934588d77e || ($b0f05381f5e2d767$export$3d7865934588d77e = {}));
var $b0f05381f5e2d767$var$src = "https://adsdk.microsoft.com/ast/ast.js";
var $b0f05381f5e2d767$export$8cc61d3e1e612be2 = /*#__PURE__*/ function() {
    "use strict";
    function $b0f05381f5e2d767$export$8cc61d3e1e612be2() {
        _classCallCheck(this, $b0f05381f5e2d767$export$8cc61d3e1e612be2);
        if ($b0f05381f5e2d767$var$IS_SERVER) {
            this.apntagLib = undefined;
            return;
        }
        if (window.apntag === undefined) window.apntag = {
            anq: [],
            setPageOpts: function() {
                return undefined;
            }
        };
        this.apntagLib = window.apntag;
    }
    _createClass($b0f05381f5e2d767$export$8cc61d3e1e612be2, [
        {
            // https://docs.xandr.com/bundle/seller-tag/page/seller-tag/push.html
            key: "addToQueue",
            value: function addToQueue(callBack) {
                var ref;
                (ref = this.apntagLib) === null || ref === void 0 ? void 0 : ref.anq.push(callBack);
            }
        },
        {
            // https://docs.xandr.com/bundle/seller-tag/page/seller-tag/set-page-options.html
            key: "setPageOpts",
            value: function setPageOpts(parameters) {
                var _this = this;
                this.addToQueue(function() {
                    var ref;
                    (ref = _this.apntagLib) === null || ref === void 0 ? void 0 : ref.setPageOpts(parameters);
                });
            }
        },
        {
            // https://docs.xandr.com/bundle/seller-tag/page/seller-tag/clear-request.html
            key: "clearRequest",
            value: function clearRequest(targetId) {
                var _this = this;
                this.addToQueue(function() {
                    var ref;
                    (ref = _this.apntagLib) === null || ref === void 0 ? void 0 : ref.clearRequest(targetId);
                });
            }
        },
        {
            // https://docs.xandr.com/bundle/seller-tag/page/seller-tag/define-tag.html
            key: "defineTag",
            value: function defineTag(parameters) {
                var _this = this;
                this.addToQueue(function() {
                    var ref;
                    (ref = _this.apntagLib) === null || ref === void 0 ? void 0 : ref.defineTag(parameters);
                });
            }
        },
        {
            // https://docs.xandr.com/bundle/seller-tag/page/seller-tag/load-tags.html
            key: "loadTags",
            value: function loadTags(targetIds) {
                var _this = this;
                this.addToQueue(function() {
                    var ref;
                    (ref = _this.apntagLib) === null || ref === void 0 ? void 0 : ref.loadTags(targetIds);
                });
            }
        },
        {
            // https://docs.xandr.com/bundle/seller-tag/page/seller-tag/on-event.html
            key: "onEvent",
            value: function onEvent(eventType, targetId, callBack) {
                var _this = this;
                this.addToQueue(function() {
                    var ref;
                    (ref = _this.apntagLib) === null || ref === void 0 ? void 0 : ref.onEvent(eventType, targetId, callBack);
                });
            }
        },
        {
            // https://docs.xandr.com/bundle/seller-tag/page/seller-tag/off-event.html
            key: "offEvent",
            value: function offEvent(eventType, targetId) {
                var _this = this;
                this.addToQueue(function() {
                    var ref;
                    (ref = _this.apntagLib) === null || ref === void 0 ? void 0 : ref.offEvent(eventType, targetId);
                });
            }
        },
        {
            key: "offAllEvents",
            value: function offAllEvents() {
                var _this = this;
                var events = [
                    "adAvailable",
                    "adNoBid",
                    "adRequested",
                    "adLoaded",
                    "adRequestFailure",
                    "adError",
                    "adCollapse"
                ];
                events.forEach(function(event) {
                    _this.offEvent(event);
                });
            }
        },
        {
            // https://docs.xandr.com/bundle/seller-tag/page/seller-tag/show-tag.html
            key: "showTag",
            value: function showTag(targetId) {
                var _this = this;
                this.addToQueue(function() {
                    var ref;
                    (ref = _this.apntagLib) === null || ref === void 0 ? void 0 : ref.showTag(targetId);
                });
            }
        },
        {
            // https://docs.xandr.com/bundle/seller-tag/page/seller-tag/refresh.html
            key: "refresh",
            value: function refresh(targetId) {
                var _this = this;
                this.addToQueue(function() {
                    var ref;
                    (ref = _this.apntagLib) === null || ref === void 0 ? void 0 : ref.refresh(targetId);
                });
            }
        },
        {
            key: "resizeAd",
            value: function resizeAd(targetId, size) {
                var _this = this;
                this.addToQueue(function() {
                    var ref;
                    (ref = _this.apntagLib) === null || ref === void 0 ? void 0 : ref.resizeAd(targetId, size);
                });
            }
        }
    ], [
        {
            key: "injectScript",
            value: function injectScript() {
                if (!$b0f05381f5e2d767$var$scriptLoaded($b0f05381f5e2d767$var$src)) $b0f05381f5e2d767$var$injectAstScript();
            }
        }
    ]);
    return $b0f05381f5e2d767$export$8cc61d3e1e612be2;
}();
function $b0f05381f5e2d767$var$scriptLoaded(scriptSrc) {
    var scripts = window.document.querySelectorAll("script[src]");
    var regex = new RegExp("^".concat(scriptSrc));
    return Boolean(Object.values(scripts).filter(function(value) {
        return regex.test(value.src);
    }).length);
}
function $b0f05381f5e2d767$var$injectAstScript() {
    var scriptElement = window.document.createElement("script");
    scriptElement.type = "text/javascript";
    scriptElement.async = true;
    scriptElement.src = $b0f05381f5e2d767$var$src;
    var head = window.document.getElementsByTagName("head")[0];
    head.insertBefore(scriptElement, head.firstChild);
}
var $b0f05381f5e2d767$var$IS_SERVER = typeof window === "undefined";
var $18610ba55b70d4a1$export$6acf61af03e62db = typeof window === "undefined";
var $c4831399c0ff6fb3$var$PREFIX = "reactads:";
var $c4831399c0ff6fb3$export$219ea56851611d76 = {
    showPlacementDebugInfo: "showPlacementDebugInfo",
    enableDebugLogging: "enableDebugLogging"
};
function $c4831399c0ff6fb3$export$8206e8d612b3e63(key) {
    if (0, $18610ba55b70d4a1$export$6acf61af03e62db) return null;
    try {
        // Internal use of local storage
        return window.localStorage.getItem("".concat($c4831399c0ff6fb3$var$PREFIX).concat(key));
    } catch (_) {
        return null;
    }
}
function $c4831399c0ff6fb3$export$604e96f884a44b28(key) {
    return $c4831399c0ff6fb3$export$8206e8d612b3e63(key) === "true";
}
function $c4831399c0ff6fb3$export$61fd6f1ddd0c20e2(key, value) {
    if (0, $18610ba55b70d4a1$export$6acf61af03e62db) return;
    try {
        // Internal use of local storage
        window.localStorage.setItem("".concat($c4831399c0ff6fb3$var$PREFIX).concat(key), value);
    } catch (_) {
    /* empty */ }
}
var $7eeb32d82f689939$var$PREFIX = "[ReactAds]";
function $7eeb32d82f689939$export$af88d00dbe7f521(message) {
    for(var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        optionalParams[_key - 1] = arguments[_key];
    }
    var _console;
    if ((0, $c4831399c0ff6fb3$export$604e96f884a44b28)("enableDebugLogging")) (_console = console).log.apply(_console, [
        $7eeb32d82f689939$var$PREFIX,
        message
    ].concat(_toConsumableArray(optionalParams)));
}
function $6c98b48e1498d8d7$var$adsReducerWithLogging(state, action) {
    var newState = $6c98b48e1498d8d7$var$adsReducer(state, action);
    (0, $7eeb32d82f689939$export$af88d00dbe7f521)("ACTION(".concat(action.type, ")"), {
        current: state,
        action: action,
        next: newState
    });
    return newState;
}
function $6c98b48e1498d8d7$var$adsReducer(state, action) {
    switch(action.type){
        case "reset":
            return _objectSpreadProps(_objectSpread({}, state), {
                placementStatus: {},
                hasShownTag: [],
                pagePlacements: []
            });
        case "registerPlacement":
            var _pagePlacements;
            return _objectSpreadProps(_objectSpread({}, state), {
                pagePlacements: _toConsumableArray((_pagePlacements = state.pagePlacements) !== null && _pagePlacements !== void 0 ? _pagePlacements : []).concat([
                    action.payload
                ])
            });
        case "unregisterPlacement":
            var ref;
            var ref1;
            return _objectSpreadProps(_objectSpread({}, state), {
                pagePlacements: (ref1 = (ref = state.pagePlacements) === null || ref === void 0 ? void 0 : ref.filter(function(name) {
                    return name !== action.payload;
                })) !== null && ref1 !== void 0 ? ref1 : []
            });
        case "setPlacementStatus":
            return _objectSpreadProps(_objectSpread({}, state), {
                placementStatus: _objectSpreadProps(_objectSpread({}, state.placementStatus), _defineProperty({}, action.payload.invCode, action.payload.status))
            });
        case "setUserTrackingConsent":
            return _objectSpreadProps(_objectSpread({}, state), {
                userTrackingConsent: action.payload
            });
        case "setExtendedUserIds":
            {
                var extendedUserIds = action.payload;
                return _objectSpreadProps(_objectSpread({}, state), {
                    extendedUserIds: extendedUserIds
                });
            }
        case "showPlacementDebugInfo":
            return _objectSpreadProps(_objectSpread({}, state), {
                showPlacementDebugInfo: action.payload
            });
        case "enableDebugLogging":
            return _objectSpreadProps(_objectSpread({}, state), {
                enableDebugLogging: action.payload
            });
        case "showTag":
            return _objectSpreadProps(_objectSpread({}, state), {
                hasShownTag: _toConsumableArray(state.hasShownTag).concat([
                    action.payload
                ])
            });
        default:
            throw new Error("Unhandled action type");
    }
}
function $6c98b48e1498d8d7$export$f1a3f96812c55fce(initialState) {
    return (0, react.useReducer)($6c98b48e1498d8d7$var$adsReducerWithLogging, initialState);
}
var $40584624a4f973e6$var$AdsContext = /*#__PURE__*/ (0, react.createContext)(undefined);
var $40584624a4f973e6$var$apntag = new (0, $b0f05381f5e2d767$export$8cc61d3e1e612be2)();
var $40584624a4f973e6$export$16c9df8491437fa5 = function(param) {
    var children = param.children, countryCode = param.countryCode, pagegen = param.pagegen, onAdLoaded = param.onAdLoaded, initialUserTrackingConsent = param.initialUserTrackingConsent, tmp = param.awaitUserTrackingConsent, awaitUserTrackingConsent = tmp === void 0 ? true : tmp, enableDevtools = param.enableDevtools;
    var ref = _slicedToArray((0, $6c98b48e1498d8d7$export$f1a3f96812c55fce)({
        showPlacementDebugInfo: (0, $c4831399c0ff6fb3$export$604e96f884a44b28)("showPlacementDebugInfo"),
        enableDebugLogging: (0, $c4831399c0ff6fb3$export$604e96f884a44b28)("enableDebugLogging"),
        hasShownTag: [],
        userTrackingConsent: initialUserTrackingConsent,
        placementStatus: {},
        pagePlacements: [],
        extendedUserIds: []
    }), 2), state = ref[0], dispatch = ref[1];
    var showPlacementDebugInfo = state.showPlacementDebugInfo, enableDebugLogging = state.enableDebugLogging, placementStatus = state.placementStatus, pagePlacements = state.pagePlacements, userTrackingConsent = state.userTrackingConsent, extendedUserIds = state.extendedUserIds, hasShownTag = state.hasShownTag;
    var value = (0, react.useMemo)(function() {
        return {
            showPlacementDebugInfo: showPlacementDebugInfo,
            enableDebugLogging: enableDebugLogging,
            placementStatus: placementStatus,
            pagePlacements: pagePlacements,
            userTrackingConsent: userTrackingConsent,
            extendedUserIds: extendedUserIds,
            hasShownTag: hasShownTag,
            dispatch: dispatch,
            onAdLoaded: onAdLoaded,
            apntag: $40584624a4f973e6$var$apntag,
            awaitUserTrackingConsent: awaitUserTrackingConsent,
            countryCode: countryCode,
            pagegen: pagegen,
            enableDevtools: enableDevtools,
            logger: $7eeb32d82f689939$export$af88d00dbe7f521
        };
    }, [
        showPlacementDebugInfo,
        enableDebugLogging,
        placementStatus,
        pagePlacements,
        userTrackingConsent,
        extendedUserIds,
        hasShownTag,
        dispatch,
        onAdLoaded,
        awaitUserTrackingConsent,
        countryCode,
        pagegen,
        enableDevtools
    ]);
    (0, react.useEffect)(function() {
        (0, $b0f05381f5e2d767$export$8cc61d3e1e612be2).injectScript();
    }, []);
    return /*#__PURE__*/ (0, jsx_runtime.jsx)($40584624a4f973e6$var$AdsContext.Provider, {
        value: value,
        children: children
    });
};
var $40584624a4f973e6$export$bfc5a6a4518bc41f = function() {
    var context = (0, react.useContext)($40584624a4f973e6$var$AdsContext);
    if (!context) throw new Error("useAdsContext must be used within an AdsProvider");
    return context;
};
function $6544654c4bfa0655$export$bec700d5f8f078b0(invCode, isVisible) {
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), apntag = ref.apntag, dispatch = ref.dispatch, hasShownTag = ref.hasShownTag, placementStatus = ref.placementStatus;
    var showTagWasCalled = hasShownTag.includes(invCode);
    var status = placementStatus[invCode];
    (0, react.useEffect)(function() {
        if (status === (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_AVAILABLE && isVisible && !showTagWasCalled) {
            apntag.showTag(invCode);
            dispatch({
                type: "showTag",
                payload: invCode
            });
        }
    }, [
        isVisible,
        invCode,
        apntag,
        status,
        showTagWasCalled,
        dispatch
    ]);
    return showTagWasCalled;
}
var $b0491ecd76bc785a$var$baseAdLabelClassName = "pjra-text-xs pjra-tracking-[0.02em] pjra-leading-[1.66667] pjra-font-normal pjra-opacity-[0.72] pjra-absolute";
var $b0491ecd76bc785a$var$adLabelLeft = "".concat($b0491ecd76bc785a$var$baseAdLabelClassName, " pjra-left-0 pjra-top-[50%] pjra-origin-left -pjra-rotate-90");
var $b0491ecd76bc785a$var$adLabelRight = "".concat($b0491ecd76bc785a$var$baseAdLabelClassName, " pjra-right-0 pjra-top-[50%] pjra-origin-right pjra-rotate-90");
var $b0491ecd76bc785a$export$e8b69ea1ed3e210d = {
    size: [
        300,
        600
    ],
    style: {
        container: "pjra-w-[300px] pjra-h-[600px]",
        adLabel: $b0491ecd76bc785a$var$adLabelRight
    }
};
var $b0491ecd76bc785a$export$281549996f3364a7 = {
    size: [
        980,
        150
    ],
    style: {
        container: "pjra-w-[980px] pjra-h-[150px]",
        adLabel: $b0491ecd76bc785a$var$adLabelLeft
    }
};
var $b0491ecd76bc785a$export$df8c5bb45fd79da6 = {
    size: [
        980,
        240
    ],
    style: {
        container: "pjra-w-[980px] pjra-h-[240px]",
        adLabel: $b0491ecd76bc785a$var$adLabelLeft
    }
};
var $b0491ecd76bc785a$export$cd5c3e15d45cb542 = {
    size: [
        970,
        250
    ],
    style: {
        container: "pjra-w-[970px] pjra-h-[250px]",
        adLabel: $b0491ecd76bc785a$var$adLabelLeft
    }
};
var $b0491ecd76bc785a$export$e61de6796281efe9 = {
    size: [
        320,
        250
    ],
    style: {
        container: "pjra-w-[320px] pjra-h-[250px]",
        adLabel: $b0491ecd76bc785a$var$adLabelLeft
    }
};
var $b0491ecd76bc785a$export$ed3bb0334e3fca3e = {
    size: [
        320,
        320
    ],
    style: {
        container: "pjra-w-[320px] pjra-h-[320px]",
        adLabel: $b0491ecd76bc785a$var$adLabelLeft
    }
};
var $b0491ecd76bc785a$export$4a5d45dba841edbb = {
    size: [
        300,
        250
    ],
    style: {
        container: "pjra-w-[300px] pjra-h-[250px]",
        adLabel: $b0491ecd76bc785a$var$adLabelLeft
    }
};
var $b0491ecd76bc785a$export$81447e77cdc8a0da = {
    size: [
        1080,
        1920
    ],
    style: {
        container: "pjra-w-full pjra-h-0",
        containerStatus: _defineProperty({}, (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_LOADED, "!pjra-h-[calc(-48px_+_100svh)]")
    }
};
var $b0491ecd76bc785a$export$28d5d138caedb6f3 = {
    size: [
        1920,
        972
    ],
    style: {
        container: "pjra-w-full pjra-h-0",
        containerStatus: _defineProperty({}, (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_LOADED, "!pjra-h-[calc(-72px_+_100svh)]")
    }
};
var $f4dc0bdecb9da16a$export$b4f27e0fc616e2cc = {
    isAdsEnabled: true,
    adsLabel: "Reklame",
    siteName: "Prisjagt",
    labelAlign: "top-right",
    translations: {
        closeWelcomePage: "Rul ned til Prisjagt"
    },
    placements: {
        welcome_page_wde: {
            invCode: "dk-prisjagt-wde-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$28d5d138caedb6f3)
        },
        widescreen_1: {
            invCode: "dk-prisjagt-wde-section-widescreen_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_2: {
            invCode: "dk-prisjagt-wde-section-widescreen_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_3: {
            invCode: "dk-prisjagt-wde-section-widescreen_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        toppanorama_wde: {
            invCode: "dk-prisjagt-wde-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_1_wde: {
            invCode: "dk-prisjagt-wde-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_2_wde: {
            invCode: "dk-prisjagt-wde-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_3_wde: {
            invCode: "dk-prisjagt-wde-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_4_wde: {
            invCode: "dk-prisjagt-wde-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        welcome_page: {
            invCode: "dk-prisjagt-wph-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$81447e77cdc8a0da)
        },
        toppanorama: {
            invCode: "dk-prisjagt-wph-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_1: {
            invCode: "dk-prisjagt-wph-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_2: {
            invCode: "dk-prisjagt-wph-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_3: {
            invCode: "dk-prisjagt-wph-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_4: {
            invCode: "dk-prisjagt-wph-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_5: {
            invCode: "dk-prisjagt-wph-section-panorama_5",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        }
    }
};
var $f7379f004cf2fc15$export$ed5179c818622fb = {
    isAdsEnabled: true,
    adsLabel: "Mainos",
    siteName: "Hintaopas",
    labelAlign: "top-right",
    translations: {
        closeWelcomePage: "Vierit\xe4 alas kohtaan Hintaopas"
    },
    placements: {
        welcome_page_wde: {
            invCode: "fi-hintaopas-wde-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$28d5d138caedb6f3)
        },
        widescreen_1: {
            invCode: "fi-hintaopas-wde-section-widescreen_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_2: {
            invCode: "fi-hintaopas-wde-section-widescreen_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_3: {
            invCode: "fi-hintaopas-wde-section-widescreen_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        toppanorama_wde: {
            invCode: "fi-hintaopas-wde-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_1_wde: {
            invCode: "fi-hintaopas-wde-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_2_wde: {
            invCode: "fi-hintaopas-wde-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_3_wde: {
            invCode: "fi-hintaopas-wde-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_4_wde: {
            invCode: "fi-hintaopas-wde-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        welcome_page: {
            invCode: "fi-hintaopas-wph-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$81447e77cdc8a0da)
        },
        toppanorama: {
            invCode: "fi-hintaopas-wph-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_1: {
            invCode: "fi-hintaopas-wph-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_2: {
            invCode: "fi-hintaopas-wph-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_3: {
            invCode: "fi-hintaopas-wph-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_4: {
            invCode: "fi-hintaopas-wph-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_5: {
            invCode: "fi-hintaopas-wph-section-panorama_5",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        }
    }
};
var $dfa09c242f1b7db5$export$acb2a88f7d552ebf = {
    isAdsEnabled: false,
    adsLabel: "Publicit\xe9",
    siteName: "leDenicheur",
    labelAlign: "top-right",
    translations: {
        closeWelcomePage: "Faites d\xe9filer jusqu'\xe0 LeDenicheur"
    },
    placements: {
        welcome_page_wde: {
            invCode: "fr-ledenicheur-wde-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$28d5d138caedb6f3)
        },
        widescreen_1: {
            invCode: "fr-ledenicheur-wde-section-widescreen_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_2: {
            invCode: "fr-ledenicheur-wde-section-widescreen_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_3: {
            invCode: "fr-ledenicheur-wde-section-widescreen_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        toppanorama_wde: {
            invCode: "fr-ledenicheur-wde-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_1_wde: {
            invCode: "fr-ledenicheur-wde-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_2_wde: {
            invCode: "fr-ledenicheur-wde-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_3_wde: {
            invCode: "fr-ledenicheur-wde-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_4_wde: {
            invCode: "fr-ledenicheur-wde-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        welcome_page: {
            invCode: "fr-ledenicheur-wph-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$81447e77cdc8a0da)
        },
        toppanorama: {
            invCode: "fr-ledenicheur-wph-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_1: {
            invCode: "fr-ledenicheur-wph-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_2: {
            invCode: "fr-ledenicheur-wph-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_3: {
            invCode: "fr-ledenicheur-wph-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_4: {
            invCode: "fr-ledenicheur-wph-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_5: {
            invCode: "fr-ledenicheur-wph-section-panorama_5",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        }
    }
};
var $5fc32e45513344c6$export$4bf1e800986c5093 = {
    isAdsEnabled: false,
    adsLabel: "Advertisement",
    siteName: "PriceSpy",
    labelAlign: "top-right",
    translations: {
        closeWelcomePage: "Scroll down to PriceSpy"
    },
    placements: {
        welcome_page_wde: {
            invCode: "gb-pricespy-wde-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$28d5d138caedb6f3)
        },
        widescreen_1: {
            invCode: "gb-pricespy-wde-section-widescreen_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_2: {
            invCode: "gb-pricespy-wde-section-widescreen_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_3: {
            invCode: "gb-pricespy-wde-section-widescreen_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        toppanorama_wde: {
            invCode: "gb-pricespy-wde-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_1_wde: {
            invCode: "gb-pricespy-wde-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_2_wde: {
            invCode: "gb-pricespy-wde-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_3_wde: {
            invCode: "gb-pricespy-wde-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_4_wde: {
            invCode: "gb-pricespy-wde-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        welcome_page: {
            invCode: "gb-pricespy-wph-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$81447e77cdc8a0da)
        },
        toppanorama: {
            invCode: "gb-pricespy-wph-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_1: {
            invCode: "gb-pricespy-wph-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_2: {
            invCode: "gb-pricespy-wph-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_3: {
            invCode: "gb-pricespy-wph-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_4: {
            invCode: "gb-pricespy-wph-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_5: {
            invCode: "gb-pricespy-wph-section-panorama_5",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        }
    }
};
var $fe0a9c09edc5dfbb$export$bd1b734a238eb944 = {
    isAdsEnabled: false,
    adsLabel: "Advertisement",
    siteName: "PriceSpy",
    labelAlign: "top-right",
    translations: {
        closeWelcomePage: "Scroll down to PriceSpy"
    },
    placements: {
        welcome_page_wde: {
            invCode: "ie-pricespy-wde-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$28d5d138caedb6f3)
        },
        widescreen_1: {
            invCode: "ie-pricespy-wde-section-widescreen_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_2: {
            invCode: "ie-pricespy-wde-section-widescreen_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_3: {
            invCode: "ie-pricespy-wde-section-widescreen_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        toppanorama_wde: {
            invCode: "ie-pricespy-wde-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_1_wde: {
            invCode: "ie-pricespy-wde-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_2_wde: {
            invCode: "ie-pricespy-wde-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_3_wde: {
            invCode: "ie-pricespy-wde-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_4_wde: {
            invCode: "ie-pricespy-wde-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        welcome_page: {
            invCode: "ie-pricespy-wph-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$81447e77cdc8a0da)
        },
        toppanorama: {
            invCode: "ie-pricespy-wph-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_1: {
            invCode: "ie-pricespy-wph-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_2: {
            invCode: "ie-pricespy-wph-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_3: {
            invCode: "ie-pricespy-wph-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_4: {
            invCode: "ie-pricespy-wph-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_5: {
            invCode: "ie-pricespy-wph-section-panorama_5",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        }
    }
};
var $0d1cc02498955d84$export$401451a107dc42ce = {
    isAdsEnabled: true,
    adsLabel: "Annonse",
    siteName: "Prisjakt",
    labelAlign: "top-right",
    translations: {
        closeWelcomePage: "Rull ned til Prisjakt"
    },
    placements: {
        welcome_page_wde: {
            invCode: "no-prisjakt-wde-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$28d5d138caedb6f3)
        },
        widescreen_1: {
            invCode: "no-prisjakt-wde-section-widescreen_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_2: {
            invCode: "no-prisjakt-wde-section-widescreen_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_3: {
            invCode: "no-prisjakt-wde-section-widescreen_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        toppanorama_wde: {
            invCode: "no-prisjakt-wde-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$281549996f3364a7)
        },
        panorama_1_wde: {
            invCode: "no-prisjakt-wde-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$281549996f3364a7)
        },
        panorama_2_wde: {
            invCode: "no-prisjakt-wde-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$281549996f3364a7)
        },
        panorama_3_wde: {
            invCode: "no-prisjakt-wde-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$281549996f3364a7)
        },
        panorama_4_wde: {
            invCode: "no-prisjakt-wde-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$281549996f3364a7)
        },
        welcome_page: {
            invCode: "no-prisjakt-wph-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$81447e77cdc8a0da)
        },
        toppanorama: {
            invCode: "no-prisjakt-wph-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$e61de6796281efe9)
        },
        panorama_1: {
            invCode: "no-prisjakt-wph-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$e61de6796281efe9)
        },
        panorama_2: {
            invCode: "no-prisjakt-wph-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$e61de6796281efe9)
        },
        panorama_3: {
            invCode: "no-prisjakt-wph-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$e61de6796281efe9)
        },
        panorama_4: {
            invCode: "no-prisjakt-wph-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$e61de6796281efe9)
        },
        panorama_5: {
            invCode: "no-prisjakt-wph-section-panorama_5",
            formatSpecification: (0, $b0491ecd76bc785a$export$e61de6796281efe9)
        }
    }
};
var $9216837224a1d314$export$e211f1b16650c0ca = {
    isAdsEnabled: true,
    adsLabel: "Advertisement",
    siteName: "PriceSpy",
    labelAlign: "bottom-left",
    translations: {
        closeWelcomePage: "Scroll down to PriceSpy"
    },
    placements: {
        welcome_page_wde: {
            invCode: "nz-pricespy-wde-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$28d5d138caedb6f3)
        },
        widescreen_1: {
            invCode: "nz-pricespy-wde-section-widescreen_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_2: {
            invCode: "nz-pricespy-wde-section-widescreen_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_3: {
            invCode: "nz-pricespy-wde-section-widescreen_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        toppanorama_wde: {
            invCode: "nz-pricespy-wde-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_1_wde: {
            invCode: "nz-pricespy-wde-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_2_wde: {
            invCode: "nz-pricespy-wde-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_3_wde: {
            invCode: "nz-pricespy-wde-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        panorama_4_wde: {
            invCode: "nz-pricespy-wde-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$cd5c3e15d45cb542)
        },
        welcome_page: {
            invCode: "nz-pricespy-wph-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$81447e77cdc8a0da)
        },
        toppanorama: {
            invCode: "nz-pricespy-wph-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_1: {
            invCode: "nz-pricespy-wph-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_2: {
            invCode: "nz-pricespy-wph-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_3: {
            invCode: "nz-pricespy-wph-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_4: {
            invCode: "nz-pricespy-wph-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        },
        panorama_5: {
            invCode: "nz-pricespy-wph-section-panorama_5",
            formatSpecification: (0, $b0491ecd76bc785a$export$4a5d45dba841edbb)
        }
    }
};
var $7f8d898bfde21441$export$6362df887b441e93 = {
    isAdsEnabled: true,
    adsLabel: "Annons",
    siteName: "Prisjakt",
    labelAlign: "top-right",
    translations: {
        closeWelcomePage: "Skrolla ner till Prisjakt"
    },
    placements: {
        welcome_page_wde: {
            invCode: "se-prisjakt-wde-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$28d5d138caedb6f3)
        },
        widescreen_1: {
            invCode: "se-prisjakt-wde-section-widescreen_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_2: {
            invCode: "se-prisjakt-wde-section-widescreen_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        widescreen_3: {
            invCode: "se-prisjakt-wde-section-widescreen_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$e8b69ea1ed3e210d)
        },
        toppanorama_wde: {
            invCode: "se-prisjakt-wde-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_1_wde: {
            invCode: "se-prisjakt-wde-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_2_wde: {
            invCode: "se-prisjakt-wde-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_3_wde: {
            invCode: "se-prisjakt-wde-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        panorama_4_wde: {
            invCode: "se-prisjakt-wde-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$df8c5bb45fd79da6)
        },
        welcome_page: {
            invCode: "se-prisjakt-wph-section-welcomepage",
            formatSpecification: (0, $b0491ecd76bc785a$export$81447e77cdc8a0da)
        },
        toppanorama: {
            invCode: "se-prisjakt-wph-section-toppanorama",
            formatSpecification: (0, $b0491ecd76bc785a$export$ed3bb0334e3fca3e)
        },
        panorama_1: {
            invCode: "se-prisjakt-wph-section-panorama_1",
            formatSpecification: (0, $b0491ecd76bc785a$export$ed3bb0334e3fca3e)
        },
        panorama_2: {
            invCode: "se-prisjakt-wph-section-panorama_2",
            formatSpecification: (0, $b0491ecd76bc785a$export$ed3bb0334e3fca3e)
        },
        panorama_3: {
            invCode: "se-prisjakt-wph-section-panorama_3",
            formatSpecification: (0, $b0491ecd76bc785a$export$ed3bb0334e3fca3e)
        },
        panorama_4: {
            invCode: "se-prisjakt-wph-section-panorama_4",
            formatSpecification: (0, $b0491ecd76bc785a$export$ed3bb0334e3fca3e)
        },
        panorama_5: {
            invCode: "se-prisjakt-wph-section-panorama_5",
            formatSpecification: (0, $b0491ecd76bc785a$export$ed3bb0334e3fca3e)
        }
    }
};
var $74ed7cefcc37c13a$export$602f1fb6ba391177 = {
    se: $7f8d898bfde21441$export$6362df887b441e93,
    no: $0d1cc02498955d84$export$401451a107dc42ce,
    dk: $f4dc0bdecb9da16a$export$b4f27e0fc616e2cc,
    fi: $f7379f004cf2fc15$export$ed5179c818622fb,
    fr: $dfa09c242f1b7db5$export$acb2a88f7d552ebf,
    gb: $5fc32e45513344c6$export$4bf1e800986c5093,
    ie: $fe0a9c09edc5dfbb$export$bd1b734a238eb944,
    nz: $9216837224a1d314$export$e211f1b16650c0ca
};
var $74ed7cefcc37c13a$export$1ab9bfcffa1d4444 = 1024;
function $c8d0348d007aec2d$export$328fc4060ef2b6ed() {
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), countryCode = ref.countryCode;
    return (0, $74ed7cefcc37c13a$export$602f1fb6ba391177)[countryCode];
}
function $e06df53e646c0d4b$export$84a5224f00276f3f(format) {
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), dispatch = ref.dispatch;
    var ref1 = (0, $c8d0348d007aec2d$export$328fc4060ef2b6ed)(), isAdsEnabled = ref1.isAdsEnabled;
    (0, react.useEffect)(function() {
        if (!isAdsEnabled) return undefined;
        dispatch({
            type: "registerPlacement",
            payload: format
        });
        return function() {
            dispatch({
                type: "unregisterPlacement",
                payload: format
            });
        };
    }, [
        dispatch,
        format,
        isAdsEnabled
    ]);
}
function $45f23814f06c62b1$export$aef4de330eb3a822(invCode) {
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), apntag = ref.apntag, hasShownTag = ref.hasShownTag, logger = ref.logger;
    var ref1 = _slicedToArray((0, react.useState)(false), 2), hasReloaded = ref1[0], setHasReloaded = ref1[1];
    var ref2 = _slicedToArray((0, react.useState)(hasShownTag === null || hasShownTag === void 0 ? void 0 : hasShownTag.includes(invCode)), 1), hasBeenShown = ref2[0];
    // The combination of these two states is used to ensure that the placement is only reloaded once per life cycle.
    (0, react.useEffect)(function() {
        if (hasBeenShown && !hasReloaded) {
            apntag === null || apntag === void 0 ? void 0 : apntag.refresh([
                invCode
            ]);
            setHasReloaded(true);
            logger("refreshPlacement()", {
                invCode: invCode
            });
        }
    }, [
        hasBeenShown,
        hasReloaded,
        invCode,
        apntag,
        logger
    ]);
}
var $0ce3f8adb9c305c0$export$333eaffa1f8fe9a = function(param) {
    var format = param.format;
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), countryCode = ref.countryCode, showPlacementDebugInfo = ref.showPlacementDebugInfo, placementStatus = ref.placementStatus;
    var ref1 = (0, $c8d0348d007aec2d$export$328fc4060ef2b6ed)(), placements = ref1.placements;
    var _format = placements[format], invCode = _format.invCode, formatSpecification = _format.formatSpecification;
    var size = formatSpecification.size;
    // showPlacementDebugInfo is always disabled server side, since it is stored in localStorage.
    // This hack will avoid hydration errors.
    var ref2 = _slicedToArray((0, react.useState)(false), 2), wasMounted = ref2[0], setWasMounted = ref2[1];
    (0, react.useEffect)(function() {
        return setWasMounted(true);
    }, []);
    var _invCode;
    return wasMounted && showPlacementDebugInfo ? /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
        className: "pjra-bg-slate-100 pjra-bg-opacity-80 hover:pjra-bg-opacity-95 pjra-p-2 pjra-z-[9] pjra-absolute pjra-max-w-[90%]",
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)("table", {
            children: /*#__PURE__*/ (0, jsx_runtime.jsxs)("tbody", {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                className: "pjra-font-bold",
                                children: "Inv code:"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                children: invCode
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                className: "pjra-font-bold",
                                children: "Status:"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                children: (_invCode = placementStatus[invCode]) !== null && _invCode !== void 0 ? _invCode : "—"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                className: "pjra-font-bold",
                                children: "Generic format:"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                children: format
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                className: "pjra-font-bold",
                                children: "Country code:"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                children: countryCode
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("td", {
                                className: "pjra-font-bold",
                                children: "Size:"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsxs)("td", {
                                children: [
                                    size[0],
                                    "x",
                                    size[1]
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }) : null;
};
function $58a605505b2677f7$export$8c1d942d50a51b91(format) {
    if (format === "widescreen_1" || format === "widescreen_2" || format === "widescreen_3") return false;
    return !format.includes("wde");
}
var $5258fa9672d60cb5$export$802c9e01fab68a53 = function(param) {
    var format = param.format, className = param.className, tmp = param.triggerPoint, triggerPoint = tmp === void 0 ? 300 : tmp;
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), placementStatus = ref.placementStatus;
    var ref1 = (0, $c8d0348d007aec2d$export$328fc4060ef2b6ed)(), placements = ref1.placements, adsLabel = ref1.adsLabel, isAdsEnabled = ref1.isAdsEnabled;
    var _format = placements[format], invCode = _format.invCode, formatSpecification = _format.formatSpecification;
    var ref2 = (0, dist/* useInView */.YD)({
        rootMargin: "0px 0px ".concat(triggerPoint, "px 0px")
    }), ref3 = ref2.ref, inView = ref2.inView;
    var status = placementStatus[invCode];
    var isAdVisible = (0, react.useMemo)(function() {
        if (!status) return false;
        switch(status){
            case (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_AVAILABLE:
            case (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_LOADED:
                return true;
            case (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_REQUESTED:
            case (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_BAD_REQUEST:
            case (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_ERROR:
            case (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_NO_BID:
            case (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_REQUEST_FAILURE:
            case (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_COLLAPSE:
                return false;
            default:
                return false;
        }
    }, [
        status
    ]);
    var displayAd = inView && isAdsEnabled;
    (0, $6544654c4bfa0655$export$bec700d5f8f078b0)(invCode, displayAd);
    (0, $e06df53e646c0d4b$export$84a5224f00276f3f)(format);
    (0, $45f23814f06c62b1$export$aef4de330eb3a822)(invCode);
    if (!isAdsEnabled) return null;
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
        className: "pjra-relative",
        children: /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
            ref: ref3,
            className: (0, clsx/* default */.Z)(className, formatSpecification.style.container, (0, $58a605505b2677f7$export$8c1d942d50a51b91)(format) ? "pjra-flex lg:pjra-hidden" : "pjra-hidden lg:pjra-flex", "pjra-justify-center pjra-items-center pjra-relative", !isAdVisible && "pjra-bg-base-100"),
            children: [
                /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                    className: formatSpecification.style.adLabel,
                    children: /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                        className: "pjra-translate-y-[-50%]",
                        children: adsLabel
                    })
                }),
                /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                    id: invCode,
                    className: "pjra-border pjra-border-base-200 pjra-border-solid"
                }),
                /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $0ce3f8adb9c305c0$export$333eaffa1f8fe9a), {
                    format: format
                })
            ]
        })
    });
};
var $7023b12729b0a7bb$export$e04bcc6127e699bf = function() {
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.6673 10.6984L22.3661 19.9997L31.6673 29.3009L29.3019 31.6663L20.0007 22.3651L10.6994 31.6663L8.33398 29.3009L17.6352 19.9997L8.33398 10.6984L10.6994 8.33301L20.0007 17.6343L29.3019 8.33301L31.6673 10.6984Z",
            fill: "white",
            filter: "drop-shadow(0px 2px 4px rgba(5, 37, 46, 0.24))"
        })
    });
};
var $51cf9c224df1e901$export$65dfa53f9cd8e12e = function() {
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, jsx_runtime.jsx)("path", {
            d: "M24.5 38.0002L12.5 26.0002L15.3 23.2002L24.5 32.3502L33.7 23.2002L36.5 26.0002L24.5 38.0002ZM24.5 26.0002L12.5 14.0002L15.3 11.2002L24.5 20.3502L33.7 11.2002L36.5 14.0002L24.5 26.0002Z",
            fill: "white",
            filter: "drop-shadow(0px 2px 4px rgba(5, 37, 46, 0.24))"
        })
    });
};
var $6112df16bb138d39$export$177f87bef94f25ab = "pj:welcomead";
var $6112df16bb138d39$export$a56d2a0597283060 = 1;
function $6112df16bb138d39$export$1a647d71b9869c4c() {
    var ref;
    if (typeof document === "undefined") return undefined;
    return (ref = document.cookie.split(";").map(function(str) {
        return str.trim();
    }).find(function(str) {
        return str.startsWith($6112df16bb138d39$export$177f87bef94f25ab);
    })) === null || ref === void 0 ? void 0 : ref.substring($6112df16bb138d39$export$177f87bef94f25ab.length + 1);
}
function $6112df16bb138d39$export$7dad4b22402a8936() {
    if (typeof document === "undefined") return;
    var date = new Date();
    date.setDate(date.getDate() + 1);
    document.cookie = "".concat($6112df16bb138d39$export$177f87bef94f25ab, "=").concat($6112df16bb138d39$export$a56d2a0597283060, "; expires=").concat(date.toUTCString(), "; path=/");
}
function $0aabae872929bce0$export$39656943dfb35acc() {
    var ref = _slicedToArray((0, react.useState)(typeof window !== "undefined" ? window.scrollY : 0), 2), position = ref[0], setPosition = ref[1];
    (0, react.useEffect)(function() {
        var updatePosition = function() {
            setPosition(window.scrollY);
        };
        window.addEventListener("scroll", updatePosition);
        return function() {
            return window.removeEventListener("scroll", updatePosition);
        };
    }, []);
    return position;
}
function $961e678e41a08606$export$876269ed4f57a901() {
    var ref = _slicedToArray((0, react.useState)(true), 2), isMobile = ref[0], setIsMobile = ref[1];
    (0, react.useEffect)(function() {
        var update = function() {
            var isDesktop = "matchMedia" in window && window.matchMedia("screen and (min-width: ".concat((0, $74ed7cefcc37c13a$export$1ab9bfcffa1d4444), "px")).matches;
            setIsMobile(!isDesktop);
        };
        update();
        window.addEventListener("resize", update);
        return function() {
            return window.removeEventListener("resize", update);
        };
    }, []);
    return isMobile;
}
var $3a2635aa79cac88b$var$HEADER_SIZE = {
    desktop: 72,
    mobile: 48
};
var $3a2635aa79cac88b$var$useHeaderSize = function() {
    var isMobileResolution = (0, $961e678e41a08606$export$876269ed4f57a901)();
    return isMobileResolution ? $3a2635aa79cac88b$var$HEADER_SIZE.mobile : $3a2635aa79cac88b$var$HEADER_SIZE.desktop;
};
var $3a2635aa79cac88b$export$dcafcc7609c4931f = function(param) {
    var className = param.className, onCloseClick = param.onCloseClick, format = param.format;
    var ref, ref1;
    var ref2 = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), apntag = ref2.apntag, placementStatus = ref2.placementStatus;
    var ref3 = (0, $c8d0348d007aec2d$export$328fc4060ef2b6ed)(), placements = ref3.placements, translations = ref3.translations, adsLabel = ref3.adsLabel, isAdsEnabled = ref3.isAdsEnabled;
    var _format = placements[format], formatSpecification = _format.formatSpecification, invCode = _format.invCode;
    var scrollPosition = (0, $0aabae872929bce0$export$39656943dfb35acc)();
    var headerSize = $3a2635aa79cac88b$var$useHeaderSize();
    var status = placementStatus[invCode];
    var hasScrolledPastWelcomeAd = typeof window !== "undefined" && Math.ceil(scrollPosition + headerSize) >= Math.floor(window.innerHeight);
    var responsiveHideClassName = (0, $58a605505b2677f7$export$8c1d942d50a51b91)(format) ? "pjra-flex md:pjra-hidden" : "pjra-hidden md:pjra-flex";
    // Always render null on first mount to avoid hydration error
    var ref4 = _slicedToArray((0, react.useState)(true), 2), initialRender = ref4[0], setInitialRender = ref4[1];
    (0, react.useEffect)(function() {
        return setInitialRender(false);
    }, []);
    // To avoid this component disappearing after the ad loads, store this state
    var welcomePageAdCookieWasSet = (0, $6112df16bb138d39$export$1a647d71b9869c4c)() !== undefined;
    var ref5 = _slicedToArray((0, react.useState)(welcomePageAdCookieWasSet), 1), welcomePageWasDisplayedPreviously = ref5[0];
    // Set cookie when the ad is displayed
    (0, react.useEffect)(function() {
        if (!welcomePageWasDisplayedPreviously && status === (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_LOADED) {
            apntag.resizeAd(invCode, [
                "100%",
                "100%"
            ]);
            (0, $6112df16bb138d39$export$7dad4b22402a8936)();
        }
    }, [
        welcomePageWasDisplayedPreviously,
        status,
        apntag,
        invCode
    ]);
    var displayAd = !initialRender && !welcomePageWasDisplayedPreviously && isAdsEnabled;
    (0, $6544654c4bfa0655$export$bec700d5f8f078b0)(invCode, displayAd);
    (0, $e06df53e646c0d4b$export$84a5224f00276f3f)(format);
    if (!displayAd) return null;
    return /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
                className: (0, clsx/* default */.Z)(className, status ? (ref = formatSpecification.style.containerStatus) === null || ref === void 0 ? void 0 : ref[status] : undefined, responsiveHideClassName, "pjra-transition-height pjra-justify-center pjra-items-center pjra-relative pjra-overflow-hidden [clip-path:inset(0_0_0_0)] pj-bg-white"),
                children: [
                    /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
                        className: (0, clsx/* default */.Z)(formatSpecification.style.container, status ? (ref1 = formatSpecification.style.containerStatus) === null || ref1 === void 0 ? void 0 : ref1[status] : undefined, "pjra-fixed pjra-left-0 pjra-top-0 pjra-flex pjra-justify-center pjra-items-center"),
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                                id: invCode,
                                className: "pjra-w-full pjra-h-full"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: onCloseClick,
                                title: translations.closeWelcomePage,
                                className: "pjra-absolute pjra-left-5 pjra-top-10 pjra-cursor-pointer hover:pjra-scale-110 pjra-transition-transform",
                                children: /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $7023b12729b0a7bb$export$e04bcc6127e699bf), {})
                            }),
                            /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                                className: "pjra-absolute pjra-right-0 pjra-top-0 pjra-bg-white pjra-text-xs pjra-tracking-[0.02em] pjra-leading-[1.66667] pjra-font-normal pjra-opacity-[0.72] pjra-px-2 pjra-py-1",
                                children: adsLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
                        className: "pjra-w-full pjra-h-[160px] pjra-flex pjra-justify-center pjra-items-center pjra-absolute pjra-bottom-0 pjra-bg-gradient-to-t pjra-from-black-20 pjra-cursor-pointer",
                        children: /*#__PURE__*/ (0, jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: onCloseClick,
                            className: "pjra-cursor-pointer pjra-px-10 pjra-h-full pjra-flex pjra-flex-col pjra-justify-center pjra-items-center pjra-text-white pjra-text-2xl pjra-gap-1 pjra-drop-shadow-md hover:pjra-scale-105 pjra-origin-bottom pjra-transition-transform",
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                                    className: "pjra-mb-3",
                                    children: translations.closeWelcomePage
                                }),
                                /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                                    className: "pjra-animate-bounce",
                                    children: /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $51cf9c224df1e901$export$65dfa53f9cd8e12e), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $0ce3f8adb9c305c0$export$333eaffa1f8fe9a), {
                        format: format
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
                type: "button",
                onClick: onCloseClick,
                className: (0, clsx/* default */.Z)(responsiveHideClassName, hasScrolledPastWelcomeAd || status !== (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_LOADED ? "!pjra-hidden" : null, "pjra-cursor-pointer pjra-h-[48px] md:pjra-h-[72px] pjra-absolute pjra-bottom-0 pjra-w-full pjra-z-[108]"),
                children: /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                    className: "pjra-hidden",
                    children: translations.closeWelcomePage
                })
            })
        ]
    });
};
var $763ce452c92ed536$export$60332b2344f7fe41 = function(param) {
    var children = param.children, title = param.title;
    return /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
        className: "pjra-bg-white pjra-p-2 pjra-rounded",
        children: [
            /*#__PURE__*/ (0, jsx_runtime.jsx)("p", {
                className: "pjra-mb-2 pjra-font-bold",
                children: title
            }),
            children
        ]
    });
};
var $cc1e46f4fa02df79$export$d4af0884abaef274 = function() {
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), placementStatus = ref.placementStatus;
    var ref1 = (0, $c8d0348d007aec2d$export$328fc4060ef2b6ed)(), placements = ref1.placements;
    var invCodes = Object.keys(placementStatus);
    var hasDuplicatedCodes = $cc1e46f4fa02df79$var$checkIfDuplicateExists(invCodes);
    var getFormat = function(invCode) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(placements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var genericFormat = _step.value;
                if (placements[genericFormat].invCode === invCode) return genericFormat;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return "Unknown format";
    };
    return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $763ce452c92ed536$export$60332b2344f7fe41), {
        title: "Placement status",
        children: !invCodes ? /*#__PURE__*/ (0, jsx_runtime.jsx)("p", {
            children: "No tags requested"
        }) : /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
            children: [
                hasDuplicatedCodes ? /*#__PURE__*/ (0, jsx_runtime.jsx)("p", {
                    className: "pjra-text-red-500",
                    children: "You have requested duplicated tags"
                }) : null,
                /*#__PURE__*/ (0, jsx_runtime.jsx)("ul", {
                    className: "pjra-list-none pjra-flex pjra-flex-col pjra-gap-1",
                    children: invCodes.map(function(invCode) {
                        return /*#__PURE__*/ (0, jsx_runtime.jsxs)("li", {
                            className: "pjra-border pjra-border-solid pjra-border-black pjra-p-1",
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
                                    children: [
                                        "Inv code: ",
                                        /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                                            className: "pjra-font-bold",
                                            children: invCode
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
                                    children: [
                                        "Generic format:",
                                        " ",
                                        /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                                            className: "pjra-font-bold",
                                            children: getFormat(invCode)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
                                    children: [
                                        "Status:",
                                        " ",
                                        /*#__PURE__*/ (0, jsx_runtime.jsx)("span", {
                                            className: "pjra-font-bold",
                                            children: placementStatus === null || placementStatus === void 0 ? void 0 : placementStatus[invCode]
                                        })
                                    ]
                                })
                            ]
                        }, invCode);
                    })
                })
            ]
        })
    });
};
function $cc1e46f4fa02df79$var$checkIfDuplicateExists() {
    var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Set(arr).size !== arr.length;
}
var $d2f27af703e414bf$export$ac5ab2dba1acaad0 = function() {
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), pagePlacements = ref.pagePlacements;
    var hasDuplicatePlacements = $d2f27af703e414bf$var$checkIfDuplicateExists(pagePlacements);
    return /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $763ce452c92ed536$export$60332b2344f7fe41), {
        title: "Placements in the page",
        children: !pagePlacements ? /*#__PURE__*/ (0, jsx_runtime.jsx)("p", {
            children: "No registered placements in the page"
        }) : /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
            children: [
                hasDuplicatePlacements ? /*#__PURE__*/ (0, jsx_runtime.jsx)("p", {
                    className: "pjra-text-red-500",
                    children: "You have duplicated ad placements in the page"
                }) : null,
                /*#__PURE__*/ (0, jsx_runtime.jsx)("ul", {
                    className: "pjra-list-none",
                    children: pagePlacements.map(function(format) {
                        return /*#__PURE__*/ (0, jsx_runtime.jsx)("li", {
                            children: format
                        }, format);
                    })
                })
            ]
        })
    });
};
function $d2f27af703e414bf$var$checkIfDuplicateExists() {
    var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Set(arr).size !== arr.length;
}
var $91c77fc24d8eb02f$var$buttonClass = "pjra-border-1 pjra-border-solid pjra-p-1.5 pjra-bg-purple-900 pjra-rounded pjra-text-white";
var $91c77fc24d8eb02f$export$1c69debae1b9d0a5 = function() {
    var ref = _slicedToArray((0, react.useState)(false), 2), open = ref[0], setOpen = ref[1];
    var ref1 = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), enableDevtools = ref1.enableDevtools, showPlacementDebugInfo = ref1.showPlacementDebugInfo, enableDebugLogging = ref1.enableDebugLogging, dispatch = ref1.dispatch;
    if (!enableDevtools) return null;
    if (open) return /*#__PURE__*/ (0, jsx_runtime.jsx)("div", {
        className: "pjra-fixed pjra-left-0 pjra-bottom-0 pjra-z-[99999] pjra-w-full pjra-bg-amber-300 pjra-p-2 sm:pjra-left-0 sm:pjra-top-0 sm:pjra-h-full sm:pjra-max-w-[400px]",
        children: /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
            className: "pjra-flex pjra-flex-col sm:pjra-h-full",
            children: [
                /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
                    className: "pjra-flex pjra-justify-between pjra-items-center",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime.jsx)("p", {
                            className: "pjra-font-bold pjra-text-lg pjra-m-0",
                            children: "@prisjakt/react-ads"
                        }),
                        /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: function() {
                                return setOpen(false);
                            },
                            className: $91c77fc24d8eb02f$var$buttonClass,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, jsx_runtime.jsxs)("label", {
                    className: "pjra-flex pjra-flex-row pjra-gap-1 pjra-items-center",
                    children: [
                        "Show placement debug info",
                        /*#__PURE__*/ (0, jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            checked: showPlacementDebugInfo,
                            onChange: function(event) {
                                (0, $c4831399c0ff6fb3$export$61fd6f1ddd0c20e2)("showPlacementDebugInfo", event.target.checked.toString());
                                dispatch({
                                    type: "showPlacementDebugInfo",
                                    payload: event.target.checked
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, jsx_runtime.jsxs)("label", {
                    className: "pjra-flex pjra-flex-row pjra-gap-1 pjra-items-center",
                    children: [
                        "Enable debug logging",
                        /*#__PURE__*/ (0, jsx_runtime.jsx)("input", {
                            type: "checkbox",
                            checked: enableDebugLogging,
                            onChange: function(event) {
                                (0, $c4831399c0ff6fb3$export$61fd6f1ddd0c20e2)("enableDebugLogging", event.target.checked.toString());
                                dispatch({
                                    type: "enableDebugLogging",
                                    payload: event.target.checked
                                });
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, jsx_runtime.jsxs)("div", {
                    className: "pjra-flex pjra-flex-row pjra-gap-2 sm:pjra-h-full pjra-overflow-y-auto sm:pjra-flex-col",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $cc1e46f4fa02df79$export$d4af0884abaef274), {}),
                        /*#__PURE__*/ (0, jsx_runtime.jsx)((0, $d2f27af703e414bf$export$ac5ab2dba1acaad0), {})
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, jsx_runtime.jsx)("button", {
        type: "button",
        onClick: function() {
            return setOpen(true);
        },
        className: (0, clsx/* default */.Z)($91c77fc24d8eb02f$var$buttonClass, "pjra-fixed pjra-left-2 pjra-top-2 pjra-z-[99999]"),
        children: "Ads Devtools"
    });
};
function $8847e0941af059ab$export$72a80136859d039f() {
    var ref = _slicedToArray((0, react.useState)("web_desktop"), 2), supplyType = ref[0], setSupplyType = ref[1];
    (0, react.useEffect)(function() {
        setSupplyType(window.innerWidth >= (0, $74ed7cefcc37c13a$export$1ab9bfcffa1d4444) ? "web_desktop" : "web_phone");
    }, []);
    return supplyType;
}
var $f2ea9c9ccded313b$var$ALL_EVENT_TYPES = Object.values((0, $b0f05381f5e2d767$export$3d7865934588d77e));
function $f2ea9c9ccded313b$export$47d5987d87b63983(formats) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), countryCode = ref.countryCode, apntag = ref.apntag, onAdLoaded = ref.onAdLoaded, dispatch = ref.dispatch, logger = ref.logger;
    var ref1 = (0, $c8d0348d007aec2d$export$328fc4060ef2b6ed)(), placements = ref1.placements;
    var supplyType = (0, $8847e0941af059ab$export$72a80136859d039f)();
    var formatsString = formats.join(",");
    var ref2 = _slicedToArray((0, react.useState)([]), 2), tags = ref2[0], setTags = ref2[1];
    (0, react.useEffect)(function() {
        if (!enabled) return undefined;
        var welcomeAdHasBeenDisplayed = (0, $6112df16bb138d39$export$1a647d71b9869c4c)() !== undefined;
        var mappedFormats = formatsString.split(",");
        var mappedTags = mappedFormats.filter(function(format) {
            return supplyType === "web_desktop" ? !(0, $58a605505b2677f7$export$8c1d942d50a51b91)(format) : (0, $58a605505b2677f7$export$8c1d942d50a51b91)(format);
        }).filter(function(format) {
            return !welcomeAdHasBeenDisplayed || !/welcome_page/.test(format);
        }).map(function(format) {
            var _format = placements[format], invCode = _format.invCode, formatSpecification = _format.formatSpecification;
            return {
                invCode: invCode,
                targetId: invCode,
                sizes: formatSpecification.size,
                allowedFormats: [
                    "banner",
                    "native"
                ],
                keywords: {
                    "se-generic-adformat": format,
                    "se-generic-adsize": formatSpecification.size.join("x")
                }
            };
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = mappedTags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var tag = _step.value;
                apntag.defineTag(tag);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setTags(mappedTags);
        // onAdLoaded callback uses genericAdFormat name
        var genericAdFormats = new Map();
        var invCodes = new Set();
        mappedFormats.forEach(function(format) {
            var placement = placements[format];
            invCodes.add(placement.invCode);
            genericAdFormats.set(placement.invCode, format);
        });
        invCodes.forEach(function(invCode) {
            $f2ea9c9ccded313b$var$ALL_EVENT_TYPES.forEach(function(event) {
                apntag.onEvent(event, invCode, function(adObj) {
                    dispatch({
                        type: "setPlacementStatus",
                        payload: {
                            invCode: invCode,
                            status: event
                        }
                    });
                    var format = genericAdFormats.get(invCode);
                    // This callback is provided by the host application and is used for tracking ad loads to GA
                    if (event === (0, $b0f05381f5e2d767$export$3d7865934588d77e).AD_LOADED && adObj !== undefined && typeof onAdLoaded === "function" && format) onAdLoaded(format, adObj);
                });
            });
        });
        logger("defineTags()", {
            tags: mappedTags
        });
        return function() {
            invCodes.forEach(function(invCode) {
                $f2ea9c9ccded313b$var$ALL_EVENT_TYPES.forEach(function(event) {
                    apntag.offEvent(event, invCode);
                });
            });
        };
    }, [
        apntag,
        countryCode,
        dispatch,
        enabled,
        onAdLoaded,
        formatsString,
        supplyType,
        placements,
        logger
    ]);
    return tags;
}
function $090b9f7a1bf22c50$export$df36fb695fd2624f() {
    var ref = _slicedToArray((0, react.useState)(), 2), genericTest = ref[0], setGenericTest = ref[1];
    (0, react.useEffect)(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var ref;
        var adParam = (ref = urlParams.get("ad")) !== null && ref !== void 0 ? ref : undefined;
        setGenericTest(adParam);
    }, []);
    return genericTest;
}
var $acaf2960a236e694$var$PAGE_TYPE_START = "index";
var $acaf2960a236e694$var$PAGE_TYPE_OTHER = "other";
var $acaf2960a236e694$var$PAGE_TYPE_PRODUCT = "product";
var $acaf2960a236e694$var$PAGE_TYPE_CATEGORY = "category";
var $acaf2960a236e694$var$PAGE_TYPE_KEYWORD = "kwlp";
var $acaf2960a236e694$var$PAGE_TYPE_CAMPAIGN = "campaign";
var $acaf2960a236e694$var$PAGE_TYPE_SHOP = "shop";
var $acaf2960a236e694$var$PAGE_TYPE_BRAND = "manufacturer";
var $acaf2960a236e694$var$PAGE_TYPE_SEARCH = "search";
var $acaf2960a236e694$var$PAGE_TYPE_USED_PRODUCTS = "usedProducts";
var $acaf2960a236e694$var$PAGE_TYPE_DEALS = "deals";
var $acaf2960a236e694$var$SCHIBSTED_PAGE_TYPE_OBJECT = "object";
var $acaf2960a236e694$var$SCHIBSTED_PAGE_TYPE_SECTION = "section";
var $acaf2960a236e694$var$SCHIBSTED_PAGE_TYPE_START = "front";
var $acaf2960a236e694$export$b4041abc3064fa61 = function(pageType) {
    switch(pageType){
        case $acaf2960a236e694$var$PAGE_TYPE_START:
            return $acaf2960a236e694$var$SCHIBSTED_PAGE_TYPE_START;
        case $acaf2960a236e694$var$PAGE_TYPE_PRODUCT:
            return $acaf2960a236e694$var$SCHIBSTED_PAGE_TYPE_OBJECT;
        case $acaf2960a236e694$var$PAGE_TYPE_CATEGORY:
            return $acaf2960a236e694$var$SCHIBSTED_PAGE_TYPE_SECTION;
        case $acaf2960a236e694$var$PAGE_TYPE_KEYWORD:
            return $acaf2960a236e694$var$SCHIBSTED_PAGE_TYPE_SECTION;
        case $acaf2960a236e694$var$PAGE_TYPE_CAMPAIGN:
            return $acaf2960a236e694$var$SCHIBSTED_PAGE_TYPE_SECTION;
        default:
            return $acaf2960a236e694$var$PAGE_TYPE_OTHER;
    }
};
function $2daf6c17b873dc69$export$e8dcee988c4738cb(options) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), countryCode = ref.countryCode, pagegen = ref.pagegen, userTrackingConsent = ref.userTrackingConsent, apntag = ref.apntag, extendedUserIds = ref.extendedUserIds, logger = ref.logger;
    var genericTest = (0, $090b9f7a1bf22c50$export$df36fb695fd2624f)();
    var supplyType = (0, $8847e0941af059ab$export$72a80136859d039f)();
    var pageType = options.pageType, price = options.price, searchWord = options.searchWord, brand = options.brand, categoryPath = options.categoryPath;
    var categoryPathString = categoryPath ? categoryPath.join(",") : "";
    var extendedUserIdsString = extendedUserIds ? JSON.stringify(extendedUserIds) : "";
    (0, react.useEffect)(function() {
        if (!enabled) return;
        var publisher = "".concat(countryCode.toUpperCase(), "-").concat((0, $74ed7cefcc37c13a$export$602f1fb6ba391177)[countryCode].siteName);
        var genericSection = categoryPathString.split(",");
        var prisjaktSection = pageType === "product" && genericSection.length > 0 ? genericSection.slice(0, -1).concat("p".concat(genericSection[genericSection.length - 1])) // Used to differentiate product page from category pages.
         : genericSection;
        var pageOptions = {
            member: 14785,
            disablePsa: true,
            noBidIfUnsold: true,
            enableSafeFrame: true,
            user: extendedUserIdsString !== "" ? {
                userIds: [
                    {
                        type: "extendedIDs",
                        eids: JSON.parse(extendedUserIdsString)
                    }
                ]
            } : undefined,
            keywords: {
                "aa-sch-page_type": (0, $acaf2960a236e694$export$b4041abc3064fa61)(pageType),
                "aa-sch-supply_type": supplyType,
                "aa-sch-country_code": countryCode,
                "aa-sch-publisher": publisher,
                "aa-sch-cmp_advertising": userTrackingConsent ? "1" : "0",
                "se-generic-pagegen": pagegen,
                "se-generic-page": pageType,
                "se-generic-section": genericSection,
                "se-prisjakt-section": prisjaktSection,
                "se-generic-price": price,
                "se-generic-searchword": searchWord,
                "se-generic-brand": brand === null || brand === void 0 ? void 0 : brand.toLowerCase(),
                "se-generic-test": genericTest
            }
        };
        apntag.setPageOpts(pageOptions);
        logger("setPageOptions()", {
            pageOptions: pageOptions
        });
    }, [
        apntag,
        brand,
        categoryPathString,
        countryCode,
        enabled,
        extendedUserIdsString,
        genericTest,
        pageType,
        pagegen,
        price,
        searchWord,
        supplyType,
        userTrackingConsent,
        logger
    ]);
}
function $a33822bc8798a249$export$5342e630b24a5668(targetIds) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), apntag = ref.apntag, awaitUserTrackingConsent = ref.awaitUserTrackingConsent, userTrackingConsent = ref.userTrackingConsent, dispatch = ref.dispatch, logger = ref.logger;
    var targetIdsString = targetIds.join(",");
    (0, react.useEffect)(function() {
        if (!enabled || awaitUserTrackingConsent && userTrackingConsent === undefined) {
            logger("loadTags()", {
                awaitUserTrackingConsent: awaitUserTrackingConsent,
                userTrackingConsent: userTrackingConsent,
                targetIdsString: targetIdsString
            });
            return undefined;
        }
        apntag.loadTags(targetIdsString.split(","));
        logger("loadTags()", {
            tags: targetIdsString.split(",")
        });
        return function() {
            apntag.clearRequest(targetIdsString.split(","));
            dispatch({
                type: "reset"
            });
        };
    }, [
        apntag,
        awaitUserTrackingConsent,
        dispatch,
        enabled,
        targetIdsString,
        userTrackingConsent,
        logger
    ]);
}
function $f61637d5be8505ac$export$d12e78c94daaa5bc(param) {
    var pageOptions = param.pageOptions, formats = param.formats, tmp = param.enabled, enabled = tmp === void 0 ? true : tmp;
    var ref = (0, $c8d0348d007aec2d$export$328fc4060ef2b6ed)(), isAdsEnabled = ref.isAdsEnabled;
    var isEnabled = enabled && isAdsEnabled;
    (0, $2daf6c17b873dc69$export$e8dcee988c4738cb)(pageOptions, isEnabled);
    var tags = (0, $f2ea9c9ccded313b$export$47d5987d87b63983)(formats, isEnabled);
    (0, $a33822bc8798a249$export$5342e630b24a5668)(tags.map(function(tag) {
        return tag.invCode;
    }), isEnabled);
}
function $17ad79b124f66ea0$export$38ddb1d34c8f2b13() {
    var ref = (0, $40584624a4f973e6$export$bfc5a6a4518bc41f)(), apntag = ref.apntag, logger = ref.logger;
    var refreshAds = (0, $ipz0l$useCallback)(function() {
        if (!apntag) return;
        apntag.refresh();
        logger("refreshAds()");
    }, [
        apntag,
        logger
    ]);
    return refreshAds;
}
 //# sourceMappingURL=module.js.map


/***/ }),

/***/ 42123:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.proxyConfig = void 0;
exports.proxyConfig = {
    /**
     * Common paths are proxied for all users on all markets.
     */ commonPaths: [
        "/_next",
        "/__nextjs",
        "/api",
        "/information",
        "/help",
        "/profile",
        "/site/v2",
        "/robots.txt"
    ],
    /**
     * Public paths are proxied for all users.
     */ publicPaths: {
        dk: [
            "/artikler",
            "/trendende",
            "/tp/",
            "/hubs",
            "/user-list",
            /^\/tema\/?$/,
            /^\/tema\/(?!dagens-deals).+$/,
            "/me/feed",
            "/s/",
            "/brugt",
            "/search",
            "/eksperter/profil",
            "/toplister",
            "/tester",
            "/guider"
        ],
        fi: [
            "/artikkeleita",
            "/trendaava",
            "/tp/",
            "/hubs",
            "/user-list",
            /^\/teema\/?$/,
            /^\/teema\/(?!parhaat-tarjoukset).+$/,
            "/me/feed",
            "/s/",
            "/top-listat",
            "/testit",
            "/oppaat",
            "/asiantuntijat/profiili",
            "/kaytetyt",
            "/search"
        ],
        fr: [
            "/articles",
            "/tendances",
            "/tp/",
            "/hubs",
            /^\/actu\/?$/,
            /^\/actu\/(?!top-promo).+$/,
            "/reconditionne-ou-occasion",
            "/search",
            "/s/"
        ],
        no: [
            "/artikler",
            "/trendende",
            "/topplister",
            "/tester",
            "/guider",
            "/tp/",
            "/eksperter/profil",
            "/hubs",
            "/user-list",
            /^\/tema\/?$/,
            /^\/tema\/(?!dagens-tilbud).+$/,
            "/me/feed",
            "/brukt",
            "/s/",
            "/search"
        ],
        se: [
            "/artiklar",
            "/guider",
            "/tester",
            "/topplistor",
            "/trendande",
            "/tp/",
            "/experter/profil",
            "/hubs",
            "/user-list",
            "/quiz",
            /^\/tema\/?$/,
            /^\/tema\/(?!dagens-deals).+$/,
            "/me/feed",
            "/begagnat",
            "/search",
            "/s/"
        ],
        gb: [
            "/articles",
            "/tp/",
            "/hubs",
            /^\/theme\/?$/,
            /^\/theme\/(?!daily-deals).+$/,
            "/s/",
            "/used",
            "/search"
        ],
        nz: [
            "/s/",
            "/used",
            "/search",
            "/articles",
            /^\/theme\/?$/,
            /^\/theme\/(?!daily-deals).+$/
        ]
    },
    /**
     * Experimental paths are proxied for users that have opted-in to the
     * Next.js proxy at /_internal/nextjs
     */ experimentalPaths: {
        dk: [
            "/hub-preview",
            "/account/profile/lists",
            /^\/user\/\d+\/lists/,
            "/bust-cache"
        ],
        fi: [
            "/hub-preview",
            "/account/profile/lists",
            /^\/user\/\d+\/lists/
        ],
        fr: [
            "/hub-preview",
            "/account/profile/lists",
            /^\/user\/\d+\/lists/
        ],
        no: [
            "/hub-preview",
            "/account/profile/lists",
            /^\/user\/\d+\/lists/
        ],
        se: [
            "/hub-preview",
            "/account/profile/lists",
            /^\/user\/\d+\/lists/,
            /^\/produkt\.php\?p=\d+(&.*)?$/
        ],
        gb: [
            "/hub-preview",
            "/account/profile/lists",
            /^\/user\/\d+\/lists/
        ],
        nz: [
            "/tp/",
            "/hubs",
            "/hub-preview",
            "/account/profile/lists",
            /^\/user\/\d+\/lists/
        ]
    }
}; //# sourceMappingURL=config.js.map


/***/ }),

/***/ 29475:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.NEXTJS_USERAGENT = exports.NEXTJS_HEADER = exports.NEXTJS_COOKIE = exports.NEXTJS_COOKIE_VERSION = exports.NEXTJS_EXPERIMENT_SLUG = void 0;
exports.NEXTJS_EXPERIMENT_SLUG = "use-nextjs-proxy";
exports.NEXTJS_COOKIE_VERSION = "1";
exports.NEXTJS_COOKIE = "pj:nextjsproxy";
exports.NEXTJS_HEADER = "x-nextjs-proxy";
exports.NEXTJS_USERAGENT = "prisjakt/nextjs-proxy"; //# sourceMappingURL=constants.js.map


/***/ }),

/***/ 98890:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.isNextJsUserAgentEnabled = exports.isNextJsCookieEnabled = exports.getNextJsCookie = void 0;
var constants_1 = __webpack_require__(29475);
function getNextJsCookie() {
    var ref;
    if (typeof document === "undefined") {
        return undefined;
    }
    return (ref = document.cookie.split(";").map(function(str) {
        return str.trim();
    }).find(function(str) {
        return str.startsWith(constants_1.NEXTJS_COOKIE);
    })) === null || ref === void 0 ? void 0 : ref.substring(constants_1.NEXTJS_COOKIE.length + 1);
}
exports.getNextJsCookie = getNextJsCookie;
/**
 * Client side function to check if nextjs cookie is enabled.
 */ function isNextJsCookieEnabled() {
    return getNextJsCookie() === constants_1.NEXTJS_COOKIE_VERSION;
}
exports.isNextJsCookieEnabled = isNextJsCookieEnabled;
/**
 * Client side function to check if nextjs userAgent is set.
 */ function isNextJsUserAgentEnabled() {
    return typeof navigator !== "undefined" && navigator.userAgent.indexOf(constants_1.NEXTJS_USERAGENT) !== -1;
}
exports.isNextJsUserAgentEnabled = isNextJsUserAgentEnabled; //# sourceMappingURL=helpers.js.map


/***/ }),

/***/ 16235:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
__exportStar(__webpack_require__(29475), exports);
__exportStar(__webpack_require__(98890), exports);
__exportStar(__webpack_require__(49715), exports);
__exportStar(__webpack_require__(42123), exports);
__exportStar(__webpack_require__(79015), exports); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 49715:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.isProxyMarket = exports.isRfePath = exports.isNextJsPath = exports.getProxyPaths = void 0;
var config_1 = __webpack_require__(42123);
function getProxyPaths(market, useExperimentalRoutes) {
    var _proxyConfig = config_1.proxyConfig, commonPaths = _proxyConfig.commonPaths, publicPaths = _proxyConfig.publicPaths;
    var experimentalPaths = useExperimentalRoutes ? config_1.proxyConfig.experimentalPaths[market] : [];
    return _toConsumableArray(commonPaths).concat(_toConsumableArray(publicPaths[market]), _toConsumableArray(experimentalPaths));
}
exports.getProxyPaths = getProxyPaths;
function isNextJsPath(path, market) {
    var useExperimentalRoutes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getProxyPaths(market, useExperimentalRoutes).some(function(proxyPath) {
        return typeof proxyPath === "string" ? path.startsWith(proxyPath) : proxyPath.test(path);
    }) === true;
}
exports.isNextJsPath = isNextJsPath;
function isRfePath(path, market) {
    var useExperimentalRoutes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return !isNextJsPath(path, market, useExperimentalRoutes);
}
exports.isRfePath = isRfePath;
function isProxyMarket(value) {
    return typeof value === "string" && [
        "dk",
        "fi",
        "fr",
        "gb",
        "no",
        "se",
        "nz"
    ].includes(value);
}
exports.isProxyMarket = isProxyMarket; //# sourceMappingURL=paths.js.map


/***/ }),

/***/ 79015:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
})); //# sourceMappingURL=types.js.map


/***/ }),

/***/ 5193:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.loadMessagingScript = exports.loadSourcepointScript = exports.initConfig = void 0;
var utils_1 = __webpack_require__(22096);
function initConfig(window, config, listeners) {
    var SPConfig = _objectSpreadProps(_objectSpread({}, config), {
        gdpr: {
            includeTcfApi: true
        },
        joinHref: !!config.propertyHref,
        events: {
            onConsentReady: function onConsentReady(_messageType, _consentUUID, _EUconsent, info) {
                listeners === null || listeners === void 0 ? void 0 : listeners.forEach(function(callback) {
                    return callback(info.consentedToAll);
                });
            }
        }
    });
    // eslint-disable-next-line no-param-reassign
    window._sp_ = window._sp_ || {};
    // eslint-disable-next-line no-param-reassign
    window._sp_.config = SPConfig;
    (0, utils_1.debug)("SourcePoint initiated with config: ", JSON.stringify(config));
}
exports.initConfig = initConfig;
function loadSourcepointScript(document) {
    var tcfScript = document.createElement("script");
    tcfScript.innerHTML = '"use strict";function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(){var t=function(){var t,e,o=[],n=window,r=n;for(;r;){try{if(r.frames.__tcfapiLocator){t=r;break}}catch(t){}if(r===n.top)break;r=r.parent}t||(!function t(){var e=n.document,o=!!n.frames.__tcfapiLocator;if(!o)if(e.body){var r=e.createElement("iframe");r.style.cssText="display:none",r.name="__tcfapiLocator",e.body.appendChild(r)}else setTimeout(t,5);return!o}(),n.__tcfapi=function(){for(var t=arguments.length,n=new Array(t),r=0;r<t;r++)n[r]=arguments[r];if(!n.length)return o;"setGdprApplies"===n[0]?n.length>3&&2===parseInt(n[1],10)&&"boolean"==typeof n[3]&&(e=n[3],"function"==typeof n[2]&&n[2]("set",!0)):"ping"===n[0]?"function"==typeof n[2]&&n[2]({gdprApplies:e,cmpLoaded:!1,cmpStatus:"stub"}):o.push(n)},n.addEventListener("message",(function(t){var e="string"==typeof t.data,o={};if(e)try{o=JSON.parse(t.data)}catch(t){}else o=t.data;var n="object"===_typeof(o)&&null!==o?o.__tcfapiCall:null;n&&window.__tcfapi(n.command,n.version,(function(o,r){var a={__tcfapiReturn:{returnValue:o,success:r,callId:n.callId}};t&&t.source&&t.source.postMessage&&t.source.postMessage(e?JSON.stringify(a):a,"*")}),n.parameter)}),!1))};"undefined"!=typeof module?module.exports=t:t()}();';
    document.head.appendChild(tcfScript);
}
exports.loadSourcepointScript = loadSourcepointScript;
function loadMessagingScript(config, document) {
    return new Promise(function(resolve, reject) {
        var wrapperMessage = "".concat(config.baseEndpoint, "/unified/wrapperMessagingWithoutDetection.js");
        var allScripts = document.getElementsByTagName("script");
        var curScript = _toConsumableArray(allScripts).at(-1);
        var preloadLink = document.createElement("link");
        (0, utils_1.setMultipleAttributes)(preloadLink, {
            rel: "preload",
            as: "script",
            crossorigin: "crossorigin",
            href: wrapperMessage
        });
        document.head.appendChild(preloadLink);
        // append wrapperMessagingWithoutDetection script
        var commonScript = document.createElement("script");
        (0, utils_1.setMultipleAttributes)(commonScript, {
            async: "true",
            src: wrapperMessage
        });
        commonScript.onload = resolve;
        commonScript.onerror = reject;
        if (curScript) {
            curScript.insertAdjacentElement("afterend", commonScript);
        } else {
            document.body.insertAdjacentElement("beforeend", commonScript);
        }
    });
}
exports.loadMessagingScript = loadMessagingScript; //# sourceMappingURL=bootstrap.js.map


/***/ }),

/***/ 22549:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.isConsentUndecided = exports.isConsentDenied = exports.isConsentGiven = exports.getFromCache = exports.getCache = exports.isConsentState = exports.getApi = exports.openPrivacyManagerModal = void 0;
var bootstrap_1 = __webpack_require__(5193);
var tcf_1 = __webpack_require__(2070);
var utils_1 = __webpack_require__(22096);
var openPrivacyManagerModal = function() {
    return(// GDPR API is imported by the Sourcepoint library without any subsequent callback. Poll for existence instead.
    (0, utils_1.waitForCondition)(function() {
        var ref, ref1;
        return typeof ((ref = window._sp_) === null || ref === void 0 ? void 0 : (ref1 = ref.gdpr) === null || ref1 === void 0 ? void 0 : ref1.loadPrivacyManagerModal) === "function";
    }).then(function() {
        return window._sp_.gdpr.loadPrivacyManagerModal();
    }).catch(function() {
        return(// eslint-disable-next-line no-console
        console.error("GDPR API not loaded"));
    }));
};
exports.openPrivacyManagerModal = openPrivacyManagerModal;
function getApi(window1, document, config) {
    return _getApi.apply(this, arguments);
}
function _getApi() {
    _getApi = _asyncToGenerator(function(window1, document, config) {
        var tcf, err;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    (0, bootstrap_1.loadSourcepointScript)(document);
                    tcf = new tcf_1.TcfApi(config);
                    (0, bootstrap_1.initConfig)(window1, config, tcf.consentedCallback);
                    // Custom callback function defined in Sourcepoint triggered when user selects privacy preferences
                    // eslint-disable-next-line no-param-reassign
                    window1._SourcePoint_Consent_Callback = tcf.notify.bind(tcf);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, bootstrap_1.loadMessagingScript)(config, document)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        {
                            tcf: tcf,
                            openPrivacyManagerModal: exports.openPrivacyManagerModal
                        }
                    ];
                case 3:
                    err = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error("Could not load Sourcepoint API", err);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getApi.apply(this, arguments);
}
exports.getApi = getApi;
var utils_2 = __webpack_require__(22096);
Object.defineProperty(exports, "isConsentState", ({
    enumerable: true,
    get: function get() {
        return utils_2.isConsentState;
    }
}));
Object.defineProperty(exports, "getCache", ({
    enumerable: true,
    get: function get() {
        return utils_2.getCache;
    }
}));
Object.defineProperty(exports, "getFromCache", ({
    enumerable: true,
    get: function get() {
        return utils_2.getFromCache;
    }
}));
Object.defineProperty(exports, "isConsentGiven", ({
    enumerable: true,
    get: function get() {
        return utils_2.isConsentGiven;
    }
}));
Object.defineProperty(exports, "isConsentDenied", ({
    enumerable: true,
    get: function get() {
        return utils_2.isConsentDenied;
    }
}));
Object.defineProperty(exports, "isConsentUndecided", ({
    enumerable: true,
    get: function get() {
        return utils_2.isConsentUndecided;
    }
})); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 2070:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TcfApi = void 0;
var utils_1 = __webpack_require__(22096);
var TcfApi = /*#__PURE__*/ function() {
    function TcfApi(config) {
        _classCallCheck(this, TcfApi);
        _defineProperty(this, "config", void 0);
        _defineProperty(this, "type", "tcf");
        _defineProperty(this, "prevValues", {
            "CMP:analytics": this.getConsentStateFromCache("CMP:analytics"),
            "CMP:marketing": this.getConsentStateFromCache("CMP:marketing")
        });
        _defineProperty(this, "subscribers", {
            "CMP:analytics": [],
            "CMP:marketing": []
        });
        _defineProperty(this, "consentedCallback", []);
        this.config = config;
    }
    _createClass(TcfApi, [
        {
            key: "getConsentStateFromCache",
            value: function getConsentStateFromCache(category) {
                (0, utils_1.debug)("".concat(this.type, ": getPermissionFromCache(category=").concat(category, ")"));
                return (0, utils_1.getFromCache)(category);
            }
        },
        {
            key: "notify",
            value: function notify(category, value) {
                var ref;
                if (this.prevValues[category] === value) {
                    (0, utils_1.debug)("".concat(this.type, ": notify(category=").concat(category, ", value=").concat(value, ") - IGNORED"));
                    return;
                }
                (0, utils_1.debug)("".concat(this.type, ": notify(category=").concat(category, ", value=").concat(value, ")"));
                // eslint-disable-next-line no-param-reassign
                this.prevValues[category] = value;
                (ref = this.subscribers[category]) === null || ref === void 0 ? void 0 : ref.forEach(function(subscriber) {
                    return subscriber(value);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(category, callback) {
                var _this = this;
                (0, utils_1.debug)("".concat(this.type, ": subscribe(category=").concat(category, ")"));
                if (!this.subscribers[category]) {
                    // eslint-disable-next-line no-console
                    console.error("Unable to subscribe - undefined consent category!");
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    return function() {};
                }
                this.subscribers[category].push(callback);
                var value = this.getConsentStateFromCache(category);
                if (value !== null) {
                    callback(value);
                }
                return function() {
                    _this.subscribers[category] = _this.subscribers[category].filter(function(cb) {
                        return cb !== callback;
                    });
                };
            }
        },
        {
            key: "isConsentedToAll",
            value: function isConsentedToAll(callback) {
                this.consentedCallback.push(callback);
            }
        },
        {
            key: "getConsentedToAllSync",
            value: function getConsentedToAllSync() {
                var consentCacheKey = "_sp_user_consent_".concat(this.config.propertyId);
                var cache = (0, utils_1.getCache)();
                var userConsentJSON = cache.getItem(consentCacheKey);
                try {
                    var ref, ref1;
                    var consents = Object.keys(cache).filter(function(e) {
                        return e.startsWith("CMP:");
                    });
                    // isConsentedAll initial value is false and we return null if no consent was given
                    if (consents.length === 0) {
                        return null;
                    }
                    var consentStatus = (ref = JSON.parse(userConsentJSON || "")) === null || ref === void 0 ? void 0 : (ref1 = ref.gdpr) === null || ref1 === void 0 ? void 0 : ref1.consentStatus;
                    var isVLChange = (consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.vendorListAdditions) || (consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.legalBasisChanges);
                    if (isVLChange) {
                        return null;
                    }
                    var consentedValue = consentStatus === null || consentStatus === void 0 ? void 0 : consentStatus.consentedAll;
                    // Type the response only for brevity
                    if (typeof consentedValue !== "boolean") {
                        return null;
                    }
                    return consentedValue;
                } catch (e) {
                    return null;
                }
            }
        }
    ]);
    return TcfApi;
}();
exports.TcfApi = TcfApi; //# sourceMappingURL=tcf.js.map


/***/ }),

/***/ 22096:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.waitForCondition = exports.isConsentUndecided = exports.isConsentDenied = exports.isConsentGiven = exports.isConsentState = exports.getFromCache = exports.getCache = exports.setMultipleAttributes = exports.debug = void 0;
function debug() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if (typeof document !== "undefined" && document.location.href.indexOf("sp_debug=1") > 0) {
        var // eslint-disable-next-line no-console
        _console;
        (_console = console).debug.apply(_console, [
            "[CMP]"
        ].concat(_toConsumableArray(args)));
    }
}
exports.debug = debug;
var setMultipleAttributes = function(element, attributes) {
    return Object.keys(attributes).forEach(function(key) {
        return element.setAttribute(key, attributes[key]);
    });
};
exports.setMultipleAttributes = setMultipleAttributes;
function getCache() {
    return window.localStorage;
}
exports.getCache = getCache;
function getFromCache(cacheKey) {
    var s = getCache().getItem(cacheKey);
    return isConsentState(s) ? s : null;
}
exports.getFromCache = getFromCache;
var ConsentStates = {
    UNDECIDED: null,
    NO: "0",
    YES: "1"
};
function isConsentState(value) {
    return value === ConsentStates.YES || value === ConsentStates.NO || value === ConsentStates.UNDECIDED;
}
exports.isConsentState = isConsentState;
var isConsentGiven = function(state) {
    return ConsentStates.YES === state;
};
exports.isConsentGiven = isConsentGiven;
var isConsentDenied = function(state) {
    return ConsentStates.NO === state;
};
exports.isConsentDenied = isConsentDenied;
var isConsentUndecided = function(state) {
    return ConsentStates.UNDECIDED === state;
};
exports.isConsentUndecided = isConsentUndecided;
var waitForCondition = function() {
    var _ref = _asyncToGenerator(function(f) {
        var maxWaitMs, waitIntervalMs, condition, msLeft;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    maxWaitMs = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 10000, waitIntervalMs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 100;
                    return [
                        4,
                        f()
                    ];
                case 1:
                    condition = _state.sent();
                    msLeft = maxWaitMs;
                    _state.label = 2;
                case 2:
                    if (!(!condition && msLeft > 0)) return [
                        3,
                        5
                    ];
                    // eslint-disable-next-line no-await-in-loop
                    return [
                        4,
                        new Promise(function(r) {
                            setTimeout(r, waitIntervalMs);
                        })
                    ];
                case 3:
                    _state.sent();
                    msLeft -= waitIntervalMs;
                    return [
                        4,
                        f()
                    ];
                case 4:
                    // eslint-disable-next-line no-await-in-loop
                    condition = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 5:
                    if (!condition) {
                        throw new Error("Condition never met");
                    }
                    return [
                        2,
                        condition
                    ];
            }
        });
    });
    return function waitForCondition(f) {
        return _ref.apply(this, arguments);
    };
}();
exports.waitForCondition = waitForCondition; //# sourceMappingURL=utils.js.map


/***/ }),

/***/ 42692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lo": () => (/* binding */ USER_SHOP_PREFERENCE_RECEIVE),
/* harmony export */   "XW": () => (/* binding */ dislikeShop),
/* harmony export */   "dt": () => (/* binding */ USER_RECEIVE),
/* harmony export */   "h_": () => (/* binding */ receiveShopPreference),
/* harmony export */   "ie": () => (/* binding */ USER_LIKE_SHOP_REQUEST),
/* harmony export */   "m": () => (/* binding */ likeShop),
/* harmony export */   "oN": () => (/* binding */ USER_DISLIKE_SHOP_REQUEST),
/* harmony export */   "pT": () => (/* binding */ shopPreferenceError),
/* harmony export */   "xX": () => (/* binding */ USER_SHOP_PREFERENCE_ERROR)
/* harmony export */ });
var USER_RECEIVE = "USER_RECEIVE";
var USER_LIKE_SHOP_REQUEST = "USER_LIKE_SHOP";
var USER_DISLIKE_SHOP_REQUEST = "USER_DISLIKE_SHOP";
var USER_SHOP_PREFERENCE_ERROR = "USER_SHOP_PREFERENCE_ERROR";
var USER_SHOP_PREFERENCE_RECEIVE = "USER_SHOP_PREFERENCE_RECEIVE";
var userReceive = function(me) {
    return {
        type: USER_RECEIVE,
        me: me || undefined
    };
};
var likeShop = function(shopId) {
    return {
        type: USER_LIKE_SHOP_REQUEST,
        shopId: shopId
    };
};
var dislikeShop = function(shopId) {
    return {
        type: USER_DISLIKE_SHOP_REQUEST,
        shopId: shopId
    };
};
var shopPreferenceError = function() {
    return {
        type: USER_SHOP_PREFERENCE_ERROR
    };
};
var receiveShopPreference = function(shopPreferenceState) {
    return {
        type: USER_SHOP_PREFERENCE_RECEIVE,
        shopPreferenceState: shopPreferenceState
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    userReceive: userReceive
});


/***/ }),

/***/ 29559:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": () => (/* binding */ ALERT_SETTINGS_CHANGE_REQUEST),
/* harmony export */   "G5": () => (/* binding */ ALERT_SETTINGS_CHANGE),
/* harmony export */   "Os": () => (/* binding */ ALERT_SETTINGS_CHANGE_SUCCESS),
/* harmony export */   "cA": () => (/* binding */ alertSettingsChangeFail),
/* harmony export */   "g5": () => (/* binding */ alertSettingsChangeSuccess),
/* harmony export */   "oD": () => (/* binding */ ALERT_SETTINGS_SAVE_REQUEST)
/* harmony export */ });
/* unused harmony exports ALERT_SETTINGS_CHANGE_FAIL, alertSettingsChange, alertSettingsSaveRequest, alertSettingsChangeRequest */
var ALERT_SETTINGS_CHANGE = "ALERT_SETTINGS_CHANGE";
var ALERT_SETTINGS_SAVE_REQUEST = "ALERT_SETTINGS_SAVE_REQUEST";
var ALERT_SETTINGS_CHANGE_REQUEST = "ALERT_SETTINGS_CHANGE_REQUEST";
var ALERT_SETTINGS_CHANGE_SUCCESS = "ALERT_SETTINGS_CHANGE_SUCCESS";
var ALERT_SETTINGS_CHANGE_FAIL = "ALERT_SETTINGS_CHANGE_FAIL";
var alertSettingsChange = function(setting) {
    return {
        type: ALERT_SETTINGS_CHANGE,
        setting: setting
    };
};
var alertSettingsSaveRequest = function(setting) {
    return {
        type: ALERT_SETTINGS_SAVE_REQUEST,
        setting: setting
    };
};
var alertSettingsChangeRequest = function(setting) {
    return {
        type: ALERT_SETTINGS_CHANGE_REQUEST,
        setting: setting
    };
};
var alertSettingsChangeSuccess = function(setting) {
    return {
        type: ALERT_SETTINGS_CHANGE_SUCCESS,
        setting: setting
    };
};
var alertSettingsChangeFail = function(setting) {
    return {
        type: ALERT_SETTINGS_CHANGE_FAIL,
        setting: setting
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    alertSettingsChange: alertSettingsChange,
    alertSettingsChangeRequest: alertSettingsChangeRequest
});


/***/ }),

/***/ 25526:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Be": () => (/* binding */ displayNameChange),
/* harmony export */   "Kc": () => (/* binding */ DISPLAY_NAME_CHANGE),
/* harmony export */   "hC": () => (/* binding */ setDisplayName),
/* harmony export */   "kr": () => (/* binding */ UPDATE_DISPLAY_NAME)
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var DISPLAY_NAME_CHANGE = "DISPLAY_NAME_CHANGE";
var UPDATE_DISPLAY_NAME = "UPDATE_DISPLAY_NAME";
var setDisplayName = function(displayName) {
    return {
        type: UPDATE_DISPLAY_NAME,
        displayName: displayName
    };
};
var displayNameChange = function(displayName) {
    return _objectSpreadProps(_objectSpread({}, displayName), {
        editing: "displayName",
        type: DISPLAY_NAME_CHANGE,
        saving: true
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    displayNameChange: displayNameChange
});


/***/ }),

/***/ 17686:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dl": () => (/* binding */ SETTINGS_START_EDITING),
/* harmony export */   "Gd": () => (/* binding */ UPDATE_SUBSCRIPTION_SETTING_REQUEST),
/* harmony export */   "Gn": () => (/* binding */ settingsChangeSuccess),
/* harmony export */   "St": () => (/* binding */ settingsChangeFail),
/* harmony export */   "Ud": () => (/* binding */ startEditing),
/* harmony export */   "Vi": () => (/* binding */ updateSubscriptionSettingRequest),
/* harmony export */   "X2": () => (/* binding */ UPDATE_SUBSCRIPTION_SETTING),
/* harmony export */   "f1": () => (/* binding */ SETTINGS_CHANGE_SUCCESS),
/* harmony export */   "nA": () => (/* binding */ SETTINGS_CHANGE_FAILED),
/* harmony export */   "su": () => (/* binding */ updateSubscriptionSetting)
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SETTINGS_CHANGE_SUCCESS = "SETTINGS_CHANGE_SUCCESS";
var SETTINGS_CHANGE_FAILED = "SETTINGS_CHANGE_FAILED";
var SETTINGS_START_EDITING = "SETTINGS_START_EDITING";
var UPDATE_SUBSCRIPTION_SETTING = "UPDATE_SUBSCRIPTION_SETTING";
var UPDATE_SUBSCRIPTION_SETTING_REQUEST = "UPDATE_SUBSCRIPTION_SETTING_REQUEST";
var startEditing = function(settings) {
    return {
        type: SETTINGS_START_EDITING,
        settings: settings
    };
};
var settingsChangeSuccess = function(settings) {
    return {
        settings: settings,
        type: SETTINGS_CHANGE_SUCCESS
    };
};
var settingsChangeFail = function(data) {
    return _objectSpreadProps(_objectSpread({}, data), {
        type: SETTINGS_CHANGE_FAILED
    });
};
var updateSubscriptionSetting = function(id, subscribed) {
    return {
        type: UPDATE_SUBSCRIPTION_SETTING,
        id: id,
        subscribed: subscribed
    };
};
var updateSubscriptionSettingRequest = function(id, subscribed) {
    return {
        type: UPDATE_SUBSCRIPTION_SETTING_REQUEST,
        id: id,
        subscribed: subscribed
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    settingsChangeSuccess: settingsChangeSuccess,
    startEditing: startEditing
});


/***/ }),

/***/ 18419:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ updateAlertSetting),
/* harmony export */   "m": () => (/* binding */ updateSetting)
/* harmony export */ });
/* harmony import */ var _globals_api_requests__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15287);

var updateSetting = function(setting, value) {
    return (0,_globals_api_requests__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .BX)("\n      mutation ($data: SettingInputType!) {\n        updateSetting(data: $data) {\n          success\n        }\n      }\n    ", {
        data: {
            setting: setting,
            value: value
        }
    });
};
var updateAlertSetting = function(setting, value) {
    return updateSetting("alert_method_".concat(setting), Number(value));
};


/***/ }),

/***/ 73081:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export handleSettingsAction */
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38247);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18419);
/* harmony import */ var _actions_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17686);
/* harmony import */ var _components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40744);
/* harmony import */ var _actions_display_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25526);
/* harmony import */ var _globals_api_requests__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15287);
/* harmony import */ var _components_subscription_settings_update_subscription_setting_mutation_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91302);
/* harmony import */ var _components_subscription_settings_update_subscription_setting_mutation_graphql__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_subscription_settings_update_subscription_setting_mutation_graphql__WEBPACK_IMPORTED_MODULE_6__);
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};







function handleSettingsAction(action) {
    var _, ref, response, ref1, _code, e;
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _ = action.type;
                switch(_){
                    case _actions_display_name__WEBPACK_IMPORTED_MODULE_4__/* .DISPLAY_NAME_CHANGE */ .Kc:
                        return [
                            3,
                            1
                        ];
                }
                return [
                    3,
                    9
                ];
            case 1:
                _state.trys.push([
                    1,
                    6,
                    ,
                    8
                ]);
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .updateSetting */ .m, "display_name", action.displayName)
                ];
            case 2:
                response = _state.sent();
                if ((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length) {
                    ;
                    ;
                    throw new Error((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code);
                }
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("success", window.APP_GLOBALS.t("account", "settings.saved")))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_display_name__WEBPACK_IMPORTED_MODULE_4__/* .setDisplayName */ .hC)(action.displayName))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .settingsChangeSuccess */ .Gn)(response.data.updateSetting))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 6:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .settingsChangeFail */ .St)({
                        settings: action,
                        error: e.message
                    }))
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 8:
                return [
                    3,
                    10
                ];
            case 9:
                {
                    return [
                        3,
                        10
                    ];
                }
                _state.label = 10;
            case 10:
                return [
                    2
                ];
        }
    });
}
function handleUpdateSubscriptionSetting(action) {
    var response;
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .updateSubscriptionSetting */ .su)(action.id, action.subscribed))
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(_globals_api_requests__WEBPACK_IMPORTED_MODULE_5__/* .graphql */ .BX, (_components_subscription_settings_update_subscription_setting_mutation_graphql__WEBPACK_IMPORTED_MODULE_6___default()), {
                        id: action.id,
                        subscribed: action.subscribed
                    })
                ];
            case 2:
                response = _state.sent();
                if (!!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("success", window.APP_GLOBALS.t("account", "settings.saved")))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function mySaga() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .takeLatest */ .Fm)([
                        _actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .SETTINGS_CHANGE_SUCCESS */ .f1,
                        _actions_display_name__WEBPACK_IMPORTED_MODULE_4__/* .DISPLAY_NAME_CHANGE */ .Kc
                    ], handleSettingsAction)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .takeEvery */ .ib)(_actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .UPDATE_SUBSCRIPTION_SETTING_REQUEST */ .Gd, handleUpdateSubscriptionSetting)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (mySaga);


/***/ }),

/***/ 11135:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2222);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ArticlePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "article";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | article */ 942).then(__webpack_require__.bind(__webpack_require__, 26345));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(26345);
        }
        return eval("require.resolve")("./article");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ArticlePage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ArticlePage.variables = function(v) {
    return {
        id: parseInt(v.id, 10)
    };
};
ArticlePage.loadOrder = [
    {}
];
/* harmony default export */ __webpack_exports__["Z"] = (ArticlePage);


/***/ }),

/***/ 65598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51882);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var BrandPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "brand";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | brand */ 362).then(__webpack_require__.bind(__webpack_require__, 54623));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(54623);
        }
        return eval("require.resolve")("./components");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
BrandPage.variables = function(param) {
    var id = param.id;
    return {
        id: id
    };
};
BrandPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
BrandPage.loadOrder = [
    {}
];
/* harmony default export */ __webpack_exports__["Z"] = (BrandPage);


/***/ }),

/***/ 51932:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ru": () => (/* binding */ CAMPAIGN_QUERY),
/* harmony export */   "d6": () => (/* binding */ campaignItemClick)
/* harmony export */ });
/* unused harmony exports CAMPAIGN_ITEM_CLICK, CAMPAIGN_SEARCH_DONE, CAMPAIGN_PAGINATION, CAMPAIGN_POPULAR_QUERY, CAMPAIGN_CATEGORY_FILTER, CAMPAIGN_RANGE_FILTER, campaignQuery, campaignPopularQuery, campaignCategoryFilter, campaignsRangeFilter */
var CAMPAIGN_QUERY = "CAMPAIGN_QUERY";
var CAMPAIGN_ITEM_CLICK = "CAMPAIGN_ITEM_CLICK";
var CAMPAIGN_SEARCH_DONE = "CAMPAIGN_SEARCH_DONE";
var CAMPAIGN_PAGINATION = "CAMPAIGN_PAGINATION";
var CAMPAIGN_POPULAR_QUERY = "CAMPAIGN_POPULAR_QUERY";
var CAMPAIGN_CATEGORY_FILTER = "CAMPAIGN_CATEGORY_FILTER";
var CAMPAIGN_RANGE_FILTER = "CAMPAIGN_RANGE_FILTER";
var campaignQuery = function(data) {
    return {
        type: CAMPAIGN_QUERY,
        data: data
    };
};
var campaignPopularQuery = function(data, filter) {
    return {
        type: CAMPAIGN_POPULAR_QUERY,
        data: data,
        filter: filter
    };
};
var campaignCategoryFilter = function(category) {
    return {
        type: CAMPAIGN_CATEGORY_FILTER,
        category: category
    };
};
var campaignsRangeFilter = function(filter) {
    return {
        type: CAMPAIGN_RANGE_FILTER,
        filter: filter
    };
};
var campaignPagination = function(pageNumber) {
    return {
        type: CAMPAIGN_PAGINATION,
        pageNumber: pageNumber
    };
};
var campaignItemClick = function(item) {
    return {
        type: CAMPAIGN_ITEM_CLICK,
        item: item
    };
};
var campaignSearchDone = function() {
    return {
        type: CAMPAIGN_SEARCH_DONE
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    campaignItemClick: campaignItemClick,
    campaignSearchDone: campaignSearchDone,
    campaignPagination: campaignPagination,
    campaignCategoryFilter: campaignCategoryFilter,
    campaignsRangeFilter: campaignsRangeFilter
});


/***/ }),

/***/ 54703:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);
/* harmony import */ var _themes_query_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98553);
/* harmony import */ var _themes_query_graphql__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_themes_query_graphql__WEBPACK_IMPORTED_MODULE_1__);


var ThemesPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "campaigns";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | campaigns */ 340).then(__webpack_require__.bind(__webpack_require__, 42905));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(42905);
        }
        return eval("require.resolve")("./components/themes");
    }
});
ThemesPage.graphQL = (_themes_query_graphql__WEBPACK_IMPORTED_MODULE_1___default());
ThemesPage.loadOrder = [];
ThemesPage.variables = function() {
    return {};
};
/* harmony default export */ __webpack_exports__["Z"] = (ThemesPage);


/***/ }),

/***/ 89191:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44125);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62619);




var CategoryIndex = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "category-index";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | category-index */ 850).then(__webpack_require__.bind(__webpack_require__, 30541));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(30541);
        }
        return eval("require.resolve")("./category-index");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null)
});
CategoryIndex.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_2___default());
/* harmony default export */ __webpack_exports__["Z"] = (CategoryIndex);


/***/ }),

/***/ 75554:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GW": () => (/* binding */ categoryLayoutChanged),
/* harmony export */   "Hp": () => (/* binding */ CATEGORY_LAYOUT_CHANGED),
/* harmony export */   "VV": () => (/* binding */ categoryLayoutRequest),
/* harmony export */   "xV": () => (/* binding */ categoryLayoutFailed)
/* harmony export */ });
/* unused harmony exports CATEGORY_LAYOUT_REQUEST, CATEGORY_LAYOUT_FAILED, CATEGORY_NAVIGATION */
var CATEGORY_LAYOUT_REQUEST = "CATEGORY_LAYOUT_REQUEST";
var CATEGORY_LAYOUT_CHANGED = "CATEGORY_LAYOUT_CHANGED";
var CATEGORY_LAYOUT_FAILED = "CATEGORY_LAYOUT_FAILED";
var CATEGORY_NAVIGATION = "CATEGORY_NAVIGATION";
// Layout Request
var categoryLayoutRequest = function(mode) {
    return {
        type: CATEGORY_LAYOUT_REQUEST,
        mode: mode
    };
};
var categoryLayoutChanged = function(mode) {
    return {
        type: CATEGORY_LAYOUT_CHANGED,
        mode: mode
    };
};
var categoryLayoutFailed = function(mode) {
    return {
        type: CATEGORY_LAYOUT_FAILED,
        mode: mode
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    categoryLayoutRequest: categoryLayoutRequest
});


/***/ }),

/***/ 67536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": () => (/* binding */ FILTER_CHANGE_ACTION),
/* harmony export */   "DQ": () => (/* binding */ filterQuery),
/* harmony export */   "Du": () => (/* binding */ setHorizontalFilter),
/* harmony export */   "HW": () => (/* binding */ COMPARE_PROPERTIES),
/* harmony export */   "I2": () => (/* binding */ FILTER_FETCH_FAILED),
/* harmony export */   "JL": () => (/* binding */ FILTER_QUERY),
/* harmony export */   "MW": () => (/* binding */ propertySearch),
/* harmony export */   "Q": () => (/* binding */ PROPERTY_SEARCH_ACTION),
/* harmony export */   "QL": () => (/* binding */ compareProperties),
/* harmony export */   "WK": () => (/* binding */ FILTER_TOGGLE_MOBILE),
/* harmony export */   "Xi": () => (/* binding */ filterChangeAction),
/* harmony export */   "c8": () => (/* binding */ FILTER_EXPAND_SECTION),
/* harmony export */   "eB": () => (/* binding */ PROPERTY_SEARCH_TOGGLE_SECTION),
/* harmony export */   "fs": () => (/* binding */ toggleMobile),
/* harmony export */   "gd": () => (/* binding */ COMPARE_PROPERTY),
/* harmony export */   "hN": () => (/* binding */ propertySearchComplete),
/* harmony export */   "kx": () => (/* binding */ PROPERTY_SEARCH_COMPLETE),
/* harmony export */   "lf": () => (/* binding */ filterFetchFailed),
/* harmony export */   "m0": () => (/* binding */ filterReceive),
/* harmony export */   "pS": () => (/* binding */ compareProperty),
/* harmony export */   "s0": () => (/* binding */ expandSection),
/* harmony export */   "vN": () => (/* binding */ FILTER_RECEIVE),
/* harmony export */   "vd": () => (/* binding */ SET_HORIZONTAL_FILTER),
/* harmony export */   "wz": () => (/* binding */ propertySearchToggleExpansion)
/* harmony export */ });
/* unused harmony exports FILTER_STARTUP, PROPERTY_SEARCH_CORE_COMPLETE, PROPERTY_SEARCH_SECTION_COMPLETE */
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var FILTER_CHANGE_ACTION = "FILTER_CHANGE_ACTION";
var FILTER_QUERY = "FILTER_QUERY";
var FILTER_RECEIVE = "FILTER_RECEIVE";
var FILTER_FETCH_FAILED = "FILTER_FETCH_FAILED";
var FILTER_STARTUP = "FILTER_STARTUP";
var FILTER_EXPAND_SECTION = "FILTER_OPEN_SECTION";
var FILTER_TOGGLE_MOBILE = "FILTER_TOGGLE_MOBILE";
var SET_HORIZONTAL_FILTER = "SET_HORIZONTAL_FILTER";
var PROPERTY_SEARCH_ACTION = "PROPERTY_SEARCH_ACTION";
var PROPERTY_SEARCH_CORE_COMPLETE = "PROPERTY_SEARCH_CORE_COMPLETE";
var PROPERTY_SEARCH_SECTION_COMPLETE = "PROPERTY_SEARCH_SECTION_COMPLETE";
var PROPERTY_SEARCH_COMPLETE = "PROPERTY_SEARCH_COMPLETE";
var PROPERTY_SEARCH_TOGGLE_SECTION = "PROPERTY_SEARCH_TOGGLE_SECTION";
var COMPARE_PROPERTY = "COMPARE_PROPERTY";
var COMPARE_PROPERTIES = "COMPARE_PROPERTIES";
var filterQuery = function(query) {
    return {
        query: query,
        type: FILTER_QUERY
    };
};
var expandSection = function(name) {
    return {
        name: name,
        type: FILTER_EXPAND_SECTION
    };
};
var filterReceive = function(data, categoryData) {
    return {
        data: data,
        categoryData: categoryData,
        type: FILTER_RECEIVE
    };
};
var filterFetchFailed = function(param, categoryId) {
    var error = param.error;
    return {
        error: error,
        categoryId: categoryId,
        type: FILTER_FETCH_FAILED
    };
};
var filterChangeAction = function(categoryId, data) {
    return _objectSpreadProps(_objectSpread({
        categoryId: categoryId
    }, data), {
        type: FILTER_CHANGE_ACTION
    });
};
var compareProperty = function(propertyId) {
    return {
        propertyId: propertyId,
        type: COMPARE_PROPERTY
    };
};
var compareProperties = function(propertyIds) {
    return {
        propertyIds: propertyIds,
        type: COMPARE_PROPERTIES
    };
};
var toggleMobile = function(open) {
    return {
        open: open,
        type: FILTER_TOGGLE_MOBILE
    };
};
var setHorizontalFilter = function(show) {
    return {
        show: show,
        type: SET_HORIZONTAL_FILTER
    };
};
var propertySearch = function(inputValue) {
    return {
        inputValue: inputValue,
        type: PROPERTY_SEARCH_ACTION
    };
};
var propertySearchToggleExpansion = function(name) {
    return {
        name: name,
        type: PROPERTY_SEARCH_TOGGLE_SECTION
    };
};
var propertySearchComplete = function(filteredCore, filteredSections, filteredValues, expandedSections) {
    return {
        filteredCore: filteredCore,
        filteredSections: filteredSections,
        filteredValues: filteredValues,
        expandedSections: expandedSections,
        type: PROPERTY_SEARCH_COMPLETE
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    filterQuery: filterQuery,
    expandSection: expandSection,
    filterReceive: filterReceive,
    filterFetchFailed: filterFetchFailed,
    filterChangeAction: filterChangeAction,
    toggleMobile: toggleMobile,
    propertySearch: propertySearch,
    propertySearchComplete: propertySearchComplete,
    propertySearchToggleExpansion: propertySearchToggleExpansion,
    compareProperty: compareProperty,
    compareProperties: compareProperties,
    setHorizontalFilter: setHorizontalFilter
});


/***/ }),

/***/ 95000:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84261);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_1__);


var ChangelogLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 85908));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(85908);
        }
        return eval("require.resolve")("./landing-page");
    }
});
ChangelogLandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_1___default());
ChangelogLandingPage.variables = function() {
    return {};
};
/* harmony default export */ __webpack_exports__["Z"] = (ChangelogLandingPage);


/***/ }),

/***/ 61877:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50973);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var EditorialContentListingPageLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "article";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | article */ 942).then(__webpack_require__.bind(__webpack_require__, 22144));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(22144);
        }
        return eval("require.resolve")("./editorial-content-listing");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
EditorialContentListingPageLoader.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
EditorialContentListingPageLoader.variables = function(param) {
    var offset = param.offset;
    var pageSize = 20;
    var parsedOffset = typeof offset === "string" ? parseInt(offset, 10) : offset;
    return {
        page: parsedOffset === null || parsedOffset === undefined ? 1 : parsedOffset / pageSize + 1,
        pageSize: pageSize
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (EditorialContentListingPageLoader);


/***/ }),

/***/ 43295:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81474);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62619);




var EditorialContent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "article";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | article */ 942).then(__webpack_require__.bind(__webpack_require__, 80439));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(80439);
        }
        return eval("require.resolve")("./editorial-content");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null)
});
EditorialContent.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_2___default());
EditorialContent.variables = function(vars) {
    // Prismic preview feature sends this parameter
    // then we send that along to the Prismic API integration
    // as the `ref` option. This lets us preview unpublished
    // articles.
    if (vars.token) {
        return {
            id: vars.documentId,
            ref: vars.token
        };
    }
    var id = vars.id, ref = vars.ref;
    return {
        id: id,
        ref: ref
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (EditorialContent);


/***/ }),

/***/ 38020:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51307);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ExpertCategory = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 54977));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(54977);
        }
        return eval("require.resolve")("./expert-category");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ExpertCategory.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ExpertCategory.variables = function(param) {
    var slug = param.slug;
    return {
        slug: slug
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (ExpertCategory);


/***/ }),

/***/ 29290:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6547);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ExpertLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 52618));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(52618);
        }
        return eval("require.resolve")("./landing-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ExpertLandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ExpertLandingPage.variables = function(param) {
    var marketCode = param.marketCode;
    // Configure popular categories here as a temp solution. These are only used in SE
    return {
        limit: marketCode === "se" ? 4 : 8,
        popCategories: [
            "horlurar",
            "barnvagnar",
            "mobiltelefoner",
            "schampo"
        ]
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (ExpertLandingPage);


/***/ }),

/***/ 18969:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I0": () => (/* binding */ sendFailed),
/* harmony export */   "Ly": () => (/* binding */ FEEDBACK_SEND_SUCCESS),
/* harmony export */   "Wr": () => (/* binding */ sendSuccess),
/* harmony export */   "YB": () => (/* binding */ FEEDBACK_CLEAR_FORM),
/* harmony export */   "_d": () => (/* binding */ FEEDBACK_CLOSE),
/* harmony export */   "d2": () => (/* binding */ FEEDBACK_SEND_FAILED),
/* harmony export */   "fn": () => (/* binding */ reportWrongPrice),
/* harmony export */   "hy": () => (/* binding */ FEEDBACK_OPEN),
/* harmony export */   "ou": () => (/* binding */ clearForm),
/* harmony export */   "ph": () => (/* binding */ FEEDBACK_SEND_REQUEST),
/* harmony export */   "r_": () => (/* binding */ FEEDBACK_REPORT_WRONG_PRICE),
/* harmony export */   "wG": () => (/* binding */ sendRequest)
/* harmony export */ });
var FEEDBACK_OPEN = "FEEDBACK_OPEN";
var FEEDBACK_CLOSE = "FEEDBACK_CLOSE";
var FEEDBACK_SEND_REQUEST = "FEEDBACK_SEND_REQUEST";
var FEEDBACK_SEND_SUCCESS = "FEEDBACK_SEND_SUCCESS";
var FEEDBACK_SEND_FAILED = "FEEDBACK_SEND_FAILED";
var FEEDBACK_CLEAR_FORM = "FEEDBACK_CLEAR_FORM";
var FEEDBACK_REPORT_WRONG_PRICE = "FEEDBACK_REPORT_WRONG_PRICE";
var open = function() {
    return {
        type: FEEDBACK_OPEN
    };
};
var close = function() {
    return {
        type: FEEDBACK_CLOSE
    };
};
var sendRequest = function(message) {
    return {
        type: FEEDBACK_SEND_REQUEST,
        message: message
    };
};
var sendSuccess = function() {
    return {
        type: FEEDBACK_SEND_SUCCESS
    };
};
var sendFailed = function(message) {
    return {
        type: FEEDBACK_SEND_FAILED,
        message: message
    };
};
var clearForm = function() {
    return {
        type: FEEDBACK_CLEAR_FORM
    };
};
var reportWrongPrice = function(message) {
    return {
        type: FEEDBACK_REPORT_WRONG_PRICE,
        message: message
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    open: open,
    close: close,
    sendRequest: sendRequest
});


/***/ }),

/***/ 88092:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13278);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);





var InfoPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "info-page";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | info-page */ 241).then(__webpack_require__.bind(__webpack_require__, 17556));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(17556);
        }
        return eval("require.resolve")("./info-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
InfoPage.variables = function(param) {
    var id = param.id;
    return {
        id: id
    };
};
InfoPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
InfoPage.loadOrder = [
    {}
];
InfoPage.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
        pageContent: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().any)
    })
};
InfoPage.defaultProps = {
    data: {
        pageContent: undefined
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoPage);


/***/ }),

/***/ 54068:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export queryToVariables */
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62619);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25559);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable camelcase */ 



var KeywordLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "keyword-landing-page";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | keyword-landing-page */ 46).then(__webpack_require__.bind(__webpack_require__, 9701));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(9701);
        }
        return eval("require.resolve")("./components");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null)
});
/**
 * @param {string|undefined} variant
 */ function getProductNumberByVariant(variant) {
    if (!variant || variant === "baseline") return 100;
    return parseInt(variant.substring("items".length), 10);
}
var queryToVariables = function(vars) {
    var ref;
    var slug = vars.slug, query = vars.query, source = vars.source;
    return {
        slug: slug,
        query: query ? decodeURI(query) : undefined,
        // set offset to 0 since we're not using pagination (yet)
        offset: 0,
        limit: getProductNumberByVariant((ref = vars.experiments["kwlp-limit-products"]) === null || ref === void 0 ? void 0 : ref.selectedVariant),
        source: source === "keywordAI" ? source : undefined
    };
};
KeywordLandingPage.variables = queryToVariables;
KeywordLandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
/* harmony default export */ __webpack_exports__["Z"] = (KeywordLandingPage);


/***/ }),

/***/ 81901:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66120);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var KeywordListingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "keyword-listing";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | keyword-listing */ 56).then(__webpack_require__.bind(__webpack_require__, 93086));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(93086);
        }
        return eval("require.resolve")("./keyword-listing");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
KeywordListingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
KeywordListingPage.variables = function(param) {
    var id = param.id, limit = param.limit, random = param.random;
    return {
        ids: id.split(","),
        limit: typeof limit === "string" ? limit.replace(/[^\d]/g, "") : 3000,
        includeRandom: typeof random === "string" ? [
            "1",
            "true",
            "yes"
        ].includes(random.toLocaleLowerCase()) : false
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (KeywordListingPage);


/***/ }),

/***/ 3492:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77166);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var LandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "landing-page";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | landing-page */ 781).then(__webpack_require__.bind(__webpack_require__, 60166));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(60166);
        }
        return eval("require.resolve")("./landing-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
LandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
LandingPage.variables = function(param) {
    var featureToggle = param.featureToggle;
    var skip = featureToggle >= 1;
    return {
        skip: skip
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingPage);


/***/ }),

/***/ 72477:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F_": () => (/* binding */ NAVIGATION_TOGGLE_MENU),
/* harmony export */   "m5": () => (/* binding */ NAVIGATION_CHANGE_CATEGORY)
/* harmony export */ });
/* unused harmony export NAVIGATION_OPEN_CATEGORY_LINK */
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var NAVIGATION_TOGGLE_MENU = "NAVIGATION_TOGGLE_MENU";
var NAVIGATION_CHANGE_CATEGORY = "NAVIGATION_CHANGE_CATEGORY";
var NAVIGATION_OPEN_CATEGORY_LINK = "NAVIGATION_OPEN_CATEGORY_LINK";
var toggleMenu = function(state) {
    return _objectSpreadProps(_objectSpread({}, state), {
        type: NAVIGATION_TOGGLE_MENU
    });
};
var changeCategory = function(state) {
    return _objectSpreadProps(_objectSpread({}, state), {
        type: NAVIGATION_CHANGE_CATEGORY
    });
};
var openCategoryLink = function(state) {
    return _objectSpreadProps(_objectSpread({}, state), {
        type: NAVIGATION_OPEN_CATEGORY_LINK
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    toggleMenu: toggleMenu,
    changeCategory: changeCategory,
    openCategoryLink: openCategoryLink
});


/***/ }),

/***/ 92306:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": () => (/* binding */ NAVIGATE_FROM_MOBILE_MENU),
/* harmony export */   "FB": () => (/* binding */ SELECT_MOBILE_MENU_HISTORY),
/* harmony export */   "QU": () => (/* binding */ OPEN_MOBILE_MENU),
/* harmony export */   "bO": () => (/* binding */ SET_INITIAL_DATA),
/* harmony export */   "cL": () => (/* binding */ CHANGE_MOBILE_MENU_CATEGORIES),
/* harmony export */   "l2": () => (/* binding */ CLOSE_MOBILE_MENU)
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var OPEN_MOBILE_MENU = "OPEN_MOBILE_MENU";
var CLOSE_MOBILE_MENU = "CLOSE_MOBILE_MENU";
var NAVIGATE_FROM_MOBILE_MENU = "NAVIGATE_FROM_MOBILE_MENU";
var SET_INITIAL_DATA = "SET_INITIAL_MOBILE_MENU_DATA";
var CHANGE_MOBILE_MENU_CATEGORIES = "CHANGE_MOBILE_MENU_CATEGORIES";
var SELECT_MOBILE_MENU_HISTORY = "SELECT_MOBILE_MENU_HISTORY";
var openMenu = function() {
    return {
        type: OPEN_MOBILE_MENU
    };
};
var closeMenu = function() {
    return {
        type: CLOSE_MOBILE_MENU
    };
};
var navigateFromMobileMenu = function() {
    return {
        type: NAVIGATE_FROM_MOBILE_MENU
    };
};
var selectHistory = function(categoryId) {
    return {
        categoryId: categoryId,
        type: SELECT_MOBILE_MENU_HISTORY
    };
};
var setInitialData = function(categories) {
    return {
        categories: categories,
        type: SET_INITIAL_DATA
    };
};
var changeCategories = function(state) {
    return _objectSpreadProps(_objectSpread({}, state), {
        type: CHANGE_MOBILE_MENU_CATEGORIES
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    openMenu: openMenu,
    closeMenu: closeMenu,
    navigateFromMobileMenu: navigateFromMobileMenu,
    selectHistory: selectHistory,
    setInitialData: setInitialData,
    changeCategories: changeCategories
});


/***/ }),

/***/ 26891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48993);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var productCollectionSitemap = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-collection";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-collection */ 603).then(__webpack_require__.bind(__webpack_require__, 97351));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(97351);
        }
        return eval("require.resolve")("./product-collection-sitemap");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
productCollectionSitemap.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
productCollectionSitemap.loadOrder = [
    {
        main: true
    }
];
productCollectionSitemap.variables = function(param) {
    var slug = param.slug;
    return {
        slug: slug
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (productCollectionSitemap);


/***/ }),

/***/ 46233:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25932);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(query_string_for_all__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50699);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_4__);





var ProductCollection = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-collection";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-collection */ 603).then(__webpack_require__.bind(__webpack_require__, 66242));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(66242);
        }
        return eval("require.resolve")("./product-collection");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ProductCollection.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_4___default());
// TODO: once we decide how to go about product collection SSR state, we can remove this as well
ProductCollection.ssr = function(param) {
    var location = param.location;
    var ref = query_string_for_all__WEBPACK_IMPORTED_MODULE_3___default().parse(location.search), offset = ref.offset, sort = ref.sort, direction = ref.direction;
    return {
        aggregations: [],
        onlyFeaturedFilters: true,
        useSponsoredContent: false,
        offset: parseInt(offset, 10) || 0,
        sort: sort,
        direction: direction,
        url: location.pathname + location.search,
        filters: []
    };
};
ProductCollection.variables = function(param) {
    var id = param.id, slug = param.slug, productPropertyIds = param.productPropertyIds;
    return {
        id: id,
        slug: slug,
        productPropertyIds: productPropertyIds
    };
};
// Calling this with an empty state object needs to match initial state of routeState in product-collection.tsx
ProductCollection.stateToVariables = function(state) {
    var ref;
    var _onlyFeaturedFilters;
    return {
        query: {
            url: state.url,
            // if the url is set, somewhere we extract the filters from the url
            filters: !state.url && state.filters ? state.filters : undefined,
            aggregations: state.aggregations,
            sort: state.sort,
            direction: state.direction,
            offset: state.offset,
            globalPropertySearch: state.globalPropertySearch
        },
        productPropertyIds: (ref = state.propertyColumnIds) === null || ref === void 0 ? void 0 : ref.filter(// SIMULATED_PROPERTY_COLUMNS
        function(column) {
            return ![
                "brand"
            ].includes(column);
        }),
        productPropertyColumnIds: state.propertyColumnIds,
        onlyFeaturedFilters: (_onlyFeaturedFilters = state.onlyFeaturedFilters) !== null && _onlyFeaturedFilters !== void 0 ? _onlyFeaturedFilters : true,
        useSponsoredContent: state.useSponsoredContent || false
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCollection);


/***/ }),

/***/ 81678:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62619);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88273);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ProductComparePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-compare";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-compare */ 373).then(__webpack_require__.bind(__webpack_require__, 78641));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(78641);
        }
        return eval("require.resolve")("./product-compare");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null)
});
var ProductCompare = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductComparePage, null);
};
// Max products value should not exceed limit in services/bff/src/resolvers/product/resolve.ts
ProductCompare.MAX_PRODUCTS = 12;
ProductCompare.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ProductCompare.variables = function(param) {
    var categoryId = param.categoryId, productIds = param.productIds;
    return {
        categoryId: categoryId || 0,
        fetchCategory: !!categoryId,
        productIds: typeof productIds !== "string" ? [] : productIds.split(",").map(function(item) {
            return parseInt(item, 10);
        }).filter(function(id, index, arr) {
            return !isNaN(id) && arr.indexOf(id) === index;
        }) // only keep unique, valid integers
        .slice(0, ProductCompare.MAX_PRODUCTS)
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCompare);


/***/ }),

/***/ 17696:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Px": () => (/* binding */ productMediaSetPosition),
/* harmony export */   "WI": () => (/* binding */ productMediaOpen)
/* harmony export */ });
/* unused harmony exports PRODUCT_MEDIA_OPEN, PRODUCT_MEDIA_SET_POSITION */
var PRODUCT_MEDIA_OPEN = "PRODUCT_MEDIA_OPEN";
var PRODUCT_MEDIA_SET_POSITION = "PRODUCT_MEDIA_SET_POSITION";
var productMediaOpen = function(position) {
    return {
        type: PRODUCT_MEDIA_OPEN,
        show: true,
        position: position
    };
};
var productMediaSetPosition = function(position, param) {
    var action = param.action;
    return {
        type: PRODUCT_MEDIA_SET_POSITION,
        position: position,
        action: action
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    productMediaOpen: productMediaOpen,
    productMediaSetPosition: productMediaSetPosition
});


/***/ }),

/***/ 1067:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bs": () => (/* binding */ DELETE_SHOP_REVIEW),
/* harmony export */   "CA": () => (/* binding */ EDIT_SHOP_REVIEW),
/* harmony export */   "DT": () => (/* binding */ HIDE_SHOP_REVIEW_THANK_YOU),
/* harmony export */   "H1": () => (/* binding */ openReviewDialog),
/* harmony export */   "Hg": () => (/* binding */ SAVE_REVIEW_DRAFT),
/* harmony export */   "ID": () => (/* binding */ editShopReview),
/* harmony export */   "Jy": () => (/* binding */ editShopReviewSuccess),
/* harmony export */   "KW": () => (/* binding */ closeReviewDialog),
/* harmony export */   "Mf": () => (/* binding */ updateReviewSummary),
/* harmony export */   "RL": () => (/* binding */ LIKE_REVIEW_FAILED),
/* harmony export */   "TA": () => (/* binding */ deleteShopReviewSuccess),
/* harmony export */   "TF": () => (/* binding */ CLOSE_REVIEW_DIALOG),
/* harmony export */   "Ty": () => (/* binding */ deleteReviewSuccess),
/* harmony export */   "U9": () => (/* binding */ likeReviewSuccess),
/* harmony export */   "UW": () => (/* binding */ DELETE_SHOP_REVIEW_SUCCESS),
/* harmony export */   "UY": () => (/* binding */ LIKE_REVIEW_SUCCESS),
/* harmony export */   "XN": () => (/* binding */ likeReviewFailed),
/* harmony export */   "XU": () => (/* binding */ createReview),
/* harmony export */   "YM": () => (/* binding */ saveReviewDraft),
/* harmony export */   "Yf": () => (/* binding */ deleteShopReview),
/* harmony export */   "ar": () => (/* binding */ REPORT_REVIEW),
/* harmony export */   "b3": () => (/* binding */ OPEN_REVIEW_DIALOG),
/* harmony export */   "bg": () => (/* binding */ CREATE_REVIEW_SUCCESS),
/* harmony export */   "c1": () => (/* binding */ reportReviewFailed),
/* harmony export */   "cO": () => (/* binding */ EDIT_REVIEW_SUCCESS),
/* harmony export */   "e1": () => (/* binding */ UPDATE_REVIEW_DATA),
/* harmony export */   "eA": () => (/* binding */ CREATE_SHOP_REVIEW_SUCCESS),
/* harmony export */   "eX": () => (/* binding */ likeReviewToggle),
/* harmony export */   "ey": () => (/* binding */ createReviewSuccess),
/* harmony export */   "g0": () => (/* binding */ hideShopReviewThankYouDialog),
/* harmony export */   "g6": () => (/* binding */ DELETE_REVIEW_SUCCESS),
/* harmony export */   "hy": () => (/* binding */ EDIT_REVIEW),
/* harmony export */   "i0": () => (/* binding */ deleteReview),
/* harmony export */   "i_": () => (/* binding */ updateShopReviewData),
/* harmony export */   "kP": () => (/* binding */ editReview),
/* harmony export */   "kX": () => (/* binding */ editReviewSuccess),
/* harmony export */   "l3": () => (/* binding */ CREATE_REVIEW),
/* harmony export */   "mb": () => (/* binding */ CREATE_SHOP_REVIEW),
/* harmony export */   "n0": () => (/* binding */ reviewRequestError),
/* harmony export */   "qG": () => (/* binding */ reportReviewSuccess),
/* harmony export */   "rj": () => (/* binding */ createShopReview),
/* harmony export */   "s6": () => (/* binding */ EDIT_SHOP_REVIEW_SUCCESS),
/* harmony export */   "u9": () => (/* binding */ REVIEW_REQUEST_ERROR),
/* harmony export */   "vH": () => (/* binding */ LIKE_REVIEW_TOGGLE),
/* harmony export */   "y$": () => (/* binding */ DELETE_REVIEW),
/* harmony export */   "zM": () => (/* binding */ UPDATE_REVIEW_SUMMARY),
/* harmony export */   "zk": () => (/* binding */ createShopReviewSuccess)
/* harmony export */ });
/* unused harmony exports REPORT_REVIEW_SUCCESS, REPORT_REVIEW_FAILED, reportReview */
var CREATE_REVIEW = "CREATE_REVIEW";
var EDIT_REVIEW = "EDIT_REVIEW";
var DELETE_REVIEW = "DELETE_REVIEW";
var CREATE_REVIEW_SUCCESS = "CREATE_REVIEW_SUCCESS";
var EDIT_REVIEW_SUCCESS = "EDIT_REVIEW_SUCCESS";
var DELETE_REVIEW_SUCCESS = "DELETE_REVIEW_SUCCESS";
var OPEN_REVIEW_DIALOG = "OPEN_REVIEW_DIALOG";
var CLOSE_REVIEW_DIALOG = "CLOSE_REVIEW_DIALOG";
var REVIEW_REQUEST_ERROR = "REVIEW_REQUEST_ERROR";
var REPORT_REVIEW = "REPORT_REVIEW";
var REPORT_REVIEW_SUCCESS = "REPORT_REVIEW_SUCCESS";
var REPORT_REVIEW_FAILED = "REPORT_REVIEW_FAILED";
var LIKE_REVIEW_TOGGLE = "LIKE_REVIEW_TOGGLE";
var LIKE_REVIEW_SUCCESS = "LIKE_REVIEW_SUCCESS";
var LIKE_REVIEW_FAILED = "LIKE_REVIEW_FAILED";
var CREATE_SHOP_REVIEW = "CREATE_SHOP_REVIEW";
var CREATE_SHOP_REVIEW_SUCCESS = "CREATE_SHOP_REVIEW_SUCCESS";
var EDIT_SHOP_REVIEW = "EDIT_SHOP_REVIEW";
var EDIT_SHOP_REVIEW_SUCCESS = "EDIT_SHOP_REVIEW_SUCCESS";
var DELETE_SHOP_REVIEW = "DELETE_SHOP_REVIEW";
var DELETE_SHOP_REVIEW_SUCCESS = "DELETE_SHOP_REVIEW_SUCCESS";
var HIDE_SHOP_REVIEW_THANK_YOU = "HIDE_SHOP_REVIEW_THANK_YOU";
var UPDATE_REVIEW_SUMMARY = "UPDATE_REVIEW_SUMMARY";
var UPDATE_REVIEW_DATA = "UPDATE_REVIEW_DATA";
var SAVE_REVIEW_DRAFT = "SAVE_REVIEW_DRAFT";
var createReview = function(param) {
    var belongsToId = param.belongsToId, rating = param.rating, reviewType = param.reviewType, reviewText = param.reviewText, purchaseDate = param.purchaseDate, displayName = param.displayName;
    return {
        type: CREATE_REVIEW,
        belongsToId: belongsToId,
        rating: rating,
        reviewType: reviewType,
        reviewText: reviewText,
        purchaseDate: purchaseDate,
        displayName: displayName
    };
};
var createShopReview = function(param) {
    var belongsToId = param.belongsToId, belongsToName = param.belongsToName, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, answers = param.answers, email = param.email, displayName = param.displayName;
    return {
        type: CREATE_SHOP_REVIEW,
        reviewType: "STORE",
        belongsToId: belongsToId,
        belongsToName: belongsToName,
        rating: rating,
        reviewText: reviewText,
        purchaseDate: purchaseDate,
        answers: answers,
        email: email,
        displayName: displayName
    };
};
var createShopReviewSuccess = function(param) {
    var shopId = param.shopId;
    return {
        type: CREATE_SHOP_REVIEW_SUCCESS,
        shopId: shopId
    };
};
var hideShopReviewThankYouDialog = function() {
    return {
        type: HIDE_SHOP_REVIEW_THANK_YOU
    };
};
var editReview = function(param) {
    var reviewId = param.reviewId, belongsToId = param.belongsToId, reviewType = param.reviewType, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, location = param.location;
    return {
        type: EDIT_REVIEW,
        reviewId: reviewId,
        belongsToId: belongsToId,
        reviewType: reviewType,
        rating: rating,
        reviewText: reviewText,
        purchaseDate: purchaseDate,
        location: location
    };
};
var editShopReview = function(param) {
    var reviewId = param.reviewId, belongsToId = param.belongsToId, belongsToName = param.belongsToName, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, answers = param.answers, location = param.location;
    return {
        type: EDIT_SHOP_REVIEW,
        reviewType: "STORE",
        reviewId: reviewId,
        belongsToId: belongsToId,
        belongsToName: belongsToName,
        rating: rating,
        reviewText: reviewText,
        purchaseDate: purchaseDate,
        answers: answers,
        location: location
    };
};
var editShopReviewSuccess = function(param) {
    var shopId = param.shopId, location = param.location;
    return {
        type: EDIT_SHOP_REVIEW_SUCCESS,
        shopId: shopId,
        location: location
    };
};
var deleteReview = function(param) {
    var reviewId = param.reviewId, belongsToId = param.belongsToId, reviewType = param.reviewType, location = param.location;
    return {
        type: DELETE_REVIEW,
        reviewId: reviewId,
        reviewType: reviewType,
        belongsToId: belongsToId,
        location: location
    };
};
var deleteShopReview = function(param) {
    var reviewId = param.reviewId, shopId = param.shopId, shopName = param.shopName, location = param.location;
    return {
        type: DELETE_SHOP_REVIEW,
        reviewId: reviewId,
        shopId: shopId,
        shopName: shopName,
        location: location
    };
};
var deleteShopReviewSuccess = function(param) {
    var shopId = param.shopId, location = param.location;
    return {
        type: DELETE_SHOP_REVIEW_SUCCESS,
        shopId: shopId,
        location: location
    };
};
var createReviewSuccess = function(param) {
    var productId = param.productId;
    return {
        type: CREATE_REVIEW_SUCCESS,
        productId: productId
    };
};
var editReviewSuccess = function(param) {
    var productId = param.productId, location = param.location;
    return {
        type: EDIT_REVIEW_SUCCESS,
        productId: productId,
        location: location
    };
};
var deleteReviewSuccess = function(param) {
    var productId = param.productId, location = param.location;
    return {
        type: DELETE_REVIEW_SUCCESS,
        productId: productId,
        location: location
    };
};
var updateReviewSummary = function(summary) {
    return {
        type: UPDATE_REVIEW_SUMMARY,
        summary: summary
    };
};
var updateShopReviewData = function(param) {
    var shopId = param.shopId, productId = param.productId, nodes = param.nodes, myReview = param.myReview;
    return {
        type: UPDATE_REVIEW_DATA,
        shopId: shopId,
        productId: productId,
        nodes: nodes,
        myReview: myReview
    };
};
var openReviewDialog = function(uid) {
    return {
        type: OPEN_REVIEW_DIALOG,
        uid: uid
    };
};
var closeReviewDialog = function() {
    return {
        type: CLOSE_REVIEW_DIALOG
    };
};
var reviewRequestError = function(errorCode) {
    return {
        type: REVIEW_REQUEST_ERROR,
        errorCode: errorCode
    };
};
var reportReview = function(reviewId, message, email) {
    return {
        type: REPORT_REVIEW,
        reviewId: reviewId,
        message: message,
        email: email
    };
};
var reportReviewSuccess = function() {
    return {
        type: REPORT_REVIEW_SUCCESS
    };
};
var reportReviewFailed = function(message) {
    return {
        type: REPORT_REVIEW_FAILED,
        message: message
    };
};
var likeReviewToggle = function(id, reviewType) {
    return {
        type: LIKE_REVIEW_TOGGLE,
        id: id,
        reviewType: reviewType
    };
};
var likeReviewSuccess = function(id, value) {
    return {
        type: LIKE_REVIEW_SUCCESS,
        id: id,
        value: value
    };
};
var likeReviewFailed = function() {
    return {
        type: LIKE_REVIEW_FAILED
    };
};
var saveReviewDraft = function(draft) {
    return {
        type: SAVE_REVIEW_DRAFT,
        draft: draft
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    editReview: editReview,
    createReview: createReview,
    deleteReview: deleteReview,
    openReviewDialog: openReviewDialog,
    closeReviewDialog: closeReviewDialog,
    reportReview: reportReview,
    reportReviewSuccess: reportReviewSuccess,
    reportReviewFailed: reportReviewFailed
});


/***/ }),

/***/ 47441:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony exports SEARCH_SAVE, CLEAR_RECENT, ENTER_SEARCH_MENU, EXIT_SEARCH_MENU, SEARCH_RESULT_CLICK_FULL, SEARCH_RESULT_CLICK_MENU, SEARCH_INPUT_QUERY, SUGGESTION_CLICK, SEARCH_CLICK, SEARCH_FOCUS, SEARCH_BLUR, SEARCH_FILTER, SEARCH_SORT, searchFetchError */
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SEARCH_SAVE = "SEARCH_SAVE";
var CLEAR_RECENT = "SEARCH_CLEAR_RECENT";
var ENTER_SEARCH_MENU = "ENTER_SEARCH_MENU";
var EXIT_SEARCH_MENU = "EXIT_SEARCH_MENU";
var SEARCH_RESULT_CLICK_FULL = "SEARCH_RESULT_CLICK_FULL";
var SEARCH_RESULT_CLICK_MENU = "SEARCH_RESULT_CLICK_MENU";
var SEARCH_INPUT_QUERY = "SEARCH_INPUT_QUERY";
var SUGGESTION_CLICK = "SUGGESTION_CLICK";
var SEARCH_CLICK = "SEARCH_CLICK";
var SEARCH_FOCUS = "SEARCH_FOCUS";
var SEARCH_BLUR = "SEARCH_BLUR";
var SEARCH_FILTER = "SEARCH_FILTER";
var SEARCH_SORT = "SEARCH_SORT";
var searchSave = function(query) {
    return {
        type: SEARCH_SAVE,
        query: query
    };
};
var clearRecent = function(content) {
    return {
        type: CLEAR_RECENT,
        content: content
    };
};
var suggestionClick = function(suggestionType, position) {
    return {
        type: SUGGESTION_CLICK,
        suggestion: suggestionType,
        reciprocalRank: 1 / position
    };
};
var searchClick = function(position) {
    return {
        type: SEARCH_CLICK,
        reciprocalRank: 1 / position
    };
};
var searchFilter = function(section) {
    return {
        type: SEARCH_FILTER,
        section: section
    };
};
var searchSort = function(sort) {
    return {
        type: SEARCH_SORT,
        sort: sort
    };
};
var searchFocus = function() {
    return {
        type: SEARCH_FOCUS
    };
};
var searchBlur = function() {
    return {
        type: SEARCH_BLUR
    };
};
var searchInstant = function(action, query, didYouMean) {
    var data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return _objectSpread({
        type: "SEARCH_INSTANT",
        action: action,
        query: [
            query,
            didYouMean
        ].filter(function(x) {
            return x;
        }).join(" → ")
    }, data);
};
var enterSearchMenu = function() {
    return {
        type: ENTER_SEARCH_MENU
    };
};
var exitSearchMenu = function() {
    return {
        type: EXIT_SEARCH_MENU
    };
};
var searchResultClick = function(actionName) {
    return function(resultType, item) {
        return {
            type: actionName,
            data: {
                type: resultType,
                item: item
            }
        };
    };
};
var searchInputQuery = function(query) {
    return {
        type: SEARCH_INPUT_QUERY,
        data: {
            query: query
        }
    };
};
var searchFetchError = function(error) {
    return {
        type: "SEARCH_FETCH_ERROR",
        error: error
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    searchInstant: searchInstant,
    suggestionClick: suggestionClick,
    searchClick: searchClick,
    searchFocus: searchFocus,
    searchBlur: searchBlur,
    searchSave: searchSave,
    clearRecent: clearRecent,
    enterSearchMenu: enterSearchMenu,
    exitSearchMenu: exitSearchMenu,
    searchResultClick: searchResultClick,
    searchInputQuery: searchInputQuery,
    searchFilter: searchFilter,
    searchSort: searchSort
});


/***/ }),

/***/ 81387:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export queryToVariables */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13897);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable camelcase */ 



var SearchPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "search";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | search */ 464).then(__webpack_require__.bind(__webpack_require__, 97240));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(97240);
        }
        return eval("require.resolve")("./components/results");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
SearchPage.mergeData = function(_, newData) {
    return newData;
};
var queryToVariables = function(param) {
    var _query = param.query, query = _query === void 0 ? "" : _query, _search = param.search, search = _search === void 0 ? "" : _search, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _sort = param.sort, sort = _sort === void 0 ? "" : _sort, _category_id = param.category_id, category_id = _category_id === void 0 ? "" : _category_id, _brand_id = param.brand_id, brand_id = _brand_id === void 0 ? "" : _brand_id, _rating_id = param.rating_id, rating_id = _rating_id === void 0 ? "" : _rating_id, _price_id = param.price_id, price_id = _price_id === void 0 ? "" : _price_id, _deals_id = param.deals_id, deals_id = _deals_id === void 0 ? "" : _deals_id, _availability_id = param.availability_id, availability_id = _availability_id === void 0 ? "" : _availability_id, _lowest_price = param.lowest_price, lowest_price = _lowest_price === void 0 ? "" : _lowest_price, _user_rating = param.user_rating, user_rating = _user_rating === void 0 ? "" : _user_rating, _experiments = param.experiments, experiments = _experiments === void 0 ? [] : _experiments, marketCode = param.marketCode;
    var ref;
    var ref1;
    var allProductsFilter = (ref1 = ((ref = experiments["search-page-all-products-searchable"]) === null || ref === void 0 ? void 0 : ref.selectedVariant) === "allProducts") !== null && ref1 !== void 0 ? ref1 : false;
    return {
        id: "search",
        query: query || search,
        sort: sort.split(":")[0] || "score",
        order: sort.split(":")[1] || "desc",
        offset: parseInt(offset, 10),
        limit: 48,
        filters: [
            {
                id: "category_id",
                selected: category_id.split(",").filter(Boolean)
            },
            {
                id: "brand_id",
                selected: brand_id.split(",").filter(Boolean)
            },
            {
                id: "lowest_price",
                from: parseInt(lowest_price.split(",")[0], 10) || undefined,
                to: parseInt(lowest_price.split(",")[1], 10) || undefined
            },
            {
                id: "user_rating",
                from: parseInt(user_rating.split(",")[0], 10) || undefined,
                to: parseInt(user_rating.split(",")[1], 10) || undefined
            }
        ],
        productModes: [
            "product",
            "raw"
        ],
        categoryFilters: category_id.split(",").filter(Boolean),
        brandFilters: brand_id.split(",").filter(Boolean),
        ratingFilters: rating_id.split(",").filter(Boolean),
        priceFilters: price_id.split(",").filter(Boolean),
        dealsFilters: deals_id.split(",").filter(Boolean),
        availabilityFilters: availability_id.split(",").filter(Boolean),
        getExperts: marketCode !== "nz",
        allProductsFilter: allProductsFilter
    };
};
SearchPage.variables = queryToVariables;
SearchPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
SearchPage.loadOrder = [
    {}
];
SearchPage.group = function(param) {
    var name = param.name, variables = param.variables;
    var groupVariables = variables ? Object.keys(variables).filter(function(key) {
        return [
            "query",
            "sort",
            "order",
            "offset"
        ].indexOf(key) > -1;
    }).map(function(key) {
        return variables[key];
    }) : [];
    var filterVariables = variables && variables.filters ? variables.filters.map(function(filter) {
        switch(filter.id){
            case "category_id":
            case "brand_id":
                return "".concat(filter.id, ":").concat(filter.selected);
            case "lowest_price":
            case "user_rating":
                return "".concat(filter.id, ":").concat(filter.from, ":").concat(filter.to);
            default:
                return filter.id;
        }
    }) : [];
    return "".concat(name, "_").concat(groupVariables.join("_"), "_").concat(filterVariables.join("_"));
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchPage);


/***/ }),

/***/ 84993:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": () => (/* binding */ ShopOfTheYearLandingPage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99230);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ShopOfTheYearLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "shop-of-the-year";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | shop-of-the-year */ 406).then(__webpack_require__.bind(__webpack_require__, 51378));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(51378);
        }
        return eval("require.resolve")("./components/landing-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ShopOfTheYearLandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ShopOfTheYearLandingPage.variables = function(param) {
    var section = param.section;
    return {
        section: section
    };
};



/***/ }),

/***/ 33944:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": () => (/* binding */ REMOVE_ALERT_SUCCESS),
/* harmony export */   "$b": () => (/* binding */ createAlertRequest),
/* harmony export */   "$x": () => (/* binding */ REMOVE_ALERT_REQUEST),
/* harmony export */   "Jl": () => (/* binding */ restoreAlertSuccess),
/* harmony export */   "Oi": () => (/* binding */ CREATE_ALERT_REQUEST),
/* harmony export */   "SU": () => (/* binding */ openAlerts),
/* harmony export */   "TI": () => (/* binding */ removeAlertError),
/* harmony export */   "VG": () => (/* binding */ OPEN_ALERTS),
/* harmony export */   "VL": () => (/* binding */ CREATE_ALERT_FAILED),
/* harmony export */   "Vp": () => (/* binding */ CLOSE_ALERTS),
/* harmony export */   "XJ": () => (/* binding */ REMOVE_ALERT_ERROR),
/* harmony export */   "Yo": () => (/* binding */ RESTORE_ALERT_SUCCESS),
/* harmony export */   "Zl": () => (/* binding */ sortAlerts),
/* harmony export */   "_X": () => (/* binding */ removeAlertSuccess),
/* harmony export */   "ej": () => (/* binding */ SORT_ALERTS),
/* harmony export */   "f9": () => (/* binding */ RESTORE_ALERT_REQUEST),
/* harmony export */   "fZ": () => (/* binding */ createAlertFailed),
/* harmony export */   "g": () => (/* binding */ restoreAlertError),
/* harmony export */   "mx": () => (/* binding */ CREATE_ALERT_SUCCESS),
/* harmony export */   "s$": () => (/* binding */ removeAlertRequest),
/* harmony export */   "w4": () => (/* binding */ createAlertSuccess),
/* harmony export */   "ys": () => (/* binding */ closeAlerts)
/* harmony export */ });
/* unused harmony exports RESTORE_ALERT_ERROR, restoreAlertRequest */
var REMOVE_ALERT_REQUEST = "REMOVE_ALERT_REQUEST";
var REMOVE_ALERT_SUCCESS = "REMOVE_ALERT_SUCCESS";
var REMOVE_ALERT_ERROR = "REMOVE_ALERT_ERROR";
var RESTORE_ALERT_REQUEST = "RESTORE_ALERT_REQUEST";
var RESTORE_ALERT_SUCCESS = "RESTORE_ALERT_SUCCESS";
var RESTORE_ALERT_ERROR = "RESTORE_ALERT_ERROR";
var CREATE_ALERT_REQUEST = "CREATE_ALERT_REQUEST";
var CREATE_ALERT_SUCCESS = "CREATE_ALERT_SUCCESS";
var CREATE_ALERT_FAILED = "CREATE_ALERT_FAILED";
var SORT_ALERTS = "SORT_ALERTS";
var OPEN_ALERTS = "OPEN_ALERTS";
var CLOSE_ALERTS = "CLOSE_ALERTS";
var createAlertRequest = function(data, onSuccess) {
    return {
        type: CREATE_ALERT_REQUEST,
        data: data,
        onSuccess: onSuccess
    };
};
var createAlertSuccess = function(id, productId) {
    return {
        type: CREATE_ALERT_SUCCESS,
        id: id,
        productId: productId
    };
};
var createAlertFailed = function(error) {
    return {
        type: CREATE_ALERT_FAILED,
        error: error
    };
};
var removeAlertRequest = function(id, productId, onSuccess) {
    return {
        type: REMOVE_ALERT_REQUEST,
        id: id,
        productId: productId,
        onSuccess: onSuccess
    };
};
var removeAlertSuccess = function(restoreToken, id, productId) {
    return {
        type: REMOVE_ALERT_SUCCESS,
        restoreToken: restoreToken,
        id: id,
        productId: productId
    };
};
var restoreAlertRequest = function(restoreToken, id, productId) {
    return {
        type: RESTORE_ALERT_REQUEST,
        restoreToken: restoreToken,
        id: id,
        productId: productId
    };
};
var restoreAlertSuccess = function(restoreToken, id, productId) {
    return {
        type: RESTORE_ALERT_SUCCESS,
        restoreToken: restoreToken,
        id: id,
        productId: productId
    };
};
var restoreAlertError = function(error) {
    return {
        type: RESTORE_ALERT_ERROR,
        error: error
    };
};
var removeAlertError = function(error) {
    return {
        type: REMOVE_ALERT_ERROR,
        error: error
    };
};
var sortAlerts = function(sort) {
    return {
        type: SORT_ALERTS,
        sort: sort
    };
};
var openAlerts = function() {
    return {
        type: OPEN_ALERTS,
        open: true
    };
};
var closeAlerts = function() {
    return {
        type: CLOSE_ALERTS,
        open: false
    };
};


/***/ }),

/***/ 44291:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ toggleFilter),
/* harmony export */   "m": () => (/* binding */ TOGGLE_FILTER)
/* harmony export */ });
var TOGGLE_FILTER = "TOGGLE_FILTER";
var toggleFilter = function() {
    return {
        type: TOGGLE_FILTER
    };
};


/***/ }),

/***/ 96805:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": () => (/* binding */ EDIT_LIST_SUCCESS),
/* harmony export */   "DU": () => (/* binding */ removeListItemRequest),
/* harmony export */   "En": () => (/* binding */ ADD_LIST_ITEM_REQUEST),
/* harmony export */   "Fc": () => (/* binding */ OPEN_LISTS),
/* harmony export */   "Fz": () => (/* binding */ selectList),
/* harmony export */   "GB": () => (/* binding */ EDIT_LIST_REQUEST),
/* harmony export */   "GV": () => (/* binding */ CLOSE_LISTS),
/* harmony export */   "Gr": () => (/* binding */ importListToMyProducts),
/* harmony export */   "Kj": () => (/* binding */ CREATE_LIST_SUCCESS),
/* harmony export */   "Ll": () => (/* binding */ removeListError),
/* harmony export */   "M1": () => (/* binding */ createListError),
/* harmony export */   "M2": () => (/* binding */ removeListItemSuccess),
/* harmony export */   "Mr": () => (/* binding */ removeListSuccess),
/* harmony export */   "N$": () => (/* binding */ REMOVE_LIST_REQUEST),
/* harmony export */   "Od": () => (/* binding */ OPEN_LIST_SETTINGS),
/* harmony export */   "Og": () => (/* binding */ REMOVE_LIST_ERROR),
/* harmony export */   "Oz": () => (/* binding */ REMOVE_LIST_ITEM_ERROR),
/* harmony export */   "P": () => (/* binding */ editListSuccess),
/* harmony export */   "Po": () => (/* binding */ ORDER_LISTS_REQUEST),
/* harmony export */   "QE": () => (/* binding */ CREATE_LIST_REQUEST),
/* harmony export */   "T3": () => (/* binding */ SELECT_LIST),
/* harmony export */   "WT": () => (/* binding */ addListItemError),
/* harmony export */   "Zh": () => (/* binding */ SORT_LIST),
/* harmony export */   "_8": () => (/* binding */ importListToMyProductsSuccess),
/* harmony export */   "aF": () => (/* binding */ REMOVE_LIST_ITEM_REQUEST),
/* harmony export */   "c": () => (/* binding */ closeLists),
/* harmony export */   "f$": () => (/* binding */ removeListItemError),
/* harmony export */   "fS": () => (/* binding */ sortList),
/* harmony export */   "hg": () => (/* binding */ addListItemRequest),
/* harmony export */   "if": () => (/* binding */ addItemToMyProductsRequest),
/* harmony export */   "iw": () => (/* binding */ REMOVE_LIST_ITEM_SUCCESS),
/* harmony export */   "j3": () => (/* binding */ addListItemSuccess),
/* harmony export */   "jk": () => (/* binding */ orderListItemsRequest),
/* harmony export */   "jy": () => (/* binding */ closeListSettings),
/* harmony export */   "ng": () => (/* binding */ removeListRequest),
/* harmony export */   "oN": () => (/* binding */ orderListsRequest),
/* harmony export */   "pU": () => (/* binding */ EDIT_LIST_ERROR),
/* harmony export */   "pd": () => (/* binding */ ADD_LIST_ITEM_SUCCESS),
/* harmony export */   "pu": () => (/* binding */ openLists),
/* harmony export */   "qR": () => (/* binding */ IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS),
/* harmony export */   "re": () => (/* binding */ createListSuccess),
/* harmony export */   "sh": () => (/* binding */ REMOVE_LIST_SUCCESS),
/* harmony export */   "sy": () => (/* binding */ IMPORT_LIST_TO_MY_PRODUCTS),
/* harmony export */   "tH": () => (/* binding */ editListError),
/* harmony export */   "vz": () => (/* binding */ openListSettings),
/* harmony export */   "w": () => (/* binding */ ORDER_LIST_ITEMS_REQUEST),
/* harmony export */   "xC": () => (/* binding */ ADD_ITEM_TO_MY_PRODUCTS_REQUEST),
/* harmony export */   "xb": () => (/* binding */ editListRequest),
/* harmony export */   "y$": () => (/* binding */ CLOSE_LIST_SETTINGS),
/* harmony export */   "zD": () => (/* binding */ ADD_LIST_ITEM_ERROR)
/* harmony export */ });
/* unused harmony exports CREATE_LIST_ERROR, createListRequest */
var ADD_LIST_ITEM_REQUEST = "ADD_LIST_ITEM_REQUEST";
var ADD_LIST_ITEM_SUCCESS = "ADD_LIST_ITEM_SUCCESS";
var ADD_LIST_ITEM_ERROR = "ADD_LIST_ITEM_ERROR";
var REMOVE_LIST_ITEM_REQUEST = "REMOVE_LIST_ITEM_REQUEST";
var REMOVE_LIST_ITEM_SUCCESS = "REMOVE_LIST_ITEM_SUCCESS";
var REMOVE_LIST_ITEM_ERROR = "REMOVE_LIST_ITEM_ERROR";
var REMOVE_LIST_REQUEST = "REMOVE_LIST_REQUEST";
var REMOVE_LIST_SUCCESS = "REMOVE_LIST_SUCCESS";
var REMOVE_LIST_ERROR = "REMOVE_LIST_ERROR";
var CREATE_LIST_REQUEST = "CREATE_LIST_REQUEST";
var CREATE_LIST_SUCCESS = "CREATE_LIST_SUCCESS";
var CREATE_LIST_ERROR = "CREATE_LIST_ERROR";
var EDIT_LIST_REQUEST = "EDIT_LIST_REQUEST";
var EDIT_LIST_SUCCESS = "EDIT_LIST_SUCCESS";
var EDIT_LIST_ERROR = "EDIT_LIST_ERROR";
var SORT_LIST = "SORT_LIST";
var SELECT_LIST = "SELECT_LIST";
var OPEN_LISTS = "OPEN_LISTS";
var CLOSE_LISTS = "CLOSE_LISTS";
var ORDER_LISTS_REQUEST = "ORDER_LISTS_REQUEST";
var ORDER_LIST_ITEMS_REQUEST = "ORDER_LIST_ITEMS_REQUEST";
var ADD_ITEM_TO_MY_PRODUCTS_REQUEST = "ADD_ITEM_TO_MY_PRODUCTS_REQUEST";
var IMPORT_LIST_TO_MY_PRODUCTS = "IMPORT_LIST_TO_MY_PRODUCTS";
var IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS = "IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS";
var OPEN_LIST_SETTINGS = "OPEN_LIST_SETTINGS";
var CLOSE_LIST_SETTINGS = "CLOSE_LIST_SETTINGS";
var addListItemRequest = function(productId, productName, isDesktop) {
    return {
        type: ADD_LIST_ITEM_REQUEST,
        productId: productId,
        productName: productName,
        isDesktop: isDesktop
    };
};
var addListItemSuccess = function(id) {
    return {
        type: ADD_LIST_ITEM_SUCCESS,
        id: id
    };
};
var addListItemError = function(error) {
    return {
        type: ADD_LIST_ITEM_ERROR,
        error: error
    };
};
var removeListItemRequest = function(id, listId) {
    return {
        type: REMOVE_LIST_ITEM_REQUEST,
        id: id,
        listId: listId
    };
};
var removeListItemSuccess = function(restoreToken, id, listId) {
    return {
        type: REMOVE_LIST_ITEM_SUCCESS,
        restoreToken: restoreToken,
        id: id,
        listId: listId
    };
};
var removeListItemError = function(error) {
    return {
        type: REMOVE_LIST_ITEM_ERROR,
        error: error
    };
};
var removeListRequest = function(id) {
    return {
        type: REMOVE_LIST_REQUEST,
        id: id
    };
};
var removeListSuccess = function(restoreToken, id) {
    return {
        type: REMOVE_LIST_SUCCESS,
        restoreToken: restoreToken,
        id: id
    };
};
var removeListError = function(error) {
    return {
        type: REMOVE_LIST_ERROR,
        error: error
    };
};
var createListRequest = function(listName) {
    return {
        type: CREATE_LIST_REQUEST,
        listName: listName
    };
};
var createListSuccess = function(list) {
    return {
        type: CREATE_LIST_SUCCESS,
        list: list
    };
};
var createListError = function(error) {
    return {
        type: CREATE_LIST_ERROR,
        error: error
    };
};
var editListRequest = function(id, name, visibility) {
    return {
        type: EDIT_LIST_REQUEST,
        id: id,
        name: name,
        visibility: visibility
    };
};
var editListSuccess = function(list) {
    return {
        type: EDIT_LIST_SUCCESS,
        list: list
    };
};
var editListError = function(error) {
    return {
        type: EDIT_LIST_ERROR,
        error: error
    };
};
var sortList = function(sort) {
    return {
        type: SORT_LIST,
        sort: sort
    };
};
var selectList = function(id) {
    return {
        type: SELECT_LIST,
        id: id
    };
};
var openLists = function() {
    return {
        type: OPEN_LISTS,
        open: true
    };
};
var closeLists = function() {
    return {
        type: CLOSE_LISTS,
        open: false
    };
};
var orderListsRequest = function(listIds) {
    return {
        type: ORDER_LISTS_REQUEST,
        listIds: listIds
    };
};
var orderListItemsRequest = function(listId, listItemIds) {
    return {
        type: ORDER_LIST_ITEMS_REQUEST,
        listId: listId,
        listItemIds: listItemIds
    };
};
var addItemToMyProductsRequest = function(productId, productName, isDesktop) {
    return {
        type: ADD_ITEM_TO_MY_PRODUCTS_REQUEST,
        productId: productId,
        productName: productName,
        isDesktop: isDesktop
    };
};
var importListToMyProducts = function(listId) {
    return {
        type: IMPORT_LIST_TO_MY_PRODUCTS,
        listId: listId
    };
};
var importListToMyProductsSuccess = function() {
    return {
        type: IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS
    };
};
var openListSettings = function() {
    return {
        type: OPEN_LIST_SETTINGS
    };
};
var closeListSettings = function() {
    return {
        type: CLOSE_LIST_SETTINGS
    };
};


/***/ }),

/***/ 24726:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ setMobileSidebarView),
/* harmony export */   "e": () => (/* binding */ SET_MOBILE_SIDEBAR_VIEW)
/* harmony export */ });
var SET_MOBILE_SIDEBAR_VIEW = "SET_MOBILE_SIDEBAR_VIEW";
var setMobileSidebarView = function(view) {
    return {
        type: SET_MOBILE_SIDEBAR_VIEW,
        currentView: view
    };
};


/***/ }),

/***/ 43641:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ storeLinkClick)
/* harmony export */ });
var storeLinkClick = function(store) {
    return {
        type: "STORE_LINK_CLICK",
        store: store
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    storeLinkClick: storeLinkClick
});


/***/ }),

/***/ 29893:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./node_modules/.pnpm/focus-visible@5.0.1/node_modules/focus-visible/dist/focus-visible.js
var focus_visible = __webpack_require__(94506);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/client.js
var client = __webpack_require__(44478);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./node_modules/.pnpm/history@4.9.0/node_modules/history/esm/history.js + 2 modules
var esm_history = __webpack_require__(83728);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/@loadable+component@5.15.2_react@18.2.0/node_modules/@loadable/component/dist/loadable.esm.js + 1 modules
var loadable_esm = __webpack_require__(71297);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/after.js
var after = __webpack_require__(77255);
var after_default = /*#__PURE__*/__webpack_require__.n(after);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var throttle = __webpack_require__(38209);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./node_modules/.pnpm/smoothscroll-polyfill@0.4.4/node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var smoothscroll = __webpack_require__(89234);
var smoothscroll_default = /*#__PURE__*/__webpack_require__.n(smoothscroll);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.23.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@tanstack/react-query/build/lib/index.mjs + 37 modules
var lib = __webpack_require__(93561);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query-devtools@4.23.0_@tanstack+react-query@4.23.0_react-dom@18.2.0_react@18._v2zb3nfagkmgnz553sn3xopmfm/node_modules/@tanstack/react-query-devtools/build/lib/index.mjs + 24 modules
var build_lib = __webpack_require__(40117);
// EXTERNAL MODULE: ./packages/prisjakt-account-react/dist/index.js
var dist = __webpack_require__(71447);
// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(15287);
;// CONCATENATED MODULE: ./src/components/account/account-provider-client.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var ref, ref1, ref2, ref3;



var prisjaktAccountConfig = {
    clientId: (ref = window.CLIENT_MARKET.prisjaktAccount) === null || ref === void 0 ? void 0 : ref.clientId,
    env: (ref1 = window.CLIENT_MARKET.prisjaktAccount) === null || ref1 === void 0 ? void 0 : ref1.env,
    market: (ref2 = window.CLIENT_MARKET.prisjaktAccount) === null || ref2 === void 0 ? void 0 : ref2.market,
    redirectUri: (ref3 = window.CLIENT_MARKET.prisjaktAccount) === null || ref3 === void 0 ? void 0 : ref3.redirectUri
};
var ClientAccountProvider = function(param) {
    var children = param.children, onSessionChange = param.onSessionChange;
    var env;
    if (prisjaktAccountConfig.env === "dev") {
        env = "development";
    } else if (prisjaktAccountConfig.env === "prod") {
        env = "production";
    } else {
        throw new Error("unsupported env: ".concat(prisjaktAccountConfig.env));
    }
    if (!prisjaktAccountConfig.market) {
        throw new Error("unsupported market: ".concat(prisjaktAccountConfig.market));
    }
    var _clientId, _redirectUri;
    return /*#__PURE__*/ react.createElement(dist.AccountProvider, {
        config: _objectSpreadProps(_objectSpread({}, prisjaktAccountConfig), {
            env: env,
            clientId: (_clientId = prisjaktAccountConfig.clientId) !== null && _clientId !== void 0 ? _clientId : "",
            redirectUri: (_redirectUri = prisjaktAccountConfig.redirectUri) !== null && _redirectUri !== void 0 ? _redirectUri : "",
            market: prisjaktAccountConfig.market
        }),
        getAuthState: requests/* getPjAccountAuthState */.xf,
        backendLogout: requests/* destroyPjAccountSession */.l5,
        onSessionChange: function(previousSession, currentSession) {
            return onSessionChange({
                type: "prisjakt-account",
                currentSession: currentSession,
                previousSession: previousSession
            });
        },
        getSession: requests/* getPjAccountUserInfo */.E8
    }, children);
};

// EXTERNAL MODULE: ./packages/react-ads/dist/module.js + 1 modules
var dist_module = __webpack_require__(6895);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
;// CONCATENATED MODULE: ./src/client/public-path.js
// eslint-disable-next-line
__webpack_require__.p = window.WEBPACK_PUBLIC_PATH;
/* harmony default export */ var public_path = ((/* unused pure expression or super */ null && (undefined)));

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
;// CONCATENATED MODULE: ./src/client/performance-reporter.ts
function performance_reporter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var addPerformanceTiming = function(event) {
    if ( true && window.performance && window.dataLayer) {
        window.dataLayer.push(performance_reporter_defineProperty({
            event: event
        }, event, window.performance.now()));
    }
};
/* harmony default export */ var performance_reporter = (addPerformanceTiming);

// EXTERNAL MODULE: ./node_modules/.pnpm/web-vitals@4.2.1/node_modules/web-vitals/dist/web-vitals.js
var web_vitals = __webpack_require__(61210);
;// CONCATENATED MODULE: ./src/client/web-vitals-reporter.ts
function web_vitals_reporter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function web_vitals_reporter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            web_vitals_reporter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function web_vitals_reporter_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function web_vitals_reporter_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        web_vitals_reporter_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var sendReport = function(metric) {
    var webVitalReport = web_vitals_reporter_objectSpreadProps(web_vitals_reporter_objectSpread({}, metric), {
        deltaRounded: Math.round(metric.name === "CLS" ? metric.delta * 1000 : metric.delta)
    });
    if ( true && window.dataLayer) {
        window.dataLayer.push({
            event: "webVitalReport",
            webVitalReport: webVitalReport
        });
    }
};
var initWebVitalReports = function() {
    (0,web_vitals/* onCLS */.mw)(sendReport);
    (0,web_vitals/* onFCP */.a4)(sendReport);
    (0,web_vitals/* onINP */.Yn)(sendReport);
    (0,web_vitals/* onLCP */.NO)(sendReport);
    (0,web_vitals/* onTTFB */.mr)(sendReport);
};

// EXTERNAL MODULE: ./src/client/store.js + 49 modules
var store = __webpack_require__(77679);
// EXTERNAL MODULE: ./src/components/fetch-context.ts
var fetch_context = __webpack_require__(4916);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
;// CONCATENATED MODULE: ./src/components/fetch-query-error-context/index.tsx

var FetchQueryErrorContext = /*#__PURE__*/ react.createContext({
    error: undefined
});
var FetchQueryErrorProvider = function(param) {
    var children = param.children, error = param.error;
    var contextValue = (0,react.useMemo)(function() {
        return {
            error: error
        };
    }, [
        error
    ]);
    return /*#__PURE__*/ react.createElement(FetchQueryErrorContext.Provider, {
        value: contextValue
    }, children);
};
function useFetchQueryError() {
    return (0,react.useContext)(FetchQueryErrorContext);
}

// EXTERNAL MODULE: ./src/client/sentry.ts
var sentry = __webpack_require__(22260);
// EXTERNAL MODULE: ./packages/frontend-admin-ui/dist/module.js + 1 modules
var frontend_admin_ui_dist_module = __webpack_require__(53254);
// EXTERNAL MODULE: ./packages/rfe-nextjs-proxy/dist/index.js
var rfe_nextjs_proxy_dist = __webpack_require__(16235);
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/viewport-tracker/index.tsx
var viewport_tracker = __webpack_require__(73567);
// EXTERNAL MODULE: ./src/hooks/use-account.ts + 1 modules
var use_account = __webpack_require__(53082);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/appStyles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      .header,\n      .header--fixed-margin,\n      .pj-footer {\n        display: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  --HEADER_HEIGHT: 4.5rem;\n  min-height: calc(100vh - var(--HEADER_HEIGHT));\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    order: 99;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 100vw;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  /* 1200 is PAGE_CONTENT_GUTTER_BREAKPOINT + 1, since this one is min-width.\n     The magic number was derived from trial and error resizing the window */\n  @media ",
        " {\n    min-width: 1320px;\n  }\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var App = styled_components_browser_esm["default"].div.withConfig({
    displayName: "App",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.layout === "raw-mobile" && (0,styled_components_browser_esm.css)(_templateObject());
});
var MainIncludingAnnouncementBanner = styled_components_browser_esm["default"].section.withConfig({
    displayName: "MainIncludingAnnouncementBanner",
    componentId: "sc-0-1"
})(_templateObject2());
var Main = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Main",
    componentId: "sc-0-2"
})(_templateObject4(), base/* media.largeUp */.BC.largeUp(_templateObject3()));
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-3"
})(_templateObject7(), "screen and (min-width: 1200px)", base/* media.mediumUp */.BC.mediumUp(_templateObject5()), base/* media.mediumDown */.BC.mediumDown(_templateObject6()));

// EXTERNAL MODULE: ./src/areas/feedback/index.tsx
var feedback = __webpack_require__(61768);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(33888);
// EXTERNAL MODULE: ./src/components/country-flag/index.ts + 2 modules
var country_flag = __webpack_require__(37364);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
;// CONCATENATED MODULE: ./src/areas/footer/components/change-market/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  list-style: none;\n  width: 100%;\n  margin: 0;\n  line-height: unset;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        " ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  transition: background ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 15rem;\n\n  &:active {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  flex: 0 1 auto;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-weight: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var Sites = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Sites",
    componentId: "sc-0-0"
})(styles_templateObject());
var Link = styled_components_browser_esm["default"].a.withConfig({
    displayName: "Link",
    componentId: "sc-0-1"
})(styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var Site = styled_components_browser_esm["default"].li.withConfig({
    displayName: "Site",
    componentId: "sc-0-2"
})(styles_templateObject2(), base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(p) {
    return p.theme.dropdowns.primary.hoverBackground;
});
var CountryNameWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CountryNameWrapper",
    componentId: "sc-0-3"
})(styles_templateObject3(), function(p) {
    return p.theme.text.primary;
});
var CountryFlag = (0,styled_components_browser_esm["default"])(country_flag/* CountryFlag */.A).withConfig({
    displayName: "CountryFlag",
    componentId: "sc-0-4"
})(styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CountryName = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CountryName",
    componentId: "sc-0-5"
})(styles_templateObject5(), ui_text.FontWeight.HEAVIER);

;// CONCATENATED MODULE: ./src/areas/footer/components/change-market/index.tsx






var ChangeMarket = function(param) {
    var sites = param.sites, current = param.current;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var siteOptions = sites.filter(function(param) {
        var code = param.code;
        return code !== current;
    }).map(function(param) {
        var url = param.url, code = param.code;
        return {
            code: code,
            url: url,
            name: t("common", "market.".concat(code))
        };
    }).sort(function(a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
    var currentMarket = sites.filter(function(param) {
        var code = param.code;
        return code === current;
    }).map(function(param) {
        var code = param.code;
        return t("common", "market.".concat(code));
    }).join();
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        closeOnItemClick: true
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        showActiveIcon: true,
        type: variants.ButtonType.OUTLINED,
        containerProps: {
            "data-test": "SiteMarketSelector"
        }
    }, /*#__PURE__*/ react.createElement(CountryFlag, {
        countryCode: current,
        altText: currentMarket
    }), /*#__PURE__*/ react.createElement(CountryNameWrapper, null, /*#__PURE__*/ react.createElement(CountryName, null, currentMarket.toUpperCase()), " -", " ", t("footer", "market.".concat(current, "-url")))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        placement: ui/* Direction.Up */.Nm.Up
    }, /*#__PURE__*/ react.createElement(Sites, null, siteOptions.map(function(param) {
        var name = param.name, url = param.url, code = param.code;
        return /*#__PURE__*/ react.createElement(Site, {
            key: "site-".concat(code)
        }, /*#__PURE__*/ react.createElement(Link, {
            href: url,
            "data-test": "SiteMarketSelectorOption",
            "data-test-market-id": code
        }, /*#__PURE__*/ react.createElement(CountryFlag, {
            countryCode: code
        }), /*#__PURE__*/ react.createElement(CountryNameWrapper, null, /*#__PURE__*/ react.createElement(CountryName, null, name.toUpperCase()), " -", " ", t("footer", "market.".concat(code, "-url")))));
    }))));
};
/* harmony default export */ var change_market = (ChangeMarket);

// EXTERNAL MODULE: ./src/areas/sidebar/constants.ts
var constants = __webpack_require__(90081);
;// CONCATENATED MODULE: ./src/components/logo/index.tsx


var suffix = function(styling) {
    switch(styling){
        case "light":
            return "_white";
        case "beta":
            return "_beta";
        case "v2-light":
            return "_v2_light";
        case "v2-dark":
            return "_v2_dark";
        default:
            return "";
    }
};
var Logo = /*#__PURE__*/ (0,react.memo)(function(param) {
    var companyName = param.companyName, market = param.market, styling = param.styling, className = param.className;
    var context = (0,react.useContext)(app_context/* AppContext */.Il);
    if (!market) {
        return null;
    }
    var cdn = context.market && context.market.cdn ? context.market.cdn : "https://cdn.pji.nu";
    var logo = "".concat(cdn, "/g/rfe/logos/logo_").concat(market).concat(suffix(styling), ".svg");
    return /*#__PURE__*/ react.createElement("img", {
        alt: companyName,
        src: logo,
        className: className
    });
});

// EXTERNAL MODULE: ./src/components/newsletter-signup/index.ts + 2 modules
var newsletter_signup = __webpack_require__(608);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/areas/footer/styles.ts
function footer_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function footer_styles_templateObject() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  transition: all 200ms ease;\n\n  /* Offset footer to the left behind the invisible sidebar wrapper\n   to keep the footer full width */\n  @media screen and (min-width: ",
        "px) {\n    margin-left: ",
        ";\n  }\n\n  @media screen and (min-width: 1980px) {\n    margin-left: ",
        ";\n  }\n"
    ]);
    footer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function footer_styles_templateObject1() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    transition: all 200ms ease;\n    \n    /* Align footer content with the rest of the page */\n    @media screen and (min-width: ",
        "px) {\n      margin-left: ",
        ";\n    }\n\n    @media screen and (min-width: 1980px) {\n      margin-left: ",
        ";\n    }\n  "
    ]);
    footer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function footer_styles_templateObject2() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    max-width: ",
        ";\n    width: 100%;\n    padding: ",
        " ",
        ";\n\n    ",
        "\n  "
    ]);
    footer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function footer_styles_templateObject3() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n      grid-auto-flow: row;\n  "
    ]);
    footer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function footer_styles_templateObject4() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: 1fr;\n  width: 100%;\n  gap: ",
        ";\n  align-items: flex-start;\n\n  ",
        "\n"
    ]);
    footer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function footer_styles_templateObject5() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    min-width: 180px;\n  "
    ]);
    footer_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    order: -1;\n    flex-basis: 100%;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    > :not(:last-child) {\n      margin-bottom: ",
        ";\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: nowrap;\n    > :not(:last-child) {\n      margin-right: ",
        ";\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin: 0 ",
        ";\n  line-height: 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = footer_styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    min-height: 90px;\n    && {\n      align-items: center;\n      flex-direction: column;\n    }\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  align-items: flex-end;\n  text-align: left;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n\n    ",
        " {\n      max-width: 370px;\n      flex-direction: column;\n      text-align: center;\n      gap: ",
        ";\n    }\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n      padding-top: ",
        ";\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  justify-content: space-between;\n  background: ",
        ";\n\n  ",
        " {\n    padding-top: ",
        ";\n\n    ",
        "\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n      flex-direction: column;\n      gap: ",
        " 0;\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  color: ",
        ";\n\n  ",
        " {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding-top: ",
        ";\n    flex-wrap: wrap;\n    gap: ",
        " ",
        ";\n\n    /* CoBranding */\n    :last-child {\n      border-top: 1px solid ",
        ";\n      align-items: center;\n      text-align: center;\n    }\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  width: 180px;\n  max-width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    flex-direction: column;\n    align-items: center;\n    p {\n      margin-bottom: 0;\n    }\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-end;\n  flex-shrink: 0;\n  gap: ",
        ";\n\n  p {\n    margin-bottom: 6px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n\n  input {\n    display: flex;\n    flex-grow: 1;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    height: 100%;\n    margin: 0 ",
        ";\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    width: min-content;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        ";\n\n  @media screen and (max-width: 430px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    order: 99;\n  "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n\n  span {\n    color: inherit;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}






var pageWithSidebarContent = base/* layout.pageContentMaxWidthVal */.bK.pageContentMaxWidthVal + base/* layout.sidebarMenuWidth.desktop.value */.bK.sidebarMenuWidth.desktop.value * 2;
var Footer = styled_components_browser_esm["default"].footer.withConfig({
    displayName: "Footer",
    componentId: "sc-0-0"
})(footer_styles_templateObject(), pageWithSidebarContent, function(props) {
    return props.sidebarOpen ? 0 : "calc(((1250px - 100vw) / 2) + ".concat(base/* layout.sidebarMenuWidth.desktop.rem */.bK.sidebarMenuWidth.desktop.rem, ")");
}, function(props) {
    return props.sidebarOpen ? 0 : "calc(-1 * ".concat(base/* layout.sidebarContentWidth.desktop.rem */.bK.sidebarContentWidth.desktop.rem, ")");
});
var styles_Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(footer_styles_templateObject2(), base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.largeUp */.BC.largeUp(footer_styles_templateObject1(), pageWithSidebarContent, props.sidebarOpen ? "inherit" : "calc(((100vw - 1250px) / 2) - ".concat(base/* layout.sidebarMenuWidth.desktop.rem */.bK.sidebarMenuWidth.desktop.rem, ")"), props.sidebarOpen ? "calc(((100vw - 1250px) / 2) - ".concat(base/* layout.sidebarMenuWidth.desktop.value */.bK.sidebarMenuWidth.desktop.value + base/* layout.sidebarContentWidth.desktop.value */.bK.sidebarContentWidth.desktop.value, "px)") : "calc(((100vw - 1250px) / 2) - ".concat(base/* layout.sidebarMenuWidth.desktop.rem */.bK.sidebarMenuWidth.desktop.rem, ")")));
});
var Columns = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Columns",
    componentId: "sc-0-2"
})(footer_styles_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.mediumDown */.BC.mediumDown(footer_styles_templateObject3()));
var Download = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Download",
    componentId: "sc-0-3"
})(styles_templateObject7(), base/* media.mediumUp */.BC.mediumUp(footer_styles_templateObject5()), base/* media.mediumDown */.BC.mediumDown(styles_templateObject6()));
var DownloadTitle = (0,styled_components_browser_esm["default"])(text_variants.H4Text).withConfig({
    displayName: "DownloadTitle",
    componentId: "sc-0-4"
})(_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var DownloadIcons = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DownloadIcons",
    componentId: "sc-0-5"
})(_templateObject11(), base/* media.mediumUp */.BC.mediumUp(_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050), base/* media.mediumDown */.BC.mediumDown(_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var SocialIcons = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SocialIcons",
    componentId: "sc-0-6"
})(_templateObject12());
var SocialIcon = styled_components_browser_esm["default"].a.withConfig({
    displayName: "SocialIcon",
    componentId: "sc-0-7"
})(_templateObject13(), function(p) {
    return p.theme.colors.base500;
}, (0,base/* remCalc */.vR)(4));
var styles_Sites = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Sites",
    componentId: "sc-0-8"
})(_templateObject14());
var CoBranding = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CoBranding",
    componentId: "sc-0-9"
})(_templateObject16(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(_templateObject15()));
var TopSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TopSection",
    componentId: "sc-0-10"
})(_templateObject18(), function(p) {
    return p.theme.colors.maybeBlue100;
}, base/* media.mediumDown */.BC.mediumDown(_templateObject17(), styles_Content, base/* layout.measurements.spacing150 */.bK.measurements.spacing150));
var MidSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MidSection",
    componentId: "sc-0-11"
})(_templateObject20(), function(p) {
    return p.theme.footer.bg.primary;
}, styles_Content, base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* media.mediumDown */.BC.mediumDown(_templateObject19(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150));
var BottomSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BottomSection",
    componentId: "sc-0-12"
})(_templateObject22(), function(p) {
    return p.theme.footer.bg.primary;
}, function(p) {
    return p.theme.colors.base500;
}, styles_Content, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, function(p) {
    return p.theme.colors.base200;
}, base/* media.mediumDown */.BC.mediumDown(_templateObject21(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var styles_Logo = (0,styled_components_browser_esm["default"])(Logo).withConfig({
    displayName: "Logo",
    componentId: "sc-0-13"
})(_templateObject23());
var LogoWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LogoWrapper",
    componentId: "sc-0-14"
})(_templateObject25(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject24()));
var NewsletterSignup = (0,styled_components_browser_esm["default"])(newsletter_signup/* NewsletterSignupFooter */._).withConfig({
    displayName: "NewsletterSignup",
    componentId: "sc-0-15"
})(_templateObject26());
var NewsLetterIllustration = styled_components_browser_esm["default"].img.withConfig({
    displayName: "NewsLetterIllustration",
    componentId: "sc-0-16"
})(_templateObject28(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.largeUp */.BC.largeUp(_templateObject27(), base/* layout.measurements.spacing250 */.bK.measurements.spacing250));
var FeedbackButton = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).withConfig({
    displayName: "FeedbackButton",
    componentId: "sc-0-17"
})(_templateObject30(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.mediumDown */.BC.mediumDown(_templateObject29()));
var ButtonText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ButtonText",
    componentId: "sc-0-18"
})(_templateObject31());
var ClassicSwitchWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ClassicSwitchWrapper",
    componentId: "sc-0-19"
})(_templateObject33(), base/* media.largeUp */.BC.largeUp(_templateObject32()));
var ClassicSwitchLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ClassicSwitchLink",
    componentId: "sc-0-20"
})(_templateObject34(), function(p) {
    return p.theme.colors.base500;
});

;// CONCATENATED MODULE: ./src/areas/footer/components/info-pages/styles.ts
function info_pages_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function info_pages_styles_templateObject() {
    var data = info_pages_styles_taggedTemplateLiteral([
        "\n  list-style: none;\n  margin: 0;\n"
    ]);
    info_pages_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function info_pages_styles_templateObject1() {
    var data = info_pages_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    info_pages_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function info_pages_styles_templateObject2() {
    var data = info_pages_styles_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    info_pages_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function info_pages_styles_templateObject3() {
    var data = info_pages_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    info_pages_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var InfoPagesList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "InfoPagesList",
    componentId: "sc-0-0"
})(info_pages_styles_templateObject());
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-1"
})(info_pages_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var styles_Link = (0,styled_components_browser_esm["default"])(text_variants.BodyMediumText).withConfig({
    displayName: "Link",
    componentId: "sc-0-2"
})(info_pages_styles_templateObject2(), function(p) {
    return p.theme.footer.fg.primary;
}, function(p) {
    return p.theme.buttons.link.textHover;
});
var Column = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-3"
})(info_pages_styles_templateObject3());

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/footer/components/info-pages/index.tsx




var InfoPages = function(param) {
    var columns = param.columns;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, columns.map(function(column) {
        return /*#__PURE__*/ react.createElement(Column, {
            key: "column-".concat(column.title)
        }, /*#__PURE__*/ react.createElement(text_variants.H3Text, null, column.title), /*#__PURE__*/ react.createElement(InfoPagesList, null, column.pages.map(function(page) {
            return page && /*#__PURE__*/ react.createElement(ListItem, {
                key: "".concat(page.title, "-").concat(page.id),
                onClick: function() {
                    return (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.FOOTER_INFO_PAGES */.U.FOOTER_INFO_PAGES,
                        nextPage: page.pathName
                    });
                }
            }, /*#__PURE__*/ react.createElement(styles_Link, {
                container: "a",
                containerProps: {
                    href: page.pathName,
                    // These links are nofollow to avoid them getting too much of the internal
                    // pagerank (since they occur on every page).
                    rel: page.follow ? "follow" : "nofollow",
                    onClick: page.onClick
                }
            }, page.title));
        })));
    }));
};
/* harmony default export */ var info_pages = (/*#__PURE__*/(0,react.memo)(InfoPages));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/social-media-facebook/index.js
var social_media_facebook = __webpack_require__(87531);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/social-media-instagram/index.js
var social_media_instagram = __webpack_require__(41777);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/social-media-twitter/index.js
var social_media_twitter = __webpack_require__(41919);
// EXTERNAL MODULE: ./packages/sourcepoint/dist/index.js
var sourcepoint_dist = __webpack_require__(22549);
;// CONCATENATED MODULE: ./src/areas/footer/footerPages.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function footerPages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function footerPages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            footerPages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function footerPages_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function footerPages_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        footerPages_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var emptyLinkRecord = {
    no: undefined,
    se: undefined,
    fi: undefined,
    gb: undefined,
    nz: undefined,
    fr: undefined,
    dk: undefined
};
var oldSchibstedPolicyMarkets = [
    "no",
    "fi",
    "dk"
];
var ocastLink = footerPages_objectSpreadProps(footerPages_objectSpread({}, emptyLinkRecord), {
    no: "https://no-prisjakt.ocast.com/no/",
    se: "https://se-prisjakt.ocast.com/se/",
    fi: "https://hintaopas.ocast.com/fi/",
    gb: "https://uk-pricespy.ocast.com/",
    nz: "https://nz-pricespy.ocast.com/"
});
var careersLink = footerPages_objectSpreadProps(footerPages_objectSpread({}, emptyLinkRecord), {
    se: "https://prisjakt.teamtailor.com/"
});
var newsroomLink = footerPages_objectSpreadProps(footerPages_objectSpread({}, emptyLinkRecord), {
    no: "https://nyhetsrom.prisjakt.no",
    se: "https://nyhetsrum.prisjakt.nu",
    fi: "https://uutishuone.hintaopas.fi",
    fr: "https://newsroom.ledenicheur.fr ",
    gb: "https://pricespy.co.uk/theme/pricespy-uk-newsroom",
    nz: "https://pricespy.co.nz/theme/pricespy-nz-newsroom"
});
var investorRelationsLink = footerPages_objectSpreadProps(footerPages_objectSpread({}, emptyLinkRecord), {
    dk: "https://investorrelations.prisjakt.nu",
    no: "https://investorrelations.prisjakt.nu",
    se: "https://investorrelations.prisjakt.nu",
    fi: "https://investorrelations.prisjakt.nu",
    fr: "https://investorrelations.prisjakt.nu",
    gb: "https://investorrelations.prisjakt.nu",
    nz: "https://investorrelations.prisjakt.nu"
});
var termsOfUseLink = footerPages_objectSpreadProps(footerPages_objectSpread({}, emptyLinkRecord), {
    dk: "/information/brugervilkar",
    no: "/information/brukervilkar",
    se: "/information/anvandarvillkor",
    fi: "/information/kayttoehdot"
});
var shopOfTheYearLink = footerPages_objectSpreadProps(footerPages_objectSpread({}, emptyLinkRecord), {
    no: "/tema/arets-butikk",
    se: "/tema/arets-butik"
});
var whyPrisjaktLink = footerPages_objectSpreadProps(footerPages_objectSpread({}, emptyLinkRecord), {
    dk: "https://business.prisjagt.dk/hvorfor_prisjagt",
    no: "https://landing.prisjakt.nu/hvorfor_prisjakt_no",
    se: "https://landing.prisjakt.nu/varfor-prisjakt-se",
    fi: "https://business.hintaopas.fi/miksi_hintaopas",
    fr: "https://business.ledenicheur.fr/nous_vous_aidons_a_attirer_un_trafic_qualifie_et_pret_a_acheter_sur_votre_boutique",
    gb: "https://business.pricespy.co.uk/attract_traffic_to_your_shop",
    nz: "https://landing.prisjakt.nu/attract_traffic_to_your_shop_nz"
});
var driveTrafficLink = footerPages_objectSpreadProps(footerPages_objectSpread({}, emptyLinkRecord), {
    se: "https://landing.prisjakt.nu/driv-trafik",
    no: "https://landing.prisjakt.nu/drive_trafikk_no",
    dk: "http://business.prisjagt.dk/driv_trafik_til_din_butik",
    fi: "https://business.hintaopas.fi/ohjaa_liikennetta_kauppaasi"
});
var getTermsPages = function(pageMap) {
    return [
        pageMap.termsOfUse,
        pageMap.transparency,
        pageMap.cookiePolicy,
        pageMap.privacyPolicy,
        pageMap.cookieSettings
    ];
};
var getPageMap = function(infoPageMap, url, market, linkTo, t, pages) {
    var _code;
    var pageMap = {
        themes: !!(url === null || url === void 0 ? void 0 : url.campaigns) && {
            pathName: (url === null || url === void 0 ? void 0 : url.campaigns) || "",
            title: t("campaigns", "themes.title"),
            id: "themes",
            follow: true
        },
        advertiseOnPrisjakt: ocastLink[market.code] && {
            pathName: ocastLink[market.code],
            title: t("footer", "link.ads"),
            id: "adlink",
            follow: false
        },
        careers: careersLink[market.code] && {
            pathName: careersLink[market.code],
            title: t("footer", "link.careers"),
            id: "careers",
            follow: false
        },
        articles: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.articles) && {
            pathName: linkTo("editorialContentListing"),
            title: t("common", "article.articles"),
            id: "articles",
            follow: true
        },
        shopOfTheYear: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.shopOfTheYear) && {
            pathName: (_code = shopOfTheYearLink[market.code]) !== null && _code !== void 0 ? _code : linkTo("shopOfTheYear"),
            title: t("campaigns", "shop-of-the-year.title"),
            id: "shopOfTheYear",
            follow: true
        },
        shopOfTheYearForShops: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.shopOfTheYearForShops) && {
            pathName: infoPageMap.shopOfTheYearForShops,
            title: t("footer", "link.soty-for-stores"),
            id: "shopOfTheYearForShops",
            follow: true
        },
        categoryIndex: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.categoryIndex) && {
            pathName: linkTo("categoryIndex"),
            title: t("category", "category-index.categories"),
            id: "categoryIndex",
            follow: true
        },
        promotions: market.promotions.enabled && {
            pathName: linkTo("promotions"),
            title: t("search", "scoped-search.promotion-title"),
            id: "promotions",
            follow: true
        },
        used: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.used) && {
            pathName: linkTo("used"),
            title: t("product", "product.used-products"),
            id: "used",
            follow: true
        },
        supportPage: {
            pathName: "/help",
            title: t("footer", "contact-helpcenter.link"),
            id: "supportPage",
            follow: false
        },
        cookieSettings: {
            pathName: "#",
            title: t("footer", "link.cookie-settings"),
            id: "cookieSettings",
            follow: false,
            onClick: function(e) {
                e.preventDefault();
                (0,sourcepoint_dist.openPrivacyManagerModal)();
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.FOOTER_INFO_PAGES */.U.FOOTER_INFO_PAGES,
                    nextPage: "open-tcf-dialog"
                });
            }
        },
        experts: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.experts) && {
            pathName: linkTo("experts"),
            title: t("footer", "link.experts"),
            id: "experts",
            follow: true
        },
        newsroom: newsroomLink[market.code] && {
            pathName: newsroomLink[market.code],
            title: t("footer", "link.newsroom"),
            id: "newsroom",
            follow: true
        },
        investorRelations: investorRelationsLink[market.code] && {
            pathName: investorRelationsLink[market.code],
            title: t("footer", "link.investor-relations"),
            id: "investorRelations",
            follow: true
        },
        blackFriday: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.blackFriday) && {
            pathName: "".concat(url === null || url === void 0 ? void 0 : url.campaigns, "/black-friday"),
            title: t("footer", "link.black-friday"),
            id: "blackFriday",
            follow: true
        },
        januarySales: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.januarySales) && {
            pathName: infoPageMap.januarySales,
            title: t("footer", "link.january-sales"),
            id: "januarySales",
            follow: true
        },
        bestDeals: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.bestDeals) && {
            pathName: infoPageMap.bestDeals,
            title: t("footer", "link.best-deals"),
            id: "bestDeals",
            follow: true
        },
        boxingDayDeals: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.boxingDayDeals) && {
            pathName: infoPageMap.boxingDayDeals,
            title: t("footer", "link.boxing-day-deals"),
            id: "boxingDayDeals",
            follow: true
        },
        registerShopInfo: driveTrafficLink[market.code] && {
            pathName: driveTrafficLink[market.code],
            title: t("footer", "link.register-shop-info"),
            id: "registerShopInfo",
            follow: false
        },
        whyPrisjakt: whyPrisjaktLink[market.code] && {
            pathName: whyPrisjaktLink[market.code],
            title: t("footer", "link.why-prisjakt"),
            id: "whyPrisjakt",
            follow: false
        },
        topProducts: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.topProducts) && {
            pathName: infoPageMap.topProducts,
            title: t("footer", "link.top-products"),
            id: "topProducts",
            follow: true
        },
        getStarted: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.getStarted) && {
            pathName: infoPageMap.getStarted,
            title: t("footer", "link.get-started"),
            id: "getStarted",
            follow: true
        },
        howWorks: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.howWorks) && {
            pathName: infoPageMap.howWorks,
            title: t("footer", "link.how-works"),
            id: "howWorks",
            follow: true
        },
        transparency: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.transparency) && {
            pathName: infoPageMap.transparency,
            title: t("footer", "link.transparency"),
            id: "transparency",
            follow: true
        },
        businessCenter: {
            pathName: market.sites.businessCenter,
            title: t("footer", "link.business-center"),
            id: "businessCenter",
            follow: false
        },
        termsOfUse: {
            pathName: termsOfUseLink[market.code],
            title: t("footer", "link.terms-of-use"),
            id: "termsOfUse",
            follow: false
        },
        hubs: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.hubs) && {
            pathName: infoPageMap.hubs,
            title: t("content-hub", "hubs-sitemap.title"),
            id: "hubs",
            follow: false
        },
        about: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.about) && {
            pathName: infoPageMap.about,
            title: t("footer", "link.info"),
            id: "about",
            follow: true
        },
        contact: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.contact) && {
            pathName: infoPageMap.contact,
            title: t("footer", "link.contact-us"),
            id: "contact",
            follow: true
        },
        userAgreement: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.userAgreement) && {
            pathName: infoPageMap.userAgreement,
            title: t("account", "signup.terms-conditions"),
            id: "userAgreement",
            follow: true
        },
        cookiePolicy: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.cookiePolicy) && {
            pathName: infoPageMap.cookiePolicy,
            title: t("footer", "link.cookie-policy"),
            id: "cookiePolicy",
            follow: true
        },
        privacyPolicy: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.privacyPolicy) && {
            pathName: infoPageMap.privacyPolicy,
            title: t("footer", "link.privacy-policy"),
            id: "privacyPolicy",
            follow: true
        },
        disclaimer: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.disclaimer) && {
            pathName: infoPageMap.disclaimer,
            title: t("footer", "link.disclaimer"),
            id: "disclaimer",
            follow: true
        }
    };
    // Add `pages` to `pageMap` with their IDs as keys
    if (pages && infoPageMap) {
        pages.nodes.forEach(function(page) {
            var name = Object.keys(infoPageMap).find(function(infoPageName) {
                return page.id === infoPageMap[infoPageName];
            });
            var id = name && infoPageMap[name];
            if (id) {
                pageMap[name] = page;
            }
        });
    }
    return pageMap;
};
var getFooterColumns = function(pageMap, t, market) {
    /*
   * If Schibsted used to be data controller. Do not show policy links in about pages.
   * Instead this information is accessible from the co-branding footer,
   * in those cases, for markets (FI, NO, DK). SE handled in getNewFooterColumns(...)
   */ var oldSchibstedPolicyMarketsRulesPages = _toConsumableArray(oldSchibstedPolicyMarkets.includes(market.code) ? [] : [
        pageMap.userAgreement,
        pageMap.disclaimer,
        pageMap.privacyPolicy,
        pageMap.cookiePolicy,
        pageMap.cookieSettings
    ]);
    var rulesPages = _toConsumableArray(oldSchibstedPolicyMarketsRulesPages).concat([
        pageMap.privacySettings
    ]);
    return [
        {
            title: t("footer", "pages.title"),
            pages: [
                pageMap.getStarted,
                pageMap.howWorks,
                pageMap.about,
                pageMap.contact,
                pageMap.advertiseOnPrisjakt,
                pageMap.whyPrisjakt,
                pageMap.registerShopInfo,
                pageMap.businessCenter,
                pageMap.supportPage
            ]
        }
    ].concat(_toConsumableArray(rulesPages.filter(function(i) {
        return i;
    }).length ? [
        {
            title: t("footer", "pages.rules-title"),
            pages: rulesPages
        }
    ] : []), [
        {
            title: t("footer", "pages.on-title"),
            pages: [
                pageMap.blackFriday,
                pageMap.bestDeals,
                pageMap.careers,
                pageMap.themes,
                pageMap.newsroom,
                pageMap.investorRelations,
                pageMap.articles,
                pageMap.shopOfTheYear,
                pageMap.shopOfTheYearForShops,
                pageMap.categoryIndex,
                pageMap.hubs,
                pageMap.promotions,
                pageMap.used,
                pageMap.topProducts,
                pageMap.experts,
                pageMap.expertLogin
            ]
        }
    ], _toConsumableArray(oldSchibstedPolicyMarkets.includes(market.code) ? [
        {
            title: t("footer", "column.terms-title"),
            pages: getTermsPages(pageMap)
        }
    ] : []));
};
/**
 * Only used for SE footer
 */ var getNewFooterColumns = function(pageMap, t) {
    return [
        {
            title: t("footer", "column.consumer-title"),
            pages: [
                pageMap.blackFriday,
                pageMap.getStarted,
                pageMap.howWorks,
                pageMap.articles,
                pageMap.experts,
                pageMap.themes,
                pageMap.shopOfTheYear,
                pageMap.categoryIndex,
                pageMap.hubs,
                pageMap.promotions,
                pageMap.used
            ]
        },
        {
            title: t("footer", "column.store-title"),
            pages: [
                pageMap.whyPrisjakt,
                pageMap.registerShopInfo,
                pageMap.advertiseOnPrisjakt,
                pageMap.shopOfTheYearForShops,
                pageMap.businessCenter
            ]
        },
        {
            title: t("footer", "column.about-us-title"),
            pages: [
                pageMap.about,
                pageMap.supportPage,
                pageMap.contact,
                pageMap.careers,
                pageMap.newsroom,
                pageMap.investorRelations,
                pageMap.expertLogin
            ]
        },
        {
            title: t("footer", "column.terms-title"),
            pages: getTermsPages(pageMap)
        }
    ];
};

// EXTERNAL MODULE: ./src/hooks/use-feedback.ts
var use_feedback = __webpack_require__(19265);
;// CONCATENATED MODULE: ./src/areas/footer/index.tsx













var footer_Footer = function(param) {
    var socialNetworks = param.socialNetworks, current = param.current, sites = param.sites, pages = param.pages, url = param.url, sidebarOpen = param.sidebarOpen;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market, infoPageMap = ref.market.infoPageMap, linkTo = ref.linkTo;
    var loadFeedback = (0,use_feedback/* useFeedback */.Z)().loadFeedback;
    var pageMap = getPageMap(infoPageMap, url, market, linkTo, t, pages);
    var infoPageColumns = market.code === "se" ? getNewFooterColumns(pageMap, t) : getFooterColumns(pageMap, t, market);
    return /*#__PURE__*/ react.createElement(Footer, {
        sidebarOpen: sidebarOpen
    }, /*#__PURE__*/ react.createElement(TopSection, null, /*#__PURE__*/ react.createElement(styles_Content, {
        sidebarOpen: sidebarOpen
    }, /*#__PURE__*/ react.createElement(NewsLetterIllustration, {
        src: "".concat(market.cdn, "/g/rfe/illustrations/newsletter-illustration-188x102px.png"),
        alt: "Footer newsletter illustration"
    }), /*#__PURE__*/ react.createElement(NewsletterSignup, {
        title: t("footer", "newsletter.title"),
        stacked: true,
        variant: "secondary"
    }))), /*#__PURE__*/ react.createElement(MidSection, null, /*#__PURE__*/ react.createElement(styles_Content, {
        sidebarOpen: sidebarOpen
    }, /*#__PURE__*/ react.createElement(Columns, null, pages && /*#__PURE__*/ react.createElement(info_pages, {
        columns: infoPageColumns
    }), /*#__PURE__*/ react.createElement(Download, null, /*#__PURE__*/ react.createElement(FeedbackButton, {
        onClick: loadFeedback,
        fullWidth: true,
        containerProps: {
            title: t("footer", "link.contact"),
            "data-test": "FeedbackButton"
        }
    }, /*#__PURE__*/ react.createElement(ButtonText, null, t("footer", "link.contact"))), /*#__PURE__*/ react.createElement(DownloadTitle, null, t("footer", "mobile-apps.title")), /*#__PURE__*/ react.createElement(DownloadIcons, {
        dangerouslySetInnerHTML: {
            __html: t("footer", "download.text.md")
        }
    }))))), /*#__PURE__*/ react.createElement(BottomSection, null, /*#__PURE__*/ react.createElement(styles_Content, {
        sidebarOpen: sidebarOpen
    }, /*#__PURE__*/ react.createElement(LogoWrapper, null, /*#__PURE__*/ react.createElement(styles_Logo, {
        styling: "v2-dark",
        market: market.code,
        companyName: t("meta", "site.name")
    }), /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        tablet: true,
        desktop: true
    }, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("p", null, t("footer", "info.copyright", {
        year: new Date().getFullYear()
    })))), /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true
    }, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("p", null, t("footer", "info.copyright", {
        year: new Date().getFullYear()
    }))))), /*#__PURE__*/ react.createElement(SocialIcons, null, socialNetworks.map(function(param) {
        var name = param.name, link = param.link;
        return link && /*#__PURE__*/ react.createElement(SocialIcon, {
            key: name,
            title: name,
            href: link,
            target: "_blank",
            rel: "noopener nofollow noreferrer"
        }, name === "instagram" && /*#__PURE__*/ react.createElement(social_media_instagram/* IconSocialMediaInstagram */.R, {
            size: 27,
            color: "base500"
        }), name === "facebook" && /*#__PURE__*/ react.createElement(social_media_facebook/* IconSocialMediaFacebook */.E, {
            size: 27,
            color: "base500"
        }), name === "twitter" && /*#__PURE__*/ react.createElement(social_media_twitter/* IconSocialMediaTwitter */.N, {
            size: 27,
            color: "base500"
        }));
    })), /*#__PURE__*/ react.createElement(styles_Sites, null, /*#__PURE__*/ react.createElement(change_market, {
        sites: sites,
        current: current
    })))));
};
var mapStateToProps = function(state) {
    return {
        socialNetworks: state.footer.socialNetworks,
        current: state.footer.current,
        sites: state.footer.sites,
        pages: state.globals.infoPages,
        url: state.footer.url,
        sidebarOpen: state.areas.sidebar.tab !== constants/* SIDEBAR_STATE.NONE */.$J.NONE
    };
};
/* harmony default export */ var footer = ((0,es/* connect */.$j)(mapStateToProps, {})(/*#__PURE__*/ (0,react.memo)(footer_Footer)));

// EXTERNAL MODULE: ./node_modules/.pnpm/redux@4.0.1/node_modules/redux/es/redux.js
var redux = __webpack_require__(59715);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/search-bar/index.tsx + 19 modules
var search_bar = __webpack_require__(87316);
// EXTERNAL MODULE: ./src/areas/search/actions/search.js
var search = __webpack_require__(47441);
// EXTERNAL MODULE: ./src/areas/navigation/actions/desktop.js
var desktop = __webpack_require__(72477);
// EXTERNAL MODULE: ./src/areas/navigation/actions/mobile-menu.js
var mobile_menu = __webpack_require__(92306);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/hideable/variants.js
var hideable_variants = __webpack_require__(28285);
// EXTERNAL MODULE: ./src/areas/navigation/components/mega-menu/index.tsx
var mega_menu = __webpack_require__(84330);
;// CONCATENATED MODULE: ./src/areas/navigation/shared/types.js
function types_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function types_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            types_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var string = (prop_types_default()).string, shape = (prop_types_default()).shape, arrayOf = (prop_types_default()).arrayOf;
var categoryShape = {
    id: string.isRequired,
    name: string,
    semantic_id: string
};
var categoryType = arrayOf(shape(types_objectSpread({
    children: arrayOf(shape(categoryShape))
}, categoryShape)));
/* harmony default export */ var types = (categoryType);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/floater/index.js
var floater = __webpack_require__(70413);
// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/components/content/index.tsx
var content = __webpack_require__(4923);
// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/actions/index.js
var actions = __webpack_require__(24726);
// EXTERNAL MODULE: ./src/areas/sidebar/tracking/index.ts
var sidebar_tracking = __webpack_require__(59909);
// EXTERNAL MODULE: ./src/components/overlay/index.tsx + 1 modules
var overlay = __webpack_require__(34879);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-mobile/styles.ts
function sidebar_mobile_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sidebar_mobile_styles_templateObject() {
    var data = sidebar_mobile_styles_taggedTemplateLiteral([
        "\n  && {\n    /* Cover the header so e.g. the search bar on the frontpage won't peek through */\n    z-index: ",
        ";\n  }\n"
    ]);
    sidebar_mobile_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sidebar_mobile_styles_templateObject1() {
    var data = sidebar_mobile_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  height: ",
        ";\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100vw;\n  z-index: ",
        ";\n"
    ]);
    sidebar_mobile_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sidebar_mobile_styles_templateObject2() {
    var data = sidebar_mobile_styles_taggedTemplateLiteral([
        "\n  /* Needed because ReactSwipe sets e.g. a child div to 2x the view width, for some reason */\n  width: 100vw;\n  max-height: 100vh;\n  overflow: hidden;\n"
    ]);
    sidebar_mobile_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Overlay = (0,react.memo)((0,styled_components_browser_esm["default"])(overlay/* default */.Z).withConfig({
    displayName: "Overlay",
    componentId: "sc-0-0"
})(sidebar_mobile_styles_templateObject(), zindex/* zindex.menu.mobile.overlay */.Y.menu.mobile.overlay));
var FakeHeader = (0,react.memo)((0,styled_components_browser_esm["default"])(hideable.Hideable).attrs({
    speed: ui/* Speed.Slow */.fD.Slow
}).withConfig({
    displayName: "FakeHeader",
    componentId: "sc-0-1"
})(sidebar_mobile_styles_templateObject1(), function(props) {
    return props.theme.header.bg;
}, base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem, zindex/* zindex.menu.header */.Y.menu.header));
var SlideLeftContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SlideLeftContainer",
    componentId: "sc-0-2"
})(sidebar_mobile_styles_templateObject2());

// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/constants.ts
var sidebar_mobile_constants = __webpack_require__(86178);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-mobile/index.tsx
function sidebar_mobile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || sidebar_mobile_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function sidebar_mobile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sidebar_mobile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sidebar_mobile_arrayLikeToArray(o, minLen);
}











var SidebarMobile = function(param) {
    var categories = param.categories, currentView = param.currentView, isAuthenticated = param.isAuthenticated, isTraversingUpwards = param.isTraversingUpwards, me = param.me, menuHistory = param.menuHistory, onClose = param.onClose, onMenuChange = param.onMenuChange, onSelectHistory = param.onSelectHistory, open = param.open, selectedList = param.selectedList, setMobileSidebarView = param.setMobileSidebarView, navigateFromMobileMenu = param.navigateFromMobileMenu;
    var ref = _slicedToArray((0,react.useState)(null), 2), previousCategory = ref[0], setPreviousCategory = ref[1];
    var ref1 = _slicedToArray((0,react.useState)("100vh"), 2), viewportHeight = ref1[0], setViewportHeight = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), draggableListsOnMobile = ref2[0], setDraggableListsOnMobile = ref2[1];
    var visible = open && categories && categories.length > 0;
    var currentCategory = menuHistory[menuHistory.length - 1];
    var parentCategory = menuHistory[menuHistory.length - 2];
    (0,react.useEffect)(function() {
        var updateViewportHeight = function() {
            if (false) {}
            // On mobile `vh` does not take browser UI into consideration,
            // causing 100vh to be higher than what is visible.
            // `window.innerHeight` is the actual visible height of the window
            // and will be updated every render.
            setViewportHeight("".concat(window.innerHeight, "px"));
        };
        window.addEventListener("resize", updateViewportHeight);
        updateViewportHeight();
        return function() {
            return window.removeEventListener("resize", updateViewportHeight);
        };
    }, [
        setViewportHeight
    ]);
    var changeMenuLevel = (0,react.useCallback)(function(category) {
        setPreviousCategory(currentCategory);
        onMenuChange({
            categories: category.children,
            parent: category
        });
    }, [
        currentCategory,
        onMenuChange,
        setPreviousCategory
    ]);
    var openParentCategory = (0,react.useCallback)(function() {
        if (parentCategory) {
            setPreviousCategory(currentCategory);
            onSelectHistory(parentCategory.id);
        }
    }, [
        currentCategory,
        onSelectHistory,
        parentCategory
    ]);
    var toggleDraggable = (0,react.useCallback)(function() {
        setDraggableListsOnMobile(!draggableListsOnMobile);
    }, [
        draggableListsOnMobile
    ]);
    var openView = (0,react.useCallback)(function(view) {
        (0,sidebar_tracking/* trackOpeningSidebar */.b)(view);
        setDraggableListsOnMobile(false);
        setMobileSidebarView(view);
    }, [
        setDraggableListsOnMobile,
        setMobileSidebarView
    ]);
    var openRootView = (0,react.useCallback)(function() {
        return openView(sidebar_mobile_constants/* VIEWS.ROOT */.n.ROOT);
    }, [
        openView
    ]);
    var closeMenu = (0,react.useCallback)(function() {
        setPreviousCategory(null);
        onClose();
    }, [
        onClose,
        setPreviousCategory
    ]);
    var closeMenuAndResetState = (0,react.useCallback)(function() {
        closeMenu();
        setMobileSidebarView(sidebar_mobile_constants/* VIEWS.ROOT */.n.ROOT);
    }, [
        closeMenu,
        setMobileSidebarView
    ]);
    var logoutClick = (0,react.useCallback)(function() {
        (0,sidebar_tracking/* trackClosingSidebar */.D)(currentView, "MobileLogoutButton");
        closeMenuAndResetState();
    }, [
        closeMenuAndResetState,
        currentView
    ]);
    var swipeOptions = (0,react.useMemo)(function() {
        return {
            continuous: false,
            transitionEnd: function(index) {
                // Close menu on swipe away
                if (index > 0) {
                    (0,sidebar_tracking/* trackClosingSidebar */.D)(currentView, "MobileSwipeToClose");
                    closeMenuAndResetState();
                }
            }
        };
    }, [
        closeMenuAndResetState,
        currentView
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Overlay, {
        active: visible
    }), /*#__PURE__*/ react.createElement(FakeHeader, {
        visible: visible
    }), /*#__PURE__*/ react.createElement(floater.Floater, {
        zIndex: zindex/* zindex.menu.mobile.overlay */.Y.menu.mobile.overlay,
        positioning: floater.Positioning.Fixed
    }, /*#__PURE__*/ react.createElement(hideable_variants.SlideLeft, {
        visible: visible,
        container: SlideLeftContainer
    }, /*#__PURE__*/ react.createElement(content/* default */.Z, {
        swipeOptions: swipeOptions,
        visible: visible,
        draggableOnMobile: draggableListsOnMobile,
        viewportHeight: viewportHeight,
        closeMenuAndResetState: closeMenuAndResetState,
        currentView: currentView,
        previousCategory: previousCategory,
        currentCategory: currentCategory,
        closeMenu: closeMenu,
        openView: openView,
        isAuthenticated: isAuthenticated,
        me: me,
        openParentCategory: openParentCategory,
        changeMenuLevel: changeMenuLevel,
        isTraversingUpwards: isTraversingUpwards,
        menuHistory: menuHistory,
        toggleMobileDraggable: toggleDraggable,
        selectedList: selectedList,
        onClose: onClose,
        openRootView: openRootView,
        logoutClick: logoutClick,
        navigateFromMobileMenu: navigateFromMobileMenu
    }))));
};
var sidebar_mobile_mapStateToProps = function(state) {
    return {
        selectedList: state.areas.sidebar.selectedList,
        me: state.areas.account.me,
        isAuthenticated: state.areas.account.isAuthenticated,
        currentView: state.areas.mobileSidebar.currentView
    };
};
var dispatchProps = {
    setMobileSidebarView: actions/* setMobileSidebarView */.E,
    navigateFromMobileMenu: mobile_menu/* default.navigateFromMobileMenu */.ZP.navigateFromMobileMenu
};
/* harmony default export */ var sidebar_mobile = ((0,es/* connect */.$j)(sidebar_mobile_mapStateToProps, dispatchProps)(SidebarMobile));

;// CONCATENATED MODULE: ./src/areas/navigation/mobile-navigation.js







var MobileNavigation = function(props) {
    var open = props.open, history = props.history, isTraversingUpwards = props.isTraversingUpwards, categories = props.categories, closeMenu = props.closeMenu, changeCategories = props.changeCategories, selectHistory = props.selectHistory;
    return /*#__PURE__*/ react.createElement(sidebar_mobile, {
        onClose: closeMenu,
        menuHistory: history,
        onSelectHistory: selectHistory,
        categories: categories,
        isTraversingUpwards: isTraversingUpwards,
        onMenuChange: changeCategories,
        open: open
    });
};
var func = (prop_types_default()).func, bool = (prop_types_default()).bool;
MobileNavigation.propTypes = {
    open: bool,
    history: types,
    isTraversingUpwards: bool,
    categories: types,
    closeMenu: func,
    navigateFromMobileMenu: func,
    selectHistory: func,
    changeCategories: func,
    showSidebar: bool
};
MobileNavigation.defaultProps = {
    open: false,
    history: [],
    isTraversingUpwards: false,
    categories: [],
    closeMenu: base/* noop */.ZT,
    navigateFromMobileMenu: base/* noop */.ZT,
    selectHistory: base/* noop */.ZT,
    changeCategories: base/* noop */.ZT,
    showSidebar: false
};
var mobile_navigation_mapStateToProps = function(state) {
    return {
        open: state.areas.navigation.mobileMenu.open,
        history: state.areas.navigation.mobileMenu.history,
        isTraversingUpwards: state.areas.navigation.mobileMenu.isTraversingUpwards,
        categories: state.areas.navigation.mobileMenu.categories
    };
};
var mobile_navigation_dispatchProps = {
    closeMenu: mobile_menu/* default.closeMenu */.ZP.closeMenu,
    changeCategories: mobile_menu/* default.changeCategories */.ZP.changeCategories,
    selectHistory: mobile_menu/* default.selectHistory */.ZP.selectHistory
};
/* harmony default export */ var mobile_navigation = ((0,es/* connect */.$j)(mobile_navigation_mapStateToProps, mobile_navigation_dispatchProps)(MobileNavigation));

// EXTERNAL MODULE: ./src/components/no-scroll/index.tsx
var no_scroll = __webpack_require__(83464);
// EXTERNAL MODULE: ./src/components/outside-click-tracker/index.js + 1 modules
var outside_click_tracker = __webpack_require__(69790);
;// CONCATENATED MODULE: ./src/areas/navigation/styles.ts
/* eslint-disable import/prefer-default-export */ function navigation_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function navigation_styles_templateObject() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n  height: calc(100vh - ",
        ");\n  top: ",
        ";\n  position: fixed;\n  width: 100%;\n  /* Should be above sidebar */\n  z-index: ",
        ";\n"
    ]);
    navigation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function navigation_styles_templateObject1() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n  max-width: 1250px;\n  margin-left: auto;\n  margin-right: auto;\n\n  ul {\n    margin: 0;\n    list-style-type: none;\n  }\n"
    ]);
    navigation_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function navigation_styles_templateObject2() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    navigation_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function navigation_styles_templateObject3() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n  flex: 0 0 100%;\n  position: fixed;\n  background: ",
        ";\n  width: 100%;\n  max-height: 80vh;\n  overflow: hidden;\n  z-index: ",
        ";\n\n  ",
        ";\n"
    ]);
    navigation_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function navigation_styles_templateObject4() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n  flex: 0 0 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ",
        ";\n  opacity: 0.9;\n\n  transition: opacity 0.1s ease;\n  visibility: visible;\n  position: fixed;\n  z-index: 9;\n"
    ]);
    navigation_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var NudgedBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NudgedBox",
    componentId: "sc-0-0"
})(navigation_styles_templateObject(), base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, zindex/* zindex.menu.mega */.Y.menu.mega);
var Navigation = styled_components_browser_esm["default"].nav.withConfig({
    displayName: "Navigation",
    componentId: "sc-0-1"
})(navigation_styles_templateObject1());
var NavigationWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NavigationWrapper",
    componentId: "sc-0-2"
})(navigation_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.bg.primary;
}, zindex/* zindex.menu.mega */.Y.menu.mega + 1, base/* media.mediumDown */.BC.mediumDown(navigation_styles_templateObject2()));
var styles_Overlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Overlay",
    componentId: "sc-0-3"
})(navigation_styles_templateObject4(), function(p) {
    return p.theme.bg.overlay;
});

;// CONCATENATED MODULE: ./src/areas/navigation/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function navigation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function navigation_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            navigation_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function navigation_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function navigation_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        navigation_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}















var NavigationMenu = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(NavigationMenu, _PureComponent);
    var _super = _createSuper(NavigationMenu);
    function NavigationMenu(props) {
        _classCallCheck(this, NavigationMenu);
        var _this;
        _this = _super.call(this, props);
        navigation_defineProperty(_assertThisInitialized(_this), "changeMegaMenuCategory", function(openCategory) {
            _this.props.changeCategory({
                openCategory: openCategory
            });
        });
        navigation_defineProperty(_assertThisInitialized(_this), "closeMegaMenu", function() {
            // Trigger redux action to change the state
            _this.props.toggleMenu({
                open: false
            });
            // Callback for side effects in parent component
            _this.props.onCloseMegaMenu();
        });
        navigation_defineProperty(_assertThisInitialized(_this), "openCategoryLink", function(categoryId) {
            _this.props.openCategoryLink({
                categoryId: categoryId
            });
        });
        _this.state = {
            fullTree: false
        };
        return _this;
    }
    _createClass(NavigationMenu, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var market = this.context.market;
                fetch("/_internal/menu-tree", {
                    credentials: "include"
                }).then(function(res) {
                    return res.json();
                }).then(function(data) {
                    var categories = data.items;
                    var sortedCategories = categories.slice()// Sort mega menu categories by name on the top level
                    .sort(function(a, b) {
                        return a.name.localeCompare(b.name, market.locale.replace("_", "-"));
                    });
                    _this.props.setInitialMobileMenuData(categories);
                    _this.setState({
                        fullTree: true,
                        sortedCategories: sortedCategories
                    });
                    // Open the first category in mega menu by default
                    _this.changeMegaMenuCategory(sortedCategories[0].id);
                }).catch(function(err) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, openCategory = _props.openCategory, open = _props.open;
                var _state = this.state, sortedCategories = _state.sortedCategories, fullTree = _state.fullTree;
                return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
                    mobile: true,
                    tablet: true
                }, /*#__PURE__*/ react.createElement(mobile_navigation, null)), /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
                    desktop: true
                }, /*#__PURE__*/ react.createElement(hideable_variants.NudgeUp, {
                    visible: open,
                    container: NudgedBox
                }, /*#__PURE__*/ react.createElement(outside_click_tracker/* default */.Z, {
                    onClickOutside: this.closeMegaMenu,
                    onEscapeKey: this.closeMegaMenu
                }, /*#__PURE__*/ react.createElement(NavigationWrapper, null, sortedCategories && /*#__PURE__*/ react.createElement(mega_menu/* default */.Z, {
                    openCategoryId: fullTree ? openCategory : null,
                    categories: sortedCategories,
                    onOpenCategory: this.changeMegaMenuCategory,
                    onClose: this.closeMegaMenu,
                    onOpenCategoryLink: this.openCategoryLink
                })))), /*#__PURE__*/ react.createElement(overlay/* default */.Z, {
                    active: open
                }), /*#__PURE__*/ react.createElement(no_scroll/* default */.Z, {
                    enabled: open
                })));
            }
        }
    ]);
    return NavigationMenu;
}(react.PureComponent);
var navigation_bool = (prop_types_default()).bool, navigation_func = (prop_types_default()).func, navigation_shape = (prop_types_default()).shape, navigation_string = (prop_types_default()).string, navigation_arrayOf = (prop_types_default()).arrayOf, node = (prop_types_default()).node;
NavigationMenu.propTypes = {
    openCategory: navigation_string,
    open: navigation_bool,
    toggleMenu: navigation_func,
    setInitialMobileMenuData: navigation_func,
    rootCategories: navigation_arrayOf(navigation_shape({
        id: navigation_string,
        name: navigation_string,
        semantic_id: navigation_string
    })),
    outsiderTrackContent: node,
    changeCategory: navigation_func,
    openCategoryLink: navigation_func,
    onCloseMegaMenu: navigation_func
};
NavigationMenu.defaultProps = {
    openCategory: null,
    open: false,
    rootCategories: undefined,
    outsiderTrackContent: undefined,
    changeCategory: base/* noop */.ZT,
    openCategoryLink: base/* noop */.ZT,
    onCloseMegaMenu: base/* noop */.ZT,
    toggleMenu: base/* noop */.ZT,
    setInitialMobileMenuData: base/* noop */.ZT
};
NavigationMenu.contextType = app_context/* AppContext */.Il;
/* harmony default export */ var navigation = ((0,es/* connect */.$j)(function(state) {
    return state.areas.navigation.megaMenu;
}, navigation_objectSpreadProps(navigation_objectSpread({}, desktop/* default */.ZP), {
    setInitialMobileMenuData: mobile_menu/* default.setInitialData */.ZP.setInitialData
}))(NavigationMenu));

// EXTERNAL MODULE: ./src/areas/navigation/components/mobile-menu-button/index.tsx + 1 modules
var mobile_menu_button = __webpack_require__(6951);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/lists.js
var lists = __webpack_require__(96805);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(60738);
;// CONCATENATED MODULE: ./src/areas/account/menu/styles.ts
function menu_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_styles_templateObject() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  &:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_styles_templateObject1() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function menu_styles_templateObject2() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  display: block;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function menu_styles_templateObject3() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    menu_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function menu_styles_templateObject4() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  align-items: center;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function menu_styles_templateObject5() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  width: 40px;\n  height: 40px;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function menu_styles_templateObject6() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  background: none;\n  overflow: visible;\n\n  &:hover {\n    background: none;\n  }\n\n  img {\n    max-width: none;\n  }\n"
    ]);
    menu_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var StyledOutlinedButton = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).withConfig({
    displayName: "StyledOutlinedButton",
    componentId: "sc-0-0"
})(menu_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SignupLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "SignupLink",
    componentId: "sc-0-1"
})(menu_styles_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});
var MenuItemLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "MenuItemLink",
    componentId: "sc-0-2"
})(menu_styles_templateObject2(), function(p) {
    return p.theme.text.callToActionHover;
});
var ProfileLinks = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "ProfileLinks",
    componentId: "sc-0-3"
})(menu_styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var AnalyticsWrapper = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "AnalyticsWrapper",
    componentId: "sc-0-4"
})(menu_styles_templateObject4(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var DropdownToggle = (0,styled_components_browser_esm["default"])(dropdown/* DropdownToggle */.Z_).withConfig({
    displayName: "DropdownToggle",
    componentId: "sc-0-5"
})(menu_styles_templateObject5(), function(p) {
    return p.theme.colors.informative700;
}, function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return base/* colorUtils.shadeColor */.$n.shadeColor(p.theme.buttons.primary.bg, -20);
});
var UserAvatar = (0,styled_components_browser_esm["default"])(user_avatar/* UserAvatar */.Y).attrs(function() {
    return {
        size: 34
    };
}).withConfig({
    displayName: "UserAvatar",
    componentId: "sc-0-6"
})(menu_styles_templateObject6());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
;// CONCATENATED MODULE: ./src/areas/account/menu/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}












var AccountMenu = function(param) {
    var style = param.style, className = param.className, closeLists = param.closeLists, selectList = param.selectList, me = param.me;
    var ref;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref1.t, market = ref1.market;
    var logout = (0,use_account/* useAccount */.m)().logout;
    var onLogout = (0,react.useCallback)(function() {
        selectList(null);
        closeLists();
        if (market.login.enabled) {
            (0,data_layer/* pushEvent */.A)("logoutComplete", {
                loggedIn: false
            });
            logout();
        }
    }, [
        selectList,
        closeLists,
        market.login.enabled,
        logout
    ]);
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        className: className,
        style: style,
        closeOnItemClick: true
    }, /*#__PURE__*/ react.createElement(DropdownToggle, {
        onlyIcon: true,
        type: ui_button.ButtonType.TEXT,
        size: ui_button.ButtonSize.MEDIUM
    }, /*#__PURE__*/ react.createElement(UserAvatar, _extends({}, me, {
        avatar: (ref = me.schibstedProfile) === null || ref === void 0 ? void 0 : ref.avatar
    }))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        width: 200,
        alignment: ui/* Direction.Right */.Nm.Right
    }, /*#__PURE__*/ react.createElement(ProfileLinks, {
        gap: 1
    }, /*#__PURE__*/ react.createElement(MenuItemLink, {
        to: "/account/profile"
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("account", "profile.title"))), /*#__PURE__*/ react.createElement(MenuItemLink, {
        to: "/account/profile/settings"
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("account", "menu.settings"))), /*#__PURE__*/ react.createElement(StyledOutlinedButton, {
        fullWidth: true,
        onClick: onLogout
    }, t("account", "menu.logout-button")))));
};
var menu_mapStateToProps = function(state) {
    return {
        me: state.areas.account.me
    };
};
var dispatchActions = {
    closeLists: lists/* closeLists */.c,
    selectList: lists/* selectList */.Fz
};
/* harmony default export */ var menu = ((0,es/* connect */.$j)(menu_mapStateToProps, dispatchActions)(AccountMenu));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/categories/index.js
var categories = __webpack_require__(39093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(56853);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(83830);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/clickable/index.js
var ui_clickable = __webpack_require__(42007);
;// CONCATENATED MODULE: ./src/areas/header/styles.ts
function header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_styles_templateObject() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    height: ",
        ";\n  "
    ]);
    header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_styles_templateObject1() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 0;\n  height: ",
        ";\n  ",
        "\n  z-index: ",
        ";\n"
    ]);
    header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_styles_templateObject2() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    background: transparent;\n    height: auto;\n    max-height: ",
        ";\n\n    ::before {\n      background: ",
        ";\n      content: '';\n      display: block;\n      height: ",
        ";\n      left: -50px;\n      position: absolute;\n      right: 0;\n      top: 0;\n      z-index: -1;\n    }\n  "
    ]);
    header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_styles_templateObject3() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  background: ",
        ";\n  width: 100%;\n  position: sticky;\n  top: 0;\n  height: ",
        ";\n  /* Should be above mega menu */\n\n  ",
        "\n"
    ]);
    header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_styles_templateObject4() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    height: ",
        ";\n  "
    ]);
    header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_styles_templateObject5() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    justify-content: flex-start;\n  "
    ]);
    header_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_styles_templateObject6() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-items: stretch;\n  width: 100%;\n  max-width: ",
        "px;\n  height: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  /* Should be above SlidingBox */\n  z-index: 2;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    header_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function header_styles_templateObject7() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  height: 100%;\n"
    ]);
    header_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    width: 100px;\n  "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 50px;\n  height: 100%;\n  ",
        "\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n  width: auto;\n\n  ",
        ";\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  height: ",
        ";\n  flex-grow: 0;\n\n  ",
        "\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: block;\n  height: 100%;\n  width: ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  transition:\n    background-color 0.1s linear,\n    color 0.1s linear;\n\n  &:hover,\n  &.focus-visible {\n    background: ",
        ";\n  }\n\n  /* Double selector to override aggressive user-agent styles in e.g. Firefox */\n  &:focus:focus {\n    outline: none;\n  }\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  fill: currentColor;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  fill: currentColor;\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    max-width: 200px;\n  "
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    height: ",
        ";\n    width: auto;\n  "
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  ",
        '\n\n  /* Special case for a certain interval of viewport widths where we set this whole column as fixed position and aligned to the left.\n     This is because we want the mega menu button to align with the sidebar, but it also has to play nicely with the logo when they "collide".\n     See also the Wrapper component which adds a pseudo-element at this same interval to reserve space for the column. */\n  @media screen and (min-width: ',
        "px) and (max-width: ",
        "px) {\n    left: 0;\n    height: ",
        ";\n  }\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    margin-left: 0;\n  "
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = header_styles_taggedTemplateLiteral([
        "\n      height: ",
        ";\n    "
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = header_styles_taggedTemplateLiteral([
        "\n      height: ",
        ";\n    "
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  padding: 0 10px;\n\n  ",
        ";\n\n  img {\n    height: ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  }\n\n  &.focus-visible {\n    background: ",
        ";\n    outline: none;\n  }\n"
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    flex: 0 0 50px;\n    width: auto;\n  "
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function styles_templateObject25() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    flex-grow: 1;\n  "
    ]);
    styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function styles_templateObject26() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    justify-content: flex-end;\n  "
    ]);
    styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function styles_templateObject27() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  width: auto;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function styles_templateObject28() {
    var data = header_styles_taggedTemplateLiteral([
        "\n      display: none;\n    "
    ]);
    styles_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function styles_templateObject29() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    ",
        "\n\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n    margin-left: ",
        ";\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.4px;\n    max-width: 120px;\n    margin-right: ",
        ";\n  "
    ]);
    styles_templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function styles_templateObject30() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  fill: currentColor;\n"
    ]);
    styles_templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function styles_templateObject31() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    /* Needed in order to bring the search box closer to center when there is no login button. */\n    min-width: ",
        "};\n  "
    ]);
    styles_templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function styles_templateObject32() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function styles_templateObject33() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-right: ",
        ";\n  margin-left: auto;\n  position: relative;\n  ",
        "\n\n  > :not(:last-child) {\n    margin-right: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    styles_templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function styles_templateObject34() {
    var data = header_styles_taggedTemplateLiteral([
        ""
    ]);
    styles_templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = header_styles_taggedTemplateLiteral([
        "\n    height: 0;\n    width: 0;\n    overflow: hidden;\n    position: absolute;\n  "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1;\n  margin: 0 50px;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}









var logoHeight = {
    small: "30px",
    medium: "35px",
    large: "38px"
};
var height = {
    desktop: base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem,
    mobile: base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem,
    mobileWithSearch: base/* layout.headerHeight.mobileWithSearch.rem */.bK.headerHeight.mobileWithSearch.rem
};
var headerMaxWidth = base/* layout.pageContent.maxWidth */.bK.pageContent.maxWidth;
// The viewport width above which the collapsed sidebar no longer occupies the same horizontal area as the header content
var sidebarOutsideHeaderWidth = headerMaxWidth.value + base/* layout.sidebarMenuWidth.desktop.value */.bK.sidebarMenuWidth.desktop.value * 2;
var mobileHeaderHeight = function(param) {
    var mobileSearchOpen = param.mobileSearchOpen;
    return mobileSearchOpen ? base/* layout.headerHeight.mobileWithSearch.value */.bK.headerHeight.mobileWithSearch.value : base/* layout.headerHeight.mobile.value */.bK.headerHeight.mobile.value;
};
var FixedMargin = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FixedMargin",
    componentId: "sc-0-0"
})(function(props) {
    return [
        {
            display: props.theme.layout === "raw-mobile" ? "none" : "block",
            height: height.desktop,
            transition: "height 300ms ease",
            willChange: "height"
        },
        base/* media.smallOnly */.BC.smallOnly({
            height: (0,base/* remCalc */.vR)(mobileHeaderHeight(props))
        })
    ];
});
var HeaderWrapper = styled_components_browser_esm["default"].header.withConfig({
    displayName: "HeaderWrapper",
    componentId: "sc-0-1"
})(header_styles_templateObject1(), height.desktop, base/* media.smallOnly */.BC.smallOnly(header_styles_templateObject(), height.mobile), zindex/* zindex.menu.header */.Y.menu.header);
var HeaderBar = styled_components_browser_esm["default"].header.attrs({
    "data-test": "Header"
}).withConfig({
    displayName: "HeaderBar",
    componentId: "sc-0-2"
})(header_styles_templateObject3(), function(p) {
    return p.theme.header.bg;
}, height.desktop, base/* media.smallOnly */.BC.smallOnly(header_styles_templateObject2(), base/* layout.headerHeight.mobileWithSearch.rem */.bK.headerHeight.mobileWithSearch.rem, function(p) {
    return p.theme.header.bg;
}, base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem));
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-3"
})(header_styles_templateObject6(), headerMaxWidth.value + base/* layout.sidebarMenuWidth.desktop.value */.bK.sidebarMenuWidth.desktop.value, base/* media.smallOnly */.BC.smallOnly(header_styles_templateObject4(), height.mobile), base/* media.mediumOnly */.BC.mediumOnly(header_styles_templateObject5()));
var columnStyles = (0,styled_components_browser_esm.css)(header_styles_templateObject7());
var MenuItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MenuItem",
    componentId: "sc-0-4"
})(styles_templateObject9(), function(props) {
    return props.wideOnTablet && base/* media.mediumOnly */.BC.mediumOnly(styles_templateObject8());
});
var MenuColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MenuColumn",
    componentId: "sc-0-5"
})(styles_templateObject11(), columnStyles, base/* media.largeUp */.BC.largeUp(styles_templateObject10()));
var MegaMenuItem = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "MegaMenuItem",
    componentId: "sc-0-6"
})(styles_templateObject13(), height.desktop, base/* media.mediumDown */.BC.mediumDown(styles_templateObject12()));
var MegaMenuButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "MegaMenuButton",
    componentId: "sc-0-7"
})(styles_templateObject14(), base/* layout.sidebarMenuWidth.desktop.rem */.bK.sidebarMenuWidth.desktop.rem, function(p) {
    return p.active ? "white" : "transparent";
}, function(p) {
    return p.active ? p.theme.icons.callToAction : p.theme.header.fg;
}, function(p) {
    return p.active ? "white" : p.theme.buttons.primary.bg;
});
var MegaMenuIcon = (0,styled_components_browser_esm["default"])(categories/* IconCategories */.L).attrs(function(p) {
    return {
        color: p.theme.header.fg
    };
}).withConfig({
    displayName: "MegaMenuIcon",
    componentId: "sc-0-8"
})(styles_templateObject15());
var CloseMegaMenuIcon = (0,styled_components_browser_esm["default"])(icon_close.IconClose).attrs(function(p) {
    return {
        color: p.theme.colors.maybeBlue700
    };
}).withConfig({
    displayName: "CloseMegaMenuIcon",
    componentId: "sc-0-9"
})(styles_templateObject16());
var LogoColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LogoColumn",
    componentId: "sc-0-10"
})(styles_templateObject19(), columnStyles, headerMaxWidth.value, sidebarOutsideHeaderWidth, height.desktop, base/* media.mediumOnly */.BC.mediumOnly(styles_templateObject17()), base/* media.smallOnly */.BC.smallOnly(styles_templateObject18(), height.mobile));
var LogoLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "LogoLink",
    componentId: "sc-0-11"
})(styles_templateObject23(), base/* media.showOutsiderAd */.BC.showOutsiderAd(styles_templateObject20()), logoHeight.small, base/* media.mediumUp */.BC.mediumUp(styles_templateObject21(), logoHeight.medium), base/* media.largeUp */.BC.largeUp(styles_templateObject22(), logoHeight.large), function(p) {
    return p.theme.buttons.primary.bg;
});
var RightColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RightColumn",
    componentId: "sc-0-12"
})(styles_templateObject27(), columnStyles, base/* media.smallOnly */.BC.smallOnly(styles_templateObject24()), base/* media.mediumOnly */.BC.mediumOnly(styles_templateObject25()), base/* media.mediumDown */.BC.mediumDown(styles_templateObject26()));
var PromoText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PromoText",
    componentId: "sc-0-13"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject29(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject28()), props.theme.colors.base0, base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var SearchIcon = (0,styled_components_browser_esm["default"])(magnifier/* IconMagnifier */.j).attrs(function(p) {
    return {
        color: p.theme.header.fg
    };
}).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-14"
})(styles_templateObject30(), function(p) {
    return p.theme.header.fg;
});
var UserArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserArea",
    componentId: "sc-0-15"
})(styles_templateObject33(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.largeUp */.BC.largeUp(styles_templateObject31(), (0,base/* remCalc */.vR)(96)), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(styles_templateObject32()));
var MagnifyerButton = (0,styled_components_browser_esm["default"])(ui_clickable.Clickable).withConfig({
    displayName: "MagnifyerButton",
    componentId: "sc-0-16"
})(styles_templateObject34());
var SearchBarWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchBarWrapper",
    componentId: "sc-0-17"
})(_templateObject36(), base/* media.smallOnly */.BC.smallOnly(_templateObject35()));

;// CONCATENATED MODULE: ./src/areas/header/index.tsx
function header_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function header_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function header_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function header_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function header_slicedToArray(arr, i) {
    return header_arrayWithHoles(arr) || header_iterableToArrayLimit(arr, i) || header_unsupportedIterableToArray(arr, i) || header_nonIterableRest();
}
function header_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return header_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return header_arrayLikeToArray(o, minLen);
}























var Header = function(param) {
    var mobileMenuOpen = param.mobileMenuOpen, _megaMenuOpen = param.megaMenuOpen, megaMenuOpen = _megaMenuOpen === void 0 ? false : _megaMenuOpen, toggleMenu = param.toggleMenu, closeMobileMenu = param.closeMobileMenu, isAuthenticated = param.isAuthenticated;
    var megaMenuButtonRef = (0,react.useRef)(null);
    var pathname = (0,react_router/* useLocation */.TH)().pathname;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var ref1 = header_slicedToArray((0,react.useState)(false), 2), showMobileSearchIcon = ref1[0], setShowMobileSearchIcon = ref1[1];
    var ref2 = header_slicedToArray((0,react.useState)(false), 2), showSearchBar = ref2[0], setShowSearchBar = ref2[1];
    var toggleMegaMenu = (0,react.useCallback)(function(e) {
        // Prevent event from triggering an "outside click" for the menu
        e.stopPropagation();
        toggleMenu({
            open: !megaMenuOpen
        });
    }, [
        toggleMenu,
        megaMenuOpen
    ]);
    var onCloseMegaMenu = (0,react.useCallback)(function() {
        if (megaMenuButtonRef.current) {
            megaMenuButtonRef.current.focus();
        }
    }, []);
    var sendFocusSearchEvent = function() {
        var el = document.getElementById("app-layout");
        var ref;
        window.scrollTo({
            top: (ref = el === null || el === void 0 ? void 0 : el.offsetTop) !== null && ref !== void 0 ? ref : 0
        });
        setTimeout(function() {
            var event = new CustomEvent("focus-search-event", {
                detail: {
                    focus: true
                }
            });
            dispatchEvent(event);
        }, 60);
    };
    var mobileSearchIconScrollHandler = function() {
        var scrollYPosition = 200;
        // Hide the search icon initially on the mobile startpage, and show it after scrolling past the hero search bar.
        if (window.scrollY >= scrollYPosition) setShowMobileSearchIcon(true);
        if (window.scrollY < scrollYPosition) setShowMobileSearchIcon(false);
    };
    (0,react.useEffect)(function() {
        var isFirstPage = pathname === "/";
        if (isFirstPage && isMobile) {
            // Hide the search bar on the mobile startpage. Only hero search bar should be visible there.
            setShowSearchBar(false);
            setShowMobileSearchIcon(false);
            // Scroll event listener for showing the search icon on the mobile startpage.
            window.addEventListener("scroll", mobileSearchIconScrollHandler);
        } else {
            setShowSearchBar(true);
            setShowMobileSearchIcon(true);
        }
        return function() {
            return window.removeEventListener("scroll", mobileSearchIconScrollHandler);
        };
    }, [
        isMobile,
        pathname
    ]);
    var menuButtonTitle = megaMenuOpen ? t("symbols", "symbol.close") : t("header", "categories.title");
    var login = (0,use_account/* useAccount */.m)().login;
    var loginButtonOnClick = function() {
        (0,data_layer/* pushEvent */.A)("login", {
            loggedIn: true
        });
        login();
    };
    return /*#__PURE__*/ react.createElement(HeaderWrapper, null, /*#__PURE__*/ react.createElement(HeaderBar, null, /*#__PURE__*/ react.createElement(MegaMenuItem, {
        title: menuButtonTitle,
        placement: ui/* Direction.Right */.Nm.Right
    }, /*#__PURE__*/ react.createElement(MegaMenuButton, {
        type: "button",
        onClick: toggleMegaMenu,
        "aria-label": menuButtonTitle,
        active: megaMenuOpen,
        "aria-expanded": megaMenuOpen,
        "aria-haspopup": true,
        ref: megaMenuButtonRef,
        "data-test": "MegaMenuToggleButton"
    }, megaMenuOpen ? /*#__PURE__*/ react.createElement(CloseMegaMenuIcon, {
        size: 30
    }) : /*#__PURE__*/ react.createElement(MegaMenuIcon, {
        size: 30
    }))), /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(MenuColumn, {
        "data-test": "MobileMenuColumn"
    }, /*#__PURE__*/ react.createElement(MenuItem, null, /*#__PURE__*/ react.createElement(mobile_menu_button/* default */.Z, null))), /*#__PURE__*/ react.createElement(LogoColumn, null, /*#__PURE__*/ react.createElement(LogoLink, {
        to: "/",
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.LOGO */.U.LOGO,
                nextPage: "/"
            });
            if (mobileMenuOpen) {
                closeMobileMenu();
            }
        }
    }, /*#__PURE__*/ react.createElement(Logo, {
        market: market.code,
        companyName: t("meta", "market.logo-alt"),
        styling: "v2-light"
    }))), showSearchBar ? /*#__PURE__*/ react.createElement(SearchBarWrapper, null, /*#__PURE__*/ react.createElement(search_bar/* SearchBar */.E, {
        initialFocus: true
    })) : null, /*#__PURE__*/ react.createElement(RightColumn, null, /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true
    }, /*#__PURE__*/ react.createElement(MenuItem, null, /*#__PURE__*/ react.createElement(hideable.Hideable, {
        visible: showMobileSearchIcon
    }, /*#__PURE__*/ react.createElement(MagnifyerButton, {
        "aria-label": t("header", "search.button"),
        onClick: sendFocusSearchEvent
    }, /*#__PURE__*/ react.createElement(SearchIcon, {
        size: 30
    }))))), market.login.enabled && /*#__PURE__*/ react.createElement(UserArea, null, isAuthenticated ? /*#__PURE__*/ react.createElement(menu, null) : /*#__PURE__*/ react.createElement(variants.TonalButton, {
        container: clickable/* Clickable */.P,
        tone: variants.ButtonTone.DARK,
        onClick: loginButtonOnClick
    }, t("account", "menu.not-logged-in-button")))))), /*#__PURE__*/ react.createElement(navigation, {
        onCloseMegaMenu: onCloseMegaMenu
    }));
};
var header_mapStateToProps = function(state) {
    return {
        mobileMenuOpen: state.areas.navigation.mobileMenu.open,
        megaMenuOpen: state.areas.navigation.megaMenu.open,
        me: state.areas.account.me,
        isAuthenticated: state.areas.account.isAuthenticated
    };
};
var header_dispatchActions = {
    searchFocus: search/* default.searchFocus */.ZP.searchFocus,
    searchBlur: search/* default.searchBlur */.ZP.searchBlur,
    closeMobileMenu: mobile_menu/* default.closeMenu */.ZP.closeMenu,
    toggleMenu: desktop/* default.toggleMenu */.ZP.toggleMenu
};
/* harmony default export */ var header = ((0,redux.compose)((0,es/* connect */.$j)(header_mapStateToProps, header_dispatchActions))(Header));

// EXTERNAL MODULE: ./src/contexts/wide-context.tsx
var wide_context = __webpack_require__(96192);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./src/areas/product-collection/constants/index.ts
var product_collection_constants = __webpack_require__(15169);
// EXTERNAL MODULE: ./src/areas/sidebar/views/alerts/index.tsx
var alerts = __webpack_require__(61082);
// EXTERNAL MODULE: ./src/areas/sidebar/views/filter/index.tsx
var filter = __webpack_require__(33642);
// EXTERNAL MODULE: ./src/areas/sidebar/views/list/index.tsx
var list = __webpack_require__(11024);
// EXTERNAL MODULE: ./src/areas/sidebar/views/lists/index.tsx
var views_lists = __webpack_require__(29865);
// EXTERNAL MODULE: ./src/areas/changelog/components/badge/index.tsx
var badge = __webpack_require__(54505);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/megaphone/index.js
var megaphone = __webpack_require__(78463);
;// CONCATENATED MODULE: ./src/areas/changelog/components/toggle-button/index.tsx
function toggle_button_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function toggle_button_templateObject() {
    var data = toggle_button_taggedTemplateLiteral([
        "\n    position: relative;\n    color: ",
        ";\n  "
    ]);
    toggle_button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function toggle_button_templateObject1() {
    var data = toggle_button_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    toggle_button_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ChangelogToggle = function(param) {
    var onClickHandler = param.onClickHandler;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(Button, {
        onClick: onClickHandler,
        type: variants.ButtonType.TEXT,
        tone: variants.ButtonTone.LIGHT,
        ariaLabel: t("changelog", "changelog.title")
    }, /*#__PURE__*/ react.createElement(Inner, null, /*#__PURE__*/ react.createElement(badge/* default */.ZP, {
        noOutline: true
    }), /*#__PURE__*/ react.createElement(megaphone/* IconMegaphone */.I, {
        size: 20,
        color: "maybeBlue700"
    })));
};
var Button = (0,styled_components_browser_esm["default"])(variants.IconButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(function(p) {
    return (0,styled_components_browser_esm.css)(toggle_button_templateObject(), p.theme.icons.secondary);
});
var Inner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Inner",
    componentId: "sc-0-1"
})(toggle_button_templateObject1());

// EXTERNAL MODULE: ./src/areas/changelog/changelog-loadable.tsx
var changelog_loadable = __webpack_require__(19151);
// EXTERNAL MODULE: ./src/areas/changelog/styles.ts
var styles = __webpack_require__(78667);
;// CONCATENATED MODULE: ./src/areas/changelog/desktop-wrapper.tsx





var selectChangelogOpen = function(state) {
    return state.areas.changelog.isOpen;
};
var selectChangelogArticles = function(state) {
    return state.areas.changelog.articles;
};
var ChangelogDesktop = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var articles = (0,es/* useSelector */.v9)(selectChangelogArticles);
    var isOpen = (0,es/* useSelector */.v9)(selectChangelogOpen);
    var toggleOpen = (0,react.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        dispatch({
            type: "CHANGELOG_TOGGLE"
        });
    }, [
        dispatch
    ]);
    if (!articles || !articles.length) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(styles/* ChangelogWrapper */.Xw, null, /*#__PURE__*/ react.createElement(ChangelogToggle, {
        onClickHandler: toggleOpen
    }), isOpen && // Conditionally render this to not load the extra bundle on pageload
    /*#__PURE__*/ react.createElement(styles/* ChangelogModal */.Xc, {
        visible: isOpen
    }, /*#__PURE__*/ react.createElement(changelog_loadable/* Changelog */.E, null)));
};
/* harmony default export */ var desktop_wrapper = (ChangelogDesktop);

// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(33944);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/filter.js
var actions_filter = __webpack_require__(44291);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/icons/toggle-sidebar.tsx

var ToggleSidebarIcon = function(param) {
    var className = param.className, size = param.size, title = param.title;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        height: size,
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, title && /*#__PURE__*/ react.createElement("title", null, title), /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M18.028 9.2L16.5 10.805 21.47 16l-4.97 5.195 1.528 1.605L24.5 16zm-7 0L9.5 10.805 14.47 16 9.5 21.195l1.528 1.605L17.5 16z",
        fill: "#909090"
    })));
};
/* harmony default export */ var toggle_sidebar = (ToggleSidebarIcon);

;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-desktop/components/menu-bar/styles.ts
function menu_bar_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_bar_styles_templateObject() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  align-items: center;\n  width: ",
        ";\n  background-color: ",
        ";\n  padding: ",
        " 0;\n  z-index: ",
        ";\n"
    ]);
    menu_bar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject1() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  > * {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    menu_bar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject2() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: ",
        ";\n  padding-top: ",
        ";\n\n  > * {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    menu_bar_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject3() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n      color: ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    menu_bar_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject4() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n      visibility: hidden;\n      opacity: 0;\n      transition:\n        visibility 0s ease 200ms,\n        opacity 200ms;\n    "
    ]);
    menu_bar_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject5() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    margin-left: auto;\n    margin-right: auto;\n    transition:\n      background 200ms ease,\n      color 200ms ease,\n      visibility 0s ease 0s,\n      opacity 200ms;\n    background: transparent;\n    color: ",
        ";\n    visibility: visible;\n    opacity: 1;\n\n    ",
        "\n\n    rect,\n    path {\n      fill: ",
        ";\n    }\n\n    ",
        "\n\n    &:hover,\n    &.focus-visible {\n      color: ",
        ";\n    }\n  "
    ]);
    menu_bar_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject6() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  pointer-events: none;\n  background: ",
        ";\n  height: 1px;\n  width: 75%;\n"
    ]);
    menu_bar_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject7() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover,\n  &.focus-visible {\n    color: ",
        ";\n  }\n  transition: transform 200ms ease;\n  transform: ",
        ";\n"
    ]);
    menu_bar_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var padding = base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
var menuWidth = base/* layout.sidebarMenuWidth.desktop */.bK.sidebarMenuWidth.desktop;
var SidebarMenu = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SidebarMenu",
    componentId: "sc-0-0"
})(menu_bar_styles_templateObject(), menuWidth.rem, function(p) {
    return p.theme.colors.base100;
}, padding, zindex/* zindex.menu.left */.Y.menu.left);
var TopBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TopBar",
    componentId: "sc-0-1"
})(menu_bar_styles_templateObject1(), padding, padding);
var BottomBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BottomBar",
    componentId: "sc-0-2"
})(menu_bar_styles_templateObject2(), padding, padding, padding, padding);
var MenuButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "MenuButton",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(menu_bar_styles_templateObject5(), props.theme.colors.base500, props.active && props.hoverEffect === "background" && (0,styled_components_browser_esm.css)(menu_bar_styles_templateObject3(), props.theme.colors.base0, props.theme.icons.callToActionHover), props.active ? props.theme.colors.base0 : "currentColor", props.hidden && (0,styled_components_browser_esm.css)(menu_bar_styles_templateObject4()), props.active ? "inherit" : props.theme.icons.callToActionHover);
});
MenuButton.defaultProps = {
    hoverEffect: "background"
};
var Divider = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Divider",
    componentId: "sc-0-4"
})(menu_bar_styles_templateObject6(), function(p) {
    return p.theme.lines.primary;
});
var styles_ToggleSidebarIcon = (0,styled_components_browser_esm["default"])(toggle_sidebar).withConfig({
    displayName: "ToggleSidebarIcon",
    componentId: "sc-0-5"
})(menu_bar_styles_templateObject7(), function(p) {
    return p.theme.colors.base300;
}, function(p) {
    return p.theme.icons.callToActionHover;
}, function(p) {
    return p.open ? "rotate(180deg)" : "none";
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/filter/index.js
var icon_filter = __webpack_require__(38077);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/heart-filled/index.js
var heart_filled = __webpack_require__(87269);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/heart-outlined/index.js
var heart_outlined = __webpack_require__(72183);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-filled/index.js
var notification_filled = __webpack_require__(40900);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(50999);
// EXTERNAL MODULE: ./src/components/experiment/index.ts + 1 modules
var experiment = __webpack_require__(43088);
// EXTERNAL MODULE: ./src/components/experiment/experiments-list.tsx + 2 modules
var experiments_list = __webpack_require__(96786);
;// CONCATENATED MODULE: ./src/components/experiment/editor-desktop.tsx
function editor_desktop_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function editor_desktop_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function editor_desktop_extends() {
    editor_desktop_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return editor_desktop_extends.apply(this, arguments);
}
function editor_desktop_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function editor_desktop_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function editor_desktop_slicedToArray(arr, i) {
    return editor_desktop_arrayWithHoles(arr) || editor_desktop_iterableToArrayLimit(arr, i) || editor_desktop_unsupportedIterableToArray(arr, i) || editor_desktop_nonIterableRest();
}
function editor_desktop_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return editor_desktop_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return editor_desktop_arrayLikeToArray(o, minLen);
}






var Editor = function(props) {
    var ref = editor_desktop_slicedToArray(react.useState(false), 2), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    if (!mounted) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, null, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        onlyIcon: true,
        type: variants.ButtonType.TEXT
    }, /*#__PURE__*/ react.createElement("img", {
        width: "20",
        height: "20",
        alt: "Experiment Editor",
        src: "https://cdn.pji.nu/g/logo/icon192x192.png"
    })), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: ui/* Direction.Down */.Nm.Down,
        placement: ui/* Direction.Right */.Nm.Right
    }, /*#__PURE__*/ react.createElement(experiments_list/* ExperimentsList */.F, editor_desktop_extends({}, props))));
};
var ExperimentEditorDesktop = function() {
    return /*#__PURE__*/ react.createElement(experiment/* ExperimentContext.Consumer */.T.Consumer, null, function(_param) {
        var showEditor = _param.showEditor, rest = _objectWithoutProperties(_param, [
            "showEditor"
        ]);
        if (!showEditor) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(Editor, editor_desktop_extends({}, rest));
    });
};

;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-desktop/components/menu-bar/index.tsx

















var SidebarMenuBar = function(param) {
    var _tab = param.tab, tab = _tab === void 0 ? constants/* SIDEBAR_STATE.NONE */.$J.NONE : _tab, _previousTab = param.previousTab, previousTab = _previousTab === void 0 ? constants/* SIDEBAR_STATE.LISTS */.$J.LISTS : _previousTab, tmp = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    closeLists, dispatchCloseLists = tmp === void 0 ? function() {} : tmp, tmp1 = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    openLists, dispatchOpenLists = tmp1 === void 0 ? function() {} : tmp1, tmp2 = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    openAlerts, dispatchOpenAlerts = tmp2 === void 0 ? function() {} : tmp2, tmp3 = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleFilter, dispatchToggleFilter = tmp3 === void 0 ? function() {} : tmp3, showFilter = param.showFilter, showHorizontalFilter = param.showHorizontalFilter;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    // Generate unique UIDs to use as HTML ids
    var getId = (0,react.useId)();
    var listsTabId = "".concat(getId, "-sidebar-desktop-lists");
    var alertsTabId = "".concat(getId, "-sidebar-desktop-alerts");
    var filterTabId = "".concat(getId, "-sidebar-desktop-filter");
    var isSidebarOpen = tab !== constants/* SIDEBAR_STATE.NONE */.$J.NONE;
    var isListTabActive = tab === constants/* SIDEBAR_STATE.LISTS */.$J.LISTS;
    var isAlertsTabActive = tab === constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS;
    var isFilterTabActive = tab === constants/* SIDEBAR_STATE.FILTER */.$J.FILTER;
    var toggleView = (0,react.useCallback)(function(state) {
        switch(state){
            case tab:
                dispatchCloseLists();
                break;
            case constants/* SIDEBAR_STATE.LISTS */.$J.LISTS:
                dispatchOpenLists();
                break;
            case constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS:
                dispatchOpenAlerts();
                break;
            case constants/* SIDEBAR_STATE.FILTER */.$J.FILTER:
                dispatchToggleFilter();
                break;
            default:
                dispatchCloseLists();
        }
    }, [
        dispatchCloseLists,
        dispatchOpenAlerts,
        dispatchOpenLists,
        tab,
        dispatchToggleFilter
    ]);
    var handleListsMenuButton = (0,react.useCallback)(function() {
        if (tab === constants/* SIDEBAR_STATE.LISTS */.$J.LISTS) {
            (0,sidebar_tracking/* trackClosingSidebar */.D)(constants/* SIDEBAR_STATE.LISTS */.$J.LISTS, "sidebarListsButton");
        } else {
            (0,sidebar_tracking/* trackOpeningSidebar */.b)(constants/* SIDEBAR_STATE.LISTS */.$J.LISTS, "sidebarListsButton");
        }
        toggleView(constants/* SIDEBAR_STATE.LISTS */.$J.LISTS);
    }, [
        toggleView,
        tab
    ]);
    var handleAlertsMenuButton = (0,react.useCallback)(function() {
        if (tab === constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS) {
            (0,sidebar_tracking/* trackClosingSidebar */.D)(constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS, "sidebarAlertsButton");
        } else {
            (0,sidebar_tracking/* trackOpeningSidebar */.b)(constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS, "sidebarAlertsButton");
        }
        toggleView(constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS);
    }, [
        toggleView,
        tab
    ]);
    var handleToggleButton = (0,react.useCallback)(function() {
        if (isSidebarOpen) {
            (0,sidebar_tracking/* trackClosingSidebar */.D)(tab, "sidebarToggleButton");
            toggleView(constants/* SIDEBAR_STATE.NONE */.$J.NONE);
            return;
        }
        // Open default view if previous view was filter but no longer
        // on a leaf category page, or if filter is set to HorizontalFilter,
        // or `previousTab` is empty.
        if (!previousTab || previousTab === constants/* SIDEBAR_STATE.FILTER */.$J.FILTER && !showFilter || previousTab === constants/* SIDEBAR_STATE.FILTER */.$J.FILTER && showHorizontalFilter) {
            (0,sidebar_tracking/* trackOpeningSidebar */.b)(constants/* DEFAULT_SIDEBAR_STATE */.N3, "sidebarToggleButton");
            toggleView(constants/* DEFAULT_SIDEBAR_STATE */.N3);
            return;
        }
        (0,sidebar_tracking/* trackOpeningSidebar */.b)(previousTab, "sidebarToggleButton");
        toggleView(previousTab);
    }, [
        isSidebarOpen,
        previousTab,
        showFilter,
        showHorizontalFilter,
        toggleView,
        tab
    ]);
    var sidebarHasButtons = market.login.enabled || showFilter && !showHorizontalFilter;
    return /*#__PURE__*/ react.createElement(SidebarMenu, null, /*#__PURE__*/ react.createElement(TopBar, null, market.login.enabled && /*#__PURE__*/ react.createElement(MenuButton, {
        active: false,
        hoverEffect: "background",
        onClick: handleToggleButton,
        hidden: !sidebarHasButtons,
        "aria-label": isSidebarOpen ? t("symbols", "symbol.collapse-sidebar") : t("symbols", "symbol.expand-sidebar"),
        "aria-expanded": isSidebarOpen,
        "aria-haspopup": "true"
    }, /*#__PURE__*/ react.createElement(styles_ToggleSidebarIcon, {
        size: 24,
        open: isSidebarOpen
    })), market.login.enabled && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(MenuButton, {
        active: isListTabActive,
        onClick: handleListsMenuButton,
        "data-test": "MenuButtonLists",
        "aria-label": t("lists", "lists.title"),
        "aria-expanded": isListTabActive,
        "aria-haspopup": "true",
        "aria-controls": listsTabId
    }, isListTabActive ? /*#__PURE__*/ react.createElement(heart_filled/* IconHeartFilled */.g, null) : /*#__PURE__*/ react.createElement(heart_outlined/* IconHeartOutlined */.G, null)), /*#__PURE__*/ react.createElement(MenuButton, {
        active: isAlertsTabActive,
        onClick: handleAlertsMenuButton,
        "data-test": "MenuButtonAlerts",
        "aria-label": t("alerts", "alerts.title"),
        "aria-expanded": isAlertsTabActive,
        "aria-haspopup": "true",
        "aria-controls": alertsTabId
    }, isAlertsTabActive ? /*#__PURE__*/ react.createElement(notification_filled/* IconNotificationFilled */.Q, null) : /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null))), /*#__PURE__*/ react.createElement(MenuButton, {
        active: isFilterTabActive,
        onClick: function() {
            return toggleView(constants/* SIDEBAR_STATE.FILTER */.$J.FILTER);
        },
        hidden: !showFilter || showHorizontalFilter,
        "data-test": "MenuButtonFilter",
        "aria-label": t("filter", "filter.title"),
        "aria-expanded": isFilterTabActive,
        "aria-haspopup": "true",
        "aria-controls": filterTabId
    }, /*#__PURE__*/ react.createElement(icon_filter/* IconFilter */.w, {
        size: 21
    }))), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(BottomBar, null, /*#__PURE__*/ react.createElement(desktop_wrapper, null), /*#__PURE__*/ react.createElement(ExperimentEditorDesktop, null))));
};
var menu_bar_mapStateToProps = function(state) {
    return {
        tab: state.areas.sidebar.tab,
        previousTab: state.areas.sidebar.previousTab,
        showFilter: state.areas.category.filter.showFilter || state.areas.sidebar.hasFilter,
        showHorizontalFilter: state.areas.category.filter.showHorizontalFilter
    };
};
var menu_bar_dispatchProps = {
    openLists: lists/* openLists */.pu,
    closeLists: lists/* closeLists */.c,
    openAlerts: actions_alert/* openAlerts */.SU,
    closeAlerts: actions_alert/* closeAlerts */.ys,
    toggleFilter: actions_filter/* toggleFilter */.c
};
/* harmony default export */ var menu_bar = ((0,es/* connect */.$j)(menu_bar_mapStateToProps, menu_bar_dispatchProps)(SidebarMenuBar));

;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-desktop/styles.ts
function sidebar_desktop_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sidebar_desktop_styles_templateObject() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    sidebar_desktop_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject1() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-shrink: 0;\n  z-index: ",
        ";\n\n  width: ",
        ";\n  transition: width ",
        "ms ease;\n  grid-row: 1 / span 2;\n\n  ",
        "\n\n  ",
        ";\n"
    ]);
    sidebar_desktop_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject2() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  height: calc(100vh - ",
        ");\n  z-index: ",
        ";\n  position: sticky;\n  top: 72px; /* Height of the header */\n"
    ]);
    sidebar_desktop_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject3() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  align-items: center;\n  width: ",
        ";\n  background-color: ",
        ";\n  padding: ",
        " 0;\n  z-index: 99;\n"
    ]);
    sidebar_desktop_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject4() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  flex-shrink: 0;\n  width: ",
        ";\n  border-right: 1px solid ",
        ";\n  overflow: auto;\n  overscroll-behavior: contain;\n  background: ",
        ";\n  z-index: 10;\n  flex-direction: column;\n"
    ]);
    sidebar_desktop_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject5() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    sidebar_desktop_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var styles_padding = base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
var contentWidth = base/* layout.sidebarContentWidth.desktop */.bK.sidebarContentWidth.desktop;
var styles_menuWidth = base/* layout.sidebarMenuWidth.desktop */.bK.sidebarMenuWidth.desktop;
var styles_pageWithSidebarContent = base/* layout.pageContent.maxWidth.value */.bK.pageContent.maxWidth.value + base/* layout.pageContent.gutter.value */.bK.pageContent.gutter.value + (contentWidth.value + styles_menuWidth.value) * 2;
var Sidebar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Sidebar",
    componentId: "sc-0-0"
})(sidebar_desktop_styles_templateObject1(), zindex/* zindex.menu.left */.Y.menu.left, function(props) {
    return props.tab === "none" ? styles_menuWidth.rem : "calc(".concat(contentWidth.rem, " + ").concat(styles_menuWidth.rem, ")");
}, ui/* speedToDurationMs */.k0[ui/* Speed.Slow */.fD.Slow], function(props) {
    return !props.isWide && "\n      /* Reserve space between page content and sidebar menu to properly align page content */\n      /* Debug or see how it works by setting a background color to this component */\n      @media (min-width: ".concat(styles_pageWithSidebarContent, "px) {\n        width: calc(").concat(contentWidth.rem, " + ").concat(styles_menuWidth.rem, ");\n      }\n\n      @media (max-width: ").concat(styles_pageWithSidebarContent, "px) {\n        min-width: calc((100vw - ").concat(base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, ") / 2);\n      }\n    ");
}, base/* media.mediumDown */.BC.mediumDown(sidebar_desktop_styles_templateObject()));
var Sticky = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Sticky",
    componentId: "sc-0-1"
})(sidebar_desktop_styles_templateObject2(), base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, zindex/* zindex.menu.left */.Y.menu.left);
var styles_SidebarMenu = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SidebarMenu",
    componentId: "sc-0-2"
})(sidebar_desktop_styles_templateObject3(), styles_menuWidth.rem, function(p) {
    return p.theme.colors.base100;
}, styles_padding);
var SidebarContent = styled_components_browser_esm["default"].div.attrs({
    role: "dialog"
}).withConfig({
    displayName: "SidebarContent",
    componentId: "sc-0-3"
})(sidebar_desktop_styles_templateObject4(), contentWidth.rem, function(p) {
    return p.theme.lines.primary;
}, function(p) {
    return p.theme.bg.primary;
});
var SidebarFilter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SidebarFilter",
    componentId: "sc-0-4"
})(sidebar_desktop_styles_templateObject5());

;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-desktop/index.tsx
function sidebar_desktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}













var sidebar_desktop_Sidebar = function(param) {
    var className = param.className, _tab = param.tab, tab = _tab === void 0 ? constants/* SIDEBAR_STATE.NONE */.$J.NONE : _tab, selectedList = param.selectedList, showFilter = param.showFilter, filterType = param.filterType;
    var isWide = (0,react.useContext)(wide_context/* WideContext */.Y).isWide;
    var isSidebarOpen = tab !== constants/* SIDEBAR_STATE.NONE */.$J.NONE;
    // Generate unique UIDs to use as HTML ids
    var getId = (0,react.useId)();
    var listsTabId = "".concat(getId, "-sidebar-desktop-lists");
    var alertsTabId = "".concat(getId, "-sidebar-desktop-alerts");
    var filterTabId = "".concat(getId, "-sidebar-desktop-filter");
    var renderSidebarContent = function() {
        var content = function() {
            switch(tab){
                case constants/* SIDEBAR_STATE.LISTS */.$J.LISTS:
                    return selectedList ? /*#__PURE__*/ react.createElement(list/* default */.Z, {
                        id: selectedList
                    }) : /*#__PURE__*/ react.createElement(views_lists/* default */.Z, null);
                case constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS:
                    return /*#__PURE__*/ react.createElement(alerts/* default */.Z, null);
                case constants/* SIDEBAR_STATE.FILTER */.$J.FILTER:
                    if (!showFilter) {
                        return null;
                    }
                    return filterType === "category" ? /*#__PURE__*/ react.createElement(filter/* default */.Z, null) : /*#__PURE__*/ react.createElement(SidebarFilter, {
                        id: product_collection_constants/* FILTER_PORTAL_ID */._B
                    });
                default:
                    return null;
            }
        }();
        var _obj;
        var id = (_obj = {}, sidebar_desktop_defineProperty(_obj, constants/* SIDEBAR_STATE.LISTS */.$J.LISTS, listsTabId), sidebar_desktop_defineProperty(_obj, constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS, alertsTabId), sidebar_desktop_defineProperty(_obj, constants/* SIDEBAR_STATE.FILTER */.$J.FILTER, filterTabId), sidebar_desktop_defineProperty(_obj, constants/* SIDEBAR_STATE.NONE */.$J.NONE, "none"), _obj)[tab];
        return /*#__PURE__*/ react.createElement(SidebarContent, {
            id: id
        }, content);
    };
    return /*#__PURE__*/ react.createElement(Sidebar, {
        tab: tab,
        className: className,
        "data-test": "SidebarDesktop",
        isWide: isWide
    }, /*#__PURE__*/ react.createElement(Sticky, null, /*#__PURE__*/ react.createElement(menu_bar, null), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(hideable_variants.SlideLeft, {
        visible: isSidebarOpen
    }, renderSidebarContent()))));
};
sidebar_desktop_Sidebar.displayName = "Sidebar";
var sidebar_desktop_mapStateToProps = function(state) {
    return {
        tab: state.areas.sidebar.tab,
        selectedList: state.areas.sidebar.selectedList,
        filterType: state.areas.sidebar.filterType,
        showFilter: state.areas.category.filter.showFilter || state.areas.sidebar.hasFilter
    };
};
/* harmony default export */ var sidebar_desktop = ((0,es/* connect */.$j)(sidebar_desktop_mapStateToProps, {})(sidebar_desktop_Sidebar));

;// CONCATENATED MODULE: ./src/client/nextjs.ts
var isNextJsProxyEnabledClient = function() {
    return  true && Boolean(window.NEXTJS_ENABLE_PROXY);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/components/announcement-banner/styles.ts
function announcement_banner_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function announcement_banner_styles_templateObject() {
    var data = announcement_banner_styles_taggedTemplateLiteral([
        "\n  padding: 10px ",
        ";\n  background: ",
        ";\n  display: flex;\n  justify-content: center;\n\n  &:hover .hover-animate-icon {\n    transform: translateX(",
        ");\n  }\n"
    ]);
    announcement_banner_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function announcement_banner_styles_templateObject1() {
    var data = announcement_banner_styles_taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    announcement_banner_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function announcement_banner_styles_templateObject2() {
    var data = announcement_banner_styles_taggedTemplateLiteral([
        "\n    gap: 0 ",
        ";\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n\n    flex-direction: ",
        ";\n\n    ",
        "\n  "
    ]);
    announcement_banner_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function announcement_banner_styles_templateObject3() {
    var data = announcement_banner_styles_taggedTemplateLiteral([
        "\n  display: inline-block;\n  height: ",
        "px;\n  vertical-align: middle;\n  transition-duration: 0.2s;\n  transition-timing-function: linear;\n  transform: none;\n"
    ]);
    announcement_banner_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function announcement_banner_styles_templateObject4() {
    var data = announcement_banner_styles_taggedTemplateLiteral([
        "\n      -webkit-line-clamp: 1;\n  "
    ]);
    announcement_banner_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function announcement_banner_styles_templateObject5() {
    var data = announcement_banner_styles_taggedTemplateLiteral([
        "\n    /* stylelint-disable value-no-vendor-prefix */\n    display: -webkit-box;\n    /* stylelint-disable property-no-vendor-prefix */\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ",
        ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    ",
        "\n  "
    ]);
    announcement_banner_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function announcement_banner_styles_templateObject6() {
    var data = announcement_banner_styles_taggedTemplateLiteral([
        "\n  display: inline;\n  white-space: nowrap;\n  margin: 0 auto;\n"
    ]);
    announcement_banner_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var BUTTON_SIZE = 20;
var StyledBannerCSS = function(props) {
    return (0,styled_components_browser_esm.css)(announcement_banner_styles_templateObject(), design_tokens.measurements.spacing075, function(p) {
        return props.$theme === "dark" ? p.theme.colors.base900 : p.theme.colors.maybeBlue100;
    }, design_tokens.measurements.spacing025);
};
/* Same CSS for both, but one is a <div> and the other an <a> */ var StyledBanner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledBanner",
    componentId: "sc-0-0"
})(StyledBannerCSS);
var StyledBannerLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "StyledBannerLink",
    componentId: "sc-0-1"
})(StyledBannerCSS);
var StyledTextsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTextsWrapper",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(announcement_banner_styles_templateObject2(), design_tokens.measurements.spacing050, props.$forceSameRow ? "row" : "column", base/* media.mediumUp */.BC.mediumUp(announcement_banner_styles_templateObject1()));
});
var StyledIconWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledIconWrapper",
    componentId: "sc-0-3"
})(announcement_banner_styles_templateObject3(), BUTTON_SIZE);
var _maxLines;
var StyledTruncatedBodySmallText = (0,styled_components_browser_esm["default"])(text_variants.BodySmallText).withConfig({
    displayName: "StyledTruncatedBodySmallText",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(announcement_banner_styles_templateObject5(), (_maxLines = props.maxLines) !== null && _maxLines !== void 0 ? _maxLines : 2, base/* media.mediumUp */.BC.mediumUp(announcement_banner_styles_templateObject4()));
});
var StyledLink = (0,styled_components_browser_esm["default"])(text_variants.BodySmallText).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-5"
})(announcement_banner_styles_templateObject6());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
;// CONCATENATED MODULE: ./src/components/announcement-banner/banner-with-link.tsx






var BannerWithLink = function(param) {
    var text = param.text, linkText = param.linkText, urlWithDomainName = param.url, theme = param.theme, fontColor = param.fontColor;
    var market = (0,app_context/* useAppContext */.bp)().market;
    var iconColor = theme === "dark" ? "base0" : "base900";
    var hasNoLinkText = !linkText;
    var RightArrowJSX = (0,react.useMemo)(function() {
        return /*#__PURE__*/ react.createElement(StyledIconWrapper, {
            className: "hover-animate-icon"
        }, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, {
            size: BUTTON_SIZE,
            color: iconColor
        }));
    }, [
        iconColor
    ]);
    if (!urlWithDomainName) return null;
    var _domain;
    var isExternalUrl = !urlWithDomainName.startsWith((_domain = market.domain) !== null && _domain !== void 0 ? _domain : "");
    var _domain1;
    var url = isExternalUrl ? urlWithDomainName : urlWithDomainName.split((_domain1 = market.domain) !== null && _domain1 !== void 0 ? _domain1 : "")[1];
    var handleOnClick = function() {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.ANNOUNCEMENT_BANNER */.U.ANNOUNCEMENT_BANNER,
            nextPage: url
        });
    };
    return /*#__PURE__*/ react.createElement(StyledBannerLink, {
        to: url,
        onClick: function(_) {
            return handleOnClick();
        },
        isExternal: isExternalUrl,
        $theme: theme
    }, /*#__PURE__*/ react.createElement(StyledTextsWrapper, {
        $forceSameRow: hasNoLinkText
    }, /*#__PURE__*/ react.createElement(StyledTruncatedBodySmallText, {
        color: fontColor,
        maxLines: 1
    }, text), linkText ? /*#__PURE__*/ react.createElement(StyledLink, {
        color: fontColor,
        weight: text_variants.FontWeight.HEAVIEST
    }, linkText, RightArrowJSX) : RightArrowJSX));
};

;// CONCATENATED MODULE: ./src/components/announcement-banner/banner-without-link.tsx



var BannerWithoutLink = function(param) {
    var text = param.text, theme = param.theme, fontColor = param.fontColor;
    return /*#__PURE__*/ react.createElement(StyledBanner, {
        $theme: theme
    }, /*#__PURE__*/ react.createElement(StyledTextsWrapper, {
        $forceSameRow: false
    }, /*#__PURE__*/ react.createElement(StyledTruncatedBodySmallText, {
        color: fontColor,
        weight: text_variants.FontWeight.HEAVIER
    }, text)));
};

;// CONCATENATED MODULE: ./src/components/announcement-banner/announcement-banner.tsx




var AnnouncementBanner = function(param) {
    var text = param.text, linkText = param.linkText, url = param.url, themeProp = param.theme;
    if (!text) return null;
    var theme = themeProp === "dark" ? "dark" : "light";
    var fontColor = theme === "dark" ? ui_text.FontColor.LIGHT : ui_text.FontColor.DARK;
    return url ? /*#__PURE__*/ react.createElement(BannerWithLink, {
        theme: theme,
        text: text,
        linkText: linkText,
        url: url,
        fontColor: fontColor
    }) : /*#__PURE__*/ react.createElement(BannerWithoutLink, {
        theme: theme,
        text: text,
        fontColor: fontColor
    });
};
/* harmony default export */ var announcement_banner = ((/* unused pure expression or super */ null && (AnnouncementBanner)));

;// CONCATENATED MODULE: ./src/components/announcement-banner/index.tsx


// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(52923);
// EXTERNAL MODULE: ./src/components/error-message/index.tsx + 1 modules
var error_message = __webpack_require__(44581);
// EXTERNAL MODULE: ./src/hooks/use-meta-tags.js
var use_meta_tags = __webpack_require__(48283);
;// CONCATENATED MODULE: ./src/components/meta-tags/index.tsx

var MetaTags = function(props) {
    var routeId = props.routeId, locationKey = props.locationKey, metaTags = props.metaTags;
    (0,use_meta_tags/* useMetaTags */.k)({
        routeId: routeId,
        locationKey: locationKey,
        metaTags: metaTags
    });
    return null;
};
/* harmony default export */ var meta_tags = (MetaTags);

;// CONCATENATED MODULE: ./src/components/error-page/index.tsx




var ErrorPage = function(param) {
    var error = param.error;
    var ref, ref1;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var firstError = (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1[0];
    var _status;
    var status = (_status = error.status) !== null && _status !== void 0 ? _status : 500;
    if (firstError) {
        var _status1;
        status = (_status1 = firstError.status) !== null && _status1 !== void 0 ? _status1 : 500;
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
        status: status
    }), /*#__PURE__*/ react.createElement(meta_tags, {
        metaTags: {
            title: "".concat(t("errors", "internal.unknown"), " (").concat(status, ")")
        }
    }));
};

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/components/location-context/index.tsx
var location_context = __webpack_require__(42028);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(94320);
;// CONCATENATED MODULE: ./src/components/newsletter-signup-modal/index.tsx
function newsletter_signup_modal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function newsletter_signup_modal_templateObject() {
    var data = newsletter_signup_modal_taggedTemplateLiteral([
        "\n    width: 100%;\n"
    ]);
    newsletter_signup_modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function newsletter_signup_modal_templateObject1() {
    var data = newsletter_signup_modal_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    newsletter_signup_modal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var NEWSLETTER_PARAM = "signup-for-our-newsletter";
var StyledNewsletterSignup = (0,styled_components_browser_esm["default"])(newsletter_signup/* NewsletterSignup */.o).withConfig({
    displayName: "StyledNewsletterSignup",
    componentId: "sc-0-0"
})(newsletter_signup_modal_templateObject1(), base/* media.mediumUp */.BC.mediumUp(newsletter_signup_modal_templateObject()));
var NewsLetterSignupModal = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var location = (0,react_router_dom/* useLocation */.TH)();
    var close = (0,react.useCallback)(function() {
        // Remove the `NEWSLETTER_PARAM` from the URL which closes the modal
        var params = querystring.parse(location.search.substr(1));
        delete params[NEWSLETTER_PARAM];
        location.search = querystring.stringify(params);
        history.push(location);
    }, [
        history,
        location
    ]);
    return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        isOpen: true,
        width: 500,
        onRequestClose: close
    }, /*#__PURE__*/ react.createElement(StyledNewsletterSignup, {
        stacked: true,
        title: t("footer", "newsletter.title"),
        description: t("footer", "newsletter.sub-title"),
        buttonText: t("campaigns", "newsletter.sign-up-button-long")
    }));
};
/* harmony default export */ var newsletter_signup_modal = (NewsLetterSignupModal);

// EXTERNAL MODULE: ./src/components/pj-frontend-admin/index.tsx
var pj_frontend_admin = __webpack_require__(9332);
;// CONCATENATED MODULE: ./src/components/scroll-to-top/index.tsx


var isScrollToTopAction = function(action) {
    return ![
        "POP",
        "REPLACE"
    ].includes(action);
};
var ScrollToTop = function(param) {
    var disableScrollOnQueryUpdate = param.disableScrollOnQueryUpdate, disableScrollForUrlParam = param.disableScrollForUrlParam;
    var ref = (0,react_router/* useLocation */.TH)(), pathname = ref.pathname, search = ref.search;
    var action = (0,react_router/* useHistory */.k6)().action;
    var getPath = function() {
        if (disableScrollOnQueryUpdate) return pathname;
        return disableScrollForUrlParam ? pathname + search.replace(disableScrollForUrlParam, "") : pathname + search;
    };
    var path = (0,react.useMemo)(getPath, [
        pathname,
        search,
        disableScrollOnQueryUpdate
    ]);
    (0,react.useEffect)(function() {
        if (isScrollToTopAction(action)) {
            window.scroll(0, 0);
        }
    }, [
        path
    ]);
    return null;
};

// EXTERNAL MODULE: ./src/components/shutdown-message/index.js
var shutdown_message = __webpack_require__(84413);
// EXTERNAL MODULE: ./src/components/toast-container/index.ts
var toast_container = __webpack_require__(51326);
// EXTERNAL MODULE: ./node_modules/.pnpm/redux-saga@1.0.3/node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(38247);
// EXTERNAL MODULE: ./src/components/toast-container/actions/index.ts
var toast_container_actions = __webpack_require__(40744);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(6213);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/info-filled/index.js
var info_filled = __webpack_require__(1747);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close-filled/index.js
var close_filled = __webpack_require__(25064);
;// CONCATENATED MODULE: ./src/components/toast-container/components/message/styles.ts
function message_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function message_styles_templateObject() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  line-height: 1;\n"
    ]);
    message_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function message_styles_templateObject1() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    message_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function message_styles_templateObject2() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    message_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function message_styles_templateObject3() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    message_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function message_styles_templateObject4() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    message_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var Message = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Message",
    componentId: "sc-0-0"
})(message_styles_templateObject());
var iconStyles = (0,styled_components_browser_esm.css)(message_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Check = (0,styled_components_browser_esm["default"])(check_filled.IconCheckFilled).withConfig({
    displayName: "Check",
    componentId: "sc-0-1"
})(message_styles_templateObject2(), iconStyles);
var Info = (0,styled_components_browser_esm["default"])(info_filled/* IconInfoFilled */.h).withConfig({
    displayName: "Info",
    componentId: "sc-0-2"
})(message_styles_templateObject3(), iconStyles);
var Warning = (0,styled_components_browser_esm["default"])(close_filled.IconCloseFilled).withConfig({
    displayName: "Warning",
    componentId: "sc-0-3"
})(message_styles_templateObject4(), iconStyles);

;// CONCATENATED MODULE: ./src/components/toast-container/components/message/index.tsx


var ToastMessage = function(param) {
    var children = param.children, type = param.type;
    var icon = null;
    var iconSize = 24;
    switch(type){
        case "info":
            icon = /*#__PURE__*/ react.createElement(Info, {
                size: iconSize,
                color: "maybeBlue700"
            });
            break;
        case "success":
            icon = /*#__PURE__*/ react.createElement(Check, {
                size: iconSize,
                color: "positive700"
            });
            break;
        case "warning":
        case "error":
            icon = /*#__PURE__*/ react.createElement(Warning, {
                size: iconSize,
                color: "redio700"
            });
            break;
        default:
    }
    return /*#__PURE__*/ react.createElement(Message, null, icon, children);
};
/* harmony default export */ var message = (ToastMessage);

;// CONCATENATED MODULE: ./src/components/toast-container/sagas/toast.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




var loadAndDisplayToast = function() {
    var _ref = _asyncToGenerator(function(action) {
        var toast;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() | toast */ 578).then(__webpack_require__.bind(__webpack_require__, 56900))
                    ];
                case 1:
                    toast = _state.sent().toast;
                    return [
                        2,
                        toast[action.promptType](/*#__PURE__*/ react.createElement(message, {
                            type: action.promptType
                        }, action.content), action.options)
                    ];
            }
        });
    });
    return function loadAndDisplayToast(action) {
        return _ref.apply(this, arguments);
    };
}();
function handleToastAction(action) {
    var toastContainerLoaded;
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.toast.required;
                    })
                ];
            case 1:
                toastContainerLoaded = _state.sent();
                if (!!toastContainerLoaded) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* requireToastContainer */.i6)())
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(loadAndDisplayToast, action)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function toastSaga() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(toast_container_actions/* TOAST_PROMPT */.c7, handleToastAction)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
if ( true && window && window.registerSaga) {
    window.registerSaga(toastSaga);
}
/* harmony default export */ var toast = ((/* unused pure expression or super */ null && (toastSaga)));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/modal/index.js
var ui_modal = __webpack_require__(51676);
;// CONCATENATED MODULE: ./src/contexts/sourcepoint.tsx
function sourcepoint_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function sourcepoint_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function sourcepoint_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function sourcepoint_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sourcepoint_slicedToArray(arr, i) {
    return sourcepoint_arrayWithHoles(arr) || sourcepoint_iterableToArrayLimit(arr, i) || sourcepoint_unsupportedIterableToArray(arr, i) || sourcepoint_nonIterableRest();
}
function sourcepoint_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sourcepoint_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sourcepoint_arrayLikeToArray(o, minLen);
}






var SourcepointContext = /*#__PURE__*/ (0,react.createContext)(null);
var useSourcepoint = function() {
    var context = (0,react.useContext)(SourcepointContext);
    if (!context) {
        throw new Error("useSourcepoint must be used within a SourcepointProvider");
    }
    return context;
};
var SourcepointProvider = function(param) {
    var children = param.children;
    var ref = (0,app_context/* useAppContext */.bp)(), prisjaktSourcepointConfig = ref.market.prisjaktSourcepointConfig;
    var dispatch = (0,dist_module/* useAdsContext */.R3)().dispatch;
    var hasOpenPrivacyManagerParam = (0,react_router/* useLocation */.TH)().search.includes("privacy_manager=open");
    var ref1 = sourcepoint_slicedToArray((0,react.useState)("loading"), 2), sourcePointState = ref1[0], setSourcePointState = ref1[1];
    var ref2 = sourcepoint_slicedToArray((0,react.useState)(null), 2), sourcepointApi = ref2[0], setSourcepointApi = ref2[1];
    // 'null' means user hasn't decided yet
    var ref3 = sourcepoint_slicedToArray((0,react.useState)(null), 2), isConsentedToAll = ref3[0], setIsConsentedToAll = ref3[1];
    // Init Sourcepoint Api
    (0,react.useEffect)(function() {
        (0,sourcepoint_dist.getApi)(window, document, prisjaktSourcepointConfig).then(function(value) {
            setSourcepointApi(value);
            if (value) {
                setSourcePointState("ready");
            } else {
                setSourcePointState("failed");
            }
        });
    }, [
        prisjaktSourcepointConfig
    ]);
    // Set "is consented" state
    (0,react.useEffect)(function() {
        if (sourcepointApi) {
            setIsConsentedToAll(sourcepointApi.tcf.getConsentedToAllSync());
            sourcepointApi.tcf.isConsentedToAll(setIsConsentedToAll);
        }
    }, [
        sourcepointApi
    ]);
    // Sync "is consented" to ads
    (0,react.useEffect)(function() {
        if (typeof isConsentedToAll === "boolean") {
            dispatch({
                type: "setUserTrackingConsent",
                payload: isConsentedToAll
            });
        }
    }, [
        isConsentedToAll,
        dispatch
    ]);
    // Open privacy manager when URL parameter exists
    (0,react.useEffect)(function() {
        if (sourcepointApi) {
            // Allow opening privacy manager only if user had made choice (to avoid double modal)
            var isConsentedSync = sourcepointApi.tcf.getConsentedToAllSync();
            if (hasOpenPrivacyManagerParam && isConsentedSync !== null) {
                sourcepointApi.openPrivacyManagerModal();
            }
        }
    }, [
        sourcepointApi,
        hasOpenPrivacyManagerParam
    ]);
    // Listen for any user selection to update state
    (0,react.useEffect)(function() {
        if (!sourcepointApi) {
            return function() {
                return undefined;
            };
        }
        return sourcepointApi.tcf.subscribe("CMP:analytics", function() {
            // Regardless of value, user has made a choice
            setSourcePointState("user-selected");
        });
    }, [
        sourcepointApi
    ]);
    // Listen for consent/rejection on Prisjakt marketing purpose to trigger GTM conversion pixels
    (0,react.useEffect)(function() {
        if (!sourcepointApi) {
            return function() {
                return undefined;
            };
        }
        return sourcepointApi.tcf.subscribe("CMP:marketing", function(value) {
            if (value === "1") {
                (0,data_layer/* pushEvent */.A)("tcfConsentedMarketing", {
                    value: value
                });
            } else {
                (0,data_layer/* pushEvent */.A)("tcfRejectedMarketing", {
                    value: value
                });
            }
        });
    }, [
        sourcepointApi
    ]);
    var ref4;
    var ctxValue = (0,react.useMemo)(function() {
        return {
            subscribe: function(category, callback) {
                return (ref4 = sourcepointApi === null || sourcepointApi === void 0 ? void 0 : sourcepointApi.tcf.subscribe(category, callback)) !== null && ref4 !== void 0 ? ref4 : function() {
                    return null;
                };
            },
            openPrivacyManager: function() {
                return sourcepointApi === null || sourcepointApi === void 0 ? void 0 : sourcepointApi.openPrivacyManagerModal();
            },
            sourcePointState: sourcePointState
        };
    }, [
        sourcepointApi,
        sourcePointState
    ]);
    return /*#__PURE__*/ react.createElement(SourcepointContext.Provider, {
        value: ctxValue
    }, children);
};

// EXTERNAL MODULE: ./src/components/modal-v2/modal.tsx
var modal_v2_modal = __webpack_require__(72291);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
;// CONCATENATED MODULE: ./src/components/update-terms-and-conditions-modal/styles.ts
function update_terms_and_conditions_modal_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function update_terms_and_conditions_modal_styles_templateObject() {
    var data = update_terms_and_conditions_modal_styles_taggedTemplateLiteral([
        "\n  margin: auto;\n  display: flex;\n  max-width: 500px;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  place-self: center;\n  padding: ",
        ";\n"
    ]);
    update_terms_and_conditions_modal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function update_terms_and_conditions_modal_styles_templateObject1() {
    var data = update_terms_and_conditions_modal_styles_taggedTemplateLiteral([
        "\n  align-self: center;\n"
    ]);
    update_terms_and_conditions_modal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function update_terms_and_conditions_modal_styles_templateObject2() {
    var data = update_terms_and_conditions_modal_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  line-height: 1.2;\n  font-weight: bold;\n  text-align: center;\n"
    ]);
    update_terms_and_conditions_modal_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function update_terms_and_conditions_modal_styles_templateObject3() {
    var data = update_terms_and_conditions_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    update_terms_and_conditions_modal_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function update_terms_and_conditions_modal_styles_templateObject4() {
    var data = update_terms_and_conditions_modal_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  &:hover {\n    text-decoration: underline;\n  }\n  cursor: pointer;\n"
    ]);
    update_terms_and_conditions_modal_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function update_terms_and_conditions_modal_styles_templateObject5() {
    var data = update_terms_and_conditions_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: ",
        ";\n  row-gap: ",
        ";\n"
    ]);
    update_terms_and_conditions_modal_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function update_terms_and_conditions_modal_styles_templateObject6() {
    var data = update_terms_and_conditions_modal_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  flex: 2 1 0%;\n  border-radius: 9999px;\n"
    ]);
    update_terms_and_conditions_modal_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function update_terms_and_conditions_modal_styles_templateObject7() {
    var data = update_terms_and_conditions_modal_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  flex: 3 1 0%;\n  border-radius: 9999px;\n"
    ]);
    update_terms_and_conditions_modal_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var ModalContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ModalContent",
    componentId: "sc-0-0"
})(update_terms_and_conditions_modal_styles_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(update_terms_and_conditions_modal_styles_templateObject1());
var Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(update_terms_and_conditions_modal_styles_templateObject2(), base/* layout.measurements.fontSizeMega */.bK.measurements.fontSizeMega);
var ParagraphContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ParagraphContainer",
    componentId: "sc-0-3"
})(update_terms_and_conditions_modal_styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal);
var LinkText = styled_components_browser_esm["default"].a.withConfig({
    displayName: "LinkText",
    componentId: "sc-0-4"
})(update_terms_and_conditions_modal_styles_templateObject4(), function(p) {
    return p.theme.text.linkExternal;
}, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal);
var ButtonRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ButtonRow",
    componentId: "sc-0-5"
})(update_terms_and_conditions_modal_styles_templateObject5(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var DeclineButton = (0,styled_components_browser_esm["default"])(components_button/* default */.Z).withConfig({
    displayName: "DeclineButton",
    componentId: "sc-0-6"
})(update_terms_and_conditions_modal_styles_templateObject6());
var AcceptButton = (0,styled_components_browser_esm["default"])(components_button/* default */.Z).withConfig({
    displayName: "AcceptButton",
    componentId: "sc-0-7"
})(update_terms_and_conditions_modal_styles_templateObject7());

;// CONCATENATED MODULE: ./src/components/update-terms-and-conditions-modal/index.tsx
function update_terms_and_conditions_modal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function update_terms_and_conditions_modal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function update_terms_and_conditions_modal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function update_terms_and_conditions_modal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                update_terms_and_conditions_modal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                update_terms_and_conditions_modal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function update_terms_and_conditions_modal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function update_terms_and_conditions_modal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function update_terms_and_conditions_modal_slicedToArray(arr, i) {
    return update_terms_and_conditions_modal_arrayWithHoles(arr) || update_terms_and_conditions_modal_iterableToArrayLimit(arr, i) || update_terms_and_conditions_modal_unsupportedIterableToArray(arr, i) || update_terms_and_conditions_modal_nonIterableRest();
}
function update_terms_and_conditions_modal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return update_terms_and_conditions_modal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return update_terms_and_conditions_modal_arrayLikeToArray(o, minLen);
}
var update_terms_and_conditions_modal_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};











function showModalOnPath(pathname) {
    return ![
        "/information",
        "/help"
    ].some(function(path) {
        return pathname.startsWith(path);
    });
}
var userAgreements = {
    dk: "brugervilkar",
    fi: "kayttoehdot",
    fr: "regles-dutilisation",
    gb: "rules-and-guidelines-for-users",
    no: "brukervilkar",
    nz: "rules-and-guidelines-for-users",
    se: "anvandarvillkor"
};
var UpdateTermsAndConditionsModal = function() {
    var ref = (0,use_account/* useAccount */.m)(), refreshSession = ref.refreshSession, session = ref.session;
    var ref1 = update_terms_and_conditions_modal_slicedToArray((0,react.useState)(true), 2), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = update_terms_and_conditions_modal_slicedToArray((0,react.useState)(false), 2), isPending = ref2[0], setIsPending = ref2[1];
    var ref3 = (0,app_context/* useAppContext */.bp)(), t = ref3.t, market = ref3.market;
    var pathname = (0,react_router_dom/* useLocation */.TH)().pathname;
    var sourcePointState = useSourcepoint().sourcePointState;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var sourcePointReady = [
        "failed",
        "user-selected"
    ].includes(sourcePointState);
    var enableModal = sourcePointReady && showModalOnPath(pathname) && session && session.acceptedUserPolicy === false;
    if (!enableModal) {
        return null;
    }
    var userAgreementLink = "/information/".concat(userAgreements[market.code]);
    var decline = function() {
        var _ref = update_terms_and_conditions_modal_asyncToGenerator(function() {
            var err;
            return update_terms_and_conditions_modal_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsPending(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0,requests/* postPJAccountLogoutAll */.Lv)()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            refreshSession()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        dispatch((0,toast_container_actions/* promptToast */.Lf)("error", t("errors", "error.unknown")));
                        return [
                            2
                        ];
                    case 5:
                        history.push("/");
                        setIsOpen(false);
                        setIsPending(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function decline() {
            return _ref.apply(this, arguments);
        };
    }();
    var accept = function() {
        var _ref = update_terms_and_conditions_modal_asyncToGenerator(function() {
            var err;
            return update_terms_and_conditions_modal_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsPending(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            (0,requests/* postPJAccountUserInfoAcceptPolicy */.xM)()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            refreshSession()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        dispatch((0,toast_container_actions/* promptToast */.Lf)("error", t("errors", "error.unknown")));
                        return [
                            2
                        ];
                    case 5:
                        setIsOpen(false);
                        setIsPending(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function accept() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ react.createElement(modal_v2_modal["default"], {
        isOpen: isOpen,
        disableClose: true
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(ui_modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(ModalContent, null, /*#__PURE__*/ react.createElement("img", {
        style: {
            margin: "auto",
            width: "214px",
            height: "92px"
        },
        src: "".concat(market.cdn, "/g/terms_and_conditions/illo_terms_conditions@2x.png"),
        alt: ""
    }), /*#__PURE__*/ react.createElement(Title, null, t("account", "t-and-c-modal.title")), /*#__PURE__*/ react.createElement(ParagraphContainer, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("span", null, t("account", "t-and-c-modal.body-1")), /*#__PURE__*/ react.createElement(LinkText, {
        href: userAgreementLink
    }, t("account", "t-and-c-modal.body-link")), /*#__PURE__*/ react.createElement("span", null, t("account", "t-and-c-modal.body-2"))), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("span", null, t("account", "t-and-c-modal.contact")), /*#__PURE__*/ react.createElement(LinkText, {
        href: "/help?chat=open"
    }, t("account", "t-and-c-modal.contact-link")))))), /*#__PURE__*/ react.createElement(ui_modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(ButtonRow, null, /*#__PURE__*/ react.createElement(DeclineButton, {
        onClick: decline,
        variant: "outlined",
        disabled: isPending
    }, t("account", "t-and-c-modal.decline")), /*#__PURE__*/ react.createElement(AcceptButton, {
        onClick: accept,
        disabled: isPending,
        color: "primary"
    }, t("account", "t-and-c-modal.accept"))))));
};

// EXTERNAL MODULE: ./src/contexts/userlike-chat.tsx
var userlike_chat = __webpack_require__(55803);
// EXTERNAL MODULE: ./src/hooks/campaigns/use-campaigns.ts
var use_campaigns = __webpack_require__(56525);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
// EXTERNAL MODULE: ./src/hooks/campaigns/campaigns.graphql
var campaigns_graphql = __webpack_require__(43837);
var campaigns_graphql_default = /*#__PURE__*/__webpack_require__.n(campaigns_graphql);
;// CONCATENATED MODULE: ./src/hooks/campaigns/use-campaigns-time-machine.ts
function use_campaigns_time_machine_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function use_campaigns_time_machine_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function use_campaigns_time_machine_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function use_campaigns_time_machine_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function use_campaigns_time_machine_slicedToArray(arr, i) {
    return use_campaigns_time_machine_arrayWithHoles(arr) || use_campaigns_time_machine_iterableToArrayLimit(arr, i) || use_campaigns_time_machine_unsupportedIterableToArray(arr, i) || use_campaigns_time_machine_nonIterableRest();
}
function use_campaigns_time_machine_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return use_campaigns_time_machine_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return use_campaigns_time_machine_arrayLikeToArray(o, minLen);
}




var useCampaignsTimeMachine = function(displayDate) {
    // Keep this state is to know if we should do a re-fetch
    // when the display date is cleared (i.e. undefined), but avoid
    // fetching when undefined on first render.
    var ref = use_campaigns_time_machine_slicedToArray((0,react.useState)(false), 2), shouldUpdate = ref[0], setShouldUpdate = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var timestamp = displayDate === null || displayDate === void 0 ? void 0 : displayDate.getTime().toString();
    // Fetch campaigns with the current display date
    var ref1 = (0,use_gql_query/* useGqlQuery */.n)({
        query: (campaigns_graphql_default()),
        queryKey: [
            "campaigns-v2",
            timestamp
        ],
        enabled: shouldUpdate || displayDate !== undefined,
        variables: {
            timestamp: timestamp
        }
    }), data = ref1.data, isError = ref1.isError, isLoading = ref1.isLoading;
    // Dispatch campaigns result to redux store
    (0,react.useEffect)(function() {
        if (!isLoading && !isError && data) {
            setShouldUpdate(true);
            var _campaignsV2;
            dispatch({
                type: "CAMPAIGNS_V2_RECEIVE",
                /**
         * @type {import('src/hooks/campaigns/use-campaigns').ReduxCampaignsV2Data}
         */ campaignsV2: {
                    allCampaigns: (_campaignsV2 = data.campaignsV2) !== null && _campaignsV2 !== void 0 ? _campaignsV2 : []
                }
            });
        }
    }, [
        data,
        isError,
        isLoading,
        dispatch
    ]);
    return data;
};

;// CONCATENATED MODULE: ./src/PageNotFound.tsx




var PageNotFound = function() {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
        status: 404
    }), /*#__PURE__*/ react.createElement(meta_tags, {
        metaTags: {
            title: "".concat(t("errors", "internal.unknown"), " (", 404, ")")
        }
    }));
};

// EXTERNAL MODULE: ./src/routes/config.ts + 85 modules
var config = __webpack_require__(6290);
;// CONCATENATED MODULE: ./src/app.tsx
function app_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function app_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function app_extends() {
    app_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return app_extends.apply(this, arguments);
}
function app_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function app_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function app_slicedToArray(arr, i) {
    return app_arrayWithHoles(arr) || app_iterableToArrayLimit(arr, i) || app_unsupportedIterableToArray(arr, i) || app_nonIterableRest();
}
function app_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return app_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return app_arrayLikeToArray(o, minLen);
}






































var Error500 = function() {
    return /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
        status: 500
    });
};
var handleGraphqlRequestError = function(error) {
    return /*#__PURE__*/ react.createElement(ErrorPage, {
        error: error
    });
};
var isRedirectedFromMarketRegex = /(&|^\?)redirect=(it|pl)(&|$)/;
var scrollToTop = function() {
    var el = document.getElementById("app-layout");
    var ref;
    window.scrollTo({
        top: (ref = el === null || el === void 0 ? void 0 : el.offsetTop) !== null && ref !== void 0 ? ref : 0,
        behavior: "smooth"
    });
};
/**
 * A number so that we can track the render after the
 * initial mounting. This is when experiments are loaded and viewportcontext is updated.
 * This is used to add user performance timings.
 */ var renders = 0;
var app_App = function(param) {
    var callback = param.callback;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var pathname = location.pathname, search = location.search;
    var currentLocation = "".concat(pathname).concat(search);
    var renderToastContainer = (0,es/* useSelector */.v9)(function(state) {
        return state.toast.required;
    });
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.globals;
    }), _layout = ref.layout, layout = _layout === void 0 ? "default" : _layout;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), _market = ref1.market, code = _market.code, routes = _market.routes, renderMode = ref1.renderMode;
    var previousLocation = (0,location_context/* useLocationContext */.F)().previousLocation;
    var ref2 = useFetchQueryError(), fetchQueryError = ref2.error;
    var ref3 = app_slicedToArray((0,react.useState)(false), 2), isNextJsLoaderActive = ref3[0], setNextJsLoaderActive = ref3[1];
    renders += 1;
    if (renders === 2) {
        performance_reporter("firstRerender");
    }
    var openNewsletterSignup = Object.keys(querystring.parse(location.search.substr(1))).includes(NEWSLETTER_PARAM);
    var isRedirectedFromMarket = isRedirectedFromMarketRegex.test(location.search);
    var redirectedFromMarket = isRedirectedFromMarket && (isRedirectedFromMarketRegex.exec(location.search) || []).filter(function(match) {
        return /^(it|pl)$/.test(match);
    }).pop();
    var isWebViewLayout = renderMode === "native";
    var routesWithPaths = (0,react.useMemo)(function() {
        return Object.values((0,config/* buildRouteConfig */.v)(code, routes));
    }, [
        code,
        routes
    ]);
    (0,react.useEffect)(function() {
        if (!isNextJsProxyEnabledClient()) {
            return;
        }
        if ((0,rfe_nextjs_proxy_dist.isProxyMarket)(code) && (0,rfe_nextjs_proxy_dist.isNextJsPath)(currentLocation, code, NEXTJS_EXPERIMENTAL_ROUTES)) {
            setNextJsLoaderActive(true);
            window.location.reload();
        }
    }, [
        currentLocation,
        code
    ]);
    var account = (0,use_account/* useAccount */.m)();
    var refreshSession = account.refreshSession;
    var displayWelcomePageAd = !previousLocation; // only show welcome page ad on initial page load
    (0,react.useEffect)(function() {
        window.addEventListener("focus", refreshSession);
        return function() {
            window.removeEventListener("focus", refreshSession);
        };
    }, [
        refreshSession
    ]);
    // Campaign states
    var ref4 = (0,use_campaigns/* useCampaigns */.t)(), allCampaigns = ref4.allCampaigns, announcementBanner = ref4.announcementBanner;
    var ref5 = app_slicedToArray((0,react.useState)((0,frontend_admin_ui_dist_module.getCampaignSettings)()), 2), campaignSettings = ref5[0], onCampaignSettingsChange = ref5[1];
    var campaignsAdminProps = (0,react.useMemo)(function() {
        return {
            allCampaigns: allCampaigns,
            onCampaignSettingsChange: onCampaignSettingsChange
        };
    }, [
        allCampaigns,
        onCampaignSettingsChange
    ]);
    useCampaignsTimeMachine(campaignSettings.displayDate);
    // Only render FrontEndAdmin client side
    var ref6 = app_slicedToArray((0,react.useState)(false), 2), showFrontEndAdmin = ref6[0], setShowFrontEndAdmin = ref6[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        return setShowFrontEndAdmin(((ref = window.SESSION_DATA) === null || ref === void 0 ? void 0 : (ref1 = ref.experiments) === null || ref1 === void 0 ? void 0 : ref1.env) === "dev");
    }, []);
    return /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: Error500
    }, displayWelcomePageAd ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(dist_module/* WelcomePageAd */.DD, {
        format: "welcome_page_wde",
        onCloseClick: scrollToTop,
        key: "desktop-welcomead-".concat(location.pathname + location.search)
    }), /*#__PURE__*/ react.createElement(dist_module/* WelcomePageAd */.DD, {
        format: "welcome_page",
        onCloseClick: scrollToTop,
        key: "mobile-welcomead-".concat(location.pathname + location.search)
    })) : null, /*#__PURE__*/ react.createElement(App, {
        layout: layout,
        ref: callback,
        id: "app-layout"
    }, openNewsletterSignup && /*#__PURE__*/ react.createElement(newsletter_signup_modal, null), /*#__PURE__*/ react.createElement(viewport_tracker/* ViewportTracker */.t, null, !isWebViewLayout && /*#__PURE__*/ react.createElement(header, null), renderToastContainer && /*#__PURE__*/ react.createElement(toast_container/* default */.Z, null), /*#__PURE__*/ react.createElement(feedback/* default */.Z, null), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: Error500
    }, /*#__PURE__*/ react.createElement(userlike_chat/* UserlikeChatProvider */.gv, null, /*#__PURE__*/ react.createElement(SourcepointProvider, null, /*#__PURE__*/ react.createElement(wide_context/* WideContextProvider */.B, null, /*#__PURE__*/ react.createElement(MainIncludingAnnouncementBanner, null, (announcementBanner === null || announcementBanner === void 0 ? void 0 : announcementBanner.text) && /*#__PURE__*/ react.createElement(AnnouncementBanner, app_extends({}, announcementBanner)), /*#__PURE__*/ react.createElement(Main, {
        "data-test": "AppMain",
        "data-test-market-id": code
    }, !isWebViewLayout && /*#__PURE__*/ react.createElement(sidebar_desktop, null), /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: handleGraphqlRequestError
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Switch */.rs, null, routesWithPaths.map(function(param) {
        var path = param.path, component = param.component, _exact = param.exact, exact = _exact === void 0 ? true : _exact, disableScrollOnQueryUpdate = param.disableScrollOnQueryUpdate, disableScrollForUrlParam = param.disableScrollForUrlParam;
        var RouteComponent = component;
        var renderRouteComponent = function() {
            if (isNextJsLoaderActive) {
                return /*#__PURE__*/ react.createElement(loader/* default */.Z, null);
            }
            if (fetchQueryError && !previousLocation) {
                return /*#__PURE__*/ react.createElement(ErrorPage, {
                    error: fetchQueryError
                });
            }
            return /*#__PURE__*/ react.createElement(RouteComponent, null);
        };
        return /*#__PURE__*/ react.createElement(react_router_dom/* Route */.AW, {
            path: path,
            exact: exact,
            key: path.toString()
        }, /*#__PURE__*/ react.createElement(ScrollToTop, {
            disableScrollOnQueryUpdate: disableScrollOnQueryUpdate,
            disableScrollForUrlParam: disableScrollForUrlParam
        }), renderRouteComponent());
    }), /*#__PURE__*/ react.createElement(react_router_dom/* Route */.AW, {
        path: "*"
    }, /*#__PURE__*/ react.createElement(PageNotFound, null)))), !isWebViewLayout && /*#__PURE__*/ react.createElement(footer, null), /*#__PURE__*/ react.createElement(UpdateTermsAndConditionsModal, null)))))))), isRedirectedFromMarket && /*#__PURE__*/ react.createElement(shutdown_message/* default */.Z, {
        redirectedFromMarket: redirectedFromMarket
    }))), showFrontEndAdmin && /*#__PURE__*/ react.createElement(pj_frontend_admin/* PjFrontEndAdmin */.K, {
        campaigns: campaignsAdminProps,
        market: code
    }));
};
/* harmony default export */ var app = (/*#__PURE__*/(0,react.memo)(app_App));

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/client/experiments.tsx
function experiments_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function experiments_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function experiments_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return experiments_arrayLikeToArray(arr);
}
function experiments_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function experiments_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                experiments_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                experiments_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function experiments_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function experiments_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function experiments_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function experiments_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function experiments_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function experiments_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            experiments_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function experiments_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function experiments_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        experiments_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function experiments_slicedToArray(arr, i) {
    return experiments_arrayWithHoles(arr) || experiments_iterableToArrayLimit(arr, i) || experiments_unsupportedIterableToArray(arr, i) || experiments_nonIterableRest();
}
function experiments_toConsumableArray(arr) {
    return experiments_arrayWithoutHoles(arr) || experiments_iterableToArray(arr) || experiments_unsupportedIterableToArray(arr) || experiments_nonIterableSpread();
}
function experiments_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return experiments_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return experiments_arrayLikeToArray(o, minLen);
}
var experiments_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var updateViewedExperiments = function() {
    var _ref = experiments_asyncToGenerator(function(viewedExperiments) {
        var sessionData;
        return experiments_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,requests/* putSession */.hO)("viewedExperiments", viewedExperiments)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        (0,requests/* getSession */.Gg)()
                    ];
                case 2:
                    sessionData = _state.sent();
                    window.SESSION_DATA = sessionData;
                    (0,data_layer/* pushEvent */.A)("updateViewedExperiments", {
                        experiments: sessionData.experiments.optimize,
                        exp_variant_string: sessionData.experiments.experimentsGA4
                    }, {
                        eventNameAsKey: false
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return function updateViewedExperiments(viewedExperiments) {
        return _ref.apply(this, arguments);
    };
}();
var ExperimentContextContainer = function(param) {
    var children = param.children;
    var _SESSION_DATA = window.SESSION_DATA, session = _SESSION_DATA.session, experiments = _SESSION_DATA.experiments;
    var ref = experiments_slicedToArray(react.useState({
        applicationExperiments: [],
        selectedVariants: {},
        viewedExperiments: session.viewedExperiments || {}
    }), 2), state = ref[0], setState = ref[1];
    var debounceUpdateViewedExperiments = react.useCallback(debounce_default()(function(viewedExperiments) {
        return updateViewedExperiments(viewedExperiments);
    }, 500), []);
    var viewedExperimentsNeedsUpdate = react.useRef(false);
    react.useEffect(function() {
        // No need to update viewed experiments when this component mounts
        // since we get the session viewed experiments from session init callback
        // in `server/react/middlewares/out.js` when page loads and use that as default state
        if (viewedExperimentsNeedsUpdate.current) {
            debounceUpdateViewedExperiments(state.viewedExperiments);
        } else {
            viewedExperimentsNeedsUpdate.current = true;
        }
    }, [
        debounceUpdateViewedExperiments,
        state.viewedExperiments
    ]);
    var methods = react.useMemo(function() {
        var devMode = experiments.env === "dev";
        return {
            registerExperiment: function(experiment) {
                if (!devMode) {
                    return;
                }
                setState(function(currState) {
                    if (currState.applicationExperiments.find(function(e) {
                        return e.id === experiment.id;
                    })) {
                        return currState;
                    }
                    return experiments_objectSpreadProps(experiments_objectSpread({}, currState), {
                        applicationExperiments: experiments_toConsumableArray(currState.applicationExperiments).concat([
                            experiment
                        ])
                    });
                });
            },
            unregisterExperiment: function(id) {
                if (!devMode) return;
                setState(function(prevState) {
                    return experiments_objectSpreadProps(experiments_objectSpread({}, prevState), {
                        applicationExperiments: prevState.applicationExperiments.filter(function(experiment) {
                            return experiment.id !== id;
                        })
                    });
                });
            },
            selectVariant: function(experiment, variant) {
                (0,requests/* putSession */.hO)("selectedVariants", experiments_defineProperty({}, experiment.id, variant));
                setState(function(currState) {
                    return experiments_objectSpreadProps(experiments_objectSpread({}, currState), {
                        selectedVariants: experiments_objectSpreadProps(experiments_objectSpread({}, currState.selectedVariants), experiments_defineProperty({}, experiment.id, experiments_objectSpreadProps(experiments_objectSpread({}, experiment), {
                            selectedVariant: variant,
                            variantIndex: -1
                        })))
                    });
                });
            },
            setViewedExperiment: function(experimentId, variant) {
                if (state.viewedExperiments[experimentId] && state.viewedExperiments[experimentId].variant === variant) {
                    return;
                }
                setState(function(currState) {
                    return experiments_objectSpreadProps(experiments_objectSpread({}, currState), {
                        viewedExperiments: experiments_objectSpreadProps(experiments_objectSpread({}, currState.viewedExperiments), experiments_defineProperty({}, experimentId, {
                            variant: variant
                        }))
                    });
                });
            }
        };
    }, [
        experiments.env,
        state.viewedExperiments
    ]);
    var value = react.useMemo(function() {
        return experiments_objectSpread({
            showEditor: experiments.env === "dev",
            sessionId: session.id,
            selectedVariants: experiments_objectSpread({}, experiments.experiments, state.selectedVariants),
            viewedExperiments: state.viewedExperiments,
            experiments: state.applicationExperiments
        }, methods);
    }, [
        experiments.experiments,
        experiments.env,
        session.id,
        state.applicationExperiments,
        state.selectedVariants,
        state.viewedExperiments,
        methods
    ]);
    return /*#__PURE__*/ react.createElement(experiment/* ExperimentContext.Provider */.T.Provider, {
        value: value
    }, children);
};
/* harmony default export */ var experiments = (ExperimentContextContainer);

// EXTERNAL MODULE: ./src/areas/category/constants.ts
var category_constants = __webpack_require__(83220);
;// CONCATENATED MODULE: ./src/client/local-storage.tsx
function local_storage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function local_storage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            local_storage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function local_storage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function local_storage_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        local_storage_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/**
 * LocalStorage keys in this array will be checked if they have any content
 * on app instantiation, and a LOCAL_STORAGE_RECEIVE action will be triggered
 * in Redux with the content from LocalStorage. It's then up to individual
 * reducers to handle this data as they see fit.
 *
 * When the state is updated, LocalStorage will be updated at each key with
 * the data returned by the stateSelector function applied to the Redux state.
 */ var persistedStates = [
    {
        localStorageKey: category_constants/* LOCAL_STORAGE_FILTER_KEY */.vg,
        stateSelector: function(state) {
            return state.areas.category.filter.showHorizontalFilter;
        }
    },
    {
        localStorageKey: product_collection_constants/* PRODUCT_COLLECTION_LAYOUT */.xU,
        stateSelector: function(state) {
            return state.areas.productCollection.userSelectedLayout;
        }
    },
    {
        localStorageKey: constants/* SIDEBAR_LOCALSTORAGE_KEY */.yT,
        stateSelector: function(state) {
            var _sidebar = state.areas.sidebar, tab = _sidebar.tab, lists = _sidebar.lists;
            return {
                tab: tab,
                listSort: lists.sort && lists.direction ? "".concat(lists.sort, ":").concat(lists.direction) : lists.sort || undefined
            };
        }
    }
];
function getLocalStorageItem(key) {
    try {
        var serializedState = localStorage.getItem(key);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
}
function setLocalStorageItem(key, state) {
    try {
        var serializedState = JSON.stringify(state);
        localStorage.setItem(key, serializedState);
    } catch (e) {
    // Ignore any errors on write
    }
}
function deleteLocalStorageItem(key) {
    try {
        localStorage.removeItem(key);
    } catch (e) {
    // Ignore any errors on delete
    }
}
function getLocalStorageState() {
    return persistedStates.reduce(function(localStorageState, param) {
        var localStorageKey = param.localStorageKey;
        return local_storage_objectSpreadProps(local_storage_objectSpread({}, localStorageState), local_storage_defineProperty({}, localStorageKey, getLocalStorageItem(localStorageKey)));
    }, {});
}
function loadLocalStorageState(store) {
    var localStorageState = getLocalStorageState();
    store.dispatch({
        type: "LOCAL_STORAGE_RECEIVE",
        localStorageState: localStorageState
    });
}
function saveStateToLocalStorage(store) {
    persistedStates.forEach(function(param) {
        var localStorageKey = param.localStorageKey, stateSelector = param.stateSelector;
        var state = stateSelector(store.getState());
        if (state === undefined) {
            deleteLocalStorageItem(localStorageKey);
        } else {
            setLocalStorageItem(localStorageKey, state);
        }
    });
}

// EXTERNAL MODULE: ./src/client/query.js
var query = __webpack_require__(492);
;// CONCATENATED MODULE: ./src/client/index.js
// polyfill
function client_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function client_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function client_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function client_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function client_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) client_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) client_defineProperties(Constructor, staticProps);
    return Constructor;
}
function client_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function client_getPrototypeOf(o) {
    client_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return client_getPrototypeOf(o);
}
function client_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) client_setPrototypeOf(subClass, superClass);
}
function client_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            client_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function client_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function client_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        client_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function client_possibleConstructorReturn(self, call) {
    if (call && (client_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return client_assertThisInitialized(self);
}
function client_setPrototypeOf(o, p) {
    client_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return client_setPrototypeOf(o, p);
}
var client_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function client_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function client_createSuper(Derived) {
    var hasNativeReflectConstruct = client_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = client_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = client_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return client_possibleConstructorReturn(this, result);
    };
}
var client_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
































(0,sentry/* initSentry */.j6)();
smoothscroll_default().polyfill();
var client_history = (0,esm_history/* createBrowserHistory */.lX)();
window.__history = client_history;
window.__getState = store/* default.getState */.Z.getState;
window.APP_GLOBALS = {
    t: (0,translate/* translator */.O)(window.TRANSLATIONS, window.CLIENT_MARKET.locale)
};
window.IS_FLOOD_IO = window.navigator.userAgent.indexOf("Flood.io PJ") !== -1;
initWebVitalReports();
var queryClient = new lib/* QueryClient */.Su({
    defaultOptions: {
        queries: {
            keepPreviousData: true,
            retry: function(failureCount, error) {
                var ref, ref1;
                if ((ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1.find(function(e) {
                    return e.status === 404;
                })) {
                    return false;
                }
                return failureCount < 2;
            },
            refetchOnWindowFocus: false
        }
    }
});
var dehydratedState = window.__REACT_QUERY_STATE__;
var dispatchSession = function(sessionData) {
    var session = sessionData.session;
    store/* default.dispatch */.Z.dispatch({
        type: "SESSION_RECEIVE",
        session: session
    });
};
var dispatchMe = function() {
    var _ref = client_asyncToGenerator(function(currentUserSession) {
        var me;
        return client_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,requests/* initialMeQuery */.$g)()
                    ];
                case 1:
                    me = _state.sent();
                    if (me) {
                        store/* default.dispatch */.Z.dispatch({
                            type: "USER_RECEIVE",
                            me: client_objectSpreadProps(client_objectSpread({}, me), {
                                authenticationMethod: currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.authenticationMethod
                            })
                        });
                    } else {
                        store/* default.dispatch */.Z.dispatch({
                            type: "USER_DESTROY"
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function dispatchMe(currentUserSession) {
        return _ref.apply(this, arguments);
    };
}();
// Handles Schibsted Account session changes
var onSessionChange = function() {
    var _ref = client_asyncToGenerator(function(param) {
        var type, previousSession, currentSession, prev, curr;
        return client_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    type = param.type, previousSession = param.previousSession, currentSession = param.currentSession;
                    prev = previousSession;
                    curr = currentSession;
                    if (type === "prisjakt-account") {
                        // If user changed for any reason update GTM data layer variable
                        if ((prev === null || prev === void 0 ? void 0 : prev.userId) !== (curr === null || curr === void 0 ? void 0 : curr.userId)) {
                            (0,data_layer/* pushEvent */.A)("prisjaktAccountUser", {
                                id: curr === null || curr === void 0 ? void 0 : curr.userId
                            });
                        }
                    }
                    // No session active.
                    // No user is logged in yet.
                    // No action needed.
                    if (!prev && !curr) {
                        // Here because we need to set the
                        // state.areas.account.loading to false
                        // so that the simplified login widget can be shown.
                        store/* default.dispatch */.Z.dispatch({
                            type: "USER_STOP_LOADING"
                        });
                        return [
                            2
                        ];
                    }
                    if (!(!prev && curr)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        dispatchMe(curr)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    // Session associated with current user.
                    // Happens if user is still logged in.
                    // No action needed.
                    if ((prev === null || prev === void 0 ? void 0 : prev.userId) && (curr === null || curr === void 0 ? void 0 : curr.userId) && (prev === null || prev === void 0 ? void 0 : prev.userId) === (curr === null || curr === void 0 ? void 0 : curr.userId)) {
                        return [
                            2
                        ];
                    }
                    if (!((prev === null || prev === void 0 ? void 0 : prev.userId) && (curr === null || curr === void 0 ? void 0 : curr.userId) && (prev === null || prev === void 0 ? void 0 : prev.userId) !== (curr === null || curr === void 0 ? void 0 : curr.userId))) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        dispatchMe(curr)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
                case 4:
                    if (!((prev === null || prev === void 0 ? void 0 : prev.userId) && !(curr === null || curr === void 0 ? void 0 : curr.userId))) return [
                        3,
                        7
                    ];
                    if (!(type === "prisjakt-account")) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        (0,requests/* destroyPjAccountSession */.l5)()
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    store/* default.dispatch */.Z.dispatch({
                        type: "USER_DESTROY"
                    });
                    (0,data_layer/* pushEvent */.A)("logoutComplete", {
                        loggedIn: false
                    });
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return function onSessionChange(_) {
        return _ref.apply(this, arguments);
    };
}();
var dispatchAdLoaded = function(placement, obj) {
    store/* default.dispatch */.Z.dispatch({
        type: "AD_LOADED",
        placement: placement,
        ad: client_objectSpreadProps(client_objectSpread({}, obj), {
            revenue: obj.cpm_publisher_currency * 0.001
        })
    });
};
var AppWithViewport = /*#__PURE__*/ function(_Component) {
    "use strict";
    client_inherits(AppWithViewport, _Component);
    var _super = client_createSuper(AppWithViewport);
    function AppWithViewport(props) {
        client_classCallCheck(this, AppWithViewport);
        var _this;
        _this = _super.call(this, props);
        client_defineProperty(client_assertThisInitialized(_this), "fetchContextValue", client_objectSpread({
            query: query/* default */.Z
        }, window.CONTEXTS.fetch));
        _this.state = {
            initialRender: window.SERVER_SIDE_RENDER_ROUTES === false
        };
        return _this;
    }
    client_createClass(AppWithViewport, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.state.initialRender) {
                    this.setState({
                        initialRender: false
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var AccountProvider = window.CLIENT_MARKET.login.enabled ? ClientAccountProvider : react.Fragment;
                return /*#__PURE__*/ react.createElement(react_router/* Router */.F0, {
                    history: client_history
                }, /*#__PURE__*/ react.createElement(app_context/* AppContextContainer */.hw, {
                    rngSeed: window.RNG_SEED,
                    renderMode: window.RENDER_CONTEXT_MODE,
                    market: window.CLIENT_MARKET,
                    locale: window.LOCALE,
                    translations: window.TRANSLATIONS,
                    sentryPromise: sentry/* sentryPromise */._8,
                    productOfTheYear: window.CONTEXTS.productsOfTheYear
                }, /*#__PURE__*/ react.createElement(location_context/* LocationProvider */.v, null, /*#__PURE__*/ react.createElement(lib/* QueryClientProvider */.aH, {
                    client: queryClient
                }, /*#__PURE__*/ react.createElement(lib/* Hydrate */.pO, {
                    state: dehydratedState
                }, /*#__PURE__*/ react.createElement(base/* StyledTheme */.VA, null, /*#__PURE__*/ react.createElement(fetch_context/* default.Provider */.Z.Provider, {
                    value: this.fetchContextValue
                }, /*#__PURE__*/ react.createElement(FetchQueryErrorProvider, {
                    error: window.CONTEXTS.fetchQueryError
                }, /*#__PURE__*/ react.createElement(AccountProvider, {
                    onSessionChange: onSessionChange
                }, /*#__PURE__*/ react.createElement(dist_module/* AdsProvider */.iH, {
                    countryCode: window.CONTEXTS.ads.countryCode,
                    enableDevtools: window.CONTEXTS.ads.enableDevtools,
                    pagegen: "rfe",
                    onAdLoaded: dispatchAdLoaded
                }, /*#__PURE__*/ react.createElement(es/* Provider */.zt, {
                    store: store/* default */.Z
                }, /*#__PURE__*/ react.createElement(experiments, null, /*#__PURE__*/ react.createElement(context/* ViewportContextContainer */.Pi, null, /*#__PURE__*/ react.createElement(app, {
                    callback: this.props.callback
                })))), /*#__PURE__*/ react.createElement(dist_module/* Devtools */.is, null))))))), /*#__PURE__*/ react.createElement(build_lib/* ReactQueryDevtools */.t, {
                    initialIsOpen: false,
                    position: "top-right"
                })))));
            }
        }
    ]);
    return AppWithViewport;
}(react.Component);
performance_reporter("startHydration");
var renderAppCallback = function() {
    performance_reporter("hydrationCompleted");
    window.PRE_TRACK_CLICKS = false;
    dispatchSession(window.SESSION_DATA);
    loadLocalStorageState(store/* default */.Z);
    store/* default.subscribe */.Z.subscribe(throttle_default()(function() {
        saveStateToLocalStorage(store/* default */.Z);
    }, 1000));
    if (/[&?]_verify_complete\b/.test(window.location.search)) {
        var paramValue = window.location.search.match(/[&?]_verify_complete=([^&]+)/);
        var mode = paramValue.length > 1 ? paramValue[1] : null;
        store/* default.dispatch */.Z.dispatch({
            type: "VERIFY_ACCOUNT_COMPLETE",
            mode: mode
        });
    }
};
var renderApp = function() {
    var root;
    var container = document.getElementById("root");
    if (!root) {
        // Don't need to call `render` here because `hydrateRoot` will take care of it
        root = (0,client/* hydrateRoot */.a)(container, /*#__PURE__*/ react.createElement(AppWithViewport, {
            callback: renderAppCallback
        }), {
            onRecoverableError: function onRecoverableError(error) {
                (0,sentry/* captureException */.Tb)(error);
            }
        });
    } else {
        root.render(/*#__PURE__*/ react.createElement(AppWithViewport, {
            callback: renderAppCallback
        }));
    }
};
if (!window.TRANSLATIONS) {
    throw new Error("Missing translations, aborting hydrate");
}
var done = after_default()(2, renderApp);
window.sessionReady(done);
(0,loadable_esm/* loadableReady */.TA)(done);


/***/ }),

/***/ 492:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var js_sha256__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5589);
/* harmony import */ var js_sha256__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_sha256__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

/**
 NOTE: In order to save sent bytes from the client
 this method tries to run a fetch without uploading the
 query itself. If server and client versions differ
 the fetch reruns with query included
* */ var execQuery = function() {
    var _ref = _asyncToGenerator(function(query, variables) {
        var ref, fetchOptions, res, json;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetchOptions = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    };
                    return [
                        4,
                        fetch("/_internal/bff", _objectSpreadProps(_objectSpread({}, fetchOptions), {
                            method: "POST",
                            body: JSON.stringify({
                                query: "hash:".concat((0,js_sha256__WEBPACK_IMPORTED_MODULE_0__.sha256)(query)),
                                variables: variables
                            })
                        }))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    json = _state.sent();
                    if (res.status === 200 && !((ref = json.errors) === null || ref === void 0 ? void 0 : ref.length)) {
                        return [
                            2,
                            json
                        ];
                    }
                    // If no success, try again with query
                    return [
                        2,
                        fetch("/_internal/bff", _objectSpreadProps(_objectSpread({}, fetchOptions), {
                            method: "POST",
                            body: JSON.stringify({
                                query: query,
                                variables: variables
                            })
                        })).then(function(x) {
                            return x.json();
                        })
                    ];
            }
        });
    });
    return function execQuery(query, variables) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (execQuery);


/***/ }),

/***/ 77679:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ client_store)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/redux@4.0.1/node_modules/redux/es/redux.js
var redux = __webpack_require__(59715);
// EXTERNAL MODULE: ./node_modules/.pnpm/redux-saga@1.0.3/node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js + 2 modules
var redux_saga_core_npm_proxy_esm = __webpack_require__(21396);
// EXTERNAL MODULE: ./src/globals/actions/index.ts
var actions = __webpack_require__(99311);
;// CONCATENATED MODULE: ./src/globals/reducers/index.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var globals = function() {
    var // eslint-disable-next-line default-param-last
    state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        layout: "default",
        campaigns: {
            active: []
        },
        /**
     * @type {import('src/hooks/campaigns/use-campaigns').ReduxCampaignsV2Data}
     */ campaignsV2: {
            allCampaigns: []
        },
        campaignBanners: {
            active: []
        },
        infoPages: {
            nodes: [],
            open: function() {}
        }
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "CAMPAIGNS_RECEIVE":
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    campaigns: {
                        active: action.campaigns.filter(function(c) {
                            return c.state === "ACTIVE";
                        })
                    },
                    campaignBanners: {
                        active: action.campaigns.reduce(function(allBanners, campaign) {
                            return allBanners.concat(campaign.banners.map(function(banner) {
                                return _objectSpreadProps(_objectSpread({}, banner), {
                                    campaign: campaign
                                });
                            }));
                        }, [])
                    }
                });
            }
        case "CAMPAIGNS_V2_RECEIVE":
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    /**
         * @type {import('src/hooks/campaigns/use-campaigns').ReduxCampaignsV2Data}
         */ campaignsV2: _objectSpread({}, state.campaignsV2, action.campaignsV2)
                });
            }
        case "FILTER_TOGGLE_MOBILE":
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    layout: action.open ? "raw-mobile" : "default"
                });
            }
        case actions/* DANGEROUS_CONFIG_RECEIVE */.R5:
        case "BRAND_MEDIA_TOGGLE":
        case "PRODUCT_MEDIA_OPEN":
            {
                return _objectSpread({}, state);
            }
        case actions/* INFO_PAGES_RECEIVE */.DU:
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    infoPages: action.pages
                });
            }
        default:
    }
    return state;
};
/* harmony default export */ var reducers = (globals);

// EXTERNAL MODULE: ./src/areas/feedback/actions/index.js
var feedback_actions = __webpack_require__(18969);
;// CONCATENATED MODULE: ./src/areas/feedback/reducers/index.js
function reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var reducer = function(state, action) {
    if (!state) {
        return {
            id: 0,
            open: false,
            sending: false,
            thanks: false,
            error: undefined,
            email: undefined
        };
    }
    switch(action.type){
        case "__DANGEROUS_CONFIG_RECEIVE":
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    group: action.server.feedbackGroup,
                    tag: action.server.feedbackTag
                });
            }
        case feedback_actions/* FEEDBACK_OPEN */.hy:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    open: true
                });
            }
        case feedback_actions/* FEEDBACK_CLOSE */._d:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    open: false
                });
            }
        case feedback_actions/* FEEDBACK_CLEAR_FORM */.YB:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    id: state.id + 1,
                    thanks: false,
                    error: undefined,
                    open: false
                });
            }
        case feedback_actions/* FEEDBACK_SEND_REQUEST */.ph:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    sending: true
                });
            }
        case feedback_actions/* FEEDBACK_REPORT_WRONG_PRICE */.r_:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    sending: true
                });
            }
        case feedback_actions/* FEEDBACK_SEND_SUCCESS */.Ly:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    sending: false,
                    thanks: true
                });
            }
        case feedback_actions/* FEEDBACK_SEND_FAILED */.d2:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    sending: false,
                    error: action.message,
                    thanks: false
                });
            }
        case "SESSION_RECEIVE":
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    email: action.session.email
                });
            }
        default:
    }
    return state;
};
/* harmony default export */ var feedback_reducers = (reducer);

;// CONCATENATED MODULE: ./src/areas/footer/reducers/types.ts
var FOOTER_ARTICLES_RECEIVE = "FOOTER_ARTICLES_RECEIVE";

;// CONCATENATED MODULE: ./src/areas/footer/reducers/index.tsx
function footer_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function footer_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            footer_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function footer_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function footer_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        footer_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var initialState = {
    socialNetworks: [],
    current: "",
    sites: [],
    articles: [],
    url: {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    open: function() {}
};
function reducers_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return footer_reducers_objectSpreadProps(footer_reducers_objectSpread({}, initialState), {
            current: ""
        });
    }
    switch(action.type){
        /**
      NOTE: All config is dispatch, any data returned will be sent
      down to the browser. Make sure no secrets is leaking!
    * */ case actions/* DANGEROUS_CONFIG_RECEIVE */.R5:
            {
                var market = action.market, markets = action.markets, server = action.server;
                return footer_reducers_objectSpreadProps(footer_reducers_objectSpread({}, state), {
                    current: market.countryCode,
                    sites: Object.keys(markets).filter(function(code) {
                        return server.appEnv === "production" ? markets[code].active : true;
                    }).map(function(code) {
                        return {
                            url: markets[code].sites[server.appEnv],
                            code: code
                        };
                    }),
                    socialNetworks: Object.keys(market.socialNetworks || {}).map(function(name) {
                        return {
                            name: name,
                            link: market.socialNetworks[name].link
                        };
                    }),
                    url: {
                        campaigns: market.url && market.url.campaigns ? market.url.campaigns : undefined
                    }
                });
            }
        case FOOTER_ARTICLES_RECEIVE:
            {
                return footer_reducers_objectSpreadProps(footer_reducers_objectSpread({}, state), {
                    articles: action.articles
                });
            }
        default:
    }
    return state;
}

// EXTERNAL MODULE: ./src/areas/product/actions/types.ts
var types = __webpack_require__(37637);
;// CONCATENATED MODULE: ./src/areas/product/reducer/index.ts
function reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var defaultProductState = {
    campaigns: null,
    variantSizes: null,
    condition: "new"
};
/* harmony default export */ function product_reducer(state, action) {
    if (!state) {
        return defaultProductState;
    }
    switch(action.type){
        case types/* ProductActionType.CAMPAIGNS_RECEIVE */.Z.CAMPAIGNS_RECEIVE:
            {
                return reducer_objectSpreadProps(reducer_objectSpread({}, state), {
                    campaigns: action.campaigns && action.campaigns.filter(function(campaign) {
                        return campaign.state === "ACTIVE";
                    })
                });
            }
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(33944);
;// CONCATENATED MODULE: ./src/areas/product-alert/reducers/index.js
function product_alert_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_alert_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_alert_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_alert_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_alert_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_alert_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function product_alert_reducers() {
    var // eslint-disable-next-line default-param-last
    state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        sending: false,
        error: false,
        success: false
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case actions_alert/* REMOVE_ALERT_REQUEST */.$x:
        case actions_alert/* CREATE_ALERT_REQUEST */.Oi:
            {
                return product_alert_reducers_objectSpreadProps(product_alert_reducers_objectSpread({}, state), {
                    sending: true,
                    error: false
                });
            }
        case actions_alert/* REMOVE_ALERT_SUCCESS */.$_:
        case actions_alert/* CREATE_ALERT_SUCCESS */.mx:
            {
                return product_alert_reducers_objectSpreadProps(product_alert_reducers_objectSpread({}, state), {
                    sending: false,
                    success: true
                });
            }
        case actions_alert/* REMOVE_ALERT_ERROR */.XJ:
        case actions_alert/* CREATE_ALERT_FAILED */.VL:
            {
                return product_alert_reducers_objectSpreadProps(product_alert_reducers_objectSpread({}, state), {
                    sending: false,
                    error: action.error
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/category/actions/category.js
var category = __webpack_require__(75554);
;// CONCATENATED MODULE: ./src/areas/category/reducers/category.js
function category_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function category_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            category_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function category_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function category_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        category_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function reducers_category(state, action) {
    if (!state) {
        return {
            id: null
        };
    }
    switch(action.type){
        case category/* CATEGORY_LAYOUT_CHANGED */.Hp:
            {
                return category_objectSpreadProps(category_objectSpread({}, state), {
                    mode: action.mode
                });
            }
        case "SESSION_RECEIVE":
            {
                return category_objectSpreadProps(category_objectSpread({}, state), {
                    mode: action.session.categoryLayout || state.mode
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/category/actions/filter.js
var filter = __webpack_require__(67536);
// EXTERNAL MODULE: ./src/areas/category/constants.ts
var constants = __webpack_require__(83220);
;// CONCATENATED MODULE: ./src/areas/category/reducers/filter.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function filter_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function filter_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        filter_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var hasChangedCategory = function(action, state) {
    return action.categoryData.categoryId !== state.loadedCategoryId || action.categoryData.categoryId === state.loadedCategoryId && state.toggledBrandCategory;
};
var getSelectionFromQuery = function(_param, currentlySelected) {
    var type = _param.type, categoryId = _param.categoryId, query = _objectWithoutProperties(_param, [
        "type",
        "categoryId"
    ]);
    var filterIds = Object.keys(query).reduce(function(all, sectionId) {
        var values = query[sectionId];
        return Array.isArray(values) ? values.map(function(valueId) {
            return "".concat(sectionId, "-").concat(valueId);
        }).concat(all) : all.concat(sectionId);
    }, []);
    var stillSelected = Object.keys(currentlySelected).filter(function(key) {
        return filterIds.includes(key);
    }).reduce(function(obj, key) {
        return filter_objectSpreadProps(filter_objectSpread({}, obj), filter_defineProperty({}, key, currentlySelected[key]));
    }, {});
    return {
        stillSelected: stillSelected,
        query: query
    };
};
var getSelection = function(_param) {
    var id = _param.id, value = _param.value, checked = _param.checked, filterType = _param.filterType, rest = _objectWithoutProperties(_param, [
        "id",
        "value",
        "checked",
        "filterType"
    ]);
    var data = filter_objectSpread({
        id: id,
        value: value,
        checked: checked,
        filterType: filterType
    }, rest);
    switch(filterType){
        case "list":
            return filter_defineProperty({}, "".concat(id, "-").concat(value), checked ? data : null);
        case "boolean":
        case "slider":
        default:
            return filter_defineProperty({}, id, data);
    }
};
/* harmony default export */ function reducers_filter(state, action) {
    var initialState = {
        selected: [],
        categoryId: null,
        isBrandCategory: false,
        toggledBrandCategory: false,
        loadedCategoryId: undefined,
        query: {},
        definition: [],
        values: {},
        core: [],
        expandedCategories: [],
        mobileOpen: false,
        error: undefined,
        comparing: [],
        showFilter: false,
        productCount: null,
        showHorizontalFilter: undefined
    };
    if (!state) {
        return initialState;
    }
    switch(action.type){
        case "ROUTE_LOADED":
            {
                // NOTE: Reset filter on category receive, noop if same category is received
                if (!action.route || action.route.name !== "category") {
                    return initialState;
                }
                // Abort if category data is missing (404)
                if (!action.data || !action.data.category) {
                    return initialState;
                }
                var category = action.data.category;
                var categoryId = category && category.id;
                var brand = action.route.variables.brand || null;
                var initialStateSetup = filter_objectSpreadProps(filter_objectSpread({}, initialState), {
                    isBrandCategory: !!brand,
                    toggledBrandCategory: !brand && state.isBrandCategory || brand && !state.isBrandCategory,
                    comparing: category && category.products && category.products.pageInfo && category.products.pageInfo.selectedProperties && category.products.pageInfo.selectedProperties.map(function(x) {
                        return x.id;
                    }).slice(0, 3)
                });
                if (state.categoryId === categoryId && state.isBrandCategory !== !!brand) {
                    return initialStateSetup;
                }
                if (state.categoryId === categoryId) {
                    return filter_objectSpreadProps(filter_objectSpread({}, state), {
                        isBrandCategory: !!brand,
                        toggledBrandCategory: !brand && state.isBrandCategory || brand && !state.isBrandCategory
                    });
                }
                return initialStateSetup;
            }
        case filter/* FILTER_CHANGE_ACTION */.$H:
            {
                // When clearing all fields for a section the action data
                // is a new query with the cleared sections removed.
                // Update selection tags to match this.
                if (!action.id) {
                    var ref = getSelectionFromQuery(action, state.selected), stillSelected = ref.stillSelected, query = ref.query;
                    return filter_objectSpreadProps(filter_objectSpread({}, state), {
                        selected: stillSelected,
                        query: query
                    });
                }
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    selected: filter_objectSpread({}, state.selected, getSelection(action))
                });
            }
        case filter/* FILTER_EXPAND_SECTION */.c8:
            {
                if (state.expandedCategories.includes(action.name)) {
                    return filter_objectSpreadProps(filter_objectSpread({}, state), {
                        expandedCategories: state.expandedCategories.filter(function(name) {
                            return name !== action.name;
                        })
                    });
                }
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    expandedCategories: _toConsumableArray(state.expandedCategories).concat([
                        action.name
                    ])
                });
            }
        case filter/* FILTER_TOGGLE_MOBILE */.WK:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    mobileOpen: action.open
                });
            }
        case filter/* FILTER_RECEIVE */.vN:
            {
                var newState = filter_objectSpreadProps(filter_objectSpread({}, state, action.categoryData), {
                    showFilter: true,
                    error: undefined
                });
                if (action.data.item) {
                    newState.values = filter_objectSpread({}, state.values, action.data.item);
                }
                if (// NOTE: Skip this update if initial load is done
                hasChangedCategory(action, state) && action.data.meta && action.data.meta.property_definitions) {
                    var meta = action.data.meta;
                    var coreProps = new Array(meta.core_properties.length);
                    // Recursively create a new array of filter sections based on `property_definitions`
                    // excluding core property sections but includes the core properties children.
                    var createSubProperties = function(properties) {
                        return properties.map(function(property) {
                            if (meta.core_properties.includes(property.id)) {
                                var index = meta.core_properties.indexOf(property.id);
                                // We need to save the property `child` in its matching `property` index
                                // to maintain the correct order of coreProperties
                                // Sub properties `children` that are not marked as core are moved to its
                                // parent section. So we can null it here
                                coreProps[index] = filter_objectSpreadProps(filter_objectSpread({}, property), {
                                    children: null
                                });
                                if (property.children) {
                                    return createSubProperties(property.children);
                                }
                                return null;
                            }
                            return property;
                        }).filter(function(p) {
                            return p;
                        }).flat();
                    }; // from core-js
                    var defs = meta.property_definitions.map(function(def) {
                        return filter_objectSpreadProps(filter_objectSpread({}, def), {
                            children: createSubProperties(def.children)
                        });
                    });
                    var first = coreProps.filter(function(p) {
                        return [
                            "brands",
                            "price"
                        ].includes(p.id);
                    });
                    var rest = coreProps.filter(function(p) {
                        return ![
                            "brands",
                            "price"
                        ].includes(p.id);
                    });
                    newState.core = _toConsumableArray(first).concat(_toConsumableArray(rest));
                    newState.definition = defs;
                }
                if (// NOTE: Skip this update if initial load is done
                hasChangedCategory(action, state) && action.data.meta) {
                    newState.query = action.data.meta.filter_settings || {};
                    // Brand ids are strings in some API responses and numbers in others. That should be fixed, but it's probably part of a bigger filter overhaul...
                    // In order to support strict equality checks in client-side operations, we just convert them to strings here for now.
                    if (newState.query.brands) {
                        newState.query.brands = newState.query.brands.map(function(id) {
                            return id.toString();
                        });
                    }
                }
                newState.loadedCategoryId = action.categoryData.categoryId;
                return newState;
            }
        case filter/* FILTER_FETCH_FAILED */.I2:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    error: action.error
                });
            }
        case filter/* FILTER_QUERY */.JL:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    query: action.query
                });
            }
        case "LOCAL_STORAGE_RECEIVE":
            {
                var filterStateFromLocalStorage = action.localStorageState[constants/* LOCAL_STORAGE_FILTER_KEY */.vg];
                if (filterStateFromLocalStorage) {
                    return filter_objectSpreadProps(filter_objectSpread({}, state), {
                        showHorizontalFilter: filterStateFromLocalStorage
                    });
                }
                return state;
            }
        case filter/* SET_HORIZONTAL_FILTER */.vd:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    showHorizontalFilter: action.show
                });
            }
        case filter/* COMPARE_PROPERTIES */.HW:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    comparing: action.propertyIds
                });
            }
        case filter/* COMPARE_PROPERTY */.gd:
            {
                var selected = state.comparing.includes(action.propertyId);
                var comparing = selected ? state.comparing.filter(function(x) {
                    return x !== action.propertyId;
                }) : state.comparing.concat(action.propertyId);
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    comparing: _toConsumableArray(new Set(comparing))
                });
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/areas/category/reducers/search.js
function search_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return search_arrayLikeToArray(arr);
}
function search_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function search_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function search_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function search_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        search_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function search_toConsumableArray(arr) {
    return search_arrayWithoutHoles(arr) || search_iterableToArray(arr) || search_unsupportedIterableToArray(arr) || search_nonIterableSpread();
}
function search_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_arrayLikeToArray(o, minLen);
}

var search_initialState = {
    inputValue: "",
    lastInputValue: "",
    filteredCore: [],
    filteredSections: [],
    filteredValues: {},
    disabledExpansions: [],
    categoryId: undefined
};
/* harmony default export */ function search(state, action) {
    if (!state) {
        return search_initialState;
    }
    switch(action.type){
        case "ROUTE_LOADED":
            {
                if (action.route && action.route.name === "category") {
                    var category = action.data && action.data.category;
                    var categoryId = category && category.id;
                    if (state.categoryId === categoryId) {
                        return state;
                    }
                    return search_objectSpreadProps(search_objectSpread({}, search_initialState), {
                        categoryId: categoryId
                    });
                }
                return state;
            }
        case filter/* PROPERTY_SEARCH_ACTION */.Q:
            {
                return search_objectSpreadProps(search_objectSpread({}, state), {
                    lastInputValue: state.inputValue,
                    inputValue: action.inputValue
                });
            }
        case filter/* PROPERTY_SEARCH_TOGGLE_SECTION */.eB:
            {
                if (state.disabledExpansions.includes(action.name)) {
                    return search_objectSpreadProps(search_objectSpread({}, state), {
                        disabledExpansions: state.disabledExpansions.filter(function(name) {
                            return name !== action.name;
                        })
                    });
                }
                return search_objectSpreadProps(search_objectSpread({}, state), {
                    disabledExpansions: search_toConsumableArray(state.disabledExpansions).concat([
                        action.name
                    ])
                });
            }
        case filter/* PROPERTY_SEARCH_COMPLETE */.kx:
            {
                return search_objectSpreadProps(search_objectSpread({}, state), {
                    filteredCore: action.filteredCore,
                    filteredSections: action.filteredSections,
                    filteredValues: action.filteredValues
                });
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/areas/category/reducers/product-list.js
function product_list_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_list_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_list_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_list_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_list_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_list_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function product_list(state, action) {
    if (!state) {
        return {
            loading: false
        };
    }
    switch(action.type){
        case "ROUTE_LOADED":
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: false
                });
            }
        case "SORT_CHANGE":
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: true
                });
            }
        case filter/* FILTER_CHANGE_ACTION */.$H:
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: true
                });
            }
        case filter/* FILTER_FETCH_FAILED */.I2:
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: false
                });
            }
        case filter/* FILTER_RECEIVE */.vN:
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: false
                });
            }
        default:
    }
    return state;
};

;// CONCATENATED MODULE: ./src/areas/category/reducers/index.js





/* harmony default export */ var category_reducers = ((0,redux.combineReducers)({
    category: reducers_category,
    filter: reducers_filter,
    search: search,
    productList: product_list
}));

// EXTERNAL MODULE: ./src/areas/account/actions/index.js
var account_actions = __webpack_require__(42692);
// EXTERNAL MODULE: ./src/areas/account/settings/actions/settings.js
var actions_settings = __webpack_require__(17686);
// EXTERNAL MODULE: ./src/areas/account/settings/actions/display-name.js
var display_name = __webpack_require__(25526);
// EXTERNAL MODULE: ./src/areas/account/settings/actions/alert-settings.js
var alert_settings = __webpack_require__(29559);
;// CONCATENATED MODULE: ./src/areas/account/reducers/index.js
function reducers_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function reducers_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return reducers_arrayLikeToArray(arr);
}
function account_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducers_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function reducers_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function account_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            account_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function account_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function account_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        account_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function reducers_toConsumableArray(arr) {
    return reducers_arrayWithoutHoles(arr) || reducers_iterableToArray(arr) || reducers_unsupportedIterableToArray(arr) || reducers_nonIterableSpread();
}
function reducers_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return reducers_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return reducers_arrayLikeToArray(o, minLen);
}




/* harmony default export */ function account_reducers() {
    var // eslint-disable-next-line default-param-last
    state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        isAuthenticated: false,
        me: undefined,
        id: undefined,
        name: undefined,
        settings: undefined,
        loading: true,
        shopPreference: {
            fetchingLikes: false,
            fetchingDislikes: false
        }
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "__DANGEROUS_CONFIG_RECEIVE":
            {
                var infoPageMap = action.market.infoPageMap;
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    infoPageMap: infoPageMap
                });
            }
        case "USER_STOP_LOADING":
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    loading: false
                });
            }
        case "USER_DESTROY":
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: undefined,
                    isAuthenticated: false,
                    loading: false
                });
            }
        case account_actions/* USER_RECEIVE */.dt:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpread({}, action.me),
                    isAuthenticated: true,
                    loading: false
                });
            }
        case actions_settings/* SETTINGS_START_EDITING */.Dl:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    settings: {
                        editing: action.settings,
                        errors: undefined,
                        saving: false
                    }
                });
            }
        case display_name/* DISPLAY_NAME_CHANGE */.Kc:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    settings: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.settings), {
                        saving: true
                    })
                });
            }
        case actions_settings/* SETTINGS_CHANGE_SUCCESS */.f1:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    settings: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.settings), {
                        editing: undefined,
                        errors: undefined,
                        saving: false
                    })
                });
            }
        case actions_settings/* SETTINGS_CHANGE_FAILED */.nA:
            {
                var errors = {
                    "registration.username-taken": "name",
                    "auth.invalid-credentials": "password",
                    "registration.password-length": "password",
                    "registration.invalid-email": "email",
                    "registration.email-invalid": "email",
                    "registration.email-in-use": "email",
                    "registration.verification-mail-not-sent": "email",
                    "validation.email-invalid": "email",
                    "request.invalid-parameter": "displayName"
                };
                var error = errors[action.error];
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    settings: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.settings), {
                        saving: false,
                        errors: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.settings.errors), account_reducers_defineProperty({}, error, action.error))
                    })
                });
            }
        case alert_settings/* ALERT_SETTINGS_CHANGE */.G5:
        case alert_settings/* ALERT_SETTINGS_CHANGE_SUCCESS */.Os:
            {
                var settings = {};
                if (Array.isArray(action.setting)) {
                    settings = action.setting.reduce(function(acc, curr) {
                        acc[curr.setting] = curr.value;
                        return acc;
                    }, {});
                } else {
                    settings = account_reducers_defineProperty({}, action.setting.setting, action.setting.value);
                }
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        alertSettings: account_reducers_objectSpread({}, state.me.alertSettings, settings)
                    })
                });
            }
        case display_name/* UPDATE_DISPLAY_NAME */.kr:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        displayName: action.displayName
                    })
                });
            }
        case "LIKE_REVIEW_SUCCESS":
            {
                var updatedLikes = action.value === "like" ? [
                    action.id
                ].concat(reducers_toConsumableArray(state.me.likes.reviews)) : state.me.likes.reviews.filter(function(review) {
                    return review !== action.id;
                });
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        likes: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.likes), {
                            reviews: updatedLikes
                        })
                    })
                });
            }
        case "LIKE_LIST_SUCCESS":
            {
                var updatedLikes1 = action.value === "like" ? [
                    action.id
                ].concat(reducers_toConsumableArray(state.me.likes.lists)) : state.me.likes.lists.filter(function(review) {
                    return review !== action.id;
                });
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        likes: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.likes), {
                            lists: updatedLikes1
                        })
                    })
                });
            }
        case "UPDATE_REVIEW_DATA":
            {
                if (!action.productId) return account_reducers_objectSpread({}, state);
                var myReview = action.nodes.find(function(review) {
                    return review.user.id === state.me.id;
                });
                var updatedProducts = reducers_toConsumableArray(state.me.reviewedProducts.filter(function(reviewedProduct) {
                    return reviewedProduct.productId !== action.productId;
                })).concat([
                    myReview ? {
                        productId: action.productId,
                        rating: myReview.rating
                    } : null
                ]).filter(function(x) {
                    return x;
                });
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        reviewedProducts: updatedProducts
                    })
                });
            }
        case actions_settings/* UPDATE_SUBSCRIPTION_SETTING */.X2:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        subscriptionSettings: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.subscriptionSettings), account_reducers_defineProperty({}, action.id, action.subscribed))
                    })
                });
            }
        case account_actions/* USER_LIKE_SHOP_REQUEST */.ie:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    shopPreference: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.shopPreference), {
                        fetchingLikes: true
                    })
                });
            }
        case account_actions/* USER_DISLIKE_SHOP_REQUEST */.oN:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    shopPreference: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.shopPreference), {
                        fetchingDislikes: true
                    })
                });
            }
        case account_actions/* USER_SHOP_PREFERENCE_ERROR */.xX:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    shopPreference: {
                        fetchingLikes: false,
                        fetchingDislikes: false
                    }
                });
            }
        case account_actions/* USER_SHOP_PREFERENCE_RECEIVE */.Lo:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    shopPreference: {
                        fetchingLikes: false,
                        fetchingDislikes: false
                    },
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        likes: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.likes), {
                            shops: action.shopPreferenceState.me.likes.shops
                        }),
                        dislikes: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.dislikes), {
                            shops: action.shopPreferenceState.me.dislikes.shops
                        })
                    })
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/navigation/actions/desktop.js
var desktop = __webpack_require__(72477);
;// CONCATENATED MODULE: ./src/areas/navigation/reducers/mega-menu.js
function mega_menu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mega_menu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mega_menu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function mega_menu_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mega_menu_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mega_menu_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function mega_menu(state, action) {
    if (!state) {
        return {
            openCategory: null,
            open: false,
            rootCategories: undefined
        };
    }
    switch(action.type){
        case "CATEGORIES_RECEIVE":
            {
                return mega_menu_objectSpreadProps(mega_menu_objectSpread({}, state), {
                    rootCategories: action.categories
                });
            }
        case desktop/* NAVIGATION_TOGGLE_MENU */.F_:
            {
                var open = action.open;
                return mega_menu_objectSpreadProps(mega_menu_objectSpread({}, state), {
                    open: open
                });
            }
        case desktop/* NAVIGATION_CHANGE_CATEGORY */.m5:
            {
                var openCategory = action.openCategory;
                return mega_menu_objectSpreadProps(mega_menu_objectSpread({}, state), {
                    openCategory: openCategory
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/navigation/actions/mobile-menu.js
var mobile_menu = __webpack_require__(92306);
;// CONCATENATED MODULE: ./src/areas/navigation/reducers/mobile-menu.js
function mobile_menu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function mobile_menu_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return mobile_menu_arrayLikeToArray(arr);
}
function mobile_menu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_menu_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function mobile_menu_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function mobile_menu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_menu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function mobile_menu_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_menu_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_menu_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function mobile_menu_toConsumableArray(arr) {
    return mobile_menu_arrayWithoutHoles(arr) || mobile_menu_iterableToArray(arr) || mobile_menu_unsupportedIterableToArray(arr) || mobile_menu_nonIterableSpread();
}
function mobile_menu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return mobile_menu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mobile_menu_arrayLikeToArray(o, minLen);
}

/* harmony default export */ function reducers_mobile_menu(state, action) {
    if (!state) {
        return {
            open: false,
            history: []
        };
    }
    switch(action.type){
        case mobile_menu/* OPEN_MOBILE_MENU */.QU:
            {
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    open: true
                });
            }
        case mobile_menu/* CLOSE_MOBILE_MENU */.l2:
            {
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    open: false
                });
            }
        case mobile_menu/* NAVIGATE_FROM_MOBILE_MENU */.CA:
            {
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    navigatedFromMobileMenu: true
                });
            }
        case "ROUTE_LOADED":
            {
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    navigatedFromMobileMenu: false,
                    // Reset mobile menu history, essentially going back to the top level of the mobile menu,
                    // unless we just navigated from mobile menu, e.g. clicked a category link in it.
                    history: state.navigatedFromMobileMenu ? state.history : state.history.slice(0, 1)
                });
            }
        case mobile_menu/* SET_INITIAL_DATA */.bO:
            {
                var categories = action.categories;
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    categories: categories,
                    history: [
                        {
                            id: "root",
                            name: null,
                            semantic_id: null,
                            children: categories
                        }
                    ]
                });
            }
        case mobile_menu/* CHANGE_MOBILE_MENU_CATEGORIES */.cL:
            {
                var categories1 = action.categories, parent = action.parent;
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    categories: categories1,
                    history: mobile_menu_toConsumableArray(state.history).concat([
                        parent
                    ]),
                    // Keep track of whether we're traversing up or down the category tree
                    // to determine transition direction
                    isTraversingUpwards: false
                });
            }
        case mobile_menu/* SELECT_MOBILE_MENU_HISTORY */.FB:
            {
                var categoryId = action.categoryId;
                var index = state.history.findIndex(function(current) {
                    return current.id === categoryId;
                });
                if (index >= 0) {
                    return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                        history: state.history.slice(0, index + 1),
                        categories: state.history[index].children,
                        // Keep track of whether we're traversing up or down the category tree
                        // to determine transition direction
                        isTraversingUpwards: true
                    });
                }
                return mobile_menu_objectSpread({}, state);
            }
        default:
    }
    return state;
};

;// CONCATENATED MODULE: ./src/areas/navigation/actions/account-menu.js
var ACCOUNT_MENU_TOGGLE = "ACCOUNT_MENU_TOGGLE";

;// CONCATENATED MODULE: ./src/areas/navigation/reducers/account-menu.js
function account_menu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function account_menu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            account_menu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function account_menu_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function account_menu_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        account_menu_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function account_menu(state, action) {
    if (!state) {
        return {
            open: false
        };
    }
    switch(action.type){
        case ACCOUNT_MENU_TOGGLE:
            {
                return account_menu_objectSpreadProps(account_menu_objectSpread({}, state), {
                    open: action.open
                });
            }
        default:
    }
    return state;
};

;// CONCATENATED MODULE: ./src/areas/navigation/reducers/index.js




/* harmony default export */ var navigation_reducers = ((0,redux.combineReducers)({
    megaMenu: mega_menu,
    mobileMenu: reducers_mobile_menu,
    accountMenu: account_menu
}));

;// CONCATENATED MODULE: ./src/areas/campaign/reducers/index.ts
function campaign_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function campaign_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            campaign_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function campaign_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function campaign_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        campaign_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var reducers_initialState = {
    base: undefined,
    popularCampaignFilterPaths: undefined,
    timezone: undefined,
    translation: undefined
};
/* harmony default export */ function campaign_reducers() {
    var // eslint-disable-next-line default-param-last
    state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        /**
      NOTE: All config is dispatched, any data returned will be sent
      down to the browser. Make sure no secrets is leaking!
    * */ case actions/* DANGEROUS_CONFIG_RECEIVE */.R5:
            {
                var market = action.market;
                return campaign_reducers_objectSpreadProps(campaign_reducers_objectSpread({}, state), {
                    translation: market.translation,
                    timezone: market.timezone,
                    base: market.url.campaigns,
                    popularCampaignFilterPaths: market.popularCampaignFilterPaths
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/areas/sidebar/constants.ts
var sidebar_constants = __webpack_require__(90081);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/lists.js
var actions_lists = __webpack_require__(96805);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/filter.js
var actions_filter = __webpack_require__(44291);
;// CONCATENATED MODULE: ./src/areas/sidebar/reducer/index.js
function reducer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function reducer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return reducer_arrayLikeToArray(arr);
}
function sidebar_reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function reducer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sidebar_reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sidebar_reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sidebar_reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sidebar_reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sidebar_reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || reducer_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function reducer_toConsumableArray(arr) {
    return reducer_arrayWithoutHoles(arr) || reducer_iterableToArray(arr) || reducer_unsupportedIterableToArray(arr) || reducer_nonIterableSpread();
}
function reducer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return reducer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return reducer_arrayLikeToArray(o, minLen);
}





/* harmony default export */ function sidebar_reducer(state, action) {
    if (!state) {
        return {
            tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE,
            previousTab: null,
            error: null,
            pending: false,
            deletedListItems: {},
            deletedLists: {},
            alerts: {
                sort: "price_change",
                direction: "desc",
                products: []
            },
            selectedList: null,
            lists: {},
            listRefresh: 0,
            hasFilter: false,
            filterType: null,
            filterGroups: []
        };
    }
    switch(action.type){
        case "USER_RECEIVE":
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        products: action.me && action.me.alertsSummary && action.me.alertsSummary.products || []
                    })
                });
            }
        case "ROUTE_LOADED":
            {
                var ref, ref1;
                var hasFilter = false;
                var filterSlice = null;
                if (action.data && action.data.productCollection) {
                    filterSlice = action.data.productCollection.slices.find(function(slice) {
                        return slice.__typename === "FilterSlice";
                    });
                    hasFilter = !!filterSlice && filterSlice.sections.length > 0;
                }
                if (((ref = action.route) === null || ref === void 0 ? void 0 : ref.name) === "category") {
                    var ref2, ref3;
                    hasFilter = !!((ref2 = action.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.category) === null || ref3 === void 0 ? void 0 : ref3.immediateProducts);
                }
                // Close filter when navigating away from a leaf category page
                if (state.tab === sidebar_constants/* SIDEBAR_STATE.FILTER */.$J.FILTER && !hasFilter) {
                    return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                        tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE,
                        hasFilter: false,
                        filterType: null,
                        filterGroups: []
                    });
                }
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    hasFilter: hasFilter,
                    filterType: (ref1 = action.route) === null || ref1 === void 0 ? void 0 : ref1.name,
                    filterGroups: filterSlice ? filterSlice.groups : []
                });
            }
        case "LOCAL_STORAGE_RECEIVE":
            {
                var sidebar = dist_default().parse(window.location.search).sidebar;
                // Opens the sidebar with a tab if a user lands on a URL containing
                // a parameter `?sidebar=lists|alerts`.
                var sidebarQueryTab = Object.values(sidebar_constants/* SIDEBAR_STATE */.$J).includes(sidebar) ? sidebar : null;
                var sidebarStateFromLocalStorage = action.localStorageState[sidebar_constants/* SIDEBAR_LOCALSTORAGE_KEY */.yT];
                if (sidebarStateFromLocalStorage) {
                    var ref4 = _slicedToArray(sidebarStateFromLocalStorage.listSort ? sidebarStateFromLocalStorage.listSort.split(":") : [], 2), sort = ref4[0], direction = ref4[1];
                    return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                        lists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.lists), {
                            sort: sort,
                            direction: direction
                        }),
                        tab: sidebarQueryTab || sidebarStateFromLocalStorage.tab
                    });
                }
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebarQueryTab || sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE
                });
            }
        case actions_alert/* CLOSE_ALERTS */.Vp:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE
                });
            }
        case actions_alert/* OPEN_ALERTS */.VG:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS,
                    previousTab: sidebar_constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS
                });
            }
        case actions_lists/* CLOSE_LISTS */.GV:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE
                });
            }
        case actions_lists/* OPEN_LISTS */.Fc:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.LISTS */.$J.LISTS,
                    previousTab: sidebar_constants/* SIDEBAR_STATE.LISTS */.$J.LISTS
                });
            }
        case actions_filter/* TOGGLE_FILTER */.m:
            {
                if (state.tab === sidebar_constants/* SIDEBAR_STATE.FILTER */.$J.FILTER) {
                    return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                        tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE
                    });
                }
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.FILTER */.$J.FILTER,
                    previousTab: sidebar_constants/* SIDEBAR_STATE.FILTER */.$J.FILTER
                });
            }
        case actions_alert/* CREATE_ALERT_SUCCESS */.mx:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        products: reducer_toConsumableArray(new Set(// Since an alert may already exist on current product with
                        // a different alert ID clear all alerts for this product
                        // and add the newly created alert
                        reducer_toConsumableArray(state.alerts.products.filter(function(alert) {
                            return alert.productId !== action.productId;
                        })).concat([
                            {
                                alertId: action.id,
                                productId: action.productId
                            }
                        ])))
                    })
                });
            }
        case actions_alert/* REMOVE_ALERT_REQUEST */.$x:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true
                });
            }
        case actions_alert/* RESTORE_ALERT_SUCCESS */.Yo:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        products: reducer_toConsumableArray(new Set(// Since an alert may already exist on current product with
                        // a different alert ID clear all alerts for this product
                        // and add the newly created alert
                        reducer_toConsumableArray(state.alerts.products.filter(function(alert) {
                            return alert.productId !== action.productId;
                        })).concat([
                            {
                                alertId: action.id,
                                productId: action.productId
                            }
                        ])))
                    })
                });
            }
        case actions_alert/* REMOVE_ALERT_SUCCESS */.$_:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        products: state.alerts.products.filter(function(param) {
                            var alertId = param.alertId, productId = param.productId;
                            return alertId !== action.id && productId !== action.productId;
                        })
                    })
                });
            }
        case actions_alert/* REMOVE_ALERT_ERROR */.XJ:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    error: action.error
                });
            }
        case actions_lists/* SORT_LIST */.Zh:
            {
                var ref5 = _slicedToArray(action.sort.value.split(":"), 2), sort1 = ref5[0], direction1 = ref5[1];
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    lists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.lists), {
                        sort: sort1,
                        direction: direction1
                    })
                });
            }
        case actions_alert/* SORT_ALERTS */.ej:
            {
                var ref6 = _slicedToArray(action.sort.value.split(":"), 2), sort2 = ref6[0], direction2 = ref6[1];
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        sort: sort2,
                        direction: direction2
                    })
                });
            }
        case actions_lists/* SELECT_LIST */.T3:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    selectedList: action.id
                });
            }
        case actions_lists/* REMOVE_LIST_ITEM_REQUEST */.aF:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true,
                    deletedListItems: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedListItems), sidebar_reducer_defineProperty({}, action.id, "pending"))
                });
            }
        case actions_lists/* REMOVE_LIST_ITEM_SUCCESS */.iw:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1,
                    deletedListItems: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedListItems), sidebar_reducer_defineProperty({}, action.id, action.productId || action.listId)),
                    pending: false
                });
            }
        case actions_lists/* REMOVE_LIST_ITEM_ERROR */.Oz:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    deletedListItems: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedListItems), sidebar_reducer_defineProperty({}, action.id, undefined))
                });
            }
        case actions_lists/* REMOVE_LIST_REQUEST */.N$:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true,
                    deletedLists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedLists), sidebar_reducer_defineProperty({}, action.id, "pending"))
                });
            }
        case actions_lists/* REMOVE_LIST_SUCCESS */.sh:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1,
                    deletedLists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedLists), sidebar_reducer_defineProperty({}, action.id, true)),
                    pending: false
                });
            }
        case actions_lists/* REMOVE_LIST_ERROR */.Og:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    listRefresh: state.listRefresh + 1,
                    deletedLists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedLists), sidebar_reducer_defineProperty({}, action.id, undefined))
                });
            }
        case actions_lists/* CREATE_LIST_SUCCESS */.Kj:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1
                });
            }
        case actions_lists/* EDIT_LIST_REQUEST */.GB:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true
                });
            }
        case actions_lists/* EDIT_LIST_SUCCESS */.Ce:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1
                });
            }
        case actions_lists/* EDIT_LIST_ERROR */.pU:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false
                });
            }
        case actions_lists/* ADD_LIST_ITEM_SUCCESS */.pd:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1,
                    deletedListItems: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedListItems), // If the product ID has been in the list before, we may get the same
                    // list item ID back, so we must mark it as not deleted.
                    sidebar_reducer_defineProperty({}, action.id, undefined))
                });
            }
        case actions_lists/* ORDER_LISTS_REQUEST */.Po:
            {
                return sidebar_reducer_objectSpread({}, state);
            }
        case actions_lists/* ORDER_LIST_ITEMS_REQUEST */.w:
            {
                return sidebar_reducer_objectSpread({}, state);
            }
        case actions_lists/* IMPORT_LIST_TO_MY_PRODUCTS */.sy:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true
                });
            }
        case actions_lists/* IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS */.qR:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    listRefresh: state.listRefresh + 1
                });
            }
        case actions_lists/* ADD_LIST_ITEM_ERROR */.zD:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false
                });
            }
        case actions_lists/* OPEN_LIST_SETTINGS */.Od:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    isListSettingsOpen: true
                });
            }
        case actions_lists/* CLOSE_LIST_SETTINGS */.y$:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    isListSettingsOpen: false
                });
            }
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/actions/index.js
var sidebar_mobile_actions = __webpack_require__(24726);
// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/constants.ts
var sidebar_mobile_constants = __webpack_require__(86178);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-mobile/reducers/index.js
function sidebar_mobile_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sidebar_mobile_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sidebar_mobile_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sidebar_mobile_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sidebar_mobile_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sidebar_mobile_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ function sidebar_mobile_reducers(state, action) {
    if (!state) {
        return {
            currentView: sidebar_mobile_constants/* VIEWS.ROOT */.n.ROOT
        };
    }
    switch(action.type){
        case sidebar_mobile_actions/* SET_MOBILE_SIDEBAR_VIEW */.e:
            return sidebar_mobile_reducers_objectSpreadProps(sidebar_mobile_reducers_objectSpread({}, state), {
                currentView: action.currentView
            });
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/components/modal/actions.ts
var modal_actions = __webpack_require__(43758);
;// CONCATENATED MODULE: ./src/components/modal/reducer.ts
function modal_reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function modal_reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            modal_reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function modal_reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function modal_reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        modal_reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var reducer_initialState = {
    current: undefined
};
/* harmony default export */ function modal_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return {
            current: undefined
        };
    }
    switch(action.type){
        case modal_actions/* HIDE_MODAL */._D:
        case modal_actions/* SHOW_MODAL */.Hn:
            {
                var modal = action.modal;
                return modal_reducer_objectSpreadProps(modal_reducer_objectSpread({}, state), {
                    current: modal || undefined
                });
            }
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/reviews/actions/index.js
var reviews_actions = __webpack_require__(1067);
;// CONCATENATED MODULE: ./src/areas/reviews/reducers/index.js
function reviews_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reviews_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reviews_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function reviews_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function reviews_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        reviews_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var DEFAULT_PAGE_INFO = {
    offset: 0,
    limit: 15
};
/* harmony default export */ function reviews_reducers(state, action) {
    if (!state) {
        return {
            pendingRequest: false,
            requestError: null,
            pageInfo: {
                store: DEFAULT_PAGE_INFO,
                product: DEFAULT_PAGE_INFO,
                profile: DEFAULT_PAGE_INFO
            },
            updatedReviews: null,
            updatedSummary: null,
            drafts: null,
            dialog: {
                openId: null
            },
            thankYouDialog: {
                openId: null
            }
        };
    }
    switch(action.type){
        case reviews_actions/* CREATE_REVIEW */.l3:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: {
                    type: "create"
                },
                requestError: null
            });
        case reviews_actions/* EDIT_REVIEW */.hy:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: {
                    type: "edit"
                },
                requestError: null
            });
        case reviews_actions/* DELETE_REVIEW */.y$:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: {
                    type: "delete"
                },
                requestError: null
            });
        case reviews_actions/* CREATE_REVIEW_SUCCESS */.bg:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* CREATE_SHOP_REVIEW */.mb:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: true,
                requestError: null
            });
        case reviews_actions/* CREATE_SHOP_REVIEW_SUCCESS */.eA:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false,
                thankYouDialog: {
                    openId: state.dialog.openId
                },
                dialog: {
                    openId: null
                }
            });
        case reviews_actions/* EDIT_SHOP_REVIEW */.CA:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: true,
                requestError: null
            });
        case reviews_actions/* EDIT_SHOP_REVIEW_SUCCESS */.s6:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false,
                dialog: {
                    openId: null
                }
            });
        case reviews_actions/* DELETE_SHOP_REVIEW */.Bs:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: true,
                requestError: null
            });
        case reviews_actions/* DELETE_SHOP_REVIEW_SUCCESS */.UW:
            {
                var drafts = state.drafts;
                // Delete drafts for the review and shop when deleting a review
                if (drafts && drafts[action.reviewId]) delete drafts[action.reviewId];
                if (drafts && drafts[action.shopId]) delete drafts[action.shopId];
                return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                    pendingRequest: false,
                    dialog: {
                        openId: null
                    },
                    drafts: drafts
                });
            }
        case reviews_actions/* HIDE_SHOP_REVIEW_THANK_YOU */.DT:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                thankYouDialog: {
                    openId: null
                }
            });
        case reviews_actions/* EDIT_REVIEW_SUCCESS */.cO:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* DELETE_REVIEW_SUCCESS */.g6:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* UPDATE_REVIEW_DATA */.e1:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                updatedReviews: {
                    shopId: action.shopId,
                    productId: action.productId,
                    nodes: action.nodes,
                    myReview: action.myReview
                }
            });
        case reviews_actions/* UPDATE_REVIEW_SUMMARY */.zM:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                updatedSummary: action.summary
            });
        case reviews_actions/* OPEN_REVIEW_DIALOG */.b3:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                dialog: {
                    openId: action.uid
                },
                requestError: null
            });
        case reviews_actions/* CLOSE_REVIEW_DIALOG */.TF:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                dialog: {
                    openId: null
                },
                requestError: null
            });
        case reviews_actions/* REVIEW_REQUEST_ERROR */.u9:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                requestError: action.errorCode,
                pendingRequest: false
            });
        case reviews_actions/* LIKE_REVIEW_TOGGLE */.vH:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: true
            });
        case reviews_actions/* LIKE_REVIEW_SUCCESS */.UY:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* LIKE_REVIEW_FAILED */.RL:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* SAVE_REVIEW_DRAFT */.Hg:
            {
                var newDrafts = reviews_reducers_objectSpread({}, state.drafts, action.draft);
                return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                    drafts: newDrafts
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./packages/product-collection-urls/dist/index.js
var product_collection_urls_dist = __webpack_require__(36074);
// EXTERNAL MODULE: ./src/areas/product-collection/actions/index.ts
var product_collection_actions = __webpack_require__(72270);
// EXTERNAL MODULE: ./src/components/recently-visited/actions.ts
var recently_visited_actions = __webpack_require__(76334);
// EXTERNAL MODULE: ./src/client/dummy-local-storage.ts
var dummy_local_storage = __webpack_require__(75077);
;// CONCATENATED MODULE: ./src/components/recently-visited/storage.ts

var LOCAL_STORAGE_KEY = "recentlyVisited";
var withLocalStorage = function(cb) {
    try {
        if ( false || !window.localStorage) {
            // There is no localStorage on the server, and localStorage can be null if
            // disabled in the browser.
            return null;
        }
        return cb(dummy_local_storage/* dummyLocalStorage */.Y);
    } catch (e) {
        // localStorage may throw an exception when disabled; just ignore it.
        if (false) {}
    }
    return null;
};
var readRecentlyVisited = function() {
    var jsonString = withLocalStorage(function(localStorage) {
        return localStorage.getItem(LOCAL_STORAGE_KEY);
    });
    if (!jsonString) {
        return [];
    }
    try {
        var data = JSON.parse(jsonString);
        return data && Array.isArray(data) ? data : [];
    } catch (e) {
        if (false) {}
        return [];
    }
};
var writeRecentlyVisited = function(data) {
    var jsonString = JSON.stringify(data);
    withLocalStorage(function(localStorage) {
        localStorage.setItem(LOCAL_STORAGE_KEY, jsonString);
    });
};

;// CONCATENATED MODULE: ./src/components/recently-visited/reducer.ts
function recently_visited_reducer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function recently_visited_reducer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return recently_visited_reducer_arrayLikeToArray(arr);
}
function recently_visited_reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function recently_visited_reducer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function recently_visited_reducer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function recently_visited_reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            recently_visited_reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function recently_visited_reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function recently_visited_reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        recently_visited_reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function recently_visited_reducer_toConsumableArray(arr) {
    return recently_visited_reducer_arrayWithoutHoles(arr) || recently_visited_reducer_iterableToArray(arr) || recently_visited_reducer_unsupportedIterableToArray(arr) || recently_visited_reducer_nonIterableSpread();
}
function recently_visited_reducer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return recently_visited_reducer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return recently_visited_reducer_arrayLikeToArray(o, minLen);
}




var MAX_ITEMS = 100;
/* harmony default export */ function recently_visited_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        items: [],
        loaded: false
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return {
            loaded: false,
            items: []
        };
    }
    switch(action.type){
        case recently_visited_actions/* LOAD_RECENTLY_VISITED */.Bx:
            {
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    loaded: true,
                    items: readRecentlyVisited()
                });
            }
        case product_collection_actions/* UPDATE_PRODUCT_COLLECTION_FILTERS */.On:
            {
                var newUrl = action.filters.reduce(function(url, filter) {
                    return (0,product_collection_urls_dist.addFilterToUrl)(url, filter);
                }, location.pathname);
                var readItems = readRecentlyVisited();
                var recentlyVisitedProductCollection = readItems.find(function(item) {
                    return item.id === action.id;
                });
                if (!recentlyVisitedProductCollection) break;
                recentlyVisitedProductCollection.url = newUrl;
                var newItems = [
                    recentlyVisitedProductCollection
                ].concat(recently_visited_reducer_toConsumableArray(readItems.filter(function(item) {
                    return item.id !== action.id;
                })));
                writeRecentlyVisited(newItems);
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    items: newItems
                });
            }
        case "ROUTE_LOADED":
            {
                if (!action.route || ![
                    "product",
                    "productCollection"
                ].includes(action.route.name) || !action.data) {
                    break;
                }
                var readItems1 = readRecentlyVisited();
                var newItem = createRecentlyVisited(action.data);
                if (!newItem) break;
                var newItems1 = [
                    newItem
                ].concat(recently_visited_reducer_toConsumableArray(readItems1.filter(function(item) {
                    if (newItem.type !== item.type) return item;
                    if ("id" in item && "id" in newItem) return item.id !== newItem.id;
                    if ("slug" in item && "slug" in newItem) return item.slug !== newItem.slug;
                    return false;
                }))).slice(0, MAX_ITEMS);
                writeRecentlyVisited(newItems1);
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    items: newItems1
                });
            }
        case recently_visited_actions/* REMOVE_RECENTLY_VISITED_ITEM */.QN:
            {
                var readItems2 = readRecentlyVisited();
                var newItems2 = readItems2.filter(function(item) {
                    return item.id !== action.id;
                });
                writeRecentlyVisited(newItems2);
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    items: newItems2
                });
            }
        default:
            break;
    }
    return state;
};
function createRecentlyVisited(data) {
    var date = Date.now();
    if ("product" in data && data.product) {
        return {
            type: "product",
            date: date,
            id: data.product.id
        };
    }
    if ("productCollection" in data && data.productCollection) {
        return {
            type: "productCollection",
            date: date,
            id: data.productCollection.id,
            slug: data.productCollection.slug,
            url: data.productCollection.url
        };
    }
    return null;
}

// EXTERNAL MODULE: ./src/components/toast-container/actions/index.ts
var toast_container_actions = __webpack_require__(40744);
;// CONCATENATED MODULE: ./src/components/toast-container/reducers/index.ts

/* harmony default export */ function toast_container_reducers(state, action) {
    if (!state) {
        return {
            required: false
        };
    }
    switch(action.type){
        case toast_container_actions/* TOAST_REQUIRED */.xy:
            return {
                required: action.required
            };
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var layout_buttons_types = __webpack_require__(21068);
// EXTERNAL MODULE: ./src/areas/product-collection/constants/index.ts
var product_collection_constants = __webpack_require__(15169);
;// CONCATENATED MODULE: ./src/areas/product-collection/reducers/redux-actions.ts
function redux_actions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function redux_actions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            redux_actions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function redux_actions_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function redux_actions_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        redux_actions_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var productCollectionReduxReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "ROUTE_LOADED":
            {
                return redux_actions_objectSpread({}, state);
            }
        case product_collection_actions/* SET_PRODUCT_COLLECTION_LAYOUT */.$3:
            return redux_actions_objectSpreadProps(redux_actions_objectSpread({}, state), {
                userSelectedLayout: action.layout
            });
        case "LOCAL_STORAGE_RECEIVE":
            {
                var productCollectionLayoutFromLocalStorage = action.localStorageState[product_collection_constants/* PRODUCT_COLLECTION_LAYOUT */.xU];
                return redux_actions_objectSpreadProps(redux_actions_objectSpread({}, state), {
                    userSelectedLayout: typeof productCollectionLayoutFromLocalStorage !== "undefined" && // Don't set `userSelectedLayout` if localStorage contains a faulty or removed value
                    Object.values(layout_buttons_types/* LayoutMode */.X).includes(productCollectionLayoutFromLocalStorage) ? productCollectionLayoutFromLocalStorage : undefined
                });
            }
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/sidebar/views/list/actions/index.ts
var list_actions = __webpack_require__(59209);
;// CONCATENATED MODULE: ./src/areas/sidebar/views/list/reducers/index.ts
function list_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function list_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            list_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function list_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function list_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        list_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

function publicListReducer(state, action) {
    if (!state) {
        return {
            openShareId: null
        };
    }
    switch(action.type){
        case list_actions/* TOGGLE_LIST_SHARE */.w:
            {
                return list_reducers_objectSpreadProps(list_reducers_objectSpread({}, state), {
                    openShareId: !state.openShareId ? action.uid : null
                });
            }
        default:
            return state;
    }
}

;// CONCATENATED MODULE: ./src/areas/changelog/reducers/index.ts
function changelog_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function changelog_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            changelog_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function changelog_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function changelog_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        changelog_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var changelog_reducers_initialState = {
    articles: [],
    isOpen: false
};
function changelog_reducers_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : changelog_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return changelog_reducers_objectSpread({}, changelog_reducers_initialState);
    }
    switch(action.type){
        case "CHANGELOG_RECEIVE":
            {
                return changelog_reducers_objectSpreadProps(changelog_reducers_objectSpread({}, state), {
                    articles: action.articles
                });
            }
        case "CHANGELOG_TOGGLE":
            {
                return changelog_reducers_objectSpreadProps(changelog_reducers_objectSpread({}, state), {
                    isOpen: !state.isOpen
                });
            }
        case "CHANGELOG_CLOSE":
            {
                return changelog_reducers_objectSpreadProps(changelog_reducers_objectSpread({}, state), {
                    isOpen: false
                });
            }
        default:
    }
    return state;
}

;// CONCATENATED MODULE: ./src/areas/search/reducers/index.ts
function search_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function search_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function search_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        search_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var search_reducers_initialState = {
    focused: false
};
function search_reducers_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : search_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return search_reducers_objectSpread({}, search_reducers_initialState);
    }
    switch(action.type){
        case "SEARCH_FOCUS":
            {
                return search_reducers_objectSpreadProps(search_reducers_objectSpread({}, state), {
                    focused: true
                });
            }
        case "SEARCH_BLUR":
            {
                return search_reducers_objectSpreadProps(search_reducers_objectSpread({}, state), {
                    focused: false
                });
            }
        default:
    }
    return state;
}

;// CONCATENATED MODULE: ./src/reducers.ts




















var areas = (0,redux.combineReducers)({
    product: product_reducer,
    productAlert: product_alert_reducers,
    category: category_reducers,
    account: account_reducers,
    navigation: navigation_reducers,
    campaign: campaign_reducers,
    sidebar: sidebar_reducer,
    mobileSidebar: sidebar_mobile_reducers,
    productCollection: productCollectionReduxReducer,
    review: reviews_reducers,
    list: publicListReducer,
    changelog: changelog_reducers_reducer,
    search: search_reducers_reducer
});
var rootReducer = (0,redux.combineReducers)({
    globals: reducers,
    feedback: feedback_reducers,
    areas: areas,
    footer: reducers_reducer,
    modal: modal_reducer,
    recentlyVisited: recently_visited_reducer,
    toast: toast_container_reducers
});
/* harmony default export */ var src_reducers = (rootReducer);

// EXTERNAL MODULE: ./node_modules/.pnpm/redux-saga@1.0.3/node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(38247);
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./node_modules/.pnpm/no-scroll@2.1.1/node_modules/no-scroll/index.js
var no_scroll = __webpack_require__(4291);
var no_scroll_default = /*#__PURE__*/__webpack_require__.n(no_scroll);
// EXTERNAL MODULE: ./src/areas/campaign/actions/index.js
var campaign_actions = __webpack_require__(51932);
;// CONCATENATED MODULE: ./src/globals/sagas/scroll-lock.js
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


/**
 * This scroll lock is mainly for IOS Safari where background is scrollable
 * even if the overflow hidden strategy is used on background content, causing
 * broken UI is some cases.
 *
 * The elastic band functionality will make the content behind be shown
 * in the bottom portion of the phone when the menu slides away.
 */ 



function scrollLockOn() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    no_scroll_default().on()
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function scrollLockOff() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    no_scroll_default().off()
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function scrollLockSaga() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(mobile_menu/* OPEN_MOBILE_MENU */.QU, scrollLockOn)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(mobile_menu/* CLOSE_MOBILE_MENU */.l2, scrollLockOff)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(feedback_actions/* FEEDBACK_OPEN */.hy, scrollLockOn)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(feedback_actions/* FEEDBACK_CLOSE */._d, scrollLockOff)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* OPEN_REVIEW_DIALOG */.b3, scrollLockOn)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* CLOSE_REVIEW_DIALOG */.TF, scrollLockOff)
                ];
            case 6:
                _state.sent();
                // We release the lock on new route load (campaign query for campaign page)
                // events to handle back actions and other unexpected page changes where the
                // user might not be able to go through the regular close path of
                // modals | menus | dialogs.
                // This might result in the scroll lock being released even if the
                // menu is still open when doing stuff like hitting the back button
                // (because of SPA). But its better than the other way around: the
                // main content being non-scrollable.
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)("ROUTE_LOADED", scrollLockOff)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(campaign_actions/* CAMPAIGN_QUERY */.Ru, scrollLockOff)
                ];
            case 8:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/globals/sagas/index.js
var sagas_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




function sortChange(action) {
    var qs, sort, direction, url, historyFunc;
    return sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                qs = querystring.decode(window.location.search.substr(1));
                sort = action.data.value.replace(/:(asc|desc)$/, "");
                direction = action.data.value.match(/:(asc|desc)$/);
                qs.sort = sort;
                qs.direction = direction && direction[1];
                if (!direction) {
                    delete qs.direction;
                }
                delete qs.offset;
                url = window.location.pathname + (Object.keys(qs).length > 0 ? "?".concat(querystring.encode(qs)) : "");
                historyFunc = action.data.replaceHistory ? window.__history.replace : window.__history.push;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(historyFunc, url)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function mySaga() {
    return sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions/* SORT_CHANGE */.NH, sortChange)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(scrollLockSaga)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var sagas = (mySaga);

// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(15287);
// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(19590);
;// CONCATENATED MODULE: ./src/areas/feedback/sagas/index.js
var feedback_sagas_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




function sendFeedback(param) {
    var message, response, e;
    return feedback_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                message = param.message;
                if (!(!message.email || !(0,helpers/* isValidEmail */.v)(message.email))) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendFailed */.I0)("error.missing.email"))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                if (!!message.message) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendFailed */.I0)("error.missing.message"))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                _state.trys.push([
                    4,
                    14,
                    ,
                    16
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* postFeedback */.qr, message)
                ];
            case 5:
                response = _state.sent();
                if (!(response.errors && response.errors.length)) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendFailed */.I0)(response.errors[0].message))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendSuccess */.Wr)())
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* putSession */.hO, "email", message.email)
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* delay */.gw)(1500)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* clearForm */.ou)())
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(feedback_actions/* default.close */.ZP.close())
                ];
            case 12:
                _state.sent();
                _state.label = 13;
            case 13:
                return [
                    3,
                    16
                ];
            case 14:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendFailed */.I0)(e.message))
                ];
            case 15:
                _state.sent();
                return [
                    3,
                    16
                ];
            case 16:
                return [
                    2
                ];
        }
    });
}
function sagas_mySaga() {
    return feedback_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)("FEEDBACK_SEND_REQUEST", sendFeedback)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var feedback_sagas = (sagas_mySaga);

// EXTERNAL MODULE: ./src/client/sentry.ts
var sentry = __webpack_require__(22260);
;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/create-alert.js
var create_alert_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};







function getNotificationTranslationKey(notifyBy) {
    if (notifyBy.email && notifyBy.push) {
        return "alert.saved.email_push";
    }
    if (notifyBy.email) {
        return "alert.saved.email";
    }
    if (notifyBy.push) {
        return "alert.saved.push";
    }
    return "alert.saved";
}
function createAlert(productId, options) {
    return (0,requests/* graphql */.BX)("\n      mutation alertCreate($productId: Int!, $options: AlertCreateOptions) {\n        alertCreate(productId: $productId, options: $options) {\n          id\n          priceThreshold\n          priceStep\n          storePreference\n          storeGradeThreshold\n          alertType\n          notifyBy {\n            email\n            push\n          }\n          product {\n            id\n            pathName\n          }\n        }\n      }\n    ", {
        productId: productId,
        options: options
    });
}
function updateAlert(alertId, options) {
    return (0,requests/* graphql */.BX)("\n      mutation alertEdit($alertId: Int!, $options: AlertCreateOptions) {\n        alertCreate: alertEdit(alertId: $alertId, options: $options) {\n          id\n          priceThreshold\n          priceStep\n          storePreference\n          storeGradeThreshold\n          alertType\n          notifyBy {\n            email\n            push\n          }\n          product {\n            id\n            pathName\n          }\n        }\n      }\n    ", {
        alertId: alertId,
        options: options
    });
}
function createAlertRequest(param) {
    var data, onSuccess, alertId, productId, email, priceThreshold, tab, isAuthenticated, options, response, _tmp, ref, e;
    return create_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                data = param.data, onSuccess = param.onSuccess;
                alertId = data.alertId, productId = data.productId, email = data.email, priceThreshold = data.priceThreshold;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar;
                    })
                ];
            case 1:
                tab = _state.sent().tab;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.account;
                    })
                ];
            case 2:
                isAuthenticated = _state.sent().isAuthenticated;
                if (!(!productId && !alertId)) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertFailed */.fZ)("error.productId.invalid"))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                if (!(email !== undefined && !(0,helpers/* isValidEmail */.v)(email))) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertFailed */.fZ)("alert.invalid-email"))
                ];
            case 5:
                _state.sent();
                return [
                    2
                ];
            case 6:
                options = data;
                delete options.productId;
                delete options.alertId;
                options.priceThreshold = parseFloat(priceThreshold || 0);
                _state.label = 7;
            case 7:
                _state.trys.push([
                    7,
                    20,
                    ,
                    23
                ]);
                if (!(isAuthenticated && alertId)) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateAlert, alertId, options)
                ];
            case 8:
                _tmp = _state.sent();
                return [
                    3,
                    11
                ];
            case 9:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(createAlert, productId, options)
                ];
            case 10:
                _tmp = _state.sent();
                _state.label = 11;
            case 11:
                response = _tmp;
                if (!(response.errors && response.errors.length)) return [
                    3,
                    13
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertFailed */.fZ)((ref = response.errors[0].extensions) === null || ref === void 0 ? void 0 : ref.code))
                ];
            case 12:
                _state.sent();
                return [
                    3,
                    19
                ];
            case 13:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertSuccess */.w4)(response.data.alertCreate.id, response.data.alertCreate.product.id))
                ];
            case 14:
                _state.sent();
                if (!onSuccess) return [
                    3,
                    16
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(onSuccess)
                ];
            case 15:
                _state.sent();
                _state.label = 16;
            case 16:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("product", getNotificationTranslationKey(response.data.alertCreate.notifyBy)), {
                        toastId: productId
                    }))
                ];
            case 17:
                _state.sent();
                if (!(isAuthenticated && tab !== sidebar_constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS)) return [
                    3,
                    19
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* openAlerts */.SU)())
                ];
            case 18:
                _state.sent();
                _state.label = 19;
            case 19:
                return [
                    3,
                    23
                ];
            case 20:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 21:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertFailed */.fZ)(e.message))
                ];
            case 22:
                _state.sent();
                return [
                    3,
                    23
                ];
            case 23:
                return [
                    2
                ];
        }
    });
}
function create_alert_mySaga() {
    return create_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(actions_alert/* CREATE_ALERT_REQUEST */.Oi, createAlertRequest)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var create_alert = (create_alert_mySaga);

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/remove-alert.js
var remove_alert_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};






function removeAlertRequest(param) {
    var id, productId, onSuccess, response, restoreToken, err;
    return remove_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id, productId = param.productId, onSuccess = param.onSuccess;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    9,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation alertDelete($id: Int!) {\n        alertDelete(id: $id) {\n          restoreToken\n        }\n      }", {
                        id: id
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* removeAlertError */.TI)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                restoreToken = response.data.alertDelete.restoreToken;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* removeAlertSuccess */._X)(restoreToken, id, productId))
                ];
            case 5:
                _state.sent();
                if (!onSuccess) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(onSuccess)
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", /*#__PURE__*/ react.createElement(react.Fragment, null, window.APP_GLOBALS.t("alerts", "confirm.alert-deleted")), {
                        toastId: productId
                    }))
                ];
            case 8:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 9:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* removeAlertError */.TI)(err))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function restoreAlertRequest(param) {
    var restoreToken, id, productId, response, err;
    return remove_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                restoreToken = param.restoreToken, id = param.id, productId = param.productId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation restoreItem($token: String!) {\n        restoreItem(token: $token) {\n          success\n        }\n      }", {
                        token: restoreToken
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* restoreAlertError */.g)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* restoreAlertSuccess */.Jl)(restoreToken, id, productId))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("alerts", "confirm.alert-restored"), {
                        toastId: productId
                    }))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 7:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* restoreAlertError */.g)(err))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function remove_alert_mySaga() {
    return remove_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_alert/* REMOVE_ALERT_REQUEST */.$x, removeAlertRequest)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_alert/* RESTORE_ALERT_REQUEST */.f9, restoreAlertRequest)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var remove_alert = (remove_alert_mySaga);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/remove-list-item.js
var remove_list_item_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};






function removeListItem(param) {
    var id, listId, response, restoreToken, err;
    return remove_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id, listId = param.listId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listItemDelete($id: Int!, $listId: Int!) {\n        listItemDelete(id: $id, listId: $listId) {\n          restoreToken\n        }\n      }", {
                        id: id,
                        listId: listId
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListItemError */.f$)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                restoreToken = response.data.listItemDelete.restoreToken;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListItemSuccess */.M2)(restoreToken, id, listId))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", /*#__PURE__*/ react.createElement(react.Fragment, null, window.APP_GLOBALS.t("lists", "confirm.item-deleted"))))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 7:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListItemError */.f$)(err))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function remove_list_item_mySaga() {
    return remove_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* REMOVE_LIST_ITEM_REQUEST */.aF, removeListItem)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var remove_list_item = (remove_list_item_mySaga);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/remove-list.js
var remove_list_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};






function removeList(param) {
    var id, response, restoreToken, err;
    return remove_list_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listDelete($id: Int!) {\n        listDelete(id: $id) {\n          restoreToken\n        }\n      }", {
                        id: id
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListError */.Ll)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                restoreToken = response.data.listDelete.restoreToken;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListSuccess */.Mr)(restoreToken, id))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", /*#__PURE__*/ react.createElement(react.Fragment, null, window.APP_GLOBALS.t("lists", "confirm.list-deleted"))))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 7:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListError */.Ll)(err))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function remove_list_mySaga() {
    return remove_list_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* REMOVE_LIST_REQUEST */.N$, removeList)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var remove_list = (remove_list_mySaga);

;// CONCATENATED MODULE: ./src/areas/account/requests/index.js
var request = function(url) {
    return fetch("/_internal/account/".concat(url), {
        credentials: "include",
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    }).then(function(resp) {
        return resp.json();
    });
};
var fetchMe = function() {
    return request("me");
};

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/update-user.js
function update_user_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function update_user_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            update_user_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function update_user_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function update_user_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        update_user_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var update_user_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





// Fetch user data again to update the new list name across the app
function updateUser() {
    var response, userInfo, error;
    return update_user_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    6
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(fetchMe)
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* getPjAccountUserInfo */.E8)
                ];
            case 2:
                userInfo = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(account_actions/* default.userReceive */.ZP.userReceive({
                        me: update_user_objectSpreadProps(update_user_objectSpread({}, response.me), {
                            authenticationMethod: userInfo === null || userInfo === void 0 ? void 0 : userInfo.authenticationMethod
                        })
                    }))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 4:
                error = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* editListError */.tH)(error))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var update_user = (updateUser);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/add-list-item.js
var add_list_item_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};










function createList(param) {
    var listName, createdList, response, error;
    return add_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                listName = param.listName;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    ,
                    8
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listCreate($name: String!) {\n          listCreate(name: $name) {\n            success\n            list {\n              id\n              name\n            }\n          }\n        }", {
                        name: listName
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* createListError */.M1)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2,
                    false
                ];
            case 4:
                createdList = response.data.listCreate.list;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* createListSuccess */.re)(createdList))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* createListError */.M1)(error))
                ];
            case 7:
                _state.sent();
                return [
                    2,
                    false
                ];
            case 8:
                return [
                    2,
                    createdList
                ];
        }
    });
}
function addListItem(param) {
    var productId, productName, isDesktop, tab, selectedList, ref, lists, listId, listName, createdList, response, addedItem, err;
    return add_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                productId = param.productId, productName = param.productName, isDesktop = param.isDesktop;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar;
                    })
                ];
            case 1:
                tab = _state.sent().tab;
                if (!!isDesktop) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(mobile_menu/* default.openMenu */.ZP.openMenu())
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,sidebar_mobile_actions/* setMobileSidebarView */.E)(sidebar_mobile_constants/* VIEWS.LIST */.n.LIST))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                if (!(tab !== sidebar_constants/* SIDEBAR_STATE.LISTS */.$J.LISTS)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* openLists */.pu)())
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar;
                    })
                ];
            case 7:
                selectedList = _state.sent().selectedList;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.account.me.lists;
                    })
                ];
            case 8:
                ref = _state.sent(), lists = ref.nodes;
                listId = selectedList;
                listName = selectedList ? lists.find(function(x) {
                    return x.id === listId;
                }).name : undefined;
                if (!!listId) return [
                    3,
                    11
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(createList, {
                        listName: window.APP_GLOBALS.t("lists", "list.default-name")
                    })
                ];
            case 9:
                createdList = _state.sent();
                listId = createdList.id;
                listName = createList.name;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* selectList */.Fz)(listId))
                ];
            case 10:
                _state.sent();
                _state.label = 11;
            case 11:
                _state.trys.push([
                    11,
                    17,
                    ,
                    20
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "\n      mutation listItemAdd($id: ID!, $listId: Int!, $type: ListItemType!) {\n        listItemAdd(id: $id, listId: $listId, type: $type) {\n          success\n          item {\n            id\n          }\n        }\n      }", {
                        id: productId,
                        listId: listId,
                        type: "product"
                    })
                ];
            case 12:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    14
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(response.errors[0]))
                ];
            case 13:
                _state.sent();
                _state.label = 14;
            case 14:
                addedItem = response.data.listItemAdd.item;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemSuccess */.j3)(addedItem.id))
                ];
            case 15:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("lists", "confirm.item-added", {
                        productName: productName,
                        listName: listName
                    })))
                ];
            case 16:
                _state.sent();
                return [
                    3,
                    20
                ];
            case 17:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 18:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(err))
                ];
            case 19:
                _state.sent();
                return [
                    3,
                    20
                ];
            case 20:
                return [
                    2
                ];
        }
    });
}
function add_list_item_mySaga() {
    return add_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* ADD_LIST_ITEM_REQUEST */.En, addListItem)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* CREATE_LIST_REQUEST */.QE, createList)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* CREATE_LIST_SUCCESS */.Kj, update_user)
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var add_list_item = (add_list_item_mySaga);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/edit-list.js
var edit_list_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




function editList(param) {
    var id, name, visibility, response, error;
    return edit_list_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id, name = param.name, visibility = param.visibility;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    8,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listEdit($id: Int!, $name: String!, $visibility: ListVisibility!) {\n        listEdit(id: $id, name: $name, visibility: $visibility) {\n          success\n        }\n      }", {
                        id: id,
                        name: name,
                        visibility: visibility
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* editListError */.tH)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2,
                    false
                ];
            case 4:
                if (!response.data.listEdit.success) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* editListSuccess */.P)({
                        id: id,
                        name: name
                    }))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* closeListSettings */.jy)())
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                error = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* editListError */.tH)(error))
                ];
            case 9:
                _state.sent();
                return [
                    2,
                    false
                ];
            case 10:
                return [
                    2,
                    true
                ];
        }
    });
}
function edit_list_mySaga() {
    return edit_list_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* EDIT_LIST_REQUEST */.GB, editList)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* EDIT_LIST_SUCCESS */.Ce, update_user)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var edit_list = (edit_list_mySaga);

// EXTERNAL MODULE: ./src/areas/reviews/generic-user-review.graphql
var generic_user_review_graphql = __webpack_require__(4692);
var generic_user_review_graphql_default = /*#__PURE__*/__webpack_require__.n(generic_user_review_graphql);
;// CONCATENATED MODULE: ./src/areas/reviews/sagas/index.js
function sagas_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sagas_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sagas_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sagas_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sagas_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sagas_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function sagas_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = sagas_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function sagas_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var reviews_sagas_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};









// Remove all query params related to reviews when closing the form
function removeReviewQueryParams() {
    var push, _ref, review, reviewId, code, draft, queryParams;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                push = window.__history.push;
                _ref = dist_default().parse(window.location.search), review = _ref.review, reviewId = _ref.review_id, code = _ref.code, draft = _ref.draft, queryParams = sagas_objectWithoutProperties(_ref, [
                    "review",
                    "review_id",
                    "code",
                    "draft"
                ]);
                if (!review && !reviewId && !code && !draft) return [
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(push, decodeURIComponent("".concat(window.location.pathname, "?").concat(dist_default().stringify(queryParams))))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
// Update review data on profile pages
function updateProfileReviews(shouldSave) {
    var limit, isAuthenticated, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.review.pageInfo.profile;
                    })
                ];
            case 1:
                limit = _state.sent().limit;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.account.isAuthenticated;
                    })
                ];
            case 2:
                isAuthenticated = _state.sent().isAuthenticated;
                if (!isAuthenticated) return [
                    2
                ];
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "\n        query updateProfileReviews(\n          $limit: Int = 10\n          $getProduct: Boolean = true\n          $getStore: Boolean = true\n        ) {\n          me {\n            reviews(offset: 0, limit: $limit) {\n              totalItems\n              pageInfo {\n                limit\n                offset\n                hasNext\n                hasPrevious\n              }\n              nodes {\n                ...GenericUserReview\n              }\n            }\n          }\n        }\n        ".concat((generic_user_review_graphql_default())), {
                        limit: limit
                    })
                ];
            case 4:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 6:
                _state.sent();
                return [
                    2
                ];
            case 7:
                if (!shouldSave) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* updateShopReviewData */.i_)({
                        nodes: response.data.me.reviews.nodes
                    }))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
// Updates review data and invalidates previous cached results
function updateReviewsData(param) {
    var shopId, productId, location, shouldSaveProfileData, type, limit, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                shopId = param.shopId, productId = param.productId, location = param.location;
                shouldSaveProfileData = Boolean(location && location.includes("/account/profile"));
                // Updates and invalidates cache for profile reviews
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateProfileReviews, shouldSaveProfileData)
                ];
            case 1:
                _state.sent();
                if (!shopId && !productId) return [
                    2
                ];
                if (shopId) type = "store";
                if (productId) type = "product";
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.review.pageInfo[type];
                    })
                ];
            case 2:
                limit = _state.sent().limit;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "query updateReviews($id: Int!, $limit: Int!, $getProduct: Boolean = false, $getStore: Boolean = false) {\n          ".concat(type, '(id: $id) {\n            userReviews(limit: $limit, offset: 0, invalidateCache: true) {\n              nodes {\n                ...GenericUserReview\n              }\n              myReview {\n                id\n                rating\n                reviewText\n                createdAt\n                localizedCreatedAt: createdAt(format: "L")\n                localizedUpdatedAt: updatedAt(format: "L")\n              }\n            }\n\n          }\n        }, ').concat((generic_user_review_graphql_default())), {
                        id: shopId || productId,
                        limit: limit,
                        getProduct: type === "product"
                    })
                ];
            case 4:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 6:
                _state.sent();
                return [
                    2
                ];
            case 7:
                if (!!shouldSaveProfileData) return [
                    3,
                    9
                ];
                // Updates and invalidates cache for store and product pages
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* updateShopReviewData */.i_)({
                        shopId: shopId,
                        productId: productId,
                        nodes: response.data[type].userReviews.nodes,
                        myReview: response.data[type].userReviews.myReview
                    }))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function updateSummaryData(id, type) {
    var ref, response, ref1, _code;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,requests/* graphql */.BX)("query updateReviewSummary($id: Int!) {\n      ".concat(type.toLowerCase(), "(id: $id) {\n        userReviewSummary {\n          rating\n          count\n          countTotal\n          distributionNew {\n            score\n            count\n            percentage\n          }\n        }\n      }\n    }\n    "), {
                        id: id
                    })
                ];
            case 1:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                if (!(response.data && response.data.product && response.data.product.userReviewSummary)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* updateReviewSummary */.Mf)(sagas_objectSpreadProps(sagas_objectSpread({}, response.data.product.userReviewSummary), {
                        belongsToId: id
                    })))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    2
                ];
        }
    });
}
function createReview(param) {
    var belongsToId, rating, type, reviewText, purchaseDate, displayName, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                belongsToId = param.belongsToId, rating = param.rating, type = param.reviewType, reviewText = param.reviewText, purchaseDate = param.purchaseDate, displayName = param.displayName;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    12,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewCreate(\n        $belongsToId: Int!,\n        $type: reviewType!,\n        $rating: Int!,\n        $reviewText: String!,\n        $purchaseDate: String\n        $displayName: String\n        $getProduct: Boolean = false\n        $getStore: Boolean = false) {\n          reviewCreate(\n            type: $type,\n            belongsToId: $belongsToId,\n            rating: $rating,\n            reviewText: $reviewText,\n            purchaseDate: $purchaseDate\n            displayName: $displayName) {\n              ...GenericUserReview\n            }\n      }, ".concat((generic_user_review_graphql_default())), {
                        type: type,
                        belongsToId: belongsToId,
                        rating: parseInt(rating, 10),
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        displayName: displayName
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                if (!displayName) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,display_name/* setDisplayName */.hC)(displayName))
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* createReviewSuccess */.ey)({
                        productId: belongsToId
                    }))
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, type)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.create-success")))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 12:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function createShopReview(param) {
    var belongsToId, belongsToName, rating, reviewType, reviewText, purchaseDate, answers, email, displayName, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                belongsToId = param.belongsToId, belongsToName = param.belongsToName, rating = param.rating, reviewType = param.reviewType, reviewText = param.reviewText, purchaseDate = param.purchaseDate, answers = param.answers, email = param.email, displayName = param.displayName;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    11,
                    ,
                    13
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewCreate(\n        $belongsToId: Int!,\n        $type: reviewType!,\n        $rating: Int!,\n        $reviewText: String!,\n        $purchaseDate: String,\n        $answers: [AnswerInput]\n        $email: String\n        $displayName: String\n        $getProduct: Boolean = false\n        $getStore: Boolean = false) {\n          reviewCreate(\n            type: $type,\n            belongsToId: $belongsToId,\n            rating: $rating,\n            reviewText: $reviewText,\n            purchaseDate: $purchaseDate,\n            answers: $answers,\n            email: $email\n            displayName: $displayName) {\n              ...GenericUserReview\n            }\n      }, ".concat((generic_user_review_graphql_default())), {
                        type: reviewType,
                        belongsToId: belongsToId,
                        rating: parseInt(rating, 10),
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        answers: answers,
                        email: email,
                        displayName: displayName
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                if (!displayName) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,display_name/* setDisplayName */.hC)(displayName))
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, reviewType)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* createShopReviewSuccess */.zk)(// Don't update data if review needs to be verified before published
                    !email ? {
                        shopId: belongsToId
                    } : {}))
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 10:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 11:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 12:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 13:
                return [
                    2
                ];
        }
    });
}
function editReview(param) {
    var reviewId, reviewType, rating, reviewText, purchaseDate, belongsToId, location, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, reviewType = param.reviewType, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, belongsToId = param.belongsToId, location = param.location;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewEdit(\n        $reviewId: String!,\n        $rating: Int!,\n        $reviewText: String!,\n        $purchaseDate: String,\n        $getProduct: Boolean = false\n        $getStore: Boolean = false\n      ) {\n        reviewEdit(\n          reviewId: $reviewId,\n          rating: $rating,\n          reviewText: $reviewText,\n          purchaseDate: $purchaseDate,\n        ) {\n          ...GenericUserReview\n        }\n      }, ".concat((generic_user_review_graphql_default())), {
                        reviewId: reviewId,
                        rating: parseInt(rating, 10),
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        getProduct: reviewType === "PRODUCT"
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* editReviewSuccess */.kX)({
                        productId: belongsToId,
                        location: location
                    }))
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, reviewType)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.edit-success")))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function editShopReview(param) {
    var reviewId, reviewType, rating, reviewText, purchaseDate, belongsToId, belongsToName, answers, location, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, reviewType = param.reviewType, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, belongsToId = param.belongsToId, belongsToName = param.belongsToName, answers = param.answers, location = param.location;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation editShopReview(\n        $reviewId: ID!\n        $rating: Int!\n        $reviewText: String!\n        $purchaseDate: String\n        $answers: [AnswerInput]\n      ) {\n        editShopReview(\n          reviewId: $reviewId,\n          rating: $rating,\n          reviewText: $reviewText,\n          purchaseDate: $purchaseDate,\n          answers: $answers\n        ) {\n          success\n        }\n      }", {
                        reviewId: reviewId,
                        rating: parseInt(rating, 10),
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        answers: answers
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* editShopReviewSuccess */.Jy)({
                        shopId: belongsToId,
                        location: location
                    }))
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, reviewType)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.edit-success")))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function deleteReview(param) {
    var reviewId, reviewType, belongsToId, location, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, reviewType = param.reviewType, belongsToId = param.belongsToId, location = param.location;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewDelete(\n        $reviewId: String!,\n      ) {\n        reviewDelete(\n          reviewId: $reviewId,\n        ) {\n          success\n        }\n      }", {
                        reviewId: reviewId
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* deleteReviewSuccess */.Ty)({
                        productId: belongsToId,
                        location: location
                    }))
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, reviewType)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.delete-success")))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function deleteShopReview(param) {
    var reviewId, shopId, shopName, location, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, shopId = param.shopId, shopName = param.shopName, location = param.location;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    9,
                    ,
                    11
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "\n      mutation($reviewId: ID!) {\n        deleteShopReview(id: $reviewId) {\n          success\n        }\n      }\n    ", {
                        reviewId: reviewId
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* deleteShopReviewSuccess */.TA)({
                        shopId: shopId,
                        reviewId: reviewId,
                        location: location
                    }))
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.delete-success")))
                ];
            case 8:
                _state.sent();
                return [
                    3,
                    11
                ];
            case 9:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 10:
                _state.sent();
                return [
                    3,
                    11
                ];
            case 11:
                return [
                    2
                ];
        }
    });
}
function reportReview(param) {
    var reviewId, message, email, response, err;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, message = param.message, email = param.email;
                if (!(!email || !(0,helpers/* isValidEmail */.v)(email))) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewFailed */.c1)("error.missing.email"))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                if (!!message) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewFailed */.c1)("error.missing.message"))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                _state.trys.push([
                    4,
                    11,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewReport(\n        $reviewId: String!,\n        $message: String!,\n        $email: String!,\n      ) {\n        reviewReport(\n          reviewId: $reviewId,\n          message: $message,\n          email: $email,\n        ) {\n          success\n        }\n      }", {
                        reviewId: reviewId,
                        message: message,
                        email: email
                    })
                ];
            case 5:
                response = _state.sent();
                if (!(response && response.data && response.data.reviewReport && response.data.reviewReport.success)) return [
                    3,
                    8
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewSuccess */.qG)())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("feedback", "report-review.success")))
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 8:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewFailed */.c1)(response ? response.errors : undefined))
                ];
            case 9:
                _state.sent();
                _state.label = 10;
            case 10:
                return [
                    3,
                    14
                ];
            case 11:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewFailed */.c1)(err.message))
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function likeReview(param) {
    var id, reviewType, query, response, likedReviews, value;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id, reviewType = param.reviewType;
                query = "\n    mutation($reviewId: String!) {\n      reviewVoteHelpful(reviewId: $reviewId) {\n        success\n      }\n    }\n  ";
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, query, {
                        reviewId: id
                    })
                ];
            case 1:
                response = _state.sent();
                if (!(response.data.reviewVoteHelpful && response.data.reviewVoteHelpful.success)) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.account.me.likes.reviews;
                    })
                ];
            case 2:
                likedReviews = _state.sent();
                value = likedReviews && likedReviews.includes(id) ? "unlike" : "like";
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* likeReviewSuccess */.U9)(id, value))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 4:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* likeReviewFailed */.XN)())
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    2
                ];
        }
    });
}
function reviews_sagas_mySaga() {
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* CREATE_REVIEW */.l3, createReview)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* CREATE_SHOP_REVIEW */.mb, createShopReview)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* EDIT_SHOP_REVIEW */.CA, editShopReview)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* EDIT_REVIEW */.hy, editReview)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* DELETE_REVIEW */.y$, deleteReview)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* DELETE_SHOP_REVIEW */.Bs, deleteShopReview)
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* REPORT_REVIEW */.ar, reportReview)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* LIKE_REVIEW_TOGGLE */.vH, likeReview)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)([
                        reviews_actions/* CREATE_SHOP_REVIEW_SUCCESS */.eA,
                        reviews_actions/* EDIT_SHOP_REVIEW_SUCCESS */.s6,
                        reviews_actions/* DELETE_SHOP_REVIEW_SUCCESS */.UW,
                        reviews_actions/* CREATE_REVIEW_SUCCESS */.bg,
                        reviews_actions/* EDIT_REVIEW_SUCCESS */.cO,
                        reviews_actions/* DELETE_REVIEW_SUCCESS */.g6
                    ], updateReviewsData)
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* CLOSE_REVIEW_DIALOG */.TF, removeReviewQueryParams)
                ];
            case 10:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var reviews_sagas = (reviews_sagas_mySaga);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/order-lists.js
var order_lists_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




function orderLists(param) {
    var listIds, response, err;
    return order_lists_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                listIds = param.listIds;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    3,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listsOrder($listIds: [Int!]!) {\n        listsOrder(listIds: $listIds) {\n          success\n        }\n      }", {
                        listIds: listIds
                    })
                ];
            case 2:
                response = _state.sent();
                if (response.errors) {
                    return [
                        2
                    ];
                }
                return [
                    3,
                    5
                ];
            case 3:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function orderListItems(param) {
    var listItemIds, listId, response, err;
    return order_lists_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                listItemIds = param.listItemIds, listId = param.listId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    3,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listItemsOrder($listId: Int!, $listItemIds: [Int!]!) {\n        listItemsOrder(listId: $listId, listItemIds: $listItemIds) {\n          success\n        }\n      }", {
                        listItemIds: listItemIds,
                        listId: listId
                    })
                ];
            case 2:
                response = _state.sent();
                if (response.errors) {
                    return [
                        2
                    ];
                }
                return [
                    3,
                    5
                ];
            case 3:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function order_lists_mySaga() {
    return order_lists_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* ORDER_LISTS_REQUEST */.Po, orderLists)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* ORDER_LIST_ITEMS_REQUEST */.w, orderListItems)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var order_lists = (order_lists_mySaga);

// EXTERNAL MODULE: ./src/areas/sidebar/my-products-mutation.graphql
var my_products_mutation_graphql = __webpack_require__(16242);
var my_products_mutation_graphql_default = /*#__PURE__*/__webpack_require__.n(my_products_mutation_graphql);
// EXTERNAL MODULE: ./src/areas/sidebar/my-products-import.graphql
var my_products_import_graphql = __webpack_require__(50191);
var my_products_import_graphql_default = /*#__PURE__*/__webpack_require__.n(my_products_import_graphql);
;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/my-products.js
var my_products_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};











function addItemToMyProducts(param) {
    var productId, productName, isDesktop, tab, response, err;
    return my_products_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                productId = param.productId, productName = param.productName, isDesktop = param.isDesktop;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar;
                    })
                ];
            case 1:
                tab = _state.sent().tab;
                if (!!isDesktop) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(mobile_menu/* default.openMenu */.ZP.openMenu())
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,sidebar_mobile_actions/* setMobileSidebarView */.E)(sidebar_mobile_constants/* VIEWS.LIST */.n.LIST))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                if (!(tab !== sidebar_constants/* SIDEBAR_STATE.LISTS */.$J.LISTS)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* openLists */.pu)())
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _state.trys.push([
                    6,
                    14,
                    ,
                    17
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, (my_products_mutation_graphql_default()), {
                        productIds: [
                            productId
                        ]
                    })
                ];
            case 7:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(response.errors[0]))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                if (!response.data) return [
                    3,
                    13
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* selectList */.Fz)(response.data.myProductsItemsAdd.id))
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemSuccess */.j3)())
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("lists", "confirm.item-added", {
                        productName: productName,
                        listName: window.APP_GLOBALS.t("lists", "my-products.title")
                    })))
                ];
            case 12:
                _state.sent();
                _state.label = 13;
            case 13:
                return [
                    3,
                    17
                ];
            case 14:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 15:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(err))
                ];
            case 16:
                _state.sent();
                return [
                    3,
                    17
                ];
            case 17:
                return [
                    2
                ];
        }
    });
}
function importListToMyProducts(param) {
    var listId, response, selectedList, err;
    return my_products_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                listId = param.listId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    9,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,requests/* graphql */.BX)((my_products_import_graphql_default()), {
                        listId: listId
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                if (!response.data) return [
                    3,
                    8
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar.selectedList;
                    })
                ];
            case 5:
                selectedList = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* importListToMyProductsSuccess */._8)())
                ];
            case 6:
                _state.sent();
                if (!(selectedList === sidebar_constants/* NO_MY_PRODUCTS_CREATED_ID */.Ym)) return [
                    3,
                    8
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* selectList */.Fz)(response.data.myProductsImport.id))
                ];
            case 7:
                _state.sent();
                _state.label = 8;
            case 8:
                return [
                    3,
                    12
                ];
            case 9:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(err))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function myProductsSaga() {
    return my_products_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* ADD_ITEM_TO_MY_PRODUCTS_REQUEST */.xC, addItemToMyProducts)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* IMPORT_LIST_TO_MY_PRODUCTS */.sy, importListToMyProducts)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var my_products = (myProductsSaga);

// EXTERNAL MODULE: ./src/areas/account/settings/sagas/index.js
var settings_sagas = __webpack_require__(73081);
// EXTERNAL MODULE: ./src/areas/account/sagas/queries/like-shop.graphql
var like_shop_graphql = __webpack_require__(70518);
var like_shop_graphql_default = /*#__PURE__*/__webpack_require__.n(like_shop_graphql);
// EXTERNAL MODULE: ./src/areas/account/sagas/queries/dislike-shop.graphql
var dislike_shop_graphql = __webpack_require__(7432);
var dislike_shop_graphql_default = /*#__PURE__*/__webpack_require__.n(dislike_shop_graphql);
// EXTERNAL MODULE: ./src/areas/account/sagas/queries/shop-preference-state.graphql
var shop_preference_state_graphql = __webpack_require__(74035);
var shop_preference_state_graphql_default = /*#__PURE__*/__webpack_require__.n(shop_preference_state_graphql);
;// CONCATENATED MODULE: ./src/areas/account/sagas/shop-preference.ts
var shop_preference_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};








function likeShopRequest(param) {
    var shopId, mutationResponse, stateResponse, e;
    return shop_preference_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                shopId = param.shopId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(function() {
                        return (0,requests/* graphql */.BX)((like_shop_graphql_default()), {
                            shopId: "".concat(shopId)
                        });
                    })
                ];
            case 2:
                mutationResponse = _state.sent();
                if (!(mutationResponse.errors && mutationResponse.errors.length)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, mutationResponse.errors)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("error", window.APP_GLOBALS.t("account", "shop-preference.request-error"), {
                        toastId: "likeShop".concat(shopId)
                    }))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* shopPreferenceError */.pT)())
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(function() {
                        return (0,requests/* graphql */.BX)((shop_preference_state_graphql_default()));
                    })
                ];
            case 7:
                stateResponse = _state.sent();
                if (!stateResponse.data) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* receiveShopPreference */.h_)(stateResponse.data))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                return [
                    3,
                    14
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("error", window.APP_GLOBALS.t("account", "shop-preference.request-error"), {
                        toastId: "likeShop".concat(shopId)
                    }))
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* shopPreferenceError */.pT)())
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function dislikeShopRequest(param) {
    var shopId, mutationResponse, stateResponse, e;
    return shop_preference_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                shopId = param.shopId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(function() {
                        return (0,requests/* graphql */.BX)((dislike_shop_graphql_default()), {
                            shopId: "".concat(shopId)
                        });
                    })
                ];
            case 2:
                mutationResponse = _state.sent();
                if (!(mutationResponse.errors && mutationResponse.errors.length)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, mutationResponse.errors)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("error", window.APP_GLOBALS.t("account", "shop-preference.request-error"), {
                        toastId: "dislikeShop".concat(shopId)
                    }))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* shopPreferenceError */.pT)())
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(function() {
                        return (0,requests/* graphql */.BX)((shop_preference_state_graphql_default()));
                    })
                ];
            case 7:
                stateResponse = _state.sent();
                if (!stateResponse.data) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* receiveShopPreference */.h_)(stateResponse.data))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                return [
                    3,
                    14
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("error", window.APP_GLOBALS.t("account", "shop-preference.request-error"), {
                        toastId: "dislikeShop".concat(shopId)
                    }))
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* shopPreferenceError */.pT)())
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function shopPreferenceSaga() {
    return shop_preference_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(account_actions/* USER_LIKE_SHOP_REQUEST */.ie, likeShopRequest)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(account_actions/* USER_DISLIKE_SHOP_REQUEST */.oN, dislikeShopRequest)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var shop_preference = (shopPreferenceSaga);

;// CONCATENATED MODULE: ./src/components/filters/reducers/api.js
function api_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function api_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            api_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function api_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function api_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        api_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var filterChildren = function(filteredValues, child) {
    var valueIndex = filteredValues.findIndex(function(v) {
        return v === child.id;
    });
    if (valueIndex !== -1) {
        filteredValues.splice(valueIndex, 1);
    }
    if (child.children) return child.children.reduce(filterChildren, filteredValues);
    return filteredValues;
};
var flattenTree = function(values, parents, children) {
    var autoSelectChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var reducedParents = parents.reduce(function(filteredValues, parent) {
        if (!parent.children) return filteredValues;
        var childIds = parent.children.map(function(child) {
            return child.id;
        });
        var checked = childIds.map(function(id) {
            return filteredValues.includes(id);
        });
        if (autoSelectChildren && checked.includes(false) === false) {
            filteredValues.push(parent.id);
            return filteredValues.filter(function(value) {
                return !childIds.includes(value);
            });
        }
        if (filteredValues.includes(parent.id)) {
            return filteredValues.filter(function(value) {
                return value !== parent.id;
            });
        }
        return filteredValues;
    }, values);
    var reducedChildren = children.reduce(filterChildren, reducedParents);
    return reducedChildren;
};
var uniqueValues = function(values) {
    return values.filter(function(value, index) {
        return values.indexOf(value) === index;
    });
};
/* harmony default export */ function api(query, action) {
    var checked = action.checked, value = action.value, id = action.id, parents = action.parents, children = action.children, autoSelectChildren = action.autoSelectChildren;
    var values = query[id] || [];
    if (checked) {
        values.push(value);
        return api_objectSpreadProps(api_objectSpread({}, query), api_defineProperty({}, id, uniqueValues(flattenTree(values, parents || [], children || [], autoSelectChildren))));
    }
    // Filter out all children from array
    var childrenIds = children ? children.map(function(child) {
        return child.id;
    }) : [];
    var parentIds = parents ? parents.map(function(p) {
        return p.id;
    }) : [];
    var filtered = values.filter(function(x) {
        return x !== value;
    }).filter(function(x) {
        return !childrenIds.includes(x);
    });
    if (filtered.length === 0) {
        delete query[id]; // eslint-disable-line
        return api_objectSpread({}, query);
    }
    // Need to traverse parent to set new values
    if (filtered.length === values.length) {
        return api_objectSpreadProps(api_objectSpread({}, query), api_defineProperty({}, id, uniqueValues(filtered.concat(parents.reduce(function(results, curr) {
            if (results.done) {
                return results;
            }
            curr.children.forEach(function(child) {
                if (child.id === value) {
                    return;
                }
                results.values.push(child.id);
            });
            // Abort reduce when to level selected has been reached
            if (values.includes(curr.id)) {
                results.done = true; // eslint-disable-line
            }
            return results;
        }, {
            done: false,
            values: []
        }).values)// Filter out all parents from array
        .filter(function(value) {
            return !parentIds.includes(value);
        }))));
    }
    return api_objectSpreadProps(api_objectSpread({}, query), api_defineProperty({}, id, uniqueValues(filtered.filter(function(x) {
        return !parentIds.includes(x);
    }))));
};

// EXTERNAL MODULE: ./src/globals/helpers/is-numeric.js
var is_numeric = __webpack_require__(53541);
;// CONCATENATED MODULE: ./src/areas/category/sagas/filter.js
function sagas_filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sagas_filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sagas_filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sagas_filter_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sagas_filter_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sagas_filter_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var filter_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var filter_reducer = function(query, action) {
    switch(action.filterType){
        case "boolean":
            {
                if (action.value === null) {
                    // eslint-disable-next-line no-param-reassign
                    delete query[action.id];
                    return sagas_filter_objectSpread({}, query);
                }
                return sagas_filter_objectSpreadProps(sagas_filter_objectSpread({}, query), sagas_filter_defineProperty({}, action.id, action.value));
            }
        case "slider":
            {
                if (action.value === null) {
                    // eslint-disable-next-line no-param-reassign
                    delete query[action.id];
                    return sagas_filter_objectSpread({}, query);
                }
                return sagas_filter_objectSpreadProps(sagas_filter_objectSpread({}, query), sagas_filter_defineProperty({}, action.id, action.value));
            }
        case "list":
            {
                return api(query, action);
            }
        case "string":
            {
                return sagas_filter_objectSpreadProps(sagas_filter_objectSpread({}, query), sagas_filter_defineProperty({}, action.id, action.value));
            }
        default:
            {
                return query;
            }
    }
};
var getQuery = function(state) {
    return state.areas.category.filter.query;
};
var getCompareProperties = function(state) {
    return state.areas.category.filter.comparing;
};
var getLoadedCategoryId = function(state) {
    return state.areas.category.filter.loadedCategoryId;
};
var getFilter = function(code, id, items) {
    return fetch("/_internal/filters/".concat(id).concat(items ? "/".concat(items) : ""), {
        credentials: "include"
    }).then(function(res) {
        if (res.status !== 200) {
            throw new Error("Filter fetch failed for ID ".concat(id).concat(items ? ", Items ".concat(items) : ""));
        }
        return res.json();
    }).catch(function(err) {
        return {
            error: err
        };
    });
};
var postFilter = function(code, id, query) {
    return fetch("/_internal/filters/".concat(id), {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(query)
    }).then(function(res) {
        if (res.status !== 200) {
            throw new Error("Filter create failed for ID ".concat(id));
        }
        return res.json();
    }).then(function(data) {
        return data.items[0];
    }).catch(function(err) {
        return {
            error: err
        };
    });
};
// Utility to get certain properties from an object as a new object
var pickProperties = function(props, obj) {
    return Object.keys(obj).reduce(function(params, key) {
        return props.includes(key) ? Object.assign(params, sagas_filter_defineProperty({}, key, obj[key])) : params;
    }, {});
};
function handleFilterActions(action) {
    var _, qs, loadedCategoryId, categoryState, ref, immediateProducts, productCount, _variables, id, filterId, brand, categoryData, toggledBrandCategory, hasChangedCategory, brandFilterId, brandFilter, data, replace, query, newQuery, categoryId, newFilter, filterId1, qs1, paramsToPropagate, newQueryString, data1, replace1, compare, selectedProps, currentParams, newQueryString1;
    return filter_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _ = action.type;
                switch(_){
                    case "ROUTE_LOADED":
                        return [
                            3,
                            1
                        ];
                    case filter/* FILTER_CHANGE_ACTION */.$H:
                        return [
                            3,
                            13
                        ];
                    case filter/* COMPARE_PROPERTY */.gd:
                        return [
                            3,
                            28
                        ];
                }
                return [
                    3,
                    31
                ];
            case 1:
                if (!action.route) {
                    return [
                        3,
                        32
                    ];
                }
                qs = querystring.decode(location.search.substr(1));
                if (!qs.compare) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* compareProperties */.QL)(qs.compare.split(",").filter(is_numeric/* default */.Z)))
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(getLoadedCategoryId)
                ];
            case 4:
                loadedCategoryId = _state.sent();
                if (action.route.name !== "category" || !action.data || !action.data.category) {
                    return [
                        3,
                        32
                    ];
                }
                categoryState = action.data.category;
                ref = action.category || categoryState, immediateProducts = ref.immediateProducts, productCount = ref.productCount;
                _variables = action.route.variables, id = _variables.id, filterId = _variables.filterId, brand = _variables.brand;
                categoryData = {
                    categoryId: id,
                    productCount: productCount
                };
                if (!immediateProducts) {
                    return [
                        3,
                        32
                    ];
                }
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.category.filter.toggledBrandCategory;
                    })
                ];
            case 5:
                toggledBrandCategory = _state.sent();
                hasChangedCategory = loadedCategoryId !== id || loadedCategoryId === id && toggledBrandCategory;
                if (!hasChangedCategory) return [
                    3,
                    12
                ];
                brandFilterId = null;
                if (!brand) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(postFilter, window.CLIENT_MARKET.code, id, {
                        brands: [
                            String(brand)
                        ]
                    })
                ];
            case 6:
                brandFilter = _state.sent();
                brandFilterId = brandFilter.id;
                _state.label = 7;
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(getFilter, window.CLIENT_MARKET.code, brandFilterId || filterId || id)
                ];
            case 8:
                data = _state.sent();
                if (!data.error) return [
                    3,
                    10
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterFetchFailed */.lf)(data, id))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterReceive */.m0)(data, categoryData))
                ];
            case 11:
                _state.sent();
                _state.label = 12;
            case 12:
                return [
                    3,
                    32
                ];
            case 13:
                replace = window.__history.replace; // No idea why this is undefined in scope above
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(getQuery)
                ];
            case 14:
                query = _state.sent();
                newQuery = filter_reducer(query, action);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterQuery */.DQ)(newQuery))
                ];
            case 15:
                _state.sent();
                categoryId = action.categoryId;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(postFilter, window.CLIENT_MARKET.code, categoryId, newQuery)
                ];
            case 16:
                newFilter = _state.sent();
                if (!newFilter.error) return [
                    3,
                    18
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterFetchFailed */.lf)({
                        error: newFilter.error
                    }, categoryId))
                ];
            case 17:
                _state.sent();
                return [
                    2
                ];
            case 18:
                filterId1 = newFilter.id;
                qs1 = querystring.decode(location.search.substr(1));
                paramsToPropagate = pickProperties([
                    "brand",
                    "t",
                    "sort",
                    "k",
                    "b",
                    "m",
                    "o",
                    "catId",
                    "compare",
                    "direction"
                ], qs1);
                if (!(Object.keys(newQuery).length === 0)) return [
                    3,
                    20
                ];
                paramsToPropagate.k = newFilter.parent.id;
                delete paramsToPropagate.catId;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(replace, "".concat(window.location.pathname, "?").concat(querystring.encode(paramsToPropagate)))
                ];
            case 19:
                _state.sent();
                return [
                    3,
                    22
                ];
            case 20:
                newQueryString = paramsToPropagate;
                newQueryString.catId = categoryId;
                newQueryString.k = filterId1;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(replace, "".concat(window.location.pathname, "?").concat(querystring.encode(newQueryString)))
                ];
            case 21:
                _state.sent();
                _state.label = 22;
            case 22:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(getFilter, window.CLIENT_MARKET.code, filterId1)
                ];
            case 23:
                data1 = _state.sent();
                if (!data1.error) return [
                    3,
                    25
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterFetchFailed */.lf)(data1, categoryId))
                ];
            case 24:
                _state.sent();
                return [
                    3,
                    27
                ];
            case 25:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterReceive */.m0)(data1, {
                        categoryId: categoryId
                    }))
                ];
            case 26:
                _state.sent();
                _state.label = 27;
            case 27:
                return [
                    3,
                    32
                ];
            case 28:
                replace1 = window.__history.replace; // No idea why this is undefined in scope above
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(getCompareProperties)
                ];
            case 29:
                compare = _state.sent();
                selectedProps = compare.filter(is_numeric/* default */.Z);
                currentParams = querystring.decode(window.location.search.substring(1));
                newQueryString1 = sagas_filter_objectSpreadProps(sagas_filter_objectSpread({}, currentParams), {
                    compare: selectedProps.join(",")
                });
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(replace1, "".concat(window.location.pathname, "?").concat(querystring.encode(newQueryString1)))
                ];
            case 30:
                _state.sent();
                return [
                    3,
                    32
                ];
            case 31:
                {
                    return [
                        3,
                        32
                    ];
                }
                _state.label = 32;
            case 32:
                return [
                    2
                ];
        }
    });
}
function filter_mySaga() {
    return filter_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)([
                        "ROUTE_LOADED",
                        filter/* FILTER_CHANGE_ACTION */.$H,
                        filter/* COMPARE_PROPERTY */.gd
                    ], handleFilterActions)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var sagas_filter = (filter_mySaga);

;// CONCATENATED MODULE: ./src/areas/category/sagas/search.js
function sagas_search_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sagas_search_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sagas_search_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sagas_search_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sagas_search_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sagas_search_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var search_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


var getInputValues = function(state) {
    return {
        inputValue: state.areas.category.search.inputValue,
        lastInputValue: state.areas.category.search.lastInputValue
    };
};
var search_getFilter = function(state) {
    return state.areas.category.filter;
};
function filterValues(values, loweredInput) {
    var newValues = [];
    values.forEach(function(val) {
        var filteredChildren = val.children ? filterValues(val.children, loweredInput) : null;
        if (val.name.toLowerCase().indexOf(loweredInput) >= 0) {
            newValues.push(sagas_search_objectSpread({}, val));
        } else if (filteredChildren && filteredChildren.length > 0) {
            newValues.push(sagas_search_objectSpreadProps(sagas_search_objectSpread({}, val), {
                children: filteredChildren
            }));
        }
    });
    return newValues;
}
function includeFilter(filter, loweredInput, values, filteredValues) {
    var visible = false;
    if (filter.type && filter.type.indexOf("list") >= 0 && values[filter.id] && values[filter.id].values) {
        filteredValues[filter.id] = {}; // eslint-disable-line no-param-reassign
        var newValues = filterValues(values[filter.id].values, loweredInput);
        if (newValues.length > 0) {
            visible = newValues.length > 0 || visible;
            filteredValues[filter.id].values = newValues; // eslint-disable-line no-param-reassign
        } else {
            filteredValues[filter.id] = sagas_search_objectSpread({}, values[filter.id]); // eslint-disable-line no-param-reassign
        }
    } else {
        filteredValues[filter.id] = sagas_search_objectSpread({}, values[filter.id]); // eslint-disable-line no-param-reassign
    }
    if (filter.name.toLowerCase().indexOf(loweredInput) >= 0 || filter.unit && filter.unit.toLowerCase().indexOf(loweredInput) >= 0) {
        visible = true;
    }
    var filteredChildren = null;
    if (filter.children) {
        filteredChildren = filter.children.map(function(child) {
            return includeFilter(child, loweredInput, values, filteredValues);
        }).filter(function(x) {
            return x;
        });
        visible = filteredChildren.length > 0 || visible;
    }
    return visible ? sagas_search_objectSpreadProps(sagas_search_objectSpread({}, filter), {
        children: filteredChildren
    }) : null;
}
function filterSection(section, loweredInput, values, filteredValues) {
    var filteredChildren = section.children.map(function(filter) {
        return includeFilter(filter, loweredInput, values, filteredValues);
    }).filter(function(x) {
        return x;
    });
    // If we only have a hit on the section name, we display the
    // whole section but with the expansion intact.
    if (filteredChildren.length === 0 && section.name.toLowerCase().indexOf(loweredInput) >= 0) {
        return sagas_search_objectSpread({}, section);
    }
    return filteredChildren.length > 0 ? sagas_search_objectSpreadProps(sagas_search_objectSpread({}, section), {
        children: filteredChildren
    }) : null;
}
function handleSearchActions(action) {
    var _, ref, inputValue, lastInputValue, inputFilter, loweredInput, values, core, definition, filteredValues, filteredCore, filteredSections;
    return search_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _ = action.type;
                switch(_){
                    case filter/* FILTER_RECEIVE */.vN:
                        return [
                            3,
                            1
                        ];
                    case filter/* PROPERTY_SEARCH_ACTION */.Q:
                        return [
                            3,
                            1
                        ];
                }
                return [
                    3,
                    8
                ];
            case 1:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(getInputValues)
                ];
            case 2:
                ref = _state.sent(), inputValue = ref.inputValue, lastInputValue = ref.lastInputValue;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(search_getFilter)
                ];
            case 3:
                inputFilter = _state.sent();
                if (!(inputValue.length < 2)) return [
                    3,
                    6
                ];
                if (!(action.type === filter/* FILTER_RECEIVE */.vN || lastInputValue.length > 1)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* propertySearchComplete */.hN)(inputFilter.core, inputFilter.definition, inputFilter.values))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                return [
                    2
                ];
            case 6:
                loweredInput = inputValue.toLowerCase();
                values = inputFilter.values, core = inputFilter.core, definition = inputFilter.definition;
                filteredValues = {};
                filteredCore = core.map(function(filter) {
                    return includeFilter(filter, loweredInput, values, filteredValues);
                }).filter(function(x) {
                    return x;
                });
                filteredSections = definition.map(function(section) {
                    return filterSection(section, loweredInput, values, filteredValues);
                }).filter(function(x) {
                    return x;
                });
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* propertySearchComplete */.hN)(filteredCore, filteredSections, filteredValues))
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 8:
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function search_mySaga() {
    return search_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)([
                        filter/* PROPERTY_SEARCH_ACTION */.Q,
                        filter/* FILTER_RECEIVE */.vN
                    ], handleSearchActions)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ var sagas_search = (search_mySaga);

;// CONCATENATED MODULE: ./src/sagas.ts













// FIXME: These sagas need the ROUTE_LOADED event to work correctly.
// Since this event is sometimes dispatched any lazily loaded code,
// they need to be here.


/* harmony default export */ var src_sagas = ([
    sagas,
    feedback_sagas,
    create_alert,
    remove_alert,
    remove_list_item,
    order_lists,
    remove_list,
    add_list_item,
    edit_list,
    reviews_sagas,
    sagas_filter,
    sagas_search,
    my_products,
    settings_sagas/* default */.Z,
    shop_preference
]);

// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/client/store.js
function store_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function store_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return store_arrayLikeToArray(arr);
}
function store_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function store_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function store_toConsumableArray(arr) {
    return store_arrayWithoutHoles(arr) || store_iterableToArray(arr) || store_unsupportedIterableToArray(arr) || store_nonIterableSpread();
}
function store_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return store_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return store_arrayLikeToArray(o, minLen);
}





var sagaMiddleware = (0,redux_saga_core_npm_proxy_esm/* default */.ZP)();
var middleware = [
    sagaMiddleware,
    data_layer/* default */.Z
];
if (false) { var createLogger; }
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux.compose;
var store_initialState = window.INITIAL_STATE;
var store = (0,redux.createStore)(src_reducers, store_initialState, composeEnhancers(redux.applyMiddleware.apply(void 0, store_toConsumableArray(middleware))));
window.registerSaga = function(saga) {
    sagaMiddleware.run(saga);
};
src_sagas.forEach(sagaMiddleware.run);
/* harmony default export */ var client_store = (store);


/***/ }),

/***/ 94141:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VA": () => (/* reexport */ styled_theme),
  "ry": () => (/* reexport */ animation_utils_namespaceObject),
  "sF": () => (/* reexport */ animations),
  "D2": () => (/* reexport */ variables/* brandColors */.D2),
  "AV": () => (/* reexport */ variables/* breakpoints */.AV),
  "TV": () => (/* reexport */ browser_support),
  "$n": () => (/* reexport */ color_utils),
  "O9": () => (/* reexport */ variables/* colors */.O9),
  "bK": () => (/* reexport */ variables/* layout */.bK),
  "BC": () => (/* reexport */ variables/* media */.BC),
  "ZT": () => (/* binding */ noop),
  "A": () => (/* reexport */ variables/* pixelCalc */.A),
  "m4": () => (/* reexport */ variables/* ratingStarColors */.m4),
  "vR": () => (/* reexport */ variables/* remCalc */.vR),
  "au": () => (/* reexport */ styled_utils_namespaceObject)
});

// UNUSED EXPORTS: campaignColors, darkTheme, defaultTheme

// NAMESPACE OBJECT: ./src/components/base/src/animation-utils.js
var animation_utils_namespaceObject = {};
__webpack_require__.r(animation_utils_namespaceObject);
__webpack_require__.d(animation_utils_namespaceObject, {
  "easing": () => (easing),
  "tween": () => (tween)
});

// NAMESPACE OBJECT: ./src/components/base/src/styled-utils.ts
var styled_utils_namespaceObject = {};
__webpack_require__.r(styled_utils_namespaceObject);
__webpack_require__.d(styled_utils_namespaceObject, {
  "overlay": () => (overlay)
});

// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(76323);
// EXTERNAL MODULE: ./src/components/base/src/color-utils.ts
var color_utils = __webpack_require__(33747);
;// CONCATENATED MODULE: ./src/components/base/src/animation-utils.js
var easing = {
    easeOut: function(progress) {
        return progress * (2 - progress);
    }
};
/**
 * Creates a tween animation that interpolates a value from a starting point
 * to an ending point over a given duration, using an easing function.
 *
 * @param {Object} [options={}] - Configuration options for the tween.
 * @param {number} [options.from=0] - The starting value of the tween.
 * @param {number} [options.to=1] - The ending value of the tween.
 * @param {number} [options.duration=200] - Duration of the tween in milliseconds.
 * @param {(t: number) => number} [options.easingFunction=easing.easeOut] - Easing function that maps a normalized time (0–1) to an eased progress value.
 * @param {(value: number) => void} [options.onUpdate] - Callback invoked on each animation frame with the current interpolated value.
 * @param {() => void} [options.onComplete] - Callback invoked once the tween has finished.
 *
 * @returns {void} This function does not return a value.
 */ function tween() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _from = ref.from, from = _from === void 0 ? 0 : _from, _to = ref.to, to = _to === void 0 ? 1 : _to, _duration = ref.duration, duration = _duration === void 0 ? 200 : _duration, _easingFunction = ref.easingFunction, easingFunction = _easingFunction === void 0 ? easing.easeOut : _easingFunction, onUpdate = ref.onUpdate, onComplete = ref.onComplete;
    var startTime = performance.now();
    var animate = function(time) {
        var progress = duration === 0 ? 1 : Math.min(Math.max(0, (time - startTime) / duration), 1);
        var value = from + (to - from) * easingFunction(progress);
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(value);
        if (progress < 1) {
            requestAnimationFrame(animate);
        } else {
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
        }
    };
    requestAnimationFrame(animate);
}

// EXTERNAL MODULE: ./src/components/base/src/animations/index.ts + 1 modules
var animations = __webpack_require__(90063);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/components/base/src/styled-utils.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  content: '';\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * An overlay helper that can be included within a pseudo-element like ::before or ::after, in
 * order to cover the whole area of the nearest positioning context with the specified color.
 *
 * Can be used instead of a background-color in order to avoid white boxes around e.g. product
 * images, which generally have a white background.
 */ var overlay = function(color) {
    return (0,styled_components_browser_esm.css)(_templateObject(), color || (0,color_utils.setRgbaAlpha)(light_theme_colors.base800, 0.04));
};

;// CONCATENATED MODULE: ./src/components/base/src/browser-support.js
var checks = {};
// Check if browser supports passive option for addEventListener
// See: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var passiveEventListener = function() {
    if (Object.keys(checks).includes("passiveEventListener")) {
        return checks.passiveEventListener;
    }
    try {
        var options = {
            // eslint-disable-next-line getter-return
            get passive () {
                checks.passiveEventListener = true;
            }
        };
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (err) {
        checks.passiveEventListener = false;
    }
    return checks.passiveEventListener;
};
/* harmony default export */ var browser_support = ({
    passiveEventListener: passiveEventListener
});

;// CONCATENATED MODULE: ./src/components/base/styles/themes/default.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var theme = {
    colors: _objectSpread({}, light_theme_colors),
    bg: {
        primary: light_theme_colors.base0,
        secondary: light_theme_colors.base100,
        tertiary: light_theme_colors.base200,
        quaternary: "#F0F2F3",
        overlay: (0,color_utils.setRgbaAlpha)(light_theme_colors.base700, "0.2"),
        productCompare: light_theme_colors.yellove500,
        productCompareLight: (0,color_utils.setRgbaAlpha)(light_theme_colors.yellove500, "0.05")
    },
    header: {
        bg: light_theme_colors.maybeBlue500,
        fg: light_theme_colors.base100
    },
    footer: {
        bg: {
            primary: light_theme_colors.base100,
            secondary: light_theme_colors.base100
        },
        fg: {
            primary: light_theme_colors.base600
        }
    },
    lines: {
        primary: light_theme_colors.base200,
        secondary: light_theme_colors.base300,
        tertiary: light_theme_colors.base500,
        quaternary: light_theme_colors.base700,
        highlight: light_theme_colors.maybeBlue700,
        groupHeader: light_theme_colors.yellove500
    },
    text: {
        primary: light_theme_colors.base800,
        secondary: light_theme_colors.base600,
        tertiary: light_theme_colors.base500,
        quaternary: light_theme_colors.base400,
        linkExternal: light_theme_colors.maybeBlue700,
        linkExternalHover: light_theme_colors.maybeBlue500,
        linkInternal: light_theme_colors.base700,
        linkInternalHover: light_theme_colors.base700,
        callToAction: light_theme_colors.maybeBlue700,
        callToActionHover: light_theme_colors.maybeBlue500,
        negative: light_theme_colors.negative700,
        positive: light_theme_colors.positive500
    },
    icons: {
        primary: light_theme_colors.base600,
        secondary: light_theme_colors.base500,
        tertiary: light_theme_colors.base400,
        quaternary: light_theme_colors.base300,
        light: light_theme_colors.base500,
        callToAction: light_theme_colors.maybeBlue700,
        callToActionHover: light_theme_colors.maybeBlue500,
        positive: light_theme_colors.positive500,
        negative: light_theme_colors.negative700
    },
    buttons: {
        primary: {
            bg: light_theme_colors.maybeBlue700,
            bgActive: light_theme_colors.maybeBlue100,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        secondary: {
            bg: light_theme_colors.base500,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        tertiary: {
            bg: light_theme_colors.base200,
            text: light_theme_colors.base700,
            textHover: light_theme_colors.base700
        },
        quarternary: {
            bg: light_theme_colors.base700,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        positive: {
            bg: light_theme_colors.positive700,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        negative: {
            bg: light_theme_colors.negative700,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        link: {
            bg: "transparent",
            text: light_theme_colors.maybeBlue700,
            textHover: light_theme_colors.maybeBlue500
        },
        disabled: {
            bg: light_theme_colors.base500,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        category: {
            bg: light_theme_colors.base0,
            bgActive: (0,color_utils.setRgbaAlpha)(light_theme_colors.maybeBlue700, "0.08"),
            text: light_theme_colors.base700,
            textHover: light_theme_colors.maybeBlue700
        },
        panning: {
            bg: "rgba(0, 0, 0, 0.6)",
            bgHover: "rgba(0, 0, 0, 0.4)",
            text: light_theme_colors.base0
        }
    },
    pill: {
        primary: {
            bg: light_theme_colors.maybeBlue700,
            text: light_theme_colors.base0
        },
        inverted: {
            bg: light_theme_colors.base0,
            text: light_theme_colors.base700
        }
    },
    inputs: {
        primary: {
            bg: light_theme_colors.base0,
            border: light_theme_colors.base500,
            borderFocus: light_theme_colors.maybeBlue700
        },
        secondary: {
            bg: light_theme_colors.base100,
            border: light_theme_colors.base100,
            borderFocus: light_theme_colors.maybeBlue700
        }
    },
    dropdowns: {
        primary: {
            bg: light_theme_colors.base0,
            hoverBackground: (0,color_utils.setRgbaAlpha)(light_theme_colors.maybeBlue700, "0.2"),
            borderRadius: "5px",
            borderColor: {
                active: light_theme_colors.base700,
                inactive: light_theme_colors.base700
            }
        },
        secondary: {
            bg: light_theme_colors.base0,
            hoverBackground: (0,color_utils.setRgbaAlpha)(light_theme_colors.maybeBlue700, "0.2"),
            borderRadius: 0,
            borderColor: {
                active: light_theme_colors.base200,
                inactive: "transparent"
            }
        }
    },
    placeholders: {
        bg: light_theme_colors.base100,
        fg: light_theme_colors.base300
    },
    actionBar: {
        bg: light_theme_colors.base700,
        fg: light_theme_colors.base0,
        boxShadow: "0 -2px 10px 0 rgba(0, 0, 0, 0.2)"
    },
    ratings: {
        positive: {
            bg: light_theme_colors.positive300,
            fg: light_theme_colors.positive700
        },
        neutral: {
            bg: light_theme_colors.notice300,
            fg: light_theme_colors.yellove900
        },
        negative: {
            bg: light_theme_colors.negative300,
            fg: light_theme_colors.negative700
        },
        disabled: {
            bg: light_theme_colors.base200,
            fg: light_theme_colors.base500
        }
    },
    notifications: {
        info: {
            bg: (0,color_utils.setRgbaAlpha)(light_theme_colors.maybeBlue700, "0.04"),
            fg: light_theme_colors.maybeBlue700
        },
        issue: {
            bg: (0,color_utils.setRgbaAlpha)(light_theme_colors.negative300, "0.2"),
            fg: (0,color_utils.setRgbaAlpha)(light_theme_colors.negative700, "0.7")
        },
        neutral: {
            bg: light_theme_colors.base100,
            fg: light_theme_colors.base600
        }
    },
    promos: {
        bg: light_theme_colors.maybeBlue100,
        fg: light_theme_colors.base600
    }
};
/* harmony default export */ var themes_default = (theme);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/dark-theme-colors.js
var dark_theme_colors = __webpack_require__(30294);
;// CONCATENATED MODULE: ./src/components/base/styles/themes/dark.ts
function dark_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dark_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dark_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var darkTheme = {
    colors: dark_objectSpread({}, dark_theme_colors),
    bg: {
        primary: "#404040",
        secondary: dark_theme_colors.base600,
        tertiary: dark_theme_colors.base600,
        quaternary: (0,color_utils.setRgbaAlpha)(dark_theme_colors.base800, "0.06"),
        overlay: "#000",
        productCompare: dark_theme_colors.yellove500,
        productCompareLight: (0,color_utils.setRgbaAlpha)(dark_theme_colors.yellove500, "0.05")
    },
    header: {
        bg: dark_theme_colors.maybeBlue500,
        fg: dark_theme_colors.base100
    },
    footer: {
        bg: {
            primary: dark_theme_colors.base100,
            secondary: dark_theme_colors.base100
        },
        fg: {
            primary: dark_theme_colors.base600
        }
    },
    text: {
        primary: "white",
        secondary: "#eee",
        tertiary: "#bbb",
        quaternary: "#aaa",
        linkExternal: dark_theme_colors.maybeBlue700,
        linkExternalHover: dark_theme_colors.maybeBlue500,
        linkInternal: dark_theme_colors.base0,
        linkInternalHover: dark_theme_colors.base0,
        callToAction: dark_theme_colors.maybeBlue700,
        callToActionHover: dark_theme_colors.maybeBlue500,
        negative: dark_theme_colors.negative700,
        positive: dark_theme_colors.positive500
    },
    icons: {
        primary: dark_theme_colors.base600,
        secondary: dark_theme_colors.base500,
        tertiary: dark_theme_colors.base400,
        quaternary: dark_theme_colors.base300,
        light: dark_theme_colors.base500,
        callToAction: dark_theme_colors.maybeBlue700,
        callToActionHover: dark_theme_colors.maybeBlue500,
        positive: dark_theme_colors.positive300,
        negative: dark_theme_colors.negative700
    },
    lines: {
        primary: "#303030",
        secondary: "#202020",
        tertiary: "#101010",
        quaternary: "#000",
        highlight: dark_theme_colors.maybeBlue700,
        groupHeader: dark_theme_colors.yellove500
    },
    buttons: {
        primary: {
            bg: dark_theme_colors.maybeBlue700,
            bgActive: dark_theme_colors.maybeBlue100,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        secondary: {
            bg: dark_theme_colors.base500,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        tertiary: {
            bg: dark_theme_colors.base600,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        quarternary: {
            bg: dark_theme_colors.base700,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        positive: {
            bg: dark_theme_colors.positive700,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        negative: {
            bg: dark_theme_colors.negative700,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        link: {
            bg: "transparent",
            text: dark_theme_colors.maybeBlue700,
            textHover: dark_theme_colors.maybeBlue500
        },
        disabled: {
            bg: dark_theme_colors.base500,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        category: {
            bg: "#404040",
            bgActive: dark_theme_colors.base600,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base100
        },
        panning: {
            bg: "rgba(0, 0, 0, 0.6)",
            bgHover: "rgba(0, 0, 0, 0.4)",
            text: dark_theme_colors.base0
        }
    },
    pill: {
        primary: {
            bg: dark_theme_colors.maybeBlue700,
            text: dark_theme_colors.base0
        },
        inverted: {
            bg: dark_theme_colors.base0,
            text: dark_theme_colors.base700
        }
    },
    inputs: {
        primary: {
            bg: dark_theme_colors.base0,
            border: dark_theme_colors.base500,
            borderFocus: dark_theme_colors.maybeBlue700
        },
        secondary: {
            bg: dark_theme_colors.base100,
            border: dark_theme_colors.base100,
            borderFocus: dark_theme_colors.maybeBlue700
        }
    },
    dropdowns: {
        primary: {
            bg: dark_theme_colors.base0,
            hoverBackground: (0,color_utils.setRgbaAlpha)(dark_theme_colors.maybeBlue700, "0.2"),
            borderRadius: "5px",
            borderColor: {
                active: dark_theme_colors.base700,
                inactive: dark_theme_colors.base700
            }
        },
        secondary: {
            bg: dark_theme_colors.base0,
            hoverBackground: (0,color_utils.setRgbaAlpha)(dark_theme_colors.maybeBlue700, "0.2"),
            borderRadius: 0,
            borderColor: {
                active: dark_theme_colors.base200,
                inactive: "transparent"
            }
        }
    },
    placeholders: {
        bg: dark_theme_colors.base100,
        fg: dark_theme_colors.base300
    },
    actionBar: {
        bg: dark_theme_colors.base700,
        fg: dark_theme_colors.base0,
        boxShadow: "0 -2px 10px 0 rgba(0, 0, 0, 0.2)"
    },
    ratings: {
        positive: {
            bg: dark_theme_colors.positive300,
            fg: dark_theme_colors.positive700
        },
        neutral: {
            bg: dark_theme_colors.notice300,
            fg: dark_theme_colors.yellove900
        },
        negative: {
            bg: dark_theme_colors.negative300,
            fg: dark_theme_colors.negative700
        },
        disabled: {
            bg: dark_theme_colors.base200,
            fg: dark_theme_colors.base500
        }
    },
    notifications: {
        info: {
            bg: (0,color_utils.setRgbaAlpha)(dark_theme_colors.maybeBlue700, "0.04"),
            fg: dark_theme_colors.maybeBlue700
        },
        issue: {
            bg: (0,color_utils.setRgbaAlpha)(dark_theme_colors.negative300, "0.2"),
            fg: (0,color_utils.setRgbaAlpha)(dark_theme_colors.negative700, "0.7")
        },
        neutral: {
            bg: dark_theme_colors.base100,
            fg: dark_theme_colors.base600
        }
    },
    promos: {
        bg: dark_theme_colors.maybeBlue100,
        fg: dark_theme_colors.base600
    }
};
/* harmony default export */ var dark = ((/* unused pure expression or super */ null && (darkTheme)));

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/base/styles/styled-theme.tsx
function styled_theme_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function styled_theme_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            styled_theme_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var StyledTheme = function(param) {
    var children = param.children, _layout = param.layout, layout = _layout === void 0 ? "default" : _layout;
    var theme = react.useMemo(function() {
        return _objectSpreadProps(styled_theme_objectSpread({}, themes_default), {
            layout: layout
        });
    }, [
        layout
    ]);
    return /*#__PURE__*/ react.createElement(styled_components_browser_esm.ThemeProvider, {
        theme: theme
    }, children);
};
/* harmony default export */ var styled_theme = (StyledTheme);

;// CONCATENATED MODULE: ./src/components/base/index.js









var noop = function() {};



/***/ }),

/***/ 91135:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3616);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24828);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57735);





var InfoPageLink = function(param) {
    var id = param.id, children = param.children, pages = param.nodes, className = param.className, url = param.url;
    var page = pages.find(function(p) {
        return p.id === id;
    });
    var pathName = url || (page === null || page === void 0 ? void 0 : page.pathName);
    if (!pathName) {
        return null;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
        className: className,
        to: pathName,
        onClick: function() {
            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.ABOUT_REVIEWS */ .U.ABOUT_REVIEWS,
                nextPage: pathName
            });
        }
    }, children);
};
var number = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number), node = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node), arrayOf = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf), shape = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape), string = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string);
InfoPageLink.propTypes = {
    id: number,
    children: node,
    nodes: arrayOf(shape({
        id: number.isRequired,
        pathName: string.isRequired
    })),
    className: string,
    url: string
};
InfoPageLink.defaultProps = {
    children: undefined,
    id: null,
    nodes: [],
    className: undefined,
    url: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(function(state) {
    return state.globals.infoPages;
})(InfoPageLink));


/***/ }),

/***/ 60428:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ login_promo)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/hooks/use-account.ts + 1 modules
var use_account = __webpack_require__(53082);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(94320);
// EXTERNAL MODULE: ./src/components/modal/actions.ts
var actions = __webpack_require__(43758);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(6213);
;// CONCATENATED MODULE: ./src/components/modal/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  margin: 10px 0 20px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  vertical-align: middle;\n  margin-right: 0.5em;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  margin-bottom: 5px;\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var FeatureList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "FeatureList",
    componentId: "sc-0-0"
})(_templateObject());
var FeatureListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "FeatureListItem",
    componentId: "sc-0-1"
})(_templateObject1());
var FeatureListCheckIcon = (0,styled_components_browser_esm["default"])(check_filled.IconCheckFilled).attrs({
    color: "positive500"
}).withConfig({
    displayName: "FeatureListCheckIcon",
    componentId: "sc-0-2"
})(_templateObject2());
var StyledPrimaryButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "StyledPrimaryButton",
    componentId: "sc-0-3"
})(_templateObject3());
var StyledTextButton = (0,styled_components_browser_esm["default"])(variants.TextButton).withConfig({
    displayName: "StyledTextButton",
    componentId: "sc-0-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/components/modal/login-promo.js










var LoginPromoModal = function(param) {
    var hideModalAction = param.hideModalAction, onRequestClose = param.onRequestClose, id = param.id, isOpen = param.isOpen;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var login = (0,use_account/* useAccount */.m)().login;
    var loginOnClick = function(e) {
        e.preventDefault();
        (0,data_layer/* pushEvent */.A)("login", {
            loggedIn: true
        });
        login();
    };
    return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        id: id,
        isOpen: isOpen,
        onRequestClose: onRequestClose || hideModalAction,
        width: 400
    }, /*#__PURE__*/ react.createElement("h3", null, t("account", "sign-in-promo.modal-title")), /*#__PURE__*/ react.createElement(FeatureList, null, /*#__PURE__*/ react.createElement(FeatureListItem, null, /*#__PURE__*/ react.createElement(FeatureListCheckIcon, null), t("account", "sign-in-promo.list-item-sync-your-info")), /*#__PURE__*/ react.createElement(FeatureListItem, null, /*#__PURE__*/ react.createElement(FeatureListCheckIcon, null), t("account", "sign-in-promo.list-item-optimise-alerts")), /*#__PURE__*/ react.createElement(FeatureListItem, null, /*#__PURE__*/ react.createElement(FeatureListCheckIcon, null), t("account", "sign-in-promo.list-item-organise-lists"))), /*#__PURE__*/ react.createElement(StyledPrimaryButton, {
        container: react_router_dom/* Link */.rU,
        onClick: loginOnClick,
        containerProps: {
            "data-test": "SignInButton",
            to: "/login"
        }
    }, t("account", "sign-in-promo.sign-in-button")), /*#__PURE__*/ react.createElement(StyledTextButton, {
        container: react_router_dom/* Link */.rU,
        onClick: loginOnClick,
        containerProps: {
            "data-test": "CreateAccountButton",
            to: "/signup"
        }
    }, t("account", "sign-in-promo.create-account-button")));
};
var func = (prop_types_default()).func, string = (prop_types_default()).string, bool = (prop_types_default()).bool;
LoginPromoModal.propTypes = {
    hideModalAction: func,
    onRequestClose: func,
    id: string,
    isOpen: bool
};
LoginPromoModal.defaultProps = {
    hideModalAction: undefined,
    onRequestClose: undefined,
    id: undefined,
    isOpen: false
};
/* harmony default export */ var login_promo = ((0,es/* connect */.$j)(null, {
    hideModalAction: actions/* default.hideModal */.ZP.hideModal
})(/*#__PURE__*/ (0,react.memo)(LoginPromoModal)));


/***/ }),

/***/ 69790:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ outside_click_tracker)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/outside-click-tracker/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  body {\n    /* For some reason iOS Safari requires a pointer cursor to trigger click events... */\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: default;\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var OutsideArea = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject());
var InsideArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InsideArea",
    componentId: "sc-0-0"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/components/outside-click-tracker/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var OutsideClickTracker = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(OutsideClickTracker, _PureComponent);
    var _super = _createSuper(OutsideClickTracker);
    function OutsideClickTracker(props) {
        _classCallCheck(this, OutsideClickTracker);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "listenerOptions", {
            capture: true
        });
        _defineProperty(_assertThisInitialized(_this), "mouseDownListener", function(e) {
            if (_this.props.active && _this.wrapperRef.current && !_this.wrapperRef.current.contains(e.target) && document.getElementById("root").contains(e.target)) {
                _this.props.onMouseDownOutside();
            }
        });
        _defineProperty(_assertThisInitialized(_this), "clickListener", function(e) {
            if (_this.props.active && _this.wrapperRef.current && !_this.wrapperRef.current.contains(e.target) && // We dont want to close things like the mobile sidebar when trying to close
            // a toast notification or when accepting cookies from the cookie banner
            document.getElementById("root").contains(e.target)) {
                e.stopPropagation();
                _this.props.onClickOutside();
            }
        });
        _defineProperty(_assertThisInitialized(_this), "keyUpListener", function(e) {
            if (_this.props.active && e.keyCode === 27) {
                _this.props.onEscapeKey();
            }
        });
        _this.wrapperRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    _createClass(OutsideClickTracker, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.active) {
                    this.addListeners();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeListeners();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.active && !prevProps.active) {
                    this.addListeners();
                }
                if (!this.props.active && prevProps.active) {
                    this.removeListeners();
                }
            }
        },
        {
            key: "addListeners",
            value: function addListeners() {
                window.addEventListener("mousedown", this.mouseDownListener, this.listenerOptions);
                window.addEventListener("click", this.clickListener, this.listenerOptions);
                window.addEventListener("keyup", this.keyUpListener, this.listenerOptions);
            }
        },
        {
            key: "removeListeners",
            value: function removeListeners() {
                window.removeEventListener("mousedown", this.clickListener, this.listenerOptions);
                window.removeEventListener("click", this.clickListener, this.listenerOptions);
                window.removeEventListener("keyup", this.keyUpListener, this.listenerOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(OutsideArea, null), /*#__PURE__*/ react.createElement(InsideArea, {
                    className: this.props.className,
                    ref: this.wrapperRef
                }, this.props.children));
            }
        }
    ]);
    return OutsideClickTracker;
}(react.PureComponent);
OutsideClickTracker.propTypes = {
    children: prop_types.node,
    className: prop_types.string,
    onMouseDownOutside: prop_types.func,
    onClickOutside: prop_types.func,
    onEscapeKey: prop_types.func,
    active: prop_types.bool
};
OutsideClickTracker.defaultProps = {
    children: undefined,
    className: undefined,
    onMouseDownOutside: base/* noop */.ZT,
    onClickOutside: base/* noop */.ZT,
    onEscapeKey: base/* noop */.ZT,
    active: true
};
/* harmony default export */ var outside_click_tracker = (OutsideClickTracker);


/***/ }),

/***/ 47910:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ sentiment_badge)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/like-filled/index.js
var like_filled = __webpack_require__(46304);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/sentiment-badge/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-right: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 5px;\n  line-height: 1.3em;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 10px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Badge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Badge",
    componentId: "sc-0-0"
})(_templateObject());
var Text = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(_templateObject1());
var RelatedReviews = styled_components_browser_esm["default"].span.withConfig({
    displayName: "RelatedReviews",
    componentId: "sc-0-2"
})(_templateObject2(), function(props) {
    return props.theme.text.secondary;
});

;// CONCATENATED MODULE: ./src/components/sentiment-badge/index.js





var SentimentBadge = function(param) {
    var badge = param.badge, minPositive = param.minPositive, showNrOfReviewsAs = param.showNrOfReviewsAs;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (badge.nrOfPositiveReviews < minPositive) {
        return null;
    }
    var renderNumberOfReviews = function() {
        return showNrOfReviewsAs === "text" ? t("product", "sentiment-badge.n-related-reviews", {
            n: badge.nrOfReviews
        }) : "(".concat(badge.nrOfReviews, ")");
    };
    var textElement = /*#__PURE__*/ react.createElement(Text, null, /*#__PURE__*/ react.createElement("span", null, t("product", "sentiment-badge.".concat(badge.name, "-").concat(badge.sentiment))), /*#__PURE__*/ react.createElement(RelatedReviews, null, showNrOfReviewsAs && renderNumberOfReviews()));
    return /*#__PURE__*/ react.createElement(Badge, null, /*#__PURE__*/ react.createElement(like_filled/* IconLikeFilled */.G, {
        size: 16,
        color: "positive500"
    }), textElement);
};
SentimentBadge.propTypes = {
    badge: prop_types_default().shape({
        name: (prop_types_default()).string,
        sentiment: prop_types_default().oneOf([
            "positive",
            "negative"
        ])
    }),
    minPositive: (prop_types_default()).number,
    showNrOfReviewsAs: prop_types_default().oneOf([
        "number",
        "text"
    ])
};
SentimentBadge.defaultProps = {
    badge: null,
    minPositive: 2,
    showNrOfReviewsAs: undefined
};
/* harmony default export */ var sentiment_badge = (/*#__PURE__*/(0,react.memo)(SentimentBadge));


/***/ }),

/***/ 84413:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var ShutdownMessageModal = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 61045));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(61045);
        }
        return eval("require.resolve")("./modal");
    }
});
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ShutdownMessageModal, _extends({}, props));
};


/***/ }),

/***/ 15287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$g": () => (/* binding */ initialMeQuery),
/* harmony export */   "BX": () => (/* binding */ graphql),
/* harmony export */   "E8": () => (/* binding */ getPjAccountUserInfo),
/* harmony export */   "Gg": () => (/* binding */ getSession),
/* harmony export */   "Lv": () => (/* binding */ postPJAccountLogoutAll),
/* harmony export */   "hO": () => (/* binding */ putSession),
/* harmony export */   "l5": () => (/* binding */ destroyPjAccountSession),
/* harmony export */   "qr": () => (/* binding */ postFeedback),
/* harmony export */   "xM": () => (/* binding */ postPJAccountUserInfoAcceptPolicy),
/* harmony export */   "xf": () => (/* binding */ getPjAccountAuthState)
/* harmony export */ });
/* harmony import */ var _server_queries_me_query_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58781);
/* harmony import */ var _server_queries_me_query_graphql__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_server_queries_me_query_graphql__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_client_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(492);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


var getSession = function() {
    return fetch("/_internal/session", {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            "X-Set-Viewed-Experiments": "1"
        }
    }).then(function(res) {
        return res.json();
    });
};
var putSession = function(key, value) {
    return fetch("/_internal/session", {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            "X-Set-Viewed-Experiments": "1"
        },
        body: JSON.stringify(_defineProperty({}, key, value))
    });
};
var getPjAccountAuthState = function() {
    return fetch("".concat(window.CLIENT_MARKET.bff.publicBaseUrl, "/auth/pj/state?location=").concat(encodeURIComponent(window.location.href)), {
        method: "GET",
        credentials: "include"
    }).then(function(res) {
        if (!res.ok) {
            throw new Error("Unable to generate OAuth state, ".concat(res.status, " ").concat(res.statusText));
        }
        return res;
    }).then(function(res) {
        return res.text();
    });
};
var getPjAccountUserInfo = function() {
    return fetch("".concat(window.CLIENT_MARKET.bff.publicBaseUrl, "/auth/pj/userinfo"), {
        method: "GET",
        credentials: "include"
    }).then(function(res) {
        if (!res.ok && res.status === 401) {
            return Promise.resolve(undefined);
        }
        if (!res.ok) {
            throw new Error("Querying userinfo failed unexpectedly, ".concat(res.status, " ").concat(res.statusText));
        }
        return res.json();
    });
};
var postPJAccountUserInfoAcceptPolicy = function() {
    return fetch("".concat(window.CLIENT_MARKET.bff.publicBaseUrl, "/auth/pj/userinfo/accept-policy"), {
        method: "POST",
        credentials: "include"
    });
};
var destroyPjAccountSession = function() {
    return fetch("".concat(window.CLIENT_MARKET.bff.publicBaseUrl, "/auth/pj/destroy"), {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        }
    }).then(function(res) {
        return res.json();
    });
};
var postPJAccountLogoutAll = function() {
    return fetch("".concat(window.CLIENT_MARKET.bff.publicBaseUrl, "/auth/pj/logout-all"), {
        method: "POST",
        credentials: "include"
    });
};
var graphql = function(query, variables) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0,src_client_query__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(query, variables, undefined, undefined, options);
};
var postFeedback = function(message) {
    return graphql("\n      mutation ($data: FeedbackInputType!) {\n        feedback(data: $data) {\n          success\n        }\n      }\n    ", {
        data: message
    });
};
var initialMeQuery = function() {
    var _ref = _asyncToGenerator(function() {
        var ref, fetchResult, result;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(window.CLIENT_MARKET.bff.publicBaseUrl, {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                query: (_server_queries_me_query_graphql__WEBPACK_IMPORTED_MODULE_0___default())
                            })
                        })
                    ];
                case 1:
                    fetchResult = _state.sent();
                    return [
                        4,
                        fetchResult.json()
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        (ref = result.data) === null || ref === void 0 ? void 0 : ref.me
                    ];
            }
        });
    });
    return function initialMeQuery() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 53541:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isNumeric)
/* harmony export */ });
function isNumeric(n) {
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(parseFloat(n)) && isFinite(n);
}


/***/ }),

/***/ 83104:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DE": () => (/* binding */ NEW_PRODUCT_CLICK),
/* harmony export */   "IT": () => (/* binding */ OTHER_POPULAR_PRODUCT_CLICK),
/* harmony export */   "LT": () => (/* binding */ POPULAR_CLICK),
/* harmony export */   "dL": () => (/* binding */ OTHERS_ALSO_VISITED_PRODUCT_CLICK),
/* harmony export */   "fT": () => (/* binding */ TRENDING_PRODUCT_CLICK),
/* harmony export */   "gv": () => (/* binding */ SEGMENT_PRODUCT_CLICK),
/* harmony export */   "qq": () => (/* binding */ RECENTLY_VISITED_CLICK)
/* harmony export */ });
/* unused harmony exports RECOMMENDED_CLICK, COMING_SOON_CLICK, PRISMIC_PRODUCT_LIST_CLICK */
var RECOMMENDED_CLICK = "Recommended click";
var POPULAR_CLICK = "Popular click";
var RECENTLY_VISITED_CLICK = "Recently visited click";
var NEW_PRODUCT_CLICK = "New product click";
var COMING_SOON_CLICK = "Coming soon click";
var PRISMIC_PRODUCT_LIST_CLICK = "Article product list click";
var TRENDING_PRODUCT_CLICK = "Trending product click";
var SEGMENT_PRODUCT_CLICK = "Segment / navigation category product click";
var OTHER_POPULAR_PRODUCT_CLICK = "Popular product click";
var OTHERS_ALSO_VISITED_PRODUCT_CLICK = "Other visited product click";


/***/ }),

/***/ 48283:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ useMetaTags)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);
/* harmony import */ var src_components_location_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42028);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var makeTag = function(tagName) {
    var attributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, properties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var element = document.createElement(tagName);
    Object.keys(attributes).forEach(function(attrName) {
        element.setAttribute(attrName, attributes[attrName]);
    });
    Object.keys(properties).forEach(function(propName) {
        element[propName] = properties[propName];
    });
    return element;
};
var makeOpenGraphTags = function() {
    var openGraphEntries = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return openGraphEntries.filter(Boolean).map(function(openGraphEntry) {
        return makeTag("meta", {
            property: "og:".concat(openGraphEntry.key),
            content: openGraphEntry.content
        });
    });
};
var makeLinkedDataTag = function(content) {
    return content && makeTag("script", {
        type: "application/ld+json"
    }, {
        innerHTML: JSON.stringify(content)
    });
};
var makeBreadcrumbDataTags = function(market, breadcrumb) {
    return makeLinkedDataTag({
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumb.map(function(item, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                item: {
                    "@id": market.domain + item.pathName,
                    name: item.name
                }
            };
        })
    });
};
var makeStructuredDataTags = function(market, breadcrumb, structuredData) {
    var structuredDataArray;
    if (!structuredData) {
        structuredDataArray = [];
    } else {
        structuredDataArray = !Array.isArray(structuredData) ? [
            structuredData
        ] : structuredData;
    }
    return [
        breadcrumb && makeBreadcrumbDataTags(market, breadcrumb)
    ].concat(_toConsumableArray(structuredDataArray.map(makeLinkedDataTag))).filter(Boolean);
};
var makeAndroidTag = function(market, android) {
    return makeTag("link", {
        rel: "alternate",
        href: "android-app://".concat(market.android, "/https/").concat(market.host).concat(android)
    });
};
var makeIosTag = function(market, ios) {
    return makeTag("meta", {
        name: "apple-itunes-app",
        content: "app-id=".concat(market.ios, ", app-argument=https://").concat(market.host).concat(ios)
    });
};
function useMetaTags(props) {
    var routeId = props.routeId, locationKey = props.locationKey, metaTags = props.metaTags;
    var market = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).market;
    var previousLocation = (0,src_components_location_context__WEBPACK_IMPORTED_MODULE_2__/* .useLocationContext */ .F)().previousLocation;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ( false || routeId === "initial" && locationKey === undefined || !previousLocation) {
            // For initial request, do not mess with the meta tags sent from server
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = document.head.querySelectorAll("[data-route-id]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var metaTagElement = _step.value;
                metaTagElement.parentNode.removeChild(metaTagElement);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var title = metaTags.title, breadcrumb = metaTags.breadcrumb, description = metaTags.description, thumbnail = metaTags.thumbnail, canonical = metaTags.canonical, structuredData = metaTags.structuredData, _openGraph = metaTags.openGraph, openGraph = _openGraph === void 0 ? [] : _openGraph, android = metaTags.android, ios = metaTags.ios, prev = metaTags.prev, next = metaTags.next, noIndex = metaTags.noIndex, _botify = metaTags.botify, botify = _botify === void 0 ? {} : _botify, hasAdultContent = metaTags.hasAdultContent;
        var elements = [
            title && makeTag("title", {}, {
                innerText: title
            }),
            hasAdultContent && makeTag("rating", {
                content: "adult"
            })
        ].concat(_toConsumableArray(makeOpenGraphTags(openGraph)), [
            noIndex && makeTag("meta", {
                name: "robots",
                content: "noindex"
            }),
            description && makeTag("meta", {
                name: "description",
                content: description
            }),
            thumbnail && makeTag("meta", {
                name: "thumbnail",
                content: thumbnail
            }),
            canonical && makeTag("link", {
                rel: "canonical",
                href: canonical
            }),
            prev && makeTag("link", {
                rel: "prev",
                href: prev
            }),
            next && makeTag("link", {
                rel: "next",
                href: next
            })
        ], _toConsumableArray(makeStructuredDataTags(market, breadcrumb, structuredData)), [
            botify && makeTag("meta", _objectSpreadProps(_objectSpread({}, botify), {
                name: "botify"
            })),
            market.android && android && makeAndroidTag(market, android),
            market.ios && ios && makeIosTag(market, ios)
        ]).filter(Boolean);
        elements.forEach(function(element) {
            element.setAttribute("data-route-id", routeId !== null && routeId !== void 0 ? routeId : "1337");
            document.head.appendChild(element);
        });
    }, [
        routeId,
        locationKey,
        metaTags
    ]);
}


/***/ }),

/***/ 91097:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ match_route)
});

// UNUSED EXPORTS: generateKey

// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
;// CONCATENATED MODULE: ./src/routes/shared.ts
function getProductPageTabFromHash(hash) {
    var hashContent = hash && hash.substr(1);
    if (hashContent === "properties" || hashContent === "reviews" || hashContent === "statistics") {
        return hashContent;
    }
    return "main";
}

;// CONCATENATED MODULE: ./src/routes/match-classic-route.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var idFromQuery = function() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, identifiers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var id = identifiers.find(function(identifier) {
        return query[identifier];
    });
    return query[id];
};
// eslint-disable-next-line no-bitwise
var is32BitInt = function(x) {
    return (x | 0) === x;
};
var matchClassicRoute = function(data) {
    var pathname = data.pathname, _query = data.query, query = _query === void 0 ? {} : _query, _hash = data.hash, hash = _hash === void 0 ? "" : _hash, _routeConfig = data.routeConfig, routeConfig = _routeConfig === void 0 ? {} : _routeConfig;
    var name = "/".concat(pathname.split("/")[1]);
    switch(name){
        case routeConfig.product.path:
            {
                // The following pages don't exist anymore and should be permanently redirected
                if ([
                    "cc",
                    "em",
                    "g",
                    "map",
                    "pid",
                    "r",
                    "rec",
                    "rel",
                    "pu",
                    "o",
                    "e"
                ].some(function(key) {
                    return query[key] !== undefined;
                })) {
                    return false;
                }
                // Bastardised version of the price history URL, e.g. /product.php/statistics?p=1234
                // This should be redirected, so not matched here.
                if (/statistics$/.test(pathname)) {
                    return false;
                }
                var id = parseInt(idFromQuery(query, [
                    "p"
                ]), 10);
                if (!is32BitInt(id)) {
                    return undefined;
                }
                // Render 404 on missing id
                if (!id) {
                    return undefined;
                }
                return {
                    route: "product",
                    params: {
                        id: id,
                        section: getProductPageTabFromHash(hash)
                    }
                };
            }
        case routeConfig.category.path:
            {
                var id1 = idFromQuery(query, [
                    "k",
                    "c",
                    "l",
                    "m",
                    "b",
                    "lb"
                ]);
                var filterId;
                if (id1 === "all") {
                    return undefined;
                }
                if (/^s/.test(id1) && query.catId) {
                    filterId = id1;
                    id1 = query.catId;
                }
                // No category id exists and we don't have a category index page
                // Load 404 route instead
                if (!id1 && !filterId) {
                    return undefined;
                }
                // Make sure id is in correct format
                if (!/^(s|v)?\d+$/.test(id1)) {
                    return undefined;
                }
                return {
                    route: "category",
                    params: _objectSpread({
                        id: id1,
                        filterId: filterId
                    }, query.t && parseInt(query.t, 10) > 0 ? {
                        brand: query.t
                    } : {})
                };
            }
        case routeConfig.store.path:
            {
                var id2 = parseInt(idFromQuery(query, [
                    "f",
                    "ftgid"
                ]), 10);
                // Render 404 on missing id
                if (!id2) {
                    return undefined;
                }
                return {
                    route: "store",
                    params: {
                        id: id2
                    }
                };
            }
        case routeConfig.brand.path:
            {
                var id3 = parseInt(idFromQuery(query, [
                    "t"
                ]), 10);
                // Render 404 on missing id
                if (!id3) {
                    return undefined;
                }
                return {
                    route: "brand",
                    params: {
                        id: id3
                    }
                };
            }
        default:
            return undefined;
    }
};
/* harmony default export */ var match_classic_route = (matchClassicRoute);

;// CONCATENATED MODULE: ./src/routes/match-route.js
function match_route_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function match_route_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            match_route_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var isConflictingRoute = function(pathname) {
    switch(pathname.split("/")[1]){
        case "news":
        case "nyheter":
            {
                return true;
            }
        default:
            return false;
    }
};
var generateKey = function(name, variables) {
    var sortedVariables = Object.keys(variables).sort(function(a, b) {
        return a.localeCompare(b);
    }).reduce(function(all, key) {
        return all + key + JSON.stringify(variables[key]);
    }, "");
    return name + JSON.stringify(sortedVariables);
};
/* harmony default export */ function match_route(param) {
    var routeConfig = param.routeConfig, location = param.location, marketCode = param.marketCode, experiments = param.experiments;
    var query = querystring.decode(location.search.substr(1));
    var classicMatch = match_classic_route({
        pathname: location.pathname,
        query: query,
        hash: location.hash,
        routeConfig: routeConfig
    });
    // matchClassicRoute returns explicit false
    // when it is a redirect and we should skip
    // any further attempts at matching routes.
    if (classicMatch === false) {
        return undefined;
    }
    if (classicMatch) {
        var match = (0,react_router/* matchPath */.LX)(location.pathname, {
            path: "*",
            exact: false
        });
        match.params = classicMatch.params;
        var _route = routeConfig[classicMatch.route], component = _route.component, metaTags = _route.metaTags, cacheControl = _route.cacheControl, props = _route.props;
        var variables = component.variables ? component.variables(_objectSpreadProps(match_route_objectSpread({}, query, classicMatch.params), {
            marketCode: marketCode,
            experiments: experiments,
            /* The app feature level from .env config (APP_FEATURE_LEVEL). featureToggle is set
           * from "server/init.js". window.FEATURE_TOGGLE is set from "server/react/middelware/out.js".
           */ featureToggle: FEATURE_TOGGLE
        })) : {};
        return {
            name: classicMatch.route,
            component: component,
            variables: variables,
            metaTags: metaTags,
            cacheControl: cacheControl,
            key: generateKey(classicMatch.route, variables),
            match: match,
            ssr: component.ssr,
            props: props
        };
    }
    /**
   * Some classic routes are in conflict with our new routes.
   * Ex. "/news/whatever--something" will match the store route (--s:id).
   * Handle this special case here for now by simply bypassing the matchPath loop.
   */ if (isConflictingRoute(location.pathname)) {
        return undefined;
    }
    /**
      This is very similar to what react-router switch does,
      simply run matchPath (which is used internally in react router)
      and return first match. Runs as a for loop to avoid unnessary iterations
    * */ var routeKeys = Object.keys(routeConfig);
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < routeKeys.length; i++){
        var name = routeKeys[i];
        var _name = routeConfig[name], path = _name.path, _exact = _name.exact, exact = _exact === void 0 ? true : _exact;
        var match1 = (0,react_router/* matchPath */.LX)(location.pathname, {
            path: path,
            exact: exact
        });
        if (match1) {
            var _name1 = routeConfig[name], component1 = _name1.component, metaTags1 = _name1.metaTags, cacheControl1 = _name1.cacheControl, props1 = _name1.props;
            if (name === "product") {
                var section = getProductPageTabFromHash(location.hash);
                if (section !== "main") {
                    match1.params.section = section;
                }
            }
            var variables1 = component1.variables ? component1.variables(_objectSpreadProps(match_route_objectSpread({}, query, match1.params), {
                searchQuery: query,
                marketCode: marketCode,
                experiments: experiments,
                /* The app feature level from .env config (APP_FEATURE_LEVEL). featureToggle is set
             * from "server/init.js". window.FEATURE_TOGGLE is set from "server/react/middelware/out.js".
             */ featureToggle: FEATURE_TOGGLE
            })) : {};
            return {
                name: name,
                component: component1,
                variables: variables1,
                key: generateKey(name, variables1),
                metaTags: metaTags1,
                cacheControl: cacheControl1,
                match: match1,
                ssr: component1.ssr,
                props: props1
            };
        }
    }
    return undefined;
};


/***/ }),

/***/ 19590:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": () => (/* binding */ isValidEmail)
/* harmony export */ });
function isValidEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


/***/ }),

/***/ 5791:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ AccountLoginRedirect),
/* harmony export */   "g": () => (/* binding */ AccountLoginError)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);



var AccountLoginRedirect = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "user";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | user */ 378).then(__webpack_require__.bind(__webpack_require__, 13971));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(13971);
        }
        return eval("require.resolve")("./account-login-redirect");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
var AccountLoginError = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "user";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | user */ 378).then(__webpack_require__.bind(__webpack_require__, 46390));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(46390);
        }
        return eval("require.resolve")("./account-login-error");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});



/***/ }),

/***/ 81784:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export MyProfile */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var _me_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60591);
/* harmony import */ var _me_graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_me_graphql__WEBPACK_IMPORTED_MODULE_2__);



var MyProfile = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "profile";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | profile */ 845).then(__webpack_require__.bind(__webpack_require__, 24137));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(24137);
        }
        return eval("require.resolve")("./views/my-profile");
    }
});
// Fixes loadable type errors `Property 'graphQL' does not exist on type`
var MyProfilePage = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MyProfile, null);
};
MyProfilePage.variables = function(param) {
    var _offset = param.offset, offset = _offset === void 0 ? 0 : _offset;
    return {
        offset: typeof offset === "string" ? parseInt(offset, 10) : offset
    };
};
MyProfilePage.group = function(param) {
    var name = param.name, variables = param.variables;
    var groupVariables = variables ? Object.keys(variables).filter(function(key) {
        return key === "offset";
    }).filter(function(key) {
        return variables[key];
    }).map(function(key) {
        return variables[key];
    }) : [];
    return "".concat(name, "_").concat(groupVariables.join("_"));
};
MyProfilePage.graphQL = (_me_graphql__WEBPACK_IMPORTED_MODULE_2___default());
/* harmony default export */ __webpack_exports__["Z"] = (MyProfilePage);


/***/ }),

/***/ 30296:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export UserProfile */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var _user_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97731);
/* harmony import */ var _user_graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_user_graphql__WEBPACK_IMPORTED_MODULE_2__);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var UserProfile = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "profile";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | profile */ 845).then(__webpack_require__.bind(__webpack_require__, 81701));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(81701);
        }
        return eval("require.resolve")("./views/user-profile");
    }
});
// Fixes loadable type errors `Property 'graphQL' does not exist on type`
var UserProfilePage = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserProfile, _extends({}, props));
};
UserProfilePage.graphQL = (_user_graphql__WEBPACK_IMPORTED_MODULE_2___default());
UserProfilePage.variables = function(param) {
    var id = param.id, offset = param.offset, section = param.section;
    return {
        id: parseInt(id, 10),
        offset: parseInt(offset, 10) || 0,
        isListsTab: section === "lists",
        isReviewsTab: section === "reviews" || !section,
        section: section,
        includeSchibstedProfile: true
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (UserProfilePage);


/***/ }),

/***/ 38545:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony export Unsubscribe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);


var Unsubscribe = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "profile";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | profile */ 845).then(__webpack_require__.bind(__webpack_require__, 96820));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(96820);
        }
        return eval("require.resolve")("./unsubscribe-landing-page");
    }
});
// Fixes loadable type errors `Property 'graphQL' does not exist on type`
var UnsubscribeLandingPage = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Unsubscribe, null);
};
UnsubscribeLandingPage.variables = function(props) {
    return {
        id: props.group_id,
        subscribed: false,
        userID: props.user_id,
        hash: props.hash
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (UnsubscribeLandingPage);


/***/ }),

/***/ 88373:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19478);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var CampaignPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "campaigns";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | campaigns */ 340).then(__webpack_require__.bind(__webpack_require__, 6079));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(6079);
        }
        return eval("require.resolve")("../scoped-search-pages/deals-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
var Campaign = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CampaignPage, null);
};
Campaign.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
Campaign.loadOrder = [
    {}
];
var FILTER_URL_PARAMS = [
    "category",
    "price",
    "productRating",
    "storeRating",
    "stores",
    "offset"
];
Campaign.variables = function(variables) {
    var slug = variables.slug, page = variables.page, marketCode = variables.marketCode;
    var currentPageFromUrl = page ? Number(page) : undefined;
    return {
        id: /^\d+$/.test(slug) ? parseInt(slug, 10) : undefined,
        campaignSlug: slug,
        limit: 20,
        filters: FILTER_URL_PARAMS.map(function(key) {
            return variables[key] ? {
                key: key,
                value: variables[key]
            } : null;
        }).filter(Boolean),
        campaignDeals: slug === "black-friday",
        // To get the first page from the API, we pass 0 as the page number.
        // In the URL and in the UI, we call this page "page=1". To pass the right value
        // to the API, we therefore need to subtract 1 from currentPageFromUrl.
        page: currentPageFromUrl && currentPageFromUrl > 0 ? currentPageFromUrl - 1 : 0,
        sortType: marketCode === "nz" ? "trending" : "popularity",
        filtersV2: []
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (Campaign);


/***/ }),

/***/ 83220:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": () => (/* binding */ sortOptions),
/* harmony export */   "I8": () => (/* binding */ bothDirectionsSortOptions),
/* harmony export */   "vg": () => (/* binding */ LOCAL_STORAGE_FILTER_KEY)
/* harmony export */ });
var LOCAL_STORAGE_FILTER_KEY = "pj:filterExpanded";
var sortOptions = [
    "name",
    "popularity",
    "user_reviews"
];
var bothDirectionsSortOptions = [
    "price",
    "price_include_shipping"
];


/***/ }),

/***/ 31498:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48472);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var CategoryPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "category";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | category */ 34).then(__webpack_require__.bind(__webpack_require__, 43675));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(43675);
        }
        return eval("require.resolve")("./category");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
var Category = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CategoryPage, null);
};
Category.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
Category.variables = function(param) {
    var id = param.id, offset = param.offset, campaignId = param.campaignId, filterId = param.filterId, sort = param.sort, direction = param.direction, brand = param.brand, compare = param.compare, marketCode = param.marketCode;
    return {
        id: id,
        offset: parseInt(offset, 10) || 0,
        campaignId: campaignId,
        categoryDealId: [
            id
        ],
        filterId: filterId,
        sort: sort,
        direction: direction,
        brand: brand,
        compareIds: compare ? compare.split(",") : [
            "_core_"
        ],
        isServices: marketCode === "se" && id === "v1004",
        isVirtualCategory: (id === null || id === void 0 ? void 0 : id.startsWith("s")) || (id === null || id === void 0 ? void 0 : id.startsWith("v")),
        categoryIds: [
            id
        ]
    };
};
Category.group = function(param) {
    var name = param.name, variables = param.variables;
    var groupVariables = variables ? Object.keys(variables).filter(function(key) {
        return [
            "id",
            "brand",
            "filterId",
            "offset"
        ].includes(key);
    }).filter(function(key) {
        return variables[key];
    }).map(function(key) {
        return variables[key];
    }) : [];
    return "".concat(name, "_").concat(groupVariables.join("_"), "_").concat(variables.compareIds.join(":"));
};
/* harmony default export */ __webpack_exports__["Z"] = (Category);


/***/ }),

/***/ 19151:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ Changelog)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var Changelog = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "changelog";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | changelog */ 827).then(__webpack_require__.bind(__webpack_require__, 67606));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(67606);
        }
        return eval("require.resolve")("./changelog");
    }
});


/***/ }),

/***/ 54505:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* unused harmony exports BadgeIndicator, useCheckChangelogUnreadStatus */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24828);
/* harmony import */ var _prisjakt_ui_hideable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59945);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  background: ",
        ";\n  border-radius: 99px;\n  position: absolute;\n  top: -",
        "px;\n  right: -",
        "px;\n  box-shadow: ",
        ";\n  transition: transform 150ms ease;\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var BADGE_SIZE = 12;
var STORAGE_KEY = "pj:changelogRead";
var Badge = function(param) {
    var noOutline = param.noOutline;
    var hasUnread = useCheckChangelogUnreadStatus();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BadgeIndicator, {
        visible: hasUnread,
        $outline: !noOutline
    });
};
var BadgeIndicator = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_hideable__WEBPACK_IMPORTED_MODULE_3__.Hideable).withConfig({
    displayName: "BadgeIndicator",
    componentId: "sc-0-0"
})(_templateObject(), BADGE_SIZE, BADGE_SIZE, function(p) {
    return p.theme.colors.yellove500;
}, BADGE_SIZE / 10, BADGE_SIZE / 10, function(p) {
    return p.$outline ? "0 0 0 2px ".concat(p.theme.header.bg) : "none";
});
var selectChangelogArticles = function(state) {
    return state.areas.changelog.articles.map(function(a) {
        return a.id;
    });
};
var selectChangelogOpen = function(state) {
    return state.areas.changelog.isOpen;
};
function useCheckChangelogUnreadStatus() {
    var ids = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(selectChangelogArticles);
    var isOpen = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(selectChangelogOpen);
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), 2), unread = ref[0], setUnread = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isOpen) {
            setReadUpdates();
        }
        if (!isOpen) {
            setUnreadStatus();
        }
    }, [
        isOpen
    ]);
    var setUnreadStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        try {
            var ref;
            // Deprecated use of local storage (Changelog)
            var read = ((ref = localStorage.getItem(STORAGE_KEY)) === null || ref === void 0 ? void 0 : ref.split(";")) || [];
            setUnread(ids.filter(function(id) {
                return !read.includes(id);
            }));
        } catch (e) {} // eslint-disable-line no-empty
    }, [
        ids
    ]);
    var setReadUpdates = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        try {
            // Deprecated use of local storage (Changelog)
            localStorage.setItem(STORAGE_KEY, ids.join(";"));
            setUnread([]);
        } catch (e) {} // eslint-disable-line no-empty
    }, [
        ids
    ]);
    return Boolean(unread.length);
}
/* harmony default export */ __webpack_exports__["ZP"] = (Badge);


/***/ }),

/***/ 78667:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H3": () => (/* binding */ H3),
/* harmony export */   "Qg": () => (/* binding */ ReadAllButton),
/* harmony export */   "W4": () => (/* binding */ ButtonWrapper),
/* harmony export */   "Xc": () => (/* binding */ ChangelogModal),
/* harmony export */   "Xw": () => (/* binding */ ChangelogWrapper),
/* harmony export */   "ck": () => (/* binding */ Item),
/* harmony export */   "or": () => (/* binding */ Main),
/* harmony export */   "zx": () => (/* binding */ Button)
/* harmony export */ });
/* unused harmony export ReadMoreButton */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29261);
/* harmony import */ var _prisjakt_ui_hideable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59945);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21541);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25670);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  left: 100%;\n  bottom: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  background: ",
        ";\n  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.1);\n  width: 320px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 100%;\n    width: auto;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n  min-width: 160px;\n  max-width: fit-content;\n  text-align: center;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}






var ChangelogWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ChangelogWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var alternateModalPosition = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1());
var ChangelogModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_hideable__WEBPACK_IMPORTED_MODULE_3__.Hideable).withConfig({
    displayName: "ChangelogModal",
    componentId: "sc-0-1"
})(_templateObject2(), function(p) {
    return p.theme.bg.primary;
}, alternateModalPosition);
var Main = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__.Column).withConfig({
    displayName: "Main",
    componentId: "sc-0-2"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Item = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Item",
    componentId: "sc-0-3"
})(_templateObject4());
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__.PrimaryButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-4"
})(_templateObject5());
var H3 = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.H3Text).withConfig({
    displayName: "",
    componentId: "sc-0-5"
})(_templateObject6());
var ButtonWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__.PrimaryButton).withConfig({
    displayName: "ButtonWrapper",
    componentId: "sc-0-6"
})(_templateObject8(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject7()));
var ReadMoreButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__.PrimaryButton).withConfig({
    displayName: "ReadMoreButton",
    componentId: "sc-0-7"
})(_templateObject9());
var ReadAllButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__.OutlinedButton).withConfig({
    displayName: "ReadAllButton",
    componentId: "sc-0-8"
})(_templateObject10());


/***/ }),

/***/ 56264:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": () => (/* binding */ FaqSanity)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/ui/accordion/index.tsx + 4 modules
var accordion = __webpack_require__(94954);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/ui/accordion/styles.ts
var styles = __webpack_require__(14124);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/sanity-faq/faqStyles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n  max-height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 20px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.333;\n  margin-bottom: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: 400;\n  line-height: 1.5;\n  color: inherit;\n\n  :last-child {\n    margin-bottom: 0 !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-style: italic;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  text-decoration: underline;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  text-decoration: line-through;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-family: monospace;\n  background-color: #f5f5f5;\n  padding: 2px 4px;\n  border-radius: 4px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  padding-inline-start: ",
        ";\n  &:not(:last-of-type) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: '100%';\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  list-style-type: none;\n  padding-inline-start: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  list-style-type: decimal;\n  padding-inline-start: ",
        ";\n  &:not(:last-of-type) {\n    margin-bottom: ",
        ";\n  }\n  &:last-of-type {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: 400;\n  line-height: 1.5;\n  color: inherit;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var FaqContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FaqContainer",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var FaqTitle = (0,styled_components_browser_esm["default"])(variants.H2Text).withConfig({
    displayName: "FaqTitle",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject1()));
var StyledLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-2"
})(_templateObject3(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.linkExternalHover;
});
var FaqParagraph = styled_components_browser_esm["default"].p.withConfig({
    displayName: "FaqParagraph",
    componentId: "sc-0-3"
})(_templateObject4(), base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium);
var StyledStrong = styled_components_browser_esm["default"].strong.withConfig({
    displayName: "StyledStrong",
    componentId: "sc-0-4"
})(_templateObject5());
var StyledEm = styled_components_browser_esm["default"].em.withConfig({
    displayName: "StyledEm",
    componentId: "sc-0-5"
})(_templateObject6());
var StyledUnderline = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledUnderline",
    componentId: "sc-0-6"
})(_templateObject7());
var StyledStrikeThrough = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledStrikeThrough",
    componentId: "sc-0-7"
})(_templateObject8());
var StyledCode = styled_components_browser_esm["default"].code.withConfig({
    displayName: "StyledCode",
    componentId: "sc-0-8"
})(_templateObject9());
var StyledUl = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "StyledUl",
    componentId: "sc-0-9"
})(_templateObject10(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledAccordionWrapper = (0,styled_components_browser_esm["default"])(styles/* StyledContentWrapper */.H6).withConfig({
    displayName: "StyledAccordionWrapper",
    componentId: "sc-0-10"
})(_templateObject11());
var StyledUlNoStyle = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "StyledUlNoStyle",
    componentId: "sc-0-11"
})(_templateObject12(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var StyledOl = styled_components_browser_esm["default"].ol.withConfig({
    displayName: "StyledOl",
    componentId: "sc-0-12"
})(_templateObject13(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing200 */.bK.measurements.spacing200);
var StyledSpan = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledSpan",
    componentId: "sc-0-13"
})(_templateObject14(), base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/sanity-faq/numericList.tsx

 // Adjust the import path as needed
var NumericList = function(param) {
    var sections = param.sections, renderSection = param.renderSection;
    return /*#__PURE__*/ react.createElement(StyledOl, null, sections.map(function(section) {
        return /*#__PURE__*/ react.createElement("li", {
            key: section._key
        }, renderSection(section));
    }));
};
/* harmony default export */ var numericList = (NumericList);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/sanity-faq/faqAnswer.tsx



var FaqAnswer = function(param) {
    var answer = param.answer;
    var renderSpan = function(span, markDefs) {
        var ref;
        var content = /*#__PURE__*/ react.createElement("span", {
            key: span._key
        }, span.text);
        (ref = span.marks) === null || ref === void 0 ? void 0 : ref.forEach(function(mark) {
            if (mark === "strong") {
                content = /*#__PURE__*/ react.createElement(StyledStrong, {
                    key: span._key
                }, content);
            } else if (mark === "em") {
                content = /*#__PURE__*/ react.createElement(StyledEm, {
                    key: span._key
                }, content);
            } else if (mark === "underline") {
                content = /*#__PURE__*/ react.createElement(StyledUnderline, {
                    key: span._key
                }, content);
            } else if (mark === "strike-through") {
                content = /*#__PURE__*/ react.createElement(StyledStrikeThrough, {
                    key: span._key
                }, content);
            } else if (mark === "code") {
                content = /*#__PURE__*/ react.createElement(StyledCode, {
                    key: span._key
                }, content);
            } else {
                var markDef = markDefs.find(function(def) {
                    return def._key === mark;
                });
                if (markDef && markDef._type === "link" && markDef.href) {
                    content = /*#__PURE__*/ react.createElement(StyledLink, {
                        key: span._key,
                        href: markDef.href,
                        target: markDef.blank ? "_blank" : "_self",
                        rel: "noopener noreferrer"
                    }, content);
                }
            }
        });
        return content;
    };
    var renderSection = function(section) {
        var _markDefs;
        var content = section.children.map(function(child) {
            return renderSpan(child, (_markDefs = section.markDefs) !== null && _markDefs !== void 0 ? _markDefs : []);
        });
        if (section.listItem === "bullet") {
            if (section.level && section.level > 1) {
                return /*#__PURE__*/ react.createElement(StyledUlNoStyle, {
                    key: section._key
                }, /*#__PURE__*/ react.createElement("li", null, /*#__PURE__*/ react.createElement(StyledUl, null, /*#__PURE__*/ react.createElement("li", {
                    key: content[0].key
                }, content))));
            }
            return /*#__PURE__*/ react.createElement(StyledUl, {
                key: section._key
            }, /*#__PURE__*/ react.createElement("li", {
                key: content[0].key
            }, content));
        }
        switch(section.style){
            case "h4":
                return /*#__PURE__*/ react.createElement("h4", {
                    key: section._key
                }, content);
            case "normal":
            default:
                return /*#__PURE__*/ react.createElement(FaqParagraph, {
                    key: section._key
                }, content);
        }
    };
    var renderAnswer = function(sections) {
        var elements = [];
        var numericListItems = [];
        sections.forEach(function(section) {
            if (section.listItem === "number") {
                numericListItems.push(section);
            } else {
                if (numericListItems.length > 0) {
                    elements.push(/*#__PURE__*/ react.createElement(numericList, {
                        key: numericListItems[0]._key,
                        sections: numericListItems,
                        renderSection: renderSection
                    }));
                    numericListItems = [];
                }
                elements.push(renderSection(section));
            }
        });
        if (numericListItems.length > 0) {
            elements.push(/*#__PURE__*/ react.createElement(numericList, {
                key: numericListItems[0]._key,
                sections: numericListItems,
                renderSection: renderSection
            }));
        }
        return elements;
    };
    return renderAnswer(answer.sections);
};

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/sanity-faq/index.tsx




var FaqSanity = function(param) {
    var _faq = param.faq, faqTitle = _faq.faqTitle, faqItems = _faq.faqItems;
    return /*#__PURE__*/ react.createElement(FaqContainer, null, faqTitle ? /*#__PURE__*/ react.createElement(FaqTitle, null, faqTitle) : null, faqItems ? faqItems.map(function(item) {
        return /*#__PURE__*/ react.createElement(accordion/* Accordion */.UQ, {
            key: item.question,
            id: item.question
        }, /*#__PURE__*/ react.createElement(accordion/* AccordionHeader */._m, null, /*#__PURE__*/ react.createElement(StyledSpan, null, item.question)), /*#__PURE__*/ react.createElement(accordion/* AccordionContent */.vF, {
            maxHeight: "100%"
        }, /*#__PURE__*/ react.createElement(FaqAnswer, {
            answer: item.answer
        })));
    }) : null);
};


/***/ }),

/***/ 45030:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ rich_text),
  "K": () => (/* binding */ plainText)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prismic-dom@2.2.7/node_modules/prismic-dom/dist/prismic-dom.min.js
var prismic_dom_min = __webpack_require__(24605);
var prismic_dom_min_default = /*#__PURE__*/__webpack_require__.n(prismic_dom_min);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/rich-text/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 32px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 20px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 18px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 18px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  &,\n  p {\n    font-size: ",
        ";\n    font-weight: 400;\n    line-height: 1.5;\n    color: inherit;\n  }\n\n  p {\n    margin-bottom: ",
        ";\n  }\n\n  h1 {\n    font-size: 40px;\n    font-weight: 800;\n    line-height: 1.25;\n    margin-bottom: ",
        ";\n\n    ",
        ";\n  }\n\n  h2 {\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.333;\n    margin-bottom: ",
        ";\n\n    ",
        ";\n  }\n\n  h3 {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 1.4;\n    margin-bottom: ",
        ";\n\n    ",
        ";\n  }\n\n  h4 {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.5;\n    margin-bottom: ",
        ";\n  }\n\n  h5 {\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 1.4;\n    margin-bottom: ",
        ";\n\n    ",
        ";\n  }\n\n  strong: {\n    font-weight: 700;\n  }\n\n  ol,\n  ul {\n    padding-inline-start: ",
        ";\n\n    li {\n      &:not(:last-of-type) {\n        margin-bottom: ",
        ";\n      }\n      &:last-of-type {\n        margin-bottom: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var RichTextSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "RichTextSection",
    componentId: "sc-0-0"
})(_templateObject4(), base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject()), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject1()), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject2()), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject3()), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing200 */.bK.measurements.spacing200);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/rich-text/index.tsx

// @ts-expect-error -- Untyped


var RichText = function(param) {
    var data = param.data, linkResolver = param.linkResolver, serializer = param.serializer, container = param.container, className = param.className;
    if (!Array.isArray(data) || !data.length) {
        return null;
    }
    var html = prismic_dom_min_default().RichText.asHtml(data, linkResolver, serializer);
    var Component = container || RichTextSection;
    return /*#__PURE__*/ react.createElement(Component, {
        className: className,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
var plainText = function(data) {
    var ref;
    return (ref = prismic_dom_min_default().RichText.asText(data)) !== null && ref !== void 0 ? ref : "";
};
/* harmony default export */ var rich_text = (RichText);


/***/ }),

/***/ 59669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        "px;\n  object-fit: cover;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Image = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.height;
});
var CardImage = function(param) {
    var src = param.src, height = param.height, alt = param.alt;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Image, {
        src: src,
        alt: alt,
        height: height
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardImage);


/***/ }),

/***/ 61768:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _components_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94320);
/* harmony import */ var _components_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62619);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18969);






var FeedbackForm = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 6600));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(6600);
        }
        return eval("require.resolve")("./components/feedback-form");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null)
});
var Feedback = function() {
    var feedback = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.feedback;
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    return feedback.open === true ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        width: 800,
        isOpen: feedback.open,
        onRequestClose: function() {
            return dispatch(_actions__WEBPACK_IMPORTED_MODULE_5__/* ["default"].close */ .ZP.close());
        },
        key: "FeedbackFormModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FeedbackForm, null)) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Feedback);


/***/ }),

/***/ 95785:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ useIsKWLP),
/* harmony export */   "e": () => (/* binding */ IsKWLPContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var IsKWLPContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);
var useIsKWLP = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(IsKWLPContext);
};


/***/ }),

/***/ 39563:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": () => (/* binding */ appsConfig),
/* harmony export */   "V": () => (/* binding */ LIMIT)
/* harmony export */ });
var LIMIT = 30;
var appsConfig = {
    ios: {
        id: "369151774",
        storeUrl: "https://itunes.apple.com/se/app/prisjakt/id369151774"
    },
    android: {
        id: "se.prisjakt.pricespy",
        storeUrl: "https://play.google.com/store/apps/details?id=se.prisjakt.pricespy"
    }
};


/***/ }),

/***/ 67363:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var src_areas_sidebar_list_query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20907);
/* harmony import */ var src_areas_sidebar_list_query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(src_areas_sidebar_list_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39563);
/* harmony import */ var src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73426);






var MyListLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "lists";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | lists */ 422).then(__webpack_require__.bind(__webpack_require__, 52333));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(52333);
        }
        return eval("require.resolve")("./my-list");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
var MyList = function() {
    var authenticated = (0,src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_5__/* .useIsAuthenticated */ .k)();
    if (!authenticated) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MyListLoadable, null);
};
MyList.graphQL = (src_areas_sidebar_list_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
MyList.variables = function(param) {
    var id = param.id, offset = param.offset;
    return {
        id: Number(id),
        limit: _constants__WEBPACK_IMPORTED_MODULE_4__/* .LIMIT */ .V,
        offset: offset !== undefined ? Number(offset) : 0
    };
};
MyList.loadOrder = [
    {}
];
/* harmony default export */ __webpack_exports__["Z"] = (MyList);


/***/ }),

/***/ 96449:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _queries_public_list_query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95307);
/* harmony import */ var _queries_public_list_query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_queries_public_list_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39563);





var PublicListLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "lists";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | lists */ 422).then(__webpack_require__.bind(__webpack_require__, 88990));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(88990);
        }
        return eval("require.resolve")("./public-list");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
var PublicList = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PublicListLoadable, null);
};
PublicList.graphQL = (_queries_public_list_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
PublicList.variables = function(param) {
    var id = param.id, offset = param.offset;
    return {
        id: Number(id),
        limit: _constants__WEBPACK_IMPORTED_MODULE_4__/* .LIMIT */ .V,
        offset: offset !== undefined ? Number(offset) : 0
    };
};
PublicList.loadOrder = [
    {}
];
/* harmony default export */ __webpack_exports__["Z"] = (PublicList);


/***/ }),

/***/ 84330:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var MegaMenuLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "mega-menu";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | mega-menu */ 495).then(__webpack_require__.bind(__webpack_require__, 72932));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(72932);
        }
        return eval("require.resolve")("./mega-menu");
    }
});
var MegaMenu = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuLoadable, _extends({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (MegaMenu);


/***/ }),

/***/ 6951:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ mobile_menu_button)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/changelog/components/badge/index.tsx
var badge = __webpack_require__(54505);
// EXTERNAL MODULE: ./src/areas/navigation/actions/mobile-menu.js
var mobile_menu = __webpack_require__(92306);
// EXTERNAL MODULE: ./src/areas/sidebar/tracking/index.ts
var tracking = __webpack_require__(59909);
// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/constants.ts
var constants = __webpack_require__(86178);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/menu-hamburger/index.js
var menu_hamburger = __webpack_require__(28053);
;// CONCATENATED MODULE: ./src/areas/navigation/components/mobile-menu-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  line-height: inherit;\n  text-align: left;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  position: relative;\n\n  ",
        ";\n\n  &.focus-visible {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var MenuButton = styled_components_browser_esm["default"].button.attrs({
    type: "button"
}).withConfig({
    displayName: "MenuButton",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.theme.header.fg;
}, base/* media.largeUp */.BC.largeUp(_templateObject()), function(p) {
    return p.active ? "white" : p.theme.buttons.primary.bg;
});
var MenuIcon = (0,styled_components_browser_esm["default"])(menu_hamburger/* IconMenuHamburger */.P).attrs({
    size: 32,
    color: "base100"
}).withConfig({
    displayName: "MenuIcon",
    componentId: "sc-0-1"
})(_templateObject2(), (0,base/* remCalc */.vR)(27));

;// CONCATENATED MODULE: ./src/areas/navigation/components/mobile-menu-button/index.tsx









var MobileButton = function(param) {
    var _handleOnClick = param.handleOnClick, handleOnClick = _handleOnClick === void 0 ? base/* noop */.ZT : _handleOnClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var open = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.navigation.mobileMenu;
    }).open;
    var dispatch = (0,es/* useDispatch */.I0)();
    var toggleMenu = function() {
        if (open) {
            dispatch(mobile_menu/* default.closeMenu */.ZP.closeMenu());
        } else {
            (0,tracking/* trackOpeningSidebar */.b)(constants/* VIEWS.ROOT */.n.ROOT, "MobileMenuButton");
            dispatch(mobile_menu/* default.openMenu */.ZP.openMenu());
            handleOnClick();
        }
    };
    return /*#__PURE__*/ react.createElement(MenuButton, {
        onClick: toggleMenu,
        "aria-label": t("header", "mobile-menu.title"),
        "data-test": "MobileMenuButton"
    }, /*#__PURE__*/ react.createElement(badge/* default */.ZP, null), /*#__PURE__*/ react.createElement(MenuIcon, {
        size: 32
    }));
};
/* harmony default export */ var mobile_menu_button = (MobileButton);


/***/ }),

/***/ 14236:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": () => (/* binding */ Errors),
/* harmony export */   "d_": () => (/* binding */ AlertTypes),
/* harmony export */   "lc": () => (/* binding */ ShopPreference)
/* harmony export */ });
var AlertTypes;
(function(AlertTypes) {
    AlertTypes["IN_STOCK"] = "IN_STOCK";
    AlertTypes["PRICE_DROPS"] = "PRICE_DROPS";
    AlertTypes["IN_STOCK_PRICE_DROPS"] = "IN_STOCK_PRICE_DROPS";
})(AlertTypes || (AlertTypes = {}));
var ShopPreference;
(function(ShopPreference) {
    ShopPreference["NONE"] = "NONE";
    ShopPreference["LIKED"] = "LIKED";
    ShopPreference["EXCLUDE_DISLIKED"] = "EXCLUDE_DISLIKED";
})(ShopPreference || (ShopPreference = {}));
var Errors;
(function(Errors) {
    Errors["ERROR_EMAIL_INVALID"] = "alert.invalid-email";
    Errors["ERROR_EMAIL_IN_USE"] = "EMAIL_ASSOCIATED_WITH_USER";
    Errors["ERROR_UNKNOWN"] = "alert.error";
    Errors["ERROR_THRESHOLD_TOO_LOW"] = "alert.threshold-too-low";
})(Errors || (Errors = {}));


/***/ }),

/***/ 72270:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": () => (/* binding */ SET_PRODUCT_COLLECTION_LAYOUT),
/* harmony export */   "E8": () => (/* binding */ updateProductCollectionFilters),
/* harmony export */   "On": () => (/* binding */ UPDATE_PRODUCT_COLLECTION_FILTERS),
/* harmony export */   "l2": () => (/* binding */ setProductCollectionLayout)
/* harmony export */ });
var SET_PRODUCT_COLLECTION_LAYOUT = "SET_PRODUCT_COLLECTION_LAYOUT";
var UPDATE_PRODUCT_COLLECTION_FILTERS = "UPDATE_PRODUCT_COLLECTION_FILTERS";
var setProductCollectionLayout = function(layout) {
    return {
        type: SET_PRODUCT_COLLECTION_LAYOUT,
        layout: layout
    };
};
var updateProductCollectionFilters = function(id, filters) {
    return {
        type: UPDATE_PRODUCT_COLLECTION_FILTERS,
        id: id,
        filters: filters
    };
};


/***/ }),

/***/ 72943:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": () => (/* binding */ Ads)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./packages/react-ads/dist/module.js + 1 modules
var dist_module = __webpack_require__(6895);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/ads/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        " display:none; "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      transform: scale(",
        ");\n      transform-origin: left;\n      margin: -",
        "em 0;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        " display:none; "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    list-style: none;\n    grid-row: ",
        ";\n    grid-column: 1 / -1;\n\n    ",
        ";\n\n    ",
        "\n\n    ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin: auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var Advert = styled_components_browser_esm["default"].li.withConfig({
    displayName: "Advert",
    componentId: "sc-0-0"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), p.row || "0", p.$display === "mobile" && (0,styled_components_browser_esm.css)(_templateObject1(), base/* media.mediumUp */.BC.mediumUp(_templateObject())), p.$scale && base/* media.largeUp */.BC.largeUp(_templateObject2(), p.$scale, p.$scale / 2), p.$display === "desktop" && (0,styled_components_browser_esm.css)(_templateObject4(), base/* media.smallOnly */.BC.smallOnly(_templateObject3())));
});
var AdPlacementAligned = (0,styled_components_browser_esm["default"])(dist_module/* AdPlacement */.ZD).withConfig({
    displayName: "AdPlacementAligned",
    componentId: "sc-0-1"
})(_templateObject6());

// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(21068);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/ads/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var _obj;
var DEFAULT_LAYOUT_CONFIG = (_obj = {}, _defineProperty(_obj, types/* LayoutMode.GRID */.X.GRID, {
    panorama_extra: {
        show: true,
        row: 2
    },
    dubbelpanorama1: {
        show: true,
        row: 2
    },
    dubbelpanorama2: {
        show: true,
        row: 8
    }
}), _defineProperty(_obj, types/* LayoutMode.LIST */.X.LIST, {
    panorama_extra: {
        show: true,
        row: 2
    },
    dubbelpanorama1: {
        show: true,
        row: 2
    },
    dubbelpanorama2: {
        show: true,
        row: 8
    }
}), _defineProperty(_obj, types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST, {
    panorama_extra: {
        show: true,
        row: 2
    },
    dubbelpanorama1: {
        show: true,
        row: 2
    },
    dubbelpanorama2: {
        show: true,
        row: 8
    }
}), _obj);
var Ads = function(param) {
    var offersLength = param.offersLength, layout = param.layout, layoutConfig = param.layoutConfig, scaleBase = param.scaleBase, async = param.async, scale = param.scale;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, offersLength > 4 && /*#__PURE__*/ react.createElement(ads_Advert, {
        scalable: true,
        scaleBase: scaleBase && ".".concat(scaleBase),
        scaleOrigin: "left center",
        placement: "panorama_extra",
        format: "panorama_1_wde",
        min: 0,
        max: 10000,
        layout: layout,
        layoutConfig: layoutConfig,
        async: async,
        scale: scale,
        triggerPoint: 0
    }), offersLength > 2 && /*#__PURE__*/ react.createElement(ads_Advert, {
        placement: "dubbelpanorama1",
        format: "panorama_1",
        min: 0,
        max: 860,
        layout: layout,
        layoutConfig: layoutConfig,
        async: async,
        scale: scale,
        triggerPoint: 0
    }), offersLength > 18 && /*#__PURE__*/ react.createElement(ads_Advert, {
        placement: "dubbelpanorama2",
        format: "panorama_2",
        min: 0,
        max: 860,
        triggerPoint: 0,
        layout: layout,
        layoutConfig: layoutConfig,
        async: async,
        scale: scale
    }));
};
var getDisplay = function(placement) {
    switch(placement){
        case "panorama_extra":
            return "desktop";
        case "dubbelpanorama1":
        case "dubbelpanorama2":
            return "mobile";
        default:
            return "";
    }
};
var ads_Advert = function(param) {
    var placement = param.placement, layout = param.layout, _layoutConfig = param.layoutConfig, layoutConfig = _layoutConfig === void 0 ? {} : _layoutConfig, scale = param.scale, triggerPoint = param.triggerPoint;
    var display = getDisplay(placement);
    var config = _objectSpread({}, DEFAULT_LAYOUT_CONFIG, layoutConfig);
    var placementConfig = config[layout][placement];
    if (!placementConfig.show) {
        return null;
    }
    var renderAd = function() {
        if (placement === "panorama_extra") return /*#__PURE__*/ react.createElement(AdPlacementAligned, {
            format: placementConfig.customPlacement ? placementConfig.customPlacement : "panorama_1_wde",
            triggerPoint: triggerPoint
        });
        if (placement === "dubbelpanorama1") return /*#__PURE__*/ react.createElement(AdPlacementAligned, {
            format: placementConfig.customPlacement ? placementConfig.customPlacement : "panorama_1",
            triggerPoint: triggerPoint
        });
        if (placement === "dubbelpanorama2") return /*#__PURE__*/ react.createElement(AdPlacementAligned, {
            format: placementConfig.customPlacement ? placementConfig.customPlacement : "panorama_2",
            triggerPoint: triggerPoint
        });
        return null;
    };
    return /*#__PURE__*/ react.createElement(Advert, {
        row: placementConfig.row,
        key: placement,
        $display: display,
        $scale: scale
    }, renderAd());
};



/***/ }),

/***/ 85029:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94141);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96742);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-radius: 1px;\n  box-shadow: 0 0 0 0.2em\n    ",
        ";\n  font-style: normal;\n  font-weight: bold;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Accepts a string containing search highlight markup and returns a formatted React element.
 */ var HighlightedSearchResult = function(param) {
    var children = param.children, component = param.component;
    var highlightPattern = /\[highlight\](.+?)\[\/highlight\]/g;
    var parts = [];
    var match = highlightPattern.exec(children);
    var nextPartStartIndex = 0;
    var Component = component || Highlight;
    while(match !== null){
        // Yield a text node of the part from the start of the string or the end of the previous match
        // to the start of the current match
        parts.push(children.substring(nextPartStartIndex, match.index));
        // Yield the formatted content of the current match
        parts.push(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, {
            key: match.index
        }, match[1]));
        // Remember the end of the current match, and try to match the next highlight (if any)
        nextPartStartIndex = highlightPattern.lastIndex;
        match = highlightPattern.exec(children);
    }
    // Yield a text node of the part from the end of the last match to the end of the string
    parts.push(children.substr(nextPartStartIndex));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, parts);
};
var Highlight = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].em.withConfig({
    displayName: "Highlight",
    componentId: "sc-0-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(theme.colors.yellove500, 0.2);
}, function(param) {
    var theme = param.theme;
    return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(theme.colors.yellove500, 0.2);
});
/* harmony default export */ __webpack_exports__["Z"] = (HighlightedSearchResult);


/***/ }),

/***/ 15169:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZZ": () => (/* binding */ categoryAdsConfig),
/* harmony export */   "_B": () => (/* binding */ FILTER_PORTAL_ID),
/* harmony export */   "xU": () => (/* binding */ PRODUCT_COLLECTION_LAYOUT)
/* harmony export */ });
var PRODUCT_COLLECTION_LAYOUT = "pj:productCollectionLayout";
var FILTER_PORTAL_ID = "sidebar-filter";
var categoryAdsConfig = {
    pageOptions: {
        pageType: "category"
    },
    formats: [
        "panorama_1_wde",
        "panorama_2_wde",
        "panorama_1",
        "panorama_2",
        "panorama_3",
        "welcome_page_wde",
        "welcome_page"
    ]
};


/***/ }),

/***/ 91567:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kQ": () => (/* binding */ trackProductCollectionProductClick),
  "ds": () => (/* binding */ trackProductCollectionSecondaryNavigationClick),
  "_P": () => (/* binding */ trackProductCollectionWordCloudClick),
  "K_": () => (/* binding */ useTrackProductCollectionClick),
  "ST": () => (/* binding */ useTrackProductCollectionImpression)
});

// UNUSED EXPORTS: trackProductCollectionQuickFilterOpen

// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/sponsored-content/mutations/track-click.graphql
var track_click_graphql = __webpack_require__(93065);
var track_click_graphql_default = /*#__PURE__*/__webpack_require__.n(track_click_graphql);
// EXTERNAL MODULE: ./src/client/gql-client.ts
var gql_client = __webpack_require__(9684);
;// CONCATENATED MODULE: ./src/areas/sponsored-content/hooks/use-track-sponsored-product-click.ts



/**
 * Hook for tracking sponsored product clicks
 * sends tracking data to the sponsored content api
 */ var useTrackSponsoredProductClick = function() {
    var trackClick = (0,react.useCallback)(function(pageUrl, adId, productId) {
        gql_client/* gqlClient.request */.N.request((track_click_graphql_default()), {
            pageUrl: pageUrl,
            adId: adId,
            productId: productId
        });
    }, []);
    return {
        mutate: trackClick
    };
};

// EXTERNAL MODULE: ./src/areas/sponsored-content/mutations/track-impression.graphql
var track_impression_graphql = __webpack_require__(77246);
var track_impression_graphql_default = /*#__PURE__*/__webpack_require__.n(track_impression_graphql);
;// CONCATENATED MODULE: ./src/areas/sponsored-content/hooks/use-track-sponsored-product-impression.ts



/**
 * Hook for tracking sponsored product impressions
 * Uses IntersectionObserver to track when products are at least 50% visible for 1 second
 * Ensures impressions are only tracked once per product per pageview
 * Sends tracking data to the sponsored content api
 */ var useTrackSponsoredProductImpression = function() {
    // Keep track of products that have already been tracked
    var trackedProducts = (0,react.useRef)(new Set());
    // Store refs to timers
    var timers = (0,react.useRef)(new Map());
    // Ref to store the observer
    var observer = (0,react.useRef)(null);
    // Create a track impression function
    var trackImpression = (0,react.useCallback)(function(adId, productId) {
        gql_client/* gqlClient.request */.N.request((track_impression_graphql_default()), {
            pageUrl: window.location.href,
            adId: adId,
            productId: productId
        });
    }, []);
    // Handle starting a timer for an element that is now visible
    var startVisibilityTimer = (0,react.useCallback)(function(targetAdId, targetProductId, entry) {
        // Skip if we already have a timer running or if the product was already tracked
        if (timers.current.has(targetAdId) || trackedProducts.current.has(targetAdId)) {
            return;
        }
        var timer = setTimeout(function() {
            // Mark as tracked and stop tracking
            trackImpression(targetAdId, targetProductId);
            trackedProducts.current.add(targetAdId);
            timers.current.delete(targetAdId);
            // Stop observing this element
            if (observer.current) {
                observer.current.unobserve(entry.target);
            }
        }, 1000); // 1 second delay
        timers.current.set(targetAdId, timer);
    }, [
        trackImpression
    ]);
    // Handle when an element is no longer visible
    var handleElementNotVisible = (0,react.useCallback)(function(targetAdId) {
        var timer = timers.current.get(targetAdId);
        if (timer) {
            clearTimeout(timer);
            timers.current.delete(targetAdId);
        }
    }, []);
    // Process intersection entries
    var handleIntersection = (0,react.useCallback)(function(entries) {
        entries.forEach(function(entry) {
            var targetAdId = entry.target.getAttribute("data-ad-id");
            var targetProductIdAttr = Number(entry.target.getAttribute("data-product-id"));
            // Skip if no adId found
            if (!targetAdId) return;
            // Element is at least 50% visible - start timer
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                startVisibilityTimer(targetAdId, targetProductIdAttr, entry);
            } else {
                // Element is not visible - clear timer
                handleElementNotVisible(targetAdId);
            }
        });
    }, [
        startVisibilityTimer,
        handleElementNotVisible
    ]);
    // Function to observe an element for visibility
    var observeElement = (0,react.useCallback)(function(element, adId) {
        // Skip if we've already tracked this product
        if (trackedProducts.current.has(adId)) {
            return;
        }
        // Create the observer if it doesn't exist
        if (!observer.current) {
            observer.current = new IntersectionObserver(handleIntersection, {
                threshold: [
                    0,
                    0.5,
                    1
                ],
                rootMargin: "0px"
            });
        }
        // Start observing the element
        observer.current.observe(element);
    }, [
        handleIntersection
    ]);
    // Function to register an element for impression tracking
    var registerForImpressionTracking = (0,react.useCallback)(function(element, adId, productId) {
        // Skip invalid inputs
        if (!element || !adId) return;
        // Add data attribute for identification in the observer callback
        element.setAttribute("data-ad-id", adId);
        element.setAttribute("data-product-id", (productId || -1).toString());
        // Start observing this element
        observeElement(element, adId);
    }, [
        observeElement
    ]);
    // Cleanup when component unmounts
    (0,react.useEffect)(function() {
        return function() {
            var // Disconnect observer
            ref;
            // Clear all timers
            timers.current.forEach(clearTimeout);
            timers.current.clear();
            (ref = observer.current) === null || ref === void 0 ? void 0 : ref.disconnect();
        };
    }, []);
    return {
        registerForImpressionTracking: registerForImpressionTracking
    };
};

;// CONCATENATED MODULE: ./src/areas/product-collection/tracking.ts




/**
 * Tracks when a product collection quick filter panel is opened.
 * @param property Quick filter property
 */ var trackProductCollectionQuickFilterOpen = function(property) {
    pushEvent("productCollectionQuickFilterOpen", {
        property: property
    });
};
/**
 * Regular tracking for product clicks (for non-sponsored products)
 * @param productId ID of product clicked
 */ var trackProductCollectionProductClick = function(productId) {
    (0,data_layer/* pushEvent */.A)("productCollectionProductClick", {
        productId: productId
    });
};
/**
 * Hook for tracking sponsored product clicks
 * Handles both GTM tracking and BFF tracking
 */ var useTrackProductCollectionClick = function() {
    var ref = useTrackSponsoredProductClick(), trackSponsoredClick = ref.mutate;
    return (0,react.useCallback)(function(sponsor) {
        if ((sponsor === null || sponsor === void 0 ? void 0 : sponsor.adId) && sponsor.productId) {
            trackSponsoredClick(window.location.href, sponsor.adId, sponsor.productId);
        }
    }, [
        trackSponsoredClick
    ]);
};
/**
 * Hook for tracking sponsored product impressions
 * Handles impression tracking when a product is at least 50% visible for 1 second
 */ var useTrackProductCollectionImpression = function() {
    var registerForImpressionTracking = useTrackSponsoredProductImpression().registerForImpressionTracking;
    return {
        registerForImpressionTracking: registerForImpressionTracking
    };
};
/**
 * Tracks when a link in the secondary navigation in product collection is clicked.
 * @param categoryUrl Url of category clicked
 */ var trackProductCollectionSecondaryNavigationClick = function(categoryUrl) {
    (0,data_layer/* pushEvent */.A)("productCollectionSecondaryNavigationClick", {
        categoryUrl: categoryUrl
    });
};
/**
 * Tracks when a link in the word cloud in product collection is clicked.
 * @param keywordId Url of keyword clicked
 */ var trackProductCollectionWordCloudClick = function(keywordUrl) {
    (0,data_layer/* pushEvent */.A)("productCollectionWordCloudClick", {
        keywordUrl: keywordUrl
    });
};


/***/ }),

/***/ 69140:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yc": () => (/* binding */ headerClickEvent),
  "nA": () => (/* binding */ productClickOutBounce),
  "$0": () => (/* binding */ productNavigation),
  "Po": () => (/* binding */ productPriceClick)
});

;// CONCATENATED MODULE: ./src/areas/product/actions/ga.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function getTypeFromStatus(status) {
    switch(status){
        case "international":
        case "variant":
        case "":
            return "normal";
        case undefined:
        case "raw":
        default:
            return "";
    }
}
function getGAPriceFromObject(price, status) {
    switch(price.__typename){
        case "Price":
            return price;
        default:
            return _objectSpreadProps(_objectSpread({}, price), {
                type: getTypeFromStatus(status)
            });
    }
}
function getGAPrice(price, status) {
    return typeof price === "object" && price !== null ? getGAPriceFromObject(price, status) : {
        price: price,
        type: getTypeFromStatus(status)
    };
}
function getGAFeatured(featured) {
    return featured ? "Featured" : "Not Featured";
}

// EXTERNAL MODULE: ./src/areas/product/actions/types.ts
var types = __webpack_require__(37637);
;// CONCATENATED MODULE: ./src/areas/product/actions/product.ts
function product_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


// NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
// reflected in react/middlewares/out.js pre click for tracking clicks before JS bundle
var productPriceClick = function(productId, price, featured, status, isAlternative, context, stockStatus, condition) {
    return {
        type: types/* ProductActionType.PRODUCT_PRICE_CLICK */.Z.PRODUCT_PRICE_CLICK,
        pretrack: false,
        productId: productId,
        price: getGAPrice(price, status),
        featured: getGAFeatured(featured),
        status: status,
        isAlternative: isAlternative,
        context: context,
        stockStatus: stockStatus,
        condition: condition
    };
};
var productNavigation = function(action, index) {
    return {
        type: types/* ProductActionType.PRODUCT_NAVIGATION */.Z.PRODUCT_NAVIGATION,
        action: action,
        index: index
    };
};
var productClickOutBounce = function(data) {
    return product_objectSpreadProps(product_objectSpread({
        type: types/* ProductActionType.PRODUCT_PRICE_CLICK_BOUNCE */.Z.PRODUCT_PRICE_CLICK_BOUNCE
    }, data), {
        priceId: data.offerId
    });
};
var headerClickEvent = function(event) {
    return {
        type: types/* ProductActionType.PRODUCT_HEADER_CLICK */.Z.PRODUCT_HEADER_CLICK,
        event: event
    };
};


/***/ }),

/***/ 37637:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ ProductActionType)
/* harmony export */ });
var ProductActionType;
(function(ProductActionType) {
    ProductActionType["PRODUCT_RECEIVE"] = "PRODUCT_RECEIVE";
    ProductActionType["PRODUCT_FETCH_ERROR"] = "PRODUCT_FETCH_ERROR";
    ProductActionType["PRODUCT_RATE_REQUEST"] = "PRODUCT_RATE_REQUEST";
    ProductActionType["PRODUCT_REVIEW_FAILED"] = "PRODUCT_REVIEW_FAILED";
    ProductActionType["PRODUCT_PRICE_CLICK"] = "PRODUCT_PRICE_CLICK";
    ProductActionType["PRODUCT_NAVIGATION"] = "PRODUCT_NAVIGATION";
    ProductActionType["PRODUCT_PRICE_CLICK_BOUNCE"] = "PRODUCT_PRICE_CLICK_BOUNCE";
    ProductActionType["PRODUCT_HEADER_CLICK"] = "PRODUCT_HEADER_CLICK";
    ProductActionType["CAMPAIGNS_RECEIVE"] = "CAMPAIGNS_RECEIVE";
    ProductActionType["ROUTE_LOADED"] = "ROUTE_LOADED";
})(ProductActionType || (ProductActionType = {}));


/***/ }),

/***/ 68620:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xV": () => (/* reexport */ CampaignBadge),
  "fd": () => (/* reexport */ MembershipBadge),
  "pb": () => (/* reexport */ MembershipInformation)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/areas/product/components/badges/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 10px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    font-style: italic;\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n    white-space: break-spaces;\n\n    /* Small mobile resolutions, e.g. Galaxy Fold */\n    @media screen and (max-width: 280px) {\n      margin-left: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: flex-end;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledTextWrapper = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledTextWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var StyledText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledText",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), props.$smallerTextSize && (0,styled_components_browser_esm.css)(_templateObject1()), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var StyledBadgeWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledBadgeWrapper",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$alignRight && (0,styled_components_browser_esm.css)(_templateObject3()), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});

;// CONCATENATED MODULE: ./src/areas/product/components/badges/membership-badge.tsx




var MembershipBadge = function(param) {
    var alignRight = param.alignRight, isMembershipPrice = param.isMembershipPrice;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!isMembershipPrice) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledBadgeWrapper, {
        $alignRight: alignRight
    }, /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "YELLOW",
        size: badge.BadgeSize.SMALL,
        text: t("product", "promotions.members-price"),
        containerProps: {
            "data-testid": "MembershipPriceBadge"
        }
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(89286);
;// CONCATENATED MODULE: ./src/areas/product/components/badges/membership-information.tsx





var MembershipInformation = function(param) {
    var isMembershipPrice = param.isMembershipPrice, isPaidMembership = param.isPaidMembership, smallerTextSize = param.smallerTextSize;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!isMembershipPrice || !isPaidMembership) return null;
    return /*#__PURE__*/ react.createElement(StyledTextWrapper, {
        emphasis: variants.FontEmphasis.HIGH,
        color: variants.FontColor.DARK
    }, /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        size: 12
    }), /*#__PURE__*/ react.createElement(StyledText, {
        $smallerTextSize: smallerTextSize,
        "data-testid": "PaidMembershipInfo"
    }, t("product", "promotions.membership-price-info")));
};

// EXTERNAL MODULE: ./src/components/offer/price/utils.ts
var utils = __webpack_require__(8501);
;// CONCATENATED MODULE: ./src/areas/product/components/badges/campaign-badge.tsx





var CampaignBadge = function(param) {
    var alignRight = param.alignRight, containerProps = param.containerProps, isCampaign = param.isCampaign, originalPrice = param.originalPrice, price = param.price, priceExpires = param.priceExpires;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    if (!isCampaign || !originalPrice || !price || originalPrice <= price) {
        return null;
    }
    var percentage = (0,utils/* getSalesPricePercentage */.U)(price, originalPrice);
    if (!percentage) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledBadgeWrapper, {
        $alignRight: alignRight
    }, /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "RED",
        size: badge.BadgeSize.SMALL,
        text: priceExpires ? t("campaigns", "campaign-card.sale-badge-end-date-percentage", {
            percentage: percentage,
            date: (0,utils/* parseUTCDate */.k)(priceExpires, market.localeStandard)
        }) : t("campaigns", "campaign-card.sale-percentage", {
            percentage: percentage
        }),
        containerProps: containerProps
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/badges/index.ts





/***/ }),

/***/ 87191:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": () => (/* binding */ PartnerVideoModal)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(51676);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(42574);
// EXTERNAL MODULE: ./src/hooks/resize-observer.ts
var resize_observer = __webpack_require__(32495);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/youtube/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  border-radius: 8px;\n  grid-area: youtube;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    max-height: unset;\n    height: 100%;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 60vh;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    max-height: unset;\n    height: 100%;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  background: url(",
        ");\n  width: 100%;\n  height: 60vh;\n  max-height: ",
        "px;\n  background-size: cover;\n  position: relative;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  cursor: pointer;\n  width: 100%;\n\n  svg {\n    height: 60px;\n    width: 86px;\n\n    path.yt-btn-bg {\n      transition: fill 150ms ease;\n      fill: rgba(0, 0, 0, 0.75);\n    }\n  }\n\n  &:hover {\n    svg path.yt-btn-bg {\n      fill: rgba(255, 0, 0, 1);\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject());
var StyledIframe = styled_components_browser_esm["default"].iframe.withConfig({
    displayName: "StyledIframe",
    componentId: "sc-0-1"
})(_templateObject2(), base/* media.mediumDown */.BC.mediumDown(_templateObject1()));
var YTPlaceholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "YTPlaceholder",
    componentId: "sc-0-2"
})(_templateObject4(), function(p) {
    return p.thumbnail;
}, function(p) {
    return p.height;
}, base/* media.mediumDown */.BC.mediumDown(_templateObject3()));
var PlayButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "PlayButton",
    componentId: "sc-0-3"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/components/youtube/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var YoutubeLoader = function(param) {
    var className = param.className, thumbnail = param.thumbnail, id = param.id;
    var ref = (0,resize_observer/* useResizeObserver */.y)(), width = ref.width, videoRef = ref.ref;
    var ref1 = _slicedToArray((0,react.useState)(false), 2), load = ref1[0], setLoad = ref1[1];
    var height = width ? width / (16 / 9) : 320;
    return /*#__PURE__*/ react.createElement(Wrapper, {
        className: className,
        ref: videoRef
    }, load ? /*#__PURE__*/ react.createElement(StyledIframe, {
        title: "youtube video",
        width: "100%",
        height: height,
        src: "https://www.youtube.com/embed/".concat(id, "?autoplay=1&showinfo=0"),
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
    }) : /*#__PURE__*/ react.createElement(YTPlaceholder, {
        height: height,
        thumbnail: thumbnail,
        onClick: function() {
            return setLoad(true);
        }
    }, /*#__PURE__*/ react.createElement(PlayButton, null, /*#__PURE__*/ react.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 68 48",
        width: "100%"
    }, /*#__PURE__*/ react.createElement("path", {
        className: "yt-btn-bg",
        d: "M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z",
        fill: "#f00"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M 45,24 27,14 27,34",
        fill: "#fff"
    })))));
};
/* harmony default export */ var youtube = (/*#__PURE__*/(0,react.memo)(YoutubeLoader));

;// CONCATENATED MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/components/partner-video-modal/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    height: 100%;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  height: 100%;\n\n  div {\n    background-color: ",
        ";\n    background-repeat: no-repeat;\n    background-position-x: center;\n    background-size: auto 100%;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledModal = (0,styled_components_browser_esm["default"])(modal_v2/* default */.Z).withConfig({
    displayName: "StyledModal",
    componentId: "sc-0-0"
})(styles_templateObject());
var StyledModalBody = (0,styled_components_browser_esm["default"])(modal/* ModalBody */.fe).withConfig({
    displayName: "StyledModalBody",
    componentId: "sc-0-1"
})(styles_templateObject1());
var StyledYoutubeLoader = (0,styled_components_browser_esm["default"])(youtube).withConfig({
    displayName: "StyledYoutubeLoader",
    componentId: "sc-0-2"
})(styles_templateObject2(), function(p) {
    return p.theme.colors.base900;
});

;// CONCATENATED MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/components/partner-video-modal/index.tsx



var PartnerVideoModal = function(props) {
    var closeModal = props.closeModal, isOpen = props.isOpen, imageUrl = props.imageUrl, title = props.title, videoId = props.videoId;
    return /*#__PURE__*/ react.createElement(StyledModal, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        size: modal/* ModalSizeEnum.FULL */.E$.FULL,
        title: title || ""
    }, /*#__PURE__*/ react.createElement(StyledModalBody, null, /*#__PURE__*/ react.createElement(StyledYoutubeLoader, {
        thumbnail: imageUrl,
        id: videoId
    })));
};


/***/ }),

/***/ 23013:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ CarouselProducts)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var _components_cards_carousel_carousel_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74650);
/* harmony import */ var src_components_cards_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49601);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57735);
/* harmony import */ var _actions_product__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69140);
/* harmony import */ var src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83104);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99467);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57048);









function getInternalNavigationScope(carouselType) {
    switch(carouselType){
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.OTHER_POPULAR_PRODUCTS */ .c.OTHER_POPULAR_PRODUCTS:
            return src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.OTHER_PRODUCTS_PRODUCT_CARD */ .U.OTHER_PRODUCTS_PRODUCT_CARD;
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.OTHERS_VISITED */ .c.OTHERS_VISITED:
            return src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.OTHER_VISITED_PRODUCTS_PRODUCT_CARD */ .U.OTHER_VISITED_PRODUCTS_PRODUCT_CARD;
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.TRENDING_PRODUCTS */ .c.TRENDING_PRODUCTS:
            return src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.TRENDING_PRODUCTS */ .U.TRENDING_PRODUCTS;
        default:
            break;
    }
    return src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.TRENDING_PRODUCTS */ .U.TRENDING_PRODUCTS;
}
function getNavigationAction(carouselType) {
    switch(carouselType){
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.OTHERS_VISITED */ .c.OTHERS_VISITED:
            return src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__/* .OTHERS_ALSO_VISITED_PRODUCT_CLICK */ .dL;
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.OTHER_POPULAR_PRODUCTS */ .c.OTHER_POPULAR_PRODUCTS:
            return src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__/* .OTHER_POPULAR_PRODUCT_CLICK */ .IT;
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.TRENDING_PRODUCTS */ .c.TRENDING_PRODUCTS:
            return src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__/* .TRENDING_PRODUCT_CLICK */ .fT;
        default:
            break;
    }
    return src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__/* .TRENDING_PRODUCT_CLICK */ .fT;
}
var CarouselProducts = function(param) {
    var carouselType = param.carouselType, _contextId = param.contextId, contextId = _contextId === void 0 ? _constants__WEBPACK_IMPORTED_MODULE_7__/* .PRODUCT_CONTEXT_ID */ .S : _contextId, products = param.products, _title = param.title, title = _title === void 0 ? "" : _title, link = param.link;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var handleProductClick = function(param) {
        var index = param.index, page = param.link;
        dispatch((0,_actions_product__WEBPACK_IMPORTED_MODULE_5__/* .productNavigation */ .$0)(getNavigationAction(carouselType), index + 1));
        (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
            scope: getInternalNavigationScope(carouselType),
            nextPage: page,
            index: index
        });
    };
    if (!(products === null || products === void 0 ? void 0 : products.length)) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_cards_carousel_carousel_context__WEBPACK_IMPORTED_MODULE_2__/* .CarouselContextContainer */ .L, {
        items: products,
        negativeMargin: true,
        onCardClick: handleProductClick,
        title: title,
        linkTitle: link === null || link === void 0 ? void 0 : link.title,
        linkPath: link === null || link === void 0 ? void 0 : link.path
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_cards_carousel__WEBPACK_IMPORTED_MODULE_3__/* .CardsCarousel */ .T, null));
};


/***/ }),

/***/ 57048:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ CarouselTypeEnum)
/* harmony export */ });
var CarouselTypeEnum;
(function(CarouselTypeEnum) {
    CarouselTypeEnum["OTHERS_VISITED"] = "others-visited";
    CarouselTypeEnum["SIMILAR_PRODUCTS"] = "similar-products";
    CarouselTypeEnum["TRENDING_PRODUCTS"] = "trending-products";
    CarouselTypeEnum["OTHER_POPULAR_PRODUCTS"] = "other-popular-products";
    CarouselTypeEnum["PERSONALIZED"] = "personalized";
})(CarouselTypeEnum || (CarouselTypeEnum = {}));


/***/ }),

/***/ 603:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ mapCarouselProducts)
/* harmony export */ });
var mapCarouselProducts = function(items) {
    if (!items) return null;
    var _pathName;
    return items.filter(function(tp) {
        return Boolean(tp);
    }).filter(function(tp) {
        return Boolean(tp.pathName);
    }).map(function(product) {
        return {
            id: Number(product.id),
            name: String(product.name),
            pathName: (_pathName = product.pathName) !== null && _pathName !== void 0 ? _pathName : "",
            media: {
                first: product.imageUrl,
                count: 1
            },
            priceSummary: {
                regular: product.price
            },
            classicFullPath: String(product.url),
            userReviewSummary: product.userReviewSummary,
            aggregatedRating: product.aggregatedRating,
            isExpertTopRated: product.isExpertTopRated
        };
    });
};


/***/ }),

/***/ 84333:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ CarrierLogo)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);


var CarrierLogo = function(name) {
    var inStorePickup = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var market = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).market;
    var imgWrapper = function(imgName) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
            alt: imgName,
            src: "".concat(market.cdn, "/g/rfe/carriers/").concat(imgName, ".svg")
        });
    };
    if (inStorePickup) {
        return imgWrapper("instore-pickup");
    }
    // Note: the carrier logos below should be the same as in Business Center
    switch(name.toLocaleLowerCase()){
        case "airmee":
            return imgWrapper("airmee");
        case "best":
            return imgWrapper("best");
        case "bring":
            return imgWrapper("bring");
        case "budbee":
            return imgWrapper("budbee");
        case "city mail":
            return imgWrapper("city_mail");
        case "dachser":
            return imgWrapper("dachser");
        case "db schenker":
            return imgWrapper("db_schenker");
        case "dhl":
            return imgWrapper("dhl");
        case "dooris":
            return imgWrapper("dooris");
        case "early bird":
            return imgWrapper("early_bird");
        case "fedex":
            return imgWrapper("fedex");
        case "instabox":
            return imgWrapper("instabox");
        case "jetpak":
            return imgWrapper("jetpak");
        case "postnord":
            return imgWrapper("postnord");
        case "ups":
            return imgWrapper("ups");
        case "gls":
            return imgWrapper("gls");
        default:
            return imgWrapper("unknown-provider");
    }
};


/***/ }),

/***/ 65974:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ MobileContractSortOptionTypeEnum)
/* harmony export */ });
var MobileContractSortOptionTypeEnum;
(function(MobileContractSortOptionTypeEnum) {
    MobileContractSortOptionTypeEnum["MONTHLY_PRICE"] = "MONTHLY_PRICE";
    MobileContractSortOptionTypeEnum["TOTAL_PRICE"] = "TOTAL_PRICE";
})(MobileContractSortOptionTypeEnum || (MobileContractSortOptionTypeEnum = {}));


/***/ }),

/***/ 8836:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ useOfferListFilterContext),
/* harmony export */   "p": () => (/* binding */ OfferListFilterContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_areas_product_utils_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14792);
/* harmony import */ var src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15301);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25349);
/* harmony import */ var _price_list_offer_list_filters_shipping_filters_delivery_methods_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64701);
/* harmony import */ var src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34057);
/* eslint-disable no-param-reassign */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var initialContextValue = {
    getInitialFilters: function() {
        return [];
    },
    getActiveFilters: function() {
        return [];
    },
    getAdditiveFilters: function() {
        return [];
    },
    getFilter: function() {
        return undefined;
    },
    getTranslatedLabel: function() {
        return "";
    },
    getFilterByPlacement: function() {
        return [];
    },
    getPriceDisplay: function() {
        return src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .PriceDisplayEnum.PRICE */ .wB.PRICE;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleFilter: function() {},
    updateMultipleFilters: function() {
        return undefined;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setFilterSelection: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    resetFilters: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    resetFiltersByPlacement: function() {},
    filtersToggledOnByUser: function() {
        return [];
    }
};
var OfferListFilterContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialContextValue);
var useOfferListFilterContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(OfferListFilterContext);
};
var OfferListFilterContextContainer = function(param) {
    var children = param.children;
    var ref, ref1;
    var ref2 = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_3__/* .useAppContext */ .bp)(), market = ref2.market, t = ref2.t;
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,src_areas_product_utils_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__/* .getFiltersConfig */ .I)()), 2), filters = ref3[0], setFilters = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        initFilters();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var setDefaultHiddenFilters = function(filtersList, type) {
        return filtersList.map(function(filter) {
            var updatedFilter = _objectSpread({}, filter);
            if (!type.includes(filter.type)) {
                updatedFilter.hidden = true;
            }
            return updatedFilter;
        });
    };
    var initFilters = function() {
        var ref, ref1, ref2;
        var initialFilters = (0,src_areas_product_utils_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__/* .getFiltersConfig */ .I)();
        var ref3;
        var hiddenFilters = (ref3 = (ref = market.offerList) === null || ref === void 0 ? void 0 : (ref1 = ref.filters) === null || ref1 === void 0 ? void 0 : ref1.hiddenFilters) !== null && ref3 !== void 0 ? ref3 : [];
        var updatedFilters = setDefaultHiddenFilters(initialFilters, hiddenFilters);
        var searchParams = new URLSearchParams(window.location.search);
        var filtersFromQuery = ((ref2 = searchParams.get("filters")) === null || ref2 === void 0 ? void 0 : ref2.split(",")) || [];
        var filtersFromQueryString = updatedFilters.map(function(filter) {
            var isInQueryString = filtersFromQuery.includes(filter.type);
            return _objectSpreadProps(_objectSpread({}, filter), {
                active: isInQueryString || filter.active
            });
        });
        setFilters(filtersFromQueryString);
    };
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var getInitialFilters = function() {
            return (0,src_areas_product_utils_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__/* .getFiltersConfig */ .I)().filter(function(filter) {
                return filter.active;
            });
        };
        var getActiveFilters = function() {
            return filters.filter(function(filter) {
                return filter.active;
            });
        };
        var getAdditiveFilters = function() {
            return filters.filter(function(filter) {
                return filter.additive;
            });
        };
        var getFilter = function(filterType) {
            return filters.find(function(filter) {
                return filter.type === filterType;
            });
        };
        var getFilterByPlacement = function(placement) {
            return filters.filter(function(filter) {
                return filter.placement.includes(placement);
            });
        };
        var getPriceDisplay = function() {
            var ref;
            return ((ref = getFilter(src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .FilterType.PRICES_INC_SHIPPING */ .vA.PRICES_INC_SHIPPING)) === null || ref === void 0 ? void 0 : ref.active) ? src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */ .wB.PRICE_INCLUDES_SHIPPING : src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .PriceDisplayEnum.PRICE */ .wB.PRICE;
        };
        var getTranslatedLabel = function(type) {
            var filter = getFilter(type);
            var hasSelections = (filter === null || filter === void 0 ? void 0 : filter.selection) && (filter === null || filter === void 0 ? void 0 : filter.selection.length) > 0;
            var newPrefix = (filter === null || filter === void 0 ? void 0 : filter.translationPrefix) || "product";
            var key;
            if (filter === null || filter === void 0 ? void 0 : filter.label) {
                key = filter === null || filter === void 0 ? void 0 : filter.label;
            }
            if ((filter === null || filter === void 0 ? void 0 : filter.type) === src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .FilterType.DELIVERY_METHOD */ .vA.DELIVERY_METHOD && hasSelections) {
                var deliveryOption = (0,_price_list_offer_list_filters_shipping_filters_delivery_methods_utils__WEBPACK_IMPORTED_MODULE_4__/* .getDeliveryMethodsConfig */ .m)().find(function(option) {
                    return option.type === filter.selection[0];
                });
                key = deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.translationString;
            }
            if (key) {
                // @ts-expect-error -- Typed too loosely
                return t(newPrefix, key);
            }
            if (hasSelections) {
                return filter.selection.join(", ");
            }
            return "";
        };
        var updateMultipleFilters = function(newFilters) {
            var updatedFilters = filters.map(function(filter) {
                var replacedFilter = filter;
                newFilters.forEach(function(newFilter) {
                    if (newFilter.type === filter.type) {
                        replacedFilter = newFilter;
                    }
                });
                return replacedFilter;
            });
            setFilters(updatedFilters);
        };
        var setFilterSelection = function(filterType, selection, resetCarriers) {
            var updatedFilters = filters.map(function(filter) {
                if (resetCarriers && filter.type === src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .FilterType.CARRIERS */ .vA.CARRIERS) {
                    return _objectSpreadProps(_objectSpread({}, filter), {
                        selection: [],
                        active: false
                    });
                }
                if (filterType === filter.type) {
                    return _objectSpreadProps(_objectSpread({}, filter), {
                        selection: selection,
                        active: Boolean(selection === null || selection === void 0 ? void 0 : selection.length)
                    });
                }
                return filter;
            });
            setFilters(updatedFilters);
            var trackFilterParams = {
                scope: src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .PageScope.PRODUCT */ .VN.PRODUCT,
                property: filterType === src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .FilterType.CARRIERS */ .vA.CARRIERS ? "Carriers" : getTranslatedLabel(filterType),
                value: filterType,
                layout: "quick-filter",
                type: "list"
            };
            if (selection.length) {
                (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterSelectEvent */ .f9)(_objectSpread({
                    translatedValue: selection[0]
                }, trackFilterParams));
            } else {
                (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterRemoveEvent */ .YD)(_objectSpread({
                    translatedValue: "all"
                }, trackFilterParams));
            }
        };
        var toggleFilter = function(filterType) {
            var filter = filters.find(function(f) {
                return f.type === filterType;
            });
            var newVal = !(filter === null || filter === void 0 ? void 0 : filter.active);
            var trackingVal = (filter === null || filter === void 0 ? void 0 : filter.additive) ? !newVal : newVal;
            var clearableFilters = filters;
            if (filter.clearOtherFiltersOnSelect && !filter.active) {
                var ref, ref1;
                var initialFilters = (0,src_areas_product_utils_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__/* .getFiltersConfig */ .I)();
                var ref2;
                var hiddenFilters = (ref2 = (ref = market.offerList) === null || ref === void 0 ? void 0 : (ref1 = ref.filters) === null || ref1 === void 0 ? void 0 : ref1.hiddenFilters) !== null && ref2 !== void 0 ? ref2 : [];
                clearableFilters = setDefaultHiddenFilters(initialFilters, hiddenFilters);
            }
            var updatedFilters = clearableFilters.map(function(f) {
                if (filterType === f.type) {
                    return _objectSpreadProps(_objectSpread({}, f), {
                        active: newVal
                    });
                }
                return f;
            });
            setFilters(updatedFilters);
            var trackFilterParams = {
                value: filterType,
                scope: src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .PageScope.PRODUCT */ .VN.PRODUCT,
                property: getTranslatedLabel(filter === null || filter === void 0 ? void 0 : filter.type),
                layout: "quick-filter",
                type: "boolean",
                translatedValue: trackingVal.toString()
            };
            if (newVal) {
                (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterSelectEvent */ .f9)(trackFilterParams);
            } else {
                (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterRemoveEvent */ .YD)(trackFilterParams);
            }
        };
        var resetFiltersByPlacement = function(filterPlacement) {
            var updatedFilters = filters.map(function(filter) {
                if (filter.placement.includes(filterPlacement)) {
                    var activeState = false;
                    if (filter.additive) {
                        activeState = true;
                    }
                    return _objectSpreadProps(_objectSpread({}, filter), {
                        active: activeState,
                        selection: []
                    });
                }
                return filter;
            });
            setFilters(updatedFilters);
        };
        var resetFilters = function() {
            var ref, ref1;
            var initialFilters = (0,src_areas_product_utils_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__/* .getFiltersConfig */ .I)();
            var ref2;
            var hiddenFilters = (ref2 = (ref = market.offerList) === null || ref === void 0 ? void 0 : (ref1 = ref.filters) === null || ref1 === void 0 ? void 0 : ref1.hiddenFilters) !== null && ref2 !== void 0 ? ref2 : [];
            var updatedFilters = setDefaultHiddenFilters(initialFilters, hiddenFilters);
            setFilters(updatedFilters);
        };
        var filtersToggledOnByUser = function() {
            var appliedNormalFilters = filters.filter(function(f) {
                return !f.additive && f.active;
            }).filter(function(f) {
                var ref, ref1;
                return !f.selection || ((ref = f.selection) === null || ref === void 0 ? void 0 : ref.toString()) !== ((ref1 = f.initialSelection) === null || ref1 === void 0 ? void 0 : ref1.toString());
            });
            var appliedAdditiveFilters = getAdditiveFilters().filter(function(f) {
                return f.additive && !f.active;
            });
            return _toConsumableArray(appliedNormalFilters).concat(_toConsumableArray(appliedAdditiveFilters));
        };
        return {
            getInitialFilters: getInitialFilters,
            getActiveFilters: getActiveFilters,
            getAdditiveFilters: getAdditiveFilters,
            getFilter: getFilter,
            getTranslatedLabel: getTranslatedLabel,
            getFilterByPlacement: getFilterByPlacement,
            getPriceDisplay: getPriceDisplay,
            toggleFilter: toggleFilter,
            updateMultipleFilters: updateMultipleFilters,
            setFilterSelection: setFilterSelection,
            resetFilters: resetFilters,
            resetFiltersByPlacement: resetFiltersByPlacement,
            filtersToggledOnByUser: filtersToggledOnByUser
        };
    }, [
        filters,
        (ref = market.offerList) === null || ref === void 0 ? void 0 : (ref1 = ref.filters) === null || ref1 === void 0 ? void 0 : ref1.hiddenFilters,
        t
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OfferListFilterContext.Provider, {
        value: contextValue
    }, children);
};


/***/ }),

/***/ 18126:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ InfoMessage)
/* harmony export */ });
/* harmony import */ var _prisjakt_ui_icon_error_outlined__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(499);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21541);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75408);




var InfoMessage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .MessageWrapper */ .e5, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_prisjakt_ui_icon_error_outlined__WEBPACK_IMPORTED_MODULE_0__/* .IconErrorOutlined */ .a, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .MessageGroup */ .dm, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Message */ .v0, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__.BodySmallText, {
        emphasis: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__.FontEmphasis.MEDIUM
    }, message.text), message.link || null)));
};


/***/ }),

/***/ 75408:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dm": () => (/* binding */ MessageGroup),
/* harmony export */   "e5": () => (/* binding */ MessageWrapper),
/* harmony export */   "iE": () => (/* binding */ StyledModalBody),
/* harmony export */   "v0": () => (/* binding */ Message)
/* harmony export */ });
/* unused harmony export StyledLink */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24774);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33561);
/* harmony import */ var _prisjakt_ui_clickable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42007);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51676);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n  flex-direction: row;\n  margin-bottom: ",
        ";\n  gap: ",
        ";\n\n  > svg {\n    width: 20px;\n    height: 20px;\n\n    > path {\n      fill: rgba(0, 22, 36, 0.72);\n    }\n  }\n\n  > img {\n    max-height: 56px;\n    max-width: 56px;\n    align-self: center;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    align-items: flex-start;\n    flex-direction: column;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n  flex-grow: 1;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: column;\n    align-items: baseline;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n\n  > a {\n    text-decoration: underline;\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  > h4 {\n    margin: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        " 0;\n  text-decoration: underline;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






var MessageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__.Card).withConfig({
    displayName: "MessageWrapper",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return !p.$elevated && "border: 1px solid ".concat(_prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_1__.base200, ";");
}, _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_1__.informative100, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.$elevated && "box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 1px 4px rgba(0, 0, 0, 0.12);";
});
var MessageGroup = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MessageGroup",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject1()));
var Message = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Message",
    componentId: "sc-0-2"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_1__.maybeBlue700, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject3()));
var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_clickable__WEBPACK_IMPORTED_MODULE_4__.Clickable).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-3"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var StyledModalBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_5__/* .ModalBody */ .fe).withConfig({
    displayName: "StyledModalBody",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), props.$noPadding && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6()));
});


/***/ }),

/***/ 79799:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": () => (/* binding */ AllFiltersLoader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var AllFilters = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-page-filters";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-page-filters */ 283).then(__webpack_require__.bind(__webpack_require__, 98584));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(98584);
        }
        return eval("require.resolve")("./all-filters");
    }
});
var AllFiltersLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AllFilters, _extends({}, props));
};


/***/ }),

/***/ 64701:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": () => (/* binding */ getTranslation),
/* harmony export */   "m": () => (/* binding */ getDeliveryMethodsConfig)
/* harmony export */ });
var getDeliveryMethodsConfig = function() {
    return [
        {
            translationDomain: "product",
            translationString: "variants.all",
            type: null
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.home-delivery",
            type: "HOME"
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.mailbox",
            type: "MAILBOX"
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.package-locker",
            type: "PACKAGE_LOCKER"
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.service-point",
            type: "SERVICE_POINT"
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.pickup-instore",
            type: "INSTORE_PICKUP"
        }
    ];
};
var getTranslation = function(t, type) {
    var deliveryMethodsConfig = getDeliveryMethodsConfig();
    var config = deliveryMethodsConfig.find(function(c) {
        return c.type === type;
    });
    if (!config) {
        return null;
    }
    // @ts-expect-error -- Typed too loosely
    return t(config.translationDomain, config.translationString);
};


/***/ }),

/***/ 23423:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* binding */ ShippingFilters)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(8466);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(8836);
// EXTERNAL MODULE: ./src/areas/product/utils/price-list/types.ts
var types = __webpack_require__(34057);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/utils.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var createNewSelection = function(val, variantSelection) {
    if (!val) {
        return [];
    }
    return variantSelection.includes(val) ? variantSelection.filter(function(v) {
        return v !== val;
    }) : _toConsumableArray(variantSelection).concat([
        val
    ]);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./src/areas/product/components/carrier-logos/carrier-logos.tsx
var carrier_logos = __webpack_require__(84333);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 62px;\n  padding: 1px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  > img {\n    height: 20px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var GridWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var GridCell = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridCell",
    componentId: "sc-0-1"
})(_templateObject1());
var CarrierLogoWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CarrierLogoWrapper",
    componentId: "sc-0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/selection-button.tsx







var CarrierSelectionButton = function(props) {
    var val = props.val, title = props.title, handleSelection = props.handleSelection, disabled = props.disabled;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var filter = getFilter(types/* FilterType.CARRIERS */.vA.CARRIERS);
    var currentSelection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : null;
    var isSelected = Boolean(val && (currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.includes(val)) || !val && !currentSelection);
    return /*#__PURE__*/ react.createElement(ui_button.Button, {
        onClick: function() {
            return handleSelection(val);
        },
        selectable: true,
        selected: isSelected,
        fullWidth: true,
        type: ui_button.ButtonType.OUTLINED,
        elevation: ui_button.ButtonElevation.NONE,
        disabled: disabled === true
    }, /*#__PURE__*/ react.createElement(CarrierLogoWrapper, null, val && (0,carrier_logos/* CarrierLogo */.p)(title)), /*#__PURE__*/ react.createElement(ui_button.ButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, title));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/carrier-buttons-grid.tsx






var CarrieButtonsGrid = function(props) {
    var aggregatedShippingInfo = props.aggregatedShippingInfo, handleSelection = props.handleSelection;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var sortedCarriers = aggregatedShippingInfo.allCarriers.sort(function(a, b) {
        return a.localeCompare(b);
    });
    var isDisabled = function(carrier) {
        var ref;
        var filter = getFilter(types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD);
        if (!(filter === null || filter === void 0 ? void 0 : filter.active) || !((ref = filter.selection) === null || ref === void 0 ? void 0 : ref.length)) {
            return false;
        }
        return !aggregatedShippingInfo.deliveryMethods.find(function(item) {
            return item.type === filter.selection[0] && item.carriers.includes(carrier);
        });
    };
    return /*#__PURE__*/ react.createElement(GridWrapper, null, /*#__PURE__*/ react.createElement(GridCell, null, /*#__PURE__*/ react.createElement(CarrierSelectionButton, {
        handleSelection: handleSelection,
        title: t("product", "variants.all"),
        val: null
    })), sortedCarriers.map(function(carrier) {
        return /*#__PURE__*/ react.createElement(GridCell, {
            key: carrier
        }, /*#__PURE__*/ react.createElement(CarrierSelectionButton, {
            handleSelection: handleSelection,
            title: carrier,
            val: carrier,
            disabled: isDisabled(carrier)
        }));
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/index.tsx





var FILTER_DEF = types/* FilterType.CARRIERS */.vA.CARRIERS;
var CarrierFilters = function(props) {
    var aggregatedShippingInfo = props.aggregatedShippingInfo;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilter = ref.getFilter, setFilterSelection = ref.setFilterSelection, toggleFilter = ref.toggleFilter;
    var filter = getFilter(FILTER_DEF);
    var currentSelection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : null;
    var handleSelection = function(val) {
        var newSelection = createNewSelection(val, (currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.length) ? currentSelection : []);
        if ((filter === null || filter === void 0 ? void 0 : filter.active) && newSelection.length === 0) {
            toggleFilter(FILTER_DEF);
        }
        setFilterSelection(FILTER_DEF, newSelection);
    };
    return /*#__PURE__*/ react.createElement(CarrieButtonsGrid, {
        handleSelection: handleSelection,
        aggregatedShippingInfo: aggregatedShippingInfo
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/radiobutton/index.js
var radiobutton = __webpack_require__(94269);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/utils.ts
var utils = __webpack_require__(64701);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/style.ts
function style_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function style_templateObject() {
    var data = style_taggedTemplateLiteral([
        "\n  display: grid;\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(style_templateObject());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/index.tsx
function delivery_methods_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function delivery_methods_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return delivery_methods_arrayLikeToArray(arr);
}
function delivery_methods_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function delivery_methods_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || delivery_methods_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function delivery_methods_toConsumableArray(arr) {
    return delivery_methods_arrayWithoutHoles(arr) || delivery_methods_iterableToArray(arr) || delivery_methods_unsupportedIterableToArray(arr) || delivery_methods_nonIterableSpread();
}
function delivery_methods_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return delivery_methods_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return delivery_methods_arrayLikeToArray(o, minLen);
}







var DeliveryMetodFilters = function(props) {
    var items = props.items;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilter = ref.getFilter, setFilterSelection = ref.setFilterSelection;
    var filter = getFilter(types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD);
    var currentSelection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : null;
    var ref1 = _slicedToArray((0,react.useState)((currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.length) ? currentSelection[0] : null), 2), selectedValue = ref1[0], setSelectedValue = ref1[1];
    var handleSelection = function(val) {
        var selection = [];
        if (val) {
            selection = [
                val
            ];
        }
        setSelectedValue(val);
        setFilterSelection(types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD, selection, true);
    };
    var allItem = {
        type: null,
        offersCount: 100,
        carriers: []
    };
    var radioButtons = [
        allItem
    ].concat(delivery_methods_toConsumableArray(items));
    return /*#__PURE__*/ react.createElement(Wrapper, null, radioButtons.map(function(button) {
        var id = button.type ? button.type : "all";
        var translation = (0,utils/* getTranslation */.i)(t, button.type);
        if (button.offersCount === 0 || !translation) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
            key: button.type,
            id: id,
            name: "deliveryOption",
            onClickHandler: handleSelection,
            selectedValue: selectedValue,
            value: button.type,
            text: translation
        });
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/hooks/use-offer-shipping-info.ts
function use_offer_shipping_info_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function use_offer_shipping_info_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return use_offer_shipping_info_arrayLikeToArray(arr);
}
function use_offer_shipping_info_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function use_offer_shipping_info_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function use_offer_shipping_info_toConsumableArray(arr) {
    return use_offer_shipping_info_arrayWithoutHoles(arr) || use_offer_shipping_info_iterableToArray(arr) || use_offer_shipping_info_unsupportedIterableToArray(arr) || use_offer_shipping_info_nonIterableSpread();
}
function use_offer_shipping_info_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return use_offer_shipping_info_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return use_offer_shipping_info_arrayLikeToArray(o, minLen);
}
var useOfferShippingInfo = function(offers, deliveryMethodsConfig) {
    var deliveryMethods = [];
    var allCarriers = new Set();
    deliveryMethodsConfig.forEach(function(config) {
        var carriers = new Set();
        var offersCount = 0;
        if (config.type) {
            offers.forEach(function(offer) {
                var ref;
                var hasDeliveryMethod = (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
                    return config.type === node.deliveryMethod;
                });
                if (hasDeliveryMethod) {
                    var ref1;
                    offersCount += 1;
                    (ref1 = offer.shipping) === null || ref1 === void 0 ? void 0 : ref1.nodes.forEach(function(node) {
                        if (config.type === node.deliveryMethod && node.carrier) {
                            carriers.add(node.carrier);
                        }
                    });
                }
            });
            deliveryMethods.push({
                type: config.type,
                offersCount: offersCount,
                carriers: use_offer_shipping_info_toConsumableArray(carriers)
            });
        }
    });
    offers.forEach(function(offer) {
        var ref;
        (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.forEach(function(node) {
            if (node.carrier) {
                allCarriers.add(node.carrier);
            }
        });
    });
    return {
        deliveryMethods: deliveryMethods,
        allCarriers: use_offer_shipping_info_toConsumableArray(allCarriers)
    };
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/styles.ts
var styles = __webpack_require__(54981);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/index.tsx









var MIN_OFFERS_LIMIT = 1;
var ShippingFilters = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var allOffersWithActiveAdditives = (0,product_context/* useProductContext */.$h)().allOffersWithActiveAdditives;
    var aggregatedShippingInfo = useOfferShippingInfo(allOffersWithActiveAdditives, (0,utils/* getDeliveryMethodsConfig */.m)());
    var offersWithShippingCount = allOffersWithActiveAdditives.filter(function(offer) {
        var ref;
        return (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
            return Boolean(node.deliveryMethod);
        });
    }, 0);
    if (offersWithShippingCount.length < MIN_OFFERS_LIMIT) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* FilterRow */.TH, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("store", "store.delivery-options")), /*#__PURE__*/ react.createElement(DeliveryMetodFilters, {
        items: aggregatedShippingInfo.deliveryMethods
    })), aggregatedShippingInfo.allCarriers.length > 0 && /*#__PURE__*/ react.createElement(styles/* FilterRow */.TH, null, /*#__PURE__*/ react.createElement(CarrierFilters, {
        aggregatedShippingInfo: aggregatedShippingInfo
    })));
};


/***/ }),

/***/ 54981:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FJ": () => (/* binding */ FilterOptionWrapper),
/* harmony export */   "HA": () => (/* binding */ CheckboxClickarea),
/* harmony export */   "TH": () => (/* binding */ FilterRow),
/* harmony export */   "g6": () => (/* binding */ FiltersDropDown),
/* harmony export */   "gC": () => (/* binding */ FilterPanelWrapper),
/* harmony export */   "hR": () => (/* binding */ FilterPanel),
/* harmony export */   "kP": () => (/* binding */ ButtonBadge),
/* harmony export */   "nv": () => (/* binding */ MobileWrapper),
/* harmony export */   "qj": () => (/* binding */ ShippingFilterTextButton),
/* harmony export */   "rO": () => (/* binding */ FilterBlocker)
/* harmony export */ });
/* unused harmony export ScrollingFiltersListWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43220);
/* harmony import */ var _prisjakt_ui_floater__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70413);
/* harmony import */ var _prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72321);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25670);
/* harmony import */ var src_ui_zindex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92873);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    min-width: ",
        "px;\n    max-width: ",
        "px;\n    min-height: ",
        "px;\n    max-height: ",
        "px;\n    overflow-y: auto;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  padding: ",
        ";\n  border-radius: 8px;\n  width: 100%;\n  margin-bottom: ",
        ";\n  border: 1px solid ",
        ";\n  box-shadow: ",
        ";\n\n  display: grid;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: ",
        ";\n  transform: translate(0.5rem, 4.5em);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    grid-template-rows: auto;\n    grid-auto-flow: row;\n    grid-template-columns: 1fr;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  gap: ",
        ";\n  width: 100%;\n\n  grid-template-rows: auto;\n  grid-auto-flow: row;\n  grid-template-columns: 1fr;\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  :last-child {\n    padding-right: 20px;\n  }"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  column-gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  position: absolute;\n  top: -30%;\n  right: -",
        ";\n  width: 24px;\n  height: 24px;\n\n  > span {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    > li:last-child { padding-right: ",
        " }\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  list-style: none;\n  margin: 0;\n  gap: ",
        ";\n  padding-bottom: ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: ",
        " 0;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}







var DESKTOP_DIALOG = {
    MIN_WIDTH: 200,
    MAX_WIDTH: 320,
    MIN_HEIGHT: 130,
    MAX_HEIGHT: 356
};
var FilterPanelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterPanelWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.theme.bg.primary;
}, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing100, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing050, function(p) {
    return p.theme.lines.primary;
}, function(p) {
    return "0px 2px 8px 0px ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.colors.base800, 0.24));
}, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject(), DESKTOP_DIALOG.MIN_WIDTH, DESKTOP_DIALOG.MAX_WIDTH, DESKTOP_DIALOG.MIN_HEIGHT, DESKTOP_DIALOG.MAX_HEIGHT));
var FiltersDropDown = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_floater__WEBPACK_IMPORTED_MODULE_3__.Floater).withConfig({
    displayName: "FiltersDropDown",
    componentId: "sc-0-1"
})(_templateObject2(), src_ui_zindex__WEBPACK_IMPORTED_MODULE_6__/* .zindex.menu.offerlistFilters */ .Y.menu.offerlistFilters);
var FilterBlocker = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterBlocker",
    componentId: "sc-0-2"
})(_templateObject3(), src_ui_zindex__WEBPACK_IMPORTED_MODULE_6__/* .zindex.overlay */ .Y.overlay);
var FilterPanel = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterPanel",
    componentId: "sc-0-3"
})(_templateObject5(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject4()));
var FilterRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterRow",
    componentId: "sc-0-4"
})(_templateObject6(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing050);
var FilterOptionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterOptionWrapper",
    componentId: "sc-0-5"
})(_templateObject8(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject7()));
var CheckboxClickarea = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "CheckboxClickarea",
    componentId: "sc-0-6"
})(_templateObject9());
var ButtonBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_4__.Badge).withConfig({
    displayName: "ButtonBadge",
    componentId: "sc-0-7"
})(_templateObject10(), function(p) {
    return p.theme.colors.maybeBlue500;
}, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing075, function(p) {
    return p.theme.colors.base0;
});
var ScrollingFiltersListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({
    displayName: "ScrollingFiltersListWrapper",
    componentId: "sc-0-8"
})(_templateObject13(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing050, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject11()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject12(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing050));
var MobileWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MobileWrapper",
    componentId: "sc-0-9"
})(_templateObject14(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing150, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing100);
var ShippingFilterTextButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__.TextButton).withConfig({
    displayName: "ShippingFilterTextButton",
    componentId: "sc-0-10"
})(_templateObject15(), function(p) {
    return p.theme.colors.base900;
});


/***/ }),

/***/ 70204:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": () => (/* binding */ PriceRowContextContainer),
/* harmony export */   "m": () => (/* binding */ usePriceRowContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_filter_dropdown_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18557);
/* harmony import */ var _product_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8466);
/* harmony import */ var _price_row_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8114);
/* harmony import */ var _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60205);





var initialValue = {
    offer: {
        featured: false,
        authorizedDealer: false,
        authorizedDealerData: null,
        condition: _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_4__/* .ConditionEnum.NEW */ .M.NEW,
        isInternationalPrice: false,
        ourChoiceScore: 0,
        dealOffers: [],
        featuredOverride: _price_row_types__WEBPACK_IMPORTED_MODULE_3__/* .FeaturedStatusEnum.UNKNOWN */ .$x.UNKNOWN
    },
    product: _product_context__WEBPACK_IMPORTED_MODULE_2__/* .EmptyProduct */ .jG,
    showUsedOffers: false,
    collapseUnfeaturedFn: undefined,
    sorting: src_components_filter_dropdown_types__WEBPACK_IMPORTED_MODULE_1__/* .OptionTypeEnum.CHEAPEST_PRICE */ .M.CHEAPEST_PRICE,
    viewSize: _price_row_types__WEBPACK_IMPORTED_MODULE_3__/* .ViewSize.SMALL */ .du.SMALL
};
var PriceRowContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var usePriceRowContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PriceRowContext);
};
var PriceRowContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PriceRowContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 21217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": () => (/* binding */ ConditionTypeBadge)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/recycle/index.js
var recycle = __webpack_require__(894);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/condition-type-badge/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  justify-content: flex-end;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BadgeWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "BadgeWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/index.ts
var product_condition = __webpack_require__(7001);
// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/types.ts
var types = __webpack_require__(60205);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/condition-type-badge/index.tsx







var ConditionTypeBadge = function(props) {
    var condition = props.condition;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var label = (0,product_condition/* getConditionName */.v)(condition, t);
    if (condition === types/* ConditionEnum.NEW */.M.NEW) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(BadgeWrapper, null, /*#__PURE__*/ react.createElement(badge.Badge, {
        icon: recycle/* IconRecycle */.L,
        color: "GREEN",
        size: badge.BadgeSize.SMALL,
        text: label
    }));
};


/***/ }),

/***/ 97157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": () => (/* binding */ GoToStoreButton)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/types.ts
var types = __webpack_require__(8114);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/go-to-store-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  /* Small mobile resolutions, e.g. Galaxy Fold */\n  @media screen and (max-width: 280px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      width: 24px;\n      align-self: stretch;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var StyledButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), (props.$viewSize === types/* ViewSize.MINI */.du.MINI || props.$viewSize === types/* ViewSize.SMALL */.du.SMALL) && (0,styled_components_browser_esm.css)(_templateObject1()));
});
var StyledIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledIconWrapper",
    componentId: "sc-0-2"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/go-to-store-button/index.tsx







var GoToStoreButton = function(props) {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var viewSize = props.viewSize;
    var renderButton = function() {
        if (viewSize <= types/* ViewSize.SMALL */.du.SMALL) {
            return /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, {
                color: "maybeBlue500",
                size: 24
            });
        }
        return /*#__PURE__*/ react.createElement(StyledButton, {
            ariaLabel: t("product", "external-link.view-in-shop"),
            tabIndex: -1,
            $viewSize: viewSize
        }, viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("product", "external-link.view-in-shop")), /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null)));
    };
    return /*#__PURE__*/ react.createElement(StyledWrapper, {
        "data-test": "GoToStoreButton"
    }, renderButton());
};


/***/ }),

/***/ 74027:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Be": () => (/* binding */ StyledFlexVertical),
/* harmony export */   "D": () => (/* binding */ StyledProductName),
/* harmony export */   "Qp": () => (/* binding */ StyledFeaturedRow),
/* harmony export */   "Y": () => (/* binding */ StyledEndColumn),
/* harmony export */   "a2": () => (/* binding */ StyledProductNameWrapper),
/* harmony export */   "e5": () => (/* binding */ StyledMiddleColumnWithPadding),
/* harmony export */   "mj": () => (/* binding */ StyledMiniOfferRightContent),
/* harmony export */   "oJ": () => (/* binding */ StyledBadgeWrapper),
/* harmony export */   "po": () => (/* binding */ StyledFlexHorizontal),
/* harmony export */   "qk": () => (/* binding */ StyledMiddleColumnInner),
/* harmony export */   "ry": () => (/* binding */ StyledUnfeaturedRow)
/* harmony export */ });
/* unused harmony export StyledCollapseUnfeaturedBtn */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21541);
/* harmony import */ var _prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33561);
/* harmony import */ var _prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71551);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8114);
/* harmony import */ var _row_types_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33900);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &&:hover:after {\n        content: '';\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      &&:after {\n        box-shadow:\n          0 2px 6px 0 rgb(0, 0, 0, 0.1),\n          0 0 0 1px rgb(0, 0, 0, 0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 1 auto;\n    cursor: pointer;\n    overflow: visible;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      align-items: flex-start;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      padding-top: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    flex-shrink: 1;\n    height: 100%;\n    align-items: center;\n    max-width: 60%;\n    row-gap: ",
        ";\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    white-space: initial;\n    color: ",
        ";\n    display: inline;\n\n    line-height: 22px;\n\n    ",
        "\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      visibility: hidden;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-shrink: 0;\n    align-items: stretch;\n    height: 100%;\n    padding: ",
        ";\n    padding-left: 0;\n\n    ",
        "\n\n    ",
        "\n\n    /* Small mobile resolutions, e.g. Galaxy Fold */\n    @media screen and (max-width: 280px) {\n      padding-right: ",
        ";\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex: 2;\n    align-items: center;\n    cursor: default;\n    height: ",
        ";\n\n    &:target {\n      outline: ",
        " dotted 1px;\n      outline: -webkit-focus-ring-color auto 1px;\n    }\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n      right: ",
        ";\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n      right: ",
        ";\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    cursor: pointer;\n    position: absolute;\n    display: flex;\n    align-self: center;\n    right: 0;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  white-space: nowrap;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  gap: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 2px ",
        ";\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        " 0;\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0 ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: ",
        ";\n  justify-content: flex-end;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}







var StyledFeaturedRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__.CardActionArea).withConfig({
    displayName: "StyledFeaturedRow",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), props.$hasPromotion && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject()), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MINI */ .du.MINI && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1()));
});
var StyledProductNameWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledProductNameWrapper",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, props.$alignStart && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3()), props.$alignStart && props.$paddingTop && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
});
var StyledProductName = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.BodySmallText).withConfig({
    displayName: "StyledProductName",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), props.$featured ? props.theme.text.primary : props.theme.text.tertiary, props.$isAlternative && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6()));
});
var StyledEndColumn = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledEndColumn",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MEDIUM */ .du.MEDIUM && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.LARGE */ .du.LARGE && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, !props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject10()));
});
var StyledUnfeaturedRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].a.withConfig({
    displayName: "StyledUnfeaturedRow",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject12(), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MINI */ .du.MINI ? _row_types_styles__WEBPACK_IMPORTED_MODULE_6__/* .ROW_HEIGHT_MINI */ .$w : _row_types_styles__WEBPACK_IMPORTED_MODULE_6__/* .ROW_HEIGHT */ .dN, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderLightGray */ .O9.borderLightGray);
});
var StyledCollapseUnfeaturedBtn = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .Tooltip */ .u).withConfig({
    displayName: "StyledCollapseUnfeaturedBtn",
    componentId: "sc-0-5"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject15(), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MEDIUM */ .du.MEDIUM && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject13(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.LARGE */ .du.LARGE && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100));
});
var StyledFlexHorizontal = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledFlexHorizontal",
    componentId: "sc-0-6"
})(_templateObject16());
var StyledFlexVertical = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledFlexVertical",
    componentId: "sc-0-7"
})(_templateObject17());
var StyledBadgeWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(StyledFlexVertical).withConfig({
    displayName: "StyledBadgeWrapper",
    componentId: "sc-0-8"
})(_templateObject18(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var StyledMiddleColumnWithPadding = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(StyledFlexVertical).withConfig({
    displayName: "StyledMiddleColumnWithPadding",
    componentId: "sc-0-9"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject21(), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MINI */ .du.MINI && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.SMALL */ .du.SMALL && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject20(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
});
var StyledMiddleColumnInner = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(StyledFlexVertical).withConfig({
    displayName: "StyledMiddleColumnInner",
    componentId: "sc-0-10"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, props.$viewSize !== undefined && props.$viewSize >= _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MEDIUM */ .du.MEDIUM && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject22(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
});
var StyledMiniOfferRightContent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledMiniOfferRightContent",
    componentId: "sc-0-11"
})(_templateObject24(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 3694:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ ReportButton)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var ReportButton = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 32569));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(32569);
        }
        return eval("require.resolve")("./report-button");
    }
});


/***/ }),

/***/ 75675:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ ReportModal)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var ReportModal = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 21011));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(21011);
        }
        return eval("require.resolve")("./report-modal");
    }
});


/***/ }),

/***/ 82440:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": () => (/* binding */ PriceRow)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row-context.tsx
var price_row_context = __webpack_require__(70204);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/alternative-price-row-context.tsx

var initialValue = {
    alternativeOffer: undefined,
    alternativeContract: undefined
};
var AlternativePriceRowContext = /*#__PURE__*/ (0,react.createContext)(initialValue);
var useAlternativePriceRowContext = function() {
    return (0,react.useContext)(AlternativePriceRowContext);
};
var AlternativePriceRowContextContainer = function(props) {
    return /*#__PURE__*/ react.createElement(AlternativePriceRowContext.Provider, {
        value: props
    }, props.children);
};

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(7920);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(58425);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(89286);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/menu-kebab/index.js
var menu_kebab = __webpack_require__(77356);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/types.ts
var types = __webpack_require__(8114);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/expand-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  outline: none;\n\n  &.focus-visible {\n    outline: ",
        " dotted 1px;\n    outline: -webkit-focus-ring-color auto 1px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledExpandButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledExpandButton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.linkExternalHover;
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/expand-button/index.tsx









var ExpandButton = function(param) {
    var _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, onClick = param.onClick;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var viewSize = (0,price_row_context/* usePriceRowContext */.m)().viewSize;
    var title = t("product", "price.more-info");
    return /*#__PURE__*/ react.createElement(StyledExpandButton, {
        type: "button",
        "aria-label": title,
        onClick: onClick,
        title: title,
        "data-test": "ExpandButton"
    }, viewSize === types/* ViewSize.MINI */.du.MINI && /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        color: "base900",
        size: 20
    }), viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(menu_kebab/* IconMenuKebab */.Q, {
        color: "base900",
        size: 20
    }), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && expanded && /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, {
        color: "base900",
        size: 20
    }), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && !expanded && /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, {
        color: "base900",
        size: 20
    }));
};

// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(8466);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
// EXTERNAL MODULE: ./src/areas/product/utils/price-list/types.ts
var price_list_types = __webpack_require__(34057);
;// CONCATENATED MODULE: ./src/components/offer/price/price-display.ts

function getDisplayPrice(price, priceDisplay) {
    if (!price) {
        return null;
    }
    return priceDisplay === price_list_types/* PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */.wB.PRICE_INCLUDES_SHIPPING && price.inclShipping ? price.inclShipping || null : price.exclShipping || null;
}

// EXTERNAL MODULE: ./src/components/offer/price/utils.ts
var utils = __webpack_require__(8501);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/offer-price/price-data.ts


function getCompiledPriceData(price, offerPrice, priceDisplay, isFeatured) {
    if (!price) {
        return {
            label: null,
            mainPrice: null,
            secondaryPrice: null
        };
    }
    var isMemberPrice = getIsMemberPrice(price, offerPrice, isFeatured);
    var isOnSalePrice = getIsOnSalePrice(price, offerPrice, isFeatured);
    var secondaryPrice = getSecondaryPrice(offerPrice, priceDisplay, isOnSalePrice, isMemberPrice);
    return {
        mainPrice: getDisplayPrice(price, priceDisplay),
        secondaryPrice: secondaryPrice,
        isMemberPrice: isMemberPrice,
        isOnSalePrice: isOnSalePrice
    };
}
function getIsOnSalePrice(price, offerPrice, featured) {
    var ref, ref1;
    return featured && (offerPrice === null || offerPrice === void 0 ? void 0 : offerPrice.originalPrice) && pricesAreEqual(price, offerPrice) ? (offerPrice === null || offerPrice === void 0 ? void 0 : (ref = offerPrice.price) === null || ref === void 0 ? void 0 : ref.exclShipping) !== (offerPrice === null || offerPrice === void 0 ? void 0 : (ref1 = offerPrice.originalPrice) === null || ref1 === void 0 ? void 0 : ref1.exclShipping) : false;
}
function getIsMemberPrice(price, offerPrice, featured) {
    return featured && pricesAreEqual(price, offerPrice) ? Boolean(offerPrice === null || offerPrice === void 0 ? void 0 : offerPrice.memberPrice) : false;
}
function pricesAreEqual(price, offerPrice) {
    var ref;
    return (price === null || price === void 0 ? void 0 : price.exclShipping) === (offerPrice === null || offerPrice === void 0 ? void 0 : (ref = offerPrice.price) === null || ref === void 0 ? void 0 : ref.exclShipping);
}
function getSecondaryPrice(offerPrice, priceDisplay, isOnSalePrice, isMemberPrice) {
    return (offerPrice === null || offerPrice === void 0 ? void 0 : offerPrice.originalPrice) && (isOnSalePrice || isMemberPrice) ? getDisplayPrice(offerPrice.originalPrice, priceDisplay) : null;
}
function getonSalePriceLabel(offerPrice, locale, t) {
    var ref;
    if (offerPrice === null || offerPrice === void 0 ? void 0 : (ref = offerPrice.price) === null || ref === void 0 ? void 0 : ref.endDate) {
        return "".concat(t("campaigns", "campaign-card.sale-badge-end-date", {
            date: (0,utils/* parseUTCDate */.k)(offerPrice.price.endDate, locale)
        }));
    }
    return t("campaigns", "campaign-card.sale");
}

// EXTERNAL MODULE: ./src/components/badges/deals-badge/index.tsx + 1 modules
var deals_badge = __webpack_require__(48285);
// EXTERNAL MODULE: ./src/areas/product/components/badges/index.ts + 4 modules
var badges = __webpack_require__(68620);
// EXTERNAL MODULE: ./src/areas/product/utils/index.ts
var product_utils = __webpack_require__(852);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/deals-page/utils.ts
var deals_page_utils = __webpack_require__(4462);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/offer-price/utils.ts

var getExpectedPrice = function(dealInfo, filteredOffers) {
    var ref, ref1, ref2;
    // To calculate the offers expected price, we need to get the offer that the deals systems dealPercentage is based on (the originalDealOffer).
    // We're calculating the expected price based on that particular offers price and the dealPercentage.
    // The expectedPrice is always the same, no matter the deal price of an offer.
    var originalDealOfferId = (ref = dealInfo.offers[dealInfo.offers.length - 1]) === null || ref === void 0 ? void 0 : ref.shopOfferId;
    if (!originalDealOfferId) return null;
    var originalDealOffer = filteredOffers.find(function(offer) {
        return offer.shopOfferId === originalDealOfferId;
    });
    if (!(originalDealOffer === null || originalDealOffer === void 0 ? void 0 : (ref1 = originalDealOffer.price) === null || ref1 === void 0 ? void 0 : ref1.exclShipping)) return null;
    return (0,deals_page_utils/* getPreviousPrice */.L)(dealInfo.dealPercentage, (ref2 = originalDealOffer.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping);
};
var getDealPercentage = function(dealInfo, filteredOffers, offerPrice) {
    // Since a product can have multiple deal offers, and since there can be a delay between an updated offers price and the deals systems dealPercentage,
    // we are calculating each individual offers deal percentage so that we display the correct percentage based on the offer price.
    var expectedPrice = getExpectedPrice(dealInfo, filteredOffers);
    if (!expectedPrice) return null;
    var dealPercentage = Math.round((1 - offerPrice / expectedPrice) * 100);
    return dealPercentage;
};

// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/types.ts
var product_condition_types = __webpack_require__(60205);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/row-types/styles.ts
var styles = __webpack_require__(33900);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/offer-price/index.tsx















var OfferPriceLabel = function(props) {
    var container = props.container, offerPrice = props.offerPrice, priceDisplay = props.priceDisplay, selectedOffer = props.selectedOffer, shipping = props.shipping;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref1.offer, product = ref1.product;
    var ref2 = (0,product_context/* useProductContext */.$h)(), filteredOffers = ref2.offers.filteredOffers;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var isUsed = selectedOffer.condition !== product_condition_types/* ConditionEnum.NEW */.M.NEW;
    var featured = alternativeOffer ? (0,product_utils/* getIsFeatured */.ZF)(offer, alternativeOffer) : offer.featured;
    if (!selectedOffer.price) {
        return null;
    }
    var priceData = getCompiledPriceData(selectedOffer.price, offerPrice, priceDisplay, featured);
    var isOnSalePrice = priceData.isOnSalePrice, secondaryPrice = priceData.secondaryPrice, isMemberPrice = priceData.isMemberPrice;
    var showSalesPrice = isOnSalePrice && Boolean(secondaryPrice) && !isUsed && !isMemberPrice;
    var isDeal = offer.dealOffers.some(function(deal) {
        return deal.shopOfferId === selectedOffer.shopOfferId;
    });
    var getPriceLabel = function() {
        var ref;
        var shippingCost = (shipping === null || shipping === void 0 ? void 0 : shipping.shippingCost) || 0;
        var price = ((ref = selectedOffer.price) === null || ref === void 0 ? void 0 : ref.exclShipping) || 0;
        var cost = priceDisplay === price_list_types/* PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */.wB.PRICE_INCLUDES_SHIPPING ? price + shippingCost : price;
        return cost;
    };
    var fontColor = function() {
        return showSalesPrice ? variants.FontColor.NEGATIVE : undefined;
    };
    var renderSalesPriceBadge = function() {
        if (!showSalesPrice) {
            return null;
        }
        var localeStandard = market.localeStandard;
        var promotionLabel = getonSalePriceLabel(offerPrice, localeStandard, t);
        if (!promotionLabel) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(badge.Badge, {
            color: "RED",
            size: badge.BadgeSize.SMALL,
            text: promotionLabel
        });
    };
    var renderDealsBadge = function() {
        var ref, ref1, ref2;
        if (!product.dealInfo || !((ref = offer.price) === null || ref === void 0 ? void 0 : ref.exclShipping)) return null;
        var dealPercentage = getDealPercentage(product.dealInfo, filteredOffers, (ref1 = offer.price) === null || ref1 === void 0 ? void 0 : ref1.exclShipping);
        if (!dealPercentage) return null;
        return /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
            badgeType: deals_badge/* BadgeTypeEnum.ICON_BADGE */.Q.ICON_BADGE,
            "data-testid": "DealsBadge",
            priceDrop: dealPercentage,
            price: ((ref2 = offer.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping) || 0,
            popoverUniqueId: "product-page-offer"
        });
    };
    var renderMembershipBadge = function() {
        return /*#__PURE__*/ react.createElement(badges/* MembershipBadge */.fd, {
            isMembershipPrice: Boolean(isMemberPrice),
            alignRight: true
        });
    };
    return /*#__PURE__*/ react.createElement(styles/* StyledPriceArea */.mk, null, /*#__PURE__*/ react.createElement(styles/* StyledBadges */._d, null, renderSalesPriceBadge(), renderMembershipBadge()), /*#__PURE__*/ react.createElement(styles/* StyledPriceAndShipping */.DB, null, isDeal && renderDealsBadge(), secondaryPrice && !isUsed && /*#__PURE__*/ react.createElement(styles/* StyledSecondaryPrice */.ng, {
        memberPrice: isMemberPrice,
        value: secondaryPrice,
        emphasis: isMemberPrice ? variants.FontEmphasis.MEDIUM : variants.FontEmphasis.LOW,
        weight: variants.FontWeight.NORMAL,
        isSecondaryPrice: true
    }), /*#__PURE__*/ react.createElement(styles/* StyledPriceLabel */.Zb, {
        container: container,
        emphasis: featured ? variants.FontEmphasis.HIGH : variants.FontEmphasis.LOW,
        fontColor: fontColor(),
        value: getPriceLabel(),
        weight: variants.FontWeight.HEAVIEST
    })));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/go-to-store-button/index.tsx + 1 modules
var go_to_store_button = __webpack_require__(97157);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(8836);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/leaf/index.js
var leaf = __webpack_require__(13637);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/verified/index.js
var verified = __webpack_require__(52757);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/authorized-dealer/index.tsx









var AuthorizedDealerBadge = function(param) {
    var className = param.className, _noTooltip = param.noTooltip, noTooltip = _noTooltip === void 0 ? false : _noTooltip;
    var ref, ref1;
    var ref2 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref2.offer, product = ref2.product, viewSize = ref2.viewSize;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var shortDescription = (ref = offer.authorizedDealerData) === null || ref === void 0 ? void 0 : ref.authorizedDealersShortDescription;
    var longDescription = (ref1 = offer.authorizedDealerData) === null || ref1 === void 0 ? void 0 : ref1.authorizedDealersDescription;
    var getTooltipText = function() {
        var ref, ref1;
        if (longDescription) return longDescription;
        if (((ref = product.brand) === null || ref === void 0 ? void 0 : ref.name) && ((ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.name)) return t("store", "store.recommended-retailer-brand", {
            brand: product.brand.name,
            store: offer.store.name
        });
        return null;
    };
    var tooltipText = getTooltipText();
    var getBadgeText = function() {
        if (noTooltip) return tooltipText;
        if (shortDescription) return shortDescription;
        return t("store", "brand.recommended-retailer");
    };
    var content = /*#__PURE__*/ react.createElement(react.Fragment, null, viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(badge.Badge, {
        circular: true,
        color: "BLUE",
        icon: verified/* IconVerfied */.b
    }), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "BLUE",
        icon: verified/* IconVerfied */.b,
        text: /*#__PURE__*/ react.createElement(variants.BodySmallText, {
            weight: 600,
            style: {
                fontSize: 12
            }
        }, getBadgeText())
    }));
    return noTooltip || !tooltipText ? /*#__PURE__*/ react.createElement("div", {
        className: className
    }, content) : /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        className: className,
        title: tooltipText,
        placement: ui/* Direction.Left */.Nm.Left
    }, content);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./src/components/filter-dropdown/types.ts
var filter_dropdown_types = __webpack_require__(18557);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/types.ts
var StockStatusEnum;
(function(StockStatusEnum) {
    StockStatusEnum["IN_STOCK"] = "in_stock";
    StockStatusEnum["INCOMING"] = "incoming";
    StockStatusEnum["PREORDER"] = "in_stock_preorder";
    StockStatusEnum["UNAVAILABLE"] = "not_in_stock";
    StockStatusEnum["UNKNOWN"] = "unknown";
})(StockStatusEnum || (StockStatusEnum = {}));

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/delivery-time/utils.ts

var ShippingType;
(function(ShippingType) {
    ShippingType["CHEAPEST"] = "cheapest";
    ShippingType["FASTEST"] = "fastest";
})(ShippingType || (ShippingType = {}));
var getDeliveryDays = function(shipping) {
    if (!shipping) {
        return null;
    }
    if (!shipping.deliveryDays || shipping.deliveryDays.min < 0 || shipping.deliveryDays.max < 0) {
        return null;
    }
    return {
        min: shipping.deliveryDays.min,
        max: shipping.deliveryDays.max
    };
};
var getDeliveryDaysGeneric = function(t, deliveryDays) {
    if (!deliveryDays) {
        return undefined;
    }
    var day = t("product", "delivery-time.days-label");
    var days = t("product", "delivery-time.days-label-plural");
    if (deliveryDays.min === 1 && deliveryDays.max === 1) {
        return "".concat(deliveryDays.max, " ").concat(day);
    }
    if (deliveryDays.min === 0 && deliveryDays.max === 0) {
        return "".concat(deliveryDays.max, " ").concat(days);
    }
    if (deliveryDays.min === deliveryDays.max) {
        return "".concat(deliveryDays.max, " ").concat(days);
    }
    return "".concat(deliveryDays.min, "-").concat(deliveryDays.max, " ").concat(days);
};
var isShippingInstorePickup = function(shipping) {
    return Boolean((shipping === null || shipping === void 0 ? void 0 : shipping.deliveryMethod) === "INSTORE_PICKUP");
};
var getShippingDays = function(t, shipping) {
    var deliveryDays = getDeliveryDays(shipping);
    return getDeliveryDaysGeneric(t, deliveryDays);
};
var getTranslatedShipping = function(t, deliveryDays) {
    var upTo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    if (!deliveryDays || !deliveryDays.min && !deliveryDays.max) {
        return t("product", "delivery-time.up-to", {
            n: upTo
        });
    }
    return getDeliveryDaysGeneric(t, deliveryDays);
};
var getStandardizedDeliveryText = function(t, stockStatus) {
    switch(stockStatus){
        case StockStatusEnum.IN_STOCK:
            return "".concat(t("product", "delivery-time.unknown")).toLowerCase();
        case StockStatusEnum.INCOMING:
            return t("product", "delivery-time.unknown-date").toLowerCase();
        case StockStatusEnum.PREORDER:
            return t("product", "stock-status.in_stock_preorder");
        case StockStatusEnum.UNAVAILABLE:
            return t("product", "delivery-time.unavailable");
        case StockStatusEnum.UNKNOWN:
        default:
            return t("product", "delivery-time.unknown");
    }
};
var getDeliveryTimeText = function(t, market, shippingDays, stockStatus, availability) {
    if (stockStatus === StockStatusEnum.PREORDER || stockStatus === StockStatusEnum.INCOMING) {
        if (availability === null || availability === void 0 ? void 0 : availability.availabilityDate) {
            return formatAvailibilityDate(availability.availabilityDate, market);
        }
        return t("product", "delivery-time.unknown-date");
    }
    if (shippingDays) {
        return shippingDays;
    }
    return getStandardizedDeliveryText(t, stockStatus);
};
var getDeliveryTextIsBold = function(shippingDays, stockStatus, availability, isInstorePickup) {
    if (isInstorePickup) {
        return false;
    }
    if (stockStatus === StockStatusEnum.IN_STOCK && shippingDays) {
        return true;
    }
    if ((stockStatus === StockStatusEnum.PREORDER || stockStatus === StockStatusEnum.INCOMING) && (availability === null || availability === void 0 ? void 0 : availability.availabilityDate)) {
        return true;
    }
    return false;
};
var getLabel = function(t, stockStatus) {
    if (stockStatus === StockStatusEnum.INCOMING) {
        return "".concat(t("product", "delivery-time.instock-date"), " ");
    }
    if (stockStatus === StockStatusEnum.PREORDER) {
        return "".concat(t("product", "delivery-time.available"), " ");
    }
    if (stockStatus === StockStatusEnum.IN_STOCK) {
        return "".concat(t("product", "delivery-time.label-experiment"), " ");
    }
    return "";
};
var formatAvailibilityDate = function(date, market) {
    return new Date(date).toLocaleDateString(market.localeStandard, {
        day: "numeric",
        month: "short"
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/delivery-time/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  /* Do not show label on smaller screens to prevent layout from breaking */\n  @media screen and (max-width: 410px) {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledDeliveryTime = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDeliveryTime",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledDeliveryText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDeliveryText",
    componentId: "sc-0-1"
})(_templateObject1());
var StyledLabel = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledLabel",
    componentId: "sc-0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/delivery-time/index.tsx










var DeliveryTime = function(props) {
    var shipping = props.shipping, stockStatus = props.stockStatus, availability = props.availability;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref1.offer, sorting = ref1.sorting, viewSize = ref1.viewSize;
    var sort = ShippingType.CHEAPEST;
    if (sorting === filter_dropdown_types/* OptionTypeEnum.FASTEST_DELIVERY */.M.FASTEST_DELIVERY) {
        sort = ShippingType.FASTEST;
    }
    var label = getLabel(t, stockStatus);
    var isInstorePickup = isShippingInstorePickup(shipping);
    var shippingDays = getShippingDays(t, shipping);
    var deliveryText = getDeliveryTimeText(t, market, shippingDays, stockStatus, availability);
    var highlightText = getDeliveryTextIsBold(shippingDays, stockStatus, availability, isInstorePickup);
    var deliveryEmphasis = highlightText ? ui_text.FontEmphasis.HIGH : ui_text.FontEmphasis.MEDIUM;
    var deliveryFontWeight = highlightText ? ui_text.FontWeight.HEAVIEST : ui_text.FontWeight.NORMAL;
    var hasAvailabilityDate = (availability === null || availability === void 0 ? void 0 : availability.availabilityDate) && (stockStatus === StockStatusEnum.INCOMING || stockStatus === StockStatusEnum.PREORDER);
    var showDeliveryTime = shippingDays || hasAvailabilityDate || isInstorePickup || sort === ShippingType.FASTEST;
    var renderMobileDeliveryTime = function() {
        return /*#__PURE__*/ react.createElement("div", null, !isInstorePickup && /*#__PURE__*/ react.createElement(StyledLabel, {
            emphasis: ui_text.FontEmphasis.MEDIUM
        }, label), /*#__PURE__*/ react.createElement(variants.CaptionText, {
            emphasis: deliveryEmphasis,
            weight: deliveryFontWeight
        }, isInstorePickup ? t("product", "delivery-option.pickup-instore") : deliveryText));
    };
    var renderDesktopDeliveryTime = function() {
        return /*#__PURE__*/ react.createElement(StyledDeliveryText, null, !isInstorePickup && /*#__PURE__*/ react.createElement(variants.CaptionText, {
            emphasis: ui_text.FontEmphasis.MEDIUM
        }, label), /*#__PURE__*/ react.createElement(variants.CaptionText, {
            emphasis: deliveryEmphasis,
            weight: deliveryFontWeight
        }, isInstorePickup ? t("product", "delivery-option.pickup-instore") : deliveryText));
    };
    // If no delivery time is available,
    // no delivery text should be visible unless sorting on fastest delivery.
    if (!showDeliveryTime || offer.mobileContract) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledDeliveryTime, null, viewSize === types/* ViewSize.SMALL */.du.SMALL && renderMobileDeliveryTime(), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && renderDesktopDeliveryTime());
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/styles.ts
function stock_price_info_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function stock_price_info_styles_templateObject() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    stock_price_info_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  gap: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  svg {\n    width: ",
        "px;\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n      svg {\n        width: ",
        "px;\n        height: ",
        "px;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  line-height: 1.25;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n    margin: ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var Row = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Row",
    componentId: "sc-0-0"
})(stock_price_info_styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var CenteredFlexBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CenteredFlexBox",
    componentId: "sc-0-1"
})(styles_templateObject1());
var FirstRow = (0,styled_components_browser_esm["default"])(Row).withConfig({
    displayName: "FirstRow",
    componentId: "sc-0-2"
})(styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ICON_SIZE_PRICE_INFO = 24;
var ICON_SIZE_STOCK_STATUS_MOBILE = 20;
var PriceInfoElement = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceInfoElement",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, ICON_SIZE_PRICE_INFO, ICON_SIZE_PRICE_INFO);
var StockStatusWrapper = (0,styled_components_browser_esm["default"])(PriceInfoElement).withConfig({
    displayName: "StockStatusWrapper",
    componentId: "sc-0-4"
})(function(props) {
    return props.$viewSize === types/* ViewSize.SMALL */.du.SMALL && (0,styled_components_browser_esm.css)(_templateObject4(), ICON_SIZE_STOCK_STATUS_MOBILE, ICON_SIZE_STOCK_STATUS_MOBILE);
});
var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-5"
})(_templateObject5());
var StyledCaptionText = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledCaptionText",
    componentId: "sc-0-6"
})(_templateObject6());
var StyledSustainabilityBadge = (0,styled_components_browser_esm["default"])(badge.Badge).withConfig({
    displayName: "StyledSustainabilityBadge",
    componentId: "sc-0-7"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject7(), props.$addExtraSpacing ? "2px" : "0");
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/price-type-badge.tsx








var PriceTypeNoticeBadge = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var priceAvailability = props.priceAvailability;
    if (!priceAvailability) {
        return null;
    }
    if (priceAvailability.condition !== "Download" && priceAvailability.condition !== "NotAvailableForOrder") {
        return null;
    }
    var label = priceAvailability.condition === "Download" ? t("product", "price-notice.download") : t("product", "price-notice.not_available_for_purchase");
    return /*#__PURE__*/ react.createElement(PriceInfoElement, null, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Up */.Nm.Up,
        title: label,
        renderOnMouseOver: true
    }, /*#__PURE__*/ react.createElement(IconWrapper, null, /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        color: "base300"
    }))), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: ui_text.FontEmphasis.MEDIUM
    }, label));
};

// EXTERNAL MODULE: ./src/components/country-flag/index.ts + 2 modules
var country_flag = __webpack_require__(37364);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/country-badge.tsx




var CountryBadge = function(props) {
    var countryCode = props.countryCode;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var title = t("common", "market.".concat(countryCode));
    return /*#__PURE__*/ react.createElement(country_flag/* CountryFlag */.A, {
        countryCode: countryCode,
        title: title,
        altText: title,
        tooltipPlacement: ui/* Direction.Up */.Nm.Up
    });
};

// EXTERNAL MODULE: ./src/components/stock-status/index.tsx + 1 modules
var stock_status = __webpack_require__(73209);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/utils.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var getStockStatusLabel = function(status, t) {
    switch(status){
        case "in_stock":
            return t("product", "stock-status.in_stock");
        case "incoming":
        case "in_stock_preorder":
            return t("product", "stock-status.incoming");
        case "not_in_stock":
            return t("product", "stock-status.not_in_stock");
        case "unknown":
        default:
            return t("product", "stock-status.unknown");
    }
};
var getChristmasCampaign = function(offer) {
    var ref;
    var christmasCampaign = (ref = offer.shippingCampaigns) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.type) === "CHRISTMAS";
    });
    var startString = christmasCampaign === null || christmasCampaign === void 0 ? void 0 : christmasCampaign.startDate;
    var endString = christmasCampaign === null || christmasCampaign === void 0 ? void 0 : christmasCampaign.endDate;
    if (!startString || !endString) return undefined;
    var startDate = new Date(startString);
    var endDate = new Date(endString);
    // Return undefined if unvalid dates
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return undefined;
    return _objectSpreadProps(_objectSpread({}, christmasCampaign), {
        startDate: startDate,
        endDate: endDate,
        type: "CHRISTMAS"
    });
};
var getChristmasBadgeIsVisible = function(christmasCampaign, stockStatus) {
    if (!christmasCampaign || stockStatus !== "in_stock") return false;
    var startDate = christmasCampaign.startDate, endDate = christmasCampaign.endDate;
    var currentTime = new Date();
    return currentTime >= startDate && currentTime <= endDate;
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/stock-badge.tsx







var StockBadge = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, viewSize = ref.viewSize;
    var status = props.status, featuredOffer = props.featuredOffer;
    var statusText = getStockStatusLabel(status, t);
    if (offer.mobileContract) return null;
    return /*#__PURE__*/ react.createElement(StockStatusWrapper, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(stock_status/* StockStatus */.B, {
        status: status,
        tooltip: statusText,
        tooltipPlacement: ui/* Direction.Up */.Nm.Up,
        featuredOffer: featuredOffer
    }));
};

// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/christmas-badge/santa-icon.tsx

var SantaIcon = function() {
    return /*#__PURE__*/ react.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M19.5106 5.12489C20.27 5.12489 20.8856 4.50931 20.8856 3.74995C20.8856 2.99058 20.27 2.375 19.5106 2.375C18.7513 2.375 18.1357 2.99058 18.1357 3.74995C18.1357 4.50931 18.7513 5.12489 19.5106 5.12489Z",
        fill: "#F8F8F8"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M17.3199 6.09641C14.8725 3.90566 18.1357 3.74983 18.1357 3.74983L18.3832 2.98903C16.6297 1.9954 14.6516 1.46833 12.6359 1.45825C9.3177 1.45825 6.6228 5.04228 6.21948 6.04141L17.3199 6.09641Z",
        fill: "#EB003B"
    }), /*#__PURE__*/ react.createElement("path", {
        opacity: "0.2",
        d: "M8.75855 6.07807C9.08854 5.16144 11.3068 2.15489 14.1667 1.56825C13.6598 1.49675 13.1483 1.46009 12.6359 1.45825C9.3177 1.45825 6.6228 5.04228 6.21948 6.04141H17.2832L8.75855 6.07807Z",
        fill: "white"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M6.62281 6.04141H16.8158C17.6196 6.02491 18.341 6.53364 18.594 7.29719L18.6948 7.59051C18.8571 8.06991 18.5995 8.59056 18.1201 8.75188C18.0248 8.78397 17.9249 8.80047 17.824 8.80047H5.66035C5.15437 8.80138 4.7428 8.39257 4.74097 7.88658C4.74097 7.78576 4.75655 7.68584 4.78955 7.59051L4.84455 7.29719C5.09754 6.53364 5.81893 6.02491 6.62281 6.04141Z",
        fill: "#F8F8F8"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M19.969 11.9995C19.969 10.1662 17.6774 8.79126 17.6774 8.79126H17.2191C17.7397 9.78672 18.0523 10.8784 18.1357 11.9995C18.2255 13.1755 17.3447 14.2012 16.1677 14.291C16.0595 14.2993 15.9514 14.2993 15.8441 14.291C14.5242 14.291 13.7817 13.3744 11.7193 13.3744C9.65687 13.3744 8.91439 14.291 7.59445 14.291C6.41841 14.3809 5.3927 13.5 5.30287 12.323C5.29462 12.2149 5.29462 12.1067 5.30287 11.9995C5.38628 10.8784 5.69885 9.78672 6.2195 8.79126H5.76118C5.76118 8.79126 3.4696 10.1662 3.4696 11.9995C3.4696 13.8327 4.38624 14.291 4.38624 14.291C4.38624 14.291 3.4696 16.1243 4.38624 17.0409C4.8638 17.5616 5.51644 17.8879 6.2195 17.9576C6.2195 17.9576 8.05276 23.3474 11.7193 21.6241C11.7193 22.3299 10.8027 22.5407 10.8027 22.5407C14.9458 22.5407 17.2191 17.9576 17.2191 17.9576C17.9221 17.8879 18.5748 17.5616 19.0523 17.0409C19.969 16.1243 19.0523 14.291 19.0523 14.291C19.0523 14.291 19.969 13.8327 19.969 11.9995Z",
        fill: "#F8F8F8"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M17.219 8.79126C17.7397 9.78672 18.0522 10.8784 18.1357 11.9995C18.2255 13.1755 17.3446 14.2012 16.1677 14.291C16.0595 14.2993 15.9513 14.2993 15.8441 14.291C14.5241 14.291 13.7817 13.3744 11.7192 13.3744C9.65682 13.3744 8.91435 14.291 7.5944 14.291C6.41836 14.3809 5.39265 13.5 5.30282 12.323C5.29457 12.2149 5.29457 12.1067 5.30282 11.9995C5.38623 10.8784 5.6988 9.78672 6.21945 8.79126H17.219Z",
        fill: "#FBBE9D"
    }), /*#__PURE__*/ react.createElement("path", {
        opacity: "0.1",
        d: "M18.1356 3.74982L18.2823 3.2915C16.5132 3.2915 14.4691 3.41983 14.4691 5.58308C14.4728 5.76183 14.5168 5.9369 14.5974 6.0964H17.3473C14.8724 3.90565 18.1356 3.74982 18.1356 3.74982Z",
        fill: "#141414"
    }), /*#__PURE__*/ react.createElement("path", {
        opacity: "0.2",
        d: "M7.13607 11.9995C7.21949 10.8784 7.53206 9.78672 8.05271 8.79126H6.21944C5.6988 9.78672 5.38623 10.8784 5.30281 11.9995C5.21298 13.1755 6.09386 14.2012 7.27082 14.291C7.37898 14.2993 7.48714 14.2993 7.59439 14.291C7.90513 14.2883 8.21403 14.2388 8.51102 14.1444C7.62189 13.8208 7.05816 12.9427 7.13607 11.9995Z",
        fill: "white"
    }), /*#__PURE__*/ react.createElement("path", {
        opacity: "0.1",
        d: "M16.3024 11.9995C16.219 10.8784 15.9065 9.78672 15.3858 8.79126H17.2191C17.7397 9.78672 18.0523 10.8784 18.1357 11.9995C18.2255 13.1755 17.3446 14.2012 16.1677 14.291C16.0595 14.2993 15.9514 14.2993 15.8441 14.291C15.5334 14.2883 15.2245 14.2388 14.9275 14.1444C15.8166 13.8208 16.3804 12.9427 16.3024 11.9995Z",
        fill: "#141414"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M17.7599 4.25404C18.0294 5.23025 19.0386 5.80315 20.0148 5.53366C20.991 5.26417 21.5639 4.25496 21.2944 3.27875C21.0249 2.30253 20.0157 1.72964 19.0395 1.99913C18.7572 2.07704 18.4968 2.22187 18.2823 2.42078C16.5398 1.50415 14.6039 1.01742 12.6359 1C9.29019 1 6.57696 4.31821 5.92615 5.69315C5.22951 5.91589 4.68137 6.45762 4.45038 7.1506L4.34955 7.41642C4.20838 7.83532 4.27988 8.2973 4.54204 8.65387C4.61079 8.7492 4.69053 8.83536 4.78036 8.91053C3.77023 9.63467 3.12401 10.7621 3.01126 11.9996C2.93702 12.8896 3.23217 13.7714 3.82707 14.4378C3.57958 15.0886 3.19459 16.5002 4.06539 17.3619C4.5622 17.8734 5.20018 18.2253 5.89865 18.3702C6.21031 19.1493 7.22777 21.3767 9.03353 22.1467C9.45427 22.3328 9.91166 22.4235 10.3718 22.4125C10.3608 22.4703 10.3608 22.5289 10.3718 22.5867C10.4002 22.8177 10.5973 22.9918 10.8301 22.99C14.7075 22.99 16.9991 19.3235 17.5399 18.4068C18.2402 18.2611 18.8791 17.9063 19.3731 17.3894C20.2348 16.5277 19.8498 15.1161 19.6115 14.4653C20.2137 13.7925 20.5098 12.8988 20.4273 11.9996C20.3063 10.7722 19.6619 9.65575 18.6582 8.93803C18.748 8.86286 18.8277 8.7767 18.8965 8.68137C19.1678 8.31838 19.2402 7.84357 19.089 7.41642L18.9881 7.1231C18.759 6.46587 18.2429 5.94981 17.5857 5.72065C16.9807 5.17067 16.8249 4.80402 16.8707 4.65736C16.9166 4.5107 17.3382 4.33654 17.7599 4.25404ZM19.5106 2.83326C20.0166 2.83326 20.4273 3.24391 20.4273 3.74989C20.4273 4.25587 20.0166 4.66653 19.5106 4.66653C19.0046 4.66653 18.594 4.25587 18.594 3.74989C18.594 3.24391 19.0046 2.83326 19.5106 2.83326ZM16.9349 9.24968C17.362 10.1076 17.615 11.0426 17.6774 11.9996C17.7626 12.9272 17.0788 13.7476 16.1512 13.8328C16.0485 13.842 15.9458 13.842 15.8441 13.8328C15.3528 13.809 14.8697 13.6908 14.4233 13.4845C12.6991 12.7329 10.7394 12.7329 9.0152 13.4845C8.5688 13.6908 8.08573 13.809 7.59442 13.8328C6.66679 13.9181 5.8464 13.2343 5.76116 12.3066C5.75199 12.204 5.75199 12.1013 5.76116 11.9996C5.82441 11.0426 6.0774 10.1086 6.50363 9.24968H16.9349ZM19.5106 11.9996C19.5106 13.4937 18.869 13.8328 18.8507 13.8328C18.6233 13.9438 18.528 14.2178 18.6389 14.4451L18.6398 14.447C18.8507 14.8778 19.2815 16.1153 18.7315 16.6744C18.3447 17.1245 17.8066 17.4178 17.219 17.4994C17.0467 17.5021 16.8918 17.602 16.8157 17.756C16.8157 17.756 15.12 21.0834 12.1776 21.8992C12.1877 21.8075 12.1877 21.7159 12.1776 21.6242C12.1757 21.3712 11.9686 21.1677 11.7156 21.1696C11.6505 21.1705 11.5854 21.1842 11.5268 21.2117C10.8631 21.5655 10.0757 21.6031 9.38185 21.3125C7.59442 20.5517 6.67779 17.8385 6.67779 17.811C6.61088 17.6213 6.42938 17.4957 6.22864 17.4994C5.64383 17.4315 5.10393 17.1547 4.70703 16.7202C4.15705 16.1702 4.5787 14.887 4.7987 14.4928C4.89586 14.2692 4.80878 14.0079 4.59704 13.8878C4.59704 13.8878 3.9279 13.4937 3.9279 11.9996C4.04889 11.0564 4.56129 10.2085 5.33951 9.66217C5.0416 10.4074 4.87386 11.1975 4.84453 11.9996C4.74461 13.4185 5.81432 14.6496 7.23327 14.7495C7.35335 14.7577 7.47434 14.7577 7.59442 14.7495C8.1994 14.7275 8.79429 14.5872 9.34519 14.337C10.8595 13.6642 12.5882 13.6642 14.1025 14.337C14.6506 14.5863 15.2419 14.7266 15.8441 14.7495C17.263 14.8494 18.4941 13.7797 18.594 12.3607C18.6022 12.2407 18.6022 12.1197 18.594 11.9996C18.5647 11.1975 18.3969 10.4074 18.099 9.66217C18.8772 10.2085 19.3896 11.0564 19.5106 11.9996ZM18.1173 7.41642L18.2182 7.70974C18.2988 7.9499 18.1705 8.20931 17.9304 8.29089C17.8845 8.30647 17.8359 8.31472 17.7874 8.31472H5.66033C5.40734 8.31288 5.20385 8.10573 5.20568 7.85274C5.20568 7.80415 5.21393 7.75557 5.22951 7.70974L5.32118 7.41642C5.51642 6.86552 6.03798 6.49795 6.62279 6.49979H16.8157C17.4005 6.49795 17.9221 6.86552 18.1173 7.41642ZM16.0091 4.32737C15.8808 4.76002 15.9697 5.2275 16.2474 5.58316H7.04444C7.89691 4.27237 10.106 1.91663 12.6359 1.91663C14.4242 1.93221 16.1842 2.36211 17.7782 3.17242C17.7782 3.22741 17.7782 3.27325 17.7324 3.32824C17.1824 3.41074 16.2658 3.64906 16.0183 4.35487L16.0091 4.32737Z",
        fill: "#141414"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M13.1767 14.9419C12.8211 15.3856 12.2876 15.6505 11.7193 15.6661C11.15 15.6541 10.6147 15.3892 10.2618 14.9419C10.0968 14.7494 9.8081 14.7274 9.61561 14.8915C9.44695 15.0363 9.4057 15.282 9.51936 15.4736C10.4241 16.6936 12.1464 16.9493 13.3665 16.0446C13.5837 15.8833 13.7762 15.6908 13.9375 15.4736C14.0842 15.2664 14.0347 14.9786 13.8275 14.8319C13.6204 14.6853 13.3325 14.7348 13.1859 14.9419H13.1767Z",
        fill: "#141414"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M9.42768 11.9995C9.93366 11.9995 10.3443 11.5889 10.3443 11.0829C10.3443 10.5769 9.93366 10.1663 9.42768 10.1663C8.9217 10.1663 8.51105 10.5769 8.51105 11.0829C8.51105 11.5889 8.9217 11.9995 9.42768 11.9995Z",
        fill: "#141414"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M14.0108 11.9995C14.5168 11.9995 14.9274 11.5889 14.9274 11.0829C14.9274 10.5769 14.5168 10.1663 14.0108 10.1663C13.5048 10.1663 13.0942 10.5769 13.0942 11.0829C13.0942 11.5889 13.5048 11.9995 14.0108 11.9995Z",
        fill: "#141414"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M17.7599 4.25404C18.0294 5.23025 19.0386 5.80315 20.0148 5.53366C20.991 5.26417 21.5639 4.25496 21.2944 3.27875C21.0249 2.30253 20.0157 1.72964 19.0395 1.99913C18.7572 2.07704 18.4968 2.22187 18.2823 2.42078C16.5398 1.50415 14.6039 1.01742 12.6359 1C9.29019 1 6.57696 4.31821 5.92615 5.69315C5.22951 5.91589 4.68137 6.45762 4.45038 7.1506L4.34955 7.41642C4.20838 7.83532 4.27988 8.2973 4.54204 8.65387C4.61079 8.7492 4.69053 8.83536 4.78036 8.91053C3.77023 9.63467 3.12401 10.7621 3.01126 11.9996C2.93702 12.8896 3.23217 13.7714 3.82707 14.4378C3.57958 15.0886 3.19459 16.5002 4.06539 17.3619C4.5622 17.8734 5.20018 18.2253 5.89865 18.3702C6.21031 19.1493 7.22777 21.3767 9.03353 22.1467C9.45427 22.3328 9.91166 22.4235 10.3718 22.4125C10.3608 22.4703 10.3608 22.5289 10.3718 22.5867C10.4002 22.8177 10.5973 22.9918 10.8301 22.99C14.7075 22.99 16.9991 19.3235 17.5399 18.4068C18.2402 18.2611 18.8791 17.9063 19.3731 17.3894C20.2348 16.5277 19.8498 15.1161 19.6115 14.4653C20.2137 13.7925 20.5098 12.8988 20.4273 11.9996C20.3063 10.7722 19.6619 9.65575 18.6582 8.93803C18.748 8.86286 18.8277 8.7767 18.8965 8.68137C19.1678 8.31838 19.2402 7.84357 19.089 7.41642L18.9881 7.1231C18.759 6.46587 18.2429 5.94981 17.5857 5.72065C16.9807 5.17067 16.8249 4.80402 16.8707 4.65736C16.9166 4.5107 17.3382 4.33654 17.7599 4.25404Z"
    }), /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        x1: "4.34515",
        y1: "7.34071",
        x2: "20.6319",
        y2: "14.9339",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "white",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: "1",
        stopColor: "white",
        stopOpacity: "0"
    }))));
};

// EXTERNAL MODULE: ./src/globals/helpers/format-date.ts
var format_date = __webpack_require__(76109);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/christmas-badge/styles.ts
function christmas_badge_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function christmas_badge_styles_templateObject() {
    var data = christmas_badge_styles_taggedTemplateLiteral([
        "\n  margin: 0 ",
        ";\n"
    ]);
    christmas_badge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function christmas_badge_styles_templateObject1() {
    var data = christmas_badge_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    christmas_badge_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function christmas_badge_styles_templateObject2() {
    var data = christmas_badge_styles_taggedTemplateLiteral([
        "\n  font-weight: 900;\n"
    ]);
    christmas_badge_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledTooltipWrapper = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "StyledTooltipWrapper",
    componentId: "sc-0-0"
})(christmas_badge_styles_templateObject(), design_tokens.measurements.spacing050);
var StyledMobileWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledMobileWrapper",
    componentId: "sc-0-1"
})(christmas_badge_styles_templateObject1(), design_tokens.measurements.spacing025);
var StyledDate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDate",
    componentId: "sc-0-2"
})(christmas_badge_styles_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/christmas-badge/index.tsx








var ChristmasBadge = function(param) {
    var className = param.className, endDate = param.endDate;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var endDateString = (0,format_date/* formatDate */.p)(endDate.getTime(), market.localeStandard, {
        day: "numeric",
        month: "short",
        timeZone: "UTC",
        hour: "numeric",
        minute: "numeric"
    });
    return isDesktop ? /*#__PURE__*/ react.createElement(StyledTooltipWrapper, {
        placement: ui/* Direction.Up */.Nm.Up,
        title: t("product", "delivery-time.christmas-label", {
            endDate: /*#__PURE__*/ react.createElement(StyledDate, null, endDateString)
        }),
        className: className,
        renderOnMouseOver: true,
        width: "216px"
    }, /*#__PURE__*/ react.createElement(SantaIcon, null)) : /*#__PURE__*/ react.createElement(StyledMobileWrapper, null, /*#__PURE__*/ react.createElement(SantaIcon, null), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, t("product", "delivery-time.christmas-label-short")), " ", /*#__PURE__*/ react.createElement(variants.CaptionStrongText, {
        emphasis: variants.FontEmphasis.HIGH
    }, endDateString));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/index.tsx

























var StockPriceInfo = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, sorting = ref.sorting, viewSize = ref.viewSize;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var ref1 = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getActiveFilters = ref1.getActiveFilters, getPriceDisplay = ref1.getPriceDisplay;
    var authorizedDealer = offer.authorizedDealer, authorizedDealerData = offer.authorizedDealerData, availability = offer.availability, isInternationalPrice = offer.isInternationalPrice, price = offer.price, store = offer.store;
    var getShippingBySort = function(shipping) {
        return sorting === filter_dropdown_types/* OptionTypeEnum.FASTEST_DELIVERY */.M.FASTEST_DELIVERY ? shipping === null || shipping === void 0 ? void 0 : shipping.fastest : shipping === null || shipping === void 0 ? void 0 : shipping.cheapest;
    };
    var getCheapestShippingNonMember = function(shipping) {
        if (!shipping) {
            return null;
        }
        var cheapestShippingNonMember = shipping.filter(function(eligibilityCheck) {
            return eligibilityCheck.eligibility !== price_list_types/* EligibilityEnum.MEMBERS */.hs.MEMBERS;
        }).reduce(function(prev, curr) {
            if (prev === null) return curr;
            var prevCost = prev.shippingCost || 0;
            var currCost = curr.shippingCost || 0;
            return prevCost < currCost ? prev : curr;
        }, null);
        return (cheapestShippingNonMember === null || cheapestShippingNonMember === void 0 ? void 0 : cheapestShippingNonMember.shippingCost) || null;
    };
    // Get props from alternative offer if supplied
    var featured = alternativeOffer ? (0,product_utils/* getIsFeatured */.ZF)(offer, alternativeOffer) : offer.featured;
    var selectedOffer = alternativeOffer || offer;
    var offerPrice = alternativeOffer ? alternativeOffer.price : price;
    var offerPrices = alternativeOffer ? alternativeOffer.offerPrices : offer.offerPrices;
    var shipping = alternativeOffer ? getShippingBySort(alternativeOffer.shipping) : getShippingBySort(offer.shipping);
    var stock = alternativeOffer ? alternativeOffer.stock : offer.stock;
    var priceAvailability = alternativeOffer ? alternativeOffer.availability : availability;
    var isDownload = (availability === null || availability === void 0 ? void 0 : availability.condition) === "Download";
    var hasSustainableShipping = (shipping === null || shipping === void 0 ? void 0 : shipping.sustainability) === price_list_types/* SustainabilityEnum.SUSTAINABLE */.$z.SUSTAINABLE;
    var hasMemberShipping = (shipping === null || shipping === void 0 ? void 0 : shipping.eligibility) === price_list_types/* EligibilityEnum.MEMBERS */.hs.MEMBERS;
    var christmasCampaign = getChristmasCampaign(offer);
    var christmasBadgeIsVisible = getChristmasBadgeIsVisible(christmasCampaign, stock === null || stock === void 0 ? void 0 : stock.status);
    var getDeliveryText = function() {
        if (hasMemberShipping) {
            var ref, ref1;
            var cheapestShippingNonMember = getCheapestShippingNonMember(((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes) || (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : (ref1 = alternativeOffer.shipping) === null || ref1 === void 0 ? void 0 : ref1.nodes));
            if (cheapestShippingNonMember !== (shipping === null || shipping === void 0 ? void 0 : shipping.shippingCost)) {
                return /*#__PURE__*/ react.createElement("span", null, (shipping === null || shipping === void 0 ? void 0 : shipping.carrier) ? "".concat(shipping === null || shipping === void 0 ? void 0 : shipping.carrier, ", ") : null, "(", /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
                    value: cheapestShippingNonMember,
                    weight: variants.FontWeight.NORMAL
                }), ") ", t("product", "price.free-shipping"));
            }
        }
        if ((shipping === null || shipping === void 0 ? void 0 : shipping.shippingCost) === 0) {
            return /*#__PURE__*/ react.createElement("span", null, (shipping === null || shipping === void 0 ? void 0 : shipping.carrier) ? "".concat(shipping === null || shipping === void 0 ? void 0 : shipping.carrier, ", ") : null, t("product", "price.free-shipping"));
        }
        if (!(shipping === null || shipping === void 0 ? void 0 : shipping.shippingCost)) {
            return /*#__PURE__*/ react.createElement("span", null, (shipping === null || shipping === void 0 ? void 0 : shipping.carrier) ? "".concat(shipping === null || shipping === void 0 ? void 0 : shipping.carrier, ", ") : null, t("product", "price.unknown-shipping"));
        }
        // Prefix the shipping cost with carrier or shipping label
        return (shipping === null || shipping === void 0 ? void 0 : shipping.carrier) ? /*#__PURE__*/ react.createElement(react.Fragment, null, shipping === null || shipping === void 0 ? void 0 : shipping.carrier, ",", " ", /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
            value: shipping.shippingCost,
            weight: variants.FontWeight.NORMAL
        })) : /*#__PURE__*/ react.createElement(react.Fragment, null, t("product", "delivery-time.label"), " ", /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
            value: shipping.shippingCost,
            weight: variants.FontWeight.NORMAL
        }));
    };
    var deliveryText = getDeliveryText();
    var showDeliveryText = function() {
        if (!deliveryText) return false;
        var filteredOnShippingInfo = Boolean(getActiveFilters().find(function(item) {
            return item.type === price_list_types/* FilterType.PRICES_INC_SHIPPING */.vA.PRICES_INC_SHIPPING || item.type === price_list_types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD || item.type === price_list_types/* FilterType.CARRIERS */.vA.CARRIERS;
        }));
        return sorting === filter_dropdown_types/* OptionTypeEnum.FASTEST_DELIVERY */.M.FASTEST_DELIVERY || filteredOnShippingInfo;
    };
    return /*#__PURE__*/ react.createElement(styles/* Column */.sg, null, /*#__PURE__*/ react.createElement(FirstRow, null, !featured && viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(CenteredFlexBox, null, isInternationalPrice && (store === null || store === void 0 ? void 0 : store.primaryMarket) && /*#__PURE__*/ react.createElement(CountryBadge, {
        countryCode: store.primaryMarket
    })), offerPrice && /*#__PURE__*/ react.createElement(react.Fragment, null, !featured && viewSize >= types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(StockBadge, {
        featuredOffer: featured,
        status: stock === null || stock === void 0 ? void 0 : stock.status
    }), /*#__PURE__*/ react.createElement(OfferPriceLabel, {
        container: "h4",
        priceDisplay: getPriceDisplay(),
        selectedOffer: selectedOffer,
        shipping: shipping !== null && shipping !== void 0 ? shipping : undefined,
        offerPrice: offerPrices
    }))), featured && /*#__PURE__*/ react.createElement(react.Fragment, null, showDeliveryText() ? /*#__PURE__*/ react.createElement(Row, null, hasSustainableShipping && /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Up */.Nm.Up,
        title: t("product", "shipping.sustainable")
    }, /*#__PURE__*/ react.createElement(StyledSustainabilityBadge, {
        circular: true,
        color: "GREEN",
        icon: leaf/* IconLeaf */.y,
        size: badge.BadgeSize.SMALL,
        $addExtraSpacing: Boolean(authorizedDealer)
    })), /*#__PURE__*/ react.createElement(StyledCaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, deliveryText)) : null, /*#__PURE__*/ react.createElement(Row, null, !alternativeOffer && (authorizedDealer || authorizedDealerData) && viewSize === types/* ViewSize.LARGE */.du.LARGE && /*#__PURE__*/ react.createElement(AuthorizedDealerBadge, null), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(react.Fragment, null, priceAvailability && /*#__PURE__*/ react.createElement(PriceTypeNoticeBadge, {
        priceAvailability: priceAvailability
    }), isInternationalPrice && (store === null || store === void 0 ? void 0 : store.primaryMarket) && /*#__PURE__*/ react.createElement(CountryBadge, {
        countryCode: store.primaryMarket
    }), !isDownload && christmasCampaign && christmasBadgeIsVisible && /*#__PURE__*/ react.createElement(ChristmasBadge, {
        endDate: christmasCampaign.endDate
    }), !isDownload && /*#__PURE__*/ react.createElement(StockBadge, {
        featuredOffer: featured,
        status: stock === null || stock === void 0 ? void 0 : stock.status
    })), !isDownload && viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(StockBadge, {
        featuredOffer: featured,
        status: stock === null || stock === void 0 ? void 0 : stock.status
    }), !isDownload && /*#__PURE__*/ react.createElement(DeliveryTime, {
        shipping: shipping,
        stockStatus: stock === null || stock === void 0 ? void 0 : stock.status,
        availability: priceAvailability
    })), !isDownload && christmasCampaign && christmasBadgeIsVisible && viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(Row, null, /*#__PURE__*/ react.createElement(ChristmasBadge, {
        endDate: christmasCampaign.endDate
    })), !alternativeOffer && (authorizedDealer || authorizedDealerData) && viewSize === types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(Row, null, /*#__PURE__*/ react.createElement(AuthorizedDealerBadge, null))));
};

// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(46256);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/index.tsx + 1 modules
var smiley_rating = __webpack_require__(89636);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-rating-average/styles.ts
function store_rating_average_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_rating_average_styles_templateObject() {
    var data = store_rating_average_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    store_rating_average_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RatingContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingContainer",
    componentId: "sc-0-0"
})(store_rating_average_styles_templateObject());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-rating-average/index.tsx





var StoreRatingAverage = function() {
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, viewSize = ref.viewSize;
    var featured = offer.featured, store = offer.store, rating = offer.rating;
    if (!store || !rating || rating.whole <= 0) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(RatingContainer, {
        "data-rating": rating.roundedString
    }, /*#__PURE__*/ react.createElement(smiley_rating/* default */.Z, {
        featured: featured,
        rating: rating,
        scoreVisibility: "row",
        size: "small",
        reviewCount: viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM ? store.userReviewSummary.countTotal : undefined
    }));
};

// EXTERNAL MODULE: ./src/areas/store/constants.ts
var constants = __webpack_require__(67595);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info-column/styles.ts
function store_info_column_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_info_column_styles_templateObject() {
    var data = store_info_column_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-shrink: 0;\n  gap: ",
        ";\n  width: 104px;\n  padding: ",
        ";\n  margin: 0;\n\n  /* Small mobile resolutions, e.g. Galaxy Fold */\n  @media screen and (max-width: ",
        ") {\n    width: calc(\n      ",
        "px + ",
        "\n    );\n  }\n"
    ]);
    store_info_column_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function store_info_column_styles_templateObject1() {
    var data = store_info_column_styles_taggedTemplateLiteral([
        "\n  /* Visually hidden since this text is primarily for Google */\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"
    ]);
    store_info_column_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function store_info_column_styles_templateObject2() {
    var data = store_info_column_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    store_info_column_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var EXTRA_SMALL_DISPLAY_WIDTH = "280px";
var StoreInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreInfo",
    componentId: "sc-0-0"
})(store_info_column_styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, EXTRA_SMALL_DISPLAY_WIDTH, store_logo/* DEFAULT_STORE_LOGO_MAX_WIDTH */.uZ, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StoreInfoTitle = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreInfoTitle",
    componentId: "sc-0-1"
})(store_info_column_styles_templateObject1());
var InfoGroup = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InfoGroup",
    componentId: "sc-0-2"
})(store_info_column_styles_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info-column/index.tsx









var StoreInfoColumn = function() {
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, viewSize = ref.viewSize, isInPriceList = ref.isInPriceList;
    var featured = offer.featured, store = offer.store, isInternationalPrice = offer.isInternationalPrice;
    if (!store) {
        return null;
    }
    var highResolutionLogo = store.logo ? {
        url: store.logo,
        width: constants/* SHOP_LOGO_WIDTH */.L9
    } : null;
    return /*#__PURE__*/ react.createElement(StoreInfo, null, /*#__PURE__*/ react.createElement(StoreInfoTitle, null, store.name), /*#__PURE__*/ react.createElement(store_logo/* StoreLogo */.Xv, {
        featured: featured,
        hasImage: Boolean(store.hasLogo),
        logoUrl: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.url,
        name: store.name,
        showHighResolutionLogo: Boolean(highResolutionLogo),
        storeId: store.id,
        variant: store_logo/* StoreLogoVariant.PRICE_LIST */.mA.PRICE_LIST,
        width: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.width
    }), /*#__PURE__*/ react.createElement(InfoGroup, null, isInPriceList && /*#__PURE__*/ react.createElement(StoreRatingAverage, null), featured && offer.authorizedDealer && viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(AuthorizedDealerBadge, null), isInternationalPrice && (store === null || store === void 0 ? void 0 : store.primaryMarket) && viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(CountryBadge, {
        countryCode: store.primaryMarket
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/prisjakt/index.js
var prisjakt = __webpack_require__(28756);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/our-choice-badge/styles.ts
function our_choice_badge_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function our_choice_badge_styles_templateObject() {
    var data = our_choice_badge_styles_taggedTemplateLiteral([
        "\n      top: -",
        ";\n    "
    ]);
    our_choice_badge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function our_choice_badge_styles_templateObject1() {
    var data = our_choice_badge_styles_taggedTemplateLiteral([
        "\n  height: 10px;\n  width: ",
        "px;\n  position: relative;\n  top: -",
        ";\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    our_choice_badge_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function our_choice_badge_styles_templateObject2() {
    var data = our_choice_badge_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  left: -",
        ";\n"
    ]);
    our_choice_badge_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var WIDTH_FOR_TOOLTIP_BASE = 210;
var StyledOurChoiceBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledOurChoiceBadgeWrapper",
    componentId: "sc-0-0"
})(our_choice_badge_styles_templateObject1(), WIDTH_FOR_TOOLTIP_BASE, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(props) {
    return props.$viewSize !== undefined && props.$viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && (0,styled_components_browser_esm.css)(our_choice_badge_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var StyledOurChoiceBadge = (0,styled_components_browser_esm["default"])(badge.Badge).withConfig({
    displayName: "StyledOurChoiceBadge",
    componentId: "sc-0-1"
})(our_choice_badge_styles_templateObject2(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/our-choice-badge/index.tsx








var OurChoiceBadge = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var viewSize = (0,price_row_context/* usePriceRowContext */.m)().viewSize;
    return /*#__PURE__*/ react.createElement(StyledOurChoiceBadgeWrapper, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        title: t("product", "prices.our-choice-explanation"),
        placement: ui/* Direction.Up */.Nm.Up
    }, /*#__PURE__*/ react.createElement(StyledOurChoiceBadge, {
        size: badge.BadgeSize.SMALL,
        color: "BLUE_INVERTED",
        text: t("product", "prices.our-choice"),
        icon: prisjakt/* IconPrisjakt */.w
    })));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/condition-type-badge/index.tsx + 1 modules
var condition_type_badge = __webpack_require__(21217);
// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/sections/mini-offerlist/utils/mini-offerlist-config.ts
var mini_offerlist_config = __webpack_require__(74673);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/selected-offer-type-badge/styles.ts
function selected_offer_type_badge_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function selected_offer_type_badge_styles_templateObject() {
    var data = selected_offer_type_badge_styles_taggedTemplateLiteral([
        "\n      > div {\n        background: rgba(0, 0, 0, 0.03);\n      }\n    "
    ]);
    selected_offer_type_badge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function selected_offer_type_badge_styles_templateObject1() {
    var data = selected_offer_type_badge_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: flex-end;\n\n    ",
        "\n  "
    ]);
    selected_offer_type_badge_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var BadgeWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "BadgeWrapper",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(selected_offer_type_badge_styles_templateObject1(), !props.$featured && (0,styled_components_browser_esm.css)(selected_offer_type_badge_styles_templateObject()));
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/selected-offer-type-badge/index.tsx








var SelectedOfferTypeBadge = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), selectedOfferType = ref.selectedOfferType, offer = ref.offer;
    var offers = (0,product_context/* useProductContext */.$h)().offers;
    var config = mini_offerlist_config/* MINI_OFFERLIST_CONFIG.find */.V.find(function(c) {
        return c.type === selectedOfferType;
    });
    var featured = (0,product_utils/* getIsFeatured */.ZF)(offer);
    if (selectedOfferType === undefined || config === undefined) {
        return null;
    }
    var label = config.getBadgeLabel({
        t: t,
        offer: offer,
        offers: offers.filteredOffersForProductHeader
    });
    var color = featured ? config.badgeColorFeatured : "GREY";
    return /*#__PURE__*/ react.createElement(BadgeWrapper, {
        $featured: featured
    }, /*#__PURE__*/ react.createElement(badge.Badge, {
        text: label,
        color: color,
        icon: config.badgeIcon,
        size: badge.BadgeSize.SMALL
    }));
};

// EXTERNAL MODULE: ./src/components/info-list/index.tsx + 1 modules
var info_list = __webpack_require__(29089);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/mobile-contract-info/styles.ts
function mobile_contract_info_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mobile_contract_info_styles_templateObject() {
    var data = mobile_contract_info_styles_taggedTemplateLiteral([
        "\n    justify-content: initial;\n  "
    ]);
    mobile_contract_info_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mobile_contract_info_styles_templateObject1() {
    var data = mobile_contract_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: end;\n\n  ",
        "\n"
    ]);
    mobile_contract_info_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledMobileContractInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledMobileContractInfo",
    componentId: "sc-0-0"
})(mobile_contract_info_styles_templateObject1(), base/* media.mediumUp */.BC.mediumUp(mobile_contract_info_styles_templateObject()));

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/mobile-contract-info/index.tsx








var MobileContractInfo = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var alternativeContract = useAlternativePriceRowContext().alternativeContract;
    var mobileContract = alternativeContract || offer.mobileContract;
    if (!mobileContract) return null;
    var getDataGBLabel = function() {
        // Hardcoded untranslated text since Mobile Contracts are only enabled in SE
        var dataGB = mobileContract.dataGB;
        if (dataGB === 0) return "Fri surf";
        return "".concat(mobileContract.dataGB, "GB ").concat(isMobile ? "" : "surfm\xe4ngd");
    };
    var getPaymentLabel = function() {
        return(// Hardcoded untranslated text since Mobile Contracts are only enabled in SE
        "".concat(mobileContract.contractMonths, " ").concat(t("common", "time.month", {
            n: mobileContract.contractMonths
        }), " ").concat(isMobile ? "" : "delbetalning"));
    };
    var TextComponent = isMobile ? variants.CaptionText : variants.BodySmallText;
    var emphasis = variants.FontEmphasis.HIGH;
    var dataGBLabel = getDataGBLabel();
    var paymentLabel = getPaymentLabel();
    return /*#__PURE__*/ react.createElement(StyledMobileContractInfo, null, /*#__PURE__*/ react.createElement(info_list/* InfoList */.Q, {
        list: [
            /*#__PURE__*/ react.createElement(TextComponent, {
                color: variants.FontColor.DARK,
                emphasis: emphasis,
                key: mobileContract.contractId
            }, dataGBLabel),
            /*#__PURE__*/ react.createElement(TextComponent, {
                color: variants.FontColor.DARK,
                emphasis: emphasis,
                key: mobileContract.contractId
            }, paymentLabel)
        ]
    }));
};

// EXTERNAL MODULE: ./src/areas/product/utils/mobile-contracts/price.ts
var price = __webpack_require__(61891);
// EXTERNAL MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/types.ts
var filters_and_sorting_types = __webpack_require__(65974);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/mobile-contract-price-label/index.tsx







var MobileContractPriceLabel = function(param) {
    var currentContract = param.currentContract, showAsCampaign = param.showAsCampaign;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var sorting = (0,price_row_context/* usePriceRowContext */.m)().sorting;
    var priceLabel = "";
    switch(sorting){
        case filters_and_sorting_types/* MobileContractSortOptionTypeEnum.TOTAL_PRICE */.o.TOTAL_PRICE:
            priceLabel = (0,price/* getTotalPriceLabel */.Yn)(currentContract, market);
            break;
        case filters_and_sorting_types/* MobileContractSortOptionTypeEnum.MONTHLY_PRICE */.o.MONTHLY_PRICE:
        default:
            priceLabel = (0,price/* getFirstMonthPriceLabel */.KJ)(currentContract, market, t);
            break;
    }
    var fontColor = function() {
        return showAsCampaign ? variants.FontColor.NEGATIVE : undefined;
    };
    var regularMontlyPrice = (0,price/* getRegularMonthlyPrice */.WL)(currentContract);
    return /*#__PURE__*/ react.createElement(styles/* StyledPriceAndShipping */.DB, null, showAsCampaign && /*#__PURE__*/ react.createElement(styles/* StyledSecondaryPrice */.ng, {
        value: regularMontlyPrice,
        emphasis: variants.FontEmphasis.LOW,
        weight: variants.FontWeight.NORMAL,
        isSecondaryPrice: true
    }), /*#__PURE__*/ react.createElement(styles/* StyledPriceLabel */.Zb, {
        container: "h4",
        emphasis: variants.FontEmphasis.HIGH,
        fontColor: fontColor(),
        value: priceLabel,
        weight: variants.FontWeight.HEAVIEST
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/mobile-contract-price-wrapper/styles.ts
function mobile_contract_price_wrapper_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mobile_contract_price_wrapper_styles_templateObject() {
    var data = mobile_contract_price_wrapper_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    mobile_contract_price_wrapper_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styles_FirstRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FirstRow",
    componentId: "sc-0-0"
})(mobile_contract_price_wrapper_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/mobile-contract-price-wrapper/index.tsx








var MobileContractPriceWrapper = function() {
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, sorting = ref.sorting;
    var alternativeContract = useAlternativePriceRowContext().alternativeContract;
    var currentContract = alternativeContract || offer.mobileContract;
    var campaignDurationMonths = currentContract.campaignDurationMonths;
    var isCampaign = campaignDurationMonths > 0 && sorting === filters_and_sorting_types/* MobileContractSortOptionTypeEnum.MONTHLY_PRICE */.o.MONTHLY_PRICE;
    return /*#__PURE__*/ react.createElement(styles/* Column */.sg, null, /*#__PURE__*/ react.createElement(styles_FirstRow, null, /*#__PURE__*/ react.createElement(styles/* StyledPriceArea */.mk, null, isCampaign && /*#__PURE__*/ react.createElement(styles/* StyledBadges */._d, null, /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "RED",
        size: badge.BadgeSize.SMALL,
        text: "Kampanjpris ".concat(campaignDurationMonths, " m\xe5n")
    })), /*#__PURE__*/ react.createElement(MobileContractPriceLabel, {
        currentContract: currentContract,
        showAsCampaign: isCampaign
    }))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/utils.ts
function utils_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function utils_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            utils_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function utils_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function utils_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        utils_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var baseLinkProps = {
    rel: "nofollow noopener",
    target: "_blank"
};
var getUnfeaturedLinkAttributes = function() {
    return utils_objectSpreadProps(utils_objectSpread({}, baseLinkProps), {
        href: undefined,
        target: "_blank",
        disabled: true
    });
};
var getContainerProps = function(name, featured, onClick, externalUri) {
    return utils_objectSpreadProps(utils_objectSpread({}, baseLinkProps), {
        to: externalUri || undefined,
        "aria-label": name,
        isExternal: true,
        disabled: !externalUri,
        onClick: onClick,
        featured: featured
    });
};
var getGAStatus = function(isInternational, isAlternative) {
    if (isInternational) {
        return "international";
    }
    if (isAlternative) {
        return "variant";
    }
    return "";
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/price-row-content/styles.ts
var price_row_content_styles = __webpack_require__(74027);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/mobile-contract-badges/styles.ts
function mobile_contract_badges_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mobile_contract_badges_styles_templateObject() {
    var data = mobile_contract_badges_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: end;\n  gap: ",
        ";\n  flex-wrap: wrap;\n  margin-top: ",
        ";\n"
    ]);
    mobile_contract_badges_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledMobileContractBadges = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledMobileContractBadges",
    componentId: "sc-0-0"
})(mobile_contract_badges_styles_templateObject(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/mobile-contract-badges/index.tsx








var MobileContractBadges = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref1.offer, sorting = ref1.sorting;
    var alternativeContract = useAlternativePriceRowContext().alternativeContract;
    var mobileContract = alternativeContract || offer.mobileContract;
    if (!mobileContract) return null;
    // Hardcoded untranslated text since Mobile Contracts are only enabled in SE
    var avaragePrice = "Snittpris: ".concat((0,price/* getAvarageMonthPriceLabel */.n9)(mobileContract, market, t));
    // Hardcoded untranslated text since Mobile Contracts are only enabled in SE
    var totalPriceLabel = "Totalpris: ".concat((0,price/* getTotalPriceLabel */.Yn)(mobileContract, market));
    return /*#__PURE__*/ react.createElement(StyledMobileContractBadges, null, /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "GREY",
        size: badge.BadgeSize.SMALL,
        text: sorting === filters_and_sorting_types/* MobileContractSortOptionTypeEnum.MONTHLY_PRICE */.o.MONTHLY_PRICE ? totalPriceLabel : avaragePrice
    }));
};

// EXTERNAL MODULE: ./src/components/clickout-wrapper/index.tsx
var clickout_wrapper = __webpack_require__(87526);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/price-row-content/featured-content.tsx





















var FeaturedContent = function(props) {
    var ref, ref1, ref2, ref3;
    var onClick = props.onClick;
    var ref4 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref4.offer, viewSize = ref4.viewSize, isOurChoice = ref4.isOurChoice, isInPriceList = ref4.isInPriceList, overridePriceDisplay = ref4.overridePriceDisplay;
    var ref5 = useAlternativePriceRowContext(), alternativeOffer = ref5.alternativeOffer, alternativeContract = ref5.alternativeContract;
    var isAlternative = Boolean(alternativeOffer || alternativeContract);
    var name = (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.name) || (alternativeContract === null || alternativeContract === void 0 ? void 0 : alternativeContract.name) || offer.name;
    var condition = (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.condition) || offer.condition;
    var isMembershipPrice = Boolean((ref = alternativeOffer || offer) === null || ref === void 0 ? void 0 : (ref1 = ref.offerPrices) === null || ref1 === void 0 ? void 0 : ref1.memberPrice);
    var isPaidMembership = Boolean((ref2 = offer.membershipProgram) === null || ref2 === void 0 ? void 0 : ref2.requiresCompensation);
    var externalUri = isAlternative ? (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.externalUri) || (alternativeContract === null || alternativeContract === void 0 ? void 0 : alternativeContract.externalUri) : offer.externalUri;
    var containerProps = getContainerProps(name || "", true, onClick, externalUri);
    var renderMembershipInformation = function() {
        return /*#__PURE__*/ react.createElement(badges/* MembershipInformation */.pb, {
            isMembershipPrice: isMembershipPrice,
            isPaidMembership: isPaidMembership,
            smallerTextSize: false
        });
    };
    var ref6;
    return /*#__PURE__*/ react.createElement(clickout_wrapper/* ClickoutWrapper */.W, null, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFeaturedRow */.Qp, {
        container: clickable/* Clickable */.P,
        containerProps: containerProps,
        $hasPromotion: Boolean(offer.promotion),
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexHorizontal */.po, null, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledMiddleColumnWithPadding */.e5, {
        $viewSize: viewSize
    }, viewSize === types/* ViewSize.SMALL */.du.SMALL && renderMembershipInformation(), /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexVertical */.Be, null, viewSize >= types/* ViewSize.SMALL */.du.SMALL && isOurChoice && isInPriceList && !isAlternative && /*#__PURE__*/ react.createElement(OurChoiceBadge, null), /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexHorizontal */.po, null, !isAlternative && /*#__PURE__*/ react.createElement(StoreInfoColumn, null), /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledMiddleColumnInner */.qk, {
        $viewSize: viewSize
    }, viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && (isMembershipPrice || isPaidMembership) && /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexVertical */.Be, null, renderMembershipInformation()), viewSize >= types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexHorizontal */.po, null, (viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM || isAlternative) && /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledProductNameWrapper */.a2, {
        $alignStart: isMembershipPrice && !isAlternative
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, !offer.mobileContract && /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledProductName */.D, {
        $featured: true,
        $isAlternative: isAlternative
    }, name), viewSize > types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(MobileContractInfo, null))), /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexVertical */.Be, null, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledBadgeWrapper */.oJ, null, /*#__PURE__*/ react.createElement(condition_type_badge/* ConditionTypeBadge */.b, {
        condition: condition
    })), offer.mobileContract ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(MobileContractPriceWrapper, null), viewSize === types/* ViewSize.SMALL */.du.SMALL ? /*#__PURE__*/ react.createElement(MobileContractInfo, null) : /*#__PURE__*/ react.createElement(MobileContractBadges, null)) : /*#__PURE__*/ react.createElement(StockPriceInfo, null))), viewSize === types/* ViewSize.MINI */.du.MINI && /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledMiniOfferRightContent */.mj, null, /*#__PURE__*/ react.createElement(SelectedOfferTypeBadge, null), offer.mobileContract ? /*#__PURE__*/ react.createElement(MobileContractPriceLabel, {
        currentContract: offer.mobileContract
    }) : /*#__PURE__*/ react.createElement(OfferPriceLabel, {
        container: "h4",
        priceDisplay: overridePriceDisplay !== null && overridePriceDisplay !== void 0 ? overridePriceDisplay : price_list_types/* PriceDisplayEnum.PRICE */.wB.PRICE,
        selectedOffer: offer,
        shipping: (ref6 = (ref3 = offer.shipping) === null || ref3 === void 0 ? void 0 : ref3.cheapest) !== null && ref6 !== void 0 ? ref6 : undefined
    })))), /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexHorizontal */.po, null, viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(MobileContractBadges, null)))), /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledEndColumn */.Y, {
        $featured: true,
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(go_to_store_button/* GoToStoreButton */.a, {
        viewSize: viewSize
    })))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(31744);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/price-row-content/unfeatured-content.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
















var UnfeaturedContent = function(props) {
    var ref, ref1;
    var priceRowRef = props.priceRowRef, setShowDisabledInfo = props.setShowDisabledInfo, showDisabledInfo = props.showDisabledInfo, handleOnClick = props.handleOnClick;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref2 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref2.offer, viewSize = ref2.viewSize;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var linkAttributes = getUnfeaturedLinkAttributes();
    var isAlternative = Boolean(alternativeOffer);
    var name = (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.name) || offer.name;
    var condition = (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.condition) || offer.condition;
    var handleOutSideClick = (0,react.useCallback)(function(e) {
        if (priceRowRef && priceRowRef.current && priceRowRef.current.contains(e.target)) {
            return;
        }
        setShowDisabledInfo === null || setShowDisabledInfo === void 0 ? void 0 : setShowDisabledInfo(false);
    }, [
        priceRowRef,
        setShowDisabledInfo
    ]);
    // componentWillUnmount
    (0,react.useEffect)(function() {
        return function() {
            window.removeEventListener("click", handleOutSideClick);
        };
    }, [
        handleOutSideClick
    ]);
    // Callback for showDisabledInfo state change
    (0,react.useEffect)(function() {
        if (!setShowDisabledInfo) return;
        if (showDisabledInfo) {
            window.addEventListener("click", handleOutSideClick);
        } else {
            window.removeEventListener("click", handleOutSideClick);
        }
    }, [
        handleOutSideClick,
        setShowDisabledInfo,
        showDisabledInfo
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledUnfeaturedRow */.ry, _extends({}, linkAttributes, {
        onClick: handleOnClick,
        "aria-describedby": "click-out-".concat((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id, "-").concat(offer.shopOfferId),
        "data-test": "UnfeaturedRow",
        $viewSize: viewSize
    }), /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledMiddleColumnWithPadding */.e5, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexHorizontal */.po, null, !isAlternative && /*#__PURE__*/ react.createElement(StoreInfoColumn, null), /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledMiddleColumnInner */.qk, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexHorizontal */.po, null, (viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM || isAlternative) && /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledProductNameWrapper */.a2, null, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledProductName */.D, {
        $isAlternative: isAlternative
    }, name)), viewSize >= types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledFlexVertical */.Be, null, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledBadgeWrapper */.oJ, null, /*#__PURE__*/ react.createElement(condition_type_badge/* ConditionTypeBadge */.b, {
        condition: condition
    })), /*#__PURE__*/ react.createElement(StockPriceInfo, null)), viewSize === types/* ViewSize.MINI */.du.MINI && /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledMiniOfferRightContent */.mj, null, /*#__PURE__*/ react.createElement(SelectedOfferTypeBadge, null), /*#__PURE__*/ react.createElement(OfferPriceLabel, {
        container: "h4",
        priceDisplay: price_list_types/* PriceDisplayEnum.PRICE */.wB.PRICE,
        selectedOffer: offer
    })))))), /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledEndColumn */.Y, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(go_to_store_button/* GoToStoreButton */.a, {
        viewSize: viewSize
    }))), /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "click-out-".concat((ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.id, "-").concat(offer.shopOfferId),
        visible: Boolean(showDisabledInfo),
        width: 250,
        horizontalAlign: popover/* Alignment.Center */.v2.Center,
        verticalAlign: viewSize === types/* ViewSize.MINI */.du.MINI ? popover/* Alignment.Start */.v2.Start : popover/* Alignment.Center */.v2.Center,
        onClose: function() {
            return setShowDisabledInfo === null || setShowDisabledInfo === void 0 ? void 0 : setShowDisabledInfo(!showDisabledInfo);
        }
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "transparency.store-info"))));
};

// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(33888);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/flag-outlined/index.js
var flag_outlined = __webpack_require__(40173);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/index.tsx
var report_modal = __webpack_require__(75675);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/alternative-price-row/styles.ts
function alternative_price_row_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function alternative_price_row_styles_templateObject() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n      flex: 2;\n    "
    ]);
    alternative_price_row_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function alternative_price_row_styles_templateObject1() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: stretch;\n\n    ",
        "\n  "
    ]);
    alternative_price_row_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function alternative_price_row_styles_templateObject2() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex-flow: column;\n  transition: opacity ease 0.25s;\n  justify-content: center;\n"
    ]);
    alternative_price_row_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  animation: ",
        " 250ms ease-in-out 1;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  min-height: 100%;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var Column = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(alternative_price_row_styles_templateObject1(), props.expand && (0,styled_components_browser_esm.css)(alternative_price_row_styles_templateObject()));
});
var Options = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Options",
    componentId: "sc-0-1"
})(alternative_price_row_styles_templateObject2());
var Option = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Option",
    componentId: "sc-0-2"
})(styles_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var fadeIn = (0,styled_components_browser_esm.keyframes)(styles_templateObject4());
var ReportOverlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReportOverlay",
    componentId: "sc-0-3"
})(styles_templateObject5(), function(p) {
    return p.theme.text.secondary;
}, fadeIn);
var Dropdown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-4"
})(styles_templateObject6());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/alternative-price-row/options-cloumn.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var OptionsColumn = function(props) {
    var ref, ref1, ref2;
    var className = props.className, isFeatured = props.isFeatured;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var isMobile = (0,react.useContext)(viewport/* ViewportContext */.R).isMobile;
    var ref3 = (0,price_row_context/* usePriceRowContext */.m)(), store = ref3.offer.store, product = ref3.product;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var ref4 = _slicedToArray((0,react.useState)(false), 2), modalIsOpen = ref4[0], setModalIsOpen = ref4[1];
    var openModal = (0,react.useCallback)(function(e) {
        // Stops the PriceRow link and onClick from firing
        e.preventDefault();
        e.stopPropagation();
        setModalIsOpen(true);
    }, [
        setModalIsOpen
    ]);
    var closeModal = (0,react.useCallback)(function() {
        return setModalIsOpen(false);
    }, [
        setModalIsOpen
    ]);
    if (!alternativeOffer) return null;
    return /*#__PURE__*/ react.createElement(Column, {
        className: className
    }, /*#__PURE__*/ react.createElement(report_modal/* ReportModal */.y, {
        isOpen: modalIsOpen,
        closeModal: closeModal,
        priceId: "".concat(store === null || store === void 0 ? void 0 : store.id, "-").concat(alternativeOffer.shopOfferId),
        priceValue: (ref = alternativeOffer.price) === null || ref === void 0 ? void 0 : ref.exclShipping,
        productName: alternativeOffer.name,
        productImage: (ref1 = product.media) === null || ref1 === void 0 ? void 0 : ref1.first,
        stockStatus: (ref2 = alternativeOffer.stock) === null || ref2 === void 0 ? void 0 : ref2.status,
        isFeatured: isFeatured,
        store: store
    }), /*#__PURE__*/ react.createElement(Options, null, /*#__PURE__*/ react.createElement(Dropdown, {
        closeOnItemClick: true,
        onToggle: function(event) {
            event.stopPropagation();
            event.preventDefault();
        }
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        onlyIcon: true,
        size: button_variants.ButtonSize.MEDIUM,
        type: button_variants.ButtonType.TEXT,
        ariaLabel: t("feedback", "dialog.prompt-button")
    }, /*#__PURE__*/ react.createElement(flag_outlined/* IconFlagOutlined */.b, {
        color: "base600",
        size: 18
    })), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        placement: isMobile ? ui/* Direction.Up */.Nm.Up : ui/* Direction.Down */.Nm.Down
    }, /*#__PURE__*/ react.createElement(ReportOverlay, null, /*#__PURE__*/ react.createElement(Option, {
        type: "button",
        onClick: openModal
    }, t("feedback", "dialog.prompt-button")))))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/alternative-price-row/index.tsx









var AlternativePriceRow = function(param) {
    var priceRowRef = param.priceRowRef, handleOnClick = param.handleOnClick;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, viewSize = ref.viewSize;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var externalUri = (alternativeOffer !== null && alternativeOffer !== void 0 ? alternativeOffer : {}).externalUri;
    var isFeatured = (0,product_utils/* getIsFeatured */.ZF)(offer, alternativeOffer);
    if (!alternativeOffer) return null;
    return /*#__PURE__*/ react.createElement(styles/* StyledCard */.rg, {
        $expanded: true,
        $featured: isFeatured,
        $isAlternative: true
    }, /*#__PURE__*/ react.createElement(styles/* Row */.X2, {
        $expanded: true,
        $featured: isFeatured,
        $isAlternative: true,
        $noExternalUri: !externalUri,
        "data-test": "AlternativePriceRow"
    }, viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(OptionsColumn, {
        isFeatured: isFeatured
    }), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(OptionsColumn, {
        isFeatured: isFeatured
    }), isFeatured && alternativeOffer.externalUri && /*#__PURE__*/ react.createElement(FeaturedContent, {
        onClick: handleOnClick
    }), (!isFeatured || !alternativeOffer.externalUri) && /*#__PURE__*/ react.createElement(UnfeaturedContent, {
        priceRowRef: priceRowRef,
        handleOnClick: handleOnClick
    })));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/report-button/index.tsx
var report_button = __webpack_require__(3694);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./src/components/store-payment/utils.ts + 1 modules
var store_payment_utils = __webpack_require__(76672);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/payment-provider/styles.ts
function payment_provider_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function payment_provider_styles_templateObject() {
    var data = payment_provider_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    payment_provider_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function payment_provider_styles_templateObject1() {
    var data = payment_provider_styles_taggedTemplateLiteral([
        "\n  height: ",
        ";\n"
    ]);
    payment_provider_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function payment_provider_styles_templateObject2() {
    var data = payment_provider_styles_taggedTemplateLiteral([
        ""
    ]);
    payment_provider_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var PaymentProviders = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PaymentProviders",
    componentId: "sc-0-0"
})(payment_provider_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var PaymentProviderLogotype = styled_components_browser_esm["default"].img.withConfig({
    displayName: "PaymentProviderLogotype",
    componentId: "sc-0-1"
})(payment_provider_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var PaymentProviderMoreLabel = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "PaymentProviderMoreLabel",
    componentId: "sc-0-2"
})(payment_provider_styles_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/payment-provider/index.tsx





var OfferPaymentProviders = function(param) {
    var store = param.store, showAll = param.showAll, limit = param.limit;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, t = ref.t;
    var paymentProviders = (0,store_payment_utils/* getPaymentProviders */.Qk)(store, market);
    var providers = (0,store_payment_utils/* getGroupedPaymentProviders */._L)(store, market);
    var visibleProviders = providers;
    if (limit && (providers === null || providers === void 0 ? void 0 : providers.length) > limit) {
        visibleProviders = providers.slice(0, limit);
    }
    var invisibleProviders = paymentProviders.providers.filter(function(p) {
        return p.active && !visibleProviders.find(function(v) {
            return v.name === p.name;
        });
    });
    if (!paymentProviders.hasProviders) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("store", "store.payment-options")), /*#__PURE__*/ react.createElement(PaymentProviders, null, showAll && paymentProviders.providers.map(function(provider) {
        return Boolean(provider.active) && /*#__PURE__*/ react.createElement(PaymentProviderLogotype, {
            src: provider.logoUrl,
            alt: provider.label,
            title: provider.label,
            key: provider.name
        });
    }), !showAll && visibleProviders.map(function(provider) {
        return /*#__PURE__*/ react.createElement(PaymentProviderLogotype, {
            src: provider.logoUrl,
            alt: provider.label,
            title: provider.label,
            key: provider.name
        });
    }), !showAll && invisibleProviders.length > 0 && /*#__PURE__*/ react.createElement(PaymentProviderMoreLabel, null, /*#__PURE__*/ react.createElement("span", null, "+"), invisibleProviders.length)));
};

// EXTERNAL MODULE: ./src/areas/product/components/carrier-logos/carrier-logos.tsx
var carrier_logos = __webpack_require__(84333);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/utils.ts
var delivery_methods_utils = __webpack_require__(64701);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/delivery-options/styles.ts
function delivery_options_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function delivery_options_styles_templateObject() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        ""
    ]);
    delivery_options_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject1() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  padding: ",
        " 0;\n\n  > img {\n    width: 48px;\n  }\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    delivery_options_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject2() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n"
    ]);
    delivery_options_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject3() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex-grow: 1;\n"
    ]);
    delivery_options_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject4() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  align-self: baseline;\n"
    ]);
    delivery_options_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject5() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n  max-width: ",
        ";\n"
    ]);
    delivery_options_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject6() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  line-height: 1.2;\n"
    ]);
    delivery_options_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var ShippingOptionList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShippingOptionList",
    componentId: "sc-0-0"
})(delivery_options_styles_templateObject());
var ShippingOptionItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShippingOptionItem",
    componentId: "sc-0-1"
})(delivery_options_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* colors.borderLightGray */.O9.borderLightGray);
var ItemTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ItemTitle",
    componentId: "sc-0-2"
})(delivery_options_styles_templateObject2());
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-0-3"
})(delivery_options_styles_templateObject3());
var StyledBadge = (0,styled_components_browser_esm["default"])(badge.Badge).withConfig({
    displayName: "StyledBadge",
    componentId: "sc-0-4"
})(delivery_options_styles_templateObject4());
var SUSTAINABLE_DESCRIPTION_MAX_WIDTH = "480px";
var StyledSustainableDescription = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSustainableDescription",
    componentId: "sc-0-5"
})(delivery_options_styles_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, SUSTAINABLE_DESCRIPTION_MAX_WIDTH);
var styles_StyledCaptionText = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledCaptionText",
    componentId: "sc-0-6"
})(delivery_options_styles_templateObject6());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/delivery-options/delivery-options.tsx











var DeliveryOptions = function(param) {
    var offer = param.offer;
    var ref, ref1;
    var ref2 = (0,app_context/* useAppContext */.bp)(), market = ref2.market, t = ref2.t;
    var missingInfoText = t("product", "delivery.missing-shipping-information", {
        store: ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.name) || ""
    });
    var deliveryMethodTranslation = function(optionMethod) {
        var deliveryOption = (0,delivery_methods_utils/* getDeliveryMethodsConfig */.m)().find(function(option) {
            return option.type === optionMethod;
        });
        var key = deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.translationString;
        if (!key) {
            return null;
        }
        // @ts-expect-error -- Types too loose
        return t("product", key);
    };
    var getDeliveryInfo = function(node) {
        if (!(node === null || node === void 0 ? void 0 : node.deliveryMethod)) {
            return missingInfoText;
        }
        var carrierText = (node === null || node === void 0 ? void 0 : node.carrier) ? " • ".concat(node.carrier) : "";
        return "".concat(deliveryMethodTranslation((node === null || node === void 0 ? void 0 : node.deliveryMethod) || "")).concat(carrierText);
    };
    var renderShippingOptions = function() {
        var ref;
        var nodes = (ref = offer.unfilteredShippings) === null || ref === void 0 ? void 0 : ref.filter(function(node) {
            return (node === null || node === void 0 ? void 0 : node.carrier) || (node === null || node === void 0 ? void 0 : node.deliveryMethod) === "INSTORE_PICKUP";
        }).sort(function(a, b) {
            var aCarrier = a.carrier || "";
            var bCarrier = b.carrier || "";
            var aShippingCost = (a === null || a === void 0 ? void 0 : a.shippingCost) || 0;
            var bShippingCost = (b === null || b === void 0 ? void 0 : b.shippingCost) || 0;
            return aCarrier.localeCompare(bCarrier) || aShippingCost - bShippingCost;
        });
        if (!nodes || (nodes === null || nodes === void 0 ? void 0 : nodes.length) <= 0) {
            return /*#__PURE__*/ react.createElement(ShippingOptionItem, null, /*#__PURE__*/ react.createElement("img", {
                src: "".concat(market.cdn, "/g/rfe/illustrations/icon-no-shipping-info.svg"),
                alt: "package-icon"
            }), /*#__PURE__*/ react.createElement(TitleWrapper, null, missingInfoText));
        }
        var isInstorePickup = function(shipping) {
            return shipping.deliveryMethod === "INSTORE_PICKUP";
        };
        return nodes === null || nodes === void 0 ? void 0 : nodes.map(function(node, i) {
            var ref, ref1;
            var deliveryDays = {
                min: (node === null || node === void 0 ? void 0 : (ref = node.deliveryDays) === null || ref === void 0 ? void 0 : ref.min) || 0,
                max: (node === null || node === void 0 ? void 0 : (ref1 = node.deliveryDays) === null || ref1 === void 0 ? void 0 : ref1.max) || 0
            };
            return /*#__PURE__*/ react.createElement(ShippingOptionItem, {
                key: i
            }, (0,carrier_logos/* CarrierLogo */.p)(node.carrier || "", isInstorePickup(node)), /*#__PURE__*/ react.createElement(TitleWrapper, null, node.sustainability === price_list_types/* SustainabilityEnum.SUSTAINABLE */.$z.SUSTAINABLE && /*#__PURE__*/ react.createElement(StyledBadge, {
                color: "GREEN",
                icon: leaf/* IconLeaf */.y,
                size: badge.BadgeSize.SMALL,
                text: t("product", "shipping.sustainable")
            }), /*#__PURE__*/ react.createElement(ItemTitle, null, !isInstorePickup(node) && /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
                flex: false
            }, getTranslatedShipping(t, deliveryDays))), /*#__PURE__*/ react.createElement(variants.BodySmallText, null, getDeliveryInfo(node))), /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
                flex: false
            }, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
                price: node === null || node === void 0 ? void 0 : node.shippingCost
            })));
        });
    };
    var hasSustainableDeliveryOptions = Boolean((ref1 = offer.shipping) === null || ref1 === void 0 ? void 0 : ref1.nodes.find(function(node) {
        return node.sustainability === price_list_types/* SustainabilityEnum.SUSTAINABLE */.$z.SUSTAINABLE;
    }));
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("store", "store.delivery-options")), hasSustainableDeliveryOptions && /*#__PURE__*/ react.createElement(StyledSustainableDescription, null, /*#__PURE__*/ react.createElement(StyledBadge, {
        color: "GREEN",
        icon: leaf/* IconLeaf */.y,
        size: badge.BadgeSize.SMALL,
        text: t("product", "shipping.sustainable")
    }), /*#__PURE__*/ react.createElement(styles_StyledCaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, t("product", "shipping.sustainable-description"))), /*#__PURE__*/ react.createElement(ShippingOptionList, null, renderShippingOptions()));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/delivery-options/index.tsx



;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/recommended-retailer/styles.ts
function recommended_retailer_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function recommended_retailer_styles_templateObject() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    display: inline-flex;\n    flex-direction: column;\n    margin-bottom: ",
        ";\n  "
    ]);
    recommended_retailer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject1() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  align-self: flex-start;\n"
    ]);
    recommended_retailer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject2() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    recommended_retailer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject3() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  column-gap: ",
        ";\n  margin-left: -",
        ";\n"
    ]);
    recommended_retailer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject4() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    recommended_retailer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject5() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  margin: ",
        " 0;\n"
    ]);
    recommended_retailer_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var BRAND_LOGO_WIDTH = 88;
var BRAND_LOGO_HEIGHT = 31;
var RecommendedRetailerExpansion = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RecommendedRetailerExpansion",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(recommended_retailer_styles_templateObject(), props.theme.text.secondary, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
});
var LogoWrapper = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "LogoWrapper",
    componentId: "sc-0-1"
})(recommended_retailer_styles_templateObject1());
var Logo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Logo",
    componentId: "sc-0-2"
})(recommended_retailer_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, BRAND_LOGO_WIDTH, BRAND_LOGO_HEIGHT);
var IconAndTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconAndTextWrapper",
    componentId: "sc-0-3"
})(recommended_retailer_styles_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Text = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Text",
    componentId: "sc-0-4"
})(recommended_retailer_styles_templateObject4());
var StyledAuthorizedDealerBadge = (0,styled_components_browser_esm["default"])(AuthorizedDealerBadge).withConfig({
    displayName: "StyledAuthorizedDealerBadge",
    componentId: "sc-0-5"
})(recommended_retailer_styles_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/recommended-retailer/index.tsx



var RecommendedRetailer = /*#__PURE__*/ (0,react.memo)(function(props) {
    var brandName = props.brandName, logo = props.logo, pathName = props.pathName, id = props.id;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, logo && /*#__PURE__*/ react.createElement(LogoWrapper, {
        to: linkTo("brand", {
            pathName: pathName,
            id: id
        })
    }, /*#__PURE__*/ react.createElement(Logo, {
        src: logo,
        alt: brandName
    })), /*#__PURE__*/ react.createElement(StyledAuthorizedDealerBadge, {
        noTooltip: true
    }));
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/store-info-list/styles.ts
function store_info_list_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_info_list_styles_templateObject() {
    var data = store_info_list_styles_taggedTemplateLiteral([
        "\n  list-style-position: inside;\n  margin-bottom: ",
        ";\n"
    ]);
    store_info_list_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function store_info_list_styles_templateObject1() {
    var data = store_info_list_styles_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ]);
    store_info_list_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledStoreInfoList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "StyledStoreInfoList",
    componentId: "sc-0-0"
})(store_info_list_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledStoreInfoText = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledStoreInfoText",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(store_info_list_styles_templateObject1(), props.theme.text.secondary);
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/store-info-list/index.tsx


var StoreInfoList = /*#__PURE__*/ react.memo(function(param) {
    var storeInfo = param.storeInfo;
    return storeInfo && storeInfo.length && storeInfo.filter(function(item) {
        return item;
    }).length ? /*#__PURE__*/ react.createElement(StyledStoreInfoList, null, storeInfo.map(function(value, index) {
        return /*#__PURE__*/ react.createElement(StyledStoreInfoText, {
            // eslint-disable-next-line react/no-array-index-key
            key: "store-info-".concat(index)
        }, /*#__PURE__*/ react.createElement("span", null, value));
    })) : null;
}, function(param, param1) {
    var prevStoreInfo = param.storeInfo, nextStoreInfo = param1.storeInfo;
    if (!prevStoreInfo && !nextStoreInfo) {
        return true;
    }
    if (!prevStoreInfo && nextStoreInfo || prevStoreInfo && !nextStoreInfo || (prevStoreInfo === null || prevStoreInfo === void 0 ? void 0 : prevStoreInfo.length) !== (nextStoreInfo === null || nextStoreInfo === void 0 ? void 0 : nextStoreInfo.length)) {
        return false;
    }
    if (prevStoreInfo && nextStoreInfo) {
        return prevStoreInfo.every(function(value, i) {
            return value === nextStoreInfo[i];
        });
    }
    return false;
});

// EXTERNAL MODULE: ./src/globals/helpers/format-number.ts
var format_number = __webpack_require__(4398);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/store-reviews/styles.ts
function store_reviews_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_reviews_styles_templateObject() {
    var data = store_reviews_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: ",
        ";\n"
    ]);
    store_reviews_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function store_reviews_styles_templateObject1() {
    var data = store_reviews_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    store_reviews_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function store_reviews_styles_templateObject2() {
    var data = store_reviews_styles_taggedTemplateLiteral([
        "\n  margin: 0 ",
        ";\n"
    ]);
    store_reviews_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledStoreReviews = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledStoreReviews",
    componentId: "sc-0-0"
})(store_reviews_styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledStoreLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledStoreLink",
    componentId: "sc-0-1"
})(store_reviews_styles_templateObject1(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, ui_text.FontWeight.HEAVIER, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var StyledSeparator = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledSeparator",
    componentId: "sc-0-2"
})(store_reviews_styles_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/store-reviews/index.tsx







var StoreReviews = function(props) {
    var reviewCount = props.reviewCount, storeLink = props.storeLink;
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var featured = offer.featured, rating = offer.rating;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    return /*#__PURE__*/ react.createElement(StyledStoreReviews, null, rating && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(smiley_rating/* default */.Z, {
        featured: featured,
        rating: rating,
        scoreVisibility: "row"
    }), /*#__PURE__*/ react.createElement(StyledSeparator, null, "|")), /*#__PURE__*/ react.createElement(StyledStoreLink, {
        to: storeLink,
        "aria-label": t("reviews", "rating.n-reviews", {
            n: reviewCount,
            count: (0,format_number/* default */.Z)(reviewCount, market.code)
        }),
        "data-test": "StoreInfoLink",
        tabIndex: 0,
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.STORE_REVIEW */.U.STORE_REVIEW,
                nextPage: storeLink
            });
        }
    }, t("reviews", "rating.n-reviews", {
        n: reviewCount,
        count: (0,format_number/* default */.Z)(reviewCount, market.code)
    })));
};

// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/membership-info/tracking.ts

var trackMembershipReadMoreClicked = function(name, externalUrl, productId) {
    (0,data_layer/* pushEvent */.A)("membershipReadMoreClicked", {
        name: name,
        externalUrl: externalUrl,
        productId: productId
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/membership-info/styles.ts
function membership_info_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function membership_info_styles_templateObject() {
    var data = membership_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  svg {\n    margin-left: ",
        ";\n\n    > path {\n      fill: ",
        ";\n    }\n\n    :hover {\n      color: ",
        ";\n\n      svg > path {\n        fill: ",
        ";\n      }\n    }\n  }\n"
    ]);
    membership_info_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function membership_info_styles_templateObject1() {
    var data = membership_info_styles_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    margin-right: ",
        ";\n  "
    ]);
    membership_info_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function membership_info_styles_templateObject2() {
    var data = membership_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    membership_info_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var MembershipLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "MembershipLink",
    componentId: "sc-0-0"
})(membership_info_styles_templateObject(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, variants.FontWeight.HEAVIER, function(p) {
    return p.theme.text.callToAction;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var MembershipInfoText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "MembershipInfoText",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(membership_info_styles_templateObject1(), props.theme.text.secondary, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var InfoLinkWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InfoLinkWrapper",
    componentId: "sc-0-2"
})(membership_info_styles_templateObject2());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(89975);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/membership-info/index.tsx







var MembershipInfo = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref4.offer, product = ref4.product;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var hasMemberPriceOffer = ((ref = offer.offerPrices) === null || ref === void 0 ? void 0 : ref.memberPrice) || ((ref1 = offer.alternativePrices) === null || ref1 === void 0 ? void 0 : ref1.map(function(alt) {
        var ref;
        return alt === null || alt === void 0 ? void 0 : (ref = alt.offerPrices) === null || ref === void 0 ? void 0 : ref.memberPrice;
    }).some(function(isTrue) {
        return isTrue;
    }));
    if (!hasMemberPriceOffer) {
        return null;
    }
    var isFree = !((ref2 = offer.membershipProgram) === null || ref2 === void 0 ? void 0 : ref2.requiresCompensation);
    var name = ((ref3 = offer.membershipProgram) === null || ref3 === void 0 ? void 0 : ref3.name) || t("product", "promotions.membership");
    var readMore = t("product", "transparency.read-more");
    var membershipText = isFree ? t("product", "promotions.membership-name-price-info-free", {
        name: name
    }) : t("product", "promotions.membership-name-price-info", {
        name: name
    });
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("product", "promotions.membership")), /*#__PURE__*/ react.createElement(InfoLinkWrapper, null, /*#__PURE__*/ react.createElement(MembershipInfoText, null, membershipText), offer.membershipLink && /*#__PURE__*/ react.createElement(MembershipLink, {
        to: {
            pathname: offer.membershipLink
        },
        target: "_blank",
        "aria-label": readMore,
        "data-test": "MembershipLink",
        tabIndex: 0,
        onClick: function() {
            var ref;
            return trackMembershipReadMoreClicked(((ref = offer.membershipProgram) === null || ref === void 0 ? void 0 : ref.name) || "", offer.membershipLink || "", product.id);
        }
    }, readMore, /*#__PURE__*/ react.createElement(outgoing_link/* IconOutgoingLink */.v, null))));
};

// EXTERNAL MODULE: ./src/components/location-and-currency-info/index.tsx + 3 modules
var location_and_currency_info = __webpack_require__(7351);
// EXTERNAL MODULE: ./src/areas/store/components/soty-badge-link/soty-badge/index.tsx + 1 modules
var soty_badge = __webpack_require__(47557);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/styles.ts
function store_info_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_info_styles_templateObject() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    store_info_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject1() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n"
    ]);
    store_info_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject2() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: ",
        ";\n  > svg > path {\n    fill: currentColor;\n  }\n"
    ]);
    store_info_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject3() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  grid-area: 2 / 1 / 3 / 3;\n  display: flex;\n  flex-direction: column;\n  > h4,\n  > div > h4 {\n    margin-top: ",
        ";\n  }\n"
    ]);
    store_info_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject4() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  align-items: baseline;\n"
    ]);
    store_info_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject5() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n      max-width: 88px;\n    "
    ]);
    store_info_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject6() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  margin: ",
        ";\n  align-items: normal;\n\n  ",
        "\n"
    ]);
    store_info_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var StyledExpandedInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledExpandedInfo",
    componentId: "sc-0-0"
})(store_info_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledFirstSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFirstSection",
    componentId: "sc-0-1"
})(store_info_styles_templateObject1());
var styles_StyledStoreLink = (0,styled_components_browser_esm["default"])(variants.H4Text).withConfig({
    displayName: "StyledStoreLink",
    componentId: "sc-0-2"
})(store_info_styles_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledGeneralInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledGeneralInfo",
    componentId: "sc-0-3"
})(store_info_styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledLocationAndCurrencyInfo = (0,styled_components_browser_esm["default"])(location_and_currency_info/* default */.Z).withConfig({
    displayName: "StyledLocationAndCurrencyInfo",
    componentId: "sc-0-4"
})(store_info_styles_templateObject4());
var StyledSotyBadge = (0,styled_components_browser_esm["default"])(soty_badge/* SotyBadge */.L).withConfig({
    displayName: "StyledSotyBadge",
    componentId: "sc-0-5"
})(store_info_styles_templateObject6(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(props) {
    return props.$viewSize === types/* ViewSize.SMALL */.du.SMALL && (0,styled_components_browser_esm.css)(store_info_styles_templateObject5());
});

// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/styles.ts
var our_choice_styles = __webpack_require__(74887);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/our-choice/info-text.tsx




var OurChoiceInfoText = function() {
    var ref;
    var ref1 = (0,app_context/* useAppContext */.bp)(), t = ref1.t, market = ref1.market;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("product", "prices.our-choice")), /*#__PURE__*/ react.createElement("p", null, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "prices.our-choice-explanation")), " ", /*#__PURE__*/ react.createElement(our_choice_styles/* StyleUnderlinedInfoPageLink */.BR, {
        id: (ref = market.infoPageMap) === null || ref === void 0 ? void 0 : ref.priceInformation
    }, t("common", "button.read-more"))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/index.tsx














var store_info_StoreInfo = function(props) {
    var ref;
    var sotyBadge = props.sotyBadge;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref1.offer, product = ref1.product, viewSize = ref1.viewSize, isOurChoice = ref1.isOurChoice;
    var authorizedDealer = offer.authorizedDealer, store = offer.store, storeInfo = offer.storeInfo;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!store) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledExpandedInfo, null, /*#__PURE__*/ react.createElement(StyledFirstSection, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(styles_StyledStoreLink, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: store.pathName,
            title: store.name,
            "data-test": "StoreInfoLink",
            "aria-label": t("product", "store-info.more-about-store", {
                store_name: store.name
            }),
            tabIndex: 0,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.STORE_GO_TO */.U.STORE_GO_TO,
                    nextPage: store.pathName
                });
            }
        }
    }, store.name, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null)), store.userReviewSummary.countTotal && store.userReviewSummary.countTotal > 0 ? /*#__PURE__*/ react.createElement(StoreReviews, {
        reviewCount: store.userReviewSummary.countTotal,
        storeLink: store.pathName
    }) : null, /*#__PURE__*/ react.createElement(StoreInfoList, {
        storeInfo: storeInfo
    })), (sotyBadge === null || sotyBadge === void 0 ? void 0 : sotyBadge.logo) ? /*#__PURE__*/ react.createElement(StyledSotyBadge, {
        imgUrl: sotyBadge.logo,
        name: sotyBadge.name,
        year: (ref = sotyBadge.year) === null || ref === void 0 ? void 0 : ref.toString(),
        $viewSize: viewSize
    }) : null), /*#__PURE__*/ react.createElement(StyledGeneralInfo, null, /*#__PURE__*/ react.createElement(StyledLocationAndCurrencyInfo, {
        countryCode: store.countryCode,
        countryName: store.countryName,
        currency: store.currency,
        marketplace: Boolean(store.marketplace),
        id: "".concat(store.id.toString(), "-").concat(offer.shopOfferId),
        storeName: store.name,
        minify: true,
        textSize: "small"
    }), isOurChoice && /*#__PURE__*/ react.createElement(OurChoiceInfoText, null), authorizedDealer && product.brand && offer.store && /*#__PURE__*/ react.createElement(RecommendedRetailer, {
        id: product.brand.id,
        pathName: product.brand.pathName,
        logo: product.brand.logo,
        brandName: product.brand.name,
        storeName: offer.store.name
    }), /*#__PURE__*/ react.createElement(MembershipInfo, null), /*#__PURE__*/ react.createElement(OfferPaymentProviders, {
        store: store,
        showAll: true
    }), !offer.mobileContract && /*#__PURE__*/ react.createElement(DeliveryOptions, {
        offer: offer
    })));
};

// EXTERNAL MODULE: ./src/areas/product/styles.tsx
var product_styles = __webpack_require__(29813);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/alternative-contract-row/index.tsx




var AlternativeContractRow = function(param) {
    var handleOnClick = param.handleOnClick;
    var alternativeContract = useAlternativePriceRowContext().alternativeContract;
    if (!alternativeContract) return null;
    var externalUri = alternativeContract.externalUri;
    return /*#__PURE__*/ react.createElement(styles/* StyledCard */.rg, {
        $expanded: true,
        $featured: true,
        $isAlternative: true
    }, /*#__PURE__*/ react.createElement(styles/* Row */.X2, {
        $expanded: true,
        $featured: true,
        $isAlternative: true,
        $noExternalUri: !externalUri,
        "data-test": "AlternativeContractRow"
    }, externalUri && /*#__PURE__*/ react.createElement(FeaturedContent, {
        onClick: handleOnClick
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/info-modal/index.tsx
function info_modal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function info_modal_templateObject() {
    var data = info_modal_taggedTemplateLiteral([
        "\n  && {\n    overflow-y: scroll;\n    max-height: 90vh;\n  }\n"
    ]);
    info_modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function info_modal_templateObject1() {
    var data = info_modal_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n"
    ]);
    info_modal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function info_modal_templateObject2() {
    var data = info_modal_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    info_modal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function info_modal_templateObject3() {
    var data = info_modal_taggedTemplateLiteral([
        "\n  padding-bottom: ",
        ";\n"
    ]);
    info_modal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var InfoModal = function(props) {
    var ref;
    var closeModal = props.closeModal, closeReportOverlay = props.closeReportOverlay, isOpen = props.isOpen, priceRowReport = props.priceRowReport, reportRowId = props.reportRowId, sotyBadge = props.sotyBadge, handleOnClick = props.handleOnClick, handleMobileContractClickOut = props.handleMobileContractClickOut;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var alternativePrices = offer.alternativePrices;
    var alternativeContracts = (ref = offer.mobileContract) === null || ref === void 0 ? void 0 : ref.alternativeContracts;
    return /*#__PURE__*/ react.createElement(StyledModal, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        shouldShowCloseIcon: true,
        width: 526
    }, /*#__PURE__*/ react.createElement(StyledContainer, null, /*#__PURE__*/ react.createElement(store_info_StoreInfo, {
        sotyBadge: sotyBadge
    }), alternativePrices ? /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledVariantTitle, null, t("product", "price.variants-title")), alternativePrices.map(function(altPrice) {
        if (!altPrice) return null;
        return /*#__PURE__*/ react.createElement(AlternativePriceRowContextContainer, {
            alternativeOffer: altPrice,
            key: altPrice.shopOfferId
        }, /*#__PURE__*/ react.createElement(AlternativePriceRowWrapper, null, /*#__PURE__*/ react.createElement(AlternativePriceRow, {
            handleOnClick: function(e) {
                return handleOnClick(e, altPrice);
            }
        }), priceRowReport === types/* ReportRowType.ALTERNATIVE */.Zu.ALTERNATIVE && reportRowId === altPrice.id && /*#__PURE__*/ react.createElement(report_button/* ReportButton */.f, {
            priceId: altPrice.id,
            priceValue: altPrice.price && altPrice.price.exclShipping,
            stockStatus: altPrice.stock && altPrice.stock.status,
            onClose: closeReportOverlay,
            productName: altPrice.name,
            isAlternative: true
        })));
    })) : null, alternativeContracts && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledVariantTitle, null, t("product", "price.variants-title")), alternativeContracts.map(function(altContract) {
        if (!altContract) return null;
        return /*#__PURE__*/ react.createElement(AlternativePriceRowContextContainer, {
            key: altContract.contractId,
            alternativeContract: altContract
        }, /*#__PURE__*/ react.createElement(AlternativePriceRowWrapper, null, /*#__PURE__*/ react.createElement(AlternativeContractRow, {
            handleOnClick: function(e) {
                return handleMobileContractClickOut(e, altContract);
            }
        })));
    }))));
};
var StyledModal = (0,styled_components_browser_esm["default"])(product_styles/* Modal */.u_).withConfig({
    displayName: "StyledModal",
    componentId: "sc-0-0"
})(info_modal_templateObject());
var StyledContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContainer",
    componentId: "sc-0-1"
})(info_modal_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var AlternativePriceRowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AlternativePriceRowWrapper",
    componentId: "sc-0-2"
})(info_modal_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledVariantTitle = (0,styled_components_browser_esm["default"])(variants.H4Text).withConfig({
    displayName: "StyledVariantTitle",
    componentId: "sc-0-3"
})(info_modal_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(15287);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/requests.ts

var fetchSotyAwardsByStoreId = function(id) {
    return (0,requests/* graphql */.BX)("\n      query storePage($id: Int!) {\n        store(id: $id) {\n          id\n          name\n          storeOfTheYearAwards {\n            id\n            name\n            resourceName\n            logo\n            year\n            mainAward\n            isSpecial\n            isPrimary\n          }\n        }\n      }\n    ", {
        id: id
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(51676);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(42574);
// EXTERNAL MODULE: ./src/components/cdn-image/index.tsx
var cdn_image = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/components/product-card-old/components/new-click-out-button.tsx
var new_click_out_button = __webpack_require__(6036);
// EXTERNAL MODULE: ./src/utils/click-out-bounce-helper.ts
var click_out_bounce_helper = __webpack_require__(40757);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var actions_product = __webpack_require__(69140);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts + 1 modules
var conversion = __webpack_require__(23513);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/tracking.ts




var handlePromotionModalClickout = function(offer, product, showUsedOffers, dispatch) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    if (!offer.shopOfferId || !offer.externalUri) return;
    var _condition;
    var dispatchParams = (0,actions_product/* productPriceClick */.Po)(product.id, offer, true, "", false, "PromotionModal", (ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status, (_condition = offer.condition) !== null && _condition !== void 0 ? _condition : product_condition_types/* ConditionEnum.NEW */.M.NEW);
    dispatch(dispatchParams);
    var condition = showUsedOffers && offer.condition ? offer.condition : undefined;
    var isInternational = ((ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.market) === "secondary";
    var isPjDeal = ((ref2 = product.dealInfo) === null || ref2 === void 0 ? void 0 : ref2.dealPercentage) ? true : undefined;
    var stockStatus = (0,conversion/* mapStockStatusToGTMStockStatus */._L)((ref3 = offer.stock) === null || ref3 === void 0 ? void 0 : ref3.status);
    var priceType = "regular";
    if ((ref4 = offer.offerPrices) === null || ref4 === void 0 ? void 0 : ref4.memberPrice) {
        priceType = "member";
    } else if ((ref5 = offer.offerPrices) === null || ref5 === void 0 ? void 0 : ref5.originalPrice) {
        priceType = "sale";
    }
    (0,conversion/* trackOfferClickWithRevenue */.Rx)({
        scope: conversion/* TrackClickScope.PROMOTION_MODAL */.b8.PROMOTION_MODAL,
        offerId: "".concat((ref6 = offer.store) === null || ref6 === void 0 ? void 0 : ref6.id, "-").concat(offer.shopOfferId),
        isRawOffer: false,
        condition: condition,
        hasShippingInfo: ((ref7 = offer.shipping) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.nodes) === null || ref8 === void 0 ? void 0 : ref8.length) ? true : undefined,
        isInternational: isInternational ? true : undefined,
        isPartOfPromotion: true,
        isPjDeal: isPjDeal,
        priceType: priceType,
        stockStatus: stockStatus
    });
};
var trackInternalPromotionLinkClick = function(url) {
    var trackingData = {
        scope: tracking/* InternalNavigationScope.PROMOTION_MODAL */.U.PROMOTION_MODAL,
        nextPage: url
    };
    (0,tracking/* trackInternalNavigationClick */.p)(trackingData);
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/styles.ts
function promotion_modal_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function promotion_modal_styles_templateObject() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    border-radius: 5px;\n  "
    ]);
    promotion_modal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject1() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  padding: 0;\n\n  ",
        "\n"
    ]);
    promotion_modal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject2() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        ";\n  gap: ",
        ";\n"
    ]);
    promotion_modal_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject3() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.2);\n"
    ]);
    promotion_modal_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject4() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n  background: ",
        ";\n  padding: ",
        ";\n  border-radius: 8px;\n  box-shadow: 0px 2px 4px 0px rgba(5, 37, 46, 0.24);\n"
    ]);
    promotion_modal_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject5() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    promotion_modal_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject6() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    promotion_modal_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  text-overflow: ellipsis;\n  /* stylelint-disable value-no-vendor-prefix  */\n  display: -webkit-box;\n  /* stylelint-disable property-no-vendor-prefix */\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  line-height: 20px;\n  gap: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  object-fit: cover;\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  background: ",
        ";\n  height: fit-content;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n    flex-direction: column;\n    gap: ",
        ";\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}







var StyledModalBody = (0,styled_components_browser_esm["default"])(modal/* ModalBody */.fe).withConfig({
    displayName: "StyledModalBody",
    componentId: "sc-0-0"
})(promotion_modal_styles_templateObject1(), base/* media.largeUp */.BC.largeUp(promotion_modal_styles_templateObject()));
var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-1"
})(promotion_modal_styles_templateObject2(), design_tokens.measurements.spacing100, design_tokens.measurements.spacing100);
var StyledPlaceholderImg = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPlaceholderImg",
    componentId: "sc-0-2"
})(promotion_modal_styles_templateObject3());
var StyledLogoImg = (0,styled_components_browser_esm["default"])(cdn_image/* CdnImage */.l).withConfig({
    displayName: "StyledLogoImg",
    componentId: "sc-0-3"
})(promotion_modal_styles_templateObject4(), design_tokens.measurements.spacing100, design_tokens.measurements.spacing100, function(p) {
    return p.theme.colors.base0;
}, design_tokens.measurements.spacing050);
var StyledButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledButtonWrapper",
    componentId: "sc-0-4"
})(promotion_modal_styles_templateObject5(), design_tokens.measurements.spacing050);
var StyledOutlinedButton = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).withConfig({
    displayName: "StyledOutlinedButton",
    componentId: "sc-0-5"
})(promotion_modal_styles_templateObject6());
var StyledDescription = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "StyledDescription",
    componentId: "sc-0-6"
})(styles_templateObject7());
var StyledIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledIconWrapper",
    componentId: "sc-0-7"
})(_templateObject8(), design_tokens.measurements.spacing050);
var StyledPromotionImg = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledPromotionImg",
    componentId: "sc-0-8"
})(_templateObject10(), base/* media.largeUp */.BC.largeUp(_templateObject9()));
var StyledImgWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledImgWrapper",
    componentId: "sc-0-9"
})(_templateObject11(), function(p) {
    return p.theme.colors.base200;
});
var StyledDetails = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDetails",
    componentId: "sc-0-10"
})(_templateObject13(), design_tokens.measurements.spacing100, base/* media.mediumUp */.BC.mediumUp(_templateObject12(), design_tokens.measurements.spacing025));
var StyledFooterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFooterWrapper",
    componentId: "sc-0-11"
})(_templateObject14(), design_tokens.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/promotion-buttons.tsx










var PromotionButtons = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), linkTo = ref.linkTo, t = ref.t;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref1.offer, product = ref1.product, showUsedOffers = ref1.showUsedOffers;
    var externalUri = offer.externalUri, promotion = offer.promotion;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleClickOut = function() {
        handlePromotionModalClickout(offer, product, showUsedOffers, dispatch);
        (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
    };
    var handleBounce = function() {
        var ref, ref1;
        dispatch((0,actions_product/* productClickOutBounce */.nA)({
            productId: product.id,
            offerId: "".concat((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id, "-").concat(offer.shopOfferId),
            storeName: (ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.name
        }));
    };
    if (!promotion) return null;
    var linkToPromotionPage = linkTo("promotions", promotion);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledOutlinedButton, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: linkToPromotionPage
        },
        onClick: function() {
            return trackInternalPromotionLinkClick(linkToPromotionPage);
        }
    }, t("product", "property.show-more")), externalUri && /*#__PURE__*/ react.createElement(StyledButtonWrapper, null, /*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
        onClick: handleClickOut,
        external: true,
        href: externalUri,
        text: t("product", "external-link.view-product")
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/schedule/index.js
var schedule = __webpack_require__(87383);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/inventory/index.js
var inventory = __webpack_require__(3242);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotion-products-page/utils/index.ts
var promotion_products_page_utils = __webpack_require__(97620);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/promotion-info.tsx










var PromotionInfo = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var promotion = offer.promotion;
    if (!promotion) return null;
    var timeSpan = (0,promotion_products_page_utils/* getPromotionTimespan */.R)(promotion, t, market.localeStandard);
    return /*#__PURE__*/ react.createElement(StyledContent, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "promotion.from-shop", {
        shop: promotion.owner.name
    })), /*#__PURE__*/ react.createElement(variants.H2Text, null, promotion.title), /*#__PURE__*/ react.createElement(StyledDetails, null, promotion.startDate && promotion.endDate && /*#__PURE__*/ react.createElement(StyledIconWrapper, null, /*#__PURE__*/ react.createElement(schedule/* IconSchedule */.c, {
        size: 16
    }), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.HIGH
    }, timeSpan.long)), promotion.numberOfProducts && /*#__PURE__*/ react.createElement(StyledIconWrapper, null, /*#__PURE__*/ react.createElement(inventory/* IconInventory */.h, {
        size: 16
    }), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.HIGH
    }, t("campaigns", "deals.n-products-subtitle", {
        n: promotion.numberOfProducts
    }))))), promotion.description && /*#__PURE__*/ react.createElement(StyledDescription, null, promotion.description), isDesktop ? /*#__PURE__*/ react.createElement(PromotionButtons, null) : null, /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, t("product", "promotion.paying-shop", {
        shop: promotion.owner.name
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/index.tsx










var PromotionModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var promotion = offer.promotion;
    if (!promotion) return null;
    return /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: isOpen,
        onRequestClose: onClose,
        style: isDesktop ? {
            content: {
                maxWidth: "800px"
            }
        } : undefined
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledModalBody, null, promotion.imageUrl ? /*#__PURE__*/ react.createElement(StyledImgWrapper, null, /*#__PURE__*/ react.createElement(StyledPromotionImg, {
        src: promotion.imageUrl,
        alt: ""
    })) : /*#__PURE__*/ react.createElement(StyledPlaceholderImg, null, /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
        name: promotion.owner.id,
        width: constants/* SHOP_LOGO_WIDTH */.L9,
        alt: promotion.owner.name,
        logoType: promotion.owner.type
    })), /*#__PURE__*/ react.createElement(PromotionInfo, null), promotion.imageUrl === undefined && /*#__PURE__*/ react.createElement(StyledLogoImg, {
        name: promotion.owner.id,
        width: constants/* SHOP_LOGO_WIDTH_SMALL */.jr,
        alt: promotion.owner.name,
        logoType: promotion.owner.type
    })), isDesktop ? null : /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(StyledFooterWrapper, null, /*#__PURE__*/ react.createElement(PromotionButtons, null)))));
};

;// CONCATENATED MODULE: ./src/globals/tracking/modal.ts

var trackModalOpenEvent = function(data) {
    (0,data_layer/* pushEvent */.A)("modal_open", {
        scope: data.scope,
        type: data.type
    });
};
var TrackModalScope;
(function(TrackModalScope) {
    TrackModalScope["PRICE_LIST"] = "product_price_list";
})(TrackModalScope || (TrackModalScope = {}));
var TrackModalType;
(function(TrackModalType) {
    TrackModalType["PROMOTION"] = "promotion";
})(TrackModalType || (TrackModalType = {}));

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/styles.ts
function promotion_bar_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function promotion_bar_styles_templateObject() {
    var data = promotion_bar_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n  background: ",
        ";\n  padding: ",
        " ",
        ";\n  box-shadow: 0 0 0 1px ",
        ";\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  width: 100%;\n  transition: box-shadow 200ms ease;\n\n  &:hover {\n    box-shadow: 0 2px 10px 0 rgb(0, 0, 0, 0.1);\n  }\n"
    ]);
    promotion_bar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function promotion_bar_styles_templateObject1() {
    var data = promotion_bar_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  flex: 0 1 auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"
    ]);
    promotion_bar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledSection = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledSection",
    componentId: "sc-0-0"
})(promotion_bar_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.yellove100;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.colors.base200;
});
var StyledText = (0,styled_components_browser_esm["default"])(variants.CaptionStrongText).withConfig({
    displayName: "StyledText",
    componentId: "sc-0-1"
})(promotion_bar_styles_templateObject1(), function(p) {
    return p.theme.colors.base900;
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/index.tsx
function promotion_bar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function promotion_bar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function promotion_bar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function promotion_bar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function promotion_bar_slicedToArray(arr, i) {
    return promotion_bar_arrayWithHoles(arr) || promotion_bar_iterableToArrayLimit(arr, i) || promotion_bar_unsupportedIterableToArray(arr, i) || promotion_bar_nonIterableRest();
}
function promotion_bar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return promotion_bar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return promotion_bar_arrayLikeToArray(o, minLen);
}







var PromotionBar = function() {
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var ref = promotion_bar_slicedToArray((0,react.useState)(false), 2), modalOpen = ref[0], setModalOpen = ref[1];
    if (!offer.promotion) return null;
    var handleOnClick = function() {
        setModalOpen(true);
        trackModalOpenEvent({
            scope: TrackModalScope.PRICE_LIST,
            type: TrackModalType.PROMOTION
        });
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, modalOpen && /*#__PURE__*/ react.createElement(PromotionModal, {
        isOpen: modalOpen,
        onClose: function() {
            return setModalOpen(false);
        }
    }), /*#__PURE__*/ react.createElement(StyledSection, {
        onClick: handleOnClick
    }, /*#__PURE__*/ react.createElement(StyledText, {
        emphasis: ui_text.FontEmphasis.HIGH
    }, offer.promotion.title), /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        color: "base900",
        size: 16
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/regular/styles.ts
function regular_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function regular_styles_templateObject() {
    var data = regular_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n\n  padding: 0.75rem;\n  padding-top: 0;\n\n  > div {\n    box-shadow: rgb(230 232 234) 0px 0px 0px 1px;\n  }\n"
    ]);
    regular_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function regular_styles_templateObject1() {
    var data = regular_styles_taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    regular_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function regular_styles_templateObject2() {
    var data = regular_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n"
    ]);
    regular_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function regular_styles_templateObject3() {
    var data = regular_styles_taggedTemplateLiteral([
        "\n      border-bottom-left-radius: 0;\n    "
    ]);
    regular_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function regular_styles_templateObject4() {
    var data = regular_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: stretch;\n    justify-content: center;\n    width: 40px;\n\n    border-right: 1px solid ",
        ";\n    border-top-left-radius: 8px;\n    border-bottom-left-radius: 8px;\n\n    transition: background-color ",
        ";\n    background-color: transparent;\n\n    &:hover {\n      background-color: ",
        ";\n    }\n\n    ",
        "\n  "
    ]);
    regular_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledAlternativePricesArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledAlternativePricesArea",
    componentId: "sc-0-0"
})(regular_styles_templateObject(), function(props) {
    return props.theme.colors.base100;
});
var styles_StyledVariantTitle = (0,styled_components_browser_esm["default"])(variants.H4Text).withConfig({
    displayName: "StyledVariantTitle",
    componentId: "sc-0-1"
})(regular_styles_templateObject1(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledInfoRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledInfoRow",
    componentId: "sc-0-2"
})(regular_styles_templateObject2(), function(props) {
    return props.theme.colors.base100;
});
var StyledExpandButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledExpandButtonWrapper",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(regular_styles_templateObject4(), props.theme.colors.staticBase200, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, props.theme.colors.base100, props.$expanded && (0,styled_components_browser_esm.css)(regular_styles_templateObject3()));
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/regular/index.tsx
function regular_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function regular_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function regular_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function regular_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function regular_slicedToArray(arr, i) {
    return regular_arrayWithHoles(arr) || regular_iterableToArrayLimit(arr, i) || regular_unsupportedIterableToArray(arr, i) || regular_nonIterableRest();
}
function regular_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return regular_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return regular_arrayLikeToArray(o, minLen);
}




















var RegularPriceRow = function(props) {
    var ref;
    var onClickOutBounce = props.onClickOutBounce, onPriceClick = props.onPriceClick, className = props.className, setShowOurChoicePopover = props.setShowOurChoicePopover;
    var ref1 = regular_slicedToArray((0,react.useState)(false), 2), showDisabledInfo = ref1[0], setShowDisabledInfo = ref1[1];
    var ref2 = regular_slicedToArray((0,react.useState)(false), 2), expanded = ref2[0], setExpanded = ref2[1];
    var ref3 = regular_slicedToArray((0,react.useState)(types/* ReportRowType.NONE */.Zu.NONE), 2), priceRowReport = ref3[0], setPriceRowReport = ref3[1];
    var ref4 = regular_slicedToArray((0,react.useState)(), 2), sotyBadge = ref4[0], setSotyBadge = ref4[1];
    var ref5 = regular_slicedToArray((0,react.useState)(null), 2), reportRowId = ref5[0], setReportRowId = ref5[1];
    var ref6 = regular_slicedToArray((0,react.useState)(false), 2), infoModalOpen = ref6[0], setInfoModalOpen = ref6[1];
    var priceRowRef = (0,react.useRef)(null);
    var ref7 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref7.offer, product = ref7.product, isInPriceList = ref7.isInPriceList, isOurChoice = ref7.isOurChoice, viewSize = ref7.viewSize;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var alternativePrices = offer.alternativePrices, externalUri = offer.externalUri, featured = offer.featured, price = offer.price, promotion = offer.promotion, stock = offer.stock, store = offer.store, condition = offer.condition, shopOfferId = offer.shopOfferId;
    var alternativeContracts = (ref = offer.mobileContract) === null || ref === void 0 ? void 0 : ref.alternativeContracts;
    var showPromotionBar = Boolean(promotion) && viewSize >= types/* ViewSize.SMALL */.du.SMALL;
    var startBounceTimer = (0,react.useCallback)(function(id) {
        // Start a timer when a user clicks out on a product
        // if they return to Prisjakt within 15 seconds
        // display an error report button in the price row.
        var startTime = Date.now();
        var onRefocus = function() {
            if (Date.now() - startTime > 15000 && document.visibilityState === "visible") {
                document.removeEventListener("visibilitychange", onRefocus);
                return;
            }
            if (document.visibilityState === "visible") {
                setReportRowId(id);
                // Action event for tracking
                onClickOutBounce();
                document.removeEventListener("visibilitychange", onRefocus);
            }
        };
        document.addEventListener("visibilitychange", onRefocus);
    }, [
        onClickOutBounce,
        setReportRowId
    ]);
    var handleMobileContractClickOut = (0,react.useCallback)(function(e, alternativeContract) {
        var status = getGAStatus(false, Boolean(alternativeContract));
        var externalUrl = (alternativeContract === null || alternativeContract === void 0 ? void 0 : alternativeContract.externalUri) || offer.externalUri;
        if (externalUrl && !e.defaultPrevented) onPriceClick(featured, status, Boolean(alternativeContract));
    }, [
        offer,
        featured,
        onPriceClick
    ]);
    var handleClickOut = (0,react.useCallback)(function(e, altPrice) {
        var ref;
        var isInternational = (offer === null || offer === void 0 ? void 0 : (ref = offer.store) === null || ref === void 0 ? void 0 : ref.market) === "secondary";
        var status = getGAStatus(isInternational, Boolean(altPrice));
        var isFeatured = altPrice ? (0,product_utils/* getIsFeatured */.ZF)(offer, altPrice) : featured;
        var offerId = altPrice ? "".concat(store === null || store === void 0 ? void 0 : store.id, "-").concat(altPrice.shopOfferId) : "".concat(store === null || store === void 0 ? void 0 : store.id, "-").concat(offer.shopOfferId);
        var externalUrl = altPrice ? altPrice.externalUri : externalUri;
        setPriceRowReport(altPrice ? types/* ReportRowType.ALTERNATIVE */.Zu.ALTERNATIVE : types/* ReportRowType.DEFAULT */.Zu.DEFAULT);
        if (isFeatured && externalUrl) {
            if ( true && offerId) startBounceTimer(offerId);
            if (!showDisabledInfo && !e.defaultPrevented) onPriceClick(featured, status, Boolean(altPrice));
        } else {
            e.preventDefault();
            setShowDisabledInfo(!showDisabledInfo);
            var conditionTyped = condition ? condition : undefined;
            var trackClickScope = conversion/* TrackClickScope.PRICE_LIST */.b8.PRICE_LIST;
            if (altPrice) {
                trackClickScope = conversion/* TrackClickScope.PRICE_LIST_EXPANDED */.b8.PRICE_LIST_EXPANDED;
            }
            if (!isInPriceList) {
                trackClickScope = conversion/* TrackClickScope.MINI_OFFERLIST */.b8.MINI_OFFERLIST;
            }
            (0,conversion/* trackUnfeaturedOfferClick */.cR)({
                offerId: "".concat(store === null || store === void 0 ? void 0 : store.id, "-").concat(shopOfferId),
                isRawOffer: false,
                productId: product.id,
                condition: conditionTyped,
                scope: trackClickScope,
                stockStatus: (0,conversion/* mapStockStatusToGTMStockStatus */._L)(stock === null || stock === void 0 ? void 0 : stock.status)
            });
        }
    }, [
        offer,
        featured,
        externalUri,
        startBounceTimer,
        showDisabledInfo,
        onPriceClick,
        condition,
        isInPriceList,
        store === null || store === void 0 ? void 0 : store.id,
        shopOfferId,
        product.id,
        stock === null || stock === void 0 ? void 0 : stock.status
    ]);
    var handleExpandButtonClick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (viewSize === types/* ViewSize.SMALL */.du.SMALL) {
            setInfoModalOpen(function(state) {
                return !state;
            });
        } else {
            setExpanded(!expanded);
        }
        if (!infoModalOpen && !expanded && sotyBadge === undefined && (store === null || store === void 0 ? void 0 : store.id)) {
            fetchSotyAwardsByStoreId(store.id).then(function(response) {
                var ref, ref1, ref2;
                if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.storeOfTheYearAwards) === null || ref2 === void 0 ? void 0 : ref2.length) {
                    setSotyBadge(response.data.store.storeOfTheYearAwards[0]);
                } else {
                    setSotyBadge(null);
                }
            });
        }
    };
    var closeReportOverlay = (0,react.useCallback)(function() {
        setPriceRowReport(types/* ReportRowType.NONE */.Zu.NONE);
        setReportRowId(null);
    }, [
        setReportRowId
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, {
        key: (store === null || store === void 0 ? void 0 : store.id) || "price-row"
    }, /*#__PURE__*/ react.createElement(styles/* StyledCard */.rg, {
        className: className,
        containerProps: {
            ref: priceRowRef
        },
        $expanded: expanded,
        $featured: featured,
        $extraMargin: isOurChoice && isInPriceList,
        $hasPromotion: showPromotionBar
    }, /*#__PURE__*/ react.createElement(styles/* Row */.X2, {
        className: "pj-ui-price-row" // Used to track click out (see out.js)
        ,
        "data-test": "PriceRow",
        $expanded: expanded,
        $featured: featured,
        $noExternalUri: !externalUri
    }, !isInPriceList && isOurChoice && /*#__PURE__*/ react.createElement(StyledExpandButtonWrapper, {
        onClick: function() {
            return setShowOurChoicePopover === null || setShowOurChoicePopover === void 0 ? void 0 : setShowOurChoicePopover(function(state) {
                return !state;
            });
        },
        $expanded: false
    }, /*#__PURE__*/ react.createElement(ExpandButton, {
        expanded: expanded
    })), isInPriceList && /*#__PURE__*/ react.createElement(StyledExpandButtonWrapper, {
        onClick: handleExpandButtonClick,
        $expanded: expanded
    }, /*#__PURE__*/ react.createElement(ExpandButton, {
        expanded: expanded
    })), featured && /*#__PURE__*/ react.createElement(FeaturedContent, {
        onClick: function(e) {
            if (offer.mobileContract) handleMobileContractClickOut(e);
            else handleClickOut(e);
        }
    }), !featured && /*#__PURE__*/ react.createElement(UnfeaturedContent, {
        priceRowRef: priceRowRef,
        setShowDisabledInfo: setShowDisabledInfo,
        showDisabledInfo: showDisabledInfo,
        handleOnClick: function(e) {
            return handleClickOut(e);
        }
    })), infoModalOpen && /*#__PURE__*/ react.createElement(InfoModal, {
        closeModal: function() {
            return setInfoModalOpen(false);
        },
        closeReportOverlay: closeReportOverlay,
        isOpen: infoModalOpen,
        priceRowReport: priceRowReport,
        reportRowId: reportRowId,
        sotyBadge: sotyBadge,
        handleOnClick: function(e, altPrice) {
            return handleClickOut(e, altPrice);
        },
        handleMobileContractClickOut: handleMobileContractClickOut
    }), expanded && store && /*#__PURE__*/ react.createElement(StyledInfoRow, {
        "data-test": "ColumnExpanded"
    }, /*#__PURE__*/ react.createElement(store_info_StoreInfo, {
        sotyBadge: sotyBadge
    })), expanded && alternativePrices && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles_StyledVariantTitle, null, t("product", "price.variants-title")), /*#__PURE__*/ react.createElement(StyledAlternativePricesArea, null, alternativePrices.map(function(altPrice) {
        if (!altPrice) return null;
        return /*#__PURE__*/ react.createElement(AlternativePriceRowContextContainer, {
            key: "".concat(store === null || store === void 0 ? void 0 : store.id, "-").concat(altPrice.shopOfferId),
            alternativeOffer: altPrice
        }, /*#__PURE__*/ react.createElement(AlternativePriceRow, {
            priceRowRef: priceRowRef,
            handleOnClick: function(e) {
                return handleClickOut(e, altPrice);
            }
        }), priceRowReport === types/* ReportRowType.ALTERNATIVE */.Zu.ALTERNATIVE && reportRowId === altPrice.shopOfferId && /*#__PURE__*/ react.createElement(report_button/* ReportButton */.f, {
            priceId: "".concat(store === null || store === void 0 ? void 0 : store.id, "-").concat(altPrice.shopOfferId),
            priceValue: altPrice.price && altPrice.price.exclShipping,
            stockStatus: altPrice.stock && altPrice.stock.status,
            onClose: closeReportOverlay,
            productName: altPrice.name,
            isAlternative: true
        }));
    }))), expanded && alternativeContracts && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles_StyledVariantTitle, null, t("product", "price.variants-title")), /*#__PURE__*/ react.createElement(StyledAlternativePricesArea, null, alternativeContracts.map(function(altContract) {
        if (!altContract) return null;
        return /*#__PURE__*/ react.createElement(AlternativePriceRowContextContainer, {
            key: altContract.contractId,
            alternativeContract: altContract
        }, /*#__PURE__*/ react.createElement(AlternativeContractRow, {
            handleOnClick: function(e) {
                return handleMobileContractClickOut(e, altContract);
            }
        }));
    })))), showPromotionBar && /*#__PURE__*/ react.createElement(PromotionBar, null), isInPriceList && priceRowReport === types/* ReportRowType.DEFAULT */.Zu.DEFAULT && reportRowId === "".concat(store === null || store === void 0 ? void 0 : store.id, "-").concat(shopOfferId) && /*#__PURE__*/ react.createElement(report_button/* ReportButton */.f, {
        priceId: "".concat(store === null || store === void 0 ? void 0 : store.id, "-").concat(shopOfferId),
        priceValue: price && price.exclShipping,
        stockStatus: stock && stock.status,
        onClose: closeReportOverlay,
        productName: product.name
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/index.tsx
function row_types_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function row_types_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            row_types_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function row_types_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function row_types_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        row_types_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var PriceRow = function(props) {
    var trackingItem = props.trackingItem, className = props.className, setShowOurChoicePopover = props.setShowOurChoicePopover;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), product = ref.product, offer = ref.offer, showUsedOffers = ref.showUsedOffers, isInPriceList = ref.isInPriceList;
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ react.createElement(RegularPriceRow, {
        onClickOutBounce: function() {
            var ref, ref1;
            dispatch((0,actions_product/* productClickOutBounce */.nA)({
                productId: product.id,
                offerId: "".concat((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id, "-").concat(offer.shopOfferId),
                storeName: (ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.name
            }));
        },
        onPriceClick: function(featured, status, isAlternative) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
            var _condition;
            // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
            // reflected in react/middlewares/out pre click for tracking clicks before JS bundle
            dispatch((0,actions_product/* productPriceClick */.Po)(product.id, trackingItem, featured, status, isAlternative, isInPriceList ? "" : "Mini offerlist", isAlternative ? "" : (ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status, (_condition = offer.condition) !== null && _condition !== void 0 ? _condition : product_condition_types/* ConditionEnum.NEW */.M.NEW));
            var condition = showUsedOffers && offer.condition ? offer.condition : undefined;
            var isInternational = ((ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.market) === "secondary";
            var isPjDeal = ((ref2 = product.dealInfo) === null || ref2 === void 0 ? void 0 : ref2.dealPercentage) ? true : undefined;
            var stockStatus = (0,conversion/* mapStockStatusToGTMStockStatus */._L)((ref3 = offer.stock) === null || ref3 === void 0 ? void 0 : ref3.status);
            var trackClickScope = conversion/* TrackClickScope.PRICE_LIST */.b8.PRICE_LIST;
            if (isAlternative) {
                trackClickScope = conversion/* TrackClickScope.PRICE_LIST_EXPANDED */.b8.PRICE_LIST_EXPANDED;
            } else if (!isInPriceList) {
                trackClickScope = conversion/* TrackClickScope.MINI_OFFERLIST */.b8.MINI_OFFERLIST;
            } else if (offer.mobileContract) {
                trackClickScope = conversion/* TrackClickScope.MOBILE_CONTRACT */.b8.MOBILE_CONTRACT;
            }
            var priceType = "regular";
            if ((ref4 = offer.offerPrices) === null || ref4 === void 0 ? void 0 : ref4.memberPrice) {
                priceType = "member";
            } else if ((ref5 = offer.offerPrices) === null || ref5 === void 0 ? void 0 : ref5.originalPrice) {
                priceType = "sale";
            }
            var clickoutData = {
                scope: trackClickScope,
                offerId: "".concat((ref6 = offer.store) === null || ref6 === void 0 ? void 0 : ref6.id, "-").concat(offer.shopOfferId),
                isRawOffer: false,
                condition: condition,
                hasShippingInfo: ((ref7 = offer.shipping) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.nodes) === null || ref8 === void 0 ? void 0 : ref8.length) ? true : undefined,
                isInternational: isInternational ? true : undefined,
                isPartOfPromotion: offer.promotion ? true : undefined,
                isPjDeal: isPjDeal,
                priceType: priceType,
                stockStatus: stockStatus
            };
            if (offer.mobileContract) {
                var ref9, ref10;
                (0,conversion/* trackMobileContractClick */._k)(row_types_objectSpreadProps(row_types_objectSpread({}, clickoutData), {
                    offerId: "",
                    shopId: (ref9 = offer.store) === null || ref9 === void 0 ? void 0 : ref9.id,
                    shopName: (ref10 = offer.store) === null || ref10 === void 0 ? void 0 : ref10.name
                }));
            } else {
                (0,conversion/* trackOfferClickWithRevenue */.Rx)(clickoutData);
            }
        },
        className: className,
        setShowOurChoicePopover: setShowOurChoicePopover
    });
};


/***/ }),

/***/ 33900:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$w": () => (/* binding */ ROW_HEIGHT_MINI),
/* harmony export */   "DB": () => (/* binding */ StyledPriceAndShipping),
/* harmony export */   "X2": () => (/* binding */ Row),
/* harmony export */   "Zb": () => (/* binding */ StyledPriceLabel),
/* harmony export */   "_d": () => (/* binding */ StyledBadges),
/* harmony export */   "dN": () => (/* binding */ ROW_HEIGHT),
/* harmony export */   "j8": () => (/* binding */ PRICE_LABEL_SIZE),
/* harmony export */   "mk": () => (/* binding */ StyledPriceArea),
/* harmony export */   "ng": () => (/* binding */ StyledSecondaryPrice),
/* harmony export */   "rg": () => (/* binding */ StyledCard),
/* harmony export */   "sg": () => (/* binding */ Column)
/* harmony export */ });
/* unused harmony export SECONDARY_PRICE_LABEL_SIZE */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33561);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
/* harmony import */ var src_components_offer_price_price_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75695);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      &:hover {\n        color: ",
        ";\n      }\n      background: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 1.3em;\n  position: relative;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      margin: ",
        " 0;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 0;\n\n      :first-child {\n        border-top-left-radius: 8px;\n        border-top-right-radius: 8px;\n      }\n\n      :last-child {\n        border-bottom-left-radius: 8px;\n        border-bottom-right-radius: 8px;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      box-shadow: none;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n\n    background-color: ",
        ";\n    flex: 1;\n\n    ",
        "\n\n    ",
        ";\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      background: none;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      background: none;\n      border: none;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    border-radius: inherit;\n    display: flex;\n    align-items: stretch;\n    background: ",
        ";\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex: 1 0 auto;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  column-gap: ",
        ";\n  align-items: baseline;\n  height: 24px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n  text-align: right;\n  margin-bottom: 0;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}




var ROW_HEIGHT = "54px";
var ROW_HEIGHT_MINI = "46px";
var PRICE_LABEL_SIZE = "16px";
var SECONDARY_PRICE_LABEL_SIZE = "12px";
var PRICE_LABEL_LINE_HEIGHT = "24px";
var SECONDARY_PRICE_LABEL_LINE_HEIGHT = "22px";
var rowStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), function(props) {
    return props.$noExternalUri && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
}, function(props) {
    return !props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), props.theme.text.secondary, props.theme.text.secondary, props.theme.colors.base100);
});
var StyledCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_1__.Card).withConfig({
    displayName: "StyledCard",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), rowStyles, props.theme.colors.base100, props.$extraMargin && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100), props.$isAlternative && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4()), !props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5()), props.$hasPromotion && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6()));
});
var Row = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Row",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), rowStyles, props.theme.bg.primary, !props.$featured && !props.$isAlternative && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8()), props.$expanded && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), props.theme.colors.base200), props.$isAlternative && !props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject10()));
});
var Column = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-2"
})(_templateObject12());
var StyledBadges = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledBadges",
    componentId: "sc-0-3"
})(_templateObject13(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var StyledPriceAndShipping = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledPriceAndShipping",
    componentId: "sc-0-4"
})(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var StyledSecondaryPrice = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_offer_price_price_label__WEBPACK_IMPORTED_MODULE_3__/* .PriceLabel */ .l).withConfig({
    displayName: "StyledSecondaryPrice",
    componentId: "sc-0-5"
})(_templateObject15(), function(p) {
    return !p.memberPrice && "text-decoration: line-through;";
}, SECONDARY_PRICE_LABEL_SIZE, SECONDARY_PRICE_LABEL_LINE_HEIGHT);
var StyledPriceLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_offer_price_price_label__WEBPACK_IMPORTED_MODULE_3__/* .PriceLabel */ .l).withConfig({
    displayName: "StyledPriceLabel",
    componentId: "sc-0-6"
})(_templateObject16(), PRICE_LABEL_SIZE, PRICE_LABEL_LINE_HEIGHT);
var StyledPriceArea = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledPriceArea",
    componentId: "sc-0-7"
})(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 8114:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$x": () => (/* binding */ FeaturedStatusEnum),
/* harmony export */   "Zu": () => (/* binding */ ReportRowType),
/* harmony export */   "du": () => (/* binding */ ViewSize)
/* harmony export */ });
/* unused harmony export ProductPageProductClick */
var ViewSize;
(function(ViewSize) {
    ViewSize[ViewSize[/*
    For showing price rows in mini layout mode
    (used in mini offerlist in product header)
   */ "MINI"] = 0] = "MINI";
    ViewSize[ViewSize[/*
    For showing price rows in small layout mode
    (used in price list on mobile screens and for our choice in product header)
  */ "SMALL"] = 1] = "SMALL";
    ViewSize[ViewSize[/*
    For showing price rows in medium layout mode
    (used in price list on tablets screens)
   */ "MEDIUM"] = 2] = "MEDIUM";
    ViewSize[ViewSize[/*
    For showing price rows in large layout mode
    (used in price list on desktop screens)
  */ "LARGE"] = 3] = "LARGE";
})(ViewSize || (ViewSize = {}));
var FeaturedStatusEnum;
(function(FeaturedStatusEnum) {
    FeaturedStatusEnum["UNKNOWN"] = "FEATURED_STATUS_UNKNOWN";
    FeaturedStatusEnum["FEATURED"] = "FEATURED";
    FeaturedStatusEnum["NOT_FEATURED"] = "NOT_FEATURED";
})(FeaturedStatusEnum || (FeaturedStatusEnum = {}));
var ProductPageProductClick = "ProductPage";
var ReportRowType;
(function(ReportRowType) {
    ReportRowType["NONE"] = "none";
    ReportRowType["DEFAULT"] = "default";
    ReportRowType["ALTERNATIVE"] = "alternative";
})(ReportRowType || (ReportRowType = {}));


/***/ }),

/***/ 54581:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ createOfferFromPriceItem),
/* harmony export */   "n": () => (/* binding */ getSortOptions)
/* harmony export */ });
/* harmony import */ var src_components_filter_dropdown_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18557);
/* harmony import */ var _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60205);
/* harmony import */ var src_areas_product_utils_price_list_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17551);



var _requiresCompensation;
var mapMemberShipProgram = function(membershipProgram) {
    return membershipProgram ? {
        name: membershipProgram.name || "",
        requiresCompensation: (_requiresCompensation = membershipProgram.requiresCompensation) !== null && _requiresCompensation !== void 0 ? _requiresCompensation : false
    } : null;
};
function createOfferFromPriceItem(item) {
    var _condition, _shopHasUniqueShippings;
    return {
        name: item.name,
        price: item.price,
        offerPrices: item.offerPrices,
        condition: (_condition = item.condition) !== null && _condition !== void 0 ? _condition : _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__/* .ConditionEnum.NEW */ .M.NEW,
        availability: item.availability,
        store: item.store,
        shopOfferId: item.shopOfferId,
        featured: item.featured,
        storeInfo: item.store && item.store.providedByStore ? item.store.providedByStore.generalInformation : null,
        rating: (0,src_areas_product_utils_price_list_common__WEBPACK_IMPORTED_MODULE_2__/* .getStoreRating */ ._5)(item.store),
        stock: item.stock,
        externalUri: item.externalUri,
        alternativePrices: item.alternativePrices,
        authorizedDealerData: item.authorizedDealerData,
        authorizedDealer: Boolean(item.authorizedDealer),
        isInternationalPrice: Boolean(item.store && item.store.market === "secondary"),
        shipping: item.shipping,
        unfilteredShippings: item.unfilteredShippings,
        ourChoiceScore: item.ourChoiceScore,
        dealOffers: item.dealOffers,
        featuredOverride: item.featuredOverride,
        membershipProgram: mapMemberShipProgram(item.membershipProgram),
        shopHasUniqueShippings: (_shopHasUniqueShippings = item.shopHasUniqueShippings) !== null && _shopHasUniqueShippings !== void 0 ? _shopHasUniqueShippings : false,
        promotion: item.promotion,
        membershipLink: item.membershipLink,
        shippingCampaigns: item.shippingCampaigns
    };
}
var getSortOptions = function(t, allOffers) {
    var hasDeliveryDays = allOffers.some(function(offer) {
        var ref;
        return (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
            return node === null || node === void 0 ? void 0 : node.deliveryDays;
        });
    });
    if (!hasDeliveryDays) {
        return [];
    }
    return [
        {
            title: t("campaigns", "sort.price.offer|asc"),
            type: src_components_filter_dropdown_types__WEBPACK_IMPORTED_MODULE_0__/* .OptionTypeEnum.CHEAPEST_PRICE */ .M.CHEAPEST_PRICE
        },
        {
            title: t("common", "sort.fastest-delivery"),
            type: src_components_filter_dropdown_types__WEBPACK_IMPORTED_MODULE_0__/* .OptionTypeEnum.FASTEST_DELIVERY */ .M.FASTEST_DELIVERY
        }
    ];
};


/***/ }),

/***/ 87378:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": () => (/* binding */ ProductBreadCrumb)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(88999);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/product/components/product-breadcrumb/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product/components/product-breadcrumb/index.tsx



var ProductBreadCrumb = function(props) {
    var ref;
    var product = props.product;
    var ref1;
    return /*#__PURE__*/ react.createElement(BreadCrumbWrapper, {
        "data-test": "Breadcrumbs"
    }, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: (ref1 = (ref = product.category) === null || ref === void 0 ? void 0 : ref.path.map(function(param) {
            var title = param.name, href = param.pathName;
            return {
                href: href,
                title: title
            };
        })) !== null && ref1 !== void 0 ? ref1 : [],
        lastItemClickable: true
    }));
};


/***/ }),

/***/ 19622:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _components_campaign_deals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87341);
/* harmony import */ var _components_error_boundary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52923);
/* harmony import */ var src_components_lazy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85518);




var ProductCampaignDeals = function(props) {
    var ref;
    var product = props.product;
    return product.category && product.category.deals && ((ref = product.category) === null || ref === void 0 ? void 0 : ref.deals.length) > 0 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_error_boundary__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onError: returnNull
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_lazy__WEBPACK_IMPORTED_MODULE_3__/* .Lazy */ .o, {
        offset: 100
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_campaign_deals__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        deals: product.category.deals,
        campaignLinkQuery: "?category=".concat(product.category.id)
    }))) : null;
};
var returnNull = function() {
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCampaignDeals);


/***/ }),

/***/ 8466:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": () => (/* binding */ useProductContext),
/* harmony export */   "HS": () => (/* binding */ ProductContext),
/* harmony export */   "jG": () => (/* binding */ EmptyProduct)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var EmptyProduct = {
    id: 0,
    media: {
        count: 0
    },
    name: "",
    classicFullPath: "",
    pathName: "",
    priceSummary: {},
    userReviewSummary: {},
    coreProperties: {},
    isExpertTopRated: false,
    metadata: {
        title: "",
        description: ""
    }
};
var initialContextValue = {
    product: EmptyProduct,
    offers: {
        initialNewOffers: [],
        filteredOffers: [],
        filteredOffersForProductHeader: []
    },
    allOffers: [],
    allOffersWithActiveAdditives: [],
    dealOffers: [],
    mobileContracts: [],
    priceInfoArticles: undefined
};
var ProductContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialContextValue);
var useProductContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductContext);
};


/***/ }),

/***/ 6743:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ ListModal)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25670);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29261);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21541);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25349);
/* harmony import */ var _list_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88103);
/* harmony import */ var _prisjakt_ui_radiobutton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94269);
/* harmony import */ var src_components_modal_v2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42574);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51676);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  gap: ",
        ";\n  margin: 0;\n  list-style: none;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var ListModal = function(props) {
    var addToList = props.addToList, addToMyProducts = props.addToMyProducts, closeModal = props.closeModal, isOpen = props.isOpen, isDesktop = props.isDesktop, lists = props.lists;
    var t = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_6__/* .useAppContext */ .bp)().t;
    var ref = (0,_list_context__WEBPACK_IMPORTED_MODULE_7__/* .useListContext */ .U)(), fetchMoreLists = ref.fetchMoreLists, moreLists = ref.moreLists, pageInfo = ref.pageInfo;
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), selectedValue = ref1[0], setSelectedValue = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), listItemSelected = ref2[0], setListItemSelected = ref2[1];
    var handleOptionClick = function(listId) {
        setSelectedValue(listId);
        if (!selectedValue) setListItemSelected(function(state) {
            return !state;
        });
    };
    var onSubmit = function() {
        if (selectedValue === "my-products") {
            addToMyProducts();
        } else if (typeof selectedValue === "number") {
            addToList(selectedValue);
        }
        closeModal();
    };
    var handleSaveToNewListClick = function() {
        addToList();
        closeModal();
    };
    var allLists = _toConsumableArray(lists || []).concat(_toConsumableArray(moreLists || []));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_modal_v2__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        size: isDesktop ? _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__/* .ModalSizeEnum.SMALL */ .E$.SMALL : _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__/* .ModalSizeEnum.FULL */ .E$.FULL,
        title: "".concat(t("lists", "list.save-to-list"), ":")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__/* .ModalBody */ .fe, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListWrapper, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_radiobutton__WEBPACK_IMPORTED_MODULE_8__/* .RadioButton */ .EU, {
        id: "my-products",
        name: "list",
        selectedValue: selectedValue,
        value: "my-products",
        text: t("lists", "my-products.title"),
        onClickHandler: function() {
            return handleOptionClick("my-products");
        }
    })), allLists.map(function(list) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
            key: list.id
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_radiobutton__WEBPACK_IMPORTED_MODULE_8__/* .RadioButton */ .EU, {
            id: list.id.toString(),
            name: "list",
            selectedValue: selectedValue,
            value: list.id,
            text: list.name,
            onClickHandler: function() {
                return handleOptionClick(list.id);
            }
        }));
    }), (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNext) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.TextButton, {
        onClick: fetchMoreLists
    }, t("common", "button.show-more")))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__/* .ModalFooter */ .mz, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__.Row, {
        equallySizedChildren: true,
        gap: 1
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.OutlinedButton, {
        onClick: handleSaveToNewListClick
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.TitleSmallText, null, t("lists", "list.save-to-new-list"))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.PrimaryButton, {
        onClick: onSubmit,
        disabled: !listItemSelected
    }, t("common", "button.save"))))));
};
var ListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].ul.withConfig({
    displayName: "ListWrapper",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);


/***/ }),

/***/ 7379:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ OurChoicePopover)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21541);
/* harmony import */ var _prisjakt_ui_popover__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31744);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74887);





var OurChoicePopover = function(props) {
    var ref;
    var showPopover = props.showPopover, setShowPopover = props.setShowPopover;
    var ref1 = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp)(), t = ref1.t, market = ref1.market;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_popover__WEBPACK_IMPORTED_MODULE_3__/* .Popover */ .J2, {
        id: "our-choice-explanation",
        visible: showPopover,
        width: 300,
        horizontalAlign: _prisjakt_ui_popover__WEBPACK_IMPORTED_MODULE_3__/* .Alignment.Center */ .v2.Center,
        verticalAlign: _prisjakt_ui_popover__WEBPACK_IMPORTED_MODULE_3__/* .Alignment.Center */ .v2.Center,
        // Adding a nextTick-timeout here enables the popover to be closed by clicking the icon again
        onClose: function() {
            return setTimeout(function() {
                return setShowPopover(false);
            });
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledPopoverContent */ .Ij, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.BodySmallText, null, t("product", "prices.our-choice-explanation")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .StyledBlueInfoPageLink */ .Kt, {
        id: (ref = market.infoPageMap) === null || ref === void 0 ? void 0 : ref.priceInformation
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.TitleSmallText, null, t("common", "button.read-more")))));
};


/***/ }),

/***/ 74887:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": () => (/* binding */ StyleUnderlinedInfoPageLink),
/* harmony export */   "Ij": () => (/* binding */ StyledPopoverContent),
/* harmony export */   "Kt": () => (/* binding */ StyledBlueInfoPageLink),
/* harmony export */   "Mv": () => (/* binding */ StyledIconWrapper),
/* harmony export */   "PU": () => (/* binding */ TitleRow),
/* harmony export */   "tw": () => (/* binding */ OurChoiceWrapper)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var src_components_info_page_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91135);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      width: 320px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: ",
        ";\n  position: relative;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 1fr 1fr;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  height: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  &:hover {\n    color: ",
        ";\n  }\n  text-decoration: underline;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var OurChoiceWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "OurChoiceWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject()));
var TitleRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "TitleRow",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var StyledIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledIconWrapper",
    componentId: "sc-0-2"
})(_templateObject3());
var StyledPopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledPopoverContent",
    componentId: "sc-0-3"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing075 */ .bK.measurements.spacing075);
var StyledBlueInfoPageLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_info_page_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "StyledBlueInfoPageLink",
    componentId: "sc-0-4"
})(_templateObject5(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var StyleUnderlinedInfoPageLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_info_page_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "StyleUnderlinedInfoPageLink",
    componentId: "sc-0-5"
})(_templateObject6(), function(p) {
    return p.theme.text.callToAction;
});


/***/ }),

/***/ 84577:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ getOurChoiceOffer)
/* harmony export */ });
/* harmony import */ var src_areas_product_components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8114);
/* harmony import */ var src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60205);


var ALLOWED_MARKETS = [
    "gb",
    "fr"
];
var MIN_PRICE_DIFF_TO_SHOPS_WITH_SCORE = 0.18;
var MIN_PRICE_DIFF_TO_CHEAPEST = 0.2;
var MAX_PRICE_DIFF_TO_CHEAPEST = 1.2;
var sortByScore = function(a, b) {
    if (a.ourChoiceScore === b.ourChoiceScore) {
        return 0;
    }
    return a.ourChoiceScore > b.ourChoiceScore ? -1 : 1;
};
var isMuchCheaperOfferWithOneScoreBelow = function(offer, ourChoice) {
    var ref, ref1;
    var ourChoicePrice = ((ref = ourChoice.price) === null || ref === void 0 ? void 0 : ref.exclShipping) || Infinity;
    var price = ((ref1 = offer.price) === null || ref1 === void 0 ? void 0 : ref1.exclShipping) || Infinity;
    var percentage = price / ourChoicePrice;
    return offer.ourChoiceScore === (ourChoice === null || ourChoice === void 0 ? void 0 : ourChoice.ourChoiceScore) - 1 && percentage <= 1 - MIN_PRICE_DIFF_TO_SHOPS_WITH_SCORE;
};
var isTooExpensiveRecommendation = function(ourChoice, offersSortedByPrice) {
    var ref, ref1, ref2;
    var ourChoicePrice = ((ref = ourChoice.price) === null || ref === void 0 ? void 0 : ref.exclShipping) || -1;
    var otherCheapestPrice = ((ref1 = offersSortedByPrice.find(function(offer) {
        var ref;
        return ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.name) !== ourChoice.store;
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping) || -1;
    if (ourChoicePrice === -1 || otherCheapestPrice === -1) {
        return false;
    }
    return ourChoicePrice >= otherCheapestPrice * MAX_PRICE_DIFF_TO_CHEAPEST;
};
var isSuspiciouslyCheapRecommendation = function(ourChoice, offersSortedByPrice) {
    var ref, ref1, ref2;
    var ourChoicePrice = (ref = ourChoice.price) === null || ref === void 0 ? void 0 : ref.exclShipping;
    var otherCheapestPrice = (ref1 = offersSortedByPrice.find(function(offer) {
        var ref;
        return ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.name) !== ourChoice.store;
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping;
    if (!ourChoicePrice || !otherCheapestPrice) {
        return false;
    }
    return ourChoicePrice < otherCheapestPrice * MIN_PRICE_DIFF_TO_CHEAPEST;
};
var getOurChoiceOffer = function(offersSortedByPrice, market) {
    if (!ALLOWED_MARKETS.includes(market)) {
        return undefined;
    }
    var filteredOffers = offersSortedByPrice.filter(function(offer) {
        var ref, ref1;
        return offer.condition === src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__/* .ConditionEnum.NEW */ .M.NEW && ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.featured) && offer.featuredOverride !== src_areas_product_components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__/* .FeaturedStatusEnum.NOT_FEATURED */ .$x.NOT_FEATURED && ((ref1 = offer.stock) === null || ref1 === void 0 ? void 0 : ref1.status) === "in_stock" && offer.ourChoiceScore > 0;
    });
    if (filteredOffers.length === 0) {
        return undefined;
    }
    var sortedOnScore = filteredOffers.sort(sortByScore);
    var ourChoice = sortedOnScore[0];
    if (isTooExpensiveRecommendation(ourChoice, offersSortedByPrice) || isSuspiciouslyCheapRecommendation(ourChoice, offersSortedByPrice)) {
        return undefined;
    }
    var cheapestOfferWithSecondBestRank = sortedOnScore.find(function(offer) {
        return isMuchCheaperOfferWithOneScoreBelow(offer, ourChoice);
    });
    if (cheapestOfferWithSecondBestRank) {
        return cheapestOfferWithSecondBestRank;
    }
    return ourChoice;
};


/***/ }),

/***/ 55634:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ProductPageHeader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(8466);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/list-context.tsx
var list_context = __webpack_require__(88103);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(8836);
// EXTERNAL MODULE: ./packages/frontend-admin-ui/dist/module.js + 1 modules
var dist_module = __webpack_require__(53254);
// EXTERNAL MODULE: ./src/areas/product/utils/price-list/filtering.ts + 1 modules
var filtering = __webpack_require__(31288);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(33888);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/utils/index.ts
var getSizeTitle = function(t) {
    return "".concat(t("product", "label.size"));
};
var getFractalRepresentation = function(numericString) {
    var integerValue = parseInt(numericString, 10);
    var decimalValue = parseFloat(numericString) % 1;
    if (isNaN(integerValue) || isNaN(decimalValue)) {
        return numericString;
    }
    if (decimalValue > 0.4 && decimalValue < 0.6) {
        return "".concat(integerValue, " \xbd");
    }
    if (decimalValue > 0.25 && decimalValue < 0.4) {
        return "".concat(integerValue, " ⅓");
    }
    if (decimalValue > 0.6 && decimalValue < 0.75) {
        return "".concat(integerValue, " ⅔");
    }
    return numericString;
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/utils/colors.ts
var getColor = function(color) {
    switch(color){
        case "Black":
            return {
                hex: "#000000",
                order: 1,
                translationKey: "colors.black"
            };
        case "White":
            return {
                hex: "#FFFFFF",
                order: 2,
                translationKey: "colors.white"
            };
        case "Grey":
            return {
                hex: "#808080",
                order: 3,
                translationKey: "colors.grey"
            };
        case "Blue":
            return {
                hex: "#1E90FF",
                order: 4,
                translationKey: "colors.blue"
            };
        case "Red":
            return {
                hex: "#FF002B",
                order: 5,
                translationKey: "colors.red"
            };
        case "Green":
            return {
                hex: "#00D471",
                order: 6,
                translationKey: "colors.green"
            };
        case "Beige":
            return {
                hex: "#F5F5DC",
                order: 7,
                translationKey: "colors.beige"
            };
        case "Orange":
            return {
                hex: "#FFA500",
                order: 8,
                translationKey: "colors.orange"
            };
        case "Pink":
            return {
                hex: "#FFA6B6",
                order: 9,
                translationKey: "colors.pink"
            };
        case "Brown":
            return {
                hex: "#915B25",
                order: 10,
                translationKey: "colors.brown"
            };
        case "Yellow":
            return {
                hex: "#FFEA00",
                order: 11,
                translationKey: "colors.yellow"
            };
        case "Silver":
            return {
                hex: "#C0C0C0",
                order: 12,
                translationKey: "colors.silver"
            };
        case "Purple":
            return {
                hex: "#800080",
                order: 13,
                translationKey: "colors.purple"
            };
        case "Turquoise":
            return {
                hex: "#40E0D0",
                order: 14,
                translationKey: "colors.turquoise"
            };
        case "Khaki":
            return {
                hex: "#8A865D",
                order: 15,
                translationKey: "colors.khaki"
            };
        case "Gold":
            return {
                hex: "#D4AF37",
                order: 16,
                translationKey: "colors.gold"
            };
        default:
            // In case we get non-normalized values from backend
            return {
                hex: null,
                order: 100,
                translationKey: null,
                nonNormalizedColor: color !== null && color !== void 0 ? color : ""
            };
    }
};
var getColorTranslation = function(t, color) {
    var colorVal = getColor(color);
    if (colorVal.translationKey) {
        return t("common", // @ts-expect-error -- Typed too loosely
        colorVal.translationKey);
    }
    if (colorVal.nonNormalizedColor) {
        return colorVal.nonNormalizedColor;
    }
    return "";
};

// EXTERNAL MODULE: ./src/areas/product/utils/price-list/types.ts
var types = __webpack_require__(34057);
;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/utils/selections.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var createNewSelection = function(variant, variantSelection) {
    if (!variant) {
        return [];
    }
    return variantSelection.includes(variant) ? variantSelection.filter(function(v) {
        return v !== variant;
    }) : _toConsumableArray(variantSelection).concat([
        variant
    ]);
};
var getSelectionsString = function(t, filter) {
    var selected = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : null;
    if (!(selected === null || selected === void 0 ? void 0 : selected.length)) {
        return null;
    }
    var prettified = selected.map(function(variant) {
        switch(filter === null || filter === void 0 ? void 0 : filter.type){
            case types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE:
                return getFractalRepresentation(variant);
            case types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR:
                return getColorTranslation(t, variant);
            default:
                return variant;
        }
    });
    return prettified.sort().join(", ");
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/styles-common.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: auto;\n  min-width: 206px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: left;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    max-height: 340px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 1px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var VariantGridTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridTitle",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var DropdownToggle = (0,styled_components_browser_esm["default"])(dropdown/* DropdownToggle */.Z_).withConfig({
    displayName: "DropdownToggle",
    componentId: "sc-0-1"
})(_templateObject1());
var DropdownButtonText = (0,styled_components_browser_esm["default"])(ui_button.ButtonText).withConfig({
    displayName: "DropdownButtonText",
    componentId: "sc-0-2"
})(_templateObject2());
var SelectionHighlightedText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "SelectionHighlightedText",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var ScrollableArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ScrollableArea",
    componentId: "sc-0-4"
})(_templateObject5(), base/* media.mediumUp */.BC.mediumUp(_templateObject4()));

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variants-button-label.tsx









var SizeVariantsButtonLabel = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var title = getSizeTitle(t);
    var filter = getFilter(types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE);
    var ref;
    var selectedVariants = (ref = getSelectionsString(t, filter)) !== null && ref !== void 0 ? ref : t("product", "variants.all");
    return /*#__PURE__*/ react.createElement(DropdownButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, title, ":", " ", /*#__PURE__*/ react.createElement(SelectionHighlightedText, null, selectedVariants)));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin: 0 ",
        ";\n    grid-template-columns: repeat(5, max-content);\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(4, [col] 1fr);\n  gap: ",
        ";\n\n  & + & {\n    margin-top: ",
        ";\n    padding-top: ",
        ";\n    border-top: 1px solid ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  min-width: 62px;\n  padding: 1px;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  max-width: 100px;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  grid-column: col / span 4;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var VariantGridWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridWrapper",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.lines.primary;
}, base/* media.mediumUp */.BC.mediumUp(styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var VariantGridCell = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridCell",
    componentId: "sc-0-1"
})(styles_templateObject2());
var SelectionButtonText = (0,styled_components_browser_esm["default"])(ui_button.ButtonText).withConfig({
    displayName: "SelectionButtonText",
    componentId: "sc-0-2"
})(styles_templateObject3());
var StyledShowMoreButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledShowMoreButtonWrapper",
    componentId: "sc-0-3"
})(styles_templateObject4());

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variant-selection-button.tsx





var SizeVariantSelectionButton = function(props) {
    var variant = props.variant, title = props.title, selection = props.selection, disabled = props.disabled, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var sizeWithFractal = title ? getFractalRepresentation(title) : "";
    var isSelected = Boolean(variant && (selection === null || selection === void 0 ? void 0 : selection.includes(variant)) || !variant && !selection);
    var onSelect = function() {
        return handleSelection(variant);
    };
    return /*#__PURE__*/ react.createElement(ui_button.Button, {
        onClick: onSelect,
        selectable: true,
        selected: isSelected,
        fullWidth: true,
        type: ui_button.ButtonType.OUTLINED,
        elevation: ui_button.ButtonElevation.NONE,
        disabled: disabled,
        size: isMobile ? ui_button.ButtonSize.NORMAL : ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(SelectionButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, sizeWithFractal));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/utils/group-size-variants.ts
function group_size_variants_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || group_size_variants_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function group_size_variants_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return group_size_variants_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return group_size_variants_arrayLikeToArray(o, minLen);
}
var getGroupedVariants = function(variants) {
    var _sizeSystem;
    var groups = groupBy(variants, function(variant) {
        return (_sizeSystem = variant.sizeSystem) !== null && _sizeSystem !== void 0 ? _sizeSystem : undefined;
    });
    var sortedGroups = groups.sort(function(param, param1) {
        var _param = _slicedToArray(param, 1), aKey = _param[0], _param1 = _slicedToArray(param1, 1), bKey = _param1[0];
        return getSizeSystemNumber(bKey) - getSizeSystemNumber(aKey);
    });
    return sortedGroups.map(function(param) {
        var _param = _slicedToArray(param, 2), group = _param[1];
        return group.sort(compareVariants);
    });
};
var compareVariants = function(a, b) {
    if (!a.size || !b.size) {
        return 0;
    }
    if (a.sizeSystem === "CLOTHESNONNUMERIC" && b.sizeSystem === "CLOTHESNONNUMERIC") {
        return getCloathesNonNumericNumber(a.size) - getCloathesNonNumericNumber(b.size);
    }
    return a.size.localeCompare(b.size, undefined, {
        numeric: true,
        sensitivity: "base"
    });
};
var getSizeSystemNumber = function(sizeSystem) {
    switch(sizeSystem){
        case "CLOTHESNUMERIC":
            return 1;
        case "CLOTHESNONNUMERIC":
            return 2;
        default:
            return Infinity;
    }
};
var getCloathesNonNumericNumber = function(size) {
    if (!size) {
        return Infinity;
    }
    switch(size.toUpperCase()){
        case "XXS":
            return 1;
        case "XS":
            return 2;
        case "S":
            return 3;
        case "S/M":
            return 4;
        case "M":
            return 5;
        case "M/L":
            return 6;
        case "L":
            return 7;
        case "L/XL":
            return 8;
        case "XL":
            return 9;
        case "XXL":
            return 10;
        case "XXXL":
            return 11;
        case "XXXXL":
            return 12;
        case "XXXXXL":
            return 13;
        case "ONE SIZE":
            return 14;
        default:
            return Infinity;
    }
};
function groupBy(input, generateKey) {
    var set = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var ref;
            var key = generateKey(element);
            if (!set.has(key)) {
                set.set(key, []);
            }
            (ref = set.get(key)) === null || ref === void 0 ? void 0 : ref.push(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Array.from(set.entries());
}

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/utils/collapsing.ts

var getSelectedSizesAsVariants = function(variantGroup, selection) {
    var findSizeInVariantGroup = function(size) {
        return variantGroup.find(function(variant) {
            return variant.size === size;
        });
    };
    var selectedSizes = (selection === null || selection === void 0 ? void 0 : selection.filter(findSizeInVariantGroup)) || [];
    return selectedSizes.map(function(size) {
        return findSizeInVariantGroup(size);
    });
};
var getSelectedAndFirstFewVariants = function(variantGroup, showSelectAll, limit, selection) {
    var selectedVariants = getSelectedSizesAsVariants(variantGroup, selection);
    var numSelected = selectedVariants.length || 0;
    var extraButtons = showSelectAll ? 1 : 0;
    var numNonSelectedVariantsToKeep = Math.max(0, limit - numSelected) - extraButtons;
    var variantIsNotSelected = function(variant) {
        return !selectedVariants.find(function(selectedVariant) {
            return (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.size) === variant.size;
        });
    };
    var nonSelectedVariantsToKeep = variantGroup.filter(variantIsNotSelected).slice(0, numNonSelectedVariantsToKeep);
    var result = selectedVariants.concat(nonSelectedVariantsToKeep);
    return result.sort(compareVariants);
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variants-grid.tsx
function size_variants_grid_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function size_variants_grid_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function size_variants_grid_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function size_variants_grid_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function size_variants_grid_slicedToArray(arr, i) {
    return size_variants_grid_arrayWithHoles(arr) || size_variants_grid_iterableToArrayLimit(arr, i) || size_variants_grid_unsupportedIterableToArray(arr, i) || size_variants_grid_nonIterableRest();
}
function size_variants_grid_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return size_variants_grid_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return size_variants_grid_arrayLikeToArray(o, minLen);
}











var SizeVariantsGrid = function(props) {
    var title = props.title, variants = props.variants, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var ref = size_variants_grid_slicedToArray((0,react.useState)(false), 2), isExpanded = ref[0], setIsExpanded = ref[1];
    var filter = getFilter(types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE);
    var selection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : undefined;
    var groupedVariants = getGroupedVariants(variants === null || variants === void 0 ? void 0 : variants.filter(Boolean));
    var LIMIT_CELLS = isMobile ? 12 : Number.MAX_VALUE;
    var selectAllCell = /*#__PURE__*/ react.createElement(VariantGridCell, null, /*#__PURE__*/ react.createElement(SizeVariantSelectionButton, {
        handleSelection: handleSelection,
        title: t("product", "variants.all"),
        selection: selection,
        variant: null,
        isMobile: isMobile
    }));
    var variantGroupCells = function(i, variantGroup, showSelectAll) {
        var key = "size-group-".concat(i);
        var variantsToDisplay = isExpanded ? variantGroup : getSelectedAndFirstFewVariants(variantGroup, showSelectAll, LIMIT_CELLS, selection);
        return /*#__PURE__*/ react.createElement(VariantGridWrapper, {
            key: key
        }, showSelectAll && selectAllCell, variantsToDisplay.map(function(sizeVariant) {
            return /*#__PURE__*/ react.createElement(VariantGridCell, {
                key: sizeVariant.size
            }, /*#__PURE__*/ react.createElement(SizeVariantSelectionButton, {
                handleSelection: handleSelection,
                title: sizeVariant.size,
                variant: sizeVariant.size,
                selection: selection,
                disabled: sizeVariant.disabled,
                isMobile: isMobile
            }));
        }), isMobile && variantGroup.length > LIMIT_CELLS && /*#__PURE__*/ react.createElement(StyledShowMoreButtonWrapper, null, /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
            fullWidth: true,
            onClick: function() {
                return setIsExpanded(!isExpanded);
            }
        }, isExpanded ? t("common", "button.show-less") : t("common", "button.show-more"))));
    };
    return /*#__PURE__*/ react.createElement("div", null, title && /*#__PURE__*/ react.createElement(VariantGridTitle, null, /*#__PURE__*/ react.createElement(text_variants.H4Text, null, title)), /*#__PURE__*/ react.createElement(ScrollableArea, null, groupedVariants.map(function(group, i) {
        return variantGroupCells(i, group, i === 0);
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variants-desktop-version.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}









var SizeVariantsDesktopVersion = function(props) {
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        zIndex: zindex/* zindex.overlay */.Y.overlay
    }, /*#__PURE__*/ react.createElement(DropdownToggle, {
        showActiveIcon: true,
        fullWidth: true,
        size: ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(DropdownButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, /*#__PURE__*/ react.createElement(SizeVariantsButtonLabel, null))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: ui/* Direction.Down */.Nm.Down
    }, /*#__PURE__*/ react.createElement(SizeVariantsGrid, _extends({}, props))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variants-mobile-version.tsx




var SizeVariantsMobileVersion = function(props) {
    var variants = props.variants, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(SizeVariantsGrid, {
        variants: variants,
        handleSelection: handleSelection,
        title: getSizeTitle(t),
        isMobile: isMobile
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/index.tsx






var FILTER_TYPE = types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE;
var SizeVariants = function(props) {
    var distinctValues = props.distinctValues, isMobile = props.isMobile;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilter = ref.getFilter, setFilterSelection = ref.setFilterSelection, toggleFilter = ref.toggleFilter;
    var filter = getFilter(FILTER_TYPE);
    var selection = (filter === null || filter === void 0 ? void 0 : filter.active) && (filter === null || filter === void 0 ? void 0 : filter.selection) ? filter === null || filter === void 0 ? void 0 : filter.selection : [];
    var handleSelection = function(variant) {
        var newSelection = createNewSelection(variant, (selection === null || selection === void 0 ? void 0 : selection.length) ? selection : []);
        if ((filter === null || filter === void 0 ? void 0 : filter.active) && newSelection.length === 0) {
            toggleFilter(FILTER_TYPE);
        } else {
            setFilterSelection(FILTER_TYPE, newSelection);
        }
    };
    if (distinctValues.length <= 1) {
        return null;
    }
    return isMobile ? /*#__PURE__*/ react.createElement(SizeVariantsMobileVersion, {
        handleSelection: handleSelection,
        variants: distinctValues,
        isMobile: isMobile
    }) : /*#__PURE__*/ react.createElement(SizeVariantsDesktopVersion, {
        handleSelection: handleSelection,
        variants: distinctValues,
        isMobile: isMobile
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variants-button-label.tsx








var ColorVariantsButtonLabel = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var filter = getFilter(types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR);
    var ref;
    var selectedVariants = (ref = getSelectionsString(t, filter)) !== null && ref !== void 0 ? ref : t("product", "variants.all");
    return /*#__PURE__*/ react.createElement(DropdownButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("product", "label.color"), ":", " ", /*#__PURE__*/ react.createElement(SelectionHighlightedText, null, selectedVariants)));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/styles.ts
function color_variants_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function color_variants_styles_templateObject() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n    width: max-content;\n    max-width: 340px;\n    margin: 0 ",
        ";\n  "
    ]);
    color_variants_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function color_variants_styles_templateObject1() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  width: 100%;\n  flex-wrap: wrap;\n\n  ",
        "\n"
    ]);
    color_variants_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function color_variants_styles_templateObject2() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 1px;\n  order: ",
        ";\n"
    ]);
    color_variants_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function color_variants_styles_templateObject3() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    color_variants_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function color_variants_styles_templateObject4() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n    min-width: ",
        ";\n    height: ",
        ";\n    min-height: ",
        ";\n    border-radius: ",
        ";\n    background: ",
        ";\n\n    ",
        ";\n  "
    ]);
    color_variants_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var styles_VariantGridWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridWrapper",
    componentId: "sc-0-0"
})(color_variants_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumUp */.BC.mediumUp(color_variants_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var styles_VariantGridCell = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridCell",
    componentId: "sc-0-1"
})(color_variants_styles_templateObject2(), function(props) {
    return props.$order;
});
var StyledColorDot = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledColorDot",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(color_variants_styles_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.$hex, props.$hex === "#FFFFFF" && (0,styled_components_browser_esm.css)(color_variants_styles_templateObject3(), props.theme.colors.base300));
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variant-selection-button.tsx






var ColorVariantSelectionButton = function(props) {
    var variant = props.variant, title = props.title, selection = props.selection, disabled = props.disabled, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var colorVal = getColor(variant);
    var buttonText = title !== null && title !== void 0 ? title : getColorTranslation(t, variant);
    var isSelected = Boolean(variant && (selection === null || selection === void 0 ? void 0 : selection.includes(variant)) || !variant && !selection);
    var onSelect = function() {
        return handleSelection(variant);
    };
    return /*#__PURE__*/ react.createElement(styles_VariantGridCell, {
        $order: colorVal.order
    }, /*#__PURE__*/ react.createElement(ui_button.Button, {
        onClick: onSelect,
        selectable: true,
        selected: isSelected,
        fullWidth: true,
        type: ui_button.ButtonType.OUTLINED,
        elevation: ui_button.ButtonElevation.NONE,
        disabled: disabled,
        size: isMobile ? ui_button.ButtonSize.NORMAL : ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, colorVal.hex && /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(StyledColorDot, {
        $hex: colorVal.hex
    })), /*#__PURE__*/ react.createElement(ui_button.ButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, buttonText))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variants-grid.tsx








var ColorVariantsGrid = function(props) {
    var title = props.title, variants = props.variants, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var filter = getFilter(types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR);
    var selection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : undefined;
    var sortedVariants = variants === null || variants === void 0 ? void 0 : variants.filter(Boolean);
    return /*#__PURE__*/ react.createElement("div", null, title && /*#__PURE__*/ react.createElement(VariantGridTitle, null, /*#__PURE__*/ react.createElement(text_variants.H4Text, null, title)), /*#__PURE__*/ react.createElement(ScrollableArea, null, /*#__PURE__*/ react.createElement(styles_VariantGridWrapper, null, /*#__PURE__*/ react.createElement(styles_VariantGridCell, {
        $order: 0
    }, /*#__PURE__*/ react.createElement(ColorVariantSelectionButton, {
        variant: null,
        title: t("product", "variants.all"),
        selection: selection,
        handleSelection: handleSelection,
        isMobile: isMobile
    })), sortedVariants === null || sortedVariants === void 0 ? void 0 : sortedVariants.map(function(variant) {
        return /*#__PURE__*/ react.createElement(ColorVariantSelectionButton, {
            variant: variant.color,
            selection: selection,
            handleSelection: handleSelection,
            disabled: variant.disabled,
            key: variant.color,
            isMobile: isMobile
        });
    }))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variants-desktop-version.tsx
function color_variants_desktop_version_extends() {
    color_variants_desktop_version_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return color_variants_desktop_version_extends.apply(this, arguments);
}









var ColorVariantsDesktopVersion = function(props) {
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        zIndex: zindex/* zindex.overlay */.Y.overlay
    }, /*#__PURE__*/ react.createElement(DropdownToggle, {
        showActiveIcon: true,
        fullWidth: true,
        size: ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(DropdownButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, /*#__PURE__*/ react.createElement(ColorVariantsButtonLabel, null))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: ui/* Direction.Down */.Nm.Down
    }, /*#__PURE__*/ react.createElement(ColorVariantsGrid, color_variants_desktop_version_extends({}, props))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variants-mobile-version.tsx



var ColorVariantsMobileVersion = function(props) {
    var variants = props.variants, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(ColorVariantsGrid, {
        variants: variants,
        handleSelection: handleSelection,
        title: t("product", "label.color"),
        isMobile: isMobile
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/index.tsx






var color_variants_FILTER_TYPE = types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR;
var ColorVariants = function(props) {
    var distinctValues = props.distinctValues, isMobile = props.isMobile;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilter = ref.getFilter, setFilterSelection = ref.setFilterSelection, toggleFilter = ref.toggleFilter;
    var filter = getFilter(color_variants_FILTER_TYPE);
    var selection = (filter === null || filter === void 0 ? void 0 : filter.active) && (filter === null || filter === void 0 ? void 0 : filter.selection) ? filter === null || filter === void 0 ? void 0 : filter.selection : [];
    var handleSelection = function(variant) {
        var newSelection = createNewSelection(variant, (selection === null || selection === void 0 ? void 0 : selection.length) ? selection : []);
        if ((filter === null || filter === void 0 ? void 0 : filter.active) && newSelection.length === 0) {
            toggleFilter(color_variants_FILTER_TYPE);
        } else {
            setFilterSelection(color_variants_FILTER_TYPE, newSelection);
        }
    };
    if (distinctValues.length <= 1) {
        return null;
    }
    return isMobile ? /*#__PURE__*/ react.createElement(ColorVariantsMobileVersion, {
        handleSelection: handleSelection,
        variants: distinctValues,
        isMobile: isMobile
    }) : /*#__PURE__*/ react.createElement(ColorVariantsDesktopVersion, {
        handleSelection: handleSelection,
        variants: distinctValues,
        isMobile: isMobile
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(7920);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(58425);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(51676);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(42574);
// EXTERNAL MODULE: ./src/areas/product/utils/price-list/split-list.ts
var split_list = __webpack_require__(93476);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/styles.ts
function product_filters_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_filters_styles_templateObject() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n    margin: 0;\n  "
    ]);
    product_filters_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_filters_styles_templateObject1() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n\n  ",
        "\n"
    ]);
    product_filters_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_filters_styles_templateObject2() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  width: fit-content;\n"
    ]);
    product_filters_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_filters_styles_templateObject3() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  gap: ",
        ";\n"
    ]);
    product_filters_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_filters_styles_templateObject4() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  column-gap: ",
        ";\n"
    ]);
    product_filters_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  min-width: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  span {\n    overflow: hidden;\n    max-width: 280px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  z-index: ",
        ";\n  margin-bottom: ",
        ";\n\n  button > span {\n    overflow: hidden;\n    max-width: 280px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "display: none"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n    padding: ",
        " ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  padding: ",
        " ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}






var FiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersWrapper",
    componentId: "sc-0-0"
})(product_filters_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(product_filters_styles_templateObject()));
var Filter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Filter",
    componentId: "sc-0-1"
})(product_filters_styles_templateObject2());
var StyledModalInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledModalInner",
    componentId: "sc-0-2"
})(product_filters_styles_templateObject3(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var StyledIconImageText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledIconImageText",
    componentId: "sc-0-3"
})(product_filters_styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledFooterInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFooterInner",
    componentId: "sc-0-4"
})(styles_templateObject5(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var CLEAR_BTN_MIN_WIDTH = "120px";
var StyledClearButton = (0,styled_components_browser_esm["default"])(button_variants.TonalButton).withConfig({
    displayName: "StyledClearButton",
    componentId: "sc-0-5"
})(_templateObject6(), CLEAR_BTN_MIN_WIDTH);
var StyledPrimaryButton = (0,styled_components_browser_esm["default"])(button_variants.PrimaryButton).withConfig({
    displayName: "StyledPrimaryButton",
    componentId: "sc-0-6"
})(_templateObject7());
var OutlinedModalButton = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).withConfig({
    displayName: "OutlinedModalButton",
    componentId: "sc-0-7"
})(_templateObject9(), base/* media.mediumUp */.BC.mediumUp(_templateObject8()));
var StyledRelationsDropDown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "StyledRelationsDropDown",
    componentId: "sc-0-8"
})(_templateObject11(), zindex/* zindex.overlay */.Y.overlay, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallDown */.BC.smallDown(_templateObject10()));
var RelationItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelationItem",
    componentId: "sc-0-9"
})(_templateObject14(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, function(p) {
    return p.$selected && base/* media.mediumUp */.BC.mediumUp(_templateObject12());
}, base/* media.smallOnly */.BC.smallOnly(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075), light_theme_colors.maybeBlue700);
var ModalFooterContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ModalFooterContent",
    componentId: "sc-0-10"
})(_templateObject15());

;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/utils/index.ts


var getVariantSelections = function(t, getFilter) {
    var sizes = getSelectionsString(t, getFilter(types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE));
    var colors = getSelectionsString(t, getFilter(types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR));
    return [
        sizes,
        colors
    ].filter(function(x) {
        return x;
    }).join(", ");
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/modal-view.tsx
function modal_view_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function modal_view_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function modal_view_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function modal_view_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function modal_view_slicedToArray(arr, i) {
    return modal_view_arrayWithHoles(arr) || modal_view_iterableToArrayLimit(arr, i) || modal_view_unsupportedIterableToArray(arr, i) || modal_view_nonIterableRest();
}
function modal_view_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return modal_view_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return modal_view_arrayLikeToArray(o, minLen);
}















var ModalView = function(props) {
    var components = props.components, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var ref1 = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getActiveFilters = ref1.getActiveFilters, getFilter = ref1.getFilter, resetFiltersByPlacement = ref1.resetFiltersByPlacement;
    var offers = (0,product_context/* useProductContext */.$h)().offers;
    var selections = getVariantSelections(t, getFilter);
    var ref2 = modal_view_slicedToArray((0,react.useState)(false), 2), visible = ref2[0], setVisible = ref2[1];
    var closeHandler = function() {
        return setVisible(false);
    };
    var toggleHandler = function() {
        return setVisible(!visible);
    };
    var filterHits = (0,split_list/* getSplitOfferlist */.Z1)(offers.filteredOffers, getActiveFilters()).mainList.length;
    var renderButtonLabel = function() {
        var singleComponentWithCustomButton = components.length === 1 && components[0].buttonLabelComponent;
        if (singleComponentWithCustomButton) {
            // For single variant selection
            return /*#__PURE__*/ react.createElement(react.Fragment, null, singleComponentWithCustomButton, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, visible ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)));
        }
        return /*#__PURE__*/ react.createElement(StyledIconImageText, null, /*#__PURE__*/ react.createElement("img", {
            src: "".concat(market.cdn, "/g/rfe/illustrations/icon-color-wheel-20x20px.png"),
            srcSet: "".concat(market.cdn, "/g/rfe/illustrations/icon-color-wheel-20x20px.png 1x, ").concat(market.cdn, "/g/rfe/illustrations/icon-color-wheel-40x40px.png 2x"),
            alt: ""
        }), /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
            behavior: text_variants.Behavior.OnelineEllipsis
        }, t("product", "variants.select-variants"), Boolean(selections) && /*#__PURE__*/ react.createElement(SelectionHighlightedText, null, " (", selections, ")")));
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
        onClick: toggleHandler,
        fullWidth: true,
        selectable: true,
        disabled: disabled
    }, renderButtonLabel()), visible && /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: true,
        onRequestClose: closeHandler,
        title: t("product", "variants.select-variants")
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(StyledModalInner, null, components.map(function(component) {
        return /*#__PURE__*/ react.createElement("div", {
            key: component.key
        }, component.selectorComponent);
    }))), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(StyledFooterInner, null, /*#__PURE__*/ react.createElement(StyledClearButton, {
        onClick: function() {
            return resetFiltersByPlacement(types/* FilterUIPlacementEnum.PRODUCT_HEADER */.jm.PRODUCT_HEADER);
        }
    }, t("common", "button.clear")), /*#__PURE__*/ react.createElement(StyledPrimaryButton, {
        onClick: closeHandler
    }, t("product", "prices.filter-offers-count", {
        n: filterHits ? String(filterHits) : "0"
    })))))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/utils/common.ts
function common_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function common_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return common_arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function common_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function common_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function common_toConsumableArray(arr) {
    return common_arrayWithoutHoles(arr) || common_iterableToArray(arr) || common_unsupportedIterableToArray(arr) || common_nonIterableSpread();
}
function common_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return common_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return common_arrayLikeToArray(o, minLen);
}

var getVariantProp = function(variantType, variant) {
    switch(variantType){
        case types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE:
            return variant.size;
        case types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR:
            return variant.color;
        default:
            return "";
    }
};
var getDistinct = function(variantType, values) {
    if (variantType === types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE) {
        return common_toConsumableArray(new Map(values.filter(function(v) {
            return v.size;
        }).map(function(item) {
            return [
                item.size,
                item
            ];
        })).values());
    }
    if (variantType === types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR) {
        return common_toConsumableArray(new Map(values.filter(function(v) {
            return v.color;
        }).map(function(item) {
            return [
                item.color,
                item
            ];
        })).values());
    }
    return [];
};
var getValuesFromVariant = function(variantType, variant) {
    var ref;
    var values = [];
    if (variantType === types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE && (variant === null || variant === void 0 ? void 0 : variant.size) && (variant === null || variant === void 0 ? void 0 : variant.sizeSystem)) {
        var val = {
            size: variant === null || variant === void 0 ? void 0 : variant.size,
            sizeSystem: variant === null || variant === void 0 ? void 0 : variant.sizeSystem
        };
        values.push(val);
    }
    if (variantType === types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR && (variant === null || variant === void 0 ? void 0 : variant.colors) && (variant === null || variant === void 0 ? void 0 : (ref = variant.colors) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        variant === null || variant === void 0 ? void 0 : variant.colors.forEach(function(color) {
            values.push({
                color: color
            });
        });
    }
    return values;
};
var disableVariantValues = function(variantType, allVariantValues, currentVariantValues, mobileContractIsActive) {
    return allVariantValues.map(function(variant) {
        return _objectSpreadProps(_objectSpread({}, variant), {
            disabled: mobileContractIsActive || !currentVariantValues.some(function(current) {
                return getVariantProp(variantType, variant) === getVariantProp(variantType, current);
            })
        });
    });
};
var getDistinctVariantValues = function(variantType, offers) {
    var allValues = [];
    offers.forEach(function(offer) {
        var ref;
        var values = getValuesFromVariant(variantType, offer.variantInfo);
        if (values.length > 0) {
            var _allValues;
            (_allValues = allValues).push.apply(_allValues, common_toConsumableArray(values));
        }
        (ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.forEach(function(alt) {
            var altValues = getValuesFromVariant(variantType, alt === null || alt === void 0 ? void 0 : alt.variantInfo);
            if (altValues.length > 0) {
                var _allValues;
                (_allValues = allValues).push.apply(_allValues, common_toConsumableArray(altValues));
            }
        });
    });
    return getDistinct(variantType, allValues);
};
var getVariantValues = function(variantType, filteredOffers, allOffers, mobileContractIsActive) {
    var filteredVariantsValues = getDistinctVariantValues(variantType, filteredOffers);
    var allVariantValues = getDistinctVariantValues(variantType, allOffers);
    return disableVariantValues(variantType, allVariantValues, filteredVariantsValues, mobileContractIsActive);
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/utils/whitelist.ts
var ENABLED_MARKETS = [
    "se",
    "no",
    "fi",
    "fr",
    "gb"
];
var CATEGORY_WHITE_LIST = [
    "1944",
    "148",
    "1827",
    "707",
    "1594",
    "401",
    "2621",
    "1349",
    "1351",
    "767",
    "769",
    "770",
    "1987",
    "2062",
    "1915",
    "2251",
    "3273",
    "2222",
    "2040",
    "551",
    "1110",
    "1918",
    "2027",
    "3215",
    "2086",
    "3172",
    "1153",
    "1166",
    "1327",
    "1326",
    "1325",
    "1152",
    "2019",
    "3187",
    "2020",
    "2021",
    "103",
    "879",
    "1808",
    "1792",
    "2668",
    "2741",
    "1973",
    "2760",
    "2395",
    "2047",
    "2772",
    "2774",
    "917",
    "3582",
    "3437",
    "3439",
    "2401",
    "1155",
    "2064",
    "1672",
    "1726",
    "2603",
    "1634",
    "1629",
    "3533",
    "1182",
    "1869",
    "1180",
    "1512",
    "1621",
    "3541",
    "1406",
    "1976",
    "1401",
    "1402",
    "1405",
    "1914",
    "1754",
    "2",
    "5130"
];
var isWhitelistedForColors = function(market, category) {
    var ref, ref1;
    if (!ENABLED_MARKETS.some(function(code) {
        return code === market.code;
    })) {
        return false;
    }
    return Boolean((category === null || category === void 0 ? void 0 : (ref = category.path) === null || ref === void 0 ? void 0 : ref.length) && (category === null || category === void 0 ? void 0 : (ref1 = category.path) === null || ref1 === void 0 ? void 0 : ref1.some(function(categoryPath) {
        return CATEGORY_WHITE_LIST.includes(categoryPath.id);
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/utils/whitelist.ts
var WHITE_LIST = [
    "1944"
];
var isWhitelistedForSizes = function(category) {
    var ref, ref1;
    return Boolean((category === null || category === void 0 ? void 0 : (ref = category.path) === null || ref === void 0 ? void 0 : ref.length) && (category === null || category === void 0 ? void 0 : (ref1 = category.path) === null || ref1 === void 0 ? void 0 : ref1.some(function(categoryPath) {
        return WHITE_LIST.includes(categoryPath.id);
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/utils/blacklist.ts
var BLACK_LIST = [
    "401",
    "894"
];
var isBlacklistedForColors = function(category) {
    var ref, ref1;
    return Boolean((category === null || category === void 0 ? void 0 : (ref = category.path) === null || ref === void 0 ? void 0 : ref.length) && (category === null || category === void 0 ? void 0 : (ref1 = category.path) === null || ref1 === void 0 ? void 0 : ref1.some(function(categoryPath) {
        return BLACK_LIST.includes(categoryPath.id);
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/utils/blacklist.ts
var blacklist_BLACK_LIST = [
    "894"
];
var isBlacklistedForSizes = function(category) {
    var ref, ref1;
    return Boolean((category === null || category === void 0 ? void 0 : (ref = category.path) === null || ref === void 0 ? void 0 : ref.length) && (category === null || category === void 0 ? void 0 : (ref1 = category.path) === null || ref1 === void 0 ? void 0 : ref1.some(function(categoryPath) {
        return blacklist_BLACK_LIST.includes(categoryPath.id);
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/product-filter-components.tsx



















var ProductFilterComponents = function(props) {
    var isMobile = props.isMobile;
    var market = (0,app_context/* useAppContext */.bp)().market;
    var ref = (0,product_context/* useProductContext */.$h)(), mobileContracts = ref.mobileContracts, product = ref.product;
    var allOffers = (0,product_context/* useProductContext */.$h)().allOffers;
    var getActiveFilters = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getActiveFilters;
    var search = (0,react_router_dom/* useLocation */.TH)().search;
    var showAllVariantsExperiment = (0,dist_module.useFeatureFlag)("variants-all");
    var components = [];
    var mobileContractIsActive = Boolean(mobileContracts.length && search.includes("list=mobile-contract"));
    var getValuesForVariantFilterType = function(variantFilter) {
        // Values should be based on all offers found in current filtered offerlist
        var activeFilters = getActiveFilters();
        // But we want to keep offers that are filtered out based on the selection of the specified variant
        var filtersExclSpecifiedType = activeFilters.filter(function(f) {
            return f.type !== variantFilter;
        });
        var filteredOffers = (0,filtering/* filterOffers */.hS)(filtersExclSpecifiedType, product.prices);
        return getVariantValues(variantFilter, filteredOffers, allOffers, mobileContractIsActive);
    };
    var CreateSizeVariantsComponent = function() {
        var show = showAllVariantsExperiment || isWhitelistedForSizes(product.category) && !isBlacklistedForSizes(product.category);
        if (!show) {
            return;
        }
        var variantValues = getValuesForVariantFilterType(types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE);
        if (allOffers.length > 1 && variantValues.length > 1) {
            components.push({
                key: "size-variants",
                buttonLabelComponent: /*#__PURE__*/ react.createElement(SizeVariantsButtonLabel, null),
                selectorComponent: /*#__PURE__*/ react.createElement(SizeVariants, {
                    distinctValues: variantValues,
                    isMobile: isMobile
                })
            });
        }
    };
    CreateSizeVariantsComponent();
    var CreateColorVariantsComponent = function() {
        var show = showAllVariantsExperiment || isWhitelistedForColors(market, product.category) && !isBlacklistedForColors(product.category);
        if (!show) {
            return;
        }
        var variantValues = getValuesForVariantFilterType(types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR);
        if (allOffers.length > 1 && variantValues.length > 1) {
            components.push({
                key: "color-variants",
                buttonLabelComponent: /*#__PURE__*/ react.createElement(ColorVariantsButtonLabel, null),
                selectorComponent: /*#__PURE__*/ react.createElement(ColorVariants, {
                    distinctValues: variantValues,
                    isMobile: isMobile
                })
            });
        }
    };
    CreateColorVariantsComponent();
    var hasComponents = components.length > 0;
    var onlyConditionComponentVisible = components.length === 1 && components.find(function(c) {
        return c.key === "conditions";
    });
    var showModal = isMobile && hasComponents && !onlyConditionComponentVisible;
    return showModal ? /*#__PURE__*/ react.createElement(ModalView, {
        components: components,
        disabled: mobileContractIsActive
    }) : /*#__PURE__*/ react.createElement(react.Fragment, null, components.map(function(component) {
        return /*#__PURE__*/ react.createElement(Filter, {
            key: component.key
        }, component.selectorComponent);
    }));
};

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/relations-dropdown.tsx
function relations_dropdown_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function relations_dropdown_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function relations_dropdown_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function relations_dropdown_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function relations_dropdown_slicedToArray(arr, i) {
    return relations_dropdown_arrayWithHoles(arr) || relations_dropdown_iterableToArrayLimit(arr, i) || relations_dropdown_unsupportedIterableToArray(arr, i) || relations_dropdown_nonIterableRest();
}
function relations_dropdown_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return relations_dropdown_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return relations_dropdown_arrayLikeToArray(o, minLen);
}










var RelationsDropdown = function(param) {
    var relationType = param.relationType, title = param.title;
    var ref = relations_dropdown_slicedToArray((0,react.useState)(), 2), relationItems = ref[0], setRelationItems = ref[1];
    var ref1 = relations_dropdown_slicedToArray((0,react.useState)(), 2), selected = ref1[0], setSelected = ref1[1];
    var ref2 = relations_dropdown_slicedToArray((0,react.useState)(false), 2), isOpen = ref2[0], setIsOpen = ref2[1];
    var product = (0,product_context/* useProductContext */.$h)().product;
    (0,react.useEffect)(function() {
        var ref;
        if (!(product === null || product === void 0 ? void 0 : product.relations) || ((ref = product.relations) === null || ref === void 0 ? void 0 : ref.length) <= 0) {
            return;
        }
        getRelationList();
    }, []);
    var getRelationList = function() {
        var ref, ref1;
        var relations = (ref1 = (ref = product.relations) === null || ref === void 0 ? void 0 : ref.filter(function(relation) {
            return relation.type === relationType;
        })[0]) === null || ref1 === void 0 ? void 0 : ref1.relations.filter(function(item) {
            return item.sortPriority !== 0;
        }).sort(function(a, b) {
            return a.sortPriority - b.sortPriority;
        });
        if (!relations) {
            return;
        }
        setSelected(relations.filter(function(item) {
            return item.selected;
        })[0]);
        setRelationItems(relations);
    };
    if (!selected || !relationItems || relationItems.length <= 1) {
        return null;
    }
    var renderRelationList = function() {
        var items = relationItems === null || relationItems === void 0 ? void 0 : relationItems.map(function(item) {
            var ref;
            var searchEncoded = encodeURIComponent(item.name);
            var categoryEncoded = encodeURIComponent("pc:".concat((ref = product.category) === null || ref === void 0 ? void 0 : ref.pathName.replace("/c/", "")));
            var link = "/search?query=".concat(searchEncoded, "&category_id=").concat(categoryEncoded);
            return /*#__PURE__*/ react.createElement(RelationItem, {
                key: item.name
            }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, "Del ".concat(item.sortPriority, ": "), /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
                to: link,
                onClick: function() {
                    (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.PRODUCT_RELATIONS */.U.PRODUCT_RELATIONS,
                        nextPage: link
                    });
                }
            }, item.name)));
        });
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(RelationItem, {
            $selected: true
        }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, "Del ".concat(selected.sortPriority, ": ").concat(selected.name))), items);
    };
    var renderContent = function() {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(RelationItem, null, /*#__PURE__*/ react.createElement(text_variants.H4Text, null, title)), renderRelationList());
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(modal/* Modal */.u_, {
        isOpen: isOpen,
        onRequestClose: function() {
            return setIsOpen(false);
        },
        title: title
    }, renderRelationList(), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(ModalFooterContent, null, /*#__PURE__*/ react.createElement(button_variants.TonalButton, {
        onClick: function() {
            return setIsOpen(false);
        }
    }, "Close")))), /*#__PURE__*/ react.createElement(OutlinedModalButton, {
        onClick: function() {
            return setIsOpen(true);
        }
    }, /*#__PURE__*/ react.createElement("span", null, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, "Del ".concat(selected.sortPriority, ": ")), /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        color: text_variants.FontColor.PRIMARY
    }, selected.name)), /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)), /*#__PURE__*/ react.createElement(StyledRelationsDropDown, null, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        showActiveIcon: true
    }, /*#__PURE__*/ react.createElement("span", null, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, "Del ".concat(selected.sortPriority, ": ")), /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        color: text_variants.FontColor.PRIMARY
    }, selected.name))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        height: 280,
        width: 320
    }, renderContent())));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/index.tsx






var ProductFilters = function() {
    var market = (0,app_context/* useAppContext */.bp)().market;
    var renderProductFilterComponents = function(isMobile) {
        return /*#__PURE__*/ react.createElement(FiltersWrapper, null, /*#__PURE__*/ react.createElement(ProductFilterComponents, {
            isMobile: isMobile
        }));
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, market.code === "se" && /*#__PURE__*/ react.createElement(RelationsDropdown, {
        title: "Delar i serien",
        relationType: "Book series SE/Sweden"
    }), /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, renderProductFilterComponents(false)), /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, renderProductFilterComponents(true)));
};

// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(52923);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(51362);
// EXTERNAL MODULE: ./src/components/rating/star-icons.tsx
var star_icons = __webpack_require__(12814);
// EXTERNAL MODULE: ./src/components/sentiment-badge/index.js + 1 modules
var sentiment_badge = __webpack_require__(47910);
// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/types.ts
var product_tabs_types = __webpack_require__(61240);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/LinkToReviews.tsx





var LinkToReviewsComponent = function(param) {
    var children = param.children;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var to = "".concat(location.pathname).concat(location.search).concat(product_tabs_types/* TabAnchor.REVIEWS */.X.REVIEWS);
    var onClick = function() {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.PRODUCT_HEADER */.U.PRODUCT_HEADER,
            nextPage: to
        });
    };
    return /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: to,
        onClick: onClick,
        "aria-label": t("product", "tabs.reviews")
    }, children);
};
var LinkToReviews = /*#__PURE__*/ (0,react.memo)(LinkToReviewsComponent);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var ui_badge = __webpack_require__(72321);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(69140);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/components/rank-badge/index.tsx
function rank_badge_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function rank_badge_templateObject() {
    var data = rank_badge_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    rank_badge_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function rank_badge_templateObject1() {
    var data = rank_badge_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  outline: none;\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n  }\n"
    ]);
    rank_badge_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var RankBadge = function(props) {
    var category = props.category, rank = props.rank;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRankCategoryClick = function() {
        return dispatch((0,product/* headerClickEvent */.Yc)("rank-category"));
    };
    var renderBadge = function(linkLocation) {
        if (!rank) return null;
        var badge = /*#__PURE__*/ react.createElement(ui_badge.Badge, {
            color: "BLUE",
            key: "categoryRank",
            text: t("product", "rank.position", {
                rank: /*#__PURE__*/ react.createElement("span", {
                    key: "rank"
                }, rank)
            })
        });
        if (!linkLocation) {
            return badge;
        }
        return /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            to: linkLocation
        }, badge);
    };
    return /*#__PURE__*/ react.createElement(StyledRankBadge, null, /*#__PURE__*/ react.createElement(Link, {
        to: category.pathName,
        key: "categoryLink",
        onClick: handleRankCategoryClick
    }, renderBadge()));
};
var StyledRankBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRankBadge",
    componentId: "sc-0-0"
})(rank_badge_templateObject(), function(p) {
    return p.theme.colors.base600;
});
var Link = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Link",
    componentId: "sc-0-1"
})(rank_badge_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.text.callToAction;
});

// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/index.tsx + 1 modules
var product_price_history = __webpack_require__(53373);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/components/price-history-summary/styles.ts
function price_history_summary_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_history_summary_styles_templateObject() {
    var data = price_history_summary_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  "
    ]);
    price_history_summary_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function price_history_summary_styles_templateObject1() {
    var data = price_history_summary_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    price_history_summary_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function price_history_summary_styles_templateObject2() {
    var data = price_history_summary_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-content: space-between;\n  gap: ",
        ";\n"
    ]);
    price_history_summary_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function price_history_summary_styles_templateObject3() {
    var data = price_history_summary_styles_taggedTemplateLiteral([
        "\n  display: inline;\n  margin-left: ",
        ";\n"
    ]);
    price_history_summary_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function price_history_summary_styles_templateObject4() {
    var data = price_history_summary_styles_taggedTemplateLiteral([
        "\n    text-decoration: underline;\n    line-height: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  "
    ]);
    price_history_summary_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-0"
})(price_history_summary_styles_templateObject1(), base/* media.largeUp */.BC.largeUp(price_history_summary_styles_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150));
var StyledTitleRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTitleRow",
    componentId: "sc-0-1"
})(price_history_summary_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledPriceLabel = (0,styled_components_browser_esm["default"])(text_variants.H4Text).withConfig({
    displayName: "StyledPriceLabel",
    componentId: "sc-0-2"
})(price_history_summary_styles_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledPriceHistoryLabel = (0,styled_components_browser_esm["default"])(text_variants.BodySmallText).withConfig({
    displayName: "StyledPriceHistoryLabel",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(price_history_summary_styles_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, props.theme.text.callToAction);
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/components/price-history-summary/index.tsx












var PriceHistorySummary = function() {
    var ref;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref1.t, market = ref1.market;
    var offers = (0,product_context/* useProductContext */.$h)().offers;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var link = "".concat(location.pathname).concat(location.search).concat(product_tabs_types/* TabAnchor.STATISTICS */.X.STATISTICS);
    var priceHistoryLinkText = market.code === "fr" ? t("product", "price-history.title") : t("product", "related-pages.related-products", {
        relatedProductsLink: t("product", "price-history.title").toLocaleLowerCase()
    });
    var handlePriceHistoryClick = function() {
        dispatch((0,product/* headerClickEvent */.Yc)("price-history"));
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.PRODUCT_PRODUCT_HEADER */.U.PRODUCT_PRODUCT_HEADER,
            currentPage: location.pathname + location.search + location.hash,
            nextPage: link
        });
    };
    return /*#__PURE__*/ react.createElement(StyledLink, {
        to: link,
        onClick: handlePriceHistoryClick,
        "aria-label": t("product", "tabs.price-history"),
        "data-test": "PriceHistorySummary"
    }, offers.initialNewOffers.length > 0 && /*#__PURE__*/ react.createElement(StyledTitleRow, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        emphasis: text_variants.FontEmphasis.HIGH
    }, t("product", "price-history.current-lowest-price"), /*#__PURE__*/ react.createElement(StyledPriceLabel, null, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        key: "lowestPrice",
        price: (ref = offers.initialNewOffers[0].price) === null || ref === void 0 ? void 0 : ref.exclShipping
    }))), /*#__PURE__*/ react.createElement(StyledPriceHistoryLabel, {
        emphasis: text_variants.FontEmphasis.MEDIUM
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, priceHistoryLinkText))), /*#__PURE__*/ react.createElement(product_price_history/* ProductPriceHistory */.N, {
        mode: "mini"
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/image/index.js
var icon_image = __webpack_require__(30130);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/play-circle-outlined/index.js
var play_circle_outlined = __webpack_require__(65399);
// EXTERNAL MODULE: ./src/components/badges/image-badges.tsx
var image_badges = __webpack_require__(21244);
// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(44266);
// EXTERNAL MODULE: ./src/areas/product/components/product-media-lightbox/index.ts
var product_media_lightbox = __webpack_require__(88877);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/product-media/media-counter.tsx
function media_counter_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function media_counter_templateObject() {
    var data = media_counter_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  > svg path {\n    fill: ",
        ";\n  }\n"
    ]);
    media_counter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(media_counter_templateObject(), function(p) {
    return p.theme.colors.base500;
});
var MediaCounter = function(param) {
    var icon = param.icon, mediaList = param.mediaList;
    if (!mediaList || mediaList.length === 0) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Wrapper, null, icon, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, mediaList.length));
};

// EXTERNAL MODULE: ./src/areas/product/actions/media.js
var actions_media = __webpack_require__(17696);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/product-media/styles.ts
function product_media_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_media_styles_templateObject() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n      opacity: 0.2;\n      max-height: 100%;\n      max-width: 100%;\n    "
    ]);
    product_media_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject1() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n      cursor: pointer;\n    "
    ]);
    product_media_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject2() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n    width: 100px;\n    height: 100px;\n  "
    ]);
    product_media_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject3() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n  width: 232px;\n  height: ",
        ";\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  &&:focus-visible {\n    outline: 2px solid ",
        ";\n  }\n"
    ]);
    product_media_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject4() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n  max-width: 200px;\n  max-height: 200px;\n"
    ]);
    product_media_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject5() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n    padding: ",
        " ",
        ";\n  "
    ]);
    product_media_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(247, 248, 248, 0.9);\n  border-radius: 18px;\n  display: flex;\n  gap: ",
        ";\n  padding: ",
        " ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var PRODUCT_MEDIA_HEIGHT = "232px";
var StyledProductMedia = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledProductMedia",
    componentId: "sc-0-0"
})(product_media_styles_templateObject3(), PRODUCT_MEDIA_HEIGHT, function(props) {
    return props.$isFallbackImage && (0,styled_components_browser_esm.css)(product_media_styles_templateObject());
}, function(props) {
    return props.$more && (0,styled_components_browser_esm.css)(product_media_styles_templateObject1());
}, base/* media.smallOnly */.BC.smallOnly(product_media_styles_templateObject2()), function(p) {
    return p.theme.colors.maybeBlue300;
});
var StyledFirstImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFirstImage",
    componentId: "sc-0-1"
})(product_media_styles_templateObject4());
var StyledCounters = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledCounters",
    componentId: "sc-0-2"
})(styles_templateObject6(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing025, design_tokens.measurements.spacing050, base/* media.largeUp */.BC.largeUp(product_media_styles_templateObject5(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing075));

// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/product-media/query.graphql
var query_graphql = __webpack_require__(91393);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/product-media/use-product-media.ts


function useProductMedia(variables) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        queryKey: [
            "product",
            "media"
        ],
        query: (query_graphql_default()),
        variables: variables
    });
}

;// CONCATENATED MODULE: ./src/areas/product/components/expert-review-badge/styles.tsx
function expert_review_badge_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function expert_review_badge_styles_templateObject() {
    var data = expert_review_badge_styles_taggedTemplateLiteral([
        "\n    width: 2rem\n  "
    ]);
    expert_review_badge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function expert_review_badge_styles_templateObject1() {
    var data = expert_review_badge_styles_taggedTemplateLiteral([
        "\n  width: 3.5rem;\n  position: absolute;\n  left: 0;\n  top: 0;\n  ",
        "\n"
    ]);
    expert_review_badge_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledExpertReviewBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledExpertReviewBadge",
    componentId: "sc-0-0"
})(expert_review_badge_styles_templateObject1(), base/* media.smallDown */.BC.smallDown(expert_review_badge_styles_templateObject()));

;// CONCATENATED MODULE: ./src/areas/product/components/expert-review-badge/index.tsx



var ExpertReviewBadge = function() {
    var market = (0,react.useContext)(app_context/* AppContext */.Il).market;
    var logo = "".concat(market.cdn, "/g/expert/").concat(market.code, "/expert-toprated-badge.png");
    return /*#__PURE__*/ react.createElement(StyledExpertReviewBadge, null, /*#__PURE__*/ react.createElement("img", {
        src: logo,
        alt: ""
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/sanity-badges/styles.ts
function sanity_badges_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sanity_badges_styles_templateObject() {
    var data = sanity_badges_styles_taggedTemplateLiteral([
        "\n    width: ",
        "\n  "
    ]);
    sanity_badges_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sanity_badges_styles_templateObject1() {
    var data = sanity_badges_styles_taggedTemplateLiteral([
        "\n  width: 3.5rem;\n  position: absolute;\n  left: 0;\n  top: 0;\n  ",
        "\n"
    ]);
    sanity_badges_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSanityBadgeComponent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSanityBadgeComponent",
    componentId: "sc-0-0"
})(sanity_badges_styles_templateObject1(), base/* media.smallDown */.BC.smallDown(sanity_badges_styles_templateObject(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200));

;// CONCATENATED MODULE: ./src/areas/product/components/sanity-badges/index.tsx


var SanityBadgeComponent = function(param) {
    var badge = param.badge;
    if (!badge || !badge.badgeImageUrl) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledSanityBadgeComponent, null, /*#__PURE__*/ react.createElement("img", {
        src: badge.badgeImageUrl,
        alt: ""
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/product-media/index.tsx
function product_media_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_media_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_media_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_media_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_media_slicedToArray(arr, i) {
    return product_media_arrayWithHoles(arr) || product_media_iterableToArrayLimit(arr, i) || product_media_unsupportedIterableToArray(arr, i) || product_media_nonIterableRest();
}
function product_media_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_media_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_media_arrayLikeToArray(o, minLen);
}















var ProductMedia = function(props) {
    var ref, ref1, ref2, ref3;
    var id = props.id, category = props.category, className = props.className, name = props.name, _isExpertTopRated = props.isExpertTopRated, isExpertTopRated = _isExpertTopRated === void 0 ? false : _isExpertTopRated, badges = props.badges;
    var data = useProductMedia({
        id: id
    }).data;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var ref4 = product_media_slicedToArray((0,react.useState)(false), 2), show = ref4[0], setShow = ref4[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var media = data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.media;
    // Filters out null values in arrays
    var images = media === null || media === void 0 ? void 0 : (ref1 = media.images) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
        return item;
    });
    var large = media === null || media === void 0 ? void 0 : (ref2 = media.large) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
        return item;
    });
    var videos = media === null || media === void 0 ? void 0 : (ref3 = media.videos) === null || ref3 === void 0 ? void 0 : ref3.filter(function(item) {
        return item;
    });
    var hasLightboxContent = function() {
        return Boolean((large === null || large === void 0 ? void 0 : large.length) || (videos === null || videos === void 0 ? void 0 : videos.length));
    };
    var open = function() {
        if (!hasLightboxContent()) {
            return;
        }
        setShow(true);
        dispatch((0,actions_media/* productMediaOpen */.WI)());
    };
    var close = function() {
        return setShow(false);
    };
    var product = (0,product_context/* useProductContext */.$h)().product;
    var productOfTheYearAward = (0,hooks/* useGetProductOfTheYear */.i)(product.id);
    var partnerBadge = badges ? badges.find(function(badge) {
        return badge.badgeType === "partner";
    }) : null;
    if (!media) {
        return /*#__PURE__*/ react.createElement(StyledProductMedia, {
            className: className,
            "data-test": "ProductMedia",
            "data-test-has-lightbox-content": false,
            $isFallbackImage: false,
            $more: false
        });
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, show && /*#__PURE__*/ react.createElement(product_media_lightbox/* default */.Z, {
        media: media,
        close: close
    }), /*#__PURE__*/ react.createElement(StyledProductMedia, {
        className: className,
        onClick: open,
        "data-test": "ProductMedia",
        "data-test-has-lightbox-content": hasLightboxContent(),
        $isFallbackImage: !(media === null || media === void 0 ? void 0 : media.first),
        $more: Boolean(images)
    }, (productOfTheYearAward === null || productOfTheYearAward === void 0 ? void 0 : productOfTheYearAward.awardLogo) && /*#__PURE__*/ react.createElement(image_badges/* ProductHeaderImageBadge */.ER, {
        badgeUrl: productOfTheYearAward.awardLogo,
        title: "".concat(productOfTheYearAward.awardName, " ").concat(productOfTheYearAward.year)
    }), /*#__PURE__*/ react.createElement(StyledFirstImage, null, /*#__PURE__*/ react.createElement("img", {
        src: media.first || (category === null || category === void 0 ? void 0 : category.logo) || undefined,
        alt: name
    })), isExpertTopRated && !productOfTheYearAward ? /*#__PURE__*/ react.createElement(ExpertReviewBadge, null) : null, partnerBadge && !productOfTheYearAward && !isExpertTopRated ? /*#__PURE__*/ react.createElement(SanityBadgeComponent, {
        badge: partnerBadge
    }) : null, (images || videos) && /*#__PURE__*/ react.createElement(StyledCounters, null, /*#__PURE__*/ react.createElement(MediaCounter, {
        icon: /*#__PURE__*/ react.createElement(icon_image/* IconImage */.Z, {
            size: isMobile ? 18 : 20
        }),
        mediaList: images
    }), /*#__PURE__*/ react.createElement(MediaCounter, {
        icon: /*#__PURE__*/ react.createElement(play_circle_outlined/* IconPlayCircleOutlined */.o, {
            size: isMobile ? 18 : 20
        }),
        mediaList: videos
    }))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/heart-outlined/index.js
var heart_outlined = __webpack_require__(72183);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/heart-filled/index.js
var heart_filled = __webpack_require__(87269);
// EXTERNAL MODULE: ./src/components/modal/login-promo.js + 1 modules
var login_promo = __webpack_require__(60428);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(73426);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/action-buttons/styles.ts
function action_buttons_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function action_buttons_styles_templateObject() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  list-style: none;\n  margin: 0;\n"
    ]);
    action_buttons_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject1() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "
    ]);
    action_buttons_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject2() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    action_buttons_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject3() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  flex: 0;\n  width: 100%;\n\n  & > div {\n    z-index: ",
        ";\n  }\n"
    ]);
    action_buttons_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject4() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n    white-space: nowrap;\n    overflow: hidden;\n  "
    ]);
    action_buttons_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject5() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    action_buttons_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject6() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    background-color: ",
        ";\n    justify-content: left;\n    margin: ",
        " 0;\n  "
    ]);
    action_buttons_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: ",
        ";\n  justify-content: left;\n  margin: ",
        " 0;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  padding: 10px;\n  background-color: ",
        ";\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}







var ListContainer = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "ListContainer",
    componentId: "sc-0-0"
})(action_buttons_styles_templateObject());
var ButtonText = (0,styled_components_browser_esm["default"])(text_variants.TitleSmallText).withConfig({
    displayName: "ButtonText",
    componentId: "sc-0-1"
})(action_buttons_styles_templateObject2(), base/* media.mediumUp */.BC.mediumUp(action_buttons_styles_templateObject1()));
var StyledTooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).attrs({
    width: "160px",
    placement: ui/* Direction.Up */.Nm.Up,
    "data-test": "Tooltip"
}).withConfig({
    displayName: "StyledTooltip",
    componentId: "sc-0-2"
})(action_buttons_styles_templateObject3(), zindex/* zindex.tooltip */.Y.tooltip);
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ContentWrapper",
    componentId: "sc-0-3"
})(action_buttons_styles_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.mediumUp */.BC.mediumUp(action_buttons_styles_templateObject4()));
var styles_StyledPrimaryButton = (0,styled_components_browser_esm["default"])(button_variants.PrimaryButton).withConfig({
    displayName: "StyledPrimaryButton",
    componentId: "sc-0-4"
})(styles_templateObject7(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(action_buttons_styles_templateObject6(), base/* colors.lightTheme.base0 */.O9.lightTheme.base0, base/* layout.measurements.spacing025 */.bK.measurements.spacing025));
var StyledDropdownItem = (0,styled_components_browser_esm["default"])(button_variants.TonalButton).withConfig({
    displayName: "StyledDropdownItem",
    componentId: "sc-0-5"
})(styles_templateObject8(), base/* colors.lightTheme.base0 */.O9.lightTheme.base0, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledCircularButton = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).attrs({
    radius: button_variants.ButtonRadius.CIRCLE,
    size: button_variants.ButtonSize.MEDIUM
}).withConfig({
    displayName: "StyledCircularButton",
    componentId: "sc-0-6"
})(styles_templateObject9(), base/* colors.lightTheme.base0 */.O9.lightTheme.base0, base/* colors.lightTheme.base100 */.O9.lightTheme.base100);

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/action-buttons/save-button/index.tsx
function save_button_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function save_button_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function save_button_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function save_button_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function save_button_slicedToArray(arr, i) {
    return save_button_arrayWithHoles(arr) || save_button_iterableToArrayLimit(arr, i) || save_button_unsupportedIterableToArray(arr, i) || save_button_nonIterableRest();
}
function save_button_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return save_button_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return save_button_arrayLikeToArray(o, minLen);
}








var SaveButton = function(param) {
    var addedToList = param.addedToList, onListClick = param.onListClick, styleAsDropdownItem = param.styleAsDropdownItem;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var ref1 = save_button_slicedToArray((0,react.useState)(false), 2), showLoginPromo = ref1[0], setLoginPromoState = ref1[1];
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var handleListClick = function() {
        return onListClick === null || onListClick === void 0 ? void 0 : onListClick(true);
    };
    var toggleLoginPromo = function() {
        return setLoginPromoState(!showLoginPromo);
    };
    if (!market.login.enabled) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("div", null, showLoginPromo && /*#__PURE__*/ react.createElement(login_promo/* default */.Z, {
        isOpen: showLoginPromo,
        onRequestClose: toggleLoginPromo
    }), styleAsDropdownItem ? /*#__PURE__*/ react.createElement(StyledDropdownItem, {
        onClick: isAuthenticated ? handleListClick : toggleLoginPromo,
        size: button_variants.ButtonSize.SMALL,
        containerProps: {
            "data-test": "SaveToListButton"
        }
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, addedToList ? /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(heart_filled/* IconHeartFilled */.g, null)) : /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(heart_outlined/* IconHeartOutlined */.G, null)), addedToList ? /*#__PURE__*/ react.createElement(ButtonText, null, t("common", "button.saved")) : /*#__PURE__*/ react.createElement(ButtonText, null, t("common", "button.save")))) : /*#__PURE__*/ react.createElement(StyledTooltip, {
        title: t("product", "action-button.list-tooltip")
    }, /*#__PURE__*/ react.createElement(StyledCircularButton, {
        onClick: isAuthenticated ? handleListClick : toggleLoginPromo,
        containerProps: {
            "data-test": "SaveToListButton"
        }
    }, addedToList ? /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(heart_filled/* IconHeartFilled */.g, null)) : /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(heart_outlined/* IconHeartOutlined */.G, null)))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/compare/index.js
var compare = __webpack_require__(34645);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/action-buttons/compare-button/index.tsx








var CompareButton = function(props) {
    var styleAsDropdownItem = props.styleAsDropdownItem;
    var ref = (0,app_context/* useAppContext */.bp)(), linkTo = ref.linkTo, t = ref.t;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var link = linkTo("productCompare", {
        category: product.category,
        products: [
            product
        ]
    });
    return /*#__PURE__*/ react.createElement("div", null, styleAsDropdownItem ? /*#__PURE__*/ react.createElement(StyledDropdownItem, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: link,
            rel: "nofollow",
            "data-test": "CompareButton"
        },
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.PRODUCT_PRODUCT_HEADER */.U.PRODUCT_PRODUCT_HEADER,
                currentPage: location.pathname + location.search + location.hash,
                nextPage: link
            });
        },
        size: button_variants.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, null)), /*#__PURE__*/ react.createElement(ButtonText, null, t("product", "product-compare.compare")))) : /*#__PURE__*/ react.createElement(StyledTooltip, {
        title: t("product", "action-button.compare-tooltip")
    }, /*#__PURE__*/ react.createElement(StyledCircularButton, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: linkTo("productCompare", {
                category: product.category,
                products: [
                    product
                ]
            }),
            rel: "nofollow",
            "data-test": "CompareButton"
        },
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.PRODUCT_PRODUCT_HEADER */.U.PRODUCT_PRODUCT_HEADER,
                currentPage: location.pathname + location.search + location.hash,
                nextPage: link
            });
        }
    }, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, {
        size: 16
    })))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/components/product-media-section/styles.ts
function product_media_section_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_media_section_styles_templateObject() {
    var data = product_media_section_styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    product_media_section_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_media_section_styles_templateObject1() {
    var data = product_media_section_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: ",
        " ",
        ";\n  width: 92px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n  border: 1px solid ",
        ";\n  height: ",
        "px;\n  border-radius: ",
        "px;\n  background: ",
        ";\n\n  &&:hover {\n    background: ",
        ";\n  }\n\n  &&:focus-visible {\n    border: 2px solid ",
        ";\n    padding: 0 3px;\n    outline: none;\n  }\n\n  img {\n    max-width: 88px;\n    max-height: 24px;\n  }\n"
    ]);
    product_media_section_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_media_section_styles_templateObject2() {
    var data = product_media_section_styles_taggedTemplateLiteral([
        "\n  flex: initial;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 ",
        ";\n"
    ]);
    product_media_section_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_media_section_styles_templateObject3() {
    var data = product_media_section_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  position: absolute;\n  top: 0;\n  right: 0;\n"
    ]);
    product_media_section_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var BUTTON_HEIGHT = 36;
var StyledMedia = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledMedia",
    componentId: "sc-0-0"
})(product_media_section_styles_templateObject());
var StyledBrandButton = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledBrandButton",
    componentId: "sc-0-1"
})(product_media_section_styles_templateObject1(), design_tokens.measurements.spacing025, design_tokens.measurements.spacing075, function(p) {
    return p.theme.colors.base200;
}, BUTTON_HEIGHT, BUTTON_HEIGHT / 2, function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return p.theme.colors.base100;
}, function(p) {
    return p.theme.colors.maybeBlue300;
});
var StyledBrandLabel = (0,styled_components_browser_esm["default"])(text_variants.CaptionStrongText).withConfig({
    displayName: "StyledBrandLabel",
    componentId: "sc-0-2"
})(product_media_section_styles_templateObject2(), design_tokens.measurements.spacing025);
var StyledActionButtonArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledActionButtonArea",
    componentId: "sc-0-3"
})(product_media_section_styles_templateObject3(), design_tokens.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/components/product-media-section/index.tsx










var ProductMediaSection = function(props) {
    var ref;
    var addedToList = props.addedToList, badges = props.badges, isExpertTopRated = props.isExpertTopRated, setListOpen = props.setListOpen;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var link = (ref = product.brand) === null || ref === void 0 ? void 0 : ref.pathName;
    return /*#__PURE__*/ react.createElement(StyledMedia, null, /*#__PURE__*/ react.createElement(ProductMedia, {
        id: product.id,
        name: product.name,
        category: product.category,
        isExpertTopRated: isExpertTopRated,
        badges: badges
    }), isDesktop && /*#__PURE__*/ react.createElement(StyledActionButtonArea, null, /*#__PURE__*/ react.createElement(SaveButton, {
        addedToList: addedToList,
        onListClick: setListOpen,
        styleAsDropdownItem: false
    }), /*#__PURE__*/ react.createElement(CompareButton, {
        styleAsDropdownItem: false
    })), product.brand && product.brand.featured && /*#__PURE__*/ react.createElement(StyledBrandButton, {
        title: t("product", "store-info.more-about-store", {
            store_name: product.brand.name
        }),
        to: link,
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.PRODUCT_PRODUCT_HEADER */.U.PRODUCT_PRODUCT_HEADER,
                currentPage: location.pathname + location.search + location.hash,
                nextPage: link
            });
        }
    }, product.brand.featured && product.brand.logo ? /*#__PURE__*/ react.createElement("img", {
        src: product.brand.logo,
        alt: product.brand.name
    }) : /*#__PURE__*/ react.createElement(StyledBrandLabel, {
        weight: 700,
        emphasis: text_variants.FontEmphasis.HIGH
    }, product.brand.name)));
};

// EXTERNAL MODULE: ./src/components/filter-dropdown/types.ts
var filter_dropdown_types = __webpack_require__(18557);
// EXTERNAL MODULE: ./src/areas/product/utils/price-list/sort-by-price.ts
var sort_by_price = __webpack_require__(17307);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row-context.tsx
var price_row_context = __webpack_require__(70204);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/utils/index.ts
var utils = __webpack_require__(54581);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/row-types/index.tsx + 72 modules
var row_types = __webpack_require__(82440);
// EXTERNAL MODULE: ./src/components/store-logo/styles.ts
var styles = __webpack_require__(47954);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/our-choice-offer-in-header/styles.ts
function our_choice_offer_in_header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function our_choice_offer_in_header_styles_templateObject() {
    var data = our_choice_offer_in_header_styles_taggedTemplateLiteral([
        "\n  box-shadow:\n    0px 1px 2px rgba(0, 0, 0, 0.12),\n    0px 1px 4px rgba(0, 0, 0, 0.12);\n\n  ",
        " {\n    max-width: ",
        "px;\n  }\n"
    ]);
    our_choice_offer_in_header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledOurChoicePriceRow = (0,styled_components_browser_esm["default"])(row_types/* PriceRow */.a).withConfig({
    displayName: "StyledOurChoicePriceRow",
    componentId: "sc-0-0"
})(our_choice_offer_in_header_styles_templateObject(), styles/* StoreLogo */.Xv, styles/* DEFAULT_STORE_LOGO_MAX_WIDTH */.uZ);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/our-choice-offer-in-header/index.tsx


var OurChoicePriceRow = function(props) {
    var item = props.trackingItem;
    return /*#__PURE__*/ react.createElement(StyledOurChoicePriceRow, {
        trackingItem: item
    });
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/types.ts
var price_row_types = __webpack_require__(8114);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/utils/index.ts
var our_choice_utils = __webpack_require__(84577);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(89286);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/clickable/index.js
var clickable = __webpack_require__(42007);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/styles.ts
var our_choice_styles = __webpack_require__(74887);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/our-choice-popover.tsx
var our_choice_popover = __webpack_require__(7379);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/our-choice/title-with-popover.tsx
function title_with_popover_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function title_with_popover_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function title_with_popover_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function title_with_popover_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function title_with_popover_slicedToArray(arr, i) {
    return title_with_popover_arrayWithHoles(arr) || title_with_popover_iterableToArrayLimit(arr, i) || title_with_popover_unsupportedIterableToArray(arr, i) || title_with_popover_nonIterableRest();
}
function title_with_popover_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return title_with_popover_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return title_with_popover_arrayLikeToArray(o, minLen);
}







var OurChoiceHeader = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = title_with_popover_slicedToArray((0,react.useState)(false), 2), showPopover = ref[0], setShowPopover = ref[1];
    return /*#__PURE__*/ react.createElement(our_choice_styles/* TitleRow */.PU, null, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("product", "prices.our-choice")), /*#__PURE__*/ react.createElement(clickable.Clickable, {
        onClick: function() {
            return setShowPopover(!showPopover);
        },
        containerProps: {
            title: t("common", "button.read-more"),
            "aria-label": t("common", "button.read-more"),
            "aria-haspopup": "dialog"
        }
    }, /*#__PURE__*/ react.createElement(our_choice_styles/* StyledIconWrapper */.Mv, null, /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        color: "base600",
        size: 16
    }))), /*#__PURE__*/ react.createElement(our_choice_popover/* OurChoicePopover */.J, {
        setShowPopover: setShowPopover,
        showPopover: showPopover
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/our-choice/index.tsx













var OurChoice = function(props) {
    var campaign = props.campaign;
    var market = (0,app_context/* useAppContext */.bp)().market;
    var ref = (0,product_context/* useProductContext */.$h)(), product = ref.product, offers = ref.offers;
    var getPriceDisplay = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getPriceDisplay;
    var currentSorting = filter_dropdown_types/* OptionTypeEnum.CHEAPEST_PRICE */.M.CHEAPEST_PRICE;
    var offersSorted = (0,sort_by_price/* sortOffersByPrice */.bo)(getPriceDisplay(), offers.filteredOffers);
    var ourChoice = (0,our_choice_utils/* getOurChoiceOffer */.T)(offersSorted, market.code);
    if (!ourChoice) {
        return null;
    }
    var offer = (0,utils/* createOfferFromPriceItem */.J)(ourChoice);
    return /*#__PURE__*/ react.createElement(our_choice_styles/* OurChoiceWrapper */.tw, null, /*#__PURE__*/ react.createElement(OurChoiceHeader, null), /*#__PURE__*/ react.createElement(price_row_context/* PriceRowContextContainer */.B, {
        offer: offer,
        product: product,
        sorting: currentSorting,
        campaign: campaign,
        viewSize: price_row_types/* ViewSize.SMALL */.du.SMALL,
        isInPriceList: false,
        isOurChoice: true
    }, /*#__PURE__*/ react.createElement(OurChoicePriceRow, {
        trackingItem: ourChoice
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/menu-kebab/index.js
var menu_kebab = __webpack_require__(77356);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-filled/index.js
var notification_filled = __webpack_require__(40900);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(50999);
// EXTERNAL MODULE: ./src/components/modal/actions.ts
var actions = __webpack_require__(43758);
// EXTERNAL MODULE: ./src/areas/product/constants.ts
var constants = __webpack_require__(99467);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/action-buttons/utils.ts




var useOnAction = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return function(type) {
        dispatch((0,product/* headerClickEvent */.Yc)(type));
        if (type === "alert-create") {
            dispatch((0,actions/* showModal */.K4)(constants/* PRODUCT_ALERT_MODAL_ID */.U));
        }
    };
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/action-buttons/alert-button/index.tsx










var AlertButton = function(props) {
    var styleAsDropdownItem = props.styleAsDropdownItem;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var userProductAlerts = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.alerts.products;
    });
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var userAlert = userProductAlerts.find(function(alert) {
        return alert.productId === product.id;
    });
    var alertId = userAlert && userAlert.alertId;
    var isBookmarked = alertId && isAuthenticated;
    var onAction = useOnAction();
    var handleAlertClick = function() {
        return onAction("alert-create");
    };
    if (!market.login.enabled) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("div", null, styleAsDropdownItem ? /*#__PURE__*/ react.createElement(StyledDropdownItem, {
        onClick: handleAlertClick,
        containerProps: {
            "data-test": "CreateAlertButton"
        },
        size: button_variants.ButtonSize.MEDIUM
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, isBookmarked ? /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(notification_filled/* IconNotificationFilled */.Q, null)) : /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null)), /*#__PURE__*/ react.createElement(ButtonText, null, t("product", "alert.create-button-exp")))) : /*#__PURE__*/ react.createElement(StyledTooltip, {
        title: t("product", "action-button.alert-tooltip")
    }, /*#__PURE__*/ react.createElement(styles_StyledPrimaryButton, {
        onClick: handleAlertClick,
        size: button_variants.ButtonSize.MEDIUM,
        containerProps: {
            "data-test": "CreateAlertButton"
        }
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, isBookmarked ? /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 20
    }, /*#__PURE__*/ react.createElement(notification_filled/* IconNotificationFilled */.Q, null)) : /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 20
    }, /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null)), /*#__PURE__*/ react.createElement(ButtonText, null, t("product", "alert.create-button-exp"))))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/action-buttons/drop-down/index.tsx










var ActionButtonsDropdown = function(param) {
    var addedToList = param.addedToList, onClick = param.onClick;
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        style: {
            height: "fit-content"
        },
        zIndex: zindex/* zindex.actionButtonDropdown */.Y.actionButtonDropdown
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        onlyIcon: true,
        type: ui_button.ButtonType.TONAL,
        size: ui_button.ButtonSize.MEDIUM
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(menu_kebab/* IconMenuKebab */.Q, null))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: ui/* Direction.Right */.Nm.Right,
        width: 200
    }, /*#__PURE__*/ react.createElement(ListContainer, null, /*#__PURE__*/ react.createElement(AlertButton, {
        styleAsDropdownItem: true
    }), /*#__PURE__*/ react.createElement(SaveButton, {
        addedToList: addedToList,
        styleAsDropdownItem: true,
        onListClick: onClick
    }), /*#__PURE__*/ react.createElement(CompareButton, {
        styleAsDropdownItem: true
    }))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-title/styles.ts
function header_title_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_title_styles_templateObject() {
    var data = header_title_styles_taggedTemplateLiteral([
        "display: none;"
    ]);
    header_title_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_title_styles_templateObject1() {
    var data = header_title_styles_taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n    "
    ]);
    header_title_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_title_styles_templateObject2() {
    var data = header_title_styles_taggedTemplateLiteral([
        "\n    ",
        "\n\n    margin-bottom: ",
        ";\n    flex-grow: 1;\n\n    ",
        "\n  "
    ]);
    header_title_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_title_styles_templateObject3() {
    var data = header_title_styles_taggedTemplateLiteral([
        "display: flex"
    ]);
    header_title_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_title_styles_templateObject4() {
    var data = header_title_styles_taggedTemplateLiteral([
        "\n  display: none;\n  flex: 1 0 auto;\n  margin-bottom: 0;\n  margin-right: 0px;\n\n  ",
        "\n"
    ]);
    header_title_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_title_styles_templateObject5() {
    var data = header_title_styles_taggedTemplateLiteral([
        "display: none"
    ]);
    header_title_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_title_styles_templateObject6() {
    var data = header_title_styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  margin-bottom: 0;\n"
    ]);
    header_title_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var attributes = {
    container: "h1"
};
var StyledMobileTitle = (0,styled_components_browser_esm["default"])(text_variants.H3Text).attrs(attributes)(function(props) {
    return (0,styled_components_browser_esm.css)(header_title_styles_templateObject2(), base/* media.mediumUp */.BC.mediumUp(header_title_styles_templateObject()), design_tokens.measurements.spacing050, props.$fontSizeSmall && (0,styled_components_browser_esm.css)(header_title_styles_templateObject1(), design_tokens.measurements.fontSizeNormal));
});
var StyledTabletTitle = (0,styled_components_browser_esm["default"])(text_variants.H2Text).attrs(attributes).withConfig({
    displayName: "StyledTabletTitle",
    componentId: "sc-0-0"
})(header_title_styles_templateObject4(), base/* media.mediumOnly */.BC.mediumOnly(header_title_styles_templateObject3()));
var StyledDesktopTitle = (0,styled_components_browser_esm["default"])(text_variants.H2Text).attrs(attributes).withConfig({
    displayName: "StyledDesktopTitle",
    componentId: "sc-0-1"
})(header_title_styles_templateObject6(), base/* media.mediumDown */.BC.mediumDown(header_title_styles_templateObject5()));

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-title/index.tsx
function header_title_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function header_title_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function header_title_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function header_title_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function header_title_slicedToArray(arr, i) {
    return header_title_arrayWithHoles(arr) || header_title_iterableToArrayLimit(arr, i) || header_title_unsupportedIterableToArray(arr, i) || header_title_nonIterableRest();
}
function header_title_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return header_title_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return header_title_arrayLikeToArray(o, minLen);
}


var CHAR_LIMIT = 60;
var TRUNC_CHAR_LIMIT = 100;
var HeaderTitle = function(param) {
    var title = param.title, viewportType = param.viewportType;
    var ref = header_title_slicedToArray((0,react.useState)(false), 2), hideTrunc = ref[0], setHideTrunc = ref[1];
    if (viewportType === "mobile") {
        // To keep the mobile ad from being pushed down below fold by a long title,
        // we limit the length of the title by altering the font-size and/or truncating it.
        var length = title.length;
        var fontSizeSmall = Boolean(length >= CHAR_LIMIT);
        var truncate = Boolean(length >= TRUNC_CHAR_LIMIT);
        var truncatedTitle = "".concat(title.slice(0, 80), "...").concat(title.slice(-10));
        return /* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */ /*#__PURE__*/ react.createElement("div", {
            onClick: function() {
                return setHideTrunc(true);
            },
            "data-test": "ProductTitle"
        }, /*#__PURE__*/ react.createElement(StyledMobileTitle, {
            $fontSizeSmall: fontSizeSmall
        }, truncate && !hideTrunc ? truncatedTitle : title));
    }
    var TitleComponent = viewportType === "tablet" ? StyledTabletTitle : StyledDesktopTitle;
    return /*#__PURE__*/ react.createElement("div", {
        "data-test": "ProductTitle"
    }, /*#__PURE__*/ react.createElement(TitleComponent, null, title));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/components/core-properties/styles.ts
function core_properties_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function core_properties_styles_templateObject() {
    var data = core_properties_styles_taggedTemplateLiteral([
        "\n    line-height: ",
        ";\n    max-height: ",
        ";\n    overflow: ",
        ";\n    color: ",
        ";\n  "
    ]);
    core_properties_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function core_properties_styles_templateObject1() {
    var data = core_properties_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  height: ",
        ";\n  width: 200px;\n  border-radius: 3px;\n"
    ]);
    core_properties_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function core_properties_styles_templateObject2() {
    var data = core_properties_styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  text-decoration: underline;\n  color: inherit;\n  white-space: nowrap;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    core_properties_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var lineHeight = function(size) {
    switch(size){
        case "tiny":
            return 12;
        case "small":
            return 16;
        default:
            return 18;
    }
};
var PropertyList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PropertyList",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(core_properties_styles_templateObject(), (0,base/* remCalc */.vR)(lineHeight(props.size)), props.maxRows ? (0,base/* remCalc */.vR)(props.maxRows * lineHeight(props.size) - 1) : "none", props.maxRows ? "hidden" : "visible", props.toneDown ? props.theme.text.secondary : props.theme.text.primary);
});
var placeholderHeight = function(size) {
    switch(size){
        case "tiny":
            return 14;
        case "small":
            return 18;
        default:
            return 21;
    }
};
var PlaceholderProperty = styled_components_browser_esm["default"].li.withConfig({
    displayName: "PlaceholderProperty",
    componentId: "sc-0-1"
})(core_properties_styles_templateObject1(), function(props) {
    return props.toneDown ? props.theme.colors.base100 : props.theme.colors.base200;
}, function(props) {
    return (0,base/* remCalc */.vR)(placeholderHeight(props.size));
});
var styles_StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-2"
})(core_properties_styles_templateObject2(), design_tokens.measurements.spacing025, function(p) {
    return p.theme.text.callToAction;
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/components/core-properties/index.tsx






var ProductCoreProperties = function(param) {
    var className = param.className, properties = param.properties, _toneDown = param.toneDown, toneDown = _toneDown === void 0 ? false : _toneDown, maxrows = param.maxrows, _size = param.size, size = _size === void 0 ? "large" : _size;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var link = "".concat(location.pathname).concat(location.search).concat(product_tabs_types/* TabAnchor.PROPERTIES */.X.PROPERTIES);
    return /*#__PURE__*/ react.createElement(PropertyList, {
        className: className,
        toneDown: toneDown,
        maxRows: maxrows,
        size: size
    }, properties ? properties.filter(function(v) {
        return v;
    }).join(", ") : /*#__PURE__*/ react.createElement(PlaceholderProperty, {
        toneDown: toneDown,
        size: size
    }), /*#__PURE__*/ react.createElement(styles_StyledLink, {
        to: link,
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.PRODUCT_PRODUCT_HEADER */.U.PRODUCT_PRODUCT_HEADER,
                currentPage: location.pathname + location.search + location.hash,
                nextPage: link
            });
        }
    }, t("common", "button.read-more")));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/styles.tsx
function header_desktop_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_desktop_styles_templateObject() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    padding: ",
        " ",
        " ",
        " ",
        ";\n    position: relative;\n    border-bottom: 1px solid ",
        ";\n    gap: ",
        ";\n    \n  "
    ]);
    header_desktop_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject1() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n    padding-bottom: ",
        ";\n  "
    ]);
    header_desktop_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject2() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    header_desktop_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject3() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n    flex: 1 1 auto;\n    flex-direction: column;\n    row-gap: ",
        ";\n  "
    ]);
    header_desktop_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject4() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    header_desktop_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject5() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n    max-width: calc(100% - ",
        " - ",
        ");\n  "
    ]);
    header_desktop_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject6() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n\n  ",
        "\n"
    ]);
    header_desktop_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject7() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  column-gap: ",
        ";\n"
    ]);
    header_desktop_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject8() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: ",
        ";\n  width: 100%;\n"
    ]);
    header_desktop_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject9() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n    flex: 1 1 auto;\n  "
    ]);
    header_desktop_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  color: ",
        ";\n  font-weight: 600;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: ",
        ";\n  align-items: center;\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  span {\n    color: inherit;\n  }\n  &:hover span {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  margin: 0 0 ",
        ";\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "display: flex"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: none;\n  min-width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}



var PRODUCT_SUMMARY_AREA_WIDTH = "310px";
var StyledDesktopHeader = styled_components_browser_esm["default"].header.withConfig({
    displayName: "StyledDesktopHeader",
    componentId: "sc-0-0"
})(header_desktop_styles_templateObject2(), base/* media.mediumUp */.BC.mediumUp(header_desktop_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.lines.primary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100), base/* media.mediumDown */.BC.mediumDown(header_desktop_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var StyledOuterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledOuterWrapper",
    componentId: "sc-0-1"
})(header_desktop_styles_templateObject4(), base/* media.mediumOnly */.BC.mediumOnly(header_desktop_styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var StyledColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledColumn",
    componentId: "sc-0-2"
})(header_desktop_styles_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.largeUp */.BC.largeUp(header_desktop_styles_templateObject5(), PRODUCT_SUMMARY_AREA_WIDTH, base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var StyledDescription = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDescription",
    componentId: "sc-0-3"
})(header_desktop_styles_templateObject7(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var StyledProductSummaryArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledProductSummaryArea",
    componentId: "sc-0-4"
})(header_desktop_styles_templateObject8(), PRODUCT_SUMMARY_AREA_WIDTH);
var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-5"
})(styles_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumOnly */.BC.mediumOnly(header_desktop_styles_templateObject9()));
var StyledWriteReview = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledWriteReview",
    componentId: "sc-0-6"
})(styles_templateObject11(), function(p) {
    return p.theme.text.linkExternal;
}, (0,base/* remCalc */.vR)(4), function(p) {
    return p.theme.text.callToAction;
});
var StyledRatingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRatingWrapper",
    componentId: "sc-0-7"
})(styles_templateObject12(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToAction;
});
var StyledPropertiesWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPropertiesWrapper",
    componentId: "sc-0-8"
})(styles_templateObject13(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledDisplayProperties = (0,styled_components_browser_esm["default"])(ProductCoreProperties).withConfig({
    displayName: "StyledDisplayProperties",
    componentId: "sc-0-9"
})(styles_templateObject14(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledReviewBadges = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledReviewBadges",
    componentId: "sc-0-10"
})(styles_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledReviewsRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledReviewsRow",
    componentId: "sc-0-11"
})(_templateObject16(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var styles_StyledTabletTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTabletTitle",
    componentId: "sc-0-12"
})(_templateObject18(), base/* media.mediumOnly */.BC.mediumOnly(_templateObject17()));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/verified-star/index.js
var verified_star = __webpack_require__(87733);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/components/verified-product-badge/styles.ts
function verified_product_badge_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function verified_product_badge_styles_templateObject() {
    var data = verified_product_badge_styles_taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n"
    ]);
    verified_product_badge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styles_Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(verified_product_badge_styles_templateObject());

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/components/verified-product-badge/index.tsx







var VerifiedProductBadge = function() {
    var ref;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var product = (0,product_context/* useProductContext */.$h)().product;
    if (!product.verifiedProductBadge) {
        return null;
    }
    var tooltipText = "".concat(t("product", "verified-product.by-text"), " ").concat((ref = product.brand) === null || ref === void 0 ? void 0 : ref.name);
    return /*#__PURE__*/ react.createElement(styles_Wrapper, null, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        title: tooltipText,
        placement: ui/* Direction.Up */.Nm.Up
    }, /*#__PURE__*/ react.createElement(verified_star/* IconVerfiedStar */.m, {
        color: "positive500",
        size: 20
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/index.tsx





















var ProductHeaderDesktop = function(props) {
    var addedToList = props.addedToList, badges = props.badges, className = props.className, currentCampaign = props.currentCampaign, isExpertTopRated = props.isExpertTopRated, setListOpen = props.setListOpen;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,context/* useViewportContext */.Ak)(), isDesktop = ref.isDesktop, isTablet = ref.isTablet;
    var getDisplayProperties = function(nodes) {
        return nodes.map(function(node) {
            return node.prettyVerbose;
        }).filter(function(item) {
            return item;
        });
    };
    var displayProperties = product && product.coreProperties ? getDisplayProperties(product.coreProperties.nodes) : [];
    var hasNoReviews = product.userReviewSummary.count === 0;
    return /*#__PURE__*/ react.createElement(StyledDesktopHeader, {
        className: className,
        "data-test": "DesktopProductHeader"
    }, /*#__PURE__*/ react.createElement(StyledOuterWrapper, null, /*#__PURE__*/ react.createElement(styles_StyledTabletTitle, null, /*#__PURE__*/ react.createElement(HeaderTitle, {
        title: product.name,
        viewportType: "tablet"
    })), /*#__PURE__*/ react.createElement(StyledColumn, null, /*#__PURE__*/ react.createElement(StyledDescription, null, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, product.media && /*#__PURE__*/ react.createElement(ProductMediaSection, {
        addedToList: addedToList,
        badges: badges,
        isExpertTopRated: isExpertTopRated,
        setListOpen: setListOpen
    })), /*#__PURE__*/ react.createElement(StyledContent, null, /*#__PURE__*/ react.createElement(HeaderTitle, {
        title: product.name,
        viewportType: "desktop"
    }), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledReviewsRow, null, product.category && product.popularity && Boolean(product.popularity.inCategory) && /*#__PURE__*/ react.createElement(RankBadge, {
        category: {
            pathName: product.category.pathName,
            name: product.category.name || ""
        },
        rank: product.popularity.inCategory
    }), /*#__PURE__*/ react.createElement(StyledRatingWrapper, null, /*#__PURE__*/ react.createElement(LinkToReviews, null, /*#__PURE__*/ react.createElement(rating/* default */.Z, {
        hide: hasNoReviews,
        rate: product.userReviewSummary.rating,
        count: product.userReviewSummary.count,
        size: "medium",
        showRate: true,
        showRateAs: "number",
        showCounterAs: "text",
        styleCounterAsLink: true
    }), hasNoReviews && /*#__PURE__*/ react.createElement(StyledWriteReview, null, /*#__PURE__*/ react.createElement(star_icons/* default */.Z, {
        stars: [
            1
        ],
        rating: rating_helper/* default.convert */.Z.convert(0),
        halfStar: false
    }), t("reviews", "button.write-review"))))), /*#__PURE__*/ react.createElement(StyledPropertiesWrapper, null, /*#__PURE__*/ react.createElement(VerifiedProductBadge, null), Boolean(displayProperties.length) && /*#__PURE__*/ react.createElement(StyledDisplayProperties, {
        toneDown: true,
        maxrows: 3,
        properties: displayProperties// Cut off at max three core properties
        .slice(0, 3)
    })), product.reviewBadges && product.reviewBadges.length > 0 && /*#__PURE__*/ react.createElement(StyledReviewBadges, null, product.reviewBadges.slice(0, 3).map(function(badge) {
        return /*#__PURE__*/ react.createElement(sentiment_badge/* default */.Z, {
            badge: badge,
            key: badge.id,
            showNrOfReviewsAs: "text"
        });
    })), /*#__PURE__*/ react.createElement(ProductFilters, null), /*#__PURE__*/ react.createElement(OurChoice, {
        campaign: currentCampaign
    })))), isTablet && /*#__PURE__*/ react.createElement(ActionButtonsDropdown, {
        addedToList: addedToList,
        onClick: setListOpen
    }))), isDesktop && /*#__PURE__*/ react.createElement(StyledProductSummaryArea, null, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, /*#__PURE__*/ react.createElement(PriceHistorySummary, null), /*#__PURE__*/ react.createElement(AlertButton, {
        styleAsDropdownItem: false
    })))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-mobile/styles.tsx
function header_mobile_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_mobile_styles_templateObject() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: ",
        ";\n  flex: 1 0 auto;\n"
    ]);
    header_mobile_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject1() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: grid;\n  grid-template-columns: auto 1fr;\n"
    ]);
    header_mobile_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject2() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  display: inline-block;\n  cursor: pointer;\n  &:hover span {\n    color: ",
        ";\n  }\n"
    ]);
    header_mobile_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject3() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  min-width: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    header_mobile_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject4() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "display: none;"
    ]);
    header_mobile_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject5() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n    ",
        "\n\n    display: flex;\n    flex-direction: column;\n    margin: ",
        ";\n    row-gap: ",
        ";\n    border-bottom: 1px solid ",
        ";\n    padding-bottom: ",
        ";\n  "
    ]);
    header_mobile_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var mediaImageSize = "100px";
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-0-0"
})(header_mobile_styles_templateObject(), design_tokens.measurements.spacing100);
var MainSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MainSection",
    componentId: "sc-0-1"
})(header_mobile_styles_templateObject1());
var StyledRating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRating",
    componentId: "sc-0-2"
})(header_mobile_styles_templateObject2(), function(p) {
    return p.theme.text.callToAction;
});
var styles_ProductMedia = (0,styled_components_browser_esm["default"])(ProductMedia).withConfig({
    displayName: "ProductMedia",
    componentId: "sc-0-3"
})(header_mobile_styles_templateObject3(), mediaImageSize, design_tokens.measurements.spacing050);
var MobileHeader = styled_components_browser_esm["default"].header.withConfig({
    displayName: "MobileHeader",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(header_mobile_styles_templateObject5(), base/* media.mediumUp */.BC.mediumUp(header_mobile_styles_templateObject4()), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050, function(p) {
        return p.theme.lines.primary;
    }, design_tokens.measurements.spacing100);
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-mobile/index.tsx










var ProductHeaderMobile = function(props) {
    var addedToList = props.addedToList, badges = props.badges, isExpertTopRated = props.isExpertTopRated, setListOpen = props.setListOpen;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var hasNoReviews = product.userReviewSummary.count === 0;
    return /*#__PURE__*/ react.createElement(MobileHeader, {
        "data-test": "MobileProductHeader"
    }, /*#__PURE__*/ react.createElement(MainSection, null, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, product && /*#__PURE__*/ react.createElement(styles_ProductMedia, {
        id: product.id,
        name: product.name,
        category: product.category,
        isExpertTopRated: isExpertTopRated,
        badges: badges
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(TitleWrapper, null, /*#__PURE__*/ react.createElement(HeaderTitle, {
        title: product.name,
        viewportType: "mobile"
    }), /*#__PURE__*/ react.createElement(ActionButtonsDropdown, {
        addedToList: addedToList,
        onClick: setListOpen
    })), /*#__PURE__*/ react.createElement(LinkToReviews, null, product.userReviewSummary && product.userReviewSummary.count !== 0 ? /*#__PURE__*/ react.createElement(StyledRating, null, /*#__PURE__*/ react.createElement(rating/* default */.Z, {
        hide: hasNoReviews,
        rate: product.userReviewSummary.rating,
        count: product.userReviewSummary.count,
        size: "medium",
        showRate: true,
        showRateAs: "number",
        showCounterAs: "number",
        styleCounterAsLink: true
    })) : null))), /*#__PURE__*/ react.createElement(ProductFilters, null));
};

// EXTERNAL MODULE: ./src/areas/sidebar/actions/lists.js
var lists = __webpack_require__(96805);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/action-buttons/save-button/list-modal.tsx
var list_modal = __webpack_require__(6743);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/product-header.tsx
function product_header_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_header_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_header_extends() {
    product_header_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return product_header_extends.apply(this, arguments);
}
function product_header_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_header_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_header_slicedToArray(arr, i) {
    return product_header_arrayWithHoles(arr) || product_header_iterableToArrayLimit(arr, i) || product_header_unsupportedIterableToArray(arr, i) || product_header_nonIterableRest();
}
function product_header_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_header_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_header_arrayLikeToArray(o, minLen);
}











var ProductHeader = /*#__PURE__*/ react.memo(function(props) {
    var ref, ref1;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var ref2 = product_header_slicedToArray((0,react.useState)(false), 2), addedToList = ref2[0], setAddedToListState = ref2[1];
    var ref3 = product_header_slicedToArray((0,react.useState)(false), 2), listOpen = ref3[0], setListOpen = ref3[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var onAction = useOnAction();
    var me = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.me;
    });
    var deletedLists = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.deletedLists;
    });
    var selectedList = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.selectedList;
    });
    var ref4;
    var latestLists = (ref4 = me === null || me === void 0 ? void 0 : (ref = me.lists) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : ref1.filter(function(list) {
        return deletedLists[list.id] !== true;
    }).filter(function(list) {
        return !list.inventory;
    }).sort(function(a) {
        if (a.id === selectedList) {
            return 1;
        }
        return 0;
    })) !== null && ref4 !== void 0 ? ref4 : [];
    var addToList = function(listId) {
        dispatch((0,lists/* selectList */.Fz)(listId));
        dispatch((0,lists/* addListItemRequest */.hg)(product.id, product.name, isDesktop));
        onAction("list-add");
        setAddedToListState(true);
    };
    var addToMyProducts = function() {
        dispatch((0,lists/* addItemToMyProductsRequest */["if"])(product.id, product.name, isDesktop));
        onAction("list-add");
        setAddedToListState(true);
    };
    var listProps = {
        addedToList: addedToList,
        setListOpen: setListOpen
    };
    return /*#__PURE__*/ react.createElement(list_context/* ListContextContainer */.V, null, /*#__PURE__*/ react.createElement(react.Fragment, null, listOpen && /*#__PURE__*/ react.createElement(list_modal/* ListModal */.a, {
        addToList: addToList,
        addToMyProducts: addToMyProducts,
        isOpen: listOpen,
        closeModal: function() {
            return setListOpen(false);
        },
        lists: latestLists,
        isDesktop: Boolean(isDesktop)
    }), /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        desktop: true,
        tablet: true
    }, /*#__PURE__*/ react.createElement(ProductHeaderDesktop, product_header_extends({}, props, listProps))), /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true
    }, /*#__PURE__*/ react.createElement(ProductHeaderMobile, product_header_extends({}, props, listProps)))));
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/index.tsx


var ProductPageHeader = function(props) {
    var currentCampaign = props.currentCampaign, isExpertTopRated = props.isExpertTopRated, badges = props.badges;
    return /*#__PURE__*/ react.createElement(ProductHeader, {
        currentCampaign: currentCampaign,
        isExpertTopRated: isExpertTopRated,
        badges: badges
    });
};


/***/ }),

/***/ 88103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": () => (/* binding */ useListContext),
/* harmony export */   "V": () => (/* binding */ ListContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var src_components_fetch_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4916);
/* harmony import */ var _lists_query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66490);
/* harmony import */ var _lists_query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_lists_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




var OFFSET = 30;
var initialContextValue = {
    fetchMoreLists: function() {
        return undefined;
    },
    moreLists: undefined,
    pageInfo: undefined
};
var ListContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialContextValue);
var useListContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ListContext);
};
var ListContextContainer = function(props) {
    var fetchContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_fetch_context__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
    var me = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.account.me;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (setPageInfo) setPageInfo(me === null || me === void 0 ? void 0 : me.lists.pageInfo);
    }, [
        me
    ]);
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(OFFSET), 2), offset = ref[0], setOffset = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), 2), moreLists = ref1[0], setMoreLists = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), 2), pageInfo = ref2[0], setPageInfo = ref2[1];
    var fetchMoreLists = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var response;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchContext.query((_lists_query_graphql__WEBPACK_IMPORTED_MODULE_3___default()), {
                            limit: OFFSET,
                            offset: offset
                        })
                    ];
                case 1:
                    response = _state.sent();
                    setMoreLists(response.data.me.lists.nodes);
                    setPageInfo(response.data.me.lists.pageInfo);
                    setOffset(function(state) {
                        return state + OFFSET;
                    });
                    return [
                        2
                    ];
            }
        });
    }), []);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            fetchMoreLists: fetchMoreLists,
            moreLists: moreLists,
            pageInfo: pageInfo
        };
    }, [
        fetchMoreLists,
        moreLists,
        pageInfo
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListContext.Provider, {
        value: contextValue
    }, props.children);
};


/***/ }),

/***/ 88877:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var ProductMediaLightboxLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 18260));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(18260);
        }
        return eval("require.resolve")("./product-media-lightbox");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (ProductMediaLightboxLoader);


/***/ }),

/***/ 50246:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ PriceHistoryMiniLoader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45321);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var LoadableComponent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-price-history-mini";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-price-history-mini */ 554).then(__webpack_require__.bind(__webpack_require__, 74440));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(74440);
        }
        return eval("require.resolve")("./mini-chart-content");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledLoader */ .Hl, {
        "data-testid": "chart-loader"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledSkeleton */ .ps, {
        width: "100%",
        height: "100%"
    }))
});
var PriceHistoryMiniLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadableComponent, _extends({}, props));
};


/***/ }),

/***/ 211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ PriceHistorySectionLoader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var src_components_skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75598);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45321);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}




var LoadableComponent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-price-history-section";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-price-history-section */ 625).then(__webpack_require__.bind(__webpack_require__, 33748));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(33748);
        }
        return eval("require.resolve")("./price-history-section-content");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledSectionContentLoader */ .Hn, {
        "data-testid": "chart-loader"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SkeletonParagraph */ .Bp, {
        width: "100%",
        height: "100%"
    }))
});
var PriceHistorySectionLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadableComponent, _extends({}, props));
};


/***/ }),

/***/ 53373:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": () => (/* binding */ ProductPriceHistory)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(8466);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/queries/query.graphql
var query_graphql = __webpack_require__(59086);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/product/components/product-price-history/queries/use-price-history-query.ts


var usePriceHistoryQuery = function(productId, timeRange, importantDates) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (query_graphql_default()),
        queryKey: [
            "price-history"
        ],
        variables: {
            id: productId,
            timeRange: timeRange,
            importantDates: importantDates
        }
    });
};

// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/components/price-history-section-loader/index.tsx
var price_history_section_loader = __webpack_require__(211);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/components/mini-chart-content-loader/index.tsx
var mini_chart_content_loader = __webpack_require__(50246);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/utils/index.ts
var utils = __webpack_require__(19329);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/types.ts
var types = __webpack_require__(34101);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/styles.ts
var styles = __webpack_require__(45321);
;// CONCATENATED MODULE: ./src/areas/product/components/product-price-history/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








/**
 * Price history component
 * This component uses Recharts visualization lib and is loaded async for performance
 *
 * @param props  - Use mode to determine if the component should be rendered as a mini chart or a full chart
 */ var ProductPriceHistory = function(props) {
    var mode = props.mode;
    var ref = _slicedToArray((0,react.useState)(false), 2), activeChart = ref[0], setActiveChart = ref[1];
    var ref1 = (0,product_context/* useProductContext */.$h)(), product = ref1.product, offers = ref1.offers;
    var ref2 = _slicedToArray((0,react.useState)("ThreeMonths"), 2), selectedTimeRange = ref2[0], setSelectedTimeRange = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)(mode === "normal"), 2), showImportantDates = ref3[0], setShowImportantDates = ref3[1];
    (0,react.useEffect)(function() {
        setActiveChart(true);
    }, []);
    var result = usePriceHistoryQuery(product.id, selectedTimeRange, showImportantDates);
    var ref4 = (0,utils/* getHistoryItems */.zq)(result.data), historyItems = ref4.historyItems, historyShops = ref4.historyShops;
    var correctedHistoryItems = offers.initialNewOffers.length > 0 ? (0,utils/* updateWithTodaysCheapestOffer */.RM)(historyItems, offers.initialNewOffers[0]) : historyItems;
    var isEmptyDataResult = (0,utils/* isResultWithMissingPriceData */.Vk)(result, correctedHistoryItems);
    var renderState = (0,utils/* getRenderState */.tP)(result, isEmptyDataResult);
    var importantDates = (0,utils/* getImportantDates */.Vs)(result.data);
    (0,react.useEffect)(function() {
        if (isEmptyDataResult) {
            setSelectedTimeRange("All");
        }
    }, [
        isEmptyDataResult
    ]);
    var retry = (0,react.useCallback)(function() {
        // Trigger a re-render
        setSelectedTimeRange(selectedTimeRange);
    }, [
        selectedTimeRange
    ]);
    var miniChart = activeChart && renderState !== types/* RENDER_STATE.ERROR */.q.ERROR && renderState !== types/* RENDER_STATE.NO_DATA */.q.NO_DATA ? /*#__PURE__*/ react.createElement(mini_chart_content_loader/* PriceHistoryMiniLoader */.C, {
        historyItems: correctedHistoryItems,
        renderState: renderState
    }) : /*#__PURE__*/ react.createElement(styles/* StyledLoader */.Hl, {
        "data-testid": "chart-loader"
    }, /*#__PURE__*/ react.createElement(styles/* StyledSkeleton */.ps, {
        width: "100%",
        height: "100%"
    }));
    return /*#__PURE__*/ react.createElement(styles/* StyledPriceHistoryArea */.Lx, null, mode === "normal" && /*#__PURE__*/ react.createElement("div", {
        "data-test": "PriceHistoryGraph"
    }, /*#__PURE__*/ react.createElement(price_history_section_loader/* PriceHistorySectionLoader */.u, {
        data: result.data,
        productId: product.id,
        initialOffers: offers.initialNewOffers,
        allHistoryShops: historyShops,
        correctedHistoryItems: correctedHistoryItems,
        importantDates: importantDates,
        retryFn: retry,
        state: {
            renderState: renderState,
            selectedTimeRange: selectedTimeRange,
            setSelectedTimeRange: setSelectedTimeRange,
            showImportantDates: showImportantDates,
            setShowImportantDates: setShowImportantDates
        }
    })), mode === "mini" && renderState !== types/* RENDER_STATE.NO_DATA */.q.NO_DATA && /*#__PURE__*/ react.createElement(styles/* StyledMiniChartWrapper */.En, null, miniChart));
};


/***/ }),

/***/ 45321:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bk": () => (/* binding */ MINI_CHART),
/* harmony export */   "En": () => (/* binding */ StyledMiniChartWrapper),
/* harmony export */   "Hl": () => (/* binding */ StyledLoader),
/* harmony export */   "Hn": () => (/* binding */ StyledSectionContentLoader),
/* harmony export */   "Lx": () => (/* binding */ StyledPriceHistoryArea),
/* harmony export */   "ps": () => (/* binding */ StyledSkeleton)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var src_components_skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75598);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  min-height: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  margin: -",
        ";\n  margin-bottom: ",
        ";\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var CONTENT_MIN_HEIGHT_DESKTOP = "476px";
var MINI_CHART = {
    WIDTH: 326,
    HEIGHT: 110
};
var StyledPriceHistoryArea = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledPriceHistoryArea",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var StyledMiniChartWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledMiniChartWrapper",
    componentId: "sc-0-1"
})(_templateObject1(), MINI_CHART.WIDTH, MINI_CHART.HEIGHT, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var StyledSectionContentLoader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledSectionContentLoader",
    componentId: "sc-0-2"
})(_templateObject2(), CONTENT_MIN_HEIGHT_DESKTOP);
var StyledLoader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledLoader",
    componentId: "sc-0-3"
})(_templateObject3());
var StyledSkeleton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SkeletonParagraph */ .Bp).withConfig({
    displayName: "StyledSkeleton",
    componentId: "sc-0-4"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 34101:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ RENDER_STATE)
/* harmony export */ });
var RENDER_STATE;
(function(RENDER_STATE) {
    RENDER_STATE[RENDER_STATE["LOADING"] = 0] = "LOADING";
    RENDER_STATE[RENDER_STATE["SHOW"] = 1] = "SHOW";
    RENDER_STATE[RENDER_STATE["ERROR"] = 2] = "ERROR";
    RENDER_STATE[RENDER_STATE["NO_DATA"] = 3] = "NO_DATA";
})(RENDER_STATE || (RENDER_STATE = {}));


/***/ }),

/***/ 55348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B7": () => (/* binding */ formatShopData),
/* harmony export */   "Bq": () => (/* binding */ createDate),
/* harmony export */   "lv": () => (/* binding */ formatData),
/* harmony export */   "zk": () => (/* binding */ isToday)
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var createDate = function(str) {
    var date = str ? new Date(str) : new Date();
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
};
var daysDiff = function(a, b) {
    return Math.round((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
};
var isToday = function(item) {
    if (!item) return false;
    return createDate(item.date).getTime() === createDate().getTime();
};
var createPriceHistoryItem = function(historyItem) {
    var date = createDate(historyItem.date);
    var price = historyItem.active ? historyItem.price : null;
    var isMembershipPrice = historyItem.isMembershipPrice, isPaidMembership = historyItem.isPaidMembership, name = historyItem.name, shopId = historyItem.shopId, shopName = historyItem.shopName;
    return {
        date: date,
        isMembershipPrice: isMembershipPrice,
        isPaidMembership: isPaidMembership,
        name: name,
        price: price,
        shopId: shopId,
        shopName: shopName,
        shopDatas: {}
    };
};
var copyItem = function(priceHistoryItem, nbr) {
    var items = [];
    for(var i = 1; i < nbr; i += 1){
        var nextDay = new Date(priceHistoryItem.date);
        nextDay.setUTCDate(nextDay.getUTCDate() + i);
        items.push(_objectSpreadProps(_objectSpread({}, priceHistoryItem), {
            date: nextDay
        }));
    }
    return items;
};
var copyItemsUntil = function(item, until) {
    var graphItems = [];
    if (item) {
        var daysInBetween = daysDiff(item.date, until);
        if (daysInBetween > 1) {
            var _graphItems;
            (_graphItems = graphItems).push.apply(_graphItems, _toConsumableArray(copyItem(item, daysInBetween)));
        }
    }
    return graphItems;
};
// The current implementation of the price history graph does not handle
// UTC dates correctly, adjusting the dates fixes this for now.
var mapHistoryItemFromUTCToLocale = function(item) {
    var dateStr = item.date;
    var date = dateStr ? new Date(dateStr) : new Date();
    date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
    return _objectSpreadProps(_objectSpread({}, item), {
        date: date.toISOString()
    });
};
var formatData = function(data) {
    var _graphItems;
    var dataItems = _toConsumableArray(data).map(mapHistoryItemFromUTCToLocale);
    var graphItems = [];
    var lastPriceHistoryItem;
    if (dataItems.length === 0) {
        return [];
    }
    while(dataItems.length > 0){
        var // Fill in blank days
        _graphItems1;
        var nextDataItem = dataItems.shift();
        // For today's date we are only interrested in the last item (which is the same as the cheapest in the price list)
        while(dataItems.length > 0 && isToday(nextDataItem)){
            nextDataItem = dataItems.shift();
        }
        if (!nextDataItem) break;
        var nextPriceHistoryItem = createPriceHistoryItem(nextDataItem);
        (_graphItems1 = graphItems).push.apply(_graphItems1, _toConsumableArray(copyItemsUntil(lastPriceHistoryItem, nextPriceHistoryItem.date)));
        lastPriceHistoryItem = nextPriceHistoryItem;
        graphItems.push(nextPriceHistoryItem);
    }
    // Fill up with days up until today
    var now = new Date();
    var tomorrow = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1));
    (_graphItems = graphItems).push.apply(_graphItems, _toConsumableArray(copyItemsUntil(lastPriceHistoryItem, tomorrow)));
    return graphItems;
};
var formatShopData = function(data) {
    var ref;
    return _objectSpreadProps(_objectSpread({}, data), {
        product: _objectSpreadProps(_objectSpread({}, data.product), {
            shopHistory: (((ref = data.product) === null || ref === void 0 ? void 0 : ref.shopHistory) || []).map(function(shopHistory) {
                return _objectSpreadProps(_objectSpread({}, shopHistory), {
                    productHistory: _objectSpreadProps(_objectSpread({}, shopHistory.productHistory), {
                        historyItems: (shopHistory.productHistory.historyItems || []).map(function(historyItem) {
                            return mapHistoryItemFromUTCToLocale(historyItem);
                        })
                    })
                });
            })
        })
    });
};


/***/ }),

/***/ 19329:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RM": () => (/* binding */ updateWithTodaysCheapestOffer),
/* harmony export */   "Vk": () => (/* binding */ isResultWithMissingPriceData),
/* harmony export */   "Vs": () => (/* binding */ getImportantDates),
/* harmony export */   "tP": () => (/* binding */ getRenderState),
/* harmony export */   "yv": () => (/* binding */ getHistoryItemRange),
/* harmony export */   "zq": () => (/* binding */ getHistoryItems)
/* harmony export */ });
/* unused harmony export getDateFromUTCString */
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34101);
/* harmony import */ var _format_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55348);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var getDateFromUTCString = function(str) {
    if (!str) {
        return undefined;
    }
    return new Date(str);
};
var getRenderState = function(result, isEmptyDataResult) {
    if (result.error) {
        return _types__WEBPACK_IMPORTED_MODULE_0__/* .RENDER_STATE.ERROR */ .q.ERROR;
    }
    if (isEmptyDataResult) {
        return _types__WEBPACK_IMPORTED_MODULE_0__/* .RENDER_STATE.NO_DATA */ .q.NO_DATA;
    }
    if (result.isSuccess && result.data) {
        return _types__WEBPACK_IMPORTED_MODULE_0__/* .RENDER_STATE.SHOW */ .q.SHOW;
    }
    return _types__WEBPACK_IMPORTED_MODULE_0__/* .RENDER_STATE.LOADING */ .q.LOADING;
};
var getHistoryItems = function(data) {
    var ref, ref1, ref2, ref3;
    var ref4, ref5;
    return {
        historyItems: (ref4 = data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : (ref1 = ref.historyV2) === null || ref1 === void 0 ? void 0 : ref1.historyItems) !== null && ref4 !== void 0 ? ref4 : [],
        historyShops: (ref5 = data === null || data === void 0 ? void 0 : (ref2 = data.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.historyV2) === null || ref3 === void 0 ? void 0 : ref3.historyAllShops) !== null && ref5 !== void 0 ? ref5 : []
    };
};
var getHistoryItemRange = function(data) {
    var ref, ref1, ref2, ref3;
    var oldestHistoryItem = getDateFromUTCString(data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : (ref1 = ref.historyV2) === null || ref1 === void 0 ? void 0 : ref1.oldestHistoryItem);
    var newestHistoryItem = getDateFromUTCString(data === null || data === void 0 ? void 0 : (ref2 = data.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.historyV2) === null || ref3 === void 0 ? void 0 : ref3.newestHistoryItem);
    if (!oldestHistoryItem || !newestHistoryItem) {
        return null;
    }
    return [
        oldestHistoryItem,
        newestHistoryItem
    ];
};
var getImportantDates = function(data) {
    var ref;
    var items = data === null || data === void 0 ? void 0 : (ref = data.importantDates) === null || ref === void 0 ? void 0 : ref.map(function(item) {
        var ref;
        var startDate = new Date((ref = item === null || item === void 0 ? void 0 : item.startDate) !== null && ref !== void 0 ? ref : 0);
        var ref1;
        var endDate = new Date((ref1 = item === null || item === void 0 ? void 0 : item.endDate) !== null && ref1 !== void 0 ? ref1 : 0);
        endDate.setUTCDate(endDate.getUTCDate() + 1);
        return {
            name: item === null || item === void 0 ? void 0 : item.name,
            startDate: startDate,
            endDate: endDate
        };
    }).filter(function(i) {
        return i.name && i.endDate.getTime() > i.startDate.getTime();
    });
    return items !== null && items !== void 0 ? items : [];
};
var updateWithTodaysCheapestOffer = function(data, offer) {
    var ref, ref1, ref2, ref3, ref4;
    if (data.length === 0) {
        return data;
    }
    var modifiedHistoryItems = _toConsumableArray(data);
    var lastHistoryItem = modifiedHistoryItems[modifiedHistoryItems.length - 1];
    var isMembershipPrice = Boolean((ref = offer.offerPrices) === null || ref === void 0 ? void 0 : ref.memberPrice);
    var isPaidMembership = Boolean((ref1 = offer.membershipProgram) === null || ref1 === void 0 ? void 0 : ref1.requiresCompensation);
    var _name, ref5, ref6, ref7;
    var newDataForToday = {
        active: true,
        date: (0,_format_data__WEBPACK_IMPORTED_MODULE_1__/* .createDate */ .Bq)().toISOString(),
        name: (_name = offer.name) !== null && _name !== void 0 ? _name : lastHistoryItem.name,
        price: (ref5 = (ref2 = offer.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping) !== null && ref5 !== void 0 ? ref5 : lastHistoryItem.price,
        shopId: (ref6 = (ref3 = offer.store) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref6 !== void 0 ? ref6 : lastHistoryItem.shopId,
        shopName: (ref7 = (ref4 = offer.store) === null || ref4 === void 0 ? void 0 : ref4.name) !== null && ref7 !== void 0 ? ref7 : lastHistoryItem.shopName,
        isPaidMembership: isPaidMembership,
        isMembershipPrice: isMembershipPrice
    };
    if ((0,_format_data__WEBPACK_IMPORTED_MODULE_1__/* .isToday */ .zk)(lastHistoryItem)) {
        // Replace last history item with data from cheapest offer today
        modifiedHistoryItems[modifiedHistoryItems.length - 1] = newDataForToday;
    } else {
        // Add cheapest offer today as a new history item
        modifiedHistoryItems.push(newDataForToday);
    }
    return modifiedHistoryItems;
};
var isResultWithMissingPriceData = function(result, historyItems) {
    if (!result.isSuccess || result.isError) {
        return false;
    }
    return !historyItems.some(function(item) {
        return item.active;
    });
};


/***/ }),

/***/ 59345:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _components_campaign_banners_promo_banner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38911);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(852);



var ProductBeforePromoBanner = function(props) {
    var campaignBanners = props.campaignBanners;
    var campaignPromoBanners = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getCampaignPromoBanners */ .qz)(campaignBanners);
    return campaignPromoBanners.before && campaignPromoBanners.before.length > 0 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_campaign_banners_promo_banner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        inverted: true,
        banners: campaignPromoBanners.before
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductBeforePromoBanner);


/***/ }),

/***/ 26910:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _components_campaign_banners_promo_banner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38911);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(852);



var ProductDuringPromoBanner = function(props) {
    var campaignBanners = props.campaignBanners;
    var campaignPromoBanners = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getCampaignPromoBanners */ .qz)(campaignBanners);
    return campaignPromoBanners.during && campaignPromoBanners.during.length > 0 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_campaign_banners_promo_banner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        banners: campaignPromoBanners.during
    })) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductDuringPromoBanner);


/***/ }),

/***/ 52456:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ ProductPropertiesLoader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var _loading_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27688);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var LoadableComponent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-properties";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-properties */ 835).then(__webpack_require__.bind(__webpack_require__, 29860));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(29860);
        }
        return eval("require.resolve")("../../product-properties");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_loading_state__WEBPACK_IMPORTED_MODULE_2__/* .LoadingState */ .G, null)
});
var ProductPropertiesLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadableComponent, _extends({}, props));
};


/***/ }),

/***/ 27688:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": () => (/* binding */ LoadingState)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/skeleton/index.ts + 3 modules
var skeleton = __webpack_require__(75598);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/components/loader/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PRODUCT_PROPERTIES_MIN_HEIGHT = 200;
var StyledSectionContentLoader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSectionContentLoader",
    componentId: "sc-0-0"
})(_templateObject(), PRODUCT_PROPERTIES_MIN_HEIGHT);

;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/components/loader/loading-state.tsx



var LoadingState = function() {
    return /*#__PURE__*/ react.createElement(StyledSectionContentLoader, {
        "data-testid": "product-properties-loader"
    }, /*#__PURE__*/ react.createElement(skeleton/* SkeletonParagraph */.Bp, {
        width: "100%",
        height: "100%"
    }));
};


/***/ }),

/***/ 45874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": () => (/* binding */ VerifiedProductInfo)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/verified-star/index.js
var verified_star = __webpack_require__(87733);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(8466);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/components/verified-product-info/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  text-decoration: underline;\n  line-height: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n\n    > span {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToAction;
});
var StyledBrandLabel = (0,styled_components_browser_esm["default"])(variants.CaptionStrongText).withConfig({
    displayName: "StyledBrandLabel",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.base900;
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/components/verified-product-info/index.tsx








var VerifiedProductInfo = function() {
    var ref, ref1, ref2;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var link = (ref = product.brand) === null || ref === void 0 ? void 0 : ref.pathName;
    if (!product.verifiedProductBadge) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(badge.Badge, {
        text: t("product", "verified-product.label-text"),
        icon: verified_star/* IconVerfiedStar */.m,
        color: "GREEN",
        size: badge.BadgeSize.SMALL
    }), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, "".concat(t("product", "verified-product.by-text"), " "), link ? /*#__PURE__*/ react.createElement(StyledLink, {
        to: link,
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.PRODUCT_INFORMATION */.U.PRODUCT_INFORMATION,
                currentPage: location.pathname + location.search + location.hash,
                nextPage: link
            });
        }
    }, /*#__PURE__*/ react.createElement(StyledBrandLabel, {
        emphasis: variants.FontEmphasis.HIGH,
        color: variants.FontColor.DARK
    }, (ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name)) : (ref2 = product.brand) === null || ref2 === void 0 ? void 0 : ref2.name));
};


/***/ }),

/***/ 69469:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_scroll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40763);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29813);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(852);
/* harmony import */ var _prisjakt_ui_icon_chevron_up__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44651);






var ProductScrollTopButton = function() {
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_scroll__WEBPACK_IMPORTED_MODULE_1__/* .ScrollLink */ .Rv, {
        to: "Top",
        onClick: _utils__WEBPACK_IMPORTED_MODULE_4__/* .blurActiveElement */ .sD
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .BackToTopButton */ .zV, {
        "aria-label": t("product", "back-to-top.button-description")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_chevron_up__WEBPACK_IMPORTED_MODULE_5__.IconChevronUp, null)));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductScrollTopButton);


/***/ }),

/***/ 46624:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": () => (/* binding */ ProductNavigation)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/sticky-tab-nav/index.tsx + 1 modules
var sticky_tab_nav = __webpack_require__(67191);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(8466);
// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/types.ts
var types = __webpack_require__(61240);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/product/components/product-section-navigation/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ProductNavigationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ProductNavigationLink",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/product/components/product-section-navigation/utils.tsx






var useNavigationLinks = function() {
    var ref, ref1, ref2;
    var ref3 = (0,app_context/* useAppContext */.bp)(), t = ref3.t, market = ref3.market;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var ref4 = (0,product_context/* useProductContext */.$h)(), mobileContracts = ref4.mobileContracts, product = ref4.product, offers = ref4.offers;
    var mobileContractsEnabled = Boolean(market.mobileContractsEnabled);
    var offersCount = offers.filteredOffers.length;
    var mobileContractsCount = mobileContractsEnabled ? mobileContracts.length : 0;
    var totalCount = offersCount + mobileContractsCount;
    var mainTabLabel = t("product", "tabs.prices-overview");
    var pricesTabLabel = "".concat(t("product", "tabs.prices")).concat(totalCount > 0 ? " (".concat(totalCount, ")") : "");
    var reviewCount = ((ref = product.aggregatedRatingSummary) === null || ref === void 0 ? void 0 : (ref1 = ref.summary) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rating) === null || ref2 === void 0 ? void 0 : ref2.count) || product.userReviewSummary.count;
    var reviewsTabLabel = "".concat(t("product", "tabs.reviews")).concat(reviewCount && reviewCount > 0 ? " (".concat(reviewCount, ")") : "");
    if (isMobile) {
        return [
            {
                id: types/* TabAnchor.ALL */.X.ALL,
                title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                    "data-test": "TabButton",
                    "data-test-section": "overview"
                }, mainTabLabel),
                scrollToTop: true,
                to: types/* TabAnchor.ALL */.X.ALL
            },
            {
                id: types/* TabAnchor.PRICES */.X.PRICES,
                title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                    "data-test": "TabButton",
                    "data-test-section": "main"
                }, pricesTabLabel),
                to: types/* TabAnchor.PRICES */.X.PRICES
            },
            {
                id: types/* TabAnchor.REVIEWS */.X.REVIEWS,
                title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                    "data-test": "TabButton",
                    "data-test-section": "reviews"
                }, reviewsTabLabel),
                to: types/* TabAnchor.REVIEWS */.X.REVIEWS
            },
            {
                id: types/* TabAnchor.STATISTICS */.X.STATISTICS,
                title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                    "data-test": "TabButton",
                    "data-test-section": "statistics"
                }, t("product", "tabs.price-history")),
                to: types/* TabAnchor.STATISTICS */.X.STATISTICS
            },
            {
                id: types/* TabAnchor.PROPERTIES */.X.PROPERTIES,
                title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                    "data-test": "TabButton",
                    "data-test-section": "properties"
                }, t("product", "tabs.properties")),
                to: types/* TabAnchor.PROPERTIES */.X.PROPERTIES
            }
        ];
    }
    return [
        {
            id: types/* TabAnchor.ALL */.X.ALL,
            title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                "data-test": "TabButton",
                "data-test-section": "main"
            }, t("product", "tabs.prices")),
            scrollToTop: true,
            to: types/* TabAnchor.ALL */.X.ALL
        },
        {
            id: types/* TabAnchor.REVIEWS */.X.REVIEWS,
            title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                "data-test": "TabButton",
                "data-test-section": "reviews"
            }, t("product", "tabs.reviews")),
            to: types/* TabAnchor.REVIEWS */.X.REVIEWS
        },
        {
            id: types/* TabAnchor.STATISTICS */.X.STATISTICS,
            title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                "data-test": "TabButton",
                "data-test-section": "statistics"
            }, t("product", "tabs.price-history")),
            to: types/* TabAnchor.STATISTICS */.X.STATISTICS
        },
        {
            id: types/* TabAnchor.PROPERTIES */.X.PROPERTIES,
            title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                "data-test": "TabButton",
                "data-test-section": "properties"
            }, t("product", "tabs.properties")),
            to: types/* TabAnchor.PROPERTIES */.X.PROPERTIES
        }
    ];
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-section-navigation/index.tsx



var ProductNavigation = function() {
    var navigationTabs = useNavigationLinks();
    return /*#__PURE__*/ react.createElement(sticky_tab_nav/* StickyTabNavigation */.g, {
        defaultActiveTabId: navigationTabs[0].id,
        tabs: navigationTabs,
        background: true
    });
};


/***/ }),

/***/ 409:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": () => (/* binding */ ProductTabs)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(8466);
// EXTERNAL MODULE: ./packages/react-ads/dist/module.js + 1 modules
var dist_module = __webpack_require__(6895);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/components/ux-feedback/index.tsx
var ux_feedback = __webpack_require__(58854);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/index.tsx
var carousel_products = __webpack_require__(23013);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/types.ts
var types = __webpack_require__(57048);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  padding: 0;\n  margin-top: ",
        ";\n  list-style: none;\n\n  > li:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "StyledList",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledMobileFiltersAndSorting = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledMobileFiltersAndSorting",
    componentId: "sc-0-1"
})(_templateObject1(), design_tokens.measurements.spacing075);

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row-context.tsx
var price_row_context = __webpack_require__(70204);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/row-types/index.tsx + 72 modules
var row_types = __webpack_require__(82440);
// EXTERNAL MODULE: ./src/areas/product/utils/mobile-contracts/mappings.ts
var mappings = __webpack_require__(82652);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/main/components/panel-header/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  align-items: center;\n\n  z-index: 3; /* Needed for sorting dropdown */\n  margin-top: 0;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    overflow-x: auto;\n    position: relative;\n    padding: ",
        ";\n    left: -",
        ";\n    width: calc(100% + ",
        ");\n    padding-bottom: 0;\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding: 1px;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledPanelHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPanelHeader",
    componentId: "sc-0-0"
})(styles_templateObject());
var StyledScrollingFiltersList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledScrollingFiltersList",
    componentId: "sc-0-1"
})(_templateObject2(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject1(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050, design_tokens.measurements.spacing100));
var SyledHeaderFlex = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SyledHeaderFlex",
    componentId: "sc-0-2"
})(_templateObject3(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050, design_tokens.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/main/components/panel-header/index.tsx


var PanelHeader = function(param) {
    var children = param.children;
    return /*#__PURE__*/ react.createElement(StyledPanelHeader, {
        "data-test": "PricePanelHeader"
    }, /*#__PURE__*/ react.createElement(StyledScrollingFiltersList, null, /*#__PURE__*/ react.createElement(SyledHeaderFlex, null, children)));
};

// EXTERNAL MODULE: ./src/areas/product/utils/price-list/common.ts
var common = __webpack_require__(17551);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(33888);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/radiobutton/index.js
var radiobutton = __webpack_require__(94269);
;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/shared/select-content/styles.ts
function select_content_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function select_content_styles_templateObject() {
    var data = select_content_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  "
    ]);
    select_content_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function select_content_styles_templateObject1() {
    var data = select_content_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    select_content_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = select_content_styles_taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n  user-select: none;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-0"
})(select_content_styles_templateObject1(), base/* media.mediumDown */.BC.mediumDown(select_content_styles_templateObject(), design_tokens.measurements.spacing050));
var StyledRadioButton = (0,styled_components_browser_esm["default"])(radiobutton/* RadioButton */.EU).withConfig({
    displayName: "StyledRadioButton",
    componentId: "sc-0-1"
})(styles_templateObject2(), design_tokens.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/dropdown-item/index.ts + 1 modules
var dropdown_item = __webpack_require__(28839);
;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/shared/select-content/index.tsx




var SelectContent = function(param) {
    var _asRadioButtons = param.asRadioButtons, asRadioButtons = _asRadioButtons === void 0 ? false : _asRadioButtons, handleOnClick = param.handleOnClick, options = param.options, selected = param.selected, title = param.title;
    return /*#__PURE__*/ react.createElement(StyledContent, null, title && /*#__PURE__*/ react.createElement(variants.H4Text, null, title), /*#__PURE__*/ react.createElement("div", null, options.map(function(option) {
        return /*#__PURE__*/ react.createElement("div", {
            key: option.value
        }, asRadioButtons ? /*#__PURE__*/ react.createElement(StyledRadioButton, {
            onClickHandler: function(value) {
                return typeof value === "string" && handleOnClick(option);
            },
            selectedValue: selected || options[0].value,
            text: option.title,
            value: option.value,
            disabled: option.disabled
        }) : /*#__PURE__*/ react.createElement(dropdown_item/* DropdownItem */.h, {
            disabled: Boolean(selected === option.value),
            onClick: function() {
                return handleOnClick(option);
            }
        }, option.title));
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/shared/desktop-select/index.tsx





var CONTENT_WIDTH = 155;
var DesktopSelect = function(param) {
    var _asRadioButtons = param.asRadioButtons, asRadioButtons = _asRadioButtons === void 0 ? false : _asRadioButtons, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? ui_button.ButtonType.OUTLINED : _buttonType, _closeOnItemClick = param.closeOnItemClick, closeOnItemClick = _closeOnItemClick === void 0 ? false : _closeOnItemClick, icon = param.icon, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, onFilterChange = param.onFilterChange, options = param.options, _selectable = param.selectable, selectable = _selectable === void 0 ? false : _selectable, selected = param.selected, title = param.title;
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        closeOnItemClick: closeOnItemClick
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        showActiveIcon: true,
        type: buttonType,
        selectable: selectable,
        selected: isSelected
    }, icon, " ", title), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: ui/* Direction.Left */.Nm.Left,
        width: CONTENT_WIDTH
    }, /*#__PURE__*/ react.createElement(SelectContent, {
        asRadioButtons: asRadioButtons,
        options: options,
        handleOnClick: onFilterChange,
        selected: selected
    }))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(51676);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(42574);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/styles.ts
var styles = __webpack_require__(54981);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(7920);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(58425);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/filter-toggle-button.tsx





var FilterToggleButton = function(props) {
    var toggleHandler = props.toggleHandler, title = props.title, icon = props.icon, _activeFilters = props.activeFilters, activeFilters = _activeFilters === void 0 ? 0 : _activeFilters, hideNumber = props.hideNumber, showToggleButton = props.showToggleButton, isOpen = props.isOpen;
    return /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
        onClick: toggleHandler,
        selectable: true,
        selected: !!activeFilters
    }, activeFilters > 0 && /*#__PURE__*/ react.createElement(styles/* ButtonBadge */.kP, {
        circular: true,
        text: !hideNumber && activeFilters
    }), icon && /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, icon), /*#__PURE__*/ react.createElement(button_variants.ButtonText, null, title), showToggleButton && /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, isOpen ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)));
};
/* harmony default export */ var filter_toggle_button = (FilterToggleButton);

;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/shared/mobile-select/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var MobileSelect = function(param) {
    var icon = param.icon, _isSelected = param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, modalTitle = param.modalTitle, onFilterChange = param.onFilterChange, options = param.options, selected = param.selected, title = param.title;
    var ref = _slicedToArray((0,react.useState)(false), 2), isModalOpen = ref[0], setIsModalOpen = ref[1];
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(filter_toggle_button, {
        activeFilters: isSelected ? 1 : 0,
        hideNumber: true,
        icon: icon,
        showToggleButton: true,
        title: title,
        toggleHandler: function() {
            return setIsModalOpen(true);
        }
    }), isModalOpen && /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: isModalOpen,
        onRequestClose: function() {
            return setIsModalOpen(false);
        }
    }, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(SelectContent, {
        asRadioButtons: true,
        options: options,
        handleOnClick: onFilterChange,
        selected: selected,
        title: modalTitle
    }))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/filter/index.tsx
function filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function filter_slicedToArray(arr, i) {
    return filter_arrayWithHoles(arr) || filter_iterableToArrayLimit(arr, i) || filter_unsupportedIterableToArray(arr, i) || filter_nonIterableRest();
}
function filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return filter_arrayLikeToArray(o, minLen);
}




var Filter = function(param) {
    var onFilterChange = param.onFilterChange, options = param.options, title = param.title;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var ref = filter_slicedToArray((0,react.useState)(options[0].value), 2), selected = ref[0], setSelected = ref[1];
    var ref1 = filter_slicedToArray((0,react.useState)(title), 2), filterTitle = ref1[0], setFilterTitle = ref1[1];
    var setTitle = function(option) {
        if (option.value === "all") return setFilterTitle(title);
        return setFilterTitle(option.title);
    };
    var onFilterSelect = function(selectedOption) {
        var value = selectedOption.value;
        setSelected(value);
        onFilterChange(value);
        setTitle(selectedOption);
    };
    return isDesktop ? /*#__PURE__*/ react.createElement(DesktopSelect, {
        asRadioButtons: true,
        isSelected: selected !== "all",
        onFilterChange: onFilterSelect,
        options: options,
        selectable: true,
        selected: selected,
        title: filterTitle
    }) : /*#__PURE__*/ react.createElement(MobileSelect, {
        isSelected: selected !== "all",
        modalTitle: title,
        onFilterChange: onFilterSelect,
        options: options,
        selected: selected,
        title: filterTitle
    });
};

// EXTERNAL MODULE: ./src/globals/tracking/filter.ts
var filter = __webpack_require__(15301);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/sort/index.js
var sort = __webpack_require__(66131);
// EXTERNAL MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/types.ts
var filters_and_sorting_types = __webpack_require__(65974);
;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/sort/index.tsx
function sort_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function sort_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function sort_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function sort_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sort_slicedToArray(arr, i) {
    return sort_arrayWithHoles(arr) || sort_iterableToArrayLimit(arr, i) || sort_unsupportedIterableToArray(arr, i) || sort_nonIterableRest();
}
function sort_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sort_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sort_arrayLikeToArray(o, minLen);
}









var Sort = function(param) {
    var onSortChange = param.onSortChange, options = param.options;
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var ref2 = sort_slicedToArray((0,react.useState)(filters_and_sorting_types/* MobileContractSortOptionTypeEnum.MONTHLY_PRICE */.o.MONTHLY_PRICE), 2), selected = ref2[0], setSelected = ref2[1];
    var handleSort = function(option) {
        if (!option.value || option.value === selected) return;
        setSelected(option.value);
        onSortChange(option);
        (0,filter/* trackSortingSelectEvent */.Em)({
            property: option.value,
            value: option.value,
            scope: filter/* PageScope.PRODUCT */.VN.PRODUCT
        });
    };
    return isDesktop ? /*#__PURE__*/ react.createElement(DesktopSelect, {
        buttonType: ui_button.ButtonType.TEXT,
        closeOnItemClick: true,
        icon: /*#__PURE__*/ react.createElement(sort/* IconSort */.M, null),
        onFilterChange: handleSort,
        options: options,
        selected: selected,
        title: ((ref = options.find(function(option) {
            return option.value === selected;
        })) === null || ref === void 0 ? void 0 : ref.title) || ""
    }) : /*#__PURE__*/ react.createElement(MobileSelect, {
        icon: /*#__PURE__*/ react.createElement(sort/* IconSort */.M, null),
        modalTitle: t("common", "sort.title"),
        onFilterChange: handleSort,
        options: options,
        selected: selected,
        title: ((ref1 = options.find(function(option) {
            return option.value === selected;
        })) === null || ref1 === void 0 ? void 0 : ref1.title) || ""
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/utils.ts

var mobileContractFilters = [
    // Hardcoded untranslated text since Mobile Contracts are only enabled in SE
    {
        id: "mobile-contract-data-amount",
        options: [
            {
                title: "Alla",
                value: "all"
            },
            {
                title: "Minst 4 GB",
                value: "4-gb"
            },
            {
                title: "Minst 10 GB",
                value: "10-gb"
            },
            {
                title: "Minst 50 GB",
                value: "50-gb"
            },
            {
                title: "Fri surf",
                value: "free-surf"
            }
        ],
        title: "Surfm\xe4ngd",
        filterFn: function(mobileContract, selectedOption) {
            switch(selectedOption){
                case "all":
                    return true;
                case "free-surf":
                    return mobileContract.dataGB === 0;
                case "50-gb":
                    return mobileContract.dataGB >= 50 || mobileContract.dataGB === 0;
                case "10-gb":
                    return mobileContract.dataGB >= 10 || mobileContract.dataGB === 0;
                case "4-gb":
                    return mobileContract.dataGB >= 4 || mobileContract.dataGB === 0;
                default:
                    return false;
            }
        }
    }
];
var getOptionIsEnabled = function(mobileContracts, filterObject, selectedOption) {
    return mobileContracts.some(function(contract) {
        var ref;
        return (ref = contract.alternativeContracts) === null || ref === void 0 ? void 0 : ref.some(function(altContract) {
            return altContract && filterObject.filterFn(altContract, selectedOption);
        });
    });
};
var getSortOptions = function() {
    return [
        {
            title: "M\xe5nadspris",
            value: filters_and_sorting_types/* MobileContractSortOptionTypeEnum.MONTHLY_PRICE */.o.MONTHLY_PRICE
        },
        {
            title: "Totalpris",
            value: filters_and_sorting_types/* MobileContractSortOptionTypeEnum.TOTAL_PRICE */.o.TOTAL_PRICE
        }
    ];
};

;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/styles.ts
function filters_and_sorting_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function filters_and_sorting_styles_templateObject() {
    var data = filters_and_sorting_styles_taggedTemplateLiteral([
        "\n    padding-right: ",
        ";\n  "
    ]);
    filters_and_sorting_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filters_and_sorting_styles_templateObject1() {
    var data = filters_and_sorting_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    filters_and_sorting_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledFiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFiltersWrapper",
    componentId: "sc-0-0"
})(filters_and_sorting_styles_templateObject1(), design_tokens.measurements.spacing075, base/* media.mediumDown */.BC.mediumDown(filters_and_sorting_styles_templateObject(), design_tokens.measurements.spacing050));

;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/components/filters-and-sorting/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var FiltersAndSorting = function(param) {
    var onFilterChange = param.onFilterChange, onSortChange = param.onSortChange;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var mobileContracts = (0,product_context/* useProductContext */.$h)().mobileContracts;
    var renderFilters = function() {
        return /*#__PURE__*/ react.createElement(StyledFiltersWrapper, {
            key: "filters"
        }, mobileContractFilters.map(function(filter) {
            return /*#__PURE__*/ react.createElement(Filter, {
                key: filter.id,
                onFilterChange: function(selectedOption) {
                    return onFilterChange(filter, selectedOption);
                },
                options: filter.options.map(function(option) {
                    return _objectSpreadProps(_objectSpread({}, option), {
                        disabled: !getOptionIsEnabled(mobileContracts, filter, option.value)
                    });
                }),
                title: filter.title
            });
        }));
    };
    var renderSort = function() {
        return /*#__PURE__*/ react.createElement(Sort, {
            key: "sorting",
            onSortChange: onSortChange,
            options: getSortOptions()
        });
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, isDesktop ? [
        renderFilters(),
        renderSort()
    ] : [
        renderSort(),
        renderFilters()
    ]);
};

// EXTERNAL MODULE: ./src/areas/product/utils/mobile-contracts/price.ts
var price = __webpack_require__(61891);
;// CONCATENATED MODULE: ./src/areas/product/utils/mobile-contracts/utils.ts
function utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return utils_arrayLikeToArray(arr);
}
function utils_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function utils_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            utils_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function utils_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function utils_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        utils_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || utils_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return utils_arrayLikeToArray(o, minLen);
}
var getMobileContractLink = function(location) {
    var pathname = location.pathname, search = location.search;
    return search.includes("list=mobile-contract") ? pathname + search : "".concat(pathname).concat(search, "&list=mobile-contract");
};
var replaceMainMobileContractWithAlternativeContract = function(mobileContract, alternativeContract) {
    var newAlternatives = [
        alternativeContract
    ].concat(_toConsumableArray(mobileContract.alternativeContracts.filter(function(alt) {
        return alt !== alternativeContract;
    })));
    return utils_objectSpreadProps(utils_objectSpread({}, alternativeContract), {
        __typename: "MobileContractV2",
        alternativeContracts: newAlternatives
    });
};

;// CONCATENATED MODULE: ./src/areas/product/utils/mobile-contracts/sorting.ts
function sorting_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function sorting_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return sorting_arrayLikeToArray(arr);
}
function sorting_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function sorting_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sorting_toConsumableArray(arr) {
    return sorting_arrayWithoutHoles(arr) || sorting_iterableToArray(arr) || sorting_unsupportedIterableToArray(arr) || sorting_nonIterableSpread();
}
function sorting_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sorting_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sorting_arrayLikeToArray(o, minLen);
}



var sortAlternativeContractsBy = function(mobileContract, sortFunc) {
    if (!mobileContract.alternativeContracts) return [];
    var alternativeContracts = sorting_toConsumableArray(mobileContract.alternativeContracts).filter(function(item) {
        return item;
    });
    return alternativeContracts.sort(sortFunc);
};
var sortMobileContracts = function(items, currentSorting) {
    var newItems = sorting_toConsumableArray(items);
    var sortFunc = currentSorting === filters_and_sorting_types/* MobileContractSortOptionTypeEnum.TOTAL_PRICE */.o.TOTAL_PRICE ? sortByTotalPrice : sortByFirstMonthPrice;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var mobileContract = _step.value;
            mobileContract.alternativeContracts = sortAlternativeContractsBy(mobileContract, sortFunc);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var updatedMainContracts = newItems.map(function(mobileContract) {
        var ref;
        return replaceMainMobileContractWithAlternativeContract(mobileContract, (ref = mobileContract.alternativeContracts) === null || ref === void 0 ? void 0 : ref[0]);
    });
    return updatedMainContracts.sort(sortFunc);
};
var sortByFirstMonthPrice = function(a, b) {
    return (0,price/* getFirstMonthPrice */.lx)(a) - (0,price/* getFirstMonthPrice */.lx)(b);
};
var sortByTotalPrice = function(a, b) {
    return a.totalPrice - b.totalPrice;
};

;// CONCATENATED MODULE: ./src/areas/product/utils/mobile-contracts/filtering.ts
function filtering_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function filtering_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            filtering_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var filterMobileContracts = function(mobileContracts, filterObject, selectedFilter) {
    var filteredMobileContracts = mobileContracts.map(function(mobileContract) {
        return filtering_objectSpread({}, mobileContract);
    });
    // For each mobile contract, filter all its alternative contracts
    filteredMobileContracts.forEach(function(mobileContract) {
        var ref;
        // eslint-disable-next-line no-param-reassign
        mobileContract.alternativeContracts = (ref = mobileContract.alternativeContracts) === null || ref === void 0 ? void 0 : ref.filter(function(alternativeContract) {
            if (!alternativeContract) return false;
            return filterObject.filterFn(alternativeContract, selectedFilter);
        });
    });
    // Remove all mobile contracts that has no alternatives left
    filteredMobileContracts = filteredMobileContracts.filter(function(mobileContract) {
        var ref;
        return ((ref = mobileContract.alternativeContracts) === null || ref === void 0 ? void 0 : ref.length) !== 0;
    });
    // Replace all main contracts with first alternative (that has the correct info)
    filteredMobileContracts = filteredMobileContracts.map(function(mobileContract) {
        var ref;
        return replaceMainMobileContractWithAlternativeContract(mobileContract, (ref = mobileContract.alternativeContracts) === null || ref === void 0 ? void 0 : ref[0]);
    });
    return filteredMobileContracts;
};

;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-information/index.tsx



var MobileContractInformation = function() {
    var mobileContracts = (0,product_context/* useProductContext */.$h)().mobileContracts;
    var totalCount = mobileContracts.length;
    var featuredCount = mobileContracts.length;
    // Hardcoded untranslated text since Mobile Contracts are only enabled in SE
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.MEDIUM,
        scale: variants.FontScale.XS
    }, "Vi har hittat produkten med abonnemang i ".concat(totalCount, " butiker, varav ").concat(featuredCount, " \xe4r\n      betalande kunder hos Prisjakt. F\xf6r att g\xf6ra priserna j\xe4mf\xf6rbara visar vi\n      avbetalning av mobiltelefon tillsammans med abonnemang \xf6ver en\n      36-m\xe5nadersperiod. Observera att abonnemanget inte alltid har en\n      bindningstid p\xe5 36 m\xe5nader, men f\xf6r att skapa r\xe4ttvisa j\xe4mf\xf6relser har vi\n      anv\xe4nt samma ber\xe4kningsmetod f\xf6r samtliga operat\xf6rer.")));
};

;// CONCATENATED MODULE: ./src/areas/product/components/mobile-contract-list/index.tsx
function mobile_contract_list_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function mobile_contract_list_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function mobile_contract_list_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function mobile_contract_list_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function mobile_contract_list_slicedToArray(arr, i) {
    return mobile_contract_list_arrayWithHoles(arr) || mobile_contract_list_iterableToArrayLimit(arr, i) || mobile_contract_list_unsupportedIterableToArray(arr, i) || mobile_contract_list_nonIterableRest();
}
function mobile_contract_list_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return mobile_contract_list_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mobile_contract_list_arrayLikeToArray(o, minLen);
}















var MobileContractList = function(param) {
    var onCountChange = param.onCountChange;
    var ref = (0,product_context/* useProductContext */.$h)(), product = ref.product, mobileContracts = ref.mobileContracts;
    var viewport = (0,context/* useViewportContext */.Ak)();
    var ref1 = mobile_contract_list_slicedToArray((0,react.useState)(filters_and_sorting_types/* MobileContractSortOptionTypeEnum.MONTHLY_PRICE */.o.MONTHLY_PRICE), 2), currentSorting = ref1[0], setCurrentSorting = ref1[1];
    var ref2 = mobile_contract_list_slicedToArray((0,react.useState)(// Sort by default (for SSR)
    sortMobileContracts(mobileContracts, filters_and_sorting_types/* MobileContractSortOptionTypeEnum.MONTHLY_PRICE */.o.MONTHLY_PRICE)), 2), selectedMobileContracts = ref2[0], setSelectedMobileContracts = ref2[1];
    var handleSortChange = function(selectedOption) {
        var sortValue = selectedOption.value;
        var sorted = sortMobileContracts(selectedMobileContracts, sortValue);
        setCurrentSorting(sortValue);
        setSelectedMobileContracts(sorted);
    };
    var handleFilterChange = function(filterObject, selectedValue) {
        var ref;
        var filtered = filterMobileContracts(mobileContracts, filterObject, selectedValue);
        var sortedFiltered = sortMobileContracts(filtered, currentSorting);
        setSelectedMobileContracts(sortedFiltered);
        onCountChange(sortedFiltered.length);
        var selectedOptionTitle = (ref = filterObject.options.find(function(f) {
            return f.value === selectedValue;
        })) === null || ref === void 0 ? void 0 : ref.title;
        var trackFilterParams = {
            scope: filter/* PageScope.PRODUCT */.VN.PRODUCT,
            property: filterObject.title,
            value: filterObject.id,
            layout: "quick-filter",
            type: "list",
            translatedValue: selectedOptionTitle
        };
        // If 'all' is selected, we should track it as a remove event
        if (selectedValue === "all") (0,filter/* trackFilterRemoveEvent */.YD)(trackFilterParams);
        else (0,filter/* trackFilterSelectEvent */.f9)(trackFilterParams);
    };
    var FilterComponent = /*#__PURE__*/ react.createElement(FiltersAndSorting, {
        onFilterChange: handleFilterChange,
        onSortChange: handleSortChange
    });
    return(// id="mobile-contract-panel" is for tab a11y (aria-controls)
    /*#__PURE__*/ react.createElement("div", {
        id: "mobile-contract-panel"
    }, /*#__PURE__*/ react.createElement(PanelHeader, null, viewport.isDesktop ? FilterComponent : /*#__PURE__*/ react.createElement(StyledMobileFiltersAndSorting, null, FilterComponent)), /*#__PURE__*/ react.createElement(StyledList, null, selectedMobileContracts === null || selectedMobileContracts === void 0 ? void 0 : selectedMobileContracts.map(function(contract) {
        return /*#__PURE__*/ react.createElement("li", {
            key: contract.contractId
        }, /*#__PURE__*/ react.createElement(price_row_context/* PriceRowContextContainer */.B, {
            offer: (0,mappings/* mapMobileContractToOffer */.v)(contract),
            product: product,
            viewSize: (0,common/* getViewSize */.a0)(viewport),
            isInPriceList: true,
            sorting: currentSorting
        }, /*#__PURE__*/ react.createElement(row_types/* PriceRow */.a, {
            trackingItem: (0,mappings/* mapMobileContractToTrackingItem */.X)(contract)
        })));
    })), /*#__PURE__*/ react.createElement(MobileContractInformation, null)));
};

// EXTERNAL MODULE: ./src/areas/editorial-content/components/sanity-faq/index.tsx + 3 modules
var sanity_faq = __webpack_require__(56264);
// EXTERNAL MODULE: ./src/components/data-list/index.tsx + 1 modules
var data_list = __webpack_require__(49907);
// EXTERNAL MODULE: ./src/components/data-list/components/parseNodes.tsx
var parseNodes = __webpack_require__(99453);
// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(52923);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(22899);
;// CONCATENATED MODULE: ./src/ui/list/index.ts
function list_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function list_templateObject() {
    var data = list_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n\n  ::marker {\n    color: ",
        ";\n  }\n  && {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    list_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_templateObject1() {
    var data = list_taggedTemplateLiteral([
        ""
    ]);
    list_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function list_templateObject2() {
    var data = list_taggedTemplateLiteral([
        "\n  list-style: none;\n  > ",
        " {\n    margin-left: 0;\n  }\n"
    ]);
    list_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Li = styled_components_browser_esm["default"].li.withConfig({
    displayName: "",
    componentId: "sc-0-0"
})(list_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(props) {
    return props.theme.text.callToAction;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Ul = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "",
    componentId: "sc-0-1"
})(list_templateObject1());
var UnStyledUl = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "UnStyledUl",
    componentId: "sc-0-2"
})(list_templateObject2(), Li);

// EXTERNAL MODULE: ./src/ui/link/index.ts
var ui_link = __webpack_require__(35050);
;// CONCATENATED MODULE: ./src/ui/text/index.ts
function text_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function text_templateObject() {
    var data = text_taggedTemplateLiteral([
        "\n  text-align: justify;\n"
    ]);
    text_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function text_templateObject1() {
    var data = text_taggedTemplateLiteral([
        "\n  text-align: justify;\n"
    ]);
    text_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function text_templateObject2() {
    var data = text_taggedTemplateLiteral([
        ""
    ]);
    text_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var P = (0,styled_components_browser_esm["default"])(variants.BodySmallText).attrs({
    container: "p"
}).withConfig({
    displayName: "P",
    componentId: "sc-0-0"
})(text_templateObject());
var Text = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(text_templateObject1());
var Strong = (0,styled_components_browser_esm["default"])(variants.BodySmallText).attrs({
    container: "strong",
    weight: variants.FontWeight.HEAVIER
}).withConfig({
    displayName: "Strong",
    componentId: "sc-0-2"
})(text_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/product-description/styles.ts
function product_description_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_description_styles_templateObject() {
    var data = product_description_styles_taggedTemplateLiteral([
        "\n    column-gap: ",
        ";\n    break-inside: avoid-column;\n    columns: 2;\n    "
    ]);
    product_description_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_description_styles_templateObject1() {
    var data = product_description_styles_taggedTemplateLiteral([
        "\n  > li {\n    /* stylelint-disable property-no-vendor-prefix */\n    -webkit-column-break-inside: avoid;\n    page-break-inside: avoid;\n    break-inside: avoid;\n  }\n  ",
        "\n"
    ]);
    product_description_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledUl = (0,styled_components_browser_esm["default"])(UnStyledUl).withConfig({
    displayName: "StyledUl",
    componentId: "sc-0-0"
})(product_description_styles_templateObject1(), base/* media.mediumUp */.BC.mediumUp(product_description_styles_templateObject(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200));

;// CONCATENATED MODULE: ./src/areas/product/components/product-description/index.tsx







var ProductDescription = function(param) {
    var description = param.description;
    var preamble = description.preamble, descriptionPoints = description.descriptionPoints, articles = description.articles;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement("div", null, preamble && /*#__PURE__*/ react.createElement(P, null, preamble), descriptionPoints && (descriptionPoints === null || descriptionPoints === void 0 ? void 0 : descriptionPoints.length) > 0 && /*#__PURE__*/ react.createElement(StyledUl, null, descriptionPoints.filter(Boolean).map(function(point) {
        return /*#__PURE__*/ react.createElement(Li, {
            key: point.title
        }, /*#__PURE__*/ react.createElement(Strong, null, point.title), /*#__PURE__*/ react.createElement(P, null, point.text));
    })), articles && (articles === null || articles === void 0 ? void 0 : articles.length) > 0 && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, {
        container: Strong
    }, t("common", "article.articles")), /*#__PURE__*/ react.createElement(Ul, null, articles.filter(Boolean).map(function(article) {
        var url = new URL(article.url).pathname;
        return /*#__PURE__*/ react.createElement(Li, {
            key: url
        }, /*#__PURE__*/ react.createElement(ui_link/* InternalLink */.h, {
            to: url
        }, article.name));
    }))));
};

// EXTERNAL MODULE: ./src/areas/product/components/product-properties/components/verified-product-info/index.tsx + 1 modules
var verified_product_info = __webpack_require__(45874);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/components/category-rank.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var subPropIsEqual = function(prev, next, prop, subProp) {
    return prev[prop] && next[prop] ? prev[prop][subProp] === next[prop][subProp] : !prev[prop] === !next[prop];
};
var CategoryRank = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(CategoryRank, _Component);
    var _super = _createSuper(CategoryRank);
    function CategoryRank() {
        _classCallCheck(this, CategoryRank);
        return _super.apply(this, arguments);
    }
    _createClass(CategoryRank, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var propsAreEqual = this.props.name === nextProps.name && subPropIsEqual(this.props, nextProps, "category", "name") && subPropIsEqual(this.props, nextProps, "category", "pathName") && subPropIsEqual(this.props, nextProps, "popularity", "inCategory") && subPropIsEqual(this.props, nextProps, "userReviewSummary", "rating");
                return !propsAreEqual;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, name = _props.name, category = _props.category, popularity = _props.popularity, userReviewSummary = _props.userReviewSummary;
                var t = this.context.t;
                return category && popularity && popularity.inCategory > 0 && popularity.inCategory < 100 ? t("product", "product-info.rank".concat(popularity.inCategory <= 10 ? "-popular" : ""), {
                    product: name,
                    category: /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
                        key: category.id,
                        to: category.pathName
                    }, category.name),
                    rating: userReviewSummary && userReviewSummary.rating ? t("product", "product-info.rank-rating", {
                        rating: Number(userReviewSummary.rating).toFixed(1)
                    }) : "",
                    n: popularity.inCategory
                }) : null;
            }
        }
    ]);
    return CategoryRank;
}(react.Component);
var string = (prop_types_default()).string, number = (prop_types_default()).number, shape = (prop_types_default()).shape;
CategoryRank.contextType = app_context/* AppContext */.Il;
CategoryRank.propTypes = {
    name: string,
    category: shape({
        name: string,
        pathName: string
    }),
    popularity: shape({
        inCategory: number
    }),
    userReviewSummary: shape({
        rating: number
    })
};
CategoryRank.defaultProps = {
    name: undefined,
    category: undefined,
    popularity: undefined,
    userReviewSummary: undefined
};
/* harmony default export */ var category_rank = (CategoryRank);

// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/components/price-summary.js




var PriceSummary = function(param) {
    var productName = param.productName, priceSummary = param.priceSummary, prices = param.prices;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var regular = (priceSummary || {}).regular;
    if (!regular) {
        return null;
    }
    var priceUsed = prices && Array.isArray(prices.nodes) ? prices.nodes.find(function(item) {
        return item.type === "used_product" && // Consider checking 'not_in_mint_condition'?
        item.store && item.store.market === "primary" && item.stock && (item.stock.status === "in_stock" || item.stock.status === null);
    }) : null;
    return priceUsed && priceUsed.price && priceUsed.price.exclShipping < regular ? /*#__PURE__*/ react.createElement(react.Fragment, null, t("product", "product-info.price-used", {
        product: productName,
        price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: regular
        }),
        priceUsed: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: priceUsed.price.exclShipping
        })
    })) : /*#__PURE__*/ react.createElement(react.Fragment, null, t("product", "product-info.price", {
        product: productName,
        price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            key: regular,
            price: regular
        })
    }));
};
var price_summary_string = (prop_types_default()).string, price_summary_number = (prop_types_default()).number, price_summary_shape = (prop_types_default()).shape, arrayOf = (prop_types_default()).arrayOf;
PriceSummary.propTypes = {
    productName: price_summary_string,
    priceSummary: price_summary_shape({
        alternative: price_summary_number,
        regular: price_summary_number
    }),
    prices: price_summary_shape({
        nodes: arrayOf(price_summary_shape({
            price: price_summary_shape({
                exclShipping: price_summary_number,
                inclShipping: price_summary_number
            }),
            type: price_summary_string
        }))
    })
};
PriceSummary.defaultProps = {
    productName: undefined,
    priceSummary: undefined,
    prices: undefined
};
/* harmony default export */ var price_summary = (PriceSummary);

// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/components/store-count.js



var StoreCount = function(param) {
    var name = param.name, prices = param.prices;
    var numberOfStores = prices && prices.meta && prices.meta.storeStatistics && prices.meta.storeStatistics.totalCount ? Math.max(1, prices.meta.storeStatistics.totalCount) : 1;
    return name ? /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product",
        product: name,
        n: numberOfStores
    }, "product-info.store-count") : null;
};
var store_count_string = (prop_types_default()).string, store_count_number = (prop_types_default()).number, store_count_shape = (prop_types_default()).shape;
StoreCount.propTypes = {
    name: store_count_string,
    prices: store_count_shape({
        meta: store_count_shape({
            storeStatistics: store_count_shape({
                totalCount: store_count_number
            })
        })
    })
};
StoreCount.defaultProps = {
    name: undefined,
    prices: undefined
};
/* harmony default export */ var store_count = (StoreCount);

;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/components/user-sentiments.js




var CompareLink = function(param) {
    var id = param.id, pathName = param.pathName, reviewBadges = param.reviewBadges;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, linkTo = ref.linkTo;
    if (!reviewBadges || reviewBadges.length === 0) {
        return null;
    }
    var ref1 = reviewBadges[0], name = ref1.name, sentiment = ref1.sentiment;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, t("product", "product-info.user-sentiments", {
        sentiment: /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            to: linkTo("productReviews", {
                id: id,
                pathName: pathName
            })
        }, t("product", "sentiment-badge.".concat(name, "-").concat(sentiment)))
    }));
};
var user_sentiments_arrayOf = (prop_types_default()).arrayOf, user_sentiments_shape = (prop_types_default()).shape, user_sentiments_number = (prop_types_default()).number, user_sentiments_string = (prop_types_default()).string;
CompareLink.propTypes = {
    id: user_sentiments_number.isRequired,
    pathName: user_sentiments_string.isRequired,
    reviewBadges: user_sentiments_arrayOf(user_sentiments_shape({
        product: user_sentiments_shape({
            name: user_sentiments_string,
            sentiment: user_sentiments_string
        })
    }))
};
CompareLink.defaultProps = {
    reviewBadges: undefined
};
/* harmony default export */ var user_sentiments = (CompareLink);

;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/styles.ts
function readable_product_information_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function readable_product_information_styles_templateObject() {
    var data = readable_product_information_styles_taggedTemplateLiteral([
        "\n  max-width: 500px;\n\n  color: ",
        ";\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    readable_product_information_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function readable_product_information_styles_templateObject1() {
    var data = readable_product_information_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    readable_product_information_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ProductInfo = styled_components_browser_esm["default"].p.withConfig({
    displayName: "ProductInfo",
    componentId: "sc-0-0"
})(readable_product_information_styles_templateObject(), function(p) {
    return p.theme.text.secondary;
}, function(p) {
    return p.theme.text.secondary;
});
var SubSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SubSection",
    componentId: "sc-0-1"
})(readable_product_information_styles_templateObject1(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200);

;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/index.tsx
function readable_product_information_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function readable_product_information_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            readable_product_information_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function readable_product_information_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function readable_product_information_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        readable_product_information_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
















var ReadableProductInformation = /*#__PURE__*/ (0,react.memo)(function() {
    var ref, ref1;
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref2.t, linkTo = ref2.linkTo, market = ref2.market;
    var product = (0,product_context/* useProductContext */.$h)().product;
    if (!product || !((ref = market.modules) === null || ref === void 0 ? void 0 : ref.readableProductInfo) || !((ref1 = market.modules) === null || ref1 === void 0 ? void 0 : ref1.readableProductInfo.enabled)) {
        return null;
    }
    var id = product.id, pathName = product.pathName, name = product.name, priceSummary = product.priceSummary, prices = product.prices, category = product.category, popularity = product.popularity, description = product.description, coreProperties = product.coreProperties, reviewBadges = product.reviewBadges, userReviewSummary = product.userReviewSummary, brand = product.brand, productDescription = product.productDescription, sanityFaq = product.sanityFaq;
    // Add brand as a custom "fake" core prop
    var brandProp = brand && category ? {
        id: "brand",
        name: t("product", "property.brand"),
        type: "string",
        value: brand.name,
        pretty: brand.name,
        valueId: brand.id.toString(),
        categoryLink: linkTo("brandCategory", readable_product_information_objectSpreadProps(readable_product_information_objectSpread({}, category), {
            brandId: brand.id
        }))
    } : null;
    var brandProperties = brandProp ? [
        brandProp
    ] : [];
    var modifiedCoreProperties = brandProperties.concat((coreProperties === null || coreProperties === void 0 ? void 0 : coreProperties.nodes) || []).filter(Boolean).slice(0, 10); // Some products apparently has _a lot_ of core props
    return /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: onError
    }, /*#__PURE__*/ react.createElement("div", {
        "data-test": "Panel",
        "data-test-type": "product-info"
    }, /*#__PURE__*/ react.createElement(variants.H2Text, null, t("product", "product-info.title")), /*#__PURE__*/ react.createElement(verified_product_info/* VerifiedProductInfo */.j, null), description && /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true
    }, /*#__PURE__*/ react.createElement(SubSection, null, /*#__PURE__*/ react.createElement(ProductInfo, {
        dangerouslySetInnerHTML: {
            __html: description
        }
    }))), /*#__PURE__*/ react.createElement(SubSection, null, productDescription ? /*#__PURE__*/ react.createElement(ProductDescription, {
        description: productDescription
    }) : /*#__PURE__*/ react.createElement(ProductInfo, null, /*#__PURE__*/ react.createElement(price_summary, {
        productName: name,
        priceSummary: priceSummary,
        prices: prices
    }), " ", /*#__PURE__*/ react.createElement(category_rank, {
        name: name,
        category: category,
        popularity: popularity,
        userReviewSummary: userReviewSummary
    }), " ", /*#__PURE__*/ react.createElement(user_sentiments, {
        id: id,
        pathName: pathName,
        reviewBadges: reviewBadges
    }), " ", /*#__PURE__*/ react.createElement(store_count, {
        name: name,
        prices: prices
    }), " ")), sanityFaq ? /*#__PURE__*/ react.createElement(SubSection, null, /*#__PURE__*/ react.createElement(sanity_faq/* FaqSanity */.P, {
        faq: sanityFaq
    })) : null, modifiedCoreProperties && /*#__PURE__*/ react.createElement(SubSection, null, /*#__PURE__*/ react.createElement(data_list/* DataList */.F, {
        properties: modifiedCoreProperties.map(function(childNode) {
            return (0,parseNodes/* parseNodes */.E)(childNode, t, false);
        })
    }))));
});
var onError = function() {
    return null;
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/main/components/panel/styles.ts
function panel_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function panel_styles_templateObject() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n    padding-top: 0;\n  "
    ]);
    panel_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function panel_styles_templateObject1() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n\n  ",
        ";\n"
    ]);
    panel_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function panel_styles_templateObject2() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n    margin-bottom: 30px;\n  "
    ]);
    panel_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = panel_styles_taggedTemplateLiteral([
        "\n  margin-bottom: 20px;\n\n  ",
        "\n\n  ul:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var PriceListPanelWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceListPanelWrapper",
    componentId: "sc-0-0"
})(panel_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(panel_styles_templateObject()));
var PricePanel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PricePanel",
    componentId: "sc-0-1"
})(styles_templateObject3(), base/* media.mediumUp */.BC.mediumUp(panel_styles_templateObject2()), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/main/components/panel/index.tsx


var Panel = function(param) {
    var children = param.children;
    return /*#__PURE__*/ react.createElement(PriceListPanelWrapper, null, /*#__PURE__*/ react.createElement(PricePanel, null, children));
};

// EXTERNAL MODULE: ./src/hooks/use-localstorage.ts
var use_localstorage = __webpack_require__(92317);
// EXTERNAL MODULE: ./src/hooks/use-show-ux-feedback.ts
var use_show_ux_feedback = __webpack_require__(95794);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/utils.ts
var utils = __webpack_require__(603);
// EXTERNAL MODULE: ./src/areas/product/styles.tsx
var product_styles = __webpack_require__(29813);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(8836);
// EXTERNAL MODULE: ./src/components/text-link/index.tsx + 1 modules
var text_link = __webpack_require__(30943);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/index.tsx
var report_modal = __webpack_require__(75675);
// EXTERNAL MODULE: ./src/components/info-page-link/index.js
var info_page_link = __webpack_require__(91135);
;// CONCATENATED MODULE: ./src/areas/product/components/price-information/styles.ts
function price_information_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_information_styles_templateObject() {
    var data = price_information_styles_taggedTemplateLiteral([
        "\n    flex-direction: row;\n  "
    ]);
    price_information_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function price_information_styles_templateObject1() {
    var data = price_information_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  color: $text-color-lighten;\n  font-size: 12px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  border-bottom: none;\n  flex-direction: column;\n  align-items: start;\n  gap: 0.5rem;\n  justify-content: space-between;\n  ",
        "\n"
    ]);
    price_information_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function price_information_styles_templateObject2() {
    var data = price_information_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  color: inherit;\n  text-decoration: underline;\n  align-items: baseline;\n"
    ]);
    price_information_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function price_information_styles_templateObject3() {
    var data = price_information_styles_taggedTemplateLiteral([
        "\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    price_information_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledPriceInformation = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPriceInformation",
    componentId: "sc-0-0"
})(price_information_styles_templateObject1(), base/* media.mediumUp */.BC.mediumUp(price_information_styles_templateObject()));
var StyledInfoPageLinkWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledInfoPageLinkWrapper",
    componentId: "sc-0-1"
})(price_information_styles_templateObject2());
var StyledInfoPageLink = (0,styled_components_browser_esm["default"])(info_page_link/* default */.Z).withConfig({
    displayName: "StyledInfoPageLink",
    componentId: "sc-0-2"
})(price_information_styles_templateObject3(), function(p) {
    return p.theme.colors.maybeBlue700;
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-information/index.tsx
function price_information_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_information_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_information_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_information_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_information_slicedToArray(arr, i) {
    return price_information_arrayWithHoles(arr) || price_information_iterableToArrayLimit(arr, i) || price_information_unsupportedIterableToArray(arr, i) || price_information_nonIterableRest();
}
function price_information_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_information_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_information_arrayLikeToArray(o, minLen);
}







var PriceInformation = function(props) {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref4.t, market = ref4.market;
    var ref5 = (0,product_context/* useProductContext */.$h)(), priceInfoArticles = ref5.priceInfoArticles, product = ref5.product;
    var priceInfoUrl = (priceInfoArticles === null || priceInfoArticles === void 0 ? void 0 : priceInfoArticles.length) ? priceInfoArticles[0].pathName : undefined;
    var ref6 = price_information_slicedToArray((0,react.useState)(false), 2), reportModalIsOpen = ref6[0], setReportModalIsOpen = ref6[1];
    return /*#__PURE__*/ react.createElement(StyledPriceInformation, null, reportModalIsOpen && /*#__PURE__*/ react.createElement(report_modal/* ReportModal */.y, {
        isOpen: true,
        closeModal: function() {
            return setReportModalIsOpen(false);
        },
        productId: product.id,
        productName: product.name,
        productImage: (ref = product.media) === null || ref === void 0 ? void 0 : ref.first
    }), /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.MEDIUM,
        scale: variants.FontScale.XS
    }, t("product", "price-comparison-information.featured-stores-ratio", {
        totalCount: ((ref1 = props.storeStatistics) === null || ref1 === void 0 ? void 0 : ref1.totalCount) || 0,
        featuredCount: ((ref2 = props.storeStatistics) === null || ref2 === void 0 ? void 0 : ref2.featuredCount) || 0
    }), /*#__PURE__*/ react.createElement("br", null), t("product", "price-comparison-information.listed-stores-information"), /*#__PURE__*/ react.createElement("br", null), /*#__PURE__*/ react.createElement(StyledInfoPageLinkWrapper, null, /*#__PURE__*/ react.createElement(StyledInfoPageLink, {
        id: (ref3 = market.infoPageMap) === null || ref3 === void 0 ? void 0 : ref3.priceInformation,
        url: priceInfoUrl
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.MEDIUM,
        scale: variants.FontScale.XS
    }, t("product", "price-comparison-information.read-more"))))), /*#__PURE__*/ react.createElement(text_link/* TextLink */.h, {
        onClick: function() {
            return setReportModalIsOpen(true);
        }
    }, t("feedback", "dialog.prompt-button")));
};

// EXTERNAL MODULE: ./src/areas/product/utils/price-list/sort-by-price.ts
var sort_by_price = __webpack_require__(17307);
// EXTERNAL MODULE: ./src/components/filter-dropdown/index.tsx + 1 modules
var filter_dropdown = __webpack_require__(85066);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/checkbox/variants.js
var checkbox_variants = __webpack_require__(92191);
// EXTERNAL MODULE: ./src/areas/product/utils/price-list/types.ts
var price_list_types = __webpack_require__(34057);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/delivery/index.js
var delivery = __webpack_require__(29610);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/shippingFilterButton.tsx





var ShippingFilterButton = function(props) {
    var toggleHandler = props.toggleHandler, title = props.title, icon = props.icon, _activeFilters = props.activeFilters, activeFilters = _activeFilters === void 0 ? 0 : _activeFilters, hideNumber = props.hideNumber, showToggleButton = props.showToggleButton, isOpen = props.isOpen;
    return /*#__PURE__*/ react.createElement(styles/* ShippingFilterTextButton */.qj, {
        onClick: toggleHandler,
        selectable: true,
        selected: !!activeFilters
    }, activeFilters > 0 && /*#__PURE__*/ react.createElement(styles/* ButtonBadge */.kP, {
        circular: true,
        text: !hideNumber && activeFilters
    }), /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, icon), /*#__PURE__*/ react.createElement(button_variants.ButtonText, null, title), showToggleButton && /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, isOpen ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/index.tsx + 8 modules
var shipping_filters = __webpack_require__(23423);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/utils.ts
var delivery_methods_utils = __webpack_require__(64701);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/shipping-filter.tsx
function shipping_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function shipping_filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function shipping_filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function shipping_filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function shipping_filter_slicedToArray(arr, i) {
    return shipping_filter_arrayWithHoles(arr) || shipping_filter_iterableToArrayLimit(arr, i) || shipping_filter_unsupportedIterableToArray(arr, i) || shipping_filter_nonIterableRest();
}
function shipping_filter_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function shipping_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return shipping_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return shipping_filter_arrayLikeToArray(o, minLen);
}
function shipping_filter_templateObject() {
    var data = shipping_filter_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-right: ",
        ";\n"
    ]);
    shipping_filter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function shipping_filter_templateObject1() {
    var data = shipping_filter_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    shipping_filter_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function shipping_filter_templateObject2() {
    var data = shipping_filter_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    shipping_filter_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function shipping_filter_templateObject3() {
    var data = shipping_filter_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    shipping_filter_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = shipping_filter_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}













var ShippingFilter = function(param) {
    var allOffersWithActiveAdditives = param.allOffersWithActiveAdditives, setShowShippingModal = param.setShowShippingModal;
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var ref2 = shipping_filter_slicedToArray((0,react.useState)(false), 2), showShipping = ref2[0], setShowShipping = ref2[1];
    var offersWithShippingCount = allOffersWithActiveAdditives.filter(function(offer) {
        var ref;
        return (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
            return Boolean(node.deliveryMethod);
        });
    }, 0);
    var activeDeliveryMethod = ((ref = getFilter(price_list_types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD)) === null || ref === void 0 ? void 0 : ref.selection) || [];
    var selectedCarriers = ((ref1 = getFilter(price_list_types/* FilterType.CARRIERS */.vA.CARRIERS)) === null || ref1 === void 0 ? void 0 : ref1.selection) || [];
    var getDeliveryTitle = function() {
        var activeCarriers = "";
        var title = t("product", "filter.delivery");
        var hasActiveMethod = activeDeliveryMethod.length > 0;
        if (hasActiveMethod) {
            title = (0,delivery_methods_utils/* getTranslation */.i)(t, activeDeliveryMethod[0]) || "";
        }
        if (selectedCarriers.length > 0 && !hasActiveMethod) {
            title = selectedCarriers[0];
        }
        if (hasActiveMethod && selectedCarriers.length > 0) {
            activeCarriers = "+".concat(selectedCarriers.length);
        }
        if (!hasActiveMethod && selectedCarriers.length > 1) {
            activeCarriers = "+".concat(selectedCarriers.length - 1);
        }
        return "".concat(title, " ").concat(activeCarriers);
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, offersWithShippingCount.length > 0 && /*#__PURE__*/ react.createElement(ShippingWrapper, null, /*#__PURE__*/ react.createElement(MobileButton, null, /*#__PURE__*/ react.createElement(filter_toggle_button, {
        toggleHandler: function() {
            return setShowShippingModal(!showShipping);
        },
        activeFilters: activeDeliveryMethod.length || selectedCarriers.length,
        hideNumber: true,
        title: getDeliveryTitle(),
        showToggleButton: true,
        icon: /*#__PURE__*/ react.createElement(delivery/* IconDeliveryOutlined */._R, null),
        isOpen: showShipping
    })), /*#__PURE__*/ react.createElement(MediumUpButton, null, /*#__PURE__*/ react.createElement(ShippingFilterButton, {
        toggleHandler: function() {
            return setShowShipping(!showShipping);
        },
        activeFilters: activeDeliveryMethod.length || selectedCarriers.length,
        hideNumber: true,
        title: getDeliveryTitle(),
        showToggleButton: true,
        icon: /*#__PURE__*/ react.createElement(delivery/* IconDeliveryOutlined */._R, null),
        isOpen: showShipping
    })), showShipping && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* FilterBlocker */.rO, {
        onClick: function() {
            return setShowShipping(false);
        }
    }), /*#__PURE__*/ react.createElement(styles/* FiltersDropDown */.g6, null, /*#__PURE__*/ react.createElement(styles/* FilterPanelWrapper */.gC, null, /*#__PURE__*/ react.createElement(shipping_filters/* ShippingFilters */.O, null))))));
};
var ShippingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShippingWrapper",
    componentId: "sc-0-0"
})(shipping_filter_templateObject(), design_tokens.measurements.spacing050);
var MobileButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MobileButton",
    componentId: "sc-0-1"
})(shipping_filter_templateObject2(), base/* media.largeUp */.BC.largeUp(shipping_filter_templateObject1()));
var MediumUpButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MediumUpButton",
    componentId: "sc-0-2"
})(_templateObject4(), base/* media.mediumDown */.BC.mediumDown(shipping_filter_templateObject3()));

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/header-filters.tsx







var HEADER_FILTERS_LIMIT = 3;
var HeaderFilters = function(param) {
    var allOffersWithActiveAdditives = param.allOffersWithActiveAdditives, applicableFilters = param.applicableFilters, setShowShippingModal = param.setShowShippingModal;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getTranslatedLabel = ref.getTranslatedLabel, toggleFilter = ref.toggleFilter;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var headerFilters = applicableFilters.filter(function(filter) {
        return filter.placement.includes(price_list_types/* FilterUIPlacementEnum.OFFERLIST_HEADER */.jm.OFFERLIST_HEADER);
    });
    // Limit the number of "quick" filters shown on desktop to prevent the header-filters to overflow
    // and the sorting dropdown from being pushed down.
    // This removes the last filter in the list, which is considered  here to have the lowest priority.
    var limitedHeaderFilters = isDesktop ? headerFilters.slice(0, HEADER_FILTERS_LIMIT - 1) : headerFilters;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, limitedHeaderFilters.map(function(filter) {
        return /*#__PURE__*/ react.createElement(styles/* FilterOptionWrapper */.FJ, {
            key: filter.label
        }, /*#__PURE__*/ react.createElement(styles/* CheckboxClickarea */.HA, null, /*#__PURE__*/ react.createElement(checkbox_variants/* CheckboxSwitch */.K_, {
            id: filter.label,
            text: getTranslatedLabel(filter.type),
            onChange: function() {
                return toggleFilter(filter.type);
            },
            checked: Boolean(filter.active)
        })));
    }), /*#__PURE__*/ react.createElement(ShippingFilter, {
        allOffersWithActiveAdditives: allOffersWithActiveAdditives,
        setShowShippingModal: setShowShippingModal
    }));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/utils/index.ts
var price_list_utils = __webpack_require__(54581);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/all-filters/index.tsx
var all_filters = __webpack_require__(79799);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/sliders/index.js
var sliders = __webpack_require__(96290);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/main-offerlist-filters-dropdown.tsx
function main_offerlist_filters_dropdown_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function main_offerlist_filters_dropdown_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function main_offerlist_filters_dropdown_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function main_offerlist_filters_dropdown_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function main_offerlist_filters_dropdown_slicedToArray(arr, i) {
    return main_offerlist_filters_dropdown_arrayWithHoles(arr) || main_offerlist_filters_dropdown_iterableToArrayLimit(arr, i) || main_offerlist_filters_dropdown_unsupportedIterableToArray(arr, i) || main_offerlist_filters_dropdown_nonIterableRest();
}
function main_offerlist_filters_dropdown_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return main_offerlist_filters_dropdown_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return main_offerlist_filters_dropdown_arrayLikeToArray(o, minLen);
}







var MainOfferlistFiltersDropdown = function(props) {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var applicableFilters = props.applicableFilters, activeOfferlistFilters = props.activeOfferlistFilters, className = props.className;
    var toggleFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().toggleFilter;
    var ref = main_offerlist_filters_dropdown_slicedToArray((0,react.useState)(false), 2), showFilters = ref[0], setShowFilters = ref[1];
    var closeHandler = function() {
        return setShowFilters(false);
    };
    var toggleHandler = function() {
        return setShowFilters(!showFilters);
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: className
    }, /*#__PURE__*/ react.createElement(filter_toggle_button, {
        toggleHandler: toggleHandler,
        activeFilters: activeOfferlistFilters.length,
        title: t("filter", "filter.title"),
        icon: /*#__PURE__*/ react.createElement(sliders/* IconSliders */.O, null)
    }), showFilters && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* FilterBlocker */.rO, {
        onClick: function() {
            return closeHandler();
        }
    }), /*#__PURE__*/ react.createElement(styles/* FiltersDropDown */.g6, null, /*#__PURE__*/ react.createElement(styles/* FilterPanelWrapper */.gC, null, /*#__PURE__*/ react.createElement(all_filters/* AllFiltersLoader */.m, {
        filters: applicableFilters,
        onToggleFilter: toggleFilter
    })))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/main-offerlist-filters-mobile.tsx
function main_offerlist_filters_mobile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function main_offerlist_filters_mobile_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function main_offerlist_filters_mobile_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function main_offerlist_filters_mobile_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function main_offerlist_filters_mobile_slicedToArray(arr, i) {
    return main_offerlist_filters_mobile_arrayWithHoles(arr) || main_offerlist_filters_mobile_iterableToArrayLimit(arr, i) || main_offerlist_filters_mobile_unsupportedIterableToArray(arr, i) || main_offerlist_filters_mobile_nonIterableRest();
}
function main_offerlist_filters_mobile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return main_offerlist_filters_mobile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return main_offerlist_filters_mobile_arrayLikeToArray(o, minLen);
}











var MainOfferlistFiltersMobile = function(props) {
    var applicableFilters = props.applicableFilters, activeOfferlistFilters = props.activeOfferlistFilters, onSort = props.onSort, currentSorting = props.currentSorting, sortOptions = props.sortOptions, className = props.className;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var toggleFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().toggleFilter;
    var ref = main_offerlist_filters_mobile_slicedToArray((0,react.useState)(false), 2), showFilters = ref[0], setShowFilters = ref[1];
    var closeHandler = function() {
        return setShowFilters(false);
    };
    var toggleHandler = function() {
        return setShowFilters(!showFilters);
    };
    var renderSortingRadios = function() {
        return sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.map(function(option) {
            /*#__PURE__*/ return react.createElement("div", {
                key: option.title
            }, /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
                onClickHandler: function() {
                    onSort === null || onSort === void 0 ? void 0 : onSort(option);
                },
                text: option.title,
                value: (option === null || option === void 0 ? void 0 : option.title) || sortOptions[0].title,
                selectedValue: currentSorting === null || currentSorting === void 0 ? void 0 : currentSorting.title
            }));
        });
    };
    var getSortFilter = function() {
        if (sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length) {
            return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("common", "sort.title")), /*#__PURE__*/ react.createElement("div", null, renderSortingRadios()));
        }
        return /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            flex: false,
            emphasis: variants.FontEmphasis.LOW,
            behavior: variants.Behavior.Oneline
        }, t("product", "sorting.sorted-by-cheapest-price"));
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: className
    }, /*#__PURE__*/ react.createElement(filter_toggle_button, {
        toggleHandler: toggleHandler,
        activeFilters: activeOfferlistFilters.length,
        title: t("filter", "filter.title"),
        icon: /*#__PURE__*/ react.createElement(sliders/* IconSliders */.O, null)
    }), showFilters && /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: showFilters,
        onRequestClose: closeHandler
    }, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(styles/* MobileWrapper */.nv, null, Boolean(sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length) && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(styles/* FilterRow */.TH, null, getSortFilter())), /*#__PURE__*/ react.createElement(all_filters/* AllFiltersLoader */.m, {
        filters: applicableFilters,
        onToggleFilter: toggleFilter
    })))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/index.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ 



var OfferListFilters = function(param) {
    var applicableFilters = param.applicableFilters, activeOfferlistFilters = param.activeOfferlistFilters, onSort = param.onSort, currentSorting = param.currentSorting, sortOptions = param.sortOptions;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(MainOfferlistFiltersMobile, {
        applicableFilters: applicableFilters,
        activeOfferlistFilters: activeOfferlistFilters,
        onSort: onSort,
        currentSorting: currentSorting,
        sortOptions: sortOptions
    })), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(MainOfferlistFiltersDropdown, {
        applicableFilters: applicableFilters,
        activeOfferlistFilters: activeOfferlistFilters
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/utils/price-list/applicable-filters.ts

var getApplicableFilters = function(filters, offers, allOffersWithActiveAdditives) {
    var hasAuthorizedInOffers = getHasAuthorizedInOffers(allOffersWithActiveAdditives);
    var hasInternationalOffers = getHasInternationalOffers(offers);
    var hasNotAvailableOffers = getHasNotAvailableOffers(offers);
    var updatedFilters = filters.filter(function(filter) {
        return (filter.type !== price_list_types/* FilterType.AUTHORIZED_DEALER */.vA.AUTHORIZED_DEALER || hasAuthorizedInOffers) && (filter.type !== price_list_types/* FilterType.INTERNATIONAL */.vA.INTERNATIONAL || hasInternationalOffers) && (filter.type !== price_list_types/* FilterType.NOT_FOR_SALE */.vA.NOT_FOR_SALE || hasNotAvailableOffers);
    });
    return updatedFilters;
};
var getHasAuthorizedInOffers = function(offers) {
    return offers.some(function(offer) {
        return offer.authorizedDealer;
    });
};
var getHasInternationalOffers = function(offers) {
    return offers.some(function(offer) {
        return !offer.primaryMarket || getHasInternationalAlternatives(offer);
    });
};
var getHasInternationalAlternatives = function(offer) {
    var _alternativePrices;
    var alternativeOffers = (_alternativePrices = offer.alternativePrices) !== null && _alternativePrices !== void 0 ? _alternativePrices : [];
    if (alternativeOffers.length === 0) {
        return false;
    }
    return alternativeOffers.some(function(altOffer) {
        return !altOffer.primaryMarket;
    });
};
var getHasNotAvailableOffers = function(offers) {
    return offers.some(function(offer) {
        var ref;
        return ((ref = offer.availability) === null || ref === void 0 ? void 0 : ref.condition) === "NotAvailableForOrder" || getHasNotAvailableAlternatives(offer);
    });
};
var getHasNotAvailableAlternatives = function(offer) {
    var _alternativePrices;
    var alternativeOffers = (_alternativePrices = offer.alternativePrices) !== null && _alternativePrices !== void 0 ? _alternativePrices : [];
    if (alternativeOffers.length === 0) {
        return false;
    }
    return alternativeOffers.some(function(altOffer) {
        var ref;
        return ((ref = altOffer.availability) === null || ref === void 0 ? void 0 : ref.condition) === "NotAvailableForOrder";
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/areas/product/components/onboarding-popover/styles.ts
function onboarding_popover_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function onboarding_popover_styles_templateObject() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    onboarding_popover_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function onboarding_popover_styles_templateObject1() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n      &::before {\n        bottom: -20px;\n        left: 50%;\n        transform: translateX(-50%) rotate(0deg);\n        border-top-color: ",
        ";\n      }\n    "
    ]);
    onboarding_popover_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function onboarding_popover_styles_templateObject2() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  background-color: ",
        ";\n  width: auto;\n  padding: ",
        ";\n  border: 1px solid rgba(5, 30, 46, 0.12);\n  border-radius: ",
        ";\n  z-index: 101;\n  bottom: 57px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    border: solid transparent;\n    border-width: 10px;\n  }\n\n  ",
        "\n"
    ]);
    onboarding_popover_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function onboarding_popover_styles_templateObject3() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -2px;\n  right: -1px;\n  border: none;\n  cursor: pointer;\n  padding: ",
        ";\n"
    ]);
    onboarding_popover_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  & button {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Container",
    componentId: "sc-0-0"
})(onboarding_popover_styles_templateObject());
var Background = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Background",
    componentId: "sc-0-1"
})(onboarding_popover_styles_templateObject2(), light_theme_colors.maybeBlue900, design_tokens.measurements.spacing075, design_tokens.measurements.spacing050, function(props) {
    return props.$arrowPosition === "bottom-middle" && (0,styled_components_browser_esm.css)(onboarding_popover_styles_templateObject1(), light_theme_colors.maybeBlue900);
});
var CloseButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-2"
})(onboarding_popover_styles_templateObject3(), design_tokens.measurements.spacing025);
var TextPopover = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextPopover",
    componentId: "sc-0-3"
})(styles_templateObject4());
var PopoverChildren = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PopoverChildren",
    componentId: "sc-0-4"
})(_templateObject5(), function(props) {
    return props.$isVisible ? "0 0 transparent, 0 0 0 1px rgba(5, 30, 46, 0.12), 0 0 0 2px rgba(0, 52, 81, 1)" : "none";
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(56853);
;// CONCATENATED MODULE: ./src/areas/product/components/onboarding-popover/index.tsx
function onboarding_popover_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function onboarding_popover_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function onboarding_popover_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function onboarding_popover_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function onboarding_popover_slicedToArray(arr, i) {
    return onboarding_popover_arrayWithHoles(arr) || onboarding_popover_iterableToArrayLimit(arr, i) || onboarding_popover_unsupportedIterableToArray(arr, i) || onboarding_popover_nonIterableRest();
}
function onboarding_popover_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return onboarding_popover_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return onboarding_popover_arrayLikeToArray(o, minLen);
}




var OnboardingPopoverExperiment = function(param) {
    var title = param.title, body = param.body, popoverFeature = param.children;
    var ref = onboarding_popover_slicedToArray((0,react.useState)(false), 2), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        var timer;
        var hasSeenOnboardingPopoverPP = localStorage.getItem("hasSeenOnboardingPopoverPP");
        if (!hasSeenOnboardingPopoverPP) {
            timer = setTimeout(function() {
                setIsVisible(true);
            }, 5000);
        } else {
            setIsVisible(false);
        }
        return function() {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);
    var handleClosePopover = function() {
        setIsVisible(false);
        localStorage.setItem("hasSeenOnboardingPopoverPP", "true");
    };
    return /*#__PURE__*/ react.createElement(Container, null, isVisible && /*#__PURE__*/ react.createElement(Background, {
        $arrowPosition: "bottom-middle"
    }, /*#__PURE__*/ react.createElement(TextPopover, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        color: variants.FontColor.LIGHT
    }, title), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        color: variants.FontColor.LIGHT,
        emphasis: variants.FontEmphasis.MEDIUM
    }, body)), /*#__PURE__*/ react.createElement(CloseButton, {
        onClick: handleClosePopover
    }, /*#__PURE__*/ react.createElement(icon_close.IconClose, {
        color: "base300"
    }))), /*#__PURE__*/ react.createElement(PopoverChildren, {
        onClick: handleClosePopover,
        $isVisible: isVisible
    }, popoverFeature));
};
/* harmony default export */ var onboarding_popover = (OnboardingPopoverExperiment);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/styles.ts
function price_list_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_list_styles_templateObject() {
    var data = price_list_styles_taggedTemplateLiteral([
        "\n      order: 3;\n    "
    ]);
    price_list_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function price_list_styles_templateObject1() {
    var data = price_list_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  border-bottom: none;\n\n  ",
        ";\n"
    ]);
    price_list_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function price_list_styles_templateObject2() {
    var data = price_list_styles_taggedTemplateLiteral([
        "\n  font-weight: 100;\n  font-size: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    price_list_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function price_list_styles_templateObject3() {
    var data = price_list_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    price_list_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function price_list_styles_templateObject4() {
    var data = price_list_styles_taggedTemplateLiteral([
        "\n    position: absolute;\n    width: calc(100vw - ",
        ");\n  "
    ]);
    price_list_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = price_list_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var AdvertTableRowElement = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AdvertTableRowElement",
    componentId: "sc-0-0"
})(price_list_styles_templateObject1(), function(p) {
    return p.withPosition && (0,styled_components_browser_esm.css)(price_list_styles_templateObject());
});
var TitleCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TitleCount",
    componentId: "sc-0-1"
})(price_list_styles_templateObject2(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var HeaderButtons = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeaderButtons",
    componentId: "sc-0-2"
})(price_list_styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var DisclaimerWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DisclaimerWrapper",
    componentId: "sc-0-3"
})(styles_templateObject5(), base/* media.smallOnly */.BC.smallOnly(price_list_styles_templateObject4(), (0,base/* remCalc */.vR)(base/* layout.pageContent.gutter.value */.bK.pageContent.gutter.value * 2)));

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/price-list-header.tsx
function price_list_header_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_list_header_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_list_header_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_list_header_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_list_header_slicedToArray(arr, i) {
    return price_list_header_arrayWithHoles(arr) || price_list_header_iterableToArrayLimit(arr, i) || price_list_header_unsupportedIterableToArray(arr, i) || price_list_header_nonIterableRest();
}
function price_list_header_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_list_header_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_list_header_arrayLikeToArray(o, minLen);
}



















var PriceListHeader = function(param) {
    var allOffers = param.allOffers, allOffersWithActiveAdditives = param.allOffersWithActiveAdditives, onSort = param.onSort, sorting = param.sorting;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilterByPlacement = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilterByPlacement;
    var ref = price_list_header_slicedToArray((0,react.useState)([]), 2), applicableFilters = ref[0], setApplicableFilters = ref[1];
    var ref1 = price_list_header_slicedToArray((0,react.useState)(false), 2), showShippingModal = ref1[0], setShowShippingModal = ref1[1];
    var filtersByPlacement = getFilterByPlacement(price_list_types/* FilterUIPlacementEnum.FILTER_MENU */.jm.FILTER_MENU);
    var sortOptions = (0,price_list_utils/* getSortOptions */.n)(t, allOffers);
    var currentSorting = sortOptions.length === 0 ? undefined : sortOptions.find(function(sort) {
        return sort.type === sorting;
    }) || sortOptions[0];
    (0,react.useEffect)(function() {
        var initializeFilters = function() {
            var updatedFilters = getApplicableFilters(filtersByPlacement, allOffers, allOffersWithActiveAdditives);
            setApplicableFilters(updatedFilters);
        };
        initializeFilters();
    }, [
        allOffers,
        allOffersWithActiveAdditives
    ]);
    var activeFiltersInFilterMenu = (filtersByPlacement === null || filtersByPlacement === void 0 ? void 0 : filtersByPlacement.filter(function(filter) {
        var isNotHidden = !!filter.hidden;
        var activeAdditive = !filter.active && filter.additive;
        var active = filter.active && !filter.additive;
        return isNotHidden && (active || activeAdditive);
    })) || [];
    var getSortFilter = function() {
        if (currentSorting) {
            return(// div needed to handle MediumUp children bug on mobile
            /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(onboarding_popover, {
                title: t("product", "onboarding-popover.title"),
                body: t("product", "onboarding-popover.body")
            }, /*#__PURE__*/ react.createElement(filter_dropdown/* FilterDropdown */.M, {
                alignment: ui/* Direction.Right */.Nm.Right,
                defaultSelected: currentSorting,
                options: sortOptions,
                onFilterChange: function(option) {
                    return onSort(option);
                }
            }))));
        }
        return /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            flex: false,
            emphasis: variants.FontEmphasis.LOW,
            behavior: variants.Behavior.Oneline
        }, t("product", "sorting.sorted-by-cheapest-price"));
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(PanelHeader, null, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(HeaderButtons, null, /*#__PURE__*/ react.createElement(OfferListFilters, {
        applicableFilters: applicableFilters,
        activeOfferlistFilters: activeFiltersInFilterMenu,
        onSort: onSort,
        currentSorting: currentSorting,
        sortOptions: sortOptions
    }), /*#__PURE__*/ react.createElement(HeaderFilters, {
        allOffersWithActiveAdditives: allOffersWithActiveAdditives,
        applicableFilters: applicableFilters,
        setShowShippingModal: setShowShippingModal
    })), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, getSortFilter()))), showShippingModal && /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: showShippingModal,
        onRequestClose: function() {
            return setShowShippingModal(false);
        }
    }, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(styles/* MobileWrapper */.nv, null, /*#__PURE__*/ react.createElement(shipping_filters/* ShippingFilters */.O, null)))));
};

// EXTERNAL MODULE: ./src/components/filter-dropdown/types.ts
var filter_dropdown_types = __webpack_require__(18557);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/globals/tracking/expand.ts

var trackExpandEvent = function(data) {
    (0,data_layer/* pushEvent */.A)("component_expand", {
        scope: data.scope
    });
};
var TrackExpandScope;
(function(TrackExpandScope) {
    TrackExpandScope["PRICE_LIST"] = "product_price_list";
})(TrackExpandScope || (TrackExpandScope = {}));

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/price-list-footer.tsx





var ShowMoreButton = function(props) {
    var offersCount = props.offersCount, showMorePrices = props.showMorePrices, numberOfVisiblePrices = props.numberOfVisiblePrices, setShowMorePrices = props.setShowMorePrices;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var showMorePricesLabel = "".concat(t("product", "prices.show-more-prices-button"), " (+").concat(offersCount - numberOfVisiblePrices, ")");
    var handleOnClick = function() {
        setShowMorePrices(true);
        trackExpandEvent({
            scope: TrackExpandScope.PRICE_LIST
        });
    };
    return /*#__PURE__*/ react.createElement("div", null, !showMorePrices && offersCount > numberOfVisiblePrices && /*#__PURE__*/ react.createElement(react.Fragment, null, isMobile ? /*#__PURE__*/ react.createElement(button_variants.PrimaryButton, {
        onClick: handleOnClick,
        style: {
            margin: "0 auto"
        },
        fullWidth: true
    }, showMorePricesLabel) : /*#__PURE__*/ react.createElement(button_variants.TonalButton, {
        onClick: handleOnClick,
        style: {
            margin: "0 auto"
        }
    }, showMorePricesLabel)));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/trending-down/index.js
var trending_down = __webpack_require__(47418);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/condition-type-badge/index.tsx + 1 modules
var condition_type_badge = __webpack_require__(21217);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/go-to-store-button/index.tsx + 1 modules
var go_to_store_button = __webpack_require__(97157);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/price-row-content/styles.ts
var price_row_content_styles = __webpack_require__(74027);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33561);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/variants.js
var card_variants = __webpack_require__(77243);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(75695);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/row-types/styles.ts
var row_types_styles = __webpack_require__(33900);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/collapsed-offers-placeholder/styles.ts
function collapsed_offers_placeholder_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function collapsed_offers_placeholder_styles_templateObject() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    collapsed_offers_placeholder_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject1() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n    margin-bottom: ",
        ";\n\n    ",
        "\n  "
    ]);
    collapsed_offers_placeholder_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject2() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n      padding: ",
        " 0 ",
        " ",
        ";\n    "
    ]);
    collapsed_offers_placeholder_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject3() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n      padding-left: ",
        ";\n    "
    ]);
    collapsed_offers_placeholder_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject4() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  && {\n    flex: 1;\n    cursor: pointer;\n    gap: ",
        ";\n    padding: ",
        " 0;\n    padding-left: ",
        ";\n    height: ",
        ";\n\n    ",
        "\n\n    ",
        "\n  }\n\n  &.focus-visible {\n    outline: 2px solid ",
        ";\n    border-radius: ",
        ";\n  }\n"
    ]);
    collapsed_offers_placeholder_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject5() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n"
    ]);
    collapsed_offers_placeholder_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: initial;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-items: flex-end;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n  font-size: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  visibility: hidden;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  border-radius: 50%;\n  background-color: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}







var StyledRowCard = (0,styled_components_browser_esm["default"])(card_variants/* RowCard */.Jz).withConfig({
    displayName: "StyledRowCard",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(collapsed_offers_placeholder_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, !props.$emphasized && (0,styled_components_browser_esm.css)(collapsed_offers_placeholder_styles_templateObject(), props.theme.colors.base100));
});
var StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-1"
})(collapsed_offers_placeholder_styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, row_types_styles/* ROW_HEIGHT */.dN, base/* media.mediumOnly */.BC.mediumOnly(collapsed_offers_placeholder_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150), base/* media.smallOnly */.BC.smallOnly(collapsed_offers_placeholder_styles_templateObject3(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075), function(props) {
    return props.theme.colors.maybeBlue300;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContentWrapper",
    componentId: "sc-0-2"
})(collapsed_offers_placeholder_styles_templateObject5());
var StyledFirstWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFirstWrapper",
    componentId: "sc-0-3"
})(_templateObject6());
var StyledSecondWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSecondWrapper",
    componentId: "sc-0-4"
})(_templateObject7());
var StyledBodyText = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "StyledBodyText",
    componentId: "sc-0-5"
})(_templateObject8());
var StyledPriceLabel = (0,styled_components_browser_esm["default"])(price_label/* PriceLabel */.l).withConfig({
    displayName: "StyledPriceLabel",
    componentId: "sc-0-6"
})(_templateObject9(), row_types_styles/* PRICE_LABEL_SIZE */.j8);
var StyledCTAPlaceholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledCTAPlaceholder",
    componentId: "sc-0-7"
})(_templateObject10());
var StyledPriceWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPriceWrapper",
    componentId: "sc-0-8"
})(_templateObject11(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledDealsIcon = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDealsIcon",
    componentId: "sc-0-9"
})(_templateObject12(), function(props) {
    return props.theme.colors.informative100;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/collapsed-offers-placeholder/index.tsx












var CollapsedOffersPlaceholder = function(props) {
    var data = props.data, onClick = props.onClick;
    var title = data.title, count = data.count, cheapestOffer = data.cheapestOffer, hasDealOffers = data.hasDealOffers, ariaLabel = data.ariaLabel, emphasized = data.emphasized;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var viewport = (0,context/* useViewportContext */.Ak)();
    var viewSize = (0,common/* getViewSize */.a0)(viewport);
    return /*#__PURE__*/ react.createElement(StyledRowCard, {
        outlined: true,
        $emphasized: emphasized
    }, /*#__PURE__*/ react.createElement(StyledCardActionArea, {
        containerProps: {
            onClick: function() {
                return onClick(product.id);
            },
            role: "button",
            "aria-label": ariaLabel
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledContentWrapper, null, /*#__PURE__*/ react.createElement(StyledFirstWrapper, null, /*#__PURE__*/ react.createElement(variants.CaptionText, null, t("common", "items.show-count", {
        count: count
    })), /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, title)), /*#__PURE__*/ react.createElement(StyledSecondWrapper, null, cheapestOffer.condition && /*#__PURE__*/ react.createElement(condition_type_badge/* ConditionTypeBadge */.b, {
        condition: cheapestOffer.condition
    }), cheapestOffer.price && /*#__PURE__*/ react.createElement(StyledPriceWrapper, null, hasDealOffers && /*#__PURE__*/ react.createElement(StyledDealsIcon, null, /*#__PURE__*/ react.createElement(trending_down/* IconTrendingDown */.j, {
        color: "maybeBlue700",
        size: 16
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledBodyText, {
        emphasis: emphasized ? ui_text.FontEmphasis.HIGH : ui_text.FontEmphasis.LOW
    }, t("product", "price.from-abbr"), " "), /*#__PURE__*/ react.createElement(StyledPriceLabel, {
        emphasis: emphasized ? ui_text.FontEmphasis.HIGH : ui_text.FontEmphasis.LOW,
        value: cheapestOffer.price.exclShipping,
        weight: ui_text.FontWeight.HEAVIEST
    }))))), /*#__PURE__*/ react.createElement(StyledCTAPlaceholder, null, /*#__PURE__*/ react.createElement(price_row_content_styles/* StyledEndColumn */.Y, {
        $featured: true,
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(go_to_store_button/* GoToStoreButton */.a, {
        viewSize: viewSize
    }))))));
};

// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/types.ts
var product_condition_types = __webpack_require__(60205);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/components/used-placeholders.tsx
function used_placeholders_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function used_placeholders_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return used_placeholders_arrayLikeToArray(arr);
}
function used_placeholders_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function used_placeholders_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function used_placeholders_toConsumableArray(arr) {
    return used_placeholders_arrayWithoutHoles(arr) || used_placeholders_iterableToArray(arr) || used_placeholders_unsupportedIterableToArray(arr) || used_placeholders_nonIterableSpread();
}
function used_placeholders_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return used_placeholders_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return used_placeholders_arrayLikeToArray(o, minLen);
}




var isUsedOffer = function(offer) {
    return offer.condition !== product_condition_types/* ConditionEnum.NEW */.M.NEW;
};
var isNewOffer = function(offer) {
    return offer.condition === product_condition_types/* ConditionEnum.NEW */.M.NEW;
};
var getUsedPlaceHolderData = function(offers, collapseUnfeatured, unfeaturedPlaceholderData, t) {
    // Filter out other offers that will be collapsed
    var filteredOffers = collapseUnfeatured ? offers.filter(isFeaturedOffer) : offers;
    var candidateOffers = filteredOffers.filter(isUsedOffer);
    var cheapestUsedOffer = candidateOffers[0];
    var shouldBeAfterUnfeaturedPlaceholder = function() {
        if (!collapseUnfeatured || !(unfeaturedPlaceholderData === null || unfeaturedPlaceholderData === void 0 ? void 0 : unfeaturedPlaceholderData.cheapestOffer) || !cheapestUsedOffer) {
            return false;
        }
        // Compare original indexes for cheapest offers in Unfeatured vs Used placeholders
        var firstUnfeaturedOfferOriginalIndex = offers.findIndex(function(offer) {
            var ref, ref1;
            return ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id) === ((ref1 = unfeaturedPlaceholderData.cheapestOffer.store) === null || ref1 === void 0 ? void 0 : ref1.id) && offer.shopOfferId === unfeaturedPlaceholderData.cheapestOffer.shopOfferId;
        });
        var firstUsedOriginalIndex = offers.findIndex(function(offer) {
            var ref, ref1;
            return ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id) === ((ref1 = cheapestUsedOffer.store) === null || ref1 === void 0 ? void 0 : ref1.id) && offer.shopOfferId === cheapestUsedOffer.shopOfferId;
        });
        return firstUnfeaturedOfferOriginalIndex < firstUsedOriginalIndex;
    };
    var position = filteredOffers.findIndex(isUsedOffer);
    if (shouldBeAfterUnfeaturedPlaceholder()) {
        position += 1;
    }
    return candidateOffers.length > 0 ? {
        title: t("product", "title.used-products", {
            n: candidateOffers.length
        }),
        count: candidateOffers.length,
        position: position,
        cheapestOffer: cheapestUsedOffer,
        hasDealOffers: false,
        ariaLabel: t("product", "price-list.used-placeholder-show-all"),
        emphasized: true
    } : undefined;
};
var insertUsedPlaceholder = function(offerRows, setUserHasExpandedUsed, placeholderData) {
    // If index in offer list for placeholder is more than offerRows.length,
    // the placeholder should not be visible.
    // This occurs when offerRows are sliced by numberOfVisiblePrices.
    if (!placeholderData || (placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position) > offerRows.length) return offerRows;
    return used_placeholders_toConsumableArray(offerRows.slice(0, placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position)).concat([
        /*#__PURE__*/ react.createElement(CollapsedOffersPlaceholder, {
            key: "used-placeholder-card",
            data: placeholderData,
            onClick: function() {
                setUserHasExpandedUsed(true);
            }
        })
    ], used_placeholders_toConsumableArray(offerRows.slice(placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position)));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/components/unfeatured-placeholders.tsx
function unfeatured_placeholders_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function unfeatured_placeholders_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return unfeatured_placeholders_arrayLikeToArray(arr);
}
function unfeatured_placeholders_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function unfeatured_placeholders_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function unfeatured_placeholders_toConsumableArray(arr) {
    return unfeatured_placeholders_arrayWithoutHoles(arr) || unfeatured_placeholders_iterableToArray(arr) || unfeatured_placeholders_unsupportedIterableToArray(arr) || unfeatured_placeholders_nonIterableSpread();
}
function unfeatured_placeholders_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return unfeatured_placeholders_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return unfeatured_placeholders_arrayLikeToArray(o, minLen);
}



var isUnfeaturedOffer = function(offer) {
    return !offer.featured;
};
var isFeaturedOffer = function(offer) {
    return offer.featured;
};
var getUnfeaturedPlaceHolderData = function(offers, collapseUsed, t) {
    // Filter out other offers that will be collapsed
    var filteredOffers = collapseUsed ? offers.filter(isNewOffer) : offers;
    var firstOfferIndex = filteredOffers.findIndex(isUnfeaturedOffer);
    var candidateOffers = filteredOffers.filter(isUnfeaturedOffer);
    var hasDealOffers = candidateOffers.some(function(offer) {
        return offer.dealOffers.some(function(deal) {
            return deal.shopOfferId === offer.shopOfferId;
        });
    });
    return candidateOffers.length > 0 ? {
        title: t("product", "title.unfeatured-products", {
            n: candidateOffers.length
        }),
        count: candidateOffers.length,
        position: firstOfferIndex,
        cheapestOffer: filteredOffers[firstOfferIndex],
        hasDealOffers: hasDealOffers,
        ariaLabel: t("product", "price-list.unfeatured-placeholder-show-all"),
        emphasized: false
    } : undefined;
};
var insertUnfeaturedPlaceholder = function(offerRows, setUserHasExpandedUnfeatured, placeholderData) {
    // If index in offer list for unfeatured placeholder is more than offerRows.length,
    // the placeholder should not be visible.
    // This occurs when offerRows are sliced by numberOfVisiblePrices.
    if (!placeholderData || (placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position) > offerRows.length) return offerRows;
    return unfeatured_placeholders_toConsumableArray(offerRows.slice(0, placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position)).concat([
        /*#__PURE__*/ react.createElement(CollapsedOffersPlaceholder, {
            key: "unfeatured-placeholder-card",
            data: placeholderData,
            onClick: function() {
                setUserHasExpandedUnfeatured(true);
            }
        })
    ], unfeatured_placeholders_toConsumableArray(offerRows.slice(placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position)));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/utils/index.ts
function price_list_panel_utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function utils_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return price_list_panel_utils_arrayLikeToArray(arr);
}
function utils_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function utils_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function utils_toConsumableArray(arr) {
    return utils_arrayWithoutHoles(arr) || utils_iterableToArray(arr) || price_list_panel_utils_unsupportedIterableToArray(arr) || utils_nonIterableSpread();
}
function price_list_panel_utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_list_panel_utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_list_panel_utils_arrayLikeToArray(o, minLen);
}


var filterOutCollapsedOffers = function(offers, collapseUnfeatured, collapseUsed) {
    var filteredOffers = utils_toConsumableArray(offers);
    var filteredOnUnfeatured = collapseUnfeatured ? filteredOffers.filter(isFeaturedOffer) : filteredOffers;
    var filterOnUsed = collapseUsed ? filteredOnUnfeatured.filter(isNewOffer) : filteredOnUnfeatured;
    return filterOnUsed;
};
var getExpandUsedFromQuerystring = function(location) {
    var ref;
    var searchParams = new URLSearchParams(location.search);
    var expandedFromQuery = ((ref = searchParams.get("expand")) === null || ref === void 0 ? void 0 : ref.split(",")) || [];
    return expandedFromQuery.includes("used");
};
var getExpandUnfeaturedByDefault = function(offers) {
    return offers.every(function(offer) {
        return isUnfeaturedOffer(offer) && isNewOffer(offer);
    }) && offers.length >= 1;
};
var getExpandOffersFromQueryString = function(location) {
    var ref;
    var searchParams = new URLSearchParams(location.search);
    var expandedFromQuery = ((ref = searchParams.get("expand")) === null || ref === void 0 ? void 0 : ref.split(",")) || [];
    return expandedFromQuery.includes("offers");
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/styles.ts
function price_list_panel_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_list_panel_styles_templateObject() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n  padding: 0;\n  margin-top: ",
        ";\n  list-style: none;\n\n  > li:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    price_list_panel_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function price_list_panel_styles_templateObject1() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    price_list_panel_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function price_list_panel_styles_templateObject2() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    overflow-x: auto;\n    position: relative;\n    padding: ",
        ";\n    left: -",
        ";\n    width: calc(100% + ",
        ");\n    padding-bottom: 0;\n  "
    ]);
    price_list_panel_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function price_list_panel_styles_templateObject3() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    price_list_panel_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function price_list_panel_styles_templateObject4() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n    flex-wrap: wrap;\n  "
    ]);
    price_list_panel_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function price_list_panel_styles_templateObject5() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n    > li:last-child { padding-right: ",
        " }\n  "
    ]);
    price_list_panel_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  list-style: none;\n  margin: 0;\n  gap: ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  padding-bottom: 2px;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var PriceList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "PriceList",
    componentId: "sc-0-0"
})(price_list_panel_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var HeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeaderWrapper",
    componentId: "sc-0-1"
})(price_list_panel_styles_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ScrollingChipList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ScrollingChipList",
    componentId: "sc-0-2"
})(price_list_panel_styles_templateObject3(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* media.smallOnly */.BC.smallOnly(price_list_panel_styles_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var ScrollingChipListWrapper = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "ScrollingChipListWrapper",
    componentId: "sc-0-3"
})(styles_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumUp */.BC.mediumUp(price_list_panel_styles_templateObject4()), base/* media.smallOnly */.BC.smallOnly(price_list_panel_styles_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var StyledChip = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledChip",
    componentId: "sc-0-4"
})(styles_templateObject7());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/price-list-body.tsx
function price_list_body_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_list_body_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_list_body_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_list_body_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_list_body_slicedToArray(arr, i) {
    return price_list_body_arrayWithHoles(arr) || price_list_body_iterableToArrayLimit(arr, i) || price_list_body_unsupportedIterableToArray(arr, i) || price_list_body_nonIterableRest();
}
function price_list_body_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_list_body_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_list_body_arrayLikeToArray(o, minLen);
}















var PriceListBody = function(props) {
    var sortedPrices = props.sortedPrices, numberOfVisiblePrices = props.numberOfVisiblePrices, campaign = props.campaign, isPrimaryList = props.isPrimaryList, _currentSorting = props.currentSorting, currentSorting = _currentSorting === void 0 ? filter_dropdown_types/* OptionTypeEnum.CHEAPEST_PRICE */.M.CHEAPEST_PRICE : _currentSorting, ourChoiceStoreId = props.ourChoiceStoreId, userHasExpandedUnfeatured = props.userHasExpandedUnfeatured, userHasExpandedUsed = props.userHasExpandedUsed, setUserHasExpandedUnfeatured = props.setUserHasExpandedUnfeatured, setUserHasExpandedUsed = props.setUserHasExpandedUsed;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var viewport = (0,context/* useViewportContext */.Ak)();
    var location = (0,react_router/* useLocation */.TH)();
    var nbrOfPlaceholders = 0;
    var ref = price_list_body_slicedToArray((0,react.useState)(getExpandOffersFromQueryString(location)), 2), showMorePrices = ref[0], setShowMorePrices = ref[1];
    // Decide if we should collapse unfeatured offers and show placeholder
    var unfeaturedPlaceholderData = getUnfeaturedPlaceHolderData(sortedPrices, !userHasExpandedUsed, t);
    var collapseUnfeaturedOffers = !userHasExpandedUnfeatured && Boolean(unfeaturedPlaceholderData);
    // Decide if we should collapse used offers and show placeholder
    var usedPlaceHolderData = getUsedPlaceHolderData(sortedPrices, collapseUnfeaturedOffers, unfeaturedPlaceholderData, t);
    var collapseUsedOffers = !userHasExpandedUsed && Boolean(usedPlaceHolderData);
    if (!sortedPrices || sortedPrices.length === 0) {
        return null;
    }
    // Filter out offers that should be hidden in placeholders
    var offers = filterOutCollapsedOffers(sortedPrices, collapseUnfeaturedOffers, collapseUsedOffers);
    // Create price rows
    var priceRows = offers.map(function(item, index) {
        var ref, ref1;
        var rowKey = "".concat((ref = item.store) === null || ref === void 0 ? void 0 : ref.id, "-").concat(index);
        var offer = (0,price_list_utils/* createOfferFromPriceItem */.J)(item);
        return /*#__PURE__*/ react.createElement(price_row_context/* PriceRowContextContainer */.B, {
            key: rowKey,
            campaign: campaign,
            offer: offer,
            product: product,
            sorting: currentSorting,
            collapseUnfeaturedFn: function() {
                return setUserHasExpandedUnfeatured(false);
            },
            showUsedOffers: userHasExpandedUsed && Boolean(usedPlaceHolderData),
            viewSize: (0,common/* getViewSize */.a0)(viewport),
            isOurChoice: ((ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.id) === ourChoiceStoreId,
            isInPriceList: true
        }, /*#__PURE__*/ react.createElement(row_types/* PriceRow */.a, {
            trackingItem: item
        }));
    });
    // Insert collapsed unfeatured offers placeholder
    if (collapseUnfeaturedOffers) {
        priceRows = insertUnfeaturedPlaceholder(priceRows, setUserHasExpandedUnfeatured, unfeaturedPlaceholderData);
        nbrOfPlaceholders += 1;
    }
    // Insert collapsed used offers placeholder
    if (collapseUsedOffers) {
        priceRows = insertUsedPlaceholder(priceRows, setUserHasExpandedUsed, usedPlaceHolderData);
        nbrOfPlaceholders += 1;
    }
    // Limit number of visible prices
    priceRows = priceRows.slice(0, showMorePrices ? undefined : numberOfVisiblePrices);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(PriceList, {
        "data-testid": isPrimaryList ? "primary-price-list" : "secondary-price-list"
    }, priceRows.map(function(row) {
        return /*#__PURE__*/ react.createElement("li", {
            key: row.key
        }, row);
    })), /*#__PURE__*/ react.createElement(ShowMoreButton, {
        offersCount: offers.length,
        showMorePrices: showMorePrices,
        numberOfVisiblePrices: numberOfVisiblePrices - nbrOfPlaceholders,
        setShowMorePrices: setShowMorePrices
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/utils/price-list/sort-by-fastest-delivery.ts
function sort_by_fastest_delivery_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function sort_by_fastest_delivery_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return sort_by_fastest_delivery_arrayLikeToArray(arr);
}
function sort_by_fastest_delivery_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sort_by_fastest_delivery_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function sort_by_fastest_delivery_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sort_by_fastest_delivery_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sort_by_fastest_delivery_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sort_by_fastest_delivery_toConsumableArray(arr) {
    return sort_by_fastest_delivery_arrayWithoutHoles(arr) || sort_by_fastest_delivery_iterableToArray(arr) || sort_by_fastest_delivery_unsupportedIterableToArray(arr) || sort_by_fastest_delivery_nonIterableSpread();
}
function sort_by_fastest_delivery_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sort_by_fastest_delivery_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sort_by_fastest_delivery_arrayLikeToArray(o, minLen);
}


var placeAfter = 1;
var placeBefore = -1;
var sortDownloadable = function(a, b) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (((ref = a.availability) === null || ref === void 0 ? void 0 : ref.condition) === "Download" && ((ref1 = b.availability) === null || ref1 === void 0 ? void 0 : ref1.condition) === "Download") return 0;
    if (((ref2 = a.availability) === null || ref2 === void 0 ? void 0 : ref2.condition) === "Download" && ((ref3 = b.availability) === null || ref3 === void 0 ? void 0 : ref3.condition) !== "Download") return placeBefore;
    if (((ref4 = a.availability) === null || ref4 === void 0 ? void 0 : ref4.condition) !== "Download" && ((ref5 = b.availability) === null || ref5 === void 0 ? void 0 : ref5.condition) === "Download") return placeAfter;
    return 0;
};
var sortFeatured = function(a, b) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (!("store" in a) || !("store" in b)) return 0;
    if (((ref = a.store) === null || ref === void 0 ? void 0 : ref.featured) && ((ref1 = b.store) === null || ref1 === void 0 ? void 0 : ref1.featured)) return 0;
    if (((ref2 = a.store) === null || ref2 === void 0 ? void 0 : ref2.featured) && !((ref3 = b.store) === null || ref3 === void 0 ? void 0 : ref3.featured)) return placeBefore;
    if (!((ref4 = a.store) === null || ref4 === void 0 ? void 0 : ref4.featured) && ((ref5 = b.store) === null || ref5 === void 0 ? void 0 : ref5.featured)) return placeAfter;
    return 0;
};
var sortStockStatus = function(a, b) {
    var ref, ref1;
    var ref2;
    var aStockStatus = getNumericSortStock((ref2 = (ref = a.stock) === null || ref === void 0 ? void 0 : ref.status) !== null && ref2 !== void 0 ? ref2 : undefined);
    var ref3;
    var bStockStatus = getNumericSortStock((ref3 = (ref1 = b.stock) === null || ref1 === void 0 ? void 0 : ref1.status) !== null && ref3 !== void 0 ? ref3 : undefined);
    return aStockStatus - bStockStatus;
};
var getNumericSortStock = function(stockStatus) {
    switch(stockStatus){
        case "in_stock":
            return 1;
        case "in_stock_preorder":
            return 2;
        case "incoming":
            return 3;
        case "not_in_stock":
            return 4;
        case "unknown":
            return 5;
        default:
            return 6;
    }
};
var sortShipping = function(a, b) {
    var ref, ref1, ref2, ref3;
    var ref4;
    var s1 = (ref4 = (ref = a.shipping) === null || ref === void 0 ? void 0 : (ref1 = ref.fastest) === null || ref1 === void 0 ? void 0 : ref1.deliveryDays) !== null && ref4 !== void 0 ? ref4 : null;
    var ref5;
    var s2 = (ref5 = (ref2 = b.shipping) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fastest) === null || ref3 === void 0 ? void 0 : ref3.deliveryDays) !== null && ref5 !== void 0 ? ref5 : null;
    if (s1 === null && s2 !== null) return placeAfter;
    if (s1 !== null && s2 === null) return placeBefore;
    if (s1 === null && s2 === null) return 0;
    if (s1.min !== s2.min) {
        return s1.min - s2.min;
    }
    return s1.max - s2.max;
};
var sortAvailability = function(a, b) {
    var ref, ref1, ref2, ref3;
    var aDate = ((ref = a.availability) === null || ref === void 0 ? void 0 : ref.availabilityDate) ? new Date((ref1 = a.availability) === null || ref1 === void 0 ? void 0 : ref1.availabilityDate) : null;
    var bDate = ((ref2 = b.availability) === null || ref2 === void 0 ? void 0 : ref2.availabilityDate) ? new Date((ref3 = b.availability) === null || ref3 === void 0 ? void 0 : ref3.availabilityDate) : null;
    if (aDate === null && bDate !== null) return placeAfter;
    if (aDate !== null && bDate === null) return placeBefore;
    if (aDate === null || bDate === null) return 0;
    return aDate.getTime() - bDate.getTime();
};
var sortByFastest = function(offerList, filters) {
    var isAlternative = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (offerList.length <= 0) {
        return offerList;
    }
    var sortedOffersAndAlternatives = sort_by_fastest_delivery_toConsumableArray(offerList);
    sortedOffersAndAlternatives.sort(function(a, b) {
        var downloadableSort = sortDownloadable(a, b);
        if (downloadableSort) {
            return downloadableSort;
        }
        var featuredSort = sortFeatured(a, b);
        if (featuredSort && !isAlternative) {
            return featuredSort;
        }
        var stockStatusSort = sortStockStatus(a, b);
        if (stockStatusSort) {
            return stockStatusSort;
        }
        var shippingSort = sortShipping(a, b);
        if (shippingSort) {
            return shippingSort;
        }
        var availabilitySort = sortAvailability(a, b);
        if (availabilitySort) {
            return availabilitySort;
        }
        return 0;
    });
    return sortedOffersAndAlternatives;
};
var sortAlternativePricesByFastestDelivery = function(offer, filters) {
    var altOffers = offer.alternativePrices ? sort_by_fastest_delivery_toConsumableArray(offer.alternativePrices) : [];
    if (!altOffers.length) return offer.alternativePrices;
    return sortByFastest(altOffers, filters, true);
};
var sortByFastestDelivery = function(offerList, currentSorting) {
    var filters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var newOffers = sort_by_fastest_delivery_objectSpread({}, offerList);
    if (currentSorting === filter_dropdown_types/* OptionTypeEnum.FASTEST_DELIVERY */.M.FASTEST_DELIVERY) {
        newOffers.mainList = sortByFastest(sort_by_fastest_delivery_toConsumableArray(newOffers.mainList), filters);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newOffers.mainList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var offer = _step.value;
                offer.alternativePrices = sortAlternativePricesByFastestDelivery(offer, filters);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        newOffers.mainList = newOffers.mainList.map(function(offer) {
            var ref;
            return (0,common/* replaceMainOfferWithAlternativeOffer */.Ot)(offer, (ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref[0]);
        });
    }
    return newOffers;
};

// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(33944);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/types.ts
var product_alert_form_types = __webpack_require__(14236);
// EXTERNAL MODULE: ./src/components/modal/login-promo.js + 1 modules
var login_promo = __webpack_require__(60428);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(73426);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/styles.ts
var offer_list_empty_message_styles = __webpack_require__(75408);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/stock-status-alert-modal.tsx
function stock_status_alert_modal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function stock_status_alert_modal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function stock_status_alert_modal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function stock_status_alert_modal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function stock_status_alert_modal_slicedToArray(arr, i) {
    return stock_status_alert_modal_arrayWithHoles(arr) || stock_status_alert_modal_iterableToArrayLimit(arr, i) || stock_status_alert_modal_unsupportedIterableToArray(arr, i) || stock_status_alert_modal_nonIterableRest();
}
function stock_status_alert_modal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return stock_status_alert_modal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return stock_status_alert_modal_arrayLikeToArray(o, minLen);
}










var StockStatusAlertModal = function(props) {
    var closeModal = props.closeModal, isOpen = props.isOpen, onSubmit = props.onSubmit;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var ref = stock_status_alert_modal_slicedToArray((0,react.useState)(""), 2), email = ref[0], setEmail = ref[1];
    var ref1 = stock_status_alert_modal_slicedToArray((0,react.useState)(undefined), 2), error = ref1[0], setError = ref1[1];
    var errorState = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.productAlert.error;
    });
    var successState = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.productAlert.success;
    });
    (0,react.useEffect)(function() {
        if (errorState) {
            switch(errorState){
                case product_alert_form_types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID:
                case product_alert_form_types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE:
                    {
                        setError(errorState);
                        break;
                    }
                default:
                    {
                        setError(product_alert_form_types/* Errors.ERROR_UNKNOWN */.D1.ERROR_UNKNOWN);
                    }
            }
        } else if (successState) {
            setEmail("");
            setError(undefined);
            closeModal();
        }
    }, [
        errorState,
        successState
    ]);
    if (!isAuthenticated) {
        return isOpen && /*#__PURE__*/ react.createElement(login_promo/* default */.Z, {
            isOpen: isOpen,
            onRequestClose: closeModal
        });
    }
    return /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        title: t("product", "alert.stock-status-alert-email")
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(offer_list_empty_message_styles/* StyledModalBody */.iE, {
        $noPadding: isAuthenticated
    }, /*#__PURE__*/ react.createElement("form", {
        id: "stock-status-alert-form",
        method: "post",
        onSubmit: function(event) {
            return onSubmit(event, email, setError);
        },
        noValidate: true
    })), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(button_variants.PrimaryButton, {
        disabled: Boolean(error),
        htmlType: "submit",
        fullWidth: true,
        containerProps: {
            form: "stock-status-alert-form"
        }
    }, t("product", "alert.create-stock-status-alert")))));
};

// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(19590);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/prompt-message.tsx






var PromptMessage = function(param) {
    var message = param.message;
    var market = (0,app_context/* useAppContext */.bp)().market;
    return /*#__PURE__*/ react.createElement(offer_list_empty_message_styles/* MessageWrapper */.e5, {
        $elevated: true
    }, /*#__PURE__*/ react.createElement("img", {
        alt: "no offers",
        src: "".concat(market.cdn, "/g/rfe/illustrations/no-offers-illustration_112x112.png")
    }), /*#__PURE__*/ react.createElement(offer_list_empty_message_styles/* MessageGroup */.dm, null, /*#__PURE__*/ react.createElement(offer_list_empty_message_styles/* Message */.v0, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, message.message)), message.showButton && /*#__PURE__*/ react.createElement(button_variants.PrimaryButton, {
        onClick: function() {
            return message.buttonOnClick();
        }
    }, message.iconPosition === "left" && /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, message.icon), message.buttonText, message.iconPosition === "right" && /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, message.icon))));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/info-message.tsx
var info_message = __webpack_require__(18126);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(50999);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/index.tsx
function offer_list_empty_message_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function offer_list_empty_message_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function offer_list_empty_message_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return offer_list_empty_message_arrayLikeToArray(arr);
}
function offer_list_empty_message_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function offer_list_empty_message_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function offer_list_empty_message_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function offer_list_empty_message_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function offer_list_empty_message_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function offer_list_empty_message_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            offer_list_empty_message_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function offer_list_empty_message_slicedToArray(arr, i) {
    return offer_list_empty_message_arrayWithHoles(arr) || offer_list_empty_message_iterableToArrayLimit(arr, i) || offer_list_empty_message_unsupportedIterableToArray(arr, i) || offer_list_empty_message_nonIterableRest();
}
function offer_list_empty_message_toConsumableArray(arr) {
    return offer_list_empty_message_arrayWithoutHoles(arr) || offer_list_empty_message_iterableToArray(arr) || offer_list_empty_message_unsupportedIterableToArray(arr) || offer_list_empty_message_nonIterableSpread();
}
function offer_list_empty_message_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return offer_list_empty_message_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return offer_list_empty_message_arrayLikeToArray(o, minLen);
}
















var PromptMessageEnum;
(function(PromptMessageEnum) {
    PromptMessageEnum["outOfStock"] = "outOfStock";
    PromptMessageEnum["noOffers"] = "noOffers";
    PromptMessageEnum["noFeaturedSellsProduct"] = "noFeaturedSellsProduct";
})(PromptMessageEnum || (PromptMessageEnum = {}));
var InfoMessageEnum;
(function(InfoMessageEnum) {
    InfoMessageEnum["noFiltersMatch"] = "noFiltersMatch";
    InfoMessageEnum["noInfoOnDelivery"] = "noInfoOnDelivery";
    InfoMessageEnum["outOfStock"] = "outOfStock";
})(InfoMessageEnum || (InfoMessageEnum = {}));
var OfferListEmptyMessage = function(param) {
    var offers = param.offers;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var ref1 = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), filtersToggledOnByUser = ref1.filtersToggledOnByUser, resetFilters = ref1.resetFilters, toggleFilter = ref1.toggleFilter;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var ref2;
    var userProductAlerts = (ref2 = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.alerts.products;
    })) !== null && ref2 !== void 0 ? ref2 : [];
    var filtersToggled = filtersToggledOnByUser();
    var ref3 = offer_list_empty_message_slicedToArray((0,react.useState)(false), 2), modalOpen = ref3[0], setModalOpen = ref3[1];
    var ref4 = offer_list_empty_message_slicedToArray((0,react.useState)(), 2), prompt = ref4[0], setPrompt = ref4[1];
    var ref5 = offer_list_empty_message_slicedToArray((0,react.useState)(null), 2), message = ref5[0], setMessage = ref5[1];
    var ref6 = offer_list_empty_message_slicedToArray((0,react.useState)(offer_list_empty_message_toConsumableArray(offers.mainList).concat(offer_list_empty_message_toConsumableArray(offers.secondaryList))), 1), allShownOffers = ref6[0];
    var hasOffers = offers.mainList.filter(function(offer) {
        var ref;
        return ((ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) === "in_stock";
    }).length > 0;
    var hasAnyOffers = allShownOffers.length > 0;
    var hasAnyInStock = allShownOffers.filter(function(offer) {
        var ref;
        return ((ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) === "in_stock";
    }).length > 0;
    var hasFeaturedOffers = hasAnyInStock && offers.mainList.filter(function(offer) {
        return offer.featured;
    }).length > 0;
    var anyOffersInList = offers.mainList.length > 0;
    var inclShippingSelected = filtersToggled.filter(function(filter) {
        return filter.type === price_list_types/* FilterType.PRICES_INC_SHIPPING */.vA.PRICES_INC_SHIPPING;
    }).length > 0;
    var inStockSelected = filtersToggled.filter(function(filter) {
        return filter.type === price_list_types/* FilterType.IN_STOCK */.vA.IN_STOCK;
    }).length > 0;
    (0,react.useEffect)(function() {
        setupPrompt();
    }, []);
    (0,react.useEffect)(function() {
        setMessage(null);
        setupMessage();
    }, [
        offers
    ]);
    var submitAlert = function(event, email, onError) {
        event.preventDefault();
        if (!isAuthenticated && email && !(0,helpers/* isValidEmail */.v)(email) && onError) return onError(product_alert_form_types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
        var userAlert = userProductAlerts.find(function(alert) {
            return alert.productId === product.id;
        });
        var stockStatusAlert = {
            alertId: userAlert === null || userAlert === void 0 ? void 0 : userAlert.alertId,
            email: !isAuthenticated ? email : undefined,
            productId: product.id,
            type: product_alert_form_types/* AlertTypes.IN_STOCK */.d_.IN_STOCK
        };
        return dispatch((0,actions_alert/* createAlertRequest */.$b)(stockStatusAlert));
    };
    var handleReset = function() {
        resetFilters();
    };
    var handleResetShipping = function() {
        toggleFilter(price_list_types/* FilterType.PRICES_INC_SHIPPING */.vA.PRICES_INC_SHIPPING);
    };
    var getCategory = function() {
        var ref;
        var category = offer_list_empty_message_objectSpread({}, (ref = product.category) === null || ref === void 0 ? void 0 : ref.path.slice(-1)[0]);
        category.name = (category === null || category === void 0 ? void 0 : category.name) || "";
        category.pathName = (category === null || category === void 0 ? void 0 : category.pathName) || "";
        return category;
    };
    var resetFilterLink = // eslint-disable-next-line
    /*#__PURE__*/ react.createElement("a", {
        onClick: handleReset
    }, t("filter", "button.clear-filters"));
    var resetShippingLink = // eslint-disable-next-line
    /*#__PURE__*/ react.createElement("a", {
        onClick: handleResetShipping
    }, t("filter", "empty-message.show-without-delivery-cost"));
    var setupPrompt = function() {
        var newPrompt = null;
        if (!hasAnyOffers) {
            newPrompt = PromptMessageEnum.noOffers;
        } else if (!hasAnyInStock) {
            newPrompt = PromptMessageEnum.outOfStock;
        } else if (!hasFeaturedOffers) {
            newPrompt = PromptMessageEnum.noFeaturedSellsProduct;
        }
        setPrompt(newPrompt);
    };
    var setupMessage = function() {
        var newMessage = null;
        if (!anyOffersInList && filtersToggled.length > 1) {
            newMessage = InfoMessageEnum.noFiltersMatch;
        } else if (inclShippingSelected && !anyOffersInList) {
            newMessage = InfoMessageEnum.noInfoOnDelivery;
        } else if (!hasOffers && filtersToggled.length > 0 && inStockSelected && prompt) {
            newMessage = InfoMessageEnum.outOfStock;
        }
        setMessage(newMessage);
    };
    //  NoStockStatus prompt should only be shown for 'new' products.
    //  That's because the prompt has an incentive to create a stock alert,
    //  and the stock alert function doesn't send notifications for 'used' products that is out of stock.
    //  Don't show it either if there is any filter activated, because it has it's own empty offer list message.
    var renderNothingInStockMessage = function() {
        if (!prompt) {
            return null;
        }
        var category = getCategory();
        var promptMessage = {
            message: "",
            buttonText: "",
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            buttonOnClick: function() {},
            icon: null,
            iconPosition: "left",
            showButton: true
        };
        switch(prompt){
            case PromptMessageEnum.noOffers:
                promptMessage = {
                    message: t("filter", "empty-message.no-store-sells-product"),
                    buttonText: t("filter", "empty-message.see-other-categories", {
                        category: category.name
                    }),
                    buttonOnClick: function() {
                        return history.push(category.pathName);
                    },
                    icon: /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null),
                    iconPosition: "right",
                    showButton: true
                };
                break;
            case PromptMessageEnum.outOfStock:
                promptMessage = {
                    message: t("filter", "empty-message.no-product-in-store"),
                    buttonText: t("filter", "empty-message.notify-me-button"),
                    buttonOnClick: function() {
                        return setModalOpen(true);
                    },
                    icon: /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null),
                    iconPosition: "left",
                    showButton: market.login.enabled
                };
                break;
            case PromptMessageEnum.noFeaturedSellsProduct:
                promptMessage = {
                    message: t("filter", "empty-message.no-featured-store-sells-product"),
                    buttonText: t("filter", "empty-message.see-other-categories", {
                        category: category.name
                    }),
                    buttonOnClick: function() {
                        return history.push(category.pathName);
                    },
                    icon: /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null),
                    iconPosition: "right",
                    showButton: true
                };
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StockStatusAlertModal, {
            closeModal: function() {
                return setModalOpen(false);
            },
            isOpen: modalOpen,
            onSubmit: submitAlert
        }), /*#__PURE__*/ react.createElement(PromptMessage, {
            message: promptMessage
        }));
    };
    var renderMessage = function() {
        if (!message) {
            return null;
        }
        var infoMessage = {
            text: "",
            link: null
        };
        switch(message){
            case InfoMessageEnum.noFiltersMatch:
                infoMessage = {
                    text: t("filter", "empty-message.no-filter-match"),
                    link: resetFilterLink
                };
                break;
            case InfoMessageEnum.noInfoOnDelivery:
                infoMessage = {
                    text: t("filter", "empty-message.no-info-on-delivery-cost"),
                    link: resetShippingLink
                };
                break;
            case InfoMessageEnum.outOfStock:
                infoMessage = {
                    text: t("filter", "empty-message.no-product-in-store"),
                    link: resetShippingLink
                };
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ react.createElement(info_message/* InfoMessage */.$, {
            message: infoMessage
        });
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, renderMessage(), renderNothingInStockMessage());
};
/* harmony default export */ var offer_list_empty_message = (OfferListEmptyMessage);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/components/expanded-placeholder-chips.tsx







var ExpandedPlaceholderChips = function(props) {
    var userHasExpandedUnfeatured = props.userHasExpandedUnfeatured, userHasExpandedUsed = props.userHasExpandedUsed, setUserHasExpandedUnfeatured = props.setUserHasExpandedUnfeatured, setUserHasExpandedUsed = props.setUserHasExpandedUsed;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!userHasExpandedUnfeatured && !userHasExpandedUsed) {
        return null;
    }
    var renderChip = function(label, ariaLabel, setUserHasExpandedFn) {
        return /*#__PURE__*/ react.createElement(StyledChip, null, /*#__PURE__*/ react.createElement(button_variants.TonalButton, {
            size: ui_button.ButtonSize.SMALL,
            onClick: function() {
                setUserHasExpandedFn(false);
            },
            ariaLabel: ariaLabel
        }, /*#__PURE__*/ react.createElement(ui_button.ButtonText, {
            behavior: ui_text.Behavior.Oneline,
            weight: ui_text.FontWeight.NORMAL
        }, label), /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(icon_close.IconClose, null))));
    };
    return /*#__PURE__*/ react.createElement(ScrollingChipList, null, /*#__PURE__*/ react.createElement(ScrollingChipListWrapper, null, userHasExpandedUsed && renderChip(t("product", "price-list.used-shops-include-all"), t("product", "price-list.used-shops-hide-all"), setUserHasExpandedUsed), userHasExpandedUnfeatured && renderChip(t("product", "price-list.unfeatured-shops-include-all"), t("product", "price-list.unfeatured-shops-hide-all"), setUserHasExpandedUnfeatured)));
};

// EXTERNAL MODULE: ./src/areas/product/utils/price-list/split-list.ts
var split_list = __webpack_require__(93476);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/utils/index.ts
var our_choice_utils = __webpack_require__(84577);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/index.tsx
function price_list_panel_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_list_panel_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_list_panel_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_list_panel_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_list_panel_slicedToArray(arr, i) {
    return price_list_panel_arrayWithHoles(arr) || price_list_panel_iterableToArrayLimit(arr, i) || price_list_panel_unsupportedIterableToArray(arr, i) || price_list_panel_nonIterableRest();
}
function price_list_panel_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_list_panel_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_list_panel_arrayLikeToArray(o, minLen);
}



















var PriceListPanel = function(props) {
    var ref, ref1;
    var storeStatistics = props.storeStatistics, campaign = props.campaign;
    var ref2 = (0,app_context/* useAppContext */.bp)(), t = ref2.t, market = ref2.market;
    var ref3 = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getActiveFilters = ref3.getActiveFilters, getPriceDisplay = ref3.getPriceDisplay;
    var ref4 = (0,product_context/* useProductContext */.$h)(), offers = ref4.offers, allOffers = ref4.allOffers, allOffersWithActiveAdditives = ref4.allOffersWithActiveAdditives;
    var location = (0,react_router/* useLocation */.TH)();
    var ref5 = price_list_panel_slicedToArray((0,react.useState)(filter_dropdown_types/* OptionTypeEnum.CHEAPEST_PRICE */.M.CHEAPEST_PRICE), 2), currentSorting = ref5[0], setCurrentSorting = ref5[1];
    var ref6 = price_list_panel_slicedToArray((0,react.useState)({
        mainList: offers.filteredOffers,
        secondaryList: []
    }), 2), sortedOffers = ref6[0], setSortedOffers = ref6[1];
    var ref7 = price_list_panel_slicedToArray((0,react.useState)((0,our_choice_utils/* getOurChoiceOffer */.T)(offers.filteredOffers, market.code)), 2), ourChoice = ref7[0], setOurChoice = ref7[1];
    var ref8 = price_list_panel_slicedToArray((0,react.useState)(getExpandUnfeaturedByDefault(offers.filteredOffers)), 2), userHasExpandedUnfeatured = ref8[0], setUserHasExpandedUnfeatured = ref8[1];
    var ref9 = price_list_panel_slicedToArray((0,react.useState)(getExpandUsedFromQuerystring(location)), 2), userHasExpandedUsed = ref9[0], setUserHasExpandedUsed = ref9[1];
    (0,react.useEffect)(function() {
        getOffersList();
    }, [
        currentSorting,
        offers
    ]);
    var getOffersList = function() {
        var offersSorted = (0,sort_by_price/* sortOffersByPrice */.bo)(getPriceDisplay(), offers.filteredOffers);
        setOurChoice((0,our_choice_utils/* getOurChoiceOffer */.T)(offersSorted, market.code));
        var splitOfferList = (0,split_list/* getSplitOfferlist */.Z1)(offersSorted, getActiveFilters());
        var newSortedOffers = sortByFastestDelivery(splitOfferList, currentSorting, getActiveFilters());
        setSortedOffers(newSortedOffers);
    };
    var handleSort = function(option) {
        if (!option.type || option.type === currentSorting) {
            return;
        }
        setCurrentSorting(option.type);
        (0,filter/* trackSortingSelectEvent */.Em)({
            property: option.type,
            value: option.type,
            scope: filter/* PageScope.PRODUCT */.VN.PRODUCT
        });
    };
    var listLimits = (0,split_list/* getListLimits */.oV)();
    return(// id="price-list-panel" is for tab a11y (aria-controls)
    /*#__PURE__*/ react.createElement("div", {
        id: "price-list-panel"
    }, allOffers.length > 0 && /*#__PURE__*/ react.createElement(PriceListHeader, {
        onSort: handleSort,
        sorting: currentSorting,
        allOffers: allOffers,
        allOffersWithActiveAdditives: allOffersWithActiveAdditives
    }), /*#__PURE__*/ react.createElement(offer_list_empty_message, {
        offers: sortedOffers
    }), /*#__PURE__*/ react.createElement(ExpandedPlaceholderChips, {
        userHasExpandedUnfeatured: userHasExpandedUnfeatured,
        userHasExpandedUsed: userHasExpandedUsed,
        setUserHasExpandedUnfeatured: setUserHasExpandedUnfeatured,
        setUserHasExpandedUsed: setUserHasExpandedUsed
    }), sortedOffers.mainList.length > 0 && /*#__PURE__*/ react.createElement(PriceListBody, {
        isPrimaryList: true,
        sortedPrices: sortedOffers.mainList,
        numberOfVisiblePrices: listLimits.mainListLimit,
        currentSorting: currentSorting,
        campaign: campaign,
        ourChoiceStoreId: ourChoice === null || ourChoice === void 0 ? void 0 : (ref = ourChoice.store) === null || ref === void 0 ? void 0 : ref.id,
        userHasExpandedUnfeatured: userHasExpandedUnfeatured,
        userHasExpandedUsed: userHasExpandedUsed,
        setUserHasExpandedUnfeatured: setUserHasExpandedUnfeatured,
        setUserHasExpandedUsed: setUserHasExpandedUsed
    }), sortedOffers.secondaryList.length > 0 && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(HeaderWrapper, null, /*#__PURE__*/ react.createElement(variants.H4Text, {
        scale: variants.FontScale.S,
        weight: variants.FontWeight.HEAVIER
    }, t("product", "splitlist-other.description"))), /*#__PURE__*/ react.createElement(PriceListBody, {
        isPrimaryList: false,
        sortedPrices: sortedOffers.secondaryList,
        numberOfVisiblePrices: listLimits.secondaryListLimit,
        currentSorting: currentSorting,
        campaign: campaign,
        ourChoiceStoreId: ourChoice === null || ourChoice === void 0 ? void 0 : (ref1 = ourChoice.store) === null || ref1 === void 0 ? void 0 : ref1.id,
        userHasExpandedUnfeatured: userHasExpandedUnfeatured,
        userHasExpandedUsed: userHasExpandedUsed,
        setUserHasExpandedUnfeatured: setUserHasExpandedUnfeatured,
        setUserHasExpandedUsed: setUserHasExpandedUsed
    })), storeStatistics && Boolean(storeStatistics.totalCount) && /*#__PURE__*/ react.createElement(PriceInformation, {
        storeStatistics: storeStatistics
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/index.tsx



// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/compare/index.js
var compare = __webpack_require__(34645);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(89286);
// EXTERNAL MODULE: ./src/components/skeleton/index.ts + 3 modules
var skeleton = __webpack_require__(75598);
// EXTERNAL MODULE: ./src/components/truncated/index.tsx
var truncated = __webpack_require__(16732);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
// EXTERNAL MODULE: ./src/areas/product/components/product-comparison/queries/query.graphql
var query_graphql = __webpack_require__(45875);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/product/components/product-comparison/queries/use-product-comparison-query.ts


var useProductComparisonQuery = function(productId) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (query_graphql_default()),
        queryKey: [
            "product-comparison"
        ],
        variables: {
            id: productId
        }
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-comparison/styles.ts
function product_comparison_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_comparison_styles_templateObject() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n  flex: none;\n"
    ]);
    product_comparison_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_comparison_styles_templateObject1() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n  height: 100px;\n"
    ]);
    product_comparison_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_comparison_styles_templateObject2() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    padding: 10px;\n    border-radius: 50%;\n  "
    ]);
    product_comparison_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_comparison_styles_templateObject3() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n    white-space: nowrap;\n    overflow: hidden;\n  "
    ]);
    product_comparison_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_comparison_styles_templateObject4() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    product_comparison_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function product_comparison_styles_templateObject5() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "
    ]);
    product_comparison_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function product_comparison_styles_templateObject6() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    product_comparison_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function product_comparison_styles_templateObject7() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-top: ",
        ";\n  gap: ",
        ";\n"
    ]);
    product_comparison_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n    height: ",
        ";\n  "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n  height: ",
        ";\n  padding: ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n    flex-direction: row;\n    height: ",
        ";\n  "
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = product_comparison_styles_taggedTemplateLiteral([
        "\n  height: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}





var LogosContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LogosContainer",
    componentId: "sc-0-0"
})(product_comparison_styles_templateObject());
var ComparisonImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "ComparisonImage",
    componentId: "sc-0-1"
})(product_comparison_styles_templateObject1());
var TextWithRing = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "TextWithRing",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(product_comparison_styles_templateObject2(), props.theme.bg.quaternary);
});
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ContentWrapper",
    componentId: "sc-0-3"
})(product_comparison_styles_templateObject4(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.largeUp */.BC.largeUp(product_comparison_styles_templateObject3()));
var ButtonText = (0,styled_components_browser_esm["default"])(variants.TitleSmallText).withConfig({
    displayName: "ButtonText",
    componentId: "sc-0-4"
})(product_comparison_styles_templateObject6(), base/* media.largeUp */.BC.largeUp(product_comparison_styles_templateObject5()));
var StyledInfoWrapper = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledInfoWrapper",
    componentId: "sc-0-5"
})(product_comparison_styles_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledTonalButton = (0,styled_components_browser_esm["default"])(button_variants.TonalButton).withConfig({
    displayName: "StyledTonalButton",
    componentId: "sc-0-6"
})(styles_templateObject8());
var MOBILE_CARD_HEIGHT = "25rem";
var DESKTOP_CARD_HEIGHT = "11.75rem";
var EmptyCard = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EmptyCard",
    componentId: "sc-0-7"
})(styles_templateObject10(), MOBILE_CARD_HEIGHT, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.largeUp */.BC.largeUp(styles_templateObject9(), DESKTOP_CARD_HEIGHT));
var StyledCard = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "StyledCard",
    componentId: "sc-0-8"
})(styles_templateObject12(), function(props) {
    return props.expanded ? "auto" : MOBILE_CARD_HEIGHT;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing125 */.bK.measurements.spacing125, base/* media.largeUp */.BC.largeUp(styles_templateObject11(), function(props) {
    return props.expanded ? "auto" : DESKTOP_CARD_HEIGHT;
}));

;// CONCATENATED MODULE: ./src/areas/product/components/product-comparison/index.tsx
function product_comparison_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_comparison_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_comparison_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_comparison_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_comparison_slicedToArray(arr, i) {
    return product_comparison_arrayWithHoles(arr) || product_comparison_iterableToArrayLimit(arr, i) || product_comparison_unsupportedIterableToArray(arr, i) || product_comparison_nonIterableRest();
}
function product_comparison_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_comparison_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_comparison_arrayLikeToArray(o, minLen);
}














var ComparisonCard = function() {
    var ref, ref1;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var ref2 = (0,app_context/* useAppContext */.bp)(), linkTo = ref2.linkTo, t = ref2.t;
    var ref3 = product_comparison_slicedToArray((0,react.useState)(false), 2), expanded = ref3[0], setExpanded = ref3[1];
    var result = useProductComparisonQuery(product.id);
    if (result.error || result.isLoading) return /*#__PURE__*/ react.createElement(StyledCard, {
        expanded: false
    }, /*#__PURE__*/ react.createElement(skeleton/* SkeletonParagraph */.Bp, {
        height: "100%",
        width: "100%"
    }));
    if (!((ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.comparison)) {
        return /*#__PURE__*/ react.createElement(EmptyCard, null, " ");
    }
    var comparison = result.data.product.comparison;
    var comparedProductUrl = linkTo("product", comparison.comparedProduct);
    var comparePageUrl = linkTo("productCompare", {
        category: product.category,
        products: [
            comparison.baseProduct,
            comparison.comparedProduct
        ]
    });
    var clickComparedProduct = function() {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.PRODUCT_COMPARISON */.U.PRODUCT_COMPARISON,
            nextPage: comparedProductUrl
        });
    };
    var clickProductCompare = function() {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.PRODUCT_COMPARISON */.U.PRODUCT_COMPARISON,
            nextPage: comparePageUrl
        });
    };
    return /*#__PURE__*/ react.createElement(StyledCard, {
        expanded: expanded
    }, /*#__PURE__*/ react.createElement(LogosContainer, null, /*#__PURE__*/ react.createElement(ComparisonImage, {
        alt: comparison.baseProduct.name,
        src: comparison.baseProduct.logo
    }), /*#__PURE__*/ react.createElement(TextWithRing, null, "vs."), /*#__PURE__*/ react.createElement(ComparisonImage, {
        alt: comparison.comparedProduct.name,
        src: comparison.comparedProduct.logo
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.H4Text, null, /*#__PURE__*/ react.createElement(truncated/* Truncated */.J, {
        maxLines: 2
    }, t("product", "product-compare.compared-to"), " ", /*#__PURE__*/ react.createElement(ui_link/* InternalLink */.h, {
        to: comparedProductUrl,
        onClick: clickComparedProduct
    }, comparison.comparedProduct.name))), /*#__PURE__*/ react.createElement(truncated/* Truncated */.J, {
        maxLines: expanded ? 20 : 4,
        onClick: function() {
            return setExpanded(!expanded);
        },
        style: {
            cursor: "pointer"
        }
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, comparison.summary)), /*#__PURE__*/ react.createElement(StyledInfoWrapper, {
        emphasis: variants.FontEmphasis.MEDIUM,
        color: variants.FontColor.DARK
    }, /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        size: 12
    }), t("product", "product-compare.comparison-info"))), /*#__PURE__*/ react.createElement(StyledTonalButton, {
        container: react_router_dom/* Link */.rU,
        onClick: clickProductCompare,
        containerProps: {
            to: comparePageUrl,
            rel: "nofollow"
        }
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, null)), /*#__PURE__*/ react.createElement(ButtonText, null, t("product", "product-compare.compare-products")))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/main/components/price-list-tabs/utils.ts

var handleTracking = function(activeTab, tabs) {
    var _location = window.location, pathname = _location.pathname, search = _location.search;
    var nextMobileContractPage = search.includes("list=mobile-contract") ? "".concat(pathname).concat(search) : "".concat(pathname).concat(search, "&list=mobile-contract");
    (0,tracking/* trackInternalNavigationClick */.p)({
        scope: tracking/* InternalNavigationScope.TAB_BAR */.U.TAB_BAR,
        currentPage: pathname + search,
        nextPage: activeTab === "mobile-contract" ? nextMobileContractPage : "".concat(pathname).concat(search.replace("&list=mobile-contract", "")),
        index: tabs.findIndex(function(tab) {
            return tab.type === activeTab;
        })
    });
};

// EXTERNAL MODULE: ./src/components/tabs-new/components/tab-link/index.tsx + 1 modules
var tab_link = __webpack_require__(10680);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/main/components/price-list-tabs/styles.ts
function price_list_tabs_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_list_tabs_styles_templateObject() {
    var data = price_list_tabs_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    price_list_tabs_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function price_list_tabs_styles_templateObject1() {
    var data = price_list_tabs_styles_taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n  "
    ]);
    price_list_tabs_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function price_list_tabs_styles_templateObject2() {
    var data = price_list_tabs_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0;\n  border-bottom: 1px solid ",
        ";\n  overflow-x: auto;\n\n  ",
        "\n"
    ]);
    price_list_tabs_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function price_list_tabs_styles_templateObject3() {
    var data = price_list_tabs_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n"
    ]);
    price_list_tabs_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function price_list_tabs_styles_templateObject4() {
    var data = price_list_tabs_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  > * {\n    margin: 0;\n    user-select: none;\n  }\n"
    ]);
    price_list_tabs_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledSubtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSubtitle",
    componentId: "sc-0-0"
})(price_list_tabs_styles_templateObject(), design_tokens.measurements.spacing050);
var StyledTabsWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTabsWrapper",
    componentId: "sc-0-1"
})(price_list_tabs_styles_templateObject2(), design_tokens.measurements.spacing050, base/* colors.borderLightGray */.O9.borderLightGray, base/* media.mediumDown */.BC.mediumDown(price_list_tabs_styles_templateObject1(), design_tokens.measurements.spacing100));
var StyledTabLink = (0,styled_components_browser_esm["default"])(tab_link/* TabLink */.f).withConfig({
    displayName: "StyledTabLink",
    componentId: "sc-0-2"
})(price_list_tabs_styles_templateObject3());
var StyledTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-3"
})(price_list_tabs_styles_templateObject4(), design_tokens.measurements.spacing025, design_tokens.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/main/components/price-list-tabs/index.tsx








var PriceListTabs = function(param) {
    var activeTab = param.activeTab, setActiveTab = param.setActiveTab, mobileContractsCount = param.mobileContractsCount;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var offers = (0,product_context/* useProductContext */.$h)().offers;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var pathname = location.pathname, search = location.search;
    // Set active tab based on URL parameter
    (0,react.useEffect)(function() {
        var showMobileContractTab = search.includes("list=mobile-contract");
        setActiveTab(showMobileContractTab ? "mobile-contract" : "price-list");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search
    ]);
    var offersCount = offers.filteredOffers.length;
    if (!mobileContractsCount) return null;
    var tabs = [
        {
            active: activeTab === "price-list",
            count: offersCount,
            title: t("product", "price-list.store-title"),
            to: pathname + search.replace("&list=mobile-contract", ""),
            type: "price-list"
        },
        {
            active: activeTab === "mobile-contract",
            count: mobileContractsCount,
            title: t("product", "price-list.mobile-contract-title"),
            to: getMobileContractLink(location),
            type: "mobile-contract"
        }
    ];
    return /*#__PURE__*/ react.createElement(StyledTabsWrapper, null, tabs.map(function(param) {
        var active = param.active, count = param.count, title = param.title, to = param.to, type = param.type;
        return /*#__PURE__*/ react.createElement(StyledTabLink, {
            active: active,
            ariaControls: "".concat(type, "-panel"),
            handleOnClick: function() {
                return handleTracking(type, tabs);
            },
            key: type,
            to: to
        }, /*#__PURE__*/ react.createElement(StyledTitle, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, title), /*#__PURE__*/ react.createElement(variants.BodySmallText, null, "(", count, ")")));
    }));
};

// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/sections/main/styles.ts
var main_styles = __webpack_require__(27029);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/main/product-tab-main.tsx
function product_tab_main_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_tab_main_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_tab_main_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_tab_main_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_tab_main_slicedToArray(arr, i) {
    return product_tab_main_arrayWithHoles(arr) || product_tab_main_iterableToArrayLimit(arr, i) || product_tab_main_unsupportedIterableToArray(arr, i) || product_tab_main_nonIterableRest();
}
function product_tab_main_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_tab_main_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_tab_main_arrayLikeToArray(o, minLen);
}




















var ProductTabMain = function(props) {
    var ref, ref1;
    var currentCampaign = props.currentCampaign;
    var ref2 = (0,product_context/* useProductContext */.$h)(), mobileContracts = ref2.mobileContracts, product = ref2.product;
    var ref3 = (0,app_context/* useAppContext */.bp)(), market = ref3.market, t = ref3.t;
    var ref4 = product_tab_main_slicedToArray((0,react.useState)("price-list"), 2), activeListTab = ref4[0], setActiveListTab = ref4[1];
    var ref5 = product_tab_main_slicedToArray((0,react.useState)(mobileContracts.length), 2), mobileContractsCount = ref5[0], setMobileContractsCount = ref5[1];
    var ref6 = product_tab_main_slicedToArray((0,use_localstorage/* useLocalStorage */._)("pj:productUXFeedbackTime", 0), 1), productUXFeedbackTime = ref6[0];
    var showUXFeedback = (0,use_show_ux_feedback/* useShowUXFeedback */.k)(use_show_ux_feedback/* ONE_DAY */.s * 7, productUXFeedbackTime, 0.5);
    var displayTrendingProducts = (product.trendingProducts || []).length > 0;
    var displayOtherVisited = (product.othersVisitedProducts || []).length > 0;
    var displayPopularProducts = !displayTrendingProducts && !displayOtherVisited && (product.popularProducts || []).length > 0;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var offers = (0,product_context/* useProductContext */.$h)().offers;
    var mobileContractsEnabled = Boolean(market.mobileContractsEnabled);
    var offersCount = offers.filteredOffers.length;
    var pricesTabLabel = "".concat(t("product", "tabs.prices")).concat(offersCount > 0 && (!mobileContractsEnabled || !mobileContracts.length) ? " (".concat(offersCount, ")") : "");
    var handleSetActiveTabCallback = (0,react.useCallback)(function(activeTab) {
        setActiveListTab(activeTab);
    }, []);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(main_styles/* StyledPageSection */.C1, {
        noPad: "top",
        recessed: true,
        "data-test": "MainTabContent"
    }, /*#__PURE__*/ react.createElement("div", null, isMobile && /*#__PURE__*/ react.createElement(main_styles/* StyledHeading */.wh, null, pricesTabLabel), /*#__PURE__*/ react.createElement(Panel, null, mobileContractsEnabled && (mobileContracts === null || mobileContracts === void 0 ? void 0 : mobileContracts.length) ? /*#__PURE__*/ react.createElement(PriceListTabs, {
        activeTab: activeListTab,
        setActiveTab: handleSetActiveTabCallback,
        mobileContractsCount: mobileContractsCount
    }) : null, activeListTab === "mobile-contract" ? /*#__PURE__*/ react.createElement(MobileContractList, {
        onCountChange: function(count) {
            return setMobileContractsCount(count);
        }
    }) : /*#__PURE__*/ react.createElement(PriceListPanel, {
        storeStatistics: (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.storeStatistics,
        campaign: currentCampaign
    }))), /*#__PURE__*/ react.createElement(product_styles/* AdPlacementWrapper */.G, null, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_1_wde",
        triggerPoint: 0
    }), /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_2",
        triggerPoint: 0
    })), market.code !== "nz" && /*#__PURE__*/ react.createElement(ComparisonCard, null), displayOtherVisited && /*#__PURE__*/ react.createElement(carousel_products/* CarouselProducts */.S, {
        products: (0,utils/* mapCarouselProducts */.b)(product.othersVisitedProducts) || [],
        title: t("product", "recommendations.others-visited"),
        carouselType: types/* CarouselTypeEnum.OTHERS_VISITED */.c.OTHERS_VISITED
    }), displayTrendingProducts && /*#__PURE__*/ react.createElement(carousel_products/* CarouselProducts */.S, {
        products: (0,utils/* mapCarouselProducts */.b)(product.trendingProducts) || [],
        title: t("landing", "trending-products.title"),
        carouselType: types/* CarouselTypeEnum.TRENDING_PRODUCTS */.c.TRENDING_PRODUCTS
    }), displayPopularProducts && /*#__PURE__*/ react.createElement(carousel_products/* CarouselProducts */.S, {
        carouselType: types/* CarouselTypeEnum.OTHER_POPULAR_PRODUCTS */.c.OTHER_POPULAR_PRODUCTS,
        products: (0,utils/* mapCarouselProducts */.b)(product.popularProducts) || [],
        title: t("product", "popular-products.title")
    }), showUXFeedback && /*#__PURE__*/ react.createElement(ux_feedback/* UxLiteQuestions */.X, {
        page: "product"
    })), /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noBorder: true
    }, /*#__PURE__*/ react.createElement(ReadableProductInformation, null)));
};

// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(40763);
// EXTERNAL MODULE: ./src/areas/product/components/product-properties/queries/query.graphql
var queries_query_graphql = __webpack_require__(547);
var queries_query_graphql_default = /*#__PURE__*/__webpack_require__.n(queries_query_graphql);
;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/queries/use-product-properties-query.ts


var useProductPropertiesQuery = function(productId) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (queries_query_graphql_default()),
        queryKey: [
            "product-properties"
        ],
        variables: {
            id: productId
        }
    });
};

// EXTERNAL MODULE: ./src/areas/product/components/product-properties/components/loader/index.tsx
var loader = __webpack_require__(52456);
;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/index.tsx




/**
 * Product properties component (loads the data and content async)
 */ var ProductProperties = function() {
    var product = (0,product_context/* useProductContext */.$h)().product;
    var result = useProductPropertiesQuery(product.id);
    return /*#__PURE__*/ react.createElement(loader/* ProductPropertiesLoader */.o, {
        queryResult: result
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/properties/index.tsx





var ProductTabProperties = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "Product Properties",
        "data-test": "PropertiesTabContent"
    }, /*#__PURE__*/ react.createElement(variants.H2Text, null, t("product", "tabs.properties")), /*#__PURE__*/ react.createElement(ProductProperties, null));
};

// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/sections/reviews/index.tsx
var reviews = __webpack_require__(85447);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/index.tsx + 1 modules
var product_price_history = __webpack_require__(53373);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/statistics/styles.ts
function statistics_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function statistics_styles_templateObject() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    statistics_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function statistics_styles_templateObject1() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: baseline;\n"
    ]);
    statistics_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function statistics_styles_templateObject2() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n"
    ]);
    statistics_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function statistics_styles_templateObject3() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    statistics_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function statistics_styles_templateObject4() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    statistics_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function statistics_styles_templateObject5() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n\n  & > * {\n    margin: ",
        " 0;\n  }\n"
    ]);
    statistics_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledPriceHistoryWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPriceHistoryWrapper",
    componentId: "sc-0-0"
})(statistics_styles_templateObject());
var StyledTitleRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTitleRow",
    componentId: "sc-0-1"
})(statistics_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var styles_StyledTitle = (0,styled_components_browser_esm["default"])(variants.H2Text).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-2"
})(statistics_styles_templateObject2());
var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-3"
})(statistics_styles_templateObject3(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var StyledIntroText = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "StyledIntroText",
    componentId: "sc-0-4"
})(statistics_styles_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var StyledAdPlacementWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledAdPlacementWrapper",
    componentId: "sc-0-5"
})(statistics_styles_templateObject5(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200);

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/statistics/index.tsx









var ProductTabStatistics = function() {
    var ref, ref1;
    var ref2 = (0,app_context/* useAppContext */.bp)(), t = ref2.t, market = ref2.market;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var onClickReadMoreLink = function() {
        var ref, ref1;
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.PRODUCT_PRICE_HISTORY */.U.PRODUCT_PRICE_HISTORY,
            currentPage: location.pathname + location.search + location.hash,
            nextPage: ((ref = market.articles) === null || ref === void 0 ? void 0 : (ref1 = ref.priceHistoryInfo) === null || ref1 === void 0 ? void 0 : ref1.path) || ""
        });
    };
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "Product Information",
        "data-test": "StatisticsTabContent"
    }, /*#__PURE__*/ react.createElement(StyledPriceHistoryWrapper, null, /*#__PURE__*/ react.createElement(StyledTitleRow, null, /*#__PURE__*/ react.createElement(styles_StyledTitle, null, t("product", "price-history.title")), /*#__PURE__*/ react.createElement(StyledLink, {
        to: ((ref = market.articles) === null || ref === void 0 ? void 0 : (ref1 = ref.priceHistoryInfo) === null || ref1 === void 0 ? void 0 : ref1.path) || "",
        onClick: onClickReadMoreLink
    }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, t("product", "price-history.read-more-link")))), /*#__PURE__*/ react.createElement(StyledIntroText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, t("product", "price-history.intro-text")), /*#__PURE__*/ react.createElement(product_price_history/* ProductPriceHistory */.N, {
        mode: "normal"
    })), /*#__PURE__*/ react.createElement(StyledAdPlacementWrapper, null, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_3_wde"
    }), /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_4"
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/index.ts






// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/index.tsx
var expert_content = __webpack_require__(10911);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/types.ts
var price_row_types = __webpack_require__(8114);
// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/sections/mini-offerlist/utils/mini-offerlist-config.ts
var mini_offerlist_config = __webpack_require__(74673);
// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/sections/mini-offerlist/types.ts
var mini_offerlist_types = __webpack_require__(80560);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/mini-offerlist/utils/mini-offers.ts









var MAX_SELECTED_OFFERS = 3;
/**
 * Returns the top selected offers for the mini offerlist
 */ var getSelectedTopOffers = function(props) {
    var _loop = function() {
        var item = mini_offerlist_config/* MINI_OFFERLIST_CONFIG */.V[prio].getItem({
            offersSortedByPrice: splitOffersSortedByPrice.mainList,
            offersSortedByShippingPrice: splitOffersSortedByShippingPrice.mainList,
            offersSortedByFastestDelivery: offersSortedByFastestDelivery,
            mobileContractsSortedByPrice: mobileContractsSortedByPrice,
            market: market
        });
        var offerType = mini_offerlist_config/* MINI_OFFERLIST_CONFIG */.V[prio].type;
        var isShopSelected = item && offerType !== undefined && !selectedOffers.find(function(o) {
            var ref, ref1;
            return ((ref = o.offer.store) === null || ref === void 0 ? void 0 : ref.id) === ((ref1 = item.offer.store) === null || ref1 === void 0 ? void 0 : ref1.id);
        });
        // Select shop offer, unless it's already selected (used offers excluded)
        if (item && (isShopSelected || offerType === mini_offerlist_types/* SelectedOfferTypeEnum.USED */.z.USED)) {
            selectedOffers.push(item);
        }
        prio += 1;
    };
    var offers = props.offers, mobileContracts = props.mobileContracts, activeProductHeaderFilters = props.activeProductHeaderFilters, market = props.market;
    // Offers sorted by price
    var offersSortedByPrice = (0,sort_by_price/* sortOffersByPrice */.bo)(price_list_types/* PriceDisplayEnum.PRICE */.wB.PRICE, offers);
    var splitOffersSortedByPrice = (0,split_list/* getSplitOfferlist */.Z1)(offersSortedByPrice, activeProductHeaderFilters);
    // Offers sorted by shipping price
    var offersSortedByShippingPrice = (0,sort_by_price/* sortOffersByPrice */.bo)(price_list_types/* PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */.wB.PRICE_INCLUDES_SHIPPING, offers);
    var splitOffersSortedByShippingPrice = (0,split_list/* getSplitOfferlist */.Z1)(offersSortedByShippingPrice, activeProductHeaderFilters);
    // Offers sorted by fastest delivery
    var offersSortedByFastestDelivery = sortByFastestDelivery(splitOffersSortedByPrice, filter_dropdown_types/* OptionTypeEnum.FASTEST_DELIVERY */.M.FASTEST_DELIVERY);
    // Mobile subscription offers
    var mobileContractsSortedByPrice = sortMobileContracts(mobileContracts, filters_and_sorting_types/* MobileContractSortOptionTypeEnum.MONTHLY_PRICE */.o.MONTHLY_PRICE);
    var selectedOffers = [];
    var prio = 0;
    // Select offers by prio order in config, until we have max selected offers
    while(selectedOffers.length < MAX_SELECTED_OFFERS && prio < mini_offerlist_config/* MINI_OFFERLIST_CONFIG.length */.V.length)_loop();
    return selectedOffers.sort(sortByDisplayPrice);
};
/**
 * Sorts by the price displayed on the item.
 * Mobile subscription offers are displayed as monthly price and this is sorted last.
 */ var sortByDisplayPrice = function(a, b) {
    var ref, ref1, ref2, ref3;
    if (a.type === mini_offerlist_types/* SelectedOfferTypeEnum.WITH_MOBILE_SUBSCRIPTION */.z.WITH_MOBILE_SUBSCRIPTION) {
        return 1;
    }
    if (b.type === mini_offerlist_types/* SelectedOfferTypeEnum.WITH_MOBILE_SUBSCRIPTION */.z.WITH_MOBILE_SUBSCRIPTION) {
        return -1;
    }
    var ref4;
    var priceA = (ref4 = a.type === mini_offerlist_types/* SelectedOfferTypeEnum.CHEAPEST_INCL_SHIPPING */.z.CHEAPEST_INCL_SHIPPING ? (ref = a.offer.price) === null || ref === void 0 ? void 0 : ref.inclShipping : (ref1 = a.offer.price) === null || ref1 === void 0 ? void 0 : ref1.exclShipping) !== null && ref4 !== void 0 ? ref4 : 0;
    var ref5;
    var priceB = (ref5 = b.type === mini_offerlist_types/* SelectedOfferTypeEnum.CHEAPEST_INCL_SHIPPING */.z.CHEAPEST_INCL_SHIPPING ? (ref2 = b.offer.price) === null || ref2 === void 0 ? void 0 : ref2.inclShipping : (ref3 = b.offer.price) === null || ref3 === void 0 ? void 0 : ref3.exclShipping) !== null && ref5 !== void 0 ? ref5 : 0;
    return priceA - priceB;
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/mini-offerlist/styles.ts
function mini_offerlist_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mini_offerlist_styles_templateObject() {
    var data = mini_offerlist_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    mini_offerlist_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function mini_offerlist_styles_templateObject1() {
    var data = mini_offerlist_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  flex-direction: row;\n  padding: ",
        " ",
        ";\n  gap: ",
        ";\n  align-items: center;\n\n  > img {\n    max-height: 56px;\n    max-width: 56px;\n    align-self: center;\n  }\n\n  > h4 {\n    margin: 0;\n  }\n"
    ]);
    mini_offerlist_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function mini_offerlist_styles_templateObject2() {
    var data = mini_offerlist_styles_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    mini_offerlist_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledWrapper",
    componentId: "sc-0-0"
})(mini_offerlist_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledFallbackMessage = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "StyledFallbackMessage",
    componentId: "sc-0-1"
})(mini_offerlist_styles_templateObject1(), light_theme_colors.informative100, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledPopover = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPopover",
    componentId: "sc-0-2"
})(mini_offerlist_styles_templateObject2());

// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/our-choice-popover.tsx
var our_choice_popover = __webpack_require__(7379);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/mini-offerlist/index.tsx
function mini_offerlist_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function mini_offerlist_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function mini_offerlist_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function mini_offerlist_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function mini_offerlist_slicedToArray(arr, i) {
    return mini_offerlist_arrayWithHoles(arr) || mini_offerlist_iterableToArrayLimit(arr, i) || mini_offerlist_unsupportedIterableToArray(arr, i) || mini_offerlist_nonIterableRest();
}
function mini_offerlist_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return mini_offerlist_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mini_offerlist_arrayLikeToArray(o, minLen);
}














var MiniOfferlist = function() {
    var market = (0,app_context/* useAppContext */.bp)().market;
    var ref = (0,product_context/* useProductContext */.$h)(), product = ref.product, offers = ref.offers, allOffers = ref.allOffers, mobileContracts = ref.mobileContracts;
    var getActiveFilters = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getActiveFilters;
    var isMobileContractsInMiniOfferlist = Boolean(market.mobileContractsEnabled);
    var ref1 = mini_offerlist_slicedToArray((0,react.useState)(false), 2), showOurChoicePopover = ref1[0], setShowOurChoicePopover = ref1[1];
    var activeProductHeaderFilters = getActiveFilters().filter(function(filter) {
        return filter.placement.includes(price_list_types/* FilterUIPlacementEnum.PRODUCT_HEADER */.jm.PRODUCT_HEADER);
    });
    var selectedTopOffers = getSelectedTopOffers({
        offers: offers.filteredOffersForProductHeader,
        allOffers: allOffers,
        mobileContracts: isMobileContractsInMiniOfferlist ? mobileContracts : [],
        activeProductHeaderFilters: activeProductHeaderFilters,
        market: market.code
    });
    return /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noBorder: true,
        recessed: true,
        noPad: "both"
    }, /*#__PURE__*/ react.createElement(StyledPopover, null, /*#__PURE__*/ react.createElement(our_choice_popover/* OurChoicePopover */.J, {
        showPopover: showOurChoicePopover,
        setShowPopover: setShowOurChoicePopover
    })), /*#__PURE__*/ react.createElement(StyledWrapper, null, selectedTopOffers.map(function(miniOffer) {
        var ref;
        /*#__PURE__*/ return react.createElement(price_row_context/* PriceRowContextContainer */.B, {
            key: "".concat((ref = miniOffer.offer.store) === null || ref === void 0 ? void 0 : ref.id, "-").concat(miniOffer.offer.shopOfferId),
            offer: miniOffer.offer,
            product: product,
            sorting: filter_dropdown_types/* OptionTypeEnum.CHEAPEST_PRICE */.M.CHEAPEST_PRICE,
            viewSize: price_row_types/* ViewSize.MINI */.du.MINI,
            isInPriceList: false,
            selectedOfferType: miniOffer.type,
            overridePriceDisplay: miniOffer.type === mini_offerlist_types/* SelectedOfferTypeEnum.CHEAPEST_INCL_SHIPPING */.z.CHEAPEST_INCL_SHIPPING ? price_list_types/* PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */.wB.PRICE_INCLUDES_SHIPPING : price_list_types/* PriceDisplayEnum.PRICE */.wB.PRICE,
            isOurChoice: miniOffer.type === mini_offerlist_types/* SelectedOfferTypeEnum.RECOMMENDED */.z.RECOMMENDED
        }, /*#__PURE__*/ react.createElement(row_types/* PriceRow */.a, {
            trackingItem: miniOffer.trackingItem,
            setShowOurChoicePopover: setShowOurChoicePopover
        }));
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/utils.ts
function product_tabs_utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_tabs_utils_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return product_tabs_utils_arrayLikeToArray(arr);
}
function product_tabs_utils_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function product_tabs_utils_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_tabs_utils_toConsumableArray(arr) {
    return product_tabs_utils_arrayWithoutHoles(arr) || product_tabs_utils_iterableToArray(arr) || product_tabs_utils_unsupportedIterableToArray(arr) || product_tabs_utils_nonIterableSpread();
}
function product_tabs_utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_tabs_utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_tabs_utils_arrayLikeToArray(o, minLen);
}
var delayedScrollIntoView = function(targetElement) {
    var ref;
    var timeout = 0;
    var navBarHeight = 71;
    var header = (ref = window.document.getElementsByTagName("header")) === null || ref === void 0 ? void 0 : ref[0];
    var _height;
    var offset = ((_height = header === null || header === void 0 ? void 0 : header.getBoundingClientRect().height) !== null && _height !== void 0 ? _height : 0) + navBarHeight;
    var sizeObserver = new ResizeObserver(function() {
        clearTimeout(timeout);
        _scrollTo(targetElement, offset);
        timeout = window === null || window === void 0 ? void 0 : window.setTimeout(function() {
            _scrollTo(targetElement, offset);
            sizeObserver.disconnect();
        }, 500);
    });
    sizeObserver.observe(window.document.body);
};
function _scrollTo(targetElement, yOffset) {
    var y = ((targetElement === null || targetElement === void 0 ? void 0 : targetElement.getBoundingClientRect().top) || 0) + window.scrollY - yOffset;
    window.scrollTo({
        top: y
    });
}
var getSimilarProductsCompareLink = function(similarProducts, product, linkTo) {
    var ref;
    if (!(similarProducts === null || similarProducts === void 0 ? void 0 : (ref = similarProducts.recommendations) === null || ref === void 0 ? void 0 : ref.length)) return null;
    var products = similarProducts.recommendations.filter(function(item) {
        return item.product;
    }).map(function(item) {
        return item.product;
    });
    return products.length ? linkTo("productCompare", {
        category: product.category,
        products: product ? [
            product
        ].concat(product_tabs_utils_toConsumableArray(products)) : products
    }) : null;
};

// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/types.ts
var product_tabs_types = __webpack_require__(61240);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/styles.ts
function product_tabs_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_tabs_styles_templateObject() {
    var data = product_tabs_styles_taggedTemplateLiteral([
        "\n      min-height: ",
        ";\n    "
    ]);
    product_tabs_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_tabs_styles_templateObject1() {
    var data = product_tabs_styles_taggedTemplateLiteral([
        "\n        min-height: ",
        ";\n      "
    ]);
    product_tabs_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_tabs_styles_templateObject2() {
    var data = product_tabs_styles_taggedTemplateLiteral([
        "\n      min-height: ",
        ";\n\n      ",
        "\n    "
    ]);
    product_tabs_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_tabs_styles_templateObject3() {
    var data = product_tabs_styles_taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    product_tabs_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_tabs_styles_templateObject4() {
    var data = product_tabs_styles_taggedTemplateLiteral([
        "\n  padding-bottom: ",
        ";\n"
    ]);
    product_tabs_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var REVIEWS_MIN_HEIGHT = "400px"; // Reviews section height with a title and no reviews
var STATISTICS_MIN_HEIGHT_DESKTOP = "634px"; // Height with top padding, but no ads
var STATISTICS_MIN_HEIGHT_MOBILE = "803px"; // Height with top padding, but no ads
var SectionWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SectionWrapper",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(product_tabs_styles_templateObject3(), props.id === product_tabs_types/* TabAnchor.REVIEWS */.X.REVIEWS && (0,styled_components_browser_esm.css)(product_tabs_styles_templateObject(), REVIEWS_MIN_HEIGHT), props.id === product_tabs_types/* TabAnchor.STATISTICS */.X.STATISTICS && (0,styled_components_browser_esm.css)(product_tabs_styles_templateObject2(), STATISTICS_MIN_HEIGHT_MOBILE, base/* media.mediumUp */.BC.mediumUp(product_tabs_styles_templateObject1(), STATISTICS_MIN_HEIGHT_DESKTOP)));
});
var StyledAdWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledAdWrapper",
    componentId: "sc-0-1"
})(product_tabs_styles_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/index.tsx















var ProductTabs = function(props) {
    var currentCampaign = props.currentCampaign;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var ref = (0,context/* useViewportContext */.Ak)(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var firstRender = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (location.hash !== "" && location.hash !== product_tabs_types/* TabAnchor.ALL */.X.ALL && firstRender.current) {
            firstRender.current = false;
            var targetElement = document.getElementById(location.hash);
            delayedScrollIntoView(targetElement);
        }
    }, [
        location.hash
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: product_tabs_types/* TabAnchor.ALL */.X.ALL
    }, isMobile ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(MiniOfferlist, null), /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noBorder: true,
        recessed: true,
        noPad: "both"
    }, /*#__PURE__*/ react.createElement(StyledAdWrapper, null, /*#__PURE__*/ react.createElement(product_styles/* AdPlacementWrapper */.G, null, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_1",
        triggerPoint: 0
    }))))) : /*#__PURE__*/ react.createElement(react.Fragment, null, isTablet && /*#__PURE__*/ react.createElement(product_styles/* AdPlacementWrapper */.G, {
        $marginTop: true
    }, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_1",
        triggerPoint: 0
    })), /*#__PURE__*/ react.createElement(ProductTabMain, {
        currentCampaign: currentCampaign
    }))), isMobile && /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: product_tabs_types/* TabAnchor.PRICES */.X.PRICES
    }, /*#__PURE__*/ react.createElement(ProductTabMain, {
        currentCampaign: currentCampaign
    })), /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: product_tabs_types/* TabAnchor.REVIEWS */.X.REVIEWS
    }, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, null, /*#__PURE__*/ react.createElement(reviews/* ProductTabReviews */.L, {
        product: product
    })))), /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: "#experts"
    }, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, null, /*#__PURE__*/ react.createElement(expert_content/* ProductExpertContent */.i, null))), /*#__PURE__*/ react.createElement(product_styles/* AdPlacementWrapper */.G, {
        $marginBottom: true
    }, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_2_wde",
        triggerPoint: 0
    }), /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        format: "panorama_3"
    }))), /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: product_tabs_types/* TabAnchor.STATISTICS */.X.STATISTICS
    }, /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noBorder: true,
        noPad: "both"
    }, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, null, /*#__PURE__*/ react.createElement(ProductTabStatistics, null))))), /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: product_tabs_types/* TabAnchor.PROPERTIES */.X.PROPERTIES
    }, /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noBorder: true,
        noPad: "top"
    }, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, null, /*#__PURE__*/ react.createElement(ProductTabProperties, null))))));
};


/***/ }),

/***/ 10911:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": () => (/* binding */ ProductExpertContent)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var ProductExpertContent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-expert-content";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-expert-content */ 536).then(__webpack_require__.bind(__webpack_require__, 73854));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(73854);
        }
        return eval("require.resolve")("./product-expert-content");
    }
});


/***/ }),

/***/ 27029:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": () => (/* binding */ StyledPageSection),
/* harmony export */   "qZ": () => (/* binding */ StyledRecommendationsPlaceholder),
/* harmony export */   "wh": () => (/* binding */ StyledHeading)
/* harmony export */ });
/* unused harmony export CAROUSEL_HEIGHT */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21541);
/* harmony import */ var src_components_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12321);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    margin-bottom: ",
        ";\n\n    > *:not(:last-child) {\n      margin-bottom: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var CAROUSEL_HEIGHT = "340px";
var StyledHeading = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__.H2Text).withConfig({
    displayName: "StyledHeading",
    componentId: "sc-0-0"
})(_templateObject());
var StyledPageSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_page__WEBPACK_IMPORTED_MODULE_2__/* .PageSection */ .NP).withConfig({
    displayName: "StyledPageSection",
    componentId: "sc-0-1"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing250 */ .bK.measurements.spacing250, src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing250 */ .bK.measurements.spacing250);
var StyledRecommendationsPlaceholder = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledRecommendationsPlaceholder",
    componentId: "sc-0-2"
})(_templateObject2(), CAROUSEL_HEIGHT);


/***/ }),

/***/ 80560:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": () => (/* binding */ SelectedOfferTypeEnum)
/* harmony export */ });
var SelectedOfferTypeEnum;
(function(SelectedOfferTypeEnum) {
    SelectedOfferTypeEnum[SelectedOfferTypeEnum["CHEAPEST"] = 0] = "CHEAPEST";
    SelectedOfferTypeEnum[SelectedOfferTypeEnum["RECOMMENDED"] = 1] = "RECOMMENDED";
    SelectedOfferTypeEnum[SelectedOfferTypeEnum["WITH_MOBILE_SUBSCRIPTION"] = 2] = "WITH_MOBILE_SUBSCRIPTION";
    SelectedOfferTypeEnum[SelectedOfferTypeEnum["USED"] = 3] = "USED";
    SelectedOfferTypeEnum[SelectedOfferTypeEnum["CHEAPEST_INCL_SHIPPING"] = 4] = "CHEAPEST_INCL_SHIPPING";
    SelectedOfferTypeEnum[SelectedOfferTypeEnum["FASTEST_DELIVERY"] = 5] = "FASTEST_DELIVERY";
})(SelectedOfferTypeEnum || (SelectedOfferTypeEnum = {}));


/***/ }),

/***/ 74673:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ MINI_OFFERLIST_CONFIG)
/* harmony export */ });
/* harmony import */ var _prisjakt_ui_icon_recycle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(894);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80560);
/* harmony import */ var src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60205);
/* harmony import */ var src_areas_product_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(852);
/* harmony import */ var _product_header_components_our_choice_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84577);
/* harmony import */ var src_areas_product_utils_product_condition__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7001);
/* harmony import */ var src_areas_product_components_price_list_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54581);
/* harmony import */ var src_areas_product_utils_mobile_contracts_mappings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82652);








var ref;
var MINI_OFFERLIST_CONFIG = [
    {
        type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.WITH_MOBILE_SUBSCRIPTION */ .z.WITH_MOBILE_SUBSCRIPTION,
        getItem: function(param) {
            var mobileContractsSortedByPrice = param.mobileContractsSortedByPrice;
            var contract = mobileContractsSortedByPrice.length > 0 ? mobileContractsSortedByPrice[0] : undefined;
            if (!contract) {
                return undefined;
            }
            return {
                type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.WITH_MOBILE_SUBSCRIPTION */ .z.WITH_MOBILE_SUBSCRIPTION,
                offer: (0,src_areas_product_utils_mobile_contracts_mappings__WEBPACK_IMPORTED_MODULE_7__/* .mapMobileContractToOffer */ .v)(contract),
                trackingItem: (0,src_areas_product_utils_mobile_contracts_mappings__WEBPACK_IMPORTED_MODULE_7__/* .mapMobileContractToTrackingItem */ .X)(contract)
            };
        },
        getBadgeLabel: function() {
            return "Abonnemang";
        },
        badgeColorFeatured: "BLUE"
    },
    {
        type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.CHEAPEST */ .z.CHEAPEST,
        getItem: function(param) {
            var offersSortedByPrice = param.offersSortedByPrice;
            var cheapest = offersSortedByPrice.find(function(offer) {
                return offer.condition === src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_2__/* .ConditionEnum.NEW */ .M.NEW;
            });
            if (!cheapest) {
                return undefined;
            }
            return {
                type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.CHEAPEST */ .z.CHEAPEST,
                offer: (0,src_areas_product_components_price_list_utils__WEBPACK_IMPORTED_MODULE_6__/* .createOfferFromPriceItem */ .J)(cheapest),
                trackingItem: cheapest
            };
        },
        getBadgeLabel: function(param) {
            var t = param.t, offers = param.offers;
            if (offers.some(function(offer) {
                return offer.condition !== src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_2__/* .ConditionEnum.NEW */ .M.NEW;
            })) {
                return t("product", "price-list-mini.new-price");
            }
            return t("product", "price-history.lowest-price-in-period");
        },
        badgeColorFeatured: "BLUE"
    },
    {
        type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.RECOMMENDED */ .z.RECOMMENDED,
        getItem: function(param) {
            var offersSortedByPrice = param.offersSortedByPrice, market = param.market;
            var recommeded = (0,_product_header_components_our_choice_utils__WEBPACK_IMPORTED_MODULE_4__/* .getOurChoiceOffer */ .T)(offersSortedByPrice, market);
            if (!recommeded) {
                return undefined;
            }
            return {
                type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.RECOMMENDED */ .z.RECOMMENDED,
                offer: (0,src_areas_product_components_price_list_utils__WEBPACK_IMPORTED_MODULE_6__/* .createOfferFromPriceItem */ .J)(recommeded),
                trackingItem: recommeded
            };
        },
        getBadgeLabel: function(param) {
            var t = param.t;
            return t("product", "prices.our-choice");
        },
        badgeColorFeatured: "BLUE_INVERTED"
    },
    {
        type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.CHEAPEST_INCL_SHIPPING */ .z.CHEAPEST_INCL_SHIPPING,
        getItem: function(param) {
            var offersSortedByShippingPrice = param.offersSortedByShippingPrice;
            var cheapestIncShipping = offersSortedByShippingPrice.find(function(offer) {
                return (0,src_areas_product_utils__WEBPACK_IMPORTED_MODULE_3__/* .getIsFeatured */ .ZF)(offer) && offer.condition === src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_2__/* .ConditionEnum.NEW */ .M.NEW;
            });
            if (!cheapestIncShipping) {
                return undefined;
            }
            return {
                type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.CHEAPEST_INCL_SHIPPING */ .z.CHEAPEST_INCL_SHIPPING,
                offer: (0,src_areas_product_components_price_list_utils__WEBPACK_IMPORTED_MODULE_6__/* .createOfferFromPriceItem */ .J)(cheapestIncShipping),
                trackingItem: cheapestIncShipping
            };
        },
        getBadgeLabel: function(param) {
            var t = param.t, offers = param.offers;
            if (offers.some(function(offer) {
                return offer.condition !== src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_2__/* .ConditionEnum.NEW */ .M.NEW;
            })) {
                return t("product", "price-list-mini.new-price-incl-shipping");
            }
            return t("product", "price-list-mini.price-incl-shipping");
        },
        badgeColorFeatured: "BLUE"
    },
    {
        type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.USED */ .z.USED,
        getItem: function(param) {
            var offersSortedByPrice = param.offersSortedByPrice;
            var used = offersSortedByPrice.find(function(offer) {
                return offer.condition !== src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_2__/* .ConditionEnum.NEW */ .M.NEW;
            });
            if (!used) {
                return undefined;
            }
            return {
                type: _types__WEBPACK_IMPORTED_MODULE_1__/* .SelectedOfferTypeEnum.USED */ .z.USED,
                offer: (0,src_areas_product_components_price_list_utils__WEBPACK_IMPORTED_MODULE_6__/* .createOfferFromPriceItem */ .J)(used),
                trackingItem: used
            };
        },
        getBadgeLabel: function(param) {
            var t = param.t, offer = param.offer;
            return (0,src_areas_product_utils_product_condition__WEBPACK_IMPORTED_MODULE_5__/* .getConditionName */ .v)((ref = offer === null || offer === void 0 ? void 0 : offer.condition) !== null && ref !== void 0 ? ref : "", t);
        },
        badgeColorFeatured: "GREEN",
        badgeIcon: _prisjakt_ui_icon_recycle__WEBPACK_IMPORTED_MODULE_0__/* .IconRecycle */ .L
    }
];


/***/ }),

/***/ 85447:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ ProductTabReviews)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var ProductTabReviews = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-tab-reviews";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-tab-reviews */ 191).then(__webpack_require__.bind(__webpack_require__, 12628));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(12628);
        }
        return eval("require.resolve")("./product-tab-reviews");
    }
});


/***/ }),

/***/ 61240:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ TabAnchor)
/* harmony export */ });
var TabAnchor;
(function(TabAnchor) {
    TabAnchor["ALL"] = "#all";
    TabAnchor["PROPERTIES"] = "#properties";
    TabAnchor["REVIEWS"] = "#reviews";
    TabAnchor["STATISTICS"] = "#statistics";
    TabAnchor["PRICES"] = "#prices";
})(TabAnchor || (TabAnchor = {}));


/***/ }),

/***/ 99467:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ PRODUCT_CONTEXT_ID),
/* harmony export */   "U": () => (/* binding */ PRODUCT_ALERT_MODAL_ID)
/* harmony export */ });
var PRODUCT_ALERT_MODAL_ID = "product-alert-modal";
var PRODUCT_CONTEXT_ID = "product-page";


/***/ }),

/***/ 7245:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ ProductPage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64799);
/* harmony import */ var _components_offer_list_filter_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8836);
/* harmony import */ var _components_product_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8466);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25349);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71297);
/* harmony import */ var src_components_lazy__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85518);
/* harmony import */ var src_components_scroll__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40763);
/* harmony import */ var src_areas_product_utils_price_list_filtering__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31288);
/* harmony import */ var src_areas_product_utils_price_list_sort_by_price__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17307);
/* harmony import */ var src_client_data_layer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24005);
/* harmony import */ var src_components_page__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12321);
/* harmony import */ var _components_recently_visited__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(24068);
/* harmony import */ var _components_product_header__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(55634);
/* harmony import */ var _components_product_tabs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(409);
/* harmony import */ var _components_product_promo_banner_product_during_promo_banner__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26910);
/* harmony import */ var _components_product_breadcrumb__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87378);
/* harmony import */ var _components_product_promo_banner_product_before_promo_banner__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59345);
/* harmony import */ var _components_product_scroll_top_button__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69469);
/* harmony import */ var _components_product_campaign_deals__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(19622);
/* harmony import */ var _components_product_section_navigation__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(46624);
/* harmony import */ var src_components_modal_actions__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(43758);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(852);
/* harmony import */ var _utils_deals__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(70018);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(99467);
/* harmony import */ var src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(34057);
/* harmony import */ var _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(60205);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(29813);
/* harmony import */ var src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(73426);
/* harmony import */ var src_components_modal_login_promo__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(60428);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}































var ProductAlertModalContent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 62975));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(62975);
        }
        return eval("require.resolve")("../product-alert/components/product-alert-modal-content");
    }
});
var ProductPage = function(param) {
    var data = param.data, _routeSection = param.routeSection, routeSection = _routeSection === void 0 ? "main" : _routeSection;
    var ref, ref1, ref2;
    var location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useLocation */ .TH)();
    var history = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useHistory */ .k6)();
    var isAuthenticated = (0,src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_29__/* .useIsAuthenticated */ .k)();
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_5__/* .useAppContext */ .bp)().market;
    var ref3 = (0,_components_offer_list_filter_context__WEBPACK_IMPORTED_MODULE_3__/* .useOfferListFilterContext */ .o)(), getActiveFilters = ref3.getActiveFilters, getInitialFilters = ref3.getInitialFilters, getFilterByPlacement = ref3.getFilterByPlacement, getAdditiveFilters = ref3.getAdditiveFilters;
    var product = data.product, prismicArticles = data.prismicArticles;
    var currentModal = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.modal.current;
    });
    var campaignBanners = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.globals.campaignBanners;
    });
    var activeCampaign = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        var ref, ref1;
        return (ref = state.globals.campaigns) === null || ref === void 0 ? void 0 : (ref1 = ref.active) === null || ref1 === void 0 ? void 0 : ref1.find(function(c) {
            return c.type === "OFFER";
        });
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    // Check if uri contains query param for opening alert modal.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (/[&?]create_alert/.test(location.search)) dispatch((0,src_components_modal_actions__WEBPACK_IMPORTED_MODULE_22__/* .showModal */ .K4)(_constants__WEBPACK_IMPORTED_MODULE_25__/* .PRODUCT_ALERT_MODAL_ID */ .U));
    }, [
        dispatch,
        location.search
    ]);
    // Handles closing modal and browser history if user visits a product page with param 'create_alert'
    var handleAlertQueryParam = function() {
        if (/[&?]create_alert/.test(location.search)) {
            var params = new URLSearchParams(location.search);
            params.delete("create_alert");
            history.push({
                pathname: location.pathname,
                search: params.toString()
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ( false || !product || !product.id) {
            return;
        }
        (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_11__/* .pushEvent */ .A)("viewItem", {
            ecommerce: {
                items: [
                    {
                        item_id: product.id,
                        item_name: product.name
                    }
                ]
            }
        }, {
            clearExistingData: true,
            eventNameAsKey: false
        });
    }, [
        product && product.id
    ]); // eslint-disable-line
    // Legacy deals
    product.campaigns = [];
    var currentCampaign = (0,_utils__WEBPACK_IMPORTED_MODULE_23__/* .getCurrentCampaign */ .uY)(activeCampaign, product);
    var privacyPolicyUri = market === null || market === void 0 ? void 0 : (ref = market.privacySettings) === null || ref === void 0 ? void 0 : (ref1 = ref.responsive) === null || ref1 === void 0 ? void 0 : ref1.privacyUrl;
    var productPrices = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,_utils__WEBPACK_IMPORTED_MODULE_23__/* .mapAlternativeOffersWithUniqueShipping */ .v8)(product);
    }, [
        product
    ]);
    // Initial filters (some filters are active by default)
    var initialFilters = getInitialFilters();
    // Initial offers as presented on the page from start
    var initialOffers = (0,src_areas_product_utils_price_list_sort_by_price__WEBPACK_IMPORTED_MODULE_10__/* .sortOffersByPrice */ .bo)(src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_26__/* .PriceDisplayEnum.PRICE */ .wB.PRICE, (0,src_areas_product_utils_price_list_filtering__WEBPACK_IMPORTED_MODULE_9__/* .filterOffers */ .hS)(initialFilters, productPrices));
    // Initial new offers (used in calculations for price history, deals, meta data etc)
    var initialNewOffers = initialOffers.filter(function(offer) {
        return offer.condition === _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_27__/* .ConditionEnum.NEW */ .M.NEW;
    });
    // New deals
    var dealOffers = (0,_utils_deals__WEBPACK_IMPORTED_MODULE_24__/* .getDealOffersForProduct */ .b)(product.dealInfo, initialNewOffers);
    // Offers filtered by all active filters
    var activeFilters = getActiveFilters();
    var filteredOffers = (0,src_areas_product_utils_price_list_filtering__WEBPACK_IMPORTED_MODULE_9__/* .filterOffers */ .hS)(activeFilters, productPrices, dealOffers);
    // Offers filtered by all active filters
    var activeAdditiveFilters = activeFilters.filter(function(filter) {
        return Boolean(filter.additive);
    });
    var allOffersWithActiveAdditives = (0,src_areas_product_utils_price_list_filtering__WEBPACK_IMPORTED_MODULE_9__/* .filterOffers */ .hS)(activeAdditiveFilters, productPrices);
    // Offers filtered in the product header
    var productHeaderFilters = getFilterByPlacement(src_areas_product_utils_price_list_types__WEBPACK_IMPORTED_MODULE_26__/* .FilterUIPlacementEnum.PRODUCT_HEADER */ .jm.PRODUCT_HEADER);
    var additiveFilters = getAdditiveFilters();
    var filteredOffersForProductHeader = (0,src_areas_product_utils_price_list_filtering__WEBPACK_IMPORTED_MODULE_9__/* .filterOffers */ .hS)(_toConsumableArray(productHeaderFilters).concat(_toConsumableArray(additiveFilters)), productPrices);
    // All offers unfiltered (incl those initially hidden by addative filters)
    var allOffers = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,src_areas_product_utils_price_list_filtering__WEBPACK_IMPORTED_MODULE_9__/* .mapPriceListToExtendedPrices */ .k2)(productPrices, dealOffers);
    }, [
        productPrices,
        dealOffers
    ]);
    var ref4;
    var mobileContracts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref;
        return (ref4 = (ref = product.prices) === null || ref === void 0 ? void 0 : ref.mobileContractsV2) !== null && ref4 !== void 0 ? ref4 : [];
    }, [
        product
    ]);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            product: product,
            offers: {
                initialNewOffers: initialNewOffers,
                filteredOffers: filteredOffers,
                filteredOffersForProductHeader: filteredOffersForProductHeader
            },
            allOffers: allOffers,
            allOffersWithActiveAdditives: allOffersWithActiveAdditives,
            priceInfoArticles: prismicArticles === null || prismicArticles === void 0 ? void 0 : prismicArticles.nodes,
            dealOffers: dealOffers,
            mobileContracts: mobileContracts
        };
    }, [
        product,
        initialNewOffers,
        filteredOffers,
        filteredOffersForProductHeader,
        allOffers,
        allOffersWithActiveAdditives,
        prismicArticles === null || prismicArticles === void 0 ? void 0 : prismicArticles.nodes,
        dealOffers,
        mobileContracts
    ]);
    var ref5;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_context__WEBPACK_IMPORTED_MODULE_4__/* .ProductContext.Provider */ .HS.Provider, {
        value: contextValue
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_28__/* .ProductPage */ .em, null, market.login.enabled && isAuthenticated && currentModal === _constants__WEBPACK_IMPORTED_MODULE_25__/* .PRODUCT_ALERT_MODAL_ID */ .U && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_28__/* .Modal */ .u_, {
        id: _constants__WEBPACK_IMPORTED_MODULE_25__/* .PRODUCT_ALERT_MODAL_ID */ .U,
        onRequestClose: function() {
            handleAlertQueryParam();
            dispatch((0,src_components_modal_actions__WEBPACK_IMPORTED_MODULE_22__/* .hideModal */ .VG)());
        },
        width: 500
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductAlertModalContent, {
        productId: product.id,
        hideModal: function() {
            handleAlertQueryParam();
            dispatch((0,src_components_modal_actions__WEBPACK_IMPORTED_MODULE_22__/* .hideModal */ .VG)());
        },
        privacyPolicyUri: privacyPolicyUri || undefined
    })), market.login.enabled && !isAuthenticated && currentModal === _constants__WEBPACK_IMPORTED_MODULE_25__/* .PRODUCT_ALERT_MODAL_ID */ .U && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_modal_login_promo__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
        isOpen: true,
        onRequestClose: function() {
            handleAlertQueryParam();
            dispatch((0,src_components_modal_actions__WEBPACK_IMPORTED_MODULE_22__/* .hideModal */ .VG)());
        }
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_promo_banner_product_during_promo_banner__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
        product: product,
        campaignBanners: campaignBanners
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_breadcrumb__WEBPACK_IMPORTED_MODULE_17__/* .ProductBreadCrumb */ .b, {
        product: product
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_scroll__WEBPACK_IMPORTED_MODULE_8__/* .ScrollElement */ .xL, {
        name: "Top"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_header__WEBPACK_IMPORTED_MODULE_14__/* .ProductPageHeader */ .Z, {
        currentCampaign: currentCampaign,
        isExpertTopRated: product.isExpertTopRated,
        badges: (ref5 = (ref2 = product.sanityBadges) === null || ref2 === void 0 ? void 0 : ref2.filter(function(badge) {
            return badge !== null;
        })) !== null && ref5 !== void 0 ? ref5 : []
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_scroll_top_button__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_section_navigation__WEBPACK_IMPORTED_MODULE_21__/* .ProductNavigation */ .u, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_tabs__WEBPACK_IMPORTED_MODULE_15__/* .ProductTabs */ .c, {
        currentCampaign: currentCampaign,
        routeSection: routeSection
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_campaign_deals__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
        product: product
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_lazy__WEBPACK_IMPORTED_MODULE_7__/* .Lazy */ .o, {
        offset: 100
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_page__WEBPACK_IMPORTED_MODULE_12__/* .PageSection */ .NP, {
        recessed: true
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_recently_visited__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        offset: 1
    })))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_promo_banner_product_before_promo_banner__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
        campaignBanners: campaignBanners
    }))));
};


/***/ }),

/***/ 29813:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ AdPlacementWrapper),
/* harmony export */   "em": () => (/* binding */ ProductPage),
/* harmony export */   "u_": () => (/* binding */ Modal),
/* harmony export */   "zV": () => (/* binding */ BackToTopButton)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var src_components_viewport_tracker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73567);
/* harmony import */ var src_components_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94320);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n\n  /* This is needed or the review action dropdown will be obscured */\n  .pj-ui-panel--row {\n    overflow: visible;\n  }\n\n  /* this is not great */\n  .pj-ui-scroll-link {\n    button:hover {\n      color: ",
        ";\n      text-decoration: underline;\n    }\n  }\n\n  .pj-ui-price-row {\n    width: 100%;\n  }\n\n  .product-header--content {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    right: 10px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    left: 50%;\n    margin-left: ",
        "px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 10px;\n  ",
        ";\n  ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  border: 1px solid ",
        ";\n  cursor: pointer;\n  padding: 10px 12px;\n  visibility: ",
        ";\n  opacity: ",
        ";\n  transition: opacity 0.2s linear;\n  z-index: 4;\n\n  :hover {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n\n  :focus {\n    background-color: ",
        ";\n    box-shadow:\n      ",
        ",\n      0 0 0 4px #000;\n    opacity: 1;\n  }\n\n  :focus:not(:focus-visible) {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100vw;\n      max-width: 100vw;\n      min-height: 30vh;\n      bottom: 0;\n      margin: 0;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    padding: ",
        " ",
        "\n      ",
        " ",
        ";\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n        margin-top: ",
        ";\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n        margin-bottom: ",
        ";\n      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n\n    & > * {\n      ",
        "\n\n      ",
        "\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var ProductPage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.attrs({
    "data-test": "ProductPage"
}).withConfig({
    displayName: "ProductPage",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.callToActionHover;
});
var backToTopButtonDropShadow = "0 1px 3px rgba(0, 0, 0, 0.3)";
var BackToTopButtonComponent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.attrs(function() {
    return {
        type: "button"
    };
}).withConfig({
    displayName: "BackToTopButtonComponent",
    componentId: "sc-0-1"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.hideOutsiderAd */ .BC.hideOutsiderAd(_templateObject1()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.showOutsiderAd */ .BC.showOutsiderAd(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.siteWidth.value */ .bK.siteWidth.value * 0.5 - 200), function(p) {
    return p.theme.colors.yellove500;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.borderRadius */ .bK.borderRadius, backToTopButtonDropShadow, function(p) {
    return p.theme.colors.yellove500;
}, function(props) {
    return props.viewport && props.viewport.top > 500 && props.viewport.scroll.yDirection > 0 ? "visible" : "hidden";
}, function(props) {
    return props.viewport && props.viewport.top > 500 && props.viewport.scroll.yDirection > 0 ? 0.9 : 0;
}, function(p) {
    return p.theme.text.callToActionHover;
}, function(p) {
    return p.theme.colors.yellove500;
}, function(p) {
    return p.theme.colors.yellove500;
}, backToTopButtonDropShadow, backToTopButtonDropShadow);
var BackToTopButton = (0,src_components_viewport_tracker__WEBPACK_IMPORTED_MODULE_2__/* .withViewport */ .s)(BackToTopButtonComponent);
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    displayName: "Modal",
    componentId: "sc-0-2"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject4()));
var AdPlacementWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "AdPlacementWrapper",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8(), props.$marginTop && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), props.$marginBottom && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
});


/***/ }),

/***/ 70018:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ getDealOffersForProduct)
/* harmony export */ });
var getDealOffersForProduct = function(dealInfo, initialOffers) {
    var ref;
    if (!dealInfo) return [];
    var dealInfoOffer = dealInfo.offers[0];
    // Find the offer or alt offer that matches the deal offer
    var offerWithDeal;
    initialOffers.forEach(function(offer) {
        var ref, ref1;
        if (offerWithDeal || ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id) !== dealInfoOffer.shopId) {
            return;
        }
        if (dealInfoOffer.shopOfferId === offer.shopOfferId) {
            offerWithDeal = offer;
            return;
        }
        offerWithDeal = (ref1 = offer.alternativePrices) === null || ref1 === void 0 ? void 0 : ref1.find(function(altOffer) {
            return (altOffer === null || altOffer === void 0 ? void 0 : altOffer.shopOfferId) === dealInfoOffer.shopOfferId;
        });
    });
    var ref1;
    var dealPriceThreshold = (ref1 = offerWithDeal === null || offerWithDeal === void 0 ? void 0 : (ref = offerWithDeal.price) === null || ref === void 0 ? void 0 : ref.exclShipping) !== null && ref1 !== void 0 ? ref1 : 0;
    if (dealPriceThreshold === 0) return [];
    var allDealOffers = [];
    // Add shop ids for all offers with the same or lower price
    initialOffers.forEach(function(offer) {
        var ref, ref1, // Same for alternative offers
        ref2;
        if (!((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id) || !validateAsDeal(offer, dealPriceThreshold)) {
            return;
        }
        allDealOffers.push({
            shopId: ((ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.id) || -1,
            shopOfferId: offer.shopOfferId || ""
        });
        (ref2 = offer.alternativePrices) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(altOffer) {
            if (altOffer && validateAsDeal(altOffer, dealPriceThreshold)) {
                var ref;
                allDealOffers.push({
                    shopId: ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id) || -1,
                    shopOfferId: altOffer.shopOfferId || ""
                });
            }
        });
    });
    return allDealOffers;
};
var validateAsDeal = function(offer, dealPriceThreshold) {
    var ref, ref1;
    if (!((ref = offer.price) === null || ref === void 0 ? void 0 : ref.exclShipping) || !offer.shopOfferId) {
        return false;
    }
    if (offer.price.exclShipping > dealPriceThreshold) {
        return false;
    }
    if (((ref1 = offer.stock) === null || ref1 === void 0 ? void 0 : ref1.status) === "not_in_stock") {
        return false;
    }
    return true;
};


/***/ }),

/***/ 852:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZF": () => (/* binding */ getIsFeatured),
/* harmony export */   "qz": () => (/* binding */ getCampaignPromoBanners),
/* harmony export */   "sD": () => (/* binding */ blurActiveElement),
/* harmony export */   "uY": () => (/* binding */ getCurrentCampaign),
/* harmony export */   "v8": () => (/* binding */ mapAlternativeOffersWithUniqueShipping)
/* harmony export */ });
/* harmony import */ var _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8114);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var getCurrentCampaign = function(activeCampaign, product) {
    return activeCampaign && product.campaigns && product.campaigns.filter(function(c) {
        return c && String(c.id) === String(activeCampaign.id);
    }).map(function(campaign) {
        return _objectSpreadProps(_objectSpread({}, campaign), {
            name: activeCampaign.name || "",
            path: "".concat(activeCampaign.web_uri ? activeCampaign.web_uri.responsive : "").concat(product.category ? "?category=".concat(product.category.id) : ""),
            media: _objectSpread({}, activeCampaign.media)
        });
    }).find(function() {
        return true;
    });
};
var getCampaignPromoBanners = function(campaignBanners) {
    return {
        before: campaignBanners && campaignBanners.active.filter(function(b) {
            return b && b.type === "BEFORE_PROMO_BANNER";
        }),
        during: campaignBanners && campaignBanners.active.filter(function(b) {
            return b && b.type === "DURING_PROMO_BANNER";
        })
    };
};
var blurActiveElement = function() {
    if (_instanceof(document.activeElement, HTMLElement)) {
        document.activeElement.blur();
    }
};
var getIsFeatured = function(offer, alternativeOffer) {
    switch((alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.featuredOverride) || offer.featuredOverride){
        case _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__/* .FeaturedStatusEnum.FEATURED */ .$x.FEATURED:
            return true;
        case _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__/* .FeaturedStatusEnum.NOT_FEATURED */ .$x.NOT_FEATURED:
            return false;
        default:
            var ref;
            return Boolean(((ref = offer.store) === null || ref === void 0 ? void 0 : ref.featured) && offer.externalUri);
    }
};
var mapAlternativeOffersWithUniqueShipping = function(product) {
    var ref, ref1;
    return _objectSpreadProps(_objectSpread({}, product.prices), {
        nodes: (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : ref1.map(function(offer) {
            var ref;
            return _objectSpreadProps(_objectSpread({}, offer), {
                alternativePrices: offer === null || offer === void 0 ? void 0 : (ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.map(function(altOffer) {
                    return _objectSpreadProps(_objectSpread({}, altOffer), {
                        shipping: (altOffer === null || altOffer === void 0 ? void 0 : altOffer.shopHasUniqueShippings) ? altOffer.shipping : offer.shipping
                    });
                })
            });
        })
    });
};


/***/ }),

/***/ 82652:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ mapMobileContractToTrackingItem),
/* harmony export */   "v": () => (/* binding */ mapMobileContractToOffer)
/* harmony export */ });
/* harmony import */ var _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8114);
/* harmony import */ var _product_condition_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60205);
/* harmony import */ var _price_list_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17551);



var mapMobileContractToOffer = function(item) {
    return {
        mobileContract: item,
        name: item.name,
        price: {
            exclShipping: item.pricePerMonth
        },
        offerPrices: {
            price: {
                exclShipping: item.pricePerMonth
            }
        },
        condition: _product_condition_types__WEBPACK_IMPORTED_MODULE_1__/* .ConditionEnum.NEW */ .M.NEW,
        store: item.store,
        featured: true,
        storeInfo: item.store && item.store.providedByStore ? item.store.providedByStore.generalInformation : null,
        rating: (0,_price_list_common__WEBPACK_IMPORTED_MODULE_2__/* .getStoreRating */ ._5)(item.store),
        externalUri: item.externalUri,
        authorizedDealer: false,
        isInternationalPrice: false,
        ourChoiceScore: 0,
        dealOffers: [],
        featuredOverride: _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__/* .FeaturedStatusEnum.UNKNOWN */ .$x.UNKNOWN
    };
};
var mapMobileContractToTrackingItem = function(item) {
    return {
        featured: true,
        dealOffers: [],
        featuredOverride: _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__/* .FeaturedStatusEnum.UNKNOWN */ .$x.UNKNOWN,
        ourChoiceScore: 0,
        store: item.store,
        name: item.name,
        price: {
            exclShipping: item.pricePerMonth
        },
        offerPrices: {
            price: {
                exclShipping: item.pricePerMonth
            }
        },
        primaryMarket: true,
        condition: _product_condition_types__WEBPACK_IMPORTED_MODULE_1__/* .ConditionEnum.NEW */ .M.NEW
    };
};


/***/ }),

/***/ 61891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KJ": () => (/* binding */ getFirstMonthPriceLabel),
/* harmony export */   "WL": () => (/* binding */ getRegularMonthlyPrice),
/* harmony export */   "Yn": () => (/* binding */ getTotalPriceLabel),
/* harmony export */   "lx": () => (/* binding */ getFirstMonthPrice),
/* harmony export */   "n9": () => (/* binding */ getAvarageMonthPriceLabel)
/* harmony export */ });
/* harmony import */ var src_components_currency__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65634);

var getMonthlyPriceLabel = function(price, market, t) {
    return "".concat(price.toLocaleString(market.localeStandard), " ").concat(t("common", "price.currency-per-month"));
};
// The price for the first month (which is campaign price if there is a campaign + hardware price)
var getFirstMonthPrice = function(mobileContract) {
    return mobileContract.campaignDurationMonths > 0 ? mobileContract.campaignPricePerMonth + mobileContract.hardwarePricePerMonth : mobileContract.pricePerMonth + mobileContract.hardwarePricePerMonth;
};
// The ordinary monthly price (after the campaign period)
var getRegularMonthlyPrice = function(mobileContract) {
    return mobileContract.pricePerMonth + mobileContract.hardwarePricePerMonth;
};
// The comparable monthly price (avarage cost per month over the contract period)
var getAvarageMonthlyPrice = function(mobileContract) {
    return Math.round(mobileContract.totalPrice / mobileContract.contractMonths);
};
var getFirstMonthPriceLabel = function(mobileContract, market, t) {
    var price = getFirstMonthPrice(mobileContract);
    return getMonthlyPriceLabel(price, market, t);
};
var getAvarageMonthPriceLabel = function(mobileContract, market, t) {
    var price = getAvarageMonthlyPrice(mobileContract);
    return getMonthlyPriceLabel(price, market, t);
};
var getTotalPriceLabel = function(mobileContract, market) {
    var ref;
    return (ref = (0,src_components_currency__WEBPACK_IMPORTED_MODULE_0__/* .formatCurrency */ .xG)(mobileContract.totalPrice, market === null || market === void 0 ? void 0 : market.code, false, "", false)) !== null && ref !== void 0 ? ref : "";
};


/***/ }),

/***/ 17551:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ot": () => (/* binding */ replaceMainOfferWithAlternativeOffer),
/* harmony export */   "_5": () => (/* binding */ getStoreRating),
/* harmony export */   "a0": () => (/* binding */ getViewSize)
/* harmony export */ });
/* harmony import */ var src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51362);
/* harmony import */ var _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8114);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var replaceMainOfferWithAlternativeOffer = function(offer, alternativeOffer) {
    if (!alternativeOffer) return offer;
    var newAlternatives = [
        alternativeOffer
    ].concat(_toConsumableArray(offer.alternativePrices.filter(function(alt) {
        return alt !== alternativeOffer;
    })));
    return _objectSpreadProps(_objectSpread({}, alternativeOffer), {
        __typename: offer.__typename,
        authorizedDealer: offer.authorizedDealer,
        featured: offer.featured,
        store: offer.store,
        unfilteredShippings: offer.unfilteredShippings,
        dealOffers: offer.dealOffers,
        alternativePrices: newAlternatives
    });
};
var getStoreRating = function(store) {
    var ref;
    return (store === null || store === void 0 ? void 0 : (ref = store.userReviewSummary) === null || ref === void 0 ? void 0 : ref.rating) ? src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_0__/* ["default"].convert */ .Z.convert(store.userReviewSummary.rating) : undefined;
};
var getViewSize = function(viewport) {
    if (viewport.isDesktop) return _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_1__/* .ViewSize.LARGE */ .du.LARGE;
    if (viewport.isTablet) return _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_1__/* .ViewSize.MEDIUM */ .du.MEDIUM;
    return _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_1__/* .ViewSize.SMALL */ .du.SMALL;
};


/***/ }),

/***/ 31288:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hS": () => (/* binding */ filterOffers),
  "k2": () => (/* binding */ mapPriceListToExtendedPrices)
});

// UNUSED EXPORTS: filterOffersUsingSingleFilter, filterShippingInfoInOffers

// EXTERNAL MODULE: ./src/areas/product/utils/index.ts
var utils = __webpack_require__(852);
;// CONCATENATED MODULE: ./src/areas/product/utils/price-list/shipping-sort.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var getSortedShipping = function(shippings, isSortByFastest, filters) {
    var isInstorePickupSelectedByUser = filters.some(function(f) {
        var ref;
        return f.type === "shipping-delivery-method" && ((ref = f.selection) === null || ref === void 0 ? void 0 : ref.includes("INSTORE_PICKUP"));
    });
    // Instore pickup should not be counted as a shipping method when sorting, unless specifically selected
    var filteredShippings = shippings;
    if (!isInstorePickupSelectedByUser) {
        filteredShippings = _toConsumableArray(shippings).filter(function(s) {
            return s.deliveryMethod !== "INSTORE_PICKUP";
        });
    }
    if (filteredShippings.length === 0) {
        return undefined;
    }
    var sortedShippings = sortShippings(filteredShippings, isSortByFastest ? sortByFastest : sortByCheapest, isSortByFastest ? sortByCheapest : sortByFastest);
    return sortedShippings[0];
};
var sortByCheapest = function(s1, s2) {
    if (s1.shippingCost === undefined && s2.shippingCost !== undefined) return 1;
    if (s1.shippingCost !== undefined && s2.shippingCost === undefined) return -1;
    if (s1.shippingCost === undefined && s2.shippingCost === undefined) return 0;
    return s1.shippingCost - s2.shippingCost;
};
var sortByFastest = function(s1, s2) {
    if (s1.deliveryDays === null && s2.deliveryDays !== null) return 1;
    if (s1.deliveryDays !== null && s2.deliveryDays === null) return -1;
    if (s1.deliveryDays === null && s2.deliveryDays === null) return 0;
    if (s1.deliveryDays.min !== s2.deliveryDays.min) {
        return s1.deliveryDays.min - s2.deliveryDays.min;
    }
    return s1.deliveryDays.max - s2.deliveryDays.max;
};
var sortShippings = function(shippings, primarySort, secondarySort) {
    if (shippings.length === 0) {
        return shippings;
    }
    return _toConsumableArray(shippings).sort(function(s1, s2) {
        var primarySortResult = primarySort(s1, s2);
        if (primarySortResult !== 0) {
            return primarySortResult;
        }
        return secondarySort(s1, s2);
    });
};

// EXTERNAL MODULE: ./src/areas/product/utils/price-list/common.ts
var common = __webpack_require__(17551);
;// CONCATENATED MODULE: ./src/areas/product/utils/price-list/filtering.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var filterOffer = function(offer, filter) {
    // Keep offers with missing info if we have a function defined for it
    return filter.missingInfoFn ? filter.filterFn(offer, filter.selection) || filter.missingInfoFn(offer) : filter.filterFn(offer, filter.selection);
};
var tryFindNewMainOffer = function(offer, filter) {
    var ref;
    var mainOfferIsValid = filter.filterFn(offer, filter.selection);
    if (mainOfferIsValid) return offer;
    var mainOfferHasMissingInfo = filter.missingInfoFn && filter.missingInfoFn(offer);
    if (!((ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.length)) {
        if (mainOfferHasMissingInfo) return offer;
        return null;
    }
    var firstValidAlternativeOffer = offer.alternativePrices.find(function(alt) {
        return filter.filterFn(alt, filter.selection);
    });
    // If no valid alt offer but a main offer with missing info, return the main offer
    if (!firstValidAlternativeOffer && mainOfferHasMissingInfo) {
        return offer;
    }
    // If no valid alt offer, try finding one with missing info
    if (!firstValidAlternativeOffer && filter.missingInfoFn) {
        firstValidAlternativeOffer = offer.alternativePrices.find(function(alt) {
            return filter.missingInfoFn(alt);
        });
    }
    // If no offer (incl. missing info) is valid, return no offer
    if (!firstValidAlternativeOffer) {
        return null;
    }
    return (0,common/* replaceMainOfferWithAlternativeOffer */.Ot)(offer, firstValidAlternativeOffer);
};
var filterOffersUsingSingleFilter = function(offers, filter) {
    if (!offers.length || !filter.active) {
        return offers;
    }
    if (!filter.filterAlternativeOffers || offers.every(function(offer) {
        var ref;
        return !((ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.length);
    })) {
        return offers.filter(function(mainOffer) {
            return filterOffer(mainOffer, filter);
        });
    }
    // Filtering alternative offers
    var filteredOffers = [];
    offers.forEach(function(offer) {
        var ref;
        var filteredAlternatives = (ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.filter(function(alt) {
            return filterOffer(alt, filter);
        });
        if (!(filteredAlternatives === null || filteredAlternatives === void 0 ? void 0 : filteredAlternatives.length)) {
            return;
        }
        var offerWithFilteredAlternatives = _objectSpreadProps(_objectSpread({}, offer), {
            alternativePrices: filteredAlternatives
        });
        var newMainOffer = tryFindNewMainOffer(offerWithFilteredAlternatives, filter);
        if (newMainOffer) {
            filteredOffers.push(newMainOffer);
        }
    });
    return filteredOffers;
};
var filterShippingInfoInOffers = function(offers, filters) {
    var applicapleFilters = filters.filter(function(filter) {
        return filter.active && filter.filterShippingFn;
    });
    var filteredOffers = offers.map(function(offer) {
        var ref;
        return _objectSpreadProps(_objectSpread({}, filterShippingInfoInSingleOffer(offer, applicapleFilters)), {
            unfilteredShippings: offer === null || offer === void 0 ? void 0 : (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes
        });
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = filteredOffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var offer = _step.value;
            if (offer.alternativePrices) {
                offer.alternativePrices = offer.alternativePrices.map(function(altOffer) {
                    return filterShippingInfoInSingleOffer(altOffer, applicapleFilters);
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return filteredOffers;
};
var filterShippingInfoInSingleOffer = function(offer, filters) {
    if (!offer.shipping || !offer.shipping.nodes) {
        return offer;
    }
    var shippingNodes = offer.shipping.nodes;
    var filteredShippings = shippingNodes.filter(function(shipping) {
        return filters.every(function(filter) {
            return filter.filterShippingFn(shipping, filter.selection);
        });
    });
    var cheapest = getSortedShipping(filteredShippings, false, filters);
    var fastest = getSortedShipping(filteredShippings, true, filters);
    return _objectSpreadProps(_objectSpread({}, offer), {
        shipping: {
            cheapest: cheapest,
            fastest: fastest,
            nodes: filteredShippings
        }
    });
};
/**
 * Filters offers in a price list based on a collection of filters
 */ var filterOffers = function(filters, priceList, deals) {
    var filteredOffers = mapPriceListToExtendedPrices(priceList, deals);
    filters.forEach(function(filter) {
        filteredOffers = filterOffersUsingSingleFilter(filteredOffers, filter);
    });
    return filterShippingInfoInOffers(filteredOffers, filters);
};
/**
 * Creates a collection of ExtendedPrice from a price list
 */ var mapPriceListToExtendedPrices = function(priceList, deals) {
    var ref;
    var offers = priceList === null || priceList === void 0 ? void 0 : (ref = priceList.nodes) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
        return x;
    });
    var ref1;
    var extendedPrices = offers === null || offers === void 0 ? void 0 : offers.map(function(offer) {
        return _objectSpreadProps(_objectSpread({}, offer), {
            featured: (0,utils/* getIsFeatured */.ZF)(offer),
            dealOffers: (ref1 = deals === null || deals === void 0 ? void 0 : deals.filter(function(deal) {
                var ref;
                return deal.shopId === ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id);
            })) !== null && ref1 !== void 0 ? ref1 : []
        });
    });
    return extendedPrices !== null && extendedPrices !== void 0 ? extendedPrices : [];
};


/***/ }),

/***/ 14792:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ getFiltersConfig)
/* harmony export */ });
/* unused harmony export isOfferWithMissingShippingInfo */
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34057);

var isOfferWithShippingInfoAndSelections = function(offer, selection) {
    var ref;
    return offer && "shipping" in offer && ((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes) && selection && selection.length > 0;
};
var isOfferWithMissingShippingInfo = function(offer) {
    var ref, ref1;
    return !(offer && "shipping" in offer) || !((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes) || !(((ref1 = offer.shipping) === null || ref1 === void 0 ? void 0 : ref1.nodes.length) > 0);
};
var getFiltersConfig = function() {
    return [
        {
            label: "display.price_includes_shipping",
            translationPrefix: "common",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.PRICES_INC_SHIPPING */ .vA.PRICES_INC_SHIPPING,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.OFFERLIST_HEADER */ .jm.OFFERLIST_HEADER,
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            filterFn: function(offer) {
                var ref;
                return Boolean(offer === null || offer === void 0 ? void 0 : (ref = offer.price) === null || ref === void 0 ? void 0 : ref.inclShipping);
            },
            missingInfoFn: function(offer) {
                var ref;
                return !(offer === null || offer === void 0 ? void 0 : (ref = offer.price) === null || ref === void 0 ? void 0 : ref.inclShipping);
            },
            filterAlternativeOffers: true,
            active: false,
            treatUnfeaturedAsMissingInfo: true
        },
        {
            label: "price-filter.in-stock-label",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.IN_STOCK */ .vA.IN_STOCK,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU,
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.OFFERLIST_HEADER */ .jm.OFFERLIST_HEADER
            ],
            subPlacement: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUISubPlacementEnum.SHOW_ONLY */ .$4.SHOW_ONLY,
            filterFn: function(offer) {
                var ref;
                return Boolean((offer === null || offer === void 0 ? void 0 : (ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) === "in_stock");
            },
            missingInfoFn: function(offer) {
                var ref, ref1;
                return Boolean(!(offer === null || offer === void 0 ? void 0 : (ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) || (offer === null || offer === void 0 ? void 0 : (ref1 = offer.stock) === null || ref1 === void 0 ? void 0 : ref1.status) === "unknown");
            },
            filterAlternativeOffers: true,
            active: false,
            treatUnfeaturedAsMissingInfo: false
        },
        {
            label: "price-filter.authorized-dealer",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.AUTHORIZED_DEALER */ .vA.AUTHORIZED_DEALER,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            subPlacement: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUISubPlacementEnum.SHOW_ONLY */ .$4.SHOW_ONLY,
            filterFn: function(offer) {
                return Boolean(offer && "authorizedDealer" in offer && offer.authorizedDealer);
            },
            filterAlternativeOffers: false,
            active: false
        },
        {
            label: "price-filter.international",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.INTERNATIONAL */ .vA.INTERNATIONAL,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            subPlacement: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUISubPlacementEnum.ADDITIVE */ .$4.ADDITIVE,
            filterFn: function(offer) {
                return Boolean(offer === null || offer === void 0 ? void 0 : offer.primaryMarket);
            },
            filterAlternativeOffers: true,
            active: true,
            additive: true
        },
        {
            label: "price-filter.not-for-sale",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.NOT_FOR_SALE */ .vA.NOT_FOR_SALE,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            subPlacement: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUISubPlacementEnum.ADDITIVE */ .$4.ADDITIVE,
            filterFn: function(offer) {
                var ref;
                return Boolean(offer && (offer === null || offer === void 0 ? void 0 : (ref = offer.availability) === null || ref === void 0 ? void 0 : ref.condition) !== "NotAvailableForOrder");
            },
            filterAlternativeOffers: true,
            active: true,
            additive: true
        },
        {
            label: "",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.VARIANT_SIZE */ .vA.VARIANT_SIZE,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.PRODUCT_HEADER */ .jm.PRODUCT_HEADER
            ],
            filterFn: function(offer, selection) {
                var ref;
                return Boolean(offer && (offer === null || offer === void 0 ? void 0 : (ref = offer.variantInfo) === null || ref === void 0 ? void 0 : ref.size) && (selection === null || selection === void 0 ? void 0 : selection.includes(offer.variantInfo.size)));
            },
            missingInfoFn: function(offer) {
                var ref;
                return !(offer === null || offer === void 0 ? void 0 : (ref = offer.variantInfo) === null || ref === void 0 ? void 0 : ref.size);
            },
            filterAlternativeOffers: true,
            active: false,
            selection: [],
            initialSelection: []
        },
        {
            label: "",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.VARIANT_COLOR */ .vA.VARIANT_COLOR,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.PRODUCT_HEADER */ .jm.PRODUCT_HEADER
            ],
            filterFn: function(offer, selection) {
                var ref, ref1;
                return Boolean((selection === null || selection === void 0 ? void 0 : selection.length) && (offer === null || offer === void 0 ? void 0 : (ref = offer.variantInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.some(function(color) {
                    return selection.includes(color);
                })));
            },
            missingInfoFn: function(offer) {
                var ref, ref1;
                return !(offer === null || offer === void 0 ? void 0 : (ref = offer.variantInfo) === null || ref === void 0 ? void 0 : ref.colors) || (offer === null || offer === void 0 ? void 0 : (ref1 = offer.variantInfo) === null || ref1 === void 0 ? void 0 : ref1.colors.length) < 1;
            },
            filterAlternativeOffers: true,
            active: false,
            selection: [],
            initialSelection: []
        },
        {
            label: "",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.CONDITION */ .vA.CONDITION,
            placement: [],
            filterFn: function(offer, selection) {
                return Boolean((offer === null || offer === void 0 ? void 0 : offer.condition) && (selection === null || selection === void 0 ? void 0 : selection.includes(offer === null || offer === void 0 ? void 0 : offer.condition)));
            },
            filterAlternativeOffers: true,
            active: false,
            selection: [],
            initialSelection: []
        },
        {
            label: "store.delivery-options",
            translationPrefix: "store",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.DELIVERY_METHOD */ .vA.DELIVERY_METHOD,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            filterFn: function(offer, selection) {
                var ref;
                return Boolean(isOfferWithShippingInfoAndSelections(offer, selection) && ((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
                    return (node === null || node === void 0 ? void 0 : node.deliveryMethod) && (selection === null || selection === void 0 ? void 0 : selection.includes(node.deliveryMethod));
                })));
            },
            filterShippingFn: function(shipping, selection) {
                return Boolean(selection && shipping.deliveryMethod && selection.includes(shipping.deliveryMethod));
            },
            missingInfoFn: isOfferWithMissingShippingInfo,
            filterAlternativeOffers: true,
            active: false,
            selection: []
        },
        {
            label: "",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.CARRIERS */ .vA.CARRIERS,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            filterFn: function(offer, selection) {
                var ref;
                return Boolean(isOfferWithShippingInfoAndSelections(offer, selection) && ((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
                    return (node === null || node === void 0 ? void 0 : node.carrier) && (selection === null || selection === void 0 ? void 0 : selection.includes(node.carrier));
                })));
            },
            filterShippingFn: function(shipping, selection) {
                return Boolean(selection && shipping.carrier && selection.includes(shipping.carrier));
            },
            missingInfoFn: isOfferWithMissingShippingInfo,
            filterAlternativeOffers: true,
            active: false,
            selection: []
        }
    ];
};


/***/ }),

/***/ 17307:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": () => (/* binding */ genericSort),
/* harmony export */   "Sr": () => (/* binding */ SortDirection),
/* harmony export */   "bo": () => (/* binding */ sortOffersByPrice)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34057);
/* harmony import */ var src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60205);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var ALMOST_INFINATE_SHIPPING_COST = 1000000;
var SortDirection;
(function(SortDirection) {
    SortDirection[SortDirection["Ascending"] = 0] = "Ascending";
    SortDirection[SortDirection["Descending"] = 1] = "Descending";
})(SortDirection || (SortDirection = {}));
var sortByPriceProp = function(priceDisplay) {
    var resolver = priceDisplay === _types__WEBPACK_IMPORTED_MODULE_0__/* .PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */ .wB.PRICE_INCLUDES_SHIPPING ? function(offer) {
        var ref;
        return getPriceInclShipping(offer) || (offer === null || offer === void 0 ? void 0 : (ref = offer.price) === null || ref === void 0 ? void 0 : ref.exclShipping);
    } : function(offer) {
        return offer.price && offer.price.exclShipping;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Ascending
    };
};
var sortByShippingPriceProp = function() {
    var resolver = function(offer) {
        return getCheapestShippingCost(offer);
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Ascending
    };
};
var sortByConditionProp = function() {
    var resolver = function(offer) {
        return offer.condition === src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__/* .ConditionEnum.NEW */ .M.NEW ? 0 : 1;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Ascending
    };
};
var sortByStockStatusProp = function() {
    var resolver = function(offer) {
        var ref;
        return ((ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) === "in_stock" ? 0 : 1;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Ascending
    };
};
var sortByUserReviewProp = function() {
    var resolver = function(offer) {
        var ref, ref1;
        return ((ref = offer.store) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.rating) || 0;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Descending
    };
};
var sortByUserReviewCountProp = function() {
    var resolver = function(offer) {
        var ref, ref1;
        return ((ref = offer.store) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.countTotal) || 0;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Descending
    };
};
var getPriceInclShipping = function(offer) {
    var ref;
    var ref1;
    var basePrice = (ref1 = (ref = offer.price) === null || ref === void 0 ? void 0 : ref.exclShipping) !== null && ref1 !== void 0 ? ref1 : Infinity;
    var cheapestShipping = getCheapestShippingCost(offer);
    return basePrice + cheapestShipping;
};
var getCheapestShippingCost = function(offer) {
    var ref, ref1;
    var ref2;
    return (ref2 = (ref = offer.shipping) === null || ref === void 0 ? void 0 : (ref1 = ref.cheapest) === null || ref1 === void 0 ? void 0 : ref1.shippingCost) !== null && ref2 !== void 0 ? ref2 : ALMOST_INFINATE_SHIPPING_COST;
};
var sortOffersByPrice = function(priceDisplay, prices) {
    var priceSort = sortByPriceProp(priceDisplay);
    var shippingPriceProp = sortByShippingPriceProp();
    var conditionProp = sortByConditionProp();
    var stockStatusProp = sortByStockStatusProp();
    var userReviewProp = sortByUserReviewProp();
    var userReviewCountProp = sortByUserReviewCountProp();
    return genericSort(prices, priceSort, shippingPriceProp, conditionProp, stockStatusProp, userReviewProp, userReviewCountProp);
};
var genericSort = function(prices, primaryProp, secondaryProp, thirdProp, fouthProp, fifthProp, sixthProp) {
    return _toConsumableArray(prices).sort(function(a, b) {
        var firstSort = orderItem(a, b, primaryProp);
        if (firstSort !== 0) {
            return firstSort;
        }
        if (secondaryProp) {
            var secondSort = orderItem(a, b, secondaryProp);
            if (secondSort !== 0) {
                return secondSort;
            }
        }
        if (thirdProp) {
            var thirdSort = orderItem(a, b, thirdProp);
            if (thirdSort !== 0) {
                return thirdSort;
            }
        }
        if (fouthProp) {
            var fourthSort = orderItem(a, b, fouthProp);
            if (fourthSort !== 0) {
                return fourthSort;
            }
        }
        if (fifthProp) {
            var fifthSort = orderItem(a, b, fifthProp);
            if (fifthSort !== 0) {
                return fifthSort;
            }
        }
        if (sixthProp) {
            var sixthSort = orderItem(a, b, sixthProp);
            if (sixthSort !== 0) {
                return sixthSort;
            }
        }
        return 0;
    });
};
var orderItem = function(a, b, prop) {
    var aProp = prop.resolver(a);
    var bProp = prop.resolver(b);
    if (aProp < bProp) {
        return prop.sortDirection === SortDirection.Descending ? 1 : -1;
    }
    if (aProp > bProp) {
        return prop.sortDirection === SortDirection.Descending ? -1 : 1;
    }
    return 0;
};


/***/ }),

/***/ 93476:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": () => (/* binding */ getSplitOfferlist),
/* harmony export */   "oV": () => (/* binding */ getListLimits)
/* harmony export */ });
/* unused harmony export LIST_LIMIT */
var offerHasFilteredInfo = function(offer, filters) {
    return filters.every(function(filter) {
        if (filter.treatUnfeaturedAsMissingInfo && !offer.featured) {
            return false;
        }
        return !filter.missingInfoFn || !filter.missingInfoFn(offer);
    });
};
var getSplitOfferlist = function(offers, filters) {
    var splittedList = {
        mainList: [],
        secondaryList: []
    };
    if (!offers.length) {
        return splittedList;
    }
    if (!filters.length) {
        splittedList.mainList = offers;
        return splittedList;
    }
    offers.forEach(function(offer) {
        if (offerHasFilteredInfo(offer, filters)) {
            splittedList.mainList.push(offer);
        } else {
            splittedList.secondaryList.push(offer);
        }
    });
    return splittedList;
};
var LIST_LIMIT = 5;
var getListLimits = function() {
    return {
        mainListLimit: LIST_LIMIT,
        secondaryListLimit: LIST_LIMIT
    };
};


/***/ }),

/***/ 34057:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$4": () => (/* binding */ FilterUISubPlacementEnum),
/* harmony export */   "$z": () => (/* binding */ SustainabilityEnum),
/* harmony export */   "hs": () => (/* binding */ EligibilityEnum),
/* harmony export */   "jm": () => (/* binding */ FilterUIPlacementEnum),
/* harmony export */   "vA": () => (/* binding */ FilterType),
/* harmony export */   "wB": () => (/* binding */ PriceDisplayEnum)
/* harmony export */ });
/* unused harmony exports SortOptionEnum, SortTypeEnum */
var PriceDisplayEnum;
(function(PriceDisplayEnum) {
    PriceDisplayEnum["PRICE"] = "price-excludes-shipping";
    PriceDisplayEnum["PRICE_INCLUDES_SHIPPING"] = "price_includes_shipping";
})(PriceDisplayEnum || (PriceDisplayEnum = {}));
var SortOptionEnum;
(function(SortOptionEnum) {
    SortOptionEnum["PRICE"] = "price";
    SortOptionEnum["PRICEANDSTOCKSTATUS"] = "price_in_stock";
})(SortOptionEnum || (SortOptionEnum = {}));
var FilterType;
(function(FilterType) {
    FilterType["PRICES_INC_SHIPPING"] = "prices_inc_shipping";
    FilterType["IN_STOCK"] = "in_stock";
    FilterType["AUTHORIZED_DEALER"] = "authorized_dealer";
    FilterType["PICKUP_ONLY"] = "pickup_only";
    FilterType["INTERNATIONAL"] = "international";
    FilterType["NOT_FOR_SALE"] = "not_for_sale";
    FilterType["VARIANT_SIZE"] = "variant_size";
    FilterType["VARIANT_COLOR"] = "variant_color";
    FilterType["CONDITION"] = "condition";
    FilterType["DELIVERY_METHOD"] = "shipping-delivery-method";
    FilterType["CARRIERS"] = "shipping-carriers";
})(FilterType || (FilterType = {}));
var SortTypeEnum;
(function(SortTypeEnum) {
    SortTypeEnum["LOWEST_PRICE"] = "lowest-price";
    SortTypeEnum["FASTEST_DELIVERY"] = "fastest-delivery";
})(SortTypeEnum || (SortTypeEnum = {}));
var FilterUIPlacementEnum;
(function(FilterUIPlacementEnum) {
    FilterUIPlacementEnum[FilterUIPlacementEnum["PRODUCT_HEADER"] = 0] = "PRODUCT_HEADER";
    FilterUIPlacementEnum[FilterUIPlacementEnum["FILTER_MENU"] = 1] = "FILTER_MENU";
    FilterUIPlacementEnum[FilterUIPlacementEnum["OFFERLIST_HEADER"] = 2] = "OFFERLIST_HEADER";
})(FilterUIPlacementEnum || (FilterUIPlacementEnum = {}));
var FilterUISubPlacementEnum;
(function(FilterUISubPlacementEnum) {
    FilterUISubPlacementEnum[FilterUISubPlacementEnum["SHOW_ONLY"] = 0] = "SHOW_ONLY";
    FilterUISubPlacementEnum[FilterUISubPlacementEnum["ADDITIVE"] = 1] = "ADDITIVE";
})(FilterUISubPlacementEnum || (FilterUISubPlacementEnum = {}));
var SustainabilityEnum;
(function(SustainabilityEnum) {
    SustainabilityEnum["SUSTAINABILITY_UNKNOWN"] = "SUSTAINABILITY_UNKNOWN";
    SustainabilityEnum["NOT_SUSTAINABLE"] = "NOT_SUSTAINABLE";
    SustainabilityEnum["SUSTAINABLE"] = "SUSTAINABLE";
})(SustainabilityEnum || (SustainabilityEnum = {}));
var EligibilityEnum;
(function(EligibilityEnum) {
    EligibilityEnum["ELIGIBILITY_UNKNOWN"] = "ELIGIBILITY_UNKNOWN";
    EligibilityEnum["ALL"] = "ALL";
    EligibilityEnum["MEMBERS"] = "MEMBERS";
})(EligibilityEnum || (EligibilityEnum = {}));


/***/ }),

/***/ 7001:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": () => (/* binding */ getConditionName)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60205);

var getConditionName = function(type, t) {
    switch(type){
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.NEW */ .M.NEW:
            return t("product", "condition-type.new");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.DEMO */ .M.DEMO:
            return t("product", "condition-type.demo");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.REFURBISHED */ .M.REFURBISHED:
            return t("product", "condition-type.refurbished");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.DAMAGED_PACKAGING */ .M.DAMAGED_PACKAGING:
            return t("product", "condition-type.damaged-packaging");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.ALMOST_NEW */ .M.ALMOST_NEW:
            return t("product", "condition-type.almostnew");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.USED */ .M.USED:
        default:
            return t("product", "condition-type.used");
    }
};


/***/ }),

/***/ 60205:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ ConditionEnum)
/* harmony export */ });
var ConditionEnum;
(function(ConditionEnum) {
    ConditionEnum["NEW"] = "new";
    ConditionEnum["USED"] = "used";
    ConditionEnum["DEMO"] = "demo";
    ConditionEnum["REFURBISHED"] = "refurbished";
    ConditionEnum["DAMAGED_PACKAGING"] = "damagedpackaging";
    ConditionEnum["ALMOST_NEW"] = "almostnew";
})(ConditionEnum || (ConditionEnum = {}));


/***/ }),

/***/ 79532:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ CampaignBannerTypeEnum)
/* harmony export */ });
var CampaignBannerTypeEnum;
(function(CampaignBannerTypeEnum) {
    CampaignBannerTypeEnum["BANNER_LOGO_BIG"] = "BANNER_LOGO_BIG";
    CampaignBannerTypeEnum["HEADER_PROMO_BANNER"] = "HEADER_PROMO_BANNER";
    CampaignBannerTypeEnum["RFE_SEARCH_TAKEOVER"] = "RFE_SEARCH_TAKEOVER";
    CampaignBannerTypeEnum["LANDING_PAGE_BIG"] = "LANDING_PAGE_BIG";
    CampaignBannerTypeEnum["BEFORE_PROMO_BANNER"] = "BEFORE_PROMO_BANNER";
    CampaignBannerTypeEnum["DURING_PROMO_BANNER"] = "DURING_PROMO_BANNER";
    CampaignBannerTypeEnum["SOTY_PROMO"] = "SOTY_PROMO";
    CampaignBannerTypeEnum["SOTY_ACTIVE"] = "SOTY_ACTIVE";
    CampaignBannerTypeEnum["SOTY_FINISHED"] = "SOTY_FINISHED";
})(CampaignBannerTypeEnum || (CampaignBannerTypeEnum = {}));


/***/ }),

/***/ 50313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yz": () => (/* binding */ useDealsContext),
/* harmony export */   "x9": () => (/* binding */ DealsStateProvider)
/* harmony export */ });
/* unused harmony exports DealsContext, extractCampaignData */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96705);
/* harmony import */ var src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26016);
/* harmony import */ var _components_deals_header_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79532);




var DealsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    activeCampaigns: [],
    campaign: undefined,
    dailyDeals: undefined,
    headerImage: null,
    inactiveCampaignTargetDate: undefined,
    isActiveCampaign: false
});
var useDealsContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(DealsContext);
};
var extractCampaignData = function(campaignData) {
    var ref, ref1;
    var campaign = campaignData === null || campaignData === void 0 ? void 0 : campaignData.campaign;
    var campaigns = (campaignData === null || campaignData === void 0 ? void 0 : campaignData.campaigns) || [];
    var isActiveCampaign = (campaign === null || campaign === void 0 ? void 0 : campaign.state) === _types__WEBPACK_IMPORTED_MODULE_1__/* .CampaignStateEnum.ACTIVE */ .k.ACTIVE;
    var activeCampaigns = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.id) !== (campaign === null || campaign === void 0 ? void 0 : campaign.id) && (item === null || item === void 0 ? void 0 : item.state) === _types__WEBPACK_IMPORTED_MODULE_1__/* .CampaignStateEnum.ACTIVE */ .k.ACTIVE;
    });
    var dailyDeals = activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.find(function(c) {
        return (c === null || c === void 0 ? void 0 : c.id) === src_globals_helpers_campaign_campaign_ids__WEBPACK_IMPORTED_MODULE_2__/* .CampaignIdEnum.DAILY_DEALS_ID */ .pw.DAILY_DEALS_ID;
    });
    var inactiveCampaignTargetDate = (campaign === null || campaign === void 0 ? void 0 : campaign.countdown) || (campaign === null || campaign === void 0 ? void 0 : campaign.start) ? Number((campaign === null || campaign === void 0 ? void 0 : campaign.countdown) || (campaign === null || campaign === void 0 ? void 0 : campaign.start)) : undefined;
    var headerImage = (campaign === null || campaign === void 0 ? void 0 : (ref = campaign.banners) === null || ref === void 0 ? void 0 : ref.length) ? ((ref1 = campaign.banners.find(function(banner) {
        return (banner === null || banner === void 0 ? void 0 : banner.type.toUpperCase()) === _components_deals_header_types__WEBPACK_IMPORTED_MODULE_3__/* .CampaignBannerTypeEnum.BANNER_LOGO_BIG */ .E.BANNER_LOGO_BIG;
    })) === null || ref1 === void 0 ? void 0 : ref1.imageUrl) || "" : null;
    return {
        activeCampaigns: activeCampaigns,
        campaign: campaign,
        dailyDeals: dailyDeals,
        headerImage: headerImage,
        inactiveCampaignTargetDate: inactiveCampaignTargetDate,
        isActiveCampaign: isActiveCampaign
    };
};
var DealsStateProvider = function(param) {
    var children = param.children, campaignData = param.campaignData;
    var initialData = extractCampaignData(campaignData);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DealsContext.Provider, {
        value: initialData
    }, children);
};


/***/ }),

/***/ 96705:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ CampaignStateEnum)
/* harmony export */ });
var CampaignStateEnum;
(function(CampaignStateEnum) {
    CampaignStateEnum["ENDED"] = "ENDED";
    CampaignStateEnum["ACTIVE"] = "ACTIVE";
    CampaignStateEnum["UPCOMING"] = "UPCOMING";
})(CampaignStateEnum || (CampaignStateEnum = {}));


/***/ }),

/***/ 4462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ getPreviousPrice)
/* harmony export */ });
var getPreviousPrice = function(priceDrop, price, memberPrice) {
    var priceDropDecimal = priceDrop / 100;
    return (memberPrice || price) / (1 - priceDropDecimal);
};


/***/ }),

/***/ 76738:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": () => (/* binding */ usePromotionContext),
/* harmony export */   "Mv": () => (/* binding */ PromotionStateProvider)
/* harmony export */ });
/* unused harmony export PromotionContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _shared_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);


var initialState = {
    id: "",
    title: "",
    description: "",
    promotionUrl: "",
    imageUrl: undefined,
    numberOfProducts: 0,
    owner: {
        id: "",
        name: "",
        type: _shared_types__WEBPACK_IMPORTED_MODULE_1__/* .PromotionOwnerTypeEnum.SHOP */ .BB.SHOP
    }
};
var PromotionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialState);
var usePromotionContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PromotionContext);
};
var PromotionStateProvider = function(param) {
    var children = param.children, promotionInfo = param.promotionInfo;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionContext.Provider, {
        value: promotionInfo
    }, children);
};


/***/ }),

/***/ 97620:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": () => (/* binding */ getPromotionTimespan)
/* harmony export */ });
var getFormattedDate = function(date, locale) {
    if (!date) {
        return "";
    }
    var options = {
        day: "numeric",
        month: "short"
    };
    var formattedDate = date.toLocaleDateString(locale, options);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Need to check if replaceAll is defined because we get error reports in Sentry for it
    return (formattedDate === null || formattedDate === void 0 ? void 0 : formattedDate.replaceAll) ? formattedDate.replaceAll(".", "") : "";
};
var getPromotionTimespan = function(promotion, t, locale) {
    var startDate = promotion.startDate ? new Date(promotion.startDate) : undefined;
    // Reducing 1 minute from end date, to get the point in time when the promotion actually ends
    var endDate = promotion.endDate ? new Date(new Date(promotion.endDate).getTime() - 1000 * 60) : undefined;
    var startDateFormatted = getFormattedDate(startDate, locale);
    var endDateFormatted = getFormattedDate(endDate, locale);
    return {
        short: "".concat(startDateFormatted, " - ").concat(endDateFormatted),
        long: t("product", "promotions.valid-timespan", {
            dateRange: "".concat(startDateFormatted, " - ").concat(endDateFormatted)
        })
    };
};


/***/ }),

/***/ 82854:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": () => (/* reexport */ PromotionCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33561);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/store/constants.ts
var constants = __webpack_require__(67595);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/inventory/index.js
var inventory = __webpack_require__(3242);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/schedule/index.js
var schedule = __webpack_require__(87383);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/cdn-image/index.tsx
var cdn_image = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/components/promotion-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  && {\n    padding: ",
        " ",
        "\n      ",
        " ",
        ";\n    flex-grow: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    height: calc(33vw - ",
        ");\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    height: calc(50vw - ",
        ");\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: 225px;\n  align-items: center;\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  height: fit-content;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.2);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 0;\n  word-break: break-word;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0;\n  margin-top: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 6px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 6px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}








var StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-0"
})(_templateObject());
var StyledCardContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "StyledCardContent",
    componentId: "sc-0-1"
})(_templateObject1(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing075, design_tokens.measurements.spacing100, design_tokens.measurements.spacing075);
var StyledCardMedia = (0,styled_components_browser_esm["default"])(card.CardMedia).withConfig({
    displayName: "StyledCardMedia",
    componentId: "sc-0-2"
})(_templateObject4(), base/* media.mediumOnly */.BC.mediumOnly(_templateObject2(), design_tokens.measurements.spacing100), base/* media.smallOnly */.BC.smallOnly(_templateObject3(), design_tokens.measurements.spacing100));
var StyledPromotionItemsContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPromotionItemsContainer",
    componentId: "sc-0-3"
})(_templateObject5(), design_tokens.measurements.spacing050);
var StyledStoreLogoContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledStoreLogoContainer",
    componentId: "sc-0-4"
})(_templateObject6());
var StyledCdnImage = (0,styled_components_browser_esm["default"])(cdn_image/* CdnImage */.l).withConfig({
    displayName: "StyledCdnImage",
    componentId: "sc-0-5"
})(_templateObject7());
var StyledOverlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledOverlay",
    componentId: "sc-0-6"
})(_templateObject8());
var StyledPromotionImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledPromotionImage",
    componentId: "sc-0-7"
})(_templateObject9());
var StyledPromotionTitle = (0,styled_components_browser_esm["default"])(variants.H4Text).withConfig({
    displayName: "StyledPromotionTitle",
    componentId: "sc-0-8"
})(_templateObject10());
var StyledScheduledPromotionRow = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledScheduledPromotionRow",
    componentId: "sc-0-9"
})(_templateObject11());
var StyledPromotionRowProducts = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledPromotionRowProducts",
    componentId: "sc-0-10"
})(_templateObject12());
var StyledIconSchedule = (0,styled_components_browser_esm["default"])(schedule/* IconSchedule */.c).withConfig({
    displayName: "StyledIconSchedule",
    componentId: "sc-0-11"
})(_templateObject13());
var StyledIconInventory = (0,styled_components_browser_esm["default"])(inventory/* IconInventory */.h).withConfig({
    displayName: "StyledIconInventory",
    componentId: "sc-0-12"
})(_templateObject14());

// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotion-products-page/utils/index.ts
var utils = __webpack_require__(97620);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/components/promotion-card/promotion-card.tsx









var PromotionCard = function(param) {
    var promotion = param.promotion, onClick = param.onClick;
    var ref = (0,app_context/* useAppContext */.bp)(), linkTo = ref.linkTo, t = ref.t, market = ref.market;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var timeSpan = (0,utils/* getPromotionTimespan */.R)(promotion, t, market.localeStandard);
    var numberOfProducts = promotion.numberOfProducts;
    var handleOnClick = function() {
        if (!onClick) {
            return;
        }
        onClick();
    };
    return /*#__PURE__*/ react.createElement(card.Card, {
        outlined: true
    }, /*#__PURE__*/ react.createElement(StyledCardActionArea, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: linkTo("promotions", promotion),
            onClick: function() {
                return handleOnClick();
            }
        }
    }, /*#__PURE__*/ react.createElement(StyledCardMedia, null, promotion.imageUrl ? /*#__PURE__*/ react.createElement(StyledPromotionImage, {
        alt: promotion.owner.name,
        src: promotion.imageUrl
    }) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledStoreLogoContainer, null, /*#__PURE__*/ react.createElement(StyledCdnImage, {
        name: promotion.owner.id,
        width: constants/* SHOP_LOGO_WIDTH */.L9,
        alt: promotion.owner.name,
        logoType: promotion.owner.type
    })), /*#__PURE__*/ react.createElement(StyledOverlay, null))), /*#__PURE__*/ react.createElement(StyledCardContent, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, promotion.owner.name), /*#__PURE__*/ react.createElement(StyledPromotionTitle, null, promotion.title), /*#__PURE__*/ react.createElement(StyledPromotionItemsContainer, null, /*#__PURE__*/ react.createElement(StyledScheduledPromotionRow, {
        emphasis: variants.FontEmphasis.HIGH
    }, /*#__PURE__*/ react.createElement(StyledIconSchedule, {
        size: 16
    }), isMobile ? timeSpan.short : timeSpan.long), /*#__PURE__*/ react.createElement(StyledPromotionRowProducts, {
        emphasis: variants.FontEmphasis.HIGH
    }, /*#__PURE__*/ react.createElement(StyledIconInventory, {
        size: 16
    }), t("campaigns", "deals.n-products-subtitle", {
        n: numberOfProducts
    }))))));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/components/promotion-card/index.ts



/***/ }),

/***/ 35350:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": () => (/* binding */ ContentWrapper)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/contexts/search-context.tsx + 1 modules
var search_context = __webpack_require__(37680);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/sliders/index.js
var sliders = __webpack_require__(96290);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(51676);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./src/areas/product-collection/components/ads/index.tsx + 1 modules
var ads = __webpack_require__(72943);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/info-message.tsx
var info_message = __webpack_require__(18126);
// EXTERNAL MODULE: ./src/components/placeholder/index.tsx + 1 modules
var placeholder = __webpack_require__(69221);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/input/variants.js
var input_variants = __webpack_require__(16133);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      display: none;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  padding: ",
        ";\n  padding-top: 0;\n  display: flex;\n  align-self: flex-start;\n  flex-direction: column;\n  width: ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  > :not(:last-child) {\n    padding-bottom: ",
        ";\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  input {\n    width: 85px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 120px;\n  margin: ",
        " 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin: ",
        " 0;\n  height: auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 50px;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n  padding-left: ",
        ";\n  padding-top: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 450px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  padding-bottom: ",
        ";\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}





var FILTERS_WIDTH = "260px";
var FiltersPanel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersPanel",
    componentId: "sc-0-0"
})(_templateObject2(), design_tokens.measurements.spacing100, design_tokens.measurements.spacing050, FILTERS_WIDTH, base/* media.mediumDown */.BC.mediumDown(_templateObject()), function(p) {
    return p.hideOnMobile && base/* media.mediumDown */.BC.mediumDown(_templateObject1());
});
var FiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersWrapper",
    componentId: "sc-0-1"
})(_templateObject3(), design_tokens.measurements.spacing100, design_tokens.measurements.spacing100);
var StyledFilterTitle = (0,styled_components_browser_esm["default"])(text_variants.H3Text).withConfig({
    displayName: "StyledFilterTitle",
    componentId: "sc-0-2"
})(_templateObject4(), design_tokens.measurements.spacing250);
var PriceRangeForm = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceRangeForm",
    componentId: "sc-0-3"
})(_templateObject5());
var PriceRangeInput = (0,styled_components_browser_esm["default"])(input_variants/* Input */.II).withConfig({
    displayName: "PriceRangeInput",
    componentId: "sc-0-4"
})(_templateObject6(), design_tokens.measurements.spacing050);
var FilterInput = (0,styled_components_browser_esm["default"])(input_variants/* Input */.II).withConfig({
    displayName: "FilterInput",
    componentId: "sc-0-5"
})(_templateObject7(), design_tokens.measurements.spacing050);
var Divider = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Divider",
    componentId: "sc-0-6"
})(_templateObject8(), design_tokens.measurements.spacing050);
var RangeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RangeWrapper",
    componentId: "sc-0-7"
})(_templateObject9());
var LetterStyle = (0,styled_components_browser_esm["default"])(text_variants.TitleSmallText).withConfig({
    displayName: "LetterStyle",
    componentId: "sc-0-8"
})(_templateObject10(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050, design_tokens.measurements.spacing050);
var ScrollableList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ScrollableList",
    componentId: "sc-0-9"
})(_templateObject11());
var CheckBoxList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CheckBoxList",
    componentId: "sc-0-10"
})(_templateObject12());
var HidableChild = CheckBoxList;
var StyledSubHeader = (0,styled_components_browser_esm["default"])(text_variants.TitleSmallText).withConfig({
    displayName: "StyledSubHeader",
    componentId: "sc-0-11"
})(_templateObject13(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050);
var StyledGroup = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledGroup",
    componentId: "sc-0-12"
})(_templateObject14());

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters-panel.tsx



var FilterPanel = function(props) {
    var _showTitle = props.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle, children = props.children, hideOnMobile = props.hideOnMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(FiltersPanel, {
        hideOnMobile: hideOnMobile
    }, showTitle && /*#__PURE__*/ react.createElement(StyledFilterTitle, null, t("filter", "filter.title")), children);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(37456);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/double-chevron-left/index.js
var double_chevron_left = __webpack_require__(77057);
// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(40763);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/pagination/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  cursor: default;\n  justify-content: center;\n  gap: ",
        ";\n  padding: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledPagination = styled_components_browser_esm["default"].nav.withConfig({
    displayName: "StyledPagination",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/pagination/index.tsx









var DEFAULT_PAGE = 1;
var Pagination = function() {
    var ref;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref1 = (0,search_context/* useSearchContext */.AB)(), searchState = ref1.searchState, setSearchState = ref1.setSearchState;
    var addStickyOffset = (0,react.useCallback)(function() {
        if (window.innerWidth < 640) {
            return 50;
        }
        return 70;
    }, []);
    var handlePageChange = function(page) {
        return setSearchState({
            page: page
        });
    };
    var currentPage = searchState.page || DEFAULT_PAGE;
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollLink */.Rv, {
        to: "pageHeader",
        shouldScroll: function(param) {
            var tagName = param.tagName;
            return tagName === "BUTTON";
        },
        animate: false,
        calculateOffset: addStickyOffset
    }, /*#__PURE__*/ react.createElement(StyledPagination, {
        "data-test": "SearchResultPagination"
    }, currentPage > 2 ? /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: function() {
            return handlePageChange(1);
        },
        onlyIcon: true
    }, /*#__PURE__*/ react.createElement(double_chevron_left/* IconDoubleChevronLeft */.E, null)) : null, currentPage > 1 ? /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: function() {
            return handlePageChange(currentPage - 1);
        },
        onlyIcon: true
    }, /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null)) : null, /*#__PURE__*/ react.createElement("span", null, t("common", "pagination.page-number", {
        number: currentPage
    })), ((ref = searchState.result) === null || ref === void 0 ? void 0 : ref.hasMorePages) && /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: function() {
            return handlePageChange(currentPage + 1);
        },
        onlyIcon: true
    }, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(83830);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/search-input.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var timer;
var SearchInput = function(param) {
    var handleSearch = param.handleSearch, _delay = param.delay, delay = _delay === void 0 ? 1000 : _delay, onClear = param.onClear, _value = param.value, value = _value === void 0 ? "" : _value;
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var searchState = (0,search_context/* useSearchContext */.AB)().searchState;
    var ref2 = _slicedToArray((0,react.useState)(value), 2), searchString = ref2[0], setSearchString = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)(value), 2), lastValue = ref3[0], setLastValue = ref3[1];
    (0,react.useEffect)(function() {
        return function() {
            clearTimeout(timer);
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if (((ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.query) === undefined) {
            setSearchString("");
        }
    }, [
        (ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.query
    ]);
    (0,react.useEffect)(function() {
        clearTimeout(timer);
        if (searchString === lastValue) {
            return;
        }
        if (!searchString) {
            if (onClear) {
                onClear();
            }
            setLastValue(searchString);
            handleSearch(searchString);
            return;
        }
        timer = setTimeout(function() {
            setLastValue(searchString);
            handleSearch(searchString);
        }, delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchString
    ]);
    var handleChange = function(inputValue) {
        if (searchString !== inputValue) {
            setSearchString(inputValue || "");
        }
    };
    return /*#__PURE__*/ react.createElement(input_variants/* Input */.II, {
        icon: magnifier/* IconMagnifier */.j,
        clearable: true,
        onChangeHandler: function(e) {
            return handleChange(e);
        },
        value: (ref1 = searchState.filters) === null || ref1 === void 0 ? void 0 : ref1.query,
        placeHolder: t("search", "search.input-placeholder"),
        type: "text",
        containerProps: {
            "aria-label": t("search", "search-products.placeholder"),
            "data-testid": "filter-search-input",
            "data-test": "filter-search-input"
        },
        maxLength: 256
    });
};

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/contexts/tracking-context.tsx
var tracking_context = __webpack_require__(83207);
// EXTERNAL MODULE: ./src/components/filter-dropdown/index.tsx + 1 modules
var filter_dropdown = __webpack_require__(85066);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/types.ts
var types = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/sort/utils.ts
function utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return utils_arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || utils_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return utils_arrayLikeToArray(o, minLen);
}

var getSortOptions = function(t, currentPage, hasQuery) {
    var productRelevanceQuery = hasQuery ? [
        {
            title: t("campaigns", "sort.relevance"),
            value: types/* ProductSortOptionValueEnum.RELEVANCE */.mJ.RELEVANCE
        }
    ] : [];
    var promotionsRelevancyQuery = hasQuery ? [
        {
            title: t("campaigns", "sort.relevance"),
            value: types/* PromotionsSortOptionValueEnum.RELEVANCY */.GZ.RELEVANCY
        }
    ] : [];
    var commonCampaignSortOptions = [
        {
            title: t("campaigns", "sort.product.popularity.total"),
            value: types/* ProductSortOptionValueEnum.PRODUCT_POPULARITY_TOTAL */.mJ.PRODUCT_POPULARITY_TOTAL
        },
        {
            title: t("campaigns", "sort.price.offer|asc"),
            value: types/* ProductSortOptionValueEnum.PRICE_OFFER_ASC */.mJ.PRICE_OFFER_ASC
        },
        {
            title: t("campaigns", "sort.price.offer|desc"),
            value: types/* ProductSortOptionValueEnum.PRICE_OFFER_DESC */.mJ.PRICE_OFFER_DESC
        },
        {
            title: t("campaigns", "sort.product.user_reviews.rating|desc"),
            value: types/* ProductSortOptionValueEnum.PRODUCT_USER_REVIEWS_RATING_DESC */.mJ.PRODUCT_USER_REVIEWS_RATING_DESC
        }
    ];
    var dealPageSortOptions = [
        {
            title: t("campaigns", "sort.latest-deals"),
            value: types/* ProductSortOptionValueEnum.DEAL_UPDATE_TIME */.mJ.DEAL_UPDATE_TIME
        },
        {
            title: t("campaigns", "sort.price.diff_percentage|desc"),
            value: types/* ProductSortOptionValueEnum.PRICE_DIFF_PERCENTAGE_DESC */.mJ.PRICE_DIFF_PERCENTAGE_DESC
        }
    ];
    var promotionsSortOptions = [
        {
            title: t("campaigns", "sort.start-date"),
            value: types/* PromotionsSortOptionValueEnum.START_DATE */.GZ.START_DATE
        },
        {
            title: t("campaigns", "sort.end-date"),
            value: types/* PromotionsSortOptionValueEnum.END_DATE */.GZ.END_DATE
        }
    ];
    switch(currentPage){
        case "campaign":
            return _toConsumableArray(productRelevanceQuery).concat(_toConsumableArray(dealPageSortOptions), _toConsumableArray(commonCampaignSortOptions));
        case "promotions":
            return _toConsumableArray(promotionsRelevancyQuery).concat(_toConsumableArray(promotionsSortOptions));
        default:
            return _toConsumableArray(productRelevanceQuery).concat(_toConsumableArray(commonCampaignSortOptions));
    }
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/sort/styles.ts
function sort_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sort_styles_templateObject() {
    var data = sort_styles_taggedTemplateLiteral([
        "\n  display: block;\n  padding: ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    sort_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = sort_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = sort_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = sort_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = sort_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var DropdownItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-0"
})(sort_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return !p.disabled && "color: ".concat(light_theme_colors.base900);
}, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var DesktopFilters = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DesktopFilters",
    componentId: "sc-0-1"
})(styles_templateObject2(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject1()));
var MobileFilters = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MobileFilters",
    componentId: "sc-0-2"
})(styles_templateObject4(), base/* media.largeUp */.BC.largeUp(styles_templateObject3()));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/sort/index.js
var sort = __webpack_require__(66131);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(42574);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/sort/sort-modal/styles.ts
function sort_modal_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sort_modal_styles_templateObject() {
    var data = sort_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: ",
        ";\n"
    ]);
    sort_modal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sort_modal_styles_templateObject1() {
    var data = sort_modal_styles_taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    sort_modal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledFooterInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFooterInner",
    componentId: "sc-0-0"
})(sort_modal_styles_templateObject(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var StyledPrimaryButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "StyledPrimaryButton",
    componentId: "sc-0-1"
})(sort_modal_styles_templateObject1());

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/sort/sort-modal/index.tsx




var SortModal = function(props) {
    var isOpen = props.isOpen, title = props.title, closeModal = props.closeModal, applyText = props.applyText, children = props.children;
    return /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        size: modal/* ModalSizeEnum.SMALL */.E$.SMALL,
        title: title
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, children), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(StyledFooterInner, null, /*#__PURE__*/ react.createElement(StyledPrimaryButton, {
        onClick: closeModal
    }, applyText)))));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/sort/mobile-sort/index.tsx
function mobile_sort_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function mobile_sort_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function mobile_sort_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function mobile_sort_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function mobile_sort_slicedToArray(arr, i) {
    return mobile_sort_arrayWithHoles(arr) || mobile_sort_iterableToArrayLimit(arr, i) || mobile_sort_unsupportedIterableToArray(arr, i) || mobile_sort_nonIterableRest();
}
function mobile_sort_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return mobile_sort_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mobile_sort_arrayLikeToArray(o, minLen);
}






var MobileSort = function(props) {
    var onFilterChange = props.onFilterChange, options = props.options, selectedOption = props.selectedOption;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = mobile_sort_slicedToArray((0,react.useState)(false), 2), sortModalOpen = ref[0], setSortModalOpen = ref[1];
    var ref1 = mobile_sort_slicedToArray((0,react.useState)(), 2), selected = ref1[0], setSelected = ref1[1];
    var setCurrentSorting = function() {
        var sorting = options.find(function(option) {
            return option.value === selectedOption;
        }) || options[0];
        setSelected(sorting);
    };
    (0,react.useEffect)(function() {
        setCurrentSorting();
    }, [
        selectedOption,
        setCurrentSorting
    ]);
    var handleOnClick = (0,react.useCallback)(function(option) {
        onFilterChange(option);
    }, [
        onFilterChange
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.TonalButton, {
        onClick: function() {
            return setSortModalOpen(true);
        }
    }, /*#__PURE__*/ react.createElement(sort/* IconSort */.M, null)), /*#__PURE__*/ react.createElement(SortModal, {
        isOpen: sortModalOpen,
        closeModal: function() {
            return setSortModalOpen(false);
        },
        applyText: t("common", "button.ok"),
        title: t("common", "sort.title")
    }, /*#__PURE__*/ react.createElement(filter_dropdown/* Content */.V, {
        onClick: function(option) {
            return handleOnClick(option);
        },
        options: options,
        selected: selected,
        showAsRadioButtons: true
    })));
};

// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/sort/index.tsx
function sort_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function sort_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function sort_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function sort_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sort_slicedToArray(arr, i) {
    return sort_arrayWithHoles(arr) || sort_iterableToArrayLimit(arr, i) || sort_unsupportedIterableToArray(arr, i) || sort_nonIterableRest();
}
function sort_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sort_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sort_arrayLikeToArray(o, minLen);
}










var Sort = function(param) {
    var defaultSort = param.defaultSort;
    var ref;
    var ref1 = sort_slicedToArray((0,react.useState)(defaultSort), 2), currentSorting = ref1[0], setCurrentSorting = ref1[1];
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref2 = (0,search_context/* useSearchContext */.AB)(), searchState = ref2.searchState, setSearchState = ref2.setSearchState;
    var trackSortingSelectEvent = (0,tracking_context/* useTrackingContext */.EF)().trackSortingSelectEvent;
    (0,react.useEffect)(function() {
        if (searchState.sortType && currentSorting !== searchState.sortType) setCurrentSorting(searchState.sortType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchState
    ]);
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var hasQuery = Boolean(((ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.query) && searchState.filters.query.length > 0);
    var sortOptions = getSortOptions(t, (route === null || route === void 0 ? void 0 : route.name) || "", hasQuery);
    var handleSortChange = function(option) {
        if (option.value) {
            var ref = sort_slicedToArray(option.value.split("|"), 1), property = ref[0];
            setSearchState({
                sortType: option.value
            });
            trackSortingSelectEvent({
                property: property,
                value: option.value
            });
        }
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(DesktopFilters, null, /*#__PURE__*/ react.createElement(filter_dropdown/* FilterDropdown */.M, {
        defaultSelected: sortOptions.find(function(option) {
            return option.value === currentSorting;
        }),
        alignment: ui/* Direction.Right */.Nm.Right,
        options: sortOptions,
        onFilterChange: function(option) {
            return handleSortChange(option);
        }
    })), /*#__PURE__*/ react.createElement(MobileFilters, null, /*#__PURE__*/ react.createElement(MobileSort, {
        options: sortOptions,
        selectedOption: currentSorting,
        onFilterChange: handleSortChange
    })));
};

// EXTERNAL MODULE: ./src/components/applied-filters/index.tsx + 3 modules
var applied_filters = __webpack_require__(52888);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/filter-utils.ts
var filter_utils = __webpack_require__(46053);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/content/active-filters.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var FilterKeys;
(function(FilterKeys) {
    FilterKeys["brands"] = "brands::";
    FilterKeys["shops"] = "shops::";
    FilterKeys["category"] = "category::";
    FilterKeys["availability"] = "availability::";
    FilterKeys["promotionType"] = "promotionType::";
})(FilterKeys || (FilterKeys = {}));
var ActiveFilters = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,search_context/* useSearchContext */.AB)(), searchState = ref.searchState, setSearchState = ref.setSearchState, clearSearchState = ref.clearSearchState;
    if (!searchState.filters) {
        return null;
    }
    var getValueFromFilter = function(filter) {
        return filter.key.split("::")[1];
    };
    var removeOneFilter = function(filter) {
        var alteredFilters = _objectSpread({}, searchState.filters);
        delete alteredFilters[filter.key];
        if (filter.key === "priceRangeCustom") {
            delete searchState.priceRange;
        }
        if (filter.key === "rating") {
            var ref;
            (ref = searchState.filters) === null || ref === void 0 ? void 0 : delete ref.rating;
        }
        if (filter.key.includes(FilterKeys.brands)) {
            var ref1;
            var brandValue = getValueFromFilter(filter);
            alteredFilters.brands = (ref1 = alteredFilters.brands) === null || ref1 === void 0 ? void 0 : ref1.filter(function(brand) {
                return brand !== brandValue;
            });
        }
        if (filter.key.includes(FilterKeys.shops)) {
            var ref2;
            var shopValue = getValueFromFilter(filter);
            alteredFilters.shops = (ref2 = alteredFilters.shops) === null || ref2 === void 0 ? void 0 : ref2.filter(function(shop) {
                return shop !== shopValue;
            });
        }
        if (filter.key.includes(FilterKeys.category)) {
            var ref3;
            var categoryValue = getValueFromFilter(filter);
            alteredFilters.category = (ref3 = alteredFilters.category) === null || ref3 === void 0 ? void 0 : ref3.filter(function(category) {
                return category !== categoryValue;
            });
        }
        if (filter.key.includes(FilterKeys.availability)) {
            var ref4;
            var availabilityValue = getValueFromFilter(filter);
            alteredFilters.availability = (ref4 = alteredFilters.availability) === null || ref4 === void 0 ? void 0 : ref4.filter(function(availability) {
                return availability !== availabilityValue;
            });
        }
        if (filter.key.includes(FilterKeys.promotionType)) {
            var ref5;
            var selected = getValueFromFilter(filter);
            alteredFilters.promotionType = (ref5 = alteredFilters.promotionType) === null || ref5 === void 0 ? void 0 : ref5.filter(function(val) {
                return val !== selected;
            });
        }
        setSearchState({
            filters: alteredFilters
        }, false);
    };
    var filterFormat = function(data) {
        return data.filter;
    };
    var activeFilters = (0,filter_utils/* getActiveFilters */.De)(searchState, t);
    if (!activeFilters.length) return null;
    return /*#__PURE__*/ react.createElement(applied_filters/* AppliedFilters */.M, {
        filters: activeFilters,
        filterFormatFn: filterFormat,
        onClearFilter: function(filter) {
            return removeOneFilter(filter);
        },
        onClearAll: function() {
            return clearSearchState();
        },
        wrap: true
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/checkbox/variants.js
var checkbox_variants = __webpack_require__(92191);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/clickable/index.js
var ui_clickable = __webpack_require__(42007);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(59945);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(58425);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(7920);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/show-more-less-button.tsx




var ShowMoreLessButton = function(param) {
    var onClick = param.onClick, showMore = param.showMore;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(ui_clickable.Clickable, {
        onClick: onClick,
        activationEffect: false
    }, /*#__PURE__*/ react.createElement(text_variants.CaptionText, {
        style: {
            textDecoration: "underline"
        },
        emphasis: text_variants.FontEmphasis.HIGH
    }, showMore ? t("common", "button.show-less") : t("common", "button.show-more")));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/styles.ts
function filters_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function filters_styles_templateObject() {
    var data = filters_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  position: relative;\n"
    ]);
    filters_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filters_styles_templateObject1() {
    var data = filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    filters_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function filters_styles_templateObject2() {
    var data = filters_styles_taggedTemplateLiteral([
        "\n  gap: ",
        ";\n  display: flex;\n  cursor: pointer;\n  width: 100%;\n  align-items: center;\n"
    ]);
    filters_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function filters_styles_templateObject3() {
    var data = filters_styles_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  > * {\n    align-items: center;\n    display: flex;\n  }\n"
    ]);
    filters_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function filters_styles_templateObject4() {
    var data = filters_styles_taggedTemplateLiteral([
        "\n  flex-grow: 1;\n"
    ]);
    filters_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = filters_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n  white-space: nowrap;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var ScrollableListContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ScrollableListContainer",
    componentId: "sc-0-0"
})(filters_styles_templateObject());
var RatingItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingItem",
    componentId: "sc-0-1"
})(filters_styles_templateObject1(), design_tokens.measurements.spacing050);
var StarItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StarItem",
    componentId: "sc-0-2"
})(filters_styles_templateObject2(), design_tokens.measurements.spacing050);
var RatingContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingContent",
    componentId: "sc-0-3"
})(filters_styles_templateObject3());
var RatingHideableContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingHideableContent",
    componentId: "sc-0-4"
})(filters_styles_templateObject4());
var StyledVerticalGap = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledVerticalGap",
    componentId: "sc-0-5"
})(styles_templateObject5(), design_tokens.measurements.spacing075);
var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-6"
})(styles_templateObject6(), function(p) {
    return p.theme.colors.base800;
});

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/checkbox-list-filter.tsx
function checkbox_list_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function checkbox_list_filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function checkbox_list_filter_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return checkbox_list_filter_arrayLikeToArray(arr);
}
function checkbox_list_filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function checkbox_list_filter_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function checkbox_list_filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function checkbox_list_filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function checkbox_list_filter_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function checkbox_list_filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            checkbox_list_filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function checkbox_list_filter_slicedToArray(arr, i) {
    return checkbox_list_filter_arrayWithHoles(arr) || checkbox_list_filter_iterableToArrayLimit(arr, i) || checkbox_list_filter_unsupportedIterableToArray(arr, i) || checkbox_list_filter_nonIterableRest();
}
function checkbox_list_filter_toConsumableArray(arr) {
    return checkbox_list_filter_arrayWithoutHoles(arr) || checkbox_list_filter_iterableToArray(arr) || checkbox_list_filter_unsupportedIterableToArray(arr) || checkbox_list_filter_nonIterableSpread();
}
function checkbox_list_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return checkbox_list_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return checkbox_list_filter_arrayLikeToArray(o, minLen);
}














var CheckBoxListFilter = function(param) {
    var _amountOfTopFilters = param.amountOfTopFilters, amountOfTopFilters = _amountOfTopFilters === void 0 ? 10 : _amountOfTopFilters, dataTest = param.dataTest, list = param.list, listName = param.listName, title = param.title;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var ref1 = (0,tracking_context/* useTrackingContext */.EF)(), trackFilterSelectEvent = ref1.trackFilterSelectEvent, trackFilterRemoveEvent = ref1.trackFilterRemoveEvent;
    var ref2 = checkbox_list_filter_slicedToArray((0,react.useState)(true), 2), listIsExpanded = ref2[0], setListIsExpanded = ref2[1];
    var ref3 = checkbox_list_filter_slicedToArray((0,react.useState)(false), 2), hideShowMoreButton = ref3[0], setHideShowMoreButton = ref3[1];
    var ref4 = checkbox_list_filter_slicedToArray((0,react.useState)(""), 2), searchString = ref4[0], setSearchString = ref4[1];
    var ref5 = checkbox_list_filter_slicedToArray((0,react.useState)(false), 2), showAll = ref5[0], setShowAll = ref5[1];
    var ref6 = (0,search_context/* useSearchContext */.AB)(), searchState = ref6.searchState, setSearchState = ref6.setSearchState;
    (0,react.useEffect)(function() {
        var shouldHideMoreButton = (list || []).length <= amountOfTopFilters;
        setHideShowMoreButton(shouldHideMoreButton);
    }, [
        list
    ]);
    var currentList = searchState.filters && searchState.filters[listName] || [];
    if ((list === null || list === void 0 ? void 0 : list.length) === 0) {
        return null;
    }
    var handleFilterTracking = function(isSelect, item) {
        var trackFilterParams = {
            value: listName,
            property: title,
            layout: "applied-filter",
            type: "list",
            translatedValue: item.name
        };
        if (isSelect) trackFilterSelectEvent(trackFilterParams);
        else trackFilterRemoveEvent(trackFilterParams);
    };
    var getCheckbox = function(item) {
        /*#__PURE__*/ return react.createElement(checkbox_variants/* Checkbox */.XZ, {
            key: "".concat(item.key, "_item"),
            onChange: function() {
                var isSelect = !currentList.includes(item.key);
                if (isSelect) currentList.push(item.key);
                else currentList.splice(currentList.indexOf(item.key), 1);
                handleFilterTracking(isSelect, item);
                var filterToSet = checkbox_list_filter_objectSpread({}, searchState.filters);
                filterToSet[listName] = currentList;
                setSearchState({
                    filters: filterToSet,
                    page: 1
                });
            },
            checked: currentList === null || currentList === void 0 ? void 0 : currentList.includes(item.key),
            name: "".concat(listName, "-filter"),
            text: "".concat(item.name, " (").concat(item.count, ")")
        });
    };
    var getTopFilters = function() {
        return checkbox_list_filter_toConsumableArray(list || []).splice(0, amountOfTopFilters).map(function(item) {
            return getCheckbox(item);
        });
    };
    var getCompleteList = function() {
        var filteredList = list === null || list === void 0 ? void 0 : list.filter(function(item) {
            if (searchString === "") {
                return true;
            }
            return item.name.toLowerCase().indexOf(searchString) >= 0;
        });
        if (!filteredList) {
            return null;
        }
        var letterToPrint;
        return filteredList.slice(0, 100).sort(function(a, b) {
            return a.name.localeCompare(b.name, market.localeStandard);
        }).map(function(item) {
            var firstLetter = item.name[0].toUpperCase();
            var letter = null;
            if (firstLetter !== letterToPrint) {
                letterToPrint = firstLetter;
                letter = /*#__PURE__*/ react.createElement(LetterStyle, null, letterToPrint);
            }
            return /*#__PURE__*/ react.createElement(CheckBoxList, {
                key: item.key
            }, letter, getCheckbox(item));
        });
    };
    return /*#__PURE__*/ react.createElement(StyledGroup, {
        role: "group",
        "aria-labelledby": "filter-panel-".concat(listName, "-title"),
        "data-test": dataTest
    }, /*#__PURE__*/ react.createElement(ui_clickable.Clickable, {
        onClick: function() {
            return setListIsExpanded(!listIsExpanded);
        },
        activationEffect: false
    }, /*#__PURE__*/ react.createElement(StyledSubHeader, {
        containerProps: {
            id: "filter-panel-".concat(listName, "-title")
        }
    }, title), listIsExpanded ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)), /*#__PURE__*/ react.createElement(hideable.Hideable, {
        collapse: ui/* Axis.Y */.RD.Y,
        speed: ui/* Speed.Slow */.fD.Slow,
        visible: listIsExpanded
    }, /*#__PURE__*/ react.createElement(HidableChild, null, getTopFilters(), !hideShowMoreButton && list && list.length >= amountOfTopFilters && /*#__PURE__*/ react.createElement(ShowMoreLessButton, {
        onClick: function() {
            return setShowAll(!showAll);
        },
        showMore: showAll
    }), !hideShowMoreButton && showAll && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(FilterInput, {
        icon: magnifier/* IconMagnifier */.j,
        onChangeHandler: function(value) {
            return setSearchString((value === null || value === void 0 ? void 0 : value.toLowerCase()) || "");
        },
        placeHolder: t("search", "search.button")
    }), /*#__PURE__*/ react.createElement(ScrollableListContainer, null, /*#__PURE__*/ react.createElement(ScrollableList, null, getCompleteList()))))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/checkbox-tree-filter/dropdown-button.tsx




var DropdownButton = function(param) {
    var item = param.item, isExpanded = param.isExpanded, onClick = param.onClick;
    if (!item.children.length) return null;
    return /*#__PURE__*/ react.createElement(variants.TonalButton, {
        radius: variants.ButtonRadius.CIRCLE,
        size: variants.ButtonSize.SMALL,
        elevation: variants.ButtonElevation.NONE,
        elevationHover: variants.ButtonElevation.NONE,
        style: {
            padding: "4px",
            backgroundColor: isExpanded ? "rgba(5, 30, 46, 0.06)" : "transparent"
        },
        onlyIcon: true,
        onClick: function() {
            return onClick(item);
        }
    }, isExpanded ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/checkbox-tree-filter/utils.ts
function checkbox_tree_filter_utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function utils_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return checkbox_tree_filter_utils_arrayLikeToArray(arr);
}
function utils_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function utils_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function utils_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function utils_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            utils_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function utils_toConsumableArray(arr) {
    return utils_arrayWithoutHoles(arr) || utils_iterableToArray(arr) || checkbox_tree_filter_utils_unsupportedIterableToArray(arr) || utils_nonIterableSpread();
}
function checkbox_tree_filter_utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return checkbox_tree_filter_utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return checkbox_tree_filter_utils_arrayLikeToArray(o, minLen);
}
var getParentsOf = function(item) {
    return (item === null || item === void 0 ? void 0 : item.parent) ? [
        item.parent
    ].concat(getParentsOf(item.parent)).filter(Boolean) : [];
};
var getChildrenOf = function(item) {
    return item.children.concat(item.children.flatMap(getChildrenOf));
};
var getLeafChildrenOf = function(item) {
    // Return the current object as an array if it has no children or is null/undefined
    if (!item.children || item.children.length === 0) return [
        item
    ];
    // Recursively get leaf children from each child object
    var leafChildren = item.children.flatMap(getLeafChildrenOf);
    // Filter out the objects that still have children
    return leafChildren.filter(function(child) {
        return !child.children || child.children.length === 0;
    });
};
var isChecked = function(item, list) {
    return list.includes(item.key) || getParentsOf(item).some(function(parent) {
        return list.includes(parent.key);
    });
};
var isSemiChecked = function(item, list) {
    return !list.includes(item.key) && item.children.some(function(child) {
        return list.includes(child.key) || isSemiChecked(child, list);
    });
};
var removeFromList = function(item, list) {
    var newList = utils_toConsumableArray(list);
    var i = list.indexOf(item.key);
    if (i !== -1) newList.splice(i, 1);
    return newList;
};
var addToList = function(item, list) {
    var isAlreadyInList = list.includes(item.key);
    if (isAlreadyInList) return list;
    return list.concat(item.key);
};
var buildTreeFromDealsAggregations = function(dealsAggregations, rootItemKey) {
    var itemsKeyMap = dealsAggregations.reduce(function(acc, curr) {
        return _objectSpreadProps(utils_objectSpread({}, acc), utils_defineProperty({}, curr.key, mapDealsAggregationsToListItem(curr)));
    }, {});
    var rootChildren = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dealsAggregations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var listItem = itemsKeyMap[item.key];
            if (!item.parentKey) {
                rootChildren.push(listItem);
            } else if (item.parentKey) {
                var parent = itemsKeyMap[item.parentKey];
                if (parent) {
                    listItem.parent = parent;
                    parent.children.push(listItem);
                } else {
                    // If we get an item without a parent to be found, we add it to the root
                    // This happens when we have an active filter (from a previous search) that gets removed
                    // from the aggregation due to a different filter being applied ending up with 0 results for that item.
                    rootChildren.push(listItem);
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        key: rootItemKey,
        children: rootChildren.filter(function(item) {
            return !item.parent;
        })
    };
};
var getChildrenToDisplay = function(item, showMoreKeys, max, list) {
    var children = item.children;
    if (showMoreKeys.includes(item.key) || item.children.length <= max) {
        return children;
    }
    var selectedChildren = item.children.slice(max).filter(function(x) {
        var childrenInclSelf = [
            x
        ].concat(utils_toConsumableArray(getChildrenOf(x)));
        var keys = childrenInclSelf.map(function(param) {
            var key = param.key;
            return key;
        });
        return list.find(function(listKey) {
            return keys.includes(listKey);
        });
    });
    var numToSlice = Math.max(0, max - selectedChildren.length);
    return item.children.slice(0, numToSlice).concat(selectedChildren);
};
var mapDealsAggregationsToListItem = function(item) {
    return {
        key: item.key,
        logo: item.logo,
        name: item.name,
        count: item.count,
        children: [],
        parent: undefined
    };
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/checkbox-tree-filter/constants.ts
var ROOT_ITEM_KEY = "__ROOT_KEY";

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/checkbox-tree-filter/styles.ts
function checkbox_tree_filter_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function checkbox_tree_filter_styles_templateObject() {
    var data = checkbox_tree_filter_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  ",
        ";\n"
    ]);
    checkbox_tree_filter_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function checkbox_tree_filter_styles_templateObject1() {
    var data = checkbox_tree_filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  & > :first-child {\n    /* Note: min-width 0 is needed to get the ellipsis working inside of flex */\n    min-width: 0;\n    flex-shrink: 1;\n    max-width: fit-content;\n\n    /* Since we can't place the tooltip as the parent for the label inside of the Checkbox-component\n    We'll have to lower the tooltip with CSS a few pixels so it doesn't float too far above. */\n    & > :first-child[role='tooltip'] {\n      margin-bottom: -6px;\n      margin-left: 25%;\n    }\n  }\n\n  /* Makes the label ellipsis if it's too long */\n  & .custom-css-ellipsis {\n    max-width: 100%;\n\n    & > span {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    /* Prevent the checkbox-square from shrinking */\n    & > div {\n      flex-shrink: 0;\n    }\n  }\n"
    ]);
    checkbox_tree_filter_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function checkbox_tree_filter_styles_templateObject2() {
    var data = checkbox_tree_filter_styles_taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    checkbox_tree_filter_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ChildrenWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ChildrenWrapper",
    componentId: "sc-0-0"
})(checkbox_tree_filter_styles_templateObject(), function(p) {
    return !p.isRootLevel && "padding-left: ".concat(base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
});
var CheckBoxRowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CheckBoxRowWrapper",
    componentId: "sc-0-1"
})(checkbox_tree_filter_styles_templateObject1());
var StyledItemCount = (0,styled_components_browser_esm["default"])(text_variants.CaptionText).attrs(function(_) {
    return {
        emphasis: text_variants.FontEmphasis.MEDIUM
    };
}).withConfig({
    displayName: "StyledItemCount",
    componentId: "sc-0-2"
})(checkbox_tree_filter_styles_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/checkbox-tree-filter/index.tsx
function checkbox_tree_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function checkbox_tree_filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function checkbox_tree_filter_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return checkbox_tree_filter_arrayLikeToArray(arr);
}
function checkbox_tree_filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function checkbox_tree_filter_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function checkbox_tree_filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function checkbox_tree_filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function checkbox_tree_filter_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function checkbox_tree_filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            checkbox_tree_filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function checkbox_tree_filter_slicedToArray(arr, i) {
    return checkbox_tree_filter_arrayWithHoles(arr) || checkbox_tree_filter_iterableToArrayLimit(arr, i) || checkbox_tree_filter_unsupportedIterableToArray(arr, i) || checkbox_tree_filter_nonIterableRest();
}
function checkbox_tree_filter_toConsumableArray(arr) {
    return checkbox_tree_filter_arrayWithoutHoles(arr) || checkbox_tree_filter_iterableToArray(arr) || checkbox_tree_filter_unsupportedIterableToArray(arr) || checkbox_tree_filter_nonIterableSpread();
}
function checkbox_tree_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return checkbox_tree_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return checkbox_tree_filter_arrayLikeToArray(o, minLen);
}
















var MIN_NAME_LENGTH_FOR_TOOLTIP = 17;
var CheckBoxTreeFilter = function(param) {
    var title = param.title, dealsAggregations = param.list, listName = param.listName, numDefaultExpandedItems = param.numDefaultExpandedItems, dataTest = param.dataTest;
    var ref;
    var ref1 = (0,search_context/* useSearchContext */.AB)(), searchState = ref1.searchState, setSearchState = ref1.setSearchState;
    var ref2 = (0,tracking_context/* useTrackingContext */.EF)(), trackFilterSelectEvent = ref2.trackFilterSelectEvent, trackFilterRemoveEvent = ref2.trackFilterRemoveEvent;
    var rootItem = (0,react.useMemo)(function() {
        return buildTreeFromDealsAggregations(dealsAggregations || [], ROOT_ITEM_KEY);
    }, [
        dealsAggregations
    ]);
    var ref3 = checkbox_tree_filter_slicedToArray((0,react.useState)([]), 2), expandedKeys = ref3[0], setExpandedKeys = ref3[1];
    var ref4 = checkbox_tree_filter_slicedToArray((0,react.useState)([]), 2), showMoreKeys = ref4[0], setShowMoreKeys = ref4[1];
    var currentList = ((ref = searchState.filters) === null || ref === void 0 ? void 0 : ref[listName]) ? checkbox_tree_filter_toConsumableArray(searchState.filters[listName]) : [];
    var setExpandedKeysUponFirstLoad = function() {
        if (!rootItem || searchState.isFetching || expandedKeys.length) return;
        var flattenedList = getChildrenOf(rootItem);
        var keysToSet = [
            rootItem.key
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var selectedKeysUponLoad = _step.value;
                var item = flattenedList.find(function(x) {
                    return x.key === selectedKeysUponLoad;
                });
                keysToSet = checkbox_tree_filter_toConsumableArray(new Set(keysToSet.concat(getParentsOf(item).map(function(x) {
                    return x.key;
                }))));
            };
            for(var _iterator = currentList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setExpandedKeys(keysToSet);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react.useEffect)(setExpandedKeysUponFirstLoad, [
        searchState.isFetching,
        rootItem
    ]);
    var updateTheCampaignFilter = function() {
        var ref, ref1;
        if (((ref = searchState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref[listName]) === null || ref1 === void 0 ? void 0 : ref1.join("")) === currentList.join("")) {
            return;
        }
        var filterToSet = checkbox_tree_filter_objectSpread({}, searchState.filters);
        filterToSet[listName] = currentList;
        setSearchState({
            filters: filterToSet
        });
    };
    var toggleExpandItem = function(item) {
        var newList = checkbox_tree_filter_toConsumableArray(expandedKeys);
        var index = newList.indexOf(item.key);
        if (index !== -1) newList.splice(index, 1);
        else newList.push(item.key);
        setExpandedKeys(newList);
    };
    var selectItem = function(item) {
        var ref;
        if (!item) return;
        // Select this item.
        currentList = addToList(item, currentList);
        // When selecting an item deselect all children recursively.
        var allChildren = getChildrenOf(item);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = allChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                currentList = removeFromList(child, currentList);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // (Recursively) if this is the last sibling to be selected inside of a parent - select the parent (only) instead.
        var siblings = ((ref = item.parent) === null || ref === void 0 ? void 0 : ref.children) || [];
        if (siblings.length && siblings.every(function(child) {
            return currentList.includes(child.key);
        })) {
            selectItem(item.parent);
        }
    };
    var deselectHierarchicalParent = function(selectedItem, item, parents) {
        if (item === selectedItem) {
            return;
        }
        if (parents.includes(item) || item === rootItem) {
            item.children.forEach(function(child) {
                deselectHierarchicalParent(selectedItem, child, parents);
            });
            return;
        }
        currentList = addToList(item, currentList);
    };
    var deselectItem = function(item) {
        var ref;
        if (!item) return;
        // Deselect this item.
        currentList = removeFromList(item, currentList);
        var itemParents = getParentsOf(item);
        var selectedParent = itemParents.find(function(x) {
            return currentList.includes(x.key);
        });
        if (selectedParent) {
            currentList = removeFromList(selectedParent, currentList);
            deselectHierarchicalParent(item, selectedParent, itemParents);
        }
        // When selecting an item deselect all children recursively.
        var allChildren = getChildrenOf(item);
        if (allChildren.length) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = allChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    currentList = removeFromList(child, currentList);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        // collapse the item's own dropdown (or the parent's if solo child)
        if (expandedKeys.includes(item.key)) {
            toggleExpandItem(item);
        } else if (((ref = item.parent) === null || ref === void 0 ? void 0 : ref.children.length) === 1) {
            toggleExpandItem(item.parent);
        }
    };
    var onClickCheckbox = function(item) {
        var trackFilterParams = {
            value: "category",
            translatedValue: item.name,
            property: title,
            layout: "applied-filter",
            type: "list-tree"
        };
        if (isChecked(item, currentList)) {
            deselectItem(item);
            trackFilterRemoveEvent(trackFilterParams);
        } else {
            selectItem(item);
            trackFilterSelectEvent(trackFilterParams);
            // When selecting a collapsed parent, expand to display its children
            if (!expandedKeys.includes(item.key) && item.children.length) {
                toggleExpandItem(item);
            }
        }
        updateTheCampaignFilter();
    };
    var isExpanded = function(item) {
        return expandedKeys.includes(item.key);
    };
    var renderItem = function(item, nestedLevel) {
        var semiChecked = isSemiChecked(item, currentList);
        var checked = isChecked(item, currentList);
        var expanded = isExpanded(item);
        // Note: The deeper we render things the fewer characters will fit in the name
        var displayTooltip = item.name.length - nestedLevel * 0.5 >= MIN_NAME_LENGTH_FOR_TOOLTIP;
        return /*#__PURE__*/ react.createElement(react.Fragment, {
            key: "".concat(item.key, "_item")
        }, /*#__PURE__*/ react.createElement(CheckBoxRowWrapper, {
            "data-test": "TreeFilterItem"
        }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
            title: displayTooltip ? item.name : "",
            placement: ui/* Direction.Up */.Nm.Up
        }, /*#__PURE__*/ react.createElement(checkbox_variants/* Checkbox */.XZ, {
            onChange: function() {
                return onClickCheckbox(item);
            },
            checked: semiChecked || checked,
            indeterminate: semiChecked && !checked,
            text: item.name,
            className: "custom-css-ellipsis",
            name: "category-filter",
            style: {
                fontWeight: expanded ? "bolder" : undefined
            }
        })), /*#__PURE__*/ react.createElement(StyledItemCount, null, "(".concat(item.count, ")")), /*#__PURE__*/ react.createElement(DropdownButton, {
            item: item,
            isExpanded: expanded,
            onClick: toggleExpandItem
        })), /*#__PURE__*/ react.createElement(hideable.Hideable, {
            collapse: ui/* Axis.Y */.RD.Y,
            speed: ui/* Speed.Slow */.fD.Slow,
            visible: expanded
        }, expanded ? renderChildren(item, nestedLevel) : null));
    };
    var onClickShowMoreLess = function(item) {
        var newList = checkbox_tree_filter_toConsumableArray(showMoreKeys);
        if (newList.includes(item.key)) newList = removeFromList(item, newList);
        else newList = addToList(item, newList);
        setShowMoreKeys(newList);
    };
    var renderChildren = function(item, nestedLevel) {
        if (!item.children.length) return null;
        var children = getChildrenToDisplay(item, showMoreKeys, numDefaultExpandedItems, currentList);
        return /*#__PURE__*/ react.createElement(ChildrenWrapper, {
            isRootLevel: nestedLevel === 0
        }, children.map(function(c) {
            return renderItem(c, nestedLevel + 1);
        }), item.children.length <= numDefaultExpandedItems ? null : /*#__PURE__*/ react.createElement(ShowMoreLessButton, {
            onClick: function() {
                return onClickShowMoreLess(item);
            },
            showMore: showMoreKeys.includes(item.key)
        }));
    };
    if (rootItem.children.length === 0) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledGroup, {
        role: "group",
        "aria-labelledby": "filter-panel-category-title",
        "data-test": dataTest
    }, /*#__PURE__*/ react.createElement(ui_clickable.Clickable, {
        onClick: function() {
            return toggleExpandItem(rootItem);
        },
        activationEffect: false
    }, /*#__PURE__*/ react.createElement(StyledSubHeader, {
        containerProps: {
            id: "filter-panel-category-title"
        }
    }, title), isExpanded(rootItem) ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)), /*#__PURE__*/ react.createElement(hideable.Hideable, {
        collapse: ui/* Axis.Y */.RD.Y,
        speed: ui/* Speed.Slow */.fD.Slow,
        visible: isExpanded(rootItem)
    }, renderChildren(rootItem, 0)));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/radiobutton/index.js
var radiobutton = __webpack_require__(94269);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon-interactive/index.js
var icon_interactive = __webpack_require__(64341);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(31744);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(89286);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/price-drop-filter.tsx
function price_drop_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_drop_filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_drop_filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_drop_filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_drop_filter_slicedToArray(arr, i) {
    return price_drop_filter_arrayWithHoles(arr) || price_drop_filter_iterableToArrayLimit(arr, i) || price_drop_filter_unsupportedIterableToArray(arr, i) || price_drop_filter_nonIterableRest();
}
function price_drop_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_drop_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_drop_filter_arrayLikeToArray(o, minLen);
}












var PriceDropFilter = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,app_context/* useAppContext */.bp)(), t = ref6.t, market = ref6.market;
    var trackFilterSelectEvent = (0,tracking_context/* useTrackingContext */.EF)().trackFilterSelectEvent;
    var ref7 = (0,search_context/* useSearchContext */.AB)(), searchState = ref7.searchState, setSearchState = ref7.setSearchState;
    var ref8 = price_drop_filter_slicedToArray((0,react.useState)(false), 2), showPopover = ref8[0], setShowPopover = ref8[1];
    var setPriceDrop = function(value) {
        var ref;
        if (!value || value === ((ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.priceDropPercent)) {
            return;
        }
        trackFilterSelectEvent({
            value: value,
            property: "price-drop",
            layout: "quick-filter",
            type: "range-groups"
        });
        setSearchState({
            filters: {
                priceDropPercent: value
            }
        });
    };
    var ref9;
    var readMoreLink = (ref9 = (ref = market.articles) === null || ref === void 0 ? void 0 : (ref1 = ref.aboutDealsCalculation) === null || ref1 === void 0 ? void 0 : ref1.path) !== null && ref9 !== void 0 ? ref9 : null;
    return /*#__PURE__*/ react.createElement(StyledGroup, {
        role: "group",
        "aria-labelledby": "filter-panel-price-drop-title"
    }, /*#__PURE__*/ react.createElement(StyledSubHeader, {
        containerProps: {
            id: "filter-panel-price-drop-title"
        }
    }, t("filter", "filter.price-drop-title"), /*#__PURE__*/ react.createElement(icon_interactive/* InteractiveIcon */.z, {
        icon: info_outlined/* IconInfoOutlined */.e,
        size: 16,
        onClick: function() {
            return setShowPopover(true);
        }
    }), /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "popover-price-trend-filter",
        visible: showPopover,
        width: 230,
        verticalAlign: popover/* Alignment.StartOutside */.v2.StartOutside,
        horizontalAlign: popover/* Alignment.Start */.v2.Start,
        offsetY: -5,
        // Adding a nextTick-timeout here enables the popover to be closed by clicking the icon again
        onClose: function() {
            return setTimeout(function() {
                return setShowPopover(false);
            });
        }
    }, /*#__PURE__*/ react.createElement(StyledVerticalGap, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        color: text_variants.FontColor.DARK
    }, t("filter", "filter.price-trend-explanation"), readMoreLink && /*#__PURE__*/ react.createElement(StyledLink, {
        to: readMoreLink
    }, t("filter", "filter.price-trend-read-more")))))), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
        text: t("filter", "filter.percent-or-more", {
            percent: "50"
        }),
        name: "price-drop-radio",
        onClickHandler: function(e) {
            return setPriceDrop(e);
        },
        selectedValue: (ref2 = searchState.filters) === null || ref2 === void 0 ? void 0 : ref2.priceDropPercent,
        value: types/* PriceDropPercent.PERCENT_50 */.E1.PERCENT_50
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
        text: t("filter", "filter.percent-or-more", {
            percent: "25"
        }),
        name: "price-drop-radio",
        onClickHandler: function(e) {
            return setPriceDrop(e);
        },
        selectedValue: (ref3 = searchState.filters) === null || ref3 === void 0 ? void 0 : ref3.priceDropPercent,
        value: types/* PriceDropPercent.PERCENT_25 */.E1.PERCENT_25
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
        text: t("filter", "filter.percent-or-more", {
            percent: "10"
        }),
        name: "price-drop-radio",
        onClickHandler: function(e) {
            return setPriceDrop(e);
        },
        selectedValue: (ref4 = searchState.filters) === null || ref4 === void 0 ? void 0 : ref4.priceDropPercent,
        value: types/* PriceDropPercent.PERCENT_10 */.E1.PERCENT_10
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
        text: t("filter", "filter.percent-or-more", {
            percent: "5"
        }),
        name: "price-drop-radio",
        onClickHandler: function(e) {
            return setPriceDrop(e);
        },
        selectedValue: (ref5 = searchState.filters) === null || ref5 === void 0 ? void 0 : ref5.priceDropPercent,
        value: types/* PriceDropPercent.PERCENT_5 */.E1.PERCENT_5
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/range/index.js
var range = __webpack_require__(82711);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/utils.ts

var defaultRange = {
    smallRange: 0,
    midRange: 5,
    maxValue: 10
};
var getPriceRangesByMarketCode = function(marketCode, page) {
    switch(marketCode){
        case "fi":
        case "gb":
        case "fr":
        case "nz":
            switch(page){
                case types/* SearchPageType.BRAND_PROMOTIONS_PRODUCTS */.zh.BRAND_PROMOTIONS_PRODUCTS:
                case types/* SearchPageType.DEALS */.zh.DEALS:
                case types/* SearchPageType.SHOP_PROMOTIONS_PRODUCTS */.zh.SHOP_PROMOTIONS_PRODUCTS:
                case types/* SearchPageType.USED */.zh.USED:
                    return {
                        smallRange: 20,
                        midRange: 100,
                        maxValue: 1000
                    };
                default:
                    return defaultRange;
            }
        case "se":
        case "no":
        case "dk":
        default:
            switch(page){
                case types/* SearchPageType.BRAND_PROMOTIONS_PRODUCTS */.zh.BRAND_PROMOTIONS_PRODUCTS:
                case types/* SearchPageType.DEALS */.zh.DEALS:
                case types/* SearchPageType.SHOP_PROMOTIONS_PRODUCTS */.zh.SHOP_PROMOTIONS_PRODUCTS:
                case types/* SearchPageType.USED */.zh.USED:
                    return {
                        smallRange: 200,
                        midRange: 1000,
                        maxValue: 10000
                    };
                default:
                    return defaultRange;
            }
    }
};
var arrayCountingUpFromOneTo = function(to) {
    return Array(to).fill(0).map(function(_, i) {
        return i + 1;
    });
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/price-range-filter.tsx
function price_range_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_range_filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_range_filter_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return price_range_filter_arrayLikeToArray(arr);
}
function price_range_filter_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function price_range_filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_range_filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_range_filter_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_range_filter_slicedToArray(arr, i) {
    return price_range_filter_arrayWithHoles(arr) || price_range_filter_iterableToArrayLimit(arr, i) || price_range_filter_unsupportedIterableToArray(arr, i) || price_range_filter_nonIterableRest();
}
function price_range_filter_toConsumableArray(arr) {
    return price_range_filter_arrayWithoutHoles(arr) || price_range_filter_iterableToArray(arr) || price_range_filter_unsupportedIterableToArray(arr) || price_range_filter_nonIterableSpread();
}
function price_range_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_range_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_range_filter_arrayLikeToArray(o, minLen);
}










var PriceRangeFilter = function(param) {
    var searchPageType = param.searchPageType;
    var ref;
    var ref1 = (0,app_context/* useAppContext */.bp)(), t = ref1.t, market = ref1.market;
    var trackFilterSelectEvent = (0,tracking_context/* useTrackingContext */.EF)().trackFilterSelectEvent;
    var ranges = getPriceRangesByMarketCode(market.code, searchPageType);
    var MAX_VALUE = ranges.maxValue;
    var SMALL_RANGE_VALUE = ranges.smallRange;
    var MID_RANGE_VALUE = ranges.midRange;
    var refPriceInputFrom = (0,react.useRef)(null);
    var refPriceInputTo = (0,react.useRef)(null);
    var ref2 = (0,search_context/* useSearchContext */.AB)(), searchState = ref2.searchState, setSearchState = ref2.setSearchState;
    var ref3 = price_range_filter_slicedToArray((0,react.useState)({
        min: 0,
        max: 1
    }), 2), minMaxSliderValue = ref3[0], setMinMaxSliderValue = ref3[1];
    var ref4 = price_range_filter_slicedToArray((0,react.useState)([
        0,
        MAX_VALUE
    ]), 2), rangeSliderValues = ref4[0], setRangeSliderValues = ref4[1];
    var ref5 = price_range_filter_slicedToArray((0,react.useState)(""), 2), fromPriceValueCurrency = ref5[0], setFromPriceValueCurrency = ref5[1];
    var ref6 = price_range_filter_slicedToArray((0,react.useState)(""), 2), toPriceValueCurrency = ref6[0], setToPriceValueCurrency = ref6[1];
    var ref7 = price_range_filter_slicedToArray((0,react.useState)(0), 2), fromPriceValue = ref7[0], setFromPriceValue = ref7[1];
    var ref8 = price_range_filter_slicedToArray((0,react.useState)(MAX_VALUE), 2), toPriceValue = ref8[0], setToPriceValue = ref8[1];
    var getMinMax = function() {
        var ref, ref1;
        var min = 0;
        var max = ((ref1 = price_range_filter_toConsumableArray(((ref = searchState.result) === null || ref === void 0 ? void 0 : ref.priceHistogram) || []).pop()) === null || ref1 === void 0 ? void 0 : ref1.max) || MAX_VALUE;
        return {
            min: min,
            max: max
        };
    };
    (0,react.useEffect)(function() {
        var ref;
        var minMax = getMinMax();
        setMinMaxSliderValue(minMax);
        if (!((ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.priceRangeCustom)) {
            setRangeSliderValues([
                0,
                minMax.max
            ]);
        }
    }, [
        (ref = searchState.result) === null || ref === void 0 ? void 0 : ref.priceHistogram
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var minMax = getMinMax();
        var from = ((ref = searchState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRangeCustom) === null || ref1 === void 0 ? void 0 : ref1.from) || 0;
        var to = ((ref2 = searchState.filters) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.priceRangeCustom) === null || ref3 === void 0 ? void 0 : ref3.to) || minMax.max;
        if (searchState.priceRange) {
            switch(searchState.priceRange){
                case types/* PriceRange.FROM_0_TO_200 */.MS.FROM_0_TO_200:
                    from = 0;
                    to = SMALL_RANGE_VALUE;
                    break;
                case types/* PriceRange.FROM_200_TO_1000 */.MS.FROM_200_TO_1000:
                    from = SMALL_RANGE_VALUE;
                    to = MID_RANGE_VALUE;
                    break;
                case types/* PriceRange.FROM_1000_TO_ALL */.MS.FROM_1000_TO_ALL:
                    from = MID_RANGE_VALUE;
                    to = minMax.max;
                    break;
                default:
                    break;
            }
        }
        var priceRangeSelector;
        var customFrom = parseInt(((ref4 = searchState.filters) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.priceRangeCustom) === null || ref5 === void 0 ? void 0 : ref5.from.toString()) || "0", 10);
        var customTo = parseInt(((ref6 = searchState.filters) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.priceRangeCustom) === null || ref7 === void 0 ? void 0 : ref7.to.toString()) || "0", 10);
        switch(true){
            case customFrom === 0 && customTo === SMALL_RANGE_VALUE:
                priceRangeSelector = types/* PriceRange.FROM_0_TO_200 */.MS.FROM_0_TO_200;
                break;
            case customFrom === SMALL_RANGE_VALUE && customTo === MID_RANGE_VALUE:
                priceRangeSelector = types/* PriceRange.FROM_200_TO_1000 */.MS.FROM_200_TO_1000;
                break;
            case customFrom === MID_RANGE_VALUE && customTo === getMinMax().max:
                priceRangeSelector = types/* PriceRange.FROM_1000_TO_ALL */.MS.FROM_1000_TO_ALL;
                break;
            default:
                break;
        }
        if (priceRangeSelector !== searchState.priceRange) {
            setSearchState({
                priceRange: priceRangeSelector
            });
        }
        if (customFrom.toString() !== rangeSliderValues[0].toString() || customTo.toString() !== rangeSliderValues[1].toString()) {
            var values = [
                from,
                to
            ].map(function(val) {
                return parseInt(val.toString(), 10);
            });
            setRangeSliderValues(values);
        }
    }, [
        searchState.filters
    ]);
    var setFormattedCurrency = function() {
        setFromPriceValue(rangeSliderValues[0]);
        setToPriceValue(rangeSliderValues[1]);
        // If the PriceRangeInput is focused, we don't want to currency-format it's value
        var from = rangeSliderValues[0].toString();
        var to = rangeSliderValues[1].toString();
        if (document.activeElement !== refPriceInputFrom.current) {
            from = (0,currency/* formatCurrency */.xG)(rangeSliderValues[0], market.code, false) || "";
        }
        if (document.activeElement !== refPriceInputTo.current) {
            to = (0,currency/* formatCurrency */.xG)(rangeSliderValues[1], market.code, false) || "";
        }
        setFromPriceValueCurrency(from);
        setToPriceValueCurrency(to);
    };
    (0,react.useEffect)(function() {
        setFormattedCurrency();
    }, [
        rangeSliderValues
    ]);
    var handleBlurPriceInput = function() {
        var ref, ref1, ref2, ref3;
        var to = toPriceValue;
        var from = fromPriceValue;
        var maxPrice = getMinMax().max;
        if (from > maxPrice) {
            from = maxPrice - 1;
        }
        if (to > maxPrice) {
            to = maxPrice;
        }
        if (to <= from) {
            to = from + 1;
        }
        var fromChanged = ((ref = searchState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRangeCustom) === null || ref1 === void 0 ? void 0 : ref1.from) !== from;
        var toChanged = ((ref2 = searchState.filters) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.priceRangeCustom) === null || ref3 === void 0 ? void 0 : ref3.to) !== to;
        setFormattedCurrency();
        if (!fromChanged && !toChanged) {
            return;
        }
        setRangeSliderValues([
            from,
            to
        ]);
        setSearchState({
            filters: {
                priceRangeCustom: {
                    from: from,
                    to: to
                }
            },
            priceRange: undefined
        });
    };
    var handleRangeOnBlur = function(rangeSlider) {
        setSearchState({
            filters: {
                priceRangeCustom: {
                    from: rangeSlider[0],
                    to: rangeSlider[1]
                }
            },
            priceRange: undefined
        });
        trackFilterSelectEvent({
            value: "".concat(rangeSlider[0], "-").concat(rangeSlider[1]),
            property: "price-range",
            layout: "applied-filter",
            type: "range"
        });
    };
    var handlePriceRangeClick = function(rangeValue, fromRange, toRange) {
        if (searchState.priceRange === rangeValue) {
            return;
        }
        setSearchState({
            filters: {
                priceRangeCustom: {
                    from: fromRange,
                    to: toRange
                }
            },
            priceRange: rangeValue
        });
        setRangeSliderValues([
            fromRange,
            toRange
        ]);
    };
    return /*#__PURE__*/ react.createElement(StyledGroup, {
        role: "group",
        "aria-labelledby": "filter-panel-price-range-title"
    }, /*#__PURE__*/ react.createElement(StyledSubHeader, {
        containerProps: {
            id: "filter-panel-price-range-title"
        }
    }, t("campaigns", "filter.price")), /*#__PURE__*/ react.createElement(PriceRangeForm, null, /*#__PURE__*/ react.createElement(PriceRangeInput, {
        containerProps: {
            "aria-label": t("common", "price.from"),
            ref: refPriceInputFrom,
            onKeyDown: function(e) {
                if (e.code.toLowerCase() === "enter" || e.keyCode === 13) {
                    handleBlurPriceInput();
                }
            },
            "data-testid": "filter-price-range-input-from"
        },
        onChangeHandler: function(e) {
            return e && setFromPriceValue(parseInt(e, 10) || 0);
        },
        onBlur: function(_) {
            return handleBlurPriceInput();
        },
        onFocus: function() {
            var ref, ref1;
            setFromPriceValueCurrency(((ref = searchState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRangeCustom) === null || ref1 === void 0 ? void 0 : ref1.from.toString()) || "");
        },
        value: fromPriceValueCurrency || "0"
    }), /*#__PURE__*/ react.createElement(Divider, null, "-"), /*#__PURE__*/ react.createElement(PriceRangeInput, {
        containerProps: {
            "aria-label": t("common", "price.to"),
            ref: refPriceInputTo,
            onKeyDown: function(e) {
                if (e.code.toLowerCase() === "enter" || e.keyCode === 13) {
                    handleBlurPriceInput();
                }
            },
            "data-testid": "filter-price-range-input-to"
        },
        onChangeHandler: function(e) {
            return e && setToPriceValue(parseInt(e, 10) || 0);
        },
        onBlur: function(_) {
            return handleBlurPriceInput();
        },
        onFocus: function() {
            var ref, ref1;
            setToPriceValueCurrency(((ref = searchState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRangeCustom) === null || ref1 === void 0 ? void 0 : ref1.to.toString()) || "");
        },
        value: toPriceValueCurrency || getMinMax().max.toString()
    })), /*#__PURE__*/ react.createElement(range/* RangeSlider */.U, {
        domain: [
            0,
            minMaxSliderValue.max
        ],
        tickValues: [],
        step: 1,
        values: rangeSliderValues,
        onChange: function(e) {
            setRangeSliderValues([
                e[0],
                e[1]
            ]);
        },
        onBlur: function(e) {
            return handleRangeOnBlur(e);
        }
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
        text: t("filter", "filter.up-to-value", {
            value: (0,currency/* formatCurrency */.xG)(SMALL_RANGE_VALUE, market.code, false) || ""
        }),
        name: "pricerange",
        onClickHandler: function(e) {
            return handlePriceRangeClick(e, 0, SMALL_RANGE_VALUE);
        },
        selectedValue: searchState.priceRange,
        value: types/* PriceRange.FROM_0_TO_200 */.MS.FROM_0_TO_200
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
        text: t("filter", "filter.from-to-value", {
            from: (0,currency/* formatCurrency */.xG)(SMALL_RANGE_VALUE, market.code, false) || "",
            to: (0,currency/* formatCurrency */.xG)(MID_RANGE_VALUE, market.code, false) || ""
        }),
        name: "pricerange",
        onClickHandler: function(e) {
            return handlePriceRangeClick(e, SMALL_RANGE_VALUE, MID_RANGE_VALUE);
        },
        selectedValue: searchState.priceRange,
        value: types/* PriceRange.FROM_200_TO_1000 */.MS.FROM_200_TO_1000
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
        text: t("filter", "filter.more-than-value", {
            value: (0,currency/* formatCurrency */.xG)(MID_RANGE_VALUE, market.code, false) || ""
        }),
        name: "pricerange",
        onClickHandler: function(e) {
            return handlePriceRangeClick(e, MID_RANGE_VALUE, getMinMax().max);
        },
        selectedValue: searchState.priceRange,
        value: types/* PriceRange.FROM_1000_TO_ALL */.MS.FROM_1000_TO_ALL
    }));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/text-search-filter.tsx






var TextSearchFilter = function(param) {
    var placeholder = param.placeholder, searchPageType = param.searchPageType;
    var ref;
    var ref1 = (0,search_context/* useSearchContext */.AB)(), searchState = ref1.searchState, setSearchState = ref1.setSearchState;
    var ref2 = (0,tracking_context/* useTrackingContext */.EF)(), trackFilterSelectEvent = ref2.trackFilterSelectEvent, trackFilterRemoveEvent = ref2.trackFilterRemoveEvent;
    var handleSearchChange = function(value) {
        if (value === "") {
            var ref;
            trackFilterRemoveEvent({
                value: ((ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.query) || "",
                property: "campaign-search",
                layout: "applied-filter",
                type: "product-name-search"
            });
            setSearchState({
                filters: {
                    query: value
                },
                sortType: searchPageType === "promotions" ? types/* PromotionsSortOptionValueEnum.START_DATE */.GZ.START_DATE : types/* ProductSortOptionValueEnum.PRODUCT_POPULARITY_TOTAL */.mJ.PRODUCT_POPULARITY_TOTAL
            });
        } else {
            trackFilterSelectEvent({
                value: value,
                property: "campaign-search",
                layout: "applied-filter",
                type: "product-name-search"
            });
            setSearchState({
                filters: {
                    query: value
                },
                sortType: searchPageType === "promotions" ? types/* PromotionsSortOptionValueEnum.RELEVANCY */.GZ.RELEVANCY : types/* ProductSortOptionValueEnum.RELEVANCE */.mJ.RELEVANCE
            });
        }
    };
    return /*#__PURE__*/ react.createElement(StyledGroup, {
        role: "group",
        "aria-labelledby": "filter-panel-search-title"
    }, /*#__PURE__*/ react.createElement(StyledSubHeader, {
        containerProps: {
            id: "filter-panel-search-title"
        }
    }, placeholder), /*#__PURE__*/ react.createElement(SearchInput, {
        value: (ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.query,
        handleSearch: handleSearchChange
    }));
};

// EXTERNAL MODULE: ./src/components/rating/star-icons.tsx
var star_icons = __webpack_require__(12814);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(51362);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/plus/index.js
var plus = __webpack_require__(31903);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/rating-filter.tsx
function rating_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function rating_filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function rating_filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function rating_filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function rating_filter_slicedToArray(arr, i) {
    return rating_filter_arrayWithHoles(arr) || rating_filter_iterableToArrayLimit(arr, i) || rating_filter_unsupportedIterableToArray(arr, i) || rating_filter_nonIterableRest();
}
function rating_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return rating_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return rating_filter_arrayLikeToArray(o, minLen);
}
















// Array.findLast is not available in browser versions older than 2022 which e.g Pingdom uses.
function getLast(array) {
    return array[array.length - 1];
}
var RatingFilter = function() {
    var ref;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref1 = (0,search_context/* useSearchContext */.AB)(), searchState = ref1.searchState, setSearchState = ref1.setSearchState;
    var ref2 = rating_filter_slicedToArray((0,react.useState)(true), 2), isExpanded = ref2[0], setIsExpanded = ref2[1];
    if (((ref = searchState.result) === null || ref === void 0 ? void 0 : ref.ratingHistogram.length) === 0) {
        return null;
    }
    var handleChangeRating = function(newRating) {
        return setSearchState({
            filters: {
                rating: newRating
            }
        });
    };
    var renderStarItem = function(starValue, count) {
        var ref;
        /*#__PURE__*/ return react.createElement(RatingItem, {
            key: starValue
        }, /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
            name: "rating-radio",
            onClickHandler: function(_) {
                return handleChangeRating(starValue);
            },
            selectedValue: (ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.rating,
            value: starValue
        }), /*#__PURE__*/ react.createElement(StarItem, {
            onClick: function() {
                return handleChangeRating(starValue);
            }
        }, /*#__PURE__*/ react.createElement(star_icons/* default */.Z, {
            stars: arrayCountingUpFromOneTo(starValue),
            rating: rating_helper/* default.convert */.Z.convert(starValue),
            halfStar: false
        }), /*#__PURE__*/ react.createElement(RatingContent, null, /*#__PURE__*/ react.createElement("span", null, starValue !== 5 && /*#__PURE__*/ react.createElement(plus/* IconPlus */.S, {
            size: 14
        })), /*#__PURE__*/ react.createElement(badge.Badge, {
            text: count || "0",
            size: badge.BadgeSize.SMALL
        }))));
    };
    var renderStarItems = function() {
        var _loop = function(i) {
            var item = histogram.find(function(r) {
                return r.key === i;
            }) || getLast(histogram);
            stars.push(renderStarItem(i, item.count));
        };
        var ref, ref1;
        var histogram = ((ref = searchState.result) === null || ref === void 0 ? void 0 : ref.ratingHistogram) || [];
        if (!histogram.length) return null;
        var stars = [];
        var highestStarValue = ((ref1 = getLast(histogram)) === null || ref1 === void 0 ? void 0 : ref1.key) || 0;
        for(var i = 1; i <= highestStarValue; i += 1)_loop(i);
        return stars;
    };
    return /*#__PURE__*/ react.createElement(StyledGroup, {
        role: "group",
        "aria-labelledby": "filter-panel-rating-title"
    }, /*#__PURE__*/ react.createElement(ui_clickable.Clickable, {
        onClick: function() {
            return setIsExpanded(!isExpanded);
        },
        activationEffect: false
    }, /*#__PURE__*/ react.createElement(StyledSubHeader, {
        containerProps: {
            id: "filter-panel-rating-title"
        }
    }, t("common", "sort.user_reviews")), isExpanded ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)), /*#__PURE__*/ react.createElement(hideable.Hideable, {
        collapse: ui/* Axis.Y */.RD.Y,
        speed: ui/* Speed.Slow */.fD.Slow,
        visible: isExpanded
    }, /*#__PURE__*/ react.createElement(RatingHideableContent, null, renderStarItems())));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/filters/index.ts







;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/search-filters-per-page.tsx
function search_filters_per_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var _obj;
var FILTERS_PER_PAGE = (_obj = {}, search_filters_per_page_defineProperty(_obj, types/* SearchPageType.BRAND_PROMOTIONS */.zh.BRAND_PROMOTIONS, []), search_filters_per_page_defineProperty(_obj, types/* SearchPageType.BRAND_PROMOTIONS_PRODUCTS */.zh.BRAND_PROMOTIONS_PRODUCTS, [
    "availability",
    "categoryTree",
    "priceRange",
    "productNameTextInput",
    "rating",
    "shops"
]), search_filters_per_page_defineProperty(_obj, types/* SearchPageType.DEALS */.zh.DEALS, [
    "brands",
    "categoryTree",
    "priceDrop",
    "priceRange",
    "productNameTextInput",
    "rating",
    "shops"
]), search_filters_per_page_defineProperty(_obj, types/* SearchPageType.PROMOTIONS */.zh.PROMOTIONS, [
    "productNameTextInput",
    "promotionType",
    "shops"
]), search_filters_per_page_defineProperty(_obj, types/* SearchPageType.SHOP_PROMOTIONS */.zh.SHOP_PROMOTIONS, []), search_filters_per_page_defineProperty(_obj, types/* SearchPageType.SHOP_PROMOTIONS_PRODUCTS */.zh.SHOP_PROMOTIONS_PRODUCTS, [
    "availability",
    "brands",
    "categoryTree",
    "priceRange",
    "productNameTextInput",
    "rating"
]), search_filters_per_page_defineProperty(_obj, types/* SearchPageType.USED */.zh.USED, [
    "brands",
    "categoryTree",
    "priceRange",
    "productNameTextInput",
    "rating"
]), _obj);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/filter-panel/search-filters.tsx
function search_filters_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_filters_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return search_filters_arrayLikeToArray(arr);
}
function search_filters_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function search_filters_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_filters_toConsumableArray(arr) {
    return search_filters_arrayWithoutHoles(arr) || search_filters_iterableToArray(arr) || search_filters_unsupportedIterableToArray(arr) || search_filters_nonIterableSpread();
}
function search_filters_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_filters_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_filters_arrayLikeToArray(o, minLen);
}






var BRAND_TOP_FILTERS_LIMIT = 5;
var SHOP_TOP_FILTERS_LIMIT = 5;
var CATEGORY_TOP_FILTERS_LIMIT = 10;
var SearchFilters = function(param) {
    var searchPageType = param.searchPageType;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,app_context/* useAppContext */.bp)(), t = ref5.t, market = ref5.market;
    var searchState = (0,search_context/* useSearchContext */.AB)().searchState;
    var filters = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var hasFilter = function(filter) {
            return FILTERS_PER_PAGE[searchPageType].includes(filter);
        };
        var sortedTypeAggregations = (ref = searchState.promotionsResult) === null || ref === void 0 ? void 0 : ref.typeAggregations.slice().sort(function(a, b) {
            return b.name.localeCompare(a.name, market.localeStandard);
        });
        var sortedCategoryFilters = (searchState === null || searchState === void 0 ? void 0 : (ref1 = searchState.result) === null || ref1 === void 0 ? void 0 : ref1.categoryAggregations) ? search_filters_toConsumableArray(searchState.result.categoryAggregations).sort(function(a, b) {
            return a.name.localeCompare(b.name, market.localeStandard);
        }) : undefined;
        var elementsOrFalse = [
            hasFilter("productNameTextInput") && /*#__PURE__*/ react.createElement(TextSearchFilter, {
                placeholder: t("filter", "filter.search-title"),
                searchPageType: searchPageType
            }),
            hasFilter("priceDrop") && /*#__PURE__*/ react.createElement(PriceDropFilter, null),
            hasFilter("priceRange") && /*#__PURE__*/ react.createElement(PriceRangeFilter, {
                searchPageType: searchPageType
            }),
            hasFilter("categoryTree") && /*#__PURE__*/ react.createElement(CheckBoxTreeFilter, {
                title: t("filter", "filter.category-title"),
                listName: "category",
                list: sortedCategoryFilters,
                numDefaultExpandedItems: CATEGORY_TOP_FILTERS_LIMIT,
                dataTest: "CategoryFilters"
            }),
            hasFilter("brands") && /*#__PURE__*/ react.createElement(CheckBoxListFilter, {
                amountOfTopFilters: BRAND_TOP_FILTERS_LIMIT,
                dataTest: "BrandFilters",
                list: searchState === null || searchState === void 0 ? void 0 : (ref2 = searchState.result) === null || ref2 === void 0 ? void 0 : ref2.brandsAggregations,
                listName: "brands",
                title: t("filter", "filter.brand-title")
            }),
            hasFilter("shops") && /*#__PURE__*/ react.createElement(CheckBoxListFilter, {
                title: t("filter", "filter.shop-title"),
                listName: "shops",
                list: searchState === null || searchState === void 0 ? void 0 : (ref3 = searchState.result) === null || ref3 === void 0 ? void 0 : ref3.shopAggregations,
                amountOfTopFilters: SHOP_TOP_FILTERS_LIMIT,
                dataTest: "ShopFilters"
            }),
            hasFilter("availability") && /*#__PURE__*/ react.createElement(CheckBoxListFilter, {
                title: t("filter", "filter.availability-title"),
                listName: "availability",
                list: searchState === null || searchState === void 0 ? void 0 : (ref4 = searchState.result) === null || ref4 === void 0 ? void 0 : ref4.availabilityAggregations,
                dataTest: "AvailabilityFilters"
            }),
            hasFilter("rating") && /*#__PURE__*/ react.createElement(RatingFilter, null),
            hasFilter("promotionType") && /*#__PURE__*/ react.createElement(CheckBoxListFilter, {
                title: t("filter", "filter.promotions-title"),
                listName: "promotionType",
                list: sortedTypeAggregations,
                dataTest: "PromotionTypeFilters"
            })
        ];
        return elementsOrFalse.filter(Boolean).map(function(el) {
            return el;
        });
    }, [
        (ref = searchState.promotionsResult) === null || ref === void 0 ? void 0 : ref.typeAggregations,
        searchState === null || searchState === void 0 ? void 0 : (ref1 = searchState.result) === null || ref1 === void 0 ? void 0 : ref1.categoryAggregations,
        searchState === null || searchState === void 0 ? void 0 : (ref2 = searchState.result) === null || ref2 === void 0 ? void 0 : ref2.brandsAggregations,
        searchState === null || searchState === void 0 ? void 0 : (ref3 = searchState.result) === null || ref3 === void 0 ? void 0 : ref3.shopAggregations,
        searchState === null || searchState === void 0 ? void 0 : (ref4 = searchState.result) === null || ref4 === void 0 ? void 0 : ref4.availabilityAggregations,
        t,
        searchPageType,
        market.localeStandard
    ]);
    return /*#__PURE__*/ react.createElement(FiltersWrapper, null, filters.map(function(filter, index) {
        return(// eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ react.createElement(react.Fragment, {
            key: index
        }, filter));
    }));
};

// EXTERNAL MODULE: ./src/components/product-card/index.ts + 67 modules
var product_card = __webpack_require__(866);
// EXTERNAL MODULE: ./src/components/did-you-mean/index.tsx
var did_you_mean = __webpack_require__(19855);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/did-you-mean/did-you-mean-with-tracking.tsx




var DidYouMeanWithTracking = function(param) {
    var didYouMeanStrings = param.didYouMeanStrings;
    var ref;
    var ref1 = (0,search_context/* useSearchContext */.AB)(), searchState = ref1.searchState, setSearchState = ref1.setSearchState;
    var trackFilterSelectEvent = (0,tracking_context/* useTrackingContext */.EF)().trackFilterSelectEvent;
    var onClick = function(didYouMeanQuery) {
        trackFilterSelectEvent({
            value: didYouMeanQuery,
            property: "campaign-search",
            layout: "applied-filter",
            type: "product-name-search"
        });
        setSearchState({
            filters: {
                query: didYouMeanQuery
            },
            page: 1
        });
    };
    return /*#__PURE__*/ react.createElement(did_you_mean/* DidYouMean */.a, {
        didYouMeanQueries: didYouMeanStrings,
        searchQuery: ((ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.query) || "",
        handleClick: onClick
    });
};

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotions-page/components/promotion-card/index.ts + 2 modules
var promotion_card = __webpack_require__(82854);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var layout_buttons_types = __webpack_require__(21068);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/content/styles.ts
function content_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function content_styles_templateObject() {
    var data = content_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n  width: 100%;\n"
    ]);
    content_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function content_styles_templateObject1() {
    var data = content_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n\n  > h3 {\n    margin: 0;\n  }\n"
    ]);
    content_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function content_styles_templateObject2() {
    var data = content_styles_taggedTemplateLiteral([
        "\n    grid-template-columns: repeat(",
        ", minmax(0, 1fr));\n    gap: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  "
    ]);
    content_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function content_styles_templateObject3() {
    var data = content_styles_taggedTemplateLiteral([
        "\n  display: grid;\n\n  grid-template-columns: repeat(",
        ", minmax(0, 1fr));\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    content_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function content_styles_templateObject4() {
    var data = content_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        ";\n\n  > button {\n    flex-grow: 1;\n  }\n"
    ]);
    content_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function content_styles_templateObject5() {
    var data = content_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    content_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function content_styles_templateObject6() {
    var data = content_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    content_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = content_styles_taggedTemplateLiteral([
        "\n  max-width: 100%;\n\n  > .input {\n    width: 100%;\n  }\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = content_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var GRID_COLUMNS_DESKTOP = 3;
var GRID_COLUMNS_MOBILE = 2;
var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-0"
})(content_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledHeaderTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeaderTitle",
    componentId: "sc-0-1"
})(content_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledProducts = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledProducts",
    componentId: "sc-0-2"
})(content_styles_templateObject3(), GRID_COLUMNS_DESKTOP, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* media.smallDown */.BC.smallDown(content_styles_templateObject2(), GRID_COLUMNS_MOBILE, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025));
var StyledFilterModalFooter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFilterModalFooter",
    componentId: "sc-0-3"
})(content_styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledFilterModalButton = (0,styled_components_browser_esm["default"])(ui_button.Button).withConfig({
    displayName: "StyledFilterModalButton",
    componentId: "sc-0-4"
})(content_styles_templateObject6(), base/* media.largeUp */.BC.largeUp(content_styles_templateObject5()));
var StyledSearchContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSearchContainer",
    componentId: "sc-0-5"
})(styles_templateObject7());
var StyledContentHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContentHeader",
    componentId: "sc-0-6"
})(styles_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotion-products-page/contexts/promotion-context.tsx
var promotion_context = __webpack_require__(76738);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/content/content.tsx
function content_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function content_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function content_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function content_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function content_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function content_slicedToArray(arr, i) {
    return content_arrayWithHoles(arr) || content_iterableToArrayLimit(arr, i) || content_unsupportedIterableToArray(arr, i) || content_nonIterableRest();
}
function content_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return content_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return content_arrayLikeToArray(o, minLen);
}



























var ADS_LAYOUT = content_defineProperty({}, layout_buttons_types/* LayoutMode.GRID */.X.GRID, {
    panorama_extra: {
        show: true,
        row: 5
    },
    dubbelpanorama1: {
        show: true,
        row: 2
    },
    dubbelpanorama2: {
        show: false,
        row: 8
    }
});
var Content = function(param) {
    var searchPageType = param.searchPageType;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,app_context/* useAppContext */.bp)(), t = ref4.t, linkTo = ref4.linkTo;
    var ref5 = (0,search_context/* useSearchContext */.AB)(), searchState = ref5.searchState, setSearchState = ref5.setSearchState, clearSearchState = ref5.clearSearchState;
    var promotionInfo = (0,promotion_context/* usePromotionContext */.ER)();
    var ref6 = content_slicedToArray((0,react.useState)(false), 2), isFilterModalOpen = ref6[0], setIsFilterModalOpen = ref6[1];
    var products = ((ref = searchState.result) === null || ref === void 0 ? void 0 : ref.items) || [];
    var promotions = ((ref1 = searchState.promotionsResult) === null || ref1 === void 0 ? void 0 : ref1.items) || [];
    var numberOfHits = (ref2 = searchState.result) === null || ref2 === void 0 ? void 0 : ref2.numberOfHits;
    var numberOfFiltersActive = (0,filter_utils/* getActiveFilters */.De)(searchState, t).length > 0 ? " (".concat((0,filter_utils/* getActiveFilters */.De)(searchState, t).length, ")") : null;
    var getDefaultSort = function() {
        if (products.length > 0) return types/* ProductSortOptionValueEnum.PRODUCT_POPULARITY_TOTAL */.mJ.PRODUCT_POPULARITY_TOTAL;
        if (promotions.length > 0) return types/* PromotionsSortOptionValueEnum.START_DATE */.GZ.START_DATE;
        return null;
    };
    var defaultSort = getDefaultSort();
    var renderDealProduct = function(product, index) {
        var ref;
        /*#__PURE__*/ return react.createElement(product_card/* DealsProductCard */.N8, {
            key: (ref = product.productId) === null || ref === void 0 ? void 0 : ref.toString(),
            product: product,
            trackingIndex: index
        });
    };
    var renderPromotionProduct = function(product, index) {
        return /*#__PURE__*/ react.createElement(product_card/* PromotionProductCard */.dK, {
            key: product.productId.toString(),
            product: product,
            promotionInfo: promotionInfo,
            trackingIndex: index
        });
    };
    var renderUsedProduct = function(product, index) {
        return /*#__PURE__*/ react.createElement(product_card/* UsedProductCard */.Ie, {
            key: product.productId.toString(),
            product: product,
            trackingIndex: index
        });
    };
    var renderProductFunction = (0,react.useMemo)(function() {
        switch(searchPageType){
            case types/* SearchPageType.DEALS */.zh.DEALS:
                return renderDealProduct;
            case types/* SearchPageType.BRAND_PROMOTIONS_PRODUCTS */.zh.BRAND_PROMOTIONS_PRODUCTS:
            case types/* SearchPageType.SHOP_PROMOTIONS_PRODUCTS */.zh.SHOP_PROMOTIONS_PRODUCTS:
                return renderPromotionProduct;
            case types/* SearchPageType.USED */.zh.USED:
                return renderUsedProduct;
            default:
                return renderPromotionProduct;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchPageType
    ]);
    var renderPromotionCard = function(promotion, index) {
        var onPromotionClick = function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: promotion.owner.type === types/* PromotionOwnerTypeEnum.SHOP */.BB.SHOP ? tracking/* InternalNavigationScope.PROMOTION_CARD_SHOP */.U.PROMOTION_CARD_SHOP : tracking/* InternalNavigationScope.PROMOTION_CARD_BRAND */.U.PROMOTION_CARD_BRAND,
                nextPage: linkTo("promotions", promotion),
                index: index
            });
        };
        return /*#__PURE__*/ react.createElement(promotion_card/* PromotionCard */.D, {
            promotion: promotion,
            key: promotion.id,
            onClick: onPromotionClick
        });
    };
    var renderContent = function() {
        if (!searchState.isFetching && !products.length && !promotions.length) {
            var ref;
            var didYouMean = ((ref = searchState.result) === null || ref === void 0 ? void 0 : ref.didYouMean) || [];
            return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledContent, null, /*#__PURE__*/ react.createElement(info_message/* InfoMessage */.$, {
                message: {
                    text: t("filter", "empty-message.no-filter-match"),
                    link: // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid
                    /*#__PURE__*/ react.createElement("a", {
                        onClick: function() {
                            return clearSearchState();
                        }
                    }, t("filter", "button.clear-filters"))
                }
            })), didYouMean.length ? /*#__PURE__*/ react.createElement(DidYouMeanWithTracking, {
                didYouMeanStrings: didYouMean
            }) : null);
        }
        return /*#__PURE__*/ react.createElement(react.Fragment, null, searchState.isFetching ? /*#__PURE__*/ react.createElement(placeholder/* Placeholder */.V, {
            color: placeholder/* ColorsEnum.WHITE */.C.WHITE,
            height: 450,
            amount: 12,
            rows: 8
        }) : /*#__PURE__*/ react.createElement(StyledProducts, {
            "data-test": "SearchResultList"
        }, isPromotionsPage(searchPageType) ? promotions.map(function(promotion, i) {
            return renderPromotionCard(promotion, i);
        }) : /*#__PURE__*/ react.createElement(react.Fragment, null, products.map(function(product, i) {
            return renderProductFunction(product, i);
        }), !isPromotionProductsPage(searchPageType) && /*#__PURE__*/ react.createElement(ads/* Ads */.f, {
            offersLength: products.length + promotions.length,
            layout: layout_buttons_types/* LayoutMode.GRID */.X.GRID,
            layoutConfig: ADS_LAYOUT,
            scaleBase: "deals-grid",
            async: true,
            scale: 0.72
        }))), /*#__PURE__*/ react.createElement(Pagination, null));
    };
    var handleSearch = function(value) {
        if (value === "") {
            setSearchState({
                filters: {
                    query: value
                },
                sortType: types/* ProductSortOptionValueEnum.PRODUCT_POPULARITY_TOTAL */.mJ.PRODUCT_POPULARITY_TOTAL
            });
        } else {
            setSearchState({
                filters: {
                    query: value
                },
                sortType: types/* ProductSortOptionValueEnum.RELEVANCE */.mJ.RELEVANCE
            });
        }
    };
    return /*#__PURE__*/ react.createElement(StyledContent, null, /*#__PURE__*/ react.createElement(StyledContentHeader, null, /*#__PURE__*/ react.createElement(StyledHeaderTitle, null, /*#__PURE__*/ react.createElement(modal/* Modal */.u_, {
        isOpen: isFilterModalOpen,
        onRequestClose: function() {
            return setIsFilterModalOpen(false);
        },
        title: t("campaigns", "filter.title"),
        size: modal/* ModalSizeEnum.SMALL */.E$.SMALL
    }, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(FilterPanel, {
        showTitle: false
    }, /*#__PURE__*/ react.createElement(SearchFilters, {
        searchPageType: searchPageType
    }))), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(StyledFilterModalFooter, null, /*#__PURE__*/ react.createElement(variants.TonalButton, {
        onClick: function() {
            return clearSearchState();
        }
    }, t("campaigns", "filter.clear-button")), /*#__PURE__*/ react.createElement(ui_button.Button, {
        onClick: function() {
            return setIsFilterModalOpen(false);
        }
    }, t("campaigns", "filter.title"))))), /*#__PURE__*/ react.createElement(StyledFilterModalButton, {
        onClick: function() {
            return setIsFilterModalOpen(true);
        }
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(sliders/* IconSliders */.O, null)), /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("campaigns", "filter.title"), numberOfFiltersActive)), numberOfHits !== undefined && /*#__PURE__*/ react.createElement(text_variants.H3Text, {
        containerProps: {
            "data-test": "NumberOfResults"
        }
    }, t("campaigns", "deals.n-results", {
        n: numberOfHits >= 1000 ? "1000+" : numberOfHits
    })), defaultSort && /*#__PURE__*/ react.createElement(Sort, {
        defaultSort: defaultSort
    })), /*#__PURE__*/ react.createElement(ActiveFilters, null), /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(StyledSearchContainer, null, /*#__PURE__*/ react.createElement(SearchInput, {
        value: (ref3 = searchState.filters) === null || ref3 === void 0 ? void 0 : ref3.query,
        handleSearch: handleSearch
    })))), renderContent());
};
var isPromotionsPage = function(searchPageType) {
    return [
        types/* SearchPageType.PROMOTIONS */.zh.PROMOTIONS,
        types/* SearchPageType.BRAND_PROMOTIONS */.zh.BRAND_PROMOTIONS,
        types/* SearchPageType.SHOP_PROMOTIONS */.zh.SHOP_PROMOTIONS
    ].includes(searchPageType);
};
var isPromotionProductsPage = function(searchPageType) {
    return [
        types/* SearchPageType.BRAND_PROMOTIONS_PRODUCTS */.zh.BRAND_PROMOTIONS_PRODUCTS,
        types/* SearchPageType.SHOP_PROMOTIONS_PRODUCTS */.zh.SHOP_PROMOTIONS_PRODUCTS
    ].includes(searchPageType);
};

// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./src/components/truncated/index.tsx
var truncated = __webpack_require__(16732);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/popular-filters/styles.ts
function popular_filters_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function popular_filters_styles_templateObject() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-bottom: -",
        ";\n  padding-top: ",
        ";\n"
    ]);
    popular_filters_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject1() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n    flex-wrap: unset;\n    overflow: auto;\n    margin: 0 -",
        ";\n    padding: 1px ",
        ";\n  "
    ]);
    popular_filters_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject2() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  column-gap: ",
        ";\n  list-style: none;\n  margin: 0;\n  flex: 1 1 100%;\n\n  ",
        "\n"
    ]);
    popular_filters_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject3() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  visibility: hidden;\n"
    ]);
    popular_filters_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject4() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  width: 90%;\n"
    ]);
    popular_filters_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject5() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n      order: ",
        ";\n    "
    ]);
    popular_filters_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject6() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    popular_filters_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject7() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n      box-shadow: 0 0 0 1px ",
        ";\n\n      &&:hover {\n        box-shadow: 0 0 0 1px ",
        ";\n      }\n    "
    ]);
    popular_filters_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject8() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n  height: ",
        "px;\n  margin-bottom: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        "px;\n  width: max-content;\n  max-width: 210px;\n  cursor: pointer;\n  background: ",
        ";\n  transition:\n    border-color 0.2s ease-in-out,\n    box-shadow 0.2s ease-in-out;\n\n  &&:hover {\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  }\n\n  &.focus-visible {\n    border-color: ",
        ";\n    box-shadow: 0 0 2px 3px ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    popular_filters_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n  gap: ",
        ";\n  padding: ",
        ";\n  min-width: 80px;\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  padding: 0;\n  min-width: auto;\n  max-width: auto;\n  flex: 1 1 auto;\n\n  & > span {\n    border-radius: ",
        "px;\n  }\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: ",
        "px;\n  height: ",
        "px;\n  flex: 1 0 ",
        "px;\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: ",
        "px;\n  width: ",
        "px;\n  padding: ",
        ";\n  gap: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        "px;\n  cursor: pointer;\n  background: ",
        ";\n\n  &&:hover {\n    background: ",
        ";\n  }\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  flex-basis: 100%;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var IMAGE_SIZE = 40;
var BUTTON_HEIGHT = 56;
var StyledPopularFilterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPopularFilterWrapper",
    componentId: "sc-0-0"
})(popular_filters_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledPopularFilters = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "StyledPopularFilters",
    componentId: "sc-0-1"
})(popular_filters_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(popular_filters_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var StyledGhostFilters = (0,styled_components_browser_esm["default"])(StyledPopularFilters).withConfig({
    displayName: "StyledGhostFilters",
    componentId: "sc-0-2"
})(popular_filters_styles_templateObject3());
var StyledSkeletonWrapper = (0,styled_components_browser_esm["default"])(StyledPopularFilters).withConfig({
    displayName: "StyledSkeletonWrapper",
    componentId: "sc-0-3"
})(popular_filters_styles_templateObject4());
var StyledFilterItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledFilterItem",
    componentId: "sc-0-4"
})(popular_filters_styles_templateObject6(), function(p) {
    return p.$order !== undefined && p.$order >= 0 && (0,styled_components_browser_esm.css)(popular_filters_styles_templateObject5(), p.$order);
});
var StyledIconButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledIconButton",
    componentId: "sc-0-5"
})(popular_filters_styles_templateObject8(), BUTTON_HEIGHT, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, function(p) {
    return p.theme.colors.base200;
}, BUTTON_HEIGHT / 2, function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return p.theme.colors.maybeBlue500;
}, function(p) {
    return p.theme.colors.maybeBlue300;
}, function(p) {
    return p.$selected && (0,styled_components_browser_esm.css)(popular_filters_styles_templateObject7(), p.theme.colors.maybeBlue500, p.theme.colors.maybeBlue500, p.theme.colors.maybeBlue500);
});
var StyledButtonInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledButtonInner",
    componentId: "sc-0-6"
})(styles_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var StyledSkeletonButtons = (0,styled_components_browser_esm["default"])(StyledIconButton).withConfig({
    displayName: "StyledSkeletonButtons",
    componentId: "sc-0-7"
})(styles_templateObject10(), BUTTON_HEIGHT / 2);
var StyledImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-8"
})(styles_templateObject11(), IMAGE_SIZE, IMAGE_SIZE, IMAGE_SIZE);
var StyledExpandButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledExpandButton",
    componentId: "sc-0-9"
})(styles_templateObject12(), BUTTON_HEIGHT, BUTTON_HEIGHT, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.base200;
}, BUTTON_HEIGHT / 2, function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return p.theme.colors.base100;
});
var StyledRowBreak = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledRowBreak",
    componentId: "sc-0-10"
})(styles_templateObject13());

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/popular-filters/components/filter-button/index.tsx





var PopularFilterButton = function(props) {
    var item = props.item, onClick = props.onClick, showImageAndText = props.showImageAndText, selected = props.selected;
    return /*#__PURE__*/ react.createElement(StyledIconButton, {
        "data-test": "PopularFilter",
        onClick: function() {
            return onClick(item);
        },
        $selected: selected
    }, /*#__PURE__*/ react.createElement(StyledButtonInner, null, showImageAndText && item.logo && /*#__PURE__*/ react.createElement(StyledImage, null, /*#__PURE__*/ react.createElement("img", {
        src: item.logo,
        alt: ""
    })), /*#__PURE__*/ react.createElement(truncated/* Truncated */.J, null, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        emphasis: ui_text.FontEmphasis.HIGH,
        color: ui_text.FontColor.DARK
    }, item.name))));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/popular-filters/components/filter-list/utils.ts
var calculateVisibleItemsForFirstRow = function(ghostElement) {
    var ref;
    if (!ghostElement || ghostElement.children.length === 0) {
        return -1;
    }
    // Set width of ghost element and calculate how many items fit in the first row
    // eslint-disable-next-line no-param-reassign
    ghostElement.style.width = "".concat((ref = ghostElement.parentElement) === null || ref === void 0 ? void 0 : ref.clientWidth, "px");
    var gap = 8;
    var expandButtonWidth = 56;
    var calcSafetyMargin = 10;
    var sanityLimit = 100;
    var maxWidth = ghostElement.clientWidth - expandButtonWidth - calcSafetyMargin;
    var numberOfItems = 0;
    var currentWidth = 0;
    var item = ghostElement.children[numberOfItems];
    while(item && currentWidth + item.getBoundingClientRect().width + gap < maxWidth && numberOfItems < sanityLimit){
        currentWidth += item.getBoundingClientRect().width + gap;
        numberOfItems += 1;
        item = ghostElement.children[numberOfItems];
    }
    return numberOfItems;
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/popular-filters/components/filter-list/index.tsx
function filter_list_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function filter_list_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function filter_list_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function filter_list_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function filter_list_slicedToArray(arr, i) {
    return filter_list_arrayWithHoles(arr) || filter_list_iterableToArrayLimit(arr, i) || filter_list_unsupportedIterableToArray(arr, i) || filter_list_nonIterableRest();
}
function filter_list_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return filter_list_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return filter_list_arrayLikeToArray(o, minLen);
}








var MIN_VISIBLE = 4;
var MAX_VISIBLE = 20;
var PopularFilterList = function(props) {
    var items = props.items, onClick = props.onClick, showImageAndText = props.showImageAndText, selectionForMultiselect = props.selectionForMultiselect;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var ref = filter_list_slicedToArray((0,react.useState)(false), 2), isExpanded = ref[0], setIsExpanded = ref[1];
    var ref1 = filter_list_slicedToArray((0,react.useState)(false), 2), isResize = ref1[0], setIsResize = ref1[1];
    var ref2 = filter_list_slicedToArray((0,react.useState)(items === null || items === void 0 ? void 0 : items.slice(0, isDesktop ? MIN_VISIBLE : MAX_VISIBLE)), 2), visibleItems = ref2[0], setVisibleItems = ref2[1];
    var ref3 = filter_list_slicedToArray((0,react.useState)(MIN_VISIBLE), 2), itemsOnFirstRow = ref3[0], setItemsOnFirstRow = ref3[1];
    var ghostElement = (0,react.useRef)(null);
    var showMoreLabel = "+".concat(Math.min(items.length, MAX_VISIBLE) - itemsOnFirstRow);
    // Calculate visible items
    (0,react.useEffect)(function() {
        if (!isDesktop) {
            setVisibleItems(items === null || items === void 0 ? void 0 : items.slice(0, MAX_VISIBLE));
            return;
        }
        var firstRow = calculateVisibleItemsForFirstRow(ghostElement.current);
        var sliceEnd = firstRow > 0 ? firstRow : MAX_VISIBLE;
        var visisble = items === null || items === void 0 ? void 0 : items.slice(0, isExpanded ? MAX_VISIBLE : sliceEnd);
        setVisibleItems(visisble);
        setItemsOnFirstRow(sliceEnd);
        setIsResize(false);
    }, [
        isDesktop,
        isExpanded,
        isResize,
        items
    ]);
    // Handle resize
    (0,react.useEffect)(function() {
        var onResize = function() {
            if (false) {}
            setIsResize(true);
        };
        window.addEventListener("resize", onResize);
        onResize();
        return function() {
            return window.removeEventListener("resize", onResize);
        };
    }, [
        setIsResize
    ]);
    var isSelected = function(filter) {
        return selectionForMultiselect === null || selectionForMultiselect === void 0 ? void 0 : selectionForMultiselect.includes(filter.key);
    };
    var onExpand = function() {
        setIsExpanded(function(state) {
            return !state;
        });
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledPopularFilters, null, visibleItems.map(function(item, index) {
        return /*#__PURE__*/ react.createElement(StyledFilterItem, {
            key: item.key,
            $order: index
        }, /*#__PURE__*/ react.createElement(PopularFilterButton, {
            item: item,
            onClick: onClick,
            showImageAndText: showImageAndText,
            selected: isSelected(item)
        }));
    }), isDesktop && items.length > itemsOnFirstRow && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("li", {
        style: {
            order: itemsOnFirstRow - 1
        }
    }, /*#__PURE__*/ react.createElement(StyledExpandButton, {
        "data-test": "PopularFilterExpandButton",
        "aria-label": isExpanded ? t("common", "button.show-less") : t("common", "button.show-more"),
        onClick: onExpand
    }, isExpanded ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, showMoreLabel))), /*#__PURE__*/ react.createElement(StyledRowBreak, {
        style: {
            order: itemsOnFirstRow - 1
        }
    }))), isDesktop && /*#__PURE__*/ react.createElement(StyledGhostFilters, {
        ref: ghostElement
    }, items === null || items === void 0 ? void 0 : items.slice(0, MAX_VISIBLE).map(function(item) {
        return /*#__PURE__*/ react.createElement(StyledFilterItem, {
            key: "ghost-".concat(item.key)
        }, /*#__PURE__*/ react.createElement(PopularFilterButton, {
            item: item,
            onClick: function() {
                return null;
            },
            showImageAndText: showImageAndText,
            selected: isSelected(item)
        }));
    })));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/popular-filters/components/categories/index.tsx
function categories_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function categories_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            categories_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function categories_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function categories_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        categories_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var PopularCategories = function() {
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref2 = (0,search_context/* useSearchContext */.AB)(), searchState = ref2.searchState, setSearchState = ref2.setSearchState;
    var trackFilterSelectEvent = (0,tracking_context/* useTrackingContext */.EF)().trackFilterSelectEvent;
    var popularCategories = (((ref = searchState.result) === null || ref === void 0 ? void 0 : (ref1 = ref.leafCategories) === null || ref1 === void 0 ? void 0 : ref1.filter(function(category) {
        return category.name;
    })) || []).map(function(category) {
        return categories_objectSpreadProps(categories_objectSpread({}, category), {
            children: []
        });
    });
    var filterOnCategory = function(filter) {
        var newFilter = {
            category: [
                filter.key
            ]
        };
        setSearchState({
            filters: newFilter
        });
        trackFilterSelectEvent({
            property: "category",
            value: filter.key,
            type: "facet-navigation",
            layout: "facet-navigation"
        });
    };
    if (popularCategories.length === 0) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledPopularFilterWrapper, null, /*#__PURE__*/ react.createElement(text_variants.H4Text, null, t("search", "popular-categories.title")), /*#__PURE__*/ react.createElement(PopularFilterList, {
        items: popularCategories,
        onClick: filterOnCategory,
        showImageAndText: true
    }));
};

// EXTERNAL MODULE: ./src/components/skeleton/index.ts + 3 modules
var skeleton = __webpack_require__(75598);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/popular-filters/components/brands/loading.tsx




var LoadingSkeletonButtons = function() {
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var skeletons = Array.from({
        length: isDesktop ? 6 : 4
    });
    return /*#__PURE__*/ react.createElement(StyledSkeletonWrapper, null, skeletons.map(function(_) {
        return /*#__PURE__*/ react.createElement(StyledSkeletonButtons, {
            key: "skeleton-".concat(Math.random())
        }, /*#__PURE__*/ react.createElement(skeleton/* SkeletonParagraph */.Bp, {
            width: "100%",
            height: "100%"
        }));
    }));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/popular-filters/components/brands/utils.ts
var createListItem = function(filter) {
    return {
        key: filter.key,
        name: filter.name,
        logo: filter.logo,
        count: filter.count,
        children: []
    };
};
var compareBrands = function(a, b) {
    if (a.count === b.count) {
        return a.name.localeCompare(b.name);
    }
    return b.count - a.count;
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/popular-filters/components/brands/index.tsx
function brands_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function brands_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function brands_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return brands_arrayLikeToArray(arr);
}
function brands_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function brands_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function brands_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function brands_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function brands_slicedToArray(arr, i) {
    return brands_arrayWithHoles(arr) || brands_iterableToArrayLimit(arr, i) || brands_unsupportedIterableToArray(arr, i) || brands_nonIterableRest();
}
function brands_toConsumableArray(arr) {
    return brands_arrayWithoutHoles(arr) || brands_iterableToArray(arr) || brands_unsupportedIterableToArray(arr) || brands_nonIterableSpread();
}
function brands_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return brands_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return brands_arrayLikeToArray(o, minLen);
}









var PopularBrands = function() {
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref2 = (0,tracking_context/* useTrackingContext */.EF)(), trackFilterSelectEvent = ref2.trackFilterSelectEvent, trackFilterRemoveEvent = ref2.trackFilterRemoveEvent;
    var ref3 = (0,search_context/* useSearchContext */.AB)(), searchState = ref3.searchState, setSearchState = ref3.setSearchState;
    var ref4 = brands_slicedToArray((0,react.useState)(), 2), isFetching = ref4[0], setIsFetching = ref4[1];
    var selection = ((ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.brands) || [];
    var popularBrands = ((ref1 = searchState.result) === null || ref1 === void 0 ? void 0 : ref1.brandsAggregations.filter(function(brand) {
        return brand.name;
    })) || [];
    var sortedBrands = popularBrands.map(createListItem).sort(compareBrands);
    var filterOnBrand = function(filter) {
        var newFilter;
        if (selection.includes(filter.key)) {
            // Remove filter
            var newSelection = selection.filter(function(f) {
                return f !== filter.key;
            });
            newFilter = {
                brands: newSelection
            };
            trackFilterRemoveEvent({
                property: "brand",
                value: filter.key,
                type: "facet-navigation",
                layout: "facet-navigation"
            });
        } else {
            // Add filter
            newFilter = {
                brands: brands_toConsumableArray(selection).concat([
                    filter.key
                ])
            };
            trackFilterSelectEvent({
                property: "brand",
                value: filter.key,
                type: "facet-navigation",
                layout: "facet-navigation"
            });
        }
        setSearchState({
            filters: newFilter
        });
    };
    // Show loader for initial fetch
    (0,react.useEffect)(function() {
        if (isFetching === undefined) {
            setIsFetching(true);
        } else if (!searchState.isFetching) {
            setIsFetching(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchState.isFetching
    ]);
    if (isFetching === false && sortedBrands.length === 0) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledPopularFilterWrapper, null, /*#__PURE__*/ react.createElement(text_variants.H4Text, null, t("search", "popular-brands.title")), isFetching === false ? /*#__PURE__*/ react.createElement(PopularFilterList, {
        items: sortedBrands,
        onClick: filterOnBrand,
        selectionForMultiselect: selection
    }) : /*#__PURE__*/ react.createElement(LoadingSkeletonButtons, null));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/popular-filters/index.tsx




var PopularFilters = function() {
    var ref, ref1;
    var searchState = (0,search_context/* useSearchContext */.AB)().searchState;
    var isCategorySelected = Boolean((ref = searchState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.length);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, !isCategorySelected && /*#__PURE__*/ react.createElement(PopularCategories, null), isCategorySelected && /*#__PURE__*/ react.createElement(PopularBrands, null));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/content-wrapper/styles.ts
function content_wrapper_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function content_wrapper_styles_templateObject() {
    var data = content_wrapper_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  column-gap: ",
        ";\n"
    ]);
    content_wrapper_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledSection = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "StyledSection",
    componentId: "sc-0-0"
})(content_wrapper_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/content-wrapper/index.tsx








var ContentWrapper = function(param) {
    var searchPageType = param.searchPageType;
    var showPopularFilters = searchPageType !== types/* SearchPageType.PROMOTIONS */.zh.PROMOTIONS;
    return /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noPad: "top",
        recessed: true
    }, showPopularFilters && /*#__PURE__*/ react.createElement(PopularFilters, null), /*#__PURE__*/ react.createElement(StyledSection, null, /*#__PURE__*/ react.createElement(FilterPanel, {
        hideOnMobile: true
    }, /*#__PURE__*/ react.createElement(SearchFilters, {
        searchPageType: searchPageType
    })), /*#__PURE__*/ react.createElement(Content, {
        searchPageType: searchPageType
    })));
};


/***/ }),

/***/ 61961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": () => (/* binding */ DescriptionText)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/types.ts
var types = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/description-text/utils.ts

var getPageDescription = function(t, searchPageType) {
    switch(searchPageType){
        case types/* SearchPageType.USED */.zh.USED:
            return t("search", "scoped-search.used-transparency-info");
        case types/* SearchPageType.BRAND_PROMOTIONS */.zh.BRAND_PROMOTIONS:
        case types/* SearchPageType.PROMOTIONS */.zh.PROMOTIONS:
        case types/* SearchPageType.SHOP_PROMOTIONS */.zh.SHOP_PROMOTIONS:
            return t("search", "scoped-search.promotion-transparency-info");
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/description-text/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 600px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n  white-space: nowrap;\n  padding-left: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledDescription = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDescription",
    componentId: "sc-0-0"
})(_templateObject());
var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.base800;
}, design_tokens.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/description-text/index.tsx




var DescriptionText = function(param) {
    var descriptionText = param.descriptionText, readMoreLink = param.readMoreLink, searchPageType = param.searchPageType;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var description = descriptionText || getPageDescription(t, searchPageType);
    if (!description) return null;
    return /*#__PURE__*/ react.createElement(StyledDescription, {
        "data-test": "DescriptionText"
    }, description, readMoreLink ? /*#__PURE__*/ react.createElement(StyledLink, {
        to: readMoreLink
    }, t("campaigns", "campaign.deals-read-more")) : null);
};


/***/ }),

/***/ 37680:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jn": () => (/* binding */ SearchStateProvider),
  "AB": () => (/* binding */ useSearchContext)
});

// UNUSED EXPORTS: SearchContext

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/filter-utils.ts
var filter_utils = __webpack_require__(46053);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/types.ts
var types = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/contexts/utils.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var updateUrlQuery = function(campaignState) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
    var query = ((ref = campaignState.filters) === null || ref === void 0 ? void 0 : ref.query) && [
        "query",
        campaignState.filters.query
    ];
    var price = ((ref1 = campaignState.filters) === null || ref1 === void 0 ? void 0 : ref1.priceRangeCustom) && [
        "price",
        "".concat((ref2 = campaignState.filters) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.priceRangeCustom) === null || ref3 === void 0 ? void 0 : ref3.from, "-").concat((ref4 = campaignState.filters) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.priceRangeCustom) === null || ref5 === void 0 ? void 0 : ref5.to)
    ];
    var priceDrop = ((ref6 = campaignState.filters) === null || ref6 === void 0 ? void 0 : ref6.priceDropPercent) && [
        "price-drop",
        (0,filter_utils/* getPriceDropText */.m3)((ref7 = campaignState.filters) === null || ref7 === void 0 ? void 0 : ref7.priceDropPercent)
    ];
    var brands = ((ref8 = campaignState.filters) === null || ref8 === void 0 ? void 0 : ref8.brands) && ((ref9 = campaignState.filters) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.brands) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 && [
        "brands",
        (ref11 = campaignState.filters) === null || ref11 === void 0 ? void 0 : ref11.brands.join("|")
    ];
    var condition = ((ref12 = campaignState.filters) === null || ref12 === void 0 ? void 0 : ref12.condition) && ((ref13 = campaignState.filters) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.condition) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 && [
        "condition",
        (ref15 = campaignState.filters) === null || ref15 === void 0 ? void 0 : ref15.condition.join("|")
    ];
    var shops = ((ref16 = campaignState.filters) === null || ref16 === void 0 ? void 0 : ref16.shops) && ((ref17 = campaignState.filters) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.shops) === null || ref18 === void 0 ? void 0 : ref18.length) > 0 && [
        "shops",
        (ref19 = campaignState.filters) === null || ref19 === void 0 ? void 0 : ref19.shops.join("|")
    ];
    var availability = ((ref20 = campaignState.filters) === null || ref20 === void 0 ? void 0 : ref20.availability) && ((ref21 = campaignState.filters) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.availability) === null || ref22 === void 0 ? void 0 : ref22.length) > 0 && [
        "availability",
        (ref23 = campaignState.filters) === null || ref23 === void 0 ? void 0 : ref23.availability.join("|")
    ];
    var rating = ((ref24 = campaignState.filters) === null || ref24 === void 0 ? void 0 : ref24.rating) && [
        "rating",
        (ref25 = campaignState.filters) === null || ref25 === void 0 ? void 0 : ref25.rating
    ];
    var category = ((ref26 = campaignState.filters) === null || ref26 === void 0 ? void 0 : ref26.category) && ((ref27 = campaignState.filters) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.category) === null || ref28 === void 0 ? void 0 : ref28.length) > 0 && [
        "category",
        (ref29 = campaignState.filters) === null || ref29 === void 0 ? void 0 : ref29.category.join("|")
    ];
    var promotionType = ((ref30 = campaignState.filters) === null || ref30 === void 0 ? void 0 : ref30.promotionType) && ((ref31 = campaignState.filters) === null || ref31 === void 0 ? void 0 : ref31.promotionType.length) > 0 && [
        "promotionType",
        (ref32 = campaignState.filters) === null || ref32 === void 0 ? void 0 : ref32.promotionType.join("|")
    ];
    var sort = campaignState.sortType && [
        "sort",
        campaignState.sortType
    ];
    var page = campaignState.page && [
        "page",
        campaignState.page
    ];
    var queryToSet = [
        availability,
        rating,
        query,
        price,
        priceDrop,
        brands,
        condition,
        shops,
        category,
        promotionType,
        sort,
        page
    ].filter(function(q) {
        return q;
    });
    var urlQuery = new URLSearchParams(queryToSet);
    var newQuery = "?".concat(urlQuery.toString());
    return newQuery;
};
var getFilterAndSortFromQuery = function(initialState) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var init = _objectSpread({}, initialState);
    delete init.isFetching;
    delete init.result;
    if (false) {}
    var getPriceDropEnum = function(priceDropValue) {
        switch(priceDropValue){
            case "5":
                return types/* PriceDropPercent.PERCENT_5 */.E1.PERCENT_5;
            case "10":
                return types/* PriceDropPercent.PERCENT_10 */.E1.PERCENT_10;
            case "25":
                return types/* PriceDropPercent.PERCENT_25 */.E1.PERCENT_25;
            case "50":
                return types/* PriceDropPercent.PERCENT_50 */.E1.PERCENT_50;
            default:
                var ref;
                return ((ref = init.filters) === null || ref === void 0 ? void 0 : ref.priceDropPercent) || null;
        }
    };
    var getPriceRangeCustom = function(range) {
        if (!range) {
            return null;
        }
        var priceObj = range.split("-");
        return {
            from: parseInt(priceObj[0] || "0", 10),
            to: parseInt(priceObj[1] || "0", 10)
        };
    };
    var getValidatedConditions = function(conditions) {
        if (!conditions) {
            var ref;
            return ((ref = init.filters) === null || ref === void 0 ? void 0 : ref.condition) || [];
        }
        var validConditions = [];
        conditions.forEach(function(condition) {
            var ref, ref1;
            if ((ref = init.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.condition) === null || ref1 === void 0 ? void 0 : ref1.some(function(c) {
                return c === condition;
            })) {
                validConditions.push(condition);
            }
        });
        return validConditions;
    };
    var filterFromQuery = new URL(window.location.href).searchParams;
    var promotion = (ref = initialState.filters) === null || ref === void 0 ? void 0 : ref.promotion;
    var query = {
        query: filterFromQuery.get("query")
    };
    var priceDrop = {
        priceDropPercent: getPriceDropEnum(filterFromQuery.get("price-drop"))
    };
    var priceRangeCustom = {
        priceRangeCustom: getPriceRangeCustom(filterFromQuery.get("price"))
    };
    var endingSoon = {
        dealsEndingSoon: !!filterFromQuery.get("ending-soon")
    };
    var availability = {
        availability: (ref1 = filterFromQuery.get("availability")) === null || ref1 === void 0 ? void 0 : ref1.split("|")
    };
    var rating = {
        rating: filterFromQuery.get("rating") ? parseInt(filterFromQuery.get("rating"), 10) : null
    };
    var brands = {
        brands: (ref2 = filterFromQuery.get("brands")) === null || ref2 === void 0 ? void 0 : ref2.split("|")
    };
    var condition = {
        condition: getValidatedConditions((ref3 = filterFromQuery.get("condition")) === null || ref3 === void 0 ? void 0 : ref3.split("|"))
    };
    var shops = {
        shops: (ref4 = filterFromQuery.get("shops")) === null || ref4 === void 0 ? void 0 : ref4.split("|")
    };
    var category = {
        category: (ref5 = filterFromQuery.get("category")) === null || ref5 === void 0 ? void 0 : ref5.split("|")
    };
    var promotionType = {
        promotionType: (ref6 = filterFromQuery.get("promotionType")) === null || ref6 === void 0 ? void 0 : ref6.split("|")
    };
    var filterToSet = _objectSpreadProps(_objectSpread({}, query, endingSoon, priceDrop, priceRangeCustom, availability, rating, brands, condition, shops, category, promotionType), {
        promotion: promotion
    });
    var sortToReturn = filterFromQuery.get("sort");
    var pageToReturn = Number(filterFromQuery.get("page")) || initialState.page;
    var filtersToReturn = Object.fromEntries(Object.entries(filterToSet).filter(function(param) {
        var _param = _slicedToArray(param, 2), _key = _param[0], v = _param[1];
        return Boolean(v);
    }));
    var mergedFilters = _objectSpreadProps(_objectSpread({}, init), {
        filters: filtersToReturn,
        page: pageToReturn
    });
    if (sortToReturn) {
        mergedFilters.sortType = sortToReturn;
    }
    return mergedFilters;
};
var DEFAULT_SEARCH_V3_RESULT = {
    availabilityAggregations: [],
    brandsAggregations: [],
    categoryAggregations: [],
    leafCategories: [],
    didYouMean: [],
    hasMorePages: false,
    items: [],
    numberOfHits: 0,
    priceHistogram: [],
    ratingHistogram: [],
    shopAggregations: []
};
var mapSearchV3Result = function(searchV3ResultProducts, t) {
    var result = DEFAULT_SEARCH_V3_RESULT;
    if (searchV3ResultProducts) {
        var ref;
        result = _objectSpread({}, result, searchV3ResultProducts);
        var availabilityAggregations = (ref = result.availabilityAggregations) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return _objectSpreadProps(_objectSpread({}, item), {
                name: mapAvailabilityNameToTranslationKey(item.name, t)
            });
        });
        if (availabilityAggregations === null || availabilityAggregations === void 0 ? void 0 : availabilityAggregations.length) {
            result.availabilityAggregations = availabilityAggregations;
        }
    }
    return result;
};
var mapSearchV3PromotionsResult = function(searchV3PromotionsResult, t) {
    var result;
    if (searchV3PromotionsResult) {
        var ref;
        result = _objectSpread({}, searchV3PromotionsResult);
        var typeAggregations = (ref = result.typeAggregations) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return _objectSpreadProps(_objectSpread({}, item), {
                name: mapPromotionTypeNameToTranslationKey(item.name, t)
            });
        });
        if (typeAggregations === null || typeAggregations === void 0 ? void 0 : typeAggregations.length) {
            result.typeAggregations = typeAggregations;
        }
    }
    return result;
};
var mergePromotionsIntoSearchV3Result = function(searchV3PromotionsResult, searchV3ResultProducts) {
    var result = searchV3ResultProducts;
    if (searchV3ResultProducts) {
        result = _objectSpreadProps(_objectSpread({}, searchV3ResultProducts), {
            hasMorePages: (searchV3PromotionsResult === null || searchV3PromotionsResult === void 0 ? void 0 : searchV3PromotionsResult.hasMorePages) || searchV3ResultProducts.hasMorePages,
            numberOfHits: (searchV3PromotionsResult === null || searchV3PromotionsResult === void 0 ? void 0 : searchV3PromotionsResult.numberOfHits) || searchV3ResultProducts.numberOfHits,
            shopAggregations: (searchV3PromotionsResult === null || searchV3PromotionsResult === void 0 ? void 0 : searchV3PromotionsResult.shopAggregations) || searchV3ResultProducts.shopAggregations
        });
    }
    return result;
};
var mapAllResults = function(productsResult, promotionsResult, t) {
    var mappedProducts = mapSearchV3Result(productsResult, t);
    var mappedPromotions = mapSearchV3PromotionsResult(promotionsResult, t);
    // The merged result is needed for promotions to work in filters, paging etc
    var mergedResult = mergePromotionsIntoSearchV3Result(mappedPromotions, mappedProducts);
    return {
        result: mergedResult,
        promotionsResult: mappedPromotions
    };
};
var mapPromotionTypeNameToTranslationKey = function(name, t) {
    switch(name){
        case "FREE_GIFT":
            return t("search", "scoped-search.promotions-type-free-gift");
        case "DISCOUNT":
            return t("search", "scoped-search.promotions-type-discount");
        case "MONEY_DISCOUNT":
            return "".concat(t("search", "scoped-search.promotions-type-discount"), " kr"); // Temp ugly fix until BC has grouped all discount types under DISCOUNT
        case "PERCENT_DISCOUNT":
            return "".concat(t("search", "scoped-search.promotions-type-discount"), " %"); // Temp ugly fix until BC has grouped all discount types under DISCOUNT
        case "CONDITIONAL_DISCOUNT":
        case "CHEAPEST_FOR_FREE":
            return t("search", "scoped-search.promotions-type-conditional-discount");
        case "CASHBACK":
            return "Cashback"; // this is just a safety precaution in case we get this value from the API (which we should)
        case "OTHER":
        default:
            return t("common", "title.other");
    }
};
var mapAvailabilityNameToTranslationKey = function(name, t) {
    switch(name){
        case "AVAILABLE":
            return t("search", "stock-status.available");
        default:
            return t("product", "stock-status.unknown");
    }
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/contexts/search-context.tsx
function search_context_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_context_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function search_context_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_context_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function search_context_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_context_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_context_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function search_context_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function search_context_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        search_context_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function search_context_slicedToArray(arr, i) {
    return search_context_arrayWithHoles(arr) || search_context_iterableToArrayLimit(arr, i) || search_context_unsupportedIterableToArray(arr, i) || search_context_nonIterableRest();
}
function search_context_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_context_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_context_arrayLikeToArray(o, minLen);
}






var SearchContext = /*#__PURE__*/ (0,react.createContext)({
    searchState: {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setSearchState: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    clearSearchState: function() {}
});
var useSearchContext = function() {
    return (0,react.useContext)(SearchContext);
};
var prevPage = 1;
var SearchStateProvider = function(param) {
    var children = param.children, initState = param.initState, useSearchQuery = param.useSearchQuery;
    var push = (0,react_router/* useHistory */.k6)().push;
    var location = (0,react_router/* useLocation */.TH)();
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = search_context_slicedToArray((0,react.useState)(initState), 1), initialState = ref[0];
    var filterAndSortFromQuery = getFilterAndSortFromQuery(initialState);
    var mappedResults = mapAllResults(initialState.result, initialState.promotionsResult, t);
    var ref1 = search_context_slicedToArray((0,react.useState)(search_context_objectSpreadProps(search_context_objectSpread({}, initialState, filterAndSortFromQuery, mappedResults), {
        isFetching: !initState.result && !initState.promotionsResult
    })), 2), searchState = ref1[0], updateSearchState = ref1[1];
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var page = (searchState.page || 1) - 1;
    var sortType = searchState.sortType;
    var filters = (0,filter_utils/* getFiltersForBff */.lf)(searchState.filters || initialState.filters);
    var searchQuery = useSearchQuery(search_context_objectSpreadProps(search_context_objectSpread({}, route === null || route === void 0 ? void 0 : route.variables), {
        filters: filters,
        page: page,
        sortType: sortType
    }), true);
    (0,react.useEffect)(function() {
        var sort = filterAndSortFromQuery.sortType || initialState.sortType;
        if (searchQuery.fetchStatus === "fetching") {
            updateSearchState(search_context_objectSpreadProps(search_context_objectSpread({}, searchState, filterAndSortFromQuery), {
                sortType: sort,
                isFetching: true
            }));
        }
        if (searchQuery.fetchStatus === "idle") {
            var ref, ref1, ref2, ref3;
            var results = mapAllResults((ref = searchQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.searchV3) === null || ref1 === void 0 ? void 0 : ref1.products, (ref2 = searchQuery.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.searchV3) === null || ref3 === void 0 ? void 0 : ref3.promotions, t);
            updateSearchState(search_context_objectSpreadProps(search_context_objectSpread(search_context_objectSpreadProps(search_context_objectSpread({}, searchState, filterAndSortFromQuery), {
                sortType: sort
            }), results), {
                isFetching: false
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchQuery.fetchStatus,
        location
    ]);
    var setSearchState = function(newState) {
        var merge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var newFilters = search_context_objectSpread({}, searchState.filters, newState.filters);
        var updatedState = search_context_objectSpread(search_context_objectSpreadProps(search_context_objectSpread({}, searchState), {
            /* page should always be 1 unless the newState provides a new value for it */ page: 1
        }), newState, {
            filters: merge ? newFilters : newState.filters
        });
        updateSearchState(updatedState);
        /** Note: using "useHistory.push" causes the entire page to reload,
     * which has the unwanted side-effect of scrolling to the top of the page
     * when changing filters or sorting on page 1. This code makes sure it
     * only reloads the page when the page number changes.
     */ var newPage = updatedState.page || 1;
        if (newPage !== prevPage) {
            prevPage = newPage;
            push(updateUrlQuery(updatedState));
        } else {
            window.history.pushState(null, "", updateUrlQuery(updatedState));
        }
    };
    var clearSearchState = function() {
        if (JSON.stringify(searchState.filters) !== JSON.stringify(initialState.filters) || searchState.sortType !== initialState.sortType) {
            setSearchState(search_context_objectSpread({}, initialState), false);
        }
    };
    var contextValue = (0,react.useMemo)(function() {
        return {
            searchState: searchState,
            setSearchState: setSearchState,
            clearSearchState: clearSearchState
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        searchState
    ]);
    return /*#__PURE__*/ react.createElement(SearchContext.Provider, {
        value: contextValue
    }, children);
};


/***/ }),

/***/ 83207:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EF": () => (/* binding */ useTrackingContext),
/* harmony export */   "qK": () => (/* binding */ TrackingFunctionsProvider)
/* harmony export */ });
/* unused harmony export TrackingContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15301);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _deals_page_contexts_deals_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50313);
/* harmony import */ var _search_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37680);





// -------- Context Creation --------
var initialState = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    trackFilterSelectEvent: function(_data) {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    trackFilterRemoveEvent: function(_data) {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    trackSortingSelectEvent: function(_data) {}
};
var TrackingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialState);
var useTrackingContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(TrackingContext);
};
// -------- utils --------
var getScopeFromSearchPageType = function(searchPageType) {
    switch(searchPageType){
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .SearchPageType.DEALS */ .zh.DEALS:
            return src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_1__/* .PageScope.DEALS */ .VN.DEALS;
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .SearchPageType.USED */ .zh.USED:
            return src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_1__/* .PageScope.USED */ .VN.USED;
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .SearchPageType.BRAND_PROMOTIONS */ .zh.BRAND_PROMOTIONS:
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .SearchPageType.PROMOTIONS */ .zh.PROMOTIONS:
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .SearchPageType.SHOP_PROMOTIONS */ .zh.SHOP_PROMOTIONS:
            return src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_1__/* .PageScope.PROMOTION */ .VN.PROMOTION;
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .SearchPageType.BRAND_PROMOTIONS_PRODUCTS */ .zh.BRAND_PROMOTIONS_PRODUCTS:
        case _types__WEBPACK_IMPORTED_MODULE_2__/* .SearchPageType.SHOP_PROMOTIONS_PRODUCTS */ .zh.SHOP_PROMOTIONS_PRODUCTS:
            return src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_1__/* .PageScope.PROMOTION_PRODUCTS */ .VN.PROMOTION_PRODUCTS;
        default:
            return null;
    }
};
// -------- Scoped versions of the global tracking functions --------
var scopedTrackFilterSelectEvent = function(searchPageType, campaignName, searchTerm, data) {
    return (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_1__/* .trackFilterSelectEvent */ .f9)({
        value: data.value,
        translatedValue: data.translatedValue,
        scope: getScopeFromSearchPageType(searchPageType),
        property: data.property,
        layout: data.layout,
        type: data.type,
        campaign: campaignName,
        searchTerm: searchTerm
    });
};
var scopedTrackFilterRemoveEvent = function(searchPageType, campaignName, searchTerm, data) {
    return (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_1__/* .trackFilterRemoveEvent */ .YD)({
        value: data.value,
        translatedValue: data.translatedValue,
        scope: getScopeFromSearchPageType(searchPageType),
        property: data.property,
        layout: data.layout,
        type: data.type,
        campaign: campaignName,
        searchTerm: searchTerm
    });
};
var scopedTrackSortingSelectEvent = function(searchPageType, campaignName, data) {
    (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_1__/* .trackSortingSelectEvent */ .Em)({
        value: data.value,
        scope: getScopeFromSearchPageType(searchPageType),
        property: data.property,
        campaign: campaignName
    });
};
// -------- Context Provider Creation --------
var TrackingFunctionsProvider = function(param) {
    var children = param.children, searchPageType = param.searchPageType;
    var ref;
    var campaign = (0,_deals_page_contexts_deals_context__WEBPACK_IMPORTED_MODULE_3__/* .useDealsContext */ .Yz)().campaign;
    var searchState = (0,_search_context__WEBPACK_IMPORTED_MODULE_4__/* .useSearchContext */ .AB)().searchState;
    var campaignName = (campaign === null || campaign === void 0 ? void 0 : campaign.name) || null;
    var searchTerm = ((ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.query) || null;
    var functions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            trackFilterSelectEvent: function(data) {
                return scopedTrackFilterSelectEvent(searchPageType, campaignName, searchTerm, data);
            },
            trackFilterRemoveEvent: function(data) {
                return scopedTrackFilterRemoveEvent(searchPageType, campaignName, searchTerm, data);
            },
            trackSortingSelectEvent: function(data) {
                return scopedTrackSortingSelectEvent(searchPageType, campaignName, data);
            }
        };
    }, [
        searchPageType,
        campaignName,
        searchTerm
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TrackingContext.Provider, {
        value: functions
    }, children);
};


/***/ }),

/***/ 46053:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "De": () => (/* binding */ getActiveFilters),
/* harmony export */   "lf": () => (/* binding */ getFiltersForBff),
/* harmony export */   "m3": () => (/* binding */ getPriceDropText)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73935);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var getPriceDropText = function(priceDrop) {
    switch(priceDrop){
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .PriceDropPercent.PERCENT_5 */ .E1.PERCENT_5:
            return 5;
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .PriceDropPercent.PERCENT_10 */ .E1.PERCENT_10:
            return 10;
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .PriceDropPercent.PERCENT_25 */ .E1.PERCENT_25:
            return 25;
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .PriceDropPercent.PERCENT_50 */ .E1.PERCENT_50:
            return 50;
        default:
            return null;
    }
};
var getFiltersForBff = function(filters) {
    var filtersToReturn = [];
    Object.keys(filters).forEach(function(filterKey) {
        if (Array.isArray(filters[filterKey]) && filters[filterKey].length === 0) {
            return;
        }
        switch(filterKey){
            case "query":
                if (!filters.query) break;
                filtersToReturn.push({
                    key: "query",
                    value: filters.query || ""
                });
                break;
            case "promotion":
                if (!filters.promotion) break;
                filtersToReturn.push({
                    key: "promotion",
                    value: filters.promotion || ""
                });
                break;
            case "priceRangeCustom":
                var ref, ref1;
                filtersToReturn.push({
                    key: "price",
                    value: "".concat((ref = filters.priceRangeCustom) === null || ref === void 0 ? void 0 : ref.from, "-").concat((ref1 = filters.priceRangeCustom) === null || ref1 === void 0 ? void 0 : ref1.to)
                });
                break;
            case "priceDropPercent":
                var ref2;
                filtersToReturn.push({
                    key: "pricedrop",
                    value: filters.priceDropPercent && ((ref2 = getPriceDropText(filters.priceDropPercent)) === null || ref2 === void 0 ? void 0 : ref2.toString()) || ""
                });
                break;
            case "availability":
                var ref3;
                filtersToReturn.push({
                    key: "availability",
                    value: ((ref3 = filters.availability) === null || ref3 === void 0 ? void 0 : ref3.join("|")) || ""
                });
                break;
            case "rating":
                var ref4;
                filtersToReturn.push({
                    key: "rating",
                    value: ((ref4 = filters.rating) === null || ref4 === void 0 ? void 0 : ref4.toString()) || ""
                });
                break;
            case "brands":
                var ref5;
                filtersToReturn.push({
                    key: "brands",
                    value: ((ref5 = filters.brands) === null || ref5 === void 0 ? void 0 : ref5.join("|")) || ""
                });
                break;
            case "condition":
                var ref6;
                filtersToReturn.push({
                    key: "condition",
                    value: ((ref6 = filters.condition) === null || ref6 === void 0 ? void 0 : ref6.join("|")) || ""
                });
                break;
            case "shops":
                var ref7;
                filtersToReturn.push({
                    key: "shop",
                    value: ((ref7 = filters.shops) === null || ref7 === void 0 ? void 0 : ref7.join("|")) || ""
                });
                break;
            case "category":
                var ref8;
                filtersToReturn.push({
                    key: "category",
                    value: ((ref8 = filters.category) === null || ref8 === void 0 ? void 0 : ref8.join("|")) || ""
                });
                break;
            case "promotionType":
                var ref9;
                filtersToReturn.push({
                    key: "promotionType",
                    value: ((ref9 = filters.promotionType) === null || ref9 === void 0 ? void 0 : ref9.join("|")) || ""
                });
                break;
            default:
                break;
        }
    });
    return filtersToReturn.sort(function(a, b) {
        return a.key.localeCompare(b.key);
    });
};
var getActiveFilters = function(searchState, t) {
    if (!searchState.filters) {
        return [];
    }
    var filters = Object.keys(searchState.filters).map(function(key) {
        var filterValue = searchState.filters[key];
        var value = "";
        var suffix;
        var prefix;
        switch(key){
            case "priceRangeCustom":
                prefix = t("campaigns", "filter.price");
                value = "".concat(filterValue.from, " - ").concat(filterValue.to);
                break;
            case "rating":
                prefix = t("common", "sort.user_reviews");
                if (filterValue !== 5) suffix = "+";
                value = filterValue.toString();
                break;
            default:
                break;
        }
        return {
            value: value,
            key: key,
            prefix: prefix,
            suffix: suffix
        };
    }).filter(function(filter) {
        return !!(filter === null || filter === void 0 ? void 0 : filter.value);
    });
    var arrayToFilter = function(keyValue, array) {
        return array.map(function(item) {
            var name = item;
            var key = "".concat(keyValue, "::").concat(item);
            switch(keyValue){
                case "category":
                    var ref, ref1;
                    name = ((ref1 = (ref = searchState.result) === null || ref === void 0 ? void 0 : ref.categoryAggregations.find(function(c) {
                        return c.key === item;
                    })) === null || ref1 === void 0 ? void 0 : ref1.name) || "";
                    break;
                case "brands":
                    var ref2, ref3;
                    name = ((ref3 = (ref2 = searchState.result) === null || ref2 === void 0 ? void 0 : ref2.brandsAggregations.find(function(c) {
                        return c.key === item;
                    })) === null || ref3 === void 0 ? void 0 : ref3.name) || "";
                    break;
                case "shops":
                    var ref4, ref5;
                    name = ((ref5 = (ref4 = searchState.result) === null || ref4 === void 0 ? void 0 : ref4.shopAggregations.find(function(c) {
                        return c.key === item;
                    })) === null || ref5 === void 0 ? void 0 : ref5.name) || "";
                    break;
                case "availability":
                    var ref6, ref7;
                    name = ((ref7 = (ref6 = searchState.result) === null || ref6 === void 0 ? void 0 : ref6.availabilityAggregations.find(function(c) {
                        return c.key === item;
                    })) === null || ref7 === void 0 ? void 0 : ref7.name) || "";
                    break;
                case "promotionType":
                    var ref8, ref9;
                    name = ((ref9 = (ref8 = searchState.promotionsResult) === null || ref8 === void 0 ? void 0 : ref8.typeAggregations.find(function(c) {
                        return c.key === item;
                    })) === null || ref9 === void 0 ? void 0 : ref9.name) || "";
                    break;
                default:
                    break;
            }
            return {
                value: name,
                key: key
            };
        });
    };
    var mergedFilters = _toConsumableArray(filters).concat(_toConsumableArray(arrayToFilter("category", searchState.filters.category || [])), _toConsumableArray(arrayToFilter("brands", searchState.filters.brands || [])), _toConsumableArray(arrayToFilter("shops", searchState.filters.shops || [])), _toConsumableArray(arrayToFilter("availability", searchState.filters.availability || [])), _toConsumableArray(arrayToFilter("promotionType", searchState.filters.promotionType || [])));
    return mergedFilters;
};


/***/ }),

/***/ 73935:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": () => (/* binding */ PromotionOwnerTypeEnum),
/* harmony export */   "E1": () => (/* binding */ PriceDropPercent),
/* harmony export */   "GZ": () => (/* binding */ PromotionsSortOptionValueEnum),
/* harmony export */   "MS": () => (/* binding */ PriceRange),
/* harmony export */   "mJ": () => (/* binding */ ProductSortOptionValueEnum),
/* harmony export */   "tl": () => (/* binding */ ConditionFilterValueEnum),
/* harmony export */   "zh": () => (/* binding */ SearchPageType)
/* harmony export */ });
/* unused harmony export SortDirectionEnum */
var SearchPageType;
(function(SearchPageType) {
    SearchPageType["BRAND_PROMOTIONS"] = "brand_promotions";
    SearchPageType["BRAND_PROMOTIONS_PRODUCTS"] = "brand_promotions_products";
    SearchPageType["DEALS"] = "deals";
    SearchPageType["PROMOTIONS"] = "promotions";
    SearchPageType["SHOP_PROMOTIONS"] = "shop_promotions";
    SearchPageType["SHOP_PROMOTIONS_PRODUCTS"] = "shop_promotions_products";
    SearchPageType["USED"] = "used";
})(SearchPageType || (SearchPageType = {}));
var SortDirectionEnum;
(function(SortDirectionEnum) {
    SortDirectionEnum[SortDirectionEnum["Ascending"] = 0] = "Ascending";
    SortDirectionEnum[SortDirectionEnum["Descending"] = 1] = "Descending";
})(SortDirectionEnum || (SortDirectionEnum = {}));
var ProductSortOptionValueEnum;
(function(ProductSortOptionValueEnum) {
    ProductSortOptionValueEnum["PRODUCT_POPULARITY_TOTAL"] = "popularity";
    ProductSortOptionValueEnum["PRICE_OFFER_ASC"] = "priceLowest";
    ProductSortOptionValueEnum["PRICE_OFFER_DESC"] = "priceHighest";
    ProductSortOptionValueEnum["PRODUCT_USER_REVIEWS_RATING_DESC"] = "rating";
    ProductSortOptionValueEnum["PRICE_DIFF_PERCENTAGE_DESC"] = "dealValue";
    ProductSortOptionValueEnum["DEAL_UPDATE_TIME"] = "dealUpdateTime";
    ProductSortOptionValueEnum["RELEVANCE"] = "score";
})(ProductSortOptionValueEnum || (ProductSortOptionValueEnum = {}));
var PromotionsSortOptionValueEnum;
(function(PromotionsSortOptionValueEnum) {
    PromotionsSortOptionValueEnum["RELEVANCY"] = "relevancy";
    PromotionsSortOptionValueEnum["END_DATE"] = "endDate";
    PromotionsSortOptionValueEnum["START_DATE"] = "startDate";
})(PromotionsSortOptionValueEnum || (PromotionsSortOptionValueEnum = {}));
var ConditionFilterValueEnum;
(function(ConditionFilterValueEnum) {
    ConditionFilterValueEnum["USED"] = "Used";
    ConditionFilterValueEnum["ALMOSTNEW"] = "AlmostNew";
    ConditionFilterValueEnum["NEW"] = "New";
})(ConditionFilterValueEnum || (ConditionFilterValueEnum = {}));
var PriceRange;
(function(PriceRange) {
    PriceRange["FROM_0_TO_200"] = "FROM_0_TO_200";
    PriceRange["FROM_200_TO_1000"] = "FROM_200_TO_1000";
    PriceRange["FROM_1000_TO_ALL"] = "FROM_1000_TO_ALL";
})(PriceRange || (PriceRange = {}));
var PriceDropPercent;
(function(PriceDropPercent) {
    PriceDropPercent["PERCENT_50"] = "PERCENT_50";
    PriceDropPercent["PERCENT_25"] = "PERCENT_25";
    PriceDropPercent["PERCENT_10"] = "PERCENT_10";
    PriceDropPercent["PERCENT_5"] = "PERCENT_5";
})(PriceDropPercent || (PriceDropPercent = {}));
var PromotionOwnerTypeEnum;
(function(PromotionOwnerTypeEnum) {
    PromotionOwnerTypeEnum["BRAND"] = "brand";
    PromotionOwnerTypeEnum["SHOP"] = "shop";
})(PromotionOwnerTypeEnum || (PromotionOwnerTypeEnum = {}));


/***/ }),

/***/ 81118:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DS": () => (/* binding */ deleteRecentSearch),
/* harmony export */   "KM": () => (/* binding */ getRecentSearches),
/* harmony export */   "_": () => (/* binding */ addRecentSearch),
/* harmony export */   "bn": () => (/* binding */ getRecentSearchesHistoryItems),
/* harmony export */   "j8": () => (/* binding */ createHistorySuggestion),
/* harmony export */   "lU": () => (/* binding */ clearRecentSearches)
/* harmony export */ });
/* harmony import */ var src_client_dummy_local_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75077);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var LOCAL_STORAGE_KEY = "pj:recentSearches";
var LIMIT = 10;
var filterHistory = function(history, query) {
    return history.toLowerCase().indexOf(query.toLowerCase()) !== -1;
};
var createHistorySuggestion = function(query, index) {
    return {
        type: "history",
        __typename: "history",
        text: query,
        navId: 100 + index
    };
};
var getRecentSearches = function() {
    var limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : LIMIT;
    try {
        var previousSearches = src_client_dummy_local_storage__WEBPACK_IMPORTED_MODULE_0__/* .dummyLocalStorage.getItem */ .Y.getItem(LOCAL_STORAGE_KEY);
        return previousSearches ? JSON.parse(previousSearches).reverse().slice(0, limit) : [];
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return [];
};
var getRecentSearchesHistoryItems = function(limit, query) {
    return getRecentSearches(limit).filter(function(s) {
        return filterHistory(s, query);
    }).map(createHistorySuggestion);
};
var deleteRecentSearch = function(query) {
    var previousSearches = getRecentSearches(LIMIT);
    var queries = new Set();
    if (previousSearches) {
        previousSearches.forEach(queries.add, queries);
        queries.delete(query);
    }
    try {
        src_client_dummy_local_storage__WEBPACK_IMPORTED_MODULE_0__/* .dummyLocalStorage.setItem */ .Y.setItem(LOCAL_STORAGE_KEY, JSON.stringify(_toConsumableArray(queries).reverse()));
    } catch (e) {
    // Swallow the exception
    }
};
var addRecentSearch = function(query) {
    if (!query || query.length < 2) {
        return;
    }
    var trimmed = query.trim();
    try {
        var previousSearches = getRecentSearches(LIMIT);
        var queries = new Set();
        if (previousSearches) {
            previousSearches.reverse()// doing this because a bug where we were storing the search query with the path
            .filter(function(x) {
                return !x.toLowerCase().startsWith("/search?");
            }).forEach(queries.add, queries);
        }
        // Move existing query to the top as most recent
        if (_toConsumableArray(queries).includes(trimmed)) {
            queries.delete(trimmed);
        }
        queries.add(trimmed);
        src_client_dummy_local_storage__WEBPACK_IMPORTED_MODULE_0__/* .dummyLocalStorage.setItem */ .Y.setItem(LOCAL_STORAGE_KEY, JSON.stringify(_toConsumableArray(queries).reverse().slice(0, LIMIT).reverse()));
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
var clearRecentSearches = function() {
    try {
        src_client_dummy_local_storage__WEBPACK_IMPORTED_MODULE_0__/* .dummyLocalStorage.setItem */ .Y.setItem(LOCAL_STORAGE_KEY, JSON.stringify([]));
    // eslint-disable-next-line no-empty
    } catch (e) {}
};


/***/ }),

/***/ 4923:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var SidebarMobileContentLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-mobile";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-mobile */ 557).then(__webpack_require__.bind(__webpack_require__, 77299));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(77299);
        }
        return eval("require.resolve")("./content");
    }
});
var SidebarMobileContent = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SidebarMobileContentLoadable, _extends({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (SidebarMobileContent);


/***/ }),

/***/ 86178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ VIEWS)
/* harmony export */ });
var VIEWS;
(function(VIEWS) {
    VIEWS["ROOT"] = "root";
    VIEWS["ALERTS"] = "alerts";
    VIEWS["LISTS"] = "lists";
    VIEWS["LIST"] = "list";
    VIEWS["USER"] = "user";
    VIEWS["CHANGELOG"] = "changelog";
})(VIEWS || (VIEWS = {}));


/***/ }),

/***/ 90081:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": () => (/* binding */ SIDEBAR_STATE),
/* harmony export */   "E8": () => (/* binding */ LIST_DELETE_TRANSITION_TIME),
/* harmony export */   "N3": () => (/* binding */ DEFAULT_SIDEBAR_STATE),
/* harmony export */   "Ym": () => (/* binding */ NO_MY_PRODUCTS_CREATED_ID),
/* harmony export */   "aP": () => (/* binding */ SORT_OPTIONS),
/* harmony export */   "yT": () => (/* binding */ SIDEBAR_LOCALSTORAGE_KEY)
/* harmony export */ });
var SIDEBAR_LOCALSTORAGE_KEY = "pj:sidebarState";
var SIDEBAR_STATE;
(function(SIDEBAR_STATE) {
    SIDEBAR_STATE["NONE"] = "none";
    SIDEBAR_STATE["LISTS"] = "lists";
    SIDEBAR_STATE["ALERTS"] = "alerts";
    SIDEBAR_STATE["FILTER"] = "filter";
    SIDEBAR_STATE["SETTINGS"] = "settings";
    SIDEBAR_STATE["LOGIN"] = "login";
})(SIDEBAR_STATE || (SIDEBAR_STATE = {}));
var DEFAULT_SIDEBAR_STATE = SIDEBAR_STATE.ALERTS;
var SORT_OPTIONS;
(function(SORT_OPTIONS) {
    SORT_OPTIONS["USER_DEFINED"] = "user_defined";
    SORT_OPTIONS["ADDED"] = "added";
    SORT_OPTIONS["NAME"] = "name";
    SORT_OPTIONS["PRICE"] = "price";
    SORT_OPTIONS["PRICE_ASC"] = "price:asc";
    SORT_OPTIONS["PRICE_DESC"] = "price:desc";
    SORT_OPTIONS["CATEGORY"] = "category";
    SORT_OPTIONS["ACCESSED"] = "accessed";
})(SORT_OPTIONS || (SORT_OPTIONS = {}));
var LIST_DELETE_TRANSITION_TIME = 500;
var NO_MY_PRODUCTS_CREATED_ID = -1;


/***/ }),

/***/ 59909:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": () => (/* binding */ trackClosingSidebar),
/* harmony export */   "b": () => (/* binding */ trackOpeningSidebar)
/* harmony export */ });
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24005);

var trackOpeningSidebar = function(view) {
    var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("trackOpeningSidebar", {
        view: view,
        element: element
    });
};
var trackClosingSidebar = function(view) {
    var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("trackClosingSidebar", {
        view: view,
        element: element
    });
};


/***/ }),

/***/ 61082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var AlertsLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-views";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-views */ 408).then(__webpack_require__.bind(__webpack_require__, 66885));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(66885);
        }
        return eval("require.resolve")("./view");
    }
});
var Alerts = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AlertsLoadable, _extends({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Alerts);


/***/ }),

/***/ 33642:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);


var SidebarFilterLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-views-filter";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-views-filter */ 970).then(__webpack_require__.bind(__webpack_require__, 15096));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(15096);
        }
        return eval("require.resolve")("./view");
    }
});
var SidebarFilter = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SidebarFilterLoadable, null);
};
/* harmony default export */ __webpack_exports__["Z"] = (SidebarFilter);


/***/ }),

/***/ 59209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ toggleListShare),
/* harmony export */   "w": () => (/* binding */ TOGGLE_LIST_SHARE)
/* harmony export */ });
var TOGGLE_LIST_SHARE = "TOGGLE_LIST_SHARE";
var toggleListShare = function(uid) {
    return {
        type: TOGGLE_LIST_SHARE,
        uid: uid
    };
};


/***/ }),

/***/ 11024:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var ListLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-views";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-views */ 408).then(__webpack_require__.bind(__webpack_require__, 96082));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(96082);
        }
        return eval("require.resolve")("./view");
    }
});
var List = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListLoadable, _extends({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (List);


/***/ }),

/***/ 29865:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var ListsLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-views";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-views */ 408).then(__webpack_require__.bind(__webpack_require__, 32448));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(32448);
        }
        return eval("require.resolve")("./view");
    }
});
var Lists = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListsLoadable, _extends({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Lists);


/***/ }),

/***/ 47557:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": () => (/* binding */ SotyBadge)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/areas/store/components/soty-badge-link/soty-badge/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var StyledSotyBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSotyBadge",
    componentId: "sc-0-0"
})(_templateObject());
var StyledImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledImageWrapper",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), "".concat(props.size, "px"));
});

;// CONCATENATED MODULE: ./src/areas/store/components/soty-badge-link/soty-badge/index.tsx



var SotyBadge = function(props) {
    var className = props.className, imgUrl = props.imgUrl, name = props.name, _size = props.size, size = _size === void 0 ? 115 : _size, year = props.year;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var altText = "".concat(t("campaigns", "shop-of-the-year.winners-title", {
        year: year || ""
    })).concat(name ? " - ".concat(name) : null);
    // replaces soty badges img urls from 2010, 2011 and 2012 with generic badge
    // because badges for those years are missing on cdn.
    var url = year && parseInt(year, 10) < 2013 ? "".concat(market.cdn, "/g/store_of_the_year/generic_store_of_the_year.png") : imgUrl;
    return /*#__PURE__*/ react.createElement(StyledSotyBadge, {
        className: className
    }, /*#__PURE__*/ react.createElement(StyledImageWrapper, {
        size: size
    }, /*#__PURE__*/ react.createElement("img", {
        src: url,
        alt: altText,
        title: altText
    })));
};


/***/ }),

/***/ 67595:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L9": () => (/* binding */ SHOP_LOGO_WIDTH),
/* harmony export */   "QO": () => (/* binding */ CONTENT_TITLE_SIZE),
/* harmony export */   "XZ": () => (/* binding */ MAIN_TITLE_SIZE),
/* harmony export */   "eZ": () => (/* binding */ SECTION_TITLE_SIZE),
/* harmony export */   "jr": () => (/* binding */ SHOP_LOGO_WIDTH_SMALL),
/* harmony export */   "yH": () => (/* binding */ SUB_TITLE_SIZE)
/* harmony export */ });
var MAIN_TITLE_SIZE = 20; // h1
var SECTION_TITLE_SIZE = 18; // h2
var CONTENT_TITLE_SIZE = 16; // h3
var SUB_TITLE_SIZE = 16; // h4
var SHOP_LOGO_WIDTH = 176;
var SHOP_LOGO_WIDTH_SMALL = 88;


/***/ }),

/***/ 82562:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62619);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71297);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96398);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var StorePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "store";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | store */ 119).then(__webpack_require__.bind(__webpack_require__, 30287));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(30287);
        }
        return eval("require.resolve")("./store");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
var Store = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StorePage, null);
};
Store.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
Store.variables = function(param) {
    var id = param.id, notification = param.notification, marketCode = param.marketCode;
    var storeIdAsNumber = typeof id === "number" ? id : parseInt(id, 10);
    var storeIdAsString = typeof id === "number" ? id.toString() : id !== null && id !== void 0 ? id : "";
    var promotionsEnabled = [
        "se",
        "no"
    ].includes(marketCode);
    // Invalidate store reviews cache if anonymous review was verified
    var invalidateCache = notification === "verify-success" || notification === "delete-success";
    return {
        id: storeIdAsNumber,
        offset: 0,
        invalidateCache: invalidateCache,
        userReviewFilter: "ALL",
        promotionsEnabled: promotionsEnabled,
        promotionFilter: [
            {
                key: "shop",
                value: storeIdAsString
            }
        ]
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (Store);


/***/ }),

/***/ 24005:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ pushEvent)
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Converts uppercase event types to camelCase
// Ex: MY_EVENT -> myEvent
var typeToEvent = function(type) {
    return type.split("_").map(function(x) {
        return x.toLowerCase();
    }).map(function(x, i) {
        return i === 0 ? x : x[0].toUpperCase() + x.slice(1);
    }).join("");
};
var defaultDataLayerOptions = {
    eventNameAsKey: true,
    clearExistingData: false
};
var pushEvent = function(name) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, optionsArg = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if ( false || !window.dataLayer) {
        return;
    }
    var options = _objectSpread({}, defaultDataLayerOptions, optionsArg);
    var eventData = options.eventNameAsKey ? _defineProperty({}, name, data) : _objectSpread({}, data);
    if (optionsArg.clearExistingData) {
        eventData._clear = true;
    }
    window.dataLayer.push(_objectSpread({
        event: name
    }, eventData));
};
var middleware = function() {
    return function(next) {
        return function(action) {
            next(action);
            if (!window.dataLayer) {
                return;
            }
            switch(action.type){
                case "USER_DESTROY":
                case "USER_STOP_LOADING":
                    break;
                case "ROUTE_LOADED":
                    break;
                // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
                // reflected in react/middlewares/out.js pre click
                case "PRODUCT_PRICE_CLICK":
                default:
                    {
                        var type = action.type, rest = _objectWithoutProperties(action, [
                            "type"
                        ]);
                        var name = typeToEvent(type);
                        pushEvent(name, rest);
                    }
            }
        };
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (middleware);


/***/ }),

/***/ 75077:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": () => (/* binding */ dummyLocalStorage)
/* harmony export */ });
/**
 * @warn We currently do not have a way to grant consent for the use of local storage, return a dummy instead
 * @see https://prisjakt.atlassian.net/browse/WEB-1584
 */ var dummyLocalStorage = {
    getItem: function getItem(_key) {
        return null;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setItem: function setItem(_key, _value) {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    removeItem: function removeItem(_key) {}
};


/***/ }),

/***/ 9684:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ gqlClient)
/* harmony export */ });
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21671);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);

var gqlClient = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient("/_internal/bff");


/***/ }),

/***/ 22260:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tb": () => (/* binding */ captureException),
/* harmony export */   "_8": () => (/* binding */ sentryPromise),
/* harmony export */   "j6": () => (/* binding */ initSentry)
/* harmony export */ });
/* unused harmony export captureMessage */
/* eslint-disable no-param-reassign, no-console, no-plusplus, no-continue, @typescript-eslint/no-empty-function, @typescript-eslint/consistent-type-imports */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var sentryBrowserPromise = __webpack_require__.e(/* import() | sentry */ 897).then(__webpack_require__.bind(__webpack_require__, 81823));
var sentryIntegrationsPromise = __webpack_require__.e(/* import() | sentry-integrations */ 722).then(__webpack_require__.bind(__webpack_require__, 3991));
function createRejectedSentryPromise() {
    return new Promise(function() {});
}
var sentryPromise = typeof window !== "undefined" && window.SENTRY ? Promise.all([
    sentryBrowserPromise,
    sentryIntegrationsPromise
]).then(function(param) {
    var _param = _slicedToArray(param, 2), sentryBrowser = _param[0], sentryIntegrations = _param[1];
    return _objectSpread({}, sentryBrowser, sentryIntegrations);
}) : createRejectedSentryPromise();
var typeErrorFetchFailedValues = new Set([
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
]);
function shouldIgnoreError(error, hint) {
    return isRecaptchaBadTimeoutRejection(error, hint) || isStatusCodeError(error) || isBlockedByAdblockNetworkError(error);
}
// https://github.com/getsentry/sentry-javascript/issues/2514
function isRecaptchaBadTimeoutRejection(_, hint) {
    return hint.originalException === "Timeout";
}
function isBlockedByAdblockNetworkError(error) {
    var ref, ref1;
    var exception = (ref = error.exception) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : ref1[0];
    var now = Date.now();
    // Schibsted ads/tracking SDK is not try-catching their stuff properly so it ends up here
    // Since not all errors have stack traces attached to them (see https://github.com/getsentry/sentry-javascript/issues/7275#issuecomment-1443091905),
    // we have to filter by breadcrumbs. Since we cannot assume that the error is the last breadcrumb (I remember seeing an instance of this in Sentry, however, can't find the link any more), we need to check all of them.
    if ((exception === null || exception === void 0 ? void 0 : exception.type) !== "TypeError" || !typeErrorFetchFailedValues.has(exception.value)) {
        return false;
    }
    if (!error.breadcrumbs) {
        return false;
    }
    // We go from the back since the last breadcrumb is most likely the erroneous one
    for(var i = error.breadcrumbs.length - 1; i >= 0; i--){
        var breadcrumb = error.breadcrumbs[i];
        if (!breadcrumb) continue;
        // We only need to check the last 5s of breadcrumbs as any earlier breadcrumbs are definitely unrelated
        if (breadcrumb.timestamp && now - breadcrumb.timestamp * 1000 > 5000) {
            break;
        }
        if (isBlockedByAdblockBreadcrumb(breadcrumb)) {
            return true;
        }
    }
    return false;
}
function isBlockedByAdblockBreadcrumb(breadcrumb) {
    var ref;
    if (breadcrumb.level !== "error" || breadcrumb.category !== "xhr" && breadcrumb.category !== "fetch") {
        return false;
    }
    var url = (ref = breadcrumb.data) === null || ref === void 0 ? void 0 : ref.url;
    if (!url) return false;
    return url === "https://secure.adnxs.com/getuidj" || // cis.prisjakt.nu, cis.prisjagt.dk etc.
    url.startsWith("https://cis.") || // Ads endpoint
    url === "https://pagead2.googlesyndication.com/pagead/buyside_topics/set/";
}
function isStatusCodeError(error) {
    return error.status === 301 || error.status === 404 || error.status === 410;
}
function initSentry() {
    sentryPromise.then(function(param) {
        var BrowserClient = param.BrowserClient, defaultStackParser = param.defaultStackParser, getCurrentHub = param.getCurrentHub, GlobalHandlers = param.GlobalHandlers, InboundFilters = param.InboundFilters, FunctionToString = param.FunctionToString, TryCatch = param.TryCatch, Breadcrumbs = param.Breadcrumbs, LinkedErrors = param.LinkedErrors, HttpContext = param.HttpContext, Dedupe = param.Dedupe, makeFetchTransport = param.makeFetchTransport, BrowserTracing = param.BrowserTracing, RewriteFrames = param.RewriteFrames;
        // See https://docs.sentry.io/platforms/javascript/configuration/tree-shaking/ for what is happening
        var client = new BrowserClient({
            // debug is defined in webpack.config.js with DefinePlugin
            dsn: window.SENTRY,
            release: window.RELEASE,
            environment: window.ENVIRONMENT,
            sampleRate: 0.1,
            tracesSampleRate: 0.0001,
            transport: makeFetchTransport,
            stackParser: defaultStackParser,
            beforeSend: function(event, hint) {
                return shouldIgnoreError(event, hint) ? null : addEventTags(event);
            },
            beforeSendTransaction: addEventTags,
            normalizeDepth: 6,
            ignoreErrors: [
                "auth.invalid-user-credentials",
                'Blocked a frame with origin "https://www.prisjakt.nu" from accessing a cross-origin frame'
            ],
            integrations: [
                new BrowserTracing(),
                new GlobalHandlers(),
                new InboundFilters(),
                new FunctionToString(),
                new TryCatch(),
                new Breadcrumbs(),
                new LinkedErrors(),
                new HttpContext(),
                new Dedupe(),
                new RewriteFrames({
                    root: "webpack://@prisjakt/responsive-frontend/./",
                    prefix: "rfe-browser:///"
                })
            ],
            allowUrls: [
                /^https:\/\/pjrfe-75b8\.kxcdn\.com/,
                /^https:\/\/www\.prisjakt\.(nu|no)/,
                /^https:\/\/pricespy\.co\.(uk|nz)/,
                /^https:\/\/prisjagt\.dk/,
                /^https:\/\/hintaopas\.fi/,
                /^https:\/\/ledenicheur\.fr/,
                /^https?:\/\/local\.prisjakt\.nu/,
                /^https?:\/\/localhost/
            ]
        });
        getCurrentHub().bindClient(client);
    });
}
function addEventTags(event) {
    var _tags;
    event.tags = (_tags = event.tags) !== null && _tags !== void 0 ? _tags : {};
    event.tags.market = window.CLIENT_MARKET.code;
    return event;
}
// Used by sagas
function captureException() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    sentryPromise.then(function(param) {
        var sentryCaptureException = param.captureException;
        return sentryCaptureException.apply(void 0, _toConsumableArray(args));
    }).catch(function() {
        var _console;
        (_console = console).error.apply(_console, _toConsumableArray(args));
    });
}
// Used by sagas
function captureMessage() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    sentryPromise.then(function(param) {
        var sentryCaptureMessage = param.captureMessage;
        return sentryCaptureMessage.apply(void 0, _toConsumableArray(args));
    }).catch(function() {
        var _console;
        (_console = console).log.apply(_console, _toConsumableArray(args));
    });
}


/***/ }),

/***/ 58281:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": () => (/* binding */ AddToListModalsWrapper)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var _viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22899);
/* harmony import */ var src_areas_product_components_product_header_components_action_buttons_save_button_list_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6743);
/* harmony import */ var _modal_login_promo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60428);
/* harmony import */ var src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96805);
/* harmony import */ var _hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73426);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var AddToListModalsWrapper = function(param) {
    var children = param.children, productId = param.productId, productName = param.productName;
    var ref;
    var isDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_viewport__WEBPACK_IMPORTED_MODULE_2__/* .ViewportContext */ .R).isDesktop;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), showLoginPromo = ref1[0], setLoginPromoState = ref1[1];
    var toggleLoginPromo = function(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        setLoginPromoState(!showLoginPromo);
    };
    // Highlights the heart if the product was recently added to a list.
    // Kind of an ugly hack; should be fixed once we can get this information
    // from GraphQL.
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), addedToList = ref2[0], setAddedToListState = ref2[1];
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), listOpen = ref3[0], setListOpen = ref3[1];
    var me = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.account.me;
    });
    var isAuthenticated = (0,_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_6__/* .useIsAuthenticated */ .k)();
    var deletedLists = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.sidebar.deletedLists;
    });
    var selectedList = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.sidebar.selectedList;
    });
    var latestLists = me === null || me === void 0 ? void 0 : (ref = me.lists) === null || ref === void 0 ? void 0 : ref.nodes.filter(function(list) {
        return deletedLists[list.id] !== true;
    }).filter(function(list) {
        return !list.inventory;
    }).sort(function(a) {
        return a.id === selectedList ? 1 : 0;
    });
    var addToMyProducts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        dispatch((0,src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__/* .addItemToMyProductsRequest */ ["if"])(productId, productName, isDesktop));
        setAddedToListState(true);
    }, [
        dispatch,
        isDesktop,
        productId,
        productName
    ]);
    var addToList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(listId) {
        if (listId) dispatch((0,src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__/* .selectList */ .Fz)(listId));
        dispatch((0,src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__/* .addListItemRequest */ .hg)(productId, productName, isDesktop));
        setAddedToListState(true);
    }, [
        dispatch,
        isDesktop,
        productId,
        productName
    ]);
    var handleOnClick = function() {
        return isAuthenticated ? function() {
            return !latestLists || latestLists.length === 0 ? addToList() : setListOpen(true);
        } : toggleLoginPromo;
    };
    if (!productId) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, showLoginPromo && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_modal_login_promo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isOpen: showLoginPromo,
        onRequestClose: toggleLoginPromo
    }), listOpen && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_areas_product_components_product_header_components_action_buttons_save_button_list_modal__WEBPACK_IMPORTED_MODULE_3__/* .ListModal */ .a, {
        addToList: addToList,
        addToMyProducts: addToMyProducts,
        isOpen: listOpen,
        closeModal: function() {
            return setListOpen(false);
        },
        lists: latestLists,
        isDesktop: Boolean(isDesktop)
    }), children(handleOnClick(), addedToList));
};


/***/ }),

/***/ 90814:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ AddToListButton)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);
/* harmony import */ var _prisjakt_ui_icon_heart_filled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87269);
/* harmony import */ var _prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72183);
/* harmony import */ var _base_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3686);
/* harmony import */ var _add_to_list_wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58281);






var AddToListButton = function(param) {
    var productId = param.productId, productName = param.productName, tooltipAlign = param.tooltipAlign, tooltipPlacement = param.tooltipPlacement;
    var t = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp)().t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_add_to_list_wrapper__WEBPACK_IMPORTED_MODULE_5__/* .AddToListModalsWrapper */ .w, {
        productId: productId,
        productName: productName
    }, function(onClick, addedToList) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_base_button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            isActive: addedToList,
            icon: addedToList ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_heart_filled__WEBPACK_IMPORTED_MODULE_2__/* .IconHeartFilled */ .g, null) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__/* .IconHeartOutlined */ .G, null),
            ariaLabel: t("common", "button.save"),
            onClick: onClick,
            tooltip: t("product", "action-button.list-tooltip"),
            tooltipAlign: tooltipAlign,
            tooltipPlacement: tooltipPlacement,
            "data-testid": "AddToListButton"
        });
    });
};


/***/ }),

/***/ 25059:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ AlertModal)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73426);
/* harmony import */ var src_components_modal_v2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42574);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51676);
/* harmony import */ var src_components_modal_login_promo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60428);







var ProductAlertModalContent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 62975));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(62975);
        }
        return eval("require.resolve")("../../../areas/product-alert/components/product-alert-modal-content");
    }
});
var AlertModal = function(props) {
    var ref, ref1;
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .bp)().market;
    var isAuthenticated = (0,src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_3__/* .useIsAuthenticated */ .k)();
    var closeModal = props.closeModal, isOpen = props.isOpen, productId = props.productId;
    if (!isAuthenticated) {
        return isOpen && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_modal_login_promo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            isOpen: isOpen,
            onRequestClose: closeModal
        });
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, isOpen && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_modal_v2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isOpen: isOpen,
        onRequestClose: closeModal
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_5__/* .ModalBody */ .fe, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductAlertModalContent, {
        productId: productId,
        hideModal: closeModal,
        privacyPolicyUri: market === null || market === void 0 ? void 0 : (ref = market.privacySettings) === null || ref === void 0 ? void 0 : (ref1 = ref.responsive) === null || ref1 === void 0 ? void 0 : ref1.privacyUrl
    }))));
};


/***/ }),

/***/ 3686:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71551);
/* harmony import */ var _prisjakt_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49452);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25670);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61058);





var BaseButton = function(param) {
    var isActive = param.isActive, icon = param.icon, ariaLabel = param.ariaLabel, dataTestid = param["data-testid"], tooltip = param.tooltip, _tooltipAlign = param.tooltipAlign, tooltipAlign = _tooltipAlign === void 0 ? _prisjakt_ui__WEBPACK_IMPORTED_MODULE_2__/* .Direction.Right */ .Nm.Right : _tooltipAlign, _tooltipPlacement = param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? _prisjakt_ui__WEBPACK_IMPORTED_MODULE_2__/* .Direction.Up */ .Nm.Up : _tooltipPlacement, onClick = param.onClick, layout = param.layout;
    if (layout === "button") {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.OutlinedButton, {
            onClick: onClick,
            containerProps: {
                "data-testid": dataTestid
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon, null, icon), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonText, null, ariaLabel));
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
        title: tooltip,
        align: tooltipAlign,
        placement: tooltipPlacement,
        width: "180px"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .IconButton */ .hU, {
        role: "button",
        active: isActive,
        "aria-label": ariaLabel,
        onClick: onClick,
        "data-testid": dataTestid
    }, icon));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseButton);


/***/ }),

/***/ 61058:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lt": () => (/* binding */ Dropdown),
/* harmony export */   "hP": () => (/* binding */ DropdownItem),
/* harmony export */   "hU": () => (/* binding */ IconButton)
/* harmony export */ });
/* unused harmony export IconWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_dropdown_new__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13961);
/* harmony import */ var src_components_dropdown_new_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92648);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background: rgba(255, 255, 255, 0.72);\n  border-radius: 100%;\n  color: ",
        ";\n\n  svg,\n  path {\n    fill: currentcolor;\n  }\n\n  &:hover {\n    svg {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: 0;\n\n  ",
        " {\n    top: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 200px;\n  height: 40px;\n  display: block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  &:first-child {\n    display: flex;\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var IconButton = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
    displayName: "IconButton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.active ? p.theme.icons.callToActionHover : p.theme.icons.secondary;
}, function(p) {
    return p.theme.icons.callToActionHover;
});
var Dropdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_dropdown_new__WEBPACK_IMPORTED_MODULE_1__/* .DropdownNew */ .cw).withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-1"
})(_templateObject1(), src_components_dropdown_new_styles__WEBPACK_IMPORTED_MODULE_2__/* .DropdownContent */ .Nv);
var DropdownItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_dropdown_new__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.lines.primary;
});
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-3"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.icons.callToAction;
});


/***/ }),

/***/ 25349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Il": () => (/* binding */ AppContext),
/* harmony export */   "bp": () => (/* binding */ useAppContext),
/* harmony export */   "hw": () => (/* binding */ AppContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var seedrandom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68116);
/* harmony import */ var seedrandom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(seedrandom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_components_translate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37702);
/* harmony import */ var _link_to__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92837);





var crash = function() {
    throw new Error("AppContext value is not initialized.");
};
var initialValue = {
    renderMode: "",
    market: "",
    linkTo: crash,
    t: crash,
    Translate: crash,
    captureMessage: crash,
    captureException: crash,
    productOfTheYear: []
};
var AppContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
AppContext.displayName = "AppContext";
var captureEvent = function(sentryPromise, sentryMethodName, data) {
    sentryPromise.then(function(sentry) {
        sentry[sentryMethodName](data);
    }).catch(function() {
        var consoleMethodName = {
            captureMessage: "log",
            captureException: "error"
        }[sentryMethodName];
        console[consoleMethodName](data); // eslint-disable-line no-console
    });
};
var AppContextContainer = function(param) {
    var children = param.children, translations = param.translations, renderMode = param.renderMode, market = param.market, locale = param.locale, sentryPromise = param.sentryPromise, rngSeed = param.rngSeed, _productOfTheYear = param.productOfTheYear, productOfTheYear = _productOfTheYear === void 0 ? [] : _productOfTheYear;
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var translate = (0,src_components_translate__WEBPACK_IMPORTED_MODULE_2__/* .translator */ .O)(translations, locale);
        var ctx = {
            renderMode: renderMode,
            market: market,
            random: seedrandom__WEBPACK_IMPORTED_MODULE_1___default()(rngSeed),
            linkTo: _link_to__WEBPACK_IMPORTED_MODULE_3__/* .linkTo.bind */ .kZ.bind(null, market.classicRoutes, market.routes),
            t: translate,
            captureMessage: function(data) {
                return captureEvent(sentryPromise, "captureMessage", data);
            },
            captureException: function(data) {
                captureEvent(sentryPromise, "captureException", data);
            },
            sentry: sentryPromise,
            productOfTheYear: productOfTheYear
        };
        return ctx;
    }, [
        translations,
        locale,
        renderMode,
        market,
        rngSeed,
        sentryPromise,
        productOfTheYear
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppContext.Provider, {
        value: context
    }, children);
};
var useAppContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppContext);
};
AppContextContainer.defaultProps = {
    children: null,
    locale: undefined
};


/***/ }),

/***/ 92837:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kZ": () => (/* binding */ linkTo),
/* harmony export */   "pS": () => (/* binding */ withQueryString)
/* harmony export */ });
/* unused harmony export addQueryToUrl */
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36074);
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97150);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var hasQueryString = function(url) {
    return typeof url === "string" && url.indexOf("?") !== -1;
};
var removeQueryString = function(url) {
    return url && hasQueryString(url) ? url.substring(0, url.indexOf("?")) : url;
};
var queryStringFromUrl = function(url) {
    return url ? url.substr(url.indexOf("?")).substr(1) : "";
};
var addQueryToUrl = function(url, qs) {
    var baseUrl = hasQueryString(url) ? removeQueryString(url) : url;
    if (!baseUrl) return "";
    var qsFragment = qs ? "?".concat(qs) : "";
    return "".concat(baseUrl).concat(qsFragment);
};
var sortWithProductIdFirst = function(a, b) {
    return b === "p" ? -1 : b.localeCompare(a);
};
// eslint-disable-next-line @typescript-eslint/ban-types
var getQueryString = function(url, query) {
    // Combine parameters from URL with query object
    var combinedQuery = Object.assign(querystring__WEBPACK_IMPORTED_MODULE_1__.decode(queryStringFromUrl(url)), query);
    // Sort object keys to ensure constant parameter order
    // Special case for the product page where we always want ?p= to come first.
    var sortedQuery = Object.keys(combinedQuery).sort(sortWithProductIdFirst).reduce(function(q, key) {
        return _objectSpreadProps(_objectSpread({}, q), _defineProperty({}, key, combinedQuery[key]));
    }, {});
    return querystring__WEBPACK_IMPORTED_MODULE_1__.encode(sortedQuery);
};
var withQueryString = function(url, query) {
    return addQueryToUrl(url, getQueryString(url, query));
};
function getPath(path) {
    return Array.isArray(path) ? path[0] : path || "";
}
var linkTo = function(classicRoutes, routes, type) {
    var item = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : undefined, query = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var linkToProduct = function linkToProduct(section) {
        var authorizedDealersLink = item && item.sponsor ? item.sponsor.authorizedDealersLink : false;
        var authorizedDealersQuery = authorizedDealersLink ? {
            filters: "authorized_dealer"
        } : {};
        var path = withQueryString(classicRoutes.product, _objectSpreadProps(_objectSpread({}, authorizedDealersQuery, query), {
            p: item === null || item === void 0 ? void 0 : item.id
        }));
        return section ? "".concat(path, "#").concat(section) : path;
    };
    // Support both graphql schema and api schema
    var semanticId = item && (item.pathName || item.semantic_id || item.path);
    var externalUri = item && (item.externalUri || item.redirect_uri);
    switch(type){
        case "raw":
            {
                return externalUri;
            }
        case "product":
        case "raw_sorted":
            {
                return linkToProduct();
            }
        case "productProperties":
            {
                return linkToProduct("properties");
            }
        case "productReviews":
            {
                return linkToProduct("reviews");
            }
        case "productPriceHistory":
            {
                return linkToProduct("statistics");
            }
        case "productAlert":
            {
                var ref;
                return withQueryString("".concat(classicRoutes.product).concat(routes === null || routes === void 0 ? void 0 : (ref = routes.productAlert) === null || ref === void 0 ? void 0 : ref.relativePath), _objectSpreadProps(_objectSpread({}, query), {
                    p: item === null || item === void 0 ? void 0 : item.id
                }));
            }
        case "productCompare":
            {
                var ref1;
                var category = item.category, products = item.products;
                var categoryId = category && category.id;
                var productIds = Array.isArray(products) ? products.map(function(p) {
                    return p.id;
                }).join(",") : "";
                var path = getPath(routes === null || routes === void 0 ? void 0 : (ref1 = routes.productCompare) === null || ref1 === void 0 ? void 0 : ref1.path);
                return withQueryString(path.replace(":productIds", productIds), categoryId ? {
                    categoryId: categoryId
                } : {});
            }
        case "brand":
            {
                return withQueryString(classicRoutes.brand, _objectSpreadProps(_objectSpread({}, query), {
                    t: item === null || item === void 0 ? void 0 : item.id
                }));
            }
        case "store":
            {
                return withQueryString(classicRoutes.store_info, _objectSpreadProps(_objectSpread({}, query), {
                    f: item === null || item === void 0 ? void 0 : item.id
                }));
            }
        case "brandCategory":
        case "brand_category":
        case "brand_virtual_category":
            if ((item === null || item === void 0 ? void 0 : item.product_collection) || (item === null || item === void 0 ? void 0 : item.productCollection)) {
                // eslint-disable-next-line no-param-reassign
                query.brand = item === null || item === void 0 ? void 0 : item.brandId;
            } else {
                // eslint-disable-next-line no-param-reassign
                query.t = item === null || item === void 0 ? void 0 : item.brandId;
            }
        case "virtual_category":
        case "virtualCategory":
        case "category":
            {
                if ((item === null || item === void 0 ? void 0 : item.type) === "productCollection" || (item === null || item === void 0 ? void 0 : item.product_collection) || (item === null || item === void 0 ? void 0 : item.productCollection)) {
                    return withQueryString(item.product_collection || item.productCollection || item.path, query);
                }
                return withQueryString(classicRoutes.category, _objectSpreadProps(_objectSpread({}, query), {
                    k: item === null || item === void 0 ? void 0 : item.id
                }));
            }
        case "shopOfTheYear":
            {
                var ref2;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref2 = routes.shopOfTheYear) === null || ref2 === void 0 ? void 0 : ref2.path);
            }
        case "shopOfTheYearCategory":
            {
                var ref3;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref3 = routes.shopOfTheYearCategory) === null || ref3 === void 0 ? void 0 : ref3.path).replace(":year", item === null || item === void 0 ? void 0 : item.year).replace(":id", item === null || item === void 0 ? void 0 : item.id);
            }
        case "shopOfTheYearWinners":
            {
                var ref4;
                return "".concat(getPath(routes === null || routes === void 0 ? void 0 : (ref4 = routes.shopOfTheYearWinners) === null || ref4 === void 0 ? void 0 : ref4.path).replace(":section", item === null || item === void 0 ? void 0 : item.year), "#winners");
            }
        case "productCollection":
            {
                var _filters = item.filters, filters = _filters === void 0 ? [] : _filters;
                return filters.reduce(_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_0__.addFilterToUrl, semanticId);
            }
        case "productCollectionSitemap":
            {
                var baseUrl = item.baseUrl;
                return removeQueryString(baseUrl.replace("/c/", "/cm/"));
            }
        case "editorialContentListing":
            {
                var ref5;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref5 = routes.editorialContentListing) === null || ref5 === void 0 ? void 0 : ref5.path);
            }
        case "user":
            {
                return "/user/".concat(item === null || item === void 0 ? void 0 : item.id);
            }
        case "list":
            {
                return withQueryString(semanticId, query);
            }
        case "categoryIndex":
            {
                var ref6;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref6 = routes.categoryIndex) === null || ref6 === void 0 ? void 0 : ref6.path);
            }
        case "expertTest":
            {
                return withQueryString(semanticId, query);
            }
        case "expertToplist":
            {
                return withQueryString(semanticId, query);
            }
        case "expertCategory":
            {
                return withQueryString(semanticId, query);
            }
        case "expertProfile":
            {
                return withQueryString(semanticId, query);
            }
        case "expertContent":
            {
                return withQueryString(semanticId, query);
            }
        case "expertMedia":
            {
                return withQueryString(semanticId, query);
            }
        case "expertArticle":
            {
                return withQueryString(semanticId, query);
            }
        case "experts":
            {
                var ref7;
                return withQueryString(getPath(routes === null || routes === void 0 ? void 0 : (ref7 = routes.expertLandingPage) === null || ref7 === void 0 ? void 0 : ref7.path), query);
            }
        case "changelog":
            {
                var ref8;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref8 = routes.changelogLandingPage) === null || ref8 === void 0 ? void 0 : ref8.path);
            }
        case "changelogArticle":
            {
                return "/".concat(item === null || item === void 0 ? void 0 : item.path);
            }
        case "changelogLatest":
            {
                var ref9;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref9 = routes.changelogLatest) === null || ref9 === void 0 ? void 0 : ref9.path);
            }
        case "keywordListing":
            {
                var slug = (item === null || item === void 0 ? void 0 : item.url) && item.url.slug ? item.url.slug : item === null || item === void 0 ? void 0 : item.slug;
                return "/kw/".concat(slug || (item === null || item === void 0 ? void 0 : item.id));
            }
        case "search":
            {
                return "/search?query=".concat(item === null || item === void 0 ? void 0 : item.query);
            }
        case "promotions":
            {
                var ref10, ref11;
                var id = item === null || item === void 0 ? void 0 : item.id;
                var path1 = getPath(routes === null || routes === void 0 ? void 0 : (ref10 = routes.promotionProducts) === null || ref10 === void 0 ? void 0 : ref10.path);
                if (id && path1) {
                    return path1.replace(":id", id);
                }
                return getPath(routes === null || routes === void 0 ? void 0 : (ref11 = routes.promotions) === null || ref11 === void 0 ? void 0 : ref11.path);
            }
        case "used":
            {
                var ref12;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref12 = routes.usedProducts) === null || ref12 === void 0 ? void 0 : ref12.path);
            }
        case "sponsoredArticle":
            {
                var ref13;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref13 = routes.sponsoredArticle) === null || ref13 === void 0 ? void 0 : ref13.path).replace(":slug", item === null || item === void 0 ? void 0 : item.slug);
            }
        case "article":
            {
                var ref14;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref14 = routes.article) === null || ref14 === void 0 ? void 0 : ref14.path).replace(":slug", item === null || item === void 0 ? void 0 : item.slug);
            }
        case "editorialLandingPage":
            {
                var ref15;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref15 = routes.campaign) === null || ref15 === void 0 ? void 0 : ref15.path).replace(":slug", item === null || item === void 0 ? void 0 : item.slug);
            }
        case "keywordLandingPage":
            {
                return withQueryString("/s/".concat(item === null || item === void 0 ? void 0 : item.slug), query);
            }
        case "topic":
            {
                return withQueryString("/tp/".concat(item === null || item === void 0 ? void 0 : item.slug), query);
            }
        default:
            return "";
    }
};



/***/ }),

/***/ 52888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": () => (/* binding */ applied_filters_AppliedFilters)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(56853);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./src/components/base/src/animations/index.ts + 1 modules
var animations = __webpack_require__(90063);
;// CONCATENATED MODULE: ./src/components/applied-filters/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: 0;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 0;\n  overflow: hidden;\n\n  animation:\n    ",
        " 250ms linear forwards,\n    ",
        " 200ms ease-out forwards;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var AppliedFilters = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "AppliedFilters",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.$wrap && "flex-wrap: wrap;";
}, base/* media.largeUp */.BC.largeUp(_templateObject()));
var AppliedFiltersTitle = styled_components_browser_esm["default"].span.withConfig({
    displayName: "AppliedFiltersTitle",
    componentId: "sc-0-1"
})(_templateObject2());
var AppliedFiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AppliedFiltersWrapper",
    componentId: "sc-0-2"
})(_templateObject3());
var AppliedFilterButton = (0,styled_components_browser_esm["default"])(variants.TagButton).withConfig({
    displayName: "AppliedFilterButton",
    componentId: "sc-0-3"
})(_templateObject4(), animations.fromZeroWidthKeyframes, animations.fadeInKeyframes);

;// CONCATENATED MODULE: ./src/components/applied-filters/applied-filter.tsx






var AppliedFilter = function(param) {
    var onClick = param.onClick, prefix = param.prefix, value = param.value, _suffix = param.suffix, suffix = _suffix === void 0 ? "" : _suffix;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var valueWithoutSuffix = prefix ? t("filter", "applied-filter.filter-with-prefix", {
        name: prefix,
        value: value
    }) : value;
    var valueToDisplay = valueWithoutSuffix.concat(suffix);
    return /*#__PURE__*/ react.createElement(AppliedFilterButton, {
        onClick: onClick,
        containerProps: {
            "data-test": "AppliedFilter"
        }
    }, /*#__PURE__*/ react.createElement(variants.ButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, valueToDisplay), /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(icon_close.IconClose, null)));
};

;// CONCATENATED MODULE: ./src/components/applied-filters/clear-button.tsx



var ClearButton = function(param) {
    var onClick = param.onClick, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(variants.TextButton, {
        className: className,
        onClick: onClick,
        size: variants.ButtonSize.SMALL,
        containerProps: {
            "data-test": "FeaturedFilterClear"
        }
    }, t("filter", "button.clear-filter"));
};

;// CONCATENATED MODULE: ./src/components/applied-filters/index.tsx





var applied_filters_AppliedFilters = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var formattedFilters = props.filters.map(function(filter) {
        return {
            filter: filter,
            formatted: props.filterFormatFn({
                filter: filter,
                t: t
            })
        };
    });
    if (!(formattedFilters === null || formattedFilters === void 0 ? void 0 : formattedFilters.length)) return null;
    return /*#__PURE__*/ react.createElement(AppliedFiltersWrapper, {
        "data-test": "AppliedFiltersWrapper"
    }, /*#__PURE__*/ react.createElement(AppliedFilters, {
        $wrap: props.wrap,
        gap: 0.5
    }, formattedFilters.map(function(param) {
        var filter = param.filter, formatted = param.formatted;
        return /*#__PURE__*/ react.createElement(AppliedFilter, {
            key: formatted.key,
            prefix: formatted.prefix,
            suffix: formatted.suffix,
            value: formatted.value,
            onClick: function() {
                return props.onClearFilter(filter);
            }
        });
    }), /*#__PURE__*/ react.createElement(ClearButton, {
        onClick: props.onClearAll
    })));
};


/***/ }),

/***/ 55445:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": () => (/* binding */ article_card_ArticleCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33561);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/info-list/index.tsx + 1 modules
var info_list = __webpack_require__(29089);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(60738);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/youtube-icon/index.tsx + 1 modules
var youtube_icon = __webpack_require__(22448);
;// CONCATENATED MODULE: ./src/components/article-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    justify-content: flex-end;\n    flex: 0 1 auto;\n    border-top: 1px solid ",
        ";\n    width: 100%;\n    padding-top: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  & > :not(:last-child) {\n    margin-bottom: unset;\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var ArticleCard = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "ArticleCard",
    componentId: "sc-0-0"
})(_templateObject());
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Footer = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "Footer",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.lines.primary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Title = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "Title",
    componentId: "sc-0-3"
})(_templateObject3());
var Content = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "Content",
    componentId: "sc-0-4"
})(_templateObject4(), Header, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, Title, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledImageWrapper",
    componentId: "sc-0-5"
})(_templateObject5());
var StyledYoutubeIcon = (0,styled_components_browser_esm["default"])(youtube_icon/* YoutubeIcon */.L).withConfig({
    displayName: "StyledYoutubeIcon",
    componentId: "sc-0-6"
})(_templateObject6());

// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/components/partner-video-modal/index.tsx + 3 modules
var partner_video_modal = __webpack_require__(87191);
// EXTERNAL MODULE: ./src/areas/expert/components/card-image/index.tsx
var card_image = __webpack_require__(59669);
;// CONCATENATED MODULE: ./src/components/article-card/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var article_card_ArticleCard = function(param) {
    var pretitle = param.pretitle, className = param.className, date = param.date, grade = param.grade, onClick = param.onClick, likes = param.likes, media = param.media, icon = param.icon, videoMetadata = param.videoMetadata, titleAndCategory = param.titleAndCategory, url = param.url, footer = param.footer, _footerPartOfLink = param.footerPartOfLink, footerPartOfLink = _footerPartOfLink === void 0 ? false : _footerPartOfLink;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, linkTo = ref.linkTo, t = ref.t, market = ref.market;
    var ref1 = _slicedToArray((0,react.useState)(false), 2), isPartnerVideoModalOpen = ref1[0], setIsPartnerVideoModalOpen = ref1[1];
    var getInfoListItems = function() {
        var render = function(string) {
            return /*#__PURE__*/ react.createElement(variants.CaptionText, {
                emphasis: variants.FontEmphasis.HIGH,
                color: variants.FontColor.DARK
            }, string);
        };
        var likesString = likes && likes >= 50 ? t("expert", "likes.count", {
            n: likes,
            count: likes.toLocaleString(market.localeStandard)
        }) : undefined;
        return _toConsumableArray(date ? [
            render(date)
        ] : []).concat(_toConsumableArray(likesString ? [
            render(likesString)
        ] : []));
    };
    var linkToString = linkTo("expertContent", {
        semantic_id: url
    }, renderMode === "native" ? {
        view: "native"
    } : undefined);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, videoMetadata && isPartnerVideoModalOpen && /*#__PURE__*/ react.createElement(partner_video_modal/* PartnerVideoModal */.o, {
        closeModal: function() {
            return setIsPartnerVideoModalOpen(false);
        },
        isOpen: isPartnerVideoModalOpen,
        imageUrl: videoMetadata.thumbnail,
        title: videoMetadata.title,
        videoId: videoMetadata.videoId
    }), /*#__PURE__*/ react.createElement(ArticleCard, {
        className: className
    }, /*#__PURE__*/ react.createElement(card.CardActionArea, {
        container: url ? clickable/* Clickable */.P : undefined,
        containerProps: {
            onClick: function() {
                onClick === null || onClick === void 0 ? void 0 : onClick();
                if (videoMetadata) setIsPartnerVideoModalOpen(true);
            },
            to: linkToString,
            isExternal: renderMode === "native"
        },
        style: {
            flex: "1 0 auto",
            cursor: "pointer"
        }
    }, videoMetadata && /*#__PURE__*/ react.createElement(StyledImageWrapper, null, /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
        src: videoMetadata.thumbnail,
        alt: "",
        height: 150
    }), /*#__PURE__*/ react.createElement(StyledYoutubeIcon, {
        size: 60
    })), media && !videoMetadata && /*#__PURE__*/ react.createElement(card.CardMedia, {
        $background: true
    }, grade, media, icon), /*#__PURE__*/ react.createElement(Content, null, pretitle && /*#__PURE__*/ react.createElement(Header, null, (pretitle === null || pretitle === void 0 ? void 0 : pretitle.image) && /*#__PURE__*/ react.createElement(user_avatar/* UserAvatar */.Y, {
        avatar: pretitle.image,
        displayName: pretitle.name
    }), /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        behavior: variants.Behavior.OnelineEllipsis,
        emphasis: variants.FontEmphasis.MEDIUM
    }, pretitle === null || pretitle === void 0 ? void 0 : pretitle.name)), /*#__PURE__*/ react.createElement(Title, null, titleAndCategory), /*#__PURE__*/ react.createElement(info_list/* InfoList */.Q, {
        list: getInfoListItems()
    })), footer && footerPartOfLink && /*#__PURE__*/ react.createElement(Footer, null, footer)), footer && !footerPartOfLink && /*#__PURE__*/ react.createElement(Footer, null, footer)));
};


/***/ }),

/***/ 48285:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": () => (/* binding */ BadgeTypeEnum),
  "T": () => (/* binding */ DealsBadge)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(89286);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/trending-down/index.js
var trending_down = __webpack_require__(47418);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(31744);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/deals-page/utils.ts
var utils = __webpack_require__(4462);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/badges/deals-badge/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  white-space: initial;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      top: 24px;\n      left: -18px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    z-index: 101;\n    white-space: initial;\n    top: 30px;\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0 ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 50%;\n      padding: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: inline-flex;\n    align-items: center;\n    background-color: ",
        ";\n    color: ",
        ";\n    border-radius: 0.225rem;\n    padding: 0.125rem ",
        ";\n    gap: ",
        ";\n    cursor: pointer;\n    white-space: nowrap;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: initial;\n  user-select: text;\n  text-align: initial;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n  white-space: nowrap;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var StyledDealsBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDealsBadge",
    componentId: "sc-0-0"
})(_templateObject());
var StyledPopoverWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPopoverWrapper",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), props.$isLabelBadge && (0,styled_components_browser_esm.css)(_templateObject1()));
});
var DealsBadgeWithInfoTooltip = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DealsBadgeWithInfoTooltip",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), design_tokens.lightThemeColors.staticInformative100, design_tokens.lightThemeColors.maybeBlue700, design_tokens.measurements.spacing050, design_tokens.measurements.spacing025, props.$isLabelBadge && (0,styled_components_browser_esm.css)(_templateObject3(), design_tokens.measurements.spacing050), props.$circular && (0,styled_components_browser_esm.css)(_templateObject4(), design_tokens.measurements.spacing025));
});
var StyledSmallVerticalGap = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSmallVerticalGap",
    componentId: "sc-0-3"
})(_templateObject6(), design_tokens.measurements.spacing025);
var StyledBigVerticalGap = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledBigVerticalGap",
    componentId: "sc-0-4"
})(_templateObject7(), design_tokens.measurements.spacing075);
var StyledPopover = (0,styled_components_browser_esm["default"])(popover/* Popover */.J2).withConfig({
    displayName: "StyledPopover",
    componentId: "sc-0-5"
})(_templateObject8());
var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-6"
})(_templateObject9(), function(p) {
    return p.theme.colors.base800;
});

;// CONCATENATED MODULE: ./src/components/badges/deals-badge/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var BadgeTypeEnum;
(function(BadgeTypeEnum) {
    BadgeTypeEnum["BADGE"] = "badge";
    BadgeTypeEnum["ICON_BADGE"] = "icon-badge";
    BadgeTypeEnum["LABEL_BADGE"] = "label-badge";
})(BadgeTypeEnum || (BadgeTypeEnum = {}));
var DealsBadge = function(param) {
    var _badgeType = param.badgeType, badgeType = _badgeType === void 0 ? BadgeTypeEnum.BADGE : _badgeType, dataTestId = param["data-testid"], popoverUniqueId = param.popoverUniqueId, price = param.price, priceDrop = param.priceDrop, hidePopover = param.hidePopover;
    var ref, ref1;
    var ref2 = (0,app_context/* useAppContext */.bp)(), t = ref2.t, market = ref2.market;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var ref3 = _slicedToArray((0,react.useState)(false), 2), showPopover = ref3[0], setShowPopover = ref3[1];
    var expectedPrice = (0,currency/* formatCurrency */.xG)(Math.round((0,utils/* getPreviousPrice */.L)(priceDrop, price)), market.code, false).toString();
    var text = badgeType === BadgeTypeEnum.LABEL_BADGE && isDesktop ? t("campaigns", "product-card.percentage-below-trend", {
        percentage: priceDrop.toString()
    }) : "".concat(priceDrop, "%");
    var ref4;
    var readMoreLink = (ref4 = (ref = market.articles) === null || ref === void 0 ? void 0 : (ref1 = ref.aboutDealsCalculation) === null || ref1 === void 0 ? void 0 : ref1.path) !== null && ref4 !== void 0 ? ref4 : null;
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledPopoverWrapper, {
        onClick: function(event) {
            if (hidePopover) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
        },
        $isLabelBadge: badgeType === BadgeTypeEnum.LABEL_BADGE
    }, /*#__PURE__*/ react.createElement(StyledPopover, {
        id: "popover-deals-badge-".concat(popoverUniqueId),
        visible: showPopover,
        width: isDesktop ? 210 : 140,
        // The setTimeout here is needed due to the Popover-onClose triggering before the Badge-onClick.
        onClose: function(event) {
            if (hidePopover) {
                return;
            }
            event === null || event === void 0 ? void 0 : event.preventDefault();
            event === null || event === void 0 ? void 0 : event.stopPropagation();
            setTimeout(function() {
                return setShowPopover(false);
            });
        },
        horizontalAlign: popover/* Alignment.Start */.v2.Start,
        verticalAlign: popover/* Alignment.Start */.v2.Start
    }, /*#__PURE__*/ react.createElement(StyledBigVerticalGap, null, /*#__PURE__*/ react.createElement(StyledSmallVerticalGap, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        color: variants.FontColor.DARK
    }, t("campaigns", "product-card.percentage-below-trend", {
        percentage: priceDrop.toString()
    })), /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        color: variants.FontColor.DARK
    }, t("campaigns", "product-card.expected-price-explanation", {
        expectedPrice: expectedPrice
    }), readMoreLink && /*#__PURE__*/ react.createElement(StyledLink, {
        to: readMoreLink
    }, t("campaigns", "product-card.read-more-about-price-trend"))))))), /*#__PURE__*/ react.createElement(StyledDealsBadge, {
        "data-testid": dataTestId,
        onClick: function(event) {
            if (hidePopover) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
        }
    }, /*#__PURE__*/ react.createElement(DealsBadgeWithInfoTooltip, {
        onClick: function(event) {
            if (hidePopover) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            setShowPopover(true);
        },
        $circular: badgeType === BadgeTypeEnum.ICON_BADGE,
        $isLabelBadge: badgeType === BadgeTypeEnum.LABEL_BADGE
    }, /*#__PURE__*/ react.createElement(trending_down/* IconTrendingDown */.j, {
        color: "maybeBlue700",
        size: badgeType === BadgeTypeEnum.LABEL_BADGE ? 11 : 16
    }), badgeType !== BadgeTypeEnum.ICON_BADGE && /*#__PURE__*/ react.createElement(react.Fragment, null, badgeType === BadgeTypeEnum.BADGE ? /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, text) : /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.HIGH
    }, text)), badgeType !== BadgeTypeEnum.ICON_BADGE && /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        size: 16,
        color: "maybeBlue700"
    }))));
};


/***/ }),

/***/ 21244:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": () => (/* binding */ ProductHeaderImageBadge),
/* harmony export */   "d3": () => (/* binding */ ImageBadge),
/* harmony export */   "gE": () => (/* binding */ MiniCardImageBadge),
/* harmony export */   "ni": () => (/* binding */ GridCardImageBadge),
/* harmony export */   "rn": () => (/* binding */ ListCardImageBadge)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 56px;\n  position: absolute;\n  z-index: auto;\n  right: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 32px;\n  top: -",
        ";\n  right: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 32px;\n  top: 0;\n  right: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    width: 48px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 40px;\n  left: 0;\n  top: 0;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var ImageBadgeImg = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].img.withConfig({
    displayName: "ImageBadgeImg",
    componentId: "sc-0-0"
})(_templateObject());
var ImageBadge = function(param) {
    var badgeUrl = param.badgeUrl, title = param.title, className = param.className;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageBadgeImg, {
        className: className,
        src: badgeUrl,
        alt: title,
        title: title
    });
};
var GridCardImageBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(ImageBadge).withConfig({
    displayName: "GridCardImageBadge",
    componentId: "sc-0-1"
})(_templateObject1());
var ListCardImageBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(ImageBadge).withConfig({
    displayName: "ListCardImageBadge",
    componentId: "sc-0-2"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var MiniCardImageBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(ImageBadge).withConfig({
    displayName: "MiniCardImageBadge",
    componentId: "sc-0-3"
})(_templateObject3());
var ProductHeaderImageBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(ImageBadge).withConfig({
    displayName: "ProductHeaderImageBadge",
    componentId: "sc-0-4"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumUp */ .BC.mediumUp(_templateObject4()));


/***/ }),

/***/ 90063:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HIGHLIGHT_NEW_CONTENT_DURATION": () => (/* reexport */ HIGHLIGHT_NEW_CONTENT_DURATION),
  "fadeInKeyframes": () => (/* binding */ fadeInKeyframes),
  "fromZeroWidthKeyframes": () => (/* binding */ fromZeroWidthKeyframes),
  "highlightNewContentAnimation": () => (/* reexport */ highlightNewContentAnimation)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(76323);
// EXTERNAL MODULE: ./src/components/base/src/color-utils.ts
var color_utils = __webpack_require__(33747);
;// CONCATENATED MODULE: ./src/components/base/src/animations/highlight-new-content.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    background-color: ",
        ";\n  }\n  25% {\n    background-color: ",
        ";\n  }\n  50% {\n    background-color: ",
        ";\n  }\n  to {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        "\n    ",
        "ms ease-out 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var INITIAL_COLOR = (0,color_utils.setRgbaAlpha)(variables/* colors.lightTheme.yellove500 */.O9.lightTheme.yellove500, "0");
var HIGHLIGHT_COLOR = (0,color_utils.setRgbaAlpha)(variables/* colors.lightTheme.yellove500 */.O9.lightTheme.yellove500, "0.2");
var highlightNewContentKeyframes = function() {
    var initialColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : INITIAL_COLOR, transitionColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : HIGHLIGHT_COLOR;
    return (0,styled_components_browser_esm.keyframes)(_templateObject(), initialColor, transitionColor, transitionColor, initialColor);
};
var HIGHLIGHT_NEW_CONTENT_DURATION = 750;
var highlightNewContentAnimation = function(initialColor, transitionColor) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), highlightNewContentKeyframes(initialColor, transitionColor), HIGHLIGHT_NEW_CONTENT_DURATION);
};

;// CONCATENATED MODULE: ./src/components/base/src/animations/index.ts
function animations_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function animations_templateObject() {
    var data = animations_taggedTemplateLiteral([
        "\nfrom { opacity: 0; }\nto { opacity: 1; }\n"
    ]);
    animations_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function animations_templateObject1() {
    var data = animations_taggedTemplateLiteral([
        "\nfrom { max-width: 0%; word-break: break-all; }\nto { max-width: 100%; word-break: unset; }\n"
    ]);
    animations_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var fadeInKeyframes = (0,styled_components_browser_esm.keyframes)(animations_templateObject());
var fromZeroWidthKeyframes = (0,styled_components_browser_esm.keyframes)(animations_templateObject1());


/***/ }),

/***/ 33747:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "blendColors": () => (/* binding */ blendColors),
/* harmony export */   "blendHexColors": () => (/* binding */ blendHexColors),
/* harmony export */   "extractRgba": () => (/* binding */ extractRgba),
/* harmony export */   "hexToRgb": () => (/* binding */ hexToRgb),
/* harmony export */   "hexToRgbaString": () => (/* binding */ hexToRgbaString),
/* harmony export */   "rgbToHex": () => (/* binding */ rgbToHex),
/* harmony export */   "rgbaFromRaw": () => (/* binding */ rgbaFromRaw),
/* harmony export */   "setRgbaAlpha": () => (/* binding */ setRgbaAlpha),
/* harmony export */   "shadeColor": () => (/* binding */ shadeColor)
/* harmony export */ });
/**
 * Shades a color, `amt` is a percentage.
 *
 * `amt`: Negative values make the color lighter, while positive values make the color darker.
 */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var regexHexSingleDigit = /^#?([\da-fA-F])([\da-fA-F])([\da-fA-F])$/;
var regexHexDoubleDigit = /^#?([\da-fA-F]{2})([\da-fA-F]{2})([\da-fA-F]{2})$/;
var regexRgb = /^rgb\(\d+,\s?\d+,\s?\d+\)$/;
var regexRgba = /^rgba\(\d+,\s?\d+,\s?\d+,\s?(1|0?\.\d+)\)$/;
var clamp0to255 = function(x) {
    return Math.min(255, Math.max(0, x));
};
var shadeColor = function(color, amt) {
    var hex = rgbToHex(color);
    var num = parseInt(hex.slice(1), 16);
    var R = (num >> 16) + amt; // eslint-disable-line no-bitwise
    var G = (num >> 8 & 0x00ff) + amt; // eslint-disable-line no-bitwise
    var B = (num & 0x0000ff) + amt; // eslint-disable-line no-bitwise
    var nR = clamp0to255(R) * 0x10000;
    var nG = clamp0to255(G) * 0x100;
    var nB = clamp0to255(B);
    return "#".concat((0x1000000 + nR + nG + nB // eslint-disable-line no-nested-ternary
    ).toString(16).slice(1));
};
var hexToRgb = function() {
    var memo = {};
    return function(hex) {
        if (memo[hex]) {
            return memo[hex];
        }
        var res = {
            r: 0,
            g: 0,
            b: 0
        };
        var matches = regexHexSingleDigit.exec(hex) || regexHexDoubleDigit.exec(hex);
        if (!matches || matches.length !== 4) {
            memo[hex] = res;
            return res;
        }
        var r = parseInt(matches[1], 16);
        var g = parseInt(matches[2], 16);
        var b = parseInt(matches[3], 16);
        res = {
            r: r,
            g: g,
            b: b
        };
        memo[hex] = res;
        return res;
    };
}();
var rgbToHex = function() {
    var memo = {};
    return function(rgb) {
        if (memo[rgb]) {
            return "#".concat(memo[rgb]);
        }
        var res = extractRgba(rgb).map(function(v) {
            return v.toString(16);
        }).map(function(v) {
            return v.length === 1 ? "0".concat(v) : v;
        }).slice(0, -1).join("");
        memo[rgb] = res;
        return "#".concat(res);
    };
}();
var hexToRgbaString = function(hex) {
    var alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (hex === "transparent") {
        return hex;
    }
    var r = hexToRgb(hex);
    return "rgba(".concat(r.r, ", ").concat(r.g, ", ").concat(r.b, ", ").concat(alpha, ")");
};
var extractRgba = function(colorStr) {
    if (colorStr === "transparent") {
        return [
            0,
            0,
            0,
            0
        ];
    }
    if (regexHexSingleDigit.test(colorStr) || regexHexDoubleDigit.test(colorStr)) {
        var rgb = hexToRgb(colorStr);
        return [
            rgb.r,
            rgb.g,
            rgb.b,
            1
        ];
    }
    if (regexRgb.test(colorStr) || regexRgba.test(colorStr)) {
        var rgb1 = colorStr.match(/[\d.]+/g).map(function(v) {
            return /^\d+\.\d+$/.test(v) ? parseFloat(v) : parseInt(v, 10);
        });
        return rgb1.length === 3 ? rgb1.concat([
            1
        ]) : rgb1;
    }
    return [
        0,
        0,
        0,
        0
    ];
};
var blendColors = function(color1, color2, amount) {
    var alpha = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1.0;
    var rgb1 = extractRgba(color1);
    var rgb2 = extractRgba(color2);
    var newRgb = [
        (1 - amount) * rgb1[0] + amount * rgb2[0],
        (1 - amount) * rgb1[1] + amount * rgb2[1],
        (1 - amount) * rgb1[2] + amount * rgb2[2]
    ];
    return "rgba(".concat(newRgb.join(","), ",").concat(alpha, ")");
};
var blendHexColors = blendColors;
var setRgbaAlpha = function(color, newAlpha) {
    var rgba = extractRgba(color);
    return "rgba(".concat(rgba[0], ", ").concat(rgba[1], ", ").concat(rgba[2], ", ").concat(newAlpha, ")");
};
var rgbaFromRaw = function(rgbaColor) {
    var overrides = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var newColor = _objectSpread({}, rgbaColor, overrides);
    return "rgba(".concat(newColor.r, ", ").concat(newColor.g, ", ").concat(newColor.b, ", ").concat(newColor.a, ")");
};


/***/ }),

/***/ 76323:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ pixelCalc),
/* harmony export */   "AV": () => (/* binding */ breakpoints),
/* harmony export */   "BC": () => (/* binding */ media),
/* harmony export */   "D2": () => (/* binding */ brandColors),
/* harmony export */   "O9": () => (/* binding */ colors),
/* harmony export */   "PS": () => (/* binding */ breakpointNames),
/* harmony export */   "bK": () => (/* binding */ layout),
/* harmony export */   "m4": () => (/* binding */ ratingStarColors),
/* harmony export */   "vR": () => (/* binding */ remCalc)
/* harmony export */ });
/* unused harmony exports campaignColors, extraMedia */
/* harmony import */ var _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24774);
/* harmony import */ var _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70416);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96742);
/* harmony import */ var _src_color_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33747);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      @media ",
        " {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var BASE_FONT_SIZE = parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.root, 10);
var PADDING_WRAPPER = 20;
var MARGIN_TOP_SUB_COMPONENT = 30;
var MARGIN_BOTTOM_SUB_COMPONENT = 30;
var GLOBAL_WIDTH = 1000;
// Transforms a pixel value to rem
// round to 5 digits to match Foundation rem-calc
function remCalc(pixelSize) {
    var remSize = pixelSize / BASE_FONT_SIZE;
    return "".concat(remSize.toFixed(5), "rem");
}
// Transforms a rem value to pixel (without px unit)
function pixelCalc(remSize) {
    return parseFloat(remSize) * BASE_FONT_SIZE;
}
var colors = {
    backgroundDarkGray: (0,_src_color_utils__WEBPACK_IMPORTED_MODULE_3__.setRgbaAlpha)(_prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base800, "0.05"),
    backgroundLightGray: "rgba(0, 0, 0, 0.06)",
    borderDarkGray: "rgba(0, 0, 0, 0.85);",
    borderLightGray: "rgba(0, 0, 0, 0.09);",
    lightTheme: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__
};
var campaignColors = {
    blackFriday: {
        id: 2,
        background: "#000",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    christmasSale: {
        id: 3,
        background: "#B70016",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    dailyDeals: {
        id: 4,
        background: "#9B051A",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    cyberMonday: {
        id: 6,
        background: "#5AA546",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    blackFridayWeekend: {
        id: 7,
        background: "#000",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    januarySale: {
        id: 12,
        background: "#4895B6",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    }
};
var brandColors = {
    twitter: "#00ACED",
    facebook: "#3B5998",
    pricespy: "#4895B6",
    expert: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.maybeBlue500
};
var ratingStarColors = {
    inactive: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base300,
    active: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.yellove500
};
var layoutMap = {
    measurements: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__,
    fontSizes: {
        base: {
            mobile: {
                value: parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeNormal, 10),
                rem: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeNormal
            },
            desktop: {
                value: parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeNormal, 10),
                rem: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeNormal
            }
        },
        small: {
            mobile: {
                value: parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeSmall, 10),
                rem: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeSmall
            },
            desktop: {
                value: parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeSmall, 10),
                rem: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeSmall
            }
        },
        h1: {
            desktop: {
                value: 64,
                rem: remCalc(64)
            },
            mobile: {
                value: 36,
                rem: remCalc(36)
            }
        },
        h2: {
            desktop: {
                value: 24,
                rem: remCalc(24)
            },
            mobile: {
                value: 20,
                rem: remCalc(20)
            }
        },
        h3: {
            desktop: {
                value: 18,
                rem: remCalc(18)
            },
            mobile: {
                value: 18,
                rem: remCalc(18)
            }
        },
        h4: {
            desktop: {
                value: 17,
                rem: remCalc(17)
            },
            mobile: {
                value: 17,
                rem: remCalc(17)
            }
        },
        h5: {
            desktop: {
                value: 17,
                rem: remCalc(17)
            },
            mobile: {
                value: 17,
                rem: remCalc(17)
            }
        },
        h6: {
            desktop: {
                value: 16,
                rem: remCalc(16)
            },
            mobile: {
                value: 16,
                rem: remCalc(16)
            }
        }
    },
    margins: {
        wrapper: {
            mobile: {
                value: 12,
                rem: remCalc(12)
            },
            desktop: {
                value: 10,
                rem: remCalc(10)
            }
        },
        component: {
            mobile: {
                value: 20,
                rem: remCalc(20)
            },
            desktop: {
                value: 30,
                rem: remCalc(30)
            }
        }
    },
    headerHeight: {
        desktop: {
            value: 72,
            rem: remCalc(72)
        },
        mobile: {
            value: 48,
            rem: remCalc(48)
        },
        mobileWithSearch: {
            value: 101,
            rem: remCalc(101)
        }
    },
    fontFamily: "Mulish, Helvetica Neue, Helvetica, Arial, Roboto, sans-serif",
    sidebarContentWidth: {
        desktop: {
            value: 304,
            rem: remCalc(304)
        }
    },
    sidebarMenuWidth: {
        desktop: {
            value: 56,
            rem: remCalc(56)
        }
    },
    pageContent: {
        gutter: {
            value: 10,
            rem: remCalc(10)
        },
        maxWidth: {
            value: 1300,
            rem: remCalc(1300)
        }
    },
    siteWidth: {
        value: GLOBAL_WIDTH,
        rem: remCalc(GLOBAL_WIDTH)
    },
    borderRadius: "5px",
    lineHeight: 1.5,
    stickyNavigationHeight: {
        value: 50,
        rem: remCalc(50)
    },
    dragAndDropHandleSize: {
        mobile: {
            value: 32,
            rem: remCalc(32)
        },
        desktop: {
            value: 16,
            rem: remCalc(16)
        }
    },
    pageContentMaxWidthVal: 1300,
    pageContentGutterVal: 10,
    // Ad layout
    takeOverTopMargin: "120px",
    takeOverWidth: "1600px",
    takeOverHeight: "900px",
    outsiderMinWidth: "200px",
    listSideMargin: "0.6rem",
    listSidePadding: "0.6rem",
    listSideHeight: "2.6rem",
    // Product card
    productCardMinWidthMobile: "146px",
    productCardMinWidth: "200px",
    productCardMaxWidth: "255px",
    productCardImageSize: "130px",
    productCardPaddingSmall: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.spacing025,
    productCardPaddingLarge: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.spacing100,
    pageNotFound: {
        maxWidth: "750px"
    },
    // Foundation grid
    gridColumnGutter: {
        small: {
            value: 25,
            rem: remCalc(25)
        },
        large: {
            value: PADDING_WRAPPER,
            rem: remCalc(PADDING_WRAPPER)
        }
    },
    // Search
    searchBar: {
        height: {
            desktop: {
                value: 40,
                rem: remCalc(40)
            },
            mobile: {
                value: 35,
                rem: remCalc(35)
            }
        },
        borderWidth: 1
    },
    animations: {
        buttonTransition: "150ms ease"
    }
};
var layoutMapDeprecated = {
    paddingWrapperVal: PADDING_WRAPPER,
    paddingWrapper: remCalc(PADDING_WRAPPER),
    marginTopSubComponentVal: MARGIN_TOP_SUB_COMPONENT,
    marginTopSubComponent: remCalc(MARGIN_TOP_SUB_COMPONENT),
    marginBottomSubComponentVal: MARGIN_BOTTOM_SUB_COMPONENT,
    marginBottomSubComponent: remCalc(MARGIN_BOTTOM_SUB_COMPONENT)
};
var fullLayoutMap = _objectSpread({}, layoutMapDeprecated, layoutMap);
var layout =  false ? 0 : fullLayoutMap;
// Foundation breakpoints
var breakpointNames = [
    "small",
    "medium",
    "large",
    "xlarge",
    "xxlarge"
];
// Force each breakpoint to provide Up|Only|Down matchers
// 1em ≙ 16px
var breakpoints = {
    smallUp: "screen",
    smallOnly: "screen and (max-width: 39.9375em)",
    smallDown: "screen and (max-width: 39.9375em)",
    mediumUp: "screen and (min-width: 40em)",
    mediumOnly: "screen and (max-width: 63.9375em) and (min-width: 40em)",
    mediumDown: "screen and (max-width: 63.9375em)",
    largeUp: "screen and (min-width: 64em)",
    largeOnly: "screen and (max-width: 89.9375em) and (min-width: 64em)",
    largeDown: "screen and (max-width: 89.9375emem)",
    xlargeUp: "screen and (min-width: 90em)",
    xlargeOnly: "screen and (max-width: 104.9375em) and  (min-width: 90em) ",
    xlargeDown: "screen and (max-width: 104.9375em)",
    xxlargeUp: "screen and (min-width: 105em)",
    xxlargeOnly: "screen and (min-width: 105em)",
    xxlargeDown: "screen"
};
var extraMedia = {
    hideOutsiderAd: "screen and (max-width: 1199px)",
    showOutsiderAd: "screen and (min-width: 1200px)"
};
var media = Object.entries(_objectSpread({}, breakpoints, extraMedia)).reduce(function(accumulator, param) {
    var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
    return _objectSpreadProps(_objectSpread({}, accumulator), _defineProperty({}, key, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), value, styled_components__WEBPACK_IMPORTED_MODULE_2__.css.apply(void 0, _toConsumableArray(args)));
    }));
}, {});


/***/ }),

/***/ 88999:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ Breadcrumbs)
/* harmony export */ });
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57735);
/* harmony import */ var _prisjakt_ui_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(100);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3616);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25349);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var LinkWithTracking = function(props) {
    var onClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_0__/* .trackInternalNavigationClick */ .p)(props.tracking);
    }, [
        props.tracking
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, _extends({
        onClick: onClick
    }, props));
};
var Breadcrumbs = function(param) {
    var crumbs = param.crumbs, _lastItemClickable = param.lastItemClickable, lastItemClickable = _lastItemClickable === void 0 ? false : _lastItemClickable;
    var t = (0,_app_context__WEBPACK_IMPORTED_MODULE_4__/* .useAppContext */ .bp)().t;
    var links = [
        {
            href: "/",
            title: t("common", "breadcrumb.home")
        }
    ].concat(_toConsumableArray(crumbs));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_prisjakt_ui_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__/* .Breadcrumbs */ .O, {
        lastItemClickable: lastItemClickable
    }, links.map(function(param, index) {
        var href = param.href, title = param.title;
        return href ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(LinkWithTracking, {
            to: href,
            key: href,
            tracking: {
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_0__/* .InternalNavigationScope.BREADCRUMB */ .U.BREADCRUMB,
                nextPage: href,
                index: index
            }
        }, title) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
            key: title
        }, title);
    }));
};


/***/ }),

/***/ 95088:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": () => (/* binding */ button_Button),
  "Z": () => (/* binding */ components_button)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var es = __webpack_require__(55703);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/button/styles.ts
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        color: ",
        ";\n        background: ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        border-radius: 100%;\n        padding: 0;\n        height: ",
        "px;\n        width: ",
        "px;\n        &:focus,\n        &:hover {\n          background: ",
        ";\n        }\n\n        &:active {\n          background: transparent;\n        }\n\n        svg {\n          transform: ",
        ";\n          path {\n            fill: ",
        ";\n          }\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        border-radius: 100%;\n        padding: 0;\n        height: ",
        ";\n        width: ",
        ";\n        background: ",
        ";\n        svg {\n          transform: scale(",
        ");\n          path {\n            fill: ",
        ";\n          }\n        }\n        &:focus,\n        &:hover,\n        &:active {\n          background: ",
        ";\n          svg {\n            path {\n              fill: ",
        ";\n            }\n          }\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n        background: ",
        ";\n        color: ",
        ";\n        white-space: normal;\n\n        &:focus,\n        &:hover {\n          background: ",
        ";\n          color: ",
        ";\n        }\n\n        &:active {\n          background: transparent;\n          color: ",
        ";\n        }\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n        background: transparent;\n        border: ",
        ";\n        border-color: ",
        ";\n\n        color: ",
        ";\n\n        &:focus,\n        &:hover {\n          background: ",
        ";\n          border-color: ",
        ";\n          color: ",
        ";\n        }\n\n        &:active {\n          background: transparent;\n        }\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    border-radius: 4px;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle;\n    white-space: nowrap;\n\n    font-size: ",
        ";\n    padding: ",
        ";\n\n    svg {\n      transform: ",
        ";\n      path {\n        fill: currentColor;\n      }\n    }\n\n    cursor: ",
        ";\n    pointer-events: ",
        ";\n    opacity: ",
        ";\n    transition:\n      background ",
        ",\n      color ",
        ";\n\n    &:hover,\n    &:focus {\n      background: ",
        ";\n      color: ",
        ";\n    }\n\n    &:active {\n      background: ",
        ";\n    }\n\n    /* Reset non-button elements like links <a role=\"button\" /> */\n    &[type='button'] {\n      appearance: none;\n      outline: none;\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline;\n      text-align: center;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: ",
        ";\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      margin-right: ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ",
        "px;\n  height: ",
        "px;\n  font-size: ",
        "px;\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonColors = function(theme) {
    return {
        primary: {
            text: theme.buttons.primary.text,
            hoverText: theme.buttons.primary.textHover,
            background: theme.buttons.primary.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.primary.bg, -20),
            activeBackground: theme.buttons.primary.bgActive,
            iconFill: theme.buttons.primary.bg
        },
        secondary: {
            text: theme.buttons.secondary.text,
            hoverText: theme.buttons.secondary.textHover,
            background: theme.buttons.secondary.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.secondary.bg, -20),
            iconFill: theme.buttons.secondary.bg
        },
        tertiary: {
            text: theme.buttons.tertiary.text,
            hoverText: theme.buttons.tertiary.textHover,
            background: theme.buttons.tertiary.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.tertiary.bg, -20),
            iconFill: theme.buttons.tertiary.bg
        },
        quarternary: {
            text: theme.buttons.quarternary.text,
            hoverText: theme.buttons.quarternary.textHover,
            background: theme.buttons.quarternary.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.quarternary.bg, 40),
            iconFill: theme.buttons.quarternary.bg
        },
        positive: {
            text: theme.buttons.positive.text,
            hoverText: theme.buttons.positive.textHover,
            background: theme.buttons.positive.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.positive.bg, -20),
            iconFill: theme.buttons.positive.bg
        },
        negative: {
            text: theme.buttons.negative.text,
            hoverText: theme.buttons.negative.textHover,
            background: theme.buttons.negative.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.negative.bg, -20),
            iconFill: theme.buttons.negative.bg
        },
        link: {
            text: theme.buttons.link.text,
            hoverText: theme.buttons.link.textHover,
            background: theme.buttons.link.bg,
            hoverBackground: theme.buttons.link.bg,
            iconFill: theme.buttons.link.text
        },
        disabled: {
            text: theme.buttons.disabled.text,
            hoverText: theme.buttons.disabled.textHover,
            background: theme.buttons.disabled.bg,
            hoverBackground: theme.buttons.disabled.bg,
            iconFill: theme.buttons.disabled.bg
        }
    };
};
var fontSize = {
    small: base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall,
    medium: base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal,
    large: base/* layout.measurements.fontSizeLarge */.bK.measurements.fontSizeLarge
};
var iconSize = {
    small: 19,
    medium: 24,
    large: 29
};
var padding = {
    small: "6px 10px",
    medium: "8px 20px",
    large: "8px 20px"
};
// Cloning allows us to dynamically render an element based on its props
// For example: We render <a /> if we pass `href` to the component
// Only forwarding `rest` to the cloned element stops the Unknown Prop warnings
// in the test suites. Should be replaced by `shouldForwardProp` when this
// feature lands in Styled Components.
var Button = (0,styled_components_browser_esm["default"])(function(_param) {
    var component = _param.component, isLink = _param.isLink, scaleIcon = _param.scaleIcon, iconPosition = _param.iconPosition, $active = _param.$active, rest = _objectWithoutProperties(_param, [
        "component",
        "isLink",
        "scaleIcon",
        "iconPosition",
        "$active"
    ]);
    return (0,react.cloneElement)(component, rest);
}).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(function(param) {
    var color = param.color, disabled = param.disabled, size = param.size, theme = param.theme, $active = param.$active, scaleIcon = param.scaleIcon;
    return (0,styled_components_browser_esm.css)(_templateObject5(), fontSize[size], padding[size], scaleIcon ? "scale(".concat(iconSize[size] / iconSize.medium, ")") : "none", disabled ? "default" : "pointer", disabled ? "none" : "inherit", disabled ? "0.5" : "1", base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, buttonColors(theme)[color].hoverBackground, buttonColors(theme)[color].hoverText, buttonColors(theme)[color].background, (0,es/* switchProp */.db)("variant", {
        default: (0,styled_components_browser_esm.css)(_templateObject(), buttonColors(theme)[color].text, buttonColors(theme)[color].background),
        icon: (0,styled_components_browser_esm.css)(_templateObject1(), iconSize[size] + 10, iconSize[size] + 10, base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(buttonColors(theme)[color].iconFill, "0.2"), scaleIcon ? "scale(".concat(iconSize[size] / iconSize.medium, ")") : "none", buttonColors(theme)[color].iconFill),
        iconOutlined: (0,styled_components_browser_esm.css)(_templateObject2(), iconSize[size] + 10, iconSize[size] + 10, $active ? base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(buttonColors(theme)[color].iconFill, "0.2") : theme.colors.base100, iconSize[size] / iconSize.medium, $active ? buttonColors(theme)[color].iconFill : theme.colors.base500, base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(buttonColors(theme)[color].iconFill, "0.2"), buttonColors(theme)[color].iconFill),
        text: (0,styled_components_browser_esm.css)(_templateObject3(), $active && buttonColors(theme)[color].activeBackground || "transparent", // eslint-disable-next-line no-nested-ternary
        disabled ? buttonColors(theme).disabled.background : color === "link" ? buttonColors(theme).link.text : buttonColors(theme)[color].background, $active && buttonColors(theme)[color].activeBackground || "transparent", base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(color === "link" ? buttonColors(theme).link.text : buttonColors(theme)[color].background, "0.7"), buttonColors(theme).link.text),
        outlined: (0,styled_components_browser_esm.css)(_templateObject4(), color === "link" ? 0 : "solid 1px", disabled ? buttonColors(theme).disabled.background : buttonColors(theme)[color].background, // eslint-disable-next-line no-nested-ternary
        disabled ? buttonColors(theme).disabled.background : color === "link" ? buttonColors(theme).link.text : buttonColors(theme)[color].background, color === "link" ? buttonColors(theme).link.background : base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(buttonColors(theme)[color].background, "0.2"), buttonColors(theme)[color].background, color === "link" ? buttonColors(theme).link.hoverText : buttonColors(theme)[color].background)
    }));
});
var Inner = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Inner",
    componentId: "sc-0-1"
})(function(param) {
    var variant = param.variant, truncate = param.truncate;
    return [
        {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            lineHeight: "1.75",
            width: "100%"
        },
        variant !== "icon" && (0,es/* switchProp */.db)("iconPosition", {
            top: {
                flexDirection: "column"
            },
            bottom: {
                flexDirection: "column"
            },
            left: {
                flexDirection: "row"
            },
            right: {
                flexDirection: "row"
            }
        }),
        truncate && (0,styled_components_browser_esm.css)(_templateObject6())
    ];
});
var IconWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-2"
})(_templateObject11(), function(p) {
    return iconSize[p.size];
}, function(p) {
    return iconSize[p.size];
}, function(p) {
    return iconSize[p.size];
}, (0,es/* switchProp */.db)("iconPosition", {
    top: (0,styled_components_browser_esm.css)(_templateObject7(), function(p) {
        return p.noMargin ? 0 : "5px";
    }),
    bottom: (0,styled_components_browser_esm.css)(_templateObject8(), function(p) {
        return p.noMargin ? 0 : "5px";
    }),
    left: (0,styled_components_browser_esm.css)(_templateObject9(), function(p) {
        return p.noMargin ? 0 : "5px";
    }),
    right: (0,styled_components_browser_esm.css)(_templateObject10(), function(p) {
        return p.noMargin ? 0 : "5px";
    })
}));

;// CONCATENATED MODULE: ./src/components/button/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function button_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = button_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function button_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var renderChildrenWithIcon = function(iconPosition, icon, children, size) {
    switch(iconPosition){
        case "bottom":
        case "right":
            return /*#__PURE__*/ react.createElement(react.Fragment, null, children, icon && /*#__PURE__*/ react.createElement(IconWrapper, {
                iconPosition: iconPosition,
                size: size
            }, icon));
        default:
            return /*#__PURE__*/ react.createElement(react.Fragment, null, icon && /*#__PURE__*/ react.createElement(IconWrapper, {
                iconPosition: iconPosition,
                size: size
            }, icon), children);
    }
};
/**
 * @deprecated Use Button from `@prisjakt/ui` instead. Whenever possible replace existing usage so that this can be removed
 */ var button_Button = function(props) {
    var component = props.component, children = props.children, className = props.className, style = props.style, disabled = props.disabled, iconPosition = props.iconPosition, icon = props.icon, iconOutlined = props.iconOutlined, onClick = props.onClick, tabIndex = props.tabIndex, href = props.href, variant = props.variant, size = props.size, color = props.color, ariaLabel = props.ariaLabel, type = props.type, truncate = props.truncate, title = props.title, active = props.active, scaleIcon = props.scaleIcon, dataTest = props["data-test"], dataTestId = props["data-testid"], anchorProps = button_objectWithoutProperties(props, [
        "component",
        "children",
        "className",
        "style",
        "disabled",
        "iconPosition",
        "icon",
        "iconOutlined",
        "onClick",
        "tabIndex",
        "href",
        "variant",
        "size",
        "color",
        "ariaLabel",
        "type",
        "truncate",
        "title",
        "active",
        "scaleIcon",
        "data-test",
        "data-testid"
    ]);
    return /*#__PURE__*/ react.createElement(Button, {
        component: // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
        href ? /*#__PURE__*/ react.createElement("a", _extends({
            href: href
        }, anchorProps)) : component,
        type: type,
        "aria-label": ariaLabel,
        isLink: !!href || color === "link",
        onClick: onClick,
        iconPosition: iconPosition,
        variant: variant,
        size: size,
        className: className,
        style: style,
        tabIndex: disabled ? "-1" : tabIndex,
        disabled: disabled,
        color: color,
        "data-test": dataTest,
        "data-testid": dataTestId,
        title: title,
        $active: active,
        scaleIcon: scaleIcon
    }, /*#__PURE__*/ react.createElement(Inner, {
        variant: variant,
        iconPosition: iconPosition,
        truncate: truncate
    }, [
        "icon",
        "iconOutlined"
    ].includes(variant) ? icon && /*#__PURE__*/ react.createElement(IconWrapper, {
        noMargin: react.Children.count(children) <= 1,
        iconPosition: iconPosition,
        size: size
    }, variant === "iconOutlined" && iconOutlined && !active ? iconOutlined : icon) : renderChildrenWithIcon(iconPosition, icon, children, size)));
};
button_Button.defaultProps = {
    children: null,
    className: undefined,
    type: "button",
    style: undefined,
    disabled: false,
    tabIndex: "0",
    onClick: undefined,
    icon: undefined,
    iconOutlined: undefined,
    href: undefined,
    iconPosition: "left",
    size: "medium",
    variant: "default",
    color: "secondary",
    ariaLabel: undefined,
    component: /*#__PURE__*/ react.createElement("button", {
        type: "button"
    }),
    truncate: false,
    "data-test": undefined,
    "data-testid": undefined,
    title: "",
    active: undefined,
    scaleIcon: true
};
/* harmony default export */ var components_button = (button_Button);


/***/ }),

/***/ 38911:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ promo_banner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/app-context/link-to.ts
var link_to = __webpack_require__(92837);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/arrow-right/index.js
var arrow_right = __webpack_require__(7743);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/components/campaign-banners/promo-banner/utils.ts
var ICON_SIZE = 40;
var getLogoUrl = function(market) {
    return {
        "1x": "".concat(market.cdn, "/g/campaigns/4/banner_logo_").concat(ICON_SIZE, ".png"),
        "2x": "".concat(market.cdn, "/g/campaigns/4/banner_logo_").concat(ICON_SIZE * 2, ".png")
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/campaign-banners/promo-banner/styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 0;\n      margin-top: 0;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      padding-left: calc(",
        " + ",
        "px);\n      background-image: image-set(\n        url(",
        ") 1x,\n        url(",
        ") 2x\n      );\n      background-position-y: 50%;\n      background-position-x: ",
        ";\n      background-repeat: no-repeat;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      border: 2px solid ",
        ";\n      background-color: ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: 56px;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    align-items: center;\n    padding: ",
        ";\n    margin: ",
        " 0;\n    border-radius: 8px;\n    background-color: ",
        ";\n\n    ",
        "\n\n    ",
        "\n\n  ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    line-height: 20px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: normal;\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}





var StyledBanner = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledBanner",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.$themeColor || "transparent", base/* media.mediumDown */.BC.mediumDown(_templateObject()), props.$logo && (0,styled_components_browser_esm.css)(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, ICON_SIZE, props.$logo["1x"], props.$logo["2x"], base/* layout.measurements.spacing050 */.bK.measurements.spacing050), props.$inverted && (0,styled_components_browser_esm.css)(_templateObject2(), props.$themeColor || props.theme.lines.primary, props.theme.bg.primary, props.$themeColor || props.theme.text.primary));
});
var StyledH4Text = (0,styled_components_browser_esm["default"])(variants.H4Text).withConfig({
    displayName: "StyledH4Text",
    componentId: "sc-0-1"
})(_templateObject5(), base/* media.smallOnly */.BC.smallOnly(_templateObject4()));
var StyledDivider = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDivider",
    componentId: "sc-0-2"
})(_templateObject7(), base/* media.smallOnly */.BC.smallOnly(_templateObject6()));
var StyledText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledText",
    componentId: "sc-0-3"
})(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledTagline = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledTagline",
    componentId: "sc-0-4"
})(_templateObject10(), base/* media.smallOnly */.BC.smallOnly(_templateObject9()));
var StyledLinkText = (0,styled_components_browser_esm["default"])(variants.TitleSmallText).withConfig({
    displayName: "StyledLinkText",
    componentId: "sc-0-5"
})(_templateObject12(), base/* media.smallOnly */.BC.smallOnly(_templateObject11()));

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/campaign-banners/promo-banner/index.tsx








var PromoBanner = function(props) {
    var ref, ref1;
    var banners = props.banners, className = props.className, _inverted = props.inverted, inverted = _inverted === void 0 ? false : _inverted, linkParams = props.linkParams;
    var market = (0,app_context/* useAppContext */.bp)().market;
    if (!(banners === null || banners === void 0 ? void 0 : banners.length)) return null;
    // TODO: render banner based on priority
    var activeBanner = banners[0];
    var options = activeBanner.options || {};
    var customLink = options.customLink && options.customLink.url;
    var path = customLink && linkParams ? (0,link_to/* withQueryString */.pS)(customLink, linkParams) : customLink;
    var tagline = (ref = options.tagline) === null || ref === void 0 ? void 0 : ref.text;
    var linkText = (ref1 = options.customLink) === null || ref1 === void 0 ? void 0 : ref1.text;
    var color = options.fallbackColor || "#000";
    var logo = options.showLogo ? getLogoUrl(market) : undefined;
    var fontColor = inverted ? variants.FontColor.DARK : variants.FontColor.LIGHT;
    if (!path) {
        return null;
    }
    var onClick = function() {
        return (0,tracking/* trackInternalNavigationClick */.p)({
            nextPage: path,
            scope: tracking/* InternalNavigationScope.BANNER */.U.BANNER
        });
    };
    return /*#__PURE__*/ react.createElement(StyledBanner, {
        className: className,
        to: path,
        onClick: onClick,
        $logo: logo,
        $themeColor: color,
        $inverted: inverted
    }, /*#__PURE__*/ react.createElement(StyledH4Text, {
        color: fontColor
    }, "Black Friday", " ", tagline && /*#__PURE__*/ react.createElement(StyledTagline, null, /*#__PURE__*/ react.createElement(StyledDivider, null, "-"), " ", tagline)), /*#__PURE__*/ react.createElement(StyledText, null, linkText && /*#__PURE__*/ react.createElement(StyledLinkText, {
        color: fontColor
    }, linkText), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
        color: inverted ? "base900" : "base100",
        size: 22
    })));
};
/* harmony default export */ var promo_banner = (PromoBanner);


/***/ }),

/***/ 87341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var CampaignDealsLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "secondary-content";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | secondary-content */ 88).then(__webpack_require__.bind(__webpack_require__, 48035));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(48035);
        }
        return eval("require.resolve")("./campaign-deals");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (CampaignDealsLoader);


/***/ }),

/***/ 74650:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ useCarouselContext),
/* harmony export */   "L": () => (/* binding */ CarouselContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var initialValue = {
    backgroundColor: undefined,
    dataTestType: undefined,
    items: undefined,
    linkPath: undefined,
    linkTitle: undefined,
    negativeMargin: undefined,
    onHeaderLinkClick: undefined,
    onCardClick: undefined,
    productsInCarousel: undefined,
    removeProductsWithNoImage: undefined,
    shouldLazyLoadImages: undefined,
    showCreateAlertButton: undefined,
    showLinkAsButton: undefined,
    subTitle: undefined,
    title: "",
    type: undefined
};
var CarouselContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var useCarouselContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CarouselContext);
};
var CarouselContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CarouselContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 49601:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": () => (/* binding */ CardsCarousel)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(89286);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(79393);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(31744);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/cards-carousel/carousel-context.tsx
var carousel_context = __webpack_require__(74650);
// EXTERNAL MODULE: ./src/ui/link/index.ts
var ui_link = __webpack_require__(35050);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/product-card/index.ts + 67 modules
var product_card = __webpack_require__(866);
;// CONCATENATED MODULE: ./src/components/cards-carousel/carousel-deals-card/index.tsx


var CarouselDealsCard = /*#__PURE__*/ (0,react.memo)(function(param) {
    var product = param.product, index = param.index;
    return /*#__PURE__*/ react.createElement(product_card/* DealsProductCard */.N8, {
        key: product.productId,
        product: product,
        trackingIndex: index
    });
});

// EXTERNAL MODULE: ./src/components/product-card-old/product-card-context.tsx
var product_card_context = __webpack_require__(5780);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-filled/index.js
var notification_filled = __webpack_require__(40900);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(50999);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(33944);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/new-product-releases/components/alert-button/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-around;\n\n  button {\n    display: flex;\n    line-height: 20px;\n    color: ",
        ";\n    margin: 20px 0;\n    padding: 10px 20px;\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    cursor: pointer;\n  }\n\n  svg {\n    fill: ",
        ";\n    width: 20px !important;\n    height: 20px !important;\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var AlertButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AlertButton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.icons.tertiary;
}, function(p) {
    return p.theme.lines.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});

;// CONCATENATED MODULE: ./src/components/new-product-releases/components/alert-button/index.js









var alert_button_AlertButton = function(props) {
    var linkTo = (0,react.useContext)(app_context/* AppContext */.Il).linkTo;
    var product = props.product, account = props.account, userProductAlerts = props.userProductAlerts, createAlertRequest = props.createAlertRequest, removeAlertRequest = props.removeAlertRequest, text = props.text, type = props.type, history = props.history;
    var isAuthenticated = (account || {}).isAuthenticated;
    var userAlert = userProductAlerts.find(function(alert) {
        return alert.productId === product.id;
    });
    var alertId = userAlert && userAlert.alertId;
    return /*#__PURE__*/ react.createElement(AlertButton, null, /*#__PURE__*/ react.createElement("button", {
        type: "button",
        onClick: function() {
            if (isAuthenticated) {
                if (!alertId) {
                    createAlertRequest({
                        productId: product.id,
                        type: type
                    });
                } else {
                    removeAlertRequest(alertId, product.id);
                }
            } else {
                history.push(linkTo("productAlert", product));
            }
        }
    }, alertId ? /*#__PURE__*/ react.createElement(notification_filled/* IconNotificationFilled */.Q, {
        color: "base400",
        size: 20
    }) : /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, {
        color: "base400",
        size: 20
    }), text));
};
alert_button_AlertButton.propTypes = {
    userProductAlerts: prop_types_default().arrayOf(prop_types_default().shape({
        productId: (prop_types_default()).number,
        alertId: (prop_types_default()).number
    })),
    account: prop_types_default().shape({
        isAuthenticated: (prop_types_default()).bool
    }),
    product: prop_types_default().shape({
        alert: prop_types_default().shape({
            id: (prop_types_default()).number
        }),
        id: (prop_types_default()).number,
        pathName: (prop_types_default()).string
    }),
    createAlertRequest: (prop_types_default()).func.isRequired,
    removeAlertRequest: (prop_types_default()).func.isRequired,
    text: (prop_types_default()).string.isRequired,
    type: (prop_types_default()).string,
    history: (prop_types_default()).object.isRequired
};
alert_button_AlertButton.defaultProps = {
    account: {
        isAuthenticated: false
    },
    userProductAlerts: [],
    product: {},
    type: "IN_STOCK"
};
var dispatchActions = {
    createAlertRequest: actions_alert/* createAlertRequest */.$b,
    removeAlertRequest: actions_alert/* removeAlertRequest */.s$
};
/* harmony default export */ var alert_button = ((0,es/* connect */.$j)(function(state) {
    return {
        account: state.areas.account,
        userProductAlerts: state.areas.sidebar.alerts.products
    };
}, dispatchActions)(/*#__PURE__*/ (0,react.memo)((0,react_router/* withRouter */.EN)(alert_button_AlertButton))));

// EXTERNAL MODULE: ./src/components/product-card-old/index.tsx + 27 modules
var product_card_old = __webpack_require__(90299);
;// CONCATENATED MODULE: ./src/components/cards-carousel/carousel-product-card/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var CarouselProductCard = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref;
    var index = props.index, onCardClick = props.onCardClick, product = props.product, _shouldLazyLoadImages = props.shouldLazyLoadImages, shouldLazyLoadImages = _shouldLazyLoadImages === void 0 ? true : _shouldLazyLoadImages, showCreateAlertButton = props.showCreateAlertButton;
    var ref1 = (0,app_context/* useAppContext */.bp)(), t = ref1.t, linkTo = ref1.linkTo, market = ref1.market;
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        key: product.id,
        background: true,
        diffPercentage: ((ref = product.price) === null || ref === void 0 ? void 0 : ref.diffPercentage) || product.diffPercentage,
        FooterArea: market.login.enabled && showCreateAlertButton ? /*#__PURE__*/ react.createElement(alert_button, {
            product: product,
            text: t("product", "alert.create-button"),
            type: "PRICE_DROPS"
        }) : null,
        hasExpertBadge: product.isExpertTopRated,
        onClick: function() {
            onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick({
                index: index,
                link: "".concat(market.domain).concat(product.pathName),
                productId: product.id
            });
        },
        product: _objectSpreadProps(_objectSpread({}, product), {
            pathName: linkTo("product", product)
        }),
        shouldLazyLoadImage: shouldLazyLoadImages
    }, /*#__PURE__*/ react.createElement(product_card_old/* ProductGridCard */.r4, null));
});

// EXTERNAL MODULE: ./src/components/article-card/index.tsx + 1 modules
var article_card = __webpack_require__(55445);
// EXTERNAL MODULE: ./src/areas/expert/components/card-image/index.tsx
var card_image = __webpack_require__(59669);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/components/partner-video-modal/index.tsx + 3 modules
var partner_video_modal = __webpack_require__(87191);
// EXTERNAL MODULE: ./src/components/youtube-icon/index.tsx + 1 modules
var youtube_icon = __webpack_require__(22448);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/components/cards-carousel/carousel-video-card/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: ",
        ";\n  left: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledYoutubeIcon = (0,styled_components_browser_esm["default"])(youtube_icon/* YoutubeIcon */.L).withConfig({
    displayName: "StyledYoutubeIcon",
    componentId: "sc-0-0"
})(styles_templateObject(), design_tokens.measurements.spacing025, design_tokens.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/cards-carousel/carousel-video-card/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var CarouselVideoCard = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var item = props.item;
    var onCardClick = (0,carousel_context/* useCarouselContext */.G)().onCardClick;
    var ref7 = _slicedToArray((0,react.useState)(false), 2), isPartnerVideoModalOpen = ref7[0], setIsPartnerVideoModalOpen = ref7[1];
    if (!((ref = item.previewImage) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) || !item.videoId) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(partner_video_modal/* PartnerVideoModal */.o, {
        closeModal: function() {
            return setIsPartnerVideoModalOpen(false);
        },
        isOpen: isPartnerVideoModalOpen,
        imageUrl: item.previewImage.large.url,
        title: item.title,
        videoId: item.videoId
    }), /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
        pretitle: {
            name: ((ref2 = item.author) === null || ref2 === void 0 ? void 0 : ref2.name) || "",
            image: (ref3 = item.author) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.avatar) === null || ref4 === void 0 ? void 0 : ref4.url
        },
        titleAndCategory: item.title,
        media: ((ref5 = item.previewImage) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.small) === null || ref6 === void 0 ? void 0 : ref6.url) && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
            src: item.previewImage.small.url,
            height: 150
        }),
        icon: /*#__PURE__*/ react.createElement(StyledYoutubeIcon, null),
        onClick: function() {
            if (onCardClick) onCardClick({
                link: item.videoUrl || "",
                index: 0,
                productId: 0
            });
            setIsPartnerVideoModalOpen(true);
        }
    }));
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/variants/medium-card-horizontal-scroll.tsx
var medium_card_horizontal_scroll = __webpack_require__(61890);
// EXTERNAL MODULE: ./src/components/cards-carousel/types.ts
var types = __webpack_require__(24124);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon-interactive/index.js
var icon_interactive = __webpack_require__(64341);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
;// CONCATENATED MODULE: ./src/components/cards-carousel/styles.ts
function cards_carousel_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function cards_carousel_styles_templateObject() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        ";\n"
    ]);
    cards_carousel_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n        padding: ",
        " ",
        ";\n        margin-right: -",
        ";\n        margin-left: -",
        ";\n        border-radius: 0;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n      border-radius: ",
        ";\n      padding: ",
        ";\n\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n      margin: 0;\n      flex-direction: column;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-self: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  z-index: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  cursor: initial;\n  user-select: text;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n          width: calc(",
        " - (",
        " / 2));\n        "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n      li > * {\n        ",
        "\n      }\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n    cursor: pointer;\n    ",
        "\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n  white-space: nowrap;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}











var PANEL_BACKGROUND_PADDING = base/* layout.measurements.spacing100 */.bK.measurements.spacing100;
var FlexColumn = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "FlexColumn",
    componentId: "sc-0-0"
})(cards_carousel_styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledPanel = (0,styled_components_browser_esm["default"])(panel/* Panel */.s_).withConfig({
    displayName: "StyledPanel",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$backgroundColor && (0,styled_components_browser_esm.css)(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, PANEL_BACKGROUND_PADDING, base/* media.smallOnly */.BC.smallOnly(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050)), props.$backgroundColor === types/* CarouselBackgroundColorsEnum.GREY */.Z.GREY && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.colors.base200));
});
var StyledPanelHeader = (0,styled_components_browser_esm["default"])(panel/* PanelHeader */.V9).withConfig({
    displayName: "StyledPanelHeader",
    componentId: "sc-0-2"
})(_templateObject6(), base/* media.smallOnly */.BC.smallOnly(_templateObject5()));
var CallToActionButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).attrs({
    color: "primary",
    variant: "outlined"
}).withConfig({
    displayName: "CallToActionButton",
    componentId: "sc-0-3"
})(_templateObject7(), function(p) {
    return p.theme.text.callToAction;
});
var StyledInteractiveIconTooltip = (0,styled_components_browser_esm["default"])(icon_interactive/* InteractiveIcon */.z).withConfig({
    displayName: "StyledInteractiveIconTooltip",
    componentId: "sc-0-4"
})(_templateObject8());
var StyledInteractiveIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledInteractiveIconWrapper",
    componentId: "sc-0-5"
})(_templateObject9(), zindex/* zindex.tooltip */.Y.tooltip);
var StyledPopoverWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPopoverWrapper",
    componentId: "sc-0-6"
})(_templateObject10());
var StyledPopover = (0,styled_components_browser_esm["default"])(popover/* Popover */.J2).withConfig({
    displayName: "StyledPopover",
    componentId: "sc-0-7"
})(_templateObject11());
var StyledMediumCardHorizontalScroll = (0,styled_components_browser_esm["default"])(medium_card_horizontal_scroll/* MediumCardHorizontalScroll */._).withConfig({
    displayName: "StyledMediumCardHorizontalScroll",
    componentId: "sc-0-8"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject14(), props.$hasBackground && (0,styled_components_browser_esm.css)(_templateObject13(), base/* media.mediumUp */.BC.mediumUp(_templateObject12(), medium_card_horizontal_scroll/* CARD_WIDTH_DESKTOP */.J, PANEL_BACKGROUND_PADDING)));
});
var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-9"
})(_templateObject15(), function(p) {
    return p.theme.colors.base800;
});

;// CONCATENATED MODULE: ./src/components/cards-carousel/index.tsx
function cards_carousel_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function cards_carousel_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function cards_carousel_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function cards_carousel_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function cards_carousel_slicedToArray(arr, i) {
    return cards_carousel_arrayWithHoles(arr) || cards_carousel_iterableToArrayLimit(arr, i) || cards_carousel_unsupportedIterableToArray(arr, i) || cards_carousel_nonIterableRest();
}
function cards_carousel_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return cards_carousel_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cards_carousel_arrayLikeToArray(o, minLen);
}














var HeaderLink = function() {
    var ref = (0,carousel_context/* useCarouselContext */.G)(), linkPath = ref.linkPath, linkTitle = ref.linkTitle, onHeaderLinkClick = ref.onHeaderLinkClick, showLinkAsButton = ref.showLinkAsButton;
    if (!linkTitle || !linkPath) return null;
    return showLinkAsButton ? /*#__PURE__*/ react.createElement(CallToActionButton, {
        component: /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            to: linkPath
        })
    }, linkTitle) : /*#__PURE__*/ react.createElement(ui_link/* InternalLink */.h, {
        to: linkPath,
        onClick: function() {
            onHeaderLinkClick === null || onHeaderLinkClick === void 0 ? void 0 : onHeaderLinkClick({
                link: linkPath
            });
        }
    }, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
        color: variants.FontColor.PRIMARY
    }, linkTitle));
};
var CardsCarousel = function(props) {
    var ref, ref1;
    var ref2 = (0,carousel_context/* useCarouselContext */.G)(), backgroundColor = ref2.backgroundColor, dataTestType = ref2.dataTestType, items = ref2.items, negativeMargin = ref2.negativeMargin, onCardClick = ref2.onCardClick, _productsInCarousel = ref2.productsInCarousel, productsInCarousel = _productsInCarousel === void 0 ? 12 : _productsInCarousel, _removeProductsWithNoImage = ref2.removeProductsWithNoImage, removeProductsWithNoImage = _removeProductsWithNoImage === void 0 ? true : _removeProductsWithNoImage, _shouldLazyLoadImages = ref2.shouldLazyLoadImages, shouldLazyLoadImages = _shouldLazyLoadImages === void 0 ? true : _shouldLazyLoadImages, showCreateAlertButton = ref2.showCreateAlertButton, subTitle = ref2.subTitle, title = ref2.title, _type = ref2.type, type = _type === void 0 ? types/* CardTypeEnum.PRODUCT_CARD */.m.PRODUCT_CARD : _type;
    var ref3 = (0,app_context/* useAppContext */.bp)(), t = ref3.t, market = ref3.market;
    var ref4 = cards_carousel_slicedToArray((0,react.useState)(false), 2), showPopover = ref4[0], setShowPopover = ref4[1];
    var getCards = function() {
        switch(type){
            case types/* CardTypeEnum.VIDEO_CARD */.m.VIDEO_CARD:
                return items === null || items === void 0 ? void 0 : items.map(function(item) {
                    return /*#__PURE__*/ react.createElement(CarouselVideoCard, {
                        item: item,
                        key: item.videoId
                    });
                }).slice(0, productsInCarousel);
            case types/* CardTypeEnum.DEALS_CARD */.m.DEALS_CARD:
                return items.filter(function(p) {
                    if (!removeProductsWithNoImage) return p;
                    return (p === null || p === void 0 ? void 0 : p.logo) !== undefined;
                }).map(function(product, index) {
                    return /*#__PURE__*/ react.createElement(CarouselDealsCard, {
                        key: product.productId,
                        index: index,
                        product: product
                    });
                }).slice(0, productsInCarousel);
            default:
                return items.filter(function(p) {
                    var ref;
                    if (!removeProductsWithNoImage) return p;
                    return (p === null || p === void 0 ? void 0 : (ref = p.media) === null || ref === void 0 ? void 0 : ref.first) !== undefined;
                }).map(function(product, index) {
                    return /*#__PURE__*/ react.createElement(CarouselProductCard, {
                        key: product.id,
                        index: index,
                        onCardClick: onCardClick,
                        product: product,
                        shouldLazyLoadImages: shouldLazyLoadImages,
                        showCreateAlertButton: showCreateAlertButton
                    });
                }).slice(0, productsInCarousel);
        }
    };
    if (!items || !items.length) return null;
    var ref5;
    var readMoreLink = (ref5 = (ref = market.articles) === null || ref === void 0 ? void 0 : (ref1 = ref.aboutDealsCalculation) === null || ref1 === void 0 ? void 0 : ref1.path) !== null && ref5 !== void 0 ? ref5 : null;
    return /*#__PURE__*/ react.createElement(StyledPanel, {
        className: props.className,
        containerProps: dataTestType ? {
            "data-test": "Panel",
            "data-test-type": dataTestType
        } : "",
        $backgroundColor: backgroundColor
    }, /*#__PURE__*/ react.createElement(StyledPanelHeader, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(FlexColumn, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, title), type === types/* CardTypeEnum.DEALS_CARD */.m.DEALS_CARD && /*#__PURE__*/ react.createElement(StyledPopoverWrapper, null, /*#__PURE__*/ react.createElement(StyledInteractiveIconWrapper, null, /*#__PURE__*/ react.createElement(StyledInteractiveIconTooltip, {
        icon: info_outlined/* IconInfoOutlined */.e,
        size: 20,
        onClick: function() {
            return setShowPopover(true);
        }
    })), /*#__PURE__*/ react.createElement(StyledPopover, {
        id: "popover-carousel-deals-info-icon",
        visible: showPopover,
        width: 290,
        onClose: function() {
            return setTimeout(function() {
                return setShowPopover(false);
            });
        },
        horizontalAlign: popover/* Alignment.Center */.v2.Center,
        verticalAlign: popover/* Alignment.EndOutside */.v2.EndOutside
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        color: variants.FontColor.DARK
    }, t("campaigns", "campaign.deals-info-icon"), readMoreLink && /*#__PURE__*/ react.createElement(StyledLink, {
        to: readMoreLink
    }, t("campaigns", "campaign.deals-read-more")))))), subTitle && /*#__PURE__*/ react.createElement(variants.CaptionText, null, subTitle)), /*#__PURE__*/ react.createElement(HeaderLink, null)), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledMediumCardHorizontalScroll, {
        loadingHeight: 140,
        negativeMargin: negativeMargin,
        $hasBackground: Boolean(backgroundColor)
    }, getCards())));
};


/***/ }),

/***/ 24124:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ CarouselBackgroundColorsEnum),
/* harmony export */   "m": () => (/* binding */ CardTypeEnum)
/* harmony export */ });
var CardTypeEnum;
(function(CardTypeEnum) {
    CardTypeEnum["PRODUCT_CARD"] = "product-card";
    CardTypeEnum["VIDEO_CARD"] = "video-card";
    CardTypeEnum["DEALS_CARD"] = "deals-card";
})(CardTypeEnum || (CardTypeEnum = {}));
var CarouselBackgroundColorsEnum;
(function(CarouselBackgroundColorsEnum) {
    CarouselBackgroundColorsEnum["GREY"] = "grey";
})(CarouselBackgroundColorsEnum || (CarouselBackgroundColorsEnum = {}));


/***/ }),

/***/ 71412:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": () => (/* binding */ CdnImage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);
/* harmony import */ var src_areas_store_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67595);



var getFolderName = function(name) {
    return name.toString().slice(-1);
};
var getShopUrl = function(cdnUrl, name, width) {
    return width === src_areas_store_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOP_LOGO_WIDTH */ .L9 ? "".concat(cdnUrl, "g/ftg_logos/sizes/").concat(src_areas_store_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOP_LOGO_WIDTH */ .L9, "/").concat(getFolderName(name), "/").concat(name, ".png") : "".concat(cdnUrl, "g/ftg_logos/store_").concat(name, ".png");
};
var getBrandUrl = function(cdnUrl, name) {
    return "".concat(cdnUrl, "g/ftg_logos/brand_sizes/").concat(src_areas_store_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOP_LOGO_WIDTH */ .L9, "/").concat(getFolderName(name), "/").concat(name, ".png");
};
var makeImageUrl = function(cdnUrl, name, logoType, width) {
    return logoType === "shop" ? getShopUrl(cdnUrl, name, width) : getBrandUrl(cdnUrl, name);
};
var CdnImage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(param) {
    var className = param.className, name = param.name, alt = param.alt, logoUrl = param.logoUrl, width = param.width, height = param.height, _logoType = param.logoType, logoType = _logoType === void 0 ? "shop" : _logoType;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il), _market = ref.market, _imageCdnUrl = _market.imageCdnUrl, imageCdnUrl = _imageCdnUrl === void 0 ? "" : _imageCdnUrl;
    var imageUrl = logoUrl !== null && logoUrl !== void 0 ? logoUrl : makeImageUrl(imageCdnUrl, name, logoType, width);
    var styles = {};
    if (height) {
        styles.height = height;
    }
    return(// @ts-expect-error picture is typed as HTMLElement which does not have alt attribute
    /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", {
        alt: alt,
        className: className
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
        srcSet: imageUrl,
        type: "image/png"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        src: imageUrl,
        alt: alt,
        width: width,
        style: styles
    })));
});


/***/ }),

/***/ 89218:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": () => (/* binding */ Clickable)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/clickable/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font: inherit;\n  cursor: pointer;\n\n  &:focus-visible {\n    outline: ",
        " 2px solid;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var styles = (0,styled_components_browser_esm.css)(_templateObject(), function(props) {
    return props.theme.colors.maybeBlue300;
});
var Button = styled_components_browser_esm["default"].button.attrs({
    type: "button"
}).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(_templateObject1(), styles);
var InternalLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "InternalLink",
    componentId: "sc-0-1"
})(_templateObject2(), styles);
var ExternalLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ExternalLink",
    componentId: "sc-0-2"
})(_templateObject3(), styles);

;// CONCATENATED MODULE: ./src/components/clickable/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var Clickable = function(_param) {
    var to = _param.to, isExternal = _param.isExternal, disabled = _param.disabled, containerProps = _param.containerProps, props = _objectWithoutProperties(_param, [
        "to",
        "isExternal",
        "disabled",
        "containerProps"
    ]);
    if (!to) {
        return /*#__PURE__*/ react.createElement(Button, _extends({
            disabled: disabled
        }, props, containerProps));
    }
    return isExternal || disabled ? /*#__PURE__*/ react.createElement(ExternalLink, _extends({
        href: disabled ? undefined : to
    }, props, containerProps)) : /*#__PURE__*/ react.createElement(InternalLink, _extends({
        to: to
    }, props, containerProps, {
        "data-test": props["data-test"] || "InternalLink"
    }));
};


/***/ }),

/***/ 87526:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": () => (/* binding */ ClickoutWrapper)
/* harmony export */ });
/* harmony import */ var js_sha256__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5589);
/* harmony import */ var js_sha256__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_sha256__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var ClickoutWrapper = function(param) {
    var children = param.children;
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!wrapperRef.current) return function() {
            return undefined;
        };
        var handleEvent = function(e) {
            var target = e.target;
            var anchor = target.closest("a[href]");
            if (anchor && anchor.href) {
                var originalHref = anchor.href;
                if (originalHref) {
                    var modifiedHref = modifyHref(originalHref);
                    if (modifiedHref && modifiedHref !== originalHref) {
                        anchor.setAttribute("href", modifiedHref);
                    }
                }
            }
        };
        var wrapper = wrapperRef.current;
        // Capture phase to ensure we run before navigation
        wrapper.addEventListener("click", handleEvent, true);
        wrapper.addEventListener("auxclick", handleEvent, true);
        wrapper.addEventListener("contextmenu", handleEvent, true);
        wrapper.addEventListener("keydown", handleEvent, true);
        return function() {
            wrapper.removeEventListener("click", handleEvent, true);
            wrapper.removeEventListener("auxclick", handleEvent, true);
            wrapper.removeEventListener("contextmenu", handleEvent, true);
            wrapper.removeEventListener("keydown", handleEvent, true);
        };
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        ref: wrapperRef,
        style: {
            display: "contents"
        }
    }, children);
};
function modifyHref(href) {
    // Try to parse the URL
    var url;
    try {
        url = new URL(href);
    } catch (e) {
        return href; // Invalid URL, return unchanged
    }
    var buttonClickParams = generateButtonClickParams(href);
    if (!buttonClickParams) {
        return href; // Doesn't match the pattern, return unchanged
    }
    var timestamp = buttonClickParams.timestamp, hash = buttonClickParams.hash;
    url.searchParams.set("pjt", timestamp);
    url.searchParams.set("pjh", hash);
    return url.toString();
}
var hrefRegex = /^http.*\/go-to-shop\/(\w+?)\/offer\/(.+?)(?:\?|\/|$)/;
function generateButtonClickParams(href) {
    var timestamp = Math.floor(Date.now() / 1000).toString();
    var hrefMatch = href.match(hrefRegex);
    if (!hrefMatch) {
        return null;
    }
    var _hrefMatch = _slicedToArray(hrefMatch, 3), shopId = _hrefMatch[1], offerId = _hrefMatch[2];
    if (!shopId || !offerId) {
        return null;
    }
    var data = "".concat(shopId, "-").concat(offerId, "-").concat(timestamp);
    var hash = (0,js_sha256__WEBPACK_IMPORTED_MODULE_0__.sha256)(data).slice(0, 10);
    return {
        timestamp: timestamp,
        hash: hash
    };
}


/***/ }),

/***/ 37364:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": () => (/* reexport */ country_flag_CountryFlag)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/country-flag/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 2px;\n\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 10px;\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.size && (0,styled_components_browser_esm.css)(_templateObject(), props.size));
});
var CountryFlag = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CountryFlag",
    componentId: "sc-0-1"
})(_templateObject2());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.text.tertiary);
});

;// CONCATENATED MODULE: ./src/components/country-flag/country-flag.tsx




var SIZE = 16;
var country_flag_CountryFlag = function(param) {
    var className = param.className, countryCode = param.countryCode, altText = param.altText, title = param.title, _showTitleAsTooltip = param.showTitleAsTooltip, showTitleAsTooltip = _showTitleAsTooltip === void 0 ? true : _showTitleAsTooltip, _tooltipPlacement = param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? ui/* Direction.Left */.Nm.Left : _tooltipPlacement;
    var renderImage = function() {
        return /*#__PURE__*/ react.createElement(Image, {
            title: altText,
            alt: altText,
            size: SIZE,
            src: "https://cdn.pji.nu/g/rfe/icons/flags/svg/".concat(countryCode, ".svg")
        });
    };
    return showTitleAsTooltip ? /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: tooltipPlacement,
        title: title,
        className: className,
        renderOnMouseOver: true
    }, /*#__PURE__*/ react.createElement(CountryFlag, null, renderImage())) : /*#__PURE__*/ react.createElement(CountryFlag, {
        className: className
    }, renderImage());
};

;// CONCATENATED MODULE: ./src/components/country-flag/index.ts



/***/ }),

/***/ 18280:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": () => (/* binding */ CurrencySettings)
/* harmony export */ });
// U+00A0 = non-breaking space
var eur = {
    symbol: "€",
    withDecimals: true,
    thousandSeparator: "\xa0",
    numberOfDecimals: 2,
    decimalSign: ",",
    minimumStepValue: 0.1,
    format: {
        pos: "%v\xa0%s",
        neg: "-%v\xa0%s",
        zero: "%v\xa0%s"
    }
};
var gbp = {
    symbol: "\xa3",
    withDecimals: true,
    thousandSeparator: ",",
    numberOfDecimals: 2,
    decimalSign: ".",
    minimumStepValue: 0.1,
    format: {
        pos: "%s%v",
        neg: "-%s%v",
        zero: "%s%v"
    }
};
var nok = {
    symbol: ",-",
    withDecimals: false,
    thousandSeparator: "\xa0",
    numberOfDecimals: 0,
    decimalSign: ",",
    minimumStepValue: 1,
    format: {
        pos: "%v\xa0%s",
        neg: "-%v\xa0%s",
        zero: "%v\xa0%s"
    }
};
var nzd = {
    symbol: "$",
    withDecimals: true,
    thousandSeparator: ",",
    numberOfDecimals: 2,
    decimalSign: ".",
    minimumStepValue: 0.1,
    format: {
        pos: "%s%v",
        neg: "-%s%v",
        zero: "%s%v"
    }
};
var sek = {
    symbol: "kr",
    withDecimals: false,
    format: {
        pos: "%v\xa0%s",
        neg: "-%v\xa0%s",
        zero: "%v\xa0%s"
    },
    thousandSeparator: "\xa0",
    numberOfDecimals: 0,
    decimalSign: ".",
    minimumStepValue: 1
};
var dkk = {
    symbol: "kr",
    withDecimals: false,
    format: {
        pos: "%v\xa0%s",
        neg: "-%v\xa0%s",
        zero: "%v\xa0%s"
    },
    thousandSeparator: "\xa0",
    numberOfDecimals: 0,
    decimalSign: ".",
    minimumStepValue: 1
};
var CurrencySettings = {
    eur: eur,
    gbp: gbp,
    nok: nok,
    nzd: nzd,
    sek: sek,
    dkk: dkk
};


/***/ }),

/***/ 65634:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ Currency),
/* harmony export */   "Gr": () => (/* reexport safe */ _market_settings__WEBPACK_IMPORTED_MODULE_2__.G),
/* harmony export */   "xG": () => (/* binding */ formatCurrency)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var accounting_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96144);
/* harmony import */ var accounting_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(accounting_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _market_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87665);
/* harmony import */ var _codes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18280);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25349);






var formatCurrency = function(price, market, asDiff, code) {
    var omitCode = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var settings = _market_settings__WEBPACK_IMPORTED_MODULE_2__/* .MarketSettings */ .G[market];
    if (!settings || price === undefined || price === null) {
        return null;
    }
    var overrideCode = typeof code === "string" ? _codes__WEBPACK_IMPORTED_MODULE_3__/* .CurrencySettings */ .B[code.toLowerCase()] : undefined;
    var ref = overrideCode || settings, withDecimals = ref.withDecimals, numberOfDecimals = ref.numberOfDecimals, symbol = ref.symbol, format = ref.format;
    var decimals = numberOfDecimals !== undefined ? numberOfDecimals : 2;
    var options = {
        symbol: omitCode ? "\xa4" : symbol,
        decimal: settings.decimalSign,
        precision: withDecimals ? decimals : 0,
        thousand: settings.thousandSeparator,
        format: format
    };
    var formattedPrice = accounting_js__WEBPACK_IMPORTED_MODULE_1___default().formatMoney(price, options);
    if (omitCode) {
        formattedPrice = formattedPrice.replace("\xa4", "").trim();
    }
    if (asDiff && Number(price) > 0) {
        return "+".concat(formattedPrice);
    }
    return formattedPrice;
};
var Currency = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(props) {
    var ref;
    var price = props.price, market = props.market, _asDiff = props.asDiff, asDiff = _asDiff === void 0 ? false : _asDiff, _code = props.code, code = _code === void 0 ? "" : _code, _omitCode = props.omitCode, omitCode = _omitCode === void 0 ? false : _omitCode;
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_4__/* .AppContext */ .Il);
    var marketFromParamOrContext = market !== null && market !== void 0 ? market : (ref = context.market) === null || ref === void 0 ? void 0 : ref.code;
    var curr = formatCurrency(price, marketFromParamOrContext, asDiff, code, omitCode);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, curr);
});


/***/ }),

/***/ 87665:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ MarketSettings)
/* harmony export */ });
/* harmony import */ var _codes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18280);

var eur = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.eur */ .B.eur, gbp = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.gbp */ .B.gbp, nok = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.nok */ .B.nok, sek = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.sek */ .B.sek, nzd = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.nzd */ .B.nzd, dkk = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.dkk */ .B.dkk;
var MarketSettings = {
    gb: gbp,
    fr: eur,
    fi: eur,
    no: nok,
    nz: nzd,
    se: sek,
    dk: dkk
};


/***/ }),

/***/ 88143:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "No": () => (/* binding */ No),
  "sk": () => (/* binding */ Yes)
});

// UNUSED EXPORTS: Unknown, default

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close-filled/index.js
var close_filled = __webpack_require__(25064);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(6213);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/question-filled/index.js
var question_filled = __webpack_require__(21832);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/data-list/components/colored-icon/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  svg {\n    margin-right: 0.4em;\n    path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ColoredIconWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ColoredIconWrapper",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.color;
}, function(props) {
    return props.color;
});

;// CONCATENATED MODULE: ./src/components/data-list/components/colored-icon/index.tsx







var ColoredIcon = function(param) {
    var children = param.children, color = param.color;
    return /*#__PURE__*/ react.createElement(ColoredIconWrapper, {
        color: color
    }, children);
};
var Yes = function() {
    return /*#__PURE__*/ react.createElement(ColoredIcon, {
        color: base/* colors.lightTheme.positive500 */.O9.lightTheme.positive500
    }, /*#__PURE__*/ react.createElement(check_filled.IconCheckFilled, {
        size: 18,
        color: "positive500"
    }), /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "property.boolean-yes"));
};
var No = function() {
    return /*#__PURE__*/ react.createElement(ColoredIcon, {
        color: base/* colors.lightTheme.negative700 */.O9.lightTheme.negative700
    }, /*#__PURE__*/ react.createElement(close_filled.IconCloseFilled, {
        size: 18,
        color: "negative700"
    }), /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "property.boolean-no"));
};
var Unknown = function() {
    return /*#__PURE__*/ React.createElement(ColoredIcon, {
        color: colors.lightTheme.base400
    }, /*#__PURE__*/ React.createElement(IconQuestionFilled, {
        size: 18,
        color: "base400"
    }));
};
/* harmony default export */ var colored_icon = ((/* unused pure expression or super */ null && (ColoredIcon)));


/***/ }),

/***/ 99453:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ parseNodes)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_text_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30943);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57735);



var isPropertyType = function(node) {
    return Boolean(node.type);
};
function parseNodes(node, t) {
    var noChildren = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref;
    var property = {
        name: node.name || undefined,
        value: {
            type: node.type,
            text: "",
            urls: []
        },
        byline: node.comment ? node.comment : "",
        children: node.children && ((ref = node.children) === null || ref === void 0 ? void 0 : ref.length) && !noChildren ? node.children.map(function(child) {
            return isPropertyType(child) && parseNodes(child, t, noChildren);
        }).filter(function(child) {
            return child !== undefined;
        }) : [],
        column: {}
    };
    switch(node.type){
        case "boolean":
            {
                var value = node.boolean;
                if (value !== null) {
                    property.value.text = value ? t("product", "property.boolean-yes") : t("product", "property.boolean-no");
                    property.value.value = value;
                }
                return property;
            }
        case "integer":
        case "decimal":
            {
                var value1 = node.number;
                var unit = node.unit;
                var text = value1 !== null && value1 !== void 0 ? value1 : node.pretty;
                if (text === null || text === undefined) {
                    property.value.text = "";
                } else {
                    property.value.text = unit ? "".concat(text, " ").concat(unit) : String(text);
                    property.value.value = text;
                }
                return property;
            }
        case "list":
            {
                var values = node.values, categoryLinks = node.categoryLinks;
                if (!values) {
                    return property;
                }
                property.value.text = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, values.map(function(value, index) {
                    var link = categoryLinks === null || categoryLinks === void 0 ? void 0 : categoryLinks[index];
                    var isLastValue = index < values.length - 1;
                    if (!value) {
                        return null;
                    }
                    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        key: value
                    }, link ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_text_link__WEBPACK_IMPORTED_MODULE_1__/* .TextLink */ .h, {
                        to: link
                    }, value) : value, isLastValue ? ", " : "");
                }));
                return property;
            }
        case "interval":
            {
                var values1 = [
                    node.from,
                    node.to
                ].filter(function(n) {
                    return n !== null;
                }).filter(function(value, index, self) {
                    return self.indexOf(value) === index;
                }).join(" - ");
                var text1 = values1 !== null && values1 !== void 0 ? values1 : node.pretty;
                property.value.text = text1 ? "".concat(text1, " ").concat(node.unit || "").trim() : "";
                return property;
            }
        case "link":
            {
                var links = node.links;
                property.value.urls = links && links.length ? links.map(function(link) {
                    return link && link.url;
                }).filter(function(link) {
                    return !!link;
                }) : [];
                property.column = {
                    full: true
                };
                return property;
            }
        case "string":
            {
                var value2 = node.value, unit1 = node.unit, categoryLink = node.categoryLink, pretty = node.pretty;
                var text2 = value2 !== null && value2 !== void 0 ? value2 : pretty;
                if (text2 === null || text2 === undefined) {
                    property.value.text = "";
                } else {
                    var valueWithUnit = unit1 ? "".concat(text2, " ").concat(unit1) : text2;
                    property.value.text = categoryLink ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_text_link__WEBPACK_IMPORTED_MODULE_1__/* .TextLink */ .h, {
                        onClick: function() {
                            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackInternalNavigationClick */ .p)({
                                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .InternalNavigationScope.PRODUCT_INFORMATION */ .U.PRODUCT_INFORMATION,
                                nextPage: categoryLink
                            });
                        },
                        to: categoryLink
                    }, valueWithUnit) : valueWithUnit;
                }
                return property;
            }
        default:
            {
                return property;
            }
    }
}


/***/ }),

/***/ 49907:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": () => (/* binding */ data_list_DataList)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/text-link/index.tsx + 1 modules
var text_link = __webpack_require__(30943);
// EXTERNAL MODULE: ./src/components/review-form/components/title/index.tsx
var title = __webpack_require__(23581);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/components/data-list/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  break-inside: avoid;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100%;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: border-box;\n  padding: ",
        " 0;\n  word-wrap: break-word;\n\n  &:nth-of-type(odd) {\n    flex: 0 0 35%;\n    max-width: 50%;\n  }\n\n  &:nth-of-type(even) {\n    flex: 1 0 50%;\n    padding-left: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-top: ",
        ";\n      border-bottom: none;\n      & > ",
        ":nth-of-type(odd) {\n        padding-left: ",
        ";\n      }\n\n      & > & > ",
        ":nth-of-type(odd) {\n        padding-left: ",
        ";\n      }\n\n      & > & > & > ",
        ":nth-of-type(odd) {\n        padding-left: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  border-bottom: ",
        ";\n\n  &:last-of-type {\n    border-bottom: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var borderStyle = "1px solid  ".concat(base/* colors.lightTheme.base200 */.O9.lightTheme.base200);
var DataList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DataList",
    componentId: "sc-0-0"
})(_templateObject());
var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Section",
    componentId: "sc-0-1"
})(_templateObject1());
var Column = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.full && (0,styled_components_browser_esm.css)(_templateObject2());
});
var Row = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Row",
    componentId: "sc-0-3"
})(_templateObject5(), borderStyle, function(p) {
    return p.inline && (0,styled_components_browser_esm.css)(_templateObject4(), borderStyle, Column, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Column, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, Column, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
});
var Title = (/* unused pure expression or super */ null && (H3Text));
var Byline = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Byline",
    componentId: "sc-0-4"
})(_templateObject6(), function(p) {
    return p.theme.colors.base600;
});
var PropertyName = (0,styled_components_browser_esm["default"])(variants.BodySmallText).attrs({
    emphasis: variants.FontEmphasis.MEDIUM
}).withConfig({
    displayName: "PropertyName",
    componentId: "sc-0-5"
})(_templateObject7());
var PropertyValue = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "PropertyValue",
    componentId: "sc-0-6"
})(_templateObject8());

// EXTERNAL MODULE: ./src/components/data-list/components/colored-icon/index.tsx + 1 modules
var colored_icon = __webpack_require__(88143);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/data-list/index.tsx






function renderValue(property) {
    var value = property.value;
    switch(value.type){
        case "link":
            return (value.urls || []).map(function(url, index) {
                return /*#__PURE__*/ react.createElement("a", {
                    key: "".concat(url, "-").concat(index.toString()),
                    href: url,
                    target: "_blank",
                    rel: "nofollow noopener noreferrer"
                }, url);
            });
        case "boolean":
            {
                if (typeof value.value !== "boolean") {
                    return null;
                }
                return value.value ? /*#__PURE__*/ react.createElement(colored_icon/* Yes */.sk, null) : /*#__PURE__*/ react.createElement(colored_icon.No, null);
            }
        default:
            return value.link ? /*#__PURE__*/ react.createElement(text_link/* TextLink */.h, {
                to: value.link,
                onClick: function() {
                    (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.PRODUCT_INFORMATION */.U.PRODUCT_INFORMATION,
                        nextPage: value.link
                    });
                }
            }, value.text) : value.text;
    }
}
var renderList = function(properties) {
    var inline = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return properties.map(function(property, index) {
        var ref, ref1;
        var key = "".concat(property.name, "-").concat(index.toString());
        return /*#__PURE__*/ react.createElement(Row, {
            inline: inline,
            key: key,
            role: "listitem"
        }, /*#__PURE__*/ react.createElement(Column, {
            full: (ref = property.column) === null || ref === void 0 ? void 0 : ref.full
        }, /*#__PURE__*/ react.createElement(PropertyName, null, property.name)), /*#__PURE__*/ react.createElement(Column, {
            full: (ref1 = property.column) === null || ref1 === void 0 ? void 0 : ref1.full
        }, /*#__PURE__*/ react.createElement(PropertyValue, null, property.value && renderValue(property)), property.byline && /*#__PURE__*/ react.createElement(Byline, {
            key: property.byline
        }, property.byline)), property.children && renderList(property.children, true));
    });
};
var data_list_DataList = function(props) {
    return /*#__PURE__*/ react.createElement(Section, {
        key: props.title,
        role: "list"
    }, props.title && /*#__PURE__*/ react.createElement(title/* default */.Z, null, props.title), renderList(props.properties));
};


/***/ }),

/***/ 19855:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ DidYouMean)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29261);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21541);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89218);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25349);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    flex: 0 1 auto;\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var DidYouMean = function(props) {
    var didYouMeanQueries = props.didYouMeanQueries, searchQuery = props.searchQuery, handleClick = props.handleClick, linkToRoute = props.linkToRoute;
    var ref = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_5__/* .useAppContext */ .bp)(), t = ref.t, linkTo = ref.linkTo;
    var renderDidYouMeanSuggestions = function() {
        return didYouMeanQueries.map(function(query) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_clickable__WEBPACK_IMPORTED_MODULE_4__/* .Clickable */ .P, {
                key: query,
                onClick: function() {
                    return handleClick(query, searchQuery);
                },
                to: linkToRoute ? linkTo(linkToRoute, {
                    query: query
                }) : null
            }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__.H4Text, {
                color: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__.FontColor.PRIMARY
            }, query));
        });
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DidYouMeanWrapper, {
        gap: 1
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__.BodyMediumText, null, t("search", "search.did-you-mean")), renderDidYouMeanSuggestions()));
};
var DidYouMeanWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__.Row).withConfig({
    displayName: "DidYouMeanWrapper",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_6__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium);


/***/ }),

/***/ 28839:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* reexport */ DropdownItem)
});

// UNUSED EXPORTS: SharedListItemStyles

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/dropdown-item/dropdown-item.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  svg {\n    margin-right: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SharedListItemStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var DropdownItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-0"
})(_templateObject1(), SharedListItemStyles);

;// CONCATENATED MODULE: ./src/components/dropdown-item/index.ts



/***/ }),

/***/ 13961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cw": () => (/* reexport */ DropdownNew),
  "HC": () => (/* reexport */ ListItem)
});

// UNUSED EXPORTS: SharedListItemStyles

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(95088);
// EXTERNAL MODULE: ./src/components/dropdown-new/styles.ts
var styles = __webpack_require__(92648);
;// CONCATENATED MODULE: ./src/components/dropdown-new/dropdown-new.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var Dropdown = function(props) {
    var ref = _slicedToArray((0,react.useState)(false), 2), expanded = ref[0], setExpandedState = ref[1];
    var dropdownRef = (0,react.useRef)(null);
    var className = props.className, children = props.children, _grow = props.grow, grow = _grow === void 0 ? "none" : _grow, toggleElement = props.toggleElement, _showArrow = props.showArrow, showArrow = _showArrow === void 0 ? true : _showArrow, _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant, onSelect = props.onSelect;
    var toggleDropdown = (0,react.useCallback)(function() {
        setExpandedState(!expanded);
    }, [
        expanded
    ]);
    var onToggleElementClick = (0,react.useCallback)(function(e) {
        if (typeof toggleElement !== "string" && toggleElement.props.onClick) {
            toggleElement.props.onClick(e);
        } else {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
        }
    }, [
        toggleDropdown,
        toggleElement
    ]);
    var handleClickOutside = function(e) {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setExpandedState(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ react.createElement(styles/* Dropdown */.Lt, {
        variant: variant,
        expanded: expanded,
        ref: dropdownRef,
        className: className,
        "data-test": props["data-test"]
    }, typeof toggleElement === "string" ? /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        style: styles/* sharedButtonStyles */.Rg,
        variant: "text",
        color: "link",
        onClick: toggleDropdown,
        iconPosition: "right",
        icon: showArrow ? /*#__PURE__*/ react.createElement(styles/* Arrow */.Eh, {
            expanded: expanded ? 1 : 0
        }) : null,
        "data-test": "DropdownToggle"
    }, toggleElement) : /*#__PURE__*/ react.createElement(toggleElement.type, _extends({
        style: styles/* sharedButtonStyles */.Rg,
        "data-test": "DropdownToggle"
    }, toggleElement.props, {
        onClick: onToggleElementClick,
        className: "dropdown-toggle-element"
    }), toggleElement.props.children, " ", showArrow && /*#__PURE__*/ react.createElement(styles/* Arrow */.Eh, {
        expanded: expanded ? 1 : 0
    })), /*#__PURE__*/ react.createElement(styles/* DropdownHideable */.Lr, {
        visible: expanded
    }, /*#__PURE__*/ react.createElement(styles/* DropdownContent */.Nv, {
        variant: variant,
        expanded: expanded,
        grow: grow
    }, react.Children.map(children, function(child) {
        if (!child) {
            return null;
        }
        return /*#__PURE__*/ react.cloneElement(child, _objectSpreadProps(_objectSpread({}, child.props), {
            onClick: function onClick(e) {
                if (child.props.onClick) {
                    child.props.onClick(e);
                }
                if (onSelect) {
                    onSelect(child.key || undefined);
                }
                if (child.props.to || child.props.onClick || onSelect) {
                    toggleDropdown();
                }
            },
            "data-test": "DropdownOption",
            "data-test-key": child.key
        }));
    }))));
};
var DropdownNew = /*#__PURE__*/ (0,react.memo)(Dropdown);

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/dropdown-new/item.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ",
        ";\n  &:disabled {\n    color: rgba(16, 16, 16, 0.3);\n  }\n\n  svg {\n    margin-right: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SharedListItemStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text.primary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var ListItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), SharedListItemStyles);

;// CONCATENATED MODULE: ./src/components/dropdown-new/index.ts





/***/ }),

/***/ 92648:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": () => (/* binding */ Arrow),
/* harmony export */   "Lr": () => (/* binding */ DropdownHideable),
/* harmony export */   "Lt": () => (/* binding */ Dropdown),
/* harmony export */   "Nv": () => (/* binding */ DropdownContent),
/* harmony export */   "Rg": () => (/* binding */ sharedButtonStyles)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34783);
/* harmony import */ var _prisjakt_ui_hideable_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28285);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      svg,\n      path {\n        fill: currentColor;\n      }\n\n      border-color: transparent;\n\n      &:hover {\n        & > button {\n          color: ",
        ";\n        }\n      }\n\n      & > button {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n\n      background: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    border: ",
        ";\n    border-bottom: ",
        ";\n    border-top-left-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n\n    color: ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    .dropdown-toggle-element {\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 11;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      top: calc(100% - 2px);\n      left: -",
        "px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      top: calc(100% - 2px);\n      right: -",
        "px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      top: calc(100% - 2px);\n      left: -",
        "px;\n      right: -",
        "px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    display: block; /* display flex + absolute position breaks in IE11 */\n    position: absolute;\n    border: ",
        ";\n    border-top: ",
        ";\n    background: ",
        ";\n    border-top-left-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  && {\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var borderSize = 1;
var dropdownBorder = function(props) {
    var transparent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return "".concat(borderSize, "px solid ").concat(transparent ? "transparent" : props.theme.dropdowns[props.variant].borderColor.active);
};
var sharedButtonStyles = {
    cursor: "pointer"
};
var Dropdown = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), dropdownBorder(props), props.expanded && props.variant === "primary" ? dropdownBorder(props, true) : dropdownBorder(props), props.theme.dropdowns[props.variant].borderRadius, props.theme.dropdowns[props.variant].borderRadius, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.theme.icons.tertiary, props.variant === "secondary" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject(), props.theme.icons.callToAction, props.expanded ? props.theme.icons.callToAction : undefined), props.variant !== "secondary" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), props.expanded ? props.theme.dropdowns[props.variant].borderColor.active : props.theme.dropdowns[props.variant].borderColor.inactive, props.expanded ? props.theme.dropdowns[props.variant].bg : "transparent"), function(p) {
        return p.theme.buttons.link.textHover;
    });
});
var DropdownHideable = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_hideable_variants__WEBPACK_IMPORTED_MODULE_2__.NudgeUp).withConfig({
    displayName: "DropdownHideable",
    componentId: "sc-0-1"
})(_templateObject3());
var DropdownContent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "DropdownContent",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), dropdownBorder(props), props.expanded && props.variant === "primary" ? dropdownBorder(props, true) : dropdownBorder(props), props.theme.dropdowns[props.variant].bg, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.theme.dropdowns[props.variant].borderRadius, props.theme.dropdowns[props.variant].borderRadius, props.grow === "right" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), borderSize), props.grow === "left" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), borderSize), props.grow === "none" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), borderSize, borderSize));
});
var arrowStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8());
var Arrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_1__/* .IconChevronDown */ .C).withConfig({
    displayName: "Arrow",
    componentId: "sc-0-3"
})(_templateObject9(), arrowStyles, function(p) {
    return p.expanded ? "rotate(180deg)" : "rotate(0)";
});


/***/ }),

/***/ 52923:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ error_boundary)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
;// CONCATENATED MODULE: ./src/components/error-boundary/error-boundary-inner.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


var ErrorBoundaryInner = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(ErrorBoundaryInner, _Component);
    var _super = _createSuper(ErrorBoundaryInner);
    function ErrorBoundaryInner(props) {
        _classCallCheck(this, ErrorBoundaryInner);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorBoundaryInner.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        this.unlisten = this.props.history.listen(function(location) {
            if (_this.state.hasError && _this.state.url !== location.pathname + location.search) {
                _this.setState({
                    hasError: false
                });
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _obj, ref;
        (ref = (_obj = this).unlisten) === null || ref === void 0 ? void 0 : ref.call(_obj);
    };
    _proto.componentDidCatch = function componentDidCatch(error, info) {
        var captureException = this.context.captureException;
        Object.assign(error, {
            info: info
        });
        captureException(error);
        this.setState({
            error: error,
            hasError: true,
            url: this.props.history.location.pathname + this.props.history.location.search
        });
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return this.props.onError(this.state.error || {}) || null;
        }
        return this.props.children;
    };
    return ErrorBoundaryInner;
}(react.Component);
ErrorBoundaryInner.contextType = app_context/* AppContext */.Il;

;// CONCATENATED MODULE: ./src/components/error-boundary/index.tsx



var ErrorBoundary = function(props) {
    var history = (0,react_router/* useHistory */.k6)();
    return /*#__PURE__*/ react.createElement(ErrorBoundaryInner, {
        history: history,
        onError: props.onError
    }, props.children);
};
/* harmony default export */ var error_boundary = (ErrorBoundary);


/***/ }),

/***/ 44581:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ error_message)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(37702);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/components/error-message/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        ";\n  max-width: ",
        ";\n\n  img {\n    max-width: 304px;\n    align-self: center;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: column;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        ";\n  min-height: 400px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 12rem;\n  width: 328px;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    padding-left: 0;\n    padding-right: 0;\n    margin-left: 0;\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-left: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: 0px;\n    text-align: left;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: left;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n  margin-top: ",
        ";\n\n  color: ",
        ";\n\n  > a {\n    color: ",
        ";\n    text-decoration-line: underline;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: ",
        ";\n\n  a:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: left;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}



var Header = (0,styled_components_browser_esm["default"])(text_variants.H1Text).withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var Body = (0,styled_components_browser_esm["default"])(text_variants.BodyLargeText).withConfig({
    displayName: "Body",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var PageNotFoundWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PageNotFoundWrapper",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.pageNotFound.maxWidth */.bK.pageNotFound.maxWidth, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var ErrorMessageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageWrapper",
    componentId: "sc-0-3"
})(_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.smallOnly */.BC.smallOnly(_templateObject3()));
var ErrorMessageMedia = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageMedia",
    componentId: "sc-0-4"
})(_templateObject6(), base/* media.smallOnly */.BC.smallOnly(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var ErrorMessageContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageContent",
    componentId: "sc-0-5"
})(_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject7()));
var ErrorMessageTitle = (0,styled_components_browser_esm["default"])(text_variants.H1Text).withConfig({
    displayName: "ErrorMessageTitle",
    componentId: "sc-0-6"
})(_templateObject10(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject9()));
var ErrorMessageSubtitle = (0,styled_components_browser_esm["default"])(text_variants.BodyLargeText).withConfig({
    displayName: "ErrorMessageSubtitle",
    componentId: "sc-0-7"
})(_templateObject12(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject11()));
var ErrorMessageSupportLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageSupportLabel",
    componentId: "sc-0-8"
})(_templateObject14(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, function(param) {
    var theme = param.theme;
    return theme.text.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.text.secondary;
}, base/* media.smallOnly */.BC.smallOnly(_templateObject13()));
var ButtonGroup = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ButtonGroup",
    componentId: "sc-0-9"
})(_templateObject15(), base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ErrorMessageErrorLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageErrorLabel",
    componentId: "sc-0-10"
})(_templateObject17(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(param) {
    var theme = param.theme;
    return theme.text.secondary;
}, function(p) {
    return p.$centered && base/* media.smallOnly */.BC.smallOnly(_templateObject16());
});
var ErrorMessageHidden = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageHidden",
    componentId: "sc-0-11"
})(_templateObject18());

;// CONCATENATED MODULE: ./src/components/error-message/index.tsx






/*
  When using compose from DataContainer we can only get
  the contexts requested by the DataContainer component.
*/ var ErrorMessage = function(param) {
    var _status = param.status, status = _status === void 0 ? 500 : _status;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), locale = ref.market.locale, t = ref.t, linkTo = ref.linkTo;
    var campaigns = (0,es/* useSelector */.v9)(function(state) {
        return state.globals.campaigns;
    });
    var renderStatusMessage = function() {
        var centered = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (!status) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(ErrorMessageErrorLabel, {
            $centered: centered
        }, t("errors", "error-page.error-code", {
            code: status
        }));
    };
    var makeButton = function(text) {
        var link = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        return /*#__PURE__*/ react.createElement(variants.TonalButton, {
            container: "a",
            containerProps: {
                href: link
            }
        }, text);
    };
    var getDailyDealsLink = function() {
        var ref;
        var dailyDeals = campaigns === null || campaigns === void 0 ? void 0 : campaigns.active.find(function(campaign) {
            return campaign.type === "OFFER";
        });
        var link = dailyDeals === null || dailyDeals === void 0 ? void 0 : (ref = dailyDeals.web_uri) === null || ref === void 0 ? void 0 : ref.responsive;
        return link || "";
    };
    var renderPageNotFoundButtons = function() {
        return /*#__PURE__*/ react.createElement(ButtonGroup, null, makeButton(t("campaigns", "daily-deals.title"), getDailyDealsLink()), locale === "sv" ? makeButton("Guider och topplistor fr\xe5n v\xe5ra experter", "/experter") : null, makeButton(t("landing", "hot-products.title"), linkTo("category", {
            id: "v100"
        })));
    };
    var renderErrorPage = function() {
        if (status === 404 || status === 410) {
            return /*#__PURE__*/ react.createElement(PageNotFoundWrapper, null, /*#__PURE__*/ react.createElement(Header, null, t("errors", "error-page.page-not-found-title")), /*#__PURE__*/ react.createElement(Body, null, t("errors", "error-page.page-not-found-subtitle")), renderPageNotFoundButtons(), /*#__PURE__*/ react.createElement("img", {
                src: "https://cdn.pji.nu/g/rfe/icons/Error_404_cute_logo.png",
                alt: ""
            }), renderStatusMessage());
        }
        return /*#__PURE__*/ react.createElement(ErrorMessageWrapper, null, /*#__PURE__*/ react.createElement(ErrorMessageContent, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(ErrorMessageTitle, null, t("errors", "error-page.title")), /*#__PURE__*/ react.createElement(ErrorMessageSubtitle, null, t("errors", "internal.unknown"), " ", t("errors", "error-page.page-not-found-subtitle")), renderPageNotFoundButtons()), /*#__PURE__*/ react.createElement(ErrorMessageMedia, null, /*#__PURE__*/ react.createElement("img", {
            alt: "Error",
            src: "https://cdn.pji.nu/g/rfe/illustrations/illo-error-500-dog-656x484.png"
        })), status >= 500 && /*#__PURE__*/ react.createElement(ErrorMessageSupportLabel, null, renderStatusMessage(true), /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
            domain: "errors"
        }, "support.text-link.md"))));
    };
    return /*#__PURE__*/ react.createElement("div", {
        "data-test": "ErrorMessage",
        "data-status": status
    }, renderErrorPage());
};
/* harmony default export */ var error_message = (ErrorMessage);


/***/ }),

/***/ 99575:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ ExperimentContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var ExperimentContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    showEditor: false,
    selectedVariants: {},
    viewedExperiments: {},
    experiments: [],
    registerExperiment: function() {
        return null;
    },
    unregisterExperiment: function() {
        return null;
    },
    selectVariant: function() {
        return null;
    },
    setViewedExperiment: function() {
        return null;
    }
});
ExperimentContext.displayName = "ExperimentContext";


/***/ }),

/***/ 96786:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": () => (/* binding */ ExperimentsList)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/experiment/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-gap: 0.5rem;\n  padding: 0.5rem 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  min-width: 250px;\n  align-items: flex-start;\n  background-color: ",
        ";\n  border-radius: 0.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-gap: 0.5rem;\n  grid-auto-flow: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ExperimentsListWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExperimentsListWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var ExperimentsListGrid = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExperimentsListGrid",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.base100;
});
var ExperimentSelectWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExperimentSelectWrapper",
    componentId: "sc-0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/components/experiment/experiment-select.tsx



var ExperimentSelect = function(param) {
    var experiment = param.experiment, selectedVariant = param.selectedVariant, onClick = param.onClick;
    var selected = selectedVariant !== null && selectedVariant !== void 0 ? selectedVariant : "baseline";
    return /*#__PURE__*/ react.createElement(ExperimentSelectWrapper, null, [
        "baseline"
    ].concat(Object.keys(experiment.variants)).map(function(variant) {
        /*#__PURE__*/ return react.createElement(variants.OutlinedButton, {
            key: variant,
            size: variants.ButtonSize.SMALL,
            type: variant === selected ? variants.ButtonType.PRIMARY : variants.ButtonType.OUTLINED,
            onClick: function() {
                return onClick === null || onClick === void 0 ? void 0 : onClick(variant);
            }
        }, variant);
    }));
};

;// CONCATENATED MODULE: ./src/components/experiment/experiments-list.tsx



var fromKebab = function(s) {
    return s.replace(/-/g, " ");
};
var fromCamel = function(s) {
    return s.replace(/([a-z])([A-Z])/g, "$1 $2");
};
var unCase = function(s) {
    return fromCamel(fromKebab(s));
};
var ExperimentsList = function(param) {
    var experiments = param.experiments, selectVariant = param.selectVariant, selectedVariants = param.selectedVariants;
    return /*#__PURE__*/ react.createElement(ExperimentsListWrapper, null, experiments === null || experiments === void 0 ? void 0 : experiments.map(function(experiment) {
        var ref;
        /*#__PURE__*/ return react.createElement(ExperimentsListGrid, {
            key: experiment.id
        }, /*#__PURE__*/ react.createElement("h4", null, unCase(experiment.id)), /*#__PURE__*/ react.createElement(ExperimentSelect, {
            experiment: experiment,
            selectedVariant: selectedVariants === null || selectedVariants === void 0 ? void 0 : (ref = selectedVariants[experiment.id]) === null || ref === void 0 ? void 0 : ref.selectedVariant,
            onClick: function(variant) {
                selectVariant === null || selectVariant === void 0 ? void 0 : selectVariant(experiment, variant);
            }
        }));
    }), !(experiments === null || experiments === void 0 ? void 0 : experiments.length) ? /*#__PURE__*/ react.createElement("div", {
        style: {
            whiteSpace: "nowrap"
        }
    }, "There are no experiments on this page") : null);
};


/***/ }),

/***/ 43088:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": () => (/* reexport */ context/* ExperimentContext */.T),
  "m": () => (/* reexport */ createExperimentHook)
});

// EXTERNAL MODULE: ./src/components/experiment/context.ts
var context = __webpack_require__(99575);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/experiment/hook.ts


var createExperimentHook = function(id, baseline, variants) {
    if (typeof id === "undefined" || typeof baseline === "undefined" || typeof variants === "undefined") {
        throw new Error("createExperimentHook expects 3 arguments: id, baseline, variants");
    }
    return function() {
        var shouldSetAsViewed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var ref = react.useContext(context/* ExperimentContext */.T), selectedVariants = ref.selectedVariants, registerExperiment = ref.registerExperiment, setViewedExperiment = ref.setViewedExperiment, unregisterExperiment = ref.unregisterExperiment;
        var variantName = selectedVariants && selectedVariants[id] && selectedVariants[id].selectedVariant;
        react.useEffect(function() {
            registerExperiment({
                id: id,
                baseline: baseline,
                variants: variants
            });
            return function() {
                return unregisterExperiment(id);
            };
        }, [
            registerExperiment,
            unregisterExperiment
        ]);
        react.useEffect(function() {
            if (shouldSetAsViewed) {
                setViewedExperiment(id, variantName && variantName in variants ? variantName : "baseline");
            }
        }, [
            shouldSetAsViewed,
            setViewedExperiment,
            variantName
        ]);
        return variantName && variantName in variants ? variants[variantName] : baseline;
    };
};

;// CONCATENATED MODULE: ./src/components/experiment/index.ts




/***/ }),

/***/ 4916:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var FetchContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    query: function() {
        return null;
    }
});
FetchContext.displayName = "FetchContext";
/* harmony default export */ __webpack_exports__["Z"] = (FetchContext);


/***/ }),

/***/ 85066:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": () => (/* binding */ Content),
  "M": () => (/* binding */ FilterDropdown)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(33888);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/radiobutton/index.js
var radiobutton = __webpack_require__(94269);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/components/filter-dropdown/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  padding: ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DropdownItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return !p.disabled && "color: ".concat(light_theme_colors.base900);
}, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/sort/index.js
var sort = __webpack_require__(66131);
;// CONCATENATED MODULE: ./src/components/filter-dropdown/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var FilterDropdown = function(param) {
    var alignment = param.alignment, className = param.className, defaultSelected = param.defaultSelected, onFilterChange = param.onFilterChange, options = param.options, width = param.width, _showAsRadioButtons = param.showAsRadioButtons, showAsRadioButtons = _showAsRadioButtons === void 0 ? false : _showAsRadioButtons, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon;
    var ref = _slicedToArray((0,react.useState)(defaultSelected || options[0]), 2), selected = ref[0], setSelected = ref[1];
    (0,react.useEffect)(function() {
        setSelected(defaultSelected);
    }, [
        defaultSelected
    ]);
    var handleOnClick = (0,react.useCallback)(function(option) {
        setSelected(option);
        onFilterChange(option);
    }, [
        onFilterChange
    ]);
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        closeOnItemClick: true,
        className: className,
        containerProps: {
            "data-test": "FilterDropdown"
        }
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        showActiveIcon: true,
        type: ui_button.ButtonType.TEXT,
        containerProps: {
            "data-test": "DropdownToggle"
        }
    }, showIcon && /*#__PURE__*/ react.createElement(sort/* IconSort */.M, null), selected === null || selected === void 0 ? void 0 : selected.title), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: alignment,
        width: width
    }, /*#__PURE__*/ react.createElement(Content, {
        onClick: handleOnClick,
        options: options,
        selected: selected,
        showAsRadioButtons: showAsRadioButtons
    })));
};
var Content = function(props) {
    var onClick = props.onClick, options = props.options, selected = props.selected, showAsRadioButtons = props.showAsRadioButtons;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, options.sort().map(function(option) {
        return /*#__PURE__*/ react.createElement("div", {
            key: option.title
        }, showAsRadioButtons ? /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
            text: option.title,
            selectedValue: (selected === null || selected === void 0 ? void 0 : selected.value) === option.value,
            value: true,
            onClickHandler: function() {
                return onClick(option);
            }
        }) : /*#__PURE__*/ react.createElement(DropdownItem, {
            onClick: function() {
                return onClick(option);
            },
            disabled: Boolean((selected === null || selected === void 0 ? void 0 : selected.title) === option.title),
            "data-test": "DropdownOption"
        }, option.title));
    }));
};


/***/ }),

/***/ 18557:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ OptionTypeEnum)
/* harmony export */ });
var OptionTypeEnum;
(function(OptionTypeEnum) {
    OptionTypeEnum["CHEAPEST_PRICE"] = "CHEAPEST_PRICE";
    OptionTypeEnum["FASTEST_DELIVERY"] = "FASTEST_DELIVERY";
})(OptionTypeEnum || (OptionTypeEnum = {}));


/***/ }),

/***/ 75081:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ HorizontalScroll),
  "C": () => (/* binding */ horizontal_scroll)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(37456);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(61061);
;// CONCATENATED MODULE: ./src/components/horizontal-scroll/constants.ts
var LOAD_MORE_ITEMS_LIMIT = 3;
var TRANSITION_TIME_MAX = 400;
var TRANSITION_TIME_MIN = 100;
var SHADOW_OVERLAY = 20;
var EPSILON = 32;
var MOCK_DIV = {
    scrollLeft: 0,
    clientWidth: 0
};

// EXTERNAL MODULE: ./src/components/horizontal-scroll/styles.ts
var styles = __webpack_require__(41852);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
;// CONCATENATED MODULE: ./src/components/horizontal-scroll/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function useHorizontalScroll(props) {
    var innerContainerRef = (0,react.useRef)();
    var outerContainerRef = (0,react.useRef)();
    var _showArrows;
    var ref = _slicedToArray((0,react.useState)((_showArrows = props.showArrows) !== null && _showArrows !== void 0 ? _showArrows : false), 2), hasStartArrow = ref[0], setHasStartArrow = ref[1];
    var _showArrows1;
    var ref1 = _slicedToArray((0,react.useState)((_showArrows1 = props.showArrows) !== null && _showArrows1 !== void 0 ? _showArrows1 : false), 2), hasEndArrow = ref1[0], setHasEndArrow = ref1[1];
    var getWidths = function() {
        if (!outerContainerRef.current || !innerContainerRef.current) return {
            scrollWidth: 0,
            clientWidth: 0,
            scrollableWidth: 0
        };
        return {
            clientWidth: innerContainerRef.current.clientWidth,
            scrollWidth: innerContainerRef.current.scrollWidth,
            scrollableWidth: Math.max(0, innerContainerRef.current.scrollWidth - innerContainerRef.current.clientWidth)
        };
    };
    var toggleArrows = (0,react.useCallback)(function(scrollLeft) {
        var ref = getWidths(), scrollWidth = ref.scrollWidth, scrollableWidth = ref.scrollableWidth, clientWidth = ref.clientWidth;
        var scrollRight = scrollableWidth - scrollLeft;
        setHasStartArrow(props.showArrows === "always" || scrollWidth > clientWidth && scrollLeft > 0);
        setHasEndArrow(props.showArrows === "always" || scrollWidth > clientWidth && scrollRight > 0);
    }, [
        props.showArrows
    ]);
    var handleScroll = function(e) {
        var ref;
        var ref1;
        toggleArrows((ref1 = (ref = e.target) === null || ref === void 0 ? void 0 : ref.scrollLeft) !== null && ref1 !== void 0 ? ref1 : 0);
    };
    var scrollTo = function(param) {
        var from = param.from, to = param.to;
        if (from === to) return;
        var distanceNormalize = Math.abs(to - from) / TRANSITION_TIME_MIN;
        var duration = Math.max(TRANSITION_TIME_MIN, Math.min(TRANSITION_TIME_MAX, TRANSITION_TIME_MIN * distanceNormalize));
        base/* animationUtils.tween */.ry.tween({
            from: from,
            to: to,
            duration: duration,
            onUpdate: function(value) {
                if (outerContainerRef.current) {
                    outerContainerRef.current.scrollLeft = Math.round(value);
                }
            }
        });
    };
    var togglePage = function(direction) {
        var round = function round(value, rounded) {
            return Math.abs(rounded - value) <= EPSILON ? rounded : value;
        };
        var ref;
        var ref1;
        var scrollLeft = (ref1 = (ref = outerContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollLeft) !== null && ref1 !== void 0 ? ref1 : 0;
        var ref2 = getWidths(), scrollableWidth = ref2.scrollableWidth, clientWidth = ref2.clientWidth;
        // This needs to match margin-left offset on li:not(:first-child)
        // so that it moves a complete "set" of items each click
        var marginOffset = 12;
        scrollTo({
            from: scrollLeft,
            to: direction === "prev" ? Math.max(0, round(scrollLeft - clientWidth - marginOffset, 0)) : Math.min(scrollableWidth, round(scrollLeft + clientWidth + marginOffset, scrollableWidth))
        });
    };
    var childrenCount = react.Children.count(props.children);
    (0,react.useEffect)(function() {
        var ref;
        var ref1;
        toggleArrows((ref1 = (ref = outerContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollLeft) !== null && ref1 !== void 0 ? ref1 : 0);
    }, [
        toggleArrows,
        childrenCount
    ]);
    return {
        innerContainerRef: innerContainerRef,
        outerContainerRef: outerContainerRef,
        handleScroll: handleScroll,
        togglePage: togglePage,
        hasStartArrow: hasStartArrow,
        hasEndArrow: hasEndArrow
    };
}
var HorizontalScroll = function(_param) {
    var itemWidth = _param.itemWidth, _negativeMargin = _param.negativeMargin, negativeMargin = _negativeMargin === void 0 ? true : _negativeMargin, _buttonSize = _param.buttonSize, buttonSize = _buttonSize === void 0 ? ui_button.ButtonSize.NORMAL : _buttonSize, props = _objectWithoutProperties(_param, [
        "itemWidth",
        "negativeMargin",
        "buttonSize"
    ]);
    var ref = useHorizontalScroll(props), innerContainerRef = ref.innerContainerRef, outerContainerRef = ref.outerContainerRef, handleScroll = ref.handleScroll, togglePage = ref.togglePage, hasStartArrow = ref.hasStartArrow, hasEndArrow = ref.hasEndArrow;
    return /*#__PURE__*/ react.createElement(styles/* HorizontalScrollContainer */.Oc, {
        "data-test": "HorizontalScroll",
        className: props.className,
        $mobileNegativeMargin: negativeMargin
    }, /*#__PURE__*/ react.createElement(styles/* Inner */.Nh, {
        ref: function(div) {
            outerContainerRef.current = div;
        },
        onScroll: handleScroll
    }, props.showArrows !== false && /*#__PURE__*/ react.createElement(react.Fragment, null, hasStartArrow && /*#__PURE__*/ react.createElement(styles/* LeftArrow */.IT, {
        onClick: function() {
            return togglePage("prev");
        },
        size: buttonSize
    }, /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null)), hasEndArrow && /*#__PURE__*/ react.createElement(styles/* RightArrow */.UV, {
        onClick: function() {
            return togglePage("next");
        },
        size: buttonSize
    }, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null))), /*#__PURE__*/ react.createElement(styles/* List */.aV, {
        ref: function(div) {
            innerContainerRef.current = div;
        }
    }, react.Children.map(props.children, function(child, i) {
        return /*#__PURE__*/ react.createElement("li", {
            // eslint-disable-next-line react/no-array-index-key
            key: i,
            style: {
                flex: itemWidth ? "0 0 ".concat(itemWidth, "px") : undefined
            }
        }, child);
    }), props.loading && /*#__PURE__*/ react.createElement(styles/* Loader */.aN, {
        style: {
            lineHeight: "".concat(props.loadingHeight, "px")
        }
    }, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        position: "none",
        isActive: true
    })))));
};
/* harmony default export */ var horizontal_scroll = (HorizontalScroll);


/***/ }),

/***/ 41852:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IT": () => (/* binding */ LeftArrow),
/* harmony export */   "Nh": () => (/* binding */ Inner),
/* harmony export */   "Oc": () => (/* binding */ HorizontalScrollContainer),
/* harmony export */   "UV": () => (/* binding */ RightArrow),
/* harmony export */   "aN": () => (/* binding */ Loader),
/* harmony export */   "aV": () => (/* binding */ List)
/* harmony export */ });
/* unused harmony exports ArrowIconRight, ArrowIconLeft */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37456);
/* harmony import */ var _prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93345);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25670);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43220);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    width: calc(100% + ",
        ");\n    margin-right: -",
        ";\n    margin-left: -",
        ";\n\n    li:first-child {\n      padding-left: ",
        ";\n    }\n\n    li:last-child {\n      padding-right: ",
        ";\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    height: 100%;\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n\n    ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  &:hover {\n    background: ",
        ";\n  }\n  z-index: 3;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  opacity: 0;\n  transition: all 250ms ease;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  left: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  right: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  -ms-overflow-style: none;\n  -webkit-overflow-scrolling: touch;\n  overflow: -moz-scrollbars-none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  user-select: none;\n  overflow-x: scroll;\n\n  &:hover {\n    > button {\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  margin: 0;\n  display: flex;\n  gap: ",
        ";\n\n  > li {\n    padding: 1px;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  float: left;\n  width: 100px;\n  text-align: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}






var ArrowIconRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__.IconChevronRight).attrs(function() {
    return {
        color: "base300"
    };
}).withConfig({
    displayName: "ArrowIconRight",
    componentId: "sc-0-0"
})(_templateObject());
var ArrowIconLeft = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__.IconChevronLeft).attrs(function() {
    return {
        color: "base300"
    };
}).withConfig({
    displayName: "ArrowIconLeft",
    componentId: "sc-0-1"
})(_templateObject1());
var HorizontalScrollContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "HorizontalScrollContainer",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3(), props.$mobileNegativeMargin && src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.mediumDown */ .BC.mediumDown(_templateObject2(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing100, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050));
});
var arrow = function(theme) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), theme.colors.base0, theme.colors.base100, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.smallOnly */ .BC.smallOnly(_templateObject4()));
};
var arrowButtonAttrs = {
    elevation: _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonElevation.HIGH,
    type: _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonType.OUTLINED
};
var LeftArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.IconButton).attrs(arrowButtonAttrs).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-3"
})(_templateObject6(), function(p) {
    return arrow(p.theme);
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing075 */ .bK.measurements.spacing075);
var RightArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.IconButton).attrs(arrowButtonAttrs).withConfig({
    displayName: "RightArrow",
    componentId: "sc-0-4"
})(_templateObject7(), function(p) {
    return arrow(p.theme);
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing075 */ .bK.measurements.spacing075);
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Inner",
    componentId: "sc-0-5"
})(_templateObject8());
var List = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({
    displayName: "List",
    componentId: "sc-0-6"
})(_templateObject9(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing075 */ .bK.measurements.spacing075, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({
    displayName: "Loader",
    componentId: "sc-0-7"
})(_templateObject10());


/***/ }),

/***/ 61890:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ CARD_WIDTH_DESKTOP),
/* harmony export */   "_": () => (/* binding */ MediumCardHorizontalScroll)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94141);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75081);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  li > * {\n    ",
        "\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var CARD_WIDTH_DESKTOP = "235px";
var CARD_WIDTH_MOBILE = "215px";
/**
 * Styled variant of HorizontalScroll that fits:
 * 1) four product cards (ProductGridCard) on each "page" of the component.
 * 2) Four article previews
 */ var MediumCardHorizontalScroll = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(___WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .C).withConfig({
    displayName: "MediumCardHorizontalScroll",
    componentId: "sc-0-0"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .media.smallUp */ .BC.smallUp(_templateObject(), CARD_WIDTH_MOBILE), src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .media.mediumUp */ .BC.mediumUp(_templateObject1(), CARD_WIDTH_DESKTOP));


/***/ }),

/***/ 29089:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": () => (/* binding */ InfoList)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/info-list/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n    margin: 0;\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  &:not(:last-child)::after {\n    content: '•';\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var List = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "List",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject(), props.theme.text.secondary);
});
var Content = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Content",
    componentId: "sc-0-1"
})(_templateObject1());
var Item = styled_components_browser_esm["default"].li.withConfig({
    displayName: "Item",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/info-list/index.tsx
/* eslint-disable react/no-array-index-key */ 

var isStringArray = function(test) {
    return Array.isArray(test) && test.every(function(value) {
        return typeof value === "string";
    });
};
var InfoList = function(param) {
    var className = param.className, list = param.list;
    if (!(list === null || list === void 0 ? void 0 : list.length)) return null;
    return /*#__PURE__*/ react.createElement(List, {
        className: className
    }, list && isStringArray(list) && list.map(function(item, index) {
        return item && /*#__PURE__*/ react.createElement(Item, {
            key: index
        }, /*#__PURE__*/ react.createElement(Content, null, item));
    }), list && !isStringArray(list) && list.map(function(item, index) {
        return item && /*#__PURE__*/ react.createElement(Item, {
            key: index
        }, item);
    }));
};


/***/ }),

/***/ 32741:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XZ": () => (/* reexport */ components_checkbox),
  "Y2": () => (/* reexport */ number_input),
  "Y8": () => (/* reexport */ components_radio),
  "ol": () => (/* reexport */ search),
  "Kx": () => (/* reexport */ text_area),
  "oi": () => (/* reexport */ text_input)
});

// UNUSED EXPORTS: CheckboxInput

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(13686);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/inputs/components/checkbox/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  user-select: none;\n  font-weight: normal;\n  opacity: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  appearance: none;\n  outline: 0;\n  opacity: 0;\n  position: absolute;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      border-color: ",
        ";\n      outline: 1px solid ",
        ";\n\n      svg {\n        background-color: ",
        ";\n      }\n\n      ",
        ":focus + & {\n        background-color: ",
        ";\n        border-color: ",
        ";\n        outline: 2px solid ",
        ";\n        svg {\n          background-color: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      svg {\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    border: 1px solid ",
        ";\n\n    ",
        " {\n      &:focus + & {\n        border-color: ",
        ";\n        outline: 1px solid ",
        ";\n      }\n    }\n\n    svg {\n      position: relative;\n      left: 1px;\n      top: 1px;\n      stroke-width: 6px;\n      path {\n        stroke: ",
        ";\n        fill: none;\n      }\n    }\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      font-weight: 600;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  display: flex;\n  flex-direction: column;\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        &:hover {\n          color: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: no-drop;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var Checkbox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Checkbox",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.disabled ? "0.5" : "1";
});
var Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(_templateObject1());
var CheckIconWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CheckIconWrapper",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.theme.lines.secondary, Input, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.base0, (props.checked || props.partial) && (0,styled_components_browser_esm.css)(_templateObject2(), props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, Input, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700), (props.checked || props.partial) && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.lines.highlight));
});
var LabelText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LabelText",
    componentId: "sc-0-3"
})(_templateObject6(), base/* layout.listSideMargin */.bK.listSideMargin, function(props) {
    return props.theme.colors.base600;
}, function(props) {
    return props.labelStyle === "bold" && (0,styled_components_browser_esm.css)(_templateObject5(), function(p) {
        return p.theme.text.callToAction;
    });
});
var Label = styled_components_browser_esm["default"].label.withConfig({
    displayName: "Label",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject9(), !props.disabled && (0,styled_components_browser_esm.css)(_templateObject7(), LabelText, props.theme.text.callToActionHover), props.disabled && (0,styled_components_browser_esm.css)(_templateObject8()));
});
var Helper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Helper",
    componentId: "sc-0-5"
})(_templateObject10(), (0,base/* remCalc */.vR)(12), function(props) {
    return props.warning ? props.theme.colors.negative700 : props.theme.colors.base500;
});

;// CONCATENATED MODULE: ./src/components/inputs/components/checkbox/index.tsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var CheckboxInput = function(param) {
    var name = param.name, onChange = param.onChange, checked = param.checked, partial = param.partial, tabIndex = param.tabIndex, disabled = param.disabled, required = param.required;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Input, {
        required: required,
        id: name,
        name: name,
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        disabled: disabled,
        tabIndex: tabIndex,
        value: checked ? "1" : "0"
    }), /*#__PURE__*/ react.createElement(CheckIconWrapper, {
        checked: checked,
        partial: partial
    }, /*#__PURE__*/ react.createElement(icons/* CheckIcon */.nQ, {
        checked: checked,
        partial: partial,
        height: 14
    })));
};
CheckboxInput.defaultProps = {
    name: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: function() {},
    checked: false,
    partial: false,
    tabIndex: "0",
    disabled: false,
    required: false
};
var checkbox_Checkbox = function(_param) {
    var name = _param.name, checked = _param.checked, partial = _param.partial, helper = _param.helper, warning = _param.warning, label = _param.label, _labelStyle = _param.labelStyle, labelStyle = _labelStyle === void 0 ? "normal" : _labelStyle, onChange = _param.onChange, className = _param.className, tabIndex = _param.tabIndex, disabled = _param.disabled, children = _param.children, required = _param.required, props = _objectWithoutProperties(_param, [
        "name",
        "checked",
        "partial",
        "helper",
        "warning",
        "label",
        "labelStyle",
        "onChange",
        "className",
        "tabIndex",
        "disabled",
        "children",
        "required"
    ]);
    var labelText = children || label;
    return /*#__PURE__*/ react.createElement(Checkbox, {
        className: className,
        disabled: disabled,
        "data-test": props["data-test"]
    }, /*#__PURE__*/ react.createElement(Label, {
        htmlFor: name,
        disabled: disabled
    }, /*#__PURE__*/ react.createElement(CheckboxInput, {
        name: name,
        onChange: onChange,
        checked: checked,
        partial: partial,
        tabIndex: tabIndex,
        disabled: disabled,
        required: required
    }), /*#__PURE__*/ react.createElement(LabelText, {
        labelStyle: labelStyle
    }, /*#__PURE__*/ react.createElement("span", null, labelText), helper && /*#__PURE__*/ react.createElement(Helper, {
        warning: warning
    }, helper))));
};
checkbox_Checkbox.defaultProps = {
    label: null,
    labelStyle: "normal",
    checked: false,
    partial: false,
    helper: null,
    warning: false,
    className: null,
    tabIndex: "0",
    disabled: false,
    children: null,
    required: false,
    "data-test": undefined
};
/* harmony default export */ var components_checkbox = (checkbox_Checkbox);

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var es = __webpack_require__(55703);
;// CONCATENATED MODULE: ./src/components/inputs/components/input/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-radius: 4px;\n    "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  background: ",
        ";\n  padding: ",
        ";\n  border: 1px solid ",
        ";\n  outline: 0;\n  ",
        "\n\n  ",
        "\n\n  &:focus {\n    border-color: ",
        ";\n    box-shadow: inset 0 0 0 1px ",
        ";\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n      background: ",
        ";\n      border: 1px solid ",
        ";\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        ";\n  resize: vertical;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  user-select: none;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n      color: ",
        ";\n    "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  margin-left: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}



var sharedInputStyle = (0,styled_components_browser_esm.css)(styles_templateObject2(), function(p) {
    return p.theme.inputs.primary.bg;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.inputs.primary.border;
}, function(props) {
    return props.warning && (0,styled_components_browser_esm.css)(styles_templateObject(), function(p) {
        return p.theme.text.negative;
    });
}, (0,es/* switchProp */.db)("variant", {
    rounded: (0,styled_components_browser_esm.css)(styles_templateObject1())
}), function(p) {
    return p.theme.inputs.primary.borderFocus;
}, function(p) {
    return p.theme.inputs.primary.borderFocus;
});
var InputWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InputWrapper",
    componentId: "sc-0-0"
})(styles_templateObject3());
var styles_Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(styles_templateObject5(), sharedInputStyle, function(p) {
    return p.disabled && (0,styled_components_browser_esm.css)(styles_templateObject4(), p.theme.inputs.secondary.bg, p.theme.inputs.secondary.border);
});
var TextArea = styled_components_browser_esm["default"].textarea.withConfig({
    displayName: "TextArea",
    componentId: "sc-0-2"
})(styles_templateObject6(), sharedInputStyle);
var styles_Label = styled_components_browser_esm["default"].label.withConfig({
    displayName: "Label",
    componentId: "sc-0-3"
})(styles_templateObject7());
var styles_LabelText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LabelText",
    componentId: "sc-0-4"
})(styles_templateObject8());
var styles_Helper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Helper",
    componentId: "sc-0-5"
})(styles_templateObject10(), function(props) {
    return props.warning && (0,styled_components_browser_esm.css)(styles_templateObject9(), function(p) {
        return p.theme.text.negative;
    });
});
var HelperWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HelperWrapper",
    componentId: "sc-0-6"
})(_templateObject11(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, function(p) {
    return p.theme.text.tertiary;
});
var CharCounter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CharCounter",
    componentId: "sc-0-7"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/inputs/components/input/text-input.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function text_input_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = text_input_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function text_input_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var TextInput = function(_param) {
    var name = _param.name, _onChange = _param.onChange, onChange = _onChange === void 0 ? base/* noop */.ZT : _onChange, _onKeyUp = _param.onKeyUp, onKeyUp = _onKeyUp === void 0 ? base/* noop */.ZT : _onKeyUp, label = _param.label, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, defaultValue = _param.defaultValue, value = _param.value, _type = _param.type, type = _type === void 0 ? "text" : _type, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? undefined : _placeholder, _tabIndex = _param.tabIndex, tabIndex = _tabIndex === void 0 ? 0 : _tabIndex, _helper = _param.helper, helper = _helper === void 0 ? null : _helper, _warning = _param.warning, warning = _warning === void 0 ? false : _warning, _className = _param.className, className = _className === void 0 ? undefined : _className, _children = _param.children, children = _children === void 0 ? null : _children, inputRef = _param.inputRef, _required = _param.required, required = _required === void 0 ? false : _required, minLength = _param.minLength, maxLength = _param.maxLength, _customInputProps = _param.customInputProps, customInputProps = _customInputProps === void 0 ? {} : _customInputProps, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, autoFocus = _param.autoFocus, autoComplete = _param.autoComplete, ariaLabel = _param.ariaLabel, onInvalid = _param.onInvalid, cancelButton = _param.cancelButton, onClick = _param.onClick, showCounter = _param.showCounter, otherProps = text_input_objectWithoutProperties(_param, [
        "name",
        "onChange",
        "onKeyUp",
        "label",
        "disabled",
        "defaultValue",
        "value",
        "type",
        "placeholder",
        "tabIndex",
        "helper",
        "warning",
        "className",
        "children",
        "inputRef",
        "required",
        "minLength",
        "maxLength",
        "customInputProps",
        "variant",
        "autoFocus",
        "autoComplete",
        "ariaLabel",
        "onInvalid",
        "cancelButton",
        "onClick",
        "showCounter"
    ]);
    var ref = _slicedToArray((0,react.useState)((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) || (value === null || value === void 0 ? void 0 : value.length) || 0), 2), characterCount = ref[0], setCharacterCount = ref[1];
    var handleOnChange = function(event) {
        setCharacterCount(event.target.value.length);
        onChange(event);
    };
    return /*#__PURE__*/ react.createElement(InputWrapper, {
        className: className
    }, /*#__PURE__*/ react.createElement(styles_Label, {
        htmlFor: name
    }, /*#__PURE__*/ react.createElement(styles_LabelText, null, label), cancelButton, children), /*#__PURE__*/ react.createElement(styles_Input, _extends({
        autoFocus: autoFocus,
        warning: warning,
        required: required,
        name: name,
        id: name,
        type: type,
        defaultValue: defaultValue,
        value: value,
        placeholder: placeholder,
        tabIndex: tabIndex,
        disabled: disabled,
        onChange: handleOnChange,
        onKeyUp: onKeyUp,
        ref: inputRef,
        minLength: minLength,
        maxLength: maxLength,
        variant: variant,
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        onInvalid: onInvalid,
        onClick: onClick
    }, customInputProps, otherProps)), helper && /*#__PURE__*/ react.createElement(HelperWrapper, null, /*#__PURE__*/ react.createElement(styles_Helper, {
        warning: warning
    }, helper), showCounter && maxLength && /*#__PURE__*/ react.createElement(CharCounter, null, "".concat(characterCount, " / ").concat(maxLength))));
};
/* harmony default export */ var text_input = (TextInput);

;// CONCATENATED MODULE: ./src/components/inputs/components/input/text-area.tsx


var text_area_TextArea = function(param) {
    var name = param.name, onChange = param.onChange, label = param.label, disabled = param.disabled, defaultValue = param.defaultValue, placeholder = param.placeholder, tabIndex = param.tabIndex, helper = param.helper, warning = param.warning, className = param.className, children = param.children, rows = param.rows, inputRef = param.inputRef, required = param.required, minLength = param.minLength, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, onInvalid = param.onInvalid;
    return /*#__PURE__*/ react.createElement(InputWrapper, {
        className: className
    }, /*#__PURE__*/ react.createElement(styles_Label, {
        htmlFor: name
    }, /*#__PURE__*/ react.createElement(styles_LabelText, null, label), children), /*#__PURE__*/ react.createElement(TextArea, {
        warning: warning,
        required: required,
        ref: inputRef,
        name: name,
        id: name,
        rows: rows,
        placeholder: placeholder,
        tabIndex: tabIndex,
        disabled: disabled,
        onChange: onChange,
        defaultValue: defaultValue,
        minLength: minLength,
        onInvalid: onInvalid,
        variant: variant
    }), /*#__PURE__*/ react.createElement(styles_Helper, {
        warning: warning
    }, helper));
};
text_area_TextArea.defaultProps = {
    label: null,
    defaultValue: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: function() {},
    disabled: false,
    placeholder: null,
    tabIndex: "0",
    helper: null,
    warning: false,
    className: null,
    children: null,
    rows: 4,
    inputRef: undefined,
    required: false,
    minlength: 0
};
/* harmony default export */ var text_area = (text_area_TextArea);

;// CONCATENATED MODULE: ./src/components/inputs/components/input/number-input.tsx
function number_input_extends() {
    number_input_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return number_input_extends.apply(this, arguments);
}


var NumberInput = function(props) {
    return /*#__PURE__*/ react.createElement(text_input, number_input_extends({
        type: "number"
    }, props));
};
/* harmony default export */ var number_input = (NumberInput);

;// CONCATENATED MODULE: ./src/components/inputs/components/radio/styles.ts
function radio_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function radio_styles_templateObject() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  user-select: none;\n  font-weight: normal;\n  opacity: ",
        ";\n"
    ]);
    radio_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function radio_styles_templateObject1() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n"
    ]);
    radio_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function radio_styles_templateObject2() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  &:focus {\n    border-color: ",
        ";\n  }\n"
    ]);
    radio_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function radio_styles_templateObject3() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  color: ",
        ";\n  padding-left: ",
        ";\n"
    ]);
    radio_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function radio_styles_templateObject4() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  width: 100%;\n  color: ",
        ";\n"
    ]);
    radio_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Radio = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Radio",
    componentId: "sc-0-0"
})(radio_styles_templateObject(), function(props) {
    return props.disabled ? "0.5" : "1";
});
var radio_styles_Label = styled_components_browser_esm["default"].label.withConfig({
    displayName: "Label",
    componentId: "sc-0-1"
})(radio_styles_templateObject1());
var radio_styles_Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-2"
})(radio_styles_templateObject2(), function(p) {
    return p.theme.colors.base700;
});
var radio_styles_LabelText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LabelText",
    componentId: "sc-0-3"
})(radio_styles_templateObject3(), function(p) {
    return p.theme.colors.base700;
}, (0,base/* remCalc */.vR)(6));
var radio_styles_Helper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Helper",
    componentId: "sc-0-4"
})(radio_styles_templateObject4(), (0,base/* remCalc */.vR)(12), function(p) {
    return p.warning ? p.theme.colors.negative700 : p.theme.colors.base500;
});

;// CONCATENATED MODULE: ./src/components/inputs/components/radio/index.tsx


var radio_Radio = function(param) {
    var name = param.name, id = param.id, helper = param.helper, warning = param.warning, label = param.label, onChange = param.onChange, className = param.className, tabIndex = param.tabIndex, disabled = param.disabled, children = param.children, value = param.value, required = param.required, defaultChecked = param.defaultChecked, checked = param.checked;
    var labelText = children || label;
    return /*#__PURE__*/ react.createElement(Radio, {
        className: className,
        disabled: disabled
    }, /*#__PURE__*/ react.createElement(radio_styles_Label, {
        htmlFor: id
    }, /*#__PURE__*/ react.createElement(radio_styles_Input, {
        checked: checked,
        defaultChecked: defaultChecked,
        required: required,
        id: id,
        name: name,
        type: "radio",
        onChange: onChange,
        disabled: disabled,
        tabIndex: tabIndex,
        value: value
    }), /*#__PURE__*/ react.createElement(radio_styles_LabelText, null, /*#__PURE__*/ react.createElement("span", null, labelText), helper && /*#__PURE__*/ react.createElement(radio_styles_Helper, {
        warning: warning
    }, helper))));
};
radio_Radio.defaultProps = {
    label: null,
    helper: null,
    warning: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: function() {},
    className: null,
    tabIndex: "0",
    disabled: false,
    children: null,
    value: "",
    required: false
};
/* harmony default export */ var components_radio = (radio_Radio);

// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(61061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close-outlined/index.js
var close_outlined = __webpack_require__(40023);
;// CONCATENATED MODULE: ./src/components/inputs/components/search/styles.ts
function search_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function search_styles_templateObject() {
    var data = search_styles_taggedTemplateLiteral([
        "\n    height: ",
        "px;\n  "
    ]);
    search_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_styles_templateObject1() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  overflow: hidden;\n  position: relative;\n  border-radius: ",
        ";\n  background: white;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    search_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_styles_templateObject2() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  background: transparent;\n  border: none;\n  width: 100%;\n  height: 100%;\n  flex-grow: 1;\n  padding: 0.5rem 10px;\n  border-radius: 5px;\n\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    search_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function search_styles_templateObject3() {
    var data = search_styles_taggedTemplateLiteral([
        "\n    height: ",
        ";\n    padding: 0 10px;\n  "
    ]);
    search_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function search_styles_templateObject4() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  height: ",
        "px;\n  margin: -0.2rem;\n  padding: 0 20px;\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n  background: ",
        ";\n  border-left: 1px solid ",
        ";\n\n  ",
        "\n\n  svg path {\n    fill: ",
        ";\n  }\n"
    ]);
    search_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function search_styles_templateObject5() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  font-size: 19px;\n  padding: 0.6rem;\n  visibility: hidden;\n  outline: none;\n\n  ",
        "\n"
    ]);
    search_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function search_styles_templateObject6() {
    var data = search_styles_taggedTemplateLiteral([
        ""
    ]);
    search_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var searchHeightMobile = base/* layout.searchBar.height.mobile.value */.bK.searchBar.height.mobile.value;
var searchHeight = base/* layout.searchBar.height.desktop.value */.bK.searchBar.height.desktop.value;
var Block = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Block",
    componentId: "sc-0-0"
})(search_styles_templateObject1(), searchHeight, base/* layout.borderRadius */.bK.borderRadius, function(p) {
    return p.hasResults ? "border-radius: ".concat(base/* layout.borderRadius */.bK.borderRadius, " ").concat(base/* layout.borderRadius */.bK.borderRadius, " 0px 0px;") : "";
}, base/* media.smallOnly */.BC.smallOnly(search_styles_templateObject(), searchHeightMobile));
var search_styles_Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(search_styles_templateObject2());
var FullSearchButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "FullSearchButton",
    componentId: "sc-0-2"
})(search_styles_templateObject4(), searchHeight - 10, base/* layout.borderRadius */.bK.borderRadius, base/* layout.borderRadius */.bK.borderRadius, function(p) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.bg.secondary, 0);
}, function(p) {
    return p.theme.colors.base200;
}, base/* media.smallOnly */.BC.smallOnly(search_styles_templateObject3(), searchHeightMobile - 10), base/* colorUtils.shadeColor */.$n.shadeColor(base/* brandColors.pricespy */.D2.pricespy, 15));
var ClearButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ClearButton",
    componentId: "sc-0-3"
})(search_styles_templateObject5(), function(p) {
    return p.visible ? "visibility: visible;" : "";
});
var CloseIcon = (0,styled_components_browser_esm["default"])(close_outlined/* IconCloseOutlined */.H).attrs({
    color: "base400"
}).withConfig({
    displayName: "CloseIcon",
    componentId: "sc-0-4"
})(search_styles_templateObject6());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(83830);
;// CONCATENATED MODULE: ./src/components/inputs/components/search/index.tsx




var Search = function(param) {
    var className = param.className, inputValue = param.inputValue, onChange = param.onChange, onFocus = param.onFocus, onBlur = param.onBlur, onSearch = param.onSearch, hasResults = param.hasResults, placeholder = param.placeholder, setInputValue = param.setInputValue, isSearching = param.isSearching;
    var clearInput = react.useCallback(function() {
        onChange("");
        setInputValue("");
    }, [
        onChange,
        setInputValue
    ]);
    var onSearchButtonClick = react.useCallback(function() {
        onSearch(inputValue);
    }, [
        onSearch,
        inputValue
    ]);
    var onInputChange = react.useCallback(function(param) {
        var target = param.target;
        onChange(target.value);
        setInputValue(target.value);
    }, [
        onChange,
        setInputValue
    ]);
    var handleFocus = react.useCallback(function(e) {
        onFocus(e.target.value);
    }, [
        onFocus
    ]);
    return /*#__PURE__*/ react.createElement(Block, {
        hasResults: hasResults,
        className: className
    }, /*#__PURE__*/ react.createElement(search_styles_Input, {
        onChange: onInputChange,
        type: "text",
        value: inputValue,
        placeholder: placeholder,
        onFocus: handleFocus,
        onBlur: onBlur
    }), /*#__PURE__*/ react.createElement(ClearButton, {
        type: "button",
        visible: inputValue,
        onClick: clearInput
    }, /*#__PURE__*/ react.createElement(CloseIcon, {
        size: 20
    })), /*#__PURE__*/ react.createElement(FullSearchButton, {
        type: "button",
        onClick: onSearchButtonClick
    }, isSearching ? /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: isSearching,
        position: "none"
    }) : /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, null)));
};
Search.defaultProps = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onFocus: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSearch: function() {},
    hasResults: false,
    placeholder: undefined
};
/* harmony default export */ var search = (Search);

;// CONCATENATED MODULE: ./src/components/inputs/index.ts









/***/ }),

/***/ 21068:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ LayoutMode)
/* harmony export */ });
var LayoutMode;
(function(LayoutMode) {
    LayoutMode["GRID"] = "grid";
    LayoutMode["LIST"] = "list";
    LayoutMode["COMPACT_LIST"] = "compact_list";
    LayoutMode["TABLE"] = "table";
})(LayoutMode || (LayoutMode = {}));


/***/ }),

/***/ 85518:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ Lazy)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18905);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


function usePrevious(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}
var Lazy = function(param) {
    var _className = param.className, className = _className === void 0 ? undefined : _className, _children = param.children, children = _children === void 0 ? null : _children, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? null : _placeholder, _offset = param.offset, offset = _offset === void 0 ? 100 : _offset, _loadOnIdle = param.loadOnIdle, loadOnIdle = _loadOnIdle === void 0 ? false : _loadOnIdle;
    var scheduleLoadOnIdle = function scheduleLoadOnIdle() {
        if (window && window.requestIdleCallback) {
            var idleHandler = window.requestIdleCallback(load);
            setAbortIdle(function() {
                window.cancelIdleCallback(idleHandler);
                setAbortIdle(null);
            });
        } else {
            var timeoutHandler = setTimeout(load, 100);
            setAbortIdle(function() {
                clearTimeout(timeoutHandler);
                setAbortIdle(null);
            });
        }
    };
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return "production" === "test";
    }), 2), shouldLoad = ref[0], setShouldLoad = ref[1];
    // eslint-disable-next-line @typescript-eslint/ban-types
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), abortIdle = ref1[0], setAbortIdle = ref1[1];
    var previousLoadOnIdle = usePrevious(loadOnIdle);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (loadOnIdle && shouldLoad) {
            scheduleLoadOnIdle();
        }
        return function() {
            if (abortIdle) {
                abortIdle();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!previousLoadOnIdle && loadOnIdle && !shouldLoad) {
            scheduleLoadOnIdle();
        }
    });
    var load = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setShouldLoad(true);
        if (abortIdle) {
            abortIdle();
        }
    }, [
        abortIdle
    ]);
    var onChangeHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(inView, entry) {
        if (!shouldLoad && isInView(inView, entry)) {
            load();
        }
    }, [
        load,
        shouldLoad
    ]);
    if (shouldLoad) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intersection_observer__WEBPACK_IMPORTED_MODULE_1__/* .InView */ .df, {
        rootMargin: "".concat(offset, "px"),
        onChange: onChangeHandler
    }, function(param) {
        var ref = param.ref, inView = param.inView;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            ref: ref,
            className: className
        }, typeof placeholder === "function" ? placeholder({
            inView: inView
        }) : placeholder);
    });
};
function isInView(inView, entry) {
    return inView || entry && entry.intersectionRatio > 0;
}


/***/ }),

/***/ 62619:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ loader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(61061);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/loader/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        0% { opacity: 0; }\n        50% { opacity: 0 }\n        100%   { opacity: 1; }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      opacity: 0;\n      animation: ",
        " 0.8s;\n      animation-fill-mode: forwards;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 70vh;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoaderRoot = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LoaderRoot",
    componentId: "sc-0-0"
})(_templateObject2(), function(props) {
    return props.fadeIn && (0,styled_components_browser_esm.css)(_templateObject1(), (0,styled_components_browser_esm.keyframes)(_templateObject()));
});

;// CONCATENATED MODULE: ./src/components/loader/index.tsx



var Loader = function(param) {
    var _fadeIn = param.fadeIn, fadeIn = _fadeIn === void 0 ? true : _fadeIn, dataTestId = param.dataTestId;
    return /*#__PURE__*/ react.createElement(LoaderRoot, {
        fadeIn: fadeIn,
        "data-testid": dataTestId
    }, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        size: 48,
        isActive: true
    }));
};
/* harmony default export */ var loader = (Loader);


/***/ }),

/***/ 7351:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ location_and_currency_info)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/show-more/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    text-decoration: none;\n\n    &:hover {\n      color: ",
        ";\n      cursor: pointer;\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        display: none;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        max-height: ",
        "px;\n        white-space: pre-line;\n        overflow: hidden;\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Button = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.text.callToAction, props.theme.text.callToActionHover, props.size === "small" && (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall));
});
var TextLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextLabel",
    componentId: "sc-0-1"
})(_templateObject2());
var Text = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Text",
    componentId: "sc-0-2"
})(_templateObject3());
var ShowMore = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShowMore",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), props.expanded && props.hideOnExpand && (0,styled_components_browser_esm.css)(_templateObject4(), Button), !props.expanded && (0,styled_components_browser_esm.css)(_templateObject5(), TextLabel, props.maxHeight));
});

;// CONCATENATED MODULE: ./src/components/show-more/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var show_more_ShowMore = function(param) {
    var children = param.children, className = param.className, _hideOnExpand = param.hideOnExpand, hideOnExpand = _hideOnExpand === void 0 ? false : _hideOnExpand, maxHeight = param.maxHeight, _size = param.size, size = _size === void 0 ? "normal" : _size, textIdentifier = param.textIdentifier;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = _slicedToArray((0,react.useState)(false), 2), expanded = ref[0], setExpanded = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), showMore = ref1[0], setShowMore = ref1[1];
    var collapseOrExpand = expanded ? "symbol.collapse" : "symbol.expand";
    var expansionText = expanded ? t("common", "button.show-less") : t("common", "button.show-more");
    var textNode = (0,react.useCallback)(function(node) {
        if (node && node.parentElement) {
            var textHeight = node.getBoundingClientRect().height;
            var wrapperHeight = node.parentElement.getBoundingClientRect().height;
            setShowMore(textHeight > wrapperHeight);
        }
    }, []);
    var toggleExpansion = (0,react.useCallback)(function() {
        setExpanded(!expanded);
    }, [
        expanded
    ]);
    return /*#__PURE__*/ react.createElement(ShowMore, {
        className: className,
        expanded: expanded,
        hideOnExpand: hideOnExpand,
        maxHeight: maxHeight
    }, /*#__PURE__*/ react.createElement(TextLabel, null, /*#__PURE__*/ react.createElement(Text, {
        ref: textNode
    }, children)), showMore && /*#__PURE__*/ react.createElement(Button, {
        onClick: toggleExpansion,
        "aria-label": t("symbols", collapseOrExpand),
        "aria-expanded": expanded,
        "aria-controls": textIdentifier,
        size: size
    }, expansionText));
};
/* harmony default export */ var show_more = (/*#__PURE__*/(0,react.memo)(show_more_ShowMore));

// EXTERNAL MODULE: ./src/components/country-flag/index.ts + 2 modules
var country_flag = __webpack_require__(37364);
;// CONCATENATED MODULE: ./src/components/location-and-currency-info/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n      color: ",
        ";\n    "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n    margin: 0;\n\n    ",
        "\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: block;\n  margin-right: ",
        ";\n\n  img {\n    height: auto;\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var LocationAndCurrencyInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LocationAndCurrencyInfo",
    componentId: "sc-0-0"
})(styles_templateObject());
var styles_Text = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject2(), props.theme.text.secondary, props.textSize === "small" && (0,styled_components_browser_esm.css)(styles_templateObject1(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, props.theme.text.tertiary));
});
var CountryFlag = (0,styled_components_browser_esm["default"])(country_flag/* CountryFlag */.A).withConfig({
    displayName: "CountryFlag",
    componentId: "sc-0-2"
})(styles_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/location-and-currency-info/index.tsx




var location_and_currency_info_LocationAndCurrencyInfo = function(param) {
    var className = param.className, countryCode = param.countryCode, countryName = param.countryName, currency = param.currency, id = param.id, marketplace = param.marketplace, _minify = param.minify, minify = _minify === void 0 ? false : _minify, storeName = param.storeName, _textSize = param.textSize, textSize = _textSize === void 0 ? "normal" : _textSize;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var shouldMinify = minify && marketplace;
    var textIdentifier = "text-id-".concat(id);
    var renderLocationAndCurrencyInfo = function(locationAndCurrencyInfo) {
        return /*#__PURE__*/ react.createElement(LocationAndCurrencyInfo, {
            className: className
        }, /*#__PURE__*/ react.createElement(CountryFlag, {
            countryCode: countryCode,
            showTitleAsTooltip: false
        }), shouldMinify ? /*#__PURE__*/ react.createElement(show_more, {
            textIdentifier: textIdentifier,
            hideOnExpand: true,
            maxHeight: 32,
            size: "small"
        }, /*#__PURE__*/ react.createElement(styles_Text, {
            id: textIdentifier,
            textSize: textSize
        }, locationAndCurrencyInfo)) : /*#__PURE__*/ react.createElement(styles_Text, {
            textSize: textSize
        }, locationAndCurrencyInfo));
    };
    if (marketplace && storeName && countryName) return renderLocationAndCurrencyInfo([
        t("store", "store.is-marketplace", {
            storeName: storeName,
            country: countryName
        }),
        currency && t("store", "store.uses-currency", {
            currency: currency
        })
    ].filter(function(item) {
        return item;
    }).join(" "));
    var locationAndCurrencyInfo = [
        countryName && t("store", "store.located-in", {
            country: countryName
        }),
        currency && t("store", "store.uses-currency", {
            currency: currency
        })
    ].filter(function(item) {
        return item;
    }).join(" ");
    return renderLocationAndCurrencyInfo(locationAndCurrencyInfo);
};
/* harmony default export */ var location_and_currency_info = (location_and_currency_info_LocationAndCurrencyInfo);


/***/ }),

/***/ 42028:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ useLocationContext),
/* harmony export */   "v": () => (/* binding */ LocationProvider)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var LocationContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    currentLocation: undefined,
    previousLocation: undefined
});
var LocationProvider = function(param) {
    var children = param.children;
    var location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .useLocation */ .TH)();
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), previousLocation = ref[0], setPreviousLocation = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), currentLocation = ref1[0], setCurrentLocation = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (currentLocation) {
            setPreviousLocation(currentLocation);
        }
        setCurrentLocation(location.pathname + location.search);
    }, [
        location.pathname,
        location.search
    ]);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            currentLocation: currentLocation,
            previousLocation: previousLocation
        };
    }, [
        currentLocation,
        previousLocation
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LocationContext.Provider, {
        value: contextValue
    }, children);
};
function useLocationContext() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LocationContext);
}


/***/ }),

/***/ 42574:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var Modal = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 72291));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(72291);
        }
        return eval("require.resolve")("./modal");
    }
});
var ModalLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Modal, _extends({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalLoader);


/***/ }),

/***/ 72291:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51676);


var APP_ROOT_ID = "root";
var MODAL_ROOT_ID = "root-modal";
var ModalComponent = function(props) {
    var children = props.children, className = props.className, isOpen = props.isOpen, onRequestClose = props.onRequestClose, _size = props.size, size = _size === void 0 ? _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_1__/* .ModalSizeEnum.SMALL */ .E$.SMALL : _size, style = props.style, title = props.title, disableClose = props.disableClose;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        className: className,
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        parentSelectorId: MODAL_ROOT_ID,
        rootId: APP_ROOT_ID,
        size: size,
        style: style,
        title: title,
        shouldCloseOnOverlayClick: !disableClose,
        shouldHaveCloseButton: !disableClose
    }, children);
};
/* harmony default export */ __webpack_exports__["default"] = (ModalComponent);


/***/ }),

/***/ 43758:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hn": () => (/* binding */ SHOW_MODAL),
/* harmony export */   "K4": () => (/* binding */ showModal),
/* harmony export */   "VG": () => (/* binding */ hideModal),
/* harmony export */   "_D": () => (/* binding */ HIDE_MODAL)
/* harmony export */ });
var SHOW_MODAL = "SHOW_MODAL";
var HIDE_MODAL = "HIDE_MODAL";
var showModal = function(modal) {
    return {
        type: SHOW_MODAL,
        modal: modal
    };
};
var hideModal = function() {
    return {
        type: HIDE_MODAL
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    showModal: showModal,
    hideModal: hideModal
});


/***/ }),

/***/ 94320:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var Modal = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 2869));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(2869);
        }
        return eval("require.resolve")("./modal");
    }
});
var ModalLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Modal, _extends({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalLoader);


/***/ }),

/***/ 608:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": () => (/* reexport */ NewsletterSignup),
  "_": () => (/* reexport */ NewsletterSignupFooter)
});

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(61061);
// EXTERNAL MODULE: ./src/components/newsletter-signup/styles.ts
var styles = __webpack_require__(34067);
// EXTERNAL MODULE: ./src/components/newsletter-signup/useNewsletterSignup.ts + 1 modules
var useNewsletterSignup = __webpack_require__(56688);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/newsletter-signup/newsletter-signup.tsx








var NewsletterSignup = function(props) {
    var className = props.className, title = props.title, description = props.description, buttonText = props.buttonText, buttonClass = props.buttonClass, stacked = props.stacked, _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = (0,useNewsletterSignup/* useNewsletterSignup */.H)(), _state = ref.state, signupFeedbackTranslationKey = _state.signupFeedbackTranslationKey, isSubscribed = _state.isSubscribed, loading = _state.loading, handleSubmit = ref.handleSubmit, handleChange = ref.handleChange, privacyPolicyUri = ref.privacyPolicyUri;
    return /*#__PURE__*/ react.createElement(styles/* NewsLetter */.M7, {
        stacked: stacked,
        variant: variant,
        className: className
    }, title && /*#__PURE__*/ react.createElement(styles/* Title */.Dx, null, title), description && /*#__PURE__*/ react.createElement(styles/* Text */.xv, null, description), !isSubscribed ? /*#__PURE__*/ react.createElement(styles/* Form */.l0, {
        method: "post",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ react.createElement(styles/* Flex */.kC, null, /*#__PURE__*/ react.createElement(styles/* InlineInput */.ZQ, {
        type: "email",
        name: "email",
        helper: t("campaigns", signupFeedbackTranslationKey),
        onChange: handleChange,
        stacked: stacked,
        variant: "rounded",
        placeholder: t("campaigns", "newsletter.email-placeholder"),
        ariaLabel: t("campaigns", "newsletter.email-input-aria-label"),
        // Do not send this element to CUX (cux.io)
        "data-cux-exclude": true
    }), /*#__PURE__*/ react.createElement(styles/* Button */.zx, {
        className: buttonClass || "",
        disabled: loading,
        htmlType: "submit"
    }, loading ? /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        position: "none",
        isActive: loading
    })) : /*#__PURE__*/ react.createElement(variants.ButtonText, null, buttonText || t("campaigns", "newsletter.sign-up-button"))))) : /*#__PURE__*/ react.createElement(styles/* Text */.xv, null, /*#__PURE__*/ react.createElement(styles/* SubscribedCheckIcon */._t, null), /*#__PURE__*/ react.createElement(styles/* SubscribeTitle */.cB, null, t("campaigns", "newsletter.sign-up-success"))), /*#__PURE__*/ react.createElement(styles/* Legal */.Q2, null, privacyPolicyUri && !privacyPolicyUri.startsWith("http") && /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: privacyPolicyUri,
        // This link is nofollow to avoid it getting too much of the internal
        // pagerank (since it occurs on every page).
        rel: "nofollow",
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.NEWSLETTER_EMAIL_PRIVACY */.U.NEWSLETTER_EMAIL_PRIVACY,
                nextPage: privacyPolicyUri
            });
        }
    }, t("product", "alert.how-your-email-is-used")), privacyPolicyUri && privacyPolicyUri.startsWith("http") && /*#__PURE__*/ react.createElement("a", {
        href: privacyPolicyUri,
        // This link is nofollow to avoid it getting too much of the internal
        // pagerank (since it occurs on every page).
        rel: "nofollow",
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.NEWSLETTER_EMAIL_PRIVACY */.U.NEWSLETTER_EMAIL_PRIVACY,
                nextPage: privacyPolicyUri
            });
        }
    }, t("product", "alert.how-your-email-is-used"))));
};

// EXTERNAL MODULE: ./src/components/newsletter-signup/legal-link.tsx
var legal_link = __webpack_require__(71636);
;// CONCATENATED MODULE: ./src/components/newsletter-signup/newsletter-signup-footer.tsx






var NewsletterSignupFooter = function(props) {
    var className = props.className, title = props.title, buttonText = props.buttonText, buttonClass = props.buttonClass, stacked = props.stacked, _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = (0,useNewsletterSignup/* useNewsletterSignup */.H)(), _state = ref.state, signupFeedbackTranslationKey = _state.signupFeedbackTranslationKey, isSubscribed = _state.isSubscribed, loading = _state.loading, handleSubmit = ref.handleSubmit, handleChange = ref.handleChange, privacyPolicyUri = ref.privacyPolicyUri;
    return /*#__PURE__*/ react.createElement(styles/* NewsLetterFooter */.CO, {
        stacked: false,
        variant: variant,
        className: className
    }, /*#__PURE__*/ react.createElement(styles/* NewsLetterFooterText */.ay, null, title && /*#__PURE__*/ react.createElement(styles/* Title */.Dx, null, title)), /*#__PURE__*/ react.createElement(styles/* NewsLetterFooterInput */.AL, null, !isSubscribed ? /*#__PURE__*/ react.createElement(styles/* Form */.l0, {
        method: "post",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ react.createElement(styles/* Flex */.kC, null, /*#__PURE__*/ react.createElement(styles/* InlineInput */.ZQ, {
        type: "email",
        name: "email",
        helper: t("campaigns", signupFeedbackTranslationKey),
        onChange: handleChange,
        stacked: stacked,
        variant: "rounded",
        placeholder: t("campaigns", "newsletter.email-placeholder"),
        ariaLabel: t("campaigns", "newsletter.email-input-aria-label"),
        // Do not send this element to CUX (cux.io)
        "data-cux-exclude": true
    }), /*#__PURE__*/ react.createElement(styles/* Button */.zx, {
        className: buttonClass || "",
        disabled: loading,
        htmlType: "submit"
    }, loading && /*#__PURE__*/ react.createElement(styles/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        position: "none",
        isActive: loading
    })), /*#__PURE__*/ react.createElement(styles/* ButtonText */.oD, {
        $hide: loading
    }, buttonText || t("campaigns", "newsletter.sign-up-button"))))) : /*#__PURE__*/ react.createElement(styles/* Text */.xv, null, /*#__PURE__*/ react.createElement(styles/* SubscribedCheckIcon */._t, null), /*#__PURE__*/ react.createElement(styles/* SubscribeTitle */.cB, null, t("campaigns", "newsletter.sign-up-success")))), /*#__PURE__*/ react.createElement(legal_link/* default */.Z, {
        privacyPolicyUri: privacyPolicyUri
    }));
};

;// CONCATENATED MODULE: ./src/components/newsletter-signup/index.ts





/***/ }),

/***/ 71636:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57735);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25349);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34067);





var LegalLink = function(param) {
    var privacyPolicyUri = param.privacyPolicyUri;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_3__/* .AppContext */ .Il).t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Legal */ .Q2, null, privacyPolicyUri && !privacyPolicyUri.startsWith("http") && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
        to: privacyPolicyUri,
        // This link is nofollow to avoid it getting too much of the internal
        // pagerank (since it occurs on every page).
        rel: "nofollow",
        onClick: function() {
            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .InternalNavigationScope.NEWSLETTER_EMAIL_PRIVACY */ .U.NEWSLETTER_EMAIL_PRIVACY,
                nextPage: privacyPolicyUri
            });
        }
    }, t("product", "alert.how-your-email-is-used")), privacyPolicyUri && privacyPolicyUri.startsWith("http") && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
        href: privacyPolicyUri,
        // This link is nofollow to avoid it getting too much of the internal
        // pagerank (since it occurs on every page).
        rel: "nofollow",
        onClick: function() {
            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .InternalNavigationScope.NEWSLETTER_EMAIL_PRIVACY */ .U.NEWSLETTER_EMAIL_PRIVACY,
                nextPage: privacyPolicyUri
            });
        }
    }, t("product", "alert.how-your-email-is-used")));
};
/* harmony default export */ __webpack_exports__["Z"] = (LegalLink);


/***/ }),

/***/ 34067:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AL": () => (/* binding */ NewsLetterFooterInput),
/* harmony export */   "CO": () => (/* binding */ NewsLetterFooter),
/* harmony export */   "Dx": () => (/* binding */ Title),
/* harmony export */   "Ei": () => (/* binding */ ButtonIcon),
/* harmony export */   "M7": () => (/* binding */ NewsLetter),
/* harmony export */   "Q2": () => (/* binding */ Legal),
/* harmony export */   "ZQ": () => (/* binding */ InlineInput),
/* harmony export */   "_t": () => (/* binding */ SubscribedCheckIcon),
/* harmony export */   "ay": () => (/* binding */ NewsLetterFooterText),
/* harmony export */   "cB": () => (/* binding */ SubscribeTitle),
/* harmony export */   "kC": () => (/* binding */ Flex),
/* harmony export */   "l0": () => (/* binding */ Form),
/* harmony export */   "oD": () => (/* binding */ ButtonText),
/* harmony export */   "x2": () => (/* binding */ Feedback),
/* harmony export */   "xv": () => (/* binding */ Text),
/* harmony export */   "zx": () => (/* binding */ Button)
/* harmony export */ });
/* unused harmony exports SubscribeSubTitle, ButtonFooter, TextFooter */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_inputs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32741);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25670);
/* harmony import */ var _prisjakt_ui_icon_check_filled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6213);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21541);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    order: 9;\n    align-self: flex-start;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  text-decoration: underline;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 16px;\n  background-color: white;\n  vertical-align: middle;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n  flex-grow: 1;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      margin-right: 20px;\n      margin-top: 2px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n\n  > input {\n    height: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: top;\n  flex-direction: 'row';\n  background-color: 'red';\n  flex-grow: 1;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  height: min-content;\n  width: 100%;\n  flex: 1;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  visibility: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n  color: ",
        ";\n  ",
        " {\n    color: ",
        ";\n  }\n  ",
        " a {\n    color: ",
        ";\n\n    :hover {\n      color: ",
        ";\n    }\n  }\n  ",
        " {\n    color: ",
        ";\n  }\n  ",
        " {\n    flex-direction: ",
        ";\n  }\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    flex-grow: 1;\n    max-width: 260px;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    margin: 0;\n  }\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100%;\n      margin-left: 0;\n      margin-top: ",
        ";\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: column;\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 380px;\n  flex-grow: 1;\n\n  form {\n    margin: 0;\n  }\n\n  ",
        " {\n    width: unset;\n\n    ",
        "\n  }\n\n  > form > ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  height: min-content;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n      text-align: left;\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    align-items: center;\n    gap: ",
        ";\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: 0;\n  color: ",
        ";\n  ",
        " {\n    color: ",
        ";\n  }\n  ",
        " {\n    a {\n      color: ",
        ";\n\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    ",
        "\n  }\n  ",
        " {\n    color: ",
        ";\n  }\n  ",
        " {\n    flex-wrap: nowrap;\n    flex-direction: ",
        ";\n  }\n  ",
        " {\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}






var Legal = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Legal",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall));
var Feedback = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Feedback",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall);
// Empty SC component to allow for it to be CSS selected
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.H3Text).withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(_templateObject3());
var SubscribeTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].b.withConfig({
    displayName: "SubscribeTitle",
    componentId: "sc-0-3"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var SubscribeSubTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SubscribeSubTitle",
    componentId: "sc-0-4"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var SubscribedCheckIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_check_filled__WEBPACK_IMPORTED_MODULE_4__.IconCheckFilled).attrs(function() {
    return {
        size: 16,
        color: "positive500"
    };
}).withConfig({
    displayName: "SubscribedCheckIcon",
    componentId: "sc-0-5"
})(_templateObject6());
var Form = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].form.withConfig({
    displayName: "Form",
    componentId: "sc-0-6"
})(_templateObject7(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var InlineInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_inputs__WEBPACK_IMPORTED_MODULE_1__/* .TextInput */ .oi).withConfig({
    displayName: "InlineInput",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return !p.stacked && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8());
});
var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Flex",
    componentId: "sc-0-8"
})(_templateObject10());
var Text = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.BodySmallText).withConfig({
    displayName: "Text",
    componentId: "sc-0-9"
})(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.PrimaryButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-10"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var ButtonText = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonText).withConfig({
    displayName: "ButtonText",
    componentId: "sc-0-11"
})(_templateObject13(), function(p) {
    return p.$hide ? "hidden" : "visible";
});
var ButtonIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon).withConfig({
    displayName: "ButtonIcon",
    componentId: "sc-0-12"
})(_templateObject14());
var NewsLetter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NewsLetter",
    componentId: "sc-0-13"
})(_templateObject15(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.variant === "secondary" && p.theme.colors.base600;
}, Title, function(p) {
    return p.variant === "secondary" && p.theme.colors.base700;
}, Legal, function(p) {
    return p.variant === "primary" ? p.theme.colors.base600 : p.theme.colors.base600;
}, function(p) {
    return p.variant === "primary" ? p.theme.colors.base600 : p.theme.text.callToActionHover;
}, Feedback, function(p) {
    return p.variant === "primary" ? p.theme.colors.negative700 : p.theme.colors.base600;
}, Flex, function(p) {
    return p.stacked ? "column" : "row";
}, Button, function(p) {
    return p.stacked && "margin-left: 0;\n    margin-top: ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";");
});
var NewsLetterFooterText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NewsLetterFooterText",
    componentId: "sc-0-14"
})(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject16()));
var NewsLetterFooterInput = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NewsLetterFooterInput",
    componentId: "sc-0-15"
})(_templateObject20(), Button, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject18(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100), Flex, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject19()));
var ButtonFooter = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.PrimaryButton).withConfig({
    displayName: "ButtonFooter",
    componentId: "sc-0-16"
})(_templateObject21(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var NewsLetterFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NewsLetterFooter",
    componentId: "sc-0-17"
})(_templateObject24(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return p.variant === "secondary" && p.theme.colors.base600;
}, Title, function(p) {
    return p.variant === "secondary" && p.theme.colors.base700;
}, Legal, function(p) {
    return p.variant === "primary" ? p.theme.colors.base600 : p.theme.colors.base600;
}, function(p) {
    return p.variant === "primary" ? p.theme.colors.base600 : p.theme.text.callToActionHover;
}, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject22()), Feedback, function(p) {
    return p.variant === "primary" ? p.theme.colors.negative700 : p.theme.colors.base600;
}, Flex, function(p) {
    return p.stacked ? "column" : "row";
}, Button, function(p) {
    return p.stacked && "margin-left: 0;\n    margin-top: ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";");
}, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150));
var TextFooter = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.BodyMediumText).withConfig({
    displayName: "TextFooter",
    componentId: "sc-0-18"
})(_templateObject25(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);


/***/ }),

/***/ 56688:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": () => (/* binding */ useNewsletterSignup)
});

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/form-serialize@0.7.2/node_modules/form-serialize/index.js
var form_serialize = __webpack_require__(96712);
var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/components/newsletter-signup/tracking.ts

function trackNewsletterSignup() {
    (0,data_layer/* pushEvent */.A)("newsletter_signup");
}

;// CONCATENATED MODULE: ./src/components/newsletter-signup/useNewsletterSignup.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var useNewsletterSignup = function() {
    var ref, ref1;
    var ref2 = _slicedToArray((0,react.useReducer)(function(state, newState) {
        return _objectSpread({}, state, newState);
    }, {
        email: "",
        isSubscribed: false,
        loading: false
    }), 2), ref3 = ref2[0], email = ref3.email, signupFeedbackTranslationKey = ref3.signupFeedbackTranslationKey, isSubscribed = ref3.isSubscribed, loading = ref3.loading, setState = ref2[1];
    var ref4 = (0,react.useContext)(app_context/* AppContext */.Il), market = ref4.market, renderMode = ref4.renderMode;
    var subscribeNewsletter = (0,react.useCallback)(function(subscriptionEmail) {
        return fetch("/_internal/newsletter/subscribe", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: subscriptionEmail
            })
        }).then(function(res) {
            return res.json();
        });
    }, []);
    var handleSubmit = (0,react.useCallback)(function(e) {
        if (!e) {
            return;
        }
        var formData = form_serialize_default()(e.target, {
            hash: true
        });
        e.preventDefault();
        if (formData.email) {
            setState({
                loading: true
            });
            subscribeNewsletter(formData.email).then(function(res) {
                setState({
                    isSubscribed: res.success,
                    signupFeedbackTranslationKey: res.success ? "newsletter.sign-up-success" : "newsletter.sign-up-error",
                    loading: false
                });
                if (res.success) {
                    trackNewsletterSignup();
                }
            }).catch(function() {
                setState({
                    signupFeedbackTranslationKey: "newsletter.sign-up-error",
                    loading: false
                });
            });
        }
    }, [
        subscribeNewsletter
    ]);
    var handleChange = (0,react.useCallback)(function(event) {
        if (!event) {
            return;
        }
        setState(_defineProperty({}, event.target.name, event.target.value));
    }, []);
    var privacyPolicyUri = ((market === null || market === void 0 ? void 0 : (ref = market.privacySettings) === null || ref === void 0 ? void 0 : ref[renderMode]) || (market === null || market === void 0 ? void 0 : (ref1 = market.privacySettings) === null || ref1 === void 0 ? void 0 : ref1.responsive)).privacyUrl;
    return {
        state: {
            email: email,
            signupFeedbackTranslationKey: signupFeedbackTranslationKey,
            isSubscribed: isSubscribed,
            loading: loading
        },
        handleSubmit: handleSubmit,
        handleChange: handleChange,
        privacyPolicyUri: privacyPolicyUri
    };
};


/***/ }),

/***/ 83464:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var _viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22899);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n&& {\n  body {\n    overflow: hidden;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* We used to keep the enabled/disabled logic and viewport checks inside this styled component,
 but due to the way createGlobalStyle works it caused bugs when maintaining multiple instances
 of the component in the app. It's better to avoid using props in the component and only mount
 it when we want the styles to be applied. */ var NoScrollGlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.createGlobalStyle)(_templateObject());
var NoScroll = function(param) {
    var _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled, mobile = param.mobile, tablet = param.tablet;
    if (!enabled) {
        return null;
    }
    // If no viewport props are set, render the styles unconditionally
    if (!mobile && !tablet) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NoScrollGlobalStyle, null);
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_viewport__WEBPACK_IMPORTED_MODULE_2__/* .ViewportContext.Consumer */ .R.Consumer, null, function(param) {
        var isMobile = param.isMobile, isTablet = param.isTablet;
        return mobile && isMobile || tablet && isTablet ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NoScrollGlobalStyle, null) : null;
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoScroll);


/***/ }),

/***/ 75695:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": () => (/* binding */ price_label_PriceLabel)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/offer/price/price-label/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PriceLabel = (0,styled_components_browser_esm["default"])(variants.BodySmallText).attrs({
    containerProps: {
        "data-test": "PriceLabel"
    }
}).withConfig({
    displayName: "PriceLabel",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/offer/price/price-label/index.tsx





var price_label_PriceLabel = function(param) {
    var className = param.className, _container = param.container, container = _container === void 0 ? "span" : _container, _emphasis = param.emphasis, emphasis = _emphasis === void 0 ? variants.FontEmphasis.HIGH : _emphasis, _fontColor = param.fontColor, fontColor = _fontColor === void 0 ? variants.FontColor.DARK : _fontColor, value = param.value, _weight = param.weight, weight = _weight === void 0 ? variants.FontWeight.HEAVIER : _weight, _isSecondaryPrice = param.isSecondaryPrice, isSecondaryPrice = _isSecondaryPrice === void 0 ? false : _isSecondaryPrice, _memberPrice = param.memberPrice, memberPrice = _memberPrice === void 0 ? false : _memberPrice;
    var context = (0,react.useContext)(app_context/* AppContext */.Il);
    var formatPrice = function(num) {
        var ref;
        return (0,currency/* formatCurrency */.xG)(num, (ref = context.market) === null || ref === void 0 ? void 0 : ref.code, false, "", false);
    };
    var renderFormattedPrice = function() {
        if (typeof value !== "number") return value;
        if (isSecondaryPrice && memberPrice) return "(".concat(formatPrice(value), ")");
        if (isSecondaryPrice) return "".concat(formatPrice(value));
        return /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: value
        });
    };
    return /*#__PURE__*/ react.createElement(PriceLabel, {
        className: className,
        color: fontColor,
        container: container,
        emphasis: emphasis,
        weight: weight
    }, renderFormattedPrice());
};


/***/ }),

/***/ 48711:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ PriceText)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57111);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var PriceText = function(props) {
    var scale = props.scale, weight = props.weight, otherProps = _objectWithoutProperties(props, [
        "scale",
        "weight"
    ]);
    var newScale = scale !== null && scale !== void 0 ? scale : _prisjakt_ui_text__WEBPACK_IMPORTED_MODULE_1__.FontScale.M;
    var newWeight = weight !== null && weight !== void 0 ? weight : _prisjakt_ui_text__WEBPACK_IMPORTED_MODULE_1__.FontWeight.HEAVIEST;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text__WEBPACK_IMPORTED_MODULE_1__.Text, _extends({}, otherProps, {
        scale: newScale,
        weight: newWeight
    }));
};


/***/ }),

/***/ 8501:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": () => (/* binding */ getSalesPricePercentage),
/* harmony export */   "k": () => (/* binding */ parseUTCDate)
/* harmony export */ });
function parseUTCDate(dateString, locale) {
    var date = new Date(dateString);
    var timeDiff = date.getTimezoneOffset() * 60000;
    var adjustedUTCDate = new Date(date.valueOf() + timeDiff);
    var localizedDate;
    try {
        localizedDate = adjustedUTCDate.toLocaleDateString(locale, {
            day: "numeric",
            month: "short"
        });
    } catch (e) {
        localizedDate = adjustedUTCDate.toLocaleDateString("en", {
            day: "numeric",
            month: "short"
        });
    }
    return localizedDate;
}
function getSalesPricePercentage(price, originalPrice) {
    if (!price || !originalPrice) {
        return 0;
    }
    return Math.round((1 - price / originalPrice) * 100);
}


/***/ }),

/***/ 34879:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ overlay)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(10422);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
;// CONCATENATED MODULE: ./src/components/overlay/styles.ts



var Overlay = (0,styled_components_browser_esm["default"])(hideable.Hideable).withConfig({
    displayName: "Overlay",
    componentId: "sc-0-0"
})(function(props) {
    return {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: props.theme.bg.overlay,
        zIndex: zindex/* zindex.overlay */.Y.overlay
    };
});

;// CONCATENATED MODULE: ./src/components/overlay/index.tsx



var overlay_Overlay = function(props) {
    if (false) {}
    var rootEl = document.getElementById("root-overlay");
    if (!rootEl) {
        return null;
    }
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ react.createElement(Overlay, {
        visible: props.active
    }), rootEl);
};
overlay_Overlay.defaultProps = {
    active: false
};
/* harmony default export */ var overlay = (overlay_Overlay);


/***/ }),

/***/ 12321:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JH": () => (/* reexport */ page_content/* default */.Z),
  "mr": () => (/* reexport */ page_header/* default */.Z),
  "WH": () => (/* reexport */ page_header_media),
  "NP": () => (/* reexport */ PageSection)
});

// EXTERNAL MODULE: ./src/components/page/page-content/index.tsx + 2 modules
var page_content = __webpack_require__(53170);
// EXTERNAL MODULE: ./src/components/page/page-header/index.tsx + 1 modules
var page_header = __webpack_require__(80270);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/page/page-header-media/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-top: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Root = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Root",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var PageHeaderMedia = function(param) {
    var src = param.src, alt = param.alt, className = param.className;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    return /*#__PURE__*/ react.createElement(Root, {
        className: className,
        src: src,
        alt: alt,
        width: isMobile ? 64 : 88
    });
};
/* harmony default export */ var page_header_media = (PageHeaderMedia);

;// CONCATENATED MODULE: ./src/components/page/page-section/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n        border-bottom: 1px solid ",
        ";\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n            border-bottom: 1px solid ",
        ";\n          "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n            background-color: ",
        ";\n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n      :before {\n        position: absolute;\n        left: -50vw;\n        right: -50vw;\n        z-index: -1;\n        content: '';\n        height: 100%;\n\n        ",
        ";\n\n        ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 0 ",
        ";\n\n  ",
        ";\n\n  &,\n  :before,\n  :after {\n    ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n            padding-top: ",
        ";\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n        padding-top: ",
        ";\n        padding-bottom: 0;\n        ",
        ";\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n          padding-bottom: ",
        ";\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n        padding-bottom: ",
        ";\n        padding-top: 0;\n        ",
        ";\n      "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n        padding: 0;\n      "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n        padding: ",
        " 0;\n      "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n      padding: ",
        " 0;\n      ",
        ";\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  :empty {\n    display: none;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n  html {\n    overflow-x: hidden !important;\n\n    &:has(> body.ReactModal__Body--open) {\n      overflow: hidden;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var PageSectionWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PageSectionWrapper",
    componentId: "sc-0-0"
})(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(param) {
    var recessed = param.recessed, theme = param.theme;
    return recessed && (0,styled_components_browser_esm.css)(styles_templateObject(), theme.bg.quaternary);
}, function(p) {
    return !p.noBorder && !p.recessed && (0,styled_components_browser_esm.css)(_templateObject1(), p.theme.lines.primary);
}, function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), base/* media.largeUp */.BC.largeUp(_templateObject4(), !p.noBorder && !p.recessed && (0,styled_components_browser_esm.css)(_templateObject2(), p.theme.lines.primary), p.recessed && (0,styled_components_browser_esm.css)(_templateObject3(), p.theme.bg.quaternary)));
});
var PageSectionContent = styled_components_browser_esm["default"].section.withConfig({
    displayName: "PageSectionContent",
    componentId: "sc-0-1"
})(_templateObject14(), function(p) {
    if (p.noPad === "bottom") {
        return (0,styled_components_browser_esm.css)(_templateObject8(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* media.mediumUp */.BC.mediumUp(_templateObject7(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400));
    }
    if (p.noPad === "top") {
        return (0,styled_components_browser_esm.css)(_templateObject10(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* media.mediumUp */.BC.mediumUp(_templateObject9(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400));
    }
    if (p.noPad === "both") {
        return (0,styled_components_browser_esm.css)(_templateObject11());
    }
    return (0,styled_components_browser_esm.css)(_templateObject13(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* media.mediumUp */.BC.mediumUp(_templateObject12(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400));
});
var GlobalStylesOverride = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject15());

;// CONCATENATED MODULE: ./src/components/page/page-section/index.tsx


var PageSection = function(props) {
    return /*#__PURE__*/ react.createElement(PageSectionWrapper, {
        className: props.className,
        recessed: props.recessed,
        noBorder: props.noBorder
    }, props.recessed && /*#__PURE__*/ react.createElement(GlobalStylesOverride, null), /*#__PURE__*/ react.createElement(PageSectionContent, {
        noPad: props.noPad
    }, props.children));
};

;// CONCATENATED MODULE: ./src/components/page/index.ts







/***/ }),

/***/ 53170:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ page_content)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/contexts/wide-context.tsx
var wide_context = __webpack_require__(96192);
// EXTERNAL MODULE: ./packages/react-ads/dist/module.js + 1 modules
var dist_module = __webpack_require__(6895);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./src/components/sticky-tab-nav/constants.ts
var constants = __webpack_require__(75871);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/page/constants.ts

var PAGE_CONTENT_GUTTER_BREAKPOINT = "".concat(1200 - 1, "px");
var OUTSIDE_AD_MIN_WIDTH = "200px";
var OUTSIDE_AD_MAX_WIDTH = "300px";
var SIDEBAR_CONTENT_WIDTH = base/* layout.sidebarContentWidth.desktop.value */.bK.sidebarContentWidth.desktop.value;
var SIDEBAR_MENU_WIDTH = base/* layout.sidebarMenuWidth.desktop.value */.bK.sidebarMenuWidth.desktop.value;
var PAGE_WITH_SIDEBAR_CONTENT_WIDTH = base/* layout.pageContent.maxWidth.value */.bK.pageContent.maxWidth.value + base/* layout.pageContent.gutter.value */.bK.pageContent.gutter.value + (SIDEBAR_CONTENT_WIDTH + SIDEBAR_MENU_WIDTH) * 2;

;// CONCATENATED MODULE: ./src/components/page/page-content/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      @media ",
        " {\n        /* Center content when the outsider ad is hidden */\n        margin-left: auto;\n        margin-right: auto;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    ",
        "\n    padding-left: 0;\n    padding-right: 0;\n    margin-right: ",
        ";\n    position: relative;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  align-self: stretch;\n  margin-bottom: ",
        ";\n  min-width: ",
        ";\n  width: ",
        ";\n  z-index: 100;\n  margin-right: ",
        ";\n\n  & > * {\n    margin-top: ",
        ";\n  }\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      /* Align page content with header content when it exceeds the open sidebar (but only if we don't have a page without fixed max width) */\n      @media ",
        " {\n        margin-left: calc(\n          ((100vw - ",
        ") / 2) -\n            ",
        "px\n        );\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: auto;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    ",
        "\n    margin-right: auto;\n    margin-left: 0;\n    margin-bottom: ",
        ";\n\n    ",
        "\n\n    ",
        ";\n\n    @media ",
        " {\n      display: flex;\n      align-items: flex-start;\n      ",
        "\n      ",
        "\n      flex-direction: row-reverse;\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      &:last-child {\n        position: sticky;\n        top: ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}





var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), !props.isWide && "max-width: ".concat((0,base/* remCalc */.vR)(1000), ";"), props.alignLeft ? "auto" : 0, props.hasAds && (0,styled_components_browser_esm.css)(_templateObject(), "screen and (max-width: ".concat(PAGE_CONTENT_GUTTER_BREAKPOINT, ")")), props.wideContent && (0,styled_components_browser_esm.css)(_templateObject1()));
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject3());
var TopAds = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "TopAds",
    componentId: "sc-0-2"
})(_templateObject4());
var OutsiderAds = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "OutsiderAds",
    componentId: "sc-0-3"
})(_templateObject5(), base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem, OUTSIDE_AD_MAX_WIDTH, OUTSIDE_AD_MAX_WIDTH, design_tokens.measurements.spacing050, base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem, "screen and (max-width: ".concat(PAGE_CONTENT_GUTTER_BREAKPOINT, ")"));
var PageContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PageContent",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), !props.isWide && "max-width: ".concat(base/* layout.pageContent.maxWidth.value */.bK.pageContent.maxWidth.value, "px;"), design_tokens.measurements.spacing150, !props.isWide && (0,styled_components_browser_esm.css)(_templateObject6(), "(min-width: ".concat(PAGE_WITH_SIDEBAR_CONTENT_WIDTH, "px)"), base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, SIDEBAR_CONTENT_WIDTH + SIDEBAR_MENU_WIDTH + base/* layout.pageContent.gutter.value */.bK.pageContent.gutter.value), base/* media.mediumDown */.BC.mediumDown(_templateObject7()), "screen and (min-width: ".concat(PAGE_CONTENT_GUTTER_BREAKPOINT, ")"), props.isWide && "justify-content: flex-end;", !props.isWide && "justify-content: center;");
});
var AdPlacementMarginTop = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AdPlacementMarginTop",
    componentId: "sc-0-5"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject10(), design_tokens.measurements.spacing050, props.$isSticky && base/* media.largeUp */.BC.largeUp(_templateObject9(), props.$headerIsVisible ? "calc(".concat(base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, " + ").concat(props.$hasTabNavigation ? "".concat(constants/* NAV_HEIGHT */.n, "px") : "0rem", " + ").concat(design_tokens.measurements.spacing050, ")") : 0));
});

;// CONCATENATED MODULE: ./src/components/page/page-content/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var page_content_PageContent = function(props) {
    var className = props.className, children = props.children, _alignLeft = props.alignLeft, alignLeft = _alignLeft === void 0 ? false : _alignLeft, _wideContent = props.wideContent, wideContent = _wideContent === void 0 ? false : _wideContent, _withAds = props.withAds, withAds = _withAds === void 0 ? false : _withAds, _noTopAds = props.noTopAds, noTopAds = _noTopAds === void 0 ? false : _noTopAds, _noOutsiderAds = props.noOutsiderAds, noOutsiderAds = _noOutsiderAds === void 0 ? false : _noOutsiderAds, hasTabNavigation = props.hasTabNavigation, adsConfig = props.adsConfig;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, renderMode = ref.renderMode;
    var isWide = (0,react.useContext)(wide_context/* WideContext */.Y).isWide;
    var adsActive = market && market.ads && market.ads.active;
    var showAds = withAds && adsActive;
    var showOutsiderAds = Boolean(showAds && !noOutsiderAds);
    var showDesktopTopAd = Boolean(showAds && !noTopAds);
    var formats = (adsConfig === null || adsConfig === void 0 ? void 0 : adsConfig.formats) || [];
    if (showOutsiderAds) formats = [
        "widescreen_1",
        "widescreen_2"
    ].concat(_toConsumableArray(formats));
    if (showDesktopTopAd) formats = [
        "toppanorama_wde"
    ].concat(_toConsumableArray(formats));
    var _pageType;
    (0,dist_module/* useLoadAds */.UF)({
        pageOptions: {
            pageType: (_pageType = adsConfig === null || adsConfig === void 0 ? void 0 : adsConfig.pageOptions.pageType) !== null && _pageType !== void 0 ? _pageType : "other",
            categoryPath: adsConfig === null || adsConfig === void 0 ? void 0 : adsConfig.pageOptions.categoryPath,
            price: adsConfig === null || adsConfig === void 0 ? void 0 : adsConfig.pageOptions.price,
            searchWord: adsConfig === null || adsConfig === void 0 ? void 0 : adsConfig.pageOptions.searchWord,
            brand: adsConfig === null || adsConfig === void 0 ? void 0 : adsConfig.pageOptions.brand
        },
        formats: formats,
        enabled: showAds
    });
    return /*#__PURE__*/ react.createElement(PageContent, {
        "data-test": props["data-test"],
        className: className,
        isWide: isWide
    }, showOutsiderAds && /*#__PURE__*/ react.createElement(OutsiderAds, {
        className: "outsider-ads"
    }, /*#__PURE__*/ react.createElement(AdPlacementMarginTop, null, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        key: "static-widescreen_1",
        format: "widescreen_1"
    })), /*#__PURE__*/ react.createElement(AdPlacementMarginTop, {
        $headerIsVisible: renderMode !== "native",
        $hasTabNavigation: hasTabNavigation,
        $isSticky: true
    }, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        key: "static-widescreen_2",
        format: "widescreen_2"
    }))), /*#__PURE__*/ react.createElement(Wrapper, null, showDesktopTopAd && /*#__PURE__*/ react.createElement(AdPlacementMarginTop, null, /*#__PURE__*/ react.createElement(dist_module/* AdPlacement */.ZD, {
        key: "static-toppanorama_wde",
        format: "toppanorama_wde"
    })), /*#__PURE__*/ react.createElement(Content, {
        hasAds: adsActive,
        wideContent: wideContent,
        alignLeft: alignLeft,
        isWide: isWide
    }, children)));
};
/* harmony default export */ var page_content = (/*#__PURE__*/(0,react.memo)(page_content_PageContent));


/***/ }),

/***/ 80270:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ page_header)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/components/page/page-header/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: ",
        ";\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 500px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Root = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Root",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.hasDescription ? "start" : "center";
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Title = (0,styled_components_browser_esm["default"])(variants.H1Text).withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), function(props) {
    return props.hasMedia ? 0 : "default";
});
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Description = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "Description",
    componentId: "sc-0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/page/page-header/index.tsx


var PageHeader = function(props) {
    var media = props.media, title = props.title, className = props.className, description = props.description;
    return /*#__PURE__*/ react.createElement(Root, {
        className: className,
        hasDescription: !!description
    }, media, /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(Title, {
        containerProps: {
            "data-test": "PageHeaderTitle"
        },
        hasMedia: !!media
    }, title), description && /*#__PURE__*/ react.createElement(Description, null, description)));
};
/* harmony default export */ var page_header = (PageHeader);


/***/ }),

/***/ 9332:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": () => (/* binding */ PjFrontEndAdmin)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var PjFrontEndAdmin = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "frontend-admin-ui";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 53254));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(53254);
        }
        return eval("require.resolve")("@prisjakt/frontend-admin-ui");
    }
});


/***/ }),

/***/ 69221:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": () => (/* reexport */ ColorsEnum),
  "V": () => (/* binding */ Placeholder)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/placeholder/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n\n  @keyframes gradient {\n    0% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: -100% 50%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    min-width: 146px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: space-between;\n      padding-bottom: 10%;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      max-height: 88px;\n      flex-direction: row;\n      flex-wrap: nowrap;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  flex-grow: 1;\n  min-width: 200px;\n\n  ",
        "\n  ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      align-self: center;\n      height: 100px;\n      width: 100px;\n      margin-bottom: 10px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    order: ",
        ";\n    display: flex;\n    height: 50px;\n    width: 50px;\n    background: ",
        ";\n    border-radius: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: 12px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: 20px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      order: ",
        ";\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n      background: linear-gradient(\n        to right,\n        rgba(238, 238, 238, 1) 8%,\n        rgba(238, 238, 238, 0.5) 18%,\n        rgba(238, 238, 238, 1) 33%\n      );\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      background: linear-gradient(to right, #fff 8%, #ffffff80 18%, #fff 33%);\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    display: flex;\n    height: 10px;\n    margin: 5px 0;\n    width: 100%;\n    background-size: 300% 300%;\n    animation: gradient 1s linear infinite;\n    border-radius: 30px;\n\n    ",
        "\n\n    ",
        "\n\n    &:nth-of-type(even) {\n      width: 80%;\n    }\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var ColorsEnum;
(function(ColorsEnum) {
    ColorsEnum["WHITE"] = "white";
    ColorsEnum["GRAY"] = "gray";
})(ColorsEnum || (ColorsEnum = {}));
var StyledPlaceholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPlaceholder",
    componentId: "sc-0-0"
})(_templateObject());
var StyledDeal = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDeal",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.height;
}, base/* media.smallOnly */.BC.smallOnly(_templateObject1()), function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject2());
}, function(props) {
    return props.mode === "row" && (0,styled_components_browser_esm.css)(_templateObject3());
});
var StyledMedia = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledMedia",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), props.mediaPosition, props.$color === ColorsEnum.GRAY ? "#eee" : "#fff", base/* layout.borderRadius */.bK.borderRadius, props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject5()));
});
var StyledRows = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRows",
    componentId: "sc-0-3"
})(_templateObject9(), function(props) {
    return props.mode === "row" && (0,styled_components_browser_esm.css)(_templateObject7());
}, function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject8());
});
var StyledText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledText",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject13(), props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject10(), props.rowIndex && props.rowIndex + 1), props.$color === ColorsEnum.GRAY && (0,styled_components_browser_esm.css)(_templateObject11()), props.$color === ColorsEnum.WHITE && (0,styled_components_browser_esm.css)(_templateObject12()));
});

;// CONCATENATED MODULE: ./src/components/placeholder/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var Placeholder = function(param) {
    var className = param.className, _amount = param.amount, amount = _amount === void 0 ? 1 : _amount, _color = param.color, color = _color === void 0 ? ColorsEnum.GRAY : _color, _rows = param.rows, rows = _rows === void 0 ? 5 : _rows, _mode = param.mode, mode = _mode === void 0 ? "grid" : _mode, _height = param.height, height = _height === void 0 ? "auto" : _height, _mediaPosition = param.mediaPosition, mediaPosition = _mediaPosition === void 0 ? 0 : _mediaPosition, _showMedia = param.showMedia, showMedia = _showMedia === void 0 ? true : _showMedia;
    return /*#__PURE__*/ react.createElement(StyledPlaceholder, {
        "data-test": "Placeholder"
    }, _toConsumableArray(new Array(amount)).map(function(e, i) {
        return /*#__PURE__*/ react.createElement(StyledDeal, {
            key: i.toString(),
            mode: mode,
            height: height
        }, showMedia && /*#__PURE__*/ react.createElement(StyledMedia, {
            mediaPosition: mediaPosition,
            mode: mode,
            $color: color
        }), /*#__PURE__*/ react.createElement(StyledRows, {
            mode: mode
        }, _toConsumableArray(new Array(rows)).map(function(row, rowIndex) {
            return /*#__PURE__*/ react.createElement(StyledText, {
                key: rowIndex.toString(),
                rowIndex: rowIndex,
                mode: mode,
                $color: color
            });
        })));
    }));
};



/***/ }),

/***/ 12618:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": () => (/* binding */ popular_searches_PopularSearches)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(83830);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./src/areas/search-suggestions/history-storage.tsx
var history_storage = __webpack_require__(81118);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/popular-searches/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        " 0;\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PopularSearches = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PopularSearches",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/popular-searches/index.tsx









var popular_searches_PopularSearches = function(props) {
    var popularSearches = props.popularSearches, onClick = props.onClick;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    if (!(popularSearches === null || popularSearches === void 0 ? void 0 : popularSearches.length)) {
        return null;
    }
    var handleClick = function(query) {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.QUICK_SEARCH_SUGGESTION */.U.QUICK_SEARCH_SUGGESTION,
            nextPage: linkTo("search", {
                query: encodeURIComponent(query)
            })
        });
        (0,history_storage/* addRecentSearch */._)(query);
        if (onClick) {
            onClick(query);
        }
    };
    return /*#__PURE__*/ react.createElement(PopularSearches, {
        "data-test": "PopularSearchesWrapper"
    }, popularSearches.map(function(search) {
        return (search === null || search === void 0 ? void 0 : search.query) && /*#__PURE__*/ react.createElement(variants.TonalButton, {
            key: search.query,
            container: clickable/* Clickable */.P,
            containerProps: {
                to: linkTo("search", {
                    query: search.query
                }),
                "data-test": "PopularSearchQuery"
            },
            onClick: function() {
                return handleClick(search.query);
            },
            size: variants.ButtonSize.SMALL
        }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, null)), /*#__PURE__*/ react.createElement(variants.ButtonText, {
            behavior: ui_text.Behavior.OnelineEllipsis
        }, search.query));
    }));
};


/***/ }),

/***/ 70330:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ ProductMedia)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_lazy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85518);
/* harmony import */ var src_components_product_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95242);
/* harmony import */ var src_components_skeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75598);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: auto;\n  height: 100%;\n  max-height: ",
        ";\n  object-fit: contain;\n  border-radius: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  max-height: ",
        ";\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ProductMedia = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), _market = ref.market, market = _market === void 0 ? {
        cdn: "https://cdn.pji.nu"
    } : _market;
    var lazyLoadImage = props.lazyLoadImage, imageSize = props.imageSize, imageSrc = props.imageSrc, name = props.name, renderWithHalo = props.renderWithHalo;
    var fallback = "".concat(market.cdn, "/product/standard/280/0.jpg");
    var productImage = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductImage, {
        src: imageSrc,
        name: name,
        fallback: fallback,
        height: imageSize,
        width: imageSize,
        $size: "".concat(imageSize, "px"),
        className: props.className
    });
    var halo = renderWithHalo ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HaloWrapper, {
        $size: "".concat(imageSize, "px")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
        cx: "50",
        cy: "50",
        r: "50",
        fill: "#001624",
        fillOpacity: "0.06"
    }))) : null;
    var placeholder = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var inView = param.inView;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_skeleton__WEBPACK_IMPORTED_MODULE_5__/* .SkeletonMedia */ .zN, {
            height: imageSize,
            width: imageSize,
            paused: !inView
        });
    }, [
        imageSize
    ]);
    return lazyLoadImage ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_lazy__WEBPACK_IMPORTED_MODULE_3__/* .Lazy */ .o, {
        offset: 0,
        placeholder: placeholder
    }, productImage, halo) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, productImage, halo);
};
var ProductImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(src_components_product_image__WEBPACK_IMPORTED_MODULE_4__/* .ProductImage */ .q).withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.$size;
});
var HaloWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "HaloWrapper",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.$size;
});


/***/ }),

/***/ 6036:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ NewClickOutButton)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99816);
/* harmony import */ var _prisjakt_ui_icon_outgoing_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89975);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3616);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      pointer-events: none;\n      opacity: 0.24;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: 42px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  & > * {\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex: none;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  justify-content: center;\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  & > path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var ICON_SIZE = 15;
var NewClickOutButton = function(param) {
    var className = param.className, containerProps = param.containerProps, href = param.href, onClick = param.onClick, external = param.external, text = param.text, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? _prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_2__.ButtonType.PRIMARY : _buttonType;
    var linkProps = external ? {
        href: href,
        rel: "nofollow",
        target: "_blank"
    } : {
        to: href
    };
    var disabled = !href;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(OuterWrapper, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(StyledButton, {
        className: className,
        containerProps: _objectSpreadProps(_objectSpread({}, containerProps, linkProps), {
            "data-testid": "click-out-button"
        }),
        container: external ? "a" : react_router_dom__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU,
        disabled: disabled,
        onClick: onClick,
        fullWidth: true,
        type: disabled ? _prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_2__.ButtonType.TONAL : buttonType,
        "data-testid": "click-out-button"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(InnerWrapper, null, "".concat(text, " "), external && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(IconWrapper, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(IconOutgoingLinkWithColorFix, {
        size: ICON_SIZE
    })))));
};
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_2__.Button).withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject()));
});
var OuterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "OuterWrapper",
    componentId: "sc-0-1"
})(_templateObject2());
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-2"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var InnerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "InnerWrapper",
    componentId: "sc-0-3"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject4()));
var IconOutgoingLinkWithColorFix = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_outgoing_link__WEBPACK_IMPORTED_MODULE_3__/* .IconOutgoingLink */ .v).withConfig({
    displayName: "IconOutgoingLinkWithColorFix",
    componentId: "sc-0-4"
})(_templateObject6());


/***/ }),

/***/ 45443:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ Price)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21541);
/* harmony import */ var src_components_currency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65634);
/* harmony import */ var src_components_offer_price_price_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48711);




var Price = function(props) {
    var _isDeal = props.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, price = props.price, currency = props.currency;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_offer_price_price_text__WEBPACK_IMPORTED_MODULE_3__/* .PriceText */ .X, {
        color: isDeal ? _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__.FontColor.NEGATIVE : _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__.FontColor.DARK
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_currency__WEBPACK_IMPORTED_MODULE_2__/* .Currency */ .F, {
        price: price,
        code: currency
    }));
};


/***/ }),

/***/ 54305:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ SponsorText)
/* harmony export */ });
/* unused harmony export SponsorTextCaptionText */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21541);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25349);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  background-color: ",
        ";\n  padding: 0px 4px;\n  border-radius: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var IconInfoFilled = function(param) {
    var _size = param.size, size = _size === void 0 ? 24 : _size;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.0144 8.99519V6.97596H12.9856V8.99519H11.0144ZM12 2C13.8269 2 15.5176 2.45673 17.0721 3.37019C18.5785 4.23558 19.7644 5.42147 20.6298 6.92788C21.5433 8.48238 22 10.1731 22 12C22 13.8269 21.5433 15.5176 20.6298 17.0721C19.7644 18.5785 18.5785 19.7644 17.0721 20.6298C15.5176 21.5433 13.8269 22 12 22C10.1731 22 8.48238 21.5433 6.92788 20.6298C5.42147 19.7484 4.23558 18.5545 3.37019 17.0481C2.45673 15.4936 2 13.8109 2 12C2 10.1891 2.45673 8.50642 3.37019 6.95192C4.25161 5.44551 5.44551 4.25161 6.95192 3.37019C8.50642 2.45673 10.1891 2 12 2ZM11.0144 17.024V11.0144H12.9856V17.024H11.0144Z",
        fill: "rgb(24, 44, 57)"
    }));
};
var SponsorTextCaptionText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.CaptionText).withConfig({
    displayName: "SponsorTextCaptionText",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.colors.yellove100;
});
var SponsorText = function() {
    var t = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_3__/* .useAppContext */ .bp)().t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SponsorTextCaptionText, {
        emphasis: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.FontEmphasis.MEDIUM,
        flex: "none"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconInfoFilled, {
        size: 16
    }), "\xa0", t("product", "sponsored-product.title"));
};


/***/ }),

/***/ 90299:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yu": () => (/* reexport */ ProductCompactListCard),
  "r4": () => (/* reexport */ ProductGridCard),
  "MP": () => (/* reexport */ ProductListCard)
});

// UNUSED EXPORTS: CompareCheckbox, mapDataToProps

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/product-card-old/product-card-context.tsx
var product_card_context = __webpack_require__(5780);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33561);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/badges/deals-badge/index.tsx + 1 modules
var deals_badge = __webpack_require__(48285);
// EXTERNAL MODULE: ./src/components/badges/image-badges.tsx
var image_badges = __webpack_require__(21244);
// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(44266);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(33888);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(46256);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  text-align: initial;\n  padding-top: 0;\n  word-break: break-word;\n  gap: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  display: flex;\n  flex-direction: column;\n  z-index: ",
        ";\n\n  > *:not(:first-child) {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: visible;\n  height: ",
        ";\n  margin: ",
        "rem 0 ",
        " 0;\n\n  &::after {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    top: ",
        ";\n    left: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  padding: 0.1rem 0.4rem;\n  border-radius: 2px;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    align-items: center;\n    flex: 0 1 auto;\n    width: 100%;\n    ",
        "\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  white-space: nowrap;\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 2;\n  bottom: 0;\n  left: ",
        ";\n  max-height: 20px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  animation: ",
        " 250ms ease-in-out 1;\n  width: 100%;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 100%;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}









var Card = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "Card",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.background && (0,styled_components_browser_esm.css)(_templateObject(), p.theme.bg.primary);
}, function(p) {
    return p.highlight && "background-color: ".concat(p.theme.colors.yellove100, ";");
});
var Content = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "Content",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var ActionButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ActionButton",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, zindex/* zindex.actionButton */.Y.actionButton, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var PriceInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceInfo",
    componentId: "sc-0-3"
})(_templateObject4());
var Properties = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Properties",
    componentId: "sc-0-4"
})(function() {
    return "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n";
});
var Media = (0,styled_components_browser_esm["default"])(card.CardMedia).withConfig({
    displayName: "Media",
    componentId: "sc-0-5"
})(_templateObject5(), function(p) {
    return p.$size;
}, function(p) {
    return p.$marginRem;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var DiffPercentageCore = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DiffPercentageCore",
    componentId: "sc-0-6"
})(_templateObject7(), function(p) {
    return p.theme.colors.redio500;
}, base/* media.mediumUp */.BC.mediumUp(_templateObject6(), base/* layout.productCardPaddingLarge */.bK.productCardPaddingLarge, base/* layout.productCardPaddingLarge */.bK.productCardPaddingLarge));
var PriceWrapper = (0,styled_components_browser_esm["default"])(variants.Row).withConfig({
    displayName: "PriceWrapper",
    componentId: "sc-0-7"
})(_templateObject8(), function(p) {
    return p.isKWLP && "justify-content: space-between";
});
var StyledPrice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPrice",
    componentId: "sc-0-8"
})(_templateObject9(), function(p) {
    return p.flexEnd && "align-items: flex-end";
});
var BrandLogo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "BrandLogo",
    componentId: "sc-0-9"
})(_templateObject10(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShopLogo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "ShopLogo",
    componentId: "sc-0-10"
})(_templateObject11(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ClickOutFooter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ClickOutFooter",
    componentId: "sc-0-11"
})(_templateObject12());
var fadeIn = (0,styled_components_browser_esm.keyframes)(_templateObject13());
var ReportOverlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReportOverlay",
    componentId: "sc-0-12"
})(_templateObject14(), function(p) {
    return p.theme.text.secondary;
}, fadeIn);
var Options = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Options",
    componentId: "sc-0-13"
})(_templateObject15());
var Option = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Option",
    componentId: "sc-0-14"
})(_templateObject16(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var Dropdown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-15"
})(_templateObject17(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CenteredButtonText = (0,styled_components_browser_esm["default"])(ui_button.ButtonText).withConfig({
    displayName: "CenteredButtonText",
    componentId: "sc-0-16"
})(_templateObject18());
var StyledTopLeftArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTopLeftArea",
    componentId: "sc-0-17"
})(_templateObject19(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing075, zindex/* zindex.popover */.Y.popover);

;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/top-left-area.tsx







var TopLeftArea = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var ref1 = (0,product_card_context/* useProductCardContext */.I)(), diffPercentage = ref1.diffPercentage, hasExpertBadge = ref1.hasExpertBadge, _product = ref1.product, id = _product.id, priceSummary = _product.priceSummary, _type = ref1.type, type = _type === void 0 ? "product" : _type;
    var expertTopRatedBadgeUrl = "".concat(market.cdn, "/g/expert/").concat(market.code, "/expert-toprated-badge.png");
    var productOfTheYearAward = (0,hooks/* useGetProductOfTheYear */.i)(type === "product" ? id : undefined);
    var renderBadge = function() {
        if (diffPercentage && (priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular)) return /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
            "data-testid": "DealsBadge",
            priceDrop: diffPercentage,
            price: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular,
            popoverUniqueId: id || 0
        });
        if (productOfTheYearAward === null || productOfTheYearAward === void 0 ? void 0 : productOfTheYearAward.awardLogo) {
            return /*#__PURE__*/ react.createElement(image_badges/* GridCardImageBadge */.ni, {
                badgeUrl: productOfTheYearAward.awardLogo,
                title: "".concat(productOfTheYearAward.awardName, " ").concat(productOfTheYearAward.year)
            });
        }
        if (hasExpertBadge) {
            return /*#__PURE__*/ react.createElement(image_badges/* GridCardImageBadge */.ni, {
                badgeUrl: expertTopRatedBadgeUrl,
                title: t("expert", "expert.top-rated-badge")
            });
        }
        return null;
    };
    var badge = renderBadge();
    if (!badge) return null;
    return /*#__PURE__*/ react.createElement(StyledTopLeftArea, null, badge);
};

// EXTERNAL MODULE: ./src/areas/product-collection/tracking.ts + 2 modules
var tracking = __webpack_require__(91567);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/grid-card.tsx








var GridCard = function(props) {
    var children = props.children, className = props.className, _FooterArea = props.FooterArea, FooterArea = _FooterArea === void 0 ? null : _FooterArea, _isClickable = props.isClickable, isClickable = _isClickable === void 0 ? true : _isClickable, _outlined = props.outlined, outlined = _outlined === void 0 ? true : _outlined;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, market = ref.market, linkTo = ref.linkTo;
    var ref1 = (0,product_card_context/* useProductCardContext */.I)(), _ActionArea = ref1.ActionArea, ActionArea = _ActionArea === void 0 ? null : _ActionArea, background = ref1.background, onClick = ref1.onClick, product = ref1.product, tmp = ref1.selectStates, ref2 = tmp === void 0 ? {} : tmp, onDeselect = ref2.onDeselect, onSelect = ref2.onSelect, selectable = ref2.selectable, selected = ref2.selected;
    var pathName = product.pathName, sponsor = product.sponsor, id = product.id;
    var linkUrl = sponsor ? linkTo("product", product) : pathName;
    // Get our tracking functions
    var trackProductClick = (0,tracking/* useTrackProductCollectionClick */.K_)();
    var registerForImpressionTracking = (0,tracking/* useTrackProductCollectionImpression */.ST)().registerForImpressionTracking;
    // Ref for the card element to track impressions
    var cardRef = (0,react.useRef)(null);
    var onClickOrSelect = (0,react.useCallback)(function() {
        var handleSelect = function() {
            if (selected && onDeselect) onDeselect();
            else if (onSelect) onSelect();
        };
        if (selectable) handleSelect();
        else {
            if (sponsor) {
                trackProductClick(sponsor ? {
                    adId: sponsor.adId,
                    productId: Number(product.id)
                } : undefined);
            }
            if (onClick) onClick();
        }
    }, [
        selected,
        onDeselect,
        onSelect,
        selectable,
        onClick,
        id,
        sponsor,
        trackProductClick
    ]);
    // Set up impression tracking when component mounts
    (0,react.useEffect)(function() {
        if (sponsor === null || sponsor === void 0 ? void 0 : sponsor.adId) {
            registerForImpressionTracking(cardRef.current, sponsor.adId, Number(product.id));
        }
    }, [
        sponsor,
        registerForImpressionTracking
    ]);
    return /*#__PURE__*/ react.createElement(Card, {
        className: className,
        background: background,
        outlined: outlined,
        selected: selected,
        container: "article",
        containerProps: {
            "data-test": "ProductGridCard",
            ref: cardRef
        }
    }, /*#__PURE__*/ react.createElement(TopLeftArea, null), ActionArea && market.login.enabled && /*#__PURE__*/ react.createElement(ActionButton, null, ActionArea), isClickable ? /*#__PURE__*/ react.createElement(card.CardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: selectable ? undefined : linkUrl,
            isExternal: renderMode === "native",
            onClick: onClickOrSelect,
            style: {
                flex: "1 1 auto",
                cursor: "pointer"
            }
        }
    }, children) : children, FooterArea);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
// EXTERNAL MODULE: ./src/components/product-card-old/components/price.tsx
var components_price = __webpack_require__(45443);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/product-name.tsx


var ProductName = function(props) {
    var children = props.children;
    return /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        behavior: text_variants.Behavior.TwolineEllipsis,
        containerProps: {
            "data-test": "ProductName"
        }
    }, children);
};

// EXTERNAL MODULE: ./src/components/cdn-image/index.tsx
var cdn_image = __webpack_require__(71412);
// EXTERNAL MODULE: ./src/areas/keyword-landing-page/contexts.ts
var contexts = __webpack_require__(95785);
;// CONCATENATED MODULE: ./src/components/product-card-old/map-to-core-props.ts
var mapToCoreProperties = function(properties) {
    return Array.isArray(properties) ? properties.filter(function(param) {
        var isCore = param.isCore, pretty = param.pretty;
        return isCore && pretty !== null;
    }).map(function(item) {
        return getPropertyValueOrName(item);
    }).filter(function(item) {
        return item !== null;
    }).join(", ") : null;
};
var getPropertyValueOrName = function(property) {
    if (property.type === "boolean") {
        return property.pretty === "true" ? property.name : null;
    }
    var _pretty;
    return (_pretty = property.pretty) !== null && _pretty !== void 0 ? _pretty : null;
};

// EXTERNAL MODULE: ./src/components/product-card-old/components/sponsor-text.tsx
var sponsor_text = __webpack_require__(54305);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/grid-card-content.tsx













var GridCardContent = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), showPrefixFromPrice = ref.showPrefixFromPrice, highlightedName = ref.highlightedName, _product = ref.product, aggregatedRating = _product.aggregatedRating, category = _product.category, name = _product.name, priceSummary = _product.priceSummary, properties = _product.properties, store = _product.store, userReviewSummary = _product.userReviewSummary, sponsor = _product.sponsor, showCategoryButton = ref.showCategoryButton;
    var price = priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular;
    var rating = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.score) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.rating);
    var reviewsCount = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.count) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.count);
    var isKWLP = (0,contexts/* useIsKWLP */._)();
    var coreProperties = mapToCoreProperties(properties === null || properties === void 0 ? void 0 : properties.nodes);
    return /*#__PURE__*/ react.createElement(Content, null, (category === null || category === void 0 ? void 0 : category.name) && !showCategoryButton && /*#__PURE__*/ react.createElement(text_variants.CaptionText, {
        emphasis: text_variants.FontEmphasis.MEDIUM,
        flex: "none"
    }, category.name), sponsor && /*#__PURE__*/ react.createElement(sponsor_text/* SponsorText */.k, null), /*#__PURE__*/ react.createElement(ProductName, null, highlightedName || name), typeof coreProperties === "string" && /*#__PURE__*/ react.createElement(Properties, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        emphasis: text_variants.FontEmphasis.MEDIUM
    }, coreProperties)), rating && rating > 0 ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        count: reviewsCount,
        showCounterAs: "number"
    }) : null, price ? /*#__PURE__*/ react.createElement(PriceWrapper, {
        gap: 0.5,
        isKWLP: isKWLP
    }, /*#__PURE__*/ react.createElement(StyledPrice, {
        flexEnd: showPrefixFromPrice
    }, showPrefixFromPrice && /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, t("product", "price.from-abbr")), /*#__PURE__*/ react.createElement(components_price/* Price */.t, {
        price: price,
        currency: store === null || store === void 0 ? void 0 : store.currency
    })), store && (isKWLP ? /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
        name: store && store.id || "",
        alt: store && store.name || "",
        height: 22
    }) : /*#__PURE__*/ react.createElement(ShopLogo, {
        variant: store_logo/* StoreLogoVariant.CAMPAIGN */.mA.CAMPAIGN,
        name: store.name,
        storeId: store.id,
        featured: true,
        hasImage: store.hasLogo || false
    }))) : /*#__PURE__*/ react.createElement("span", null, "\xa0"));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/check/index.js
var check = __webpack_require__(24300);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/compare-checkbox.tsx
function compare_checkbox_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compare_checkbox_templateObject() {
    var data = compare_checkbox_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: calc(",
        " - 4px);\n  left: calc(",
        " - 4px);\n  z-index: 102;\n  padding: ",
        ";\n  background: rgba(255, 255, 255, 0.72);\n  border-radius: 4px;\n"
    ]);
    compare_checkbox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compare_checkbox_templateObject1() {
    var data = compare_checkbox_taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  background: ",
        ";\n  box-shadow: ",
        ";\n  border-radius: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ",
        ";\n"
    ]);
    compare_checkbox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



// Prerequisites before replacing this with @prisjakt/ui/checkbox:
// 1. Change selected color on @prisjakt/ui/card from yellow to blue
// 2. Remove inner margin from @prisjakt/ui/checkbox
// 3. Maybe allow @prisjakt/ui/checkbox to be controlled (i.e. remove requirement of onChange)

var SIZE = 18;
var CompareCheckbox = function(props) {
    return /*#__PURE__*/ react.createElement(CheckboxWrapper, {
        className: props.className
    }, /*#__PURE__*/ react.createElement(SelectedCheckbox, {
        $selected: props.selected
    }, props.selected && /*#__PURE__*/ react.createElement(check/* IconCheck */.N, {
        color: "base0",
        size: 14
    })));
};
var CheckboxWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CheckboxWrapper",
    componentId: "sc-0-0"
})(compare_checkbox_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var SelectedCheckbox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SelectedCheckbox",
    componentId: "sc-0-1"
})(compare_checkbox_templateObject1(), SIZE, SIZE, function(p) {
    return p.$selected ? p.theme.colors.yellove500 : "transparent";
}, function(p) {
    return p.$selected ? "none" : "inset 0 0 0 1px ".concat(p.theme.lines.quaternary);
}, function(p) {
    return p.theme.colors.base0;
});

// EXTERNAL MODULE: ./src/components/product-card-old/components/media.tsx
var components_media = __webpack_require__(70330);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/grid-card-header.tsx





var GridCardHeader = function(props) {
    var _marginRem = props.marginRem, marginRem = _marginRem === void 0 ? 1 : _marginRem, _imageSize = props.imageSize, imageSize = _imageSize === void 0 ? 140 : _imageSize;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _product = ref.product, brand = _product.brand, media = _product.media, name = _product.name, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, selectable = ref1.selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected, _shouldLazyLoadImage = ref.shouldLazyLoadImage, shouldLazyLoadImage = _shouldLazyLoadImage === void 0 ? false : _shouldLazyLoadImage;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, selectable ? /*#__PURE__*/ react.createElement(CompareCheckbox, {
        selected: selected
    }) : null, /*#__PURE__*/ react.createElement(Media, {
        $marginRem: marginRem,
        $size: shouldLazyLoadImage ? "".concat(imageSize, "px") : "auto"
    }, (brand === null || brand === void 0 ? void 0 : brand.logo) && /*#__PURE__*/ react.createElement(BrandLogo, {
        src: brand.logo,
        alt: brand.name || ""
    }), /*#__PURE__*/ react.createElement(components_media/* ProductMedia */.S, {
        lazyLoadImage: shouldLazyLoadImage,
        imageSize: imageSize,
        imageSrc: media === null || media === void 0 ? void 0 : media.first,
        name: name || ""
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(31744);
// EXTERNAL MODULE: ./src/areas/product/utils/index.ts
var utils = __webpack_require__(852);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(89975);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/click-out-button.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function click_out_button_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function click_out_button_templateObject() {
    var data = click_out_button_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  & > * {\n    vertical-align: middle;\n  }\n"
    ]);
    click_out_button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function click_out_button_templateObject1() {
    var data = click_out_button_taggedTemplateLiteral([
        "\n  height: 74px;\n  display: flex;\n  justify-content: center;\n  padding: ",
        ";\n  width: 100%;\n"
    ]);
    click_out_button_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function click_out_button_templateObject2() {
    var data = click_out_button_taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n  text-align: center;\n  overflow: hidden;\n  ",
        "\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: calc(100% - (",
        "px + ",
        "));\n"
    ]);
    click_out_button_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function click_out_button_templateObject3() {
    var data = click_out_button_taggedTemplateLiteral([
        "\n    justify-content: center;\n  "
    ]);
    click_out_button_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function click_out_button_templateObject4() {
    var data = click_out_button_taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    click_out_button_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var ICON_SIZE = 15;
var ClickOutButton = function(props) {
    var className = props.className, href = props.href, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = props.onClick, store = props.store, featured = props.featured, containerProps = props.containerProps;
    var renderButtonContent = function() {
        if (!store) {
            return null;
        }
        if (featured) {
            return /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
                name: store && store.id || "",
                alt: store && store.name || ""
            });
        }
        return store.name;
    };
    var renderClickOutIcon = function() {
        if (!featured) return null;
        return /*#__PURE__*/ react.createElement(IconWrapper, null, /*#__PURE__*/ react.createElement(outgoing_link/* IconOutgoingLink */.v, {
            color: "base400",
            size: ICON_SIZE
        }));
    };
    return /*#__PURE__*/ react.createElement(OuterWrapper, null, /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
        className: className,
        containerProps: _objectSpread({}, containerProps, href && {
            href: href || "",
            rel: "nofollow",
            target: "_blank"
        }),
        container: href ? "a" : undefined,
        disabled: disabled,
        onClick: onClick,
        fullWidth: true
    }, /*#__PURE__*/ react.createElement(InnerWrapper, null, /*#__PURE__*/ react.createElement(StoreInfo, {
        image: store && featured || false
    }, renderButtonContent()), renderClickOutIcon())));
};
var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-0"
})(click_out_button_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var OuterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "OuterWrapper",
    componentId: "sc-0-1"
})(click_out_button_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StoreInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreInfo",
    componentId: "sc-0-2"
})(click_out_button_templateObject2(), function(p) {
    return !p.image ? "padding: 1px 0;" : "";
}, ICON_SIZE, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var InnerWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InnerWrapper",
    componentId: "sc-0-3"
})(click_out_button_templateObject4(), base/* media.smallOnly */.BC.smallOnly(click_out_button_templateObject3()));

// EXTERNAL MODULE: ./src/components/product-card-old/components/new-click-out-button.tsx
var new_click_out_button = __webpack_require__(6036);
// EXTERNAL MODULE: ./src/utils/click-out-bounce-helper.ts
var click_out_bounce_helper = __webpack_require__(40757);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var actions_product = __webpack_require__(69140);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/grid-card-offer-footer.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function grid_card_offer_footer_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function grid_card_offer_footer_templateObject() {
    var data = grid_card_offer_footer_taggedTemplateLiteral([
        "\n  && {\n    justify-self: flex-end;\n    flex: 0;\n    ",
        ": 0;\n    gap: ",
        ";\n  }\n"
    ]);
    grid_card_offer_footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var GridCardOfferFooter = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), onClick = ref.onClick, product = ref.product;
    var featuredOverride = product.featuredOverride, pathName = product.pathName, store = product.store;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = _slicedToArray((0,react.useState)(false), 2), showPopover = ref1[0], setShowPopover = ref1[1];
    var uid = (0,react.useId)();
    var isKWLP = (0,contexts/* useIsKWLP */._)();
    var featured = (0,utils/* getIsFeatured */.ZF)({
        featuredOverride: featuredOverride,
        store: store,
        externalUri: pathName
    });
    var handleBounce = function() {
        var ref, ref1;
        var parsedProductId = parseInt(((ref = product.id) === null || ref === void 0 ? void 0 : ref.toString()) || "0", 10);
        dispatch((0,actions_product/* productClickOutBounce */.nA)({
            productId: parsedProductId,
            offerId: undefined,
            storeName: ((ref1 = product.store) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
        }));
    };
    var handleClick = function() {
        if (!featured) setShowPopover(true);
        if (onClick) {
            onClick();
            (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
        }
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(FooterContent, {
        isKWLP: isKWLP
    }, isKWLP ? /*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
        href: pathName || "",
        onClick: handleClick,
        external: true,
        text: t("product", "external-link.visit-shop")
    }) : /*#__PURE__*/ react.createElement(ClickOutButton, {
        containerProps: {
            "aria-describedby": "offer-".concat(uid)
        },
        store: store,
        href: featured && pathName || "",
        onClick: handleClick,
        featured: featured
    })), !featured && /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "offer-".concat(uid),
        visible: showPopover,
        width: 250,
        offsetY: 0,
        offsetX: 0,
        verticalAlign: popover/* Alignment.End */.v2.End,
        horizontalAlign: popover/* Alignment.Center */.v2.Center,
        onClose: function() {
            return setShowPopover(false);
        },
        zIndex: 20
    }, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, t("product", "transparency.store-info"))));
};
var FooterContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "FooterContent",
    componentId: "sc-0-0"
})(grid_card_offer_footer_templateObject(), function(p) {
    return p.isKWLP ? "padding-top" : "padding";
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/grid-card-product-footer.tsx
function grid_card_product_footer_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function grid_card_product_footer_templateObject() {
    var data = grid_card_product_footer_taggedTemplateLiteral([
        "\n  && {\n    padding-top: 0;\n    justify-content: end;\n    gap: ",
        ";\n  }\n"
    ]);
    grid_card_product_footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var GridCardProductFooter = function() {
    var isKWLP = (0,contexts/* useIsKWLP */._)();
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), onClick = ref.onClick, _product = ref.product, category = _product.category, pathName = _product.pathName, _showCategoryButton = ref.showCategoryButton, showCategoryButton = _showCategoryButton === void 0 ? false : _showCategoryButton;
    var footerContent = [];
    if (isKWLP) {
        footerContent.push(/*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
            key: "click-out-button",
            href: pathName || "",
            onClick: function() {
                return onClick === null || onClick === void 0 ? void 0 : onClick();
            },
            text: t("product", "kwlp.compare-prices")
        }));
    }
    var categoryAsCategory = category;
    if (showCategoryButton && (categoryAsCategory === null || categoryAsCategory === void 0 ? void 0 : categoryAsCategory.name) && (categoryAsCategory === null || categoryAsCategory === void 0 ? void 0 : categoryAsCategory.pathName)) {
        footerContent.push(/*#__PURE__*/ react.createElement(button_variants.TonalButton, {
            container: react_router_dom/* Link */.rU,
            containerProps: {
                to: categoryAsCategory.pathName
            },
            fullWidth: true
        }, /*#__PURE__*/ react.createElement(CenteredButtonText, {
            behavior: ui_text.Behavior.OnelineEllipsis
        }, categoryAsCategory.name)));
    }
    return footerContent.length ? /*#__PURE__*/ react.createElement(Footer, null, footerContent) : null;
};
var Footer = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "Footer",
    componentId: "sc-0-0"
})(grid_card_product_footer_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/index.tsx







var ProductGridCard = function(props) {
    var className = props.className;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), FooterArea = ref.FooterArea, _type = ref.type, type = _type === void 0 ? "product" : _type;
    // The card shouldn't be clickable for offers
    var isClickable = type === "product";
    return /*#__PURE__*/ react.createElement(GridCard, {
        className: className,
        isClickable: isClickable,
        FooterArea: FooterArea || /*#__PURE__*/ react.createElement(grid_Footer, null),
        outlined: true
    }, /*#__PURE__*/ react.createElement(GridCardHeader, null), /*#__PURE__*/ react.createElement(GridCardContent, null));
};
var grid_Footer = function() {
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _type = ref.type, type = _type === void 0 ? "product" : _type;
    if (type === "product") return /*#__PURE__*/ react.createElement(GridCardProductFooter, null);
    if (type === "offer") return /*#__PURE__*/ react.createElement(GridCardOfferFooter, null);
    return null;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/variants.js
var card_variants = __webpack_require__(77243);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    grid-template-columns: auto minmax(0, 1fr);\n    grid-template-rows: auto 1fr;\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 3fr 1fr;\n  width: 100%;\n\n  ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  text-align: initial;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  align-items: flex-end;\n  justify-content: space-between;\n  flex: 1 1 auto;\n\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n    ",
        " {\n      padding-top: 0;\n    }\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    position: relative;\n    height: fit-content;\n    width: ",
        ";\n    padding: 0;\n    margin: ",
        ";\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 2;\n  bottom: 0;\n  max-height: 24px;\n  background: rgba(255, 255, 255, 0.72);\n  border-radius: 4px;\n  padding: 2px;\n\n  &:not(:last-child) {\n    margin: 0;\n  }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  align-items: center;\n  flex-wrap: wrap;\n\n  > * {\n    margin: 0;\n    max-width: max-content;\n\n    &:not(:last-child) {\n      margin-right: ",
        ";\n    }\n  }\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  padding: 2px ",
        ";\n  border-radius: 3px;\n  width: max-content;\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n    align-items: flex-start;\n    width: 100%;\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  white-space: nowrap;\n  max-width: 100%;\n\n  ",
        "\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    align-items: center;\n    flex: 0 1 auto;\n    margin-top: auto;\n  }\n\n  svg {\n    fill: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = styles_taggedTemplateLiteral([
        "\n  align-items: baseline;\n  flex-wrap: wrap;\n\n  /* stylelint-disable */\n  > * {\n    flex: 0 1 auto;\n  }\n  /* stylelint-enable */\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}





var CardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "CardActionArea",
    componentId: "sc-0-0"
})(styles_templateObject());
var Main = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Main",
    componentId: "sc-0-1"
})(styles_templateObject2(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject1()));
var MainContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "MainContent",
    componentId: "sc-0-2"
})(styles_templateObject3());
var PriceContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "PriceContent",
    componentId: "sc-0-3"
})(styles_templateObject5(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject4()));
var styles_Card = (0,styled_components_browser_esm["default"])(card_variants/* RowCard */.Jz).withConfig({
    displayName: "Card",
    componentId: "sc-0-4"
})(styles_templateObject7(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject6(), PriceContent), function(p) {
    return p.highlight && "background-color: ".concat(p.theme.colors.yellove100, ";");
});
var ImageWrapper = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-5"
})(styles_templateObject8(), function(p) {
    return p.$size;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var styles_BrandLogo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "BrandLogo",
    componentId: "sc-0-6"
})(styles_templateObject9());
var RowWrapper = (0,styled_components_browser_esm["default"])(variants.Row).withConfig({
    displayName: "RowWrapper",
    componentId: "sc-0-7"
})(styles_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Tag = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Tag",
    componentId: "sc-0-8"
})(styles_templateObject11(), function(p) {
    return p.theme.bg.secondary;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var PriceRowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceRowWrapper",
    componentId: "sc-0-9"
})(styles_templateObject13(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject12()));
var CTAText = (0,styled_components_browser_esm["default"])(variants.Row).withConfig({
    displayName: "CTAText",
    componentId: "sc-0-10"
})(styles_templateObject15(), function(p) {
    return p.theme.icons.callToAction;
}, base/* media.mediumDown */.BC.mediumDown(styles_templateObject14()));
var PriceTextWrapper = (0,styled_components_browser_esm["default"])(variants.Row).withConfig({
    displayName: "PriceTextWrapper",
    componentId: "sc-0-11"
})(styles_templateObject16());

;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card.tsx





var ListCard = function(props) {
    var className = props.className, children = props.children, isClickable = props.isClickable, highlight = props.highlight;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), ActionArea = ref.ActionArea, container = ref.container, onClick = ref.onClick, product = ref.product, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, onDeselect = ref1.onDeselect, onSelect = ref1.onSelect, selectable = ref1.selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var id = product.id, pathName = product.pathName, sponsor = product.sponsor;
    var linkUrl = sponsor ? linkTo("product", product) : pathName;
    var handleSelect = function(productId) {
        if (!productId) {
            return;
        }
        if (selected && onDeselect) onDeselect();
        else if (onSelect) onSelect();
    };
    var handleOnClick = function() {
        if (onClick && id) onClick(id);
    };
    return /*#__PURE__*/ react.createElement(styles_Card, {
        selected: selected,
        highlight: highlight,
        className: className,
        container: container,
        containerProps: {
            "data-test": "ProductListCard"
        }
    }, !selectable && ActionArea ? ActionArea : null, isClickable ? /*#__PURE__*/ react.createElement(CardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: selectable ? undefined : linkUrl,
            onClick: selectable ? function() {
                return handleSelect(id);
            } : handleOnClick
        }
    }, /*#__PURE__*/ react.createElement(Main, null, children)) : /*#__PURE__*/ react.createElement(Main, null, children));
};

// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card-content.tsx













var ListCardContent = function(props) {
    var showFromPrice = props.showFromPrice;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _diffPercentage = ref.diffPercentage, diffPercentage = _diffPercentage === void 0 ? 0 : _diffPercentage, highlightedName = ref.highlightedName, _product = ref.product, id = _product.id, aggregatedRating = _product.aggregatedRating, name = _product.name, popularity = _product.popularity, priceSummary = _product.priceSummary, properties = _product.properties, store = _product.store, userReviewSummary = _product.userReviewSummary, sponsor = _product.sponsor;
    var coreProperties = mapToCoreProperties(properties === null || properties === void 0 ? void 0 : properties.nodes);
    var rank = popularity === null || popularity === void 0 ? void 0 : popularity.inCategory;
    var rating = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.score) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.rating);
    var reviewsCount = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.count) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.count);
    return /*#__PURE__*/ react.createElement(MainContent, null, sponsor && /*#__PURE__*/ react.createElement(sponsor_text/* SponsorText */.k, null), /*#__PURE__*/ react.createElement(ProductName, null, highlightedName || name), coreProperties ? /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        emphasis: text_variants.FontEmphasis.MEDIUM
    }, coreProperties) : null, /*#__PURE__*/ react.createElement(RowWrapper, null, rank ? /*#__PURE__*/ react.createElement(Tag, null, /*#__PURE__*/ react.createElement(text_variants.CaptionText, {
        emphasis: text_variants.FontEmphasis.MEDIUM
    }, t("product", "rank.position", {
        rank: rank
    }))) : null, rating ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        count: reviewsCount,
        showCounter: true,
        showCounterAs: "number",
        showRate: true,
        showRateAs: "number"
    })), /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        count: reviewsCount,
        showCounter: true,
        showCounterAs: "number",
        showRate: true,
        showRateAs: "number",
        singleStar: true
    }))) : null), /*#__PURE__*/ react.createElement(RowWrapper, null, diffPercentage && (priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular) ? /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
        "data-testid": "DealsBadge",
        priceDrop: diffPercentage,
        price: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular,
        popoverUniqueId: id || 0
    }) : null, (priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular) ? /*#__PURE__*/ react.createElement(PriceTextWrapper, {
        gap: 0.5
    }, showFromPrice && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        emphasis: text_variants.FontEmphasis.LOW
    }, t("product", "price.from-abbr")), " "), /*#__PURE__*/ react.createElement(components_price/* Price */.t, {
        price: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular,
        currency: store === null || store === void 0 ? void 0 : store.currency
    }), Boolean(priceSummary.includeShipping) && /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        emphasis: text_variants.FontEmphasis.LOW
    }, t("product", "price.including-shipping", {
        price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: priceSummary.includeShipping
        })
    }))) : /*#__PURE__*/ react.createElement("span", null, "\xa0")));
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card-media.tsx





var ListCardMedia = function(props) {
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _imageSize = ref.imageSize, imageSize = _imageSize === void 0 ? 100 : _imageSize, _product = ref.product, brand = _product.brand, media = _product.media, name = _product.name, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, selectable = ref1.selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected, _shouldLazyLoadImage = ref.shouldLazyLoadImage, shouldLazyLoadImage = _shouldLazyLoadImage === void 0 ? false : _shouldLazyLoadImage;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, selectable ? /*#__PURE__*/ react.createElement(CompareCheckbox, {
        selected: selected
    }) : null, /*#__PURE__*/ react.createElement(ImageWrapper, {
        $size: "".concat(imageSize, "px")
    }, (brand === null || brand === void 0 ? void 0 : brand.logo) && /*#__PURE__*/ react.createElement(styles_BrandLogo, {
        src: brand.logo,
        alt: brand.name || ""
    }), props.children, /*#__PURE__*/ react.createElement(components_media/* ProductMedia */.S, {
        imageSrc: media === null || media === void 0 ? void 0 : media.first,
        imageSize: imageSize,
        name: name || "",
        lazyLoadImage: shouldLazyLoadImage
    })));
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card-offer-footer.tsx
function list_card_offer_footer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function list_card_offer_footer_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function list_card_offer_footer_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function list_card_offer_footer_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function list_card_offer_footer_slicedToArray(arr, i) {
    return list_card_offer_footer_arrayWithHoles(arr) || list_card_offer_footer_iterableToArrayLimit(arr, i) || list_card_offer_footer_unsupportedIterableToArray(arr, i) || list_card_offer_footer_nonIterableRest();
}
function list_card_offer_footer_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function list_card_offer_footer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return list_card_offer_footer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return list_card_offer_footer_arrayLikeToArray(o, minLen);
}
function list_card_offer_footer_templateObject() {
    var data = list_card_offer_footer_taggedTemplateLiteral([
        "\n    max-width: 100%;\n    grid-column-start: 1;\n    grid-column-end: 3;\n  "
    ]);
    list_card_offer_footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_card_offer_footer_templateObject1() {
    var data = list_card_offer_footer_taggedTemplateLiteral([
        "\n  max-width: 250px;\n  min-width: 200px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    list_card_offer_footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var ListCardOfferFooter = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), onClick = ref.onClick, _product = ref.product, featuredOverride = _product.featuredOverride, pathName = _product.pathName, store = _product.store, id = _product.id;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = list_card_offer_footer_slicedToArray((0,react.useState)(false), 2), showPopover = ref1[0], setShowPopover = ref1[1];
    var uid = (0,react.useId)();
    var featured = (0,utils/* getIsFeatured */.ZF)({
        featuredOverride: featuredOverride,
        store: store,
        externalUri: pathName
    });
    var handleBounce = function() {
        var parsedProductId = parseInt((id || 0).toString(), 10);
        dispatch((0,actions_product/* productClickOutBounce */.nA)({
            productId: parsedProductId,
            offerId: null,
            storeName: store === null || store === void 0 ? void 0 : store.name
        }));
    };
    var handleClick = function() {
        if (!featured) setShowPopover(true);
        if (onClick) {
            onClick();
            (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
        }
    };
    return /*#__PURE__*/ react.createElement(ButtonWrapper, null, /*#__PURE__*/ react.createElement(ClickOutButton, {
        store: store,
        href: featured && pathName || "",
        onClick: handleClick,
        featured: featured,
        containerProps: {
            "aria-describedby": "offer-".concat(uid)
        }
    }), !featured && /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "offer-".concat(uid),
        visible: showPopover,
        width: 250,
        offsetY: 0,
        offsetX: 0,
        verticalAlign: popover/* Alignment.Center */.v2.Center,
        horizontalAlign: popover/* Alignment.End */.v2.End,
        onClose: function() {
            return setShowPopover(false);
        },
        zIndex: 20
    }, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, t("product", "transparency.store-info"))));
};
var ButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ButtonWrapper",
    componentId: "sc-0-0"
})(list_card_offer_footer_templateObject1(), base/* media.mediumDown */.BC.mediumDown(list_card_offer_footer_templateObject()));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(93345);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card-product-footer.tsx






var ListCardProductFooter = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), priceSummary = ref.product.priceSummary;
    var priceCount = priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.count;
    return priceCount ? /*#__PURE__*/ react.createElement(PriceContent, null, typeof priceCount === "number" && /*#__PURE__*/ react.createElement(CTAText, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        color: text_variants.FontColor.PRIMARY
    }, t("category", "product-offer.cta", {
        n: priceCount
    })), /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, {
        color: "maybeBlue700"
    }))) : null;
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/index.tsx










var ProductListCard = function(param) {
    var className = param.className;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var ref1 = (0,product_card_context/* useProductCardContext */.I)(), hasExpertBadge = ref1.hasExpertBadge, id = ref1.product.id, _type = ref1.type, type = _type === void 0 ? "product" : _type;
    var expertTopRatedBadgeUrl = "".concat(market.cdn, "/g/expert/").concat(market.code, "/expert-toprated-badge.png");
    // The card shouldn't be clickable for offers
    var isClickable = type === "product";
    var productOfTheYearAward = (0,hooks/* useGetProductOfTheYear */.i)(type === "product" ? id : undefined);
    var productBadge = (0,react.useMemo)(function() {
        if (productOfTheYearAward === null || productOfTheYearAward === void 0 ? void 0 : productOfTheYearAward.awardLogo) {
            return /*#__PURE__*/ react.createElement(image_badges/* ListCardImageBadge */.rn, {
                badgeUrl: productOfTheYearAward.awardLogo,
                title: "".concat(productOfTheYearAward.awardName, " ").concat(productOfTheYearAward.year)
            });
        }
        if (hasExpertBadge) {
            return /*#__PURE__*/ react.createElement(image_badges/* ListCardImageBadge */.rn, {
                badgeUrl: expertTopRatedBadgeUrl,
                title: t("expert", "expert.top-rated-badge")
            });
        }
        return null;
    }, [
        productOfTheYearAward,
        hasExpertBadge,
        expertTopRatedBadgeUrl,
        t
    ]);
    return /*#__PURE__*/ react.createElement(ListCard, {
        className: className,
        isClickable: isClickable
    }, /*#__PURE__*/ react.createElement(ListCardMedia, null, " ", productBadge, " "), /*#__PURE__*/ react.createElement(ListCardContent, {
        showFromPrice: type === "product"
    }), type === "offer" && /*#__PURE__*/ react.createElement(ListCardOfferFooter, null), type === "product" && /*#__PURE__*/ react.createElement(ListCardProductFooter, null));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/clickable/index.js
var ui_clickable = __webpack_require__(42007);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/styles.ts
function compact_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compact_styles_templateObject() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-gap: ",
        ";\n  grid-auto-flow: column;\n  grid-template-columns: auto 1fr;\n  justify-items: start;\n  align-items: center;\n  padding: ",
        ";\n"
    ]);
    compact_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compact_styles_templateObject1() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n  text-align: inherit;\n  cursor: pointer;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    compact_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compact_styles_templateObject2() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    compact_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function compact_styles_templateObject3() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  display: block;\n  position: relative;\n  ",
        "\n"
    ]);
    compact_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function compact_styles_templateObject4() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  justify-self: start;\n  text-align: left;\n  cursor: pointer;\n"
    ]);
    compact_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function compact_styles_templateObject5() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  vertical-align: middle;\n  margin-left: ",
        ";\n"
    ]);
    compact_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var wrapperStyles = (0,styled_components_browser_esm.css)(compact_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ProductLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-0"
})(compact_styles_templateObject1(), wrapperStyles, function(p) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.base800, "0.04");
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(compact_styles_templateObject2(), wrapperStyles);
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-2"
})(compact_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.base200;
}, function(p) {
    return p.highlight && "background-color: ".concat(p.theme.colors.yellove100, ";");
});
var OfferLink = (0,styled_components_browser_esm["default"])(ui_clickable.Clickable).withConfig({
    displayName: "OfferLink",
    componentId: "sc-0-3"
})(compact_styles_templateObject4());
var OfferStoreIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "OfferStoreIconWrapper",
    componentId: "sc-0-4"
})(compact_styles_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card.tsx




var CompactListCard = function(props) {
    var className = props.className, children = props.children, isClickable = props.isClickable;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), onClick = ref.onClick, product = ref.product, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, onDeselect = ref1.onDeselect, onSelect = ref1.onSelect, _selectable = ref1.selectable, selectable = _selectable === void 0 ? false : _selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var id = product.id, pathName = product.pathName, sponsor = product.sponsor;
    var linkUrl = sponsor ? linkTo("product", product) : pathName;
    var handleSelect = function(productId) {
        if (!productId) return;
        if (selected && onDeselect) onDeselect();
        else if (onSelect) onSelect();
    };
    var handleOnClick = function(productId) {
        if (!productId) return;
        if (onClick) onClick(productId);
    };
    return /*#__PURE__*/ react.createElement(ListItem, {
        className: className,
        "data-test": "ProductCompactListCard",
        isSelectingProducts: selectable,
        key: id
    }, isClickable ? /*#__PURE__*/ react.createElement(ProductLink, {
        to: selectable ? undefined : linkUrl,
        onClick: selectable ? function() {
            return handleSelect(id);
        } : function() {
            return handleOnClick(id);
        }
    }, children) : /*#__PURE__*/ react.createElement(Wrapper, null, children));
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card-product-content.tsx





var RATING_TRANSLATION = {
    domain: "product",
    key: "product-card.n-ratings"
};
var CompactListCardProductContent = function() {
    var ref = (0,product_card_context/* useProductCardContext */.I)(), highlightedName = ref.highlightedName, _product = ref.product, aggregatedRating = _product.aggregatedRating, name = _product.name, userReviewSummary = _product.userReviewSummary, sponsor = _product.sponsor;
    var rating = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.score) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.rating);
    var reviewsCount = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.count) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.count);
    return /*#__PURE__*/ react.createElement("div", null, sponsor && /*#__PURE__*/ react.createElement(sponsor_text/* SponsorText */.k, null), /*#__PURE__*/ react.createElement(ProductName, null, highlightedName || name), rating && rating > 0 ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        singleStar: true,
        showRate: true,
        showCounter: true,
        count: reviewsCount,
        countTranslation: RATING_TRANSLATION,
        size: "small"
    }) : null);
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card-offer-content.tsx
function compact_list_card_offer_content_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function compact_list_card_offer_content_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function compact_list_card_offer_content_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function compact_list_card_offer_content_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function compact_list_card_offer_content_slicedToArray(arr, i) {
    return compact_list_card_offer_content_arrayWithHoles(arr) || compact_list_card_offer_content_iterableToArrayLimit(arr, i) || compact_list_card_offer_content_unsupportedIterableToArray(arr, i) || compact_list_card_offer_content_nonIterableRest();
}
function compact_list_card_offer_content_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compact_list_card_offer_content_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return compact_list_card_offer_content_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return compact_list_card_offer_content_arrayLikeToArray(o, minLen);
}
function compact_list_card_offer_content_templateObject() {
    var data = compact_list_card_offer_content_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: ",
        ";\n"
    ]);
    compact_list_card_offer_content_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var CompactListCardOfferContent = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), highlightedName = ref.highlightedName, onClick = ref.onClick, _product = ref.product, featuredOverride = _product.featuredOverride, name = _product.name, pathName = _product.pathName, store = _product.store, id = _product.id;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = compact_list_card_offer_content_slicedToArray((0,react.useState)(false), 2), showPopover = ref1[0], setShowPopover = ref1[1];
    var uid = (0,react.useId)();
    var featured = (0,utils/* getIsFeatured */.ZF)({
        featuredOverride: featuredOverride,
        store: store,
        externalUri: pathName
    });
    var handleBounce = function() {
        var parsedProductId = parseInt((id || 0).toString(), 10);
        dispatch((0,actions_product/* productClickOutBounce */.nA)({
            productId: parsedProductId,
            offerId: null,
            storeName: store === null || store === void 0 ? void 0 : store.name
        }));
    };
    var handleClick = function() {
        if (!featured) setShowPopover(true);
        if (onClick) {
            onClick();
            (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
        }
    };
    var getContainerProps = function() {
        var containerProps = {
            target: "_blank",
            rel: "nofollow"
        };
        if (featured) {
            containerProps.href = pathName;
        }
        return containerProps;
    };
    var renderClickOutIcon = function() {
        if (!featured) return null;
        return /*#__PURE__*/ react.createElement(OfferStoreIconWrapper, null, /*#__PURE__*/ react.createElement(outgoing_link/* IconOutgoingLink */.v, {
            size: 14,
            color: "base400"
        }));
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(OfferLink, {
        container: "a",
        containerProps: getContainerProps(),
        onClick: handleClick,
        "aria-describedby": "offer-".concat(uid)
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        containerProps: {
            "data-test": "OfferName"
        }
    }, highlightedName || (name && name.length > 100 ? "".concat(name.substring(0, 100), "...") : name), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        color: text_variants.FontColor.DARK,
        emphasis: text_variants.FontEmphasis.LOW
    }, store && store.name), renderClickOutIcon())))), !featured && /*#__PURE__*/ react.createElement(PopoverWrapper, null, /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "offer-".concat(uid),
        visible: showPopover,
        width: 250,
        offsetY: 0,
        offsetX: 0,
        verticalAlign: popover/* Alignment.Center */.v2.Center,
        horizontalAlign: popover/* Alignment.Start */.v2.Start,
        onClose: function() {
            return setShowPopover(false);
        },
        zIndex: zindex/* zindex.popover */.Y.popover
    }, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, t("product", "transparency.store-info")))));
};
// Popover's outermost element must be absolute positioned to not claim space when in a css-grid layout
var PopoverWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PopoverWrapper",
    componentId: "sc-0-0"
})(compact_list_card_offer_content_templateObject(), zindex/* zindex.popover */.Y.popover);

// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card-media.tsx
function compact_list_card_media_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compact_list_card_media_templateObject() {
    var data = compact_list_card_media_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    compact_list_card_media_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compact_list_card_media_templateObject1() {
    var data = compact_list_card_media_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 100%;\n"
    ]);
    compact_list_card_media_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compact_list_card_media_templateObject2() {
    var data = compact_list_card_media_taggedTemplateLiteral([
        "\n  width: 45px;\n  box-sizing: content-box;\n"
    ]);
    compact_list_card_media_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function compact_list_card_media_templateObject3() {
    var data = compact_list_card_media_taggedTemplateLiteral([
        "\n  max-width: 40px;\n  text-overflow: ellipsis;\n  max-height: 80px;\n"
    ]);
    compact_list_card_media_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var CompactListCardMedia = function() {
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _product = ref.product, media = _product.media, name = _product.name, category = _product.category, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, selectable = ref1.selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected;
    return /*#__PURE__*/ react.createElement(compact_list_card_media_Media, null, selectable ? /*#__PURE__*/ react.createElement(compact_list_card_media_CompareCheckbox, {
        selected: selected,
        "aria-label": name
    }) : null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        offset: 0
    }, /*#__PURE__*/ react.createElement(ImageContainer, null, /*#__PURE__*/ react.createElement(ListImage, {
        name: name,
        src: (media === null || media === void 0 ? void 0 : media.first) || "",
        fallback: category === null || category === void 0 ? void 0 : category.logo
    }))));
};
var compact_list_card_media_Media = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Media",
    componentId: "sc-0-0"
})(compact_list_card_media_templateObject());
var compact_list_card_media_CompareCheckbox = (0,styled_components_browser_esm["default"])(CompareCheckbox).withConfig({
    displayName: "CompareCheckbox",
    componentId: "sc-0-1"
})(compact_list_card_media_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImageContainer",
    componentId: "sc-0-2"
})(compact_list_card_media_templateObject2());
var ListImage = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "ListImage",
    componentId: "sc-0-3"
})(compact_list_card_media_templateObject3());

;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card-price.tsx
function compact_list_card_price_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compact_list_card_price_templateObject() {
    var data = compact_list_card_price_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"
    ]);
    compact_list_card_price_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compact_list_card_price_templateObject1() {
    var data = compact_list_card_price_taggedTemplateLiteral([
        "\n  align-items: baseline;\n  flex-wrap: wrap;\n  flex-direction: column;\n  text-align: end;\n"
    ]);
    compact_list_card_price_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compact_list_card_price_templateObject2() {
    var data = compact_list_card_price_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  grid-column-gap: ",
        ";\n"
    ]);
    compact_list_card_price_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var CompactListCardPrice = function(props) {
    var showFromPrice = props.showFromPrice;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _diffPercentage = ref.diffPercentage, diffPercentage = _diffPercentage === void 0 ? 0 : _diffPercentage, _product = ref.product, id = _product.id, priceSummary = _product.priceSummary, store = _product.store;
    var price = priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular;
    return /*#__PURE__*/ react.createElement(PriceContainer, null, /*#__PURE__*/ react.createElement(variants.Row, null, price && /*#__PURE__*/ react.createElement(compact_list_card_price_PriceTextWrapper, null, /*#__PURE__*/ react.createElement(PriceText, null, diffPercentage ? /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
        "data-testid": "DealsBadge",
        priceDrop: diffPercentage,
        price: price,
        popoverUniqueId: id || 0
    }) : null, /*#__PURE__*/ react.createElement("div", null, showFromPrice && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        emphasis: text_variants.FontEmphasis.LOW
    }, t("product", "price.from-abbr")), " "), /*#__PURE__*/ react.createElement(components_price/* Price */.t, {
        price: price,
        currency: store === null || store === void 0 ? void 0 : store.currency
    }))), priceSummary.includeShipping ? /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        emphasis: text_variants.FontEmphasis.LOW
    }, t("product", "price.including-shipping", {
        price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            key: priceSummary.includeShipping,
            price: priceSummary.includeShipping
        })
    })) : null)));
};
var PriceContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceContainer",
    componentId: "sc-0-0"
})(compact_list_card_price_templateObject());
var compact_list_card_price_PriceTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceTextWrapper",
    componentId: "sc-0-1"
})(compact_list_card_price_templateObject1());
var PriceText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceText",
    componentId: "sc-0-2"
})(compact_list_card_price_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/index.tsx







var ProductCompactListCard = function(props) {
    var className = props.className;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _type = ref.type, type = _type === void 0 ? "product" : _type;
    // The card shouldn't be clickable for offers
    var isClickable = type === "product";
    return /*#__PURE__*/ react.createElement(CompactListCard, {
        className: className,
        isClickable: isClickable
    }, /*#__PURE__*/ react.createElement(CompactListCardMedia, null), type === "product" && /*#__PURE__*/ react.createElement(CompactListCardProductContent, null), type === "offer" && /*#__PURE__*/ react.createElement(CompactListCardOfferContent, null), /*#__PURE__*/ react.createElement(CompactListCardPrice, {
        showFromPrice: type === "product"
    }));
};

;// CONCATENATED MODULE: ./src/components/product-card-old/map-to-props.ts
var mapDataToProps = function(item, type) {
    switch(type){
        case "product":
            {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                var product = item;
                return {
                    type: "product",
                    id: product.id,
                    brand: product.brand,
                    imageSrc: (ref = product.media) === null || ref === void 0 ? void 0 : ref.first,
                    name: product.name,
                    link: product.pathName,
                    properties: (ref1 = product.properties) === null || ref1 === void 0 ? void 0 : ref1.nodes,
                    price: (ref2 = product.priceSummary) === null || ref2 === void 0 ? void 0 : ref2.regular,
                    priceInclShipping: (ref3 = product.priceSummary) === null || ref3 === void 0 ? void 0 : ref3.includeShipping,
                    rank: (ref4 = product.popularity) === null || ref4 === void 0 ? void 0 : ref4.inCategory,
                    rating: (ref5 = product.userReviewSummary) === null || ref5 === void 0 ? void 0 : ref5.rating,
                    reviewsCount: (ref6 = product.userReviewSummary) === null || ref6 === void 0 ? void 0 : ref6.count,
                    category: product.category
                };
            }
        case "offer":
            {
                var ref7;
                var offer = item;
                return {
                    type: "offer",
                    imageSrc: (ref7 = offer.media) === null || ref7 === void 0 ? void 0 : ref7.first,
                    link: offer.externalUri,
                    name: offer.name,
                    price: offer.offerPrice,
                    store: offer.store
                };
            }
        default:
            return {};
    }
};

;// CONCATENATED MODULE: ./src/components/product-card-old/index.tsx







/***/ }),

/***/ 5780:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ useProductCardContext),
/* harmony export */   "h": () => (/* binding */ ProductCardContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_areas_product_components_product_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8466);


var initialValue = {
    ActionArea: undefined,
    background: false,
    diffPercentage: undefined,
    FooterArea: undefined,
    hasExpertBadge: false,
    highlightedName: undefined,
    imageSize: undefined,
    onClick: undefined,
    onRankInCategoryClick: undefined,
    product: src_areas_product_components_product_context__WEBPACK_IMPORTED_MODULE_1__/* .EmptyProduct */ .jG,
    selectStates: undefined,
    shouldLazyLoadImage: false,
    type: "product"
};
var ProductCardContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var useProductCardContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductCardContext);
};
var ProductCardContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductCardContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 866:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N8": () => (/* reexport */ DealsProductCard),
  "lH": () => (/* reexport */ ImageSearchProductCard),
  "dK": () => (/* reexport */ PromotionProductCard),
  "xJ": () => (/* reexport */ SearchProductCard),
  "Ie": () => (/* reexport */ UsedProductCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/product-card/types.ts
var TopLeftCornerFeature;
(function(TopLeftCornerFeature) {
    TopLeftCornerFeature["DEALS_BADGE"] = "DEALS_BADGE";
    TopLeftCornerFeature["USED_BADGE"] = "USED_BADGE";
    TopLeftCornerFeature["POTY_BADGE"] = "POTY_BADGE";
    TopLeftCornerFeature["TOP_RATED_BADGE"] = "TOP_RATED_BADGE";
})(TopLeftCornerFeature || (TopLeftCornerFeature = {}));
var TopRightCornerFeature;
(function(TopRightCornerFeature) {
    TopRightCornerFeature["NONE"] = "NONE";
    TopRightCornerFeature["ADD_TO_LIST"] = "ADD_TO_LIST";
    TopRightCornerFeature["DROPDOWN"] = "DROPDOWN";
})(TopRightCornerFeature || (TopRightCornerFeature = {}));
var BottomRightCornerFeature;
(function(BottomRightCornerFeature) {
    BottomRightCornerFeature["NONE"] = "NONE";
    BottomRightCornerFeature["IMAGE_SEARCH"] = "IMAGE_SEARCH";
})(BottomRightCornerFeature || (BottomRightCornerFeature = {}));
var ProductCardType;
(function(ProductCardType) {
    ProductCardType["DEALS"] = "DEALS";
    ProductCardType["RAW_OFFER"] = "RAW_OFFER";
    ProductCardType["USED"] = "USED";
    ProductCardType["PROMOTION_PRODUCT"] = "PROMOTION_PRODUCT";
    ProductCardType["SEARCH_RESULT"] = "SEARCH_RESULT";
    ProductCardType["IMAGE_SEARCH"] = "IMAGE_SEARCH";
})(ProductCardType || (ProductCardType = {}));

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/product-card/contexts/product-card-context.tsx



var emptyState = {
    data: {
        product: {
            id: 0,
            productLink: "",
            name: "",
            imageSearchModels: []
        },
        offer: {}
    },
    features: {
        categoryName: false,
        clickoutButton: undefined,
        deals: false,
        memberPrice: false,
        price: false,
        shopInfo: false,
        rating: false,
        salesPrice: false,
        lowestPriceInfo: false,
        topLeftCorner: [],
        topRightCorner: TopRightCornerFeature.NONE,
        bottomRightCorner: BottomRightCornerFeature.NONE
    },
    trackingClickoutScope: null,
    trackingScope: tracking/* InternalNavigationScope.CAMPAIGN_PRODUCT_CARD */.U.CAMPAIGN_PRODUCT_CARD,
    type: ProductCardType.DEALS
};
var ProductCardContext = /*#__PURE__*/ (0,react.createContext)(emptyState);
var useProductCardContext = function() {
    return (0,react.useContext)(ProductCardContext);
};
var ProductCardStateProvider = function(param) {
    var children = param.children, initialState = param.initialState;
    return /*#__PURE__*/ react.createElement(ProductCardContext.Provider, {
        value: initialState
    }, children);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(33561);
;// CONCATENATED MODULE: ./src/components/product-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  padding: ",
        ";\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    justify-content: space-between;\n    padding: 0;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  gap: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n  gap: ",
        ";\n  flex-wrap: wrap;\n\n  > * {\n    flex-grow: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var RAW_OFFER_LOW_OPACITY = 0.48;
var StyledProductCard = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "StyledProductCard",
    componentId: "sc-0-0"
})(_templateObject(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing050, function(p) {
    return p.$disabled && "opacity: ".concat(RAW_OFFER_LOW_OPACITY, "; pointer-events: none;");
});
var StyledCardContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "StyledCardContent",
    componentId: "sc-0-1"
})(_templateObject1(), design_tokens.measurements.spacing050);
var FlexColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FlexColumn",
    componentId: "sc-0-2"
})(_templateObject2(), design_tokens.measurements.spacing025);
var FlexColumnCompact = (0,styled_components_browser_esm["default"])(FlexColumn).withConfig({
    displayName: "FlexColumnCompact",
    componentId: "sc-0-3"
})(_templateObject3());
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-4"
})(_templateObject4());
var StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-5"
})(_templateObject5());
var VerticalTextAlignment = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VerticalTextAlignment",
    componentId: "sc-0-6"
})(_templateObject6(), function(props) {
    return props.extraSpacing ? design_tokens.measurements.spacing050 : design_tokens.measurements.spacing025;
});

;// CONCATENATED MODULE: ./src/components/product-card/components/card-wrapper.tsx





var CardWrapper = function(param) {
    var children = param.children;
    var productCardData = useProductCardContext();
    var loweredOpacity = productCardData.type === ProductCardType.RAW_OFFER && !productCardData.data.offer.featured;
    return /*#__PURE__*/ react.createElement(StyledProductCard, {
        outlined: true,
        $disabled: loweredOpacity,
        containerProps: {
            "data-test": "CardWrapper",
            "data-testid": "CardWrapper",
            "data-opacity": loweredOpacity ? RAW_OFFER_LOW_OPACITY : 1
        }
    }, children);
};

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
;// CONCATENATED MODULE: ./src/components/product-card/components/card-clickable-area.tsx






var CardClickableArea = function(param) {
    var children = param.children;
    var renderMode = (0,app_context/* useAppContext */.bp)().renderMode;
    var productCardData = useProductCardContext();
    var url = productCardData.data.product.productLink;
    var onClick = function() {
        var ref, ref1;
        (ref = productCardData.customTracking) === null || ref === void 0 ? void 0 : (ref1 = ref.onCardClick) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        var index = productCardData.trackingIndex ? productCardData.trackingIndex + 1 : undefined;
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: productCardData.trackingScope,
            nextPage: url,
            index: index
        });
    };
    return /*#__PURE__*/ react.createElement(StyledCardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: url,
            onClick: onClick,
            "data-testid": "CardClickableArea",
            isExternal: renderMode === "native"
        }
    }, /*#__PURE__*/ react.createElement(StyledCardContent, null, children));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
;// CONCATENATED MODULE: ./src/components/product-card/features/internal/features-utils.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var hasFeatureEnabled = function(feature, productCardData) {
    var internalFeatures = {
        salesPriceText: true,
        memberPriceText: true,
        membershipRequiresCompensation: true,
        price: true,
        lowestNewPrice: true
    };
    var boolFeatures = Object.entries(_objectSpread({}, internalFeatures, productCardData.features)).reduce(function(acc, param) {
        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
        if (value) {
            acc.push(key);
        }
        return acc;
    }, []);
    var allFeatures = _toConsumableArray(boolFeatures).concat(_toConsumableArray(productCardData.features.topLeftCorner), [
        productCardData.features.topRightCorner,
        productCardData.features.bottomRightCorner
    ]);
    return allFeatures.includes(feature);
};
var hasNoneOf = function(features, productCardData) {
    return !features.some(function(feature) {
        return showFeature(feature, productCardData);
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/features/image-search-categories.ts
var VALID_IMAGE_SEARCH_CATEGORIES = [
    1426,
    1427,
    1428,
    1446,
    1448,
    1449,
    1451,
    1457,
    1459,
    1460,
    1466,
    1467,
    1477,
    1480,
    1481,
    1482,
    1485,
    1488,
    1490,
    1491,
    1492,
    1494,
    1495,
    1497,
    1505,
    1509,
    1516,
    1525,
    1526,
    1528,
    1543,
    1551,
    1568,
    1572,
    1580,
    1581,
    1610,
    1619,
    1628,
    1629,
    1750,
    1845,
    1921,
    2057,
    2077,
    2079,
    2208,
    2326,
    2727,
    2741,
    2782,
    2827,
    3053,
    3406,
    3512,
    3515,
    3520,
    3544,
    819,
    820,
    894
];
// If we ever decide to remove the category-restraint of ImageSearch this function can get deleted
// and replaced by a simple "category?.categoryName" and we may delete "hierarchicalCategoryIds".
var hasValidImageSearchCategory = function(productCardData) {
    var ref, ref1;
    var category = productCardData.data.product.category;
    return Boolean((category === null || category === void 0 ? void 0 : category.categoryName) && ((ref = category.hierarchicalCategoryIds) === null || ref === void 0 ? void 0 : ref.length) && ((ref1 = category.hierarchicalCategoryIds) === null || ref1 === void 0 ? void 0 : ref1.some(function(id) {
        return VALID_IMAGE_SEARCH_CATEGORIES.includes(id);
    })));
};

;// CONCATENATED MODULE: ./src/components/product-card/features/index.ts
function features_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



/**
 * Why do we need this function?
 *
 * Each card-type has the possibility to hide/show specific features based on their use-case. But...
 * Just because the feature itself is enabled, doesn't mean it should be displayed.
 * Some features will be hidden due to another higher prio feature being displayed in the card already.
 * Also, just because "deals is enabled" we don't want to show a badge for it, we also need to check if "offer.priceDrop > 0", see function "hasData".
 * Beware: Don't perform infinite loops by having 2 features dependant on each other :)
 */ // * Temporary comment (Remove during 2024)
// * When modifying the RFE version of the product-card, please also modify the NextJS version of the product-card.
var showFeature = function(feature, productCardData) {
    var isEnabled = hasFeatureEnabled(feature, productCardData);
    var hasNoData = !hasData(feature, productCardData);
    if (!isEnabled || hasNoData) {
        return false;
    }
    var _obj;
    var dependencyMap = (_obj = {
        // Only display salesPrice if there is no memberPrice already.
        salesPrice: function() {
            return hasNoneOf([
                "memberPrice"
            ], productCardData);
        },
        // salesPriceText and memberPriceText are UX-special-cases where we at times want to show the badge/info but hide the
        // "previous price text". Reason: we do not want to show several kinds of "before pricedrop"-prices in the same card.
        salesPriceText: function() {
            return showFeature("salesPrice", productCardData) && hasNoneOf([
                "memberPrice"
            ], productCardData);
        },
        memberPriceText: function() {
            return showFeature("memberPrice", productCardData);
        },
        membershipRequiresCompensation: function() {
            return showFeature("memberPrice", productCardData);
        }
    }, features_defineProperty(_obj, TopLeftCornerFeature.DEALS_BADGE, function() {
        return showFeature("deals", productCardData);
    }), features_defineProperty(_obj, TopLeftCornerFeature.USED_BADGE, function() {
        return hasNoneOf([
            TopLeftCornerFeature.DEALS_BADGE
        ], productCardData);
    }), features_defineProperty(_obj, TopLeftCornerFeature.TOP_RATED_BADGE, function() {
        return hasNoneOf([
            TopLeftCornerFeature.DEALS_BADGE,
            TopLeftCornerFeature.USED_BADGE
        ], productCardData);
    }), features_defineProperty(_obj, TopLeftCornerFeature.POTY_BADGE, function() {
        return hasNoneOf([
            TopLeftCornerFeature.DEALS_BADGE,
            TopLeftCornerFeature.USED_BADGE,
            TopLeftCornerFeature.TOP_RATED_BADGE
        ], productCardData);
    }), _obj);
    if (feature in dependencyMap) {
        return dependencyMap[feature]();
    }
    return true;
};
var hasData = function(feature, productCardData) {
    var _product = productCardData.data.product, priceDrop = _product.priceDrop, rating = _product.rating, category = _product.category, productOfTheYear = _product.productOfTheYear, isExpertTopRated = _product.isExpertTopRated;
    var _offer = productCardData.data.offer, originalPrice = _offer.originalPrice, memberPrice = _offer.memberPrice, membershipRequiresCompensation = _offer.membershipRequiresCompensation, price = _offer.price, condition = _offer.condition, storeName = _offer.storeName;
    var _obj;
    // Add all your data-dependencies here.
    // Example: if you want to show the DEALS_BADGE, you need to have a "priceDrop > 0".
    var hasDataMap = (_obj = {
        deals: priceDrop,
        price: price
    }, features_defineProperty(_obj, TopLeftCornerFeature.DEALS_BADGE, true), features_defineProperty(_obj, TopLeftCornerFeature.POTY_BADGE, productOfTheYear), features_defineProperty(_obj, TopLeftCornerFeature.TOP_RATED_BADGE, isExpertTopRated), features_defineProperty(_obj, TopLeftCornerFeature.USED_BADGE, condition !== "new"), features_defineProperty(_obj, BottomRightCornerFeature.IMAGE_SEARCH, hasValidImageSearchCategory(productCardData)), features_defineProperty(_obj, "categoryName", category === null || category === void 0 ? void 0 : category.categoryName), features_defineProperty(_obj, "memberPrice", memberPrice && originalPrice && memberPrice < originalPrice), features_defineProperty(_obj, "memberPriceText", true), features_defineProperty(_obj, "membershipRequiresCompensation", membershipRequiresCompensation), features_defineProperty(_obj, "salesPrice", originalPrice && price && originalPrice > price), features_defineProperty(_obj, "salesPriceText", true), features_defineProperty(_obj, "shopInfo", storeName), features_defineProperty(_obj, "rating", rating === null || rating === void 0 ? void 0 : rating.count), features_defineProperty(_obj, "lowestNewPrice", Boolean(productCardData.type === ProductCardType.USED && productCardData.data.product.lowestNewPrice)), features_defineProperty(_obj, "lowestPriceInfo", price), _obj);
    if (feature in hasDataMap) {
        return Boolean(hasDataMap[feature]);
    }
    return true;
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/category.tsx




var Category = function() {
    var ref;
    var productCardData = useProductCardContext();
    if (!showFeature("categoryName", productCardData)) return null;
    var categoryName = (ref = productCardData.data.product.category) === null || ref === void 0 ? void 0 : ref.categoryName;
    return /*#__PURE__*/ react.createElement(variants.CaptionText, {
        behavior: variants.Behavior.OnelineEllipsis,
        emphasis: variants.FontEmphasis.MEDIUM,
        containerProps: {
            "data-testid": "Category"
        }
    }, categoryName);
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      opacity: 0.2;\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    padding: ",
        ";\n    max-height: calc(180px + ",
        " * 2);\n\n    ",
        "\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PADDING = design_tokens.measurements.spacing075;
var StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject1(), PADDING, PADDING, props.$isFallbackImage && (0,styled_components_browser_esm.css)(styles_templateObject()));
});

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/image.tsx




var Image = function() {
    var market = (0,app_context/* useAppContext */.bp)().market;
    var productCardData = useProductCardContext();
    var url = productCardData.data.product.logo;
    var fallback = "".concat(market.cdn, "/product/standard/280/0.jpg");
    return /*#__PURE__*/ react.createElement(StyledImage, {
        src: url || fallback,
        alt: "",
        "data-testid": "ProductCardImage",
        $isFallbackImage: !url
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/product-name.tsx



var ProductName = function() {
    var productCardData = useProductCardContext();
    var text = productCardData.data.product.name;
    return /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        behavior: variants.Behavior.TwolineEllipsis,
        containerProps: {
            "data-testid": "ProductName",
            "data-test": "ProductName"
        }
    }, text);
};

// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(34990);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/rating.tsx




var Rating = function() {
    var productCardData = useProductCardContext();
    if (!showFeature("rating", productCardData)) return null;
    var rating = productCardData.data.product.rating;
    return /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating.score,
        count: rating.count,
        showCounterAs: "number",
        dataTestid: "Rating"
    });
};

// EXTERNAL MODULE: ./src/components/badges/deals-badge/index.tsx + 1 modules
var deals_badge = __webpack_require__(48285);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/deals-badge.tsx





var DealsBadge = function() {
    var productCardData = useProductCardContext();
    if (!showFeature(TopLeftCornerFeature.DEALS_BADGE, productCardData)) {
        return null;
    }
    var productId = productCardData.data.product.id;
    var priceDrop = productCardData.data.product.priceDrop;
    var price = productCardData.data.offer.price;
    if (!price || !priceDrop) return null;
    return /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
        "data-testid": "DealsBadge",
        priceDrop: priceDrop,
        price: price,
        popoverUniqueId: productId
    });
};

// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(44266);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(72321);
// EXTERNAL MODULE: ./src/components/badges/image-badges.tsx
var image_badges = __webpack_require__(21244);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/styles.ts
function top_left_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function top_left_styles_templateObject() {
    var data = top_left_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: ",
        ";\n  z-index: 3;\n"
    ]);
    top_left_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function top_left_styles_templateObject1() {
    var data = top_left_styles_taggedTemplateLiteral([
        "\n  width: 56px;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    top_left_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = top_left_styles_taggedTemplateLiteral([
        "\n  max-width: 100%;\n  white-space: nowrap;\n  & > svg {\n    flex-shrink: 0;\n  }\n  & > span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledTopLeftArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTopLeftArea",
    componentId: "sc-0-0"
})(top_left_styles_templateObject(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing075);
var StyledImageBadge = (0,styled_components_browser_esm["default"])(image_badges/* ImageBadge */.d3).withConfig({
    displayName: "StyledImageBadge",
    componentId: "sc-0-1"
})(top_left_styles_templateObject1(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing075);
var StyledBadge = (0,styled_components_browser_esm["default"])(badge.Badge).withConfig({
    displayName: "StyledBadge",
    componentId: "sc-0-2"
})(styles_templateObject2());

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/product-of-the-year-badge.tsx






var ProductOfTheYearBadge = function() {
    var productCardData = useProductCardContext();
    var poty = (0,hooks/* useGetProductOfTheYear */.i)(productCardData.data.product.id);
    if (!(poty === null || poty === void 0 ? void 0 : poty.awardLogo) || !showFeature(TopLeftCornerFeature.POTY_BADGE, productCardData)) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledImageBadge, {
        badgeUrl: poty.awardLogo,
        title: "".concat(poty.awardName, " ").concat(poty.year)
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/recycle/index.js
var recycle = __webpack_require__(894);
// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/index.ts
var product_condition = __webpack_require__(7001);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/used-badge.tsx










var UsedBadge = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var productCardData = useProductCardContext();
    if (!showFeature(TopLeftCornerFeature.USED_BADGE, productCardData)) {
        return null;
    }
    var condition = productCardData.data.offer.condition;
    if (!condition) return null;
    var tooltipText = market.code === "fr" ? (0,product_condition/* getConditionName */.v)(condition, t) : undefined;
    return /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Up */.Nm.Up,
        renderOnMouseOver: true,
        title: tooltipText
    }, /*#__PURE__*/ react.createElement(StyledBadge, {
        color: "GREEN",
        icon: recycle/* IconRecycle */.L,
        text: (0,product_condition/* getConditionName */.v)(condition, t),
        containerProps: {
            "data-testid": "UsedBadge"
        }
    }));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/top-rated-badge.tsx






var TopRatedBadge = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var productCardData = useProductCardContext();
    if (!showFeature(TopLeftCornerFeature.TOP_RATED_BADGE, productCardData)) return null;
    return /*#__PURE__*/ react.createElement(StyledImageBadge, {
        badgeUrl: "".concat(market.cdn, "/g/expert/").concat(market.code, "/expert-toprated-badge.png"),
        title: t("expert", "expert.top-rated-badge")
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/top-left-area.tsx






var TopLeftArea = function() {
    return /*#__PURE__*/ react.createElement(StyledTopLeftArea, null, /*#__PURE__*/ react.createElement(ProductOfTheYearBadge, null), /*#__PURE__*/ react.createElement(TopRatedBadge, null), /*#__PURE__*/ react.createElement(DealsBadge, null), /*#__PURE__*/ react.createElement(UsedBadge, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/index.tsx


// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/index.tsx
var add_to_list = __webpack_require__(90814);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/add-to-list.tsx






var AddToList = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, renderMode = ref.renderMode;
    var productCardData = useProductCardContext();
    if (!market.login.enabled || renderMode === "native") {
        return null;
    }
    if (!showFeature(TopRightCornerFeature.ADD_TO_LIST, productCardData)) {
        return null;
    }
    var _product = productCardData.data.product, id = _product.id, name = _product.name;
    return /*#__PURE__*/ react.createElement(add_to_list/* AddToListButton */.a, {
        productId: id,
        productName: name
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(99816);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(33888);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/flag-outlined/index.js
var flag_outlined = __webpack_require__(40173);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/heart-filled/index.js
var heart_filled = __webpack_require__(87269);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/heart-outlined/index.js
var heart_outlined = __webpack_require__(72183);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/menu-kebab/index.js
var menu_kebab = __webpack_require__(77356);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(50999);
// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/add-to-list-wrapper.tsx
var add_to_list_wrapper = __webpack_require__(58281);
// EXTERNAL MODULE: ./src/components/action-buttons/alert/alert-modal.tsx
var alert_modal = __webpack_require__(25059);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/index.tsx
var report_modal = __webpack_require__(75675);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/styles.ts
function top_right_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function top_right_styles_templateObject() {
    var data = top_right_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: ",
        ";\n  top: ",
        ";\n  z-index: 1;\n"
    ]);
    top_right_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function top_right_styles_templateObject1() {
    var data = top_right_styles_taggedTemplateLiteral([
        "\n  > button {\n    background-color: ",
        ";\n\n    &:hover {\n      background-color: ",
        ";\n    }\n  }\n\n  > .Floater {\n    left: unset;\n    right: 0;\n  }\n"
    ]);
    top_right_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function top_right_styles_templateObject2() {
    var data = top_right_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        ";\n  gap: ",
        ";\n  color: ",
        ";\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    top_right_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledTopRightArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTopRightArea",
    componentId: "sc-0-0"
})(top_right_styles_templateObject(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing075);
var CardDropdown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "CardDropdown",
    componentId: "sc-0-1"
})(top_right_styles_templateObject1(), light_theme_colors.staticBase0, light_theme_colors.staticBase200);
var DropdownItem = styled_components_browser_esm["default"].button.withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-2"
})(top_right_styles_templateObject2(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050, light_theme_colors.staticBase900, light_theme_colors.staticBase200, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/dropdown.tsx
function dropdown_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function dropdown_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function dropdown_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function dropdown_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function dropdown_slicedToArray(arr, i) {
    return dropdown_arrayWithHoles(arr) || dropdown_iterableToArrayLimit(arr, i) || dropdown_unsupportedIterableToArray(arr, i) || dropdown_nonIterableRest();
}
function dropdown_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return dropdown_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dropdown_arrayLikeToArray(o, minLen);
}
















var Dropdown = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t, market = ref.market;
    var productCardData = useProductCardContext();
    var ref1 = dropdown_slicedToArray((0,react.useState)(false), 2), reportModalIsOpen = ref1[0], setReportModalIsOpen = ref1[1];
    var ref2 = dropdown_slicedToArray((0,react.useState)(false), 2), alertModalIsOpen = ref2[0], setAlertModalIsOpen = ref2[1];
    if (!showFeature(TopRightCornerFeature.DROPDOWN, productCardData)) {
        return null;
    }
    var nativeRenderMode = renderMode === "native";
    var displayAddToList = market.login.enabled && !nativeRenderMode;
    var displayAlert = market.login.enabled && !nativeRenderMode;
    var offer = productCardData.data.offer;
    var product = productCardData.data.product;
    var productId = product.id;
    var productName = product.name;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(report_modal/* ReportModal */.y, {
        isOpen: reportModalIsOpen,
        closeModal: function() {
            return setReportModalIsOpen(false);
        },
        priceId: "".concat(offer.storeId, "-").concat(offer.shopOfferId),
        priceValue: offer.price,
        productName: productName,
        productImage: product.logo,
        stockStatus: offer.stockStatus,
        store: offer.storeId && offer.storeName ? {
            id: offer.storeId,
            name: offer.storeName
        } : null,
        isFeatured: offer.featured
    }), displayAlert && /*#__PURE__*/ react.createElement(alert_modal/* AlertModal */.V, {
        closeModal: function() {
            return setAlertModalIsOpen(false);
        },
        isOpen: alertModalIsOpen,
        productId: productId
    }), /*#__PURE__*/ react.createElement(CardDropdown, {
        elevation: ui_button.ButtonElevation.NONE,
        containerProps: {
            "data-testid": "Dropdown"
        }
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        onlyIcon: true,
        type: ui_button.ButtonType.OUTLINED,
        containerProps: {
            "data-testid": "DropdownToggleButton"
        }
    }, /*#__PURE__*/ react.createElement(menu_kebab/* IconMenuKebab */.Q, null)), /*#__PURE__*/ react.createElement(add_to_list_wrapper/* AddToListModalsWrapper */.w, {
        productId: productId,
        productName: productName
    }, function(onListClick, addedToList) {
        return /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, null, displayAddToList && /*#__PURE__*/ react.createElement(DropdownItem, {
            "aria-label": t("common", "button.save"),
            onClick: onListClick,
            "data-testid": "AddToListButton"
        }, addedToList ? /*#__PURE__*/ react.createElement(heart_filled/* IconHeartFilled */.g, null) : /*#__PURE__*/ react.createElement(heart_outlined/* IconHeartOutlined */.G, null), /*#__PURE__*/ react.createElement("span", null, addedToList ? t("lists", "list.save-to-list") : t("lists", "list.save-to-new-list"))), displayAlert && /*#__PURE__*/ react.createElement(DropdownItem, {
            onClick: function() {
                return setAlertModalIsOpen(true);
            },
            "data-testid": "ToggleAlertModalButton"
        }, /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null), /*#__PURE__*/ react.createElement("span", null, t("alerts", "alert-form.create-button"))), /*#__PURE__*/ react.createElement(DropdownItem, {
            onClick: function() {
                return setReportModalIsOpen(true);
            },
            "data-testid": "ToggleReportModalButton"
        }, /*#__PURE__*/ react.createElement(flag_outlined/* IconFlagOutlined */.b, null), /*#__PURE__*/ react.createElement("span", null, t("feedback", "dialog.prompt-button"))));
    })));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/top-right-area.tsx




var TopRightArea = function() {
    return /*#__PURE__*/ react.createElement(StyledTopRightArea, null, /*#__PURE__*/ react.createElement(AddToList, null), /*#__PURE__*/ react.createElement(Dropdown, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/index.tsx


// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(89975);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/styles.ts
function clickout_button_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function clickout_button_styles_templateObject() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n      opacity: 0.24;\n    "
    ]);
    clickout_button_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function clickout_button_styles_templateObject1() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    clickout_button_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function clickout_button_styles_templateObject2() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 10;\n"
    ]);
    clickout_button_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  height: 42px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  & > * {\n    vertical-align: middle;\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex: none;\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  justify-content: center;\n\n  ",
        ";\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  & > path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: ",
        ";\n  padding: ",
        ";\n  padding-left: ",
        ";\n  border-radius: 8px;\n  background: ",
        ";\n  cursor: pointer;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}





var StyledButton = (0,styled_components_browser_esm["default"])(ui_button.Button).withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(clickout_button_styles_templateObject1(), props.disabled && (0,styled_components_browser_esm.css)(clickout_button_styles_templateObject()));
});
var GrayClickOutWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GrayClickOutWrapper",
    componentId: "sc-0-1"
})(clickout_button_styles_templateObject2());
var OuterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "OuterWrapper",
    componentId: "sc-0-2"
})(styles_templateObject3());
var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-3"
})(styles_templateObject4(), design_tokens.measurements.spacing025);
var InnerWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InnerWrapper",
    componentId: "sc-0-4"
})(styles_templateObject6(), base/* media.smallOnly */.BC.smallOnly(styles_templateObject5()));
var IconOutgoingLinkWithColorFix = (0,styled_components_browser_esm["default"])(outgoing_link/* IconOutgoingLink */.v).withConfig({
    displayName: "IconOutgoingLinkWithColorFix",
    componentId: "sc-0-5"
})(_templateObject7());
var StyledPromotionClickoutButton = styled_components_browser_esm["default"].a.withConfig({
    displayName: "StyledPromotionClickoutButton",
    componentId: "sc-0-6"
})(_templateObject8(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050, design_tokens.measurements.spacing075, function(props) {
    return props.theme.colors.yellove100;
}, function(props) {
    return props.theme.colors.yellove300;
});
var StyledLogoWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledLogoWrapper",
    componentId: "sc-0-7"
})(_templateObject9(), design_tokens.measurements.spacing050);

// EXTERNAL MODULE: ./src/components/clickout-wrapper/index.tsx
var clickout_wrapper = __webpack_require__(87526);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/base-clickout-button.tsx




var ICON_SIZE = 15;
var BaseClickoutButton = function(param) {
    var href = param.href, onClick = param.onClick, text = param.text;
    var disabled = !href;
    var containerProps = {
        href: href,
        rel: "nofollow",
        target: "_blank",
        "data-testid": "ClickoutButton"
    };
    return /*#__PURE__*/ react.createElement(OuterWrapper, null, /*#__PURE__*/ react.createElement(clickout_wrapper/* ClickoutWrapper */.W, null, /*#__PURE__*/ react.createElement(StyledButton, {
        containerProps: containerProps,
        container: "a",
        disabled: disabled,
        fullWidth: true,
        onClick: onClick,
        type: disabled ? ui_button.ButtonType.TONAL : ui_button.ButtonType.PRIMARY
    }, /*#__PURE__*/ react.createElement(InnerWrapper, null, text, /*#__PURE__*/ react.createElement(IconWrapper, null, /*#__PURE__*/ react.createElement(IconOutgoingLinkWithColorFix, {
        size: ICON_SIZE
    }))))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(31744);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/gray-clickout-button.tsx
function gray_clickout_button_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function gray_clickout_button_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function gray_clickout_button_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function gray_clickout_button_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function gray_clickout_button_slicedToArray(arr, i) {
    return gray_clickout_button_arrayWithHoles(arr) || gray_clickout_button_iterableToArrayLimit(arr, i) || gray_clickout_button_unsupportedIterableToArray(arr, i) || gray_clickout_button_nonIterableRest();
}
function gray_clickout_button_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return gray_clickout_button_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gray_clickout_button_arrayLikeToArray(o, minLen);
}






var GrayClickoutButton = function(param) {
    var text = param.text;
    var ref = gray_clickout_button_slicedToArray((0,react.useState)(false), 2), showPopover = ref[0], setShowPopover = ref[1];
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(GrayClickOutWrapper, {
        style: {
            position: "relative"
        }
    }, /*#__PURE__*/ react.createElement(BaseClickoutButton, {
        href: null,
        text: text,
        onClick: function() {
            setShowPopover(true);
        }
    }), /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "popover",
        visible: showPopover,
        onClose: function() {
            return setShowPopover(false);
        },
        width: 250,
        offsetY: 0,
        offsetX: 0,
        verticalAlign: popover/* Alignment.End */.v2.End,
        horizontalAlign: popover/* Alignment.End */.v2.End,
        zIndex: 100
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "transparency.store-info"))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts + 1 modules
var conversion = __webpack_require__(23513);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(69140);
// EXTERNAL MODULE: ./src/utils/click-out-bounce-helper.ts
var click_out_bounce_helper = __webpack_require__(40757);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/util.ts





var mapProductCardDataToTrackOfferClick = function(productCardData) {
    var offer = productCardData.data.offer;
    var dealIsDisplayed = showFeature("deals", productCardData);
    var conditionIsDisplayed = showFeature(TopLeftCornerFeature.USED_BADGE, productCardData);
    var priceType = "regular";
    if (showFeature("salesPrice", productCardData)) {
        priceType = "sale";
    } else if (showFeature("memberPrice", productCardData)) {
        priceType = "member";
    }
    return {
        offerId: "".concat(productCardData.data.offer.storeId, "-").concat(productCardData.data.offer.shopOfferId),
        isRawOffer: false,
        scope: productCardData.trackingClickoutScope,
        condition: conditionIsDisplayed && offer.condition || undefined,
        isPjDeal: dealIsDisplayed || undefined,
        priceType: priceType
    };
};
var handleClickOut = function(dispatch, productCardData, scope) {
    var ref, ref1;
    var productId = productCardData.data.product.id;
    var _offer = productCardData.data.offer, price = _offer.price, stockStatus = _offer.stockStatus, condition = _offer.condition, storeName = _offer.storeName, shopOfferId = _offer.shopOfferId, storeId = _offer.storeId;
    (ref = productCardData.customTracking) === null || ref === void 0 ? void 0 : (ref1 = ref.onClickout) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
    if (!scope) return;
    (0,conversion/* trackOfferClickWithRevenue */.Rx)(mapProductCardDataToTrackOfferClick(productCardData));
    dispatch((0,product/* productPriceClick */.Po)(productId, price, true, "", false, scope, stockStatus, condition));
    var handleBounce = function() {
        dispatch((0,product/* productClickOutBounce */.nA)({
            productId: productId,
            offerId: "".concat(storeId, "-").concat(shopOfferId),
            storeName: storeName
        }));
    };
    (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/primary-clickout-button.tsx





var PrimaryClickoutButton = function(props) {
    var productCardData = useProductCardContext();
    var dispatch = (0,es/* useDispatch */.I0)();
    var scope = productCardData.trackingClickoutScope;
    var offerLink = productCardData.data.offer.offerLink;
    return /*#__PURE__*/ react.createElement(BaseClickoutButton, {
        href: offerLink,
        onClick: function() {
            return handleClickOut(dispatch, productCardData, scope);
        },
        text: props.text
    });
};

// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./src/components/offer/price/price-text.tsx
var price_text = __webpack_require__(48711);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(46256);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/promotion-clickout-button.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}










var promotion_clickout_button_ICON_SIZE = 15;
var PromotionClickoutButton = function() {
    var productCardData = useProductCardContext();
    var offer = productCardData.data.offer, promotionOffer = productCardData.promotionOffer, trackingClickoutScope = productCardData.trackingClickoutScope;
    var dispatch = (0,es/* useDispatch */.I0)();
    var price = (promotionOffer === null || promotionOffer === void 0 ? void 0 : promotionOffer.price) || offer.price;
    var name = (promotionOffer === null || promotionOffer === void 0 ? void 0 : promotionOffer.shopName) || offer.storeName;
    var storeId = (promotionOffer === null || promotionOffer === void 0 ? void 0 : promotionOffer.shopId) || offer.storeId;
    var offerLink = (promotionOffer === null || promotionOffer === void 0 ? void 0 : promotionOffer.offerLink) || offer.offerLink;
    var linkProps = {
        href: offerLink,
        rel: "nofollow",
        target: "_blank",
        "data-testid": "ClickoutButton"
    };
    return /*#__PURE__*/ react.createElement(StyledPromotionClickoutButton, _extends({}, linkProps, {
        onClick: function() {
            return handleClickOut(dispatch, productCardData, trackingClickoutScope);
        }
    }), /*#__PURE__*/ react.createElement(VerticalTextAlignment, null, /*#__PURE__*/ react.createElement(price_text/* PriceText */.X, null, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: price
    }))), /*#__PURE__*/ react.createElement(StyledLogoWrapper, null, name && storeId && /*#__PURE__*/ react.createElement(store_logo/* StoreLogo */.Xv, {
        featured: true,
        hasImage: true,
        name: name,
        storeId: storeId,
        width: 56
    }), /*#__PURE__*/ react.createElement(outgoing_link/* IconOutgoingLink */.v, {
        size: promotion_clickout_button_ICON_SIZE
    })));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/clickout-button.tsx






var ClickoutButton = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var productCardData = useProductCardContext();
    var buttonType = productCardData.features.clickoutButton;
    var featured = productCardData.data.offer.featured;
    var text = t("product", "external-link.visit-shop");
    if (buttonType === "default") {
        if (featured) return /*#__PURE__*/ react.createElement(PrimaryClickoutButton, {
            text: text
        });
        return /*#__PURE__*/ react.createElement(GrayClickoutButton, {
            text: text
        });
    }
    if (buttonType === "promotion") return /*#__PURE__*/ react.createElement(PromotionClickoutButton, null);
    return null;
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/index.ts


;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/store-info.tsx






var StoreInfo = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var productCardData = useProductCardContext();
    if (!showFeature("shopInfo", productCardData)) return null;
    var storeCount = productCardData.data.product.storeCount;
    var storeName = productCardData.data.offer.storeName;
    var featured = productCardData.data.offer.featured;
    return /*#__PURE__*/ react.createElement(VerticalTextAlignment, null, /*#__PURE__*/ react.createElement(variants.CaptionStrongText, {
        emphasis: featured ? variants.FontEmphasis.HIGH : variants.FontEmphasis.LOW,
        containerProps: {
            "data-testid": "StoreInfoName"
        }
    }, storeName), storeCount && storeCount > 1 ? /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM,
        containerProps: {
            "data-testid": "StoreInfoCount"
        }
    }, t("search", "stores.n-title", {
        n: storeCount - 1
    }).toLocaleLowerCase()) : null);
};

// EXTERNAL MODULE: ./src/areas/product/components/badges/index.ts + 4 modules
var badges = __webpack_require__(68620);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-badges/membership-price-badge.tsx




var MembershipPriceBadge = function() {
    var productCardData = useProductCardContext();
    if (!showFeature("memberPrice", productCardData)) return null;
    return /*#__PURE__*/ react.createElement(badges/* MembershipBadge */.fd, {
        isMembershipPrice: true
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-explanations/paid-membership-info.tsx




var PaidMembershipInfo = function() {
    var productCardData = useProductCardContext();
    if (!showFeature("membershipRequiresCompensation", productCardData)) {
        return null;
    }
    var isPaidMembership = productCardData.data.offer.membershipRequiresCompensation || false;
    return /*#__PURE__*/ react.createElement(badges/* MembershipInformation */.pb, {
        isMembershipPrice: true,
        isPaidMembership: isPaidMembership,
        smallerTextSize: false
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price.tsx








var Price = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var productCardData = useProductCardContext();
    var isSalesPrice = showFeature("salesPrice", productCardData);
    var price = productCardData.data.offer.price;
    if (!showFeature("price", productCardData) || !price) return null;
    var memberPrice = productCardData.data.offer.memberPrice || Number.MAX_SAFE_INTEGER;
    var lowestPrice = Math.min(memberPrice, price);
    return /*#__PURE__*/ react.createElement(VerticalTextAlignment, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "price.from-abbr")), /*#__PURE__*/ react.createElement(price_text/* PriceText */.X, {
        color: isSalesPrice ? variants.FontColor.NEGATIVE : variants.FontColor.DARK
    }, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: lowestPrice
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-explanations/price-in-paranthesis.tsx






var PriceInParanthesis = function() {
    var productCardData = useProductCardContext();
    if (!showFeature("memberPriceText", productCardData)) return null;
    var originalPrice = productCardData.data.offer.originalPrice;
    return /*#__PURE__*/ react.createElement(price_text/* PriceText */.X, {
        emphasis: ui_text.FontEmphasis.MEDIUM,
        scale: ui_text.FontScale.S,
        weight: ui_text.FontWeight.NORMAL,
        containerProps: {
            "data-testid": "PriceInParanthesis"
        }
    }, "(", /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: originalPrice
    }), ")");
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-explanations/styles.ts
function price_explanations_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_explanations_styles_templateObject() {
    var data = price_explanations_styles_taggedTemplateLiteral([
        "\n  text-decoration: line-through;\n"
    ]);
    price_explanations_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledStrikethroughPrice = (0,styled_components_browser_esm["default"])(price_text/* PriceText */.X).withConfig({
    displayName: "StyledStrikethroughPrice",
    componentId: "sc-0-0"
})(price_explanations_styles_templateObject());

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-explanations/price-strikethrough.tsx






var PriceStrikethrough = function() {
    var productCardData = useProductCardContext();
    if (!showFeature("salesPriceText", productCardData)) return null;
    var originalPrice = productCardData.data.offer.originalPrice;
    return /*#__PURE__*/ react.createElement(StyledStrikethroughPrice, {
        emphasis: ui_text.FontEmphasis.MEDIUM,
        scale: ui_text.FontScale.S,
        weight: ui_text.FontWeight.NORMAL,
        containerProps: {
            "data-testid": "PriceStrikethrough"
        }
    }, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: originalPrice
    }));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-badges/sales-price-badge.tsx




var SalesPriceBadge = function() {
    var productCardData = useProductCardContext();
    if (!showFeature("salesPrice", productCardData)) return null;
    var _offer = productCardData.data.offer, price = _offer.price, priceExpires = _offer.priceExpires, originalPrice = _offer.originalPrice;
    return /*#__PURE__*/ react.createElement(badges/* CampaignBadge */.xV, {
        isCampaign: true,
        originalPrice: originalPrice,
        price: price,
        priceExpires: priceExpires,
        containerProps: {
            "data-testid": "SalesPriceBadge"
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(51676);
// EXTERNAL MODULE: ./src/components/modal-v2/modal.tsx
var modal_v2_modal = __webpack_require__(72291);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
// EXTERNAL MODULE: ./src/components/product-card/queries/image-search.graphql
var image_search_graphql = __webpack_require__(79018);
var image_search_graphql_default = /*#__PURE__*/__webpack_require__.n(image_search_graphql);
;// CONCATENATED MODULE: ./src/components/product-card/queries/use-image-search.ts


var CACHE_TIME_PER_PRODUCT_ID = 60 * 1000;
function useImageSearch(variables, enabled) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (image_search_graphql_default()),
        variables: variables,
        refetchOnReconnect: false,
        queryKey: [
            "use-image-search"
        ],
        enabled: enabled,
        staleTime: CACHE_TIME_PER_PRODUCT_ID
    });
}

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/tracking.ts

var trackImageSearchModalOpened = function(productId, categoryName, imageSearchModels) {
    var eventName = "imageSearchModalOpened";
    var eventData = {
        category: categoryName,
        productId: productId,
        modelIds: imageSearchModels === null || imageSearchModels === void 0 ? void 0 : imageSearchModels.join(",")
    };
    if (!eventData.category) delete eventData.category;
    if (!eventData.modelIds) delete eventData.modelIds;
    (0,data_layer/* pushEvent */.A)(eventName, eventData);
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/styles.ts
function image_search_modal_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function image_search_modal_styles_templateObject() {
    var data = image_search_modal_styles_taggedTemplateLiteral([
        "\n  overflow-x: hidden;\n"
    ]);
    image_search_modal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function image_search_modal_styles_templateObject1() {
    var data = image_search_modal_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: ",
        ";\n  grid-auto-rows: minmax(0, auto);\n"
    ]);
    image_search_modal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function image_search_modal_styles_templateObject2() {
    var data = image_search_modal_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: ",
        ";\n"
    ]);
    image_search_modal_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function image_search_modal_styles_templateObject3() {
    var data = image_search_modal_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    image_search_modal_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function image_search_modal_styles_templateObject4() {
    var data = image_search_modal_styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    image_search_modal_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function image_search_modal_styles_templateObject5() {
    var data = image_search_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    image_search_modal_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledModalBody = (0,styled_components_browser_esm["default"])(modal/* ModalBody */.fe).withConfig({
    displayName: "StyledModalBody",
    componentId: "sc-0-0"
})(image_search_modal_styles_templateObject());
var GridRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridRow",
    componentId: "sc-0-1"
})(image_search_modal_styles_templateObject1(), design_tokens.measurements.spacing100);
var GridItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridItem",
    componentId: "sc-0-2"
})(image_search_modal_styles_templateObject2(), design_tokens.measurements.spacing025);
var StyledNoResultText = (0,styled_components_browser_esm["default"])(variants.H3Text).withConfig({
    displayName: "StyledNoResultText",
    componentId: "sc-0-3"
})(image_search_modal_styles_templateObject3(), design_tokens.measurements.spacing050);
var styles_StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-4"
})(image_search_modal_styles_templateObject4(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing100, design_tokens.measurements.spacing150);
var StyledNoResultContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledNoResultContent",
    componentId: "sc-0-5"
})(image_search_modal_styles_templateObject5());

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/image-search-modal-content.tsx







var ImageSearchModalContent = function(props) {
    var ref;
    var isOpen = props.isOpen, productId = props.productId, categoryName = props.categoryName, imageSearchModels = props.imageSearchModels;
    var ref1 = (0,app_context/* useAppContext */.bp)(), t = ref1.t, market = ref1.market;
    var ref2 = useImageSearch({
        productId: productId
    }, isOpen), data = ref2.data, isLoading = ref2.isLoading;
    var products = (data === null || data === void 0 ? void 0 : (ref = data.visuallySimilarProductsV2) === null || ref === void 0 ? void 0 : ref.nodes) || [];
    (0,react.useEffect)(function() {
        if (isOpen) {
            trackImageSearchModalOpened(productId, categoryName, imageSearchModels);
        }
    }, [
        isOpen,
        categoryName,
        productId,
        imageSearchModels
    ]);
    var renderNoResults = /*#__PURE__*/ react.createElement(StyledNoResultContent, null, /*#__PURE__*/ react.createElement(StyledNoResultText, null, t("search", "visually-similar.no-results")), /*#__PURE__*/ react.createElement(styles_StyledImage, {
        src: "".concat(market.cdn, "/g/rfe/illustrations/no-search-result-illustration-309x229px.png"),
        alt: t("product", "results.no-product-found")
    }));
    var hasSearchResults = !isLoading && products.length > 0;
    var hasNoSearchResults = !isLoading && products.length === 0;
    return /*#__PURE__*/ react.createElement(StyledModalBody, null, isLoading && /*#__PURE__*/ react.createElement(loader/* default */.Z, {
        dataTestId: "loading-spinner"
    }), hasSearchResults ? /*#__PURE__*/ react.createElement(GridRow, null, products.map(function(product) {
        return /*#__PURE__*/ react.createElement(GridItem, {
            key: product.productId
        }, /*#__PURE__*/ react.createElement(ImageSearchProductCard, {
            product: product
        }));
    })) : null, hasNoSearchResults && renderNoResults);
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/image-search-modal.tsx
function image_search_modal_extends() {
    image_search_modal_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return image_search_modal_extends.apply(this, arguments);
}





var ImageSearchModal = function(props) {
    var isOpen = props.isOpen, closeModal = props.closeModal;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(modal_v2_modal["default"], {
        isOpen: isOpen,
        title: t("search", "visually-similar.modal-title"),
        size: modal/* ModalSizeEnum.MEDIUM */.E$.MEDIUM,
        onRequestClose: closeModal
    }, /*#__PURE__*/ react.createElement(ImageSearchModalContent, image_search_modal_extends({}, props)));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/index.tsx


;// CONCATENATED MODULE: ./src/components/product-card/contexts/image-search-modal-context.tsx
function image_search_modal_context_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function image_search_modal_context_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function image_search_modal_context_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function image_search_modal_context_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function image_search_modal_context_slicedToArray(arr, i) {
    return image_search_modal_context_arrayWithHoles(arr) || image_search_modal_context_iterableToArrayLimit(arr, i) || image_search_modal_context_unsupportedIterableToArray(arr, i) || image_search_modal_context_nonIterableRest();
}
function image_search_modal_context_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return image_search_modal_context_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return image_search_modal_context_arrayLikeToArray(o, minLen);
}


var ImageSearchModalContext = /*#__PURE__*/ (0,react.createContext)({
    openModal: undefined
});
var useImageSearchModalContext = function() {
    return (0,react.useContext)(ImageSearchModalContext);
};
var ImageSearchModalProvider = function(param) {
    var children = param.children;
    var ref = image_search_modal_context_slicedToArray((0,react.useState)(false), 2), showModal = ref[0], setShowModal = ref[1];
    var ref1 = image_search_modal_context_slicedToArray((0,react.useState)(0), 2), productId = ref1[0], setProductId = ref1[1];
    var ref2 = image_search_modal_context_slicedToArray((0,react.useState)(undefined), 2), imageSearchModels = ref2[0], setImageSearchModels = ref2[1];
    var ref3 = image_search_modal_context_slicedToArray((0,react.useState)(undefined), 2), categoryName = ref3[0], setCategoryName = ref3[1];
    var openModal = function(props) {
        setShowModal(true);
        setProductId(props.productId);
        setCategoryName(props.categoryName);
        setImageSearchModels(props.imageSearchModels);
    };
    var value = (0,react.useMemo)(function() {
        return {
            openModal: openModal
        };
    }, []);
    return /*#__PURE__*/ react.createElement(ImageSearchModalContext.Provider, {
        value: value
    }, children, showModal && /*#__PURE__*/ react.createElement(ImageSearchModal, {
        categoryName: categoryName,
        isOpen: showModal,
        productId: productId,
        imageSearchModels: imageSearchModels,
        closeModal: function() {
            return setShowModal(false);
        }
    }));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/utils.tsx


var showImageSearch = function(productCardData, market, overrideForAll) {
    return overrideForAll || market.imageSearchEnabled && showFeature(BottomRightCornerFeature.IMAGE_SEARCH, productCardData);
};

// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(84234);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/center-focus-strong/index.js
var center_focus_strong = __webpack_require__(35478);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon-interactive/index.js
var icon_interactive = __webpack_require__(64341);
// EXTERNAL MODULE: ./packages/frontend-admin-ui/dist/module.js + 1 modules
var dist_module = __webpack_require__(53254);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search.tsx











var ImageSearch = function() {
    var productCardData = useProductCardContext();
    var openModal = useImageSearchModalContext().openModal;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var showForAllProducts = (0,dist_module.useFeatureFlag)("image-search-all");
    if (!openModal || !showImageSearch(productCardData, market, showForAllProducts)) {
        return null;
    }
    var onClick = function(e) {
        var ref;
        e.preventDefault();
        e.stopPropagation();
        var productId = productCardData.data.product.id;
        var imageSearchModels = productCardData.data.product.imageSearchModels;
        var categoryName = (ref = productCardData.data.product.category) === null || ref === void 0 ? void 0 : ref.categoryName;
        openModal({
            productId: productId,
            categoryName: categoryName,
            imageSearchModels: imageSearchModels
        });
    };
    return /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement("div", {
        onClick: function(e) {
            return e.stopPropagation();
        },
        "data-testid": "ImageSearchWrapper"
    }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: t("search", "visually-similar.tooltip")
    }, /*#__PURE__*/ react.createElement(icon_interactive/* InteractiveIcon */.z, {
        icon: center_focus_strong/* IconCenterFocusStrong */.a,
        size: 30,
        onClick: onClick
    }))));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/index.tsx


;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/styles.ts
function bottom_right_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function bottom_right_styles_templateObject() {
    var data = bottom_right_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: 0;\n"
    ]);
    bottom_right_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledBottomRightArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledBottomRightArea",
    componentId: "sc-0-0"
})(bottom_right_styles_templateObject());

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/bottom-right-area.tsx



var BottomRightArea = function() {
    return /*#__PURE__*/ react.createElement(StyledBottomRightArea, null, /*#__PURE__*/ react.createElement(ImageSearch, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/index.tsx


;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/styles.ts
function price_components_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_components_styles_templateObject() {
    var data = price_components_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    price_components_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledBadgeWrapper",
    componentId: "sc-0-0"
})(price_components_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-badges/lowest-new-price-badge.tsx







var LowestNewPriceBadge = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var productCardData = useProductCardContext();
    if (!showFeature("lowestNewPrice", productCardData)) {
        return null;
    }
    var lowestNewPrice = productCardData.data.product.lowestNewPrice;
    return /*#__PURE__*/ react.createElement(StyledBadgeWrapper, null, /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "GREY",
        size: badge.BadgeSize.SMALL,
        text: "".concat(t("product", "product.new-from-abbr"), " ").concat((0,currency/* formatCurrency */.xG)(lowestNewPrice, market.code, false))
    }));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-explanations/lowest-price-info.tsx







var LowestPriceInfo = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var productCardData = useProductCardContext();
    var price = productCardData.data.offer.price;
    if (!showFeature("lowestPriceInfo", productCardData) || !price) return null;
    var memberPrice = productCardData.data.offer.memberPrice || Number.MAX_SAFE_INTEGER;
    var lowestPrice = Math.min(memberPrice, price);
    var storeCount = productCardData.data.product.storeCount;
    var formattedLowestPrice = (0,currency/* formatCurrency */.xG)(lowestPrice, market.code, false);
    if (!formattedLowestPrice) return null;
    return /*#__PURE__*/ react.createElement(VerticalTextAlignment, null, /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.HIGH
    }, t("product", "price.from-in", {
        price: formattedLowestPrice
    })), storeCount && storeCount >= 1 ? /*#__PURE__*/ react.createElement(variants.CaptionText, {
        containerProps: {
            "data-testid": "lowestPriceInfoCount"
        },
        emphasis: variants.FontEmphasis.HIGH,
        weight: variants.FontWeight.HEAVIEST
    }, t("product", "shop.count", {
        n: storeCount
    })) : null);
};

;// CONCATENATED MODULE: ./src/components/product-card/card-types/internal/base-product-card.tsx





















/**
 * Be mindful when modifying the BaseProductCard, changes to it will affect all card-types.
 * It uses a "showFeature" helper function so that each card-type will be able to show/hide specific features based on their use-case.
 * "showFeature" is also needed due to some features taking precedence and hiding other features (preventing multiple badges, showing too many prices at once etc).
 * The BaseProductCard should only ever receive 1 prop - the ProductCardData, it's completely detached from any specific backend/data source.
 *
 * Read more about product-card variations in "product-card/index.ts"
 * Read more about showFeature in "product-card/features/index.ts"
 */ // * Temporary comment (Remove during 2024)
// * When modifying the RFE version of the product-card, please also modify the NextJS version of the product-card.
var BaseProductCard = function() {
    return /*#__PURE__*/ react.createElement(CardWrapper, null, /*#__PURE__*/ react.createElement(TopLeftArea, null), /*#__PURE__*/ react.createElement(TopRightArea, null), /*#__PURE__*/ react.createElement(CardClickableArea, null, /*#__PURE__*/ react.createElement(FlexColumn, null, /*#__PURE__*/ react.createElement(ImageWrapper, null, /*#__PURE__*/ react.createElement(Image, null), /*#__PURE__*/ react.createElement(BottomRightArea, null)), /*#__PURE__*/ react.createElement(Category, null), /*#__PURE__*/ react.createElement(ProductName, null), /*#__PURE__*/ react.createElement(Rating, null)), /*#__PURE__*/ react.createElement(FlexColumnCompact, null, /*#__PURE__*/ react.createElement(PaidMembershipInfo, null), /*#__PURE__*/ react.createElement(MembershipPriceBadge, null), /*#__PURE__*/ react.createElement(SalesPriceBadge, null), /*#__PURE__*/ react.createElement(VerticalTextAlignment, {
        extraSpacing: true
    }, /*#__PURE__*/ react.createElement(Price, null), /*#__PURE__*/ react.createElement(PriceStrikethrough, null), /*#__PURE__*/ react.createElement(PriceInParanthesis, null)), /*#__PURE__*/ react.createElement(StoreInfo, null), /*#__PURE__*/ react.createElement(LowestNewPriceBadge, null))), /*#__PURE__*/ react.createElement(ClickoutButton, null), /*#__PURE__*/ react.createElement(LowestPriceInfo, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/mappers/map-product-card.ts
var mapProductCard = function(product) {
    var aggregatedRating = product.aggregatedRating, parentCategoryIds = product.parentCategoryIds, categoryName = product.categoryName, logo = product.logo, name = product.name, priceDrop = product.priceDrop, productId = product.productId, storeCount = product.storeCount, productLinkRaw = product.productLink, imageSearchModels = product.imageSearchModels, lowestNewPrice = product.lowestNewPrice, bestOffer = product.bestOffer;
    var ref = bestOffer || {}, condition = ref.condition, offerFeatured = ref.featured, membershipRequiresCompensation = ref.membershipRequiresCompensation, memberPrice = ref.memberPrice, offerLink = ref.offerLink, originalPrice = ref.originalPrice, price = ref.price, priceExpires = ref.priceExpires, shopOfferId = ref.shopOfferId, stockStatus = ref.stockStatus, storeId = ref.storeId, storeName = ref.storeName;
    var productLink = handleLinksToUsedProducts(productLinkRaw, Boolean(condition) && condition !== "new");
    var featured = offerFeatured && Boolean(offerLink);
    var result = {
        offer: {
            condition: condition !== null && condition !== void 0 ? condition : "new",
            featured: featured,
            memberPrice: memberPrice !== null && memberPrice !== void 0 ? memberPrice : undefined,
            membershipRequiresCompensation: membershipRequiresCompensation !== null && membershipRequiresCompensation !== void 0 ? membershipRequiresCompensation : false,
            offerLink: offerLink,
            originalPrice: originalPrice !== null && originalPrice !== void 0 ? originalPrice : undefined,
            price: price,
            priceExpires: priceExpires !== null && priceExpires !== void 0 ? priceExpires : undefined,
            shopOfferId: shopOfferId,
            stockStatus: stockStatus,
            storeId: storeId,
            storeName: storeName
        },
        product: {
            rating: aggregatedRating !== null && aggregatedRating !== void 0 ? aggregatedRating : undefined,
            category: {
                hierarchicalCategoryIds: parentCategoryIds !== null && parentCategoryIds !== void 0 ? parentCategoryIds : undefined,
                categoryName: categoryName !== null && categoryName !== void 0 ? categoryName : undefined
            },
            logo: logo !== null && logo !== void 0 ? logo : undefined,
            priceDrop: priceDrop !== null && priceDrop !== void 0 ? priceDrop : undefined,
            id: productId,
            imageSearchModels: imageSearchModels,
            productLink: productLink,
            name: name,
            storeCount: storeCount,
            lowestNewPrice: lowestNewPrice !== null && lowestNewPrice !== void 0 ? lowestNewPrice : undefined
        }
    };
    return result;
};
function handleLinksToUsedProducts(productLink, isUsed) {
    var href = productLink;
    if (isUsed) {
        href += "".concat(href.includes("?") ? "&" : "?", "expand=used");
    }
    return href;
}

;// CONCATENATED MODULE: ./src/areas/campaign/tracking.js

/**
 * Tracks a click on a campaign item (that is, a product in the campaign).
 * The structure matches the Redux action CAMPAIGN_ITEM_CLICK.
 */ var trackCampaignItemClick = function(item) {
    (0,data_layer/* pushEvent */.A)("campaignItemClick", {
        item: item
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/card-types/deals-product-card.tsx








var DealsProductCard = function(param) {
    var product = param.product, trackingIndex = param.trackingIndex;
    var data = mapProductCard(product);
    var initialState = {
        data: data,
        customTracking: {
            onCardClick: function() {
                return sendCampaignItemClick(product);
            }
        },
        features: {
            categoryName: true,
            clickoutButton: "default",
            deals: true,
            memberPrice: true,
            price: true,
            rating: true,
            salesPrice: true,
            shopInfo: true,
            lowestPriceInfo: false,
            topLeftCorner: [
                TopLeftCornerFeature.DEALS_BADGE
            ],
            topRightCorner: TopRightCornerFeature.DROPDOWN,
            bottomRightCorner: BottomRightCornerFeature.NONE
        },
        trackingClickoutScope: conversion/* TrackClickScope.CAMPAIGN_LIST_ITEM */.b8.CAMPAIGN_LIST_ITEM,
        trackingIndex: trackingIndex,
        trackingScope: tracking/* InternalNavigationScope.CAMPAIGN_PRODUCT_CARD */.U.CAMPAIGN_PRODUCT_CARD,
        type: ProductCardType.DEALS
    };
    return /*#__PURE__*/ react.createElement(ProductCardStateProvider, {
        initialState: initialState
    }, /*#__PURE__*/ react.createElement(BaseProductCard, null));
};
var sendCampaignItemClick = function(product) {
    if (!product.bestOffer) return;
    trackCampaignItemClick({
        external_uri: product.bestOffer.offerLink,
        price: product.bestOffer.price,
        product: product,
        store: {
            featured: product.bestOffer.featured,
            id: product.bestOffer.storeId,
            name: product.bestOffer.storeName
        }
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/card-types/image-search-product-card.tsx






var ImageSearchProductCard = function(param) {
    var customTracking = param.customTracking, product = param.product;
    var data = mapProductCard(product);
    var initialState = {
        data: data,
        customTracking: customTracking,
        features: {
            categoryName: false,
            clickoutButton: undefined,
            deals: true,
            memberPrice: false,
            price: true,
            rating: true,
            salesPrice: false,
            shopInfo: true,
            lowestPriceInfo: false,
            topLeftCorner: [
                TopLeftCornerFeature.POTY_BADGE,
                TopLeftCornerFeature.TOP_RATED_BADGE,
                TopLeftCornerFeature.DEALS_BADGE
            ],
            topRightCorner: TopRightCornerFeature.ADD_TO_LIST,
            bottomRightCorner: BottomRightCornerFeature.IMAGE_SEARCH
        },
        trackingClickoutScope: null,
        trackingScope: tracking/* InternalNavigationScope.GRID_LAYOUT_PRODUCT_CARD */.U.GRID_LAYOUT_PRODUCT_CARD,
        type: ProductCardType.IMAGE_SEARCH
    };
    return /*#__PURE__*/ react.createElement(ProductCardStateProvider, {
        initialState: initialState
    }, /*#__PURE__*/ react.createElement(BaseProductCard, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/mappers/map-promotion-offer.ts
var addPromotionTrackingToClickoutUrl = function(url, promotionInfo) {
    var ref;
    var clickoutUrl = "".concat(url || "", "&promotion_id=").concat(promotionInfo.id);
    if ((ref = promotionInfo.promotionCode) === null || ref === void 0 ? void 0 : ref.code) {
        var ref1;
        clickoutUrl = "".concat(clickoutUrl, "&promotion_code=").concat((ref1 = promotionInfo.promotionCode) === null || ref1 === void 0 ? void 0 : ref1.code);
    }
    return clickoutUrl;
};
var mapPromotionOffer = function(param) {
    var product = param.product, offer = param.offer, promotionInfo = param.promotionInfo;
    var ref;
    if (!promotionInfo.owner.id || !((ref = product.promotionShopPrices) === null || ref === void 0 ? void 0 : ref.length)) return undefined;
    var promotionShopPrice = product.promotionShopPrices.find(function(shop) {
        return shop;
    });
    if (!promotionShopPrice) return undefined;
    return {
        price: promotionShopPrice.price,
        shopId: Number(promotionInfo.owner.id),
        shopName: promotionInfo.owner.name,
        shopOfferId: promotionShopPrice.shopOfferId,
        offerLink: addPromotionTrackingToClickoutUrl(promotionShopPrice.offerLink || offer.offerLink, promotionInfo)
    };
};

;// CONCATENATED MODULE: ./src/components/product-card/card-types/promotion-product-card.tsx








var PromotionProductCard = function(param) {
    var product = param.product, customTracking = param.customTracking, trackingIndex = param.trackingIndex, promotionInfo = param.promotionInfo;
    var data = mapProductCard(product);
    var promotionOffer = mapPromotionOffer({
        offer: data.offer,
        product: product,
        promotionInfo: promotionInfo
    });
    var initialState = {
        data: data,
        customTracking: customTracking,
        features: {
            clickoutButton: "promotion",
            categoryName: true,
            deals: false,
            memberPrice: false,
            rating: true,
            salesPrice: false,
            shopInfo: false,
            price: false,
            lowestPriceInfo: true,
            topLeftCorner: [],
            topRightCorner: TopRightCornerFeature.ADD_TO_LIST,
            bottomRightCorner: BottomRightCornerFeature.NONE
        },
        promotionOffer: promotionOffer,
        trackingClickoutScope: conversion/* TrackClickScope.PROMOTION_PRODUCT_CARD */.b8.PROMOTION_PRODUCT_CARD,
        trackingIndex: trackingIndex,
        trackingScope: tracking/* InternalNavigationScope.PROMOTION_PRODUCT */.U.PROMOTION_PRODUCT,
        type: ProductCardType.PROMOTION_PRODUCT
    };
    return /*#__PURE__*/ react.createElement(ProductCardStateProvider, {
        initialState: initialState
    }, /*#__PURE__*/ react.createElement(BaseProductCard, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/mappers/map-search-result-product.ts
var mapSearchResultProduct = function(param) {
    var product = param.product, productOfTheYear = param.productOfTheYear;
    var aggregatedRating = product.aggregatedRating, backendCategory = product.category, media = product.media, name = product.name, dealInfo = product.dealInfo, id = product.id, isExpertTopRated = product.isExpertTopRated, regular = product.priceSummary.regular, pathName = product.pathName;
    var _first, ref;
    var result = {
        product: {
            category: mapCategory(backendCategory),
            rating: aggregatedRating !== null && aggregatedRating !== void 0 ? aggregatedRating : undefined,
            logo: (_first = media.first) !== null && _first !== void 0 ? _first : undefined,
            priceDrop: (ref = dealInfo === null || dealInfo === void 0 ? void 0 : dealInfo.dealPercentage) !== null && ref !== void 0 ? ref : undefined,
            id: id,
            name: name,
            productLink: pathName,
            isExpertTopRated: isExpertTopRated,
            imageSearchModels: [],
            productOfTheYear: productOfTheYear
        },
        offer: {
            price: regular
        }
    };
    return result;
};
// Array.findLast is not available in browser versions older than 2022 which e.g Pingdom uses.
var getLast = function(array) {
    return array[array.length - 1];
};
var mapCategory = function(backendCategory) {
    var ref;
    var leafCategory = (backendCategory === null || backendCategory === void 0 ? void 0 : backendCategory.path) ? getLast(backendCategory.path) : undefined;
    var ref1, ref2;
    var categoryName = (ref2 = (ref1 = backendCategory === null || backendCategory === void 0 ? void 0 : backendCategory.name) !== null && ref1 !== void 0 ? ref1 : leafCategory === null || leafCategory === void 0 ? void 0 : leafCategory.name) !== null && ref2 !== void 0 ? ref2 : undefined;
    var category = categoryName ? {
        hierarchicalCategoryIds: backendCategory === null || backendCategory === void 0 ? void 0 : (ref = backendCategory.path) === null || ref === void 0 ? void 0 : ref.map(function(cat) {
            return parseInt(cat.id, 10);
        }),
        categoryName: categoryName
    } : undefined;
    return category;
};

;// CONCATENATED MODULE: ./src/components/product-card/card-types/search-product-card.tsx







var SearchProductCard = function(param) {
    var customTracking = param.customTracking, product = param.product, productOfTheYear = param.productOfTheYear;
    var data = mapSearchResultProduct({
        product: product,
        productOfTheYear: productOfTheYear
    });
    var initialState = {
        data: data,
        customTracking: customTracking,
        features: {
            categoryName: true,
            clickoutButton: undefined,
            deals: true,
            memberPrice: false,
            price: true,
            rating: true,
            salesPrice: false,
            shopInfo: true,
            lowestPriceInfo: false,
            topLeftCorner: [
                TopLeftCornerFeature.POTY_BADGE,
                TopLeftCornerFeature.TOP_RATED_BADGE,
                TopLeftCornerFeature.DEALS_BADGE
            ],
            topRightCorner: TopRightCornerFeature.ADD_TO_LIST,
            bottomRightCorner: BottomRightCornerFeature.IMAGE_SEARCH
        },
        trackingClickoutScope: null,
        trackingScope: tracking/* InternalNavigationScope.GRID_LAYOUT_PRODUCT_CARD */.U.GRID_LAYOUT_PRODUCT_CARD,
        type: ProductCardType.SEARCH_RESULT
    };
    return /*#__PURE__*/ react.createElement(ProductCardStateProvider, {
        initialState: initialState
    }, /*#__PURE__*/ react.createElement(ImageSearchModalProvider, null, /*#__PURE__*/ react.createElement(BaseProductCard, null)));
};

;// CONCATENATED MODULE: ./src/components/product-card/card-types/used-product-card.tsx







var UsedProductCard = function(param) {
    var product = param.product, customTracking = param.customTracking, trackingIndex = param.trackingIndex;
    var data = mapProductCard(product);
    var initialState = {
        data: data,
        customTracking: customTracking,
        features: {
            categoryName: true,
            clickoutButton: "default",
            deals: false,
            memberPrice: true,
            price: true,
            rating: true,
            salesPrice: false,
            shopInfo: true,
            lowestPriceInfo: false,
            topLeftCorner: [
                TopLeftCornerFeature.USED_BADGE
            ],
            topRightCorner: TopRightCornerFeature.ADD_TO_LIST,
            bottomRightCorner: BottomRightCornerFeature.NONE
        },
        trackingClickoutScope: conversion/* TrackClickScope.USED_PRODUCT_CARD */.b8.USED_PRODUCT_CARD,
        trackingIndex: trackingIndex,
        trackingScope: tracking/* InternalNavigationScope.USED_PRODUCT */.U.USED_PRODUCT,
        type: ProductCardType.USED
    };
    return /*#__PURE__*/ react.createElement(ProductCardStateProvider, {
        initialState: initialState
    }, /*#__PURE__*/ react.createElement(BaseProductCard, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/index.ts




 /**
 * Note:
 * DO NOT export `card-types/internal/BaseProductCard`, it is the "abstract" base for several product card implementations.
 * Instead, use one of the provided product cards or derive your own component based off the base card.
 *
 * When creating a product card variant, add its specific settings in the "card-types" folder, customized to fit its specific use-case/page.
 * Each Card-type is responsible for taking the data it gets from any backend/data-source and mapping that to the ProductCardData.
 * This way the BaseProductCard remains reusable for all card-types.
 */  // * Temporary comment (Remove during 2024)
 // * When modifying the RFE version of the product-card, please also modify the NextJS version of the product-card.


/***/ }),

/***/ 95242:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ ProductImage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  opacity: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Image = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.$fallback ? 0.2 : 1;
});
var ProductImage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(param) {
    var fallback = param.fallback, src = param.src, name = param.name, className = param.className, height = param.height, width = param.width;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), _market = ref.market, market = _market === void 0 ? {
        cdn: "https://cdn.pji.nu"
    } : _market;
    var fallbackImage = fallback && !/^https?:\/\//.test(fallback) ? market.cdn + fallback : fallback;
    var productImage = src || fallbackImage || "".concat(market.cdn, "/product/standard/280/0.jpg");
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Image, {
        src: productImage,
        alt: name || "",
        className: className,
        height: height,
        width: width,
        $fallback: Boolean(!src && fallback)
    });
});


/***/ }),

/***/ 44266:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": () => (/* binding */ useGetProductOfTheYear)
/* harmony export */ });
/* unused harmony export useProductOfTheYearAwards */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);


/**
 * Retrive Product of the Year awards
 *
 * @param {number} [year] Year to retrive awards from. If omitted retrive all years
 * @returns Array of ProductOfTheYearAward, sorted by year
 */ var useProductOfTheYearAwards = function(year) {
    var productOfTheYear = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp)().productOfTheYear;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return productOfTheYear.filter(function(award) {
            return year ? year === (award === null || award === void 0 ? void 0 : award.year) : true;
        }).map(function(award) {
            return {
                awardName: award.awardName,
                awardLogo: award.awardLogo,
                year: award.year,
                productId: award.product.id
            };
        }).sort(function(a, b) {
            return a.year - b.year;
        });
    }, [
        productOfTheYear,
        year
    ]);
};
/**
 * Check if product has Product of the Year award
 *
 * @param {(string | number)} [productId]
 * @returns IsProductOfTheYear object. Latest year if several awards are present. If no award then false is returned.
 */ var useGetProductOfTheYear = function(productId) {
    var productOfTheYearAwards = useProductOfTheYearAwards();
    if (!productId) return undefined;
    var thisProductOfTheYearAwards = productOfTheYearAwards.filter(function(award) {
        return "".concat(productId) === "".concat(award.productId);
    });
    if (thisProductOfTheYearAwards.length === 0) return undefined;
    var latestAward = thisProductOfTheYearAwards.pop();
    return latestAward;
};


/***/ }),

/***/ 34990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ rating)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(13686);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(51362);
;// CONCATENATED MODULE: ./src/components/rating/constants.ts
var STAR_ICON_SIZE_SMALL = 12;
var STAR_ICON_SIZE_MEDIUM = 16;
var STAR_ICON_SIZE_LARGE = 18;
var STAR_ICON_SIZE_XL = 28;

// EXTERNAL MODULE: ./src/components/rating/styles.ts
var styles = __webpack_require__(80951);
;// CONCATENATED MODULE: ./src/components/rating/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var Rating = function(param) {
    var className = param.className, _interactive = param.interactive, interactive = _interactive === void 0 ? false : _interactive, _size = param.size, size = _size === void 0 ? "medium" : _size, _hide = param.hide, hide = _hide === void 0 ? false : _hide, _count = param.count, count = _count === void 0 ? 0 : _count, _counterPosition = param.counterPosition, counterPosition = _counterPosition === void 0 ? "right" : _counterPosition, dataTestid = param.dataTestid, _showCounter = param.showCounter, showCounter = _showCounter === void 0 ? true : _showCounter, _showCounterAs = param.showCounterAs, showCounterAs = _showCounterAs === void 0 ? "text" : _showCounterAs, _counterLimit = param.counterLimit, counterLimit = _counterLimit === void 0 ? 500 : _counterLimit, _countTranslation = param.countTranslation, countTranslation = _countTranslation === void 0 ? {
        domain: "reviews",
        key: "rating.n-reviews"
    } : _countTranslation, _rate = param.rate, rate = _rate === void 0 ? 0 : _rate, _nrOfDecimals = param.nrOfDecimals, nrOfDecimals = _nrOfDecimals === void 0 ? 1 : _nrOfDecimals, onChange = param.onChange, _singleStar = param.singleStar, singleStar = _singleStar === void 0 ? false : _singleStar, _centerAlign = param.centerAlign, centerAlign = _centerAlign === void 0 ? false : _centerAlign, _showRate = param.showRate, showRate = _showRate === void 0 ? false : _showRate, _showRateAs = param.showRateAs, showRateAs = _showRateAs === void 0 ? "number" : _showRateAs, _secondaryColors = param.secondaryColors, secondaryColors = _secondaryColors === void 0 ? false : _secondaryColors, _expertColors = param.expertColors, expertColors = _expertColors === void 0 ? false : _expertColors, styleCounterAsLink = param.styleCounterAsLink;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (hide) return null;
    var starCount = singleStar ? 1 : 5;
    var stars = _toConsumableArray(new Array(starCount)).map(function(_, i) {
        return i + 1;
    });
    var rating = rating_helper/* default.convert */.Z.convert(rate !== null && rate !== void 0 ? rate : 0, nrOfDecimals);
    var halfStar = rating.half !== rating.whole;
    var starSize;
    switch(size){
        case "xl":
            starSize = STAR_ICON_SIZE_XL;
            break;
        case "large":
            starSize = STAR_ICON_SIZE_LARGE;
            break;
        case "medium":
            starSize = STAR_ICON_SIZE_MEDIUM;
            break;
        case "small":
            starSize = STAR_ICON_SIZE_SMALL;
            break;
        default:
            break;
    }
    var getCounterText = function() {
        if (count === null) {
            return null;
        }
        var hasExceededLimit = count !== 0 && count > counterLimit;
        if (showCounterAs === "number") {
            return hasExceededLimit ? "".concat(counterLimit, "+") : count;
        }
        var countTranslationKey = hasExceededLimit ? "".concat(countTranslation.key, "-limited") : countTranslation.key;
        var maybeLimitedCount = hasExceededLimit ? counterLimit : count;
        return t(countTranslation.domain, countTranslationKey, {
            n: maybeLimitedCount,
            count: maybeLimitedCount
        });
    };
    if (interactive) return /*#__PURE__*/ react.createElement(InteractiveRating, {
        stars: stars,
        size: size,
        onChange: onChange,
        rate: rate
    });
    return /*#__PURE__*/ react.createElement(styles/* Rating */.iG, {
        className: className,
        centerAlign: centerAlign,
        "aria-label": t("reviews", "rating.rate-n-text-version", {
            n: rating.rounded
        }),
        "data-testid": dataTestid
    }, /*#__PURE__*/ react.createElement(styles/* StarsWrapper */.gL, {
        counterPosition: counterPosition
    }, /*#__PURE__*/ react.createElement(styles/* StarIcons */.Ob, {
        secondaryColors: secondaryColors,
        expertColors: expertColors,
        halfStar: halfStar,
        stars: stars,
        rating: rating,
        size: starSize
    }), showRate && rating.whole > 0 && // eslint-disable-next-line react/jsx-no-useless-fragment
    /*#__PURE__*/ react.createElement(react.Fragment, null, showRateAs === "text" ? /*#__PURE__*/ react.createElement(styles/* RateText */.eP, {
        size: size
    }, t("reviews", "rating.rate-n-text-version.md", {
        n: rating.rounded
    })) : /*#__PURE__*/ react.createElement(styles/* RateNumber */.xe, {
        size: size
    }, rating.rounded))), showCounter && count !== null && count > 0 && /*#__PURE__*/ react.createElement(styles/* CounterWrapper */.nU, null, "(", /*#__PURE__*/ react.createElement(styles/* Counter */.AT, {
        size: size,
        counterPosition: counterPosition,
        $linkStyles: styleCounterAsLink
    }, getCounterText()), ")"));
};
var InteractiveRating = function(param) {
    var stars = param.stars, size = param.size, rate = param.rate, onChange = param.onChange;
    var ref = _slicedToArray((0,react.useState)(0), 2), selectedRating = ref[0], setSelectedRating = ref[1];
    var handleChange = function(rating, e) {
        if (onChange) {
            onChange(rating * 2, e);
        }
        setSelectedRating(rating);
    };
    var reverseStars = (0,react.useMemo)(function() {
        return stars.reverse();
    }, [
        stars
    ]);
    // Uses a css technique to fills every star on the left side of selected radio button, in this labels
    // are floated to the right. To emit correct values i.e. first star emits 1 and so forth,
    // the map of rate values is reversed.
    return /*#__PURE__*/ react.createElement(styles/* Rating */.iG, null, /*#__PURE__*/ react.createElement(styles/* Fieldset */.pg, null, reverseStars.map(function(current) {
        return /*#__PURE__*/ react.createElement(react.Fragment, {
            key: current
        }, /*#__PURE__*/ react.createElement("input", {
            name: "rating",
            id: "rate-input-".concat(current),
            checked: selectedRating > 0 ? current === selectedRating : current === rating_helper/* default.toWhole */.Z.toWhole(rate !== null && rate !== void 0 ? rate : 0),
            onChange: function(e) {
                return handleChange(current, e);
            },
            value: current * 2,
            type: "radio"
        }), /*#__PURE__*/ react.createElement("label", {
            htmlFor: "rate-input-".concat(current)
        }, /*#__PURE__*/ react.createElement(icons/* StarIcon */.r7, {
            height: size === "medium" ? 16 : 12
        })));
    })));
};
/* harmony default export */ var rating = (Rating);


/***/ }),

/***/ 51362:
/***/ ((__unused_webpack_module, __webpack_exports__) => {

"use strict";
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var RatingHelper = /*#__PURE__*/ function() {
    "use strict";
    function RatingHelper() {
        _classCallCheck(this, RatingHelper);
    }
    RatingHelper.toRounded = function toRounded(rating) {
        var nrOfDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return parseFloat(rating.toFixed(nrOfDecimals));
    };
    RatingHelper.toRoundedString = function toRoundedString(rating) {
        var nrOfDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return rating.toFixed(nrOfDecimals);
    };
    RatingHelper.toHalf = function toHalf(rating) {
        return Math.ceil(RatingHelper.toRounded(rating) * 2) / 2;
    };
    RatingHelper.toWhole = function toWhole(rating) {
        return Math.ceil(RatingHelper.toRounded(rating));
    };
    RatingHelper.convert = function convert(rating) {
        var nrOfDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return {
            real: rating,
            rounded: RatingHelper.toRounded(rating, nrOfDecimals),
            roundedString: RatingHelper.toRoundedString(rating, nrOfDecimals),
            half: RatingHelper.toHalf(rating),
            whole: RatingHelper.toWhole(rating)
        };
    };
    return RatingHelper;
}();
/* harmony default export */ __webpack_exports__["Z"] = (RatingHelper);


/***/ }),

/***/ 89636:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ smiley_rating)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/rating-icon/index.tsx + 1 modules
var rating_icon = __webpack_require__(8354);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/utils.ts
var utils = __webpack_require__(53751);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/rating/smiley-rating/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &::after {\n        content: attr(data-rating);\n        position: absolute;\n        bottom: -8px;\n        left: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 22px;\n        height: 13px;\n        border-radius: 8px;\n        font-size: 10px;\n        font-weight: 600;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: normal;\n        letter-spacing: normal;\n        text-align: center;\n        background: ",
        ";\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n          font-size: ",
        ";\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      &::after {\n        content: attr(data-rating);\n        display: inline;\n        line-height: 1.4;\n        font-size: ",
        ";\n        margin-left: ",
        ";\n        color: ",
        ";\n\n        ",
        "\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0 0 0 ",
        ";\n    font-size: ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var IconWrapper = styled_components_browser_esm["default"].div.attrs({
    "data-test": "Rating"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), props.scoreVisibility === "compact" && (0,styled_components_browser_esm.css)(_templateObject(), props.theme.ratings.disabled.bg, props.theme.ratings.disabled.fg), props.scoreVisibility === "row" && (0,styled_components_browser_esm.css)(_templateObject2(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
        return p.theme.text.secondary;
    }, props.size === "small" && (0,styled_components_browser_esm.css)(_templateObject1(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall)));
});
var RatingSmiley = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingSmiley",
    componentId: "sc-0-0"
})(_templateObject4());
var RatingCount = styled_components_browser_esm["default"].p.withConfig({
    displayName: "RatingCount",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, props.theme.text.quaternary);
});

;// CONCATENATED MODULE: ./src/components/rating/smiley-rating/index.tsx





var smiley_rating_RatingSmiley = function(param) {
    var featured = param.featured, rating = param.rating, reviewCount = param.reviewCount, scoreVisibility = param.scoreVisibility, _size = param.size, size = _size === void 0 ? "normal" : _size, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var iconSize = size === "small" ? 17 : 20;
    var smileyRating = (0,utils/* getSmileyRating */.P)(rating.rounded);
    var label = t("reviews", "rating.rate-n-text-version", {
        n: rating.roundedString
    });
    if (!smileyRating) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(RatingSmiley, {
        className: className
    }, smileyRating.iconType ? /*#__PURE__*/ react.createElement(IconWrapper, {
        "aria-label": label,
        "data-rating": rating.roundedString,
        scoreVisibility: scoreVisibility,
        size: size
    }, /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
        type: smileyRating.iconType,
        disabled: !featured,
        size: iconSize,
        ariaLabel: label
    })) : null, reviewCount && /*#__PURE__*/ react.createElement(RatingCount, null, "(".concat(reviewCount > 500 ? "500+" : reviewCount, ")")));
};
/* harmony default export */ var smiley_rating = (smiley_rating_RatingSmiley);


/***/ }),

/***/ 8354:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ rating_icon)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/types.ts
var types = __webpack_require__(70426);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(13686);
;// CONCATENATED MODULE: ./src/components/rating/smiley-rating/rating-icon/styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var sharedStyles = (0,styled_components_browser_esm.css)(_templateObject(), function(p) {
    return p.size && p.size >= 48 ? "8px" : "4px";
});
var Angry = (0,styled_components_browser_esm["default"])(icons/* EmoticonAngry */.Sd).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.negative.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), sharedStyles, props.theme.ratings.negative.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.ratings.disabled.bg));
});
var Dissatisfied = (0,styled_components_browser_esm["default"])(icons/* EmoticonDissatisfied */._z).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.negative.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), sharedStyles, props.theme.ratings.negative.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.ratings.disabled.bg));
});
var Neutral = (0,styled_components_browser_esm["default"])(icons/* EmoticonNeutral */.sS).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.neutral.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), sharedStyles, props.theme.ratings.neutral.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject5(), props.theme.ratings.disabled.bg));
});
var Smiling = (0,styled_components_browser_esm["default"])(icons/* EmoticonSmiling */.wr).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.positive.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), sharedStyles, props.theme.ratings.positive.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject7(), props.theme.ratings.disabled.bg));
});
var Laughing = (0,styled_components_browser_esm["default"])(icons/* EmoticonLaughing */.X3).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.positive.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject10(), sharedStyles, props.theme.ratings.positive.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject9(), props.theme.ratings.disabled.bg));
});

;// CONCATENATED MODULE: ./src/components/rating/smiley-rating/rating-icon/index.tsx



var RatingIcon = function(param) {
    var disabled = param.disabled, size = param.size, type = param.type, ariaLabel = param.ariaLabel;
    switch(type){
        case types/* SmileyType.ANGRY */.P.ANGRY:
            return /*#__PURE__*/ react.createElement(Angry, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        case types/* SmileyType.DISSATISFIED */.P.DISSATISFIED:
            return /*#__PURE__*/ react.createElement(Dissatisfied, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        case types/* SmileyType.NEUTRAL */.P.NEUTRAL:
            return /*#__PURE__*/ react.createElement(Neutral, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        case types/* SmileyType.SMILING */.P.SMILING:
            return /*#__PURE__*/ react.createElement(Smiling, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        case types/* SmileyType.LAUGHING */.P.LAUGHING:
            return /*#__PURE__*/ react.createElement(Laughing, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        default:
            return null;
    }
};
/* harmony default export */ var rating_icon = (RatingIcon);


/***/ }),

/***/ 70426:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ SmileyType),
/* harmony export */   "S": () => (/* binding */ RatingString)
/* harmony export */ });
var SmileyType;
(function(SmileyType) {
    SmileyType["ANGRY"] = "smiley-angry";
    SmileyType["DISSATISFIED"] = "smiley-dissatisfied";
    SmileyType["NEUTRAL"] = "smiley-neutral";
    SmileyType["SMILING"] = "smiley-smiling";
    SmileyType["LAUGHING"] = "smiley-laughing";
})(SmileyType || (SmileyType = {}));
var RatingString;
(function(RatingString) {
    RatingString["terrible"] = "rating.terrible";
    RatingString["bad"] = "rating.bad";
    RatingString["ok"] = "rating.ok";
    RatingString["good"] = "rating.good";
    RatingString["excellent"] = "rating.excellent";
})(RatingString || (RatingString = {}));


/***/ }),

/***/ 53751:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ getSmileyRating)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70426);

var getSmileyRating = function(rating) {
    if (rating <= 1) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.ANGRY */ .P.ANGRY,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.terrible */ .S.terrible
        };
    }
    if (rating <= 2) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.DISSATISFIED */ .P.DISSATISFIED,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.bad */ .S.bad
        };
    }
    if (rating <= 3) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.NEUTRAL */ .P.NEUTRAL,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.ok */ .S.ok
        };
    }
    if (rating <= 4) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.SMILING */ .P.SMILING,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.good */ .S.good
        };
    }
    if (rating > 4) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.LAUGHING */ .P.LAUGHING,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.excellent */ .S.excellent
        };
    }
    return null;
};


/***/ }),

/***/ 12814:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25349);


var StarIcons = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, stars = param.stars, rating = param.rating, secondaryColors = param.secondaryColors, expertColors = param.expertColors, halfStar = param.halfStar, className = param.className;
    var market = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).market;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        style: {
            width: (size + 1) * stars.length,
            lineHeight: 0
        },
        className: className
    }, stars.map(function(star) {
        var cdn = market && market.cdn ? market.cdn : "https://cdn.pji.nu";
        var file = "empty-new";
        var alt = "Empty Star";
        if (halfStar && rating.whole === star) {
            // Half stars
            if (secondaryColors) {
                file = "alt-half";
                alt = "Half Star";
            } else if (expertColors) {
                file = "expert-half-new";
                alt = "Half Star";
            } else {
                file = "primary-half-new";
                alt = "Half Star";
            }
        } else if (rating.whole >= star) {
            if (secondaryColors) {
                file = "alt-full";
                alt = "Full Star";
            } else if (expertColors) {
                file = "expert-full-new";
                alt = "Full Star";
            } else {
                file = "primary-full-new";
                alt = "Full Star";
            }
        }
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
            key: "star-".concat(star),
            style: {
                width: size,
                height: size,
                marginRight: "1px"
            },
            src: "".concat(cdn, "/g/rfe/icons/stars/").concat(file, ".svg"),
            alt: "".concat(alt, " ").concat(star)
        });
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(StarIcons));


/***/ }),

/***/ 80951:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": () => (/* binding */ Counter),
/* harmony export */   "Ob": () => (/* binding */ StarIcons),
/* harmony export */   "eP": () => (/* binding */ RateText),
/* harmony export */   "gL": () => (/* binding */ StarsWrapper),
/* harmony export */   "iG": () => (/* binding */ Rating),
/* harmony export */   "nU": () => (/* binding */ CounterWrapper),
/* harmony export */   "pg": () => (/* binding */ Fieldset),
/* harmony export */   "xe": () => (/* binding */ RateNumber)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43220);
/* harmony import */ var _star_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12814);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  line-height: 1.4;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  line-height: 1.4;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline;\n  line-height: 1.2;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      text-decoration: underline;\n      &:hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      position: relative;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      padding-left: 0;\n      display: block;\n      width: 100%;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0;\n    line-height: 1.2;\n\n    ",
        "\n\n    ",
        "\n\n      ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: center;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    align-items: center;\n    gap: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n    font-weight: normal;\n    ",
        ";\n\n    p {\n      margin-bottom: 0;\n    }\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    font-weight: bold;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  float: left;\n  padding: 0;\n  margin: 0;\n  border: none;\n  /* Float right to be able to use sibling selector (~) on hover\n  to be able to fill all previous icons with correct direction */\n  > label {\n    float: right;\n    cursor: pointer;\n  }\n\n  > input {\n    display: none;\n  }\n\n  /* highlight current and previous icons when checked */\n  > input:checked ~ label {\n    svg path {\n      fill: ",
        ";\n    }\n  }\n\n  &:not(:checked) > label:hover, /* highlight current icon on hover */\n      &:not(:checked) > label:hover ~ label, /* highlight previous icons on hover */\n      > input:checked + label:hover, /* highlight current icon on change */\n      > input:checked ~ label:hover,\n      > input:checked ~ label:hover ~ label {\n    svg path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}




var sharedStyleSizeSmall = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(12));
var sharedStyleSizeLarge = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(16));
var sharedStylesRateText = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2());
var CounterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "CounterWrapper",
    componentId: "sc-0-0"
})(_templateObject3(), function(p) {
    return p.theme.colors.base500;
});
var Counter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Counter",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), props.$linkStyles && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), function(p) {
        return p.theme.text.callToActionHover;
    }), props.size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), sharedStyleSizeSmall), props.size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), sharedStyleSizeLarge), props.counterPosition === "right" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), function(p) {
        return p.theme.text.tertiary;
    }), props.counterPosition === "bottom" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8()));
});
var Rating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.attrs({
    "data-test": "Rating"
}).withConfig({
    displayName: "Rating",
    componentId: "sc-0-2"
})(_templateObject11(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_2__.measurements.spacing050, function(props) {
    return props.centerAlign && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject10());
});
var StarsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StarsWrapper",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject13(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(4), props.counterPosition === "right" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject12()));
});
var StarIcons = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_star_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    displayName: "StarIcons",
    componentId: "sc-0-4"
})(_templateObject14());
var RateText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "RateText",
    componentId: "sc-0-5"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject17(), sharedStylesRateText, props.size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject15(), sharedStyleSizeSmall), props.size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject16(), sharedStyleSizeLarge));
});
var RateNumber = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "RateNumber",
    componentId: "sc-0-6"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject20(), sharedStylesRateText, props.size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), sharedStyleSizeSmall), props.size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), sharedStyleSizeLarge));
});
var Fieldset = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].fieldset.withConfig({
    displayName: "Fieldset",
    componentId: "sc-0-7"
})(_templateObject21(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .ratingStarColors.active */ .m4.active, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .ratingStarColors.active */ .m4.active);


/***/ }),

/***/ 76334:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bx": () => (/* binding */ LOAD_RECENTLY_VISITED),
/* harmony export */   "NU": () => (/* binding */ removeRecentlyVisitedItem),
/* harmony export */   "QN": () => (/* binding */ REMOVE_RECENTLY_VISITED_ITEM),
/* harmony export */   "e_": () => (/* binding */ loadRecentlyVisited)
/* harmony export */ });
var REMOVE_RECENTLY_VISITED_ITEM = "REMOVE_RECENTLY_VISITED_ITEM";
var LOAD_RECENTLY_VISITED = "LOAD_RECENTLY_VISITED";
var removeRecentlyVisitedItem = function(id) {
    return {
        type: REMOVE_RECENTLY_VISITED_ITEM,
        id: id
    };
};
var loadRecentlyVisited = function() {
    return {
        type: LOAD_RECENTLY_VISITED
    };
};


/***/ }),

/***/ 24068:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

var RecentlyVisitedProductsLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "secondary-content";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | secondary-content */ 88).then(__webpack_require__.bind(__webpack_require__, 82394));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(82394);
        }
        return eval("require.resolve")("./recently-visited");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (RecentlyVisitedProductsLoader);


/***/ }),

/***/ 23581:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200);
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 58869:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": () => (/* binding */ ScrollHandler),
/* harmony export */   "o": () => (/* binding */ getScrollPositionFromElement)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38209);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_2__);



var ScrollHandler = function(props) {
    var onScrollCallback = props.onScrollCallback, _topMargin = props.topMargin, topMargin = _topMargin === void 0 ? 0 : _topMargin;
    var location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .useLocation */ .TH)();
    var handleScroll = lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        if (onScrollCallback) onScrollCallback();
    }, 400);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var element = document.getElementById(location.hash);
        if (!element) return;
        setTimeout(function() {
            window.scrollTo({
                behavior: "smooth",
                top: getScrollPositionFromElement(element, topMargin)
            });
        }, 100);
    }, [
        location,
        topMargin
    ]);
    return null;
};
function getScrollPositionFromElement(element, topMargin) {
    var ref;
    if (!element) {
        return 0;
    }
    var header = (ref = window.document.getElementsByTagName("header")) === null || ref === void 0 ? void 0 : ref[0];
    var _height;
    return element.getBoundingClientRect().top + window.scrollY - topMargin - ((_height = header === null || header === void 0 ? void 0 : header.getBoundingClientRect().height) !== null && _height !== void 0 ? _height : 0);
}


/***/ }),

/***/ 85011:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": () => (/* binding */ ScrollElement)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19006);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


var _Component;
var ScrollElement = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(ScrollElement, _superClass);
    var _super = _createSuper(ScrollElement);
    function ScrollElement() {
        _classCallCheck(this, ScrollElement);
        var _this;
        _this = _super.apply(this, arguments);
        _this.node = null;
        return _this;
    }
    var _proto = ScrollElement.prototype;
    _proto.componentDidMount = function componentDidMount() {
        (0,_map__WEBPACK_IMPORTED_MODULE_1__/* .set */ .t8)(this.props.name, this.node);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0,_map__WEBPACK_IMPORTED_MODULE_1__/* .clear */ .ZH)(this.props.name);
    };
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", {
            ref: function(node) {
                _this.node = node;
            },
            "data-test": this.props["data-test"],
            className: this.props.className
        }, this.props.children);
    };
    return ScrollElement;
}(_Component = react__WEBPACK_IMPORTED_MODULE_0__.Component);
ScrollElement.defaultProps = {
    children: null
};


/***/ }),

/***/ 19006:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U2": () => (/* binding */ get),
/* harmony export */   "ZH": () => (/* binding */ clear),
/* harmony export */   "t8": () => (/* binding */ set)
/* harmony export */ });
// This file is causing memory leaks
var map = {};
function set(key, value) {
    map[key] = value;
    return map;
}
function get(key) {
    return map[key];
}
function clear(key) {
    map[key] = undefined;
    return map;
}



/***/ }),

/***/ 40763:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xL": () => (/* reexport */ components_element/* ScrollElement */.x),
  "Rv": () => (/* reexport */ ScrollLink)
});

// UNUSED EXPORTS: SCROLL_DURATION

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/scroll/components/map.ts
var map = __webpack_require__(19006);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/scroll/components/link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n\n  &:hover {\n    p {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledElement = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledElement",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/scroll/components/link/index.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var SCROLL_DURATION = 200;
var _Component;
var ScrollLink = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(ScrollLink, _superClass);
    var _super = _createSuper(ScrollLink);
    function ScrollLink() {
        _classCallCheck(this, ScrollLink);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onClickHandler = function(e) {
            _this.props.onClick(e);
            var contains = true;
            var current = e.target;
            while(contains){
                contains = Boolean(current && e.currentTarget.contains(current));
                // Exit while loop if we should scroll
                if (current && _this.props.shouldScroll(current)) {
                    var ele = (0,map/* get */.U2)(_this.props.to);
                    if (ele) {
                        _this.scrollTo(ele);
                    }
                    break;
                }
                current = current && current.parentNode;
            }
        };
        return _this;
    }
    var _proto = ScrollLink.prototype;
    _proto.scrollTo = function scrollTo(domElement) {
        var _props = this.props, direction = _props.direction, animate = _props.animate;
        if (!domElement) {
            return;
        }
        var offset = this.props.calculateOffset();
        var from = window.pageYOffset;
        var to = domElement.offsetTop - offset;
        if (direction === "up" && from < to) {
            return;
        }
        if (direction === "down" && from > to) {
            return;
        }
        // Init scroll animation.
        base/* animationUtils.tween */.ry.tween({
            from: from,
            to: to,
            duration: animate ? SCROLL_DURATION : 0,
            onUpdate: function onUpdate(value) {
                window.scrollTo(0, Math.round(value));
            }
        });
    };
    _proto.render = function render() {
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
        /*#__PURE__*/ react.createElement(StyledElement, {
            className: "pj-ui-scroll-link ".concat(this.props.className),
            onClick: this.onClickHandler,
            as: this.props.component
        }, this.props.children));
    };
    return ScrollLink;
}(_Component = react.Component);
ScrollLink.defaultProps = {
    component: "span",
    shouldScroll: function() {
        return true;
    },
    calculateOffset: function() {
        return 0;
    },
    children: null,
    direction: "both",
    animate: true,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick: function() {},
    className: ""
};

// EXTERNAL MODULE: ./src/components/scroll/components/element/index.tsx
var components_element = __webpack_require__(85011);
;// CONCATENATED MODULE: ./src/components/scroll/index.ts





/***/ }),

/***/ 87316:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ SearchBar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/search-suggestions/history-storage.tsx
var history_storage = __webpack_require__(81118);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(29261);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(83830);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(56853);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
;// CONCATENATED MODULE: ./src/components/search-bar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    max-width: ",
        ";\n  }\n\n  to {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    max-width: ",
        ";\n  }\n\n  to {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0 ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n          animation: ",
        " 150ms;\n          width: ",
        ";\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n          max-width: ",
        ";\n          width: auto;\n          animation: ",
        " 150ms;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    background-color: ",
        ";\n    height: 100%;\n    padding: 0 ",
        ";\n    user-select: none;\n    cursor: ",
        ";\n    width: ",
        ";\n    min-width: ",
        ";\n    transition: background-color 150ms ease;\n    overflow: hidden;\n    color: rgba(0, 0, 0, 1);\n\n    &:disabled {\n      color: rgba(0, 0, 0, 0.3);\n    }\n\n    &:hover {\n      background-color: ",
        ";\n    }\n\n    ",
        "\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      box-shadow: none;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n        border-radius: ",
        ";\n      "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: ",
        ";\n    overflow: hidden;\n    position: relative;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    background: ",
        ";\n    z-index: ",
        ";\n\n    ",
        ";\n\n    ",
        " {\n      ",
        ";\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 1 auto;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  flex: 1 0 auto;\n  height: 100%;\n  opacity: 1;\n\n  ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    height: 48px;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  background: transparent;\n  border: none;\n  width: 100%;\n  height: ",
        ";\n  flex-grow: 1;\n  padding: 0 ",
        ";\n\n  ",
        ";\n\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin-right: ",
        ";\n  cursor: pointer;\n  transition: background-color 150ms ease;\n  flex: 0 0 auto;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    align-items: center;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        position: fixed;\n        z-index: ",
        ";\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 56px;\n        background: ",
        ";\n        flex-direction: column;\n        height: 100vh;\n        max-width: initial;\n      "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: 590px;\n  display: flex;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    padding: 0 ",
        ";\n    z-index: ",
        ";\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  flex-shrink: 0;\n  z-index: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}







var _measurements = base/* layout.measurements */.bK.measurements, spacing050 = _measurements.spacing050, spacing100 = _measurements.spacing100;
var BUTTON_MIN = "40px";
var BUTTON_MAX = "135px";
var scaleIn = (0,styled_components_browser_esm.keyframes)(_templateObject(), BUTTON_MIN, BUTTON_MAX);
var scaleOut = (0,styled_components_browser_esm.keyframes)(_templateObject1(), BUTTON_MAX, BUTTON_MIN);
var searchButtonColor = function(p) {
    if (!p.active) {
        return "";
    }
    return "background-color: ".concat(p.disabled ? "transparent" : p.theme.colors.yellove500, ";");
};
var SearchButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "SearchButton",
    componentId: "sc-0-0"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject7(), p.theme.colors.yellove500, spacing100, p.disabled ? "initial" : "pointer", BUTTON_MIN, BUTTON_MIN, base/* colorUtils.shadeColor */.$n.shadeColor(p.theme.colors.yellove500, p.disabled ? 0 : -10), base/* media.mediumDown */.BC.mediumDown(_templateObject2(), spacing050), base/* media.smallOnly */.BC.smallOnly(_templateObject3(), searchButtonColor(p)), base/* media.mediumUp */.BC.mediumUp(_templateObject6(), p.disabled && (0,styled_components_browser_esm.css)(_templateObject4(), scaleOut, BUTTON_MIN), !p.disabled && (0,styled_components_browser_esm.css)(_templateObject5(), BUTTON_MAX, scaleIn)));
});
var StyledSearchBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSearchBar",
    componentId: "sc-0-1"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject10(), base/* layout.searchBar.height.desktop.rem */.bK.searchBar.height.desktop.rem, p.theme.colors.base0, zindex/* zindex.menu.searchSuggestions */.Y.menu.searchSuggestions, base/* media.smallOnly */.BC.smallOnly(_templateObject8()), SearchButton, base/* media.smallOnly */.BC.smallOnly(_templateObject9(), p.$active ? "4px" : 0));
});
var InputWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InputWrapper",
    componentId: "sc-0-2"
})(_templateObject12(), base/* media.smallOnly */.BC.smallOnly(_templateObject11()));
var SearchInput = styled_components_browser_esm["default"].input.withConfig({
    displayName: "SearchInput",
    componentId: "sc-0-3"
})(_templateObject14(), base/* layout.searchBar.height.desktop.rem */.bK.searchBar.height.desktop.rem, spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject13()));
var ClearIcon = (0,styled_components_browser_esm["default"])(icon_close.IconClose).withConfig({
    displayName: "ClearIcon",
    componentId: "sc-0-4"
})(_templateObject15());
var ClearButton = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ClearButton",
    componentId: "sc-0-5"
})(_templateObject16(), function(p) {
    return p.show ? "flex" : "none";
}, function(p) {
    return p.theme.bg.tertiary;
}, function(p) {
    return p.theme.icons.primary;
}, spacing100, function(p) {
    return base/* colorUtils.shadeColor */.$n.shadeColor(p.theme.bg.tertiary, -20);
});
var SearchIcon = (0,styled_components_browser_esm["default"])(magnifier/* IconMagnifier */.j).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-6"
})(_templateObject17());
var SearchButtonText = (0,styled_components_browser_esm["default"])(variants.TitleSmallText).withConfig({
    displayName: "SearchButtonText",
    componentId: "sc-0-7"
})(_templateObject18());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-8"
})(_templateObject20(), function(p) {
    return p.$visible ? "inline" : "none";
}, base/* media.smallOnly */.BC.smallOnly(_templateObject19()));
var searchBarMobile = function(p) {
    if (p.$active) {
        return (0,styled_components_browser_esm.css)(_templateObject22(), base/* media.smallOnly */.BC.smallOnly(_templateObject21(), zindex/* zindex.menu.searchBar */.Y.menu.searchBar, p.theme.bg.primary));
    }
    return null;
};
var SearchBarWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchBarWrapper",
    componentId: "sc-0-9"
})(_templateObject23(), function(p) {
    return p.$active ? "z-index: 109;" : "z-index:1;";
}, function(p) {
    return searchBarMobile(p);
});
var SearchBarGroup = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchBarGroup",
    componentId: "sc-0-10"
})(_templateObject25(), zindex/* zindex.menu.searchBar */.Y.menu.searchBar, function(p) {
    return base/* media.smallOnly */.BC.smallOnly(_templateObject24(), p.$active ? "box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); max-width: 100%; height: 56px;" : "", spacing050, zindex/* zindex.modal */.Y.modal);
});
var CloseButton = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-11"
})(_templateObject27(), function(p) {
    return p.theme.text.primary;
}, function(p) {
    return base/* media.smallOnly */.BC.smallOnly(_templateObject26(), !p.$active ? "display: none;" : "display: flex;");
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.3.2_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-use/lib/useClickAway.js
var useClickAway = __webpack_require__(45026);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    position: static;\n    overflow: auto;\n    height: 100vh;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: ",
        ";\n  margin: 0 auto;\n  position: absolute;\n  bottom: -15px;\n  z-index: ",
        ";\n  color: ",
        ";\n\n  ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    position: relative;\n    padding: ",
        " 0;\n    overflow: hidden;\n    height: calc(100vh + 200px);\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  max-width: ",
        ";\n  width: 100%;\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n    border: none;\n    overflow: auto;\n    border-radius: none;\n    width: 100%;\n    min-height: 100%;\n    box-shadow: none;\n    background: transparent;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin: 0 auto;\n  padding: ",
        " 0 ",
        ";\n  overflow: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 4px;\n  list-style: none;\n  z-index: 1;\n  margin-top: -",
        ";\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-top: ",
        ";\n  flex: 0 1 auto;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        ""
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "top: 56px; background-color: ",
        ";"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n  position: fixed;\n  z-index: ",
        ";\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var Suggestions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Suggestions",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, zindex/* zindex.menu.searchSuggestions */.Y.menu.searchSuggestions, function(p) {
    return p.theme.text.primary;
}, base/* media.smallOnly */.BC.smallOnly(styles_templateObject()));
var Inner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Inner",
    componentId: "sc-0-1"
})(styles_templateObject3(), base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, base/* media.smallOnly */.BC.smallOnly(styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var Items = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Items",
    componentId: "sc-0-2"
})(styles_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(styles_templateObject4()));
var PopularSearchesTitle = (0,styled_components_browser_esm["default"])(variants.H4Text).withConfig({
    displayName: "PopularSearchesTitle",
    componentId: "sc-0-3"
})(styles_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var AdItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "AdItem",
    componentId: "sc-0-4"
})(styles_templateObject7());
var SuggestionOverlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SuggestionOverlay",
    componentId: "sc-0-5"
})(styles_templateObject9(), function(p) {
    return !p.$visible ? "display: none;" : "";
}, zindex/* zindex.menu.searchOverlay */.Y.menu.searchOverlay, function(p) {
    return p.theme.bg.overlay;
}, base/* media.smallOnly */.BC.smallOnly(styles_templateObject8(), function(p) {
    return p.theme.colors.base0;
}));

;// CONCATENATED MODULE: ./src/areas/search-suggestions/suggestion-box.tsx


var SuggestionBox = function(props) {
    var children = props.children, containerRef = props.containerRef;
    return /*#__PURE__*/ react.createElement(Suggestions, null, /*#__PURE__*/ react.createElement(Inner, null, /*#__PURE__*/ react.createElement(Items, {
        ref: containerRef,
        "data-test": "SearchSuggestionsBox",
        id: "overlaySearchResults",
        "aria-expanded": "true"
    }, children)));
};

// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(95242);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(57111);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/highlighted-search-result.tsx
var highlighted_search_result = __webpack_require__(85029);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/highlighted-name.tsx
function highlighted_name_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function highlighted_name_templateObject() {
    var data = highlighted_name_taggedTemplateLiteral([
        "\n  font-weight: ",
        ";\n"
    ]);
    highlighted_name_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function highlighted_name_templateObject1() {
    var data = highlighted_name_taggedTemplateLiteral([
        "\n  font-weight: ",
        ";\n"
    ]);
    highlighted_name_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var HighlightedName = function(props) {
    var query = props.query, children = props.children;
    var escapedRegExpQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var re = new RegExp(escapedRegExpQuery, "gi");
    var highlight = children.match(re) || [];
    var highlightedName = children.replace(re, "[highlight]".concat(highlight[0] || "", "[/highlight]"));
    return(// NOTE: Don't let Google translate this as it will cause a client crash
    /*#__PURE__*/ react.createElement(highlighted_name_Text, {
        className: "notranslate"
    }, /*#__PURE__*/ react.createElement(highlighted_search_result/* default */.Z, {
        component: Highlight
    }, highlightedName || "")));
};
var highlighted_name_Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-0"
})(highlighted_name_templateObject(), ui_text.FontWeight.HEAVIEST);
var Highlight = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Highlight",
    componentId: "sc-0-1"
})(highlighted_name_templateObject1(), ui_text.FontWeight.NORMAL);

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/styles.ts
function list_items_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function list_items_styles_templateObject() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-align: left;\n  height: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  opacity: ",
        ";\n  width: 100%;\n  transition: background-color 150ms ease;\n  color: ",
        ";\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  > *:not(:last-child) {\n    margin-right: ",
        ";\n  }\n"
    ]);
    list_items_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject1() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  ",
        " {\n    background-color: ",
        ";\n  }\n"
    ]);
    list_items_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject2() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  order: ",
        ";\n  ",
        ";\n  position: relative;\n"
    ]);
    list_items_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject3() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n        background: transparent;\n      "
    ]);
    list_items_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject4() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  && {\n    ",
        ";\n  }\n\n  ",
        " {\n    /* suggestions gutter + icon size + icon spacing */\n    padding-left: 2.5rem;\n    height: 30px;\n  }\n"
    ]);
    list_items_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject5() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  align-items: center;\n"
    ]);
    list_items_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject6() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  && {\n    align-items: baseline;\n    flex: 0 1 auto;\n  }\n"
    ]);
    list_items_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject7() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  justify-content: center;\n"
    ]);
    list_items_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject8() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n"
    ]);
    list_items_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject9() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    list_items_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n  align-self: baseline;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = list_items_styles_taggedTemplateLiteral([
        ""
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  height: 31px;\n  width: 88px;\n\n  /* stylelint-disable-next-line value-no-vendor-prefix */\n  image-rendering: -webkit-optimize-contrast;\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  padding: 8px;\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}






var ITEM_HEIGHT = "40px";
var ListItemButton = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ListItemButton",
    componentId: "sc-0-0"
})(list_items_styles_templateObject(), ITEM_HEIGHT, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.disabled ? 0.3 : 1;
}, function(p) {
    return p.theme.text.primary;
}, function(p) {
    return p.theme.colors.informative100;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var selectedStyles = (0,styled_components_browser_esm.css)(list_items_styles_templateObject1(), ListItemButton, function(p) {
    return p.theme.colors.informative100;
});
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-1"
})(list_items_styles_templateObject2(), function(p) {
    return p.order || 1;
}, function(p) {
    return p.$selected && selectedStyles;
});
var SubListItem = (0,styled_components_browser_esm["default"])(ListItem).withConfig({
    displayName: "SubListItem",
    componentId: "sc-0-2"
})(list_items_styles_templateObject4(), function(p) {
    return p.$selected && (0,styled_components_browser_esm.css)(list_items_styles_templateObject3());
}, ListItemButton);
var Wrapper = (0,styled_components_browser_esm["default"])(list_variants.Row).attrs({
    gap: 0.5
}).withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-3"
})(list_items_styles_templateObject5());
var Labels = (0,styled_components_browser_esm["default"])(list_variants.Row).attrs(function(p) {
    return {
        gap: p.gap || 0.5
    };
}).withConfig({
    displayName: "Labels",
    componentId: "sc-0-4"
})(list_items_styles_templateObject6());
var LabelsColumn = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "LabelsColumn",
    componentId: "sc-0-5"
})(list_items_styles_templateObject7());
var NameLabel = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "NameLabel",
    componentId: "sc-0-6"
})(list_items_styles_templateObject8());
var VerticallyAlignedLabel = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "VerticallyAlignedLabel",
    componentId: "sc-0-7"
})(list_items_styles_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SectionLabel = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "SectionLabel",
    componentId: "sc-0-8"
})(styles_templateObject10());
var styles_SearchIcon = (0,styled_components_browser_esm["default"])(magnifier/* IconMagnifier */.j).attrs({
    color: "base500"
}).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-9"
})(styles_templateObject11());
var ShopLogo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "ShopLogo",
    componentId: "sc-0-10"
})(styles_templateObject12());
var ShopLogoWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ShopLogoWrapper",
    componentId: "sc-0-11"
})(styles_templateObject13(), function(p) {
    return p.theme.colors.base200;
}, function(p) {
    return p.theme.colors.base0;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/components/offer/price/price-text.tsx
var price_text = __webpack_require__(48711);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/product.tsx
function product_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_templateObject() {
    var data = product_taggedTemplateLiteral([
        "\n  && {\n    height: auto;\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    product_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_templateObject1() {
    var data = product_taggedTemplateLiteral([
        "\n  height: 48px;\n  width: 48px;\n  padding: 4px;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    product_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var ProductItem = function(props) {
    var ariaActivedescendantId = props.ariaActivedescendantId, id = props.id, text = props.text, price = props.price, order = props.order, selected = props.selected, onClick = props.onClick, query = props.query, category = props.category;
    var ref = (0,app_context/* useAppContext */.bp)(), _market = ref.market, market = _market === void 0 ? {
        cdn: "https://cdn.pji.nu"
    } : _market, t = ref.t;
    var imageSrc = "".concat(market.cdn, "/product/standard/80/").concat(id, ".jpg");
    return /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "ProductItem",
        order: order,
        $selected: selected,
        id: ariaActivedescendantId
    }, /*#__PURE__*/ react.createElement(Button, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(Image, {
        src: imageSrc
    }), /*#__PURE__*/ react.createElement(Labels, null, /*#__PURE__*/ react.createElement(list_variants.Column, null, category && /*#__PURE__*/ react.createElement(variants.CaptionText, null, category), /*#__PURE__*/ react.createElement(NameLabel, {
        containerProps: {
            "data-test": "NameLabel"
        }
    }, /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, text))))), price ? /*#__PURE__*/ react.createElement(Labels, {
        gap: 0.25
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.LOW
    }, t("product", "price.from-abbr")), /*#__PURE__*/ react.createElement(price_text/* PriceText */.X, null, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: price
    }))) : null));
};
var Button = (0,styled_components_browser_esm["default"])(ListItemButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(product_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Image = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(product_templateObject1(), function(p) {
    return p.theme.colors.base200;
}, function(p) {
    return p.theme.colors.base0;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/history/index.js
var icon_history = __webpack_require__(77690);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/history-item.tsx
function history_item_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function history_item_templateObject() {
    var data = history_item_taggedTemplateLiteral([
        "\n  align-items: center;\n  padding: ",
        " 0;\n  overflow: hidden;\n  margin-right: ",
        "px;\n"
    ]);
    history_item_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function history_item_templateObject1() {
    var data = history_item_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background-color 150ms ease;\n  color: ",
        ";\n  position: absolute;\n  top: 50%;\n  right: ",
        ";\n  transform: translateY(-50%);\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    history_item_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function history_item_templateObject2() {
    var data = history_item_taggedTemplateLiteral([
        "\n  order: ",
        ";\n  margin-left: ",
        ";\n  margin-top: ",
        ";\n  flex: 0 1 auto;\n"
    ]);
    history_item_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function history_item_templateObject3() {
    var data = history_item_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    history_item_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function history_item_templateObject4() {
    var data = history_item_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n  order: ",
        ";\n  margin-left: ",
        ";\n  margin-top: ",
        ";\n\n  ",
        ";\n\n  button {\n    color: inherit;\n    cursor: pointer;\n  }\n"
    ]);
    history_item_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function history_item_templateObject5() {
    var data = history_item_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    history_item_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var ORDER = 100;
var HistoryItem = function(props) {
    var text = props.text, onDelete = props.onDelete, onClick = props.onClick, selected = props.selected, onClear = props.onClear, showClear = props.showClear;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var handleOnClick = (0,react.useCallback)(function() {
        onClick();
    }, [
        onClick
    ]);
    var handleOnDelete = (0,react.useCallback)(function(event) {
        onDelete(event);
    }, [
        onDelete
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, showClear ? /*#__PURE__*/ react.createElement(history_item_ClearButton, {
        color: variants.FontColor.PRIMARY
    }, /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        onClick: onClear,
        "data-test": "ClearHistoryItemButton"
    }, t("common", "button.clear"))) : null, /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "HistoryItem",
        $selected: selected,
        order: ORDER
    }, /*#__PURE__*/ react.createElement(ListItemButton, {
        onClick: handleOnClick
    }, /*#__PURE__*/ react.createElement(ItemInner, {
        gap: 0.5
    }, /*#__PURE__*/ react.createElement(icon_history/* IconHistory */.H, {
        size: iconSize,
        color: "base400"
    }), /*#__PURE__*/ react.createElement(history_item_Text, null, text))), /*#__PURE__*/ react.createElement(RemoveButton, {
        onClick: handleOnDelete
    }, /*#__PURE__*/ react.createElement(icon_close.IconClose, {
        size: 12,
        color: "base600"
    }))));
};
var history_item_measurements = base/* layout.measurements */.bK.measurements, history_item_spacing050 = history_item_measurements.spacing050, history_item_spacing100 = history_item_measurements.spacing100;
var iconSize = 24;
var ItemInner = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "ItemInner",
    componentId: "sc-0-0"
})(history_item_templateObject(), history_item_spacing050, iconSize);
var RemoveButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "RemoveButton",
    componentId: "sc-0-1"
})(history_item_templateObject1(), function(p) {
    return p.theme.bg.secondary;
}, function(p) {
    return p.theme.icons.primary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.bg.tertiary;
});
var Title = (0,styled_components_browser_esm["default"])(variants.H4Text).attrs({
    "data-test": "HistoryItemsTitle"
}).withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(history_item_templateObject2(), ORDER, history_item_spacing100, history_item_spacing100);
var history_item_ClearButton = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "ClearButton",
    componentId: "sc-0-3"
})(history_item_templateObject4(), ORDER + 1, history_item_spacing100, history_item_spacing100, base/* media.mediumUp */.BC.mediumUp(history_item_templateObject3()));
var history_item_Text = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "Text",
    componentId: "sc-0-4"
})(history_item_templateObject5());

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/keyword.tsx




var KeywordItem = function(props) {
    var ariaActivedescendantId = props.ariaActivedescendantId, text = props.text, order = props.order, selected = props.selected, onClick = props.onClick, query = props.query;
    return /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "KeywordItem",
        order: order,
        $selected: selected,
        id: ariaActivedescendantId
    }, /*#__PURE__*/ react.createElement(ListItemButton, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(list_variants.Row, null, /*#__PURE__*/ react.createElement(list_variants.Column, null, /*#__PURE__*/ react.createElement(VerticallyAlignedLabel, null, /*#__PURE__*/ react.createElement(styles_SearchIcon, null), /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, text)))))));
};

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/shop.tsx
function shop_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function shop_templateObject() {
    var data = shop_taggedTemplateLiteral([
        "\n  && {\n    height: auto;\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    shop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var ShopItem = function(props) {
    var ariaActivedescendantId = props.ariaActivedescendantId, id = props.id, text = props.text, selected = props.selected, order = props.order, onClick = props.onClick, query = props.query;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var logoUrl = "https://cdn.pji.nu/g/ftg_logos/store_".concat(id, ".png");
    return /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "ShopItem",
        $selected: selected,
        order: order,
        id: ariaActivedescendantId
    }, /*#__PURE__*/ react.createElement(shop_Button, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(list_variants.Row, null, /*#__PURE__*/ react.createElement(ShopLogoWrapper, null, /*#__PURE__*/ react.createElement(ShopLogo, {
        alt: text,
        src: logoUrl
    })), /*#__PURE__*/ react.createElement(LabelsColumn, null, /*#__PURE__*/ react.createElement(variants.CaptionText, null, t("search", "suggest.store")), /*#__PURE__*/ react.createElement(NameLabel, null, /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, text))))));
};
var shop_Button = (0,styled_components_browser_esm["default"])(ListItemButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(shop_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/category-filter.tsx





var CategoryFilterItem = function(props) {
    var ariaActivedescendantId = props.ariaActivedescendantId, text = props.text, categoryName = props.categoryName, selected = props.selected, order = props.order, onClick = props.onClick, query = props.query;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "CategoryFilterItem",
        id: ariaActivedescendantId,
        $selected: selected,
        order: order
    }, /*#__PURE__*/ react.createElement(ListItemButton, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Labels, null, text.length > 0 ? /*#__PURE__*/ react.createElement(NameLabel, {
        containerProps: {
            "data-test": "NameLabel"
        }
    }, /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, text), "\xa0", /*#__PURE__*/ react.createElement(variants.CaptionText, null, t("search", "suggest.category-filter", {
        category: categoryName
    }))) : /*#__PURE__*/ react.createElement(NameLabel, {
        containerProps: {
            "data-test": "NameLabel"
        }
    }, /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, categoryName)))));
};

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/items.tsx







var SuggestionItems = function(props) {
    var handleClearHistory = props.handleClearHistory, handleClick = props.handleClick, handleDeleteHistory = props.handleDeleteHistory, items = props.items, query = props.query, selectedId = props.selectedId;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, items.map(function(suggestion, index) {
        var onSuggestionClickHandler = function() {
            return handleClick(suggestion, index);
        };
        switch(suggestion.__typename){
            case "SuggestedSearchPhrase":
                {
                    if (!query.length) return null;
                    return /*#__PURE__*/ react.createElement(KeywordItem, {
                        key: "keyword-".concat(suggestion.text),
                        text: suggestion.text,
                        onClick: onSuggestionClickHandler,
                        query: query,
                        selected: selectedId === suggestion.navId,
                        ariaActivedescendantId: "selection".concat(suggestion.navId)
                    });
                }
            case "SuggestedProduct":
                {
                    var ref;
                    if (!query.length) return null;
                    return /*#__PURE__*/ react.createElement(ProductItem, {
                        key: "product-".concat(suggestion.id),
                        id: ((ref = suggestion.id) === null || ref === void 0 ? void 0 : ref.toString()) || "",
                        text: suggestion.text,
                        price: suggestion.price,
                        category: suggestion.category,
                        onClick: onSuggestionClickHandler,
                        query: query,
                        selected: selectedId === suggestion.navId,
                        ariaActivedescendantId: "selection".concat(suggestion.navId)
                    });
                }
            case "SuggestedShop":
                {
                    if (!query.length) return null;
                    return /*#__PURE__*/ react.createElement(ShopItem, {
                        key: "shop-".concat(suggestion.id),
                        id: suggestion.id,
                        text: suggestion.text,
                        onClick: onSuggestionClickHandler,
                        query: query,
                        selected: selectedId === suggestion.navId,
                        ariaActivedescendantId: "selection".concat(suggestion.navId)
                    });
                }
            case "SuggestedCategoryFilter":
                {
                    if (!query.length) return null;
                    return /*#__PURE__*/ react.createElement(CategoryFilterItem, {
                        key: "category-".concat(suggestion.id, "-").concat(suggestion.text),
                        id: suggestion.id,
                        text: suggestion.text,
                        categoryName: suggestion.name,
                        onClick: onSuggestionClickHandler,
                        query: query,
                        selected: selectedId === suggestion.navId,
                        ariaActivedescendantId: "selection".concat(suggestion.navId)
                    });
                }
            case "history":
                {
                    var firstHistoryItem = items === null || items === void 0 ? void 0 : items.findIndex(function(item) {
                        return item.__typename === "history";
                    });
                    return /*#__PURE__*/ react.createElement("div", {
                        "data-test": "HistoryItemWrapper",
                        key: "history-".concat(suggestion.text),
                        id: "selection".concat(index)
                    }, firstHistoryItem === index && /*#__PURE__*/ react.createElement(Title, {
                        key: "history=title"
                    }, t("search", "search.recent-searches")), /*#__PURE__*/ react.createElement(HistoryItem, {
                        key: "".concat(suggestion.text, "-").concat(index + 100),
                        selected: suggestion.navId === selectedId,
                        onClick: onSuggestionClickHandler,
                        onDelete: function(e) {
                            return handleDeleteHistory(e, suggestion.text);
                        },
                        onClear: handleClearHistory,
                        text: suggestion.text,
                        showClear: index === firstHistoryItem && items.filter(function(s) {
                            return s.__typename === "history";
                        }).length > 2
                    }));
                }
            default:
                return null;
        }
    }));
};

// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(15287);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/types.ts
var SuggestionTypeEnum;
(function(SuggestionTypeEnum) {
    SuggestionTypeEnum["SUGGESTED_PRODUCT"] = "SuggestedProduct";
    SuggestionTypeEnum["SUGGESTED_SEARCH_PHRASE"] = "SuggestedSearchPhrase";
    SuggestionTypeEnum["SUGGESTED_SHOP"] = "SuggestedShop";
    SuggestionTypeEnum["SUGGESTED_CATEGORY_FILTER"] = "SuggestedCategoryFilter";
})(SuggestionTypeEnum || (SuggestionTypeEnum = {}));

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/tracking.ts



var trackSearchSuggestionsListed = function(types) {
    (0,data_layer/* pushEvent */.A)("searchSuggestionsListed", {
        types: types
    });
};
var trackSearchSuggestionInternalNavigationClicked = function(type, index, linkUrl, searchQuery) {
    var scope;
    switch(type){
        case SuggestionTypeEnum.SUGGESTED_CATEGORY_FILTER:
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_CATEGORY */.U.QUICK_SEARCH_CATEGORY;
            break;
        case SuggestionTypeEnum.SUGGESTED_SEARCH_PHRASE:
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_SEARCH_SUGGESTIONS */.U.QUICK_SEARCH_SEARCH_SUGGESTIONS;
            break;
        case SuggestionTypeEnum.SUGGESTED_PRODUCT:
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_PRODUCT */.U.QUICK_SEARCH_PRODUCT;
            break;
        case SuggestionTypeEnum.SUGGESTED_SHOP:
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_STORE */.U.QUICK_SEARCH_STORE;
            break;
        case "history":
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_LATEST_SEARCHES */.U.QUICK_SEARCH_LATEST_SEARCHES;
            break;
        case "original":
            return;
        default:
            return;
    }
    (0,tracking/* trackInternalNavigationClick */.p)({
        index: index,
        scope: scope,
        nextPage: linkUrl,
        searchQuery: searchQuery
    });
};

// EXTERNAL MODULE: ./src/components/popular-searches/index.tsx + 1 modules
var popular_searches = __webpack_require__(12618);
// EXTERNAL MODULE: ./src/areas/search-suggestions/requests/popular-searches.graphql
var popular_searches_graphql = __webpack_require__(21598);
var popular_searches_graphql_default = /*#__PURE__*/__webpack_require__.n(popular_searches_graphql);
;// CONCATENATED MODULE: ./src/hooks/use-event-listener.ts

var useEventListener = function(eventName, // eslint-disable-next-line @typescript-eslint/ban-types
handler) {
    var element = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : typeof window === "undefined" ? null : window;
    // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
    var savedHandler = (0,react.useRef)(function() {});
    (0,react.useEffect)(function() {
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0,react.useEffect)(function() {
        var isSupported = element && element.addEventListener;
        if (!isSupported) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return function() {};
        }
        var eventListener = function(event) {
            return savedHandler.current(event);
        };
        element.addEventListener(eventName, eventListener);
        return function() {
            element.removeEventListener(eventName, eventListener);
        };
    }, [
        eventName,
        element
    ]);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/utils.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var mapNewTypes = {
    SuggestedProduct: "product",
    SuggestedShop: "store"
};
var constructNavigationUrl = function() {
    var _ref = _asyncToGenerator(function(suggestion, query) {
        return __generator(this, function(_state) {
            switch(suggestion.__typename){
                case "SuggestedShop":
                case "SuggestedProduct":
                    return [
                        2,
                        gotoUrl(mapNewTypes[suggestion.__typename], suggestion.id.toString(), suggestion.text)
                    ];
                case "SuggestedSearchPhrase":
                    return [
                        2,
                        "/search?query=".concat(encodeURIComponent(suggestion.text))
                    ];
                case "SuggestedCategoryFilter":
                    return [
                        2,
                        "/search?".concat(suggestion.text ? "query=".concat(encodeURIComponent(suggestion.text), "&") : "", "category_id=").concat(suggestion.id.split("/").pop())
                    ];
                default:
                    // Prevent race condition when pressing enter quickly after a search
                    // because `query` and `suggestion.text` states are out of sync.
                    return [
                        2,
                        "/search?query=".concat(encodeURIComponent(suggestion.navId === 0 ? query : suggestion.text))
                    ];
            }
            return [
                2
            ];
        });
    });
    return function constructNavigationUrl(suggestion, query) {
        return _ref.apply(this, arguments);
    };
}();
var gotoUrl = function() {
    var _ref = _asyncToGenerator(function(type, id, queryParam, meta) {
        var params, res;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = {
                        q: queryParam,
                        meta: meta
                    };
                    return [
                        4,
                        fetch("/_internal/goto/".concat(type, "/").concat(id, "?").concat(dist_default().stringify(params)))
                    ];
                case 1:
                    res = _state.sent();
                    if (res.status !== 200) {
                        throw new Error("Cannot resolve url for ".concat(type));
                    }
                    return [
                        2,
                        res.text()
                    ];
            }
        });
    });
    return function gotoUrl(type, id, queryParam, meta) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/areas/search-suggestions/helpers/use-get-element.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var useGetElement = function(name, visible) {
    var ref = _slicedToArray((0,react.useState)(), 2), el = ref[0], setElement = ref[1];
    (0,react.useEffect)(function() {
        var elementFound = Array.from(document.querySelectorAll('[data-suggestions="'.concat(name, '"]'))).find(function(element) {
            return _instanceof(element, HTMLInputElement) && element.offsetParent !== null;
        });
        if (elementFound) setElement(elementFound);
    }, [
        visible,
        name
    ]);
    return {
        el: el
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.3.2_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-use/esm/index.js + 120 modules
var esm = __webpack_require__(58073);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/helpers/use-track-search-suggestions-listed.tsx



var validTypes = Object.values(SuggestionTypeEnum);
var useTrackSearchSuggestionsListed = function(suggestions, visible) {
    (0,esm/* useDebounce */.Nr)(function() {
        var suggestionsCount = suggestions.filter(function(suggestion) {
            return validTypes.includes(suggestion.type || "");
        }).length;
        if (visible && suggestionsCount) trackSearchSuggestionsListed(suggestions.map(function(item) {
            return item.type;
        }).join(", "));
    }, 500, [
        suggestions,
        visible
    ]);
};

// EXTERNAL MODULE: ./src/areas/search-suggestions/query.graphql
var query_graphql = __webpack_require__(26585);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/helpers/use-set-suggestions.tsx
function use_set_suggestions_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return use_set_suggestions_arrayLikeToArray(arr);
}
function use_set_suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function use_set_suggestions_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                use_set_suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                use_set_suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || use_set_suggestions_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function use_set_suggestions_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return use_set_suggestions_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return use_set_suggestions_arrayLikeToArray(o, minLen);
}
var use_set_suggestions_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};






var useSetSuggestions = function(query, setSuggestions, limit) {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, captureException = ref.captureException;
    // Keep track of the request count to discard old results
    var requestCount = (0,react.useRef)(0);
    (0,react.useEffect)(function() {
        setSuggestions(_toConsumableArray((0,history_storage/* getRecentSearchesHistoryItems */.bn)(limit, query)));
    }, []);
    (0,esm/* useDebounce */.Nr)(/*#__PURE__*/ use_set_suggestions_asyncToGenerator(function() {
        var myRequestCount, ref, res, e;
        return use_set_suggestions_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!query.trim().length) {
                        setSuggestions(_toConsumableArray((0,history_storage/* getRecentSearchesHistoryItems */.bn)(limit, query)));
                        return [
                            2
                        ];
                    }
                    myRequestCount = requestCount.current + 1;
                    requestCount.current = myRequestCount;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,requests/* graphql */.BX)((query_graphql_default()), {
                            query: query
                        })
                    ];
                case 2:
                    res = _state.sent();
                    // Discard if the response we're processing is not from the latest request
                    if (myRequestCount !== requestCount.current) return [
                        2
                    ];
                    if ((ref = res.errors) === null || ref === void 0 ? void 0 : ref.length) {
                        setSuggestions(_toConsumableArray((0,history_storage/* getRecentSearchesHistoryItems */.bn)(limit, query)));
                        return [
                            2
                        ];
                    }
                    if (res.data) {
                        setSuggestions(_toConsumableArray(res.data.searchSuggestions.map(function(s, index) {
                            return _objectSpreadProps(_objectSpread({}, s), {
                                type: s.__typename,
                                // Make sure navigation in based on the actual order displayed
                                navId: index
                            });
                        })));
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    captureException(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), 100, [
        query,
        market
    ]);
};

;// CONCATENATED MODULE: ./src/areas/search-suggestions/index.tsx
function search_suggestions_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_suggestions_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function search_suggestions_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return search_suggestions_arrayLikeToArray(arr);
}
function search_suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function search_suggestions_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                search_suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                search_suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function search_suggestions_instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function search_suggestions_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function search_suggestions_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function search_suggestions_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_suggestions_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_suggestions_slicedToArray(arr, i) {
    return search_suggestions_arrayWithHoles(arr) || search_suggestions_iterableToArrayLimit(arr, i) || search_suggestions_unsupportedIterableToArray(arr, i) || search_suggestions_nonIterableRest();
}
function search_suggestions_toConsumableArray(arr) {
    return search_suggestions_arrayWithoutHoles(arr) || search_suggestions_iterableToArray(arr) || search_suggestions_unsupportedIterableToArray(arr) || search_suggestions_nonIterableSpread();
}
function search_suggestions_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_suggestions_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_suggestions_arrayLikeToArray(o, minLen);
}
var search_suggestions_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



















var NAV_ID_ORIGINAL = -1;
var LIMIT = 5;
var createOriginalSuggestion = function(query) {
    return {
        navId: NAV_ID_ORIGINAL,
        text: query,
        type: "original",
        __typename: "original"
    };
};
var search_suggestions_Suggestions = function(props) {
    var query = props.query, onClose = props.onClose, onKeyboardSelection = props.onKeyboardSelection, setQuery = props.setQuery, visible = props.visible, updatedInputElement = props.updatedInputElement, updatedSearchWrapperElement = props.updatedSearchWrapperElement, placement = props.placement;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var ref = search_suggestions_slicedToArray((0,react.useState)(), 2), selected = ref[0], setSelected = ref[1];
    var ref1 = useGetElement("search-".concat(placement), visible), searchInputElement = ref1.el;
    var ref2 = useGetElement("searchWrapper-".concat(placement), visible), searchWrapperElement = ref2.el;
    var containerRef = (0,react.useRef)(null);
    var history = (0,react_router/* useHistory */.k6)();
    var ref3 = search_suggestions_slicedToArray((0,react.useState)([]), 2), suggestions = ref3[0], setSuggestions = ref3[1];
    var ref4 = search_suggestions_slicedToArray((0,react.useState)([]), 2), popularSearches = ref4[0], setPopularSearches = ref4[1];
    useTrackSearchSuggestionsListed(suggestions, visible);
    (0,react.useEffect)(function() {
        var getPopularSearches = function() {
            var _ref = search_suggestions_asyncToGenerator(function() {
                var ref, response;
                return search_suggestions_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,requests/* graphql */.BX)((popular_searches_graphql_default()))
                            ];
                        case 1:
                            response = _state.sent();
                            setPopularSearches((response === null || response === void 0 ? void 0 : response.data) ? (ref = response.data) === null || ref === void 0 ? void 0 : ref.popularSearches : []);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getPopularSearches() {
                return _ref.apply(this, arguments);
            };
        }();
        getPopularSearches();
    }, []);
    var handleOnClose = function() {
        onClose();
        setSelected(undefined);
    };
    var handleClickPopular = function(popularQuery) {
        setQuery(popularQuery.trim());
        handleOnClose();
    };
    var handleClickSuggestion = (0,react.useCallback)(function() {
        var _ref = search_suggestions_asyncToGenerator(function(suggestion, index) {
            var ref, push, linkToUrl, currentQuery;
            return search_suggestions_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        push = history.push;
                        if ((suggestion.type === "original" || !suggestion.text) && query.length < 2) {
                            // Don't redirect to the full page result for queries that are too short or not set. It will just fail.
                            return [
                                2
                            ];
                        }
                        setQuery(suggestion.text.trim());
                        return [
                            4,
                            constructNavigationUrl(suggestion, query)
                        ];
                    case 1:
                        linkToUrl = _state.sent();
                        linkToUrl = (linkToUrl || "").trim();
                        trackSearchSuggestionInternalNavigationClicked(suggestion.type, index, linkToUrl, query);
                        if (suggestion.__typename === "SuggestedSearchPhrase") {
                            (0,history_storage/* addRecentSearch */._)(suggestion.text);
                        } else if (!((ref = suggestion.__typename) === null || ref === void 0 ? void 0 : ref.startsWith("Suggested"))) {
                            currentQuery = suggestion.navId === 0 ? query : suggestion.text;
                            (0,history_storage/* addRecentSearch */._)(currentQuery);
                        }
                        if (linkToUrl) {
                            handleOnClose();
                            push(linkToUrl);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(suggestion, index) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        history,
        handleOnClose,
        query
    ]);
    var handleKeyPress = function(e) {
        if (!containerRef.current) {
            return;
        }
        var key = e.key || e.keyCode;
        var originalSuggestion = createOriginalSuggestion(query);
        var activeSuggestions = search_suggestions_toConsumableArray(suggestions);
        switch(key){
            case "Enter":
            case 13:
                {
                    var suggestion = activeSuggestions.find(function(s) {
                        return s.navId === selected;
                    }) || originalSuggestion;
                    var index = activeSuggestions.indexOf(suggestion);
                    if (suggestion.text.length > 0 || suggestion.__typename === "SuggestedCategoryFilter") {
                        handleClickSuggestion(suggestion, index);
                        if (searchInputElement) {
                            searchInputElement.blur();
                        }
                        e.stopPropagation();
                    }
                    break;
                }
            case "ArrowRight":
            case 39:
                {
                    var suggestion1 = activeSuggestions.find(function(s) {
                        return s.navId === selected;
                    });
                    if (suggestion1 && searchInputElement && searchInputElement.selectionStart === searchInputElement.selectionEnd && searchInputElement.selectionStart === searchInputElement.value.length) {
                        searchInputElement.value = "".concat(suggestion1.text, " ");
                        searchInputElement.dispatchEvent(new CustomEvent("focus"));
                    }
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
            case 38:
            case 40:
                {
                    e.preventDefault();
                    var nextItem;
                    var currentIndex = activeSuggestions.findIndex(function(s) {
                        return s.navId === selected;
                    });
                    if (key === 40 || key === "ArrowDown") {
                        // ArrowDown
                        nextItem = activeSuggestions[(currentIndex + 1) % activeSuggestions.length];
                    } else {
                        // ArrowUp
                        var nextIndex = currentIndex - 1 === -1 ? activeSuggestions.length - 1 : currentIndex - 1;
                        nextItem = activeSuggestions[nextIndex];
                    }
                    if (nextItem) {
                        if (searchInputElement) {
                            searchInputElement.value = "".concat(nextItem.text, " ");
                            onKeyboardSelection(nextItem.navId);
                        }
                        setSelected(nextItem.navId);
                        console.log("nextItem set", nextItem.navId, nextItem);
                    }
                    break;
                }
            case "Escape":
            case "Esc":
            case 27:
                handleOnClose();
                e.preventDefault();
                break;
            default:
                break;
        }
    };
    useEventListener("keydown", handleKeyPress);
    (0,useClickAway/* default */.Z)(containerRef, function(e) {
        var ref;
        if (isMobile) return;
        if (search_suggestions_instanceof(e.target, Node) && (searchInputElement === e.target || (updatedInputElement === null || updatedInputElement === void 0 ? void 0 : updatedInputElement.current) === e.target || (updatedSearchWrapperElement === null || updatedSearchWrapperElement === void 0 ? void 0 : (ref = updatedSearchWrapperElement.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) || (searchWrapperElement === null || searchWrapperElement === void 0 ? void 0 : searchWrapperElement.contains(e.target)))) {
            // It's the search bar, we don't want to close
            return;
        }
        handleOnClose();
    });
    (0,react.useEffect)(function() {
        // Clear old suggestions when erasing input query
        if (query.length === 0) setSuggestions((0,history_storage/* getRecentSearches */.KM)(LIMIT).map(history_storage/* createHistorySuggestion */.j8));
        // Reset selected state when query changed
        if (selected !== 0) setSelected(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    useSetSuggestions(query, setSuggestions, LIMIT);
    var handleDeleteHistory = function(e, historyQuery) {
        e.stopPropagation();
        (0,history_storage/* deleteRecentSearch */.DS)(historyQuery);
        setSuggestions(function(prevState) {
            return search_suggestions_toConsumableArray(prevState.filter(function(item) {
                return item.__typename !== "history";
            })).concat(search_suggestions_toConsumableArray((0,history_storage/* getRecentSearchesHistoryItems */.bn)(LIMIT, query)));
        });
    };
    var handleClearHistory = function() {
        (0,history_storage/* clearRecentSearches */.lU)();
        setSuggestions(function(prevState) {
            return search_suggestions_toConsumableArray(prevState.filter(function(item) {
                return item.__typename !== "history";
            }));
        });
    };
    if (!visible || !suggestions.length && !popularSearches.length) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SuggestionOverlay, {
        $visible: visible
    }), /*#__PURE__*/ react.createElement(SuggestionBox, {
        containerRef: containerRef
    }, popularSearches.length && !suggestions.find(function(s) {
        return Object.values(SuggestionTypeEnum).includes(// Check if suggestions includes any actual suggestion results
        // recast because TS won't allow this check to ever be falsy.
        s.__typename);
    }) ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(PopularSearchesTitle, null, t("search", "search.popular-searches")), /*#__PURE__*/ react.createElement(popular_searches/* PopularSearches */.S, {
        popularSearches: popularSearches,
        onClick: handleClickPopular
    })) : null, /*#__PURE__*/ react.createElement(SuggestionItems, {
        query: query,
        items: suggestions,
        handleClick: handleClickSuggestion,
        selectedId: selected,
        handleClearHistory: handleClearHistory,
        handleDeleteHistory: handleDeleteHistory
    })));
};
/* harmony default export */ var search_suggestions = (search_suggestions_Suggestions);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(37456);
// EXTERNAL MODULE: ./src/components/no-scroll/index.tsx
var no_scroll = __webpack_require__(83464);
// EXTERNAL MODULE: ./src/areas/search/actions/search.js
var search = __webpack_require__(47441);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
;// CONCATENATED MODULE: ./src/components/search-bar/index.tsx
function search_bar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_bar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function search_bar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function search_bar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_bar_slicedToArray(arr, i) {
    return search_bar_arrayWithHoles(arr) || search_bar_iterableToArrayLimit(arr, i) || search_bar_unsupportedIterableToArray(arr, i) || search_bar_nonIterableRest();
}
function search_bar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_bar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_bar_arrayLikeToArray(o, minLen);
}














var SearchBar = function(param) {
    var initialFocus = param.initialFocus, _placement = param.placement, placement = _placement === void 0 ? "header" : _placement;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var searchBarRef = (0,react.useRef)(null);
    var history = (0,react_router_dom/* useHistory */.k6)();
    var location = (0,react_router_dom/* useLocation */.TH)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var searchBlur = search/* default.searchBlur */.ZP.searchBlur, searchFocus = search/* default.searchFocus */.ZP.searchFocus;
    var ref = search_bar_slicedToArray((0,react.useState)(Boolean(initialFocus)), 2), focused = ref[0], setFocused = ref[1];
    var ref1 = search_bar_slicedToArray((0,react.useState)(false), 2), active = ref1[0], setActive = ref1[1];
    var ref2 = search_bar_slicedToArray((0,react.useState)(""), 2), currentQuery = ref2[0], setCurrentQuery = ref2[1];
    var ref3 = search_bar_slicedToArray((0,react.useState)(), 2), selectedSuggestion = ref3[0], setSelectedSuggestion = ref3[1];
    var searchParam = new URLSearchParams(location.search).get("query") || "";
    var hasSuggestionItemSelected = (0,react.useRef)(false);
    var searchCriteria = currentQuery.length >= 2;
    var handleChange = function(e) {
        var newValue = e.target.value;
        setCurrentQuery(newValue);
        if (searchCriteria && !active) {
            setActive(true);
        }
    };
    (0,react.useEffect)(function() {
        // Clears search input after searching, except on the search page
        if (!location.pathname.includes("/search")) {
            setCurrentQuery("");
            return;
        }
        setCurrentQuery(searchParam);
    }, [
        location,
        searchParam
    ]);
    (0,react.useEffect)(function() {
        if (!searchBarRef.current) {
            return;
        }
        if (focused) {
            searchBarRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        focused,
        searchBarRef
    ]);
    var handleSubmit = function(e) {
        e.preventDefault();
        if (!searchCriteria || searchParam === currentQuery) {
            return;
        }
        trackSearchBarNavigation();
        (0,history_storage/* addRecentSearch */._)(currentQuery);
        setFocused(false);
        setActive(false);
        history.push("/search?query=".concat(encodeURIComponent(currentQuery)));
    };
    var handleClearSearchClick = function() {
        setCurrentQuery("");
        focusSearchBar();
    };
    var blurSearchBar = function() {
        setActive(false);
        setFocused(false);
        hasSuggestionItemSelected.current = false;
        dispatch(searchBlur());
    };
    var focusSearchBar = function() {
        if (!searchBarRef.current) {
            return;
        }
        searchBarRef.current.focus();
        if (!active) {
            setActive(true);
            dispatch(searchFocus());
        }
    };
    var trackSearchBarNavigation = function() {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.QUICK_SEARCH */.U.QUICK_SEARCH,
            nextPage: "/search?query=".concat(encodeURIComponent(currentQuery)),
            searchQuery: currentQuery
        });
    };
    useEventListener("focus-search-event", function(e) {
        if (!e.detail.focus || !searchBarRef.current) {
            return;
        }
        focusSearchBar();
    });
    useEventListener("keyup", function(e) {
        var key = e.key || e.keyCode;
        var isTabKey = key === "Tab" || key === 9;
        var isEscKey = key === "Escape" || key === "Esc" || key === 27;
        if (isTabKey || isEscKey) {
            setActive(false);
        }
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SearchBarWrapper, {
        $active: active
    }, /*#__PURE__*/ react.createElement(SearchBarGroup, {
        $active: active
    }, /*#__PURE__*/ react.createElement(CloseButton, {
        $active: active,
        onClick: function() {
            return blurSearchBar();
        }
    }, /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, {
        size: 30
    })), /*#__PURE__*/ react.createElement(StyledSearchBar, {
        $active: active
    }, /*#__PURE__*/ react.createElement(InputWrapper, {
        "data-suggestions": "searchWrapper-".concat(placement)
    }, /*#__PURE__*/ react.createElement(variants.BodyMediumText, null, /*#__PURE__*/ react.createElement("form", {
        action: "/search",
        onSubmit: handleSubmit,
        role: "search"
    }, /*#__PURE__*/ react.createElement(SearchInput, {
        onKeyDown: function(e) {
            if (e.key === "Enter") {
                // Prevent a form submission if the user has selected a suggestion-item using the Enter key
                if (hasSuggestionItemSelected.current) e.preventDefault();
                else trackSearchBarNavigation();
            }
        },
        ref: searchBarRef,
        value: currentQuery,
        name: "query",
        "data-suggestions": "search-".concat(placement),
        role: "combobox",
        "aria-expanded": focused && active,
        "aria-owns": focused || active ? "overlaySearchResults" : undefined,
        "aria-autocomplete": "both",
        "aria-activedescendant": selectedSuggestion ? "selection".concat(selectedSuggestion) : "",
        autoCorrect: "off",
        autoCapitalize: "off",
        autoComplete: "off",
        spellCheck: false,
        type: "search",
        placeholder: t("search", "search.placeholder"),
        onChange: handleChange,
        maxLength: 256,
        onFocus: function() {
            return setFocused(true);
        },
        onClick: function() {
            return focusSearchBar();
        }
    }))), /*#__PURE__*/ react.createElement(ClearButton, {
        show: currentQuery.length > 0,
        "data-test": "ClearSearchButton",
        "data-testid": "clear-search-button",
        onClick: function() {
            return handleClearSearchClick();
        }
    }, /*#__PURE__*/ react.createElement(ClearIcon, {
        size: 12
    }))), /*#__PURE__*/ react.createElement(SearchButton, {
        disabled: !searchCriteria,
        active: active,
        onClick: function(e) {
            return handleSubmit(e);
        },
        "data-test": "SearchButton",
        type: "button",
        "aria-label": t("header", "search.button")
    }, /*#__PURE__*/ react.createElement(SearchButtonText, null, /*#__PURE__*/ react.createElement(list_variants.Row, {
        gap: 0.5
    }, /*#__PURE__*/ react.createElement(SearchIcon, {
        size: 20
    }), /*#__PURE__*/ react.createElement(Text, {
        $visible: searchCriteria
    }, t("header", "search.button"))))))), /*#__PURE__*/ react.createElement(search_suggestions, {
        visible: active,
        query: currentQuery,
        setQuery: function(newQuery) {
            return setCurrentQuery(newQuery);
        },
        onClose: function() {
            return blurSearchBar();
        },
        onKeyboardSelection: function(selected) {
            hasSuggestionItemSelected.current = true;
            setSelectedSuggestion(selected);
        },
        updatedInputElement: null,
        updatedSearchWrapperElement: null,
        placement: placement
    })), /*#__PURE__*/ react.createElement(no_scroll/* default */.Z, {
        mobile: true,
        enabled: active
    }));
};


/***/ }),

/***/ 75598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zN": () => (/* reexport */ SkeletonMedia),
  "Bp": () => (/* reexport */ skeleton_paragraph_SkeletonParagraph)
});

// UNUSED EXPORTS: SkeletonCircle, SkeletonText

// EXTERNAL MODULE: ./src/components/skeleton/skeleton-text.tsx
var skeleton_text = __webpack_require__(46054);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/skeleton/styled.tsx
var styled = __webpack_require__(70657);
;// CONCATENATED MODULE: ./src/components/skeleton/skeleton-paragraph.tsx


var skeleton_paragraph_SkeletonParagraph = function(param) {
    var _count = param.count, count = _count === void 0 ? 1 : _count, circle = param.circle, height = param.height, width = param.width, _children = param.children, children = _children === void 0 ? /*#__PURE__*/ react.createElement(react.Fragment, null, "‌") : _children, flex = param.flex, paused = param.paused;
    var elements = [];
    for(var i = 0; i < count; i += 1){
        var elementWidth = count > 1 ? getVariableLength(i) : width;
        var style = {
            height: height,
            width: elementWidth
        };
        if (circle) {
            style.borderRadius = "50%";
            if (!width && !height) {
                style.width = "1em";
                style.height = "1em";
            }
        }
        elements.push(/*#__PURE__*/ react.createElement(react.Fragment, {
            key: i
        }, /*#__PURE__*/ react.createElement(styled/* SkeletonFrame */.p, {
            key: i,
            style: style,
            flex: flex,
            paused: paused
        }, children), count > 1 && /*#__PURE__*/ react.createElement("br", null)));
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, elements);
};
function getVariableLength(i) {
    var width = 100;
    width = i % 2 === 0 ? 70 : width;
    width = i % 3 === 0 ? 80 : width;
    width = i % 5 === 0 ? 60 : width;
    width = i === 0 ? 90 : width;
    return "".concat(width, "%");
}

;// CONCATENATED MODULE: ./src/components/skeleton/skeleton-media.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var SkeletonMedia = function(props) {
    return /*#__PURE__*/ react.createElement(skeleton_paragraph_SkeletonParagraph, _extends({}, props, {
        flex: true
    }));
};

;// CONCATENATED MODULE: ./src/components/skeleton/skeleton-circle.tsx


var SkeletonCircle = function(props) {
    return /*#__PURE__*/ React.createElement(SkeletonParagraph, {
        height: props.diameter,
        width: props.diameter,
        circle: true,
        paused: props.paused
    });
};

;// CONCATENATED MODULE: ./src/components/skeleton/index.ts







/***/ }),

/***/ 46054:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ SkeletonText)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70657);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var SkeletonText = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styled__WEBPACK_IMPORTED_MODULE_1__/* .SkeletonFrame */ .p, _extends({}, props));
};


/***/ }),

/***/ 70657:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ SkeletonFrame)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  background-image: linear-gradient(\n    90deg,\n    ",
        ",\n    ",
        ",\n    ",
        "\n  );\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n  border-radius: 4px;\n  line-height: 1;\n  width: ",
        ";\n  height: ",
        ";\n  animation: ",
        " 1.2s ease-in-out infinite;\n  ",
        "\n  display: inline-block;\n  ",
        "\n  ",
        "\n\n  @media (prefers-reduced-motion) {\n    animation: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var skeletonKeyframes = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.keyframes)(_templateObject());
var _width, _height;
var SkeletonFrame = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "SkeletonFrame",
    componentId: "sc-0-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.base0;
}, function(param) {
    var theme = param.theme;
    return theme.colors.base0;
}, function(param) {
    var theme = param.theme;
    return theme.colors.base100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.base0;
}, function(p) {
    return (_width = p.width) !== null && _width !== void 0 ? _width : "100%";
}, function(p) {
    return (_height = p.height) !== null && _height !== void 0 ? _height : "1em";
}, skeletonKeyframes, function(p) {
    return p.paused && "animation-play-state: paused;";
}, function(p) {
    return p.marginBottom && "margin-bottom: ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements */ .bK.measurements[p.marginBottom], ";");
}, function(p) {
    return p.flex && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1());
});


/***/ }),

/***/ 61061:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": () => (/* reexport */ Spinner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/spinner/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    0% {\n      transform: rotate(0) ",
        ";\n    }\n    100% {\n      transform: rotate(360deg) ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    0% {\n      transform: rotate(0) ",
        ";\n    }\n    100% {\n      transform: rotate(360deg) ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    0% {\n      transform: rotate(0) ",
        ";\n    }\n    100% {\n      transform: rotate(360deg) ",
        ";\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      transform-origin: 50% 0;\n      animation: ",
        " 0.6s infinite linear;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      left: 10px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      right: 10px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      left: 50%;\n      transform-origin: 0 0;\n      animation: ",
        " 0.6s infinite linear;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      animation: ",
        " 0.6s infinite linear;\n      position: relative;\n      left: 0;\n      top: 0;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  display: block;\n  border: solid rgba(0, 0, 0, 0.2);\n  border-top-color: ",
        ";\n  position: absolute;\n  top: 50%;\n  ",
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var translate = "translate3d(0, -50%, 0)";
var translateCenter = "translate3d(-50%, -50%, 0)";
var translateNone = "translate3d(0, 0, 0)";
var spin = (0,styled_components_browser_esm.keyframes)(_templateObject(), translate, translate);
var spinCenter = (0,styled_components_browser_esm.keyframes)(_templateObject1(), translateCenter, translateCenter);
var spinNone = (0,styled_components_browser_esm.keyframes)(_templateObject2(), translateNone, translateNone);
var StyledSpinner = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledSpinner",
    componentId: "sc-0-0"
})(_templateObject8(), function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return (p.position === "left" || p.position === "right") && (0,styled_components_browser_esm.css)(_templateObject3(), spin);
}, function(p) {
    return p.position === "left" && (0,styled_components_browser_esm.css)(_templateObject4());
}, function(p) {
    return p.position === "right" && (0,styled_components_browser_esm.css)(_templateObject5());
}, function(p) {
    return p.position === "center" && (0,styled_components_browser_esm.css)(_templateObject6(), spinCenter);
}, function(p) {
    return p.position === "none" && (0,styled_components_browser_esm.css)(_templateObject7(), spinNone);
});

;// CONCATENATED MODULE: ./src/components/spinner/spinner.tsx


var getSpinnerSize = function(size) {
    return {
        height: size,
        width: size,
        borderWidth: spinnerBorderWidth(size)
    };
};
var spinnerBorderWidth = function(size) {
    if (size < 18) {
        return 2;
    }
    if (size > 36) {
        return 6;
    }
    return 4;
};
var Spinner = function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _position = param.position, position = _position === void 0 ? "center" : _position, _size = param.size, size = _size === void 0 ? 24 : _size;
    var spinnerSize = getSpinnerSize(size);
    return isActive ? /*#__PURE__*/ react.createElement(StyledSpinner, {
        style: spinnerSize,
        position: position
    }) : null;
};

;// CONCATENATED MODULE: ./src/components/spinner/index.ts




/***/ }),

/***/ 75871:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": () => (/* binding */ NAV_HEIGHT_WITH_MARGIN),
/* harmony export */   "n": () => (/* binding */ NAV_HEIGHT)
/* harmony export */ });
var NAV_HEIGHT = 55;
var NAV_HEIGHT_WITH_MARGIN = NAV_HEIGHT + 16;


/***/ }),

/***/ 67191:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": () => (/* binding */ StickyTabNavigation)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/scroll-handler/index.ts
var scroll_handler = __webpack_require__(58869);
// EXTERNAL MODULE: ./src/components/sticky-tab-nav/constants.ts
var constants = __webpack_require__(75871);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
// EXTERNAL MODULE: ./src/components/tabs-new/index.tsx + 1 modules
var tabs_new = __webpack_require__(6381);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(92873);
;// CONCATENATED MODULE: ./src/components/sticky-tab-nav/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      z-index: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      top: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: sticky;\n    top: ",
        ";\n    background: ",
        ";\n    z-index: ",
        ";\n    ",
        ";\n    height: ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var SPACE_FOR_HEADER_MARGIN = 4;
var Tabs = (0,styled_components_browser_esm["default"])(tabs_new/* Tabs */.m).withConfig({
    displayName: "Tabs",
    componentId: "sc-0-0"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), p.$headerIsVisible ? base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem : 0, p.theme.bg.primary, zindex/* zindex.menu.sticky.normal */.Y.menu.sticky.normal, p.background && (0,styled_components_browser_esm.css)(_templateObject(), p.isSticky ? zindex/* zindex.menu.sticky.background.isSticky */.Y.menu.sticky.background.isSticky : zindex/* zindex.menu.sticky.background.default */.Y.menu.sticky.background["default"]), "".concat(constants/* NAV_HEIGHT */.n, "px"), base/* media.smallOnly */.BC.smallOnly(_templateObject1(), p.$headerIsVisible ? base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem : 0, "".concat(constants/* NAV_HEIGHT */.n - SPACE_FOR_HEADER_MARGIN, "px")));
});

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(57735);
;// CONCATENATED MODULE: ./src/components/sticky-tab-nav/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var StickyTabNavigation = function(props) {
    var background = props.background, defaultActiveTabId = props.defaultActiveTabId, _headerIsVisible = props.headerIsVisible, headerIsVisible = _headerIsVisible === void 0 ? true : _headerIsVisible, onClick = props.onClick, _shouldScrollOnClick = props.shouldScrollOnClick, shouldScrollOnClick = _shouldScrollOnClick === void 0 ? true : _shouldScrollOnClick, tabs = props.tabs;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var ref = _slicedToArray((0,react.useState)(defaultActiveTabId), 2), _activeTab = ref[0], _setActiveTab = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), _scrollOngoing = ref1[0], _setScrollOngoing = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), isSticky = ref2[0], setIsSticky = ref2[1];
    var activeTab = (0,react.useRef)(_activeTab);
    var scrollOngoing = (0,react.useRef)(_scrollOngoing);
    var tabsRef = (0,react.useRef)(null);
    var sensitivity = 100;
    var setActiveTab = (0,react.useCallback)(function(data) {
        activeTab.current = data;
        _setActiveTab(data);
    }, []);
    (0,react.useEffect)(function() {
        activeTab.current = defaultActiveTabId;
        setActiveTab(defaultActiveTabId);
    }, [
        defaultActiveTabId,
        setActiveTab
    ]);
    var setScrollOngoing = (0,react.useCallback)(function(data) {
        scrollOngoing.current = data;
        _setScrollOngoing(data);
    }, []);
    var handleScrollOngoingState = (0,react.useCallback)(function(element) {
        if (activeTab.current === element.id && window.scrollY >= element.position && window.scrollY <= element.positionEnd) setScrollOngoing(false);
    }, [
        setScrollOngoing
    ]);
    var handleActiveStateOnClick = (0,react.useCallback)(function(tab, index) {
        setActiveTab(tab);
        if (shouldScrollOnClick) setScrollOngoing(true);
        if (onClick) onClick(tab);
        trackTabClick(tab, index);
    }, [
        onClick,
        shouldScrollOnClick,
        setActiveTab,
        setScrollOngoing
    ]);
    var trackTabClick = function(newHash, index) {
        var urlWithoutHash = location.pathname + location.search;
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.TAB_BAR */.U.TAB_BAR,
            currentPage: urlWithoutHash + location.hash,
            nextPage: urlWithoutHash + newHash,
            index: index
        });
    };
    var handleActiveStateOnScroll = (0,react.useCallback)(function() {
        var newStickyValue = window.scrollY >= (0,scroll_handler/* getScrollPositionFromElement */.o)(tabsRef.current, 0);
        if (newStickyValue !== isSticky) {
            setIsSticky(newStickyValue);
        }
        var tabElements = tabs.map(function(tab) {
            var element = document.getElementById(tab.id);
            var position = (0,scroll_handler/* getScrollPositionFromElement */.o)(element, constants/* NAV_HEIGHT_WITH_MARGIN */.g);
            return {
                element: element,
                position: position,
                id: tab.id
            };
        }).map(function(element, index, array) {
            return _objectSpreadProps(_objectSpread({}, element), {
                positionEnd: array[index + 1] ? array[index + 1].position - 1 : document.body.scrollHeight
            });
        });
        tabElements.map(function(element) {
            if (!element.position) return null;
            // If there's an ongoing tab click scrollTo, do not change tab active state.
            if (scrollOngoing.current) {
                return handleScrollOngoingState(element);
            }
            // Sets active tab based on scroll position for manual scroll.
            if (activeTab.current !== element.id && window.scrollY + sensitivity >= element.position) {
                return setActiveTab(element.id);
            }
            // Set active tab to default if scroll position is lower than defaultActiveTab position
            if (activeTab.current !== element.id && element.id === defaultActiveTabId && window.scrollY < element.position) {
                return setActiveTab(defaultActiveTabId);
            }
            return null;
        });
    }, [
        setActiveTab,
        handleScrollOngoingState,
        tabs,
        defaultActiveTabId,
        isSticky
    ]);
    var allTabs = tabs.map(function(tab) {
        return _objectSpreadProps(_objectSpread({}, tab), {
            active: tab.id === activeTab.current,
            to: "".concat(location.pathname).concat(location.search).concat(tab.id)
        });
    });
    if (allTabs.length <= 1) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, shouldScrollOnClick && /*#__PURE__*/ react.createElement(scroll_handler/* ScrollHandler */.Y, {
        onScrollCallback: handleActiveStateOnScroll,
        topMargin: constants/* NAV_HEIGHT_WITH_MARGIN */.g
    }), /*#__PURE__*/ react.createElement(Tabs, {
        background: background,
        isSticky: background && isSticky,
        onClick: handleActiveStateOnClick,
        ref: tabsRef,
        tabs: allTabs,
        $headerIsVisible: headerIsVisible
    }));
};


/***/ }),

/***/ 73209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": () => (/* binding */ stock_status_StockStatus)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/stock-incoming/index.js
var stock_incoming = __webpack_require__(51298);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/stock-in-stock/index.js
var stock_in_stock = __webpack_require__(39796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/stock-out-of-stock/index.js
var stock_out_of_stock = __webpack_require__(78940);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/stock-unknown/index.js
var stock_unknown = __webpack_require__(90633);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(49452);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(71551);
;// CONCATENATED MODULE: ./src/components/stock-status/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  min-height: 1.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  text-align: left;\n  color: ",
        ";\n  &::first-letter {\n    text-transform: capitalize;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  *:first-child {\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  border-radius: 50%;\n  height: 10px;\n  width: 10px;\n  margin: 5px;\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StockStatus = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StockStatus",
    componentId: "sc-0-0"
})(_templateObject());
var IconAndText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconAndText",
    componentId: "sc-0-1"
})(_templateObject1());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-2"
})(_templateObject2(), function(props) {
    return !props.toneDown ? props.theme.colors.base500 : props.theme.colors.base600;
});
var Tooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "Tooltip",
    componentId: "sc-0-3"
})(_templateObject3());
var getIconStyling = function(theme, status, toneDown) {
    switch(status){
        case "in_stock_preorder":
        case "incoming":
            return "background-color: ".concat(theme.colors.base0, "; box-shadow: inset 0 0 0 2px ").concat(toneDown ? theme.colors.base300 : theme.colors.positive500);
        case "in_stock":
            return toneDown ? "background-color: ".concat(theme.colors.base200) : "background-color: ".concat(theme.colors.positive500);
        case "not_in_stock":
            return toneDown ? "background-color: ".concat(theme.colors.base200) : "background-color: ".concat(theme.colors.negative700);
        default:
            return toneDown ? "background-color: ".concat(theme.colors.base200, ";") : "background-color: ".concat(theme.colors.base500);
    }
};
var Icon = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Icon",
    componentId: "sc-0-4"
})(_templateObject4(), function(props) {
    return getIconStyling(props.theme, props.status, props.toneDown);
});

;// CONCATENATED MODULE: ./src/components/stock-status/index.tsx








var stock_status_StockStatus = /*#__PURE__*/ (0,react.memo)(function(props) {
    var className = props.className, size = props.size, status = props.status, statusText = props.statusText, tooltip = props.tooltip, _tooltipPlacement = props.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? ui/* Direction.Left */.Nm.Left : _tooltipPlacement, _featuredOffer = props.featuredOffer, featuredOffer = _featuredOffer === void 0 ? true : _featuredOffer;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var renderIconComponent = function(featured) {
        switch(status){
            case "in_stock_preorder":
            case "incoming":
                return /*#__PURE__*/ react.createElement(stock_incoming/* IconStockIncoming */.T, {
                    size: size,
                    color: featured ? "yellove700" : "base400"
                });
            case "in_stock":
                return /*#__PURE__*/ react.createElement(stock_in_stock/* IconStockInStock */.l, {
                    size: size,
                    color: featured ? "positive500" : "base400"
                });
            case "not_in_stock":
                return /*#__PURE__*/ react.createElement(stock_out_of_stock/* IconStockOutOfStock */.Y, {
                    size: size,
                    color: featured ? "redio700" : "base400"
                });
            default:
                return /*#__PURE__*/ react.createElement(stock_unknown/* IconStockUnknown */.v, {
                    size: size,
                    color: "base400"
                });
        }
    };
    var getStatusText = function() {
        if (status === "incoming" && statusText) {
            return statusText.replace(/-/g, "‑"); // Replace hyphen with hard hyphen to prevent row break in date (Eg in 2019-08-10).
        }
        return t("product", "stock-status.".concat(status || "unknown"));
    };
    return /*#__PURE__*/ react.createElement(Tooltip, {
        placement: tooltipPlacement,
        title: tooltip === true ? getStatusText() : tooltip,
        className: className,
        renderOnMouseOver: true
    }, /*#__PURE__*/ react.createElement(IconAndText, null, renderIconComponent(featuredOffer)));
});


/***/ }),

/***/ 46256:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xv": () => (/* binding */ StoreLogo),
/* harmony export */   "mA": () => (/* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.mA),
/* harmony export */   "uZ": () => (/* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.uZ)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_cdn_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71412);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21541);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47954);





var StoreLogo = function(param) {
    var className = param.className, _featured = param.featured, featured = _featured === void 0 ? false : _featured, hasImage = param.hasImage, logoUrl = param.logoUrl, name = param.name, _showHighResolutionLogo = param.showHighResolutionLogo, showHighResolutionLogo = _showHighResolutionLogo === void 0 ? false : _showHighResolutionLogo, storeId = param.storeId, _variant = param.variant, variant = _variant === void 0 ? _styles__WEBPACK_IMPORTED_MODULE_3__/* .StoreLogoVariant.DEFAULT */ .mA.DEFAULT : _variant, _width = param.width, width = _width === void 0 ? 88 : _width;
    var shouldRenderLogo = hasImage && (featured || variant === _styles__WEBPACK_IMPORTED_MODULE_3__/* .StoreLogoVariant.CAMPAIGN */ .mA.CAMPAIGN);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StoreLogo */ .Xv, {
        className: className,
        logoWidth: width,
        showHighResolutionLogo: showHighResolutionLogo,
        showLogo: shouldRenderLogo,
        variant: variant
    }, shouldRenderLogo ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_cdn_image__WEBPACK_IMPORTED_MODULE_1__/* .CdnImage */ .l, {
        name: storeId,
        width: width,
        alt: name,
        logoUrl: logoUrl
    }) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StoreLogoText */ .sd, {
        emphasis: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.FontEmphasis.LOW
    }, name));
};


/***/ }),

/***/ 47954:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xv": () => (/* binding */ StoreLogo),
/* harmony export */   "mA": () => (/* binding */ StoreLogoVariant),
/* harmony export */   "sd": () => (/* binding */ StoreLogoText),
/* harmony export */   "uZ": () => (/* binding */ DEFAULT_STORE_LOGO_MAX_WIDTH)
/* harmony export */ });
/* unused harmony export campaignImageHeight */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55703);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21541);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  line-height: 1.3em;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  max-height: ",
        "px;\n  overflow: hidden;\n  align-items: normal;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 12px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 10px;\n  color: ",
        ";\n  max-width: 100%;\n  height: ",
        "px;\n  line-height: ",
        "px;\n  padding: 0 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: center;\n  border: 1px solid ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: ",
        "px;\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: normal;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var DEFAULT_STORE_LOGO_MAX_WIDTH = 68;
var DEFAULT_STORE_LOGO_MAX_HEIGHT = 31;
var StoreLogoVariant;
(function(StoreLogoVariant) {
    StoreLogoVariant["DEFAULT"] = "DEFAULT";
    StoreLogoVariant["CAMPAIGN"] = "CAMPAIGN";
    StoreLogoVariant["HEADING"] = "HEADING";
    StoreLogoVariant["REVIEWS"] = "REVIEWS";
    StoreLogoVariant["PRICE_LIST"] = "PRICE_LIST";
})(StoreLogoVariant || (StoreLogoVariant = {}));
var campaignImageHeight = 31;
var defaultNoLogoCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
var priceListNoLogoCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), defaultNoLogoCss, DEFAULT_STORE_LOGO_MAX_HEIGHT);
var campaignNoLogoCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3(), function(p) {
    return p.theme.colors.base700;
}, campaignImageHeight, campaignImageHeight, function(p) {
    return p.theme.colors.base200;
}, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumUp */ .BC.mediumUp(_templateObject2()));
var reviewsNoLogoCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var StoreLogo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-0"
})(function(props) {
    var _obj;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), props.showHighResolutionLogo ? props.logoWidth / 2 : props.logoWidth, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject5(), props.showHighResolutionLogo ? DEFAULT_STORE_LOGO_MAX_WIDTH : props.logoWidth), (0,styled_tools__WEBPACK_IMPORTED_MODULE_1__/* .ifNotProp */ .Zn)("showLogo", (0,styled_tools__WEBPACK_IMPORTED_MODULE_1__/* .switchProp */ .db)("variant", (_obj = {}, _defineProperty(_obj, StoreLogoVariant.DEFAULT, defaultNoLogoCss), _defineProperty(_obj, StoreLogoVariant.HEADING, defaultNoLogoCss), _defineProperty(_obj, StoreLogoVariant.PRICE_LIST, priceListNoLogoCss), _defineProperty(_obj, StoreLogoVariant.CAMPAIGN, campaignNoLogoCss), _defineProperty(_obj, StoreLogoVariant.REVIEWS, reviewsNoLogoCss), _obj))));
});
var StoreLogoText = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__.CaptionText).withConfig({
    displayName: "StoreLogoText",
    componentId: "sc-0-1"
})(_templateObject7());


/***/ }),

/***/ 76672:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_L": () => (/* binding */ getGroupedPaymentProviders),
  "V7": () => (/* binding */ getPaymentOptions),
  "Qk": () => (/* binding */ getPaymentProviders)
});

;// CONCATENATED MODULE: ./src/components/store-payment/types.ts
var PaymentProviderGroup;
(function(PaymentProviderGroup) {
    PaymentProviderGroup[PaymentProviderGroup["Direct"] = 0] = "Direct";
    PaymentProviderGroup[PaymentProviderGroup["Invoice"] = 1] = "Invoice";
    PaymentProviderGroup[PaymentProviderGroup["Card"] = 2] = "Card";
})(PaymentProviderGroup || (PaymentProviderGroup = {}));

;// CONCATENATED MODULE: ./src/components/store-payment/utils.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var PAYMENT_GROUP_SETTINGS = [
    {
        group: PaymentProviderGroup.Invoice,
        count: 1
    },
    {
        group: PaymentProviderGroup.Direct,
        count: 1
    },
    {
        group: PaymentProviderGroup.Card,
        count: 2
    }
];
var supportedPaymentOptions = [
    {
        name: "BITCOIN",
        translationKey: "store.payment-options-bitcoin"
    },
    {
        name: "CARD",
        translationKey: "store.payment-options-card"
    },
    {
        name: "CASH_ON_DELIVERY",
        translationKey: "store.payment-options-cash-on-delivery"
    },
    {
        name: "DIRECT",
        translationKey: "store.payment-options-direct"
    },
    {
        name: "INSTALLMENT",
        translationKey: "store.payment-options-installment"
    },
    {
        name: "INVOICE",
        translationKey: "store.payment-options-invoice"
    },
    {
        name: "PHONE_BILL",
        translationKey: "store.payment-options-phone-bill"
    },
    {
        name: "PREPAID",
        translationKey: "store.payment-options-prepaid"
    },
    {
        name: "SMS",
        translationKey: "store.payment-options-sms"
    }
];
var supportedPaymentProviders = [
    {
        name: "KLARNA",
        label: "Klarna",
        logo: "klarna.svg",
        group: PaymentProviderGroup.Invoice
    },
    // To be turned on when supported by backend ENUM
    // {
    //   name: 'MOBILE_PAY',
    //   label: 'Mobile pay',
    //   logo: 'mobile-pay.svg',
    // },
    // { name: 'DANKORT', label: 'Dankort', logo: 'dankort.svg', sortOrder: 3 },
    // { name: 'AFTERPAY', label: 'Afterpay', logo: 'afterpay.svg', sortOrder: 4 },
    {
        name: "SWISH",
        label: "Swish",
        logo: "swish.svg",
        group: PaymentProviderGroup.Direct
    },
    {
        name: "VIPPS",
        label: "Vipps",
        logo: "vipps.svg",
        group: PaymentProviderGroup.Direct
    },
    {
        name: "MASTER_CARD",
        label: "MasterCard",
        logo: "mastercard.svg",
        group: PaymentProviderGroup.Card
    },
    {
        name: "VISA",
        label: "Visa",
        logo: "visa.svg",
        group: PaymentProviderGroup.Card
    },
    {
        name: "PAYPAL",
        label: "PayPal",
        logo: "paypal.svg",
        group: PaymentProviderGroup.Direct
    },
    {
        name: "AMEX",
        label: "American Express",
        logo: "americanexpress.svg",
        group: PaymentProviderGroup.Card
    },
    {
        name: "SVEA_WEB_PAY",
        label: "SveaWebPay",
        logo: "svea_ekonomi.svg",
        group: PaymentProviderGroup.Invoice
    },
    {
        name: "PAYSON",
        label: "Payson",
        logo: "payson.svg",
        group: PaymentProviderGroup.Invoice
    },
    {
        name: "DINERS",
        label: "Diners Club",
        logo: "diners.svg",
        group: PaymentProviderGroup.Card
    }
];
var getPaymentOptions = function(store, t) {
    var ref, ref1;
    var ref2;
    var activePaymentOptions = (ref2 = (ref = store.payment) === null || ref === void 0 ? void 0 : (ref1 = ref.options) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean).map(function(option) {
        return option === null || option === void 0 ? void 0 : option.name;
    })) !== null && ref2 !== void 0 ? ref2 : [];
    var hasOptions = activePaymentOptions.length > 0;
    var options = supportedPaymentOptions.map(function(option) {
        return _objectSpreadProps(_objectSpread({}, option), {
            active: activePaymentOptions.includes(option.name),
            translatedName: t("store", option.translationKey)
        });
    }).sort(function(a, b) {
        if (a.active && b.active || !a.active && !b.active) {
            return a.translatedName.localeCompare(b.translatedName);
        }
        if (a.active) {
            return -1;
        }
        return 1;
    });
    return {
        hasOptions: hasOptions,
        options: options
    };
};
var compareSortOrder = function(a, b) {
    if (a.sortOrder < 0) {
        return 1;
    }
    if (b.sortOrder < 0) {
        return -1;
    }
    if (a.sortOrder < b.sortOrder) {
        return -1;
    }
    return 0;
};
var getPaymentProviders = function(store, market) {
    var ref, ref1, ref2;
    if (!store) {
        return {
            hasProviders: false,
            providers: []
        };
    }
    var marketPriorities = (market === null || market === void 0 ? void 0 : (ref = market.paymentProviders) === null || ref === void 0 ? void 0 : ref.priorities) ? market.paymentProviders.priorities : [];
    var ref3;
    var activePaymentProviders = (ref3 = (ref1 = store.payment) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.providers) === null || ref2 === void 0 ? void 0 : ref2.filter(Boolean).map(function(provider) {
        return provider === null || provider === void 0 ? void 0 : provider.name;
    })) !== null && ref3 !== void 0 ? ref3 : [];
    var hasProviders = activePaymentProviders.length > 0;
    var providers = supportedPaymentProviders === null || supportedPaymentProviders === void 0 ? void 0 : supportedPaymentProviders.map(function(provider) {
        return _objectSpreadProps(_objectSpread({}, provider), {
            sortOrder: marketPriorities.indexOf(provider.name),
            active: activePaymentProviders.includes(provider.name),
            logoUrl: "".concat(market.cdn, "/g/rfe/store/paymentprovider/").concat(provider.logo)
        });
    });
    var providersSortedByMarketPrio = _toConsumableArray(providers).sort(compareSortOrder);
    return {
        hasProviders: hasProviders,
        providers: providersSortedByMarketPrio
    };
};
var getGroupedPaymentProviders = function(store, market) {
    var ref, ref1;
    var ref2 = getPaymentProviders(store, market), providers = ref2.providers, hasProviders = ref2.hasProviders;
    var groupedProviders = [];
    var activeProviders = providers.filter(function(p) {
        return p.active;
    });
    if (hasProviders && (market === null || market === void 0 ? void 0 : (ref = market.paymentProviders) === null || ref === void 0 ? void 0 : (ref1 = ref.groupPriorities) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        market.paymentProviders.groupPriorities.forEach(function(group) {
            var visibilitySetting = PAYMENT_GROUP_SETTINGS.find(function(setting) {
                return setting.group === group;
            });
            var visible = (visibilitySetting === null || visibilitySetting === void 0 ? void 0 : visibilitySetting.count) || 0;
            for(var index = 0; index < visible; index += 1){
                groupedProviders.push(getPrioritizedProvidersForGroup(activeProviders, group, index));
            }
        });
    } else if (hasProviders) {
        // Fallback if there are no group priorities for the market
        groupedProviders.push(activeProviders[0]);
    }
    return groupedProviders.filter(function(n) {
        return n;
    });
};
var getPrioritizedProvidersForGroup = function(providers, group, pos) {
    var providersFromGroup = providers.filter(function(p) {
        return p.group === group;
    });
    return providersFromGroup.length > pos ? providersFromGroup[pos] : null;
};


/***/ }),

/***/ 10680:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": () => (/* binding */ TabLink)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/tabs-new/components/tab-link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      box-shadow: inset 0 -5px 0 -1px ",
        ";\n      color: ",
        ";\n\n      a:hover,\n      &:hover {\n        color: inherit;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    height: 100%;\n    display: flex;\n    align-items: center;\n    padding: ",
        " ",
        ";\n    font-weight: 600;\n    cursor: pointer;\n    color: ",
        ";\n    transition: box-shadow 0.1s linear;\n    white-space: nowrap;\n\n    > * {\n      user-select: none;\n    }\n\n    a:hover,\n    &:hover {\n      color: ",
        ";\n    }\n\n    button {\n      cursor: pointer;\n    }\n\n    ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledTabLink = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTabLink",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), design_tokens.measurements.spacing025, design_tokens.measurements.spacing100, props.theme.colors.base500, props.theme.colors.base600, props.$active && (0,styled_components_browser_esm.css)(_templateObject(), props.theme.colors.maybeBlue500, props.theme.text.primary));
});

;// CONCATENATED MODULE: ./src/components/tabs-new/components/tab-link/index.tsx



var TabLink = function(param) {
    var _active = param.active, active = _active === void 0 ? false : _active, ariaControls = param.ariaControls, children = param.children, className = param.className, handleOnClick = param.handleOnClick, to = param.to;
    return /*#__PURE__*/ react.createElement(StyledTabLink, {
        $active: active,
        className: className
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        "aria-expanded": ariaControls ? active : undefined,
        "aria-controls": ariaControls,
        to: to,
        onClick: function(e) {
            return handleOnClick === null || handleOnClick === void 0 ? void 0 : handleOnClick(e);
        }
    }, children));
};


/***/ }),

/***/ 6381:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": () => (/* binding */ tabs_new_Tabs)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/tabs-new/styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 100vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: bottom;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          left: 0;\n          right: 0;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      overflow: unset;\n\n      :before {\n        content: '';\n        position: absolute;\n        background-color: ",
        ";\n        left: -50vw;\n        right: -50vw;\n        z-index: -1;\n        height: 100%;\n        border-bottom: 1px solid ",
        ";\n\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    width: 100%;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    overflow-x: auto;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0 ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  html {\n    overflow-x: hidden !important;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var Tabs = styled_components_browser_esm["default"].nav.withConfig({
    displayName: "Tabs",
    componentId: "sc-0-0"
})(_templateObject1(), base/* media.mediumDown */.BC.mediumDown(_templateObject()));
var TabsBackground = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TabsBackground",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), props.background && props.isSticky && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.bg.primary, props.theme.lines.primary, base/* media.mediumDown */.BC.mediumDown(_templateObject2())), !props.background && (0,styled_components_browser_esm.css)(_templateObject4(), props.theme.lines.primary));
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-2"
})(_templateObject8(), base/* media.smallOnly */.BC.smallOnly(_templateObject6()), base/* media.mediumUp */.BC.mediumUp(_templateObject7(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var Image = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-3"
})(_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var GlobalStylesOverride = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject10());

// EXTERNAL MODULE: ./src/components/tabs-new/components/tab-link/index.tsx + 1 modules
var tab_link = __webpack_require__(10680);
;// CONCATENATED MODULE: ./src/components/tabs-new/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}




var TabItem = function(param) {
    var active = param.active, id = param.id, index = param.index, onClick = param.onClick, scrollToTop = param.scrollToTop, title = param.title, to = param.to;
    var history = (0,react_router/* useHistory */.k6)();
    var handleOnClick = (0,react.useCallback)(function(e) {
        if (scrollToTop) {
            e.preventDefault();
            e.stopPropagation();
            // Scroll to top
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            // Remove potential hash from url
            history.push(history.location.pathname + history.location.search);
        }
        return onClick === null || onClick === void 0 ? void 0 : onClick(id, index);
    }, [
        id,
        onClick,
        scrollToTop,
        history
    ]);
    return /*#__PURE__*/ react.createElement(tab_link/* TabLink */.f, {
        active: active,
        handleOnClick: function(e) {
            return handleOnClick(e);
        },
        to: to
    }, title);
};
var tabs_new_Tabs = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var className = param.className, onClick = param.onClick, tabs = param.tabs, background = param.background, isSticky = param.isSticky;
    return /*#__PURE__*/ react.createElement(Tabs, {
        className: className,
        ref: ref
    }, isSticky && /*#__PURE__*/ react.createElement(GlobalStylesOverride, null), /*#__PURE__*/ react.createElement(TabsBackground, {
        background: background,
        isSticky: isSticky
    }, /*#__PURE__*/ react.createElement(Wrapper, null, tabs.map(function(tab, index) {
        return /*#__PURE__*/ react.createElement(TabItem, _extends({}, tab, {
            index: index,
            key: tab.id,
            onClick: onClick
        }));
    }))));
});


/***/ }),

/***/ 30943:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* binding */ text_link_TextLink)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(89218);
;// CONCATENATED MODULE: ./src/components/text-link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TextLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "TextLink",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});

;// CONCATENATED MODULE: ./src/components/text-link/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var text_link_TextLink = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    return react.createElement(TextLink, _extends({}, props), children);
};


/***/ }),

/***/ 40744:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lf": () => (/* binding */ promptToast),
/* harmony export */   "c7": () => (/* binding */ TOAST_PROMPT),
/* harmony export */   "i6": () => (/* binding */ requireToastContainer),
/* harmony export */   "xy": () => (/* binding */ TOAST_REQUIRED)
/* harmony export */ });
var TOAST_PROMPT = "TOAST_PROMPT";
var TOAST_REQUIRED = "TOAST_REQUIRED";
var promptToast = function(promptType, content) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return {
        type: TOAST_PROMPT,
        promptType: promptType,
        content: content,
        options: options
    };
};
var requireToastContainer = function() {
    return {
        type: TOAST_REQUIRED,
        required: true
    };
};


/***/ }),

/***/ 51326:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71297);

/* harmony default export */ __webpack_exports__["Z"] = ((0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "toast";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | toast */ 578).then(__webpack_require__.bind(__webpack_require__, 90383));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(90383);
        }
        return eval("require.resolve")("./toast-container");
    }
}));


/***/ }),

/***/ 37702:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": () => (/* reexport */ Translate),
  "O": () => (/* reexport */ translator)
});

;// CONCATENATED MODULE: ./src/components/translate/translator.ts
var pluralForm = function(locale, count) {
    // Numeric check for pluralization count
    // Also, handle negative numbers, treat -1 as 1.
    var n = Math.abs(parseFloat(String(count)));
    if (isNaN(n) || !isFinite(n)) {
        return false;
    }
    switch(locale){
        // Rule: nplurals=2; plural=(n != 1);
        // Fallthrough where the same rule applies
        case "en":
        case "en_GB":
        case "en_IE":
        case "en_NZ":
        case "nb_NO":
        case "sv":
        case "fi":
        case "es":
        case "it":
        case "da":
            // Rule: nplurals=2; plural=(n != 1);
            return n !== 1 ? 1 : 0;
        case "fr":
            // Rule: nplurals=2; plural=(n > 1);
            return n > 1 ? 1 : 0;
        case "pl":
            // Rule: nplurals=3; plural=(n==1 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);
            if (n === 1) {
                return 0;
            }
            return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        default:
            return false;
    }
};
var getPluralIndex = function(translation, locale, params) {
    var pluralIndex = pluralForm(locale, params.n);
    if (typeof pluralIndex !== "boolean" && Array.isArray(translation)) {
        return translation[pluralIndex] !== undefined ? pluralIndex : false;
    }
    return false;
};
var translator = function(translations, locale) {
    return function(domain, text) {
        var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
            react: true
        };
        if (!translations || !translations[domain] || !translations[domain][text]) {
            return text;
        }
        var translation = translations[domain][text];
        var pluralIndex = getPluralIndex(translation, locale, params);
        var translatedString = text;
        if (pluralIndex !== false) {
            translatedString = translation[pluralIndex];
        } else if (typeof translation === "string") {
            translatedString = translation;
        }
        var stringWithParams = Object.keys(params).reduce(function(string, key) {
            return string.replace(new RegExp("%".concat(!options.react ? "@?" : "").concat(key, "%"), "g"), params[key]);
        }, translatedString);
        if (!options.react) {
            return stringWithParams;
        }
        // Inject non-text components (replace placeholders that start with "@")
        var stringComponentArray = Object.keys(params).reduce(function(stringArray, key) {
            var newStringArray = [];
            stringArray.forEach(function(str) {
                if (typeof str === "string") {
                    var stringParts = str.split("%@".concat(key, "%"));
                    for(var i = stringParts.length - 1; i > 0; i -= 1){
                        stringParts.splice(i, 0, params[key]);
                    }
                    newStringArray = newStringArray.concat(stringParts.filter(function(item) {
                        return item !== "" && item !== undefined;
                    }));
                } else {
                    newStringArray.push(str);
                }
            });
            return newStringArray;
        }, [
            stringWithParams
        ]);
        // Return string if possible
        return stringComponentArray.length === 1 ? stringComponentArray[0] : stringComponentArray;
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/translate/translate-func.ts
/* eslint-disable */ 

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
;// CONCATENATED MODULE: ./src/components/translate/translate.tsx
/* eslint-disable react/no-danger */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function sanitizeParamForMarkdown(param) {
    return param.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
function sanitizeParamsForMarkdown(params) {
    return Object.keys(params).reduce(function(sanitizedParams, key) {
        return _objectSpreadProps(_objectSpread({}, sanitizedParams), _defineProperty({}, key, sanitizeParamForMarkdown(params[key])));
    }, {});
}
function getTextFromNode(node) {
    if (typeof node === "string") return node;
    return "";
}
var Translate = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var domain = _param.domain, children = _param.children, params = _objectWithoutProperties(_param, [
        "domain",
        "children"
    ]);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (!t) {
        return /*#__PURE__*/ react.createElement("span", null, children);
    }
    var childrenText = getTextFromNode(children);
    var isMarkdown = childrenText && childrenText.slice(-3) === ".md";
    var text = t(domain, // @ts-expect-error expects never for some reason
    childrenText, isMarkdown ? sanitizeParamsForMarkdown(params) : params);
    return isMarkdown ? /*#__PURE__*/ react.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: text
        }
    }) : /*#__PURE__*/ react.createElement("span", null, text);
});

;// CONCATENATED MODULE: ./src/components/translate/index.ts





/***/ }),

/***/ 16732:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ Truncated)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  /* stylelint-disable */\n  /* Restrict the box to the specified number of lines of text.\n   * See https://css-tricks.com/almanac/properties/l/line-clamp/ */\n  display: -webkit-box;\n  -webkit-line-clamp: ",
        ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var _maxLines;
var Truncated = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Truncated",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return (_maxLines = props.maxLines) !== null && _maxLines !== void 0 ? _maxLines : 2;
});


/***/ }),

/***/ 60738:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": () => (/* binding */ user_avatar_UserAvatar)
});

// UNUSED EXPORTS: Symbol

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/account/index.js
var account = __webpack_require__(88863);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/components/user-avatar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &:hover,\n      .focus-visible & {\n        color: ",
        ";\n        background: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  font-weight: 600;\n  font-size: ",
        "px;\n  text-transform: uppercase;\n  box-sizing: border-box;\n  height: ",
        "px;\n  width: ",
        "px;\n  border-radius: ",
        "px;\n  transition: all ",
        ";\n  overflow: hidden;\n  background: ",
        ";\n\n  color: ",
        ";\n\n  img {\n    transition: all ",
        ";\n    border-radius: ",
        "px;\n  }\n\n  svg path {\n    fill: currentColor;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  object-fit: cover;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var UserAvatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserAvatar",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return Math.round(0.67 * p.$size);
}, function(p) {
    return p.$size;
}, function(p) {
    return p.$size;
}, function(p) {
    return p.$size;
}, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(p) {
    return p.theme.colors.base500;
}, function(p) {
    return p.theme.colors.base0;
}, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(p) {
    return p.$size;
}, function(p) {
    return p.$isLinked && (0,styled_components_browser_esm.css)(_templateObject(), p.theme.colors.base0, p.theme.icons.callToActionHover);
});
var Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), function(p) {
    return p.width;
}, function(p) {
    return p.height;
});

;// CONCATENATED MODULE: ./src/components/user-avatar/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var DEFAULT_SIZE = 32;
var user_avatar_UserAvatar = function(param) {
    var _size = param.size, size = _size === void 0 ? DEFAULT_SIZE : _size, className = param.className, avatar = param.avatar, displayName = param.displayName, email = param.email, _isLinked = param.isLinked, isLinked = _isLinked === void 0 ? true : _isLinked;
    return /*#__PURE__*/ react.createElement(UserAvatar, {
        className: className,
        "data-test": "UserAvatar",
        $size: size,
        $isLinked: isLinked
    }, /*#__PURE__*/ react.createElement(Symbol1, {
        displayName: displayName,
        avatar: avatar,
        email: email,
        size: size
    }));
};
var Symbol1 = function(param) {
    var displayName = param.displayName, avatar = param.avatar, email = param.email, _size = param.size, size = _size === void 0 ? DEFAULT_SIZE : _size;
    var ref = _slicedToArray((0,react.useState)(false), 2), imageError = ref[0], setImageError = ref[1];
    var onError = function() {
        setImageError(true);
    };
    if (avatar && !imageError) {
        return /*#__PURE__*/ react.createElement(Image, {
            alt: displayName || email || "",
            src: avatar,
            width: size,
            height: size,
            onError: onError
        });
    }
    var ref1;
    var firstChar = (ref1 = getFirstChar(displayName)) !== null && ref1 !== void 0 ? ref1 : getFirstChar(email);
    if (firstChar) {
        return /*#__PURE__*/ react.createElement("span", {
            style: {
                lineHeight: "".concat(size, "px")
            }
        }, firstChar);
    }
    return /*#__PURE__*/ react.createElement(account/* IconAccount */.U, {
        size: size * 0.75
    });
};

var getFirstChar = function(name) {
    var validNameOrEmail = /^[A-Za-z]/;
    if (name && name.match(validNameOrEmail)) {
        return name.charAt(0);
    }
    return undefined;
};


/***/ }),

/***/ 58854:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ UxLiteQuestions)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var UxLiteQuestionsLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "ux-lite";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | ux-lite */ 314).then(__webpack_require__.bind(__webpack_require__, 21162));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(21162);
        }
        return eval("require.resolve")("./ux-lite-questions");
    }
});
var UxLiteQuestions = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UxLiteQuestionsLoadable, _extends({}, props));
};


/***/ }),

/***/ 73567:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ withViewport),
/* harmony export */   "t": () => (/* binding */ ViewportTracker)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38209);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94141);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var ViewportTrackerContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
ViewportTrackerContext.displayName = "ViewportTrackerContext";
var ViewportTracker = function(param) {
    var children = param.children;
    var state = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        scroll: {
            xDirection: undefined,
            yDirection: undefined,
            x: -0,
            y: -0
        }
    });
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(state.current), 2), viewport = ref[0], setViewport = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var onUpdateViewport = function onUpdateViewport() {
            var html = document.documentElement;
            var x = window.scrollX;
            var y = window.scrollY;
            var scrollChanged = x !== state.current.scroll.x || y !== state.current.scroll.y;
            var scroll = scrollChanged ? {
                xDirection: Math.sign(state.current.scroll.x - x),
                yDirection: Math.sign(state.current.scroll.y - y),
                x: x,
                y: y
            } : state.current.scroll;
            state.current = {
                width: window.innerWidth || html.clientWidth,
                height: window.innerHeight || html.clientHeight,
                left: window.pageXOffset || html.scrollLeft,
                top: window.pageYOffset || html.scrollTop,
                scroll: scroll
            };
            setViewport(state.current);
        };
        var throttledOnUpdateViewport = lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default()(onUpdateViewport, 200);
        window.addEventListener("scroll", throttledOnUpdateViewport, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .browserSupports.passiveEventListener */ .TV.passiveEventListener() ? {
            passive: true
        } : false);
        onUpdateViewport();
        return function() {
            window.removeEventListener("scroll", throttledOnUpdateViewport);
        };
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ViewportTrackerContext.Provider, {
        value: viewport
    }, children);
};
var withViewport = function(Component) {
    return function(props) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ViewportTrackerContext.Consumer, null, function(viewport) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _extends({}, props, {
                viewport: viewport
            }));
        });
    };
};


/***/ }),

/***/ 50238:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": () => (/* binding */ useViewportContext),
/* harmony export */   "Pi": () => (/* binding */ ViewportContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38209);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shallowequal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50631);
/* harmony import */ var shallowequal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(shallowequal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94141);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var ViewportContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
ViewportContext.displayName = "ViewportContext";
var queries;
var getSizes = function() {
    if (!window) {
        // This should never happen (SSR always sends an initialValue) but just to be safe, here we go :)
        return {
            isMobile: false,
            isTablet: false,
            isDesktop: true
        };
    }
    if (!queries) {
        queries = {
            smallOnly: window.matchMedia(src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.smallOnly */ .AV.smallOnly),
            mediumOnly: window.matchMedia(src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.mediumOnly */ .AV.mediumOnly),
            largeUp: window.matchMedia(src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.largeUp */ .AV.largeUp)
        };
    }
    return {
        isMobile: queries.smallOnly.matches,
        isTablet: queries.mediumOnly.matches,
        isDesktop: queries.largeUp.matches
    };
};
var ViewportContextContainer = function(param) {
    var children = param.children, _initialValue = param.initialValue, initialValue = _initialValue === void 0 ? undefined : _initialValue;
    // In SSR initialValue is guessed from the user agent
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_0__.useState(initialValue !== null && initialValue !== void 0 ? initialValue : getSizes()), 2), state = ref[0], setState = ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var onResize = lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default()(function() {
            var sizes = getSizes();
            setState(function(s) {
                if (!shallowequal__WEBPACK_IMPORTED_MODULE_2___default()(sizes, s)) {
                    return sizes;
                }
                return s;
            });
        }, 200);
        window.addEventListener("resize", onResize);
        onResize();
        return function() {
            return window.removeEventListener("resize", onResize);
        };
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ViewportContext.Provider, {
        value: state
    }, children);
};
var useViewportContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ViewportContext);
};
/* harmony default export */ __webpack_exports__["ZP"] = (ViewportContext);


/***/ }),

/***/ 22899:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": () => (/* reexport safe */ _context__WEBPACK_IMPORTED_MODULE_2__.ZP)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50238);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "display: none;"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "display: none;"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "display: none;"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  /* Hide element with slightly increased specificity. This allows us to extend this component\n    with custom display values and other styles rather than having to use it as a wrapper. */\n  && {\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledViewport = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.attrs(// TODO: Remove all this?
function(param) {
    var mobile = param.mobile, tablet = param.tablet, desktop = param.desktop;
    return {
        "data-test": "Viewport",
        "data-test-mobile": mobile,
        "data-test-tablet": tablet,
        "data-test-desktop": desktop
    };
}).withConfig({
    displayName: "StyledViewport",
    componentId: "sc-0-0"
})(_templateObject3(), function(props) {
    return !props.mobile && src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject());
}, function(props) {
    return !props.tablet && src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumOnly */ .BC.mediumOnly(_templateObject1());
}, function(props) {
    return !props.desktop && src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject2());
});

/* harmony default export */ __webpack_exports__["Z"] = (StyledViewport);


/***/ }),

/***/ 22448:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": () => (/* binding */ YoutubeIcon)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/youtube/index.js
var youtube = __webpack_require__(81258);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/components/youtube-icon/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n\n    svg {\n      /* Needed to make red youtube icon appear over white arrow */\n      z-index: 2;\n    }\n\n    /* White arrow inside youtube icon */\n    &::after {\n      content: '';\n      background: ",
        ";\n      width: ",
        "px;\n      height: ",
        "px;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 1;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledYoutubeIcon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledYoutubeIcon",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject(), function(p) {
        return p.theme.colors.base0;
    }, props.$size / 2, props.$size / 2);
});

;// CONCATENATED MODULE: ./src/components/youtube-icon/index.tsx



var YOUTUBE_ICON_SIZE_DEFAULT = 40;
var YoutubeIcon = function(props) {
    var className = props.className, _size = props.size, size = _size === void 0 ? YOUTUBE_ICON_SIZE_DEFAULT : _size;
    return /*#__PURE__*/ react.createElement(StyledYoutubeIcon, {
        className: className,
        $size: size
    }, /*#__PURE__*/ react.createElement(youtube/* IconYoutube */.z, {
        size: size,
        color: "staticRedio700"
    }));
};


/***/ }),

/***/ 55803:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gv": () => (/* binding */ UserlikeChatProvider),
/* harmony export */   "hy": () => (/* binding */ useUserlikeChatContext)
/* harmony export */ });
/* unused harmony export UserlikeChatContext */
/* harmony import */ var _userlike_messenger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87202);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64799);
/* harmony import */ var src_client_sentry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22260);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var UserlikeChatContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createContext(null);
var UserlikeChatProvider = function(param) {
    var children = param.children;
    var location = (0,react_router__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)();
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), 2), api = ref[0], setApi = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), 2), messenger = ref1[0], setMessenger = ref1[1];
    var me = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.account.me;
    });
    var visibility = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            button: false,
            main: false,
            notifications: false
        };
    }, []);
    // Init API
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        var widgetKey = (ref = window.CLIENT_MARKET) === null || ref === void 0 ? void 0 : ref.userlikeChatKey;
        if (!widgetKey) {
            return;
        }
        var initApi = function() {
            var _ref = _asyncToGenerator(function() {
                var apiResult;
                return __generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,_userlike_messenger__WEBPACK_IMPORTED_MODULE_0__/* .createMessenger */ .RF)({
                                    version: 2,
                                    widgetKey: widgetKey
                                })
                            ];
                        case 1:
                            apiResult = _state.sent();
                            if (apiResult.kind === "error") {
                                (0,src_client_sentry__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(apiResult.error);
                                return [
                                    2
                                ];
                            }
                            if (!apiResult.value.api) {
                                (0,src_client_sentry__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(new Error("Userlike chat API is deprecated, please upgrade."));
                                return [
                                    2
                                ];
                            }
                            setApi(apiResult.value.api);
                            return [
                                2
                            ];
                    }
                });
            });
            return function initApi() {
                return _ref.apply(this, arguments);
            };
        }();
        initApi();
    }, []);
    // Mount chat on init (or login)
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!api) {
            return undefined;
        }
        // When user is logged in, pass their token to access past chats
        var mountOptions = {};
        if (me) {
            mountOptions = {
                externalToken: {
                    getToken: /*#__PURE__*/ _asyncToGenerator(function() {
                        return __generator(this, function(_state) {
                            return [
                                2,
                                me.userlikeChatContactAuthToken
                            ];
                        });
                    }),
                    onError: function(authError) {
                        return (0,src_client_sentry__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(authError);
                    }
                }
            };
        }
        var messengerSub = api.mount(mountOptions).subscribe(function(messengerResult) {
            if (messengerResult.kind === "error") {
                (0,src_client_sentry__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(messengerResult.error);
                return;
            }
            if (!messengerResult.value) {
                (0,src_client_sentry__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb)(new Error("Userlike chat failed to mount."));
                return;
            }
            setMessenger(messengerResult.value);
        });
        return function() {
            return messengerSub.unsubscribe();
        };
    }, [
        api,
        me
    ]);
    // Show/hide messenger based on viewport
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        messenger === null || messenger === void 0 ? void 0 : messenger.setVisibility(visibility);
    }, [
        messenger,
        visibility
    ]);
    var openMessenger = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        messenger === null || messenger === void 0 ? void 0 : messenger.maximize();
        messenger === null || messenger === void 0 ? void 0 : messenger.setVisibility(_objectSpreadProps(_objectSpread({}, visibility), {
            main: true
        }));
    }, [
        messenger,
        visibility
    ]);
    // Auto open if URL param present
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (messenger && location.search.includes("chat=open")) {
            // 'maximize()' is does nothing when invoked right after messenger mount. We have to subscribe to the Observable.
            // https://github.com/userlike/messenger/issues/10
            var messengerSub = messenger.state$.subscribe(function(param) {
                var state = param.state;
                if (state === "minimized") {
                    openMessenger();
                    messengerSub.unsubscribe();
                }
            });
            return function() {
                return messengerSub.unsubscribe();
            };
        }
        return undefined;
    }, [
        messenger,
        location.search,
        openMessenger
    ]);
    var ctxValue = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return {
            isActive: !!messenger,
            openMessenger: openMessenger
        };
    }, [
        messenger,
        openMessenger
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(UserlikeChatContext.Provider, {
        value: ctxValue
    }, children);
};
var useUserlikeChatContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(UserlikeChatContext);
    if (!context) {
        throw new Error("useUserlikeChatContext must be used within a UserlikeChatProvider");
    }
    return context;
};


/***/ }),

/***/ 96192:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": () => (/* binding */ WideContextProvider),
/* harmony export */   "Y": () => (/* binding */ WideContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var WideContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isWide: false,
    setIsWide: function() {
        return null;
    }
});
var WideContextProvider = function(props) {
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), isWide = ref[0], setIsWide = ref[1];
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            isWide: isWide,
            setIsWide: setIsWide
        };
    }, [
        isWide
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WideContext.Provider, {
        value: contextValue
    }, props.children);
};


/***/ }),

/***/ 99311:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DU": () => (/* binding */ INFO_PAGES_RECEIVE),
/* harmony export */   "NH": () => (/* binding */ SORT_CHANGE),
/* harmony export */   "R5": () => (/* binding */ DANGEROUS_CONFIG_RECEIVE),
/* harmony export */   "rB": () => (/* binding */ sortChange)
/* harmony export */ });
/* unused harmony exports SESSION_RECEIVE, dangerousConfigReceive */
var SORT_CHANGE = "SORT_CHANGE";
var DANGEROUS_CONFIG_RECEIVE = "__DANGEROUS_CONFIG_RECEIVE";
var INFO_PAGES_RECEIVE = "INFO_PAGES_RECEIVE";
var SESSION_RECEIVE = "SESSION_RECEIVE";
function dangerousConfigReceive(data) {
    return {
        type: DANGEROUS_CONFIG_RECEIVE,
        market: data.market,
        markets: data.markets,
        server: data.server,
        routes: data.routes
    };
}
var sortChange = function(data) {
    return {
        type: SORT_CHANGE,
        data: data
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    sortChange: sortChange
});


/***/ }),

/***/ 26016:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MC": () => (/* binding */ CampaignEnum),
/* harmony export */   "k1": () => (/* binding */ mapCampaignIdToName),
/* harmony export */   "pw": () => (/* binding */ CampaignIdEnum)
/* harmony export */ });
var CampaignIdEnum;
(function(CampaignIdEnum) {
    CampaignIdEnum[CampaignIdEnum["BLACK_FRIDAY_ID"] = 2] = "BLACK_FRIDAY_ID";
    CampaignIdEnum[CampaignIdEnum["CHRISTMAS_SALE_ID"] = 3] = "CHRISTMAS_SALE_ID";
    CampaignIdEnum[CampaignIdEnum["DAILY_DEALS_ID"] = 4] = "DAILY_DEALS_ID";
    CampaignIdEnum[CampaignIdEnum["CYBER_MONDAY_ID"] = 6] = "CYBER_MONDAY_ID";
    CampaignIdEnum[CampaignIdEnum["BLACK_FRIDAY_WEEKEND_ID"] = 7] = "BLACK_FRIDAY_WEEKEND_ID";
    CampaignIdEnum[CampaignIdEnum["BACK_TO_SCHOOL_ID"] = 9] = "BACK_TO_SCHOOL_ID";
    CampaignIdEnum[CampaignIdEnum["JANUARY_SALE_ID"] = 12] = "JANUARY_SALE_ID";
})(CampaignIdEnum || (CampaignIdEnum = {}));
var CampaignEnum;
(function(CampaignEnum) {
    CampaignEnum["BLACK_FRIDAY"] = "blackFriday";
    CampaignEnum["CHRISTMAS_SALE"] = "christmasSale";
    CampaignEnum["DAILY_DEALS"] = "dailyDeals";
    CampaignEnum["CYBER_MONDAY"] = "cyberMonday";
    CampaignEnum["BLACK_FRIDAY_WEEKEND"] = "blackFridayWeekend";
    CampaignEnum["BACK_TO_SCHOOL"] = "backToSchool";
    CampaignEnum["JANUARY_SALE"] = "januarySale";
})(CampaignEnum || (CampaignEnum = {}));
var mapCampaignIdToName = function(activeCampaignId) {
    switch(activeCampaignId){
        case CampaignIdEnum.BLACK_FRIDAY_ID:
            return CampaignEnum.BLACK_FRIDAY;
        case CampaignIdEnum.CYBER_MONDAY_ID:
            return CampaignEnum.CYBER_MONDAY;
        case CampaignIdEnum.BLACK_FRIDAY_WEEKEND_ID:
            return CampaignEnum.BLACK_FRIDAY_WEEKEND;
        case CampaignIdEnum.BACK_TO_SCHOOL_ID:
            return CampaignEnum.BACK_TO_SCHOOL;
        case CampaignIdEnum.CHRISTMAS_SALE_ID:
            return CampaignEnum.CHRISTMAS_SALE;
        case CampaignIdEnum.JANUARY_SALE_ID:
            return CampaignEnum.JANUARY_SALE;
        case CampaignIdEnum.DAILY_DEALS_ID:
        default:
            return CampaignEnum.DAILY_DEALS;
    }
};


/***/ }),

/***/ 76109:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ formatDate)
/* harmony export */ });
var formatDate = function(value, locale, dateFormatOptions) {
    var defaultFormat = {
        day: "numeric",
        month: "short",
        year: "numeric"
    };
    var formattedDate = new Date(value).toLocaleDateString(locale, dateFormatOptions || defaultFormat);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Need to check if replaceAll is defined because we get error reports in Sentry for it
    return (formattedDate === null || formattedDate === void 0 ? void 0 : formattedDate.replaceAll) ? formattedDate.replaceAll(".", "") : "";
};


/***/ }),

/***/ 4398:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ formatNumber)
/* harmony export */ });
// Formats number with thousands separator
function formatNumber(count, marketCode) {
    var countString = count.toString();
    if (countString.length <= 3) return count;
    switch(marketCode){
        case "se":
        case "no":
        case "dk":
        case "fi":
        case "fr":
            return countString.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
        case "gb":
            return count.toLocaleString("en-GB");
        default:
            return count.toLocaleString();
    }
}


/***/ }),

/***/ 23513:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b8": () => (/* binding */ TrackClickScope),
  "_L": () => (/* reexport */ mapStockStatusToGTMStockStatus),
  "_k": () => (/* binding */ trackMobileContractClick),
  "Rx": () => (/* binding */ trackOfferClickWithRevenue),
  "Yn": () => (/* binding */ trackShopClickWithRevenue),
  "cR": () => (/* binding */ trackUnfeaturedOfferClick)
});

// UNUSED EXPORTS: TrackClickType

// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(24005);
;// CONCATENATED MODULE: ./src/globals/tracking/util.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var removeUndefinedFields = function(input) {
    var output = Object.keys(input).reduce(function(acc, key) {
        return input[key] === undefined ? _objectSpread({}, acc) : _objectSpreadProps(_objectSpread({}, acc), _defineProperty({}, key, input[key]));
    }, {});
    return output;
};
var mapStockStatusToGTMStockStatus = function(stockStatus) {
    switch(stockStatus){
        case "in_stock":
            return "in_stock";
        case "in_stock_preorder":
            return "preorder";
        case "incoming":
            return "backorder";
        case "not_in_stock":
            return "out_of_stock";
        case "unknown":
            return "unknown";
        default:
            return undefined;
    }
};

;// CONCATENATED MODULE: ./src/globals/tracking/conversion.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function conversion_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function conversion_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            conversion_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



var TrackClickType;
(function(TrackClickType) {
    TrackClickType["RAW"] = "raw";
    TrackClickType["OFFER"] = "offer";
    TrackClickType["SHOP"] = "shop";
})(TrackClickType || (TrackClickType = {}));
var TrackClickScope;
(function(TrackClickScope) {
    TrackClickScope["PRICE_HISTORY"] = "product_price_history";
    TrackClickScope["MINI_OFFERLIST"] = "product_mini_offerlist";
    TrackClickScope["PRICE_LIST"] = "product_price_list";
    TrackClickScope["PRICE_LIST_EXPANDED"] = "product_price_list_expanded";
    TrackClickScope["MOBILE_CONTRACT"] = "product_mobile_contract";
    TrackClickScope["PROMOTION_MODAL"] = "promotion_modal";
    TrackClickScope["PROMOTION_PRODUCTS_PAGE_HEADER"] = "promotion_products_page_header";
    TrackClickScope["PROMOTION_PRODUCT_CARD"] = "promotion_product_card";
    TrackClickScope["SHOP_PAGE_HEADER"] = "shop_page_header";
    TrackClickScope["SHOP_PAGE_ABOUT"] = "shop_page_about";
    TrackClickScope["KEYWORD_PAGE"] = "keyword_page";
    TrackClickScope["SEARCH_RESULT_PAGE"] = "search_result_page";
    TrackClickScope["CAMPAIGN_SHOP_POPUP"] = "campaign_shop_popup";
    TrackClickScope["CAMPAIGN_LIST_ITEM"] = "campaign_list_item";
    TrackClickScope["USER_REVIEW_CARD"] = "user_review_card";
    TrackClickScope["USED_PRODUCT_CARD"] = "used_product_card";
    TrackClickScope["EXPERT_PRODUCT_CARD"] = "expert_product_card";
})(TrackClickScope || (TrackClickScope = {}));
function fetchClickData(type, id) {
    return _fetchClickData.apply(this, arguments);
}
function _fetchClickData() {
    _fetchClickData = _asyncToGenerator(function(type, id) {
        var res, error;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!id) return [
                        2,
                        {}
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch("/_internal/click-data/".concat(type, "/").concat(id))
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res.json()
                    ];
                case 3:
                    error = _state.sent();
                    // Fail silently in case of adblocker
                    return [
                        2,
                        {}
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchClickData.apply(this, arguments);
}
var trackOfferClickWithRevenue = function() {
    var _ref = _asyncToGenerator(function(data) {
        var offerId, isRawOffer, clickData, error, eventData, eventName;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    offerId = data.offerId, isRawOffer = data.isRawOffer;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetchClickData(isRawOffer ? TrackClickType.RAW : TrackClickType.OFFER, offerId)
                    ];
                case 2:
                    clickData = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    eventData = removeUndefinedFields(conversion_objectSpread({}, data, clickData));
                    eventName = isRawOffer ? "rawOfferClickWithRevenue" : "offerClickWithRevenue";
                    (0,data_layer/* pushEvent */.A)(eventName, eventData);
                    return [
                        2
                    ];
            }
        });
    });
    return function trackOfferClickWithRevenue(data) {
        return _ref.apply(this, arguments);
    };
}();
var trackShopClickWithRevenue = function() {
    var _ref = _asyncToGenerator(function(data) {
        var clickData, error;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetchClickData(TrackClickType.SHOP, String(data.shopId))
                    ];
                case 1:
                    clickData = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    (0,data_layer/* pushEvent */.A)("shopClickWithRevenue", conversion_objectSpread({}, data, clickData));
                    return [
                        2
                    ];
            }
        });
    });
    return function trackShopClickWithRevenue(data) {
        return _ref.apply(this, arguments);
    };
}();
var trackUnfeaturedOfferClick = function() {
    var _ref = _asyncToGenerator(function(data) {
        return __generator(this, function(_state) {
            (0,data_layer/* pushEvent */.A)("unfeaturedOfferClicked", data);
            return [
                2
            ];
        });
    });
    return function trackUnfeaturedOfferClick(data) {
        return _ref.apply(this, arguments);
    };
}();
var trackMobileContractClick = function(data) {
    var eventData = removeUndefinedFields(data);
    (0,data_layer/* pushEvent */.A)("offerClickWithRevenue", eventData);
};


/***/ }),

/***/ 15301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Em": () => (/* binding */ trackSortingSelectEvent),
/* harmony export */   "VN": () => (/* binding */ PageScope),
/* harmony export */   "YD": () => (/* binding */ trackFilterRemoveEvent),
/* harmony export */   "f9": () => (/* binding */ trackFilterSelectEvent)
/* harmony export */ });
/* harmony import */ var src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24005);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var PageScope;
(function(PageScope) {
    PageScope["CATEGORY"] = "Category";
    PageScope["CAMPAIGN"] = "Campaign";
    PageScope["DEALS"] = "Deals";
    PageScope["PROMOTION"] = "Promotion";
    PageScope["PROMOTION_PRODUCTS"] = "PromotionProducts";
    PageScope["USED"] = "Used";
    PageScope["SEARCH"] = "Search";
    PageScope["PRICE_HISTORY_GRAPH"] = "PriceHistoryGraph";
    PageScope["PRODUCT"] = "Product";
    PageScope["REVIEWS"] = "Reviews";
})(PageScope || (PageScope = {}));
var trackFilterSelectEvent = function(data) {
    var eventData = _objectSpread({}, data);
    if (!eventData.campaign) eventData.campaign = null;
    if (!eventData.category) eventData.category = null;
    if (!eventData.searchTerm) eventData.searchTerm = null;
    if (!eventData.translatedValue) eventData.translatedValue = data.value;
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("filterSelect", eventData);
};
var trackFilterRemoveEvent = function(data) {
    var eventData = _objectSpread({}, data);
    if (!eventData.campaign) eventData.campaign = null;
    if (!eventData.category) eventData.category = null;
    if (!eventData.searchTerm) eventData.searchTerm = null;
    if (!eventData.translatedValue) eventData.translatedValue = data.value;
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("filterRemove", eventData);
};
var trackSortingSelectEvent = function(data) {
    var eventData = _objectSpread({}, data);
    if (!eventData.campaign) eventData.campaign = null;
    if (!eventData.category) eventData.category = null;
    if (!eventData.searchTerm) eventData.searchTerm = null;
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("sortingSelect", eventData);
};


/***/ }),

/***/ 57735:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": () => (/* binding */ InternalNavigationScope),
/* harmony export */   "p": () => (/* binding */ trackInternalNavigationClick)
/* harmony export */ });
/* harmony import */ var src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24005);

var trackInternalNavigationClick = function(data) {
    var currentPage = data.currentPage || window.location.pathname + window.location.search + window.location.hash;
    // Calling this function with an identical route can happen due to bugs,
    // when that happens we don't want to track it.
    if (currentPage === data.nextPage) return;
    var eventData = {
        scope: data.scope,
        current_page: currentPage,
        next_page: data.nextPage,
        index: typeof data.index === "number" ? data.index + 1 : undefined,
        search_query: data.searchQuery
    };
    if (!eventData.index) delete eventData.index;
    if (!eventData.search_query) delete eventData.search_query;
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("internal_navigation_click", eventData);
};
var InternalNavigationScope;
(function(InternalNavigationScope) {
    InternalNavigationScope["ABOUT_REVIEWS"] = "About reviews";
    InternalNavigationScope["ARTICLE_CONTENT_CARD"] = "Article - content card";
    InternalNavigationScope["ARTICLE_READ_MORE"] = "Article - read more";
    InternalNavigationScope["ARTICLE_SHOW_ALL"] = "Article - show all";
    InternalNavigationScope["ARTICLE_PRODUCT_CARD"] = "Article - product card";
    InternalNavigationScope["ARTICLE_PAGE_GO_TO"] = "Article-page - go to";
    InternalNavigationScope["AUTHORIZED_DEALER"] = "Authorized dealer";
    InternalNavigationScope["ANNOUNCEMENT_BANNER"] = "Announcement banner";
    InternalNavigationScope["BANNER"] = "Banner";
    InternalNavigationScope["BRAND_CARD"] = "Brand - card";
    InternalNavigationScope["BRAND_CATEGORY_CARD"] = "Brand - category card";
    InternalNavigationScope["BRAND_CATEGORY_TREE"] = "Brand - category tree";
    InternalNavigationScope["BRAND_PRODUCT_CARD"] = "Brand - product card";
    InternalNavigationScope["BREADCRUMB"] = "Breadcrumb";
    InternalNavigationScope["CALL_TO_ACTION"] = "Call to action";
    InternalNavigationScope["CAMPAIGN_GO_TO"] = "Campaign - go to";
    InternalNavigationScope["CAMPAIGN_HEADER"] = "Campaign - header";
    InternalNavigationScope["CAMPAIGN_PRODUCT_CARD"] = "Campaign - product card";
    InternalNavigationScope["CAMPAIGN_SHOW_ALL"] = "Campaign - show all";
    InternalNavigationScope["CATEGORY_CARD"] = "Category - card";
    InternalNavigationScope["CATEGORY_INDEX_LINK"] = "Category index - link";
    InternalNavigationScope["CATEGORY_LIST_SUB_LVL"] = "Category list - sub level";
    InternalNavigationScope["CATEGORY_LIST_TOP_LVL"] = "Category list - top level";
    InternalNavigationScope["COMPACT_LIST_LAYOUT_PRODUCT_CARD"] = "Compact list layout - product card";
    InternalNavigationScope["COMPARE_PRODUCTS_PRODUCT_HEADER"] = "Compare products - product header";
    InternalNavigationScope["COMPARE_PRODUCTS_PRODUCT_IMAGE"] = "Compare products - product image";
    InternalNavigationScope["EXPERT_ADVISE_SHOW_ALL"] = "Expert advise - show all";
    InternalNavigationScope["EXPERT_ALL_CATEGORIES"] = "Expert - all categories";
    InternalNavigationScope["EXPERT_CATEGORIES"] = "Expert - categories";
    InternalNavigationScope["EXPERT_CATEGORY_AREA"] = "Expert - category area";
    InternalNavigationScope["EXPERT_PROFILE_GO_TO"] = "Expert profile - go to";
    InternalNavigationScope["EXPERT_INDEPENDENT_GUARANTEE"] = "Expert - independent guarantee";
    InternalNavigationScope["EXPERT_LIST_PROFILE_GO_TO"] = "Expert list profile - go to";
    InternalNavigationScope["EXPERT_LIST_EXPERT_PAGE_GO_TO"] = "Expert list expert-page - go to";
    InternalNavigationScope["EXPERT_ALSO_IN_CATEGORIES"] = "Expert - also in categories";
    InternalNavigationScope["EXPERT_PAGE_GO_TO"] = "Expert-page - go to";
    InternalNavigationScope["EXPERT_PROMO"] = "Expert - promo";
    InternalNavigationScope["EXPERT_RECOMMEND_PRODUCTS"] = "Expert - recommend products";
    InternalNavigationScope["EXPERT_SEARCH_RESULT_CATEGORY_GO_TO"] = "Expert search result - category go to";
    InternalNavigationScope["EXPERT_SEARCH_RESULT_PRODUCT_TEST_GO_TO"] = "Expert search result - product-test go to";
    InternalNavigationScope["EXPERT_SEARCH_RESULT_TOPLIST_GO_TO"] = "Expert search result - toplist go to";
    InternalNavigationScope["EXPERT_SHOW_ALL_IN_CATEGORY"] = "Expert - show all in category";
    InternalNavigationScope["EXPERT_TOP_LIST"] = "Expert - top list";
    InternalNavigationScope["EXPERT_GUIDE_PAGE_GO_TO"] = "Expert guide - go to";
    InternalNavigationScope["POPULAR_PRODUCTS_LANDINGPAGE_PRODUCT_CARD"] = "Popular products start page - product card";
    InternalNavigationScope["POPULAR_PRODUCTS_LANDINGPAGE_HEADER"] = "Popular products start page - header";
    InternalNavigationScope["FEATURED_CATEGORY_ARTICLE"] = "Featured category article";
    InternalNavigationScope["FEATURED_PRODUCTS_PRODUCTS_CARD"] = "Featured products - product card";
    InternalNavigationScope["FEATURED_PRODUCTS_HEADER"] = "Featured products - header";
    InternalNavigationScope["FOOTER_INFO_PAGES"] = "Footer - info pages";
    InternalNavigationScope["GRID_LAYOUT_PRODUCT_CARD"] = "Grid layout - product card";
    InternalNavigationScope["GUIDE_EXPERT_TOPLIST"] = "Guide - expert toplist";
    InternalNavigationScope["GUIDE_PAGE_GO_TO"] = "Guide-page - go to";
    InternalNavigationScope["HERO_BANNER"] = "Hero banner";
    InternalNavigationScope["LIST_LAYOUT_PRODUCT_CARD"] = "List layout - product card";
    InternalNavigationScope["LOGO"] = "Logo";
    InternalNavigationScope["MEGA_MENU"] = "Mega menu";
    InternalNavigationScope["MIXED_CONTENT_CARD"] = "Mixed content card";
    InternalNavigationScope["MY_PROFILE_USER_REVIEW_CARD"] = "My profile - user review card";
    InternalNavigationScope["NAVIGATION_CAROUSEL"] = "Navigation carousel";
    InternalNavigationScope["NEWSLETTER_EMAIL_PRIVACY"] = "Newsletter - email privacy";
    InternalNavigationScope["NEW_PRODUCT_RELEASES_PRODUCT_CARD"] = "New Product releases - product card";
    InternalNavigationScope["NEW_PRODUCT_RELEASES_HEADER"] = "New Product releases - header";
    InternalNavigationScope["OTHER_PRODUCTS_PRODUCT_CARD"] = "Other popular products - product card";
    InternalNavigationScope["OTHER_VISITED_PRODUCTS_PRODUCT_CARD"] = "Other visited - product card";
    InternalNavigationScope["PERSONALIZED_RECOMMENDATIONS_PRODUCT_CARD"] = "Personalized recommendations - product card";
    InternalNavigationScope["PERSONALIZED_RECOMMENDATIONS_HEADER"] = "Personalized recommendations - header";
    InternalNavigationScope["PRODUCT_INFORMATION"] = "Product information";
    InternalNavigationScope["POPULAR_FACETS_HEADER"] = "Popular facets - header";
    InternalNavigationScope["POPULAR_FACETS_PRODUCT_CARD"] = "Popular facets - product card";
    InternalNavigationScope["POPULAR_PRODUCTS_HEADER"] = "Popular products - header";
    InternalNavigationScope["POPULAR_PRODUCTS_SHOW_ALL"] = "Popular products - show all";
    InternalNavigationScope["POPULAR_PRODUCTS_PRODUCT_CARD"] = "Popular products - product card";
    InternalNavigationScope["PRODUCT_LISTING_PRODUCT_CARD_CATEGORY_LINK"] = "Product listing - product card go to category link";
    InternalNavigationScope["PRODUCT_COLLECTION_SITEMAP_LINK"] = "Product-collection sitemap - link";
    InternalNavigationScope["PRODUCT_PRODUCT_HEADER"] = "Product - product header";
    InternalNavigationScope["PRODUCT_RELATIONS"] = "Product - product relations";
    InternalNavigationScope["PRODUCT_PRICE_HISTORY"] = "Product - Price History";
    InternalNavigationScope["PRODUCT_TEST_PAGE_GO_TO"] = "Product-test-page - go to";
    InternalNavigationScope["PRODUCT_TEST_SIDEBAR_FIND_BEST_PRICE"] = "Product-test - sidebar find best price";
    InternalNavigationScope["PRODUCT_TEST_SIDEBAR_PRODUCT_CARD"] = "Product-test - sidebar product card";
    InternalNavigationScope["PRODUCT_TEST_SIDEBAR_RANK_IN_CATEGORY"] = "Product-test - sidebar rank in category";
    InternalNavigationScope["PRODUCT_HEADER"] = "Product header";
    InternalNavigationScope["PROMOTION_MODAL"] = "Promotion - promotion modal";
    InternalNavigationScope["PROMOTION_CARD_SHOP"] = "Promotion - shop promotion card";
    InternalNavigationScope["PROMOTION_CARD_BRAND"] = "Promotion - brand promotion card";
    InternalNavigationScope["PROMOTION_PRODUCT"] = "Promotion products - product card";
    InternalNavigationScope["PRODUCT_COMPARISON"] = "Product page - product comparison";
    InternalNavigationScope["RECENTLY_VISITED_PRODUCT_CARD"] = "Recently visited - product card";
    InternalNavigationScope["RECENTLY_VISITED_PRODUCT_COLLECTION_CARD"] = "Recently visited - product collection card";
    InternalNavigationScope["REVIEW_READ_ALL"] = "Review - read all";
    InternalNavigationScope["REVIEW_USER_CARD"] = "Review - user card";
    InternalNavigationScope["RATE_SHOP_GO_TO"] = "Rate shop - go to";
    InternalNavigationScope["RELATED_ARTICLE"] = "Related article";
    InternalNavigationScope["SECONDARY_NAVIGATION"] = "Secondary navigation";
    InternalNavigationScope["STORE_AWARD_CARD"] = "Store - award card";
    InternalNavigationScope["STORE_CARD"] = "Store - card";
    InternalNavigationScope["STORE_GO_TO"] = "Store - go to";
    InternalNavigationScope["STORE_REVIEW"] = "Store - review";
    InternalNavigationScope["STORE_PROMOTIONS"] = "Store - promotions";
    InternalNavigationScope["SPONSORED_PRODUCT_CARD"] = "Sponsored product card";
    InternalNavigationScope["TABLE_LAYOUT_PRODUCT_CARD"] = "Table layout - product card";
    InternalNavigationScope["TAB_BAR"] = "Tab bar";
    InternalNavigationScope["TOPLIST_COMPARE_PRODUCTS"] = "Toplist - compare products";
    InternalNavigationScope["TOPLIST_MORE_FROM_EXPERT"] = "Toplist - More from expert";
    InternalNavigationScope["TOPLIST_MORE_REVIEWS_FOR_CATEGORY"] = "Toplist - More reviews for category";
    InternalNavigationScope["TOPLIST_PAGE_GO_TO"] = "Toplist-page - go to";
    InternalNavigationScope["TOPLIST_PAGE_HEADLINE_GO_TO"] = "Toplist-page headline - go to";
    InternalNavigationScope["TOPLIST_PRODUCT_IN_TOPLIST"] = "Toplist - Product in toplist";
    InternalNavigationScope["TOPLIST_PRODUCT_TEST"] = "Toplist - product test";
    InternalNavigationScope["TRENDING_PRODUCTS"] = "Trending products";
    InternalNavigationScope["USED_PRODUCT"] = "Used products - product card";
    InternalNavigationScope["QUICK_SEARCH"] = "Quick search - search button";
    InternalNavigationScope["QUICK_SEARCH_CATEGORY"] = "Quick search - Category";
    InternalNavigationScope["QUICK_SEARCH_LATEST_SEARCHES"] = "Quick search - Latest searches";
    InternalNavigationScope["QUICK_SEARCH_PRODUCT"] = "Quick search - Product";
    InternalNavigationScope["QUICK_SEARCH_STORE"] = "Quick search - Store";
    InternalNavigationScope["QUICK_SEARCH_SEARCH_SUGGESTIONS"] = "Quick search - Search suggestions";
    InternalNavigationScope["QUICK_SEARCH_SUGGESTION"] = "Quick search - Suggestion";
    InternalNavigationScope["SEARCH_SUGGESTION"] = "Search - Suggestion";
    InternalNavigationScope["SEARCH_RESULT_PAGE_INTERNAL_ANCHOR"] = "Search result page - internal anchor";
    InternalNavigationScope["PRODUCT_GRID_ARTICLE"] = "Product - Grid article";
    InternalNavigationScope["WORD_CLOUD"] = "Word cloud";
})(InternalNavigationScope || (InternalNavigationScope = {}));


/***/ }),

/***/ 56525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ useCampaigns)
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);


var useCampaigns = function() {
    var allCampaigns = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.globals.campaignsV2;
    }).allCampaigns;
    var activeCampaigns = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return allCampaigns.filter(function(param) {
            var active = param.active;
            return active;
        });
    }, [
        allCampaigns
    ]);
    var announcementBanner = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return findAnnouncementBanner(activeCampaigns.slice().reverse());
    }, [
        activeCampaigns
    ]);
    var startPageBanners = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            top: findBanner(activeCampaigns.slice().reverse(), "startPageTopBanner"),
            middle: findBanner(activeCampaigns.slice().reverse(), "startPageMiddleBanner"),
            bottom: findBanner(activeCampaigns.slice().reverse(), "startPageBottomBanner")
        };
    }, [
        activeCampaigns
    ]);
    return {
        allCampaigns: allCampaigns,
        activeCampaigns: activeCampaigns,
        announcementBanner: announcementBanner,
        startPageBanners: startPageBanners
    };
};
var findAnnouncementBanner = function(campaigns) {
    var ref;
    return ((ref = campaigns.find(function(campaign) {
        var ref;
        return ((ref = campaign.announcementBanner) === null || ref === void 0 ? void 0 : ref.text) !== null;
    })) === null || ref === void 0 ? void 0 : ref.announcementBanner) || null;
};
var findBanner = function(campaigns, bannerType) {
    var ref;
    return ((ref = campaigns.find(function(campaign) {
        return (campaign === null || campaign === void 0 ? void 0 : campaign[bannerType]).length;
    })) === null || ref === void 0 ? void 0 : ref[bannerType]) || [];
};


/***/ }),

/***/ 32495:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ useResizeObserver)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function useResizeObserver() {
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), width = ref[0], setWidth = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), height = ref1[0], setHeight = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), contentRect = ref2[0], setContentRect = ref2[1];
    // Use a state entry for the observed node in order to update when the node changes. The state
    // setter can be directly reused as a callback ref.
    // https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), node = ref3[0], ref4 = ref3[1];
    // Init the ResizeObserver on mount and use the same instance throughout the hook's lifetime
    var observerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (observerRef.current) {
            return;
        }
        if (observerRef.current || !("ResizeObserver" in window)) {
            return;
        }
        observerRef.current = new ResizeObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    var contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
                    var ref;
                    setWidth((ref = contentBoxSize === null || contentBoxSize === void 0 ? void 0 : contentBoxSize.inlineSize) !== null && ref !== void 0 ? ref : entry.contentRect.width);
                    var ref1;
                    setHeight((ref1 = contentBoxSize === null || contentBoxSize === void 0 ? void 0 : contentBoxSize.blockSize) !== null && ref1 !== void 0 ? ref1 : entry.contentRect.height);
                    setContentRect(entry.contentRect);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    }, []);
    // Update the observed nodes when the node changes
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var resizeObserver = observerRef.current;
        if (!resizeObserver || !_instanceof(node, Element)) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return function() {};
        }
        resizeObserver.observe(node);
        return function() {
            return resizeObserver.unobserve(node);
        };
    }, [
        node
    ]);
    return {
        width: width,
        height: height,
        ref: ref4,
        node: node,
        contentRect: contentRect
    };
}


/***/ }),

/***/ 53082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": () => (/* binding */ useAccount)
});

// EXTERNAL MODULE: ./packages/prisjakt-account-react/dist/index.js
var dist = __webpack_require__(71447);
;// CONCATENATED MODULE: ./src/hooks/use-prisjakt-account.ts

// Used for tests.
var dummyAccount = {
    session: undefined,
    login: function() {
        return undefined;
    },
    logout: function() {
        return undefined;
    },
    refreshSession: function() {
        return Promise.resolve();
    },
    hasSessionInitiated: true,
    profilePageUrl: function() {
        return "";
    }
};
var usePrisjaktAccount = function() {
    try {
        return (0,dist.useAccount)();
    } catch (e) {
        return dummyAccount;
    }
};


;// CONCATENATED MODULE: ./src/hooks/use-account.ts

function useAccount() {
    return usePrisjaktAccount();
}


/***/ }),

/***/ 19265:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useFeedback)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var src_areas_feedback_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18969);
/* harmony import */ var src_contexts_userlike_chat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55803);




var openFeedback = src_areas_feedback_actions__WEBPACK_IMPORTED_MODULE_2__/* ["default"].open */ .ZP.open;
var useFeedback = function() {
    var ref = (0,src_contexts_userlike_chat__WEBPACK_IMPORTED_MODULE_3__/* .useUserlikeChatContext */ .hy)(), isActive = ref.isActive, openMessenger = ref.openMessenger;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var loadFeedback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        // If Userlike chat is not loaded, open standard feedback modal
        if (isActive) {
            openMessenger();
        } else {
            dispatch(openFeedback());
        }
    }, [
        dispatch,
        isActive,
        openMessenger
    ]);
    return {
        loadFeedback: loadFeedback
    };
};


/***/ }),

/***/ 659:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ useGqlMutation)
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93561);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var src_client_gql_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9684);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function useGqlMutation(options) {
    var mutation = options.mutation, _ = options.variables, useMutationOptions = _objectWithoutProperties(options, [
        "mutation",
        "variables"
    ]);
    var activeCampaign = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.globals.campaigns.active.find(function(c) {
            return c.type === "OFFER";
        });
    });
    var variables = _objectSpreadProps(_objectSpread({}, options.variables), {
        campaignId: activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.id
    });
    var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(_objectSpread({
        mutationFn: function() {
            return src_client_gql_client__WEBPACK_IMPORTED_MODULE_2__/* .gqlClient.request */ .N.request(mutation, variables);
        }
    }, useMutationOptions));
    return result;
}


/***/ }),

/***/ 27019:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ useGqlQuery)
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93561);
/* harmony import */ var src_client_gql_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9684);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function useGqlQuery(options) {
    var queryKey = options.queryKey, query = options.query, _variables = options.variables, variables = _variables === void 0 ? {} : _variables, rest = _objectWithoutProperties(options, [
        "queryKey",
        "query",
        "variables"
    ]);
    var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)(_objectSpreadProps(_objectSpread({}, rest), {
        queryKey: options.queryKey.concat([
            variables
        ]),
        queryFn: function() {
            return src_client_gql_client__WEBPACK_IMPORTED_MODULE_1__/* .gqlClient.request */ .N.request(query, variables);
        },
        enabled: options.enabled
    }));
    return result;
}


/***/ }),

/***/ 73426:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ useIsAuthenticated)
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24828);

var useIsAuthenticated = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.areas.account.isAuthenticated;
    });
};


/***/ }),

/***/ 92317:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ useLocalStorage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var useLocalStorage = function(key, initialValue) {
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        try {
            // Get from local storage by key
            var item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // If error also return initialValue
            return initialValue;
        }
    }), 2), storedValue = ref[0], setStoredValue = ref[1];
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    var setValue = function(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = _instanceof(value, Function) ? value(storedValue) : value;
            // Save state
            setStoredValue(value);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
        // A more advanced implementation would handle the error case
        }
    };
    return [
        storedValue,
        setValue
    ];
};


/***/ }),

/***/ 42281:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ useMatchedRoute)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25349);
/* harmony import */ var src_components_experiment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43088);
/* harmony import */ var src_routes_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6290);
/* harmony import */ var src_routes_match_route__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91097);






function useMatchedRoute() {
    var context = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .bp)();
    var market = context.market;
    var location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .useLocation */ .TH)();
    var experiments = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_experiment__WEBPACK_IMPORTED_MODULE_3__/* .ExperimentContext */ .T);
    return (0,src_routes_match_route__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        routeConfig: (0,src_routes_config__WEBPACK_IMPORTED_MODULE_4__/* .buildRouteConfig */ .v)(market.code, market.routes),
        location: location,
        marketCode: market.code,
        experiments: experiments.selectedVariants
    });
}


/***/ }),

/***/ 24567:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ usePageMetaTags)
/* harmony export */ });
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25349);
/* harmony import */ var src_hooks_use_matched_route__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42281);
/* harmony import */ var src_hooks_use_meta_tags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48283);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function usePageMetaTags(data) {
    var context = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_0__/* .useAppContext */ .bp)();
    var matchedRoute = (0,src_hooks_use_matched_route__WEBPACK_IMPORTED_MODULE_1__/* .useMatchedRoute */ .M)();
    var metaTags = {};
    if (matchedRoute && matchedRoute.metaTags) {
        metaTags = matchedRoute.metaTags(_objectSpread({
            data: data,
            routeName: matchedRoute.name
        }, matchedRoute.variables), context);
    }
    (0,src_hooks_use_meta_tags__WEBPACK_IMPORTED_MODULE_2__/* .useMetaTags */ .k)({
        metaTags: metaTags
    });
}


/***/ }),

/***/ 48458:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": () => (/* binding */ usePageQuery)
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93561);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var src_client_gql_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9684);
/* harmony import */ var src_hooks_use_page_meta_tags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24567);
/* harmony import */ var src_hooks_use_route_loaded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65560);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





function usePageQuery(options) {
    var routeName = options.routeName, query = options.query, rest = _objectWithoutProperties(options, [
        "routeName",
        "query"
    ]);
    var activeCampaign = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.globals.campaigns.active.find(function(c) {
            return c.type === "OFFER";
        });
    });
    var variables = _objectSpreadProps(_objectSpread({}, options.variables), {
        campaignId: activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.id
    });
    var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)(_objectSpread({
        queryKey: [
            routeName,
            "page",
            variables
        ],
        queryFn: function() {
            return src_client_gql_client__WEBPACK_IMPORTED_MODULE_2__/* .gqlClient.request */ .N.request(query, variables);
        },
        useErrorBoundary: true
    }, rest));
    (0,src_hooks_use_route_loaded__WEBPACK_IMPORTED_MODULE_4__/* .useRouteLoaded */ .N)(result.data, result.isFetching);
    (0,src_hooks_use_page_meta_tags__WEBPACK_IMPORTED_MODULE_3__/* .usePageMetaTags */ .p)(result.data);
    return result;
}


/***/ }),

/***/ 65560:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ useRouteLoaded)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24828);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64799);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25349);
/* harmony import */ var src_components_experiment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43088);
/* harmony import */ var src_components_location_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42028);
/* harmony import */ var src_routes_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6290);
/* harmony import */ var src_routes_match_route__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91097);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function useRouteLoaded(data, isFetching) {
    var location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useLocation */ .TH)();
    var context = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_3__/* .useAppContext */ .bp)();
    var market = context.market;
    var ref = (0,src_components_location_context__WEBPACK_IMPORTED_MODULE_5__/* .useLocationContext */ .F)(), currentLocation = ref.currentLocation, previousLocation = ref.previousLocation;
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), isNewLocation = ref1[0], setIsNewLocation = ref1[1];
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var experiments = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_experiment__WEBPACK_IMPORTED_MODULE_4__/* .ExperimentContext */ .T);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsNewLocation(true);
    }, [
        currentLocation
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref, ref1, ref2;
        if (!(window === null || window === void 0 ? void 0 : window.dataLayer) || !data || !isNewLocation || isFetching) {
            return;
        }
        var route = (0,src_routes_match_route__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            routeConfig: (0,src_routes_config__WEBPACK_IMPORTED_MODULE_6__/* .buildRouteConfig */ .v)(market.code, market.routes),
            location: location,
            marketCode: market.code,
            experiments: experiments.experiments
        });
        var ref3;
        var meta = (ref3 = route === null || route === void 0 ? void 0 : (ref = route.metaTags) === null || ref === void 0 ? void 0 : ref.call(route, _objectSpread({
            data: data,
            routeName: route.name
        }, route.variables), context)) !== null && ref3 !== void 0 ? ref3 : {};
        var routeData = {
            page: route === null || route === void 0 ? void 0 : route.name,
            meta: meta,
            section: route === null || route === void 0 ? void 0 : (ref1 = route.match) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.params) === null || ref2 === void 0 ? void 0 : ref2.section,
            previousLocation: previousLocation !== undefined ? getUrlHostPrefix() + previousLocation : undefined,
            currentLocation: currentLocation !== undefined ? getUrlHostPrefix() + currentLocation : undefined
        };
        // Since Google Tag Manager does a recursive merge of data in its data layer
        // we do a reset of our route data here to avoid merges of arrays and objects
        // when navigating between routes with the same route name
        var dataReset = {};
        Object.keys(data).forEach(function(key) {
            dataReset[key] = undefined;
        });
        window.dataLayer.push(_objectSpread({
            event: "resetRouteDataLayer"
        }, routeData, dataReset));
        window.dataLayer.push(_objectSpread({
            event: "routeLoaded"
        }, routeData, data));
        var action = {
            type: "ROUTE_LOADED",
            location: location,
            route: route,
            data: data
        };
        dispatch(action);
        setIsNewLocation(false);
    }, [
        isNewLocation,
        data,
        isFetching
    ]);
}
var getUrlHostPrefix = function() {
    return  true ? "".concat(window.location.protocol, "//").concat(window.location.host) : 0;
};


/***/ }),

/***/ 95794:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ useShowUXFeedback),
/* harmony export */   "s": () => (/* binding */ ONE_DAY)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var ONE_DAY = 86400 * 1000;
var useShowUXFeedback = function(/* A number in milliseconds that specifies how long time the feedback should be
  hidden (from timeSinceLastShown)  */ timeout, /* A number in milliseconds that specifies the last time the feedback was shown */ timeSinceLastShown) {
    var /* A number between 0 - 1 that specifies how often the feedback should appear,
  where 0 is 0% and 1 is 100%.  */ distribution = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), shouldShow = ref[0], setShouldShow = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setShouldShow(Math.random() < distribution && new Date().valueOf() - timeout > timeSinceLastShown);
    }, [
        distribution,
        timeout,
        timeSinceLastShown
    ]);
    return shouldShow;
};


/***/ }),

/***/ 6290:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": () => (/* binding */ buildRouteConfig)
});

;// CONCATENATED MODULE: ./src/components/meta-tags/article.js
var getCanonicalPath = function(article, market) {
    // Handle Black Friday 2019 featured article.
    // It is an article merged from several articles so
    // canonicals for merged articles should point on campaign page
    if (article.related.campaign && article.related.campaign.id === 2) {
        if (market.code === "se" && [
            43,
            169,
            177
        ].includes(article.id)) {
            return article.related.campaign.web_uri.responsive;
        }
        if (market.code === "no" && [
            51,
            55,
            54
        ].includes(article.id)) {
            return article.related.campaign.web_uri.responsive;
        }
        if (market.code === "gb" && [
            85,
            84,
            69
        ].includes(article.id)) {
            return article.related.campaign.web_uri.responsive;
        }
        if (market.code === "fi" && [
            20,
            17
        ].includes(article.id)) {
            return article.related.campaign.web_uri.responsive;
        }
    }
    if (article.related.campaign && article.featured) {
        // Use campaign page as canonical if article is featured
        return article.related.campaign.web_uri.responsive;
    }
    if (article.related.category && article.featured) {
        // Use category page as canonical if article is featured
        return article.related.category.pathName;
    }
    return article.pathName;
};
/* harmony default export */ function article(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    if (!data) {
        return {};
    }
    var article = data.article;
    if (!article) {
        return {};
    }
    var canonicalUrl = market.domain + getCanonicalPath(article, market);
    var articleUrl = market.domain + article.pathName;
    var openGraph = [
        {
            key: "title",
            content: article.title
        },
        {
            key: "type",
            content: "article"
        },
        {
            key: "url",
            content: articleUrl
        },
        {
            key: "image",
            content: article.imageUrl
        }
    ];
    return {
        title: t("meta", "article.page-title", {
            title: article.title
        }),
        description: article.preamble,
        canonical: canonicalUrl,
        structuredData: undefined,
        openGraph: openGraph
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/editorial-content/sanityFaq.ts
function sanityFaqPage(faqData) {
    if (!faqData) return null;
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqData.faqItems.filter(Boolean).map(function(f) {
            return faqSchema(f);
        }) || []
    };
}
function faqSchema(faq) {
    return {
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
            "@type": "Answer",
            text: plainText(faq.answer)
        }
    };
}
function plainText(faqAnswer) {
    return faqAnswer.sections.map(function(section) {
        return section.children.map(function(child) {
            return child.text;
        }).join("");
    }).join(" ");
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/product-group-schema.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function productGroupSchema(product, description, withContext) {
    return _objectSpreadProps(_objectSpread({}, withContext ? {
        "@context": "https://schema.org"
    } : {}), {
        "@type": "ProductGroup",
        name: product.name,
        description: description,
        productGroupID: product.id.toString()
    });
}

// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(65634);
;// CONCATENATED MODULE: ./src/components/meta-tags/product/constants.ts
var constants_sectionMap = {
    main: "product",
    properties: "productProperties",
    reviews: "productReviews",
    statistics: "productPriceHistory"
};
var constants_sectionClassicParam = {
    main: "p",
    properties: "e",
    reviews: "o",
    statistics: "pu"
};

;// CONCATENATED MODULE: ./src/components/meta-tags/product/utils.ts


function getRoundedCurrency(price, param) {
    var code = param.code;
    var ref;
    return parseFloat(price.toFixed((ref = currency/* MarketSettings */.Gr[code]) === null || ref === void 0 ? void 0 : ref.numberOfDecimals));
}
function formatUrl(market, section, url, id) {
    if (!market) {
        return url;
    }
    if (!section || section === "main") {
        return url;
    }
    if (/\?p=/.test(url)) {
        return url.replace("?p=".concat(id), "?".concat(sectionClassicParam[section], "=").concat(id));
    }
    if (/--p/.test(url)) {
        return "".concat(url, "/").concat(section);
    }
    return url;
}
function getLinkType(section) {
    return sectionMap[section || "main"];
}
// Must match market configs in Web App
var marketHrefLangLocale = {
    dk: "da-DK",
    fi: "fi-FI",
    fr: "fr-FR",
    gb: "en-GB",
    ie: "en-IE",
    no: "nb-NO",
    nz: "en-NZ",
    se: "sv-SE"
};
var productionBases = {
    dk: "https://prisjagt.dk",
    fi: "https://hintaopas.fi",
    fr: "https://ledenicheur.fr",
    gb: "https://pricespy.co.uk",
    ie: "https://pricespy.ie",
    no: "https://www.prisjakt.no",
    nz: "https://pricespy.co.nz",
    se: "https://www.prisjakt.nu"
};
function getHrefLang(product) {
    return product.indexableIn.map(function(market) {
        return {
            // This really hurts to write, but the current setup really doesn't like reading
            // config values (e.g. product route) from other markets. We will remove this soon(tm)
            // so do it properly in the Web App.
            locale: marketHrefLangLocale[market],
            url: "".concat(productionBases[market]).concat(market === "se" ? "/produkt.php" : "/product.php", "?p=").concat(product.id)
        };
    });
}
function getCanonical(product, market, linkTo) {
    return market.domain + linkTo("product", product);
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/aggregate-offer.ts

function aggregateOffer(pathName, initialStatistics, market) {
    var ref, ref1;
    return {
        "@type": "AggregateOffer",
        url: market.domain + pathName,
        lowPrice: getRoundedCurrency((ref = initialStatistics === null || initialStatistics === void 0 ? void 0 : initialStatistics.lowestPrice) !== null && ref !== void 0 ? ref : 0, market),
        highPrice: getRoundedCurrency((ref1 = initialStatistics === null || initialStatistics === void 0 ? void 0 : initialStatistics.highestPrice) !== null && ref1 !== void 0 ? ref1 : 0, market),
        offerCount: initialStatistics === null || initialStatistics === void 0 ? void 0 : initialStatistics.numberMainOffers,
        priceCurrency: market.currency
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/aggregate-rating.ts
function aggregateRating(product, market, t) {
    var ref, ref1, ref2;
    return {
        "@type": "AggregateRating",
        url: market.domain + product.pathName,
        ratingValue: ((ref = product.aggregatedRatingSummary) === null || ref === void 0 ? void 0 : ref.summary.rating.score) || ((ref1 = product.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.rating) || 0,
        ratingCount: ((ref2 = product.aggregatedRatingSummary) === null || ref2 === void 0 ? void 0 : ref2.summary.rating.count) || product.userReviewSummary.count || 0,
        worstRating: 0,
        bestRating: 5,
        name: t("reviews", "panel.title")
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/brand.ts
function brand(productBrand) {
    return {
        "@type": "Brand",
        name: productBrand.name
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/core-property-value.ts
function corePropertyValue(coreProperties, t) {
    var booleanStrings = {
        true: t("product", "property.boolean-yes"),
        false: t("product", "property.boolean-no")
    };
    var ref;
    return (ref = coreProperties === null || coreProperties === void 0 ? void 0 : coreProperties.nodes.filter(function(item) {
        return item.name && item.prettyTable;
    }).map(function(item) {
        return {
            "@type": "PropertyValue",
            name: item.name,
            value: item.type === "boolean" ? booleanStrings[item.prettyTable || "true"] : item.prettyTable
        };
    })) !== null && ref !== void 0 ? ref : [];
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/offer.ts

function offer(product, market) {
    return {
        "@type": "Offer",
        url: market.domain + product.pathName,
        price: getRoundedCurrency(product.priceSummary.regular, market),
        priceCurrency: market.currency
    };
}
function variantOffer(variant, market) {
    var _inclShipping;
    var price = (_inclShipping = variant.price.inclShipping) !== null && _inclShipping !== void 0 ? _inclShipping : variant.price.exclShipping;
    return {
        "@type": "Offer",
        price: getRoundedCurrency(price, market),
        priceCurrency: market.currency
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/product-schema.ts
function product_schema_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_schema_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_schema_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_schema_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_schema_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_schema_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function productSchema(product, description, withContext) {
    return product_schema_objectSpreadProps(product_schema_objectSpread({}, withContext ? {
        "@context": "https://schema.org"
    } : {}), {
        "@type": "Product",
        name: product.name,
        description: description
    });
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/rating.ts
/**
 *
 * @param val Expects a value between 0 and 10, which will then be normalized to 0 and 5.
 * @returns Rating
 */ function rating(val) {
    return {
        "@type": "Rating",
        worstRating: 0,
        bestRating: 5,
        ratingValue: val || 0
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/review.ts

function reviews(product, t) {
    return product.userReviews.nodes.filter(function(r) {
        return r !== undefined && r !== null;
    }).map(function(item) {
        return review(item, t);
    });
}
function review(item, t) {
    var ref;
    var ref1;
    // @NOTE: Do not include "reviewBody: item.reviewText," (potential XSS).
    return {
        "@type": "Review",
        datePublished: item.updatedAt || undefined,
        reviewRating: rating(item.convertedRating),
        author: {
            "@type": "Person",
            // @NOTE: This assumes display names are validated (!)
            name: (ref1 = (ref = item.user) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : t("reviews", "user.guest")
        }
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/product-structured-data.ts







function createProductStructuredData(param) {
    var product = param.product, description = param.description, withContext = param.withContext, market = param.market, t = param.t, initialStatistics = param.initialStatistics;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var structuredData = productSchema(product, description, withContext);
    if ((ref = product.media) === null || ref === void 0 ? void 0 : ref.first) {
        structuredData.image = product.media.first;
    }
    if ((ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name) {
        structuredData.brand = brand(product.brand);
    }
    if ((product === null || product === void 0 ? void 0 : (ref2 = product.aggregatedRatingSummary) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.summary) === null || ref3 === void 0 ? void 0 : ref3.rating.score) && (product === null || product === void 0 ? void 0 : (ref4 = product.aggregatedRatingSummary) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.summary) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.rating) === null || ref6 === void 0 ? void 0 : ref6.count) || (product === null || product === void 0 ? void 0 : (ref7 = product.userReviewSummary) === null || ref7 === void 0 ? void 0 : ref7.rating) && (product === null || product === void 0 ? void 0 : (ref8 = product.userReviewSummary) === null || ref8 === void 0 ? void 0 : ref8.count)) {
        structuredData.aggregateRating = aggregateRating(product, market, t);
    }
    var aggregateOffers = aggregateOffer(product.pathName, initialStatistics !== null && initialStatistics !== void 0 ? initialStatistics : null, market);
    if (aggregateOffers.offerCount && typeof aggregateOffers.offerCount === "number" && aggregateOffers.offerCount > 0) {
        structuredData.offers = aggregateOffers;
    } else if (product.priceSummary && product.priceSummary.regular) {
        structuredData.offers = offer(product, market);
    }
    if (product.userReviews) {
        structuredData.review = reviews(product, t);
    }
    if (product.releaseDate) {
        structuredData.releaseDate = product.releaseDate;
    }
    if ((ref9 = product.coreProperties) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.nodes) === null || ref10 === void 0 ? void 0 : ref10.length) {
        structuredData.additionalProperty = corePropertyValue(product.coreProperties, t);
    }
    return structuredData;
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/product-group-structured-data.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function product_group_structured_data_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_group_structured_data_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_group_structured_data_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_group_structured_data_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_group_structured_data_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_group_structured_data_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



function createProductGroupStructuredData(options) {
    var product = options.product, description = options.description, market = options.market, withContext = options.withContext;
    var productGroupStructuredData = productGroupSchema(product, description, withContext);
    var _variants;
    var priceVariants = mergeVariantToProductPrices(product, (_variants = product.variants) !== null && _variants !== void 0 ? _variants : []);
    var _variants1;
    return product_group_structured_data_objectSpreadProps(product_group_structured_data_objectSpread({}, productGroupStructuredData), {
        url: market.domain + product.pathName,
        variesBy: createVariesBy((_variants1 = product.variants) !== null && _variants1 !== void 0 ? _variants1 : []),
        hasVariant: createVariants(priceVariants, options)
    });
}
function createVariesBy(variants) {
    var variesBy = variants.flatMap(function(item) {
        return item.attributes.map(function(attribute) {
            return "https://schema.org/".concat(attribute.type.toLowerCase());
        });
    });
    return _toConsumableArray(new Set(variesBy));
}
function createVariantAttributes(attributes) {
    return attributes.reduce(function(acc, item) {
        acc[item.type.toLowerCase()] = item.value;
        return acc;
    }, {});
}
function mergeVariantWithPrice(alternativePrice, variants) {
    var variant = variants.find(function(productVariant) {
        return productVariant.id.toString() === (alternativePrice === null || alternativePrice === void 0 ? void 0 : alternativePrice.variantId);
    });
    return product_group_structured_data_objectSpreadProps(product_group_structured_data_objectSpread({}, alternativePrice), {
        variant: variant
    });
}
function mergeVariantToProductPrices(product, variants) {
    var ref;
    if (!((ref = product.prices) === null || ref === void 0 ? void 0 : ref.nodes)) {
        return [];
    }
    return product.prices.nodes.flatMap(function(price) {
        if (!(price === null || price === void 0 ? void 0 : price.alternativePrices)) {
            return [];
        }
        return price.alternativePrices.filter(function(alternativePrice) {
            return (alternativePrice === null || alternativePrice === void 0 ? void 0 : alternativePrice.variantId) !== null;
        }).map(function(alternativePrice) {
            return mergeVariantWithPrice(alternativePrice, variants);
        });
    });
}
function createVariants(priceVariants, productOptions) {
    return priceVariants.map(function(priceVariant) {
        var ref, ref1, ref2, ref3;
        var productStructuredData = createProductStructuredData(productOptions);
        var ref4;
        return product_group_structured_data_objectSpreadProps(product_group_structured_data_objectSpread({}, productStructuredData, createVariantAttributes((ref4 = (ref = priceVariant.variant) === null || ref === void 0 ? void 0 : ref.attributes) !== null && ref4 !== void 0 ? ref4 : [])), {
            name: (ref1 = priceVariant.variant) === null || ref1 === void 0 ? void 0 : ref1.name,
            offers: variantOffer(priceVariant, productOptions.market),
            gtin14: (ref2 = priceVariant.variant) === null || ref2 === void 0 ? void 0 : ref2.gtin14,
            sku: (ref3 = priceVariant.variant) === null || ref3 === void 0 ? void 0 : ref3.sku
        });
    });
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/create-structured-data.ts


function createStructuredData(options) {
    var ref;
    var product = options.product;
    var structuredData = ((ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) && !isVariantIdNull(product) ? createProductGroupStructuredData(options) : createProductStructuredData(options);
    return structuredData;
}
function isVariantIdNull(product) {
    var ref, ref1;
    return (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : ref1.every(function(price) {
        var ref;
        return price === null || price === void 0 ? void 0 : (ref = price.alternativePrices) === null || ref === void 0 ? void 0 : ref.every(function(alternativePrice) {
            return (alternativePrice === null || alternativePrice === void 0 ? void 0 : alternativePrice.variantId) === null;
        });
    });
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/open-graph.ts
function graph(product, title, description, market) {
    return [
        {
            key: "title",
            content: title
        },
        {
            key: "description",
            content: description
        },
        {
            key: "url",
            content: market.domain + product.pathName
        },
        {
            key: "type",
            content: "product"
        },
        product.priceSummary && {
            key: "amount",
            content: product.priceSummary.regular || product.priceSummary.alternative
        },
        {
            key: "currency",
            content: market.currency
        },
        product.category && {
            key: "category",
            content: product.category.name
        },
        product.media && {
            key: "image",
            content: product.media.first
        }
    ].filter(Boolean);
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/product.js




/* harmony default export */ function product(param, param1) {
    var data = param.data, market = param1.market, t = param1.t, linkTo = param1.linkTo;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    if (!data) {
        return {};
    }
    var product = data.product;
    if (!product) {
        return {};
    }
    var metadata = product.metadata;
    var options = {
        product: product,
        initialStatistics: product.initialStatistics,
        description: metadata.description,
        market: market,
        t: t,
        withContext: true
    };
    var structuredData = createStructuredData(options);
    var openGraph = graph(product, product.metadata.title, metadata.description, market);
    var hrefLang = getHrefLang(product);
    var canonical = getCanonical(product, market, linkTo);
    var faq = sanityFaqPage(product.sanityFaq);
    return {
        title: metadata.title,
        description: metadata.description,
        hasAdultContent: !!((ref = product.category) === null || ref === void 0 ? void 0 : ref.hasAdultContent),
        thumbnail: (ref1 = product.media) === null || ref1 === void 0 ? void 0 : ref1.first,
        openGraph: openGraph,
        structuredData: [
            structuredData,
            faq
        ],
        breadcrumb: (ref2 = product.category) === null || ref2 === void 0 ? void 0 : ref2.path,
        hrefLang: hrefLang,
        canonical: canonical,
        android: product.pathName,
        ios: "/product/".concat(product.id),
        noIndex: !product.indexableIn.includes(market.code),
        botify: {
            page: "product",
            category: (ref3 = product.category) === null || ref3 === void 0 ? void 0 : ref3.id,
            parentCategory: ((ref4 = product.category) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.path) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[product.category.path.length - 2]) === null || ref6 === void 0 ? void 0 : ref6.id) || null,
            mainCategory: (ref7 = product.category) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.path) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.id
        }
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/product-compare/whitelist.js
var versusCategories = [
    "103",
    "148",
    "107",
    "1427",
    "965",
    "393",
    "353",
    "1428",
    "350",
    "401",
    "1808",
    "1183",
    "1594",
    "1217",
    "1619",
    "556",
    "386",
    "1610",
    "515",
    "1827",
    "776",
    "380",
    "893",
    "879",
    "1497",
    "379",
    "2",
    "820",
    "1922",
    "1750",
    "1320",
    "2308",
    "2128",
    "335",
    "520",
    "712",
    "819",
    "1528",
    "3279",
    "576",
    "500",
    "743",
    "1543",
    "523",
    "1029",
    "2033",
    "555",
    "549",
    "513",
    "1003",
    "1147",
    "1792",
    "101",
    "974",
    "433",
    "766",
    "546",
    "1180",
    "1182",
    "1153",
    "295",
    "1526",
    "916",
    "830",
    "1701",
    "941",
    "326",
    "465",
    "1509",
    "1737",
    "532",
    "1209",
    "1637",
    "1672",
    "663",
    "553",
    "1740",
    "534",
    "542",
    "436",
    "1707",
    "1818",
    "897",
    "560",
    "834",
    "544",
    "1530",
    "559",
    "1974",
    "1723",
    "1912",
    "1046",
    "84",
    "1001",
    "1760",
    "767",
    "352",
    "1836",
    "580",
    "25",
    "1068",
    "4653",
    "570",
    "1010",
    "1466",
    "1602",
    "1077",
    "40",
    "537",
    "1976",
    "473",
    "91",
    "1636",
    "47",
    "360",
    "894",
    "1326",
    "1354",
    "358",
    "1138",
    "1834",
    "1870",
    "1978",
    "967",
    "539",
    "2022",
    "2207",
    "1838",
    "1479",
    "917",
    "528",
    "1982",
    "398",
    "24",
    "1790",
    "37",
    "2425",
    "581",
    "803",
    "1568",
    "713",
    "867",
    "727",
    "836",
    "2256",
    "2302",
    "1981",
    "1713",
    "1963",
    "1283",
    "369",
    "1110",
    "2009",
    "527",
    "1022",
    "97",
    "992",
    "990",
    "568",
    "551",
    "1807",
    "2135",
    "530",
    "514",
    "1874",
    "2005",
    "2247",
    "1145",
    "1346",
    "547",
    "584",
    "1711",
    "1520",
    "889",
    "1683",
    "1332",
    "1239",
    "840",
    "890",
    "370",
    "1027",
    "28",
    "562",
    "2110",
    "1639",
    "1238",
    "1375",
    "975",
    "1793",
    "2112",
    "2027",
    "2362",
    "1399",
    "1918",
    "439",
    "168",
    "2245",
    "1002",
    "1679",
    "1975",
    "1054",
    "363",
    "516",
    "611",
    "1624",
    "1078",
    "1722",
    "645",
    "1331",
    "1677",
    "1525",
    "391",
    "1547",
    "1376",
    "902",
    "1852",
    "1603",
    "2136",
    "1923",
    "1224",
    "2071",
    "1724",
    "1419",
    "1488",
    "1024",
    "571",
    "403",
    "1200",
    "569",
    "606",
    "997",
    "1739",
    "1390",
    "2103",
    "1426",
    "812",
    "1107",
    "1425",
    "887",
    "1789",
    "1146",
    "1869",
    "1262",
    "795",
    "1382",
    "837",
    "1266",
    "373",
    "1495",
    "1477",
    "711",
    "778",
    "565",
    "1893",
    "1087",
    "3432",
    "531",
    "554",
    "1172",
    "924",
    "455",
    "130",
    "2190",
    "1940",
    "402",
    "801",
    "3327",
    "909",
    "2303",
    "1327",
    "567",
    "3331",
    "1113",
    "1229",
    "1270",
    "1328",
    "1228",
    "1756",
    "658",
    "966",
    "3581",
    "573",
    "1924",
    "1856",
    "1282",
    "1381",
    "1088",
    "736"
];

;// CONCATENATED MODULE: ./src/components/meta-tags/product-compare/index.js
// We only want to index compare pages in these categories and only if they
// have a high rank in popularity. This logic is also reflected in
// our sitemap generator. We do this to avoid bloating our Google index
function product_compare_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_compare_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_compare_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_compare_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_compare_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_compare_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var versusProductLimit = 50;
/* harmony default export */ function product_compare(param, param1) {
    var data = param.data, linkTo = param1.linkTo, t = param1.t;
    if (!data) {
        return {
            title: t("meta", "product-compare.title-fallback"),
            noIndex: true
        };
    }
    var category = data.category, products = data.products;
    var isVersus = products && products.length === 2;
    var categoryProps = {};
    var path = linkTo("productCompare", {
        category: category,
        products: products
    });
    if (category) {
        categoryProps.thumbnail = category.logo;
        categoryProps.breadcrumb = category.path.concat([
            {
                name: t("category", "product-compare.breadcrumb"),
                pathName: path
            }
        ]);
    }
    var noIndex = true;
    var title = t("meta", "product-compare.title-fallback");
    var description = null;
    if (isVersus) {
        title = t("meta", "product-compare.versus-title", {
            name1: products[0].name,
            name2: products[1].name
        });
        description = t("meta", "product-compare.versus-description", {
            name1: products[0].name,
            name2: products[1].name
        });
        noIndex = !(category && versusCategories.indexOf(category.id) > -1 && products[0].popularity.inCategory <= versusProductLimit && products[1].popularity.inCategory <= versusProductLimit);
    } else if (category) {
        title = t("meta", "product-compare.title", {
            categoryName: category.name
        });
    }
    return product_compare_objectSpreadProps(product_compare_objectSpread({}, categoryProps), {
        noIndex: noIndex,
        title: title,
        description: description
    });
};

;// CONCATENATED MODULE: ./src/components/meta-tags/product-alert.js
/* harmony default export */ function product_alert() {
    return {
        noIndex: true
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/start.js
/* harmony default export */ function start(_, param) {
    var market = param.market, t = param.t;
    return {
        title: t("meta", "landing.title"),
        description: t("meta", "landing.description"),
        canonical: market.domain,
        openGraph: [
            {
                key: "title",
                content: t("meta", "company.name")
            },
            {
                key: "type",
                content: "website"
            },
            {
                key: "image",
                content: "".concat(market.cdn, "/g/rfe/logos/logo_v2_symbol.png")
            },
            {
                key: "url",
                content: market.domain
            }
        ],
        structuredData: {
            "@context": "http://schema.org",
            "@type": "WebSite",
            url: market.domain,
            potentialAction: {
                "@type": "SearchAction",
                target: "".concat(market.domain, "/search?query={search_term}"),
                "query-input": "required minLength=2 name=search_term"
            }
        },
        android: "/",
        ios: "/"
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
;// CONCATENATED MODULE: ./src/components/meta-tags/category.js
function category_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function category_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return category_arrayLikeToArray(arr);
}
function category_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function category_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function category_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function category_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            category_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function category_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function category_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        category_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || category_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function category_toConsumableArray(arr) {
    return category_arrayWithoutHoles(arr) || category_iterableToArray(arr) || category_unsupportedIterableToArray(arr) || category_nonIterableSpread();
}
function category_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return category_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return category_arrayLikeToArray(o, minLen);
}

var isFilterCategory = function(category) {
    return /^s/.test(category.id) || category.filterId !== null;
};
var getParentPath = function(category) {
    return category.path && category.path.length > 0 ? category.path.slice(-1).pop().pathName : category.pathName;
};
var getPopularBrands = function(products) {
    var brandsAggregation = products.reduce(function(brands, product) {
        if (!product.brand) {
            return brands;
        }
        var brand = product.brand.name;
        return Object.assign(brands, category_defineProperty({}, brand, (brands[brand] || 0) + 1));
    }, {});
    return Object.keys(brandsAggregation).sort(function(a, b) {
        return brandsAggregation[b] - brandsAggregation[a];
    });
};
var getUrlsForSEO = function(domain, path, pageInfo) {
    var currentOffset = pageInfo.offset || 0;
    var currentLimit = pageInfo.limit;
    var ref = _slicedToArray(path.split("?"), 2), pathName = ref[0], query = ref[1];
    var qs = querystring.parse(query || {});
    var prevOffset = Math.max(0, currentOffset - currentLimit);
    var prevParams = category_objectSpread({}, qs, prevOffset > 0 ? {
        offset: prevOffset
    } : {});
    var nextParams = category_objectSpreadProps(category_objectSpread({}, qs), {
        offset: currentOffset + currentLimit
    });
    var canonicalParams = category_objectSpread({}, qs, currentOffset > 0 && {
        offset: currentOffset
    });
    var sortedCanonicalQuery = Object.keys(canonicalParams).sort().reduce(function(q, key) {
        return category_objectSpreadProps(category_objectSpread({}, q), category_defineProperty({}, key, canonicalParams[key]));
    }, {});
    return {
        prev: domain + pathName + (Object.keys(prevParams).length > 0 ? "?".concat(querystring.encode(prevParams)) : ""),
        next: domain + pathName + (Object.keys(nextParams).length > 0 ? "?".concat(querystring.encode(nextParams)) : ""),
        canonical: domain + pathName + (Object.keys(sortedCanonicalQuery).length > 0 ? "?".concat(querystring.encode(sortedCanonicalQuery)) : "")
    };
};
var addBrandToCategoryUrl = function(category, url) {
    if (!category.brand) {
        return url;
    }
    if (/[?&]k=/.test(url)) {
        return "".concat(url, "&t=").concat(category.brand.id);
    }
    if (/--c/.test(url)) {
        var separator = url.indexOf("?") === -1 ? "?" : "&";
        return "".concat(url).concat(separator, "brand=").concat(category.brand.id);
    }
    return url;
};
/* harmony default export */ function category(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    var ref, ref1;
    if (!data) {
        return {};
    }
    if (((ref = data.categoryTree) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id) === "v1004") {
        var ref2;
        // Meta tags for services page
        var tags = {
            title: t("meta", "landing.title"),
            description: t("meta", "landing.description"),
            canonical: market.domain,
            openGraph: []
        };
        return category_objectSpreadProps(category_objectSpread({}, tags), {
            openGraph: [
                {
                    key: "title",
                    content: t("meta", "company.name")
                },
                {
                    key: "type",
                    content: "website"
                },
                ((ref2 = data.categoryTree) === null || ref2 === void 0 ? void 0 : ref2[0]) && {
                    key: "image",
                    content: data.categoryTree[0].logo
                },
                {
                    key: "url",
                    content: market.domain
                }
            ].filter(Boolean)
        });
    }
    var category = data.category;
    if (!category) {
        return {};
    }
    var meta = {
        data: category.name,
        name: category.name
    };
    var categoryNames = [
        category.name
    ].concat(category_toConsumableArray(category.categories ? category.categories.nodes.map(function(c) {
        return c.name;
    }).slice(0, 3) : [])).join(", ");
    var productCount = category.productCount;
    var popularBrands = getPopularBrands(category.products.nodes).slice(0, 3).join(", ");
    var description = t("meta", "category.description", {
        categoryNames: categoryNames,
        productCount: productCount,
        popularBrands: popularBrands
    });
    var openGraph = [
        {
            key: "title",
            content: t("meta", "category.og-title", {
                name: category.name
            })
        },
        {
            key: "url",
            content: market.domain + category.pathName
        },
        {
            key: "desc",
            content: description
        },
        {
            key: "type",
            content: "product.group"
        },
        {
            key: "image",
            content: category.logo
        }
    ];
    var isFilter = isFilterCategory(category);
    var path = isFilter ? getParentPath(category) : category.pathName;
    // Will only use these values if its not a filtered result and we are viewing the leaf node in the category tree
    var ref3 = !isFilter && category.immediateProducts ? getUrlsForSEO(market.domain, path, category.products.pageInfo) : {}, prev = ref3.prev, canonical = ref3.canonical, next = ref3.next;
    // Trying to prevent indexation of empty category pages with huge offsets
    var noIndex = category.immediateProducts && category.products.pageInfo.offset > 0 && !category.products.nodes.length;
    return {
        canonical: canonical || market.domain + path,
        next: category.products.pageInfo.hasNext && next,
        prev: category.products.pageInfo.hasPrevious && prev,
        thumbnail: category.logo,
        hasAdultContent: category.hasAdultContent,
        description: description,
        title: t("meta", "category.title", meta),
        openGraph: openGraph,
        breadcrumb: category.path,
        structuredData: [
            {
                "@context": "http://schema.org",
                "@type": "Thing",
                name: category.name,
                description: description,
                image: category.logo,
                url: market.domain + category.pathName
            }
        ],
        android: category.pathName,
        ios: "/category/".concat(category.id),
        botify: {
            page: "category",
            category: category.id,
            parentCategory: category.path && category.path[category.path.length - 2] ? category.path[category.path.length - 2].id : null,
            mainCategory: category.path && category.path.length > 0 && category.path[0].id
        },
        noIndex: noIndex
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/store.js
/* harmony default export */ function store(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    if (!data) {
        return {};
    }
    var store = data.store;
    if (!store) {
        return {};
    }
    var url = market.domain + store.pathName;
    var meta = {
        name: store.name
    };
    var structuredData = {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: store.name,
        url: url
    };
    // Only add ratings if there is a set rating value
    if (store.userReviewSummary.count && store.userReviewSummary.rating) {
        structuredData.aggregateRating = {
            "@type": "AggregateRating",
            ratingValue: store.userReviewSummary.rating,
            url: url,
            ratingCount: store.userReviewSummary.count,
            worstRating: 0,
            bestRating: 5,
            name: t("reviews", "panel.title")
        };
        // Add the reviews
        // @NOTE: Do not include "reviewBody: item.reviewText," (potential XSS).
        structuredData.review = store.userReviews && store.userReviews.nodes ? store.userReviews.nodes.map(function(item) {
            return {
                "@type": "Review",
                datePublished: item.updatedAt,
                reviewRating: {
                    "@type": "Rating",
                    worstRating: 0,
                    bestRating: 5,
                    ratingValue: parseFloat((item.rating / 2).toFixed(1))
                },
                author: {
                    "@type": "Person",
                    // @NOTE: This assumes display names are validated (!)
                    name: item.user ? item.user.name : t("reviews", "user.guest")
                }
            };
        }) : [];
    }
    // TODO: Less hacky solution
    var storeLogoUrl = "".concat(market.imageCdnUrl, "image/store/").concat(store.id, ".png?w=88");
    var openGraph = [
        {
            key: "title",
            content: t("meta", "store.og-title", {
                name: store.name
            })
        },
        {
            key: "url",
            content: market.domain + store.pathName
        },
        {
            key: "type",
            content: "company"
        },
        {
            key: "image",
            content: storeLogoUrl
        }
    ];
    return {
        title: t("meta", "store.title", meta),
        description: t("meta", "store.description", meta),
        thumbnail: storeLogoUrl,
        canonical: market.domain + store.pathName,
        structuredData: structuredData,
        openGraph: openGraph,
        android: store.pathName,
        ios: "/store/".concat(store.id)
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/campaign.js
/* harmony default export */ function campaign(param, param1) {
    var data = param.data, t = param1.t;
    if (!data) {
        return {};
    }
    var campaign = data.campaign;
    var title = campaign ? campaign.facetted.seoTitle : t("campaigns", "themes.title");
    var description = campaign ? campaign.facetted.seoDescription : t("campaigns", "themes.description");
    var campaignLogoBanner = campaign && campaign.banners && campaign.banners.length > 0 ? campaign.banners.find(function(item) {
        return item.type.toUpperCase() === "BANNER_LOGO_BIG";
    }) : undefined;
    var campaignImage = campaignLogoBanner ? campaignLogoBanner.imageUrl : undefined;
    var canonical = campaign ? campaign.facetted.canonical : undefined;
    var openGraph = campaign && [
        {
            key: "title",
            content: title
        },
        {
            key: "description",
            content: description
        },
        {
            key: "url",
            content: canonical
        },
        campaignImage && {
            key: "image",
            content: campaignImage
        },
        {
            key: "type",
            content: "website"
        }
    ];
    var structuredData = [];
    if (campaign) {
        var structuredDataCampaign = {
            "@context": "http://schema.org",
            "@type": "Thing",
            name: title,
            description: campaign.description.page,
            url: canonical
        };
        if (campaignImage) {
            structuredDataCampaign.image = campaignImage;
        }
        structuredData = [
            structuredDataCampaign
        ];
    }
    return {
        title: title,
        description: description,
        canonical: canonical,
        openGraph: openGraph,
        structuredData: structuredData
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/info-page.ts
/* harmony default export */ function info_page(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    var domain = market.domain;
    var ref = (data === null || data === void 0 ? void 0 : data.page) || {}, title = ref.title, pathName = ref.pathName;
    var canonical = domain && pathName ? new URL(pathName, domain).toString() : undefined;
    return {
        title: title ? t("meta", "info.page-title", {
            title: title
        }) : undefined,
        description: t("meta", "info.description"),
        canonical: canonical,
        openGraph: []
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/brand.js
/* harmony default export */ function meta_tags_brand(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    if (!data) {
        return {};
    }
    var brand = data.brand;
    if (!brand) {
        return {};
    }
    var meta = {
        name: brand.name,
        productCount: brand.productsTotal
    };
    var openGraph = [
        {
            key: "title",
            content: brand.name
        },
        {
            key: "type",
            content: "company"
        },
        {
            key: "image",
            content: brand.logo
        }
    ];
    return {
        canonical: market.domain + brand.pathName,
        thumbnail: brand.logo,
        description: t("meta", "brand.description", meta),
        title: t("meta", "brand.title", meta),
        openGraph: openGraph,
        structuredData: undefined,
        noIndex: !brand.productsTotal
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/login.js
/* harmony default export */ function login(props, param) {
    var t = param.t;
    return {
        title: t("meta", "login.title")
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/shop-of-the-year-landing-page.js
/* harmony default export */ function shop_of_the_year_landing_page(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    if (!data) {
        return {};
    }
    var year = data.shopOfTheYear ? data.shopOfTheYear.year : "";
    var cdnDir = "".concat(market.cdn, "/g/store_of_the_year/").concat(year, "/").concat(market.code);
    var badgeURI = "".concat(cdnDir, "/award/main_award.png");
    var openGraph = [
        {
            key: "title",
            content: t("campaigns", "shop-of-the-year.meta-title", {
                year: year
            })
        },
        {
            key: "type",
            content: "website"
        },
        {
            key: "image",
            content: badgeURI
        }
    ];
    return {
        thumbnail: badgeURI,
        description: t("campaigns", "shop-of-the-year.active-header-description", {
            year: year
        }),
        title: t("campaigns", "shop-of-the-year.title"),
        openGraph: openGraph,
        structuredData: undefined
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/shop-of-the-year-category.js
/* harmony default export */ function shop_of_the_year_category(param, param1) {
    var data = param.data, t = param1.t;
    if (!data) {
        return {};
    }
    var category = data.shopOfTheYearCategory;
    var sotyTitle = t("campaigns", "shop-of-the-year.title");
    var categoryTitle = t("campaigns", "shop-of-the-year.category-title", {
        category: category.name
    });
    var pageTitle = "".concat(sotyTitle, " - ").concat(categoryTitle);
    var openGraph = [
        {
            key: "title",
            content: pageTitle
        },
        {
            key: "type",
            content: "website"
        }
    ];
    return {
        title: pageTitle,
        openGraph: openGraph,
        structuredData: undefined
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/shop-of-the-year-winners.js
/* harmony default export */ function shop_of_the_year_winners(param, param1) {
    var data = param.data, market = param1.market, t = param1.t, linkTo = param1.linkTo;
    if (!data) {
        return {};
    }
    var year = data.shopOfTheYear ? data.shopOfTheYear.year : "";
    var cdnDir = "".concat(market.cdn, "/g/store_of_the_year/").concat(year, "/").concat(market.code);
    var badgeURI = "".concat(cdnDir, "/award/main_award.png");
    var openGraph = [
        {
            key: "title",
            content: t("campaigns", "shop-of-the-year.winners-page-title", {
                year: year
            })
        },
        {
            key: "type",
            content: "website"
        },
        {
            key: "image",
            content: badgeURI
        }
    ];
    return {
        canonical: "".concat(market.domain, "/").concat(linkTo("shopOfTheYearWinners", {
            year: year
        })),
        thumbnail: badgeURI,
        description: t("campaigns", "shop-of-the-year.winners-description", {
            year: year
        }),
        title: t("campaigns", "shop-of-the-year.winners-page-title", {
            year: year
        }),
        openGraph: openGraph,
        structuredData: undefined
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/shop-of-the-year.js


/* harmony default export */ function shop_of_the_year(props, context) {
    if (!props.data) {
        return {};
    }
    if (props.data.shopOfTheYear) {
        return shop_of_the_year_landing_page(props, context);
    }
    return shop_of_the_year_winners(props, context);
};

;// CONCATENATED MODULE: ./src/components/meta-tags/promotion-products.ts
/* harmony default export */ function promotion_products(param, param1) {
    var data = param.data, linkTo = param1.linkTo, market = param1.market, t = param1.t;
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (!(data === null || data === void 0 ? void 0 : (ref = data.promotion) === null || ref === void 0 ? void 0 : ref.id) || !(data === null || data === void 0 ? void 0 : (ref1 = data.promotion) === null || ref1 === void 0 ? void 0 : ref1.title) || !(data === null || data === void 0 ? void 0 : (ref2 = data.promotion) === null || ref2 === void 0 ? void 0 : ref2.description) || !(data === null || data === void 0 ? void 0 : (ref3 = data.promotion) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.owner) === null || ref4 === void 0 ? void 0 : ref4.name)) {
        return {};
    }
    var title = "".concat(t("meta", "site.name"), " | ").concat(data.promotion.owner.name, " | ").concat(data.promotion.title);
    var description = data.promotion.description;
    var canonical = "".concat(market.domain).concat(linkTo("promotions", {
        id: data === null || data === void 0 ? void 0 : (ref5 = data.promotion) === null || ref5 === void 0 ? void 0 : ref5.id
    }));
    return {
        noIndex: true,
        title: title,
        description: description,
        canonical: canonical
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/promotions.ts
/* harmony default export */ function promotions(_data, param) {
    var t = param.t, linkTo = param.linkTo, market = param.market;
    return {
        title: "".concat(t("meta", "site.name"), " | ").concat(t("meta", "promotions-list.title")),
        description: t("meta", "promotions-list.description"),
        canonical: "".concat(market.domain).concat(linkTo("promotions"))
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/used-products.ts
/* harmony default export */ function used_products(_data, param) {
    var t = param.t, linkTo = param.linkTo, market = param.market;
    return {
        title: "".concat(t("meta", "site.name"), " | ").concat(t("meta", "used-products.title")),
        description: t("meta", "used-products.description"),
        canonical: "".concat(market.domain).concat(linkTo("used"))
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/search.js
/* harmony default export */ function search(param, param1) {
    var data = param.data, t = param1.t;
    if (!data) {
        return {};
    }
    var search = data.newSearch || data.search;
    if (!search) {
        return {};
    }
    var meta = {
        query: search.query
    };
    return {
        noIndex: true,
        description: t("meta", "search.description", meta),
        title: t("meta", "search.title", meta)
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/generic.js
var titles = {
    login: {
        domain: "account",
        key: "login.title"
    },
    forgotPassword: {
        domain: "account",
        key: "forgot-password.title"
    },
    forgotPasswordChange: {
        domain: "account",
        key: "forgot-password-change.title"
    },
    personalization: {
        domain: "account",
        key: "personalization.headline"
    },
    settings: {
        domain: "account",
        key: "settings.title"
    },
    categoryIndex: {
        domain: "category",
        key: "category-index.categories"
    }
};
/* harmony default export */ function generic(param, param1) {
    var routeName = param.routeName, t = param1.t;
    return {
        title: titles[routeName] ? "".concat(t(titles[routeName].domain, titles[routeName].key), " | ").concat(t("meta", "site.name")) : t("meta", "landing.title")
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/product-collection.ts
function product_collection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_collection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_collection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_collection_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_collection_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_collection_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var getSlice = function(slices, type) {
    return Array.isArray(slices) ? slices.find(function(slice) {
        return slice.__typename === type;
    }) : undefined;
};
/* harmony default export */ function product_collection(param, param1) {
    var data = param.data, t = param1.t, market = param1.market;
    var ref, ref1;
    if (!data || !data.productCollection) {
        return {};
    }
    var _productCollection = data.productCollection, slices = _productCollection.slices, indexable = _productCollection.indexable, sanityFaq = _productCollection.sanityFaq;
    var metaData = getSlice(slices, "MetaDataSlice");
    var breadcrumb = getSlice(slices, "BreadcrumbsSlice");
    var productSlice = getSlice(slices, "ProductsSlice");
    if (!metaData) {
        return {};
    }
    var noIndex = (productSlice === null || productSlice === void 0 ? void 0 : (ref = productSlice.products) === null || ref === void 0 ? void 0 : ref.length) === 0 || indexable === false;
    var title = metaData.title, description = metaData.description, image = metaData.image, metaUrls = metaData.url, pagination = metaData.pagination;
    var ref2 = metaUrls || {}, current = ref2.current, next = ref2.next, prev = ref2.prev;
    var titleWithPagination = pagination && pagination.currentPage > 1 ? t("meta", "product-collection.paginated-title", product_collection_objectSpreadProps(product_collection_objectSpread({}, pagination), {
        title: title
    })) : title;
    var descriptionWithPagination = pagination && pagination.currentPage > 1 ? t("meta", "product-collection.paginated-description", product_collection_objectSpreadProps(product_collection_objectSpread({}, pagination), {
        description: description || ""
    })) : description;
    var topProducts = productSlice === null || productSlice === void 0 ? void 0 : (ref1 = productSlice.top5ProductsForMetadata) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 5);
    var structuredData = [];
    if (topProducts) {
        var itemList = {
            "@context": "https://schema.org",
            "@type": "ItemList",
            itemListElement: topProducts.map(function(topProduct, index) {
                // Merge with product from the list, so we don't have to fetch some information twice
                var product = productSlice.products.find(function(p) {
                    return p.id === topProduct.id;
                });
                var mergedProduct = product_collection_objectSpread({}, product, topProduct);
                var _initialStatistics;
                var options = {
                    product: mergedProduct,
                    initialStatistics: (_initialStatistics = mergedProduct.initialStatistics) !== null && _initialStatistics !== void 0 ? _initialStatistics : null,
                    description: mergedProduct.metadata.description,
                    market: market,
                    t: t,
                    withContext: false
                };
                return {
                    "@type": "ListItem",
                    position: index + 1,
                    item: createProductStructuredData(options)
                };
            })
        };
        structuredData.push(itemList);
    }
    if (sanityFaq) {
        structuredData.push(sanityFaqPage(sanityFaq));
    }
    return {
        title: titleWithPagination,
        description: descriptionWithPagination,
        hasAdultContent: data.productCollection.hasAdultContent,
        canonical: noIndex ? undefined : current,
        noIndex: noIndex,
        breadcrumb: breadcrumb && breadcrumb.items,
        structuredData: structuredData,
        openGraph: [
            {
                key: "title",
                content: title
            },
            {
                key: "url",
                content: current
            },
            {
                key: "desc",
                content: descriptionWithPagination
            },
            {
                key: "type",
                content: "product.group"
            },
            {
                key: "image",
                content: image
            }
        ],
        thumbnail: image,
        next: next,
        prev: prev
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/product-collection-sitemap.ts
/* harmony default export */ function product_collection_sitemap(props, param) {
    var t = param.t;
    var data = props.data;
    if (!(data === null || data === void 0 ? void 0 : data.productCollectionSitemap)) {
        return {};
    }
    var title = t("meta", "product-collection-sitemap.title", {
        title: data.productCollectionSitemap.name || ""
    });
    var description = t("meta", "product-collection-sitemap.description", {
        title: data.productCollectionSitemap.name || ""
    });
    return {
        noIndex: true,
        follow: true,
        title: title,
        description: description,
        openGraph: [
            {
                key: "title",
                content: title
            },
            {
                key: "desc",
                content: description
            },
            {
                key: "type",
                content: "website"
            }
        ]
    };
};

// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/rich-text/index.tsx + 1 modules
var rich_text = __webpack_require__(45030);
;// CONCATENATED MODULE: ./src/components/meta-tags/editorial-content/faq.ts

function faqPage(faqData) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqData.items.filter(Boolean).map(function(f) {
            return faq_faqSchema(f);
        }) || []
    };
}
function faq_faqSchema(faq) {
    return {
        "@type": "Question",
        name: (0,rich_text/* plainText */.K)(faq.question),
        acceptedAnswer: {
            "@type": "Answer",
            text: (0,rich_text/* plainText */.K)(faq.answer)
        }
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/editorial-content/editorial-content.ts
function editorial_content_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function editorial_content_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return editorial_content_arrayLikeToArray(arr);
}
function editorial_content_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function editorial_content_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function editorial_content_toConsumableArray(arr) {
    return editorial_content_arrayWithoutHoles(arr) || editorial_content_iterableToArray(arr) || editorial_content_unsupportedIterableToArray(arr) || editorial_content_nonIterableSpread();
}
function editorial_content_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return editorial_content_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return editorial_content_arrayLikeToArray(o, minLen);
}

var isPrismicSliceHeroTitle = function(value) {
    return value !== null && typeof value === "object" && "heroImage" in value;
};
var isPrismicSliceImage = function(value) {
    return value !== null && typeof value === "object" && "image" in value;
};
var getFirstTextContent = function(content) {
    var ref;
    return (ref = content.find(function(item) {
        return "text" in item;
    })) === null || ref === void 0 ? void 0 : ref.text;
};
/* harmony default export */ function editorial_content(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    var ref, ref1, ref2;
    if (!(data === null || data === void 0 ? void 0 : data.prismicArticle)) {
        return {};
    }
    var domain = market.domain;
    var _prismicArticle = data.prismicArticle, pathName = _prismicArticle.pathName, datePublished = _prismicArticle.publishedAt, dateModified = _prismicArticle.updatedAt, prismicData = _prismicArticle.data;
    var articleUrl = domain && pathName ? new URL(pathName, domain).toString() : undefined;
    var _title;
    var articleTitle = (_title = prismicData.meta.title) !== null && _title !== void 0 ? _title : getFirstTextContent(prismicData.title);
    var _description;
    var articleDescription = (_description = prismicData.meta.description) !== null && _description !== void 0 ? _description : ((ref = prismicData.metaDescription) === null || ref === void 0 ? void 0 : ref.length) ? getFirstTextContent(prismicData.metaDescription) : undefined;
    var featuredImage = (ref1 = prismicData.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.url;
    var articleImages = [
        featuredImage
    ].concat(editorial_content_toConsumableArray(prismicData.body.map(function(slice) {
        if (slice.type === "HERO_TITLE" && isPrismicSliceHeroTitle(slice.primary)) {
            var ref;
            return (ref = slice.primary.heroImage) === null || ref === void 0 ? void 0 : ref.url;
        }
        if (slice.type === "IMAGE" && isPrismicSliceImage(slice.primary)) {
            return slice.primary.image.url;
        }
        return undefined;
    }))).filter(function(value) {
        return typeof value === "string";
    });
    var openGraph = [
        {
            key: "title",
            content: articleTitle
        },
        {
            key: "type",
            content: "article"
        },
        {
            key: "url",
            content: articleUrl
        },
        {
            key: "image",
            content: articleImages[0]
        }
    ];
    var structuredData = {
        "@context": "http://schema.org",
        "@type": "Article",
        datePublished: datePublished,
        dateModified: dateModified,
        headline: articleTitle,
        image: articleImages[0],
        description: articleDescription
    };
    var articleFaqSlice = (ref2 = prismicData.body.find(function(slice) {
        return slice.type === "FAQ_SECTION";
    })) === null || ref2 === void 0 ? void 0 : ref2.primary;
    return {
        title: t("meta", "article.page-title", {
            title: articleTitle
        }),
        description: articleDescription,
        canonical: articleUrl,
        structuredData: articleFaqSlice ? [
            structuredData,
            faqPage(articleFaqSlice)
        ] : structuredData,
        openGraph: openGraph
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/editorial-content/editorial-content-listing.js
/* harmony default export */ function editorial_content_listing(_, param) {
    var market = param.market, t = param.t;
    return {
        title: t("meta", "articles.title"),
        description: undefined,
        canonical: "".concat(market.domain).concat(market.routes && market.routes.editorialContentListing && market.routes.editorialContentListing.path || "/articles"),
        openGraph: [],
        structuredData: undefined
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/user-profile.tsx
var profileMetaTags = function(param, param1) {
    var data = param.data, offset = param.offset, section = param.section, market = param1.market, t = param1.t;
    if (!data || !data.user) {
        return {};
    }
    var baseUrl = "".concat(market.domain, "/user/").concat(data.user.id);
    // Canonicalise to the section URL
    var url = section ? "".concat(baseUrl, "/").concat(section) : "".concat(baseUrl, "/reviews");
    // Self canonicalise each offset page to make Google index it as its
    // own unique page
    var canonical = offset ? "".concat(url, "?offset=").concat(offset) : url;
    var metaTags = {
        title: t("meta", "profile.page-title", {
            user: data.user.displayName || t("account", "profile.title")
        }),
        description: null,
        canonical: canonical,
        openGraph: [],
        structuredData: undefined
    };
    return metaTags;
};
/* harmony default export */ var user_profile = (profileMetaTags);

;// CONCATENATED MODULE: ./src/components/meta-tags/public-list.ts
/* harmony default export */ function public_list(param, param1) {
    var data = param.data, t = param1.t;
    var ref;
    if (!(data === null || data === void 0 ? void 0 : data.list)) return {};
    var title = ((ref = data.list.user) === null || ref === void 0 ? void 0 : ref.displayName) ? t("meta", "list.title", {
        name: data.list.name,
        owner: data.list.user.displayName
    }) : data.list.name;
    return {
        title: title
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/helpers/expert-category-mappings.json
var expert_category_mappings_namespaceObject = JSON.parse('{"hP":{"Hörlurar":"hörlurar","Datorer":"dator","Högtalare":"högtalare","Eltandborstar":"eltandborste","Barnstolar":"barnstol","TV":"tv","Surfplattor":"surfplatta","Babyvakter":"babyvakt","Bilbarnstolar":"bilbarnstol","Köksassistenter":"köksassistent","Mobiltelefoner":"mobiltelefon","Drönare":"drönare","Barnvagnar":"barnvagn","Spelkonsoler":"spelkonsol","Blenders":"blender","Spel":"spel","Kaffemaskiner":"kaffemaskin","Bärselar":"bärsele","Åkpåsar":"åkpåse","Skrivare":"skrivare","Elvispar":"elvisp","Babysitters":"babysitter","Objektiv":"objektiv","Kameror":"kamera","Stavmixers":"stavmixer","Smarta klockor":"smart klocka","Bildskärmar":"bildskärm","Glassmaskiner":"glassmaskin","Grillar":"grill","Hårfönar":"hårfön","Hårtrimmers":"hårtrimmer","Kaffekvarnar":"kaffekvarn","Läsplattor":"läsplatta","Locktänger":"locktång","Matberedare":"matberedare","Övervakningskameror":"övervakningskamera","Plattänger":"plattång","Rakapparater":"rakapparat","Robotdammsugare":"robotdammsugare","Routrar":"router","Smarta lampor":"smart lampa","Barngrindar":"barngrind","Barnsängar":"barnsäng","Cyklar":"cykel","Däck":"däck","Dammsugare":"dammsugare","Diskmaskiner":"diskmaskin","Elcyklar":"elcykel","Ficklampor":"ficklampa","Fiske":"fiskepryl","Frysar":"frys","Kylskåp":"kylskåp","Längdskidor":"längdskidor","Löpband":"löpband","Motionscyklar":"motionscykel","Powerbanks":"powerbank","Roddmaskiner":"roddmaskin","Sällskapsspel":"sällskapsspel","Brädspel":"brädspel","Schampo":"schampo","Skäggolja":"skäggolja","Skötbord":"skötbord","Skötväskor":"skötväska","Skridskor":"skridskor","Stegräknare":"stegräknare","Tvättmaskiner":"tvättmaskin","Värmepumpar":"värmepump","Cykelvagnar":"cykelvagn","Concealer":"concealer","Balsam":"balsam","Foundation":"foundation","Stekpannor":"stekpanna","Hårinpackning":"hårinpackning","Tangentbord":"tangentbord","Mascara":"mascara","Primer":"primer","Projektorer":"projektor","Löparskor":"löparsko","Sous vide":"sous vide","Vakuumförpackare":"vakuumförpackare","Smarta hubbar":"smart hubb","Datormöss":"datormus","Tält":"tält","Liggunderlag":"liggunderlag","Sovsäckar":"sovsäck","Ansiktsmasker":"ansiktsmask","Jackor":"jacka","Pannlampor":"pannlampa","Robotgräsklippare":"robotgräsklippare","Ryggsäckar":"ryggsäck","Stormkök":"stormkök","Vandringskängor":"vandringskänga","Solkräm":"solkräm","Grästrimmrar & röjsågar":"grästrimmer & röjsåg","Personvågar":"personvåg","Smarta lås":"smart lås","Ansiktsrengöring":"ansiktsrengöring","Brun utan sol":"brun utan sol","Läppglans":"läppglans","Massageapparater":"massageapparat","Puder & mineralpuder":"puder","Kolsyremaskiner":"kolsyremaskin","Vattenkokare":"vattenkokare","Stektermometrar":"stektermometer","Contouring & highlighter":"highlighter","Duschtvål":"duschtvål","Kajal & eyeliner":"kajalpenna","Serum":"serum","Sminksvamp":"sminksvamp","Padel":"padeltillbehör","Grilltillbehör":"grilltillbehör","Fläktar":"fläkt","Kokplattor":"kokplatta","Fritöser":"airfryer","Parfym":"parfym","Ansiktskräm":"ansiktskräm","Ögonvård":"ögonvård","Peeling":"peeling","Riskokare":"riskokare","Fotvård":"fotvård","Nagellack":"nagellack","Kockknivar":"kockkniv","Bakmaskiner":"bakmaskin","Vinkylar":"vinkyl","Våffeljärn":"våffeljärn","Slow cookers":"slow cooker","Mattork":"mattork","Termoskannor":"termoskanna","Pizzaugnar":"pizzaugn","Body lotion & krämer":"body lotion","Skidhandskar":"skidhandske","Luftfuktare":"luftfuktare","Avfuktare":"avfuktare","Luftrenare":"luftrenare","Skidglasögon":"skidglasögon","Skidhjälmar":"skidhjälm","Ögonbrynsgel":"ögonbrynsgel","Smörgåsgrillar":"smörgåsgrill","Blenders & stavmixers":"blender & stavmixer","Gödsel":"gödsel","Mandoliner":"mandolin","Portabel AC":"portabel ac","Värmeskydd":"värmeskydd","Grytor & kastruller":"kastrull och gryta","Alpinskydd - Ryggskydd":"ryggskydd","Popcornmaskiner":"popcornmaskin","Pastamaskiner":"pastamaskin","Mjölkskummare":"mjölkskummare","Knivslipar":"knivslip"},"l2":{"Hörlurar":"hörlurarna","Datorer":"datorn","Högtalare":"högtalaren","Eltandborstar":"eltandborsten","Barnstolar":"barnstolen","TV":"tv:n","Surfplattor":"surfplattan","Babyvakter":"babyvakten","Bilbarnstolar":"bilbarnstolen","Köksassistenter":"köksassistenten","Mobiltelefoner":"mobiltelefonen","Drönare":"drönaren","Barnvagnar":"barnvagnen","Spelkonsoler":"spelkonsolen","Blenders":"blendern","Spel":"spelet","Kaffemaskiner":"kaffemaskinen","Bärselar":"bärselen","Åkpåsar":"åkpåsen","Skrivare":"skrivaren","Elvispar":"elvispen","Babysitters":"babysittern","Objektiv":"objektivet","Kameror":"kameran","Stavmixers":"stavmixern","Smarta klockor":"smarta klockan","Bildskärmar":"bildskärmen","Glassmaskiner":"glassmaskinen","Grillar":"grillen","Hårfönar":"hårfönen","Hårtrimmers":"hårtrimmern","Kaffekvarnar":"kaffekvarnen","Läsplattor":"läsplattan","Locktänger":"locktången","Matberedare":"matberedaren","Övervakningskameror":"övervakningskameran","Plattänger":"plattången","Rakapparater":"rakapparaten","Robotdammsugare":"robotdammsugaren","Routrar":"routern","Smarta lampor":"smarta lampan","Barngrindar":"barngrinden","Barnsängar":"barnsängen","Cyklar":"cykeln","Däck":"däcket","Dammsugare":"dammsugaren","Diskmaskiner":"diskmaskinen","Elcyklar":"elcykeln","Ficklampor":"ficklampan","Fiske":"fiskeprylen","Frysar":"frysen","Kylskåp":"kylskåpet","Längdskidor":"längdskidorna","Löpband":"löpbandet","Motionscyklar":"motionscykeln","Powerbanks":"powerbanken","Roddmaskiner":"roddmaskinen","Sällskapsspel":"sällskapsspelet","Brädspel":"brädspelet","Schampo":"schampot","Skäggolja":"skäggoljan","Skötbord":"skötbordet","Skötväskor":"skötväskan","Skridskor":"skridskorna","Stegräknare":"stegräknaren","Tvättmaskiner":"tvättmaskinen","Värmepumpar":"värmepumpen","Cykelvagnar":"cykelvagnen","Concealer":"concealern","Balsam":"balsamet","Foundation":"foundationet","Stekpannor":"stekpannan","Hårinpackning":"hårinpackningen","Tangentbord":"tangentbordet","Mascara":"mascaran","Primer":"primern","Projektorer":"projektorn","Löparskor":"löparskon","Sous vide":"sous vide-maskinen","Vakuumförpackare":"vakuumförpackaren","Smarta hubbar":"smarta hubben","Datormöss":"datormusen","Tält":"tältet","Liggunderlag":"liggunderlaget","Sovsäckar":"sovsäcken","Ansiktsmasker":"ansiktsmasken","Jackor":"jackan","Pannlampor":"pannlampan","Robotgräsklippare":"robotgräsklipparen","Ryggsäckar":"ryggsäcken","Stormkök":"stormköket","Vandringskängor":"vandringskängan","Solkräm":"solkrämen","Grästrimmrar & röjsågar":"grästrimmern & röjsågen","Personvågar":"personvågen","Smarta lås":"smarta låset","Ansiktsrengöring":"ansiktsrengöringen","Brun utan sol":"brun utan sol","Läppglans":"läppglanset","Massageapparater":"massageapparaten","Puder & mineralpuder":"pudret","Kolsyremaskiner":"kolsyremaskinen","Vattenkokare":"vattenkokaren","Stektermometrar":"stektermometern","Contouring & highlighter":"highlightern","Duschtvål":"duschtvålen","Kajal & eyeliner":"kajalpennan","Serum":"serumet","Sminksvamp":"sminksvampen","Padel":"padeltillbehöret","Grilltillbehör":"grilltillbehöret","Fläktar":"fläkten","Kokplattor":"kokplattan","Fritöser":"airfryern","Parfym":"parfymen","Ansiktskräm":"ansiktskrämen","Ögonvård":"ögonvårdsprodukten","Peeling":"peelingen","Riskokare":"riskokaren","Fotvård":"fotvården","Nagellack":"nagellacket","Kockknivar":"kockkniven","Bakmaskiner":"bakmaskinen","Vinkylar":"vinkylen","Våffeljärn":"våffeljärnet","Slow cookers":"slow cookern","Mattork":"mattorken","Termoskannor":"termoskannan","Pizzaugnar":"pizzaugnen","Body lotion & krämer":"body lotionen","Skidhandskar":"skidhandsken","Luftfuktare":"luftfuktaren","Avfuktare":"avfuktaren","Luftrenare":"luftrenaren","Skidglasögon":"skidglasögonen","Skidhjälmar":"skidhjälmen","Ögonbrynsgel":"ögonbrynsgelen","Smörgåsgrillar":"smörgåsgrillen","Blenders & stavmixers":"blendern & stavmixern","Gödsel":"gödslen","Mandoliner":"mandolinen","Portabel AC":"portabla ac:n","Värmeskydd":"värmeskyddet","Grytor & kastruller":"kastrullen och grytan","Alpinskydd - Ryggskydd":"ryggskyddet","Popcornmaskiner":"popcornmaskinen","Pastamaskiner":"pastamaskinen","Mjölkskummare":"mjölkskummaren","Knivslipar":"knivslipen"}}');
;// CONCATENATED MODULE: ./src/components/meta-tags/expert-category.ts

var expertCategory = function(param, param1) {
    var data = param.data, t = param1.t;
    if (!data || !data.expertCategoryPage) {
        return {};
    }
    var category = (data.expertCategoryPage || {}).category;
    if (!(category === null || category === void 0 ? void 0 : category.name)) return {};
    return {
        description: t("meta", "expert.category-description", {
            category: expert_category_mappings_namespaceObject.hP[category.name] || (category === null || category === void 0 ? void 0 : category.name.toLowerCase())
        }),
        title: t("meta", "expert.category-title", {
            category: expert_category_mappings_namespaceObject.l2[category === null || category === void 0 ? void 0 : category.name] || (category === null || category === void 0 ? void 0 : category.name.toLowerCase()),
            year: new Date().getFullYear()
        }),
        canonical: category.fullUrl,
        openGraph: undefined,
        structuredData: undefined
    };
};
/* harmony default export */ var expert_category = (expertCategory);

;// CONCATENATED MODULE: ./src/components/meta-tags/expert-landing-page.ts
var expertLandingPageMetaTags = function(param, param1) {
    var data = param.data, t = param1.t, linkTo = param1.linkTo, market = param1.market;
    if (!data || !data.expertLandingPage) {
        return {};
    }
    var title = t("meta", "expert.landing-page-title");
    var description = t("meta", "expert.landing-page-description");
    var openGraph = [
        {
            key: "url",
            content: "".concat(market.domain).concat(linkTo("experts"))
        },
        {
            key: "title",
            content: title
        },
        {
            key: "description",
            content: description
        },
        {
            key: "type",
            content: "website"
        },
        {
            key: "siteName",
            content: t("meta", "site.name")
        }
    ];
    return {
        description: description,
        title: title,
        openGraph: openGraph,
        canonical: "".concat(market.domain).concat(linkTo("experts")),
        structuredData: undefined
    };
};
/* harmony default export */ var expert_landing_page = (expertLandingPageMetaTags);

;// CONCATENATED MODULE: ./src/components/meta-tags/keyword-landing-page.ts
function keyword_landing_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function keyword_landing_page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            keyword_landing_page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function keyword_landing_page_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function keyword_landing_page_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        keyword_landing_page_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/* harmony default export */ function keyword_landing_page(kwlpData, param) {
    var market = param.market, t = param.t;
    if (!kwlpData.data) return {};
    var _keywordLandingPage = kwlpData.data.keywordLandingPage, url = _keywordLandingPage.url, _categories = _keywordLandingPage.categories, categories = _categories.nodes, title = _keywordLandingPage.title, inSitemap = _keywordLandingPage.inSitemap, parentCategory = _keywordLandingPage.parentCategory, hasAdultContent = _keywordLandingPage.hasAdultContent, metaDescription = _keywordLandingPage.metaDescription, descriptionObject = _keywordLandingPage.description;
    var canonical = market.domain + url;
    var noIndex = !inSitemap;
    var breadcrumb = parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.path;
    var firstLetterVariantA = /^[a-i]/i;
    var firstLetterVariantB = /^[j-r]/i;
    var variantA = firstLetterVariantA.test(title);
    var variantB = firstLetterVariantB.test(title);
    var keyword = "".concat(title[0].toUpperCase()).concat(title.slice(1));
    var isOffersOnly = !categories.length;
    var description = setUpDescription({
        keyword: keyword,
        categories: categories,
        t: t,
        isOffersOnly: isOffersOnly,
        metaDescription: metaDescription,
        descriptionText: descriptionObject === null || descriptionObject === void 0 ? void 0 : descriptionObject.text
    });
    var isExperimentalMarket = [
        "no",
        "dk",
        "fr",
        "fi"
    ].includes(market.code);
    var titleDescription = {};
    if (variantA && isExperimentalMarket) {
        titleDescription = {
            title: t("meta", "keyword-landing-page.title", {
                keyword: keyword
            }),
            description: t("meta", "keyword-landing-page.description-experiment", {
                keyword: keyword
            })
        };
    } else if (variantB && isExperimentalMarket) {
        titleDescription = {
            title: t("meta", "keyword-landing-page.title-experiment", {
                keyword: keyword
            }),
            description: description
        };
    } else {
        titleDescription = {
            title: t("meta", "keyword-landing-page.title", {
                keyword: keyword
            }),
            description: description
        };
    }
    var maxImagePreview = "standard";
    return keyword_landing_page_objectSpreadProps(keyword_landing_page_objectSpread({}, titleDescription), {
        canonical: canonical,
        noIndex: noIndex,
        breadcrumb: breadcrumb,
        maxImagePreview: maxImagePreview,
        hasAdultContent: hasAdultContent
    });
};
var setUpDescription = function(param) {
    var keyword = param.keyword, categories = param.categories, t = param.t, isOffersOnly = param.isOffersOnly, metaDescription = param.metaDescription, descriptionText = param.descriptionText;
    if (metaDescription) {
        return metaDescription;
    }
    if (descriptionText) {
        return descriptionText;
    }
    if (isOffersOnly) {
        return t("meta", "keyword-landing-page.description-offers-only", {
            keyword: keyword
        });
    }
    return t("meta", "keyword-landing-page.description", {
        keyword: keyword,
        categories: categories.map(function(category) {
            return category === null || category === void 0 ? void 0 : category.name;
        }).join(" ")
    });
};

;// CONCATENATED MODULE: ./src/components/meta-tags/keyword-listing.ts
/* harmony default export */ function keyword_listing(param, param1) {
    var data = param.data, t = param1.t;
    var ref = (data === null || data === void 0 ? void 0 : data.popularSearchTerms) || {}, _keywords = ref.keywords, keywords = _keywords === void 0 ? [] : _keywords, _categories = ref.categories, categories = _categories === void 0 ? [] : _categories;
    var categoryNames = categories.slice(0, 3).map(function(param) {
        var name = param.name;
        return name;
    });
    var keywordNames = keywords.slice(0, 3).map(function(param) {
        var name = param.name;
        return name;
    });
    var title = t("meta", "keyword-listing.title", {
        category: categoryNames[0]
    });
    var description = t("meta", "keyword-listing.description", {
        keyword: keywordNames.join(", "),
        categories: categoryNames.join(", ")
    });
    return {
        noIndex: true,
        follow: true,
        title: title,
        description: description
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/changelog-landing-page.js
/* harmony default export */ function changelog_landing_page(_, param) {
    var market = param.market, t = param.t;
    return {
        title: t("changelog", "changelog.title"),
        description: undefined,
        canonical: "".concat(market.domain).concat(market.routes && market.routes.changelogLandingPage && market.routes.changelogLandingPage.path || "/changelog"),
        openGraph: [],
        structuredData: undefined
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/definitions.js































/* harmony default export */ var definitions = ({
    article: article,
    product: product,
    productCompare: product_compare,
    productAlert: product_alert,
    start: start,
    category: category,
    store: store,
    campaign: campaign,
    infoPage: info_page,
    brand: meta_tags_brand,
    login: login,
    shopOfTheYearLandingPage: shop_of_the_year_landing_page,
    shopOfTheYearCategory: shop_of_the_year_category,
    shopOfTheYearWinners: shop_of_the_year_winners,
    shopOfTheYear: shop_of_the_year,
    promotionProducts: promotion_products,
    promotions: promotions,
    usedProducts: used_products,
    search: search,
    generic: generic,
    productCollection: product_collection,
    productCollectionSitemap: product_collection_sitemap,
    editorialContent: editorial_content,
    editorialContentListing: editorial_content_listing,
    userProfile: user_profile,
    publicList: public_list,
    expertCategory: expert_category,
    expertLandingPage: expert_landing_page,
    keywordLandingPage: keyword_landing_page,
    keywordListing: keyword_listing,
    changelogLandingPage: changelog_landing_page
});

// EXTERNAL MODULE: ./src/areas/landing-page/index.js
var landing_page = __webpack_require__(3492);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(8836);
// EXTERNAL MODULE: ./src/areas/product/product-page.tsx
var product_page = __webpack_require__(7245);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(62619);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(12321);
// EXTERNAL MODULE: ./src/areas/product/query.graphql
var query_graphql = __webpack_require__(42318);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/product/queries/use-product-page.ts


function useProductPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "product",
        variables: variables,
        keepPreviousData: false
    });
}

// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(42281);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(25349);
;// CONCATENATED MODULE: ./src/areas/product/index.tsx









var Product = function(props) {
    var ref, ref1, ref2, ref3;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var variables = route === null || route === void 0 ? void 0 : route.variables;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    var ref4 = useProductPageQuery(variables), data = ref4.data, isLoading = ref4.isLoading, isSuccess = ref4.isSuccess;
    var routeSection = props.routeSection;
    if (!isLoading && !isSuccess) {
        return null;
    }
    if (isLoading) {
        return /*#__PURE__*/ react.createElement("div", {
            key: variables.id
        }, /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
            hasTabNavigation: true
        }, /*#__PURE__*/ react.createElement(loader/* default */.Z, null)));
    }
    var product = data.product;
    if (false) { var error; }
    var ref5, ref6;
    var adsConfig = {
        pageOptions: {
            pageType: "product",
            categoryPath: (ref1 = product === null || product === void 0 ? void 0 : (ref = product.category) === null || ref === void 0 ? void 0 : ref.path.map(function(path) {
                return path.id;
            })) === null || ref1 === void 0 ? void 0 : ref1.concat(product === null || product === void 0 ? void 0 : product.id.toString()),
            price: (ref5 = product === null || product === void 0 ? void 0 : (ref2 = product.priceSummary) === null || ref2 === void 0 ? void 0 : ref2.regular) !== null && ref5 !== void 0 ? ref5 : undefined,
            brand: (ref6 = product === null || product === void 0 ? void 0 : (ref3 = product.brand) === null || ref3 === void 0 ? void 0 : ref3.name) !== null && ref6 !== void 0 ? ref6 : ""
        },
        formats: [
            "panorama_1_wde",
            "panorama_1",
            "panorama_2_wde",
            "panorama_2",
            "panorama_3_wde",
            "panorama_3",
            "panorama_4",
            "welcome_page_wde",
            "welcome_page"
        ]
    };
    return /*#__PURE__*/ react.createElement("div", {
        key: variables.id
    }, /*#__PURE__*/ react.createElement(offer_list_filter_context/* OfferListFilterContextContainer */.p, null, /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        hasTabNavigation: true,
        adsConfig: adsConfig
    }, isLoading && /*#__PURE__*/ react.createElement(loader/* default */.Z, null), isSuccess && /*#__PURE__*/ react.createElement(product_page/* ProductPage */.e, {
        data: data,
        routeSection: routeSection
    }))));
};
Product.graphQL = (query_graphql_default());
// Group on product ID, ignore section param
Product.group = function(param) {
    var name = param.name, match = param.match;
    return "".concat(name, "_").concat(match && match.params ? match.params.id : "unknown");
};
Product.variables = function(param) {
    var id = param.id, marketCode = param.marketCode;
    var partnerVideosEnabled = [
        "se"
    ].includes(marketCode);
    return {
        id: parseInt(id, 10),
        expertsEnabled: true,
        partnerVideosEnabled: partnerVideosEnabled
    };
};
/* harmony default export */ var areas_product = (Product);

// EXTERNAL MODULE: ./src/areas/product-compare/index.js
var areas_product_compare = __webpack_require__(81678);
// EXTERNAL MODULE: ./src/areas/category/index.tsx
var areas_category = __webpack_require__(31498);
// EXTERNAL MODULE: ./src/areas/category-index/index.js
var category_index = __webpack_require__(89191);
// EXTERNAL MODULE: ./src/areas/keyword-landing-page/index.js
var areas_keyword_landing_page = __webpack_require__(54068);
// EXTERNAL MODULE: ./src/areas/keyword-listing/index.js
var areas_keyword_listing = __webpack_require__(81901);
// EXTERNAL MODULE: ./src/areas/product-collection/index.js
var areas_product_collection = __webpack_require__(46233);
// EXTERNAL MODULE: ./src/areas/product-collection-sitemap/index.js
var areas_product_collection_sitemap = __webpack_require__(26891);
// EXTERNAL MODULE: ./src/areas/brand/index.js
var areas_brand = __webpack_require__(65598);
// EXTERNAL MODULE: ./src/areas/store/index.tsx
var areas_store = __webpack_require__(82562);
// EXTERNAL MODULE: ./src/areas/editorial-content/index.js
var areas_editorial_content = __webpack_require__(43295);
// EXTERNAL MODULE: ./src/areas/editorial-content-listing/index.js
var areas_editorial_content_listing = __webpack_require__(61877);
// EXTERNAL MODULE: ./src/areas/info/index.js
var info = __webpack_require__(88092);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotion-products-page/query.graphql
var promotion_products_page_query_graphql = __webpack_require__(58948);
var promotion_products_page_query_graphql_default = /*#__PURE__*/__webpack_require__.n(promotion_products_page_query_graphql);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/contexts/search-context.tsx + 1 modules
var search_context = __webpack_require__(37680);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotion-products-page/contexts/promotion-context.tsx
var promotion_context = __webpack_require__(76738);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/contexts/tracking-context.tsx
var tracking_context = __webpack_require__(83207);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(50238);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/queries/use-promotion-products-page-query.ts


function usePromotionProductsPageQuery(variables, enabled) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (promotion_products_page_query_graphql_default()),
        routeName: "promotion",
        variables: variables,
        refetchOnReconnect: false,
        enabled: enabled
    });
}

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotion-products-page/queries/promotion-products.graphql
var promotion_products_graphql = __webpack_require__(16611);
var promotion_products_graphql_default = /*#__PURE__*/__webpack_require__.n(promotion_products_graphql);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(27019);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/queries/use-promotion-products-query.ts


function usePromotionProductsQuery(variables, enabled) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (promotion_products_graphql_default()),
        variables: variables,
        refetchOnReconnect: false,
        queryKey: [
            "promotion-products"
        ],
        enabled: enabled
    });
}

// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(88999);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(94141);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/shared/components/breadcrumbs/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/components/breadcrumbs/index.tsx
function breadcrumbs_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function breadcrumbs_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return breadcrumbs_arrayLikeToArray(arr);
}
function breadcrumbs_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function breadcrumbs_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function breadcrumbs_toConsumableArray(arr) {
    return breadcrumbs_arrayWithoutHoles(arr) || breadcrumbs_iterableToArray(arr) || breadcrumbs_unsupportedIterableToArray(arr) || breadcrumbs_nonIterableSpread();
}
function breadcrumbs_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return breadcrumbs_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return breadcrumbs_arrayLikeToArray(o, minLen);
}





var PromotionProductsBreadcrumbs = function() {
    var title = (0,promotion_context/* usePromotionContext */.ER)().title;
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t, linkTo = ref.linkTo, market = ref.market;
    var promotionsPageUrl = linkTo("promotions");
    var nativeRenderMode = renderMode === "native";
    return /*#__PURE__*/ react.createElement(react.Fragment, null, !nativeRenderMode && /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: breadcrumbs_toConsumableArray(market.promotions.enabled ? [
            {
                href: promotionsPageUrl,
                title: t("search", "scoped-search.promotion-title")
            }
        ] : []).concat([
            {
                title: title
            }
        ])
    })));
};

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/components/content-wrapper/index.tsx + 41 modules
var content_wrapper = __webpack_require__(35350);
// EXTERNAL MODULE: ./src/components/error-message/index.tsx + 1 modules
var error_message = __webpack_require__(44581);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(24828);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(21541);
// EXTERNAL MODULE: ./src/components/product-card-old/components/new-click-out-button.tsx
var new_click_out_button = __webpack_require__(6036);
// EXTERNAL MODULE: ./src/areas/store/constants.ts
var constants = __webpack_require__(67595);
// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(40763);
// EXTERNAL MODULE: ./src/components/cdn-image/index.tsx
var cdn_image = __webpack_require__(71412);
// EXTERNAL MODULE: ./src/areas/store/actions/index.js
var actions = __webpack_require__(43641);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts + 1 modules
var conversion = __webpack_require__(23513);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/components/header/tracking.ts


var trackExternalPromotionLinkClick = function(promotion, dispatch) {
    if (promotion.owner.type === "shop") {
        dispatch((0,actions/* storeLinkClick */.P)());
        (0,conversion/* trackShopClickWithRevenue */.Yn)({
            shopId: parseInt(promotion.owner.id, 10),
            scope: conversion/* TrackClickScope.PROMOTION_PRODUCTS_PAGE_HEADER */.b8.PROMOTION_PRODUCTS_PAGE_HEADER
        });
    } else if (promotion.owner.type === "brand") {
    // 10 Oct 2023: We currently have no revenue tracking for Brands. Elina and Sara are looking into this.
    }
};

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotion-products-page/utils/index.ts
var utils = __webpack_require__(97620);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/icon/schedule/index.js
var schedule = __webpack_require__(87383);
// EXTERNAL MODULE: ./src/components/truncated/index.tsx
var truncated = __webpack_require__(16732);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/components/header/desktop/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  margin: ",
        " ",
        "\n    ",
        " ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 168px;\n  max-width: 200px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  flex: 1;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  width: 264px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 118px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  vertical-align: text-bottom;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var StyledHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeader",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-1"
})(_templateObject1());
var StyledContentColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContentColumn",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledTitle = (0,styled_components_browser_esm["default"])(variants.H1Text).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-3"
})(_templateObject3());
var StyledTruncated = (0,styled_components_browser_esm["default"])(truncated/* Truncated */.J).withConfig({
    displayName: "StyledTruncated",
    componentId: "sc-0-4"
})(_templateObject4());
var StyledOwnerColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledOwnerColumn",
    componentId: "sc-0-5"
})(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledShopLogo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledShopLogo",
    componentId: "sc-0-6"
})(_templateObject6());
var StyledIcon = (0,styled_components_browser_esm["default"])(schedule/* IconSchedule */.c).withConfig({
    displayName: "StyledIcon",
    componentId: "sc-0-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/components/header/desktop/index.tsx
function desktop_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function desktop_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function desktop_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function desktop_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function desktop_slicedToArray(arr, i) {
    return desktop_arrayWithHoles(arr) || desktop_iterableToArrayLimit(arr, i) || desktop_unsupportedIterableToArray(arr, i) || desktop_nonIterableRest();
}
function desktop_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return desktop_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return desktop_arrayLikeToArray(o, minLen);
}












var PromotionProductsHeaderDesktop = function(param) {
    var Breadcrumbs = param.Breadcrumbs;
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t, market = ref.market;
    var promotion = (0,promotion_context/* usePromotionContext */.ER)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = desktop_slicedToArray((0,react.useState)(false), 2), showWholeDescription = ref1[0], setShowWholeDescription = ref1[1];
    var timeSpan = (0,utils/* getPromotionTimespan */.R)(promotion, t, market.localeStandard);
    var handleLinkClick = function() {
        trackExternalPromotionLinkClick(promotion, dispatch);
    };
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "pageHeader"
    }, renderMode !== "native" && Breadcrumbs, /*#__PURE__*/ react.createElement(StyledHeader, null, promotion.imageUrl && /*#__PURE__*/ react.createElement(StyledImage, {
        src: promotion.imageUrl,
        alt: ""
    }), /*#__PURE__*/ react.createElement(StyledContentColumn, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledTitle, {
        containerProps: {
            "data-test": "HeaderText"
        }
    }, promotion.title), /*#__PURE__*/ react.createElement(variants.BodyLargeText, null, promotion.owner.name)), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.HIGH
    }, /*#__PURE__*/ react.createElement(StyledIcon, {
        size: 16
    }), " ", timeSpan.long)), promotion.description && /*#__PURE__*/ react.createElement(react.Fragment, null, showWholeDescription ? /*#__PURE__*/ react.createElement(StyledTruncated, {
        maxLines: 100,
        onClick: function() {
            return setShowWholeDescription(false);
        }
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, promotion.description)) : /*#__PURE__*/ react.createElement(StyledTruncated, {
        maxLines: 3,
        onClick: function() {
            return setShowWholeDescription(true);
        }
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, promotion.description)))), /*#__PURE__*/ react.createElement(StyledOwnerColumn, null, /*#__PURE__*/ react.createElement(StyledShopLogo, null, /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
        name: promotion.owner.id,
        width: constants/* SHOP_LOGO_WIDTH */.L9,
        alt: promotion.owner.name,
        logoType: promotion.owner.type
    })), promotion.promotionUrl && /*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
        onClick: handleLinkClick,
        external: true,
        href: promotion.promotionUrl,
        text: t("product", "external-link.view-in-shop")
    }))));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/components/header/mobile/styles.ts
function mobile_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function mobile_styles_templateObject() {
    var data = mobile_styles_taggedTemplateLiteral([
        "\n  margin: ",
        " ",
        "\n    ",
        " ",
        ";\n"
    ]);
    mobile_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = mobile_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  flex: 1;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = mobile_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: -1px;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = mobile_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = mobile_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = mobile_styles_taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 140px;\n  max-width: 200px;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = mobile_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = mobile_styles_taggedTemplateLiteral([
        "\n  vertical-align: text-bottom;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var styles_StyledHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeader",
    componentId: "sc-0-0"
})(mobile_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledColumn",
    componentId: "sc-0-1"
})(styles_templateObject1(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var StyledSubTitleColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSubTitleColumn",
    componentId: "sc-0-2"
})(styles_templateObject2());
var StyledRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRow",
    componentId: "sc-0-3"
})(styles_templateObject3(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var styles_StyledTitle = (0,styled_components_browser_esm["default"])(variants.H1Text).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-4"
})(styles_templateObject4());
var styles_StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-5"
})(styles_templateObject5());
var styles_StyledTruncated = (0,styled_components_browser_esm["default"])(truncated/* Truncated */.J).withConfig({
    displayName: "StyledTruncated",
    componentId: "sc-0-6"
})(styles_templateObject6());
var styles_StyledIcon = (0,styled_components_browser_esm["default"])(schedule/* IconSchedule */.c).withConfig({
    displayName: "StyledIcon",
    componentId: "sc-0-7"
})(styles_templateObject7());

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/components/header/mobile/index.tsx
function mobile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function mobile_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function mobile_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function mobile_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function mobile_slicedToArray(arr, i) {
    return mobile_arrayWithHoles(arr) || mobile_iterableToArrayLimit(arr, i) || mobile_unsupportedIterableToArray(arr, i) || mobile_nonIterableRest();
}
function mobile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return mobile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mobile_arrayLikeToArray(o, minLen);
}












var PromotionProductsHeaderMobile = function(param) {
    var Breadcrumbs = param.Breadcrumbs;
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t, market = ref.market;
    var promotion = (0,promotion_context/* usePromotionContext */.ER)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = mobile_slicedToArray((0,react.useState)(false), 2), showWholeDescription = ref1[0], setShowWholeDescription = ref1[1];
    var timeSpan = (0,utils/* getPromotionTimespan */.R)(promotion, t, market.localeStandard);
    var handleLinkClick = function() {
        trackExternalPromotionLinkClick(promotion, dispatch);
    };
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "pageHeader"
    }, renderMode !== "native" && Breadcrumbs, /*#__PURE__*/ react.createElement(styles_StyledHeader, null, /*#__PURE__*/ react.createElement(StyledColumn, null, /*#__PURE__*/ react.createElement(styles_StyledTitle, {
        containerProps: {
            "data-test": "HeaderText"
        }
    }, promotion.title), /*#__PURE__*/ react.createElement(StyledRow, null, promotion.imageUrl && /*#__PURE__*/ react.createElement(styles_StyledImage, {
        src: promotion.imageUrl,
        alt: ""
    }), /*#__PURE__*/ react.createElement(StyledColumn, null, /*#__PURE__*/ react.createElement(StyledSubTitleColumn, null, /*#__PURE__*/ react.createElement(variants.BodyLargeText, null, promotion.owner.name), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.HIGH
    }, /*#__PURE__*/ react.createElement(styles_StyledIcon, {
        size: 16
    }), " ", timeSpan.long)), /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
        name: promotion.owner.id,
        width: constants/* SHOP_LOGO_WIDTH_SMALL */.jr,
        alt: promotion.owner.name,
        logoType: promotion.owner.type
    }), promotion.promotionUrl && /*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
        onClick: handleLinkClick,
        external: true,
        href: promotion.promotionUrl,
        text: t("product", "external-link.view-in-shop")
    }))), promotion.description && /*#__PURE__*/ react.createElement(react.Fragment, null, showWholeDescription ? /*#__PURE__*/ react.createElement(styles_StyledTruncated, {
        maxLines: 100,
        onClick: function() {
            return setShowWholeDescription(false);
        }
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, promotion.description)) : /*#__PURE__*/ react.createElement(styles_StyledTruncated, {
        maxLines: 3,
        onClick: function() {
            return setShowWholeDescription(true);
        }
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, promotion.description))))));
};

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/types.ts
var types = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/promotion-products.tsx
function promotion_products_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function promotion_products_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            promotion_products_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
















var PromotionProductsPageComponent = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var ref = usePromotionProductsPageQuery(promotion_products_objectSpread({}, route === null || route === void 0 ? void 0 : route.variables), true), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess;
    var initState = {
        filters: {
            promotion: route === null || route === void 0 ? void 0 : route.variables.id
        },
        page: 1,
        sortType: types/* ProductSortOptionValueEnum.PRODUCT_POPULARITY_TOTAL */.mJ.PRODUCT_POPULARITY_TOTAL
    };
    var promotionInfo = data === null || data === void 0 ? void 0 : data.promotion;
    if (!isLoading && !isSuccess) {
        return /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
            status: 500
        });
    }
    var searchPageType = (promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.owner.type) === types/* PromotionOwnerTypeEnum.SHOP */.BB.SHOP ? types/* SearchPageType.SHOP_PROMOTIONS_PRODUCTS */.zh.SHOP_PROMOTIONS_PRODUCTS : types/* SearchPageType.BRAND_PROMOTIONS_PRODUCTS */.zh.BRAND_PROMOTIONS_PRODUCTS;
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        noOutsiderAds: true
    }, isLoading && /*#__PURE__*/ react.createElement(loader/* default */.Z, null), isSuccess && promotionInfo && /*#__PURE__*/ react.createElement(promotion_context/* PromotionStateProvider */.Mv, {
        promotionInfo: promotionInfo
    }, /*#__PURE__*/ react.createElement(search_context/* SearchStateProvider */.jn, {
        initState: initState,
        useSearchQuery: usePromotionProductsQuery
    }, /*#__PURE__*/ react.createElement(tracking_context/* TrackingFunctionsProvider */.qK, {
        searchPageType: searchPageType
    }, isMobile ? /*#__PURE__*/ react.createElement(PromotionProductsHeaderMobile, {
        Breadcrumbs: /*#__PURE__*/ react.createElement(PromotionProductsBreadcrumbs, null)
    }) : /*#__PURE__*/ react.createElement(PromotionProductsHeaderDesktop, {
        Breadcrumbs: /*#__PURE__*/ react.createElement(PromotionProductsBreadcrumbs, null)
    }), /*#__PURE__*/ react.createElement(content_wrapper/* ContentWrapper */.v, {
        searchPageType: searchPageType
    })))));
};
/* harmony default export */ var promotion_products_page_promotion_products = (PromotionProductsPageComponent);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotion-products-page/index.tsx



// Fixes loadable type errors `Property 'graphQL' does not exist on type
var PromotionProductsPage = function() {
    return /*#__PURE__*/ react.createElement(promotion_products_page_promotion_products, null);
};
PromotionProductsPage.graphQL = (promotion_products_page_query_graphql_default());
PromotionProductsPage.variables = function(param) {
    var id = param.id;
    return {
        id: id
    };
};
/* harmony default export */ var promotion_products_page = (PromotionProductsPage);

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotions-page/queries/promotions.graphql
var promotions_graphql = __webpack_require__(68035);
var promotions_graphql_default = /*#__PURE__*/__webpack_require__.n(promotions_graphql);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/shared/components/description-text/index.tsx + 2 modules
var description_text = __webpack_require__(61961);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/components/header/styles.ts
function header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_styles_templateObject() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: ",
        " ",
        "\n    ",
        " ",
        ";\n"
    ]);
    header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_styles_templateObject1() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_styles_templateObject2() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n  "
    ]);
    header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_styles_templateObject3() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n\n  ",
        "\n"
    ]);
    header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_styles_templateObject4() {
    var data = header_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var HEADER_IMAGE_MAX_HEIGHT_DESKTOP = "64px";
var HEADER_IMAGE_MAX_HEIGHT_MOBILE = "58px";
var header_styles_StyledHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeader",
    componentId: "sc-0-0"
})(header_styles_templateObject(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledHeaderInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeaderInner",
    componentId: "sc-0-1"
})(header_styles_templateObject1(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var header_styles_StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-2"
})(header_styles_templateObject3(), HEADER_IMAGE_MAX_HEIGHT_DESKTOP, base/* media.smallOnly */.BC.smallOnly(header_styles_templateObject2(), HEADER_IMAGE_MAX_HEIGHT_MOBILE));
var header_styles_StyledTitle = (0,styled_components_browser_esm["default"])(variants.H1Text).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-3"
})(header_styles_templateObject4());

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/components/header/index.tsx







var PromotionsHeader = function(param) {
    var breadcrumbs = param.breadcrumbs, searchPageType = param.searchPageType;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,app_context/* useAppContext */.bp)(), renderMode = ref5.renderMode, t = ref5.t, market = ref5.market;
    var searchState = (0,search_context/* useSearchContext */.AB)().searchState;
    var singleSelectedShop = ((ref = searchState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.shops) === null || ref1 === void 0 ? void 0 : ref1.length) === 1 && ((ref4 = (ref2 = searchState.result) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.shopAggregations) === null || ref3 === void 0 ? void 0 : ref3.find(function(shop) {
        return shop.key === searchState.filters.shops[0];
    })) === null || ref4 === void 0 ? void 0 : ref4.name);
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "pageHeader"
    }, renderMode !== "native" && breadcrumbs, /*#__PURE__*/ react.createElement(header_styles_StyledHeader, null, /*#__PURE__*/ react.createElement(StyledHeaderInner, null, /*#__PURE__*/ react.createElement(header_styles_StyledImage, {
        src: "".concat(market.cdn, "/g/rfe/icons/promotions_icon.png")
    }), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(header_styles_StyledTitle, {
        containerProps: {
            "data-test": "HeaderText"
        }
    }, t("search", "scoped-search.promotion-title")), singleSelectedShop && /*#__PURE__*/ react.createElement(variants.BodyLargeText, null, singleSelectedShop))), /*#__PURE__*/ react.createElement(description_text/* DescriptionText */.R, {
        searchPageType: searchPageType
    })));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/components/breadcrumbs/index.tsx




var PromotionsBreadcrumbs = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t;
    var nativeRenderMode = renderMode === "native";
    return /*#__PURE__*/ react.createElement(react.Fragment, null, !nativeRenderMode && /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: [
            {
                title: t("search", "scoped-search.promotion-title")
            }
        ]
    })));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/queries/use-promotions-page-query.ts


function usePromotionsPageQuery(variables, enabled) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (promotions_graphql_default()),
        routeName: "promotions",
        variables: variables,
        refetchOnReconnect: false,
        enabled: enabled
    });
}

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/queries/use-promotions-query.ts


function usePromotionsQuery(variables, enabled) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (promotions_graphql_default()),
        variables: variables,
        refetchOnReconnect: false,
        queryKey: [
            "promotions"
        ],
        enabled: enabled
    });
}

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/promotions.tsx
function promotions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function promotions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            promotions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function promotions_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function promotions_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        promotions_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var PAGE_TYPE = types/* SearchPageType.PROMOTIONS */.zh.PROMOTIONS;
var PromotionsPage = function() {
    var ref;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref1 = usePromotionsPageQuery(promotions_objectSpread({}, route === null || route === void 0 ? void 0 : route.variables), true), data = ref1.data, isLoading = ref1.isLoading, isSuccess = ref1.isSuccess;
    var adsConfig = {
        pageOptions: {
            pageType: "campaign"
        },
        formats: [
            "panorama_1_wde",
            "panorama_1",
            "welcome_page_wde",
            "welcome_page"
        ]
    };
    var initState = promotions_objectSpreadProps(promotions_objectSpread({}, route === null || route === void 0 ? void 0 : route.variables), {
        filters: {},
        page: 1
    });
    var promotions = data === null || data === void 0 ? void 0 : (ref = data.searchV3) === null || ref === void 0 ? void 0 : ref.promotions;
    if (!isLoading && (!isSuccess || !promotions)) {
        return /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
            status: isSuccess ? 404 : 500
        });
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        noOutsiderAds: true,
        adsConfig: adsConfig
    }, isLoading && /*#__PURE__*/ react.createElement(loader/* default */.Z, null), isSuccess && promotions && /*#__PURE__*/ react.createElement(search_context/* SearchStateProvider */.jn, {
        initState: initState,
        useSearchQuery: usePromotionsQuery
    }, /*#__PURE__*/ react.createElement(tracking_context/* TrackingFunctionsProvider */.qK, {
        searchPageType: PAGE_TYPE
    }, /*#__PURE__*/ react.createElement(PromotionsHeader, {
        breadcrumbs: /*#__PURE__*/ react.createElement(PromotionsBreadcrumbs, null),
        searchPageType: PAGE_TYPE
    }), /*#__PURE__*/ react.createElement(content_wrapper/* ContentWrapper */.v, {
        searchPageType: PAGE_TYPE
    }))));
};
/* harmony default export */ var promotions_page_promotions = (PromotionsPage);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/promotions-page/index.tsx






// Fixes loadable type errors `Property 'graphQL' does not exist on type
var Promotions = function() {
    var market = (0,app_context/* useAppContext */.bp)().market;
    if (market.promotions.enabled) {
        return /*#__PURE__*/ react.createElement(promotions_page_promotions, null);
    }
    return /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
        status: 404
    });
};
Promotions.graphQL = (promotions_graphql_default());
Promotions.variables = function() {
    return {
        filters: [],
        page: 0,
        sortType: types/* PromotionsSortOptionValueEnum.START_DATE */.GZ.START_DATE
    };
};
/* harmony default export */ var promotions_page = (Promotions);

// EXTERNAL MODULE: ./src/areas/scoped-search-pages/used-products-page/queries/used-products.graphql
var used_products_graphql = __webpack_require__(76599);
var used_products_graphql_default = /*#__PURE__*/__webpack_require__.n(used_products_graphql);
;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/used-products-page/queries/use-used-products-page-query.ts


function useUsedProductsPageQuery(variables, enabled) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (used_products_graphql_default()),
        routeName: "usedProducts",
        variables: variables,
        refetchOnReconnect: false,
        enabled: enabled
    });
}

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/used-products-page/queries/use-used-products-query.ts


function useUsedProductsQuery(variables, enabled) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (used_products_graphql_default()),
        variables: variables,
        refetchOnReconnect: false,
        queryKey: [
            "used-products"
        ],
        enabled: enabled
    });
}

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/used-products-page/components/header/styles.ts
function components_header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function components_header_styles_templateObject() {
    var data = components_header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: ",
        " ",
        "\n    ",
        " ",
        ";\n"
    ]);
    components_header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function components_header_styles_templateObject1() {
    var data = components_header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    components_header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function components_header_styles_templateObject2() {
    var data = components_header_styles_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n  "
    ]);
    components_header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function components_header_styles_templateObject3() {
    var data = components_header_styles_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n\n  ",
        "\n"
    ]);
    components_header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function components_header_styles_templateObject4() {
    var data = components_header_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n  margin: 0;\n"
    ]);
    components_header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var styles_HEADER_IMAGE_MAX_HEIGHT_DESKTOP = "52px";
var styles_HEADER_IMAGE_MAX_HEIGHT_MOBILE = "40px";
var components_header_styles_StyledHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeader",
    componentId: "sc-0-0"
})(components_header_styles_templateObject(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledTitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTitleWrapper",
    componentId: "sc-0-1"
})(components_header_styles_templateObject1(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var components_header_styles_StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-2"
})(components_header_styles_templateObject3(), styles_HEADER_IMAGE_MAX_HEIGHT_DESKTOP, base/* media.smallOnly */.BC.smallOnly(components_header_styles_templateObject2(), styles_HEADER_IMAGE_MAX_HEIGHT_MOBILE));
var components_header_styles_StyledTitle = (0,styled_components_browser_esm["default"])(variants.H1Text).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-3"
})(components_header_styles_templateObject4());

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/used-products-page/components/header/index.tsx





var UsedProductsHeader = function(param) {
    var breadcrumbs = param.breadcrumbs, searchPageType = param.searchPageType;
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t, market = ref.market;
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "pageHeader"
    }, renderMode !== "native" && breadcrumbs, /*#__PURE__*/ react.createElement(components_header_styles_StyledHeader, null, /*#__PURE__*/ react.createElement(StyledTitleWrapper, null, /*#__PURE__*/ react.createElement(components_header_styles_StyledImage, {
        src: "".concat(market.cdn, "/g/rfe/icons/used_products.png")
    }), /*#__PURE__*/ react.createElement(components_header_styles_StyledTitle, {
        containerProps: {
            "data-test": "HeaderText"
        }
    }, t("product", "product.used-products"))), /*#__PURE__*/ react.createElement(description_text/* DescriptionText */.R, {
        searchPageType: searchPageType
    })));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/used-products-page/components/breadcrumbs/index.tsx




var UsedProductsBreadcrumbs = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t;
    var nativeRenderMode = renderMode === "native";
    return /*#__PURE__*/ react.createElement(react.Fragment, null, !nativeRenderMode && /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: [
            {
                title: t("product", "product.used-products")
            }
        ]
    })));
};

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/used-products-page/used-products.tsx
function used_products_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function used_products_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            used_products_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function used_products_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function used_products_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        used_products_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}













var used_products_PAGE_TYPE = types/* SearchPageType.USED */.zh.USED;
var UsedProductsPage = function() {
    var ref;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var adsConfig = {
        pageOptions: {
            pageType: "usedProducts"
        },
        formats: [
            "panorama_1_wde",
            "panorama_1",
            "welcome_page_wde",
            "welcome_page"
        ]
    };
    var ref1 = useUsedProductsPageQuery(used_products_objectSpread({}, route === null || route === void 0 ? void 0 : route.variables), true), data = ref1.data, isLoading = ref1.isLoading, isSuccess = ref1.isSuccess;
    var usedProductsData = data === null || data === void 0 ? void 0 : (ref = data.searchV3) === null || ref === void 0 ? void 0 : ref.products;
    var initState = used_products_objectSpreadProps(used_products_objectSpread({}, route === null || route === void 0 ? void 0 : route.variables), {
        filters: {
            condition: [
                types/* ConditionFilterValueEnum.USED */.tl.USED
            ]
        },
        page: 1,
        result: usedProductsData
    });
    if (!isLoading && (!isSuccess || !usedProductsData)) {
        return /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
            status: isSuccess ? 404 : 500
        });
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        adsConfig: adsConfig
    }, isLoading && /*#__PURE__*/ react.createElement(loader/* default */.Z, null), isSuccess && usedProductsData && /*#__PURE__*/ react.createElement(search_context/* SearchStateProvider */.jn, {
        initState: initState,
        useSearchQuery: useUsedProductsQuery
    }, /*#__PURE__*/ react.createElement(tracking_context/* TrackingFunctionsProvider */.qK, {
        searchPageType: used_products_PAGE_TYPE
    }, /*#__PURE__*/ react.createElement(UsedProductsHeader, {
        breadcrumbs: /*#__PURE__*/ react.createElement(UsedProductsBreadcrumbs, null),
        searchPageType: used_products_PAGE_TYPE
    }), /*#__PURE__*/ react.createElement(content_wrapper/* ContentWrapper */.v, {
        searchPageType: used_products_PAGE_TYPE
    }))));
};
/* harmony default export */ var used_products_page_used_products = (UsedProductsPage);

;// CONCATENATED MODULE: ./src/areas/scoped-search-pages/used-products-page/index.tsx




// Fixes loadable type errors `Property 'graphQL' does not exist on type`
var used_products_page_UsedProductsPage = function() {
    return /*#__PURE__*/ react.createElement(used_products_page_used_products, null);
};
used_products_page_UsedProductsPage.graphQL = (used_products_graphql_default());
used_products_page_UsedProductsPage.variables = function() {
    return {
        filters: [
            {
                key: "condition",
                value: types/* ConditionFilterValueEnum.USED */.tl.USED
            }
        ],
        page: 0,
        sortType: types/* ProductSortOptionValueEnum.PRODUCT_POPULARITY_TOTAL */.mJ.PRODUCT_POPULARITY_TOTAL
    };
};
/* harmony default export */ var used_products_page = (used_products_page_UsedProductsPage);

// EXTERNAL MODULE: ./src/areas/campaign/index.tsx
var areas_campaign = __webpack_require__(88373);
// EXTERNAL MODULE: ./src/areas/campaign/themes.js
var themes = __webpack_require__(54703);
// EXTERNAL MODULE: ./src/areas/article/index.js
var areas_article = __webpack_require__(11135);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 1 modules
var react_router = __webpack_require__(64799);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/components/toast-container/actions/index.ts
var toast_container_actions = __webpack_require__(40744);
;// CONCATENATED MODULE: ./src/areas/newsletter-verification/actions/index.ts
var NEWSLETTER_SUBSCRIBE_VERIFIED = "NEWSLETTER_SUBSCRIBE_VERIFIED";
var newsletterSubscribeVerified = function(email) {
    return {
        type: NEWSLETTER_SUBSCRIBE_VERIFIED,
        email: email
    };
};
/* harmony default export */ var newsletter_verification_actions = ({
    newsletterSubscribeVerified: newsletterSubscribeVerified
});

;// CONCATENATED MODULE: ./src/areas/newsletter-verification/index.tsx







var NewsletterVerification = function(props) {
    var t = react.useContext(app_context/* AppContext */.Il).t;
    var location = (0,react_router/* useLocation */.TH)();
    var promptToast = props.promptToast, newsletterSubscribeVerified = props.newsletterSubscribeVerified;
    react.useEffect(function() {
        var ref = dist_default().parse(location.search), email = ref.email, hash = ref.hash;
        fetch("/_internal/newsletter/confirm-subscription", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                hash: hash
            })
        }).then(function(res) {
            return res.json();
        }).then(function(param) {
            var success = param.success;
            if (success) {
                newsletterSubscribeVerified(String(email));
                promptToast("success", t("footer", "newsletter.subscription-confirmed"));
            } else {
                promptToast("error", t("errors", "internal.unknown"));
            }
        }).catch(function() {
            promptToast("error", t("errors", "internal.unknown"));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ react.createElement(react_router/* Redirect */.l_, {
        to: "/"
    });
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
/* harmony default export */ var newsletter_verification = ((0,es/* connect */.$j)(function() {}, {
    promptToast: toast_container_actions/* promptToast */.Lf,
    newsletterSubscribeVerified: newsletterSubscribeVerified
})(NewsletterVerification));

// EXTERNAL MODULE: ./src/areas/search/index.js
var areas_search = __webpack_require__(81387);
// EXTERNAL MODULE: ./src/areas/account/profile/my-profile-loadable.tsx
var my_profile_loadable = __webpack_require__(81784);
// EXTERNAL MODULE: ./src/areas/account/profile/user-profile-loadable.tsx
var user_profile_loadable = __webpack_require__(30296);
// EXTERNAL MODULE: ./src/areas/expert/category/index.js
var areas_expert_category = __webpack_require__(38020);
// EXTERNAL MODULE: ./src/areas/expert/landing-page/index.js
var areas_expert_landing_page = __webpack_require__(29290);
// EXTERNAL MODULE: ./src/areas/changelog/landing-page/index.js
var areas_changelog_landing_page = __webpack_require__(95000);
// EXTERNAL MODULE: ./src/areas/account/index.tsx
var account = __webpack_require__(5791);
// EXTERNAL MODULE: ./src/areas/account/settings/components/subscription-settings/unsubscribe-landing-page/unsubscribe-landing-page-loadable.tsx
var unsubscribe_landing_page_loadable = __webpack_require__(38545);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.8_react-dom@18.2.0_react@18.2.0__react@18.2.0_styled-components@5.3.5_react-_kbab3dadkagnqunhbuaz4iyy5u/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(25670);
// EXTERNAL MODULE: ./src/hooks/use-page-meta-tags.ts
var use_page_meta_tags = __webpack_require__(24567);
// EXTERNAL MODULE: ./src/hooks/use-route-loaded.ts
var use_route_loaded = __webpack_require__(65560);
// EXTERNAL MODULE: ./src/areas/alerts/unsubscribe/mutation.graphql
var mutation_graphql = __webpack_require__(12541);
var mutation_graphql_default = /*#__PURE__*/__webpack_require__.n(mutation_graphql);
// EXTERNAL MODULE: ./src/hooks/use-gql-mutation.ts
var use_gql_mutation = __webpack_require__(659);
;// CONCATENATED MODULE: ./src/areas/alerts/unsubscribe/queries/useAlertUnsubscribeMutation.ts


function useAlertUnsubscribeMutation(variables) {
    return (0,use_gql_mutation/* useGqlMutation */.c)({
        mutation: (mutation_graphql_default()),
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/components/page/page-content/index.tsx + 2 modules
var page_content = __webpack_require__(53170);
;// CONCATENATED MODULE: ./src/areas/alerts/unsubscribe/components/styles.ts
function components_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function components_styles_templateObject() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    components_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function components_styles_templateObject1() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: ",
        ";\n  color: ",
        ";\n"
    ]);
    components_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function components_styles_templateObject2() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  margin: ",
        " 0;\n"
    ]);
    components_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function components_styles_templateObject3() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    components_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function components_styles_templateObject4() {
    var data = components_styles_taggedTemplateLiteral([
        "\n    margin-left: 0;\n  "
    ]);
    components_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function components_styles_templateObject5() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n\n  ",
        "\n"
    ]);
    components_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function components_styles_templateObject6() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    components_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(components_styles_templateObject());
var Body = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Body",
    componentId: "sc-0-1"
})(components_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.base500;
});
var Footer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-2"
})(components_styles_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-3"
})(components_styles_templateObject3(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var styles_BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-4"
})(components_styles_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(components_styles_templateObject4()));
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-5"
})(components_styles_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/alerts/unsubscribe/components/index.tsx













var AlertUnsubscribePageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = useAlertUnsubscribeMutation(route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess, mutate = ref.mutate;
    (0,react.useEffect)(function() {
        mutate();
    }, []);
    (0,use_route_loaded/* useRouteLoaded */.N)(data);
    (0,use_page_meta_tags/* usePageMetaTags */.p)(data);
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page_content/* default */.Z, null, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data ? /*#__PURE__*/ react.createElement(AlertUnsubscribePage, {
        data: data
    }) : null);
};
var AlertUnsubscribePage = function(param) {
    var data = param.data;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var product = data.alertUnsubscribe.product;
    var ref;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles_BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: [
            {
                title: t("alerts", "alerts.title")
            }
        ]
    })), /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(Header, null, /*#__PURE__*/ react.createElement(variants.TitleMediumText, null, t("alerts", "unsubscribe.removed")), /*#__PURE__*/ react.createElement(Body, null, /*#__PURE__*/ react.createElement("span", null, t("alerts", "unsubscribe.no-more-notifications")), /*#__PURE__*/ react.createElement(ProductLink, {
        to: (ref = product === null || product === void 0 ? void 0 : product.pathName) !== null && ref !== void 0 ? ref : ""
    }, product === null || product === void 0 ? void 0 : product.name))), /*#__PURE__*/ react.createElement(Footer, null, /*#__PURE__*/ react.createElement(button_variants.PrimaryButton, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: "/"
        }
    }, t("common", "button.go-home")))));
};

;// CONCATENATED MODULE: ./src/areas/alerts/unsubscribe/index.js


var unsubscribe_AlertUnsubscribePage = AlertUnsubscribePageLoader;
unsubscribe_AlertUnsubscribePage.defaultProps = {};
unsubscribe_AlertUnsubscribePage.graphQL = (mutation_graphql_default());
unsubscribe_AlertUnsubscribePage.variables = function(param) {
    var key = param.key;
    return {
        token: key || ""
    };
};
/* harmony default export */ var unsubscribe = (unsubscribe_AlertUnsubscribePage);

// EXTERNAL MODULE: ./src/areas/list-page/my-list/index.tsx
var my_list = __webpack_require__(67363);
// EXTERNAL MODULE: ./src/areas/list-page/public-list/index.tsx
var list_page_public_list = __webpack_require__(96449);
// EXTERNAL MODULE: ./src/areas/shop-of-the-year/index.js
var areas_shop_of_the_year = __webpack_require__(84993);
// EXTERNAL MODULE: ./config/dist/markets/index.js
var markets = __webpack_require__(10439);
;// CONCATENATED MODULE: ./src/routes/nextjs-migrated-page.tsx
var NextjsMigratedPage = function() {
    return null;
};

;// CONCATENATED MODULE: ./src/routes/config.ts
function config_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function config_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            config_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function config_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




































var loginEnabledMarkets = Object.values(markets/* marketConfig */.q).filter(function(market) {
    return market.login.enabled === true;
}).map(function(market) {
    return market.countryCode;
});
var buildRouteConfig = function(market, routes) {
    var obj = config_objectSpread(config_objectSpreadProps(config_objectSpread({
        start: {
            path: "/",
            component: landing_page/* default */.Z,
            exact: true,
            metaTags: definitions.start,
            cacheControl: {
                maxAge: "1h",
                maxStale: "30m"
            }
        },
        newsletterVerify: {
            path: "/newsletter/verify",
            component: newsletter_verification
        },
        search: {
            path: "/search",
            component: areas_search/* default */.Z,
            metaTags: definitions.search
        },
        productCompare: {
            path: "/compare/products/:productIds?",
            component: areas_product_compare/* default */.Z,
            metaTags: definitions.productCompare
        },
        product: {
            path: "*--p:id(\\d+)/:section(properties|reviews|statistics)?",
            component: areas_product,
            metaTags: definitions.product,
            cacheControl: {
                maxAge: "12h",
                maxStale: "30m"
            },
            disableScrollForUrlParam: "&list=mobile-contract"
        },
        category: {
            path: "*--c:id([sv]?\\d+)",
            component: areas_category/* default */.Z,
            metaTags: definitions.category,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        categoryIndex: {
            path: "/categories",
            component: category_index/* default */.Z,
            metaTags: definitions.generic
        },
        productCollection: {
            path: "/:type(c|o)/:slug",
            component: areas_product_collection/* default */.Z,
            metaTags: definitions.productCollection,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        keywordLandingPage: {
            path: [
                "/s/:slug",
                "/sq/:query/:source?"
            ],
            component: areas_keyword_landing_page/* default */.Z,
            metaTags: definitions.keywordLandingPage,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        keywordListingPage: {
            path: "/kw/:id",
            component: areas_keyword_listing/* default */.Z,
            metaTags: definitions.keywordListing,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        productCollectionSitemap: {
            path: "/cm/:slug",
            component: areas_product_collection_sitemap/* default */.Z,
            metaTags: definitions.productCollectionSitemap,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        store: {
            path: "*--s:id(\\d+)/:section(reviews)?",
            component: areas_store/* default */.Z,
            metaTags: definitions.store
        },
        brand: {
            path: "*--b:id(\\d+)",
            component: areas_brand/* default */.Z,
            metaTags: definitions.brand
        },
        infoPage: {
            path: "*--i:id(\\d+)",
            component: info/* default */.Z,
            metaTags: definitions.infoPage,
            cacheControl: {
                maxAge: "1h",
                maxStale: "30m"
            }
        },
        prismicArticle: {
            path: "*--a:id(\\d+)",
            component: areas_article/* default */.Z,
            metaTags: definitions.article,
            cacheControl: {
                maxAge: "1h",
                maxStale: "30m"
            }
        },
        editorialContent: {
            path: [
                "*--ec:id([\\w\\-]+)",
                "*--cl:id([\\w\\-]+)",
                "/prismic-preview"
            ],
            component: areas_editorial_content/* default */.Z,
            metaTags: definitions.editorialContent
        },
        editorialContentListing: {
            path: "/articles",
            component: areas_editorial_content_listing/* default */.Z,
            metaTags: definitions.editorialContentListing
        },
        prismicInfoPage: {
            path: "/info/*--ip:id([\\w\\-]+)",
            component: areas_editorial_content/* default */.Z,
            metaTags: definitions.editorialContent
        },
        promotions: {
            path: "/promotions",
            component: promotions_page,
            metaTags: definitions.promotions
        },
        promotionProducts: {
            path: "/promotions/:id(\\w+)",
            component: promotion_products_page,
            metaTags: definitions.promotionProducts
        },
        usedProducts: {
            path: "/used",
            component: used_products_page,
            metaTags: definitions.usedProducts
        },
        themes: {
            path: "/campaigns",
            component: themes/* default */.Z,
            metaTags: definitions.campaign,
            exact: true,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        campaign: {
            path: "/campaigns/:slug?",
            // Campaign pages uses AWS and elasticsearch internally for performance
            // and load reasons, we don't want to trigger a new fetch on url change.
            fetchStrategy: "initial-only",
            component: areas_campaign/* default */.Z,
            metaTags: definitions.campaign,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        }
    }, loginEnabledMarkets.includes(market) && {
        signup: {
            path: "/signup",
            exact: true,
            component: account/* AccountLoginRedirect */.$,
            metaTags: definitions.generic
        }
    }, loginEnabledMarkets.includes(market) && {
        login: {
            path: "/login",
            component: account/* AccountLoginRedirect */.$,
            metaTags: definitions.generic
        }
    }, loginEnabledMarkets.includes(market) && {
        loginError: {
            path: "/login/error/:error?",
            component: account/* AccountLoginError */.g,
            metaTags: definitions.generic
        }
    }, loginEnabledMarkets.includes(market) && {
        profile: {
            path: "/account/profile/:section(reviews|settings|lists|shop-preference)?",
            component: my_profile_loadable/* default */.Z,
            metaTags: definitions.generic
        }
    }, loginEnabledMarkets.includes(market) && {
        user: {
            path: "/user/:id/:section(reviews|lists)?",
            component: user_profile_loadable/* default */.Z,
            metaTags: definitions.userProfile
        }
    }), {
        alertUnsubscribe: {
            path: "/alerts/unsubscribe",
            component: unsubscribe,
            metaTags: definitions.generic
        },
        unsubscribe: {
            path: "/unsubscribe",
            component: unsubscribe_landing_page_loadable/* default */.Z,
            metaTags: definitions.generic
        },
        shopOfTheYear: {
            path: "/shop-of-the-year",
            component: areas_shop_of_the_year/* ShopOfTheYearLandingPage */.U,
            metaTags: definitions.shopOfTheYear
        },
        shopOfTheYearWinners: {
            path: "/shop-of-the-year/:section",
            component: areas_shop_of_the_year/* ShopOfTheYearLandingPage */.U,
            metaTags: definitions.shopOfTheYear
        },
        shopOfTheYearCategory: {
            path: "/shop-of-the-year/:year/category/:id",
            component: areas_shop_of_the_year/* ShopOfTheYearLandingPage */.U,
            metaTags: definitions.shopOfTheYearCategory
        },
        publicList: {
            path: "/list/*--l:id",
            component: list_page_public_list/* default */.Z,
            metaTags: definitions.publicList
        },
        myList: {
            path: "/my-list/*--l:id",
            component: my_list/* default */.Z,
            metaTags: definitions.publicList
        },
        expertProductTest: {
            path: "/tests/:slug?",
            relativePath: "/tests",
            component: NextjsMigratedPage
        },
        expertToplists: {
            path: "/toplists/:slug?",
            relativePath: "/toplists",
            component: NextjsMigratedPage
        },
        expertGuide: {
            path: "/guides/:slug?",
            relativePath: "/guides",
            component: NextjsMigratedPage
        },
        expertProfile: {
            path: "/experts/profile/:slug?",
            relativePath: "/experts/profile",
            component: NextjsMigratedPage
        },
        expertCategory: {
            path: "/experts/:slug",
            relativePath: "/experts",
            component: areas_expert_category/* default */.Z,
            metaTags: definitions.expertCategory
        },
        expertLandingPage: {
            path: "/experts",
            component: areas_expert_landing_page/* default */.Z,
            metaTags: definitions.expertLandingPage,
            exact: true
        },
        changelogLandingPage: {
            path: "/changelog",
            component: areas_changelog_landing_page/* default */.Z,
            metaTags: definitions.changelogLandingPage
        },
        sponsoredArticle: {
            path: "/articles/sponsored/:slug",
            component: NextjsMigratedPage
        },
        article: {
            path: "/articles/:slug",
            component: NextjsMigratedPage
        },
        topic: {
            path: "/tp/:slug",
            component: NextjsMigratedPage
        },
        hubPreview: {
            path: "/hub-preview",
            component: NextjsMigratedPage
        },
        hubs: {
            path: "/hubs",
            component: NextjsMigratedPage
        },
        userListJoin: {
            path: "/user-list/:id/join/:role",
            component: NextjsMigratedPage
        },
        quiz: {
            path: "/quiz/:slug",
            component: NextjsMigratedPage
        },
        sanityInfoPage: {
            path: "/information/:slug?",
            component: NextjsMigratedPage
        }
    }), loginEnabledMarkets.includes(market) && {
        meFeed: {
            path: "/me/feed",
            component: NextjsMigratedPage
        }
    });
    return Object.keys(obj).reduce(function(curr, key) {
        // eslint-disable-next-line no-param-reassign
        curr[key] = config_objectSpreadProps(config_objectSpread({}, obj[key]), {
            path: (routes === null || routes === void 0 ? void 0 : routes[key]) ? routes[key].path : obj[key].path
        });
        return curr;
    }, {});
};


/***/ }),

/***/ 94954:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": () => (/* reexport */ Accordion),
  "vF": () => (/* reexport */ AccordionContent),
  "_m": () => (/* reexport */ AccordionHeader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/ui/accordion/accordion-context.tsx

var AccordionContext = /*#__PURE__*/ react.createContext({
    expanded: false,
    disabled: false,
    id: "",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggle: function() {}
});

// EXTERNAL MODULE: ./src/ui/accordion/styles.ts
var styles = __webpack_require__(14124);
;// CONCATENATED MODULE: ./src/ui/accordion/accordion.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



/**
 * Should have 2 children - AccordionHeader and AccordionContent
 */ var Accordion = function(param) {
    var children = param.children, id = param.id, onChange = param.onChange, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var ref = _slicedToArray((0,react.useState)(function() {
        return expanded;
    }), 2), expandedState = ref[0], setExpandedState = ref[1];
    var toggle = react.useCallback(function(event) {
        setExpandedState(!expandedState);
        if (onChange) {
            onChange(event, !expandedState);
        }
    }, [
        expandedState,
        setExpandedState,
        onChange
    ]);
    var context = react.useMemo(function() {
        return {
            expanded: Boolean(expandedState),
            toggle: toggle,
            disabled: Boolean(disabled),
            id: id
        };
    }, [
        expandedState,
        toggle,
        disabled,
        id
    ]);
    return /*#__PURE__*/ react.createElement(styles/* AccordionWrapper */.WL, {
        "aria-labelledby": id
    }, /*#__PURE__*/ react.createElement(AccordionContext.Provider, {
        value: context
    }, children));
};

;// CONCATENATED MODULE: ./src/ui/accordion/accordion-content.tsx



var AccordionContent = function(param) {
    var children = param.children, maxHeight = param.maxHeight;
    var ref = react.useContext(AccordionContext), expanded = ref.expanded, id = ref.id;
    return /*#__PURE__*/ react.createElement(styles/* StyledContentWrapper */.H6, {
        expanded: expanded,
        "aria-labelledby": "accordion-header".concat(id),
        maxHeight: maxHeight
    }, /*#__PURE__*/ react.createElement(styles/* StyledContent */.Hz, null, children));
};

;// CONCATENATED MODULE: ./src/ui/accordion/accordion-header.tsx



var AccordionHeader = function(param) {
    var children = param.children, onClick = param.onClick;
    var ref = react.useContext(AccordionContext), disabled = ref.disabled, expanded = ref.expanded, toggle = ref.toggle, id = ref.id;
    var handleChange = function(event) {
        if (!disabled) {
            toggle(event);
            if (onClick) {
                onClick(event);
            }
        }
    };
    return /*#__PURE__*/ react.createElement(styles/* StyledHeader */.eb, {
        disabled: disabled,
        onClick: handleChange,
        "aria-expanded": expanded,
        role: "button",
        "aria-controls": "accordion-content".concat(id),
        id: "accordion-header".concat(id)
    }, /*#__PURE__*/ react.createElement(styles/* StyledIconPlus */.Kl, {
        expanded: expanded
    }), children);
};

;// CONCATENATED MODULE: ./src/ui/accordion/index.tsx






/***/ }),

/***/ 14124:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H6": () => (/* binding */ StyledContentWrapper),
/* harmony export */   "Hz": () => (/* binding */ StyledContent),
/* harmony export */   "Kl": () => (/* binding */ StyledIconPlus),
/* harmony export */   "WL": () => (/* binding */ AccordionWrapper),
/* harmony export */   "eb": () => (/* binding */ StyledHeader)
/* harmony export */ });
/* harmony import */ var _prisjakt_ui_icon_plus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31903);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96742);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  && {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  transform: ",
        ";\n  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n  transition: max-height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var AccordionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    displayName: "AccordionWrapper",
    componentId: "sc-0-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.bg.tertiary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var StyledHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    displayName: "StyledHeader",
    componentId: "sc-0-1"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var StyledIconPlus = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_prisjakt_ui_icon_plus__WEBPACK_IMPORTED_MODULE_0__/* .IconPlus */ .S).withConfig({
    displayName: "StyledIconPlus",
    componentId: "sc-0-2"
})(_templateObject2(), function(param) {
    var expanded = param.expanded;
    return expanded ? "rotate(45deg)" : "rotate(0deg)";
});
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-3"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var StyledContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    displayName: "StyledContentWrapper",
    componentId: "sc-0-4"
})(_templateObject4(), function(param) {
    var expanded = param.expanded, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? "500px" : _maxHeight;
    return expanded ? maxHeight : "0";
});


/***/ }),

/***/ 84234:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H5": () => (/* binding */ MediumDown),
/* harmony export */   "NZ": () => (/* binding */ DesktopOnly),
/* harmony export */   "TD": () => (/* binding */ MediumUp),
/* harmony export */   "iB": () => (/* binding */ MobileOnly)
/* harmony export */ });
/* unused harmony exports TabletOnly, MobileAndDesktopOnly */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96742);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94141);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        " display: none;"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n          ",
        "\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    && {\n      ",
        "\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var hideInViewports = function(viewports) {
    return function(Component) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(Component).withConfig({
            displayName: "hideInViewports",
            componentId: "sc-0-0"
        })(_templateObject2(), viewports.map(function(viewport) {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), viewport(_templateObject()));
        }));
    };
};
var applyStyles = function(param) {
    var child = param.children, className = param.className;
    if (!(0,react__WEBPACK_IMPORTED_MODULE_2__.isValidElement)(child)) {
        return null;
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(child, {
        className: className
    });
};
/**
 * These components apply a className to their given child in order to hide it in certain viewports.
 * For them to work, they can only be given a single child that takes a `className` prop that then passes it
 * to its inner-most HTML element. If you want to give them multiple children, or if it's not suitable to
 * pass along `className` all the way down, wrap the childen in an HTML element (e.g. a `div`).
 */ var DesktopOnly = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown
])(applyStyles);
var TabletOnly = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly,
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp
])(applyStyles);
var MobileAndDesktopOnly = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumOnly */ .BC.mediumOnly
])(applyStyles);
var MobileOnly = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp
])(applyStyles);
var MediumDown = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp
])(applyStyles);
var MediumUp = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly
])(applyStyles);


/***/ }),

/***/ 13686:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nQ": () => (/* reexport */ check),
  "Sd": () => (/* reexport */ EmoticonAngry),
  "_z": () => (/* reexport */ EmoticonDissatisfied),
  "X3": () => (/* reexport */ EmoticonLaughing),
  "sS": () => (/* reexport */ EmoticonNeutral),
  "wr": () => (/* reexport */ EmoticonSmiling),
  "r7": () => (/* reexport */ star)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react@18.2.0__react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(96742);
;// CONCATENATED MODULE: ./src/ui/icons/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    g,\n    path,\n    circle {\n      fill: ",
        ";\n      stroke: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      path {\n        fill: ",
        ";\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  stop-color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  stop-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  stop-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

function iconColor(color) {
    var noFill = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, noStroke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var fillColor = noFill ? "none" : color;
    var strokeColor = noStroke ? "none" : color;
    return (0,styled_components_browser_esm.css)(_templateObject(), fillColor, strokeColor);
}
function getCheckColorFromStyle(theme, style) {
    switch(style){
        case "neutral-light":
            return theme.colors.base0;
        case "primary":
        default:
            return theme.colors.base700;
    }
}
function getStarColorFromStyle(theme, style) {
    switch(style){
        case "active":
            return theme.colors.yellove700;
        case "inactive":
        case "active-alt":
            return theme.colors.base300;
        case "inactive-alt":
            return theme.colors.base500;
        case "half-alt":
        case "half":
        default:
            return theme.colors.base700;
    }
}
function checkIconStyles(theme, iconStyle) {
    return iconColor(getCheckColorFromStyle(theme, iconStyle), true, false);
}
function starIconStyles(theme, iconStyle) {
    return iconColor(getStarColorFromStyle(theme, iconStyle), false, true);
}
var StyledCheckIcon = styled_components_browser_esm["default"].svg.withConfig({
    displayName: "StyledCheckIcon",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return checkIconStyles(p.theme, p.$styling);
});
var StyledStarIcon = styled_components_browser_esm["default"].svg.withConfig({
    displayName: "StyledStarIcon",
    componentId: "sc-0-1"
})(_templateObject3(), function(p) {
    return starIconStyles(p.theme, p.$styling);
}, function(p) {
    return (p.$styling === "half-alt" || p.$styling === "half") && (0,styled_components_browser_esm.css)(_templateObject2(), p.$styling === "half" ? "url(#halfGradient)" : "url(#halfGradientAlt)");
});
var StopFirstHalf = styled_components_browser_esm["default"].stop.withConfig({
    displayName: "StopFirstHalf",
    componentId: "sc-0-2"
})(_templateObject4(), function(p) {
    return p.theme.colors.yellove700;
});
var StopFirstHalfAlt = styled_components_browser_esm["default"].stop.withConfig({
    displayName: "StopFirstHalfAlt",
    componentId: "sc-0-3"
})(_templateObject5(), function(p) {
    return p.theme.colors.base500;
});
var StopSecondHalf = styled_components_browser_esm["default"].stop.withConfig({
    displayName: "StopSecondHalf",
    componentId: "sc-0-4"
})(_templateObject6(), function(p) {
    return p.theme.colors.base300;
});

;// CONCATENATED MODULE: ./src/ui/icons/check.tsx


var CheckIcon = function(param) {
    var _checked = param.checked, checked = _checked === void 0 ? false : _checked, _partial = param.partial, partial = _partial === void 0 ? false : _partial, _height = param.height, height = _height === void 0 ? 8 : _height, _left = param.left, left = _left === void 0 ? 0 : _left, _top = param.top, top = _top === void 0 ? 0 : _top, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "4" : _strokeWidth, _styling = param.styling, styling = _styling === void 0 ? "primary" : _styling;
    return /*#__PURE__*/ react.createElement(StyledCheckIcon, {
        $styling: styling,
        height: height,
        width: height,
        viewBox: "0 0 34 34",
        fill: "none",
        strokeLinecap: "miter",
        strokeLinejoin: "butt",
        strokeWidth: strokeWidth,
        stroke: "currentcolor",
        style: {
            left: left,
            top: top
        }
    }, checked && /*#__PURE__*/ react.createElement("path", {
        d: "M3 16 L14 24 26 4"
    }), partial && /*#__PURE__*/ react.createElement("path", {
        d: "M4 16 L24 16"
    }));
};
/* harmony default export */ var check = (CheckIcon);

;// CONCATENATED MODULE: ./src/ui/icons/star.tsx


var StarIcon = function(param) {
    var title = param.title, _styling = param.styling, styling = _styling === void 0 ? "inactive" : _styling, _height = param.height, height = _height === void 0 ? 13 : _height, _secondaryColors = param.secondaryColors, secondaryColors = _secondaryColors === void 0 ? false : _secondaryColors;
    var modifier = styling;
    if (secondaryColors) {
        modifier = "".concat(styling, "-alt");
    }
    return /*#__PURE__*/ react.createElement(StyledStarIcon, {
        $styling: modifier,
        height: height,
        width: height,
        viewBox: "0 0 13 13"
    }, /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "halfGradient"
    }, /*#__PURE__*/ react.createElement(StopFirstHalf, {
        offset: "50%"
    }), /*#__PURE__*/ react.createElement(StopSecondHalf, {
        offset: "50%"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "halfGradientAlt"
    }, /*#__PURE__*/ react.createElement(StopFirstHalfAlt, {
        offset: "50%"
    }), /*#__PURE__*/ react.createElement(StopSecondHalf, {
        offset: "50%"
    }))), title && /*#__PURE__*/ react.createElement("title", null, title), /*#__PURE__*/ react.createElement("path", {
        d: "M13 4.805c0 .114-.068.24-.203.375L9.96 7.945l.672 3.907c.005.036.008.088.008.156a.46.46 0 0 1-.082.277.276.276 0 0 1-.239.113.632.632 0 0 1-.312-.093L6.5 10.46l-3.508 1.844a.664.664 0 0 1-.312.093c-.11 0-.192-.037-.246-.113a.46.46 0 0 1-.082-.277c0-.031.005-.084.015-.156l.672-3.907L.195 5.18C.065 5.04 0 4.914 0 4.805c0-.193.146-.313.438-.36l3.921-.57L6.117.32c.1-.213.227-.32.383-.32s.284.107.383.32L8.64 3.875l3.921.57c.292.047.438.167.438.36z",
        fill: "#002136"
    }));
};
/* harmony default export */ var star = (StarIcon);

;// CONCATENATED MODULE: ./src/ui/icons/emoticons.tsx

var EmoticonAngry = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFF",
        fillOpacity: "0",
        d: "M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2zm0 14c-3.866 0-7 3.526-7 7.875 0 0 3.542 1.125 7.063 1.125C19.542 25 23 23.875 23 23.875 23 19.525 19.866 16 16 16z"
    }), /*#__PURE__*/ react.createElement("path", {
        stroke: color,
        strokeWidth: "2",
        d: "M10.035 23.13c1.178.314 3.608.87 6.028.87 2.38 0 4.749-.551 5.903-.865-.152-1.618-.794-3.073-1.764-4.164C19.127 17.76 17.645 17 16 17s-3.127.761-4.202 1.97c-.97 1.091-1.611 2.544-1.763 4.16z"
    }), /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M23.741 8.5l-3.586 4h5.09M8.504 8.5l3.587 4H7"
    }))));
};
var EmoticonDissatisfied = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M20 18a6 6 0 0 0-6 6M22.618 12.25c-.329.332-.704.5-1.118.5-.414 0-.79-.168-1.06-.44l2.178-.06zm-11 0c-.329.332-.704.5-1.118.5-.414 0-.79-.168-1.06-.44l2.178-.06z"
    }))));
};
var EmoticonNeutral = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("circle", {
        cx: "10",
        cy: "12",
        r: "1"
    }), /*#__PURE__*/ react.createElement("circle", {
        cx: "22",
        cy: "12",
        r: "1"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M12 20.5h8"
    }))));
};
var EmoticonSmiling = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M10 18a6 6 0 1 0 12 0M11 12a.997.997 0 0 1-1 1 .997.997 0 0 1-1-1 .997.997 0 0 1 1-1 .997.997 0 0 1 1 1zm12 0a.997.997 0 0 1-1 1 .997.997 0 0 1-1-1 .997.997 0 0 1 1-1 .997.997 0 0 1 1 1z"
    }))));
};
var EmoticonLaughing = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "none",
        d: "M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2zm.063 14C12.542 16 9 17.125 9 17.125 9 21.475 12.134 25 16 25s7-3.526 7-7.875c0 0-3.458-1.125-6.937-1.125z"
    }), /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M10.035 17.87c1.178-.314 3.608-.87 6.028-.87 2.38 0 4.749.551 5.903.865-.152 1.618-.794 3.073-1.764 4.164C19.127 23.24 17.645 24 16 24s-3.127-.761-4.202-1.97c-.97-1.091-1.611-2.544-1.763-4.16zM13.215 12.456a3 3 0 1 0-5.909 1.042M24.694 13.498a3 3 0 0 0-5.909-1.042"
    }))));
};

;// CONCATENATED MODULE: ./src/ui/icons/index.ts






/***/ }),

/***/ 35050:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": () => (/* binding */ InternalLink)
/* harmony export */ });
/* unused harmony export ExternalLink */
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3616);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96742);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var InternalLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(react_router_dom__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU).withConfig({
    displayName: "InternalLink",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.theme.text.linkExternal;
}, function(props) {
    return props.theme.text.linkExternalHover;
});
var ExternalLink = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].a.attrs({
    rel: "noopener nofollow",
    target: "_blank"
}).withConfig({
    displayName: "ExternalLink",
    componentId: "sc-0-1"
})(_templateObject1(), function(props) {
    return props.theme.text.linkExternal;
}, function(props) {
    return props.theme.text.linkExternalHover;
});


/***/ }),

/***/ 92873:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": () => (/* binding */ zindex)
/* harmony export */ });
var zindex = {
    modal: 200,
    menu: {
        header: 107,
        searchSuggestions: 110,
        searchOverlay: 100,
        searchBar: 120,
        left: 105,
        sticky: {
            normal: 10,
            background: {
                default: 99,
                isSticky: 102
            }
        },
        filter: 107,
        offerlistFilters: 106,
        experimentEditor: 101,
        mega: 107,
        mobile: {
            overlay: 108,
            content: 109
        }
    },
    overlay: 106,
    productFinder: {
        searchOverlay: 100,
        searchResults: 101
    },
    ads: {
        outside: 100
    },
    graph: 99,
    popover: 4,
    tooltip: 103,
    actionButtonDropdown: 103,
    actionButton: 2
};


/***/ }),

/***/ 40757:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ handleClickOutBounce)
/* harmony export */ });
var handleClickOutBounce = function(callback) {
    // Start a timer when a user clicks out on a product
    // if they return to Prisjakt within 15 seconds
    // display an error report button in the price row.
    var startTime = Date.now();
    var onRefocus = function() {
        if (Date.now() - startTime > 15000 && document.visibilityState === "visible") {
            document.removeEventListener("visibilitychange", onRefocus);
            return;
        }
        if (document.visibilityState === "visible") {
            callback();
            document.removeEventListener("visibilitychange", onRefocus);
        }
    };
    document.addEventListener("visibilitychange", onRefocus);
};


/***/ }),

/***/ 58781:
/***/ ((module) => {

module.exports = "query serverMe {\n  me {\n    id\n    uuid\n    intercomHash\n    userlikeChatContactAuthToken\n    reviewCount\n    name\n    displayName\n    memberSince\n    statistics {\n      helpfulScore\n    }\n    likes {\n      reviews\n      lists\n      shops\n    }\n    dislikes {\n      reviews\n      lists\n      shops\n    }\n    email\n    hasActivePushTokens\n    alertSettings {\n      email\n      push\n    }\n    lists(limit: 30, sort: \"accessed\") {\n      pageInfo {\n        hasNext\n      }\n      nodes {\n        id\n        ... on ListCategory {\n          name\n          inventory\n        }\n      }\n    }\n    alertsSummary {\n      products {\n        productId\n        alertId\n      }\n    }\n    reviewedProducts {\n      productId\n      rating\n    }\n    schibstedProfile {\n      schibstedDisplayName\n      avatar(size: _200)\n    }\n  }\n}"

/***/ }),

/***/ 60591:
/***/ ((module) => {

module.exports = "query myProfile($offset: Int, $getProduct: Boolean = true, $getStore: Boolean = true) {\n  me {\n    reviews(offset: $offset, limit: 10) {\n      totalItems\n      pageInfo {\n        limit\n        offset\n        hasNext\n        hasPrevious\n      }\n      nodes {\n        ...GenericUserReview\n      }\n    }\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}"

/***/ }),

/***/ 97731:
/***/ ((module) => {

module.exports = "query userQuery($id: Int!, $offset: Int, $getProduct: Boolean = true, $getStore: Boolean = true, $isReviewsTab: Boolean = false, $isListsTab: Boolean = false, $limit: Int = 30, $sort: String = \"published\", $includeSchibstedProfile: Boolean = false) {\n  user(id: $id, includeSchibstedProfile: $includeSchibstedProfile) {\n    id\n    displayName\n    reviewCount\n    memberSince\n    statistics {\n      helpfulScore\n    }\n    reviews(offset: $offset) @include(if: $isReviewsTab) {\n      totalItems\n      pageInfo {\n        limit\n        offset\n        hasNext\n        hasPrevious\n      }\n      nodes {\n        ...GenericUserReview\n      }\n    }\n    ...userLists\n    schibstedProfile @include(if: $includeSchibstedProfile) {\n      schibstedDisplayName\n      avatar(size: _200)\n    }\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}\n\nfragment userLists on UserProfile {\n  lists(offset: $offset, limit: $limit, sort: $sort) @include(if: $isListsTab) {\n    pageInfo {\n      limit\n      offset\n      hasNext\n      hasPrevious\n    }\n    nodes {\n      ...listItem\n    }\n  }\n}\n\nfragment listItem on ListItem {\n  id\n  ... on AlertProduct {\n    __typename\n    priceThreshold\n    alertType\n    priceStep\n    storePreference\n    storeGradeThreshold\n    product {\n      preloaded: __typename\n      id\n      name\n      stockStatus\n      category {\n        id\n        name\n      }\n      latestPriceChange {\n        time(fromNow: true)\n        amount\n      }\n      priceSummary {\n        regular\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      media {\n        first(width: _280)\n      }\n      pathName\n    }\n  }\n  ... on AlertSearch {\n    __typename\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ...listProduct\n  ... on ListSearch {\n    __typename\n    quantity\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ... on ListCategory {\n    __typename\n    name\n    created(fromNow: true)\n    icon\n    pathName\n    itemsCount\n    priceSummary\n    inventory\n    visibility\n  }\n}\n\nfragment listProduct on ListProduct {\n  __typename\n  quantity\n  product {\n    preloaded: __typename\n    id\n    name\n    description\n    category {\n      id\n      name\n    }\n    priceSummary {\n      regular\n      alternative\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _280)\n    }\n    pathName\n  }\n}"

/***/ }),

/***/ 7432:
/***/ ((module) => {

module.exports = "mutation dislikeShop($shopId: String!) {\n  dislikeShop(shopId: $shopId) {\n    success\n  }\n}"

/***/ }),

/***/ 70518:
/***/ ((module) => {

module.exports = "mutation likeShop($shopId: String!) {\n  likeShop(shopId: $shopId) {\n    success\n  }\n}"

/***/ }),

/***/ 74035:
/***/ ((module) => {

module.exports = "query meShopPreferenceState {\n  me {\n    likes {\n      shops\n    }\n    dislikes {\n      shops\n    }\n  }\n}"

/***/ }),

/***/ 91302:
/***/ ((module) => {

module.exports = "mutation updateSubsciptionSetting($id: ID!, $subscribed: Boolean!) {\n  updateSubscriptionSetting(id: $id, subscribed: $subscribed) {\n    channels {\n      mail {\n        id\n        subscribed\n      }\n      push {\n        id\n        subscribed\n      }\n    }\n  }\n}"

/***/ }),

/***/ 12541:
/***/ ((module) => {

module.exports = "mutation alertUnsubscribe($token: String!) {\n  alertUnsubscribe(token: $token) {\n    product {\n      pathName\n      name\n    }\n  }\n}"

/***/ }),

/***/ 2222:
/***/ ((module) => {

module.exports = "query article($id: Int!) {\n  article(id: $id) {\n    id\n    title\n    preamble\n    body\n    byline\n    publishedAt\n    featured\n    imageUrl\n    imageCaption\n    metaTitle\n    metaDescription\n    pathName\n    related {\n      campaign {\n        id\n        name\n        slug\n        title {\n          short\n        }\n        description {\n          short\n        }\n        web_uri {\n          mobile\n          desktop\n          responsive\n        }\n      }\n      category {\n        id\n        name\n        pathName\n        path {\n          id\n          name\n          pathName\n        }\n      }\n      articles {\n        id\n        title\n        preamble\n        imageUrl\n        pathName\n        publishedAt\n      }\n    }\n  }\n}"

/***/ }),

/***/ 51882:
/***/ ((module) => {

module.exports = "query brandPage($id: ID!) {\n  brand(id: $id) {\n    ...brandPage\n    ...brandProductListing\n    ...videoListing\n    ...categoryListing\n    ...premiumBrandContent\n  }\n}\n\nfragment brandPage on Brand {\n  id\n  name\n  pathName\n  featured\n  logo\n  externalUri\n  externalUriText\n  premium\n  header\n  description\n  productsTotal\n}\n\nfragment brandProductListing on Brand {\n  products(limit: 10, onlyFromFeaturedStores: true) {\n    nodes {\n      preloaded: __typename\n      id\n      name\n      pathName\n      description\n      media {\n        first(width: _280)\n      }\n      priceSummary {\n        regular\n        alternative\n      }\n      userReviewSummary {\n        rating\n      }\n      aggregatedRating {\n        score\n      }\n    }\n  }\n}\n\nfragment videoListing on Brand {\n  media {\n    videos {\n      source_id\n      thumbnail\n      embed_url\n    }\n  }\n}\n\nfragment categoryListing on Brand {\n  categories(limit: 5) {\n    nodes {\n      preloaded: __typename\n      id\n      name\n      pathName\n      productCollection\n      logo(width: _192)\n    }\n  }\n  ...categoryTreeListing\n}\n\nfragment categoryTreeListing on Brand {\n  categoryTree(depth: 3) {\n    ...CategoryFields\n    children {\n      ...CategoryFields\n      children {\n        ...CategoryFields\n      }\n    }\n  }\n}\n\nfragment CategoryFields on CategoryTree {\n  preloaded: __typename\n  id\n  name\n  name_hierarchical\n  logo\n  semantic_id\n  product_collection\n}\n\nfragment premiumBrandContent on Brand {\n  featuredProducts {\n    id\n    name\n    pathName\n    media {\n      first(width: _800)\n    }\n    priceSummary {\n      regular\n      alternative\n      inStock\n    }\n    category {\n      id\n      name\n      productCollection\n    }\n  }\n}"

/***/ }),

/***/ 19478:
/***/ ((module) => {

module.exports = "query campaignPage($id: ID, $campaignId: ID, $campaignSlug: ID, $filters: [CampaignFilter!]!, $campaignDeals: Boolean = false, $onlyFromFeaturedStores: Boolean = false, $getDealsProducts: Boolean = false, $categoryIds: [ID], $page: Int! = 0, $sortType: SearchV3Sorting!, $filtersV2: [SearchFilter!]!) {\n  ...campaignDealsRoot @include(if: $campaignDeals)\n  ...dealsProducts @include(if: $getDealsProducts)\n  campaign(id: $id, slug: $campaignSlug, filters: $filters) {\n    id\n    name\n    slug\n    tagline\n    web_uri {\n      mobile\n      desktop\n      responsive\n    }\n    facetted {\n      title\n      seoTitle\n      description\n      seoDescription\n      tagline\n      canonical\n      isFacetted\n    }\n    title {\n      short\n      long\n      page\n    }\n    description {\n      short\n      long\n      page\n    }\n    descriptionHtml {\n      short\n      long\n      page\n    }\n    banners {\n      url\n      type\n      imageUrl\n    }\n    state\n    type\n    start(format: \"x\")\n    end(format: \"x\")\n    countdown(format: \"x\")\n    articles {\n      id\n      title\n      preamble\n      body\n      byline\n      publishedAt\n      featured\n      imageUrl\n      imageCaption\n      pathName\n    }\n  }\n  ...campaignContent\n}\n\nfragment campaignContent on RootQuery {\n  articles(type: CAMPAIGN) {\n    id\n    publishedAt\n    title\n    preamble\n    imageUrl\n    imageCaption\n    pathName\n    featured\n  }\n  campaigns(inactive: true) {\n    id\n    name\n    slug\n    type\n    tagline\n    title {\n      short\n      long\n      page\n    }\n    description {\n      short\n      long\n      page\n    }\n    web_uri {\n      mobile\n      desktop\n      responsive\n    }\n    media {\n      images {\n        featured\n      }\n    }\n    banners {\n      url\n      type\n      imageUrl\n    }\n    state\n    start(format: \"x\")\n    end(format: \"x\")\n    countdown(format: \"x\")\n  }\n  categoryTree(depth: 7) {\n    id\n    name\n    children {\n      id\n      name\n      children {\n        id\n        name\n        children {\n          id\n          name\n          children {\n            id\n            name\n            children {\n              id\n              name\n              children {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment dealsProducts on RootQuery {\n  searchV3 {\n    products(\n      sortType: $sortType\n      page: $page\n      filters: $filtersV2\n      order: desc\n      searchType: deals\n    ) {\n      items {\n        ... on ProductCard {\n          productId\n          priceDrop\n          coreProperties\n          dealUpdateTime\n          logo\n          name\n          aggregatedRating {\n            score\n            count\n          }\n          productLink\n          storeCount\n          categoryName\n          bestOffer {\n            storeId\n            stockStatus\n            shopOfferId\n            storeName\n            originalPrice\n            memberPrice\n            price\n            offerLink\n            featured\n            priceExpires\n            membershipRequiresCompensation\n          }\n          __typename\n        }\n      }\n      leafCategories {\n        key\n        count\n        name\n        logo\n      }\n      categoryAggregations {\n        key\n        parentKey\n        count\n        name\n        logo\n      }\n      brandsAggregations {\n        key\n        count\n        name\n      }\n      priceHistogram {\n        min\n        max\n        count\n      }\n      hasMorePages\n      didYouMean\n      numberOfHits\n    }\n  }\n}\n\nfragment campaignDealsRoot on RootQuery {\n  campaignDeals(\n    campaignId: $campaignId\n    onlyFromFeaturedStores: $onlyFromFeaturedStores\n    categoryIds: $categoryIds\n  ) {\n    id\n    externalUri\n    price {\n      diffPercentage\n      previousPrice\n      compareDaysAgo\n      id\n    }\n    store {\n      id\n      name\n      hasLogo\n      featured\n    }\n    product {\n      preloaded: __typename\n      description\n      id\n      name\n      pathName\n      media {\n        first(width: _280)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      priceSummary {\n        regular\n        alternative\n        inStock\n        count\n      }\n      category {\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}"

/***/ }),

/***/ 98553:
/***/ ((module) => {

module.exports = "query campaignPageThemes {\n  ...campaignContent\n}\n\nfragment campaignContent on RootQuery {\n  articles(type: CAMPAIGN) {\n    id\n    publishedAt\n    title\n    preamble\n    imageUrl\n    imageCaption\n    pathName\n    featured\n  }\n  campaigns(inactive: true) {\n    id\n    name\n    slug\n    type\n    tagline\n    title {\n      short\n      long\n      page\n    }\n    description {\n      short\n      long\n      page\n    }\n    web_uri {\n      mobile\n      desktop\n      responsive\n    }\n    media {\n      images {\n        featured\n      }\n    }\n    banners {\n      url\n      type\n      imageUrl\n    }\n    state\n    start(format: \"x\")\n    end(format: \"x\")\n    countdown(format: \"x\")\n  }\n  categoryTree(depth: 7) {\n    id\n    name\n    children {\n      id\n      name\n      children {\n        id\n        name\n        children {\n          id\n          name\n          children {\n            id\n            name\n            children {\n              id\n              name\n              children {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}"

/***/ }),

/***/ 44125:
/***/ ((module) => {

module.exports = "query getCategoryIndex {\n  categoryIndex {\n    id\n    name\n    pathName\n    type\n  }\n}"

/***/ }),

/***/ 48472:
/***/ ((module) => {

module.exports = "query categoryPage($id: ID!, $offset: Int!, $filterId: ID, $brand: ID, $sort: String, $direction: SortDirection, $compareIds: [ID] = [\"_core_\"], $isServices: Boolean!, $campaignId: ID, $categoryIds: [ID], $onlyFromFeaturedStores: Boolean, $isVirtualCategory: Boolean!) {\n  categoryTree(idId: $id, flattenChildren: true, flattenChildrenLimit: 15) {\n    id\n    name\n    logo\n    semantic_id\n    product_collection\n    externalUri\n    children {\n      id\n      name\n      semantic_id\n      product_collection\n      externalUri\n      logo\n    }\n  }\n  category(id: $id, filterId: $filterId, brandId: $brand) @skip(if: $isServices) {\n    ...category\n    ...subCategoryListing\n    ...categoryProductListing\n    brand {\n      ...brandPage\n    }\n  }\n  ...campaignDealsRoot\n  newProducts: recommendation {\n    newReleases(categoryId: $id, limit: 16, onlyFromFeaturedStores: false) @skip(if: $isVirtualCategory) {\n      nodes {\n        id\n        name\n        pathName\n        description\n        highlight\n        isExpertTopRated\n        category {\n          name\n          pathName\n        }\n        popularity {\n          total\n          inCategory\n        }\n        brand {\n          name\n          logo\n        }\n        media {\n          first(width: _280)\n        }\n        priceSummary {\n          regular\n          alternative\n          includeShipping\n          count(type: _regular)\n        }\n        userReviewSummary {\n          rating\n          count\n        }\n        aggregatedRating {\n          score\n          count\n        }\n      }\n    }\n  }\n}\n\nfragment category on Category {\n  id\n  filterId\n  name\n  aliases\n  description(html: true)\n  logo\n  immediateProducts\n  hasAdultContent\n  productCount: products_total\n  storesCount\n  pathName\n  semanticId\n  defaultLayoutMode\n  path {\n    id\n    name\n    pathName\n  }\n  markets {\n    market\n    lang\n    desktop\n  }\n  articles {\n    id\n    title\n    preamble\n    body\n    byline\n    publishedAt\n    featured\n    imageUrl\n    imageCaption\n    pathName\n  }\n  productCollection\n  newPopularSearchTerms {\n    popularKeywords {\n      name\n      url\n    }\n    trendingKeywords {\n      name\n      url\n    }\n  }\n  popularProducts: products(\n    limit: 24\n    sort: \"popularity\"\n    onlyFromFeaturedStores: true\n  ) {\n    nodes {\n      id\n      name\n      pathName\n      description\n      highlight\n      isExpertTopRated\n      category {\n        name\n        pathName\n      }\n      popularity {\n        total\n        inCategory\n      }\n      brand {\n        name\n        logo\n      }\n      media {\n        first(width: _280)\n      }\n      priceSummary {\n        regular\n        alternative\n        includeShipping\n        count(type: _regular)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      dealInfo {\n        dealPercentage\n      }\n    }\n  }\n  trendingProducts(onlyFromFeaturedStores: true) {\n    id\n    name\n    pathName\n    category\n    price\n    url\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    imageUrl\n    isExpertTopRated\n  }\n}\n\nfragment subCategoryListing on Category {\n  categories {\n    nodes {\n      id\n      name\n      logo\n      pathName\n      path {\n        id\n        name\n      }\n    }\n  }\n  brands(limit: 4, sort: \"popularity\") {\n    nodes {\n      id\n      name\n    }\n  }\n  categoryTree {\n    id\n    name\n    logo\n    semantic_id\n    product_collection\n    externalUri\n    children {\n      id\n      name\n      semantic_id\n      product_collection\n      externalUri\n      logo\n    }\n  }\n}\n\nfragment brandPage on Brand {\n  id\n  name\n  pathName\n  featured\n  logo\n  externalUri\n  externalUriText\n  premium\n  header\n  description\n  productsTotal\n}\n\nfragment categoryProductListing on Category {\n  products(\n    offset: $offset\n    limit: 24\n    sort: $sort\n    direction: $direction\n    brand: $brand\n  ) {\n    pageInfo {\n      offset\n      limit\n      hasNext\n      hasPrevious\n      selectedProperties {\n        id\n        name\n      }\n      sort {\n        name\n        direction\n        available\n      }\n    }\n    nodes {\n      preloaded: __typename\n      id\n      name\n      pathName\n      description\n      category {\n        name\n        pathName\n      }\n      brand {\n        name\n        featured\n        logo\n      }\n      media {\n        first(width: _280)\n      }\n      priceSummary {\n        regular\n        alternative\n        includeShipping\n        count(type: _regular)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      campaigns {\n        id\n      }\n      dealInfo {\n        dealPercentage\n      }\n      properties(ids: $compareIds) {\n        nodes {\n          id\n          type\n          name\n          pretty(mode: simple)\n          prettyTable: pretty(mode: table)\n          prettyVerbose: pretty(mode: verbose)\n        }\n      }\n      popularity {\n        total\n        inCategory\n      }\n    }\n  }\n}\n\nfragment campaignDealsRoot on RootQuery {\n  campaignDeals(\n    campaignId: $campaignId\n    onlyFromFeaturedStores: $onlyFromFeaturedStores\n    categoryIds: $categoryIds\n  ) {\n    id\n    externalUri\n    price {\n      diffPercentage\n      previousPrice\n      compareDaysAgo\n      id\n    }\n    store {\n      id\n      name\n      hasLogo\n      featured\n    }\n    product {\n      preloaded: __typename\n      description\n      id\n      name\n      pathName\n      media {\n        first(width: _280)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      priceSummary {\n        regular\n        alternative\n        inStock\n        count\n      }\n      category {\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}"

/***/ }),

/***/ 84261:
/***/ ((module) => {

module.exports = "query changelogArticles {\n  prismicArticles(type: CHANGELOG) {\n    pageInfo {\n      offset\n      limit\n    }\n    nodes {\n      id\n      pathName\n      publishedAt(format: \"DD MMM, YYYY\")\n      data {\n        title {\n          ...richContentFragment\n        }\n        secondaryTitle {\n          ...richContentFragment\n        }\n        metaDescription {\n          ...richContentFragment\n        }\n        metaDescriptionLong {\n          ...richContentFragment\n        }\n        featuredImage {\n          ...imageFragment\n        }\n      }\n    }\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}"

/***/ }),

/***/ 50973:
/***/ ((module) => {

module.exports = "query prismicArticlesQuery($page: Int, $pageSize: Int) {\n  prismicArticles(type: EDITORIAL_CONTENT, page: $page, pageSize: $pageSize) {\n    pageInfo {\n      limit\n      offset\n      hasNext\n      hasPrevious\n    }\n    totalCount\n    nodes {\n      id\n      pathName\n      publishedAt\n      updatedAt\n      data {\n        title {\n          ...richContentFragment\n        }\n        metaDescription {\n          ...richContentFragment\n        }\n        featuredImage {\n          ...imageFragment\n        }\n      }\n    }\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}"

/***/ }),

/***/ 81474:
/***/ ((module) => {

module.exports = "query prismicArticle($id: ID!, $ref: String) {\n  prismicArticle(id: $id, ref: $ref) {\n    id\n    uid\n    pathName\n    slugs\n    tags\n    updatedAt\n    publishedAt\n    type\n    data {\n      meta {\n        title\n        description\n      }\n      metaDescription {\n        ...richContentFragment\n      }\n      featuredImage {\n        ...imageFragment\n      }\n      body {\n        type\n        label\n        primary {\n          __typename\n          ... on PrismicSliceImage {\n            imageLinkOrPath\n            image {\n              ...imageFragment\n            }\n          }\n          ... on PrismicSliceImageText {\n            imageLinkOrPath\n            backgroundColor\n            gridLayout\n            text {\n              ...richContentFragment\n            }\n            image {\n              ...imageFragment\n            }\n          }\n          ... on PrismicSliceTextImage {\n            imageLinkOrPath\n            backgroundColor\n            gridLayout\n            text {\n              ...richContentFragment\n            }\n            image {\n              ...imageFragment\n            }\n          }\n          ... on PrismicSliceTextText {\n            backgroundColor\n            gridLayout\n            textBefore {\n              ...richContentFragment\n            }\n            textAfter {\n              ...richContentFragment\n            }\n          }\n          ... on PrismicSliceHeroTitle {\n            textColor\n            textAlign\n            heroBackgroundColor\n            titleBoxWidth\n            title {\n              ...richContentFragment\n            }\n            secondaryTitle {\n              ...richContentFragment\n            }\n            heroImage {\n              url\n              dimensions {\n                width\n                height\n              }\n              alt\n              copyright\n              Mobile {\n                url\n                dimensions {\n                  width\n                  height\n                }\n                alt\n                copyright\n              }\n              Desktop {\n                url\n                dimensions {\n                  width\n                  height\n                }\n                alt\n                copyright\n              }\n            }\n          }\n          ... on PrismicSliceText {\n            text {\n              ...richContentFragment\n            }\n            backgroundColor\n            textAlign\n          }\n          ... on PrismicSliceProduct {\n            title {\n              ...richContentFragment\n            }\n            product {\n              ...toplistProduct\n            }\n          }\n          ... on PrismicSlicePopularProducts {\n            popularFacet {\n              title\n              url\n              linkText\n              products {\n                id\n                pathName\n                name\n                media {\n                  first(width: _280)\n                }\n                priceSummary {\n                  regular\n                  alternative\n                  inStock\n                }\n                userReviewSummary {\n                  rating\n                  count\n                }\n                aggregatedRating {\n                  score\n                  count\n                }\n                popularity {\n                  total\n                  inCategory\n                }\n                brand {\n                  name\n                }\n                diffPercentage\n                isExpertTopRated\n              }\n            }\n          }\n          ... on PrismicSliceProductList {\n            title {\n              ...richContentFragment\n            }\n            listType\n            products {\n              id\n              name\n              pathName\n              media {\n                first(width: _280)\n              }\n              userReviewSummary {\n                rating\n                count\n              }\n              aggregatedRating {\n                score\n                count\n              }\n              priceSummary {\n                regular\n                alternative\n                inStock\n              }\n              diffPercentage\n              isExpertTopRated\n            }\n          }\n          ... on PrismicSliceVideo {\n            video {\n              url\n            }\n            backgroundColor\n          }\n          ... on PrismicSliceVideoText {\n            text {\n              ...richContentFragment\n            }\n            video {\n              url\n            }\n            gridLayout\n            backgroundColor\n          }\n          ... on PrismicSliceTextVideo {\n            text {\n              ...richContentFragment\n            }\n            video {\n              url\n            }\n            gridLayout\n            backgroundColor\n          }\n          ... on PrismicSliceCallToAction {\n            buttonTitle\n            buttonUrl\n          }\n          ... on PrismicSliceFaqSection {\n            faqTitle {\n              ...richContentFragment\n            }\n            items {\n              question {\n                ...richContentFragment\n              }\n              answer {\n                ...richContentFragment\n              }\n            }\n          }\n          ... on PrismicFrontPageBanner {\n            link\n            textColor\n            buttonText\n            buttonColor\n            image {\n              ...imageFragment\n            }\n            title {\n              ...richContentFragment\n            }\n            subtitle {\n              ...richContentFragment\n            }\n          }\n          ... on PrismicSliceCategories {\n            optionalTitle {\n              ...richContentFragment\n            }\n            categories {\n              type\n              id\n              name\n              path\n              image\n              fallbackImage\n            }\n          }\n          ... on PrismicSliceArticleCarousel {\n            articles {\n              id\n              image {\n                ...imageFragment\n              }\n              slugs\n              title {\n                ...richContentFragment\n              }\n              preamble {\n                ...richContentFragment\n              }\n            }\n          }\n          ... on PrismicSliceColumns {\n            columnsTitle {\n              ...richContentFragment\n            }\n            columnsDescription {\n              ...richContentFragment\n            }\n            pictureCarousel\n            columns {\n              backgroundcolor\n              buttonText {\n                ...richContentFragment\n              }\n              buttonLinkOrPath\n              buttonType\n              text {\n                ...richContentFragment\n              }\n              title {\n                ...richContentFragment\n              }\n              image {\n                ...imageFragment\n              }\n              imageLinkOrPath\n              imageIsOfProduct\n              textColor\n              heightOfImage\n              useImageAsBackground\n            }\n          }\n          ... on PrismicSliceNewsletter {\n            header\n            width\n          }\n        }\n      }\n      title {\n        ...richContentFragment\n      }\n    }\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment toplistProduct on Product {\n  id\n  name\n  pathName\n  userReviewSummary {\n    rating\n    count\n  }\n  aggregatedRating {\n    score\n    count\n  }\n  diffPercentage\n  category {\n    name\n    pathName\n  }\n  media {\n    first(width: _280)\n  }\n  priceSummary {\n    regular\n    count\n  }\n  popularity {\n    inCategory\n  }\n  prices {\n    nodes {\n      shopOfferId\n      condition\n      availability {\n        condition\n      }\n      price {\n        inclShipping\n        exclShipping\n      }\n      primaryMarket\n      store {\n        id\n        name\n        logo\n        hasLogo\n        featured\n        userReviewSummary {\n          rating\n          count\n        }\n        market\n      }\n      stock {\n        status\n      }\n      externalUri\n    }\n  }\n}"

/***/ }),

/***/ 51307:
/***/ ((module) => {

module.exports = "query expertCategoryPageQuery($slug: String!) {\n  expertCategoryPage(url: $slug) {\n    category {\n      name\n      activeExperts\n      description\n      descriptionImage\n      fullUrl\n    }\n    toplistHeadlines {\n      __typename\n      id\n      url\n      name\n      toplists {\n        publishedAt\n        date(format: \"D MMMM\")\n        expert {\n          name\n          avatar\n          url\n        }\n        products {\n          id\n          order\n          image\n        }\n        headlineInfo {\n          otherExperts {\n            name\n            avatar\n          }\n          likes\n        }\n        description {\n          type\n          data\n        }\n      }\n    }\n    tests {\n      __typename\n      id\n      publishedAt\n      url\n      title\n      likes\n      grade\n      gradeNotConverted\n      date(format: \"D MMMM\")\n      expert {\n        name\n        avatar\n        url\n      }\n      imageWithSize(size: x2) {\n        src\n      }\n    }\n    guides {\n      __typename\n      id\n      publishedAt\n      url\n      title\n      likes\n      date(format: \"D MMMM\")\n      expert {\n        name\n        avatar\n        url\n      }\n      image(size: x2) {\n        src\n        alt\n      }\n    }\n  }\n}"

/***/ }),

/***/ 6547:
/***/ ((module) => {

module.exports = "query ExpertLandingPage($skipNews: Int = 0, $skipGuides: Int = 0, $skipToplists: Int = 0, $skipTests: Int = 0, $popCategories: [String], $limit: Int) {\n  expertLandingPage(\n    skipNews: $skipNews\n    skipGuides: $skipGuides\n    skipToplists: $skipToplists\n    skipTests: $skipTests\n    limit: $limit\n  ) {\n    experts {\n      id\n      name\n      avatar\n      url\n    }\n    expertCount\n    items {\n      ...listItems\n    }\n    menuCategories {\n      label\n      icon\n      children {\n        label\n        url\n      }\n    }\n  }\n  popularCategories(popCategories: $popCategories, limit: $limit) {\n    items {\n      ...listItems\n    }\n  }\n}\n\nfragment listItems on LandingPageItems {\n  tests {\n    __typename\n    id\n    publishedAt\n    url\n    title\n    grade\n    likes\n    date(format: \"D MMMM\")\n    imageWithSize(size: x2) {\n      src\n      alt\n    }\n    expert {\n      name\n      avatar\n      url\n    }\n    category {\n      name\n      url\n    }\n    product {\n      category {\n        name\n      }\n    }\n  }\n  toplists {\n    __typename\n    id\n    publishedAt\n    id\n    title\n    publishedAt\n    date(format: \"D MMMM\")\n    headlineInfo {\n      url\n      likes\n      otherExperts {\n        name\n        avatar\n      }\n    }\n    products {\n      id\n      order\n      image\n    }\n    description {\n      type\n      data\n    }\n    category {\n      name\n      url\n    }\n    expert {\n      name\n      avatar\n      url\n    }\n  }\n}"

/***/ }),

/***/ 13278:
/***/ ((module) => {

module.exports = "query infoPage($id: ID) {\n  pageContent: page(type: INFO_PAGE, id: $id) {\n    id\n    title\n    body: markdown(format: true)\n    pathName\n  }\n}"

/***/ }),

/***/ 25559:
/***/ ((module) => {

module.exports = "query keywordLandingPage($slug: String, $query: String, $offset: Int, $limit: Int, $source: KeywordLandingPageSource) {\n  keywordLandingPage(slug: $slug, query: $query, source: $source) {\n    title\n    url\n    published\n    inSitemap\n    hasAdultContent\n    publishedAt\n    sourceId\n    metaDescription\n    label\n    sanityFaq {\n      faqTitle\n      faqItems {\n        question\n        answer {\n          sections {\n            _key\n            _type\n            style\n            listItem\n            level\n            children {\n              _key\n              _type\n              text\n              marks\n            }\n            markDefs {\n              _key\n              _type\n              blank\n              href\n            }\n            listItem\n          }\n        }\n      }\n    }\n    description {\n      text\n      descriptionSource\n    }\n    isUsed\n    items(offset: $offset, limit: $limit) {\n      pageInfo {\n        offset\n        limit\n        total\n        pages\n        numberOfOffers\n        numberOfProducts\n        hasDescription\n      }\n      nodes {\n        ... on Product {\n          __typename\n          id\n          name\n          pathName\n          userReviewSummary {\n            rating\n            count\n          }\n          aggregatedRating {\n            score\n            count\n          }\n          priceSummary {\n            regular\n            alternative\n            count\n          }\n          media {\n            first(width: _140)\n            firstLarge: first(width: _280)\n          }\n          dealInfo {\n            dealPercentage\n          }\n          properties(coreOnly: true) {\n            nodes {\n              id\n              type\n              name\n              isCore\n              pretty(mode: simple)\n              prettyTable: pretty(mode: table)\n              unit\n              ... on PropertyBoolean {\n                boolean\n              }\n              ... on PropertyString {\n                value\n              }\n              ... on PropertyList {\n                values\n              }\n              ... on PropertyNumber {\n                number\n              }\n              ... on PropertyInterval {\n                from\n                to\n              }\n            }\n          }\n          isExpertTopRated\n        }\n        ... on Offer {\n          __typename\n          offerId: id\n          name\n          externalUri\n          media {\n            first\n          }\n          store {\n            name\n            id\n            featured\n            currency\n          }\n          offerPrice {\n            regular\n          }\n        }\n      }\n    }\n    categories(limit: 10) {\n      pageInfo {\n        total\n      }\n      nodes {\n        type\n        id\n        name\n        path\n        image\n        productCount\n      }\n    }\n    parentCategory {\n      path {\n        id\n        name\n        pathName\n      }\n    }\n  }\n  popularSearches {\n    query\n  }\n}"

/***/ }),

/***/ 66120:
/***/ ((module) => {

module.exports = "query keywordListingPage($ids: [String!], $limit: Int, $includeRandom: Boolean) {\n  popularSearchTerms(ids: $ids, limit: $limit, includeRandom: $includeRandom) {\n    keywords {\n      name\n      url\n    }\n    categories {\n      id\n      name\n      url\n      imageUrl\n      classicId\n    }\n  }\n}"

/***/ }),

/***/ 77166:
/***/ ((module) => {

module.exports = "query landingPage($campaignId: ID, $skip: Boolean = false, $onlyFromFeaturedStores: Boolean = true, $categoryIds: [ID]) {\n  ...rootCategories\n  ...featuredProducts\n  ...campaignDealsRoot\n  ...popularFacets\n  ...expertContent @skip(if: $skip)\n  shopOfTheYear {\n    year\n  }\n  landingPageArticles {\n    id\n    title\n    description\n    thumbnail\n    slug\n  }\n}\n\nfragment rootCategories on RootQuery {\n  rootCategories: categoryTree(depth: 7, flattenChildren: true) {\n    id\n    name\n    logo\n    semantic_id\n    product_collection\n    externalUri\n    children {\n      id\n      name\n      semantic_id\n      product_collection\n      externalUri\n    }\n  }\n}\n\nfragment campaignDealsRoot on RootQuery {\n  campaignDeals(\n    campaignId: $campaignId\n    onlyFromFeaturedStores: $onlyFromFeaturedStores\n    categoryIds: $categoryIds\n  ) {\n    id\n    externalUri\n    price {\n      diffPercentage\n      previousPrice\n      compareDaysAgo\n      id\n    }\n    store {\n      id\n      name\n      hasLogo\n      featured\n    }\n    product {\n      preloaded: __typename\n      description\n      id\n      name\n      pathName\n      media {\n        first(width: _280)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      priceSummary {\n        regular\n        alternative\n        inStock\n        count\n      }\n      category {\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}\n\nfragment featuredProducts on RootQuery {\n  featuredProductsArray {\n    title\n    linkTitle\n    linkUrl\n    products {\n      id\n      name\n      pathName\n      media {\n        first(width: _140)\n      }\n      priceSummary {\n        regular\n      }\n      category {\n        id\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}\n\nfragment popularFacets on RootQuery {\n  popularFacets {\n    title\n    url\n    linkText\n    products(onlyFromFeaturedStores: true) {\n      id\n      pathName\n      name\n      media {\n        first(width: _280)\n      }\n      priceSummary {\n        regular\n        alternative\n        inStock\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      popularity {\n        total\n        inCategory\n      }\n      brand {\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}\n\nfragment expertContent on RootQuery {\n  expertLandingPage(\n    skipNews: 0\n    skipGuides: 0\n    skipToplists: 0\n    skipTests: 0\n    limit: 4\n  ) {\n    expertCount\n    experts {\n      name\n      avatar\n      url\n    }\n    items {\n      tests {\n        __typename\n        id\n        url\n        title\n        publishedAt\n        category {\n          name\n          url\n        }\n        expert {\n          name\n          avatar\n        }\n        date(format: \"D MMMM\")\n        imageWithSize(size: x2) {\n          src\n          alt\n        }\n      }\n      toplists {\n        __typename\n        id\n        title\n        publishedAt\n        date(format: \"D MMMM\")\n        category {\n          name\n          url\n        }\n        expert {\n          name\n          avatar\n          url\n        }\n        headlineInfo {\n          url\n          otherExperts {\n            name\n            avatar\n          }\n          likes\n        }\n        products {\n          id\n          order\n        }\n        description {\n          type\n          data\n        }\n      }\n    }\n  }\n}"

/***/ }),

/***/ 95307:
/***/ ((module) => {

module.exports = "query publicList($id: Int!, $limit: Int, $offset: Int, $sort: String, $direction: SortDirection) {\n  list(id: $id) {\n    id\n    name\n    pathName\n    priceSummary\n    itemsCount\n    icon\n    likes\n    visibility\n    user {\n      id\n      displayName\n      schibstedProfile {\n        schibstedDisplayName\n        avatar(size: _200)\n      }\n    }\n    items(limit: $limit, offset: $offset, sort: $sort, direction: $direction) {\n      nodes {\n        ...listItemFragment\n      }\n      pageInfo {\n        limit\n        offset\n        hasNext\n        hasPrevious\n        sort {\n          name\n          direction\n        }\n      }\n    }\n  }\n}\n\nfragment listItemFragment on ListItem {\n  id\n  ... on AlertProduct {\n    __typename\n    priceThreshold\n    alertType\n    priceStep\n    storePreference\n    storeGradeThreshold\n    product {\n      preloaded: __typename\n      id\n      name\n      stockStatus\n      category {\n        id\n        name\n      }\n      latestPriceChange {\n        time(fromNow: true)\n        amount\n      }\n      priceSummary {\n        regular\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      media {\n        first(width: _280)\n      }\n      pathName\n    }\n  }\n  ... on AlertSearch {\n    __typename\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ...listItemProductFragment\n  ... on ListSearch {\n    __typename\n    quantity\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ... on ListCategory {\n    __typename\n    name\n    created(fromNow: true)\n    icon\n    pathName\n    itemsCount\n    priceSummary\n    inventory\n    visibility\n  }\n}\n\nfragment listItemProductFragment on ListProduct {\n  __typename\n  quantity\n  product {\n    preloaded: __typename\n    id\n    name\n    description\n    category {\n      id\n      name\n    }\n    priceSummary {\n      regular\n      alternative\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _280)\n    }\n    pathName\n  }\n}"

/***/ }),

/***/ 48993:
/***/ ((module) => {

module.exports = "query productCollectionSitemap($slug: String) {\n  productCollectionSitemap(slug: $slug) {\n    name\n    sitemapCollection {\n      property\n      sitemapItems {\n        path\n        title\n      }\n    }\n  }\n}"

/***/ }),

/***/ 50699:
/***/ ((module) => {

module.exports = "query productCollectionPage($slug: String, $id: String, $query: ProductCollectionQueryInput, $productPropertyIds: [ID!] = [\"_core_\"], $productPropertyColumnIds: [String!], $onlyFeaturedFilters: Boolean, $useSponsoredContent: Boolean) {\n  productCollection(\n    id: $id\n    slug: $slug\n    query: $query\n    onlyFeaturedFilters: $onlyFeaturedFilters\n    useSponsoredContent: $useSponsoredContent\n  ) {\n    id\n    slug\n    name\n    indexable\n    url\n    aliases\n    hasAdultContent\n    sanityFaq {\n      faqTitle\n      faqItems {\n        question\n        answer {\n          sections {\n            _key\n            _type\n            style\n            listItem\n            level\n            children {\n              _key\n              _type\n              text\n              marks\n            }\n            markDefs {\n              _key\n              _type\n              blank\n              href\n            }\n            listItem\n          }\n        }\n      }\n    }\n    categories {\n      id\n    }\n    query {\n      aggregations {\n        id\n        size\n      }\n    }\n    categoryPath {\n      id\n      slug\n      name\n      pathName\n    }\n    newPopularSearchTerms {\n      popularKeywords {\n        name\n        url\n      }\n      trendingKeywords {\n        name\n        url\n      }\n    }\n    filters {\n      ... on ProductCollectionTermFilter {\n        id\n        type\n        property\n      }\n      ... on ProductCollectionTermsFilter {\n        ids\n        type\n        property\n      }\n      ... on ProductCollectionRangeFilter {\n        type\n        property\n        to\n        from\n      }\n      ... on ProductCollectionRangeGroupFilter {\n        type\n        key\n        property\n      }\n      ... on ProductCollectionBooleanFilter {\n        id\n        type\n        property\n      }\n      ... on ProductCollectionNameSearchFilter {\n        query\n        type\n      }\n    }\n    slices {\n      __typename\n      ... on BreadcrumbsSlice {\n        id\n        items {\n          name\n          pathName\n        }\n      }\n      ... on NavigationSlice {\n        id\n        property\n        links {\n          id\n          value\n          count\n          path\n          productMedia {\n            first(width: _280)\n          }\n          fallbackImage\n          indexable\n        }\n      }\n      ... on SecondaryNavigationSlice {\n        id\n        navigationItems {\n          title\n          url\n        }\n      }\n      ... on HeaderBlockSlice {\n        id\n        title\n        description\n        logo\n        pagination {\n          pages\n          currentPage\n        }\n      }\n      ... on DescriptionSlice {\n        id\n        description\n      }\n      ... on FilterSlice {\n        id\n        productsCount\n        sections {\n          __typename\n          ... on AggregationSectionInterface {\n            id\n            title\n            property\n            featured\n            group\n          }\n          ... on ListSection {\n            multiple\n            hasMore\n            search\n            items {\n              id\n              value\n              count\n              indexable\n            }\n            popular {\n              id\n              value\n              count\n              indexable\n            }\n          }\n          ... on ListTreeSection {\n            multiple\n            hasMore\n            search\n            items {\n              id\n              value\n              count\n              indexable\n              selectable\n              parentId\n            }\n          }\n          ... on RangeSection {\n            count\n            min\n            max\n            unit\n            valueType\n            histogram {\n              scale\n              largestBucketCount\n              buckets {\n                id\n                count\n                from\n                to\n              }\n            }\n          }\n          ... on RangeGroupSection {\n            multiple\n            groups {\n              id\n              count\n              from\n              to\n              value\n            }\n          }\n          ... on BooleanSection {\n            items {\n              id\n              value\n              count\n            }\n          }\n          ... on UnsupportedSection {\n            type\n          }\n        }\n        filters {\n          __typename\n          ... on ProductCollectionTermsFilter {\n            property\n            title\n            values\n            ids\n            clearFilterPath\n          }\n          ... on ProductCollectionTermFilter {\n            property\n            title\n            value\n            id\n            clearFilterPath\n          }\n          ... on ProductCollectionRangeFilter {\n            property\n            title\n            value\n            clearFilterPath\n            from\n            to\n            unit\n          }\n          ... on ProductCollectionRangeGroupFilter {\n            title\n            type\n            key\n            values\n            property\n            unit\n          }\n          ... on ProductCollectionBooleanFilter {\n            property\n            title\n            id\n            clearFilterPath\n          }\n          ... on ProductCollectionNameSearchFilter {\n            query\n            type\n          }\n        }\n      }\n      ... on ProductsSlice {\n        id\n        pageInfo {\n          sort {\n            name\n            direction\n          }\n          offset\n          limit\n        }\n        products {\n          id\n          pathName\n          name\n          stockStatus\n          indexingDate(format: distance)\n          media {\n            first(width: _140)\n          }\n          priceSummary {\n            regular\n            includeShipping\n            count(type: _regular)\n          }\n          userReviewSummary {\n            rating\n            count\n          }\n          aggregatedRating {\n            score\n            count\n          }\n          dealInfo {\n            dealPercentage\n          }\n          properties(ids: $productPropertyIds, coreOnly: true) {\n            nodes {\n              id\n              type\n              name\n              isCore\n              pretty(mode: table)\n              unit\n              ... on PropertyBoolean {\n                boolean\n              }\n              ... on PropertyString {\n                value\n              }\n              ... on PropertyList {\n                values\n              }\n              ... on PropertyNumber {\n                number\n              }\n              ... on PropertyInterval {\n                from\n                to\n              }\n            }\n          }\n          popularity {\n            total\n            inCategory\n          }\n          category {\n            logo\n          }\n          brand {\n            name\n            logo\n          }\n          highlight\n          cheapestPrice(\n            featured: true\n            inStock: true\n            excludeTypes: [not_in_mint_condition, not_available_for_purchase, used_product]\n          ) {\n            externalUri\n            store {\n              name\n              logo\n              userReviewSummary {\n                rating\n              }\n            }\n            price {\n              exclShipping\n              exclShipping\n            }\n          }\n          isExpertTopRated\n          sponsor {\n            brand {\n              id\n              name\n            }\n            order\n            authorizedDealersLink\n            adId\n          }\n        }\n        productsCount\n        storeCount\n        legalText\n        availableSorts\n        currentSort\n        maxHitsAmount\n        sortDirection\n        featuredProperties {\n          id\n          name\n          type\n          unit\n        }\n        propertyColumns(ids: $productPropertyColumnIds) {\n          __typename\n          ... on ProductCollectionTruePropertyColumn {\n            id\n            name\n            type\n            unit\n          }\n          ... on ProductCollectionSimulatedPropertyColumn {\n            id\n          }\n        }\n        preferredViewMode\n      }\n      ... on MetaDataSlice {\n        title\n        description\n        image\n        name\n        url {\n          current\n          next\n          prev\n        }\n        pagination {\n          pages\n          currentPage\n        }\n      }\n      ... on AdsSlice {\n        categoryPath\n      }\n      ... on FeaturedArticlesSlice {\n        sanityArticle {\n          description\n          id\n          title\n          slug\n          thumbnail\n          relatedProducts {\n            name\n            pathName\n            media {\n              first(width: _140)\n            }\n          }\n        }\n        toplistArticles {\n          __typename\n          id\n          title\n          url\n          category {\n            name\n            url\n          }\n          date(format: \"D MMMM\")\n          publishedAt\n          description {\n            type\n            data\n          }\n          expert {\n            name\n            url\n            avatar\n          }\n          headlineInfo {\n            likes\n            url\n            otherExperts {\n              name\n              avatar\n            }\n          }\n          products {\n            image\n            order\n          }\n          pjProducts {\n            id\n            name\n            media {\n              first(width: _280)\n            }\n            pathName\n          }\n          image(size: x3) {\n            src\n            alt\n          }\n        }\n        prismicArticle {\n          __typename\n          id\n          pathName\n          data {\n            title {\n              ...richContentFragment\n            }\n            metaDescription {\n              ...richContentFragment\n            }\n            featuredImage {\n              ...imageFragment\n            }\n            body {\n              type\n              primary {\n                __typename\n                ...expertArticleProducts\n              }\n            }\n          }\n        }\n      }\n      ... on ExpertSlice {\n        expert {\n          toplistsCount\n          testsCount\n          guidesCount\n          category {\n            name\n            descriptionImage\n            url\n          }\n          tests {\n            __typename\n            id\n            title\n            url\n            grade\n            date(format: \"D MMMM\")\n            publishedAt\n            likes\n            expert {\n              name\n              url\n              avatar\n            }\n            imageWithSize(size: x2) {\n              src\n              alt\n            }\n          }\n          toplists {\n            __typename\n            id\n            title\n            url\n            date(format: \"D MMMM\")\n            publishedAt\n            description {\n              type\n              data\n            }\n            expert {\n              name\n              url\n              avatar\n            }\n            headlineInfo {\n              likes\n              url\n              otherExperts {\n                name\n                avatar\n              }\n            }\n            products {\n              image\n              order\n            }\n          }\n        }\n      }\n    }\n    trendingProducts(onlyFromFeaturedStores: true) {\n      id\n      name\n      pathName\n      category\n      price\n      url\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      imageUrl\n      isExpertTopRated\n    }\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment expertArticleProducts on PrismicSliceProductList {\n  listType\n  products {\n    id\n    name\n    pathName\n    media {\n      first(width: _280)\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    priceSummary {\n      regular\n      alternative\n      inStock\n    }\n  }\n}"

/***/ }),

/***/ 88273:
/***/ ((module) => {

module.exports = "query productComparePage($categoryId: ID!, $productIds: [Int!]!, $productIdRelated: Int, $fetchCategory: Boolean = true) {\n  ...categoryProps @include(if: $fetchCategory)\n  products(ids: $productIds, compare: true) {\n    id\n    name\n    description\n    pathName\n    stockStatus\n    releaseDate\n    priceSummary {\n      regular\n      count\n      includeShipping\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _280)\n    }\n    brand {\n      id\n      name\n      featured\n      logo\n      pathName\n    }\n    popularity {\n      inCategory\n    }\n    reviewBadges {\n      id\n      name\n      sentiment\n      nrOfPositiveReviews\n      nrOfReviews\n    }\n    ...productProperties\n  }\n  relatedProducts(productId: $productIdRelated) {\n    id\n    name\n    imageUrl\n    price\n  }\n}\n\nfragment categoryProps on RootQuery {\n  category(id: $categoryId) {\n    id\n    logo\n    name\n    pathName\n    semanticId\n    path {\n      id\n      name\n      pathName\n    }\n  }\n}\n\nfragment productProperties on Product {\n  properties {\n    nodes {\n      id\n      type\n      name\n      children\n      isRoot\n      isCore\n      isDiff\n      unit\n      comment\n      ... on PropertyBoolean {\n        boolean\n      }\n      ... on PropertyCategory {\n        id\n      }\n      ... on PropertyNumber {\n        number\n      }\n      ... on PropertyInterval {\n        id\n      }\n      ... on PropertyLink {\n        links {\n          url\n          languages\n        }\n      }\n      ... on PropertyList {\n        values\n        categoryLinks\n      }\n      ... on PropertyString {\n        value\n        categoryLink\n      }\n      ... on PropertyInterval {\n        from\n        to\n      }\n    }\n  }\n}"

/***/ }),

/***/ 45875:
/***/ ((module) => {

module.exports = "query productComparison($id: Int!) {\n  product(id: $id) {\n    comparison {\n      baseProduct {\n        id\n        name\n        logo\n      }\n      comparedProduct {\n        id\n        name\n        logo\n      }\n      summary\n    }\n  }\n}"

/***/ }),

/***/ 91393:
/***/ ((module) => {

module.exports = "query productMedia($id: Int!) {\n  product(id: $id) {\n    media {\n      first(width: _280)\n      images(width: _280)\n      large: images(width: _800)\n      videos {\n        source_id\n        embed_url\n        thumbnail\n      }\n    }\n  }\n}"

/***/ }),

/***/ 66490:
/***/ ((module) => {

module.exports = "query fetchLists($limit: Int, $offset: Int) {\n  me {\n    id\n    lists(limit: $limit, offset: $offset, sort: \"accessed\") {\n      pageInfo {\n        hasNext\n      }\n      nodes {\n        id\n        ... on ListCategory {\n          name\n          inventory\n        }\n      }\n    }\n  }\n}"

/***/ }),

/***/ 59086:
/***/ ((module) => {

module.exports = "query priceHistoryV2($id: Int!, $timeRange: TimeRange!, $importantDates: Boolean = false) {\n  product(id: $id) {\n    historyV2(timeRange: $timeRange) {\n      historyItems {\n        date\n        name\n        price\n        isMembershipPrice\n        isPaidMembership\n        shopName\n        shopId\n        active\n      }\n      historyAllShops {\n        id\n        name\n      }\n      oldestHistoryItem\n      newestHistoryItem\n    }\n  }\n  ...importantDates @include(if: $importantDates)\n}\n\nfragment importantDates on RootQuery {\n  importantDates {\n    startDate\n    endDate\n    name\n  }\n}"

/***/ }),

/***/ 547:
/***/ ((module) => {

module.exports = "query productTabProperties($id: Int!) {\n  product(id: $id) {\n    ...productProperties\n  }\n}\n\nfragment productProperties on Product {\n  properties {\n    nodes {\n      id\n      type\n      name\n      children\n      isRoot\n      isCore\n      isDiff\n      unit\n      comment\n      ... on PropertyBoolean {\n        boolean\n      }\n      ... on PropertyCategory {\n        id\n      }\n      ... on PropertyNumber {\n        number\n      }\n      ... on PropertyInterval {\n        id\n      }\n      ... on PropertyLink {\n        links {\n          url\n          languages\n        }\n      }\n      ... on PropertyList {\n        values\n        categoryLinks\n      }\n      ... on PropertyString {\n        value\n        categoryLink\n      }\n      ... on PropertyInterval {\n        from\n        to\n      }\n    }\n  }\n}"

/***/ }),

/***/ 42318:
/***/ ((module) => {

module.exports = "query productPage($id: Int!, $expertsEnabled: Boolean!, $partnerVideosEnabled: Boolean!) {\n  product(id: $id) {\n    ...productPage\n    ...productPageExpertContent @include(if: $expertsEnabled)\n    prices {\n      ...priceList\n    }\n    initialStatistics {\n      numberMainOffers\n      lowestPrice\n      highestPrice\n    }\n    relations {\n      type\n      relations {\n        name\n        sortPriority\n        selected\n      }\n    }\n    variants {\n      id\n      name\n      gtin14\n      sku\n      attributes {\n        type\n        value\n      }\n    }\n    category {\n      products(limit: 10, sort: \"popularity\", getProperties: false) {\n        nodes {\n          id\n        }\n      }\n    }\n    popularProducts(onlyFromFeaturedStores: true) {\n      ...productCarouselFields\n    }\n    trendingProducts(onlyFromFeaturedStores: true) {\n      ...productCarouselFields\n    }\n    othersVisitedProducts {\n      ...productCarouselFields\n    }\n    isExpertTopRated\n    metadata {\n      title\n      description\n    }\n    partnerVideos(productId: $id) @include(if: $partnerVideosEnabled) {\n      __typename\n      author {\n        avatar {\n          url\n        }\n        name\n      }\n      previewImage {\n        small {\n          url\n        }\n        large {\n          url\n        }\n      }\n      title\n      videoId\n      videoUrl\n    }\n    verifiedProductBadge\n    sanityBadges {\n      badgeType\n      badgeImageUrl\n    }\n  }\n  prismicArticles(tags: [\"productpage-priceinfo\"]) {\n    nodes {\n      pathName\n    }\n  }\n}\n\nfragment productPage on Product {\n  id\n  name\n  description(html: true)\n  pathName\n  stockStatus\n  releaseDate\n  indexableIn\n  sanityFaq {\n    faqTitle\n    faqItems {\n      question\n      answer {\n        sections {\n          _key\n          _type\n          style\n          listItem\n          level\n          children {\n            _key\n            _type\n            text\n            marks\n          }\n          markDefs {\n            _key\n            _type\n            blank\n            href\n          }\n          listItem\n        }\n      }\n    }\n  }\n  userReviewSummary {\n    rating\n    count\n    countTotal\n  }\n  aggregatedRatingSummary {\n    summary {\n      rating {\n        score\n        count\n      }\n    }\n  }\n  coreProperties: properties(ids: \"_core_\") {\n    nodes {\n      __typename\n      id\n      name\n      type\n      pretty\n      prettyVerbose: pretty(mode: verbose)\n      prettyTable: pretty(mode: table)\n      ... on PropertyString {\n        valueId\n        categoryLink\n      }\n      ... on PropertyList {\n        values\n        valueIds\n        categoryLinks\n      }\n      ... on PropertyBoolean {\n        boolean\n      }\n    }\n  }\n  brand {\n    id\n    name\n    featured\n    logo\n    pathName\n  }\n  priceSummary {\n    regular\n    alternative\n  }\n  media {\n    count\n    first(width: _280)\n  }\n  category {\n    id\n    logo\n    name\n    pathName\n    productCollection\n    hasAdultContent\n    path {\n      id\n      name\n      pathName\n    }\n  }\n  sparkline {\n    values\n  }\n  popularity {\n    total\n    inCategory\n  }\n  productDescription {\n    preamble\n    descriptionPoints {\n      title\n      text\n    }\n    articles {\n      name\n      url\n    }\n  }\n  dealInfo {\n    dealPercentage\n    offers {\n      shopId\n      shopOfferId\n    }\n  }\n}\n\nfragment priceList on PriceList {\n  meta {\n    itemsTotal\n    storeStatistics {\n      totalCount\n      featuredCount\n    }\n  }\n  nodes {\n    ...priceListItem\n  }\n  mobileContractsV2 {\n    ...mobileContract\n  }\n}\n\nfragment priceListItem on Price {\n  __typename\n  shopOfferId\n  name\n  externalUri\n  primaryMarket\n  membershipProgram {\n    name\n    requiresCompensation\n  }\n  stock {\n    status\n    statusText\n  }\n  condition\n  availability {\n    condition\n    availabilityDate\n  }\n  price {\n    inclShipping\n    exclShipping\n    originalCurrency\n  }\n  offerPrices {\n    price {\n      exclShipping\n      inclShipping\n      endDate\n    }\n    originalPrice {\n      exclShipping\n      inclShipping\n    }\n    memberPrice {\n      exclShipping\n      inclShipping\n      endDate\n    }\n  }\n  store {\n    ...store\n  }\n  authorizedDealer\n  authorizedDealerData {\n    authorizedDealersDescription\n    authorizedDealersShortDescription\n  }\n  alternativePrices(includeMainPrice: true) {\n    __typename\n    shopOfferId\n    name\n    externalUri\n    primaryMarket\n    stock {\n      status\n      statusText\n    }\n    condition\n    availability {\n      condition\n      availabilityDate\n    }\n    price {\n      exclShipping\n      inclShipping\n      originalCurrency\n    }\n    offerPrices {\n      price {\n        exclShipping\n        inclShipping\n        endDate\n      }\n      originalPrice {\n        exclShipping\n        inclShipping\n      }\n      memberPrice {\n        exclShipping\n        inclShipping\n        endDate\n      }\n    }\n    variantInfo {\n      size\n      sizeSystem\n      colors\n    }\n    variantId\n    shipping {\n      cheapest {\n        deliveryDays {\n          min\n          max\n        }\n        shippingCost\n        carrier\n      }\n      fastest {\n        deliveryDays {\n          min\n          max\n        }\n        shippingCost\n      }\n      nodes {\n        deliveryMethod\n        carrier\n        deliveryDays {\n          min\n          max\n        }\n        shippingCost\n        sustainability\n        eligibility\n      }\n    }\n    shopHasUniqueShippings\n    ourChoiceScore\n    featuredOverride\n    shippingCampaigns {\n      id\n      type\n      startDate\n      endDate\n    }\n  }\n  variantInfo {\n    size\n    sizeSystem\n    colors\n  }\n  variantId\n  shipping {\n    cheapest {\n      deliveryDays {\n        min\n        max\n      }\n      shippingCost\n      carrier\n      sustainability\n    }\n    fastest {\n      deliveryDays {\n        min\n        max\n      }\n      shippingCost\n      carrier\n      sustainability\n    }\n    nodes {\n      deliveryMethod\n      carrier\n      deliveryDays {\n        min\n        max\n      }\n      shippingCost\n      sustainability\n      eligibility\n    }\n  }\n  shopHasUniqueShippings\n  ourChoiceScore\n  featuredOverride\n  membershipLink\n  promotion {\n    id\n    description\n    startDate\n    endDate\n    imageUrl\n    owner {\n      id\n      name\n      type\n    }\n    title\n    numberOfProducts\n  }\n  shippingCampaigns {\n    id\n    type\n    startDate\n    endDate\n  }\n}\n\nfragment mobileContract on MobileContractV2 {\n  __typename\n  contractId\n  name\n  contractMonths\n  pricePerMonth\n  dataGB\n  externalUri\n  totalPrice\n  campaignPricePerMonth\n  campaignDurationMonths\n  hardwarePricePerMonth\n  alternativeContracts {\n    contractId\n    name\n    contractMonths\n    pricePerMonth\n    dataGB\n    externalUri\n    totalPrice\n    campaignPricePerMonth\n    campaignDurationMonths\n    hardwarePricePerMonth\n    store {\n      ...store\n    }\n  }\n  store {\n    ...store\n  }\n}\n\nfragment store on Store {\n  id\n  name\n  featured\n  hasLogo\n  logo(width: _176)\n  pathName\n  providedByStore {\n    generalInformation\n  }\n  userReviewSummary {\n    rating\n    count\n    countTotal\n  }\n  market\n  marketplace\n  countryCode\n  primaryMarket\n  currency\n  payment {\n    options {\n      name\n    }\n    providers {\n      name\n    }\n  }\n}\n\nfragment productPageExpertContent on Product {\n  expertContent {\n    totalCount\n    experts {\n      name\n      avatar\n      url\n    }\n    selected {\n      ... on ProductPageExpertTest {\n        __typename\n        rating\n        date(format: \"D MMMM YYYY\")\n        title\n        plus\n        minus\n        imageWithSize {\n          src\n          alt\n        }\n        suitedForLong\n        suitedFor {\n          headline\n          text\n        }\n        url\n        expert {\n          name\n          avatar\n          url\n        }\n        category {\n          name\n        }\n      }\n      ... on ProductPageToplist {\n        __typename\n        title\n        url\n        category {\n          name\n        }\n        expert {\n          name\n          avatar\n          url\n        }\n        products {\n          id\n          plus\n          minus\n          description\n        }\n      }\n    }\n    tests {\n      ... on ProductPageExpertTest {\n        __typename\n        title\n        imageWithSize {\n          src\n          alt\n        }\n        url\n      }\n    }\n    toplists {\n      toplists {\n        __typename\n        title\n        url\n        description {\n          type\n          data\n        }\n        headlineInfo {\n          url\n        }\n        products {\n          id\n          plus\n          minus\n        }\n        imageUrl\n      }\n    }\n    guides {\n      ... on ProductPageExpertGuide {\n        __typename\n        title\n        imageUrl\n        url\n      }\n    }\n  }\n}\n\nfragment productCarouselFields on CarouselProduct {\n  id\n  name\n  pathName\n  category\n  price\n  url\n  userReviewSummary {\n    rating\n    count\n  }\n  aggregatedRating {\n    score\n    count\n  }\n  imageUrl\n  isExpertTopRated\n}"

/***/ }),

/***/ 4692:
/***/ ((module) => {

module.exports = "fragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}"

/***/ }),

/***/ 16611:
/***/ ((module) => {

module.exports = "query promotionProducts($page: Int! = 0, $sortType: SearchV3Sorting!, $filters: [SearchFilter!]!) {\n  searchV3 {\n    products(\n      sortType: $sortType\n      page: $page\n      filters: $filters\n      order: desc\n      searchType: promotions\n    ) {\n      items {\n        ... on ProductCard {\n          productId\n          logo\n          coreProperties\n          name\n          aggregatedRating {\n            score\n            count\n          }\n          productLink\n          storeCount\n          categoryName\n          bestOffer {\n            storeId\n            stockStatus\n            shopOfferId\n            storeName\n            price\n            originalPrice\n            memberPrice\n            offerLink\n            featured\n            priceExpires\n            condition\n            membershipRequiresCompensation\n          }\n          promotionShopPrices {\n            storeId\n            promotionId\n            price\n            shopOfferId\n            offerLink\n          }\n          __typename\n        }\n      }\n      availabilityAggregations {\n        key\n        count\n        name\n      }\n      brandsAggregations {\n        key\n        count\n        name\n      }\n      leafCategories {\n        key\n        count\n        name\n        logo\n      }\n      categoryAggregations {\n        key\n        parentKey\n        count\n        name\n        logo\n      }\n      priceHistogram {\n        min\n        max\n        count\n      }\n      ratingHistogram {\n        key\n        count\n      }\n      shopAggregations {\n        key\n        count\n        name\n      }\n      hasMorePages\n      didYouMean\n      numberOfHits\n    }\n  }\n}"

/***/ }),

/***/ 58948:
/***/ ((module) => {

module.exports = "query promotionProductsPage($id: String!) {\n  promotion(id: $id) {\n    id\n    title\n    description\n    imageUrl\n    promotionUrl\n    startDate\n    endDate\n    numberOfProducts\n    owner {\n      id\n      name\n      type\n    }\n    promotionCode {\n      code\n    }\n  }\n}"

/***/ }),

/***/ 68035:
/***/ ((module) => {

module.exports = "query promotions($page: Int! = 0, $filters: [PromotionSearchFilter!]!, $sortType: SearchV3PromotionsSorting = relevancy, $order: SearchOrder = desc) {\n  searchV3 {\n    promotions(page: $page, filters: $filters, sortType: $sortType, order: $order) {\n      ...promotionItemsFragment\n      typeAggregations {\n        key\n        name\n        count\n      }\n      shopAggregations {\n        key\n        count\n        name\n      }\n      hasMorePages\n      numberOfHits\n    }\n  }\n}\n\nfragment promotionItemsFragment on SearchV3PromotionsResult {\n  items {\n    id\n    description\n    imageUrl\n    owner {\n      id\n      name\n      type\n    }\n    promotionUrl\n    title\n    startDate\n    endDate\n    numberOfProducts\n  }\n}"

/***/ }),

/***/ 76599:
/***/ ((module) => {

module.exports = "query usedProducts($page: Int!, $sortType: SearchV3Sorting!, $filters: [SearchFilter!]!) {\n  searchV3 {\n    products(\n      sortType: $sortType\n      page: $page\n      filters: $filters\n      order: desc\n      searchType: used\n    ) {\n      items {\n        ... on ProductCard {\n          productId\n          priceDrop\n          coreProperties\n          dealUpdateTime\n          logo\n          name\n          aggregatedRating {\n            score\n            count\n          }\n          productLink\n          storeCount\n          categoryName\n          lowestNewPrice\n          bestOffer {\n            storeId\n            stockStatus\n            shopOfferId\n            storeName\n            price\n            originalPrice\n            memberPrice\n            offerLink\n            featured\n            priceExpires\n            condition\n            membershipRequiresCompensation\n          }\n          __typename\n        }\n      }\n      availabilityAggregations {\n        key\n        count\n        name\n      }\n      brandsAggregations {\n        key\n        count\n        name\n      }\n      leafCategories {\n        key\n        count\n        name\n        logo\n      }\n      categoryAggregations {\n        key\n        parentKey\n        count\n        name\n        logo\n      }\n      priceHistogram {\n        min\n        max\n        count\n      }\n      ratingHistogram {\n        key\n        count\n      }\n      shopAggregations {\n        key\n        count\n        name\n      }\n      hasMorePages\n      didYouMean\n      numberOfHits\n    }\n  }\n}"

/***/ }),

/***/ 26585:
/***/ ((module) => {

module.exports = "query suggestions($query: String!) {\n  searchSuggestions(query: $query) {\n    ... on SuggestedProduct {\n      __typename\n      text\n      id\n      category\n      price\n    }\n    ... on SuggestedSearchPhrase {\n      __typename\n      text\n    }\n    ... on SuggestedShop {\n      __typename\n      id\n      text\n    }\n    ... on SuggestedCategoryFilter {\n      __typename\n      text\n      id\n      name\n    }\n  }\n}"

/***/ }),

/***/ 21598:
/***/ ((module) => {

module.exports = "query getPopularSearches {\n  popularSearches {\n    query\n  }\n}"

/***/ }),

/***/ 13897:
/***/ ((module) => {

module.exports = "query searchPage($query: String!, $offset: Int, $limit: Int, $sort: SearchProductSortingEnum, $order: SearchOrder, $categoryFilters: [String], $brandFilters: [String], $ratingFilters: [String], $priceFilters: [String], $dealsFilters: [String], $availabilityFilters: [String], $getExperts: Boolean = false, $allProductsFilter: Boolean = false) {\n  newSearch(\n    query: $query\n    categoryFilter: $categoryFilters\n    brandFilter: $brandFilters\n    ratingFilter: $ratingFilters\n    priceFilter: $priceFilters\n    dealsFilter: $dealsFilters\n    availabilityFilter: $availabilityFilters\n    allProductsFilter: $allProductsFilter\n  ) {\n    errorOccured\n    query\n    results {\n      products(offset: $offset, limit: $limit, sort: $sort, order: $order) {\n        pageInfo {\n          offset\n          limit\n          total\n          pages\n          sort {\n            name\n            direction\n          }\n        }\n        nodes {\n          ... on Product {\n            __typename\n            id\n            name\n            category {\n              path {\n                id\n                name\n              }\n            }\n            pathName\n            aggregatedRating {\n              score\n              count\n            }\n            priceSummary {\n              regular\n              alternative\n              count\n            }\n            media {\n              first(width: _280)\n            }\n            dealInfo {\n              dealPercentage\n            }\n            isExpertTopRated\n          }\n          ... on Offer {\n            __typename\n            offerId: id\n            name\n            externalUri\n            media {\n              first\n            }\n            store {\n              name\n              id\n              featured\n              currency\n            }\n            offerPrice {\n              regular\n            }\n            featuredOverride\n          }\n        }\n      }\n      categories(limit: 16) {\n        pageInfo {\n          total\n        }\n        nodes {\n          type\n          id\n          name\n          path\n          image\n          productCount\n          productMedia\n        }\n      }\n      brands(limit: 10) {\n        pageInfo {\n          total\n        }\n        nodes {\n          id\n          name\n          brandLogo\n          pathName\n        }\n      }\n      shops {\n        pageInfo {\n          total\n        }\n        nodes {\n          id\n          name\n          hasLogo\n          pathName\n        }\n      }\n      articlesResult @include(if: $getExperts) {\n        items {\n          tests {\n            __typename\n            id\n            title\n            url\n            likes\n            grade\n            gradeNotConverted\n            date(format: \"D MMMM YYYY\")\n            imageWithSize(size: x2) {\n              src\n              alt\n            }\n            expert {\n              name\n              avatar\n              url\n            }\n            publishedAt\n            order\n          }\n          toplists {\n            __typename\n            id\n            title\n            likes\n            date(format: \"D MMMM YYYY\")\n            headlineInfo {\n              url\n            }\n            products {\n              name\n              image\n              order\n            }\n            pjProducts {\n              id\n              name\n              media {\n                first(width: _140)\n              }\n            }\n            expert {\n              name\n              avatar\n              url\n            }\n            description {\n              type\n              data\n            }\n            publishedAt\n            order\n            image(size: x2) {\n              src\n              alt\n            }\n          }\n          guides {\n            __typename\n            id\n            title\n            url\n            likes\n            date(format: \"D MMMM YYYY\")\n            image(size: x2) {\n              src\n              alt\n            }\n            expert {\n              name\n              avatar\n              url\n            }\n            description\n            publishedAt\n            order\n          }\n          videos {\n            __typename\n            id\n            youtubeId\n            previewImage\n            order\n            title\n            author\n            avatar {\n              url\n              alt\n            }\n          }\n          articles {\n            __typename\n            id\n            title\n            description\n            image {\n              src\n              alt\n            }\n            link\n            date\n            order\n          }\n          sponsoredArticles {\n            __typename\n            id\n            order\n            sponsorName\n            thumbnail\n            title\n            preamble\n            slug\n          }\n          genericArticles {\n            __typename\n            id\n            order\n            thumbnail\n            title\n            preamble\n            slug\n            date\n            thumbnailAlt\n          }\n          editorialLandingPages {\n            __typename\n            id\n            order\n            thumbnail\n            title\n            preamble\n            slug\n            date\n            thumbnailAlt\n          }\n        }\n      }\n    }\n    filters {\n      category {\n        id\n        name\n        productCount\n        selected\n      }\n      brand {\n        id\n        name\n        productCount\n        selected\n      }\n      availability {\n        id\n        name\n        productCount\n        selected\n      }\n      rating {\n        min\n        max\n        histogram {\n          key\n          count\n        }\n      }\n      price {\n        min\n        max\n        histogram {\n          key\n          count\n          from\n          to\n        }\n      }\n      deals {\n        min\n        max\n        histogram {\n          key\n          count\n        }\n      }\n    }\n  }\n  popularSearches {\n    query\n  }\n  keywordSuggestions(query: $query) {\n    query\n  }\n  didYouMean(query: $query) {\n    text\n  }\n}"

/***/ }),

/***/ 99230:
/***/ ((module) => {

module.exports = "query sotyPage($year: Int, $getProduct: Boolean = false, $getStore: Boolean = true) {\n  shopOfTheYear(year: $year) {\n    year\n    leaderboards {\n      nodes {\n        id\n        name\n        isSpecial\n        mainAward\n        logo\n        leaderboard {\n          id\n          name\n          pathName\n          hasLogo\n          featured\n        }\n      }\n    }\n    charity {\n      name\n      description\n      logo\n    }\n    featuredArticle {\n      title\n      preamble\n      imageUrl\n      pathName\n    }\n  }\n  latestReviews(limit: 20, reviewType: STORES) {\n    ...GenericUserReview\n  }\n  prismicArticles(tags: [\"shop-of-the-year\"], sort: lastPublicationDate) {\n    nodes {\n      id\n      pathName\n      tags\n      data {\n        title {\n          ...richContentFragment\n        }\n        metaDescription {\n          ...richContentFragment\n        }\n        featuredImage {\n          ...imageFragment\n        }\n      }\n    }\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}"

/***/ }),

/***/ 20907:
/***/ ((module) => {

module.exports = "query sidebarList($id: ID!, $offset: Int, $limit: Int, $sort: String, $direction: SortDirection) {\n  me {\n    list(id: $id) {\n      id\n      name\n      pathName\n      priceSummary\n      itemsCount\n      inventory\n      likes\n      visibility\n      listType\n      items(offset: $offset, limit: $limit, sort: $sort, direction: $direction) {\n        pageInfo {\n          limit\n          hasNext\n          hasPrevious\n          offset\n          sort {\n            name\n            direction\n            available\n          }\n        }\n        nodes {\n          ...listItem\n        }\n      }\n    }\n  }\n}\n\nfragment listItem on ListItem {\n  id\n  ... on AlertProduct {\n    __typename\n    priceThreshold\n    alertType\n    priceStep\n    storePreference\n    storeGradeThreshold\n    product {\n      preloaded: __typename\n      id\n      name\n      stockStatus\n      category {\n        id\n        name\n      }\n      latestPriceChange {\n        time(fromNow: true)\n        amount\n      }\n      priceSummary {\n        regular\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      media {\n        first(width: _280)\n      }\n      pathName\n    }\n  }\n  ... on AlertSearch {\n    __typename\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ...listProduct\n  ... on ListSearch {\n    __typename\n    quantity\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ... on ListCategory {\n    __typename\n    name\n    created(fromNow: true)\n    icon\n    pathName\n    itemsCount\n    priceSummary\n    inventory\n    visibility\n  }\n}\n\nfragment listProduct on ListProduct {\n  __typename\n  quantity\n  product {\n    preloaded: __typename\n    id\n    name\n    description\n    category {\n      id\n      name\n    }\n    priceSummary {\n      regular\n      alternative\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _280)\n    }\n    pathName\n  }\n}"

/***/ }),

/***/ 50191:
/***/ ((module) => {

module.exports = "mutation MyProductsImport($listId: Int!) {\n  myProductsImport(listId: $listId) {\n    id\n  }\n}"

/***/ }),

/***/ 16242:
/***/ ((module) => {

module.exports = "mutation AddProductsToMyProducts($productIds: [Int!]!) {\n  myProductsItemsAdd(productIds: $productIds) {\n    id\n  }\n}"

/***/ }),

/***/ 93065:
/***/ ((module) => {

module.exports = "mutation trackSponsoredProductClick($pageUrl: String!, $adId: String!, $productId: Int!) {\n  trackSponsoredProductClick(\n    pageUrl: $pageUrl\n    adId: $adId\n    productId: $productId\n  ) {\n    success\n    message\n  }\n}"

/***/ }),

/***/ 77246:
/***/ ((module) => {

module.exports = "mutation trackSponsoredProductImpression($pageUrl: String!, $adId: String!, $productId: Int!) {\n  trackSponsoredProductImpression(\n    pageUrl: $pageUrl\n    adId: $adId\n    productId: $productId\n  ) {\n    success\n    message\n  }\n}"

/***/ }),

/***/ 96398:
/***/ ((module) => {

module.exports = "query storePage($id: Int!, $offset: Int!, $getProduct: Boolean = false, $getStore: Boolean = false, $invalidateCache: Boolean, $limit: Int = 12, $sort: String = \"popularity\", $userReviewLimit: Int = 10, $userReviewSort: String = \"date\", $userReviewFilter: ReviewFilter = ALL, $promotionsEnabled: Boolean!, $promotionFilter: [PromotionSearchFilter!]!) {\n  store(id: $id) {\n    id\n    name\n    hasLogo\n    logo(width: _176)\n    externalUri\n    externalUriText\n    featured\n    pathName\n    countryCode\n    countryName\n    currency\n    providedByStore {\n      generalInformation\n    }\n    consumerInformation {\n      time\n      message\n    }\n    storeOfTheYearAwards {\n      id\n      categoryId\n      name\n      resourceName\n      logo\n      year\n      mainAward\n      isSpecial\n      isPrimary\n    }\n    companyName\n    companyNumber\n    supportTelephone\n    supportOnsite\n    payment {\n      options {\n        name\n      }\n      providers {\n        name\n      }\n    }\n    marketplace\n    companyInfoUrl\n    languages {\n      support\n    }\n    ...storeUserReviews\n    products(limit: $limit, sort: $sort, onlyFromFeaturedStores: true) {\n      nodes {\n        id\n        pathName\n        name\n        media {\n          first(width: _140)\n        }\n        priceSummary {\n          regular\n          alternative\n        }\n        userReviewSummary {\n          rating\n          count\n        }\n        aggregatedRating {\n          score\n          count\n        }\n        prices {\n          nodes {\n            store {\n              id\n            }\n            price {\n              exclShipping\n            }\n          }\n        }\n        isExpertTopRated\n      }\n    }\n  }\n  searchV3 @include(if: $promotionsEnabled) {\n    promotions(page: 0, filters: $promotionFilter, sortType: startDate) {\n      ...promotionItemsFragment\n    }\n  }\n}\n\nfragment storeUserReviews on Store {\n  userReviewSummary {\n    rating\n    count\n    countTotal\n    distributionNew {\n      score\n      count\n      percentage\n    }\n  }\n  userReviews(\n    offset: $offset\n    limit: $userReviewLimit\n    sort: $userReviewSort\n    filter: $userReviewFilter\n    invalidateCache: $invalidateCache\n  ) {\n    myReview {\n      id\n      rating\n      reviewText\n      createdAt\n      localizedCreatedAt: createdAt(format: \"L\")\n      localizedUpdatedAt: updatedAt(format: \"L\")\n    }\n    pageInfo {\n      offset\n      limit\n      hasNext\n      hasPrevious\n    }\n    nodes {\n      ...GenericUserReview\n      reply\n      replyDate\n      translation {\n        text: reviewText\n        language\n        service {\n          name\n          uri\n        }\n      }\n      verifiedPurchase\n    }\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}\n\nfragment promotionItemsFragment on SearchV3PromotionsResult {\n  items {\n    id\n    description\n    imageUrl\n    owner {\n      id\n      name\n      type\n    }\n    promotionUrl\n    title\n    startDate\n    endDate\n    numberOfProducts\n  }\n}"

/***/ }),

/***/ 79018:
/***/ ((module) => {

module.exports = "query imageSearch($productId: Int!) {\n  visuallySimilarProductsV2(productId: $productId) {\n    nodes {\n      productId\n      priceDrop\n      coreProperties\n      dealUpdateTime\n      imageSearchModels\n      logo\n      name\n      aggregatedRating {\n        score\n        count\n      }\n      productLink\n      storeCount\n      parentCategoryIds\n      categoryName\n      bestOffer {\n        condition\n        featured\n        memberPrice\n        membershipRequiresCompensation\n        offerLink\n        originalPrice\n        price\n        priceExpires\n        shopOfferId\n        stockStatus\n        storeId\n        storeName\n      }\n      __typename\n    }\n  }\n}"

/***/ }),

/***/ 43837:
/***/ ((module) => {

module.exports = "query campaignsWithDisplayDate($timestamp: String = null) {\n  ...campaignsV2Fragment\n}\n\nfragment campaignsV2Fragment on RootQuery {\n  campaignsV2(timestamp: $timestamp) {\n    _id\n    _type\n    name\n    startDate\n    endDate\n    active\n    ended\n    announcementBanner {\n      text\n      theme\n      linkText\n      url\n    }\n    startPageTopBanner {\n      ...startPageBannerFragment\n    }\n    startPageMiddleBanner {\n      ...startPageBannerFragment\n    }\n    startPageBottomBanner {\n      ...startPageBannerFragment\n    }\n  }\n}\n\nfragment startPageBannerFragment on StartPageBanner {\n  _type\n  _key\n  overline\n  title\n  copy\n  bannerSize\n  theme\n  backgroundImageUrl\n  button {\n    _type\n    text\n    url\n  }\n}"

/***/ }),

/***/ 43121:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 96777:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 21440:
/***/ (() => {

/* (ignored) */

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd define */
/******/ 	(() => {
/******/ 		__webpack_require__.amdD = function () {
/******/ 			throw new Error('define cannot be used indirect');
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/amd options */
/******/ 	(() => {
/******/ 		__webpack_require__.amdO = {};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + {"34":"abf4747cf35d4b513b85","46":"a7db78e69aacfaa396b1","56":"9881835c9fc3b045a4b4","88":"1ee59e28812761c6d978","119":"049dbd5d4d4906b79594","120":"c007ec75639a488d6f5f","159":"b64b5a72ffd7fe53cfc7","191":"f221a38d49430d4da332","236":"750d274e11af550e9962","241":"208b6f64922908d964cb","283":"5dfaeb1dffc7b8907c0d","314":"1eb691a70fcff70d19a0","340":"70938565ba954b7f89eb","362":"6dab8ae7a0e148bf6c0f","373":"43083806606f5c0957ca","378":"047ce81596ac9dc13b65","406":"b223fa73682c23ca0a8f","408":"2d3154ef3e5a273f2918","422":"1a5c2e3bad064ffce2cd","464":"e1aecb0a7129c8f0ddcd","495":"dc29d93d36d8687100dd","536":"574eebc6373c0acafdd0","554":"c104c1bbd7fa463a368a","557":"62fa0f0e98dddb556743","578":"f8bebb65b0633d6c7d2a","603":"a54b85eef8f336ec2c9e","625":"f5c349bdb76881392f2c","722":"938a774cb7f4ab849d51","737":"147b60a80b0857c18186","781":"b7fc052b79880d323766","827":"28965c0dda38be3b1753","831":"719ce79fa8510ee12d7f","835":"56abdfb0b231b32d0395","845":"ff30cc7dc89b26d5412f","850":"7497987a8d62659a74dc","877":"84f429c33abb00a897b6","897":"a7c4cc4b4b601b3ab4e2","912":"990d4d9c63bdb968542c","942":"8bf98971263bb5661b32","970":"2f27f3c3479e46d082d7"}[chunkId] + "/" + chunkId + ".js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@prisjakt/responsive-frontend:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			;
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			826: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						} else installedChunks[chunkId] = 0;
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// module factories are used so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [677], () => (__webpack_require__(29893)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;